import { isVue3 as $m, defineComponent as LM, getCurrentInstance as zM, ref as _d, computed as BM, watch as n1, onMounted as FM, onUnmounted as qM, h as VM } from "vue-demi";
var HM = Object.defineProperty, WM = Object.defineProperties, UM = Object.getOwnPropertyDescriptors, r1 = Object.getOwnPropertySymbols, JM = Object.prototype.hasOwnProperty, KM = Object.prototype.propertyIsEnumerable, i1 = (e, t, n) => t in e ? HM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, GM = (e, t) => {
  for (var n in t || (t = {}))
    JM.call(t, n) && i1(e, n, t[n]);
  if (r1)
    for (var n of r1(t))
      KM.call(t, n) && i1(e, n, t[n]);
  return e;
}, QM = (e, t) => WM(e, UM(t));
function o1(e) {
  const t = Array.from(e);
  return t[0] = t[0].toUpperCase(), t.unshift("n"), t.unshift("o"), t.join("");
}
function XM(e, t = []) {
  let n = {}, r = {}, i = {}, o = {};
  const a = Array.isArray(t) ? t : Object.keys(t);
  for (let s in e)
    if (s.startsWith("@")) {
      const u = s.substring(1);
      $m ? u.startsWith("vnode") ? o[o1(u)] = e[s] : i[o1(u)] = e[s] : u.startsWith("hook:") ? o[u] = e[s] : i[u] = e[s];
    } else
      a.includes(s) ? n[s] = e[s] : r[s] = e[s];
  return {
    props: n,
    attrs: r,
    listeners: i,
    hooks: o
  };
}
var ZM = typeof global == "object" && global && global.Object === Object && global, M_ = ZM, YM = typeof self == "object" && self && self.Object === Object && self, tT = M_ || YM || Function("return this")(), mo = tT, eT = mo.Symbol, fo = eT, T_ = Object.prototype, nT = T_.hasOwnProperty, rT = T_.toString, Su = fo ? fo.toStringTag : void 0;
function iT(e) {
  var t = nT.call(e, Su), n = e[Su];
  try {
    e[Su] = void 0;
    var r = !0;
  } catch {
  }
  var i = rT.call(e);
  return r && (t ? e[Su] = n : delete e[Su]), i;
}
var oT = Object.prototype, aT = oT.toString;
function sT(e) {
  return aT.call(e);
}
var uT = "[object Null]", cT = "[object Undefined]", a1 = fo ? fo.toStringTag : void 0;
function Xa(e) {
  return e == null ? e === void 0 ? cT : uT : a1 && a1 in Object(e) ? iT(e) : sT(e);
}
function ho(e) {
  return e != null && typeof e == "object";
}
var lT = "[object Symbol]";
function _m(e) {
  return typeof e == "symbol" || ho(e) && Xa(e) == lT;
}
function fT(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var hT = Array.isArray, gi = hT, dT = 1 / 0, s1 = fo ? fo.prototype : void 0, u1 = s1 ? s1.toString : void 0;
function I_(e) {
  if (typeof e == "string")
    return e;
  if (gi(e))
    return fT(e, I_) + "";
  if (_m(e))
    return u1 ? u1.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -dT ? "-0" : t;
}
function Eo(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function Cm(e) {
  return e;
}
var vT = "[object AsyncFunction]", pT = "[object Function]", mT = "[object GeneratorFunction]", gT = "[object Proxy]";
function Om(e) {
  if (!Eo(e))
    return !1;
  var t = Xa(e);
  return t == pT || t == mT || t == vT || t == gT;
}
var yT = mo["__core-js_shared__"], Cd = yT, c1 = function() {
  var e = /[^.]+$/.exec(Cd && Cd.keys && Cd.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function bT(e) {
  return !!c1 && c1 in e;
}
var kT = Function.prototype, wT = kT.toString;
function Za(e) {
  if (e != null) {
    try {
      return wT.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var xT = /[\\^$.*+?()[\]{}|]/g, jT = /^\[object .+?Constructor\]$/, ST = Function.prototype, $T = Object.prototype, _T = ST.toString, CT = $T.hasOwnProperty, OT = RegExp("^" + _T.call(CT).replace(xT, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function AT(e) {
  if (!Eo(e) || bT(e))
    return !1;
  var t = Om(e) ? OT : jT;
  return t.test(Za(e));
}
function PT(e, t) {
  return e == null ? void 0 : e[t];
}
function Ya(e, t) {
  var n = PT(e, t);
  return AT(n) ? n : void 0;
}
var ET = Ya(mo, "WeakMap"), Lv = ET, l1 = Object.create, MT = function() {
  function e() {
  }
  return function(t) {
    if (!Eo(t))
      return {};
    if (l1)
      return l1(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), TT = MT;
function IT(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function N_(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var NT = 800, RT = 16, DT = Date.now;
function LT(e) {
  var t = 0, n = 0;
  return function() {
    var r = DT(), i = RT - (r - n);
    if (n = r, i > 0) {
      if (++t >= NT)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function zT(e) {
  return function() {
    return e;
  };
}
var BT = function() {
  try {
    var e = Ya(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), bf = BT, FT = bf ? function(e, t) {
  return bf(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: zT(t),
    writable: !0
  });
} : Cm, qT = FT, VT = LT(qT), HT = VT;
function WT(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var UT = 9007199254740991, JT = /^(?:0|[1-9]\d*)$/;
function Am(e, t) {
  var n = typeof e;
  return t = t == null ? UT : t, !!t && (n == "number" || n != "symbol" && JT.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Sh(e, t, n) {
  t == "__proto__" && bf ? bf(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function Mc(e, t) {
  return e === t || e !== e && t !== t;
}
var KT = Object.prototype, GT = KT.hasOwnProperty;
function R_(e, t, n) {
  var r = e[t];
  (!(GT.call(e, t) && Mc(r, n)) || n === void 0 && !(t in e)) && Sh(e, t, n);
}
function tu(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = t.length; ++o < a; ) {
    var s = t[o], u = r ? r(n[s], e[s], s, n, e) : void 0;
    u === void 0 && (u = e[s]), i ? Sh(n, s, u) : R_(n, s, u);
  }
  return n;
}
var f1 = Math.max;
function QT(e, t, n) {
  return t = f1(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = f1(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), IT(e, this, s);
  };
}
function XT(e, t) {
  return HT(QT(e, t, Cm), e + "");
}
var ZT = 9007199254740991;
function Pm(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ZT;
}
function $h(e) {
  return e != null && Pm(e.length) && !Om(e);
}
function YT(e, t, n) {
  if (!Eo(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? $h(n) && Am(t, n.length) : r == "string" && t in n) ? Mc(n[t], e) : !1;
}
function D_(e) {
  return XT(function(t, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && YT(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = Object(t); ++r < i; ) {
      var s = n[r];
      s && e(t, s, r, o);
    }
    return t;
  });
}
var t9 = Object.prototype;
function Em(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || t9;
  return e === n;
}
function e9(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var n9 = "[object Arguments]";
function h1(e) {
  return ho(e) && Xa(e) == n9;
}
var L_ = Object.prototype, r9 = L_.hasOwnProperty, i9 = L_.propertyIsEnumerable, o9 = h1(function() {
  return arguments;
}()) ? h1 : function(e) {
  return ho(e) && r9.call(e, "callee") && !i9.call(e, "callee");
}, kf = o9;
function a9() {
  return !1;
}
var z_ = typeof exports == "object" && exports && !exports.nodeType && exports, d1 = z_ && typeof module == "object" && module && !module.nodeType && module, s9 = d1 && d1.exports === z_, v1 = s9 ? mo.Buffer : void 0, u9 = v1 ? v1.isBuffer : void 0, c9 = u9 || a9, tc = c9, l9 = "[object Arguments]", f9 = "[object Array]", h9 = "[object Boolean]", d9 = "[object Date]", v9 = "[object Error]", p9 = "[object Function]", m9 = "[object Map]", g9 = "[object Number]", y9 = "[object Object]", b9 = "[object RegExp]", k9 = "[object Set]", w9 = "[object String]", x9 = "[object WeakMap]", j9 = "[object ArrayBuffer]", S9 = "[object DataView]", $9 = "[object Float32Array]", _9 = "[object Float64Array]", C9 = "[object Int8Array]", O9 = "[object Int16Array]", A9 = "[object Int32Array]", P9 = "[object Uint8Array]", E9 = "[object Uint8ClampedArray]", M9 = "[object Uint16Array]", T9 = "[object Uint32Array]", Pn = {};
Pn[$9] = Pn[_9] = Pn[C9] = Pn[O9] = Pn[A9] = Pn[P9] = Pn[E9] = Pn[M9] = Pn[T9] = !0;
Pn[l9] = Pn[f9] = Pn[j9] = Pn[h9] = Pn[S9] = Pn[d9] = Pn[v9] = Pn[p9] = Pn[m9] = Pn[g9] = Pn[y9] = Pn[b9] = Pn[k9] = Pn[w9] = Pn[x9] = !1;
function I9(e) {
  return ho(e) && Pm(e.length) && !!Pn[Xa(e)];
}
function Mm(e) {
  return function(t) {
    return e(t);
  };
}
var B_ = typeof exports == "object" && exports && !exports.nodeType && exports, Bu = B_ && typeof module == "object" && module && !module.nodeType && module, N9 = Bu && Bu.exports === B_, Od = N9 && M_.process, R9 = function() {
  try {
    var e = Bu && Bu.require && Bu.require("util").types;
    return e || Od && Od.binding && Od.binding("util");
  } catch {
  }
}(), Ds = R9, p1 = Ds && Ds.isTypedArray, D9 = p1 ? Mm(p1) : I9, Tm = D9, L9 = Object.prototype, z9 = L9.hasOwnProperty;
function F_(e, t) {
  var n = gi(e), r = !n && kf(e), i = !n && !r && tc(e), o = !n && !r && !i && Tm(e), a = n || r || i || o, s = a ? e9(e.length, String) : [], u = s.length;
  for (var c in e)
    (t || z9.call(e, c)) && !(a && (c == "length" || i && (c == "offset" || c == "parent") || o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || Am(c, u))) && s.push(c);
  return s;
}
function q_(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var B9 = q_(Object.keys, Object), F9 = B9, q9 = Object.prototype, V9 = q9.hasOwnProperty;
function H9(e) {
  if (!Em(e))
    return F9(e);
  var t = [];
  for (var n in Object(e))
    V9.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function Tc(e) {
  return $h(e) ? F_(e) : H9(e);
}
function W9(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var U9 = Object.prototype, J9 = U9.hasOwnProperty;
function K9(e) {
  if (!Eo(e))
    return W9(e);
  var t = Em(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !J9.call(e, r)) || n.push(r);
  return n;
}
function eu(e) {
  return $h(e) ? F_(e, !0) : K9(e);
}
var G9 = D_(function(e, t, n, r) {
  tu(t, eu(t), e, r);
}), Q9 = G9, X9 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Z9 = /^\w*$/;
function Im(e, t) {
  if (gi(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || _m(e) ? !0 : Z9.test(e) || !X9.test(e) || t != null && e in Object(t);
}
var Y9 = Ya(Object, "create"), ec = Y9;
function tI() {
  this.__data__ = ec ? ec(null) : {}, this.size = 0;
}
function eI(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var nI = "__lodash_hash_undefined__", rI = Object.prototype, iI = rI.hasOwnProperty;
function oI(e) {
  var t = this.__data__;
  if (ec) {
    var n = t[e];
    return n === nI ? void 0 : n;
  }
  return iI.call(t, e) ? t[e] : void 0;
}
var aI = Object.prototype, sI = aI.hasOwnProperty;
function uI(e) {
  var t = this.__data__;
  return ec ? t[e] !== void 0 : sI.call(t, e);
}
var cI = "__lodash_hash_undefined__";
function lI(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ec && t === void 0 ? cI : t, this;
}
function Ba(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ba.prototype.clear = tI;
Ba.prototype.delete = eI;
Ba.prototype.get = oI;
Ba.prototype.has = uI;
Ba.prototype.set = lI;
function fI() {
  this.__data__ = [], this.size = 0;
}
function _h(e, t) {
  for (var n = e.length; n--; )
    if (Mc(e[n][0], t))
      return n;
  return -1;
}
var hI = Array.prototype, dI = hI.splice;
function vI(e) {
  var t = this.__data__, n = _h(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : dI.call(t, n, 1), --this.size, !0;
}
function pI(e) {
  var t = this.__data__, n = _h(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function mI(e) {
  return _h(this.__data__, e) > -1;
}
function gI(e, t) {
  var n = this.__data__, r = _h(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function Mo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Mo.prototype.clear = fI;
Mo.prototype.delete = vI;
Mo.prototype.get = pI;
Mo.prototype.has = mI;
Mo.prototype.set = gI;
var yI = Ya(mo, "Map"), nc = yI;
function bI() {
  this.size = 0, this.__data__ = {
    hash: new Ba(),
    map: new (nc || Mo)(),
    string: new Ba()
  };
}
function kI(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Ch(e, t) {
  var n = e.__data__;
  return kI(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function wI(e) {
  var t = Ch(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function xI(e) {
  return Ch(this, e).get(e);
}
function jI(e) {
  return Ch(this, e).has(e);
}
function SI(e, t) {
  var n = Ch(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function To(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
To.prototype.clear = bI;
To.prototype.delete = wI;
To.prototype.get = xI;
To.prototype.has = jI;
To.prototype.set = SI;
var $I = "Expected a function";
function Nm(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError($I);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (Nm.Cache || To)(), n;
}
Nm.Cache = To;
var _I = 500;
function CI(e) {
  var t = Nm(e, function(r) {
    return n.size === _I && n.clear(), r;
  }), n = t.cache;
  return t;
}
var OI = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, AI = /\\(\\)?/g, PI = CI(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(OI, function(n, r, i, o) {
    t.push(i ? o.replace(AI, "$1") : r || n);
  }), t;
}), EI = PI;
function MI(e) {
  return e == null ? "" : I_(e);
}
function V_(e, t) {
  return gi(e) ? e : Im(e, t) ? [e] : EI(MI(e));
}
var TI = 1 / 0;
function Oh(e) {
  if (typeof e == "string" || _m(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -TI ? "-0" : t;
}
function H_(e, t) {
  t = V_(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[Oh(t[n++])];
  return n && n == r ? e : void 0;
}
function II(e, t, n) {
  var r = e == null ? void 0 : H_(e, t);
  return r === void 0 ? n : r;
}
function W_(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var NI = q_(Object.getPrototypeOf, Object), Rm = NI, RI = "[object Object]", DI = Function.prototype, LI = Object.prototype, U_ = DI.toString, zI = LI.hasOwnProperty, BI = U_.call(Object);
function zv(e) {
  if (!ho(e) || Xa(e) != RI)
    return !1;
  var t = Rm(e);
  if (t === null)
    return !0;
  var n = zI.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && U_.call(n) == BI;
}
function FI() {
  this.__data__ = new Mo(), this.size = 0;
}
function qI(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function VI(e) {
  return this.__data__.get(e);
}
function HI(e) {
  return this.__data__.has(e);
}
var WI = 200;
function UI(e, t) {
  var n = this.__data__;
  if (n instanceof Mo) {
    var r = n.__data__;
    if (!nc || r.length < WI - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new To(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function Ii(e) {
  var t = this.__data__ = new Mo(e);
  this.size = t.size;
}
Ii.prototype.clear = FI;
Ii.prototype.delete = qI;
Ii.prototype.get = VI;
Ii.prototype.has = HI;
Ii.prototype.set = UI;
function JI(e, t) {
  return e && tu(t, Tc(t), e);
}
function KI(e, t) {
  return e && tu(t, eu(t), e);
}
var J_ = typeof exports == "object" && exports && !exports.nodeType && exports, m1 = J_ && typeof module == "object" && module && !module.nodeType && module, GI = m1 && m1.exports === J_, g1 = GI ? mo.Buffer : void 0, y1 = g1 ? g1.allocUnsafe : void 0;
function K_(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = y1 ? y1(n) : new e.constructor(n);
  return e.copy(r), r;
}
function QI(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
function G_() {
  return [];
}
var XI = Object.prototype, ZI = XI.propertyIsEnumerable, b1 = Object.getOwnPropertySymbols, YI = b1 ? function(e) {
  return e == null ? [] : (e = Object(e), QI(b1(e), function(t) {
    return ZI.call(e, t);
  }));
} : G_, Dm = YI;
function tN(e, t) {
  return tu(e, Dm(e), t);
}
var eN = Object.getOwnPropertySymbols, nN = eN ? function(e) {
  for (var t = []; e; )
    W_(t, Dm(e)), e = Rm(e);
  return t;
} : G_, Q_ = nN;
function rN(e, t) {
  return tu(e, Q_(e), t);
}
function X_(e, t, n) {
  var r = t(e);
  return gi(e) ? r : W_(r, n(e));
}
function Bv(e) {
  return X_(e, Tc, Dm);
}
function iN(e) {
  return X_(e, eu, Q_);
}
var oN = Ya(mo, "DataView"), Fv = oN, aN = Ya(mo, "Promise"), qv = aN, sN = Ya(mo, "Set"), Vv = sN, k1 = "[object Map]", uN = "[object Object]", w1 = "[object Promise]", x1 = "[object Set]", j1 = "[object WeakMap]", S1 = "[object DataView]", cN = Za(Fv), lN = Za(nc), fN = Za(qv), hN = Za(Vv), dN = Za(Lv), $a = Xa;
(Fv && $a(new Fv(new ArrayBuffer(1))) != S1 || nc && $a(new nc()) != k1 || qv && $a(qv.resolve()) != w1 || Vv && $a(new Vv()) != x1 || Lv && $a(new Lv()) != j1) && ($a = function(e) {
  var t = Xa(e), n = t == uN ? e.constructor : void 0, r = n ? Za(n) : "";
  if (r)
    switch (r) {
      case cN:
        return S1;
      case lN:
        return k1;
      case fN:
        return w1;
      case hN:
        return x1;
      case dN:
        return j1;
    }
  return t;
});
var rc = $a, vN = Object.prototype, pN = vN.hasOwnProperty;
function mN(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && pN.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var gN = mo.Uint8Array, wf = gN;
function Lm(e) {
  var t = new e.constructor(e.byteLength);
  return new wf(t).set(new wf(e)), t;
}
function yN(e, t) {
  var n = t ? Lm(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var bN = /\w*$/;
function kN(e) {
  var t = new e.constructor(e.source, bN.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var $1 = fo ? fo.prototype : void 0, _1 = $1 ? $1.valueOf : void 0;
function wN(e) {
  return _1 ? Object(_1.call(e)) : {};
}
function Z_(e, t) {
  var n = t ? Lm(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var xN = "[object Boolean]", jN = "[object Date]", SN = "[object Map]", $N = "[object Number]", _N = "[object RegExp]", CN = "[object Set]", ON = "[object String]", AN = "[object Symbol]", PN = "[object ArrayBuffer]", EN = "[object DataView]", MN = "[object Float32Array]", TN = "[object Float64Array]", IN = "[object Int8Array]", NN = "[object Int16Array]", RN = "[object Int32Array]", DN = "[object Uint8Array]", LN = "[object Uint8ClampedArray]", zN = "[object Uint16Array]", BN = "[object Uint32Array]";
function FN(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case PN:
      return Lm(e);
    case xN:
    case jN:
      return new r(+e);
    case EN:
      return yN(e, n);
    case MN:
    case TN:
    case IN:
    case NN:
    case RN:
    case DN:
    case LN:
    case zN:
    case BN:
      return Z_(e, n);
    case SN:
      return new r();
    case $N:
    case ON:
      return new r(e);
    case _N:
      return kN(e);
    case CN:
      return new r();
    case AN:
      return wN(e);
  }
}
function Y_(e) {
  return typeof e.constructor == "function" && !Em(e) ? TT(Rm(e)) : {};
}
var qN = "[object Map]";
function VN(e) {
  return ho(e) && rc(e) == qN;
}
var C1 = Ds && Ds.isMap, HN = C1 ? Mm(C1) : VN, WN = HN, UN = "[object Set]";
function JN(e) {
  return ho(e) && rc(e) == UN;
}
var O1 = Ds && Ds.isSet, KN = O1 ? Mm(O1) : JN, GN = KN, QN = 1, XN = 2, ZN = 4, tC = "[object Arguments]", YN = "[object Array]", tR = "[object Boolean]", eR = "[object Date]", nR = "[object Error]", eC = "[object Function]", rR = "[object GeneratorFunction]", iR = "[object Map]", oR = "[object Number]", nC = "[object Object]", aR = "[object RegExp]", sR = "[object Set]", uR = "[object String]", cR = "[object Symbol]", lR = "[object WeakMap]", fR = "[object ArrayBuffer]", hR = "[object DataView]", dR = "[object Float32Array]", vR = "[object Float64Array]", pR = "[object Int8Array]", mR = "[object Int16Array]", gR = "[object Int32Array]", yR = "[object Uint8Array]", bR = "[object Uint8ClampedArray]", kR = "[object Uint16Array]", wR = "[object Uint32Array]", Sn = {};
Sn[tC] = Sn[YN] = Sn[fR] = Sn[hR] = Sn[tR] = Sn[eR] = Sn[dR] = Sn[vR] = Sn[pR] = Sn[mR] = Sn[gR] = Sn[iR] = Sn[oR] = Sn[nC] = Sn[aR] = Sn[sR] = Sn[uR] = Sn[cR] = Sn[yR] = Sn[bR] = Sn[kR] = Sn[wR] = !0;
Sn[nR] = Sn[eC] = Sn[lR] = !1;
function Ql(e, t, n, r, i, o) {
  var a, s = t & QN, u = t & XN, c = t & ZN;
  if (n && (a = i ? n(e, r, i, o) : n(e)), a !== void 0)
    return a;
  if (!Eo(e))
    return e;
  var l = gi(e);
  if (l) {
    if (a = mN(e), !s)
      return N_(e, a);
  } else {
    var f = rc(e), h = f == eC || f == rR;
    if (tc(e))
      return K_(e, s);
    if (f == nC || f == tC || h && !i) {
      if (a = u || h ? {} : Y_(e), !s)
        return u ? rN(e, KI(a, e)) : tN(e, JI(a, e));
    } else {
      if (!Sn[f])
        return i ? e : {};
      a = FN(e, f, s);
    }
  }
  o || (o = new Ii());
  var d = o.get(e);
  if (d)
    return d;
  o.set(e, a), GN(e) ? e.forEach(function(m) {
    a.add(Ql(m, t, n, m, e, o));
  }) : WN(e) && e.forEach(function(m, g) {
    a.set(g, Ql(m, t, n, g, e, o));
  });
  var p = c ? u ? iN : Bv : u ? eu : Tc, v = l ? void 0 : p(e);
  return WT(v || e, function(m, g) {
    v && (g = m, m = e[g]), R_(a, g, Ql(m, t, n, g, e, o));
  }), a;
}
var xR = 1, jR = 4;
function SR(e) {
  return Ql(e, xR | jR);
}
var $R = "__lodash_hash_undefined__";
function _R(e) {
  return this.__data__.set(e, $R), this;
}
function CR(e) {
  return this.__data__.has(e);
}
function xf(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new To(); ++t < n; )
    this.add(e[t]);
}
xf.prototype.add = xf.prototype.push = _R;
xf.prototype.has = CR;
function OR(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function AR(e, t) {
  return e.has(t);
}
var PR = 1, ER = 2;
function rC(e, t, n, r, i, o) {
  var a = n & PR, s = e.length, u = t.length;
  if (s != u && !(a && u > s))
    return !1;
  var c = o.get(e), l = o.get(t);
  if (c && l)
    return c == t && l == e;
  var f = -1, h = !0, d = n & ER ? new xf() : void 0;
  for (o.set(e, t), o.set(t, e); ++f < s; ) {
    var p = e[f], v = t[f];
    if (r)
      var m = a ? r(v, p, f, t, e, o) : r(p, v, f, e, t, o);
    if (m !== void 0) {
      if (m)
        continue;
      h = !1;
      break;
    }
    if (d) {
      if (!OR(t, function(g, y) {
        if (!AR(d, y) && (p === g || i(p, g, n, r, o)))
          return d.push(y);
      })) {
        h = !1;
        break;
      }
    } else if (!(p === v || i(p, v, n, r, o))) {
      h = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), h;
}
function MR(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function TR(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var IR = 1, NR = 2, RR = "[object Boolean]", DR = "[object Date]", LR = "[object Error]", zR = "[object Map]", BR = "[object Number]", FR = "[object RegExp]", qR = "[object Set]", VR = "[object String]", HR = "[object Symbol]", WR = "[object ArrayBuffer]", UR = "[object DataView]", A1 = fo ? fo.prototype : void 0, Ad = A1 ? A1.valueOf : void 0;
function JR(e, t, n, r, i, o, a) {
  switch (n) {
    case UR:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case WR:
      return !(e.byteLength != t.byteLength || !o(new wf(e), new wf(t)));
    case RR:
    case DR:
    case BR:
      return Mc(+e, +t);
    case LR:
      return e.name == t.name && e.message == t.message;
    case FR:
    case VR:
      return e == t + "";
    case zR:
      var s = MR;
    case qR:
      var u = r & IR;
      if (s || (s = TR), e.size != t.size && !u)
        return !1;
      var c = a.get(e);
      if (c)
        return c == t;
      r |= NR, a.set(e, t);
      var l = rC(s(e), s(t), r, i, o, a);
      return a.delete(e), l;
    case HR:
      if (Ad)
        return Ad.call(e) == Ad.call(t);
  }
  return !1;
}
var KR = 1, GR = Object.prototype, QR = GR.hasOwnProperty;
function XR(e, t, n, r, i, o) {
  var a = n & KR, s = Bv(e), u = s.length, c = Bv(t), l = c.length;
  if (u != l && !a)
    return !1;
  for (var f = u; f--; ) {
    var h = s[f];
    if (!(a ? h in t : QR.call(t, h)))
      return !1;
  }
  var d = o.get(e), p = o.get(t);
  if (d && p)
    return d == t && p == e;
  var v = !0;
  o.set(e, t), o.set(t, e);
  for (var m = a; ++f < u; ) {
    h = s[f];
    var g = e[h], y = t[h];
    if (r)
      var b = a ? r(y, g, h, t, e, o) : r(g, y, h, e, t, o);
    if (!(b === void 0 ? g === y || i(g, y, n, r, o) : b)) {
      v = !1;
      break;
    }
    m || (m = h == "constructor");
  }
  if (v && !m) {
    var k = e.constructor, w = t.constructor;
    k != w && "constructor" in e && "constructor" in t && !(typeof k == "function" && k instanceof k && typeof w == "function" && w instanceof w) && (v = !1);
  }
  return o.delete(e), o.delete(t), v;
}
var ZR = 1, P1 = "[object Arguments]", E1 = "[object Array]", ll = "[object Object]", YR = Object.prototype, M1 = YR.hasOwnProperty;
function tD(e, t, n, r, i, o) {
  var a = gi(e), s = gi(t), u = a ? E1 : rc(e), c = s ? E1 : rc(t);
  u = u == P1 ? ll : u, c = c == P1 ? ll : c;
  var l = u == ll, f = c == ll, h = u == c;
  if (h && tc(e)) {
    if (!tc(t))
      return !1;
    a = !0, l = !1;
  }
  if (h && !l)
    return o || (o = new Ii()), a || Tm(e) ? rC(e, t, n, r, i, o) : JR(e, t, u, n, r, i, o);
  if (!(n & ZR)) {
    var d = l && M1.call(e, "__wrapped__"), p = f && M1.call(t, "__wrapped__");
    if (d || p) {
      var v = d ? e.value() : e, m = p ? t.value() : t;
      return o || (o = new Ii()), i(v, m, n, r, o);
    }
  }
  return h ? (o || (o = new Ii()), XR(e, t, n, r, i, o)) : !1;
}
function zm(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !ho(e) && !ho(t) ? e !== e && t !== t : tD(e, t, n, r, zm, i);
}
var eD = 1, nD = 2;
function rD(e, t, n, r) {
  var i = n.length, o = i, a = !r;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var u = s[0], c = e[u], l = s[1];
    if (a && s[2]) {
      if (c === void 0 && !(u in e))
        return !1;
    } else {
      var f = new Ii();
      if (r)
        var h = r(c, l, u, e, t, f);
      if (!(h === void 0 ? zm(l, c, eD | nD, r, f) : h))
        return !1;
    }
  }
  return !0;
}
function iC(e) {
  return e === e && !Eo(e);
}
function iD(e) {
  for (var t = Tc(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, iC(i)];
  }
  return t;
}
function oC(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function oD(e) {
  var t = iD(e);
  return t.length == 1 && t[0][2] ? oC(t[0][0], t[0][1]) : function(n) {
    return n === e || rD(n, e, t);
  };
}
function aD(e, t) {
  return e != null && t in Object(e);
}
function sD(e, t, n) {
  t = V_(t, e);
  for (var r = -1, i = t.length, o = !1; ++r < i; ) {
    var a = Oh(t[r]);
    if (!(o = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return o || ++r != i ? o : (i = e == null ? 0 : e.length, !!i && Pm(i) && Am(a, i) && (gi(e) || kf(e)));
}
function uD(e, t) {
  return e != null && sD(e, t, aD);
}
var cD = 1, lD = 2;
function fD(e, t) {
  return Im(e) && iC(t) ? oC(Oh(e), t) : function(n) {
    var r = II(n, e);
    return r === void 0 && r === t ? uD(n, e) : zm(t, r, cD | lD);
  };
}
function hD(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function dD(e) {
  return function(t) {
    return H_(t, e);
  };
}
function vD(e) {
  return Im(e) ? hD(Oh(e)) : dD(e);
}
function pD(e) {
  return typeof e == "function" ? e : e == null ? Cm : typeof e == "object" ? gi(e) ? fD(e[0], e[1]) : oD(e) : vD(e);
}
function mD(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
      var u = a[e ? s : ++i];
      if (n(o[u], u, o) === !1)
        break;
    }
    return t;
  };
}
var gD = mD(), aC = gD;
function yD(e, t) {
  return e && aC(e, t, Tc);
}
function Hv(e, t, n) {
  (n !== void 0 && !Mc(e[t], n) || n === void 0 && !(t in e)) && Sh(e, t, n);
}
function bD(e) {
  return ho(e) && $h(e);
}
function Wv(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function kD(e) {
  return tu(e, eu(e));
}
function wD(e, t, n, r, i, o, a) {
  var s = Wv(e, n), u = Wv(t, n), c = a.get(u);
  if (c) {
    Hv(e, n, c);
    return;
  }
  var l = o ? o(s, u, n + "", e, t, a) : void 0, f = l === void 0;
  if (f) {
    var h = gi(u), d = !h && tc(u), p = !h && !d && Tm(u);
    l = u, h || d || p ? gi(s) ? l = s : bD(s) ? l = N_(s) : d ? (f = !1, l = K_(u, !0)) : p ? (f = !1, l = Z_(u, !0)) : l = [] : zv(u) || kf(u) ? (l = s, kf(s) ? l = kD(s) : (!Eo(s) || Om(s)) && (l = Y_(u))) : f = !1;
  }
  f && (a.set(u, l), i(l, u, r, o, a), a.delete(u)), Hv(e, n, l);
}
function sC(e, t, n, r, i) {
  e !== t && aC(t, function(o, a) {
    if (i || (i = new Ii()), Eo(o))
      wD(e, t, a, n, sC, r, i);
    else {
      var s = r ? r(Wv(e, a), o, a + "", e, t, i) : void 0;
      s === void 0 && (s = o), Hv(e, a, s);
    }
  }, eu);
}
var xD = D_(function(e, t, n, r) {
  sC(e, t, n, r);
}), jD = xD;
function SD(e, t) {
  var n = {};
  return t = pD(t), yD(e, function(r, i, o) {
    Sh(n, t(r, i, o), r);
  }), n;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var jf = function() {
  return jf = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, jf.apply(this, arguments);
};
function $D(e) {
  return e.toLowerCase();
}
var _D = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], CD = /[^A-Z0-9]+/gi;
function OD(e, t) {
  t === void 0 && (t = {});
  for (var n = t.splitRegexp, r = n === void 0 ? _D : n, i = t.stripRegexp, o = i === void 0 ? CD : i, a = t.transform, s = a === void 0 ? $D : a, u = t.delimiter, c = u === void 0 ? " " : u, l = T1(T1(e, r, "$1\0$2"), o, "\0"), f = 0, h = l.length; l.charAt(f) === "\0"; )
    f++;
  for (; l.charAt(h - 1) === "\0"; )
    h--;
  return l.slice(f, h).split("\0").map(s).join(c);
}
function T1(e, t, n) {
  return t instanceof RegExp ? e.replace(t, n) : t.reduce(function(r, i) {
    return r.replace(i, n);
  }, e);
}
function uC(e, t) {
  var n = e.charAt(0), r = e.substr(1).toLowerCase();
  return t > 0 && n >= "0" && n <= "9" ? "_" + n + r : "" + n.toUpperCase() + r;
}
function AD(e, t) {
  return t === void 0 && (t = {}), OD(e, jf({ delimiter: "", transform: uC }, t));
}
function PD(e, t) {
  return t === 0 ? e.toLowerCase() : uC(e, t);
}
function ED(e, t) {
  return t === void 0 && (t = {}), AD(e, jf({ transform: PD }, t));
}
function Ls(e) {
  return {}.toString.call(e).slice(8, -1).toLowerCase();
}
(function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
})();
function MD({
  type: e,
  name: t,
  prop: n,
  validator: r
}) {
  if (e) {
    Ls(e) === "string" && (e = [e]);
    const i = Ls(n);
    if (!e.includes(i))
      throw Error(`${t}\u9700\u4E3A${e.toString()}\u7C7B\u578B\uFF08\u5F97\u5230${i}\uFF09`);
  }
  if (r && !r(n))
    throw Error(`${t}\u4E0D\u5408\u6CD5`);
}
function TD(e, {
  mergeObject: t,
  mergeFunction: n
}) {
  const r = n ? (i, o) => Ls(i) === "function" && Ls(o) === "function" ? n(o, i) : void 0 : void 0;
  return t === "deep" ? jD(...e, r) : Q9(...e, r);
}
function ID(e, {
  mergeFunction: t
}) {
  return e.reduce(t, () => {
  });
}
function cC(e, t = {}) {
  let {
    name: n = "",
    type: r,
    default: i,
    defaultIsDynamic: o = !1,
    required: a = !1,
    validator: s,
    camelCase: u = !0,
    mergeObject: c = "deep",
    mergeObjectApplyOnlyToDefault: l = !1,
    mergeFunction: f = !1,
    mergeFunctionApplyOnlyToDefault: h = !0
  } = t, d;
  if (o) {
    if (Ls(i) !== "function")
      throw Error(`${n}\u52A8\u6001\u751F\u6210\u9ED8\u8BA4\u503C\u65F6\uFF0C\u9ED8\u8BA4\u503C\u9700\u4E3A\u51FD\u6570\u7C7B\u578B`);
    d = [...e];
  } else
    d = [...e, i];
  let p, v = !1, m = !1;
  for (let g = 0; g < d.length; g++) {
    const y = d[g];
    if (y !== void 0) {
      MD({
        type: r,
        name: n,
        prop: y,
        validator: s
      });
      const b = zv(y), k = Ls(y) === "function";
      if (v = b, m = k, !b && !k)
        break;
    }
  }
  v ? d = SR(d) : (c = !1, m || (f = !1));
  for (let g = 0; g < d.length; g++) {
    const y = d[g];
    if (y !== void 0) {
      g === d.length - 1 ? p = y : c ? p = TD(l ? [i, y] : [...d].reverse(), {
        mergeObject: c,
        mergeFunction: f
      }) : f ? p = ID(h ? [y, i] : d, {
        mergeFunction: f
      }) : p = y;
      break;
    }
  }
  if (a && p === void 0)
    throw Error(`${n}\u53C2\u6570\u4E0D\u80FD\u4E3A\u7A7A`);
  return o ? cC(e, QM(GM({}, t), {
    default: i(p),
    defaultIsDynamic: !1
  })) : u && zv(p) ? SD(p, (g, y) => ED(y, {
    stripRegexp: /-/g
  })) : p;
}
var I1, N1, R1, D1, L1, z1, B1, F1, q1, V1, H1, W1, U1, J1, K1, G1, Q1, X1, Z1, Y1, ty, ey, ny, ry, iy, oy, ay, sy, uy, cy, ly, fy, hy, dy, vy, py, my, gy, yy, by, ky, wy, xy, jy, Sy, $y, _y, Cy, Oy, Ay, Py, Ey, My, Ty, Iy, Ny, Ry, Dy, Ly, zy, By, Fy, qy, Vy, Hy, Wy, Uy, Jy, Ky, Gy, Qy, Xy, Zy, Yy, tb, eb, nb, rb, ib, ob, ab, sb, ub, cb, lb, fb, hb, db, vb, pb, mb, gb, yb, bb, kb, wb, xb, jb, Sb, $b, _b, Cb, Ob, Ab, Pb, Eb, Mb, Tb, Ib, Nb, Rb, Db, Lb, zb, Bb, Fb, qb, Vb, Hb, Wb, Ub, Jb, Kb, Gb, Qb, Xb, Zb, Yb, tk, ek, nk, rk, ik, ok, ak, sk, uk, ck, lk, fk, hk, dk, vk, pk, mk, gk, yk, bk, kk, wk, xk, jk, Sk, $k, _k, Ck, Ok, Ak, Pk, Ek, Mk, Tk, Ik, Nk, Rk, Dk, Lk, zk, Bk, Fk, qk, Vk, Hk, Wk, Uk, Jk, Kk, Gk, Qk, Xk, Zk, Yk, tw, ew, nw, rw, iw, ow, aw, sw, uw, cw, lw, fw, hw, dw, vw, pw, mw, gw, yw, bw, kw, ww, xw, jw, Sw, $w, _w, Cw, Ow, Aw, Pw, Ew, Mw, Tw, Iw, Nw, Rw, Dw, Lw, zw, Bw, Fw, qw, Vw, Hw, Ww, Uw, Jw, Kw, Gw, Qw, Xw, Zw, Yw, t2, e2, n2, r2, i2, o2, a2, s2, u2, c2, l2, f2, h2, d2, v2, p2, m2, g2, y2, b2, k2, w2, x2, j2, S2, $2, _2, C2, O2, A2, P2, E2, M2, T2, I2, N2, R2, D2, L2, z2, B2, F2, q2, V2, H2, W2;
function Xl(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return (Xl = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1))
      return n;
    var r;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n))
        return t.get(n);
      t.set(n, i);
    }
    function i() {
      return lC(n, arguments, qe(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), Ah(i, n);
  })(e);
}
function lC(e, t, n) {
  return (lC = hC() ? Reflect.construct.bind() : function(r, i, o) {
    var a = [null];
    a.push.apply(a, i);
    var s = new (Function.bind.apply(r, a))();
    return o && Ah(s, o.prototype), s;
  }).apply(null, arguments);
}
function ot(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function de() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  de = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, r = typeof Symbol == "function" ? Symbol : {}, i = r.iterator || "@@iterator", o = r.asyncIterator || "@@asyncIterator", a = r.toStringTag || "@@toStringTag";
  function s(O, j, V) {
    return Object.defineProperty(O, j, { value: V, enumerable: !0, configurable: !0, writable: !0 }), O[j];
  }
  try {
    s({}, "");
  } catch {
    s = function(j, V, E) {
      return j[V] = E;
    };
  }
  function u(O, j, V, E) {
    var C = j && j.prototype instanceof f ? j : f, H = Object.create(C.prototype), X = new S(E || []);
    return H._invoke = function(F, G, M) {
      var $ = "suspendedStart";
      return function(q, B) {
        if ($ === "executing")
          throw new Error("Generator is already running");
        if ($ === "completed") {
          if (q === "throw")
            throw B;
          return P();
        }
        for (M.method = q, M.arg = B; ; ) {
          var D = M.delegate;
          if (D) {
            var _ = k(D, M);
            if (_) {
              if (_ === l)
                continue;
              return _;
            }
          }
          if (M.method === "next")
            M.sent = M._sent = M.arg;
          else if (M.method === "throw") {
            if ($ === "suspendedStart")
              throw $ = "completed", M.arg;
            M.dispatchException(M.arg);
          } else
            M.method === "return" && M.abrupt("return", M.arg);
          $ = "executing";
          var L = c(F, G, M);
          if (L.type === "normal") {
            if ($ = M.done ? "completed" : "suspendedYield", L.arg === l)
              continue;
            return { value: L.arg, done: M.done };
          }
          L.type === "throw" && ($ = "completed", M.method = "throw", M.arg = L.arg);
        }
      };
    }(O, V, X), H;
  }
  function c(O, j, V) {
    try {
      return { type: "normal", arg: O.call(j, V) };
    } catch (E) {
      return { type: "throw", arg: E };
    }
  }
  e.wrap = u;
  var l = {};
  function f() {
  }
  function h() {
  }
  function d() {
  }
  var p = {};
  s(p, i, function() {
    return this;
  });
  var v = Object.getPrototypeOf, m = v && v(v(T([])));
  m && m !== t && n.call(m, i) && (p = m);
  var g = d.prototype = f.prototype = Object.create(p);
  function y(O) {
    ["next", "throw", "return"].forEach(function(j) {
      s(O, j, function(V) {
        return this._invoke(j, V);
      });
    });
  }
  function b(O, j) {
    function V(C, H, X, F) {
      var G = c(O[C], O, H);
      if (G.type !== "throw") {
        var M = G.arg, $ = M.value;
        return $ && ne($) == "object" && n.call($, "__await") ? j.resolve($.__await).then(function(q) {
          V("next", q, X, F);
        }, function(q) {
          V("throw", q, X, F);
        }) : j.resolve($).then(function(q) {
          M.value = q, X(M);
        }, function(q) {
          return V("throw", q, X, F);
        });
      }
      F(G.arg);
    }
    var E;
    this._invoke = function(C, H) {
      function X() {
        return new j(function(F, G) {
          V(C, H, F, G);
        });
      }
      return E = E ? E.then(X, X) : X();
    };
  }
  function k(O, j) {
    var V = O.iterator[j.method];
    if (V === void 0) {
      if (j.delegate = null, j.method === "throw") {
        if (O.iterator.return && (j.method = "return", j.arg = void 0, k(O, j), j.method === "throw"))
          return l;
        j.method = "throw", j.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return l;
    }
    var E = c(V, O.iterator, j.arg);
    if (E.type === "throw")
      return j.method = "throw", j.arg = E.arg, j.delegate = null, l;
    var C = E.arg;
    return C ? C.done ? (j[O.resultName] = C.value, j.next = O.nextLoc, j.method !== "return" && (j.method = "next", j.arg = void 0), j.delegate = null, l) : C : (j.method = "throw", j.arg = new TypeError("iterator result is not an object"), j.delegate = null, l);
  }
  function w(O) {
    var j = { tryLoc: O[0] };
    1 in O && (j.catchLoc = O[1]), 2 in O && (j.finallyLoc = O[2], j.afterLoc = O[3]), this.tryEntries.push(j);
  }
  function x(O) {
    var j = O.completion || {};
    j.type = "normal", delete j.arg, O.completion = j;
  }
  function S(O) {
    this.tryEntries = [{ tryLoc: "root" }], O.forEach(w, this), this.reset(!0);
  }
  function T(O) {
    if (O) {
      var j = O[i];
      if (j)
        return j.call(O);
      if (typeof O.next == "function")
        return O;
      if (!isNaN(O.length)) {
        var V = -1, E = function C() {
          for (; ++V < O.length; )
            if (n.call(O, V))
              return C.value = O[V], C.done = !1, C;
          return C.value = void 0, C.done = !0, C;
        };
        return E.next = E;
      }
    }
    return { next: P };
  }
  function P() {
    return { value: void 0, done: !0 };
  }
  return h.prototype = d, s(g, "constructor", d), s(d, "constructor", h), h.displayName = s(d, a, "GeneratorFunction"), e.isGeneratorFunction = function(O) {
    var j = typeof O == "function" && O.constructor;
    return !!j && (j === h || (j.displayName || j.name) === "GeneratorFunction");
  }, e.mark = function(O) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(O, d) : (O.__proto__ = d, s(O, a, "GeneratorFunction")), O.prototype = Object.create(g), O;
  }, e.awrap = function(O) {
    return { __await: O };
  }, y(b.prototype), s(b.prototype, o, function() {
    return this;
  }), e.AsyncIterator = b, e.async = function(O, j, V, E, C) {
    C === void 0 && (C = Promise);
    var H = new b(u(O, j, V, E), C);
    return e.isGeneratorFunction(j) ? H : H.next().then(function(X) {
      return X.done ? X.value : H.next();
    });
  }, y(g), s(g, a, "Generator"), s(g, i, function() {
    return this;
  }), s(g, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(O) {
    var j = [];
    for (var V in O)
      j.push(V);
    return j.reverse(), function E() {
      for (; j.length; ) {
        var C = j.pop();
        if (C in O)
          return E.value = C, E.done = !1, E;
      }
      return E.done = !0, E;
    };
  }, e.values = T, S.prototype = { constructor: S, reset: function(O) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !O)
      for (var j in this)
        j.charAt(0) === "t" && n.call(this, j) && !isNaN(+j.slice(1)) && (this[j] = void 0);
  }, stop: function() {
    this.done = !0;
    var O = this.tryEntries[0].completion;
    if (O.type === "throw")
      throw O.arg;
    return this.rval;
  }, dispatchException: function(O) {
    if (this.done)
      throw O;
    var j = this;
    function V(G, M) {
      return H.type = "throw", H.arg = O, j.next = G, M && (j.method = "next", j.arg = void 0), !!M;
    }
    for (var E = this.tryEntries.length - 1; E >= 0; --E) {
      var C = this.tryEntries[E], H = C.completion;
      if (C.tryLoc === "root")
        return V("end");
      if (C.tryLoc <= this.prev) {
        var X = n.call(C, "catchLoc"), F = n.call(C, "finallyLoc");
        if (X && F) {
          if (this.prev < C.catchLoc)
            return V(C.catchLoc, !0);
          if (this.prev < C.finallyLoc)
            return V(C.finallyLoc);
        } else if (X) {
          if (this.prev < C.catchLoc)
            return V(C.catchLoc, !0);
        } else {
          if (!F)
            throw new Error("try statement without catch or finally");
          if (this.prev < C.finallyLoc)
            return V(C.finallyLoc);
        }
      }
    }
  }, abrupt: function(O, j) {
    for (var V = this.tryEntries.length - 1; V >= 0; --V) {
      var E = this.tryEntries[V];
      if (E.tryLoc <= this.prev && n.call(E, "finallyLoc") && this.prev < E.finallyLoc) {
        var C = E;
        break;
      }
    }
    C && (O === "break" || O === "continue") && C.tryLoc <= j && j <= C.finallyLoc && (C = null);
    var H = C ? C.completion : {};
    return H.type = O, H.arg = j, C ? (this.method = "next", this.next = C.finallyLoc, l) : this.complete(H);
  }, complete: function(O, j) {
    if (O.type === "throw")
      throw O.arg;
    return O.type === "break" || O.type === "continue" ? this.next = O.arg : O.type === "return" ? (this.rval = this.arg = O.arg, this.method = "return", this.next = "end") : O.type === "normal" && j && (this.next = j), l;
  }, finish: function(O) {
    for (var j = this.tryEntries.length - 1; j >= 0; --j) {
      var V = this.tryEntries[j];
      if (V.finallyLoc === O)
        return this.complete(V.completion, V.afterLoc), x(V), l;
    }
  }, catch: function(O) {
    for (var j = this.tryEntries.length - 1; j >= 0; --j) {
      var V = this.tryEntries[j];
      if (V.tryLoc === O) {
        var E = V.completion;
        if (E.type === "throw") {
          var C = E.arg;
          x(V);
        }
        return C;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(O, j, V) {
    return this.delegate = { iterator: T(O), resultName: j, nextLoc: V }, this.method === "next" && (this.arg = void 0), l;
  } }, e;
}
function U2(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a), u = s.value;
  } catch (c) {
    return void n(c);
  }
  s.done ? t(u) : Promise.resolve(u).then(r, i);
}
function mn(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(u) {
        U2(o, r, i, a, s, "next", u);
      }
      function s(u) {
        U2(o, r, i, a, s, "throw", u);
      }
      a(void 0);
    });
  };
}
function ut(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Bm(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(u) {
        throw u;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, a = !0, s = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var u = n.next();
    return a = u.done, u;
  }, e: function(u) {
    s = !0, o = u;
  }, f: function() {
    try {
      a || n.return == null || n.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function xe(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var i = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (i != null) {
      var o, a, s = [], u = !0, c = !1;
      try {
        for (i = i.call(n); !(u = (o = i.next()).done) && (s.push(o.value), !r || s.length !== r); u = !0)
          ;
      } catch (l) {
        c = !0, a = l;
      } finally {
        try {
          u || i.return == null || i.return();
        } finally {
          if (c)
            throw a;
        }
      }
      return s;
    }
  }(e, t) || Bm(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function J2(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? J2(Object(n), !0).forEach(function(r) {
      na(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : J2(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function na(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Je() {
  return (Je = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(e, t, n) {
    var r = ND(e, t);
    if (r) {
      var i = Object.getOwnPropertyDescriptor(r, t);
      return i.get ? i.get.call(arguments.length < 3 ? e : n) : i.value;
    }
  }).apply(this, arguments);
}
function ND(e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = qe(e)) !== null; )
    ;
  return e;
}
function Et(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ah(e, t);
}
function Ah(e, t) {
  return (Ah = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  })(e, t);
}
function Mt(e) {
  var t = hC();
  return function() {
    var n, r = qe(e);
    if (t) {
      var i = qe(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else
      n = r.apply(this, arguments);
    return fC(this, n);
  };
}
function fC(e, t) {
  if (t && (ne(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return he(e);
}
function he(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hC() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function qe(e) {
  return (qe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(e);
}
function Pe(e) {
  return function(t) {
    if (Array.isArray(t))
      return Uv(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || Bm(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Bm(e, t) {
  if (e) {
    if (typeof e == "string")
      return Uv(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Uv(e, t) : void 0;
  }
}
function Uv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Z(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function K2(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Y(e, t, n) {
  return t && K2(e.prototype, t), n && K2(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ne(e) {
  return (ne = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(e);
}
function Wt() {
}
var dC = function(e) {
  return e;
};
function da(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
}
function vC(e) {
  return e();
}
function G2() {
  return /* @__PURE__ */ Object.create(null);
}
function Dn(e) {
  e.forEach(vC);
}
function Ai(e) {
  return typeof e == "function";
}
function ir(e, t) {
  return e != e ? t == t : e !== t || e && ne(e) === "object" || typeof e == "function";
}
function Ue(e, t) {
  return e != e ? t == t : e !== t;
}
function Di(e, t, n, r) {
  if (e) {
    var i = pC(e, t, n, r);
    return e[0](i);
  }
}
function pC(e, t, n, r) {
  return e[1] && r ? da(n.ctx.slice(), e[1](r(t))) : n.ctx;
}
function Li(e, t, n, r) {
  if (e[2] && r) {
    var i = e[2](r(n));
    if (t.dirty === void 0)
      return i;
    if (ne(i) === "object") {
      for (var o = [], a = Math.max(t.dirty.length, i.length), s = 0; s < a; s += 1)
        o[s] = t.dirty[s] | i[s];
      return o;
    }
    return t.dirty | i;
  }
  return t.dirty;
}
function zi(e, t, n, r, i, o) {
  if (i) {
    var a = pC(t, n, r, o);
    e.p(a, i);
  }
}
function Bi(e) {
  if (e.ctx.length > 32) {
    for (var t = [], n = e.ctx.length / 32, r = 0; r < n; r++)
      t[r] = -1;
    return t;
  }
  return -1;
}
function er(e) {
  return e == null ? "" : e;
}
function Ic(e) {
  return e && Ai(e.destroy) ? e.destroy : Wt;
}
var fl, mC = typeof window < "u", RD = mC ? function() {
  return window.performance.now();
} : function() {
  return Date.now();
}, Fm = mC ? function(e) {
  return requestAnimationFrame(e);
} : Wt, Fu = /* @__PURE__ */ new Set();
function gC(e) {
  Fu.forEach(function(t) {
    t.c(e) || (Fu.delete(t), t.f());
  }), Fu.size !== 0 && Fm(gC);
}
function W(e, t) {
  e.appendChild(t);
}
function Te(e, t, n) {
  var r = qm(e);
  if (!r.getElementById(t)) {
    var i = rt("style");
    i.id = t, i.textContent = n, yC(r, i);
  }
}
function qm(e) {
  if (!e)
    return document;
  var t = e.getRootNode ? e.getRootNode() : e.ownerDocument;
  return t && t.host ? t : e.ownerDocument;
}
function DD(e) {
  var t = rt("style");
  return yC(qm(e), t), t.sheet;
}
function yC(e, t) {
  W(e.head || e, t);
}
function pt(e, t, n) {
  e.insertBefore(t, n || null);
}
function vt(e) {
  e.parentNode.removeChild(e);
}
function Ar(e, t) {
  for (var n = 0; n < e.length; n += 1)
    e[n] && e[n].d(t);
}
function rt(e) {
  return document.createElement(e);
}
function Co(e) {
  return document.createElementNS("http://www.w3.org/2000/svg", e);
}
function Xt(e) {
  return document.createTextNode(e);
}
function bt() {
  return Xt(" ");
}
function Ye() {
  return Xt("");
}
function Nt(e, t, n, r) {
  return e.addEventListener(t, n, r), function() {
    return e.removeEventListener(t, n, r);
  };
}
function bC(e) {
  return function(t) {
    return t.stopPropagation(), e.call(this, t);
  };
}
function A(e, t, n) {
  n == null ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n);
}
function Q2(e, t) {
  var n = Object.getOwnPropertyDescriptors(e.__proto__);
  for (var r in t)
    t[r] == null ? e.removeAttribute(r) : r === "style" ? e.style.cssText = t[r] : r === "__value" ? e.value = e[r] = t[r] : n[r] && n[r].set ? e[r] = t[r] : A(e, r, t[r]);
}
function Sf(e, t) {
  for (var n in t)
    A(e, n, t[n]);
}
function Jv(e, t, n) {
  t in e ? e[t] = typeof e[t] == "boolean" && n === "" || n : A(e, t, n);
}
function LD(e) {
  return Array.from(e.childNodes);
}
function Ve(e, t) {
  t = "" + t, e.wholeText !== t && (e.data = t);
}
function ra(e, t) {
  e.value = t == null ? "" : t;
}
function to(e, t, n, r) {
  n === null ? e.style.removeProperty(t) : e.style.setProperty(t, n, r ? "important" : "");
}
function X2(e, t) {
  for (var n = 0; n < e.options.length; n += 1) {
    var r = e.options[n];
    if (r.__value === t)
      return void (r.selected = !0);
  }
  e.selectedIndex = -1;
}
function zD() {
  if (fl === void 0) {
    fl = !1;
    try {
      typeof window < "u" && window.parent && window.parent.document;
    } catch {
      fl = !0;
    }
  }
  return fl;
}
function Ut(e, t, n) {
  e.classList[n ? "add" : "remove"](t);
}
function kC(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.bubbles, i = r !== void 0 && r, o = n.cancelable, a = o !== void 0 && o, s = document.createEvent("CustomEvent");
  return s.initCustomEvent(e, i, a, t), s;
}
var ic, BD = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    Z(this, e), this.is_svg = !1, this.is_svg = t, this.e = this.n = null;
  }
  return Y(e, [{ key: "c", value: function(t) {
    this.h(t);
  } }, { key: "m", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    this.e || (this.is_svg ? this.e = Co(n.nodeName) : this.e = rt(n.nodeName), this.t = n, this.c(t)), this.i(r);
  } }, { key: "h", value: function(t) {
    this.e.innerHTML = t, this.n = Array.from(this.e.childNodes);
  } }, { key: "i", value: function(t) {
    for (var n = 0; n < this.n.length; n += 1)
      pt(this.t, this.n[n], t);
  } }, { key: "p", value: function(t) {
    this.d(), this.h(t), this.i(this.a);
  } }, { key: "d", value: function() {
    this.n.forEach(vt);
  } }]), e;
}(), $f = /* @__PURE__ */ new Map(), Kv = 0;
function FD(e) {
  for (var t = 5381, n = e.length; n--; )
    t = (t << 5) - t ^ e.charCodeAt(n);
  return t >>> 0;
}
function qD(e, t) {
  var n = { stylesheet: DD(t), rules: {} };
  return $f.set(e, n), n;
}
function Z2(e, t, n, r, i, o, a) {
  for (var s = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0, u = 16.666 / r, c = `{
`, l = 0; l <= 1; l += u) {
    var f = t + (n - t) * o(l);
    c += 100 * l + "%{".concat(a(f, 1 - f), `}
`);
  }
  var h = c + "100% {".concat(a(n, 1 - n), `}
}`), d = "__svelte_".concat(FD(h), "_").concat(s), p = qm(e), v = $f.get(p) || qD(p, e), m = v.stylesheet, g = v.rules;
  g[d] || (g[d] = !0, m.insertRule("@keyframes ".concat(d, " ").concat(h), m.cssRules.length));
  var y = e.style.animation || "";
  return e.style.animation = "".concat(y ? "".concat(y, ", ") : "").concat(d, " ").concat(r, "ms linear ").concat(i, "ms 1 both"), Kv += 1, d;
}
function VD(e, t) {
  var n = (e.style.animation || "").split(", "), r = n.filter(t ? function(o) {
    return o.indexOf(t) < 0;
  } : function(o) {
    return o.indexOf("__svelte") === -1;
  }), i = n.length - r.length;
  i && (e.style.animation = r.join(", "), (Kv -= i) || Fm(function() {
    Kv || ($f.forEach(function(o) {
      for (var a = o.stylesheet, s = a.cssRules.length; s--; )
        a.deleteRule(s);
      o.rules = {};
    }), $f.clear());
  }));
}
function qu(e) {
  ic = e;
}
function nu() {
  if (!ic)
    throw new Error("Function called outside component initialization");
  return ic;
}
function wC(e) {
  nu().$$.before_update.push(e);
}
function yi(e) {
  nu().$$.on_mount.push(e);
}
function Fa(e) {
  nu().$$.on_destroy.push(e);
}
function Ph() {
  var e = nu();
  return function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.cancelable, o = i !== void 0 && i, a = e.$$.callbacks[t];
    if (a) {
      var s = kC(t, n, { cancelable: o });
      return a.slice().forEach(function(u) {
        u.call(e, s);
      }), !s.defaultPrevented;
    }
    return !0;
  };
}
function xC(e, t) {
  return nu().$$.context.set(e, t), t;
}
function Hr(e) {
  return nu().$$.context.get(e);
}
var Tu = [], Be = [], Zl = [], Gv = [], jC = Promise.resolve(), Qv = !1;
function SC() {
  Qv || (Qv = !0, jC.then($C));
}
function Qn() {
  return SC(), jC;
}
function ia(e) {
  Zl.push(e);
}
function di(e) {
  Gv.push(e);
}
var hl, Pd = /* @__PURE__ */ new Set(), dl = 0;
function $C() {
  var e = ic;
  do {
    for (; dl < Tu.length; ) {
      var t = Tu[dl];
      dl++, qu(t), HD(t.$$);
    }
    for (qu(null), Tu.length = 0, dl = 0; Be.length; )
      Be.pop()();
    for (var n = 0; n < Zl.length; n += 1) {
      var r = Zl[n];
      Pd.has(r) || (Pd.add(r), r());
    }
    Zl.length = 0;
  } while (Tu.length);
  for (; Gv.length; )
    Gv.pop()();
  Qv = !1, Pd.clear(), qu(e);
}
function HD(e) {
  if (e.fragment !== null) {
    e.update(), Dn(e.before_update);
    var t = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(ia);
  }
}
function Ed(e, t, n) {
  e.dispatchEvent(kC("".concat(t ? "intro" : "outro").concat(n)));
}
var So, Yl = /* @__PURE__ */ new Set();
function qt() {
  So = { r: 0, c: [], p: So };
}
function Vt() {
  So.r || Dn(So.c), So = So.p;
}
function U(e, t) {
  e && e.i && (Yl.delete(e), e.i(t));
}
function tt(e, t, n, r) {
  if (e && e.o) {
    if (Yl.has(e))
      return;
    Yl.add(e), So.c.push(function() {
      Yl.delete(e), r && (n && e.d(1), r());
    }), e.o(t);
  }
}
var WD = { duration: 0 };
function vl(e, t, n, r) {
  var i = t(e, n), o = r ? 0 : 1, a = null, s = null, u = null;
  function c() {
    u && VD(e, u);
  }
  function l(h, d) {
    var p = h.b - o;
    return d *= Math.abs(p), { a: o, b: h.b, d: p, duration: d, start: h.start, end: h.start + d, group: h.group };
  }
  function f(h) {
    var d, p = i || WD, v = p.delay, m = v === void 0 ? 0 : v, g = p.duration, y = g === void 0 ? 300 : g, b = p.easing, k = b === void 0 ? dC : b, w = p.tick, x = w === void 0 ? Wt : w, S = p.css, T = { start: RD() + m, b: h };
    h || (T.group = So, So.r += 1), a || s ? s = T : (S && (c(), u = Z2(e, o, h, y, m, k, S)), h && x(0, 1), a = l(T, y), ia(function() {
      return Ed(e, h, "start");
    }), d = function(P) {
      if (s && P > s.start && (a = l(s, y), s = null, Ed(e, a.b, "start"), S && (c(), u = Z2(e, o, a.b, a.duration, 0, k, i.css))), a) {
        if (P >= a.end)
          x(o = a.b, 1 - o), Ed(e, a.b, "end"), s || (a.b ? c() : --a.group.r || Dn(a.group.c)), a = null;
        else if (P >= a.start) {
          var O = P - a.start;
          o = a.a + a.d * k(O / a.duration), x(o, 1 - o);
        }
      }
      return !(!a && !s);
    }, Fu.size === 0 && Fm(gC), new Promise(function(P) {
      Fu.add({ c: d, f: P });
    }));
  }
  return { run: function(h) {
    Ai(i) ? (hl || (hl = Promise.resolve()).then(function() {
      hl = null;
    }), hl).then(function() {
      i = i(), f(h);
    }) : f(h);
  }, end: function() {
    c(), a = s = null;
  } };
}
var Vm = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : global;
function UD(e, t) {
  e.d(1), t.delete(e.key);
}
function Eh(e, t) {
  tt(e, 1, 1, function() {
    t.delete(e.key);
  });
}
function Nc(e, t, n, r, i, o, a, s, u, c, l, f) {
  for (var h = e.length, d = o.length, p = h, v = {}; p--; )
    v[e[p].key] = p;
  var m = [], g = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map();
  for (p = d; p--; ) {
    var b = f(i, o, p), k = n(b), w = a.get(k);
    w ? r && w.p(b, t) : (w = c(k, b)).c(), g.set(k, m[p] = w), k in v && y.set(k, Math.abs(p - v[k]));
  }
  var x = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Set();
  function T(C) {
    U(C, 1), C.m(s, l), a.set(C.key, C), l = C.first, d--;
  }
  for (; h && d; ) {
    var P = m[d - 1], O = e[h - 1], j = P.key, V = O.key;
    P === O ? (l = P.first, h--, d--) : g.has(V) ? !a.has(j) || x.has(j) ? T(P) : S.has(V) ? h-- : y.get(j) > y.get(V) ? (S.add(j), T(P)) : (x.add(V), h--) : (u(O, a), h--);
  }
  for (; h--; ) {
    var E = e[h];
    g.has(E.key) || u(E, a);
  }
  for (; d; )
    T(m[d - 1]);
  return m;
}
function ts(e, t) {
  for (var n = {}, r = {}, i = { $$scope: 1 }, o = e.length; o--; ) {
    var a = e[o], s = t[o];
    if (s) {
      for (var u in a)
        u in s || (r[u] = 1);
      for (var c in s)
        i[c] || (n[c] = s[c], i[c] = 1);
      e[o] = s;
    } else
      for (var l in a)
        i[l] = 1;
  }
  for (var f in r)
    f in n || (n[f] = void 0);
  return n;
}
function Mh(e) {
  return ne(e) === "object" && e !== null ? e : {};
}
function Kr(e, t, n) {
  var r = e.$$.props[t];
  r !== void 0 && (e.$$.bound[r] = n, n(e.$$.ctx[r]));
}
function Pt(e) {
  e && e.c();
}
function Ot(e, t, n, r) {
  var i = e.$$, o = i.fragment, a = i.on_mount, s = i.on_destroy, u = i.after_update;
  o && o.m(t, n), r || ia(function() {
    var c = a.map(vC).filter(Ai);
    s ? s.push.apply(s, Pe(c)) : Dn(c), e.$$.on_mount = [];
  }), u.forEach(ia);
}
function At(e, t) {
  var n = e.$$;
  n.fragment !== null && (Dn(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []);
}
function JD(e, t) {
  e.$$.dirty[0] === -1 && (Tu.push(e), SC(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function ke(e, t, n, r, i, o, a) {
  var s = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [-1], u = ic;
  qu(e);
  var c = e.$$ = { fragment: null, ctx: null, props: o, update: Wt, not_equal: i, bound: G2(), on_mount: [], on_destroy: [], on_disconnect: [], before_update: [], after_update: [], context: new Map(t.context || (u ? u.$$.context : [])), callbacks: G2(), dirty: s, skip_bound: !1, root: t.target || u.$$.root };
  a && a(c.root);
  var l = !1;
  if (c.ctx = n ? n(e, t.props || {}, function(h, d) {
    var p = !(arguments.length <= 2) && arguments.length - 2 ? arguments.length <= 2 ? void 0 : arguments[2] : d;
    return c.ctx && i(c.ctx[h], c.ctx[h] = p) && (!c.skip_bound && c.bound[h] && c.bound[h](p), l && JD(e, h)), d;
  }) : [], c.update(), l = !0, Dn(c.before_update), c.fragment = !!r && r(c.ctx), t.target) {
    if (t.hydrate) {
      var f = LD(t.target);
      c.fragment && c.fragment.l(f), f.forEach(vt);
    } else
      c.fragment && c.fragment.c();
    t.intro && U(e.$$.fragment), Ot(e, t.target, t.anchor, t.customElement), $C();
  }
  qu(u);
}
var pe = function() {
  function e() {
    Z(this, e);
  }
  return Y(e, [{ key: "$destroy", value: function() {
    At(this, 1), this.$destroy = Wt;
  } }, { key: "$on", value: function(t, n) {
    var r = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return r.push(n), function() {
      var i = r.indexOf(n);
      i !== -1 && r.splice(i, 1);
    };
  } }, { key: "$set", value: function(t) {
    var n;
    this.$$set && (n = t, Object.keys(n).length !== 0) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  } }]), e;
}(), KD = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    if (Z(this, n), !r || !r.target && !r.$$inline)
      throw new Error("'target' is a required option");
    return t.call(this);
  }
  return Y(n, [{ key: "$destroy", value: function() {
    Je(qe(n.prototype), "$destroy", this).call(this), this.$destroy = function() {
      console.warn("Component was already destroyed");
    };
  } }, { key: "$capture_state", value: function() {
  } }, { key: "$inject_state", value: function() {
  } }]), n;
}();
(function(e) {
  Et(n, KD);
  var t = Mt(n);
  function n(r) {
    return Z(this, n), t.call(this, r);
  }
  return Y(n);
})();
function Ur(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !!QD("debug");
  if (t) {
    var n = XD(e);
    return function() {
      for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
        o[a] = arguments[a];
      (r = console).log.apply(r, ["%c".concat(e), "color:".concat(n)].concat(o));
    };
  }
  return GD;
}
function GD() {
}
function QD(e) {
  try {
    if (typeof window < "u" && window.localStorage !== void 0)
      return window.localStorage[e];
  } catch {
  }
}
function XD(e) {
  for (var t = 0, n = 0; n < e.length; n++)
    t = (t << 5) - t + e.charCodeAt(n), t |= 0;
  return Y2[Math.abs(t) % Y2.length];
}
var Y2 = ["#0000CC", "#0099FF", "#009400", "#8dd200", "#CCCC00", "#CC9933", "#ae04e7", "#ff35d7", "#FF3333", "#FF6600", "#FF9933", "#FFCC33"];
function ZD(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.delay, r = n === void 0 ? 0 : n, i = t.duration, o = i === void 0 ? 400 : i, a = t.easing, s = a === void 0 ? dC : a, u = +getComputedStyle(e).opacity;
  return { delay: r, duration: o, easing: s, css: function(c) {
    return "opacity: ".concat(c * u);
  } };
}
var YD = Vm.window;
function tL(e) {
  Te(e, "svelte-g4wg3a", `.svelte-g4wg3a{box-sizing:border-box}.bg.svelte-g4wg3a{position:fixed;z-index:1000;top:0;left:0;display:flex;flex-direction:column;justify-content:center;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.66)}.wrap.svelte-g4wg3a{position:relative;margin:2rem;max-height:100%}.window.svelte-g4wg3a{position:relative;width:40rem;max-width:100%;max-height:100%;margin:2rem auto;color:black;border-radius:0.5rem;background:white}.content.svelte-g4wg3a{position:relative;padding:1rem;max-height:calc(100vh - 4rem);overflow:auto}.close.svelte-g4wg3a{display:block;box-sizing:border-box;position:absolute;z-index:1000;top:1rem;right:1rem;margin:0;padding:0;width:1.5rem;height:1.5rem;border:0;color:black;border-radius:1.5rem;background:white;box-shadow:0 0 0 1px black;transition:transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),
      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);-webkit-appearance:none}.close.svelte-g4wg3a:before,.close.svelte-g4wg3a:after{content:'';display:block;box-sizing:border-box;position:absolute;top:50%;width:1rem;height:1px;background:black;transform-origin:center;transition:height 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),
      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)}.close.svelte-g4wg3a:before{-webkit-transform:translate(0, -50%) rotate(45deg);-moz-transform:translate(0, -50%) rotate(45deg);transform:translate(0, -50%) rotate(45deg);left:0.25rem}.close.svelte-g4wg3a:after{-webkit-transform:translate(0, -50%) rotate(-45deg);-moz-transform:translate(0, -50%) rotate(-45deg);transform:translate(0, -50%) rotate(-45deg);left:0.25rem}.close.svelte-g4wg3a:hover{background:black}.close.svelte-g4wg3a:hover:before,.close.svelte-g4wg3a:hover:after{height:2px;background:white}.close.svelte-g4wg3a:focus{border-color:#3399ff;box-shadow:0 0 0 2px #3399ff}.close.svelte-g4wg3a:active{transform:scale(0.9)}.close.svelte-g4wg3a:hover,.close.svelte-g4wg3a:focus,.close.svelte-g4wg3a:active{outline:none}`);
}
function tx(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y = e[1].closeButton && ex(e), b = e[2];
  return b && (a = new b({})), { c: function() {
    t = rt("div"), n = rt("div"), r = rt("div"), y && y.c(), i = bt(), o = rt("div"), a && Pt(a.$$.fragment), A(o, "class", s = er(e[1].classContent) + " svelte-g4wg3a"), A(o, "style", e[9]), Ut(o, "content", !e[0]), A(r, "class", u = er(e[1].classWindow) + " svelte-g4wg3a"), A(r, "role", "dialog"), A(r, "aria-modal", "true"), A(r, "aria-label", c = e[1].ariaLabelledBy ? null : e[1].ariaLabel || null), A(r, "aria-labelledby", l = e[1].ariaLabelledBy || null), A(r, "style", e[8]), Ut(r, "window", !e[0]), A(n, "class", h = er(e[1].classWindowWrap) + " svelte-g4wg3a"), A(n, "style", e[7]), Ut(n, "wrap", !e[0]), A(t, "class", d = er(e[1].classBg) + " svelte-g4wg3a"), A(t, "style", e[6]), Ut(t, "bg", !e[0]);
  }, m: function(k, w) {
    pt(k, t, w), W(t, n), W(n, r), y && y.m(r, null), W(r, i), W(r, o), a && Ot(a, o, null), e[49](r), e[50](n), e[51](t), v = !0, m || (g = [Nt(r, "introstart", function() {
      Ai(e[13]) && e[13].apply(this, arguments);
    }), Nt(r, "outrostart", function() {
      Ai(e[14]) && e[14].apply(this, arguments);
    }), Nt(r, "introend", function() {
      Ai(e[15]) && e[15].apply(this, arguments);
    }), Nt(r, "outroend", function() {
      Ai(e[16]) && e[16].apply(this, arguments);
    }), Nt(t, "mousedown", e[20]), Nt(t, "mouseup", e[21])], m = !0);
  }, p: function(k, w) {
    if ((e = k)[1].closeButton ? y ? (y.p(e, w), 2 & w[0] && U(y, 1)) : ((y = ex(e)).c(), U(y, 1), y.m(r, i)) : y && (qt(), tt(y, 1, 1, function() {
      y = null;
    }), Vt()), b !== (b = e[2])) {
      if (a) {
        qt();
        var x = a;
        tt(x.$$.fragment, 1, 0, function() {
          At(x, 1);
        }), Vt();
      }
      b ? (Pt((a = new b({})).$$.fragment), U(a.$$.fragment, 1), Ot(a, o, null)) : a = null;
    }
    (!v || 2 & w[0] && s !== (s = er(e[1].classContent) + " svelte-g4wg3a")) && A(o, "class", s), (!v || 512 & w[0]) && A(o, "style", e[9]), 3 & w[0] && Ut(o, "content", !e[0]), (!v || 2 & w[0] && u !== (u = er(e[1].classWindow) + " svelte-g4wg3a")) && A(r, "class", u), (!v || 2 & w[0] && c !== (c = e[1].ariaLabelledBy ? null : e[1].ariaLabel || null)) && A(r, "aria-label", c), (!v || 2 & w[0] && l !== (l = e[1].ariaLabelledBy || null)) && A(r, "aria-labelledby", l), (!v || 256 & w[0]) && A(r, "style", e[8]), 3 & w[0] && Ut(r, "window", !e[0]), (!v || 2 & w[0] && h !== (h = er(e[1].classWindowWrap) + " svelte-g4wg3a")) && A(n, "class", h), (!v || 128 & w[0]) && A(n, "style", e[7]), 3 & w[0] && Ut(n, "wrap", !e[0]), (!v || 2 & w[0] && d !== (d = er(e[1].classBg) + " svelte-g4wg3a")) && A(t, "class", d), (!v || 64 & w[0]) && A(t, "style", e[6]), 3 & w[0] && Ut(t, "bg", !e[0]);
  }, i: function(k) {
    v || (U(y), a && U(a.$$.fragment, k), ia(function() {
      f || (f = vl(r, e[12], e[1].transitionWindowProps, !0)), f.run(1);
    }), ia(function() {
      p || (p = vl(t, e[11], e[1].transitionBgProps, !0)), p.run(1);
    }), v = !0);
  }, o: function(k) {
    tt(y), a && tt(a.$$.fragment, k), f || (f = vl(r, e[12], e[1].transitionWindowProps, !1)), f.run(0), p || (p = vl(t, e[11], e[1].transitionBgProps, !1)), p.run(0), v = !1;
  }, d: function(k) {
    k && vt(t), y && y.d(), a && At(a), e[49](null), k && f && f.end(), e[50](null), e[51](null), k && p && p.end(), m = !1, Dn(g);
  } };
}
function ex(e) {
  var t, n, r, i, o, a = [nL, eL], s = [];
  function u(c, l) {
    return 2 & l[0] && (t = null), t == null && (t = !!c[17](c[1].closeButton)), t ? 0 : 1;
  }
  return n = u(e, [-1, -1, -1]), r = s[n] = a[n](e), { c: function() {
    r.c(), i = Ye();
  }, m: function(c, l) {
    s[n].m(c, l), pt(c, i, l), o = !0;
  }, p: function(c, l) {
    var f = n;
    (n = u(c, l)) === f ? s[n].p(c, l) : (qt(), tt(s[f], 1, 1, function() {
      s[f] = null;
    }), Vt(), (r = s[n]) ? r.p(c, l) : (r = s[n] = a[n](c)).c(), U(r, 1), r.m(i.parentNode, i));
  }, i: function(c) {
    o || (U(r), o = !0);
  }, o: function(c) {
    tt(r), o = !1;
  }, d: function(c) {
    s[n].d(c), c && vt(i);
  } };
}
function eL(e) {
  var t, n, r, i;
  return { c: function() {
    A(t = rt("button"), "class", n = er(e[1].classCloseButton) + " svelte-g4wg3a"), A(t, "aria-label", "Close modal"), A(t, "style", e[10]), A(t, "type", "button"), Ut(t, "close", !e[0]);
  }, m: function(o, a) {
    pt(o, t, a), r || (i = Nt(t, "click", e[18]), r = !0);
  }, p: function(o, a) {
    2 & a[0] && n !== (n = er(o[1].classCloseButton) + " svelte-g4wg3a") && A(t, "class", n), 1024 & a[0] && A(t, "style", o[10]), 3 & a[0] && Ut(t, "close", !o[0]);
  }, i: Wt, o: Wt, d: function(o) {
    o && vt(t), r = !1, i();
  } };
}
function nL(e) {
  var t, n, r, i = e[1].closeButton;
  function o(a) {
    return { props: { onClose: a[18] } };
  }
  return i && (t = new i(o(e))), { c: function() {
    t && Pt(t.$$.fragment), n = Ye();
  }, m: function(a, s) {
    t && Ot(t, a, s), pt(a, n, s), r = !0;
  }, p: function(a, s) {
    if (i !== (i = a[1].closeButton)) {
      if (t) {
        qt();
        var u = t;
        tt(u.$$.fragment, 1, 0, function() {
          At(u, 1);
        }), Vt();
      }
      i ? (Pt((t = new i(o(a))).$$.fragment), U(t.$$.fragment, 1), Ot(t, n.parentNode, n)) : t = null;
    }
  }, i: function(a) {
    r || (t && U(t.$$.fragment, a), r = !0);
  }, o: function(a) {
    t && tt(t.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && vt(n), t && At(t, a);
  } };
}
function rL(e) {
  var t, n, r, i, o = e[2] && tx(e), a = e[48].default, s = Di(a, e, e[47], null);
  return { c: function() {
    o && o.c(), t = bt(), s && s.c();
  }, m: function(u, c) {
    o && o.m(u, c), pt(u, t, c), s && s.m(u, c), n = !0, r || (i = Nt(YD, "keydown", e[19]), r = !0);
  }, p: function(u, c) {
    u[2] ? o ? (o.p(u, c), 4 & c[0] && U(o, 1)) : ((o = tx(u)).c(), U(o, 1), o.m(t.parentNode, t)) : o && (qt(), tt(o, 1, 1, function() {
      o = null;
    }), Vt()), s && s.p && (!n || 65536 & c[1]) && zi(s, a, u, u[47], n ? Li(a, u[47], c, null) : Bi(u[47]), null);
  }, i: function(u) {
    n || (U(o), U(s, u), n = !0);
  }, o: function(u) {
    tt(o), tt(s, u), n = !1;
  }, d: function(u) {
    o && o.d(u), u && vt(t), s && s.d(u), r = !1, i();
  } };
}
function iL(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(n) {
    return new e(Ct(Ct({}, n), {}, { props: Ct(Ct({}, t), n.props) }));
  };
}
function oL(e, t, n) {
  var r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y = t.$$slots, b = y === void 0 ? {} : y, k = t.$$scope, w = Ph(), x = xC, S = t.isTabbable, T = S === void 0 ? function(It) {
    return It.tabIndex >= 0 && !It.hidden && !It.disabled && It.style.display !== "none" && It.type !== "hidden" && Boolean(It.offsetWidth || It.offsetHeight || It.getClientRects().length);
  } : S, P = t.show, O = P === void 0 ? null : P, j = t.key, V = j === void 0 ? "simple-modal" : j, E = t.ariaLabel, C = E === void 0 ? null : E, H = t.ariaLabelledBy, X = H === void 0 ? null : H, F = t.closeButton, G = F === void 0 || F, M = t.closeOnEsc, $ = M === void 0 || M, q = t.closeOnOuterClick, B = q === void 0 || q, D = t.styleBg, _ = D === void 0 ? {} : D, L = t.styleWindowWrap, J = L === void 0 ? {} : L, st = t.styleWindow, ht = st === void 0 ? {} : st, xt = t.styleContent, kt = xt === void 0 ? {} : xt, I = t.styleCloseButton, R = I === void 0 ? {} : I, it = t.classBg, N = it === void 0 ? null : it, K = t.classWindowWrap, z = K === void 0 ? null : K, at = t.classWindow, yt = at === void 0 ? null : at, jt = t.classContent, Ft = jt === void 0 ? null : jt, zt = t.classCloseButton, St = zt === void 0 ? null : zt, Gt = t.unstyled, _e = Gt !== void 0 && Gt, Fe = t.setContext, fn = Fe === void 0 ? x : Fe, De = t.transitionBg, $t = De === void 0 ? ZD : De, oe = t.transitionBgProps, Ce = oe === void 0 ? { duration: 250 } : oe, sn = t.transitionWindow, vn = sn === void 0 ? $t : sn, nt = t.transitionWindowProps, ct = nt === void 0 ? Ce : nt, lt = t.disableFocusTrap, wt = lt !== void 0 && lt, Rt = { ariaLabel: C, ariaLabelledBy: X, closeButton: G, closeOnEsc: $, closeOnOuterClick: B, styleBg: _, styleWindowWrap: J, styleWindow: ht, styleContent: kt, styleCloseButton: R, classBg: N, classWindowWrap: z, classWindow: yt, classContent: Ft, classCloseButton: St, transitionBg: $t, transitionBgProps: Ce, transitionWindow: vn, transitionWindowProps: ct, disableFocusTrap: wt, isTabbable: T, unstyled: _e }, Bt = Ct({}, Rt), ee = null, ie = function(It) {
    return It ? Object.keys(It).reduce(function(un, hn) {
      return "".concat(un, "; ").concat(function(tn) {
        return tn.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
      }(hn), ": ").concat(It[hn]);
    }, "") : "";
  }, gt = function(It) {
    return !!(It && It.constructor && It.call && It.apply);
  }, Kt = function() {
    n(6, s = ie(Object.assign({}, { width: window.innerWidth, height: window.innerHeight }, Bt.styleBg))), n(7, u = ie(Bt.styleWindowWrap)), n(8, c = ie(Bt.styleWindow)), n(9, l = ie(Bt.styleContent)), n(10, f = ie(Bt.styleCloseButton)), n(11, h = Bt.transitionBg), n(12, d = Bt.transitionWindow);
  }, ae = function() {
  }, Yt = ae, se = ae, Ae = ae, me = ae, Se = function(It) {
    var un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, hn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tn = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    n(2, ee = iL(It, un)), n(1, Bt = Ct(Ct({}, Rt), hn)), Kt(), Ee(), n(13, Yt = function(on) {
      tn.onOpen && tn.onOpen(on), w("open"), w("opening");
    }), n(14, se = function(on) {
      tn.onClose && tn.onClose(on), w("close"), w("closing");
    }), n(15, Ae = function(on) {
      tn.onOpened && tn.onOpened(on), w("opened");
    }), n(16, me = function(on) {
      tn.onClosed && tn.onClosed(on), w("closed");
    });
  }, Oe = function() {
    var It = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ee && (n(14, se = It.onClose || se), n(16, me = It.onClosed || me), n(2, ee = null), kn());
  }, Ee = function() {
    a = window.scrollY, p = document.body.style.position, v = document.body.style.overflow, m = document.body.style.width, document.body.style.position = "fixed", document.body.style.top = "-".concat(a, "px"), document.body.style.overflow = "hidden", document.body.style.width = "100%";
  }, kn = function() {
    document.body.style.position = p || "", document.body.style.top = "", document.body.style.overflow = v || "", document.body.style.width = m || "", window.scrollTo(0, a);
  };
  fn(V, { open: Se, close: Oe });
  var Yn = !1;
  return Fa(function() {
    Yn && Oe();
  }), yi(function() {
    n(46, Yn = !0);
  }), e.$$set = function(It) {
    "isTabbable" in It && n(22, T = It.isTabbable), "show" in It && n(23, O = It.show), "key" in It && n(24, V = It.key), "ariaLabel" in It && n(25, C = It.ariaLabel), "ariaLabelledBy" in It && n(26, X = It.ariaLabelledBy), "closeButton" in It && n(27, G = It.closeButton), "closeOnEsc" in It && n(28, $ = It.closeOnEsc), "closeOnOuterClick" in It && n(29, B = It.closeOnOuterClick), "styleBg" in It && n(30, _ = It.styleBg), "styleWindowWrap" in It && n(31, J = It.styleWindowWrap), "styleWindow" in It && n(32, ht = It.styleWindow), "styleContent" in It && n(33, kt = It.styleContent), "styleCloseButton" in It && n(34, R = It.styleCloseButton), "classBg" in It && n(35, N = It.classBg), "classWindowWrap" in It && n(36, z = It.classWindowWrap), "classWindow" in It && n(37, yt = It.classWindow), "classContent" in It && n(38, Ft = It.classContent), "classCloseButton" in It && n(39, St = It.classCloseButton), "unstyled" in It && n(0, _e = It.unstyled), "setContext" in It && n(40, fn = It.setContext), "transitionBg" in It && n(41, $t = It.transitionBg), "transitionBgProps" in It && n(42, Ce = It.transitionBgProps), "transitionWindow" in It && n(43, vn = It.transitionWindow), "transitionWindowProps" in It && n(44, ct = It.transitionWindowProps), "disableFocusTrap" in It && n(45, wt = It.disableFocusTrap), "$$scope" in It && n(47, k = It.$$scope);
  }, e.$$.update = function() {
    8388608 & e.$$.dirty[0] | 32768 & e.$$.dirty[1] && Yn && (gt(O) ? Se(O) : Oe());
  }, [_e, Bt, ee, r, i, o, s, u, c, l, f, h, d, Yt, se, Ae, me, gt, Oe, function(It) {
    if (Bt.closeOnEsc && ee && It.key === "Escape" && (It.preventDefault(), Oe()), ee && It.key === "Tab" && !Bt.disableFocusTrap) {
      var un = o.querySelectorAll("*"), hn = Array.from(un).filter(Bt.isTabbable).sort(function(on, an) {
        return on.tabIndex - an.tabIndex;
      }), tn = hn.indexOf(document.activeElement);
      tn === -1 && It.shiftKey && (tn = 0), tn += hn.length + (It.shiftKey ? -1 : 1), hn[tn %= hn.length].focus(), It.preventDefault();
    }
  }, function(It) {
    !Bt.closeOnOuterClick || It.target !== r && It.target !== i || (g = It.target);
  }, function(It) {
    Bt.closeOnOuterClick && It.target === g && (It.preventDefault(), Oe());
  }, T, O, V, C, X, G, $, B, _, J, ht, kt, R, N, z, yt, Ft, St, fn, $t, Ce, vn, ct, wt, Yn, k, b, function(It) {
    Be[It ? "unshift" : "push"](function() {
      n(5, o = It);
    });
  }, function(It) {
    Be[It ? "unshift" : "push"](function() {
      n(4, i = It);
    });
  }, function(It) {
    Be[It ? "unshift" : "push"](function() {
      n(3, r = It);
    });
  }];
}
var aL = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, oL, rL, ir, { isTabbable: 22, show: 23, key: 24, ariaLabel: 25, ariaLabelledBy: 26, closeButton: 27, closeOnEsc: 28, closeOnOuterClick: 29, styleBg: 30, styleWindowWrap: 31, styleWindow: 32, styleContent: 33, styleCloseButton: 34, classBg: 35, classWindowWrap: 36, classWindow: 37, classContent: 38, classCloseButton: 39, unstyled: 0, setContext: 40, transitionBg: 41, transitionBgProps: 42, transitionWindow: 43, transitionWindowProps: 44, disableFocusTrap: 45 }, tL, [-1, -1, -1]), i;
  }
  return Y(n);
}(), qa = [{ start: 0, end: 100 }], _f = { closeButton: !1, classBg: "jse-modal-bg", classWindow: "jse-modal-window", classWindowWrap: "jse-modal-window-wrap", classContent: "jse-modal-content" }, sL = Ct(Ct({}, _f), {}, { classWindow: "jse-modal-window jse-modal-window-sort" }), uL = Ct(Ct({}, _f), {}, { classWindow: "jse-modal-window jse-modal-window-transform" }), Hm = "Insert or paste contents, enter [ insert a new array, enter { to insert a new object, or start typing to insert a new value", _C = "Open context menu (Click here, right click on the selection, or use the context menu button or Ctrl+Q)", cL = "NO", Wm = "SELF", Um = "NEXT_INSIDE", lL = 0;
function Cf() {
  return ++lL;
}
function fL(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mt = { exports: {} };
(function(e) {
  function t(N) {
    return (t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(K) {
      return typeof K;
    } : function(K) {
      return K && typeof Symbol == "function" && K.constructor === Symbol && K !== Symbol.prototype ? "symbol" : typeof K;
    })(N);
  }
  function n(N, K) {
    return JSON.stringify(N) === JSON.stringify(K);
  }
  function r(N, K) {
    return N === K;
  }
  function i(N) {
    return N.slice(0, N.length - 1);
  }
  function o(N) {
    return N[N.length - 1];
  }
  function a(N, K) {
    var z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : r;
    if (N.length < K.length)
      return !1;
    for (var at = 0; at < K.length; at++)
      if (!z(N[at], K[at]))
        return !1;
    return !0;
  }
  function s(N) {
    return t(N) === "object" && N !== null;
  }
  function u(N, K) {
    var z = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var at = Object.getOwnPropertySymbols(N);
      K && (at = at.filter(function(yt) {
        return Object.getOwnPropertyDescriptor(N, yt).enumerable;
      })), z.push.apply(z, at);
    }
    return z;
  }
  function c(N) {
    for (var K = 1; K < arguments.length; K++) {
      var z = arguments[K] != null ? arguments[K] : {};
      K % 2 ? u(Object(z), !0).forEach(function(at) {
        l(N, at, z[at]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(z)) : u(Object(z)).forEach(function(at) {
        Object.defineProperty(N, at, Object.getOwnPropertyDescriptor(z, at));
      });
    }
    return N;
  }
  function l(N, K, z) {
    return K in N ? Object.defineProperty(N, K, { value: z, enumerable: !0, configurable: !0, writable: !0 }) : N[K] = z, N;
  }
  function f(N) {
    return (f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(K) {
      return typeof K;
    } : function(K) {
      return K && typeof Symbol == "function" && K.constructor === Symbol && K !== Symbol.prototype ? "symbol" : typeof K;
    })(N);
  }
  function h(N) {
    if (Array.isArray(N)) {
      var K = N.slice();
      return Object.getOwnPropertySymbols(N).forEach(function(at) {
        K[at] = N[at];
      }), K;
    }
    if (f(N) === "object") {
      var z = c({}, N);
      return Object.getOwnPropertySymbols(N).forEach(function(at) {
        z[at] = N[at];
      }), z;
    }
    return N;
  }
  function d(N, K, z) {
    if (N[K] === z)
      return N;
    var at = h(N);
    return at[K] = z, at;
  }
  function p(N, K) {
    for (var z = N, at = 0; at < K.length; )
      z = s(z) ? z[K[at]] : void 0, at++;
    return z;
  }
  function v(N, K, z) {
    var at = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    if (K.length === 0)
      return z;
    var yt = K[0], jt = v(N ? N[yt] : void 0, K.slice(1), z, at);
    if (!s(N)) {
      if (at) {
        var Ft = typeof yt == "number" ? [] : {};
        return Ft[yt] = jt, Ft;
      }
      throw new Error("Path does not exist");
    }
    return d(N, yt, jt);
  }
  function m(N, K, z) {
    if (K.length === 0)
      return z(N);
    if (!s(N))
      throw new Error("Path doesn't exist");
    var at = K[0];
    return d(N, at, m(N[at], K.slice(1), z));
  }
  function g(N, K) {
    if (K.length === 0)
      return N;
    if (!s(N))
      throw new Error("Path does not exist");
    if (K.length === 1) {
      var z = K[0];
      if (z in N) {
        var at = h(N);
        return Array.isArray(at) ? at.splice(z, 1) : delete at[z], at;
      }
      return N;
    }
    var yt = K[0];
    return d(N, yt, g(N[yt], K.slice(1)));
  }
  function y(N, K, z) {
    var at = K.slice(0, K.length - 1), yt = K[K.length - 1];
    return m(N, at, function(jt) {
      if (!Array.isArray(jt))
        throw new TypeError("Array expected at path " + JSON.stringify(at));
      var Ft = h(jt);
      return Ft.splice(yt, 0, z), Ft;
    });
  }
  function b(N, K) {
    return N !== void 0 && (K.length === 0 || b(N[K[0]], K.slice(1)));
  }
  function k(N) {
    var K = N.split("/");
    return K.shift(), K.map(function(z) {
      return z.replace(/~1/g, "/").replace(/~0/g, "~");
    });
  }
  function w(N) {
    return N.map(x).join("");
  }
  function x(N) {
    return "/" + String(N).replace(/~/g, "~0").replace(/\//g, "~1");
  }
  function S(N, K) {
    return N + x(K);
  }
  function T(N, K) {
    return N.startsWith(K) && (N.length === K.length || N[K.length] === "/");
  }
  function P(N, K, z) {
    for (var at = N, yt = 0; yt < K.length; yt++) {
      G(K[yt]);
      var jt = K[yt];
      if (z && z.before) {
        var Ft = z.before(at, jt);
        Ft !== void 0 && (Ft.json !== void 0 && (at = Ft.json), Ft.operation !== void 0 && (jt = Ft.operation));
      }
      var zt = at, St = M(at, jt.path);
      if (jt.op === "add")
        at = V(at, St, jt.value);
      else if (jt.op === "remove")
        at = j(at, St);
      else if (jt.op === "replace")
        at = O(at, St, jt.value);
      else if (jt.op === "copy")
        at = E(at, St, $(jt.from));
      else if (jt.op === "move")
        at = C(at, St, $(jt.from));
      else {
        if (jt.op !== "test")
          throw new Error("Unknown JSONPatch operation " + JSON.stringify(jt.op));
        H(at, St, jt.value);
      }
      if (z && z.after) {
        var Gt = z.after(at, jt, zt);
        Gt !== void 0 && (at = Gt);
      }
    }
    return at;
  }
  function O(N, K, z) {
    return v(N, K, z);
  }
  function j(N, K) {
    return g(N, K);
  }
  function V(N, K, z) {
    return X(N, K) ? y(N, K, z) : v(N, K, z);
  }
  function E(N, K, z) {
    var at = p(N, z);
    return X(N, K) ? y(N, K, at) : v(N, K, p(N, z));
  }
  function C(N, K, z) {
    var at = p(N, z), yt = g(N, z);
    return X(yt, K) ? y(yt, K, at) : v(yt, K, at);
  }
  function H(N, K, z) {
    if (z === void 0)
      throw new Error('Test failed: no value provided (path: "'.concat(w(K), '")'));
    if (!b(N, K))
      throw new Error('Test failed: path not found (path: "'.concat(w(K), '")'));
    if (!n(p(N, K), z))
      throw new Error('Test failed, value differs (path: "'.concat(w(K), '")'));
  }
  function X(N, K) {
    if (K.length === 0)
      return !1;
    var z = p(N, i(K));
    return Array.isArray(z);
  }
  function F(N, K) {
    if (o(K) !== "-")
      return K;
    var z = i(K), at = p(N, z);
    return z.concat(at.length);
  }
  function G(N) {
    if (!["add", "remove", "replace", "copy", "move", "test"].includes(N.op))
      throw new Error("Unknown JSONPatch op " + JSON.stringify(N.op));
    if (typeof N.path != "string")
      throw new Error('Required property "path" missing or not a string in operation ' + JSON.stringify(N));
    if ((N.op === "copy" || N.op === "move") && typeof N.from != "string")
      throw new Error('Required property "from" missing or not a string in operation ' + JSON.stringify(N));
  }
  function M(N, K) {
    return F(N, k(K));
  }
  function $(N) {
    return k(N);
  }
  function q(N, K, z) {
    var at = [];
    return P(N, K, { before: function(yt, jt) {
      var Ft, zt, St = M(yt, jt.path);
      if (jt.op === "add")
        Ft = _(yt, St, jt.value);
      else if (jt.op === "remove")
        Ft = D(yt, St);
      else if (jt.op === "replace")
        Ft = B(yt, St);
      else if (jt.op === "copy")
        Ft = L(yt, St, jt.value);
      else if (jt.op === "move")
        Ft = J(yt, St, $(jt.from));
      else {
        if (jt.op !== "test")
          throw new Error("Unknown JSONPatch operation " + JSON.stringify(jt.op));
        Ft = [];
      }
      if (z && z.before) {
        var Gt = z.before(yt, jt, Ft);
        Gt && Gt.revertOperations && (Ft = Gt.revertOperations), Gt && Gt.json && (zt = Gt.json);
      }
      if (at = Ft.concat(at), zt !== void 0)
        return { json: zt };
    } }), at;
  }
  function B(N, K) {
    return [{ op: "replace", path: w(K), value: p(N, K) }];
  }
  function D(N, K) {
    return [{ op: "add", path: w(K), value: p(N, K) }];
  }
  function _(N, K, z) {
    return X(N, K) || !b(N, K) ? [{ op: "remove", path: w(K) }] : B(N, K);
  }
  function L(N, K, z) {
    return _(N, K);
  }
  function J(N, K, z) {
    if (K.length < z.length && a(z, K))
      return [{ op: "replace", path: w(K), value: N }];
    var at = [{ op: "move", from: w(K), path: w(z) }];
    return !X(N, K) && b(N, K) && (at = at.concat(D(N, K))), at;
  }
  function st(N) {
    return !!N && typeof N.op == "string";
  }
  function ht(N) {
    return !!N && N.op === "add";
  }
  function xt(N) {
    return !!N && N.op === "remove";
  }
  function kt(N) {
    return !!N && N.op === "replace";
  }
  function I(N) {
    return !!N && N.op === "copy";
  }
  function R(N) {
    return !!N && N.op === "move";
  }
  function it(N) {
    return !!N && N.op === "test";
  }
  e.appendToJSONPointer = S, e.compileJSONPointer = w, e.compileJSONPointerProp = x, e.deleteIn = g, e.existsIn = b, e.getIn = p, e.immutableJSONPatch = P, e.insertAt = y, e.isJSONPatchAdd = ht, e.isJSONPatchCopy = I, e.isJSONPatchMove = R, e.isJSONPatchOperation = st, e.isJSONPatchRemove = xt, e.isJSONPatchReplace = kt, e.isJSONPatchTest = it, e.parseFrom = $, e.parseJSONPointer = k, e.parsePath = M, e.revertJSONPatch = q, e.setIn = v, e.startsWithJSONPointer = T, e.updateIn = m, Object.defineProperty(e, "__esModule", { value: !0 });
})(mt.exports);
var Of = {}, nx = { b: "\b", f: "\f", n: `
`, r: "\r", t: "	", '"': '"', "/": "/", "\\": "\\" }, hL = "a".charCodeAt();
Of.parse = function(e, t, n) {
  var r = {}, i = 0, o = 0, a = 0, s = n && n.bigint && typeof BigInt < "u";
  return { data: u("", !0), pointers: r };
  function u(x, S) {
    var T;
    c(), m(x, "value");
    var P = h();
    switch (P) {
      case "t":
        f("rue"), T = !0;
        break;
      case "f":
        f("alse"), T = !1;
        break;
      case "n":
        f("ull"), T = null;
        break;
      case '"':
        T = l();
        break;
      case "[":
        T = function(O) {
          c();
          var j = [], V = 0;
          if (h() == "]")
            return j;
          for (d(); ; ) {
            var E = O + "/" + V;
            j.push(u(E)), c();
            var C = h();
            if (C == "]")
              break;
            C != "," && k(), c(), V++;
          }
          return j;
        }(x);
        break;
      case "{":
        T = function(O) {
          c();
          var j = {};
          if (h() == "}")
            return j;
          for (d(); ; ) {
            var V = y();
            h() != '"' && k();
            var E = l(), C = O + "/" + Md(E);
            g(C, "key", V), m(C, "keyEnd"), c(), h() != ":" && k(), c(), j[E] = u(C), c();
            var H = h();
            if (H == "}")
              break;
            H != "," && k(), c();
          }
          return j;
        }(x);
        break;
      default:
        d(), "-0123456789".indexOf(P) >= 0 ? T = function() {
          var O = "", j = !0;
          e[a] == "-" && (O += h()), O += e[a] == "0" ? h() : v(), e[a] == "." && (O += h() + v(), j = !1), e[a] != "e" && e[a] != "E" || (O += h(), e[a] != "+" && e[a] != "-" || (O += h()), O += v(), j = !1);
          var V = +O;
          return s && j && (V > Number.MAX_SAFE_INTEGER || V < Number.MIN_SAFE_INTEGER) ? BigInt(O) : V;
        }() : b();
    }
    return m(x, "valueEnd"), c(), S && a < e.length && b(), T;
  }
  function c() {
    t:
      for (; a < e.length; ) {
        switch (e[a]) {
          case " ":
            o++;
            break;
          case "	":
            o += 4;
            break;
          case "\r":
            o = 0;
            break;
          case `
`:
            o = 0, i++;
            break;
          default:
            break t;
        }
        a++;
      }
  }
  function l() {
    for (var x, S = ""; (x = h()) != '"'; )
      x == "\\" ? (x = h()) in nx ? S += nx[x] : x == "u" ? S += p() : k() : S += x;
    return S;
  }
  function f(x) {
    for (var S = 0; S < x.length; S++)
      h() !== x[S] && k();
  }
  function h() {
    w();
    var x = e[a];
    return a++, o++, x;
  }
  function d() {
    a--, o--;
  }
  function p() {
    for (var x = 4, S = 0; x--; ) {
      S <<= 4;
      var T = h().toLowerCase();
      T >= "a" && T <= "f" ? S += T.charCodeAt() - hL + 10 : T >= "0" && T <= "9" ? S += +T : k();
    }
    return String.fromCharCode(S);
  }
  function v() {
    for (var x = ""; e[a] >= "0" && e[a] <= "9"; )
      x += h();
    if (x.length)
      return x;
    w(), b();
  }
  function m(x, S) {
    g(x, S, y());
  }
  function g(x, S, T) {
    r[x] = r[x] || {}, r[x][S] = T;
  }
  function y() {
    return { line: i, column: o, pos: a };
  }
  function b() {
    throw new SyntaxError("Unexpected token " + e[a] + " in JSON at position " + a);
  }
  function k() {
    d(), b();
  }
  function w() {
    if (a >= e.length)
      throw new SyntaxError("Unexpected end of JSON input");
  }
}, Of.stringify = function(e, t, n) {
  if (pl(e)) {
    var r, i, o = 0, a = ne(n) == "object" ? n.space : n;
    switch (ne(a)) {
      case "number":
        var s = a > 10 ? 10 : a < 0 ? 0 : Math.floor(a);
        a = s && y(s, " "), r = s, i = s;
        break;
      case "string":
        a = a.slice(0, 10), r = 0, i = 0;
        for (var u = 0; u < a.length; u++) {
          switch (a[u]) {
            case " ":
              i++;
              break;
            case "	":
              i += 4;
              break;
            case "\r":
              i = 0;
              break;
            case `
`:
              i = 0, o++;
              break;
            default:
              throw new Error("whitespace characters not allowed in JSON");
          }
          r++;
        }
        break;
      default:
        a = void 0;
    }
    var c = "", l = {}, f = 0, h = 0, d = 0, p = n && n.es6 && typeof Map == "function";
    return function b(k, w, x) {
      switch (g(x, "value"), ne(k)) {
        case "number":
        case "bigint":
        case "boolean":
          v("" + k);
          break;
        case "string":
          v(ml(k));
          break;
        case "object":
          k === null ? v("null") : typeof k.toJSON == "function" ? v(ml(k.toJSON())) : Array.isArray(k) ? S() : p ? k.constructor.BYTES_PER_ELEMENT ? S() : k instanceof Map ? P() : k instanceof Set ? P(!0) : T() : T();
      }
      function S() {
        if (k.length) {
          v("[");
          for (var O = w + 1, j = 0; j < k.length; j++) {
            j && v(","), m(O);
            var V = pl(k[j]) ? k[j] : null;
            b(V, O, x + "/" + j);
          }
          m(w), v("]");
        } else
          v("[]");
      }
      function T() {
        var O = Object.keys(k);
        if (O.length) {
          v("{");
          for (var j = w + 1, V = 0; V < O.length; V++) {
            var E = O[V], C = k[E];
            if (pl(C)) {
              V && v(",");
              var H = x + "/" + Md(E);
              m(j), g(H, "key"), v(ml(E)), g(H, "keyEnd"), v(":"), a && v(" "), b(C, j, H);
            }
          }
          m(w), v("}");
        } else
          v("{}");
      }
      function P(O) {
        if (k.size) {
          v("{");
          for (var j = w + 1, V = !0, E = k.entries(), C = E.next(); !C.done; ) {
            var H = C.value, X = H[0], F = !!O || H[1];
            if (pl(F)) {
              V || v(","), V = !1;
              var G = x + "/" + Md(X);
              m(j), g(G, "key"), v(ml(X)), g(G, "keyEnd"), v(":"), a && v(" "), b(F, j, G);
            }
            C = E.next();
          }
          m(w), v("}");
        } else
          v("{}");
      }
      g(x, "valueEnd");
    }(e, 0, ""), { json: c, pointers: l };
  }
  function v(b) {
    h += b.length, d += b.length, c += b;
  }
  function m(b) {
    if (a) {
      for (c += `
` + y(b, a), f++, h = 0; b--; )
        o ? (f += o, h = i) : h += i, d += r;
      d += 1;
    }
  }
  function g(b, k) {
    l[b] = l[b] || {}, l[b][k] = { line: f, column: h, pos: d };
  }
  function y(b, k) {
    return Array(b + 1).join(k);
  }
};
var dL = ["number", "bigint", "boolean", "string", "object"];
function pl(e) {
  return dL.indexOf(ne(e)) >= 0;
}
var vL = /"|\\/g, pL = /[\b]/g, mL = /\f/g, gL = /\n/g, yL = /\r/g, bL = /\t/g;
function ml(e) {
  return '"' + (e = e.replace(vL, "\\$&").replace(mL, "\\f").replace(pL, "\\b").replace(gL, "\\n").replace(yL, "\\r").replace(bL, "\\t")) + '"';
}
var kL = /~/g, wL = /\//g;
function Md(e) {
  return e.replace(kL, "~0").replace(wL, "~1");
}
var Zo = function() {
  function e(_, L) {
    if (!(this instanceof e))
      throw new SyntaxError("Constructor must be called with the new operator");
    this.message = _ + " (char " + L + ")", this.char = L, this.stack = new Error().stack;
  }
  (e.prototype = new Error()).constructor = Error;
  var t = { "'": !0, "\u2018": !0, "\u2019": !0, "`": !0, "\xB4": !0 }, n = { '"': !0, "\u201C": !0, "\u201D": !0 };
  function r(_) {
    return i.test(_);
  }
  var i = /^[a-zA-Z_]$/, o = /^[0-9a-fA-F]$/;
  function a(_) {
    return s.test(_);
  }
  var s = /^[0-9]$/;
  function u(_) {
    return _ === " " || _ === "	" || _ === `
` || _ === "\r";
  }
  function c(_) {
    return _ === "\xA0" || "\u2000" <= _ && _ <= "\u200A" || _ === "\u202F" || _ === "\u205F" || _ === "\u3000";
  }
  function l(_) {
    return t[_] === !0;
  }
  function f(_) {
    return n[_] === !0;
  }
  function h(_) {
    return t[_] === !0 ? "'" : n[_] === !0 ? '"' : _;
  }
  function d(_, L) {
    return (L = _.lastIndexOf(L)) !== -1 ? _.substring(0, L) + _.substring(L + 1) : _;
  }
  function p(_, L) {
    var J = _.length;
    if (!u(_[J - 1]))
      return _ + L;
    for (; u(_[J - 1]); )
      J--;
    return _.substring(0, J) + L + _.substring(J);
  }
  var v = 0, m = 1, g = 2, y = 3, b = 4, k = 5, w = 6, x = { "": !0, "{": !0, "}": !0, "[": !0, "]": !0, ":": !0, ",": !0, "(": !0, ")": !0, ";": !0, "+": !0 }, S = { '"': '"', "\\": "\\", "/": "/", b: "\b", f: "\f", n: `
`, r: "\r", t: "	" }, T = { "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t" }, P = { null: "null", true: "true", false: "false" }, O = { None: "null", True: "true", False: "false" }, j = "", V = "", E = 0, C = "", H = "", X = w;
  function F() {
    E++, C = j.charAt(E);
  }
  function G() {
    F(), C === "\\" && F();
  }
  function M() {
    return X === v && (H === "[" || H === "{") || X === g || X === m || X === y;
  }
  function $() {
    V += H, X = w, H = "", x[C] ? (X = v, H = C, F()) : function() {
      if (a(C) || C === "-") {
        if (X = m, C === "-") {
          if (H += C, F(), !a(C))
            throw new e("Invalid number, digit expected", E);
        } else
          C === "0" && (H += C, F());
        for (; a(C); )
          H += C, F();
        if (C === ".") {
          if (H += C, F(), !a(C))
            throw new e("Invalid number, digit expected", E);
          for (; a(C); )
            H += C, F();
        }
        if (C === "e" || C === "E") {
          if (H += C, F(), C !== "+" && C !== "-" || (H += C, F()), !a(C))
            throw new e("Invalid number, digit expected", E);
          for (; a(C); )
            H += C, F();
        }
      } else
        C === "\\" && j.charAt(E + 1) === '"' ? (F(), B(G)) : B(F);
    }(), X === b && (H = function(_) {
      for (var L = "", J = 0; J < _.length; J++) {
        var st = _[J];
        L += c(st) ? " " : st;
      }
      return L;
    }(H), $()), X === k && (X = w, H = "", $());
  }
  function q() {
    H === "," && (H = "", X = w, $());
  }
  function B(_) {
    if (t[L = C] === !0 || n[L] === !0) {
      var L = h(C), J = l(C) ? l : f;
      for (H += '"', X = g, _(); C !== "" && !J(C); )
        if (C === "\\")
          if (_(), S[C] !== void 0)
            H += "\\" + C, _();
          else if (C === "u") {
            H += "\\u", _();
            for (var st = 0; st < 4; st++) {
              if (ht = C, !o.test(ht))
                throw new e("Invalid unicode character", E - H.length);
              H += C, _();
            }
          } else {
            if (C !== "'")
              throw new e('Invalid escape character "\\' + C + '"', E);
            H += "'", _();
          }
        else
          T[C] ? H += T[C] : H += C === '"' ? '\\"' : C, _();
      if (h(C) !== L)
        throw new e("End of string expected", E - H.length);
      return H += '"', void _();
    }
    var ht;
    (function() {
      if (r(C))
        for (X = y; r(C) || a(C) || C === "$"; )
          H += C, F();
      else
        (function() {
          if (u(C) || c(C))
            for (X = b; u(C) || c(C); )
              H += C, F();
          else
            (function() {
              if (C !== "/" || j[E + 1] !== "*")
                if (C !== "/" || j[E + 1] !== "/")
                  (function() {
                    for (X = w; C !== ""; )
                      H += C, F();
                    throw new e('Syntax error in part "' + H + '"', E - H.length);
                  })();
                else
                  for (X = k; C !== "" && C !== `
`; )
                    H += C, F();
              else {
                for (X = k; C !== "" && (C !== "*" || C === "*" && j[E + 1] !== "/"); )
                  H += C, F();
                C === "*" && j[E + 1] === "/" && (H += C, F(), H += C, F());
              }
            })();
        })();
    })();
  }
  function D() {
    if (X !== v || H !== "{")
      (function() {
        if (X !== v || H !== "[")
          (function() {
            if (X !== g)
              (X !== m ? function() {
                if (X !== y)
                  (function() {
                    throw new e(H === "" ? "Unexpected end of json string" : "Value expected", E - H.length);
                  })();
                else if (P[H])
                  $();
                else {
                  if (O[H])
                    return H = O[H], $();
                  var L = H, J = V.length;
                  if (H = "", $(), X === v && H === "(")
                    return H = "", $(), D(), X === v && H === ")" && (H = "", $(), X === v && H === ";" && (H = "", $()));
                  for (V = function(st, ht, xt) {
                    return st.substring(0, xt) + ht + st.substring(xt);
                  }(V, '"'.concat(L), J); X === y || X === m; )
                    $();
                  V += '"';
                }
              } : $)();
            else
              for ($(); X === v && H === "+"; ) {
                var _;
                H = "", $(), X === g && (_ = V.lastIndexOf('"'), V = V.substring(0, _) + H.substring(1), H = "", $());
              }
          })();
        else if ($(), X !== v || H !== "]") {
          for (; ; )
            if (D(), X === v && H === ",") {
              if ($(), X === v && H === "]") {
                V = d(V, ",");
                break;
              }
              if (H === "") {
                V = d(V, ",");
                break;
              }
            } else {
              if (!M())
                break;
              V = p(V, ",");
            }
          X === v && H === "]" ? $() : V = p(V, "]");
        } else
          $();
      })();
    else if ($(), X !== v || H !== "}") {
      for (; ; ) {
        if (X !== y && X !== m || (X = g, H = '"'.concat(H, '"')), X !== g)
          throw new e("Object key expected", E - H.length);
        if ($(), X === v && H === ":")
          $();
        else {
          if (!M())
            throw new e("Colon expected", E - H.length);
          V = p(V, ":");
        }
        if (D(), X === v && H === ",") {
          if ($(), X === v && H === "}") {
            V = d(V, ",");
            break;
          }
          if (H === "") {
            V = d(V, ",");
            break;
          }
        } else {
          if (X !== g && X !== m && X !== y)
            break;
          V = p(V, ",");
        }
      }
      X === v && H === "}" ? $() : V = p(V, "}");
    } else
      $();
  }
  return function(_) {
    V = "", E = 0, C = (j = _).charAt(0), H = "", X = w, $();
    var L = X;
    if (D(), q(), H === "")
      return V;
    if (L === X && M()) {
      for (var J = ""; L === X && M(); )
        J += V = p(V, ","), V = "", D(), q();
      return `[
`.concat(J).concat(V, `
]`);
    }
    throw new e("Unexpected characters", E - H.length);
  };
}();
function mr(e) {
  return ne(e) === "object" && e !== null && !Array.isArray(e);
}
function ur(e) {
  return ne(e) === "object" && e !== null;
}
function CC(e) {
  var t = window.document.createElement("div");
  return t.style.color = e, t.style.color.split(/\s+/).join("").toLowerCase() || null;
}
function Jm(e) {
  return e === null ? "null" : e === void 0 ? "undefined" : typeof e == "number" ? "number" : typeof e == "string" ? "string" : typeof e == "boolean" ? "boolean" : e instanceof RegExp ? "regexp" : Array.isArray(e) ? "array" : "object";
}
var xL = /^https?:\/\/\S+$/;
function Km(e) {
  return typeof e == "string" && xL.test(e);
}
function Rc(e) {
  if (e === "")
    return "";
  if (e === "null")
    return null;
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  var t = Number(e);
  return isNaN(t) || isNaN(parseFloat(e)) ? e : t;
}
var OC = (typeof global > "u" ? "undefined" : ne(global)) == "object" && global && global.Object === Object && global, jL = (typeof self > "u" ? "undefined" : ne(self)) == "object" && self && self.Object === Object && self, dr = OC || jL || Function("return this")(), _r = dr.Symbol, AC = Object.prototype, SL = AC.hasOwnProperty, $L = AC.toString, $u = _r ? _r.toStringTag : void 0, _L = Object.prototype.toString, rx = _r ? _r.toStringTag : void 0;
function zr(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : rx && rx in Object(e) ? function(t) {
    var n = SL.call(t, $u), r = t[$u];
    try {
      t[$u] = void 0;
      var i = !0;
    } catch {
    }
    var o = $L.call(t);
    return i && (n ? t[$u] = r : delete t[$u]), o;
  }(e) : function(t) {
    return _L.call(t);
  }(e);
}
function Un(e) {
  return e != null && ne(e) == "object";
}
function Wr(e) {
  return ne(e) == "symbol" || Un(e) && zr(e) == "[object Symbol]";
}
function ix(e) {
  return typeof e == "number" ? e : Wr(e) ? NaN : +e;
}
function qn(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var Ne = Array.isArray, ox = _r ? _r.prototype : void 0, ax = ox ? ox.toString : void 0;
function ni(e) {
  if (typeof e == "string")
    return e;
  if (Ne(e))
    return qn(e, ni) + "";
  if (Wr(e))
    return ax ? ax.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Th(e, t) {
  return function(n, r) {
    var i;
    if (n === void 0 && r === void 0)
      return t;
    if (n !== void 0 && (i = n), r !== void 0) {
      if (i === void 0)
        return r;
      typeof n == "string" || typeof r == "string" ? (n = ni(n), r = ni(r)) : (n = ix(n), r = ix(r)), i = e(n, r);
    }
    return i;
  };
}
var PC = Th(function(e, t) {
  return e + t;
}, 0), CL = /\s/;
function EC(e) {
  for (var t = e.length; t-- && CL.test(e.charAt(t)); )
    ;
  return t;
}
var OL = /^\s+/;
function MC(e) {
  return e && e.slice(0, EC(e) + 1).replace(OL, "");
}
function Rn(e) {
  var t = ne(e);
  return e != null && (t == "object" || t == "function");
}
var AL = /^[-+]0x[0-9a-f]+$/i, PL = /^0b[01]+$/i, EL = /^0o[0-7]+$/i, ML = parseInt;
function ti(e) {
  if (typeof e == "number")
    return e;
  if (Wr(e))
    return NaN;
  if (Rn(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Rn(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = MC(e);
  var n = PL.test(e);
  return n || EL.test(e) ? ML(e.slice(2), n ? 2 : 8) : AL.test(e) ? NaN : +e;
}
function ao(e) {
  return e ? (e = ti(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : e === 0 ? e : 0;
}
function ze(e) {
  var t = ao(e), n = t % 1;
  return t == t ? n ? t - n : t : 0;
}
function TC(e, t) {
  if (typeof t != "function")
    throw new TypeError("Expected a function");
  return e = ze(e), function() {
    if (--e < 1)
      return t.apply(this, arguments);
  };
}
function Cr(e) {
  return e;
}
function go(e) {
  if (!Rn(e))
    return !1;
  var t = zr(e);
  return t == "[object Function]" || t == "[object GeneratorFunction]" || t == "[object AsyncFunction]" || t == "[object Proxy]";
}
var sx, tf = dr["__core-js_shared__"], ux = (sx = /[^.]+$/.exec(tf && tf.keys && tf.keys.IE_PROTO || "")) ? "Symbol(src)_1." + sx : "", TL = Function.prototype.toString;
function es(e) {
  if (e != null) {
    try {
      return TL.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var IL = /^\[object .+?Constructor\]$/, NL = Function.prototype, RL = Object.prototype, DL = NL.toString, LL = RL.hasOwnProperty, zL = RegExp("^" + DL.call(LL).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function IC(e) {
  return !(!Rn(e) || function(t) {
    return !!ux && ux in t;
  }(e)) && (go(e) ? zL : IL).test(es(e));
}
function ns(e, t) {
  var n = function(r, i) {
    return r == null ? void 0 : r[i];
  }(e, t);
  return IC(n) ? n : void 0;
}
var oc = ns(dr, "WeakMap"), Af = oc && new oc(), NC = Af ? function(e, t) {
  return Af.set(e, t), e;
} : Cr, cx = Object.create, ru = function() {
  function e() {
  }
  return function(t) {
    if (!Rn(t))
      return {};
    if (cx)
      return cx(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Vu(e) {
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return new e();
      case 1:
        return new e(t[0]);
      case 2:
        return new e(t[0], t[1]);
      case 3:
        return new e(t[0], t[1], t[2]);
      case 4:
        return new e(t[0], t[1], t[2], t[3]);
      case 5:
        return new e(t[0], t[1], t[2], t[3], t[4]);
      case 6:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
      case 7:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
    }
    var n = ru(e.prototype), r = e.apply(n, t);
    return Rn(r) ? r : n;
  };
}
function ri(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var BL = Math.max;
function RC(e, t, n, r) {
  for (var i = -1, o = e.length, a = n.length, s = -1, u = t.length, c = BL(o - a, 0), l = Array(u + c), f = !r; ++s < u; )
    l[s] = t[s];
  for (; ++i < a; )
    (f || i < o) && (l[n[i]] = e[i]);
  for (; c--; )
    l[s++] = e[i++];
  return l;
}
var FL = Math.max;
function DC(e, t, n, r) {
  for (var i = -1, o = e.length, a = -1, s = n.length, u = -1, c = t.length, l = FL(o - s, 0), f = Array(l + c), h = !r; ++i < l; )
    f[i] = e[i];
  for (var d = i; ++u < c; )
    f[d + u] = t[u];
  for (; ++a < s; )
    (h || i < o) && (f[d + n[a]] = e[i++]);
  return f;
}
function qL(e, t) {
  for (var n = e.length, r = 0; n--; )
    e[n] === t && ++r;
  return r;
}
function Ih() {
}
function Ke(e) {
  this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
}
function Qe() {
}
Ke.prototype = ru(Ih.prototype), Ke.prototype.constructor = Ke;
var Gm = Af ? function(e) {
  return Af.get(e);
} : Qe, ws = {}, VL = Object.prototype.hasOwnProperty;
function ef(e) {
  for (var t = e.name + "", n = ws[t], r = VL.call(ws, t) ? n.length : 0; r--; ) {
    var i = n[r], o = i.func;
    if (o == null || o == e)
      return i.name;
  }
  return t;
}
function pi(e, t) {
  this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
}
function Vr(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
function LC(e) {
  if (e instanceof Ke)
    return e.clone();
  var t = new pi(e.__wrapped__, e.__chain__);
  return t.__actions__ = Vr(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
}
pi.prototype = ru(Ih.prototype), pi.prototype.constructor = pi;
var HL = Object.prototype.hasOwnProperty;
function Q(e) {
  if (Un(e) && !Ne(e) && !(e instanceof Ke)) {
    if (e instanceof pi)
      return e;
    if (HL.call(e, "__wrapped__"))
      return LC(e);
  }
  return new pi(e);
}
function Xv(e) {
  var t = ef(e), n = Q[t];
  if (typeof n != "function" || !(t in Ke.prototype))
    return !1;
  if (e === n)
    return !0;
  var r = Gm(n);
  return !!r && e === r[0];
}
Q.prototype = Ih.prototype, Q.prototype.constructor = Q;
var WL = Date.now;
function zC(e) {
  var t = 0, n = 0;
  return function() {
    var r = WL(), i = 16 - (r - n);
    if (n = r, i > 0) {
      if (++t >= 800)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var BC = zC(NC), UL = /\{\n\/\* \[wrapped with (.+)\] \*/, JL = /,? & /, KL = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
function Nh(e) {
  return function() {
    return e;
  };
}
var Pf = function() {
  try {
    var e = ns(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Qm = zC(Pf ? function(e, t) {
  return Pf(e, "toString", { configurable: !0, enumerable: !1, value: Nh(t), writable: !0 });
} : Cr);
function fi(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function Rh(e, t, n, r) {
  for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
function FC(e) {
  return e != e;
}
function iu(e, t, n) {
  return t == t ? function(r, i, o) {
    for (var a = o - 1, s = r.length; ++a < s; )
      if (r[a] === i)
        return a;
    return -1;
  }(e, t, n) : Rh(e, FC, n);
}
function Dh(e, t) {
  return !!(e != null && e.length) && iu(e, t, 0) > -1;
}
var GL = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];
function qC(e, t, n) {
  var r = t + "";
  return Qm(e, function(i, o) {
    var a = o.length;
    if (!a)
      return i;
    var s = a - 1;
    return o[s] = (a > 1 ? "& " : "") + o[s], o = o.join(a > 2 ? ", " : " "), i.replace(KL, `{
/* [wrapped with ` + o + `] */
`);
  }(r, function(i, o) {
    return fi(GL, function(a) {
      var s = "_." + a[0];
      o & a[1] && !Dh(i, s) && i.push(s);
    }), i.sort();
  }(function(i) {
    var o = i.match(UL);
    return o ? o[1].split(JL) : [];
  }(r), n)));
}
function VC(e, t, n, r, i, o, a, s, u, c) {
  var l = 8 & t;
  t |= l ? 32 : 64, 4 & (t &= ~(l ? 64 : 32)) || (t &= -4);
  var f = [e, t, i, l ? o : void 0, l ? a : void 0, l ? void 0 : o, l ? void 0 : a, s, u, c], h = n.apply(void 0, f);
  return Xv(e) && BC(h, f), h.placeholder = r, qC(h, e, t);
}
function ou(e) {
  return e.placeholder;
}
var QL = /^(?:0|[1-9]\d*)$/;
function Io(e, t) {
  var n = ne(e);
  return !!(t = t == null ? 9007199254740991 : t) && (n == "number" || n != "symbol" && QL.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var XL = Math.min;
function ZL(e, t) {
  for (var n = e.length, r = XL(t.length, n), i = Vr(e); r--; ) {
    var o = t[r];
    e[r] = Io(o, n) ? i[o] : void 0;
  }
  return e;
}
function Yo(e, t) {
  for (var n = -1, r = e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    a !== t && a !== "__lodash_placeholder__" || (e[n] = "__lodash_placeholder__", o[i++] = n);
  }
  return o;
}
function Ef(e, t, n, r, i, o, a, s, u, c) {
  var l = 128 & t, f = 1 & t, h = 2 & t, d = 24 & t, p = 512 & t, v = h ? void 0 : Vu(e);
  return function m() {
    for (var g = arguments.length, y = Array(g), b = g; b--; )
      y[b] = arguments[b];
    if (d)
      var k = ou(m), w = qL(y, k);
    if (r && (y = RC(y, r, i, d)), o && (y = DC(y, o, a, d)), g -= w, d && g < c) {
      var x = Yo(y, k);
      return VC(e, t, Ef, m.placeholder, n, y, x, s, u, c - g);
    }
    var S = f ? n : this, T = h ? S[e] : e;
    return g = y.length, s ? y = ZL(y, s) : p && g > 1 && y.reverse(), l && u < g && (y.length = u), this && this !== dr && this instanceof m && (T = v || Vu(T)), T.apply(S, y);
  };
}
var YL = Math.min, lx = Math.max;
function No(e, t, n, r, i, o, a, s) {
  var u = 2 & t;
  if (!u && typeof e != "function")
    throw new TypeError("Expected a function");
  var c = r ? r.length : 0;
  if (c || (t &= -97, r = i = void 0), a = a === void 0 ? a : lx(ze(a), 0), s = s === void 0 ? s : ze(s), c -= i ? i.length : 0, 64 & t) {
    var l = r, f = i;
    r = i = void 0;
  }
  var h = u ? void 0 : Gm(e), d = [e, t, n, r, i, l, f, o, a, s];
  if (h && function(v, m) {
    var g = v[1], y = m[1], b = g | y, k = b < 131, w = y == 128 && g == 8 || y == 128 && g == 256 && v[7].length <= m[8] || y == 384 && m[7].length <= m[8] && g == 8;
    if (!k && !w)
      return v;
    1 & y && (v[2] = m[2], b |= 1 & g ? 0 : 4);
    var x = m[3];
    if (x) {
      var S = v[3];
      v[3] = S ? RC(S, x, m[4]) : x, v[4] = S ? Yo(v[3], "__lodash_placeholder__") : m[4];
    }
    (x = m[5]) && (S = v[5], v[5] = S ? DC(S, x, m[6]) : x, v[6] = S ? Yo(v[5], "__lodash_placeholder__") : m[6]), (x = m[7]) && (v[7] = x), 128 & y && (v[8] = v[8] == null ? m[8] : YL(v[8], m[8])), v[9] == null && (v[9] = m[9]), v[0] = m[0], v[1] = b;
  }(d, h), e = d[0], t = d[1], n = d[2], r = d[3], i = d[4], !(s = d[9] = d[9] === void 0 ? u ? 0 : e.length : lx(d[9] - c, 0)) && 24 & t && (t &= -25), t && t != 1)
    p = t == 8 || t == 16 ? function(v, m, g) {
      var y = Vu(v);
      return function b() {
        for (var k = arguments.length, w = Array(k), x = k, S = ou(b); x--; )
          w[x] = arguments[x];
        var T = k < 3 && w[0] !== S && w[k - 1] !== S ? [] : Yo(w, S);
        return (k -= T.length) < g ? VC(v, m, Ef, b.placeholder, void 0, w, T, void 0, void 0, g - k) : ri(this && this !== dr && this instanceof b ? y : v, this, w);
      };
    }(e, t, s) : t != 32 && t != 33 || i.length ? Ef.apply(void 0, d) : function(v, m, g, y) {
      var b = 1 & m, k = Vu(v);
      return function w() {
        for (var x = -1, S = arguments.length, T = -1, P = y.length, O = Array(P + S), j = this && this !== dr && this instanceof w ? k : v; ++T < P; )
          O[T] = y[T];
        for (; S--; )
          O[T++] = arguments[++x];
        return ri(j, b ? g : this, O);
      };
    }(e, t, n, r);
  else
    var p = function(v, m, g) {
      var y = 1 & m, b = Vu(v);
      return function k() {
        return (this && this !== dr && this instanceof k ? b : v).apply(y ? g : this, arguments);
      };
    }(e, t, n);
  return qC((h ? NC : BC)(p, d), e, t);
}
function Xm(e, t, n) {
  return t = n ? void 0 : t, No(e, 128, void 0, void 0, void 0, void 0, t = e && t == null ? e.length : t);
}
function Ro(e, t, n) {
  t == "__proto__" && Pf ? Pf(e, t, { configurable: !0, enumerable: !0, value: n, writable: !0 }) : e[t] = n;
}
function wi(e, t) {
  return e === t || e != e && t != t;
}
var tz = Object.prototype.hasOwnProperty;
function Dc(e, t, n) {
  var r = e[t];
  tz.call(e, t) && wi(r, n) && (n !== void 0 || t in e) || Ro(e, t, n);
}
function so(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = t.length; ++o < a; ) {
    var s = t[o], u = r ? r(n[s], e[s], s, n, e) : void 0;
    u === void 0 && (u = e[s]), i ? Ro(n, s, u) : Dc(n, s, u);
  }
  return n;
}
var fx = Math.max;
function HC(e, t, n) {
  return t = fx(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = fx(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), ri(e, this, s);
  };
}
function We(e, t) {
  return Qm(HC(e, t, Cr), e + "");
}
function Lc(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}
function Br(e) {
  return e != null && Lc(e.length) && !go(e);
}
function Dr(e, t, n) {
  if (!Rn(n))
    return !1;
  var r = ne(t);
  return !!(r == "number" ? Br(n) && Io(t, n.length) : r == "string" && t in n) && wi(n[t], e);
}
function au(e) {
  return We(function(t, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && Dr(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = Object(t); ++r < i; ) {
      var s = n[r];
      s && e(t, s, r, o);
    }
    return t;
  });
}
var ez = Object.prototype;
function zc(e) {
  var t = e && e.constructor;
  return e === (typeof t == "function" && t.prototype || ez);
}
function Zm(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
function hx(e) {
  return Un(e) && zr(e) == "[object Arguments]";
}
var WC = Object.prototype, nz = WC.hasOwnProperty, rz = WC.propertyIsEnumerable, oa = hx(function() {
  return arguments;
}()) ? hx : function(e) {
  return Un(e) && nz.call(e, "callee") && !rz.call(e, "callee");
};
function Lh() {
  return !1;
}
var UC = (typeof exports > "u" ? "undefined" : ne(exports)) == "object" && exports && !exports.nodeType && exports, dx = UC && (typeof module > "u" ? "undefined" : ne(module)) == "object" && module && !module.nodeType && module, vx = dx && dx.exports === UC ? dr.Buffer : void 0, Oo = (vx ? vx.isBuffer : void 0) || Lh, An = {};
function ii(e) {
  return function(t) {
    return e(t);
  };
}
An["[object Float32Array]"] = An["[object Float64Array]"] = An["[object Int8Array]"] = An["[object Int16Array]"] = An["[object Int32Array]"] = An["[object Uint8Array]"] = An["[object Uint8ClampedArray]"] = An["[object Uint16Array]"] = An["[object Uint32Array]"] = !0, An["[object Arguments]"] = An["[object Array]"] = An["[object ArrayBuffer]"] = An["[object Boolean]"] = An["[object DataView]"] = An["[object Date]"] = An["[object Error]"] = An["[object Function]"] = An["[object Map]"] = An["[object Number]"] = An["[object Object]"] = An["[object RegExp]"] = An["[object Set]"] = An["[object String]"] = An["[object WeakMap]"] = !1;
var JC = (typeof exports > "u" ? "undefined" : ne(exports)) == "object" && exports && !exports.nodeType && exports, Hu = JC && (typeof module > "u" ? "undefined" : ne(module)) == "object" && module && !module.nodeType && module, Td = Hu && Hu.exports === JC && OC.process, bi = function() {
  try {
    var e = Hu && Hu.require && Hu.require("util").types;
    return e || Td && Td.binding && Td.binding("util");
  } catch {
  }
}(), px = bi && bi.isTypedArray, rs = px ? ii(px) : function(e) {
  return Un(e) && Lc(e.length) && !!An[zr(e)];
}, iz = Object.prototype.hasOwnProperty;
function KC(e, t) {
  var n = Ne(e), r = !n && oa(e), i = !n && !r && Oo(e), o = !n && !r && !i && rs(e), a = n || r || i || o, s = a ? Zm(e.length, String) : [], u = s.length;
  for (var c in e)
    !t && !iz.call(e, c) || a && (c == "length" || i && (c == "offset" || c == "parent") || o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || Io(c, u)) || s.push(c);
  return s;
}
function GC(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var oz = GC(Object.keys, Object), az = Object.prototype.hasOwnProperty;
function Ym(e) {
  if (!zc(e))
    return oz(e);
  var t = [];
  for (var n in Object(e))
    az.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function or(e) {
  return Br(e) ? KC(e) : Ym(e);
}
var sz = Object.prototype.hasOwnProperty, QC = au(function(e, t) {
  if (zc(t) || Br(t))
    so(t, or(t), e);
  else
    for (var n in t)
      sz.call(t, n) && Dc(e, n, t[n]);
}), uz = Object.prototype.hasOwnProperty;
function cz(e) {
  if (!Rn(e))
    return function(i) {
      var o = [];
      if (i != null)
        for (var a in Object(i))
          o.push(a);
      return o;
    }(e);
  var t = zc(e), n = [];
  for (var r in e)
    (r != "constructor" || !t && uz.call(e, r)) && n.push(r);
  return n;
}
function Lr(e) {
  return Br(e) ? KC(e, !0) : cz(e);
}
var Mf = au(function(e, t) {
  so(t, Lr(t), e);
}), zs = au(function(e, t, n, r) {
  so(t, Lr(t), e, r);
}), XC = au(function(e, t, n, r) {
  so(t, or(t), e, r);
}), lz = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, fz = /^\w*$/;
function tg(e, t) {
  if (Ne(e))
    return !1;
  var n = ne(e);
  return !(n != "number" && n != "symbol" && n != "boolean" && e != null && !Wr(e)) || fz.test(e) || !lz.test(e) || t != null && e in Object(t);
}
var _u = ns(Object, "create"), hz = Object.prototype.hasOwnProperty, dz = Object.prototype.hasOwnProperty;
function Oa(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function gl(e, t) {
  for (var n = e.length; n--; )
    if (wi(e[n][0], t))
      return n;
  return -1;
}
Oa.prototype.clear = function() {
  this.__data__ = _u ? _u(null) : {}, this.size = 0;
}, Oa.prototype.delete = function(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}, Oa.prototype.get = function(e) {
  var t = this.__data__;
  if (_u) {
    var n = t[e];
    return n === "__lodash_hash_undefined__" ? void 0 : n;
  }
  return hz.call(t, e) ? t[e] : void 0;
}, Oa.prototype.has = function(e) {
  var t = this.__data__;
  return _u ? t[e] !== void 0 : dz.call(t, e);
}, Oa.prototype.set = function(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = _u && t === void 0 ? "__lodash_hash_undefined__" : t, this;
};
var vz = Array.prototype.splice;
function xo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
xo.prototype.clear = function() {
  this.__data__ = [], this.size = 0;
}, xo.prototype.delete = function(e) {
  var t = this.__data__, n = gl(t, e);
  return !(n < 0) && (n == t.length - 1 ? t.pop() : vz.call(t, n, 1), --this.size, !0);
}, xo.prototype.get = function(e) {
  var t = this.__data__, n = gl(t, e);
  return n < 0 ? void 0 : t[n][1];
}, xo.prototype.has = function(e) {
  return gl(this.__data__, e) > -1;
}, xo.prototype.set = function(e, t) {
  var n = this.__data__, r = gl(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
};
var ac = ns(dr, "Map");
function yl(e, t) {
  var n, r, i = e.__data__;
  return ((r = ne(n = t)) == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
}
function jo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
jo.prototype.clear = function() {
  this.size = 0, this.__data__ = { hash: new Oa(), map: new (ac || xo)(), string: new Oa() };
}, jo.prototype.delete = function(e) {
  var t = yl(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}, jo.prototype.get = function(e) {
  return yl(this, e).get(e);
}, jo.prototype.has = function(e) {
  return yl(this, e).has(e);
}, jo.prototype.set = function(e, t) {
  var n = yl(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
};
function su(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError("Expected a function");
  var n = function r() {
    var i = arguments, o = t ? t.apply(this, i) : i[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var s = e.apply(this, i);
    return r.cache = a.set(o, s) || a, s;
  };
  return n.cache = new (su.Cache || jo)(), n;
}
su.Cache = jo;
var pz = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, mz = /\\(\\)?/g, ZC = function(e) {
  var t = su(e, function(r) {
    return n.size === 500 && n.clear(), r;
  }), n = t.cache;
  return t;
}(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(pz, function(n, r, i, o) {
    t.push(i ? o.replace(mz, "$1") : r || n);
  }), t;
});
function ln(e) {
  return e == null ? "" : ni(e);
}
function va(e, t) {
  return Ne(e) ? e : tg(e, t) ? [e] : ZC(ln(e));
}
function yo(e) {
  if (typeof e == "string" || Wr(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function is(e, t) {
  for (var n = 0, r = (t = va(t, e)).length; e != null && n < r; )
    e = e[yo(t[n++])];
  return n && n == r ? e : void 0;
}
function zh(e, t, n) {
  var r = e == null ? void 0 : is(e, t);
  return r === void 0 ? n : r;
}
function eg(e, t) {
  for (var n = -1, r = t.length, i = Array(r), o = e == null; ++n < r; )
    i[n] = o ? void 0 : zh(e, t[n]);
  return i;
}
function pa(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var mx = _r ? _r.isConcatSpreadable : void 0;
function gz(e) {
  return Ne(e) || oa(e) || !!(mx && e && e[mx]);
}
function kr(e, t, n, r, i) {
  var o = -1, a = e.length;
  for (n || (n = gz), i || (i = []); ++o < a; ) {
    var s = e[o];
    t > 0 && n(s) ? t > 1 ? kr(s, t - 1, n, r, i) : pa(i, s) : r || (i[i.length] = s);
  }
  return i;
}
function ng(e) {
  return e != null && e.length ? kr(e, 1) : [];
}
function Do(e) {
  return Qm(HC(e, void 0, ng), e + "");
}
var YC = Do(eg), Bh = GC(Object.getPrototypeOf, Object), yz = Function.prototype, bz = Object.prototype, t5 = yz.toString, kz = bz.hasOwnProperty, wz = t5.call(Object);
function uu(e) {
  if (!Un(e) || zr(e) != "[object Object]")
    return !1;
  var t = Bh(e);
  if (t === null)
    return !0;
  var n = kz.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && t5.call(n) == wz;
}
function Fh(e) {
  if (!Un(e))
    return !1;
  var t = zr(e);
  return t == "[object Error]" || t == "[object DOMException]" || typeof e.message == "string" && typeof e.name == "string" && !uu(e);
}
var rg = We(function(e, t) {
  try {
    return ri(e, void 0, t);
  } catch (n) {
    return Fh(n) ? n : new Error(n);
  }
});
function ig(e, t) {
  var n;
  if (typeof t != "function")
    throw new TypeError("Expected a function");
  return e = ze(e), function() {
    return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = void 0), n;
  };
}
var Bc = We(function(e, t, n) {
  var r = 1;
  if (n.length) {
    var i = Yo(n, ou(Bc));
    r |= 32;
  }
  return No(e, r, t, n, i);
});
Bc.placeholder = {};
var e5 = Do(function(e, t) {
  return fi(t, function(n) {
    n = yo(n), Ro(e, n, Bc(e[n], e));
  }), e;
}), qh = We(function(e, t, n) {
  var r = 3;
  if (n.length) {
    var i = Yo(n, ou(qh));
    r |= 32;
  }
  return No(t, r, e, n, i);
});
function ki(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), (n = n > i ? i : n) < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
function ma(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : ki(e, t, n);
}
qh.placeholder = {};
var xz = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
function cu(e) {
  return xz.test(e);
}
var jz = "[\\ud800-\\udfff]", Zv = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", Yv = "\\ud83c[\\udffb-\\udfff]", n5 = "[^\\ud800-\\udfff]", r5 = "(?:\\ud83c[\\udde6-\\uddff]){2}", i5 = "[\\ud800-\\udbff][\\udc00-\\udfff]", gx = "(?:" + Zv + "|" + Yv + ")?", Sz = "[\\ufe0e\\ufe0f]?" + gx + ("(?:\\u200d(?:" + [n5, r5, i5].join("|") + ")[\\ufe0e\\ufe0f]?" + gx + ")*"), $z = "(?:" + [n5 + Zv + "?", Zv, r5, i5, jz].join("|") + ")", _z = RegExp(Yv + "(?=" + Yv + ")|" + $z + Sz, "g");
function Fi(e) {
  return cu(e) ? function(t) {
    return t.match(_z) || [];
  }(e) : function(t) {
    return t.split("");
  }(e);
}
function o5(e) {
  return function(t) {
    var n = cu(t = ln(t)) ? Fi(t) : void 0, r = n ? n[0] : t.charAt(0), i = n ? ma(n, 1).join("") : t.slice(1);
    return r[e]() + i;
  };
}
var Vh = o5("toUpperCase");
function og(e) {
  return Vh(ln(e).toLowerCase());
}
function ag(e, t, n, r) {
  var i = -1, o = e == null ? 0 : e.length;
  for (r && o && (n = e[++i]); ++i < o; )
    n = t(n, e[i], i, e);
  return n;
}
function sg(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var Cz = sg({ \u00C0: "A", \u00C1: "A", \u00C2: "A", \u00C3: "A", \u00C4: "A", \u00C5: "A", \u00E0: "a", \u00E1: "a", \u00E2: "a", \u00E3: "a", \u00E4: "a", \u00E5: "a", \u00C7: "C", \u00E7: "c", \u00D0: "D", \u00F0: "d", \u00C8: "E", \u00C9: "E", \u00CA: "E", \u00CB: "E", \u00E8: "e", \u00E9: "e", \u00EA: "e", \u00EB: "e", \u00CC: "I", \u00CD: "I", \u00CE: "I", \u00CF: "I", \u00EC: "i", \u00ED: "i", \u00EE: "i", \u00EF: "i", \u00D1: "N", \u00F1: "n", \u00D2: "O", \u00D3: "O", \u00D4: "O", \u00D5: "O", \u00D6: "O", \u00D8: "O", \u00F2: "o", \u00F3: "o", \u00F4: "o", \u00F5: "o", \u00F6: "o", \u00F8: "o", \u00D9: "U", \u00DA: "U", \u00DB: "U", \u00DC: "U", \u00F9: "u", \u00FA: "u", \u00FB: "u", \u00FC: "u", \u00DD: "Y", \u00FD: "y", \u00FF: "y", \u00C6: "Ae", \u00E6: "ae", \u00DE: "Th", \u00FE: "th", \u00DF: "ss", \u0100: "A", \u0102: "A", \u0104: "A", \u0101: "a", \u0103: "a", \u0105: "a", \u0106: "C", \u0108: "C", \u010A: "C", \u010C: "C", \u0107: "c", \u0109: "c", \u010B: "c", \u010D: "c", \u010E: "D", \u0110: "D", \u010F: "d", \u0111: "d", \u0112: "E", \u0114: "E", \u0116: "E", \u0118: "E", \u011A: "E", \u0113: "e", \u0115: "e", \u0117: "e", \u0119: "e", \u011B: "e", \u011C: "G", \u011E: "G", \u0120: "G", \u0122: "G", \u011D: "g", \u011F: "g", \u0121: "g", \u0123: "g", \u0124: "H", \u0126: "H", \u0125: "h", \u0127: "h", \u0128: "I", \u012A: "I", \u012C: "I", \u012E: "I", \u0130: "I", \u0129: "i", \u012B: "i", \u012D: "i", \u012F: "i", \u0131: "i", \u0134: "J", \u0135: "j", \u0136: "K", \u0137: "k", \u0138: "k", \u0139: "L", \u013B: "L", \u013D: "L", \u013F: "L", \u0141: "L", \u013A: "l", \u013C: "l", \u013E: "l", \u0140: "l", \u0142: "l", \u0143: "N", \u0145: "N", \u0147: "N", \u014A: "N", \u0144: "n", \u0146: "n", \u0148: "n", \u014B: "n", \u014C: "O", \u014E: "O", \u0150: "O", \u014D: "o", \u014F: "o", \u0151: "o", \u0154: "R", \u0156: "R", \u0158: "R", \u0155: "r", \u0157: "r", \u0159: "r", \u015A: "S", \u015C: "S", \u015E: "S", \u0160: "S", \u015B: "s", \u015D: "s", \u015F: "s", \u0161: "s", \u0162: "T", \u0164: "T", \u0166: "T", \u0163: "t", \u0165: "t", \u0167: "t", \u0168: "U", \u016A: "U", \u016C: "U", \u016E: "U", \u0170: "U", \u0172: "U", \u0169: "u", \u016B: "u", \u016D: "u", \u016F: "u", \u0171: "u", \u0173: "u", \u0174: "W", \u0175: "w", \u0176: "Y", \u0177: "y", \u0178: "Y", \u0179: "Z", \u017B: "Z", \u017D: "Z", \u017A: "z", \u017C: "z", \u017E: "z", \u0132: "IJ", \u0133: "ij", \u0152: "Oe", \u0153: "oe", \u0149: "'n", \u017F: "s" }), Oz = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Az = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
function ug(e) {
  return (e = ln(e)) && e.replace(Oz, Cz).replace(Az, "");
}
var Pz = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ez = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, a5 = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", yx = "[" + a5 + "]", s5 = "\\d+", Mz = "[\\u2700-\\u27bf]", u5 = "[a-z\\xdf-\\xf6\\xf8-\\xff]", c5 = "[^\\ud800-\\udfff" + a5 + s5 + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]", l5 = "(?:\\ud83c[\\udde6-\\uddff]){2}", f5 = "[\\ud800-\\udbff][\\udc00-\\udfff]", ys = "[A-Z\\xc0-\\xd6\\xd8-\\xde]", bx = "(?:" + u5 + "|" + c5 + ")", Tz = "(?:" + ys + "|" + c5 + ")", kx = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?", Iz = "[\\ufe0e\\ufe0f]?" + kx + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", l5, f5].join("|") + ")[\\ufe0e\\ufe0f]?" + kx + ")*"), Nz = "(?:" + [Mz, l5, f5].join("|") + ")" + Iz, Rz = RegExp([ys + "?" + u5 + "+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=" + [yx, ys, "$"].join("|") + ")", Tz + "+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=" + [yx, ys + bx, "$"].join("|") + ")", ys + "?" + bx + "+(?:['\u2019](?:d|ll|m|re|s|t|ve))?", ys + "+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", s5, Nz].join("|"), "g");
function cg(e, t, n) {
  return e = ln(e), (t = n ? void 0 : t) === void 0 ? function(r) {
    return Ez.test(r);
  }(e) ? function(r) {
    return r.match(Rz) || [];
  }(e) : function(r) {
    return r.match(Pz) || [];
  }(e) : e.match(t) || [];
}
var Dz = RegExp("['\u2019]", "g");
function lu(e) {
  return function(t) {
    return ag(cg(ug(t).replace(Dz, "")), e, "");
  };
}
var h5 = lu(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? og(t) : t);
});
function d5() {
  if (!arguments.length)
    return [];
  var e = arguments[0];
  return Ne(e) ? e : [e];
}
var Lz = dr.isFinite, zz = Math.min;
function lg(e) {
  var t = Math[e];
  return function(n, r) {
    if (n = ti(n), (r = r == null ? 0 : zz(ze(r), 292)) && Lz(n)) {
      var i = (ln(n) + "e").split("e");
      return +((i = (ln(t(i[0] + "e" + (+i[1] + r))) + "e").split("e"))[0] + "e" + (+i[1] - r));
    }
    return t(n);
  };
}
var v5 = lg("ceil");
function fg(e) {
  var t = Q(e);
  return t.__chain__ = !0, t;
}
var Bz = Math.ceil, Fz = Math.max;
function p5(e, t, n) {
  t = (n ? Dr(e, t, n) : t === void 0) ? 1 : Fz(ze(t), 0);
  var r = e == null ? 0 : e.length;
  if (!r || t < 1)
    return [];
  for (var i = 0, o = 0, a = Array(Bz(r / t)); i < r; )
    a[o++] = ki(e, i, i += t);
  return a;
}
function os(e, t, n) {
  return e == e && (n !== void 0 && (e = e <= n ? e : n), t !== void 0 && (e = e >= t ? e : t)), e;
}
function m5(e, t, n) {
  return n === void 0 && (n = t, t = void 0), n !== void 0 && (n = (n = ti(n)) == n ? n : 0), t !== void 0 && (t = (t = ti(t)) == t ? t : 0), os(ti(e), t, n);
}
function Ci(e) {
  var t = this.__data__ = new xo(e);
  this.size = t.size;
}
function g5(e, t) {
  return e && so(t, or(t), e);
}
Ci.prototype.clear = function() {
  this.__data__ = new xo(), this.size = 0;
}, Ci.prototype.delete = function(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}, Ci.prototype.get = function(e) {
  return this.__data__.get(e);
}, Ci.prototype.has = function(e) {
  return this.__data__.has(e);
}, Ci.prototype.set = function(e, t) {
  var n = this.__data__;
  if (n instanceof xo) {
    var r = n.__data__;
    if (!ac || r.length < 199)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new jo(r);
  }
  return n.set(e, t), this.size = n.size, this;
};
var y5 = (typeof exports > "u" ? "undefined" : ne(exports)) == "object" && exports && !exports.nodeType && exports, wx = y5 && (typeof module > "u" ? "undefined" : ne(module)) == "object" && module && !module.nodeType && module, xx = wx && wx.exports === y5 ? dr.Buffer : void 0, jx = xx ? xx.allocUnsafe : void 0;
function b5(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = jx ? jx(n) : new e.constructor(n);
  return e.copy(r), r;
}
function ga(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
function Hh() {
  return [];
}
var qz = Object.prototype.propertyIsEnumerable, Sx = Object.getOwnPropertySymbols, hg = Sx ? function(e) {
  return e == null ? [] : (e = Object(e), ga(Sx(e), function(t) {
    return qz.call(e, t);
  }));
} : Hh, k5 = Object.getOwnPropertySymbols ? function(e) {
  for (var t = []; e; )
    pa(t, hg(e)), e = Bh(e);
  return t;
} : Hh;
function w5(e, t, n) {
  var r = t(e);
  return Ne(e) ? r : pa(r, n(e));
}
function tp(e) {
  return w5(e, or, hg);
}
function dg(e) {
  return w5(e, Lr, k5);
}
var ep = ns(dr, "DataView"), np = ns(dr, "Promise"), Cs = ns(dr, "Set"), Vz = es(ep), Hz = es(ac), Wz = es(np), Uz = es(Cs), Jz = es(oc), _a = zr;
(ep && _a(new ep(new ArrayBuffer(1))) != "[object DataView]" || ac && _a(new ac()) != "[object Map]" || np && _a(np.resolve()) != "[object Promise]" || Cs && _a(new Cs()) != "[object Set]" || oc && _a(new oc()) != "[object WeakMap]") && (_a = function(e) {
  var t = zr(e), n = t == "[object Object]" ? e.constructor : void 0, r = n ? es(n) : "";
  if (r)
    switch (r) {
      case Vz:
        return "[object DataView]";
      case Hz:
        return "[object Map]";
      case Wz:
        return "[object Promise]";
      case Uz:
        return "[object Set]";
      case Jz:
        return "[object WeakMap]";
    }
  return t;
});
var vo = _a, Kz = Object.prototype.hasOwnProperty, Tf = dr.Uint8Array;
function rp(e) {
  var t = new e.constructor(e.byteLength);
  return new Tf(t).set(new Tf(e)), t;
}
var Gz = /\w*$/, $x = _r ? _r.prototype : void 0, _x = $x ? $x.valueOf : void 0;
function x5(e, t) {
  var n = t ? rp(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
function Qz(e, t, n) {
  var r, i = e.constructor;
  switch (t) {
    case "[object ArrayBuffer]":
      return rp(e);
    case "[object Boolean]":
    case "[object Date]":
      return new i(+e);
    case "[object DataView]":
      return function(o, a) {
        var s = a ? rp(o.buffer) : o.buffer;
        return new o.constructor(s, o.byteOffset, o.byteLength);
      }(e, n);
    case "[object Float32Array]":
    case "[object Float64Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object Int32Array]":
    case "[object Uint8Array]":
    case "[object Uint8ClampedArray]":
    case "[object Uint16Array]":
    case "[object Uint32Array]":
      return x5(e, n);
    case "[object Map]":
      return new i();
    case "[object Number]":
    case "[object String]":
      return new i(e);
    case "[object RegExp]":
      return function(o) {
        var a = new o.constructor(o.source, Gz.exec(o));
        return a.lastIndex = o.lastIndex, a;
      }(e);
    case "[object Set]":
      return new i();
    case "[object Symbol]":
      return r = e, _x ? Object(_x.call(r)) : {};
  }
}
function j5(e) {
  return typeof e.constructor != "function" || zc(e) ? {} : ru(Bh(e));
}
var Cx = bi && bi.isMap, vg = Cx ? ii(Cx) : function(e) {
  return Un(e) && vo(e) == "[object Map]";
}, Ox = bi && bi.isSet, pg = Ox ? ii(Ox) : function(e) {
  return Un(e) && vo(e) == "[object Set]";
}, jn = {};
function mi(e, t, n, r, i, o) {
  var a, s = 1 & t, u = 2 & t, c = 4 & t;
  if (n && (a = i ? n(e, r, i, o) : n(e)), a !== void 0)
    return a;
  if (!Rn(e))
    return e;
  var l = Ne(e);
  if (l) {
    if (a = function(v) {
      var m = v.length, g = new v.constructor(m);
      return m && typeof v[0] == "string" && Kz.call(v, "index") && (g.index = v.index, g.input = v.input), g;
    }(e), !s)
      return Vr(e, a);
  } else {
    var f = vo(e), h = f == "[object Function]" || f == "[object GeneratorFunction]";
    if (Oo(e))
      return b5(e, s);
    if (f == "[object Object]" || f == "[object Arguments]" || h && !i) {
      if (a = u || h ? {} : j5(e), !s)
        return u ? function(v, m) {
          return so(v, k5(v), m);
        }(e, function(v, m) {
          return v && so(m, Lr(m), v);
        }(a, e)) : function(v, m) {
          return so(v, hg(v), m);
        }(e, g5(a, e));
    } else {
      if (!jn[f])
        return i ? e : {};
      a = Qz(e, f, s);
    }
  }
  o || (o = new Ci());
  var d = o.get(e);
  if (d)
    return d;
  o.set(e, a), pg(e) ? e.forEach(function(v) {
    a.add(mi(v, t, n, v, e, o));
  }) : vg(e) && e.forEach(function(v, m) {
    a.set(m, mi(v, t, n, m, e, o));
  });
  var p = l ? void 0 : (c ? u ? dg : tp : u ? Lr : or)(e);
  return fi(p || e, function(v, m) {
    p && (v = e[m = v]), Dc(a, m, mi(v, t, n, m, e, o));
  }), a;
}
jn["[object Arguments]"] = jn["[object Array]"] = jn["[object ArrayBuffer]"] = jn["[object DataView]"] = jn["[object Boolean]"] = jn["[object Date]"] = jn["[object Float32Array]"] = jn["[object Float64Array]"] = jn["[object Int8Array]"] = jn["[object Int16Array]"] = jn["[object Int32Array]"] = jn["[object Map]"] = jn["[object Number]"] = jn["[object Object]"] = jn["[object RegExp]"] = jn["[object Set]"] = jn["[object String]"] = jn["[object Symbol]"] = jn["[object Uint8Array]"] = jn["[object Uint8ClampedArray]"] = jn["[object Uint16Array]"] = jn["[object Uint32Array]"] = !0, jn["[object Error]"] = jn["[object Function]"] = jn["[object WeakMap]"] = !1;
function S5(e) {
  return mi(e, 4);
}
function $5(e) {
  return mi(e, 5);
}
function mg(e, t) {
  return mi(e, 5, t = typeof t == "function" ? t : void 0);
}
function _5(e, t) {
  return mi(e, 4, t = typeof t == "function" ? t : void 0);
}
function ip() {
  return new pi(this.value(), this.__chain__);
}
function C5(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++t < n; ) {
    var o = e[t];
    o && (i[r++] = o);
  }
  return i;
}
function O5() {
  var e = arguments.length;
  if (!e)
    return [];
  for (var t = Array(e - 1), n = arguments[0], r = e; r--; )
    t[r - 1] = arguments[r];
  return pa(Ne(n) ? Vr(n) : [n], kr(t, 1));
}
function Da(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new jo(); ++t < n; )
    this.add(e[t]);
}
function gg(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function sc(e, t) {
  return e.has(t);
}
Da.prototype.add = Da.prototype.push = function(e) {
  return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, Da.prototype.has = function(e) {
  return this.__data__.has(e);
};
function Ax(e, t, n, r, i, o) {
  var a = 1 & n, s = e.length, u = t.length;
  if (s != u && !(a && u > s))
    return !1;
  var c = o.get(e), l = o.get(t);
  if (c && l)
    return c == t && l == e;
  var f = -1, h = !0, d = 2 & n ? new Da() : void 0;
  for (o.set(e, t), o.set(t, e); ++f < s; ) {
    var p = e[f], v = t[f];
    if (r)
      var m = a ? r(v, p, f, t, e, o) : r(p, v, f, e, t, o);
    if (m !== void 0) {
      if (m)
        continue;
      h = !1;
      break;
    }
    if (d) {
      if (!gg(t, function(g, y) {
        if (!sc(d, y) && (p === g || i(p, g, n, r, o)))
          return d.push(y);
      })) {
        h = !1;
        break;
      }
    } else if (p !== v && !i(p, v, n, r, o)) {
      h = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), h;
}
function yg(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function Wh(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var Px = _r ? _r.prototype : void 0, Id = Px ? Px.valueOf : void 0, Xz = Object.prototype.hasOwnProperty, bl = "[object Object]", Ex = Object.prototype.hasOwnProperty;
function Zz(e, t, n, r, i, o) {
  var a = Ne(e), s = Ne(t), u = a ? "[object Array]" : vo(e), c = s ? "[object Array]" : vo(t), l = (u = u == "[object Arguments]" ? bl : u) == bl, f = (c = c == "[object Arguments]" ? bl : c) == bl, h = u == c;
  if (h && Oo(e)) {
    if (!Oo(t))
      return !1;
    a = !0, l = !1;
  }
  if (h && !l)
    return o || (o = new Ci()), a || rs(e) ? Ax(e, t, n, r, i, o) : function(g, y, b, k, w, x, S) {
      switch (b) {
        case "[object DataView]":
          if (g.byteLength != y.byteLength || g.byteOffset != y.byteOffset)
            return !1;
          g = g.buffer, y = y.buffer;
        case "[object ArrayBuffer]":
          return !(g.byteLength != y.byteLength || !x(new Tf(g), new Tf(y)));
        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return wi(+g, +y);
        case "[object Error]":
          return g.name == y.name && g.message == y.message;
        case "[object RegExp]":
        case "[object String]":
          return g == y + "";
        case "[object Map]":
          var T = yg;
        case "[object Set]":
          var P = 1 & k;
          if (T || (T = Wh), g.size != y.size && !P)
            return !1;
          var O = S.get(g);
          if (O)
            return O == y;
          k |= 2, S.set(g, y);
          var j = Ax(T(g), T(y), k, w, x, S);
          return S.delete(g), j;
        case "[object Symbol]":
          if (Id)
            return Id.call(g) == Id.call(y);
      }
      return !1;
    }(e, t, u, n, r, i, o);
  if (!(1 & n)) {
    var d = l && Ex.call(e, "__wrapped__"), p = f && Ex.call(t, "__wrapped__");
    if (d || p) {
      var v = d ? e.value() : e, m = p ? t.value() : t;
      return o || (o = new Ci()), i(v, m, n, r, o);
    }
  }
  return !!h && (o || (o = new Ci()), function(g, y, b, k, w, x) {
    var S = 1 & b, T = tp(g), P = T.length;
    if (P != tp(y).length && !S)
      return !1;
    for (var O = P; O--; ) {
      var j = T[O];
      if (!(S ? j in y : Xz.call(y, j)))
        return !1;
    }
    var V = x.get(g), E = x.get(y);
    if (V && E)
      return V == y && E == g;
    var C = !0;
    x.set(g, y), x.set(y, g);
    for (var H = S; ++O < P; ) {
      var X = g[j = T[O]], F = y[j];
      if (k)
        var G = S ? k(F, X, j, y, g, x) : k(X, F, j, g, y, x);
      if (!(G === void 0 ? X === F || w(X, F, b, k, x) : G)) {
        C = !1;
        break;
      }
      H || (H = j == "constructor");
    }
    if (C && !H) {
      var M = g.constructor, $ = y.constructor;
      M == $ || !("constructor" in g) || !("constructor" in y) || typeof M == "function" && M instanceof M && typeof $ == "function" && $ instanceof $ || (C = !1);
    }
    return x.delete(g), x.delete(y), C;
  }(e, t, n, r, i, o));
}
function Fc(e, t, n, r, i) {
  return e === t || (e == null || t == null || !Un(e) && !Un(t) ? e != e && t != t : Zz(e, t, n, r, Fc, i));
}
function bg(e, t, n, r) {
  var i = n.length, o = i, a = !r;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    var u = (s = n[i])[0], c = e[u], l = s[1];
    if (a && s[2]) {
      if (c === void 0 && !(u in e))
        return !1;
    } else {
      var f = new Ci();
      if (r)
        var h = r(c, l, u, e, t, f);
      if (!(h === void 0 ? Fc(l, c, 3, r, f) : h))
        return !1;
    }
  }
  return !0;
}
function A5(e) {
  return e == e && !Rn(e);
}
function kg(e) {
  for (var t = or(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, A5(i)];
  }
  return t;
}
function P5(e, t) {
  return function(n) {
    return n != null && n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function E5(e) {
  var t = kg(e);
  return t.length == 1 && t[0][2] ? P5(t[0][0], t[0][1]) : function(n) {
    return n === e || bg(n, e, t);
  };
}
function Yz(e, t) {
  return e != null && t in Object(e);
}
function M5(e, t, n) {
  for (var r = -1, i = (t = va(t, e)).length, o = !1; ++r < i; ) {
    var a = yo(t[r]);
    if (!(o = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return o || ++r != i ? o : !!(i = e == null ? 0 : e.length) && Lc(i) && Io(a, i) && (Ne(e) || oa(e));
}
function Uh(e, t) {
  return e != null && M5(e, t, Yz);
}
function T5(e, t) {
  return tg(e) && A5(t) ? P5(yo(e), t) : function(n) {
    var r = zh(n, e);
    return r === void 0 && r === t ? Uh(n, e) : Fc(t, r, 3);
  };
}
function wg(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function xg(e) {
  return tg(e) ? wg(yo(e)) : function(t) {
    return function(n) {
      return is(n, t);
    };
  }(e);
}
function Re(e) {
  return typeof e == "function" ? e : e == null ? Cr : ne(e) == "object" ? Ne(e) ? T5(e[0], e[1]) : E5(e) : xg(e);
}
function I5(e) {
  var t = e == null ? 0 : e.length, n = Re;
  return e = t ? qn(e, function(r) {
    if (typeof r[1] != "function")
      throw new TypeError("Expected a function");
    return [n(r[0]), r[1]];
  }) : [], We(function(r) {
    for (var i = -1; ++i < t; ) {
      var o = e[i];
      if (ri(o[0], this, r))
        return ri(o[1], this, r);
    }
  });
}
function N5(e, t, n) {
  var r = n.length;
  if (e == null)
    return !r;
  for (e = Object(e); r--; ) {
    var i = n[r], o = t[i], a = e[i];
    if (a === void 0 && !(i in e) || !o(a))
      return !1;
  }
  return !0;
}
function R5(e) {
  return function(t) {
    var n = or(t);
    return function(r) {
      return N5(r, t, n);
    };
  }(mi(e, 1));
}
function D5(e, t) {
  return t == null || N5(e, t, or(t));
}
function tB(e, t, n, r) {
  for (var i = -1, o = e == null ? 0 : e.length; ++i < o; ) {
    var a = e[i];
    t(r, a, n(a), e);
  }
  return r;
}
function L5(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
      var u = a[e ? s : ++i];
      if (n(o[u], u, o) === !1)
        break;
    }
    return t;
  };
}
var jg = L5();
function uo(e, t) {
  return e && jg(e, t, or);
}
function z5(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Br(n))
      return e(n, r);
    for (var i = n.length, o = t ? i : -1, a = Object(n); (t ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var ya = z5(uo);
function eB(e, t, n, r) {
  return ya(e, function(i, o, a) {
    t(r, i, n(i), a);
  }), r;
}
function Jh(e, t) {
  return function(n, r) {
    var i = Ne(n) ? tB : eB, o = t ? t() : {};
    return i(n, e, Re(r), o);
  };
}
var nB = Object.prototype.hasOwnProperty, B5 = Jh(function(e, t, n) {
  nB.call(e, n) ? ++e[n] : Ro(e, n, 1);
});
function F5(e, t) {
  var n = ru(e);
  return t == null ? n : g5(n, t);
}
function Kh(e, t, n) {
  var r = No(e, 8, void 0, void 0, void 0, void 0, void 0, t = n ? void 0 : t);
  return r.placeholder = Kh.placeholder, r;
}
Kh.placeholder = {};
function Gh(e, t, n) {
  var r = No(e, 16, void 0, void 0, void 0, void 0, void 0, t = n ? void 0 : t);
  return r.placeholder = Gh.placeholder, r;
}
Gh.placeholder = {};
var Wu = function() {
  return dr.Date.now();
}, rB = Math.max, iB = Math.min;
function fu(e, t, n) {
  var r, i, o, a, s, u, c = 0, l = !1, f = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  function d(b) {
    var k = r, w = i;
    return r = i = void 0, c = b, a = e.apply(w, k);
  }
  function p(b) {
    return c = b, s = setTimeout(m, t), l ? d(b) : a;
  }
  function v(b) {
    var k = b - u;
    return u === void 0 || k >= t || k < 0 || f && b - c >= o;
  }
  function m() {
    var b = Wu();
    if (v(b))
      return g(b);
    s = setTimeout(m, function(k) {
      var w = t - (k - u);
      return f ? iB(w, o - (k - c)) : w;
    }(b));
  }
  function g(b) {
    return s = void 0, h && r ? d(b) : (r = i = void 0, a);
  }
  function y() {
    var b = Wu(), k = v(b);
    if (r = arguments, i = this, u = b, k) {
      if (s === void 0)
        return p(u);
      if (f)
        return clearTimeout(s), s = setTimeout(m, t), d(u);
    }
    return s === void 0 && (s = setTimeout(m, t)), a;
  }
  return t = ti(t) || 0, Rn(n) && (l = !!n.leading, o = (f = "maxWait" in n) ? rB(ti(n.maxWait) || 0, t) : o, h = "trailing" in n ? !!n.trailing : h), y.cancel = function() {
    s !== void 0 && clearTimeout(s), c = 0, r = u = i = s = void 0;
  }, y.flush = function() {
    return s === void 0 ? a : g(Wu());
  }, y;
}
function q5(e, t) {
  return e == null || e != e ? t : e;
}
var V5 = Object.prototype, oB = V5.hasOwnProperty, H5 = We(function(e, t) {
  e = Object(e);
  var n = -1, r = t.length, i = r > 2 ? t[2] : void 0;
  for (i && Dr(t[0], t[1], i) && (r = 1); ++n < r; )
    for (var o = t[n], a = Lr(o), s = -1, u = a.length; ++s < u; ) {
      var c = a[s], l = e[c];
      (l === void 0 || wi(l, V5[c]) && !oB.call(e, c)) && (e[c] = o[c]);
    }
  return e;
});
function Nd(e, t, n) {
  (n !== void 0 && !wi(e[t], n) || n === void 0 && !(t in e)) && Ro(e, t, n);
}
function Gn(e) {
  return Un(e) && Br(e);
}
function Rd(e, t) {
  if ((t !== "constructor" || typeof e[t] != "function") && t != "__proto__")
    return e[t];
}
function Sg(e) {
  return so(e, Lr(e));
}
function Qh(e, t, n, r, i) {
  e !== t && jg(t, function(o, a) {
    if (i || (i = new Ci()), Rn(o))
      (function(u, c, l, f, h, d, p) {
        var v = Rd(u, l), m = Rd(c, l), g = p.get(m);
        if (g)
          Nd(u, l, g);
        else {
          var y = d ? d(v, m, l + "", u, c, p) : void 0, b = y === void 0;
          if (b) {
            var k = Ne(m), w = !k && Oo(m), x = !k && !w && rs(m);
            y = m, k || w || x ? Ne(v) ? y = v : Gn(v) ? y = Vr(v) : w ? (b = !1, y = b5(m, !0)) : x ? (b = !1, y = x5(m, !0)) : y = [] : uu(m) || oa(m) ? (y = v, oa(v) ? y = Sg(v) : Rn(v) && !go(v) || (y = j5(m))) : b = !1;
          }
          b && (p.set(m, y), h(y, m, f, d, p), p.delete(m)), Nd(u, l, y);
        }
      })(e, t, a, n, Qh, r, i);
    else {
      var s = r ? r(Rd(e, a), o, a + "", e, t, i) : void 0;
      s === void 0 && (s = o), Nd(e, a, s);
    }
  }, Lr);
}
function W5(e, t, n, r, i, o) {
  return Rn(e) && Rn(t) && (o.set(t, e), Qh(e, t, void 0, W5, o), o.delete(t)), e;
}
var $g = au(function(e, t, n, r) {
  Qh(e, t, n, r);
}), U5 = We(function(e) {
  return e.push(void 0, W5), ri($g, void 0, e);
});
function J5(e, t, n) {
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  return setTimeout(function() {
    e.apply(void 0, n);
  }, t);
}
var K5 = We(function(e, t) {
  return J5(e, 1, t);
}), G5 = We(function(e, t, n) {
  return J5(e, ti(t) || 0, n);
});
function _g(e, t, n) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
function qc(e, t, n, r) {
  var i = -1, o = Dh, a = !0, s = e.length, u = [], c = t.length;
  if (!s)
    return u;
  n && (t = qn(t, ii(n))), r ? (o = _g, a = !1) : t.length >= 200 && (o = sc, a = !1, t = new Da(t));
  t:
    for (; ++i < s; ) {
      var l = e[i], f = n == null ? l : n(l);
      if (l = r || l !== 0 ? l : 0, a && f == f) {
        for (var h = c; h--; )
          if (t[h] === f)
            continue t;
        u.push(l);
      } else
        o(t, f, r) || u.push(l);
    }
  return u;
}
var Q5 = We(function(e, t) {
  return Gn(e) ? qc(e, kr(t, 1, Gn, !0)) : [];
});
function ve(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var X5 = We(function(e, t) {
  var n = ve(t);
  return Gn(n) && (n = void 0), Gn(e) ? qc(e, kr(t, 1, Gn, !0), Re(n)) : [];
}), Z5 = We(function(e, t) {
  var n = ve(t);
  return Gn(n) && (n = void 0), Gn(e) ? qc(e, kr(t, 1, Gn, !0), void 0, n) : [];
}), Y5 = Th(function(e, t) {
  return e / t;
}, 1);
function tO(e, t, n) {
  var r = e == null ? 0 : e.length;
  return r ? ki(e, (t = n || t === void 0 ? 1 : ze(t)) < 0 ? 0 : t, r) : [];
}
function eO(e, t, n) {
  var r = e == null ? 0 : e.length;
  return r ? ki(e, 0, (t = r - (t = n || t === void 0 ? 1 : ze(t))) < 0 ? 0 : t) : [];
}
function Xh(e, t, n, r) {
  for (var i = e.length, o = r ? i : -1; (r ? o-- : ++o < i) && t(e[o], o, e); )
    ;
  return n ? ki(e, r ? 0 : o, r ? o + 1 : i) : ki(e, r ? o + 1 : 0, r ? i : o);
}
function nO(e, t) {
  return e && e.length ? Xh(e, Re(t), !0, !0) : [];
}
function rO(e, t) {
  return e && e.length ? Xh(e, Re(t), !0) : [];
}
function bo(e) {
  return typeof e == "function" ? e : Cr;
}
function If(e, t) {
  return (Ne(e) ? fi : ya)(e, bo(t));
}
function aB(e, t) {
  for (var n = e == null ? 0 : e.length; n-- && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var iO = L5(!0);
function Cg(e, t) {
  return e && iO(e, t, or);
}
var oO = z5(Cg, !0);
function uc(e, t) {
  return (Ne(e) ? aB : oO)(e, bo(t));
}
function aO(e, t, n) {
  e = ln(e), t = ni(t);
  var r = e.length, i = n = n === void 0 ? r : os(ze(n), 0, r);
  return (n -= t.length) >= 0 && e.slice(n, i) == t;
}
function sO(e) {
  return function(t) {
    var n = vo(t);
    return n == "[object Map]" ? yg(t) : n == "[object Set]" ? function(r) {
      var i = -1, o = Array(r.size);
      return r.forEach(function(a) {
        o[++i] = [a, a];
      }), o;
    }(t) : function(r, i) {
      return qn(i, function(o) {
        return [o, r[o]];
      });
    }(t, e(t));
  };
}
var Nf = sO(or), Rf = sO(Lr), sB = sg({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }), uO = /[&<>"']/g, uB = RegExp(uO.source);
function Og(e) {
  return (e = ln(e)) && uB.test(e) ? e.replace(uO, sB) : e;
}
var cO = /[\\^$.*+?()[\]{}|]/g, cB = RegExp(cO.source);
function lO(e) {
  return (e = ln(e)) && cB.test(e) ? e.replace(cO, "\\$&") : e;
}
function fO(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (!t(e[n], n, e))
      return !1;
  return !0;
}
function lB(e, t) {
  var n = !0;
  return ya(e, function(r, i, o) {
    return n = !!t(r, i, o);
  }), n;
}
function hO(e, t, n) {
  var r = Ne(e) ? fO : lB;
  return n && Dr(e, t, n) && (t = void 0), r(e, Re(t));
}
function Ag(e) {
  return e ? os(ze(e), 0, 4294967295) : 0;
}
function dO(e, t, n, r) {
  var i = e == null ? 0 : e.length;
  return i ? (n && typeof n != "number" && Dr(e, t, n) && (n = 0, r = i), function(o, a, s, u) {
    var c = o.length;
    for ((s = ze(s)) < 0 && (s = -s > c ? 0 : c + s), (u = u === void 0 || u > c ? c : ze(u)) < 0 && (u += c), u = s > u ? 0 : Ag(u); s < u; )
      o[s++] = a;
    return o;
  }(e, t, n, r)) : [];
}
function vO(e, t) {
  var n = [];
  return ya(e, function(r, i, o) {
    t(r, i, o) && n.push(r);
  }), n;
}
function pO(e, t) {
  return (Ne(e) ? ga : vO)(e, Re(t));
}
function mO(e) {
  return function(t, n, r) {
    var i = Object(t);
    if (!Br(t)) {
      var o = Re(n);
      t = or(t), n = function(s) {
        return o(i[s], s, i);
      };
    }
    var a = e(t, n, r);
    return a > -1 ? i[o ? t[a] : a] : void 0;
  };
}
var fB = Math.max;
function Pg(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = n == null ? 0 : ze(n);
  return i < 0 && (i = fB(r + i, 0)), Rh(e, Re(t), i);
}
var gO = mO(Pg);
function yO(e, t, n) {
  var r;
  return n(e, function(i, o, a) {
    if (t(i, o, a))
      return r = o, !1;
  }), r;
}
function bO(e, t) {
  return yO(e, Re(t), uo);
}
var hB = Math.max, dB = Math.min;
function Eg(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = r - 1;
  return n !== void 0 && (i = ze(n), i = n < 0 ? hB(r + i, 0) : dB(i, r - 1)), Rh(e, Re(t), i, !0);
}
var kO = mO(Eg);
function wO(e, t) {
  return yO(e, Re(t), Cg);
}
function cr(e) {
  return e && e.length ? e[0] : void 0;
}
function xO(e, t) {
  var n = -1, r = Br(e) ? Array(e.length) : [];
  return ya(e, function(i, o, a) {
    r[++n] = t(i, o, a);
  }), r;
}
function hu(e, t) {
  return (Ne(e) ? qn : xO)(e, Re(t));
}
function jO(e, t) {
  return kr(hu(e, t), 1);
}
function SO(e, t) {
  return kr(hu(e, t), 1 / 0);
}
function $O(e, t, n) {
  return n = n === void 0 ? 1 : ze(n), kr(hu(e, t), n);
}
function _O(e) {
  return e != null && e.length ? kr(e, 1 / 0) : [];
}
function CO(e, t) {
  return e != null && e.length ? kr(e, t = t === void 0 ? 1 : ze(t)) : [];
}
function OO(e) {
  return No(e, 512);
}
var AO = lg("floor");
function PO(e) {
  return Do(function(t) {
    var n = t.length, r = n, i = pi.prototype.thru;
    for (e && t.reverse(); r--; ) {
      var o = t[r];
      if (typeof o != "function")
        throw new TypeError("Expected a function");
      if (i && !a && ef(o) == "wrapper")
        var a = new pi([], !0);
    }
    for (r = a ? r : n; ++r < n; ) {
      var s = ef(o = t[r]), u = s == "wrapper" ? Gm(o) : void 0;
      a = u && Xv(u[0]) && u[1] == 424 && !u[4].length && u[9] == 1 ? a[ef(u[0])].apply(a, u[3]) : o.length == 1 && Xv(o) ? a[s]() : a.thru(o);
    }
    return function() {
      var c = arguments, l = c[0];
      if (a && c.length == 1 && Ne(l))
        return a.plant(l).value();
      for (var f = 0, h = n ? t[f].apply(this, c) : l; ++f < n; )
        h = t[f].call(this, h);
      return h;
    };
  });
}
var EO = PO(), MO = PO(!0);
function TO(e, t) {
  return e == null ? e : jg(e, bo(t), Lr);
}
function IO(e, t) {
  return e == null ? e : iO(e, bo(t), Lr);
}
function NO(e, t) {
  return e && uo(e, bo(t));
}
function RO(e, t) {
  return e && Cg(e, bo(t));
}
function DO(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n; ) {
    var i = e[t];
    r[i[0]] = i[1];
  }
  return r;
}
function Zh(e, t) {
  return ga(t, function(n) {
    return go(e[n]);
  });
}
function LO(e) {
  return e == null ? [] : Zh(e, or(e));
}
function zO(e) {
  return e == null ? [] : Zh(e, Lr(e));
}
var vB = Object.prototype.hasOwnProperty, Vc = Jh(function(e, t, n) {
  vB.call(e, n) ? e[n].push(t) : Ro(e, n, [t]);
});
function Mg(e, t) {
  return e > t;
}
function Yh(e) {
  return function(t, n) {
    return typeof t == "string" && typeof n == "string" || (t = ti(t), n = ti(n)), e(t, n);
  };
}
var BO = Yh(Mg), FO = Yh(function(e, t) {
  return e >= t;
}), pB = Object.prototype.hasOwnProperty;
function mB(e, t) {
  return e != null && pB.call(e, t);
}
function qO(e, t) {
  return e != null && M5(e, t, mB);
}
var gB = Math.max, yB = Math.min;
function VO(e, t, n) {
  return t = ao(t), n === void 0 ? (n = t, t = 0) : n = ao(n), function(r, i, o) {
    return r >= yB(i, o) && r < gB(i, o);
  }(e = ti(e), t, n);
}
function Hc(e) {
  return typeof e == "string" || !Ne(e) && Un(e) && zr(e) == "[object String]";
}
function Tg(e, t) {
  return qn(t, function(n) {
    return e[n];
  });
}
function as(e) {
  return e == null ? [] : Tg(e, or(e));
}
var bB = Math.max;
function HO(e, t, n, r) {
  e = Br(e) ? e : as(e), n = n && !r ? ze(n) : 0;
  var i = e.length;
  return n < 0 && (n = bB(i + n, 0)), Hc(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && iu(e, t, n) > -1;
}
var kB = Math.max;
function WO(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = n == null ? 0 : ze(n);
  return i < 0 && (i = kB(r + i, 0)), iu(e, t, i);
}
function Ge(e) {
  return e != null && e.length ? ki(e, 0, -1) : [];
}
var wB = Math.min;
function Ig(e, t, n) {
  for (var r = n ? _g : Dh, i = e[0].length, o = e.length, a = o, s = Array(o), u = 1 / 0, c = []; a--; ) {
    var l = e[a];
    a && t && (l = qn(l, ii(t))), u = wB(l.length, u), s[a] = !n && (t || i >= 120 && l.length >= 120) ? new Da(a && l) : void 0;
  }
  l = e[0];
  var f = -1, h = s[0];
  t:
    for (; ++f < i && c.length < u; ) {
      var d = l[f], p = t ? t(d) : d;
      if (d = n || d !== 0 ? d : 0, !(h ? sc(h, p) : r(c, p, n))) {
        for (a = o; --a; ) {
          var v = s[a];
          if (!(v ? sc(v, p) : r(e[a], p, n)))
            continue t;
        }
        h && h.push(p), c.push(d);
      }
    }
  return c;
}
function Ng(e) {
  return Gn(e) ? e : [];
}
var UO = We(function(e) {
  var t = qn(e, Ng);
  return t.length && t[0] === e[0] ? Ig(t) : [];
}), JO = We(function(e) {
  var t = ve(e), n = qn(e, Ng);
  return t === ve(n) ? t = void 0 : n.pop(), n.length && n[0] === e[0] ? Ig(n, Re(t)) : [];
}), KO = We(function(e) {
  var t = ve(e), n = qn(e, Ng);
  return (t = typeof t == "function" ? t : void 0) && n.pop(), n.length && n[0] === e[0] ? Ig(n, void 0, t) : [];
});
function GO(e, t) {
  return function(n, r) {
    return function(i, o, a, s) {
      return uo(i, function(u, c, l) {
        o(s, a(u), c, l);
      }), s;
    }(n, e, t(r), {});
  };
}
var xB = Object.prototype.toString, QO = GO(function(e, t, n) {
  t != null && typeof t.toString != "function" && (t = xB.call(t)), e[t] = n;
}, Nh(Cr)), XO = Object.prototype, jB = XO.hasOwnProperty, SB = XO.toString, ZO = GO(function(e, t, n) {
  t != null && typeof t.toString != "function" && (t = SB.call(t)), jB.call(e, t) ? e[t].push(n) : e[t] = [n];
}, Re);
function YO(e, t) {
  return t.length < 2 ? e : is(e, ki(t, 0, -1));
}
function Wc(e, t, n) {
  var r = (e = YO(e, t = va(t, e))) == null ? e : e[yo(ve(t))];
  return r == null ? void 0 : ri(r, e, n);
}
var t6 = We(Wc), e6 = We(function(e, t, n) {
  var r = -1, i = typeof t == "function", o = Br(e) ? Array(e.length) : [];
  return ya(e, function(a) {
    o[++r] = i ? ri(t, a, n) : Wc(a, t, n);
  }), o;
}), Mx = bi && bi.isArrayBuffer, n6 = Mx ? ii(Mx) : function(e) {
  return Un(e) && zr(e) == "[object ArrayBuffer]";
};
function r6(e) {
  return e === !0 || e === !1 || Un(e) && zr(e) == "[object Boolean]";
}
var Tx = bi && bi.isDate, i6 = Tx ? ii(Tx) : function(e) {
  return Un(e) && zr(e) == "[object Date]";
};
function o6(e) {
  return Un(e) && e.nodeType === 1 && !uu(e);
}
var $B = Object.prototype.hasOwnProperty;
function _n(e) {
  if (e == null)
    return !0;
  if (Br(e) && (Ne(e) || typeof e == "string" || typeof e.splice == "function" || Oo(e) || rs(e) || oa(e)))
    return !e.length;
  var t = vo(e);
  if (t == "[object Map]" || t == "[object Set]")
    return !e.size;
  if (zc(e))
    return !Ym(e).length;
  for (var n in e)
    if ($B.call(e, n))
      return !1;
  return !0;
}
function rn(e, t) {
  return Fc(e, t);
}
function a6(e, t, n) {
  var r = (n = typeof n == "function" ? n : void 0) ? n(e, t) : void 0;
  return r === void 0 ? Fc(e, t, void 0, n) : !!r;
}
var _B = dr.isFinite;
function s6(e) {
  return typeof e == "number" && _B(e);
}
function Rg(e) {
  return typeof e == "number" && e == ze(e);
}
function u6(e, t) {
  return e === t || bg(e, t, kg(t));
}
function c6(e, t, n) {
  return n = typeof n == "function" ? n : void 0, bg(e, t, kg(t), n);
}
function Dg(e) {
  return typeof e == "number" || Un(e) && zr(e) == "[object Number]";
}
function l6(e) {
  return Dg(e) && e != +e;
}
var CB = tf ? go : Lh;
function f6(e) {
  if (CB(e))
    throw new Error("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
  return IC(e);
}
function h6(e) {
  return e == null;
}
function d6(e) {
  return e === null;
}
var Ix = bi && bi.isRegExp, td = Ix ? ii(Ix) : function(e) {
  return Un(e) && zr(e) == "[object RegExp]";
};
function v6(e) {
  return Rg(e) && e >= -9007199254740991 && e <= 9007199254740991;
}
function p6(e) {
  return e === void 0;
}
function m6(e) {
  return Un(e) && vo(e) == "[object WeakMap]";
}
function g6(e) {
  return Un(e) && zr(e) == "[object WeakSet]";
}
function y6(e) {
  return Re(typeof e == "function" ? e : mi(e, 1));
}
var OB = Array.prototype.join;
function b6(e, t) {
  return e == null ? "" : OB.call(e, t);
}
var k6 = lu(function(e, t, n) {
  return e + (n ? "-" : "") + t.toLowerCase();
}), w6 = Jh(function(e, t, n) {
  Ro(e, n, t);
}), AB = Math.max, PB = Math.min;
function x6(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = r;
  return n !== void 0 && (i = (i = ze(n)) < 0 ? AB(r + i, 0) : PB(i, r - 1)), t == t ? function(o, a, s) {
    for (var u = s + 1; u--; )
      if (o[u] === a)
        return u;
    return u;
  }(e, t, i) : Rh(e, FC, i, !0);
}
var j6 = lu(function(e, t, n) {
  return e + (n ? " " : "") + t.toLowerCase();
}), S6 = o5("toLowerCase");
function Lg(e, t) {
  return e < t;
}
var $6 = Yh(Lg), _6 = Yh(function(e, t) {
  return e <= t;
});
function C6(e, t) {
  var n = {};
  return t = Re(t), uo(e, function(r, i, o) {
    Ro(n, t(r, i, o), r);
  }), n;
}
function O6(e, t) {
  var n = {};
  return t = Re(t), uo(e, function(r, i, o) {
    Ro(n, i, t(r, i, o));
  }), n;
}
function A6(e) {
  return E5(mi(e, 1));
}
function P6(e, t) {
  return T5(e, mi(t, 1));
}
function ed(e, t, n) {
  for (var r = -1, i = e.length; ++r < i; ) {
    var o = e[r], a = t(o);
    if (a != null && (s === void 0 ? a == a && !Wr(a) : n(a, s)))
      var s = a, u = o;
  }
  return u;
}
function E6(e) {
  return e && e.length ? ed(e, Cr, Mg) : void 0;
}
function M6(e, t) {
  return e && e.length ? ed(e, Re(t), Mg) : void 0;
}
function zg(e, t) {
  for (var n, r = -1, i = e.length; ++r < i; ) {
    var o = t(e[r]);
    o !== void 0 && (n = n === void 0 ? o : n + o);
  }
  return n;
}
function T6(e, t) {
  var n = e == null ? 0 : e.length;
  return n ? zg(e, t) / n : NaN;
}
function I6(e) {
  return T6(e, Cr);
}
function N6(e, t) {
  return T6(e, Re(t));
}
var R6 = au(function(e, t, n) {
  Qh(e, t, n);
}), D6 = We(function(e, t) {
  return function(n) {
    return Wc(n, e, t);
  };
}), L6 = We(function(e, t) {
  return function(n) {
    return Wc(e, n, t);
  };
});
function z6(e) {
  return e && e.length ? ed(e, Cr, Lg) : void 0;
}
function xs(e, t) {
  return e && e.length ? ed(e, Re(t), Lg) : void 0;
}
function Bg(e, t, n) {
  var r = or(t), i = Zh(t, r), o = !(Rn(n) && "chain" in n && !n.chain), a = go(e);
  return fi(i, function(s) {
    var u = t[s];
    e[s] = u, a && (e.prototype[s] = function() {
      var c = this.__chain__;
      if (o || c) {
        var l = e(this.__wrapped__), f = l.__actions__ = Vr(this.__actions__);
        return f.push({ func: u, args: arguments, thisArg: e }), l.__chain__ = c, l;
      }
      return u.apply(e, pa([this.value()], arguments));
    });
  }), e;
}
var B6 = Th(function(e, t) {
  return e * t;
}, 1);
function Bs(e) {
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return !e.call(this);
      case 1:
        return !e.call(this, t[0]);
      case 2:
        return !e.call(this, t[0], t[1]);
      case 3:
        return !e.call(this, t[0], t[1], t[2]);
    }
    return !e.apply(this, t);
  };
}
var Dd = _r ? _r.iterator : void 0;
function Fg(e) {
  if (!e)
    return [];
  if (Br(e))
    return Hc(e) ? Fi(e) : Vr(e);
  if (Dd && e[Dd])
    return function(n) {
      for (var r, i = []; !(r = n.next()).done; )
        i.push(r.value);
      return i;
    }(e[Dd]());
  var t = vo(e);
  return (t == "[object Map]" ? yg : t == "[object Set]" ? Wh : as)(e);
}
function op() {
  this.__values__ === void 0 && (this.__values__ = Fg(this.value()));
  var e = this.__index__ >= this.__values__.length;
  return { done: e, value: e ? void 0 : this.__values__[this.__index__++] };
}
function F6(e, t) {
  var n = e.length;
  if (n)
    return Io(t += t < 0 ? n : 0, n) ? e[t] : void 0;
}
function q6(e, t) {
  return e && e.length ? F6(e, ze(t)) : void 0;
}
function V6(e) {
  return e = ze(e), We(function(t) {
    return F6(t, e);
  });
}
function qg(e, t) {
  return (e = YO(e, t = va(t, e))) == null || delete e[yo(ve(t))];
}
function EB(e) {
  return uu(e) ? void 0 : e;
}
var H6 = Do(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = qn(t, function(o) {
    return o = va(o, e), r || (r = o.length > 1), o;
  }), so(e, dg(e), n), r && (n = mi(n, 7, EB));
  for (var i = t.length; i--; )
    qg(n, t[i]);
  return n;
});
function Uc(e, t, n, r) {
  if (!Rn(e))
    return e;
  for (var i = -1, o = (t = va(t, e)).length, a = o - 1, s = e; s != null && ++i < o; ) {
    var u = yo(t[i]), c = n;
    if (u === "__proto__" || u === "constructor" || u === "prototype")
      return e;
    if (i != a) {
      var l = s[u];
      (c = r ? r(l, u, s) : void 0) === void 0 && (c = Rn(l) ? l : Io(t[i + 1]) ? [] : {});
    }
    Dc(s, u, c), s = s[u];
  }
  return e;
}
function W6(e, t, n) {
  for (var r = -1, i = t.length, o = {}; ++r < i; ) {
    var a = t[r], s = is(e, a);
    n(s, a) && Uc(o, va(a, e), s);
  }
  return o;
}
function Vg(e, t) {
  if (e == null)
    return {};
  var n = qn(dg(e), function(r) {
    return [r];
  });
  return t = Re(t), W6(e, n, function(r, i) {
    return t(r, i[0]);
  });
}
function U6(e, t) {
  return Vg(e, Bs(Re(t)));
}
function J6(e) {
  return ig(2, e);
}
function K6(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, i = e == e, o = Wr(e), a = t !== void 0, s = t === null, u = t == t, c = Wr(t);
    if (!s && !c && !o && e > t || o && a && u && !s && !c || r && a && u || !n && u || !i)
      return 1;
    if (!r && !o && !c && e < t || c && n && i && !r && !o || s && n && i || !a && i || !u)
      return -1;
  }
  return 0;
}
function G6(e, t, n) {
  t = t.length ? qn(t, function(i) {
    return Ne(i) ? function(o) {
      return is(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : [Cr];
  var r = -1;
  return t = qn(t, ii(Re)), function(i, o) {
    var a = i.length;
    for (i.sort(o); a--; )
      i[a] = i[a].value;
    return i;
  }(xO(e, function(i, o, a) {
    return { criteria: qn(t, function(s) {
      return s(i);
    }), index: ++r, value: i };
  }), function(i, o) {
    return function(a, s, u) {
      for (var c = -1, l = a.criteria, f = s.criteria, h = l.length, d = u.length; ++c < h; ) {
        var p = K6(l[c], f[c]);
        if (p)
          return c >= d ? p : p * (u[c] == "desc" ? -1 : 1);
      }
      return a.index - s.index;
    }(i, o, n);
  });
}
function Q6(e, t, n, r) {
  return e == null ? [] : (Ne(t) || (t = t == null ? [] : [t]), Ne(n = r ? void 0 : n) || (n = n == null ? [] : [n]), G6(e, t, n));
}
function Hg(e) {
  return Do(function(t) {
    return t = qn(t, ii(Re)), We(function(n) {
      var r = this;
      return e(t, function(i) {
        return ri(i, r, n);
      });
    });
  });
}
var X6 = Hg(qn), MB = We, TB = Math.min, Z6 = MB(function(e, t) {
  var n = (t = t.length == 1 && Ne(t[0]) ? qn(t[0], ii(Re)) : qn(kr(t, 1), ii(Re))).length;
  return We(function(r) {
    for (var i = -1, o = TB(r.length, n); ++i < o; )
      r[i] = t[i].call(this, r[i]);
    return ri(e, this, r);
  });
}), Y6 = Hg(fO), t7 = Hg(gg), IB = Math.floor;
function ap(e, t) {
  var n = "";
  if (!e || t < 1 || t > 9007199254740991)
    return n;
  do
    t % 2 && (n += e), (t = IB(t / 2)) && (e += e);
  while (t);
  return n;
}
var NB = wg("length"), RB = "[\\ud800-\\udfff]", sp = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", up = "\\ud83c[\\udffb-\\udfff]", e7 = "[^\\ud800-\\udfff]", n7 = "(?:\\ud83c[\\udde6-\\uddff]){2}", r7 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Nx = "(?:" + sp + "|" + up + ")?", DB = "[\\ufe0e\\ufe0f]?" + Nx + ("(?:\\u200d(?:" + [e7, n7, r7].join("|") + ")[\\ufe0e\\ufe0f]?" + Nx + ")*"), LB = "(?:" + [e7 + sp + "?", sp, n7, r7, RB].join("|") + ")", Rx = RegExp(up + "(?=" + up + ")|" + LB + DB, "g");
function du(e) {
  return cu(e) ? function(t) {
    for (var n = Rx.lastIndex = 0; Rx.test(t); )
      ++n;
    return n;
  }(e) : NB(e);
}
var zB = Math.ceil;
function Df(e, t) {
  var n = (t = t === void 0 ? " " : ni(t)).length;
  if (n < 2)
    return n ? ap(t, e) : t;
  var r = ap(t, zB(e / du(t)));
  return cu(t) ? ma(Fi(r), 0, e).join("") : r.slice(0, e);
}
var BB = Math.ceil, FB = Math.floor;
function i7(e, t, n) {
  e = ln(e);
  var r = (t = ze(t)) ? du(e) : 0;
  if (!t || r >= t)
    return e;
  var i = (t - r) / 2;
  return Df(FB(i), n) + e + Df(BB(i), n);
}
function o7(e, t, n) {
  e = ln(e);
  var r = (t = ze(t)) ? du(e) : 0;
  return t && r < t ? e + Df(t - r, n) : e;
}
function a7(e, t, n) {
  e = ln(e);
  var r = (t = ze(t)) ? du(e) : 0;
  return t && r < t ? Df(t - r, n) + e : e;
}
var qB = /^\s+/, VB = dr.parseInt;
function s7(e, t, n) {
  return n || t == null ? t = 0 : t && (t = +t), VB(ln(e).replace(qB, ""), t || 0);
}
var Jc = We(function(e, t) {
  return No(e, 32, void 0, t, Yo(t, ou(Jc)));
});
Jc.placeholder = {};
var nd = We(function(e, t) {
  return No(e, 64, void 0, t, Yo(t, ou(nd)));
});
nd.placeholder = {};
var u7 = Jh(function(e, t, n) {
  e[n ? 0 : 1].push(t);
}, function() {
  return [[], []];
}), c7 = Do(function(e, t) {
  return e == null ? {} : function(n, r) {
    return W6(n, r, function(i, o) {
      return Uh(n, o);
    });
  }(e, t);
});
function cp(e) {
  for (var t, n = this; n instanceof Ih; ) {
    var r = LC(n);
    r.__index__ = 0, r.__values__ = void 0, t ? i.__wrapped__ = r : t = r;
    var i = r;
    n = n.__wrapped__;
  }
  return i.__wrapped__ = e, t;
}
function l7(e) {
  return function(t) {
    return e == null ? void 0 : is(e, t);
  };
}
function HB(e, t, n, r) {
  for (var i = n - 1, o = e.length; ++i < o; )
    if (r(e[i], t))
      return i;
  return -1;
}
var Dx = Array.prototype.splice;
function Wg(e, t, n, r) {
  var i = r ? HB : iu, o = -1, a = t.length, s = e;
  for (e === t && (t = Vr(t)), n && (s = qn(e, ii(n))); ++o < a; )
    for (var u = 0, c = t[o], l = n ? n(c) : c; (u = i(s, l, u, r)) > -1; )
      s !== e && Dx.call(s, u, 1), Dx.call(e, u, 1);
  return e;
}
function Ug(e, t) {
  return e && e.length && t && t.length ? Wg(e, t) : e;
}
var f7 = We(Ug);
function h7(e, t, n) {
  return e && e.length && t && t.length ? Wg(e, t, Re(n)) : e;
}
function d7(e, t, n) {
  return e && e.length && t && t.length ? Wg(e, t, void 0, n) : e;
}
var WB = Array.prototype.splice;
function v7(e, t) {
  for (var n = e ? t.length : 0, r = n - 1; n--; ) {
    var i = t[n];
    if (n == r || i !== o) {
      var o = i;
      Io(i) ? WB.call(e, i, 1) : qg(e, i);
    }
  }
  return e;
}
var p7 = Do(function(e, t) {
  var n = e == null ? 0 : e.length, r = eg(e, t);
  return v7(e, qn(t, function(i) {
    return Io(i, n) ? +i : i;
  }).sort(K6)), r;
}), UB = Math.floor, JB = Math.random;
function Jg(e, t) {
  return e + UB(JB() * (t - e + 1));
}
var KB = parseFloat, GB = Math.min, QB = Math.random;
function m7(e, t, n) {
  if (n && typeof n != "boolean" && Dr(e, t, n) && (t = n = void 0), n === void 0 && (typeof t == "boolean" ? (n = t, t = void 0) : typeof e == "boolean" && (n = e, e = void 0)), e === void 0 && t === void 0 ? (e = 0, t = 1) : (e = ao(e), t === void 0 ? (t = e, e = 0) : t = ao(t)), e > t) {
    var r = e;
    e = t, t = r;
  }
  if (n || e % 1 || t % 1) {
    var i = QB();
    return GB(e + i * (t - e + KB("1e-" + ((i + "").length - 1))), t);
  }
  return Jg(e, t);
}
var XB = Math.ceil, ZB = Math.max;
function g7(e) {
  return function(t, n, r) {
    return r && typeof r != "number" && Dr(t, n, r) && (n = r = void 0), t = ao(t), n === void 0 ? (n = t, t = 0) : n = ao(n), function(i, o, a, s) {
      for (var u = -1, c = ZB(XB((o - i) / (a || 1)), 0), l = Array(c); c--; )
        l[s ? c : ++u] = i, i += a;
      return l;
    }(t, n, r = r === void 0 ? t < n ? 1 : -1 : ao(r), e);
  };
}
var Kg = g7(), y7 = g7(!0), b7 = Do(function(e, t) {
  return No(e, 256, void 0, void 0, void 0, t);
});
function k7(e, t, n, r, i) {
  return i(e, function(o, a, s) {
    n = r ? (r = !1, o) : t(n, o, a, s);
  }), n;
}
function w7(e, t, n) {
  var r = Ne(e) ? ag : k7, i = arguments.length < 3;
  return r(e, Re(t), n, i, ya);
}
function YB(e, t, n, r) {
  var i = e == null ? 0 : e.length;
  for (r && i && (n = e[--i]); i--; )
    n = t(n, e[i], i, e);
  return n;
}
function x7(e, t, n) {
  var r = Ne(e) ? YB : k7, i = arguments.length < 3;
  return r(e, Re(t), n, i, oO);
}
function j7(e, t) {
  return (Ne(e) ? ga : vO)(e, Bs(Re(t)));
}
function S7(e, t) {
  var n = [];
  if (!e || !e.length)
    return n;
  var r = -1, i = [], o = e.length;
  for (t = Re(t); ++r < o; ) {
    var a = e[r];
    t(a, r, e) && (n.push(a), i.push(r));
  }
  return v7(e, i), n;
}
function $7(e, t, n) {
  return t = (n ? Dr(e, t, n) : t === void 0) ? 1 : ze(t), ap(ln(e), t);
}
function _7() {
  var e = arguments, t = ln(e[0]);
  return e.length < 3 ? t : t.replace(e[1], e[2]);
}
function C7(e, t) {
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  return We(e, t = t === void 0 ? t : ze(t));
}
function O7(e, t, n) {
  var r = -1, i = (t = va(t, e)).length;
  for (i || (i = 1, e = void 0); ++r < i; ) {
    var o = e == null ? void 0 : e[yo(t[r])];
    o === void 0 && (r = i, o = n), e = go(o) ? o.call(e) : o;
  }
  return e;
}
var tF = Array.prototype.reverse;
function Lf(e) {
  return e == null ? e : tF.call(e);
}
var A7 = lg("round");
function P7(e) {
  var t = e.length;
  return t ? e[Jg(0, t - 1)] : void 0;
}
function eF(e) {
  return P7(as(e));
}
function E7(e) {
  return (Ne(e) ? P7 : eF)(e);
}
function rd(e, t) {
  var n = -1, r = e.length, i = r - 1;
  for (t = t === void 0 ? r : t; ++n < t; ) {
    var o = Jg(n, i), a = e[o];
    e[o] = e[n], e[n] = a;
  }
  return e.length = t, e;
}
function nF(e, t) {
  return rd(Vr(e), os(t, 0, e.length));
}
function rF(e, t) {
  var n = as(e);
  return rd(n, os(t, 0, n.length));
}
function M7(e, t, n) {
  return t = (n ? Dr(e, t, n) : t === void 0) ? 1 : ze(t), (Ne(e) ? nF : rF)(e, t);
}
function T7(e, t, n) {
  return e == null ? e : Uc(e, t, n);
}
function I7(e, t, n, r) {
  return r = typeof r == "function" ? r : void 0, e == null ? e : Uc(e, t, n, r);
}
function iF(e) {
  return rd(Vr(e));
}
function oF(e) {
  return rd(as(e));
}
function N7(e) {
  return (Ne(e) ? iF : oF)(e);
}
function R7(e) {
  if (e == null)
    return 0;
  if (Br(e))
    return Hc(e) ? du(e) : e.length;
  var t = vo(e);
  return t == "[object Map]" || t == "[object Set]" ? e.size : Ym(e).length;
}
function D7(e, t, n) {
  var r = e == null ? 0 : e.length;
  return r ? (n && typeof n != "number" && Dr(e, t, n) ? (t = 0, n = r) : (t = t == null ? 0 : ze(t), n = n === void 0 ? r : ze(n)), ki(e, t, n)) : [];
}
var L7 = lu(function(e, t, n) {
  return e + (n ? "_" : "") + t.toLowerCase();
});
function aF(e, t) {
  var n;
  return ya(e, function(r, i, o) {
    return !(n = t(r, i, o));
  }), !!n;
}
function z7(e, t, n) {
  var r = Ne(e) ? gg : aF;
  return n && Dr(e, t, n) && (t = void 0), r(e, Re(t));
}
var Gg = We(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && Dr(e, t[0], t[1]) ? t = [] : n > 2 && Dr(t[0], t[1], t[2]) && (t = [t[0]]), G6(e, kr(t, 1), []);
}), sF = Math.floor, uF = Math.min;
function Qg(e, t, n, r) {
  var i = 0, o = e == null ? 0 : e.length;
  if (o === 0)
    return 0;
  for (var a = (t = n(t)) != t, s = t === null, u = Wr(t), c = t === void 0; i < o; ) {
    var l = sF((i + o) / 2), f = n(e[l]), h = f !== void 0, d = f === null, p = f == f, v = Wr(f);
    if (a)
      var m = r || p;
    else
      m = c ? p && (r || h) : s ? p && h && (r || !d) : u ? p && h && !d && (r || !v) : !d && !v && (r ? f <= t : f < t);
    m ? i = l + 1 : o = l;
  }
  return uF(o, 4294967294);
}
function id(e, t, n) {
  var r = 0, i = e == null ? r : e.length;
  if (typeof t == "number" && t == t && i <= 2147483647) {
    for (; r < i; ) {
      var o = r + i >>> 1, a = e[o];
      a !== null && !Wr(a) && (n ? a <= t : a < t) ? r = o + 1 : i = o;
    }
    return i;
  }
  return Qg(e, t, Cr, n);
}
function B7(e, t) {
  return id(e, t);
}
function F7(e, t, n) {
  return Qg(e, t, Re(n));
}
function q7(e, t) {
  var n = e == null ? 0 : e.length;
  if (n) {
    var r = id(e, t);
    if (r < n && wi(e[r], t))
      return r;
  }
  return -1;
}
function V7(e, t) {
  return id(e, t, !0);
}
function H7(e, t, n) {
  return Qg(e, t, Re(n), !0);
}
function W7(e, t) {
  if (e != null && e.length) {
    var n = id(e, t, !0) - 1;
    if (wi(e[n], t))
      return n;
  }
  return -1;
}
function U7(e, t) {
  for (var n = -1, r = e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n], s = t ? t(a) : a;
    if (!n || !wi(s, u)) {
      var u = s;
      o[i++] = a === 0 ? 0 : a;
    }
  }
  return o;
}
function J7(e) {
  return e && e.length ? U7(e) : [];
}
function K7(e, t) {
  return e && e.length ? U7(e, Re(t)) : [];
}
function G7(e, t, n) {
  return n && typeof n != "number" && Dr(e, t, n) && (t = n = void 0), (n = n === void 0 ? 4294967295 : n >>> 0) ? (e = ln(e)) && (typeof t == "string" || t != null && !td(t)) && !(t = ni(t)) && cu(e) ? ma(Fi(e), 0, n) : e.split(t, n) : [];
}
var cF = Math.max;
function Q7(e, t) {
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  return t = t == null ? 0 : cF(ze(t), 0), We(function(n) {
    var r = n[t], i = ma(n, 0, t);
    return r && pa(i, r), ri(e, this, i);
  });
}
var X7 = lu(function(e, t, n) {
  return e + (n ? " " : "") + Vh(t);
});
function Z7(e, t, n) {
  return e = ln(e), n = n == null ? 0 : os(ze(n), 0, e.length), t = ni(t), e.slice(n, n + t.length) == t;
}
function Y7() {
  return {};
}
function t8() {
  return "";
}
function e8() {
  return !0;
}
var n8 = Th(function(e, t) {
  return e - t;
}, 0);
function r8(e) {
  return e && e.length ? zg(e, Cr) : 0;
}
function i8(e, t) {
  return e && e.length ? zg(e, Re(t)) : 0;
}
function o8(e) {
  var t = e == null ? 0 : e.length;
  return t ? ki(e, 1, t) : [];
}
function a8(e, t, n) {
  return e && e.length ? ki(e, 0, (t = n || t === void 0 ? 1 : ze(t)) < 0 ? 0 : t) : [];
}
function s8(e, t, n) {
  var r = e == null ? 0 : e.length;
  return r ? ki(e, (t = r - (t = n || t === void 0 ? 1 : ze(t))) < 0 ? 0 : t, r) : [];
}
function u8(e, t) {
  return e && e.length ? Xh(e, Re(t), !1, !0) : [];
}
function c8(e, t) {
  return e && e.length ? Xh(e, Re(t)) : [];
}
function l8(e, t) {
  return t(e), e;
}
var f8 = Object.prototype, lF = f8.hasOwnProperty;
function Lx(e, t, n, r) {
  return e === void 0 || wi(e, f8[n]) && !lF.call(r, n) ? t : e;
}
var fF = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" };
function hF(e) {
  return "\\" + fF[e];
}
var h8 = /<%=([\s\S]+?)%>/g, zf = { escape: /<%-([\s\S]+?)%>/g, evaluate: /<%([\s\S]+?)%>/g, interpolate: h8, variable: "", imports: { _: { escape: Og } } }, dF = /\b__p \+= '';/g, vF = /\b(__p \+=) '' \+/g, pF = /(__e\(.*?\)|\b__t\)) \+\n'';/g, mF = /[()=,{}\[\]\/\s]/, gF = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, kl = /($^)/, yF = /['\n\r\u2028\u2029\\]/g, zx = Object.prototype.hasOwnProperty;
function d8(e, t, n) {
  var r = zf.imports._.templateSettings || zf;
  n && Dr(e, t, n) && (t = void 0), e = ln(e), t = zs({}, t, r, Lx);
  var i, o, a = zs({}, t.imports, r.imports, Lx), s = or(a), u = Tg(a, s), c = 0, l = t.interpolate || kl, f = "__p += '", h = RegExp((t.escape || kl).source + "|" + l.source + "|" + (l === h8 ? gF : kl).source + "|" + (t.evaluate || kl).source + "|$", "g"), d = zx.call(t, "sourceURL") ? "//# sourceURL=" + (t.sourceURL + "").replace(/\s/g, " ") + `
` : "";
  e.replace(h, function(m, g, y, b, k, w) {
    return y || (y = b), f += e.slice(c, w).replace(yF, hF), g && (i = !0, f += `' +
__e(` + g + `) +
'`), k && (o = !0, f += `';
` + k + `;
__p += '`), y && (f += `' +
((__t = (` + y + `)) == null ? '' : __t) +
'`), c = w + m.length, m;
  }), f += `';
`;
  var p = zx.call(t, "variable") && t.variable;
  if (p) {
    if (mF.test(p))
      throw new Error("Invalid `variable` option passed into `_.template`");
  } else
    f = `with (obj) {
` + f + `
}
`;
  f = (o ? f.replace(dF, "") : f).replace(vF, "$1").replace(pF, "$1;"), f = "function(" + (p || "obj") + `) {
` + (p ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (o ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + f + `return __p
}`;
  var v = rg(function() {
    return Function(s, d + "return " + f).apply(void 0, u);
  });
  if (v.source = f, Fh(v))
    throw v;
  return v;
}
function Xg(e, t, n) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  return Rn(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), fu(e, t, { leading: r, maxWait: t, trailing: i });
}
function Fs(e, t) {
  return t(e);
}
var bF = Math.min;
function Zg(e, t) {
  if ((e = ze(e)) < 1 || e > 9007199254740991)
    return [];
  var n = 4294967295, r = bF(e, 4294967295);
  e -= 4294967295;
  for (var i = Zm(r, t = bo(t)); ++n < e; )
    t(n);
  return i;
}
function lp() {
  return this;
}
function v8(e, t) {
  var n = e;
  return n instanceof Ke && (n = n.value()), ag(t, function(r, i) {
    return i.func.apply(i.thisArg, pa([r], i.args));
  }, n);
}
function Pa() {
  return v8(this.__wrapped__, this.__actions__);
}
function p8(e) {
  return ln(e).toLowerCase();
}
function m8(e) {
  return Ne(e) ? qn(e, yo) : Wr(e) ? [e] : Vr(ZC(ln(e)));
}
function g8(e) {
  return e ? os(ze(e), -9007199254740991, 9007199254740991) : e === 0 ? e : 0;
}
function y8(e) {
  return ln(e).toUpperCase();
}
function b8(e, t, n) {
  var r = Ne(e), i = r || Oo(e) || rs(e);
  if (t = Re(t), n == null) {
    var o = e && e.constructor;
    n = i ? r ? new o() : [] : Rn(e) && go(o) ? ru(Bh(e)) : {};
  }
  return (i ? fi : uo)(e, function(a, s, u) {
    return t(n, a, s, u);
  }), n;
}
function k8(e, t) {
  for (var n = e.length; n-- && iu(t, e[n], 0) > -1; )
    ;
  return n;
}
function w8(e, t) {
  for (var n = -1, r = e.length; ++n < r && iu(t, e[n], 0) > -1; )
    ;
  return n;
}
function x8(e, t, n) {
  if ((e = ln(e)) && (n || t === void 0))
    return MC(e);
  if (!e || !(t = ni(t)))
    return e;
  var r = Fi(e), i = Fi(t);
  return ma(r, w8(r, i), k8(r, i) + 1).join("");
}
function j8(e, t, n) {
  if ((e = ln(e)) && (n || t === void 0))
    return e.slice(0, EC(e) + 1);
  if (!e || !(t = ni(t)))
    return e;
  var r = Fi(e);
  return ma(r, 0, k8(r, Fi(t)) + 1).join("");
}
var kF = /^\s+/;
function S8(e, t, n) {
  if ((e = ln(e)) && (n || t === void 0))
    return e.replace(kF, "");
  if (!e || !(t = ni(t)))
    return e;
  var r = Fi(e);
  return ma(r, w8(r, Fi(t))).join("");
}
var wF = /\w*$/;
function $8(e, t) {
  var n = 30, r = "...";
  if (Rn(t)) {
    var i = "separator" in t ? t.separator : i;
    n = "length" in t ? ze(t.length) : n, r = "omission" in t ? ni(t.omission) : r;
  }
  var o = (e = ln(e)).length;
  if (cu(e)) {
    var a = Fi(e);
    o = a.length;
  }
  if (n >= o)
    return e;
  var s = n - du(r);
  if (s < 1)
    return r;
  var u = a ? ma(a, 0, s).join("") : e.slice(0, s);
  if (i === void 0)
    return u + r;
  if (a && (s += u.length - s), td(i)) {
    if (e.slice(s).search(i)) {
      var c, l = u;
      for (i.global || (i = RegExp(i.source, ln(wF.exec(i)) + "g")), i.lastIndex = 0; c = i.exec(l); )
        var f = c.index;
      u = u.slice(0, f === void 0 ? s : f);
    }
  } else if (e.indexOf(ni(i), s) != s) {
    var h = u.lastIndexOf(i);
    h > -1 && (u = u.slice(0, h));
  }
  return u + r;
}
function _8(e) {
  return Xm(e, 1);
}
var xF = sg({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }), C8 = /&(?:amp|lt|gt|quot|#39);/g, jF = RegExp(C8.source);
function O8(e) {
  return (e = ln(e)) && jF.test(e) ? e.replace(C8, xF) : e;
}
var SF = Cs && 1 / Wh(new Cs([, -0]))[1] == 1 / 0 ? function(e) {
  return new Cs(e);
} : Qe;
function aa(e, t, n) {
  var r = -1, i = Dh, o = e.length, a = !0, s = [], u = s;
  if (n)
    a = !1, i = _g;
  else if (o >= 200) {
    var c = t ? null : SF(e);
    if (c)
      return Wh(c);
    a = !1, i = sc, u = new Da();
  } else
    u = t ? [] : s;
  t:
    for (; ++r < o; ) {
      var l = e[r], f = t ? t(l) : l;
      if (l = n || l !== 0 ? l : 0, a && f == f) {
        for (var h = u.length; h--; )
          if (u[h] === f)
            continue t;
        t && u.push(f), s.push(l);
      } else
        i(u, f, n) || (u !== s && u.push(f), s.push(l));
    }
  return s;
}
var A8 = We(function(e) {
  return aa(kr(e, 1, Gn, !0));
}), P8 = We(function(e) {
  var t = ve(e);
  return Gn(t) && (t = void 0), aa(kr(e, 1, Gn, !0), Re(t));
}), E8 = We(function(e) {
  var t = ve(e);
  return t = typeof t == "function" ? t : void 0, aa(kr(e, 1, Gn, !0), void 0, t);
});
function M8(e) {
  return e && e.length ? aa(e) : [];
}
function T8(e, t) {
  return e && e.length ? aa(e, Re(t)) : [];
}
function I8(e, t) {
  return t = typeof t == "function" ? t : void 0, e && e.length ? aa(e, void 0, t) : [];
}
var $F = 0;
function qs(e) {
  var t = ++$F;
  return ln(e) + t;
}
function N8(e, t) {
  return e == null || qg(e, t);
}
var _F = Math.max;
function od(e) {
  if (!e || !e.length)
    return [];
  var t = 0;
  return e = ga(e, function(n) {
    if (Gn(n))
      return t = _F(n.length, t), !0;
  }), Zm(t, function(n) {
    return qn(e, wg(n));
  });
}
function Yg(e, t) {
  if (!e || !e.length)
    return [];
  var n = od(e);
  return t == null ? n : qn(n, function(r) {
    return ri(t, void 0, r);
  });
}
function R8(e, t, n, r) {
  return Uc(e, t, n(is(e, t)), r);
}
function D8(e, t, n) {
  return e == null ? e : R8(e, t, bo(n));
}
function L8(e, t, n, r) {
  return r = typeof r == "function" ? r : void 0, e == null ? e : R8(e, t, bo(n), r);
}
var z8 = lu(function(e, t, n) {
  return e + (n ? " " : "") + t.toUpperCase();
});
function B8(e) {
  return e == null ? [] : Tg(e, Lr(e));
}
var F8 = We(function(e, t) {
  return Gn(e) ? qc(e, t) : [];
});
function q8(e, t) {
  return Jc(bo(t), e);
}
var V8 = Do(function(e) {
  var t = e.length, n = t ? e[0] : 0, r = this.__wrapped__, i = function(o) {
    return eg(o, e);
  };
  return !(t > 1 || this.__actions__.length) && r instanceof Ke && Io(n) ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({ func: Fs, args: [i], thisArg: void 0 }), new pi(r, this.__chain__).thru(function(o) {
    return t && !o.length && o.push(void 0), o;
  })) : this.thru(i);
});
function H8() {
  return fg(this);
}
function W8() {
  var e = this.__wrapped__;
  if (e instanceof Ke) {
    var t = e;
    return this.__actions__.length && (t = new Ke(this)), (t = t.reverse()).__actions__.push({ func: Fs, args: [Lf], thisArg: void 0 }), new pi(t, this.__chain__);
  }
  return this.thru(Lf);
}
function t0(e, t, n) {
  var r = e.length;
  if (r < 2)
    return r ? aa(e[0]) : [];
  for (var i = -1, o = Array(r); ++i < r; )
    for (var a = e[i], s = -1; ++s < r; )
      s != i && (o[i] = qc(o[i] || a, e[s], t, n));
  return aa(kr(o, 1), t, n);
}
var U8 = We(function(e) {
  return t0(ga(e, Gn));
}), J8 = We(function(e) {
  var t = ve(e);
  return Gn(t) && (t = void 0), t0(ga(e, Gn), Re(t));
}), K8 = We(function(e) {
  var t = ve(e);
  return t = typeof t == "function" ? t : void 0, t0(ga(e, Gn), void 0, t);
}), G8 = We(od);
function Q8(e, t, n) {
  for (var r = -1, i = e.length, o = t.length, a = {}; ++r < i; ) {
    var s = r < o ? t[r] : void 0;
    n(a, e[r], s);
  }
  return a;
}
function X8(e, t) {
  return Q8(e || [], t || [], Dc);
}
function Z8(e, t) {
  return Q8(e || [], t || [], Uc);
}
var Y8 = We(function(e) {
  var t = e.length, n = t > 1 ? e[t - 1] : void 0;
  return n = typeof n == "function" ? (e.pop(), n) : void 0, Yg(e, n);
}), ce = { chunk: p5, compact: C5, concat: O5, difference: Q5, differenceBy: X5, differenceWith: Z5, drop: tO, dropRight: eO, dropRightWhile: nO, dropWhile: rO, fill: dO, findIndex: Pg, findLastIndex: Eg, first: cr, flatten: ng, flattenDeep: _O, flattenDepth: CO, fromPairs: DO, head: cr, indexOf: WO, initial: Ge, intersection: UO, intersectionBy: JO, intersectionWith: KO, join: b6, last: ve, lastIndexOf: x6, nth: q6, pull: f7, pullAll: Ug, pullAllBy: h7, pullAllWith: d7, pullAt: p7, remove: S7, reverse: Lf, slice: D7, sortedIndex: B7, sortedIndexBy: F7, sortedIndexOf: q7, sortedLastIndex: V7, sortedLastIndexBy: H7, sortedLastIndexOf: W7, sortedUniq: J7, sortedUniqBy: K7, tail: o8, take: a8, takeRight: s8, takeRightWhile: u8, takeWhile: c8, union: A8, unionBy: P8, unionWith: E8, uniq: M8, uniqBy: T8, uniqWith: I8, unzip: od, unzipWith: Yg, without: F8, xor: U8, xorBy: J8, xorWith: K8, zip: G8, zipObject: X8, zipObjectDeep: Z8, zipWith: Y8 }, yn = { countBy: B5, each: If, eachRight: uc, every: hO, filter: pO, find: gO, findLast: kO, flatMap: jO, flatMapDeep: SO, flatMapDepth: $O, forEach: If, forEachRight: uc, groupBy: Vc, includes: HO, invokeMap: e6, keyBy: w6, map: hu, orderBy: Q6, partition: u7, reduce: w7, reduceRight: x7, reject: j7, sample: E7, sampleSize: M7, shuffle: N7, size: R7, some: z7, sortBy: Gg }, CF = Wu, Kn = { after: TC, ary: Xm, before: ig, bind: Bc, bindKey: qh, curry: Kh, curryRight: Gh, debounce: fu, defer: K5, delay: G5, flip: OO, memoize: su, negate: Bs, once: J6, overArgs: Z6, partial: Jc, partialRight: nd, rearg: b7, rest: C7, spread: Q7, throttle: Xg, unary: _8, wrap: q8 }, je = { castArray: d5, clone: S5, cloneDeep: $5, cloneDeepWith: mg, cloneWith: _5, conformsTo: D5, eq: wi, gt: BO, gte: FO, isArguments: oa, isArray: Ne, isArrayBuffer: n6, isArrayLike: Br, isArrayLikeObject: Gn, isBoolean: r6, isBuffer: Oo, isDate: i6, isElement: o6, isEmpty: _n, isEqual: rn, isEqualWith: a6, isError: Fh, isFinite: s6, isFunction: go, isInteger: Rg, isLength: Lc, isMap: vg, isMatch: u6, isMatchWith: c6, isNaN: l6, isNative: f6, isNil: h6, isNull: d6, isNumber: Dg, isObject: Rn, isObjectLike: Un, isPlainObject: uu, isRegExp: td, isSafeInteger: v6, isSet: pg, isString: Hc, isSymbol: Wr, isTypedArray: rs, isUndefined: p6, isWeakMap: m6, isWeakSet: g6, lt: $6, lte: _6, toArray: Fg, toFinite: ao, toInteger: ze, toLength: Ag, toNumber: ti, toPlainObject: Sg, toSafeInteger: g8, toString: ln }, Er = { add: PC, ceil: v5, divide: Y5, floor: AO, max: E6, maxBy: M6, mean: I6, meanBy: N6, min: z6, minBy: xs, multiply: B6, round: A7, subtract: n8, sum: r8, sumBy: i8 }, OF = m5, AF = VO, PF = m7, Me = { assign: QC, assignIn: Mf, assignInWith: zs, assignWith: XC, at: YC, create: F5, defaults: H5, defaultsDeep: U5, entries: Nf, entriesIn: Rf, extend: Mf, extendWith: zs, findKey: bO, findLastKey: wO, forIn: TO, forInRight: IO, forOwn: NO, forOwnRight: RO, functions: LO, functionsIn: zO, get: zh, has: qO, hasIn: Uh, invert: QO, invertBy: ZO, invoke: t6, keys: or, keysIn: Lr, mapKeys: C6, mapValues: O6, merge: R6, mergeWith: $g, omit: H6, omitBy: U6, pick: c7, pickBy: Vg, result: O7, set: T7, setWith: I7, toPairs: Nf, toPairsIn: Rf, transform: b8, unset: N8, update: D8, updateWith: L8, values: as, valuesIn: B8 }, Ui = { at: V8, chain: fg, commit: ip, lodash: Q, next: op, plant: cp, reverse: W8, tap: l8, thru: Fs, toIterator: lp, toJSON: Pa, value: Pa, valueOf: Pa, wrapperChain: H8 }, cn = { camelCase: h5, capitalize: og, deburr: ug, endsWith: aO, escape: Og, escapeRegExp: lO, kebabCase: k6, lowerCase: j6, lowerFirst: S6, pad: i7, padEnd: o7, padStart: a7, parseInt: s7, repeat: $7, replace: _7, snakeCase: L7, split: G7, startCase: X7, startsWith: Z7, template: d8, templateSettings: zf, toLower: p8, toUpper: y8, trim: x8, trimEnd: j8, trimStart: S8, truncate: $8, unescape: O8, upperCase: z8, upperFirst: Vh, words: cg }, dn = { attempt: rg, bindAll: e5, cond: I5, conforms: R5, constant: Nh, defaultTo: q5, flow: EO, flowRight: MO, identity: Cr, iteratee: y6, matches: A6, matchesProperty: P6, method: D6, methodOf: L6, mixin: Bg, noop: Qe, nthArg: V6, over: X6, overEvery: Y6, overSome: t7, property: xg, propertyOf: l7, range: Kg, rangeRight: y7, stubArray: Hh, stubFalse: Lh, stubObject: Y7, stubString: t8, stubTrue: e8, times: Zg, toPath: m8, uniqueId: qs }, EF = Math.max, MF = Math.min, TF = Math.min;
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var Ld, IF = Array.prototype, Bx = Object.prototype.hasOwnProperty, Fx = _r ? _r.iterator : void 0, NF = Math.max, qx = Math.min, zd = function(e) {
  return function(t, n, r) {
    if (r == null) {
      var i = Rn(n), o = i && or(n), a = o && o.length && Zh(n, o);
      (a ? a.length : i) || (r = n, n = t, t = this);
    }
    return e(t, n, r);
  };
}(Bg);
Q.after = Kn.after, Q.ary = Kn.ary, Q.assign = Me.assign, Q.assignIn = Me.assignIn, Q.assignInWith = Me.assignInWith, Q.assignWith = Me.assignWith, Q.at = Me.at, Q.before = Kn.before, Q.bind = Kn.bind, Q.bindAll = dn.bindAll, Q.bindKey = Kn.bindKey, Q.castArray = je.castArray, Q.chain = Ui.chain, Q.chunk = ce.chunk, Q.compact = ce.compact, Q.concat = ce.concat, Q.cond = dn.cond, Q.conforms = dn.conforms, Q.constant = dn.constant, Q.countBy = yn.countBy, Q.create = Me.create, Q.curry = Kn.curry, Q.curryRight = Kn.curryRight, Q.debounce = Kn.debounce, Q.defaults = Me.defaults, Q.defaultsDeep = Me.defaultsDeep, Q.defer = Kn.defer, Q.delay = Kn.delay, Q.difference = ce.difference, Q.differenceBy = ce.differenceBy, Q.differenceWith = ce.differenceWith, Q.drop = ce.drop, Q.dropRight = ce.dropRight, Q.dropRightWhile = ce.dropRightWhile, Q.dropWhile = ce.dropWhile, Q.fill = ce.fill, Q.filter = yn.filter, Q.flatMap = yn.flatMap, Q.flatMapDeep = yn.flatMapDeep, Q.flatMapDepth = yn.flatMapDepth, Q.flatten = ce.flatten, Q.flattenDeep = ce.flattenDeep, Q.flattenDepth = ce.flattenDepth, Q.flip = Kn.flip, Q.flow = dn.flow, Q.flowRight = dn.flowRight, Q.fromPairs = ce.fromPairs, Q.functions = Me.functions, Q.functionsIn = Me.functionsIn, Q.groupBy = yn.groupBy, Q.initial = ce.initial, Q.intersection = ce.intersection, Q.intersectionBy = ce.intersectionBy, Q.intersectionWith = ce.intersectionWith, Q.invert = Me.invert, Q.invertBy = Me.invertBy, Q.invokeMap = yn.invokeMap, Q.iteratee = dn.iteratee, Q.keyBy = yn.keyBy, Q.keys = or, Q.keysIn = Me.keysIn, Q.map = yn.map, Q.mapKeys = Me.mapKeys, Q.mapValues = Me.mapValues, Q.matches = dn.matches, Q.matchesProperty = dn.matchesProperty, Q.memoize = Kn.memoize, Q.merge = Me.merge, Q.mergeWith = Me.mergeWith, Q.method = dn.method, Q.methodOf = dn.methodOf, Q.mixin = zd, Q.negate = Bs, Q.nthArg = dn.nthArg, Q.omit = Me.omit, Q.omitBy = Me.omitBy, Q.once = Kn.once, Q.orderBy = yn.orderBy, Q.over = dn.over, Q.overArgs = Kn.overArgs, Q.overEvery = dn.overEvery, Q.overSome = dn.overSome, Q.partial = Kn.partial, Q.partialRight = Kn.partialRight, Q.partition = yn.partition, Q.pick = Me.pick, Q.pickBy = Me.pickBy, Q.property = dn.property, Q.propertyOf = dn.propertyOf, Q.pull = ce.pull, Q.pullAll = ce.pullAll, Q.pullAllBy = ce.pullAllBy, Q.pullAllWith = ce.pullAllWith, Q.pullAt = ce.pullAt, Q.range = dn.range, Q.rangeRight = dn.rangeRight, Q.rearg = Kn.rearg, Q.reject = yn.reject, Q.remove = ce.remove, Q.rest = Kn.rest, Q.reverse = ce.reverse, Q.sampleSize = yn.sampleSize, Q.set = Me.set, Q.setWith = Me.setWith, Q.shuffle = yn.shuffle, Q.slice = ce.slice, Q.sortBy = yn.sortBy, Q.sortedUniq = ce.sortedUniq, Q.sortedUniqBy = ce.sortedUniqBy, Q.split = cn.split, Q.spread = Kn.spread, Q.tail = ce.tail, Q.take = ce.take, Q.takeRight = ce.takeRight, Q.takeRightWhile = ce.takeRightWhile, Q.takeWhile = ce.takeWhile, Q.tap = Ui.tap, Q.throttle = Kn.throttle, Q.thru = Fs, Q.toArray = je.toArray, Q.toPairs = Me.toPairs, Q.toPairsIn = Me.toPairsIn, Q.toPath = dn.toPath, Q.toPlainObject = je.toPlainObject, Q.transform = Me.transform, Q.unary = Kn.unary, Q.union = ce.union, Q.unionBy = ce.unionBy, Q.unionWith = ce.unionWith, Q.uniq = ce.uniq, Q.uniqBy = ce.uniqBy, Q.uniqWith = ce.uniqWith, Q.unset = Me.unset, Q.unzip = ce.unzip, Q.unzipWith = ce.unzipWith, Q.update = Me.update, Q.updateWith = Me.updateWith, Q.values = Me.values, Q.valuesIn = Me.valuesIn, Q.without = ce.without, Q.words = cn.words, Q.wrap = Kn.wrap, Q.xor = ce.xor, Q.xorBy = ce.xorBy, Q.xorWith = ce.xorWith, Q.zip = ce.zip, Q.zipObject = ce.zipObject, Q.zipObjectDeep = ce.zipObjectDeep, Q.zipWith = ce.zipWith, Q.entries = Me.toPairs, Q.entriesIn = Me.toPairsIn, Q.extend = Me.assignIn, Q.extendWith = Me.assignInWith, zd(Q, Q), Q.add = Er.add, Q.attempt = dn.attempt, Q.camelCase = cn.camelCase, Q.capitalize = cn.capitalize, Q.ceil = Er.ceil, Q.clamp = OF, Q.clone = je.clone, Q.cloneDeep = je.cloneDeep, Q.cloneDeepWith = je.cloneDeepWith, Q.cloneWith = je.cloneWith, Q.conformsTo = je.conformsTo, Q.deburr = cn.deburr, Q.defaultTo = dn.defaultTo, Q.divide = Er.divide, Q.endsWith = cn.endsWith, Q.eq = je.eq, Q.escape = cn.escape, Q.escapeRegExp = cn.escapeRegExp, Q.every = yn.every, Q.find = yn.find, Q.findIndex = ce.findIndex, Q.findKey = Me.findKey, Q.findLast = yn.findLast, Q.findLastIndex = ce.findLastIndex, Q.findLastKey = Me.findLastKey, Q.floor = Er.floor, Q.forEach = yn.forEach, Q.forEachRight = yn.forEachRight, Q.forIn = Me.forIn, Q.forInRight = Me.forInRight, Q.forOwn = Me.forOwn, Q.forOwnRight = Me.forOwnRight, Q.get = Me.get, Q.gt = je.gt, Q.gte = je.gte, Q.has = Me.has, Q.hasIn = Me.hasIn, Q.head = ce.head, Q.identity = Cr, Q.includes = yn.includes, Q.indexOf = ce.indexOf, Q.inRange = AF, Q.invoke = Me.invoke, Q.isArguments = je.isArguments, Q.isArray = Ne, Q.isArrayBuffer = je.isArrayBuffer, Q.isArrayLike = je.isArrayLike, Q.isArrayLikeObject = je.isArrayLikeObject, Q.isBoolean = je.isBoolean, Q.isBuffer = je.isBuffer, Q.isDate = je.isDate, Q.isElement = je.isElement, Q.isEmpty = je.isEmpty, Q.isEqual = je.isEqual, Q.isEqualWith = je.isEqualWith, Q.isError = je.isError, Q.isFinite = je.isFinite, Q.isFunction = je.isFunction, Q.isInteger = je.isInteger, Q.isLength = je.isLength, Q.isMap = je.isMap, Q.isMatch = je.isMatch, Q.isMatchWith = je.isMatchWith, Q.isNaN = je.isNaN, Q.isNative = je.isNative, Q.isNil = je.isNil, Q.isNull = je.isNull, Q.isNumber = je.isNumber, Q.isObject = Rn, Q.isObjectLike = je.isObjectLike, Q.isPlainObject = je.isPlainObject, Q.isRegExp = je.isRegExp, Q.isSafeInteger = je.isSafeInteger, Q.isSet = je.isSet, Q.isString = je.isString, Q.isSymbol = je.isSymbol, Q.isTypedArray = je.isTypedArray, Q.isUndefined = je.isUndefined, Q.isWeakMap = je.isWeakMap, Q.isWeakSet = je.isWeakSet, Q.join = ce.join, Q.kebabCase = cn.kebabCase, Q.last = ve, Q.lastIndexOf = ce.lastIndexOf, Q.lowerCase = cn.lowerCase, Q.lowerFirst = cn.lowerFirst, Q.lt = je.lt, Q.lte = je.lte, Q.max = Er.max, Q.maxBy = Er.maxBy, Q.mean = Er.mean, Q.meanBy = Er.meanBy, Q.min = Er.min, Q.minBy = Er.minBy, Q.stubArray = dn.stubArray, Q.stubFalse = dn.stubFalse, Q.stubObject = dn.stubObject, Q.stubString = dn.stubString, Q.stubTrue = dn.stubTrue, Q.multiply = Er.multiply, Q.nth = ce.nth, Q.noop = dn.noop, Q.now = CF, Q.pad = cn.pad, Q.padEnd = cn.padEnd, Q.padStart = cn.padStart, Q.parseInt = cn.parseInt, Q.random = PF, Q.reduce = yn.reduce, Q.reduceRight = yn.reduceRight, Q.repeat = cn.repeat, Q.replace = cn.replace, Q.result = Me.result, Q.round = Er.round, Q.sample = yn.sample, Q.size = yn.size, Q.snakeCase = cn.snakeCase, Q.some = yn.some, Q.sortedIndex = ce.sortedIndex, Q.sortedIndexBy = ce.sortedIndexBy, Q.sortedIndexOf = ce.sortedIndexOf, Q.sortedLastIndex = ce.sortedLastIndex, Q.sortedLastIndexBy = ce.sortedLastIndexBy, Q.sortedLastIndexOf = ce.sortedLastIndexOf, Q.startCase = cn.startCase, Q.startsWith = cn.startsWith, Q.subtract = Er.subtract, Q.sum = Er.sum, Q.sumBy = Er.sumBy, Q.template = cn.template, Q.times = dn.times, Q.toFinite = je.toFinite, Q.toInteger = ze, Q.toLength = je.toLength, Q.toLower = cn.toLower, Q.toNumber = je.toNumber, Q.toSafeInteger = je.toSafeInteger, Q.toString = je.toString, Q.toUpper = cn.toUpper, Q.trim = cn.trim, Q.trimEnd = cn.trimEnd, Q.trimStart = cn.trimStart, Q.truncate = cn.truncate, Q.unescape = cn.unescape, Q.uniqueId = dn.uniqueId, Q.upperCase = cn.upperCase, Q.upperFirst = cn.upperFirst, Q.each = yn.forEach, Q.eachRight = yn.forEachRight, Q.first = ce.head, zd(Q, (Ld = {}, uo(Q, function(e, t) {
  Bx.call(Q.prototype, t) || (Ld[t] = e);
}), Ld), { chain: !1 }), Q.VERSION = "4.17.21", (Q.templateSettings = cn.templateSettings).imports._ = Q, fi(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
  Q[e].placeholder = Q;
}), fi(["drop", "take"], function(e, t) {
  Ke.prototype[e] = function(n) {
    n = n === void 0 ? 1 : NF(ze(n), 0);
    var r = this.__filtered__ && !t ? new Ke(this) : this.clone();
    return r.__filtered__ ? r.__takeCount__ = qx(n, r.__takeCount__) : r.__views__.push({ size: qx(n, 4294967295), type: e + (r.__dir__ < 0 ? "Right" : "") }), r;
  }, Ke.prototype[e + "Right"] = function(n) {
    return this.reverse()[e](n).reverse();
  };
}), fi(["filter", "map", "takeWhile"], function(e, t) {
  var n = t + 1, r = n == 1 || n == 3;
  Ke.prototype[e] = function(i) {
    var o = this.clone();
    return o.__iteratees__.push({ iteratee: Re(i), type: n }), o.__filtered__ = o.__filtered__ || r, o;
  };
}), fi(["head", "last"], function(e, t) {
  var n = "take" + (t ? "Right" : "");
  Ke.prototype[e] = function() {
    return this[n](1).value()[0];
  };
}), fi(["initial", "tail"], function(e, t) {
  var n = "drop" + (t ? "" : "Right");
  Ke.prototype[e] = function() {
    return this.__filtered__ ? new Ke(this) : this[n](1);
  };
}), Ke.prototype.compact = function() {
  return this.filter(Cr);
}, Ke.prototype.find = function(e) {
  return this.filter(e).head();
}, Ke.prototype.findLast = function(e) {
  return this.reverse().find(e);
}, Ke.prototype.invokeMap = We(function(e, t) {
  return typeof e == "function" ? new Ke(this) : this.map(function(n) {
    return Wc(n, e, t);
  });
}), Ke.prototype.reject = function(e) {
  return this.filter(Bs(Re(e)));
}, Ke.prototype.slice = function(e, t) {
  e = ze(e);
  var n = this;
  return n.__filtered__ && (e > 0 || t < 0) ? new Ke(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), t !== void 0 && (n = (t = ze(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
}, Ke.prototype.takeRightWhile = function(e) {
  return this.reverse().takeWhile(e).reverse();
}, Ke.prototype.toArray = function() {
  return this.take(4294967295);
}, uo(Ke.prototype, function(e, t) {
  var n = /^(?:filter|find|map|reject)|While$/.test(t), r = /^(?:head|last)$/.test(t), i = Q[r ? "take" + (t == "last" ? "Right" : "") : t], o = r || /^find/.test(t);
  i && (Q.prototype[t] = function() {
    var a = this.__wrapped__, s = r ? [1] : arguments, u = a instanceof Ke, c = s[0], l = u || Ne(a), f = function(g) {
      var y = i.apply(Q, pa([g], s));
      return r && h ? y[0] : y;
    };
    l && n && typeof c == "function" && c.length != 1 && (u = l = !1);
    var h = this.__chain__, d = !!this.__actions__.length, p = o && !h, v = u && !d;
    if (!o && l) {
      a = v ? a : new Ke(this);
      var m = e.apply(a, s);
      return m.__actions__.push({ func: Fs, args: [f], thisArg: void 0 }), new pi(m, h);
    }
    return p && v ? e.apply(this, s) : (m = this.thru(f), p ? r ? m.value()[0] : m.value() : m);
  });
}), fi(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
  var t = IF[e], n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(e);
  Q.prototype[e] = function() {
    var i = arguments;
    if (r && !this.__chain__) {
      var o = this.value();
      return t.apply(Ne(o) ? o : [], i);
    }
    return this[n](function(a) {
      return t.apply(Ne(a) ? a : [], i);
    });
  };
}), uo(Ke.prototype, function(e, t) {
  var n = Q[t];
  if (n) {
    var r = n.name + "";
    Bx.call(ws, r) || (ws[r] = []), ws[r].push({ name: t, func: n });
  }
}), ws[Ef(void 0, 2).name] = [{ name: "wrapper", func: void 0 }], Ke.prototype.clone = function() {
  var e = new Ke(this.__wrapped__);
  return e.__actions__ = Vr(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Vr(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Vr(this.__views__), e;
}, Ke.prototype.reverse = function() {
  if (this.__filtered__) {
    var e = new Ke(this);
    e.__dir__ = -1, e.__filtered__ = !0;
  } else
    (e = this.clone()).__dir__ *= -1;
  return e;
}, Ke.prototype.value = function() {
  var e = this.__wrapped__.value(), t = this.__dir__, n = Ne(e), r = t < 0, i = n ? e.length : 0, o = function(w, x, S) {
    for (var T = -1, P = S.length; ++T < P; ) {
      var O = S[T], j = O.size;
      switch (O.type) {
        case "drop":
          w += j;
          break;
        case "dropRight":
          x -= j;
          break;
        case "take":
          x = MF(x, w + j);
          break;
        case "takeRight":
          w = EF(w, x - j);
      }
    }
    return { start: w, end: x };
  }(0, i, this.__views__), a = o.start, s = o.end, u = s - a, c = r ? s : a - 1, l = this.__iteratees__, f = l.length, h = 0, d = TF(u, this.__takeCount__);
  if (!n || !r && i == u && d == u)
    return v8(e, this.__actions__);
  var p = [];
  t:
    for (; u-- && h < d; ) {
      for (var v = -1, m = e[c += t]; ++v < f; ) {
        var g = l[v], y = g.iteratee, b = g.type, k = y(m);
        if (b == 2)
          m = k;
        else if (!k) {
          if (b == 1)
            continue t;
          break t;
        }
      }
      p[h++] = m;
    }
  return p;
}, Q.prototype.at = Ui.at, Q.prototype.chain = Ui.wrapperChain, Q.prototype.commit = Ui.commit, Q.prototype.next = Ui.next, Q.prototype.plant = Ui.plant, Q.prototype.reverse = Ui.reverse, Q.prototype.toJSON = Q.prototype.valueOf = Q.prototype.value = Ui.value, Q.prototype.first = Q.prototype.head, Fx && (Q.prototype[Fx] = Ui.toIterator);
Object.freeze({ __proto__: null, add: PC, after: TC, ary: Xm, assign: QC, assignIn: Mf, assignInWith: zs, assignWith: XC, at: YC, attempt: rg, before: ig, bind: Bc, bindAll: e5, bindKey: qh, camelCase: h5, capitalize: og, castArray: d5, ceil: v5, chain: fg, chunk: p5, clamp: m5, clone: S5, cloneDeep: $5, cloneDeepWith: mg, cloneWith: _5, commit: ip, compact: C5, concat: O5, cond: I5, conforms: R5, conformsTo: D5, constant: Nh, countBy: B5, create: F5, curry: Kh, curryRight: Gh, debounce: fu, deburr: ug, defaultTo: q5, defaults: H5, defaultsDeep: U5, defer: K5, delay: G5, difference: Q5, differenceBy: X5, differenceWith: Z5, divide: Y5, drop: tO, dropRight: eO, dropRightWhile: nO, dropWhile: rO, each: If, eachRight: uc, endsWith: aO, entries: Nf, entriesIn: Rf, eq: wi, escape: Og, escapeRegExp: lO, every: hO, extend: Mf, extendWith: zs, fill: dO, filter: pO, find: gO, findIndex: Pg, findKey: bO, findLast: kO, findLastIndex: Eg, findLastKey: wO, first: cr, flatMap: jO, flatMapDeep: SO, flatMapDepth: $O, flatten: ng, flattenDeep: _O, flattenDepth: CO, flip: OO, floor: AO, flow: EO, flowRight: MO, forEach: If, forEachRight: uc, forIn: TO, forInRight: IO, forOwn: NO, forOwnRight: RO, fromPairs: DO, functions: LO, functionsIn: zO, get: zh, groupBy: Vc, gt: BO, gte: FO, has: qO, hasIn: Uh, head: cr, identity: Cr, inRange: VO, includes: HO, indexOf: WO, initial: Ge, intersection: UO, intersectionBy: JO, intersectionWith: KO, invert: QO, invertBy: ZO, invoke: t6, invokeMap: e6, isArguments: oa, isArray: Ne, isArrayBuffer: n6, isArrayLike: Br, isArrayLikeObject: Gn, isBoolean: r6, isBuffer: Oo, isDate: i6, isElement: o6, isEmpty: _n, isEqual: rn, isEqualWith: a6, isError: Fh, isFinite: s6, isFunction: go, isInteger: Rg, isLength: Lc, isMap: vg, isMatch: u6, isMatchWith: c6, isNaN: l6, isNative: f6, isNil: h6, isNull: d6, isNumber: Dg, isObject: Rn, isObjectLike: Un, isPlainObject: uu, isRegExp: td, isSafeInteger: v6, isSet: pg, isString: Hc, isSymbol: Wr, isTypedArray: rs, isUndefined: p6, isWeakMap: m6, isWeakSet: g6, iteratee: y6, join: b6, kebabCase: k6, keyBy: w6, keys: or, keysIn: Lr, last: ve, lastIndexOf: x6, lodash: Q, lowerCase: j6, lowerFirst: S6, lt: $6, lte: _6, map: hu, mapKeys: C6, mapValues: O6, matches: A6, matchesProperty: P6, max: E6, maxBy: M6, mean: I6, meanBy: N6, memoize: su, merge: R6, mergeWith: $g, method: D6, methodOf: L6, min: z6, minBy: xs, mixin: Bg, multiply: B6, negate: Bs, next: op, noop: Qe, now: Wu, nth: q6, nthArg: V6, omit: H6, omitBy: U6, once: J6, orderBy: Q6, over: X6, overArgs: Z6, overEvery: Y6, overSome: t7, pad: i7, padEnd: o7, padStart: a7, parseInt: s7, partial: Jc, partialRight: nd, partition: u7, pick: c7, pickBy: Vg, plant: cp, property: xg, propertyOf: l7, pull: f7, pullAll: Ug, pullAllBy: h7, pullAllWith: d7, pullAt: p7, random: m7, range: Kg, rangeRight: y7, rearg: b7, reduce: w7, reduceRight: x7, reject: j7, remove: S7, repeat: $7, replace: _7, rest: C7, result: O7, reverse: Lf, round: A7, sample: E7, sampleSize: M7, set: T7, setWith: I7, shuffle: N7, size: R7, slice: D7, snakeCase: L7, some: z7, sortBy: Gg, sortedIndex: B7, sortedIndexBy: F7, sortedIndexOf: q7, sortedLastIndex: V7, sortedLastIndexBy: H7, sortedLastIndexOf: W7, sortedUniq: J7, sortedUniqBy: K7, split: G7, spread: Q7, startCase: X7, startsWith: Z7, stubArray: Hh, stubFalse: Lh, stubObject: Y7, stubString: t8, stubTrue: e8, subtract: n8, sum: r8, sumBy: i8, tail: o8, take: a8, takeRight: s8, takeRightWhile: u8, takeWhile: c8, tap: l8, template: d8, templateSettings: zf, throttle: Xg, thru: Fs, times: Zg, toArray: Fg, toFinite: ao, toInteger: ze, toIterator: lp, toJSON: Pa, toLength: Ag, toLower: p8, toNumber: ti, toPairs: Nf, toPairsIn: Rf, toPath: m8, toPlainObject: Sg, toSafeInteger: g8, toString: ln, toUpper: y8, transform: b8, trim: x8, trimEnd: j8, trimStart: S8, truncate: $8, unary: _8, unescape: O8, union: A8, unionBy: P8, unionWith: E8, uniq: M8, uniqBy: T8, uniqWith: I8, uniqueId: qs, unset: N8, unzip: od, unzipWith: Yg, update: D8, updateWith: L8, upperCase: z8, upperFirst: Vh, value: Pa, valueOf: Pa, values: as, valuesIn: B8, without: F8, words: cg, wrap: q8, wrapperAt: V8, wrapperChain: H8, wrapperCommit: ip, wrapperLodash: Q, wrapperNext: op, wrapperPlant: cp, wrapperReverse: W8, wrapperToIterator: lp, wrapperValue: Pa, xor: U8, xorBy: J8, xorWith: K8, zip: G8, zipObject: X8, zipObjectDeep: Z8, zipWith: Y8, default: Q });
var RF = [];
function fp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = {};
  if (!Array.isArray(e))
    throw new TypeError("Array expected");
  function r(u, c) {
    (!Array.isArray(u) && !mr(u) || t && c.length > 0) && (n[mt.exports.compileJSONPointer(c)] = !0), mr(u) && Object.keys(u).forEach(function(l) {
      r(u[l], c.concat(l));
    });
  }
  for (var i = Math.min(e.length, 1e4), o = 0; o < i; o++) {
    var a = e[o];
    r(a, RF);
  }
  var s = Object.keys(n).sort();
  return s.map(mt.exports.parseJSONPointer);
}
function tA(e, t, n) {
  if (!(t <= e))
    for (var r = e; r < t; r++)
      n(r);
}
function Vx(e, t) {
  return e.length > t ? e.slice(0, t) : e;
}
function Hx(e) {
  return Ct({}, e);
}
function Wx(e) {
  return Object.values(e);
}
function Ux(e, t, n, r) {
  var i = e.slice(0), o = i.splice(t, n);
  return i.splice.apply(i, [t + r, 0].concat(Pe(o))), i;
}
function nr(e) {
  return parseInt(e, 10);
}
function Rr(e) {
  return mr(e);
}
function yr(e) {
  return Array.isArray(e);
}
function e0(e) {
  try {
    return JSON.parse(e);
  } catch {
    return JSON.parse(Zo(e));
  }
}
function eA(e) {
  try {
    return e0(e);
  } catch {
    return;
  }
}
function n0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : JSON.parse;
  e = e.replace(nA, "");
  try {
    return t(e);
  } catch {
  }
  try {
    return t("[" + e + "]");
  } catch {
  }
  try {
    return t("{" + e + "}");
  } catch {
  }
  throw new Error("Failed to parse partial JSON");
}
function DF(e) {
  e = e.replace(nA, "");
  try {
    return Zo(e);
  } catch {
  }
  try {
    var t = Zo("[" + e + "]");
    return t.substring(1, t.length - 1);
  } catch {
  }
  try {
    var n = Zo("{" + e + "}");
    return n.substring(1, n.length - 1);
  } catch {
  }
  throw new Error("Failed to repair partial JSON");
}
var nA = /,\s*$/;
function rA(e, t) {
  var n = Kx.exec(t);
  if (n) {
    var r = nr(n[2]), i = function(h, d) {
      for (var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : h.length, m = 0, g = p; g < v; g++)
        h.charAt(g) === d && m++;
      return m;
    }(e, `
`, 0, r), o = r - e.lastIndexOf(`
`, r) - 1;
    return { position: r, line: i, column: o, message: t.replace(Kx, function() {
      return "line ".concat(i + 1, " column ").concat(o + 1);
    }) };
  }
  var a = zF.exec(t), s = a ? nr(a[1]) : null, u = s !== null ? s - 1 : null, c = BF.exec(t), l = c ? nr(c[1]) : null, f = l !== null ? l - 1 : null;
  return { position: u !== null && f !== null ? function(h, d, p) {
    for (var v = h.indexOf(`
`), m = 1; m < d && v !== -1; )
      v = h.indexOf(`
`, v + 1), m++;
    return v !== -1 ? v + p + 1 : null;
  }(e, u, f) : null, line: u, column: f, message: t.replace(/^JSON.parse: /, "").replace(/ of the JSON data$/, "") };
}
function Bd(e) {
  return mr(e) ? e.json !== void 0 ? e.text !== void 0 ? 'Content must contain either a property "json" or a property "text" but not both' : null : e.text === void 0 ? 'Content must contain either a property "json" or a property "text"' : typeof e.text != "string" ? 'Content "text" property must be string' : null : "Content must be an object";
}
function hp(e) {
  return typeof e.text == "string";
}
function Jx(e, t) {
  return LF(e, t) > t;
}
function LF(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1 / 0;
  if (hp(e))
    return e.text.length;
  var n = e.json, r = 0;
  function i(o) {
    if (Array.isArray(o)) {
      if ((r += o.length - 1 + 2) > t)
        return r;
      for (var a = 0; a < o.length; a++)
        if (i(o[a]), r > t)
          return r;
    } else if (mr(o)) {
      var s = Object.keys(o);
      r += 2 + s.length + (s.length - 1);
      for (var u = 0; u < s.length; u++) {
        var c = s[u], l = o[c];
        r += c.length + 2, i(l);
      }
    } else
      r += typeof o == "string" ? o.length + 2 : String(o).length;
  }
  return i(n), r;
}
var ci, gn, Oi, Ni, Kx = /(position|char) (\d+)/, zF = /line (\d+)/, BF = /column (\d+)/;
function iA(e) {
  var t = e.escapeControlCharacters, n = e.escapeUnicodeCharacters;
  return t ? n ? FF : qF : n ? VF : HF;
}
(function(e) {
  e.text = "text", e.tree = "tree";
})(ci || (ci = {})), function(e) {
  e.after = "after", e.inside = "inside", e.key = "key", e.value = "value", e.multi = "multi";
}(gn || (gn = {})), function(e) {
  e.after = "after", e.key = "key", e.value = "value", e.inside = "inside";
}(Oi || (Oi = {})), function(e) {
  e.key = "key", e.value = "value";
}(Ni || (Ni = {}));
var FF = { escapeValue: function(e) {
  return oA(sA(String(e)));
}, unescapeValue: function(e) {
  return uA(aA(e));
} }, qF = { escapeValue: function(e) {
  return sA(String(e));
}, unescapeValue: function(e) {
  return uA(e);
} }, VF = { escapeValue: function(e) {
  return oA(String(e));
}, unescapeValue: function(e) {
  return aA(e);
} }, HF = { escapeValue: function(e) {
  return String(e);
}, unescapeValue: function(e) {
  return e;
} };
function oA(e) {
  return e.replace(/[^\x20-\x7F]/g, function(t) {
    return t === "\b" || t === "\f" || t === `
` || t === "\r" || t === "	" ? t : "\\u" + ("000" + t.codePointAt(0).toString(16)).slice(-4);
  });
}
function aA(e) {
  return e.replace(/\\u[a-fA-F0-9]{4}/g, function(t) {
    try {
      return JSON.parse('"' + t + '"');
    } catch {
      return t;
    }
  });
}
var WF = { "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t" }, UF = { "\\b": "\b", "\\f": "\f", "\\n": `
`, "\\r": "\r", "\\t": "	" };
function sA(e) {
  return e.replace(/[\b\f\n\r\t]/g, function(t) {
    return WF[t] || t;
  });
}
function uA(e) {
  return e.replace(/\\[bfnrt]/g, function(t) {
    return UF[t] || t;
  });
}
function Va(e) {
  return typeof e != "string" ? String(e) : e.endsWith(`
`) ? e + `
` : e;
}
function cA(e, t) {
  return Kc(e, function(n) {
    return n.nodeName.toUpperCase() === t.toUpperCase();
  });
}
function Ea(e, t, n) {
  return Kc(e, function(r) {
    return function(i, o, a) {
      return typeof i.getAttribute == "function" && i.getAttribute(o) === a;
    }(r, t, n);
  });
}
function Kc(e, t) {
  return !!r0(e, t);
}
function r0(e, t) {
  for (var n = e; n && !t(n); )
    n = n.parentNode;
  return n || void 0;
}
function lA(e) {
  if (e.firstChild != null) {
    var t = document.createRange(), n = window.getSelection();
    t.setStart(e, 1), t.collapse(!0), n.removeAllRanges(), n.addRange(t);
  } else
    e.focus();
}
function cc(e) {
  return e && e.ownerDocument && e.ownerDocument.defaultView;
}
function dp(e) {
  return Kc(cc(e).document.activeElement, function(t) {
    return t === e;
  });
}
function JF(e, t) {
  return r0(e, function(n) {
    return n.nodeName === t;
  });
}
function Fd(e) {
  return Ea(e, "data-type", "selectable-key") ? gn.key : Ea(e, "data-type", "selectable-value") ? gn.value : Ea(e, "data-type", "insert-selection-area-inside") ? gn.inside : Ea(e, "data-type", "insert-selection-area-after") ? gn.after : gn.multi;
}
function vp(e) {
  return encodeURIComponent(mt.exports.compileJSONPointer(e));
}
function KF(e) {
  var t, n = r0(e, function(r) {
    return r.hasAttribute("data-path");
  });
  return n ? (t = n.getAttribute("data-path"), mt.exports.parseJSONPointer(decodeURIComponent(t))) : null;
}
function GF(e) {
  var t = e.allElements, n = e.currentElement, r = e.direction, i = e.hasPrio, o = i === void 0 ? function() {
    return !0;
  } : i, a = e.margin, s = a === void 0 ? 10 : a, u = hu(t.filter(function(g) {
    var y = g.getBoundingClientRect();
    return y.width > 0 && y.height > 0;
  }), l), c = l(n);
  function l(g) {
    var y = g.getBoundingClientRect();
    return { x: y.left + y.width / 2, y: y.top + y.height / 2, rect: y, element: g };
  }
  function f(g, y) {
    var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, k = g.x - y.x, w = (g.y - y.y) * b;
    return Math.sqrt(k * k + w * w);
  }
  var h = function(g) {
    return f(g, c);
  };
  if (r === "Left" || r === "Right") {
    var d = r === "Left" ? u.filter(function(g) {
      return y = c, g.rect.left + s < y.rect.left;
      var y;
    }) : u.filter(function(g) {
      return y = c, g.rect.right > y.rect.right + s;
      var y;
    }), p = xs(d.filter(function(g) {
      return y = g, b = c, Math.abs(y.y - b.y) < s;
      var y, b;
    }), h) || xs(d, function(g) {
      return f(g, c, 10);
    });
    return p == null ? void 0 : p.element;
  }
  if (r === "Up" || r === "Down") {
    var v = r === "Up" ? u.filter(function(g) {
      return y = c, g.y + s < y.y;
      var y;
    }) : u.filter(function(g) {
      return y = c, g.y > y.y + s;
      var y;
    }), m = xs(v.filter(function(g) {
      return o(g.element);
    }), h) || xs(v, h);
    return m == null ? void 0 : m.element;
  }
}
var fA = typeof navigator < "u" && navigator.platform.toUpperCase().indexOf("MAC") >= 0;
function vu(e) {
  var t = [];
  e.ctrlKey && t.push("Ctrl"), e.metaKey && t.push("Command"), e.altKey && t.push(fA ? "Option" : "Alt"), e.shiftKey && t.push("Shift");
  var n = function(r) {
    return XF[r] || "";
  }(e.which);
  return QF[n] || t.push(n), t.join("+");
}
var QF = { Ctrl: !0, Command: !0, Alt: !0, Option: !0, Shift: !0 }, XF = { 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt", 19: "Pause_Break", 20: "Caps_Lock", 27: "Escape", 33: "Page_Up", 34: "Page_Down", 35: "End", 36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 45: "Insert", 46: "Delete", 48: "0", 49: "1", 50: "2", 51: "3", 52: "4", 53: "5", 54: "6", 55: "7", 56: "8", 57: "9", 65: "A", 66: "B", 67: "C", 68: "D", 69: "E", 70: "F", 71: "G", 72: "H", 73: "I", 74: "J", 75: "K", 76: "L", 77: "M", 78: "N", 79: "O", 80: "P", 81: "Q", 82: "R", 83: "S", 84: "T", 85: "U", 86: "V", 87: "W", 88: "X", 89: "Y", 90: "Z", 91: "Left_Window_Key", 92: "Right_Window_Key", 93: "Select_Key", 96: "Numpad_0", 97: "Numpad_1", 98: "Numpad_2", 99: "Numpad_3", 100: "Numpad_4", 101: "Numpad_5", 102: "Numpad_6", 103: "Numpad_7", 104: "Numpad_8", 105: "Numpad_9", 106: "Numpad_*", 107: "Numpad_+", 109: "Numpad_-", 110: "Numpad_.", 111: "Numpad_/", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "Num_Lock", 145: "Scroll_Lock", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'" }, qd = Vm.window;
function ZF(e) {
  Te(e, "svelte-p9zniz", ".jse-absolute-popup.svelte-p9zniz.svelte-p9zniz{position:relative;left:0;top:0;width:0;height:0;z-index:1001}.jse-absolute-popup.svelte-p9zniz .jse-hidden-input.svelte-p9zniz{position:absolute;left:0;top:0;width:0;height:0;padding:0;margin:0;border:none;outline:none;overflow:hidden}.jse-absolute-popup.svelte-p9zniz .jse-absolute-popup-content.svelte-p9zniz{position:absolute}");
}
function Gx(e) {
  var t, n, r, i, o, a, s = [e[0].props], u = e[0].component;
  function c(l) {
    for (var f = {}, h = 0; h < s.length; h += 1)
      f = da(f, s[h]);
    return { props: f };
  }
  return u && (i = new u(c())), { c: function() {
    t = rt("div"), n = rt("input"), r = bt(), i && Pt(i.$$.fragment), A(n, "class", "jse-hidden-input svelte-p9zniz"), A(t, "class", "jse-absolute-popup-content svelte-p9zniz"), A(t, "style", o = Qx(e[1], e[0].options));
  }, m: function(l, f) {
    pt(l, t, f), W(t, n), e[7](n), W(t, r), i && Ot(i, t, null), a = !0;
  }, p: function(l, f) {
    var h = 1 & f ? ts(s, [Mh(l[0].props)]) : {};
    if (u !== (u = l[0].component)) {
      if (i) {
        qt();
        var d = i;
        tt(d.$$.fragment, 1, 0, function() {
          At(d, 1);
        }), Vt();
      }
      u ? (Pt((i = new u(c())).$$.fragment), U(i.$$.fragment, 1), Ot(i, t, null)) : i = null;
    } else
      u && i.$set(h);
    (!a || 3 & f && o !== (o = Qx(l[1], l[0].options))) && A(t, "style", o);
  }, i: function(l) {
    a || (i && U(i.$$.fragment, l), a = !0);
  }, o: function(l) {
    i && tt(i.$$.fragment, l), a = !1;
  }, d: function(l) {
    l && vt(t), e[7](null), i && At(i);
  } };
}
function YF(e) {
  var t, n, r, i, o = e[1] && Gx(e);
  return { c: function() {
    t = rt("div"), o && o.c(), A(t, "class", "jse-absolute-popup svelte-p9zniz");
  }, m: function(a, s) {
    pt(a, t, s), o && o.m(t, null), e[8](t), n = !0, r || (i = [Nt(qd, "mousedown", e[3], !0), Nt(qd, "keydown", e[4], !0), Nt(qd, "wheel", e[5], !0), Nt(t, "mousedown", tq), Nt(t, "keydown", e[4])], r = !0);
  }, p: function(a, s) {
    var u = xe(s, 1)[0];
    a[1] ? o ? (o.p(a, u), 2 & u && U(o, 1)) : ((o = Gx(a)).c(), U(o, 1), o.m(t, null)) : o && (qt(), tt(o, 1, 1, function() {
      o = null;
    }), Vt());
  }, i: function(a) {
    n || (U(o), n = !0);
  }, o: function(a) {
    tt(o), n = !1;
  }, d: function(a) {
    a && vt(t), o && o.d(), e[8](null), r = !1, Dn(i);
  } };
}
function tq(e) {
  e.stopPropagation();
}
function Qx(e, t) {
  var n = e.getBoundingClientRect(), r = function() {
    if (t.anchor) {
      var u = t.anchor, c = t.width, l = c === void 0 ? 0 : c, f = t.height, h = f === void 0 ? 0 : f, d = t.offsetTop, p = d === void 0 ? 0 : d, v = t.offsetLeft, m = v === void 0 ? 0 : v, g = t.position, y = u.getBoundingClientRect(), b = y.left, k = y.top, w = y.bottom, x = y.right, S = g === "top" || k + h > window.innerHeight && k > h, T = g === "left" || b + l > window.innerWidth && b > l;
      return { left: T ? x - m : b + m, top: S ? k - p : w + p, positionAbove: S, positionLeft: T };
    }
    if (typeof t.left == "number" && typeof t.top == "number") {
      var P = t.left, O = t.top, j = t.width, V = j === void 0 ? 0 : j, E = t.height, C = E === void 0 ? 0 : E;
      return { left: P, top: O, positionAbove: O + C > window.innerHeight && O > C, positionLeft: P + V > window.innerWidth && P > V };
    }
    throw new Error('Invalid config: pass either "left" and "top", or pass "anchor"');
  }(), i = r.left, o = r.top, a = r.positionAbove, s = r.positionLeft;
  return (a ? "bottom: ".concat(n.top - o, "px;") : "top: ".concat(o - n.top, "px;")) + (s ? "right: ".concat(n.left - i, "px;") : "left: ".concat(i - n.left, "px;"));
}
function eq(e, t, n) {
  var r, i, o = t.popup, a = t.closeAbsolutePopup;
  function s(u) {
    o.options && o.options.closeOnOuterClick && !Kc(u.target, function(c) {
      return c === r;
    }) && a(o.id);
  }
  return yi(function() {
    i && i.focus();
  }), e.$$set = function(u) {
    "popup" in u && n(0, o = u.popup), "closeAbsolutePopup" in u && n(6, a = u.closeAbsolutePopup);
  }, [o, r, i, function(u) {
    s(u);
  }, function(u) {
    vu(u) === "Escape" && a(o.id);
  }, function(u) {
    s(u);
  }, a, function(u) {
    Be[u ? "unshift" : "push"](function() {
      n(2, i = u);
    });
  }, function(u) {
    Be[u ? "unshift" : "push"](function() {
      n(1, r = u);
    });
  }];
}
var nq = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, eq, YF, ir, { popup: 0, closeAbsolutePopup: 6 }, ZF), i;
  }
  return Y(n);
}();
function Xx(e, t, n) {
  var r = e.slice();
  return r[6] = t[n], r;
}
function Zx(e) {
  var t, n;
  return t = new nq({ props: { popup: e[6], closeAbsolutePopup: e[1] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.popup = r[6]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function rq(e) {
  for (var t, n, r = e[0], i = [], o = 0; o < r.length; o += 1)
    i[o] = Zx(Xx(e, r, o));
  var a = function(c) {
    return tt(i[c], 1, 1, function() {
      i[c] = null;
    });
  }, s = e[3].default, u = Di(s, e, e[2], null);
  return { c: function() {
    for (var c = 0; c < i.length; c += 1)
      i[c].c();
    t = bt(), u && u.c();
  }, m: function(c, l) {
    for (var f = 0; f < i.length; f += 1)
      i[f].m(c, l);
    pt(c, t, l), u && u.m(c, l), n = !0;
  }, p: function(c, l) {
    var f = xe(l, 1)[0];
    if (3 & f) {
      var h;
      for (r = c[0], h = 0; h < r.length; h += 1) {
        var d = Xx(c, r, h);
        i[h] ? (i[h].p(d, f), U(i[h], 1)) : (i[h] = Zx(d), i[h].c(), U(i[h], 1), i[h].m(t.parentNode, t));
      }
      for (qt(), h = r.length; h < i.length; h += 1)
        a(h);
      Vt();
    }
    u && u.p && (!n || 4 & f) && zi(u, s, c, c[2], n ? Li(s, c[2], f, null) : Bi(c[2]), null);
  }, i: function(c) {
    if (!n) {
      for (var l = 0; l < r.length; l += 1)
        U(i[l]);
      U(u, c), n = !0;
    }
  }, o: function(c) {
    i = i.filter(Boolean);
    for (var l = 0; l < i.length; l += 1)
      tt(i[l]);
    tt(u, c), n = !1;
  }, d: function(c) {
    Ar(i, c), c && vt(t), u && u.d(c);
  } };
}
function iq(e, t, n) {
  var r = t.$$slots, i = r === void 0 ? {} : r, o = t.$$scope, a = Ur("jsoneditor:AbsolutePopup"), s = [];
  function u(c) {
    var l = s.findIndex(function(h) {
      return h.id === c;
    });
    if (l !== -1) {
      var f = s[l];
      f.options.onClose && f.options.onClose(), n(0, s = s.filter(function(h) {
        return h.id !== c;
      }));
    }
  }
  return xC("absolute-popup", { openAbsolutePopup: function(c, l, f) {
    a("open...", l, f);
    var h = { id: Cf(), component: c, props: l || {}, options: f || {} };
    return n(0, s = [].concat(Pe(s), [h])), h.id;
  }, closeAbsolutePopup: u }), e.$$set = function(c) {
    "$$scope" in c && n(2, o = c.$$scope);
  }, e.$$.update = function() {
    1 & e.$$.dirty && a("popups", s);
  }, [s, u, o, i];
}
var hA = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, iq, rq, Ue, {}), i;
  }
  return Y(n);
}(), oq = { prefix: "fas", iconName: "angle-down", icon: [384, 512, [8964], "f107", "M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"] }, dA = { prefix: "fas", iconName: "angle-right", icon: [256, 512, [8250], "f105", "M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"] }, aq = { prefix: "fas", iconName: "arrow-down", icon: [384, 512, [8595], "f063", "M374.6 310.6l-160 160C208.4 476.9 200.2 480 192 480s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 370.8V64c0-17.69 14.33-31.1 31.1-31.1S224 46.31 224 64v306.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0S387.1 298.1 374.6 310.6z"] }, i0 = { prefix: "fas", iconName: "arrow-down-short-wide", icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M320 224H416c17.67 0 32-14.33 32-32s-14.33-32-32-32h-95.1c-17.67 0-32 14.33-32 32S302.3 224 320 224zM320 352H480c17.67 0 32-14.33 32-32s-14.33-32-32-32h-159.1c-17.67 0-32 14.33-32 32S302.3 352 320 352zM320 96h32c17.67 0 31.1-14.33 31.1-32s-14.33-32-31.1-32h-32c-17.67 0-32 14.33-32 32S302.3 96 320 96zM544 416h-223.1c-17.67 0-32 14.33-32 32s14.33 32 32 32H544c17.67 0 32-14.33 32-32S561.7 416 544 416zM192.4 330.7L160 366.1V64.03C160 46.33 145.7 32 128 32S96 46.33 96 64.03v302L63.6 330.7c-6.312-6.883-14.94-10.38-23.61-10.38c-7.719 0-15.47 2.781-21.61 8.414c-13.03 11.95-13.9 32.22-1.969 45.27l87.1 96.09c12.12 13.26 35.06 13.26 47.19 0l87.1-96.09c11.94-13.05 11.06-33.31-1.969-45.27C224.6 316.8 204.4 317.7 192.4 330.7z"] }, vA = { prefix: "fas", iconName: "arrow-rotate-left", icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M480 256c0 123.4-100.5 223.9-223.9 223.9c-48.86 0-95.19-15.58-134.2-44.86c-14.14-10.59-17-30.66-6.391-44.81c10.61-14.09 30.69-16.97 44.8-6.375c27.84 20.91 61 31.94 95.89 31.94C344.3 415.8 416 344.1 416 256s-71.67-159.8-159.8-159.8C205.9 96.22 158.6 120.3 128.6 160H192c17.67 0 32 14.31 32 32S209.7 224 192 224H48c-17.67 0-32-14.31-32-32V48c0-17.69 14.33-32 32-32s32 14.31 32 32v70.23C122.1 64.58 186.1 32.11 256.1 32.11C379.5 32.11 480 132.6 480 256z"] }, pA = { prefix: "fas", iconName: "arrow-rotate-right", icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M496 48V192c0 17.69-14.31 32-32 32H320c-17.69 0-32-14.31-32-32s14.31-32 32-32h63.39c-29.97-39.7-77.25-63.78-127.6-63.78C167.7 96.22 96 167.9 96 256s71.69 159.8 159.8 159.8c34.88 0 68.03-11.03 95.88-31.94c14.22-10.53 34.22-7.75 44.81 6.375c10.59 14.16 7.75 34.22-6.375 44.81c-39.03 29.28-85.36 44.86-134.2 44.86C132.5 479.9 32 379.4 32 256s100.5-223.9 223.9-223.9c69.15 0 134 32.47 176.1 86.12V48c0-17.69 14.31-32 32-32S496 30.31 496 48z"] }, no = { prefix: "fas", iconName: "caret-down", icon: [320, 512, [], "f0d7", "M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"] }, Qo = { prefix: "fas", iconName: "caret-right", icon: [256, 512, [], "f0da", "M118.6 105.4l128 127.1C252.9 239.6 256 247.8 256 255.1s-3.125 16.38-9.375 22.63l-128 127.1c-9.156 9.156-22.91 11.9-34.88 6.943S64 396.9 64 383.1V128c0-12.94 7.781-24.62 19.75-29.58S109.5 96.23 118.6 105.4z"] }, pp = { prefix: "fas", iconName: "check", icon: [448, 512, [10004, 10003], "f00c", "M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"] }, sq = { prefix: "fas", iconName: "chevron-down", icon: [448, 512, [], "f078", "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"] }, uq = { prefix: "fas", iconName: "chevron-up", icon: [448, 512, [], "f077", "M416 352c-8.188 0-16.38-3.125-22.62-9.375L224 173.3l-169.4 169.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25C432.4 348.9 424.2 352 416 352z"] }, cq = { prefix: "fas", iconName: "circle-notch", icon: [512, 512, [], "f1ce", "M222.7 32.15C227.7 49.08 218.1 66.9 201.1 71.94C121.8 95.55 64 169.1 64 255.1C64 362 149.1 447.1 256 447.1C362 447.1 448 362 448 255.1C448 169.1 390.2 95.55 310.9 71.94C293.9 66.9 284.3 49.08 289.3 32.15C294.4 15.21 312.2 5.562 329.1 10.6C434.9 42.07 512 139.1 512 255.1C512 397.4 397.4 511.1 256 511.1C114.6 511.1 0 397.4 0 255.1C0 139.1 77.15 42.07 182.9 10.6C199.8 5.562 217.6 15.21 222.7 32.15V32.15z"] }, lq = { prefix: "fas", iconName: "clone", icon: [512, 512, [], "f24d", "M0 224C0 188.7 28.65 160 64 160H128V288C128 341 170.1 384 224 384H352V448C352 483.3 323.3 512 288 512H64C28.65 512 0 483.3 0 448V224zM224 352C188.7 352 160 323.3 160 288V64C160 28.65 188.7 0 224 0H448C483.3 0 512 28.65 512 64V288C512 323.3 483.3 352 448 352H224z"] }, Bf = { prefix: "fas", iconName: "code", icon: [640, 512, [], "f121", "M414.8 40.79L286.8 488.8C281.9 505.8 264.2 515.6 247.2 510.8C230.2 505.9 220.4 488.2 225.2 471.2L353.2 23.21C358.1 6.216 375.8-3.624 392.8 1.232C409.8 6.087 419.6 23.8 414.8 40.79H414.8zM518.6 121.4L630.6 233.4C643.1 245.9 643.1 266.1 630.6 278.6L518.6 390.6C506.1 403.1 485.9 403.1 473.4 390.6C460.9 378.1 460.9 357.9 473.4 345.4L562.7 256L473.4 166.6C460.9 154.1 460.9 133.9 473.4 121.4C485.9 108.9 506.1 108.9 518.6 121.4V121.4zM166.6 166.6L77.25 256L166.6 345.4C179.1 357.9 179.1 378.1 166.6 390.6C154.1 403.1 133.9 403.1 121.4 390.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4L121.4 121.4C133.9 108.9 154.1 108.9 166.6 121.4C179.1 133.9 179.1 154.1 166.6 166.6V166.6z"] }, Ff = { prefix: "fas", iconName: "copy", icon: [512, 512, [], "f0c5", "M384 96L384 0h-112c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48H464c26.51 0 48-21.49 48-48V128h-95.1C398.4 128 384 113.6 384 96zM416 0v96h96L416 0zM192 352V128h-144c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h192c26.51 0 48-21.49 48-48L288 416h-32C220.7 416 192 387.3 192 352z"] }, fq = { prefix: "fas", iconName: "crop-simple", icon: [512, 512, ["crop-alt"], "f565", "M128 384H352V448H128C92.65 448 64 419.3 64 384V128H32C14.33 128 0 113.7 0 96C0 78.33 14.33 64 32 64H64V32C64 14.33 78.33 0 96 0C113.7 0 128 14.33 128 32V384zM384 128H160V64H384C419.3 64 448 92.65 448 128V384H480C497.7 384 512 398.3 512 416C512 433.7 497.7 448 480 448H448V480C448 497.7 433.7 512 416 512C398.3 512 384 497.7 384 480V128z"] }, hq = { prefix: "fas", iconName: "ellipsis-vertical", icon: [128, 512, ["ellipsis-v"], "f142", "M64 360C94.93 360 120 385.1 120 416C120 446.9 94.93 472 64 472C33.07 472 8 446.9 8 416C8 385.1 33.07 360 64 360zM64 200C94.93 200 120 225.1 120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200zM64 152C33.07 152 8 126.9 8 96C8 65.07 33.07 40 64 40C94.93 40 120 65.07 120 96C120 126.9 94.93 152 64 152z"] }, o0 = { prefix: "fas", iconName: "filter", icon: [512, 512, [], "f0b0", "M3.853 54.87C10.47 40.9 24.54 32 40 32H472C487.5 32 501.5 40.9 508.1 54.87C514.8 68.84 512.7 85.37 502.1 97.33L320 320.9V448C320 460.1 313.2 471.2 302.3 476.6C291.5 482 278.5 480.9 268.8 473.6L204.8 425.6C196.7 419.6 192 410.1 192 400V320.9L9.042 97.33C-.745 85.37-2.765 68.84 3.854 54.87L3.853 54.87z"] }, dq = { prefix: "fas", iconName: "gear", icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6C499.2 175.2 496.4 184.9 489.6 191.2L446.3 230.6C447.4 238.9 448 247.4 448 256C448 264.6 447.4 273.1 446.3 281.4L489.6 320.8C496.4 327.1 499.2 336.8 495.9 345.4C491.5 357.3 486.2 368.8 480.2 379.7L475.5 387.8C468.9 398.8 461.5 409.2 453.4 419.1C447.4 426.2 437.7 428.7 428.9 425.9L373.2 408.1C359.8 418.4 344.1 427 329.2 433.6L316.7 490.7C314.7 499.7 307.7 506.1 298.5 508.5C284.7 510.8 270.5 512 255.1 512C241.5 512 227.3 510.8 213.5 508.5C204.3 506.1 197.3 499.7 195.3 490.7L182.8 433.6C167 427 152.2 418.4 138.8 408.1L83.14 425.9C74.3 428.7 64.55 426.2 58.63 419.1C50.52 409.2 43.12 398.8 36.52 387.8L31.84 379.7C25.77 368.8 20.49 357.3 16.06 345.4C12.82 336.8 15.55 327.1 22.41 320.8L65.67 281.4C64.57 273.1 64 264.6 64 256C64 247.4 64.57 238.9 65.67 230.6L22.41 191.2C15.55 184.9 12.82 175.3 16.06 166.6C20.49 154.7 25.78 143.2 31.84 132.3L36.51 124.2C43.12 113.2 50.52 102.8 58.63 92.95C64.55 85.8 74.3 83.32 83.14 86.14L138.8 103.9C152.2 93.56 167 84.96 182.8 78.43L195.3 21.33C197.3 12.25 204.3 5.04 213.5 3.51C227.3 1.201 241.5 0 256 0C270.5 0 284.7 1.201 298.5 3.51C307.7 5.04 314.7 12.25 316.7 21.33L329.2 78.43C344.1 84.96 359.8 93.56 373.2 103.9L428.9 86.14C437.7 83.32 447.4 85.8 453.4 92.95C461.5 102.8 468.9 113.2 475.5 124.2L480.2 132.3C486.2 143.2 491.5 154.7 495.9 166.6V166.6zM256 336C300.2 336 336 300.2 336 255.1C336 211.8 300.2 175.1 256 175.1C211.8 175.1 176 211.8 176 255.1C176 300.2 211.8 336 256 336z"] }, a0 = { prefix: "fas", iconName: "magnifying-glass", icon: [512, 512, [128269, "search"], "f002", "M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"] }, vq = { prefix: "fas", iconName: "paste", icon: [512, 512, ["file-clipboard"], "f0ea", "M320 96V80C320 53.49 298.5 32 272 32H215.4C204.3 12.89 183.6 0 160 0S115.7 12.89 104.6 32H48C21.49 32 0 53.49 0 80v320C0 426.5 21.49 448 48 448l144 .0013L192 176C192 131.8 227.8 96 272 96H320zM160 88C146.8 88 136 77.25 136 64S146.8 40 160 40S184 50.75 184 64S173.3 88 160 88zM416 128v96h96L416 128zM384 224L384 128h-112C245.5 128 224 149.5 224 176v288c0 26.51 21.49 48 48 48h192c26.51 0 48-21.49 48-48V256h-95.99C398.4 256 384 241.6 384 224z"] }, s0 = { prefix: "fas", iconName: "pen", icon: [512, 512, [128394], "f304", "M362.7 19.32C387.7-5.678 428.3-5.678 453.3 19.32L492.7 58.75C517.7 83.74 517.7 124.3 492.7 149.3L444.3 197.7L314.3 67.72L362.7 19.32zM421.7 220.3L188.5 453.4C178.1 463.8 165.2 471.5 151.1 475.6L30.77 511C22.35 513.5 13.24 511.2 7.03 504.1C.8198 498.8-1.502 489.7 .976 481.2L36.37 360.9C40.53 346.8 48.16 333.9 58.57 323.5L291.7 90.34L421.7 220.3z"] }, mp = { prefix: "fas", iconName: "scissors", icon: [512, 512, [9986, 9988, 9984, "cut"], "f0c4", "M396.8 51.2C425.1 22.92 470.9 22.92 499.2 51.2C506.3 58.27 506.3 69.73 499.2 76.8L216.5 359.5C221.3 372.1 224 385.7 224 400C224 461.9 173.9 512 112 512C50.14 512 0 461.9 0 400C0 338.1 50.14 287.1 112 287.1C126.3 287.1 139.9 290.7 152.5 295.5L191.1 255.1L152.5 216.5C139.9 221.3 126.3 224 112 224C50.14 224 0 173.9 0 112C0 50.14 50.14 0 112 0C173.9 0 224 50.14 224 112C224 126.3 221.3 139.9 216.5 152.5L255.1 191.1L396.8 51.2zM160 111.1C160 85.49 138.5 63.1 112 63.1C85.49 63.1 64 85.49 64 111.1C64 138.5 85.49 159.1 112 159.1C138.5 159.1 160 138.5 160 111.1zM112 448C138.5 448 160 426.5 160 400C160 373.5 138.5 352 112 352C85.49 352 64 373.5 64 400C64 426.5 85.49 448 112 448zM278.6 342.6L342.6 278.6L499.2 435.2C506.3 442.3 506.3 453.7 499.2 460.8C470.9 489.1 425.1 489.1 396.8 460.8L278.6 342.6z"] }, pq = { prefix: "fas", iconName: "square-caret-down", icon: [448, 512, ["caret-square-down"], "f150", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.65 419.3 32 384 32zM345.6 232.3l-104 112C237 349.2 230.7 352 224 352s-13.03-2.781-17.59-7.656l-104-112c-6.5-7-8.219-17.19-4.407-25.94C101.8 197.7 110.5 192 120 192h208c9.531 0 18.19 5.656 21.1 14.41C353.8 215.2 352.1 225.3 345.6 232.3z"] }, mq = { prefix: "fas", iconName: "square-caret-up", icon: [448, 512, ["caret-square-up"], "f151", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.65 419.3 32 384 32zM349.1 305.6C346.2 314.3 337.5 320 328 320h-208c-9.531 0-18.19-5.656-22-14.41C94.19 296.8 95.91 286.7 102.4 279.7l104-112c9.125-9.75 26.06-9.75 35.19 0l104 112C352.1 286.7 353.8 296.8 349.1 305.6z"] }, pu = { prefix: "fas", iconName: "triangle-exclamation", icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"] }, u0 = { prefix: "fas", iconName: "wrench", icon: [512, 512, [128295], "f0ad", "M507.6 122.8c-2.904-12.09-18.25-16.13-27.04-7.338l-76.55 76.56l-83.1-.0002l0-83.1l76.55-76.56c8.791-8.789 4.75-24.14-7.336-27.04c-23.69-5.693-49.34-6.111-75.92 .2484c-61.45 14.7-109.4 66.9-119.2 129.3C189.8 160.8 192.3 186.7 200.1 210.1l-178.1 178.1c-28.12 28.12-28.12 73.69 0 101.8C35.16 504.1 53.56 512 71.1 512s36.84-7.031 50.91-21.09l178.1-178.1c23.46 7.736 49.31 10.24 76.17 6.004c62.41-9.84 114.6-57.8 129.3-119.2C513.7 172.1 513.3 146.5 507.6 122.8zM80 456c-13.25 0-24-10.75-24-24c0-13.26 10.75-24 24-24s24 10.74 24 24C104 445.3 93.25 456 80 456z"] }, Gc = { prefix: "fas", iconName: "xmark", icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"] };
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function wl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
  if (e < 0.9 * t)
    return e.toFixed() + " B";
  var n = e / t;
  if (n < 0.9 * t)
    return n.toFixed(1) + " KB";
  var r = n / t;
  if (r < 0.9 * t)
    return r.toFixed(1) + " MB";
  var i = r / t;
  if (i < 0.9 * t)
    return i.toFixed(1) + " GB";
  var o = i / t;
  return o.toFixed(1) + " TB";
}
var xl = Ur("jsoneditor:FocusTracker");
function mA(e) {
  var t, n = e.onMount, r = e.onDestroy, i = e.getWindow, o = e.hasFocus, a = e.onFocus, s = e.onBlur, u = !1;
  function c() {
    var f = o();
    f && (clearTimeout(t), u || (xl("focus"), a(), u = f));
  }
  function l() {
    u && (clearTimeout(t), t = setTimeout(function() {
      xl("blur"), u = !1, s();
    }));
  }
  n(function() {
    xl("mount FocusTracker");
    var f = i();
    f && (f.addEventListener("focusin", c, !0), f.addEventListener("focusout", l, !0));
  }), r(function() {
    xl("destroy FocusTracker");
    var f = i();
    f && (f.removeEventListener("focusin", c, !0), f.removeEventListener("focusout", l, !0));
  });
}
function gq(e) {
  for (var t, n, r = [{ id: n = "path-" + e[0] }, e[1]], i = {}, o = 0; o < r.length; o += 1)
    i = da(i, r[o]);
  return { c: function() {
    Sf(t = Co("path"), i);
  }, m: function(a, s) {
    pt(a, t, s);
  }, p: function(a, s) {
    var u = xe(s, 1)[0];
    Sf(t, i = ts(r, [1 & u && n !== (n = "path-" + a[0]) && { id: n }, 2 & u && a[1]]));
  }, i: Wt, o: Wt, d: function(a) {
    a && vt(t);
  } };
}
function yq(e, t, n) {
  var r = t.id, i = t.data, o = i === void 0 ? {} : i;
  return e.$$set = function(a) {
    "id" in a && n(0, r = a.id), "data" in a && n(1, o = a.data);
  }, [r, o];
}
var bq = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, yq, gq, ir, { id: 0, data: 1 }), i;
  }
  return Y(n);
}();
function kq(e) {
  for (var t, n, r = [{ id: n = "polygon-" + e[0] }, e[1]], i = {}, o = 0; o < r.length; o += 1)
    i = da(i, r[o]);
  return { c: function() {
    Sf(t = Co("polygon"), i);
  }, m: function(a, s) {
    pt(a, t, s);
  }, p: function(a, s) {
    var u = xe(s, 1)[0];
    Sf(t, i = ts(r, [1 & u && n !== (n = "polygon-" + a[0]) && { id: n }, 2 & u && a[1]]));
  }, i: Wt, o: Wt, d: function(a) {
    a && vt(t);
  } };
}
function wq(e, t, n) {
  var r = t.id, i = t.data, o = i === void 0 ? {} : i;
  return e.$$set = function(a) {
    "id" in a && n(0, r = a.id), "data" in a && n(1, o = a.data);
  }, [r, o];
}
var xq = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, wq, kq, ir, { id: 0, data: 1 }), i;
  }
  return Y(n);
}();
function jq(e) {
  var t;
  return { c: function() {
    t = Co("g");
  }, m: function(n, r) {
    pt(n, t, r), t.innerHTML = e[0];
  }, p: function(n, r) {
    1 & xe(r, 1)[0] && (t.innerHTML = n[0]);
  }, i: Wt, o: Wt, d: function(n) {
    n && vt(t);
  } };
}
function Sq(e, t, n) {
  var r, i = 870711, o = t.data;
  function a(s) {
    if (!s || !s.raw)
      return null;
    var u = s.raw, c = {};
    return u = (u = u.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function(l, f) {
      var h = "fa-".concat((i += 1).toString(16));
      return c[f] = h, ' id="'.concat(h, '"');
    })).replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function(l, f, h, d) {
      var p = f || d;
      return p && c[p] ? "#".concat(c[p]) : l;
    });
  }
  return e.$$set = function(s) {
    "data" in s && n(1, o = s.data);
  }, e.$$.update = function() {
    2 & e.$$.dirty && n(0, r = a(o));
  }, [r, o];
}
var $q = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, Sq, jq, ir, { data: 1 }), i;
  }
  return Y(n);
}();
function _q(e) {
  Te(e, "svelte-1dof0an", ".fa-icon.svelte-1dof0an{display:inline-block;fill:currentColor}.fa-flip-horizontal.svelte-1dof0an{transform:scale(-1, 1)}.fa-flip-vertical.svelte-1dof0an{transform:scale(1, -1)}.fa-spin.svelte-1dof0an{animation:svelte-1dof0an-fa-spin 1s 0s infinite linear}.fa-inverse.svelte-1dof0an{color:#fff}.fa-pulse.svelte-1dof0an{animation:svelte-1dof0an-fa-spin 1s infinite steps(8)}@keyframes svelte-1dof0an-fa-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
}
function Cq(e) {
  var t, n, r, i, o = e[13].default, a = Di(o, e, e[12], null);
  return { c: function() {
    t = Co("svg"), a && a.c(), A(t, "version", "1.1"), A(t, "class", n = "fa-icon " + e[0] + " svelte-1dof0an"), A(t, "x", e[8]), A(t, "y", e[9]), A(t, "width", e[1]), A(t, "height", e[2]), A(t, "aria-label", e[11]), A(t, "role", r = e[11] ? "img" : "presentation"), A(t, "viewBox", e[3]), A(t, "style", e[10]), Ut(t, "fa-spin", e[4]), Ut(t, "fa-pulse", e[6]), Ut(t, "fa-inverse", e[5]), Ut(t, "fa-flip-horizontal", e[7] === "horizontal"), Ut(t, "fa-flip-vertical", e[7] === "vertical");
  }, m: function(s, u) {
    pt(s, t, u), a && a.m(t, null), i = !0;
  }, p: function(s, u) {
    var c = xe(u, 1)[0];
    a && a.p && (!i || 4096 & c) && zi(a, o, s, s[12], i ? Li(o, s[12], c, null) : Bi(s[12]), null), (!i || 1 & c && n !== (n = "fa-icon " + s[0] + " svelte-1dof0an")) && A(t, "class", n), (!i || 256 & c) && A(t, "x", s[8]), (!i || 512 & c) && A(t, "y", s[9]), (!i || 2 & c) && A(t, "width", s[1]), (!i || 4 & c) && A(t, "height", s[2]), (!i || 2048 & c) && A(t, "aria-label", s[11]), (!i || 2048 & c && r !== (r = s[11] ? "img" : "presentation")) && A(t, "role", r), (!i || 8 & c) && A(t, "viewBox", s[3]), (!i || 1024 & c) && A(t, "style", s[10]), 17 & c && Ut(t, "fa-spin", s[4]), 65 & c && Ut(t, "fa-pulse", s[6]), 33 & c && Ut(t, "fa-inverse", s[5]), 129 & c && Ut(t, "fa-flip-horizontal", s[7] === "horizontal"), 129 & c && Ut(t, "fa-flip-vertical", s[7] === "vertical");
  }, i: function(s) {
    i || (U(a, s), i = !0);
  }, o: function(s) {
    tt(a, s), i = !1;
  }, d: function(s) {
    s && vt(t), a && a.d(s);
  } };
}
function Oq(e, t, n) {
  var r = t.$$slots, i = r === void 0 ? {} : r, o = t.$$scope, a = t.class, s = t.width, u = t.height, c = t.box, l = t.spin, f = l !== void 0 && l, h = t.inverse, d = h !== void 0 && h, p = t.pulse, v = p !== void 0 && p, m = t.flip, g = m === void 0 ? null : m, y = t.x, b = y === void 0 ? void 0 : y, k = t.y, w = k === void 0 ? void 0 : k, x = t.style, S = x === void 0 ? void 0 : x, T = t.label, P = T === void 0 ? void 0 : T;
  return e.$$set = function(O) {
    "class" in O && n(0, a = O.class), "width" in O && n(1, s = O.width), "height" in O && n(2, u = O.height), "box" in O && n(3, c = O.box), "spin" in O && n(4, f = O.spin), "inverse" in O && n(5, d = O.inverse), "pulse" in O && n(6, v = O.pulse), "flip" in O && n(7, g = O.flip), "x" in O && n(8, b = O.x), "y" in O && n(9, w = O.y), "style" in O && n(10, S = O.style), "label" in O && n(11, P = O.label), "$$scope" in O && n(12, o = O.$$scope);
  }, [a, s, u, c, f, d, v, g, b, w, S, P, o, i];
}
var Aq = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, Oq, Cq, ir, { class: 0, width: 1, height: 2, box: 3, spin: 4, inverse: 5, pulse: 6, flip: 7, x: 8, y: 9, style: 10, label: 11 }, _q), i;
  }
  return Y(n);
}();
function Yx(e, t, n) {
  var r = e.slice();
  return r[24] = t[n], r[26] = n, r;
}
function tj(e, t, n) {
  var r = e.slice();
  return r[27] = t[n], r[26] = n, r;
}
function ej(e) {
  var t, n, r, i, o = e[6].paths && nj(e), a = e[6].polygons && ij(e), s = e[6].raw && aj(e);
  return { c: function() {
    o && o.c(), t = bt(), a && a.c(), n = bt(), s && s.c(), r = Ye();
  }, m: function(u, c) {
    o && o.m(u, c), pt(u, t, c), a && a.m(u, c), pt(u, n, c), s && s.m(u, c), pt(u, r, c), i = !0;
  }, p: function(u, c) {
    u[6].paths ? o ? (o.p(u, c), 64 & c && U(o, 1)) : ((o = nj(u)).c(), U(o, 1), o.m(t.parentNode, t)) : o && (qt(), tt(o, 1, 1, function() {
      o = null;
    }), Vt()), u[6].polygons ? a ? (a.p(u, c), 64 & c && U(a, 1)) : ((a = ij(u)).c(), U(a, 1), a.m(n.parentNode, n)) : a && (qt(), tt(a, 1, 1, function() {
      a = null;
    }), Vt()), u[6].raw ? s ? (s.p(u, c), 64 & c && U(s, 1)) : ((s = aj(u)).c(), U(s, 1), s.m(r.parentNode, r)) : s && (qt(), tt(s, 1, 1, function() {
      s = null;
    }), Vt());
  }, i: function(u) {
    i || (U(o), U(a), U(s), i = !0);
  }, o: function(u) {
    tt(o), tt(a), tt(s), i = !1;
  }, d: function(u) {
    o && o.d(u), u && vt(t), a && a.d(u), u && vt(n), s && s.d(u), u && vt(r);
  } };
}
function nj(e) {
  for (var t, n, r = e[6].paths, i = [], o = 0; o < r.length; o += 1)
    i[o] = rj(tj(e, r, o));
  var a = function(s) {
    return tt(i[s], 1, 1, function() {
      i[s] = null;
    });
  };
  return { c: function() {
    for (var s = 0; s < i.length; s += 1)
      i[s].c();
    t = Ye();
  }, m: function(s, u) {
    for (var c = 0; c < i.length; c += 1)
      i[c].m(s, u);
    pt(s, t, u), n = !0;
  }, p: function(s, u) {
    if (64 & u) {
      var c;
      for (r = s[6].paths, c = 0; c < r.length; c += 1) {
        var l = tj(s, r, c);
        i[c] ? (i[c].p(l, u), U(i[c], 1)) : (i[c] = rj(l), i[c].c(), U(i[c], 1), i[c].m(t.parentNode, t));
      }
      for (qt(), c = r.length; c < i.length; c += 1)
        a(c);
      Vt();
    }
  }, i: function(s) {
    if (!n) {
      for (var u = 0; u < r.length; u += 1)
        U(i[u]);
      n = !0;
    }
  }, o: function(s) {
    i = i.filter(Boolean);
    for (var u = 0; u < i.length; u += 1)
      tt(i[u]);
    n = !1;
  }, d: function(s) {
    Ar(i, s), s && vt(t);
  } };
}
function rj(e) {
  var t, n;
  return t = new bq({ props: { id: e[26], data: e[27] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    64 & i && (o.data = r[27]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function ij(e) {
  for (var t, n, r = e[6].polygons, i = [], o = 0; o < r.length; o += 1)
    i[o] = oj(Yx(e, r, o));
  var a = function(s) {
    return tt(i[s], 1, 1, function() {
      i[s] = null;
    });
  };
  return { c: function() {
    for (var s = 0; s < i.length; s += 1)
      i[s].c();
    t = Ye();
  }, m: function(s, u) {
    for (var c = 0; c < i.length; c += 1)
      i[c].m(s, u);
    pt(s, t, u), n = !0;
  }, p: function(s, u) {
    if (64 & u) {
      var c;
      for (r = s[6].polygons, c = 0; c < r.length; c += 1) {
        var l = Yx(s, r, c);
        i[c] ? (i[c].p(l, u), U(i[c], 1)) : (i[c] = oj(l), i[c].c(), U(i[c], 1), i[c].m(t.parentNode, t));
      }
      for (qt(), c = r.length; c < i.length; c += 1)
        a(c);
      Vt();
    }
  }, i: function(s) {
    if (!n) {
      for (var u = 0; u < r.length; u += 1)
        U(i[u]);
      n = !0;
    }
  }, o: function(s) {
    i = i.filter(Boolean);
    for (var u = 0; u < i.length; u += 1)
      tt(i[u]);
    n = !1;
  }, d: function(s) {
    Ar(i, s), s && vt(t);
  } };
}
function oj(e) {
  var t, n;
  return t = new xq({ props: { id: e[26], data: e[24] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    64 & i && (o.data = r[24]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function aj(e) {
  var t, n, r;
  function i(a) {
    e[15](a);
  }
  var o = {};
  return e[6] !== void 0 && (o.data = e[6]), t = new $q({ props: o }), Be.push(function() {
    return Kr(t, "data", i);
  }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(a, s) {
    Ot(t, a, s), r = !0;
  }, p: function(a, s) {
    var u = {};
    !n && 64 & s && (n = !0, u.data = a[6], di(function() {
      return n = !1;
    })), t.$set(u);
  }, i: function(a) {
    r || (U(t.$$.fragment, a), r = !0);
  }, o: function(a) {
    tt(t.$$.fragment, a), r = !1;
  }, d: function(a) {
    At(t, a);
  } };
}
function Pq(e) {
  var t, n = e[14].default, r = Di(n, e, e[16], null), i = r || function(o) {
    var a, s, u = o[6] && ej(o);
    return { c: function() {
      u && u.c(), a = Ye();
    }, m: function(c, l) {
      u && u.m(c, l), pt(c, a, l), s = !0;
    }, p: function(c, l) {
      c[6] ? u ? (u.p(c, l), 64 & l && U(u, 1)) : ((u = ej(c)).c(), U(u, 1), u.m(a.parentNode, a)) : u && (qt(), tt(u, 1, 1, function() {
        u = null;
      }), Vt());
    }, i: function(c) {
      s || (U(u), s = !0);
    }, o: function(c) {
      tt(u), s = !1;
    }, d: function(c) {
      u && u.d(c), c && vt(a);
    } };
  }(e);
  return { c: function() {
    i && i.c();
  }, m: function(o, a) {
    i && i.m(o, a), t = !0;
  }, p: function(o, a) {
    r ? r.p && (!t || 65536 & a) && zi(r, n, o, o[16], t ? Li(n, o[16], a, null) : Bi(o[16]), null) : i && i.p && (!t || 64 & a) && i.p(o, t ? a : -1);
  }, i: function(o) {
    t || (U(i, o), t = !0);
  }, o: function(o) {
    tt(i, o), t = !1;
  }, d: function(o) {
    i && i.d(o);
  } };
}
function Eq(e) {
  var t, n;
  return t = new Aq({ props: { label: e[5], width: e[7], height: e[8], box: e[10], style: e[9], spin: e[1], flip: e[4], inverse: e[2], pulse: e[3], class: e[0], $$slots: { default: [Pq] }, $$scope: { ctx: e } } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = xe(i, 1)[0], a = {};
    32 & o && (a.label = r[5]), 128 & o && (a.width = r[7]), 256 & o && (a.height = r[8]), 1024 & o && (a.box = r[10]), 512 & o && (a.style = r[9]), 2 & o && (a.spin = r[1]), 16 & o && (a.flip = r[4]), 4 & o && (a.inverse = r[2]), 8 & o && (a.pulse = r[3]), 1 & o && (a.class = r[0]), 65600 & o && (a.$$scope = { dirty: o, ctx: r }), t.$set(a);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function Mq(e, t, n) {
  var r, i, o, a, s = t.$$slots, u = s === void 0 ? {} : s, c = t.$$scope, l = t.class, f = l === void 0 ? "" : l, h = t.data, d = t.scale, p = d === void 0 ? 1 : d, v = t.spin, m = v !== void 0 && v, g = t.inverse, y = g !== void 0 && g, b = t.pulse, k = b !== void 0 && b, w = t.flip, x = w === void 0 ? null : w, S = t.label, T = S === void 0 ? null : S, P = null, O = t.style, j = O === void 0 ? null : O;
  function V() {
    var C = 1;
    return p !== void 0 && (C = Number(p)), isNaN(C) || C <= 0 ? (console.warn('Invalid prop: prop "scale" should be a number over 0.'), 1) : 1 * C;
  }
  function E() {
    return P ? Math.max(P.width, P.height) / 16 : 1;
  }
  return e.$$set = function(C) {
    "class" in C && n(0, f = C.class), "data" in C && n(11, h = C.data), "scale" in C && n(12, p = C.scale), "spin" in C && n(1, m = C.spin), "inverse" in C && n(2, y = C.inverse), "pulse" in C && n(3, k = C.pulse), "flip" in C && n(4, x = C.flip), "label" in C && n(5, T = C.label), "style" in C && n(13, j = C.style), "$$scope" in C && n(16, c = C.$$scope);
  }, e.$$.update = function() {
    14336 & e.$$.dirty && (function() {
      if (h !== void 0) {
        var C = function(X) {
          if ("iconName" in X && "icon" in X) {
            var F = {}, G = X.icon, M = X.iconName, $ = { width: G[0], height: G[1], paths: [{ d: G[4] }] };
            return F[M] = $, F;
          }
          return X;
        }(h), H = C[xe(Object.keys(C), 1)[0]];
        H.paths || (H.paths = []), H.d && H.paths.push({ d: H.d }), H.polygons || (H.polygons = []), H.points && H.polygons.push({ points: H.points }), n(6, P = H);
      }
    }(), n(7, r = P ? P.width / E() * V() : 0), n(8, i = P ? P.height / E() * V() : 0), n(9, o = function() {
      var C = "";
      j !== null && (C += j);
      var H = V();
      return H === 1 ? C.length === 0 ? void 0 : C : (C === "" || C.endsWith(";") || (C += "; "), "".concat(C, "font-size: ").concat(H, "em"));
    }()), n(10, a = P ? "0 0 ".concat(P.width, " ").concat(P.height) : "0 0 ".concat(r, " ").concat(i)));
  }, [f, m, y, k, x, T, P, r, i, o, a, h, p, j, u, function(C) {
    n(6, P = C);
  }, c];
}
var Le = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, Mq, Eq, ir, { class: 0, data: 11, scale: 12, spin: 1, inverse: 2, pulse: 3, flip: 4, label: 5, style: 13 }), i;
  }
  return Y(n);
}();
function Tq(e) {
  Te(e, "svelte-kvi5ls", ".jse-message.svelte-kvi5ls.svelte-kvi5ls{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);padding:var(--jse-padding);display:flex;gap:var(--jse-padding);flex-wrap:wrap;align-items:center}.jse-message.jse-success.svelte-kvi5ls.svelte-kvi5ls{background:var(--jse-message-success-background);color:var(--jse-message-success-color)}.jse-message.svelte-kvi5ls .jse-text.svelte-kvi5ls{flex:1;min-width:60%}.jse-message.svelte-kvi5ls .jse-text.jse-clickable.svelte-kvi5ls{cursor:pointer}.jse-message.svelte-kvi5ls .jse-text.jse-clickable.svelte-kvi5ls:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-message.jse-error.svelte-kvi5ls.svelte-kvi5ls{background:var(--jse-message-error-background);color:var(--jse-message-error-color)}.jse-message.jse-warning.svelte-kvi5ls.svelte-kvi5ls{background:var(--jse-message-warning-background);color:var(--jse-message-warning-color)}.jse-message.jse-info.svelte-kvi5ls.svelte-kvi5ls{background:var(--jse-message-info-background);color:var(--jse-message-info-color)}.jse-message.svelte-kvi5ls .jse-actions.svelte-kvi5ls{display:flex;gap:var(--jse-padding)}.jse-message.svelte-kvi5ls .jse-actions button.jse-action.svelte-kvi5ls{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;background:var(--jse-message-action-background);color:inherit;padding:calc(0.5 * var(--jse-padding)) var(--jse-padding)}.jse-message.svelte-kvi5ls .jse-actions button.jse-action.svelte-kvi5ls:hover{background:var(--jse-message-action-background-highlight)}");
}
function sj(e, t, n) {
  var r = e.slice();
  return r[8] = t[n], r;
}
function uj(e) {
  var t, n;
  return t = new Le({ props: { data: e[1] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2 & i && (o.data = r[1]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function cj(e) {
  var t, n;
  return t = new Le({ props: { data: e[8].icon } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    8 & i && (o.data = r[8].icon), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function lj(e) {
  var t, n, r, i, o, a, s, u, c, l = e[8].text + "", f = e[8].icon && cj(e);
  function h() {
    return e[6](e[8]);
  }
  function d() {
    return e[7](e[8]);
  }
  return { c: function() {
    t = rt("button"), f && f.c(), n = bt(), r = Xt(l), i = bt(), A(t, "type", "button"), A(t, "class", "jse-button jse-action jse-primary svelte-kvi5ls"), A(t, "title", o = e[8].title), t.disabled = a = e[8].disabled;
  }, m: function(p, v) {
    pt(p, t, v), f && f.m(t, null), W(t, n), W(t, r), W(t, i), s = !0, u || (c = [Nt(t, "click", h), Nt(t, "mousedown", d)], u = !0);
  }, p: function(p, v) {
    (e = p)[8].icon ? f ? (f.p(e, v), 8 & v && U(f, 1)) : ((f = cj(e)).c(), U(f, 1), f.m(t, n)) : f && (qt(), tt(f, 1, 1, function() {
      f = null;
    }), Vt()), (!s || 8 & v) && l !== (l = e[8].text + "") && Ve(r, l), (!s || 8 & v && o !== (o = e[8].title)) && A(t, "title", o), (!s || 8 & v && a !== (a = e[8].disabled)) && (t.disabled = a);
  }, i: function(p) {
    s || (U(f), s = !0);
  }, o: function(p) {
    tt(f), s = !1;
  }, d: function(p) {
    p && vt(t), f && f.d(), u = !1, Dn(c);
  } };
}
function Iq(e) {
  for (var t, n, r, i, o, a, s, u, c, l, f = e[1] && uj(e), h = e[3], d = [], p = 0; p < h.length; p += 1)
    d[p] = lj(sj(e, h, p));
  var v = function(m) {
    return tt(d[m], 1, 1, function() {
      d[m] = null;
    });
  };
  return { c: function() {
    t = rt("div"), n = rt("div"), f && f.c(), r = bt(), i = Xt(e[2]), o = bt(), a = rt("div");
    for (var m = 0; m < d.length; m += 1)
      d[m].c();
    A(n, "class", "jse-text svelte-kvi5ls"), Ut(n, "jse-clickable", e[4] !== null), A(a, "class", "jse-actions svelte-kvi5ls"), A(t, "class", s = "jse-message jse-" + e[0] + " svelte-kvi5ls");
  }, m: function(m, g) {
    pt(m, t, g), W(t, n), f && f.m(n, null), W(n, r), W(n, i), W(t, o), W(t, a);
    for (var y = 0; y < d.length; y += 1)
      d[y].m(a, null);
    u = !0, c || (l = Nt(n, "click", e[5]), c = !0);
  }, p: function(m, g) {
    var y = xe(g, 1)[0];
    if (m[1] ? f ? (f.p(m, y), 2 & y && U(f, 1)) : ((f = uj(m)).c(), U(f, 1), f.m(n, r)) : f && (qt(), tt(f, 1, 1, function() {
      f = null;
    }), Vt()), (!u || 4 & y) && Ve(i, m[2]), 16 & y && Ut(n, "jse-clickable", m[4] !== null), 8 & y) {
      var b;
      for (h = m[3], b = 0; b < h.length; b += 1) {
        var k = sj(m, h, b);
        d[b] ? (d[b].p(k, y), U(d[b], 1)) : (d[b] = lj(k), d[b].c(), U(d[b], 1), d[b].m(a, null));
      }
      for (qt(), b = h.length; b < d.length; b += 1)
        v(b);
      Vt();
    }
    (!u || 1 & y && s !== (s = "jse-message jse-" + m[0] + " svelte-kvi5ls")) && A(t, "class", s);
  }, i: function(m) {
    if (!u) {
      U(f);
      for (var g = 0; g < h.length; g += 1)
        U(d[g]);
      u = !0;
    }
  }, o: function(m) {
    tt(f), d = d.filter(Boolean);
    for (var g = 0; g < d.length; g += 1)
      tt(d[g]);
    u = !1;
  }, d: function(m) {
    m && vt(t), f && f.d(), Ar(d, m), c = !1, l();
  } };
}
function Nq(e, t, n) {
  var r = t.type, i = r === void 0 ? "success" : r, o = t.icon, a = o === void 0 ? void 0 : o, s = t.message, u = s === void 0 ? void 0 : s, c = t.actions, l = c === void 0 ? [] : c, f = t.onClick, h = f === void 0 ? void 0 : f;
  return e.$$set = function(d) {
    "type" in d && n(0, i = d.type), "icon" in d && n(1, a = d.icon), "message" in d && n(2, u = d.message), "actions" in d && n(3, l = d.actions), "onClick" in d && n(4, h = d.onClick);
  }, [i, a, u, l, h, function() {
    h && h();
  }, function(d) {
    d.onClick && d.onClick();
  }, function(d) {
    d.onMouseDown && d.onMouseDown();
  }];
}
var ss = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, Nq, Iq, Ue, { type: 0, icon: 1, message: 2, actions: 3, onClick: 4 }, Tq), i;
  }
  return Y(n);
}();
function sa(e) {
  return e.map(Rq).join("");
}
function Rq(e) {
  return yA.test(e) ? "[" + e + "]" : gA.test(e) ? "." + e : "[" + JSON.stringify(e) + "]";
}
function ja(e) {
  return e.map(function(t) {
    return yA.test(t) ? "?.[".concat(t, "]") : gA.test(t) ? "?.".concat(t) : "?.[".concat(JSON.stringify(t), "]");
  }).join("");
}
var gA = /^[A-z$_][A-z$_\d]*$/i, yA = /^\d+$/;
function Dq(e) {
  Te(e, "svelte-1oe8e8r", ".jse-validation-errors-overview.svelte-1oe8e8r.svelte-1oe8e8r{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);background:var(--jse-message-warning-background);color:var(--jse-message-warning-color);overflow:auto;max-height:25%}.jse-validation-errors-overview.svelte-1oe8e8r table.svelte-1oe8e8r{border-collapse:collapse;width:100%}.jse-validation-errors-overview.svelte-1oe8e8r table tr.svelte-1oe8e8r{cursor:pointer}.jse-validation-errors-overview.svelte-1oe8e8r table tr.svelte-1oe8e8r:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.svelte-1oe8e8r{padding:4px var(--jse-padding);vertical-align:middle}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.jse-validation-error-icon.svelte-1oe8e8r{width:36px;box-sizing:border-box}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.jse-validation-error-action.svelte-1oe8e8r{width:36px;box-sizing:border-box;padding:0}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1oe8e8r{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;width:36px;height:26px;cursor:pointer}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1oe8e8r:hover{background-color:rgba(255, 255, 255, 0.2)}.jse-validation-errors-overview.svelte-1oe8e8r table tr td div.jse-validation-errors-expand.svelte-1oe8e8r{display:inline-block;position:relative;top:3px}");
}
function fj(e, t, n) {
  var r = e.slice();
  return r[6] = t[n], r[8] = n, r;
}
function hj(e) {
  var t, n, r, i, o = [zq, Lq], a = [];
  function s(u, c) {
    return u[2] || u[0].length === 1 ? 0 : 1;
  }
  return n = s(e), r = a[n] = o[n](e), { c: function() {
    t = rt("div"), r.c(), A(t, "class", "jse-validation-errors-overview svelte-1oe8e8r");
  }, m: function(u, c) {
    pt(u, t, c), a[n].m(t, null), i = !0;
  }, p: function(u, c) {
    var l = n;
    (n = s(u)) === l ? a[n].p(u, c) : (qt(), tt(a[l], 1, 1, function() {
      a[l] = null;
    }), Vt(), (r = a[n]) ? r.p(u, c) : (r = a[n] = o[n](u)).c(), U(r, 1), r.m(t, null));
  }, i: function(u) {
    i || (U(r), i = !0);
  }, o: function(u) {
    tt(r), i = !1;
  }, d: function(u) {
    u && vt(t), a[n].d();
  } };
}
function Lq(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v = e[0].length + "";
  return o = new Le({ props: { data: pu } }), f = new Le({ props: { data: dA } }), { c: function() {
    t = rt("table"), n = rt("tbody"), r = rt("tr"), i = rt("td"), Pt(o.$$.fragment), a = bt(), s = rt("td"), u = Xt(v), c = Xt(` validation errors
              `), l = rt("div"), Pt(f.$$.fragment), A(i, "class", "jse-validation-error-icon svelte-1oe8e8r"), A(l, "class", "jse-validation-errors-expand svelte-1oe8e8r"), A(s, "class", "svelte-1oe8e8r"), A(r, "class", "jse-validation-error svelte-1oe8e8r"), A(t, "class", "svelte-1oe8e8r");
  }, m: function(m, g) {
    pt(m, t, g), W(t, n), W(n, r), W(r, i), Ot(o, i, null), W(r, a), W(r, s), W(s, u), W(s, c), W(s, l), Ot(f, l, null), h = !0, d || (p = Nt(r, "click", e[4]), d = !0);
  }, p: function(m, g) {
    (!h || 1 & g) && v !== (v = m[0].length + "") && Ve(u, v);
  }, i: function(m) {
    h || (U(o.$$.fragment, m), U(f.$$.fragment, m), h = !0);
  }, o: function(m) {
    tt(o.$$.fragment, m), tt(f.$$.fragment, m), h = !1;
  }, d: function(m) {
    m && vt(t), At(o), At(f), d = !1, p();
  } };
}
function zq(e) {
  for (var t, n, r, i = e[0], o = [], a = 0; a < i.length; a += 1)
    o[a] = vj(fj(e, i, a));
  var s = function(u) {
    return tt(o[u], 1, 1, function() {
      o[u] = null;
    });
  };
  return { c: function() {
    t = rt("table"), n = rt("tbody");
    for (var u = 0; u < o.length; u += 1)
      o[u].c();
    A(t, "class", "svelte-1oe8e8r");
  }, m: function(u, c) {
    pt(u, t, c), W(t, n);
    for (var l = 0; l < o.length; l += 1)
      o[l].m(n, null);
    r = !0;
  }, p: function(u, c) {
    if (11 & c) {
      var l;
      for (i = u[0], l = 0; l < i.length; l += 1) {
        var f = fj(u, i, l);
        o[l] ? (o[l].p(f, c), U(o[l], 1)) : (o[l] = vj(f), o[l].c(), U(o[l], 1), o[l].m(n, null));
      }
      for (qt(), l = i.length; l < o.length; l += 1)
        s(l);
      Vt();
    }
  }, i: function(u) {
    if (!r) {
      for (var c = 0; c < i.length; c += 1)
        U(o[c]);
      r = !0;
    }
  }, o: function(u) {
    o = o.filter(Boolean);
    for (var c = 0; c < o.length; c += 1)
      tt(o[c]);
    r = !1;
  }, d: function(u) {
    u && vt(t), Ar(o, u);
  } };
}
function dj(e) {
  var t, n, r, i, o;
  return n = new Le({ props: { data: oq } }), { c: function() {
    t = rt("button"), Pt(n.$$.fragment), A(t, "type", "button"), A(t, "class", "jse-validation-errors-collapse svelte-1oe8e8r"), A(t, "title", "Collapse validation errors");
  }, m: function(a, s) {
    pt(a, t, s), Ot(n, t, null), r = !0, i || (o = Nt(t, "click", bC(e[3])), i = !0);
  }, p: Wt, i: function(a) {
    r || (U(n.$$.fragment, a), r = !0);
  }, o: function(a) {
    tt(n.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && vt(t), At(n), i = !1, o();
  } };
}
function vj(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m = sa(e[6].path) + "", g = e[6].message + "";
  r = new Le({ props: { data: pu } });
  var y = e[8] === 0 && e[0].length > 1 && dj(e);
  function b() {
    return e[5](e[6]);
  }
  return { c: function() {
    t = rt("tr"), n = rt("td"), Pt(r.$$.fragment), i = bt(), o = rt("td"), a = Xt(m), s = bt(), u = rt("td"), c = Xt(g), l = bt(), f = rt("td"), y && y.c(), h = bt(), A(n, "class", "jse-validation-error-icon svelte-1oe8e8r"), A(o, "class", "svelte-1oe8e8r"), A(u, "class", "svelte-1oe8e8r"), A(f, "class", "jse-validation-error-action svelte-1oe8e8r"), A(t, "class", "jse-validation-error svelte-1oe8e8r");
  }, m: function(k, w) {
    pt(k, t, w), W(t, n), Ot(r, n, null), W(t, i), W(t, o), W(o, a), W(t, s), W(t, u), W(u, c), W(t, l), W(t, f), y && y.m(f, null), W(t, h), d = !0, p || (v = Nt(t, "click", b), p = !0);
  }, p: function(k, w) {
    e = k, (!d || 1 & w) && m !== (m = sa(e[6].path) + "") && Ve(a, m), (!d || 1 & w) && g !== (g = e[6].message + "") && Ve(c, g), e[8] === 0 && e[0].length > 1 ? y ? (y.p(e, w), 1 & w && U(y, 1)) : ((y = dj(e)).c(), U(y, 1), y.m(f, null)) : y && (qt(), tt(y, 1, 1, function() {
      y = null;
    }), Vt());
  }, i: function(k) {
    d || (U(r.$$.fragment, k), U(y), d = !0);
  }, o: function(k) {
    tt(r.$$.fragment, k), tt(y), d = !1;
  }, d: function(k) {
    k && vt(t), At(r), y && y.d(), p = !1, v();
  } };
}
function Bq(e) {
  var t, n, r = !_n(e[0]), i = r && hj(e);
  return { c: function() {
    i && i.c(), t = Ye();
  }, m: function(o, a) {
    i && i.m(o, a), pt(o, t, a), n = !0;
  }, p: function(o, a) {
    var s = xe(a, 1)[0];
    1 & s && (r = !_n(o[0])), r ? i ? (i.p(o, s), 1 & s && U(i, 1)) : ((i = hj(o)).c(), U(i, 1), i.m(t.parentNode, t)) : i && (qt(), tt(i, 1, 1, function() {
      i = null;
    }), Vt());
  }, i: function(o) {
    n || (U(i), n = !0);
  }, o: function(o) {
    tt(i), n = !1;
  }, d: function(o) {
    i && i.d(o), o && vt(t);
  } };
}
function Fq(e, t, n) {
  var r = t.validationErrors, i = t.selectError, o = !0;
  return e.$$set = function(a) {
    "validationErrors" in a && n(0, r = a.validationErrors), "selectError" in a && n(1, i = a.selectError);
  }, [r, i, o, function() {
    n(2, o = !1);
  }, function() {
    n(2, o = !0);
  }, function(a) {
    setTimeout(function() {
      return i(a);
    });
  }];
}
var bA = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, Fq, Bq, Ue, { validationErrors: 0, selectError: 1 }, Dq), i;
  }
  return Y(n);
}(), qq = { prefix: "fas", iconName: "jsoneditor-expand", icon: [512, 512, [], null, "M 0,448 V 512 h 512 v -64 z M 0,0 V 64 H 512 V 0 Z M 256,96 128,224 h 256 z M 256,416 384,288 H 128 Z"] }, Vq = { prefix: "fas", iconName: "jsoneditor-collapse", icon: [512, 512, [], null, "m 0,224 v 64 h 512 v -64 z M 256,192 384,64 H 128 Z M 256,320 128,448 h 256 z"] }, Hq = { prefix: "fas", iconName: "jsoneditor-format", icon: [512, 512, [], null, "M 0,32 v 64 h 416 v -64 z M 160,160 v 64 h 352 v -64 z M 160,288 v 64 h 288 v -64 z M 0,416 v 64 h 320 v -64 z"] }, Wq = { prefix: "fas", iconName: "jsoneditor-compact", icon: [512, 512, [], null, "M 0,32 v 64 h 512 v -64 z M 0,160 v 64 h 512 v -64 z M 0,288 v 64 h 352 v -64 z"] };
function Uq(e) {
  Te(e, "svelte-v4jelk", ".jse-menu.svelte-v4jelk.svelte-v4jelk{background:var(--jse-theme-color);border-bottom:1px solid var(--jse-theme-color);color:var(--jse-menu-color);display:flex;flex-wrap:wrap;align-items:center;position:relative}.jse-menu.svelte-v4jelk .jse-button.svelte-v4jelk{width:var(--jse-menu-button-size);height:var(--jse-menu-button-size);border:none;background:transparent;color:inherit;cursor:pointer;padding:calc(0.5 * var(--jse-padding));margin:0;border-radius:0}.jse-menu.svelte-v4jelk .jse-button.svelte-v4jelk:hover,.jse-menu.svelte-v4jelk .jse-button.svelte-v4jelk:focus{background:var(--jse-theme-color-highlight)}.jse-menu.svelte-v4jelk .jse-button.svelte-v4jelk:disabled{color:var(--jse-menu-color);opacity:0.5;background:transparent}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.svelte-v4jelk{border:1px solid var(--jse-menu-color);padding:0;margin:calc(0.5 * var(--jse-padding)) 0;height:calc(var(--jse-menu-button-size) - var(--jse-padding));width:40px}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.svelte-v4jelk:not(.jse-last){border-right:none}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.jse-first.svelte-v4jelk{margin-left:calc(0.5 * var(--jse-padding))}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.jse-last.svelte-v4jelk{margin-right:calc(0.5 * var(--jse-padding))}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.svelte-v4jelk:hover,.jse-menu.svelte-v4jelk .jse-button.jse-group-button.svelte-v4jelk:focus{background:var(--jse-theme-color-highlight)}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.jse-selected.svelte-v4jelk{background:var(--jse-menu-color);color:var(--jse-theme-color)}.jse-menu.svelte-v4jelk .jse-space.svelte-v4jelk{flex:1}.jse-menu.svelte-v4jelk .jse-separator.svelte-v4jelk{background:var(--jse-menu-color);opacity:0.3;box-sizing:border-box;width:1px;height:calc(var(--jse-menu-button-size) - 6px);margin:3px}");
}
var Jq = function(e) {
  return {};
}, pj = function(e) {
  return {};
};
function mj(e, t, n) {
  var r = e.slice();
  return r[3] = t[n], r;
}
var Kq = function(e) {
  return {};
}, gj = function(e) {
  return {};
};
function Gq(e) {
  var t, n, r, i, o, a, s, u, c = e[3].icon && yj(e), l = e[3].text && bj(e);
  return { c: function() {
    t = rt("button"), c && c.c(), n = bt(), l && l.c(), A(t, "type", "button"), A(t, "class", r = "jse-button " + e[3].className + " svelte-v4jelk"), A(t, "title", i = e[3].title), t.disabled = o = e[3].disabled || !1;
  }, m: function(f, h) {
    pt(f, t, h), c && c.m(t, null), W(t, n), l && l.m(t, null), a = !0, s || (u = Nt(t, "click", function() {
      Ai(e[3].onClick) && e[3].onClick.apply(this, arguments);
    }), s = !0);
  }, p: function(f, h) {
    (e = f)[3].icon ? c ? (c.p(e, h), 1 & h && U(c, 1)) : ((c = yj(e)).c(), U(c, 1), c.m(t, n)) : c && (qt(), tt(c, 1, 1, function() {
      c = null;
    }), Vt()), e[3].text ? l ? l.p(e, h) : ((l = bj(e)).c(), l.m(t, null)) : l && (l.d(1), l = null), (!a || 1 & h && r !== (r = "jse-button " + e[3].className + " svelte-v4jelk")) && A(t, "class", r), (!a || 1 & h && i !== (i = e[3].title)) && A(t, "title", i), (!a || 1 & h && o !== (o = e[3].disabled || !1)) && (t.disabled = o);
  }, i: function(f) {
    a || (U(c), a = !0);
  }, o: function(f) {
    tt(c), a = !1;
  }, d: function(f) {
    f && vt(t), c && c.d(), l && l.d(), s = !1, u();
  } };
}
function Qq(e) {
  var t;
  return { c: function() {
    A(t = rt("div"), "class", "jse-space svelte-v4jelk");
  }, m: function(n, r) {
    pt(n, t, r);
  }, p: Wt, i: Wt, o: Wt, d: function(n) {
    n && vt(t);
  } };
}
function Xq(e) {
  var t;
  return { c: function() {
    A(t = rt("div"), "class", "jse-separator svelte-v4jelk");
  }, m: function(n, r) {
    pt(n, t, r);
  }, p: Wt, i: Wt, o: Wt, d: function(n) {
    n && vt(t);
  } };
}
function yj(e) {
  var t, n;
  return t = new Le({ props: { data: e[3].icon } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.data = r[3].icon), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function bj(e) {
  var t, n = e[3].text + "";
  return { c: function() {
    t = Xt(n);
  }, m: function(r, i) {
    pt(r, t, i);
  }, p: function(r, i) {
    1 & i && n !== (n = r[3].text + "") && Ve(t, n);
  }, d: function(r) {
    r && vt(t);
  } };
}
function kj(e) {
  var t, n, r, i, o = [Xq, Qq, Gq], a = [];
  function s(u, c) {
    return u[3].separator === !0 ? 0 : u[3].space === !0 ? 1 : 2;
  }
  return t = s(e), n = a[t] = o[t](e), { c: function() {
    n.c(), r = Ye();
  }, m: function(u, c) {
    a[t].m(u, c), pt(u, r, c), i = !0;
  }, p: function(u, c) {
    var l = t;
    (t = s(u)) === l ? a[t].p(u, c) : (qt(), tt(a[l], 1, 1, function() {
      a[l] = null;
    }), Vt(), (n = a[t]) ? n.p(u, c) : (n = a[t] = o[t](u)).c(), U(n, 1), n.m(r.parentNode, r));
  }, i: function(u) {
    i || (U(n), i = !0);
  }, o: function(u) {
    tt(n), i = !1;
  }, d: function(u) {
    a[t].d(u), u && vt(r);
  } };
}
function Zq(e) {
  for (var t, n, r, i, o = e[2].left, a = Di(o, e, e[1], gj), s = e[0], u = [], c = 0; c < s.length; c += 1)
    u[c] = kj(mj(e, s, c));
  var l = function(d) {
    return tt(u[d], 1, 1, function() {
      u[d] = null;
    });
  }, f = e[2].right, h = Di(f, e, e[1], pj);
  return { c: function() {
    t = rt("div"), a && a.c(), n = bt();
    for (var d = 0; d < u.length; d += 1)
      u[d].c();
    r = bt(), h && h.c(), A(t, "class", "jse-menu svelte-v4jelk");
  }, m: function(d, p) {
    pt(d, t, p), a && a.m(t, null), W(t, n);
    for (var v = 0; v < u.length; v += 1)
      u[v].m(t, null);
    W(t, r), h && h.m(t, null), i = !0;
  }, p: function(d, p) {
    var v = xe(p, 1)[0];
    if (a && a.p && (!i || 2 & v) && zi(a, o, d, d[1], i ? Li(o, d[1], v, Kq) : Bi(d[1]), gj), 1 & v) {
      var m;
      for (s = d[0], m = 0; m < s.length; m += 1) {
        var g = mj(d, s, m);
        u[m] ? (u[m].p(g, v), U(u[m], 1)) : (u[m] = kj(g), u[m].c(), U(u[m], 1), u[m].m(t, r));
      }
      for (qt(), m = s.length; m < u.length; m += 1)
        l(m);
      Vt();
    }
    h && h.p && (!i || 2 & v) && zi(h, f, d, d[1], i ? Li(f, d[1], v, Jq) : Bi(d[1]), pj);
  }, i: function(d) {
    if (!i) {
      U(a, d);
      for (var p = 0; p < s.length; p += 1)
        U(u[p]);
      U(h, d), i = !0;
    }
  }, o: function(d) {
    tt(a, d), u = u.filter(Boolean);
    for (var p = 0; p < u.length; p += 1)
      tt(u[p]);
    tt(h, d), i = !1;
  }, d: function(d) {
    d && vt(t), a && a.d(d), Ar(u, d), h && h.d(d);
  } };
}
function Yq(e, t, n) {
  var r = t.$$slots, i = r === void 0 ? {} : r, o = t.$$scope, a = t.items, s = a === void 0 ? [] : a;
  return e.$$set = function(u) {
    "items" in u && n(0, s = u.items), "$$scope" in u && n(1, o = u.$$scope);
  }, [s, o, i];
}
var c0 = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, Yq, Zq, Ue, { items: 0 }, Uq), i;
  }
  return Y(n);
}();
function tV(e) {
  var t, n;
  return t = new c0({ props: { items: e[0] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & xe(i, 1)[0] && (o.items = r[0]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function eV(e, t, n) {
  var r, i, o = t.readOnly, a = o !== void 0 && o, s = t.onFormat, u = t.onCompact, c = t.onSort, l = t.onTransform, f = t.onToggleSearch, h = t.onUndo, d = t.onRedo, p = t.canUndo, v = t.canRedo, m = t.canFormat, g = t.canCompact, y = t.canSort, b = t.canTransform, k = t.onRenderMenu, w = k === void 0 ? Qe : k;
  return e.$$set = function(x) {
    "readOnly" in x && n(1, a = x.readOnly), "onFormat" in x && n(2, s = x.onFormat), "onCompact" in x && n(3, u = x.onCompact), "onSort" in x && n(4, c = x.onSort), "onTransform" in x && n(5, l = x.onTransform), "onToggleSearch" in x && n(6, f = x.onToggleSearch), "onUndo" in x && n(7, h = x.onUndo), "onRedo" in x && n(8, d = x.onRedo), "canUndo" in x && n(9, p = x.canUndo), "canRedo" in x && n(10, v = x.canRedo), "canFormat" in x && n(11, m = x.canFormat), "canCompact" in x && n(12, g = x.canCompact), "canSort" in x && n(13, y = x.canSort), "canTransform" in x && n(14, b = x.canTransform), "onRenderMenu" in x && n(15, w = x.onRenderMenu);
  }, e.$$.update = function() {
    32766 & e.$$.dirty && n(16, r = a ? [{ space: !0 }] : [{ icon: Hq, title: "Format JSON: add proper indentation and new lines (Ctrl+I)", className: "jse-format", onClick: s, disabled: a || !m }, { icon: Wq, title: "Compact JSON: remove all white spacing and new lines (Ctrl+Shift+I)", className: "jse-compact", onClick: u, disabled: a || !g }, { separator: !0 }, { icon: i0, title: "Sort", className: "jse-sort", onClick: c, disabled: a || !y }, { icon: o0, title: "Transform contents (filter, sort, project)", className: "jse-transform", onClick: l, disabled: a || !b }, { icon: a0, title: "Search (Ctrl+F)", className: "jse-search", onClick: f }, { separator: !0 }, { icon: vA, title: "Undo (Ctrl+Z)", className: "jse-undo", onClick: h, disabled: !p }, { icon: pA, title: "Redo (Ctrl+Shift+Z)", className: "jse-redo", onClick: d, disabled: !v }, { space: !0 }]), 98304 & e.$$.dirty && n(0, i = w("text", r) || r);
  }, [i, a, s, u, c, l, f, h, d, p, v, m, g, y, b, w, r];
}
var nV = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, eV, tV, Ue, { readOnly: 1, onFormat: 2, onCompact: 3, onSort: 4, onTransform: 5, onToggleSearch: 6, onUndo: 7, onRedo: 8, canUndo: 9, canRedo: 10, canFormat: 11, canCompact: 12, canSort: 13, canTransform: 14, onRenderMenu: 15 }), i;
  }
  return Y(n);
}(), xn = function() {
  function e() {
    Z(this, e);
  }
  return Y(e, [{ key: "lineAt", value: function(t) {
    if (t < 0 || t > this.length)
      throw new RangeError("Invalid position ".concat(t, " in document of length ").concat(this.length));
    return this.lineInner(t, !1, 1, 0);
  } }, { key: "line", value: function(t) {
    if (t < 1 || t > this.lines)
      throw new RangeError("Invalid line number ".concat(t, " in ").concat(this.lines, "-line document"));
    return this.lineInner(t, !0, 1, 0);
  } }, { key: "replace", value: function(t, n, r) {
    var i = [];
    return this.decompose(0, t, i, 2), r.length && r.decompose(0, r.length, i, 3), this.decompose(n, this.length, i, 1), nf.from(i, this.length - (n - t) + r.length);
  } }, { key: "append", value: function(t) {
    return this.replace(this.length, this.length, t);
  } }, { key: "slice", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length, r = [];
    return this.decompose(t, n, r, 0), nf.from(r, n - t);
  } }, { key: "eq", value: function(t) {
    if (t == this)
      return !0;
    if (t.length != this.length || t.lines != this.lines)
      return !1;
    for (var n = this.scanIdentical(t, 1), r = this.length - this.scanIdentical(t, -1), i = new Uu(this), o = new Uu(t), a = n, s = n; ; ) {
      if (i.next(a), o.next(a), a = 0, i.lineBreak != o.lineBreak || i.done != o.done || i.value != o.value)
        return !1;
      if (s += i.value.length, i.done || s >= r)
        return !0;
    }
  } }, { key: "iter", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return new Uu(this, t);
  } }, { key: "iterRange", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length;
    return new kA(this, t, n);
  } }, { key: "iterLines", value: function(t, n) {
    var r;
    if (t == null)
      r = this.iter();
    else {
      n == null && (n = this.lines + 1);
      var i = this.line(t).from;
      r = this.iterRange(i, Math.max(i, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new wA(r);
  } }, { key: "toString", value: function() {
    return this.sliceString(0);
  } }, { key: "toJSON", value: function() {
    var t = [];
    return this.flatten(t), t;
  } }], [{ key: "of", value: function(t) {
    if (t.length == 0)
      throw new RangeError("A document must have at least one line");
    return t.length != 1 || t[0] ? t.length <= 32 ? new Pi(t) : nf.from(Pi.split(t, [])) : e.empty;
  } }]), e;
}(), Pi = function(e) {
  Et(n, xn);
  var t = Mt(n);
  function n(r) {
    var i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : rV(r);
    return Z(this, n), (i = t.call(this)).text = r, i.length = o, i;
  }
  return Y(n, [{ key: "lines", get: function() {
    return this.text.length;
  } }, { key: "children", get: function() {
    return null;
  } }, { key: "lineInner", value: function(r, i, o, a) {
    for (var s = 0; ; s++) {
      var u = this.text[s], c = a + u.length;
      if ((i ? o : c) >= r)
        return new iV(a, c, o, u);
      a = c + 1, o++;
    }
  } }, { key: "decompose", value: function(r, i, o, a) {
    var s = r <= 0 && i >= this.length ? this : new n(wj(this.text, r, i), Math.min(i, this.length) - Math.max(0, r));
    if (1 & a) {
      var u = o.pop(), c = rf(s.text, u.text.slice(), 0, s.length);
      if (c.length <= 32)
        o.push(new n(c, u.length + s.length));
      else {
        var l = c.length >> 1;
        o.push(new n(c.slice(0, l)), new n(c.slice(l)));
      }
    } else
      o.push(s);
  } }, { key: "replace", value: function(r, i, o) {
    if (!(o instanceof n))
      return Je(qe(n.prototype), "replace", this).call(this, r, i, o);
    var a = rf(this.text, rf(o.text, wj(this.text, 0, r)), i), s = this.length + o.length - (i - r);
    return a.length <= 32 ? new n(a, s) : nf.from(n.split(a, []), s);
  } }, { key: "sliceString", value: function(r) {
    for (var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : `
`, a = "", s = 0, u = 0; s <= i && u < this.text.length; u++) {
      var c = this.text[u], l = s + c.length;
      s > r && u && (a += o), r < l && i > s && (a += c.slice(Math.max(0, r - s), i - s)), s = l + 1;
    }
    return a;
  } }, { key: "flatten", value: function(r) {
    var i, o = ut(this.text);
    try {
      for (o.s(); !(i = o.n()).done; ) {
        var a = i.value;
        r.push(a);
      }
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
  } }, { key: "scanIdentical", value: function() {
    return 0;
  } }], [{ key: "split", value: function(r, i) {
    var o, a = [], s = -1, u = ut(r);
    try {
      for (u.s(); !(o = u.n()).done; ) {
        var c = o.value;
        a.push(c), s += c.length + 1, a.length == 32 && (i.push(new n(a, s)), a = [], s = -1);
      }
    } catch (l) {
      u.e(l);
    } finally {
      u.f();
    }
    return s > -1 && i.push(new n(a, s)), i;
  } }]), n;
}(), nf = function(e) {
  Et(n, xn);
  var t = Mt(n);
  function n(r, i) {
    var o;
    Z(this, n), (o = t.call(this)).children = r, o.length = i, o.lines = 0;
    var a, s = ut(r);
    try {
      for (s.s(); !(a = s.n()).done; ) {
        var u = a.value;
        o.lines += u.lines;
      }
    } catch (c) {
      s.e(c);
    } finally {
      s.f();
    }
    return o;
  }
  return Y(n, [{ key: "lineInner", value: function(r, i, o, a) {
    for (var s = 0; ; s++) {
      var u = this.children[s], c = a + u.length, l = o + u.lines - 1;
      if ((i ? l : c) >= r)
        return u.lineInner(r, i, o, a);
      a = c + 1, o = l + 1;
    }
  } }, { key: "decompose", value: function(r, i, o, a) {
    for (var s = 0, u = 0; u <= i && s < this.children.length; s++) {
      var c = this.children[s], l = u + c.length;
      if (r <= l && i >= u) {
        var f = a & ((u <= r ? 1 : 0) | (l >= i ? 2 : 0));
        u >= r && l <= i && !f ? o.push(c) : c.decompose(r - u, i - u, o, f);
      }
      u = l + 1;
    }
  } }, { key: "replace", value: function(r, i, o) {
    if (o.lines < this.lines)
      for (var a = 0, s = 0; a < this.children.length; a++) {
        var u = this.children[a], c = s + u.length;
        if (r >= s && i <= c) {
          var l = u.replace(r - s, i - s, o), f = this.lines - u.lines + l.lines;
          if (l.lines < f >> 4 && l.lines > f >> 6) {
            var h = this.children.slice();
            return h[a] = l, new n(h, this.length - (i - r) + o.length);
          }
          return Je(qe(n.prototype), "replace", this).call(this, s, c, l);
        }
        s = c + 1;
      }
    return Je(qe(n.prototype), "replace", this).call(this, r, i, o);
  } }, { key: "sliceString", value: function(r) {
    for (var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.length, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : `
`, a = "", s = 0, u = 0; s < this.children.length && u <= i; s++) {
      var c = this.children[s], l = u + c.length;
      u > r && s && (a += o), r < l && i > u && (a += c.sliceString(r - u, i - u, o)), u = l + 1;
    }
    return a;
  } }, { key: "flatten", value: function(r) {
    var i, o = ut(this.children);
    try {
      for (o.s(); !(i = o.n()).done; )
        i.value.flatten(r);
    } catch (a) {
      o.e(a);
    } finally {
      o.f();
    }
  } }, { key: "scanIdentical", value: function(r, i) {
    if (!(r instanceof n))
      return 0;
    for (var o = 0, a = xe(i > 0 ? [0, 0, this.children.length, r.children.length] : [this.children.length - 1, r.children.length - 1, -1, -1], 4), s = a[0], u = a[1], c = a[2], l = a[3]; ; s += i, u += i) {
      if (s == c || u == l)
        return o;
      var f = this.children[s], h = r.children[u];
      if (f != h)
        return o + f.scanIdentical(h, i);
      o += f.length + 1;
    }
  } }], [{ key: "from", value: function(r) {
    var i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r.reduce(function(P, O) {
      return P + O.length + 1;
    }, -1), a = 0, s = ut(r);
    try {
      for (s.s(); !(i = s.n()).done; ) {
        var u = i.value;
        a += u.lines;
      }
    } catch (P) {
      s.e(P);
    } finally {
      s.f();
    }
    if (a < 32) {
      var c, l = [], f = ut(r);
      try {
        for (f.s(); !(c = f.n()).done; ) {
          var h = c.value;
          h.flatten(l);
        }
      } catch (P) {
        f.e(P);
      } finally {
        f.f();
      }
      return new Pi(l, o);
    }
    var d = Math.max(32, a >> 5), p = d << 1, v = d >> 1, m = [], g = 0, y = -1, b = [];
    function k(P) {
      var O;
      if (P.lines > p && P instanceof n) {
        var j, V = ut(P.children);
        try {
          for (V.s(); !(j = V.n()).done; )
            k(j.value);
        } catch (E) {
          V.e(E);
        } finally {
          V.f();
        }
      } else
        P.lines > v && (g > v || !g) ? (w(), m.push(P)) : P instanceof Pi && g && (O = b[b.length - 1]) instanceof Pi && P.lines + O.lines <= 32 ? (g += P.lines, y += P.length + 1, b[b.length - 1] = new Pi(O.text.concat(P.text), O.length + 1 + P.length)) : (g + P.lines > d && w(), g += P.lines, y += P.length + 1, b.push(P));
    }
    function w() {
      g != 0 && (m.push(b.length == 1 ? b[0] : n.from(b, y)), y = -1, g = b.length = 0);
    }
    var x, S = ut(r);
    try {
      for (S.s(); !(x = S.n()).done; ) {
        var T = x.value;
        k(T);
      }
    } catch (P) {
      S.e(P);
    } finally {
      S.f();
    }
    return w(), m.length == 1 ? m[0] : new n(m, o);
  } }]), n;
}();
function rV(e) {
  var t, n = -1, r = ut(e);
  try {
    for (r.s(); !(t = r.n()).done; )
      n += t.value.length + 1;
  } catch (i) {
    r.e(i);
  } finally {
    r.f();
  }
  return n;
}
function rf(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1e9, i = 0, o = 0, a = !0; o < e.length && i <= r; o++) {
    var s = e[o], u = i + s.length;
    u >= n && (u > r && (s = s.slice(0, r - i)), i < n && (s = s.slice(n - i)), a ? (t[t.length - 1] += s, a = !1) : t.push(s)), i = u + 1;
  }
  return t;
}
function wj(e, t, n) {
  return rf(e, [""], t, n);
}
xn.empty = new Pi([""], 0);
var Uu = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    Z(this, e), this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [t], this.offsets = [n > 0 ? 1 : (t instanceof Pi ? t.text.length : t.children.length) << 1];
  }
  return Y(e, [{ key: "nextInner", value: function(t, n) {
    for (this.done = this.lineBreak = !1; ; ) {
      var r = this.nodes.length - 1, i = this.nodes[r], o = this.offsets[r], a = o >> 1, s = i instanceof Pi ? i.text.length : i.children.length;
      if (a == (n > 0 ? s : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((1 & o) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, t == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        t--;
      } else if (i instanceof Pi) {
        var u = i.text[a + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, u.length > Math.max(0, t))
          return this.value = t == 0 ? u : n > 0 ? u.slice(t) : u.slice(0, u.length - t), this;
        t -= u.length;
      } else {
        var c = i.children[a + (n < 0 ? -1 : 0)];
        t > c.length ? (t -= c.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(c), this.offsets.push(n > 0 ? 1 : (c instanceof Pi ? c.text.length : c.children.length) << 1));
      }
    }
  } }, { key: "next", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t < 0 && (this.nextInner(-t, -this.dir), t = this.value.length), this.nextInner(t, this.dir);
  } }]), e;
}(), kA = function() {
  function e(t, n, r) {
    Z(this, e), this.value = "", this.done = !1, this.cursor = new Uu(t, n > r ? -1 : 1), this.pos = n > r ? t.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  return Y(e, [{ key: "nextInner", value: function(t, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    t += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    var r = n < 0 ? this.pos - this.from : this.to - this.pos;
    t > r && (t = r), r -= t;
    var i = this.cursor.next(t).value;
    return this.pos += (i.length + t) * n, this.value = i.length <= r ? i : n < 0 ? i.slice(i.length - r) : i.slice(0, r), this.done = !this.value, this;
  } }, { key: "next", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t < 0 ? t = Math.max(t, this.from - this.pos) : t > 0 && (t = Math.min(t, this.to - this.pos)), this.nextInner(t, this.cursor.dir);
  } }, { key: "lineBreak", get: function() {
    return this.cursor.lineBreak && this.value != "";
  } }]), e;
}(), wA = function() {
  function e(t) {
    Z(this, e), this.inner = t, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  return Y(e, [{ key: "next", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = this.inner.next(t), r = n.done, i = n.lineBreak, o = n.value;
    return r ? (this.done = !0, this.value = "") : i ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = o, this.afterBreak = !1), this;
  } }, { key: "lineBreak", get: function() {
    return !1;
  } }]), e;
}();
typeof Symbol < "u" && (xn.prototype[Symbol.iterator] = function() {
  return this.iter();
}, Uu.prototype[Symbol.iterator] = kA.prototype[Symbol.iterator] = wA.prototype[Symbol.iterator] = function() {
  return this;
});
for (var iV = function() {
  function e(t, n, r, i) {
    Z(this, e), this.from = t, this.to = n, this.number = r, this.text = i;
  }
  return Y(e, [{ key: "length", get: function() {
    return this.to - this.from;
  } }]), e;
}(), Os = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map(function(e) {
  return e ? parseInt(e, 36) : 1;
}), jl = 1; jl < Os.length; jl++)
  Os[jl] += Os[jl - 1];
function oV(e) {
  for (var t = 1; t < Os.length; t += 2)
    if (Os[t] > e)
      return Os[t - 1] <= e;
  return !1;
}
function xj(e) {
  return e >= 127462 && e <= 127487;
}
function Xr(e, t) {
  var n = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], r = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
  return (n ? xA : aV)(e, t, r);
}
function xA(e, t, n) {
  if (t == e.length)
    return t;
  t && jA(e.charCodeAt(t)) && SA(e.charCodeAt(t - 1)) && t--;
  var r = gr(e, t);
  for (t += Jr(r); t < e.length; ) {
    var i = gr(e, t);
    if (r == 8205 || i == 8205 || n && oV(i))
      t += Jr(i), r = i;
    else {
      if (!xj(i))
        break;
      for (var o = 0, a = t - 2; a >= 0 && xj(gr(e, a)); )
        o++, a -= 2;
      if (o % 2 == 0)
        break;
      t += 2;
    }
  }
  return t;
}
function aV(e, t, n) {
  for (; t > 0; ) {
    var r = xA(e, t - 2, n);
    if (r < t)
      return r;
    t--;
  }
  return 0;
}
function jA(e) {
  return e >= 56320 && e < 57344;
}
function SA(e) {
  return e >= 55296 && e < 56320;
}
function gr(e, t) {
  var n = e.charCodeAt(t);
  if (!SA(n) || t + 1 == e.length)
    return n;
  var r = e.charCodeAt(t + 1);
  return jA(r) ? r - 56320 + (n - 55296 << 10) + 65536 : n;
}
function l0(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e)));
}
function Jr(e) {
  return e < 65536 ? 1 : 2;
}
var gp = /\r\n?|\n/, Ir = function(e) {
  return e[e.Simple = 0] = "Simple", e[e.TrackDel = 1] = "TrackDel", e[e.TrackBefore = 2] = "TrackBefore", e[e.TrackAfter = 3] = "TrackAfter", e;
}(Ir || (Ir = {})), As = function() {
  function e(t) {
    Z(this, e), this.sections = t;
  }
  return Y(e, [{ key: "length", get: function() {
    for (var t = 0, n = 0; n < this.sections.length; n += 2)
      t += this.sections[n];
    return t;
  } }, { key: "newLength", get: function() {
    for (var t = 0, n = 0; n < this.sections.length; n += 2) {
      var r = this.sections[n + 1];
      t += r < 0 ? this.sections[n] : r;
    }
    return t;
  } }, { key: "empty", get: function() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  } }, { key: "iterGaps", value: function(t) {
    for (var n = 0, r = 0, i = 0; n < this.sections.length; ) {
      var o = this.sections[n++], a = this.sections[n++];
      a < 0 ? (t(r, i, o), i += o) : i += a, r += o;
    }
  } }, { key: "iterChangedRanges", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    yp(this, t, n);
  } }, { key: "invertedDesc", get: function() {
    for (var t = [], n = 0; n < this.sections.length; ) {
      var r = this.sections[n++], i = this.sections[n++];
      i < 0 ? t.push(r, i) : t.push(i, r);
    }
    return new e(t);
  } }, { key: "composeDesc", value: function(t) {
    return this.empty ? t : t.empty ? this : $A(this, t);
  } }, { key: "mapDesc", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return t.empty ? this : bp(this, t, n);
  } }, { key: "mapPos", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ir.Simple, i = 0, o = 0, a = 0; a < this.sections.length; ) {
      var s = this.sections[a++], u = this.sections[a++], c = i + s;
      if (u < 0) {
        if (c > t)
          return o + (t - i);
        o += s;
      } else {
        if (r != Ir.Simple && c >= t && (r == Ir.TrackDel && i < t && c > t || r == Ir.TrackBefore && i < t || r == Ir.TrackAfter && c > t))
          return null;
        if (c > t || c == t && n < 0 && !s)
          return t == i || n < 0 ? o : o + u;
        o += u;
      }
      i = c;
    }
    if (t > i)
      throw new RangeError("Position ".concat(t, " is out of range for changeset of length ").concat(i));
    return o;
  } }, { key: "touchesRange", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, r = 0, i = 0; r < this.sections.length && i <= n; ) {
      var o = this.sections[r++], a = this.sections[r++], s = i + o;
      if (a >= 0 && i <= n && s >= t)
        return !(i < t && s > n) || "cover";
      i = s;
    }
    return !1;
  } }, { key: "toString", value: function() {
    for (var t = "", n = 0; n < this.sections.length; ) {
      var r = this.sections[n++], i = this.sections[n++];
      t += (t ? " " : "") + r + (i >= 0 ? ":" + i : "");
    }
    return t;
  } }, { key: "toJSON", value: function() {
    return this.sections;
  } }], [{ key: "fromJSON", value: function(t) {
    if (!Array.isArray(t) || t.length % 2 || t.some(function(n) {
      return typeof n != "number";
    }))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new e(t);
  } }, { key: "create", value: function(t) {
    return new e(t);
  } }]), e;
}(), qi = function(e) {
  Et(n, As);
  var t = Mt(n);
  function n(r, i) {
    var o;
    return Z(this, n), (o = t.call(this, r)).inserted = i, o;
  }
  return Y(n, [{ key: "apply", value: function(r) {
    if (this.length != r.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return yp(this, function(i, o, a, s, u) {
      return r = r.replace(a, a + (o - i), u);
    }, !1), r;
  } }, { key: "mapDesc", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return bp(this, r, i, !0);
  } }, { key: "invert", value: function(r) {
    for (var i = this.sections.slice(), o = [], a = 0, s = 0; a < i.length; a += 2) {
      var u = i[a], c = i[a + 1];
      if (c >= 0) {
        i[a] = c, i[a + 1] = u;
        for (var l = a >> 1; o.length < l; )
          o.push(xn.empty);
        o.push(u ? r.slice(s, s + u) : xn.empty);
      }
      s += u;
    }
    return new n(i, o);
  } }, { key: "compose", value: function(r) {
    return this.empty ? r : r.empty ? this : $A(this, r, !0);
  } }, { key: "map", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return r.empty ? this : bp(this, r, i, !0);
  } }, { key: "iterChanges", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    yp(this, r, i);
  } }, { key: "desc", get: function() {
    return As.create(this.sections);
  } }, { key: "filter", value: function(r) {
    var i = [], o = [], a = [], s = new lc(this);
    t:
      for (var u = 0, c = 0; ; ) {
        for (var l = u == r.length ? 1e9 : r[u++]; c < l || c == l && s.len == 0; ) {
          if (s.done)
            break t;
          var f = Math.min(s.len, l - c);
          jr(a, f, -1);
          var h = s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0;
          jr(i, f, h), h > 0 && Xo(o, i, s.text), s.forward(f), c += f;
        }
        for (var d = r[u++]; c < d; ) {
          if (s.done)
            break t;
          var p = Math.min(s.len, d - c);
          jr(i, p, -1), jr(a, p, s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0), s.forward(p), c += p;
        }
      }
    return { changes: new n(i, o), filtered: As.create(a) };
  } }, { key: "toJSON", value: function() {
    for (var r = [], i = 0; i < this.sections.length; i += 2) {
      var o = this.sections[i], a = this.sections[i + 1];
      a < 0 ? r.push(o) : a == 0 ? r.push([o]) : r.push([o].concat(this.inserted[i >> 1].toJSON()));
    }
    return r;
  } }], [{ key: "of", value: function(r, i, o) {
    var a = [], s = [], u = 0, c = null;
    function l() {
      var f = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (f || a.length) {
        u < i && jr(a, i - u, -1);
        var h = new n(a, s);
        c = c ? c.compose(h.map(c)) : h, a = [], s = [], u = 0;
      }
    }
    return function f(h) {
      if (Array.isArray(h)) {
        var d, p = ut(h);
        try {
          for (p.s(); !(d = p.n()).done; )
            f(d.value);
        } catch (w) {
          p.e(w);
        } finally {
          p.f();
        }
      } else if (h instanceof n) {
        if (h.length != i)
          throw new RangeError("Mismatched change set length (got ".concat(h.length, ", expected ").concat(i, ")"));
        l(), c = c ? c.compose(h.map(c)) : h;
      } else {
        var v = h.from, m = h.to, g = m === void 0 ? v : m, y = h.insert;
        if (v > g || v < 0 || g > i)
          throw new RangeError("Invalid change range ".concat(v, " to ").concat(g, " (in doc of length ").concat(i, ")"));
        var b = y ? typeof y == "string" ? xn.of(y.split(o || gp)) : y : xn.empty, k = b.length;
        if (v == g && k == 0)
          return;
        v < u && l(), v > u && jr(a, v - u, -1), jr(a, g - v, k), Xo(s, a, b), u = g;
      }
    }(r), l(!c), c;
  } }, { key: "empty", value: function(r) {
    return new n(r ? [r, -1] : [], []);
  } }, { key: "fromJSON", value: function(r) {
    if (!Array.isArray(r))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    for (var i = [], o = [], a = 0; a < r.length; a++) {
      var s = r[a];
      if (typeof s == "number")
        i.push(s, -1);
      else {
        if (!Array.isArray(s) || typeof s[0] != "number" || s.some(function(u, c) {
          return c && typeof u != "string";
        }))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (s.length == 1)
          i.push(s[0], 0);
        else {
          for (; o.length < a; )
            o.push(xn.empty);
          o[a] = xn.of(s.slice(1)), i.push(s[0], o[a].length);
        }
      }
    }
    return new n(i, o);
  } }, { key: "createSet", value: function(r, i) {
    return new n(r, i);
  } }]), n;
}();
function jr(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
  if (!(t == 0 && n <= 0)) {
    var i = e.length - 2;
    i >= 0 && n <= 0 && n == e[i + 1] ? e[i] += t : t == 0 && e[i] == 0 ? e[i + 1] += n : r ? (e[i] += t, e[i + 1] += n) : e.push(t, n);
  }
}
function Xo(e, t, n) {
  if (n.length != 0) {
    var r = t.length - 2 >> 1;
    if (r < e.length)
      e[e.length - 1] = e[e.length - 1].append(n);
    else {
      for (; e.length < r; )
        e.push(xn.empty);
      e.push(n);
    }
  }
}
function yp(e, t, n) {
  for (var r = e.inserted, i = 0, o = 0, a = 0; a < e.sections.length; ) {
    var s = e.sections[a++], u = e.sections[a++];
    if (u < 0)
      i += s, o += s;
    else {
      for (var c = i, l = o, f = xn.empty; c += s, l += u, u && r && (f = f.append(r[a - 2 >> 1])), !(n || a == e.sections.length || e.sections[a + 1] < 0); )
        s = e.sections[a++], u = e.sections[a++];
      t(i, c, o, l, f), i = c, o = l;
    }
  }
}
function bp(e, t, n) {
  for (var r = arguments.length > 3 && arguments[3] !== void 0 && arguments[3], i = [], o = r ? [] : null, a = new lc(e), s = new lc(t), u = -1; ; )
    if (a.ins == -1 && s.ins == -1) {
      var c = Math.min(a.len, s.len);
      jr(i, c, -1), a.forward(c), s.forward(c);
    } else if (s.ins >= 0 && (a.ins < 0 || u == a.i || a.off == 0 && (s.len < a.len || s.len == a.len && !n))) {
      var l = s.len;
      for (jr(i, s.ins, -1); l; ) {
        var f = Math.min(a.len, l);
        a.ins >= 0 && u < a.i && a.len <= f && (jr(i, 0, a.ins), o && Xo(o, i, a.text), u = a.i), a.forward(f), l -= f;
      }
      s.next();
    } else {
      if (!(a.ins >= 0)) {
        if (a.done && s.done)
          return o ? qi.createSet(i, o) : As.create(i);
        throw new Error("Mismatched change set lengths");
      }
      for (var h = 0, d = a.len; d; )
        if (s.ins == -1) {
          var p = Math.min(d, s.len);
          h += p, d -= p, s.forward(p);
        } else {
          if (!(s.ins == 0 && s.len < d))
            break;
          d -= s.len, s.next();
        }
      jr(i, h, u < a.i ? a.ins : 0), o && u < a.i && Xo(o, i, a.text), u = a.i, a.forward(a.len - d);
    }
}
function $A(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], r = [], i = n ? [] : null, o = new lc(e), a = new lc(t), s = !1; ; ) {
    if (o.done && a.done)
      return i ? qi.createSet(r, i) : As.create(r);
    if (o.ins == 0)
      jr(r, o.len, 0, s), o.next();
    else if (a.len != 0 || a.done) {
      if (o.done || a.done)
        throw new Error("Mismatched change set lengths");
      var u = Math.min(o.len2, a.len), c = r.length;
      if (o.ins == -1) {
        var l = a.ins == -1 ? -1 : a.off ? 0 : a.ins;
        jr(r, u, l, s), i && l && Xo(i, r, a.text);
      } else
        a.ins == -1 ? (jr(r, o.off ? 0 : o.len, u, s), i && Xo(i, r, o.textBit(u))) : (jr(r, o.off ? 0 : o.len, a.off ? 0 : a.ins, s), i && !a.off && Xo(i, r, a.text));
      s = (o.ins > u || a.ins >= 0 && a.len > u) && (s || r.length > c), o.forward2(u), a.forward(u);
    } else
      jr(r, 0, a.ins, s), i && Xo(i, r, a.text), a.next();
  }
}
var lc = function() {
  function e(t) {
    Z(this, e), this.set = t, this.i = 0, this.next();
  }
  return Y(e, [{ key: "next", value: function() {
    var t = this.set.sections;
    this.i < t.length ? (this.len = t[this.i++], this.ins = t[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  } }, { key: "done", get: function() {
    return this.ins == -2;
  } }, { key: "len2", get: function() {
    return this.ins < 0 ? this.len : this.ins;
  } }, { key: "text", get: function() {
    var t = this.set.inserted, n = this.i - 2 >> 1;
    return n >= t.length ? xn.empty : t[n];
  } }, { key: "textBit", value: function(t) {
    var n = this.set.inserted, r = this.i - 2 >> 1;
    return r >= n.length && !t ? xn.empty : n[r].slice(this.off, t == null ? void 0 : this.off + t);
  } }, { key: "forward", value: function(t) {
    t == this.len ? this.next() : (this.len -= t, this.off += t);
  } }, { key: "forward2", value: function(t) {
    this.ins == -1 ? this.forward(t) : t == this.ins ? this.next() : (this.ins -= t, this.off += t);
  } }]), e;
}(), Sl = function() {
  function e(t, n, r) {
    Z(this, e), this.from = t, this.to = n, this.flags = r;
  }
  return Y(e, [{ key: "anchor", get: function() {
    return 16 & this.flags ? this.to : this.from;
  } }, { key: "head", get: function() {
    return 16 & this.flags ? this.from : this.to;
  } }, { key: "empty", get: function() {
    return this.from == this.to;
  } }, { key: "assoc", get: function() {
    return 4 & this.flags ? -1 : 8 & this.flags ? 1 : 0;
  } }, { key: "bidiLevel", get: function() {
    var t = 3 & this.flags;
    return t == 3 ? null : t;
  } }, { key: "goalColumn", get: function() {
    var t = this.flags >> 5;
    return t == 33554431 ? void 0 : t;
  } }, { key: "map", value: function(t) {
    var n, r, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
    return this.empty ? n = r = t.mapPos(this.from, i) : (n = t.mapPos(this.from, 1), r = t.mapPos(this.to, -1)), n == this.from && r == this.to ? this : new e(n, r, this.flags);
  } }, { key: "extend", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t;
    if (t <= this.anchor && n >= this.anchor)
      return Ht.range(t, n);
    var r = Math.abs(t - this.anchor) > Math.abs(n - this.anchor) ? t : n;
    return Ht.range(this.anchor, r);
  } }, { key: "eq", value: function(t) {
    return this.anchor == t.anchor && this.head == t.head;
  } }, { key: "toJSON", value: function() {
    return { anchor: this.anchor, head: this.head };
  } }], [{ key: "fromJSON", value: function(t) {
    if (!t || typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return Ht.range(t.anchor, t.head);
  } }, { key: "create", value: function(t, n, r) {
    return new e(t, n, r);
  } }]), e;
}(), Ht = function() {
  function e(t, n) {
    Z(this, e), this.ranges = t, this.mainIndex = n;
  }
  return Y(e, [{ key: "map", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
    return t.empty ? this : e.create(this.ranges.map(function(r) {
      return r.map(t, n);
    }), this.mainIndex);
  } }, { key: "eq", value: function(t) {
    if (this.ranges.length != t.ranges.length || this.mainIndex != t.mainIndex)
      return !1;
    for (var n = 0; n < this.ranges.length; n++)
      if (!this.ranges[n].eq(t.ranges[n]))
        return !1;
    return !0;
  } }, { key: "main", get: function() {
    return this.ranges[this.mainIndex];
  } }, { key: "asSingle", value: function() {
    return this.ranges.length == 1 ? this : new e([this.main], 0);
  } }, { key: "addRange", value: function(t) {
    var n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
    return e.create([t].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  } }, { key: "replaceRange", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.mainIndex, r = this.ranges.slice();
    return r[n] = t, e.create(r, this.mainIndex);
  } }, { key: "toJSON", value: function() {
    return { ranges: this.ranges.map(function(t) {
      return t.toJSON();
    }), main: this.mainIndex };
  } }], [{ key: "fromJSON", value: function(t) {
    if (!t || !Array.isArray(t.ranges) || typeof t.main != "number" || t.main >= t.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new e(t.ranges.map(function(n) {
      return Sl.fromJSON(n);
    }), t.main);
  } }, { key: "single", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t;
    return new e([e.range(t, n)], 0);
  } }, { key: "create", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (t.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (var r = 0, i = 0; i < t.length; i++) {
      var o = t[i];
      if (o.empty ? o.from <= r : o.from < r)
        return e.normalized(t.slice(), n);
      r = o.to;
    }
    return new e(t, n);
  } }, { key: "cursor", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0;
    return Sl.create(t, t, (n == 0 ? 0 : n < 0 ? 4 : 8) | (r == null ? 3 : Math.min(2, r)) | (i != null ? i : 33554431) << 5);
  } }, { key: "range", value: function(t, n, r) {
    var i = (r != null ? r : 33554431) << 5;
    return n < t ? Sl.create(n, t, 24 | i) : Sl.create(t, n, i | (n > t ? 4 : 0));
  } }, { key: "normalized", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = t[n];
    t.sort(function(c, l) {
      return c.from - l.from;
    }), n = t.indexOf(r);
    for (var i = 1; i < t.length; i++) {
      var o = t[i], a = t[i - 1];
      if (o.empty ? o.from <= a.to : o.from < a.to) {
        var s = a.from, u = Math.max(o.to, a.to);
        i <= n && n--, t.splice(--i, 2, o.anchor > o.head ? e.range(u, s) : e.range(s, u));
      }
    }
    return new e(t, n);
  } }]), e;
}();
function _A(e, t) {
  var n, r = ut(e.ranges);
  try {
    for (r.s(); !(n = r.n()).done; )
      if (n.value.to > t)
        throw new RangeError("Selection points outside of document");
  } catch (i) {
    r.e(i);
  } finally {
    r.f();
  }
}
var f0 = 0, be = function() {
  function e(t, n, r, i, o) {
    Z(this, e), this.combine = t, this.compareInput = n, this.compare = r, this.isStatic = i, this.id = f0++, this.default = t([]), this.extensions = typeof o == "function" ? o(this) : o;
  }
  return Y(e, [{ key: "of", value: function(t) {
    return new of([], this, 0, t);
  } }, { key: "compute", value: function(t, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new of(t, this, 1, n);
  } }, { key: "computeN", value: function(t, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new of(t, this, 2, n);
  } }, { key: "from", value: function(t, n) {
    return n || (n = function(r) {
      return r;
    }), this.compute([t], function(r) {
      return n(r.field(t));
    });
  } }], [{ key: "define", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new e(t.combine || function(n) {
      return n;
    }, t.compareInput || function(n, r) {
      return n === r;
    }, t.compare || (t.combine ? function(n, r) {
      return n === r;
    } : kp), !!t.static, t.enables);
  } }]), e;
}();
function kp(e, t) {
  return e == t || e.length == t.length && e.every(function(n, r) {
    return n === t[r];
  });
}
var of = function() {
  function e(t, n, r, i) {
    Z(this, e), this.dependencies = t, this.facet = n, this.type = r, this.value = i, this.id = f0++;
  }
  return Y(e, [{ key: "dynamicSlot", value: function(t) {
    var n, r, i = this, o = this.value, a = this.facet.compareInput, s = this.id, u = t[s] >> 1, c = this.type == 2, l = !1, f = !1, h = [], d = ut(this.dependencies);
    try {
      for (d.s(); !(r = d.n()).done; ) {
        var p = r.value;
        p == "doc" ? l = !0 : p == "selection" ? f = !0 : (1 & ((n = t[p.id]) !== null && n !== void 0 ? n : 1)) == 0 && h.push(t[p.id]);
      }
    } catch (v) {
      d.e(v);
    } finally {
      d.f();
    }
    return { create: function(v) {
      return v.values[u] = o(v), 1;
    }, update: function(v, m) {
      if (l && m.docChanged || f && (m.docChanged || m.selection) || wp(v, h)) {
        var g = o(v);
        if (c ? !jj(g, v.values[u], a) : !a(g, v.values[u]))
          return v.values[u] = g, 1;
      }
      return 0;
    }, reconfigure: function(v, m) {
      var g = o(v), y = m.config.address[s];
      if (y != null) {
        var b = qf(m, y);
        if (i.dependencies.every(function(k) {
          return k instanceof be ? m.facet(k) === v.facet(k) : !(k instanceof br) || m.field(k, !1) == v.field(k, !1);
        }) || (c ? jj(g, b, a) : a(g, b)))
          return v.values[u] = b, 0;
      }
      return v.values[u] = g, 1;
    } };
  } }]), e;
}();
function jj(e, t, n) {
  if (e.length != t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!n(e[r], t[r]))
      return !1;
  return !0;
}
function wp(e, t) {
  var n, r = !1, i = ut(t);
  try {
    for (i.s(); !(n = i.n()).done; )
      1 & Ku(e, n.value) && (r = !0);
  } catch (o) {
    i.e(o);
  } finally {
    i.f();
  }
  return r;
}
var Sj = be.define({ static: !0 }), br = function() {
  function e(t, n, r, i, o) {
    Z(this, e), this.id = t, this.createF = n, this.updateF = r, this.compareF = i, this.spec = o, this.provides = void 0;
  }
  return Y(e, [{ key: "create", value: function(t) {
    var n = this, r = t.facet(Sj).find(function(i) {
      return i.field == n;
    });
    return ((r == null ? void 0 : r.create) || this.createF)(t);
  } }, { key: "slot", value: function(t) {
    var n = this, r = t[this.id] >> 1;
    return { create: function(i) {
      return i.values[r] = n.create(i), 1;
    }, update: function(i, o) {
      var a = i.values[r], s = n.updateF(a, o);
      return n.compareF(a, s) ? 0 : (i.values[r] = s, 1);
    }, reconfigure: function(i, o) {
      return o.config.address[n.id] != null ? (i.values[r] = o.field(n), 0) : (i.values[r] = n.create(i), 1);
    } };
  } }, { key: "init", value: function(t) {
    return [this, Sj.of({ field: this, create: t })];
  } }, { key: "extension", get: function() {
    return this;
  } }], [{ key: "define", value: function(t) {
    var n = new e(f0++, t.create, t.update, t.compare || function(r, i) {
      return r === i;
    }, t);
    return t.provide && (n.provides = t.provide(n)), n;
  } }]), e;
}(), sV = 4, uV = 3, CA = 2, cV = 1;
function Cu(e) {
  return function(t) {
    return new OA(t, e);
  };
}
var Qc = { highest: Cu(0), high: Cu(cV), default: Cu(CA), low: Cu(uV), lowest: Cu(sV) }, OA = Y(function e(t, n) {
  Z(this, e), this.inner = t, this.prec = n;
}), Ju = function() {
  function e() {
    Z(this, e);
  }
  return Y(e, [{ key: "of", value: function(t) {
    return new xp(this, t);
  } }, { key: "reconfigure", value: function(t) {
    return e.reconfigure.of({ compartment: this, extension: t });
  } }, { key: "get", value: function(t) {
    return t.config.compartments.get(this);
  } }]), e;
}(), xp = Y(function e(t, n) {
  Z(this, e), this.compartment = t, this.inner = n;
}), $j = function() {
  function e(t, n, r, i, o, a) {
    for (Z(this, e), this.base = t, this.compartments = n, this.dynamicSlots = r, this.address = i, this.staticValues = o, this.facets = a, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(0);
  }
  return Y(e, [{ key: "staticFacet", value: function(t) {
    var n = this.address[t.id];
    return n == null ? t.default : this.staticValues[n >> 1];
  } }], [{ key: "resolve", value: function(t, n, r) {
    var i, o = [], a = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ new Map(), u = ut(function(b, k, w) {
      var x = [[], [], [], [], []], S = /* @__PURE__ */ new Map();
      function T(P, O) {
        var j = S.get(P);
        if (j != null) {
          if (j <= O)
            return;
          var V = x[j].indexOf(P);
          V > -1 && x[j].splice(V, 1), P instanceof xp && w.delete(P.compartment);
        }
        if (S.set(P, O), Array.isArray(P)) {
          var E, C = ut(P);
          try {
            for (C.s(); !(E = C.n()).done; )
              T(E.value, O);
          } catch (F) {
            C.e(F);
          } finally {
            C.f();
          }
        } else if (P instanceof xp) {
          if (w.has(P.compartment))
            throw new RangeError("Duplicate use of compartment in extensions");
          var H = k.get(P.compartment) || P.inner;
          w.set(P.compartment, H), T(H, O);
        } else if (P instanceof OA)
          T(P.inner, P.prec);
        else if (P instanceof br)
          x[O].push(P), P.provides && T(P.provides, O);
        else if (P instanceof of)
          x[O].push(P), P.facet.extensions && T(P.facet.extensions, O);
        else {
          var X = P.extension;
          if (!X)
            throw new Error("Unrecognized extension value in extension set (".concat(P, "). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks."));
          T(X, O);
        }
      }
      return T(b, CA), x.reduce(function(P, O) {
        return P.concat(O);
      });
    }(t, n, s));
    try {
      for (u.s(); !(i = u.n()).done; ) {
        var c = i.value;
        c instanceof br ? o.push(c) : (a[c.facet.id] || (a[c.facet.id] = [])).push(c);
      }
    } catch (b) {
      u.e(b);
    } finally {
      u.f();
    }
    for (var l = /* @__PURE__ */ Object.create(null), f = [], h = [], d = function() {
      var b = v[p];
      l[b.id] = h.length << 1, h.push(function(k) {
        return b.slot(k);
      });
    }, p = 0, v = o; p < v.length; p++)
      d();
    var m = r == null ? void 0 : r.config.facets, g = function(b) {
      var k = a[b], w = k[0].facet, x = m && m[b] || [];
      if (k.every(function(j) {
        return j.type == 0;
      }))
        if (l[w.id] = f.length << 1 | 1, kp(x, k))
          f.push(r.facet(w));
        else {
          var S = w.combine(k.map(function(j) {
            return j.value;
          }));
          f.push(r && w.compare(S, r.facet(w)) ? r.facet(w) : S);
        }
      else {
        var T, P = ut(k);
        try {
          var O = function() {
            var j = T.value;
            j.type == 0 ? (l[j.id] = f.length << 1 | 1, f.push(j.value)) : (l[j.id] = h.length << 1, h.push(function(V) {
              return j.dynamicSlot(V);
            }));
          };
          for (P.s(); !(T = P.n()).done; )
            O();
        } catch (j) {
          P.e(j);
        } finally {
          P.f();
        }
        l[w.id] = h.length << 1, h.push(function(j) {
          return function(V, E, C) {
            var H = C.map(function($) {
              return V[$.id];
            }), X = C.map(function($) {
              return $.type;
            }), F = H.filter(function($) {
              return !(1 & $);
            }), G = V[E.id] >> 1;
            function M($) {
              for (var q = [], B = 0; B < H.length; B++) {
                var D = qf($, H[B]);
                if (X[B] == 2) {
                  var _, L = ut(D);
                  try {
                    for (L.s(); !(_ = L.n()).done; ) {
                      var J = _.value;
                      q.push(J);
                    }
                  } catch (st) {
                    L.e(st);
                  } finally {
                    L.f();
                  }
                } else
                  q.push(D);
              }
              return E.combine(q);
            }
            return { create: function($) {
              var q, B = ut(H);
              try {
                for (B.s(); !(q = B.n()).done; )
                  Ku($, q.value);
              } catch (D) {
                B.e(D);
              } finally {
                B.f();
              }
              return $.values[G] = M($), 1;
            }, update: function($, q) {
              if (!wp($, F))
                return 0;
              var B = M($);
              return E.compare(B, $.values[G]) ? 0 : ($.values[G] = B, 1);
            }, reconfigure: function($, q) {
              var B = wp($, H), D = q.config.facets[E.id], _ = q.facet(E);
              if (D && !B && kp(C, D))
                return $.values[G] = _, 0;
              var L = M($);
              return E.compare(L, _) ? ($.values[G] = _, 0) : ($.values[G] = L, 1);
            } };
          }(j, w, k);
        });
      }
    };
    for (var y in a)
      g(y);
    return new e(t, s, h.map(function(b) {
      return b(l);
    }), l, f, a);
  } }]), e;
}();
function Ku(e, t) {
  if (1 & t)
    return 2;
  var n = t >> 1, r = e.status[n];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (2 & r)
    return r;
  e.status[n] = 4;
  var i = e.computeSlot(e, e.config.dynamicSlots[n]);
  return e.status[n] = 2 | i;
}
function qf(e, t) {
  return 1 & t ? e.config.staticValues[t >> 1] : e.values[t >> 1];
}
var AA = be.define(), PA = be.define({ combine: function(e) {
  return e.some(function(t) {
    return t;
  });
}, static: !0 }), EA = be.define({ combine: function(e) {
  return e.length ? e[0] : void 0;
}, static: !0 }), MA = be.define(), TA = be.define(), IA = be.define(), NA = be.define({ combine: function(e) {
  return !!e.length && e[0];
} }), Ma = function() {
  function e(t, n) {
    Z(this, e), this.type = t, this.value = n;
  }
  return Y(e, null, [{ key: "define", value: function() {
    return new lV();
  } }]), e;
}(), lV = function() {
  function e() {
    Z(this, e);
  }
  return Y(e, [{ key: "of", value: function(t) {
    return new Ma(this, t);
  } }]), e;
}(), fV = function() {
  function e(t) {
    Z(this, e), this.map = t;
  }
  return Y(e, [{ key: "of", value: function(t) {
    return new He(this, t);
  } }]), e;
}(), He = function() {
  function e(t, n) {
    Z(this, e), this.type = t, this.value = n;
  }
  return Y(e, [{ key: "map", value: function(t) {
    var n = this.type.map(this.value, t);
    return n === void 0 ? void 0 : n == this.value ? this : new e(this.type, n);
  } }, { key: "is", value: function(t) {
    return this.type == t;
  } }], [{ key: "define", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new fV(t.map || function(n) {
      return n;
    });
  } }, { key: "mapEffects", value: function(t, n) {
    if (!t.length)
      return t;
    var r, i = [], o = ut(t);
    try {
      for (o.s(); !(r = o.n()).done; ) {
        var a = r.value.map(n);
        a && i.push(a);
      }
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
    return i;
  } }]), e;
}();
He.reconfigure = He.define(), He.appendConfig = He.define();
var Fr = function() {
  function e(t, n, r, i, o, a) {
    Z(this, e), this.startState = t, this.changes = n, this.selection = r, this.effects = i, this.annotations = o, this.scrollIntoView = a, this._doc = null, this._state = null, r && _A(r, n.newLength), o.some(function(s) {
      return s.type == e.time;
    }) || (this.annotations = o.concat(e.time.of(Date.now())));
  }
  return Y(e, [{ key: "newDoc", get: function() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  } }, { key: "newSelection", get: function() {
    return this.selection || this.startState.selection.map(this.changes);
  } }, { key: "state", get: function() {
    return this._state || this.startState.applyTransaction(this), this._state;
  } }, { key: "annotation", value: function(t) {
    var n, r = ut(this.annotations);
    try {
      for (r.s(); !(n = r.n()).done; ) {
        var i = n.value;
        if (i.type == t)
          return i.value;
      }
    } catch (o) {
      r.e(o);
    } finally {
      r.f();
    }
  } }, { key: "docChanged", get: function() {
    return !this.changes.empty;
  } }, { key: "reconfigured", get: function() {
    return this.startState.config != this.state.config;
  } }, { key: "isUserEvent", value: function(t) {
    var n = this.annotation(e.userEvent);
    return !(!n || !(n == t || n.length > t.length && n.slice(0, t.length) == t && n[t.length] == "."));
  } }], [{ key: "create", value: function(t, n, r, i, o, a) {
    return new e(t, n, r, i, o, a);
  } }]), e;
}();
function hV(e, t) {
  for (var n = [], r = 0, i = 0; ; ) {
    var o = void 0, a = void 0;
    if (r < e.length && (i == t.length || t[i] >= e[r]))
      o = e[r++], a = e[r++];
    else {
      if (!(i < t.length))
        return n;
      o = t[i++], a = t[i++];
    }
    !n.length || n[n.length - 1] < o ? n.push(o, a) : n[n.length - 1] < a && (n[n.length - 1] = a);
  }
}
function _j(e, t, n) {
  var r, i, o, a;
  return n ? (i = t.changes, o = qi.empty(t.changes.length), a = e.changes.compose(t.changes)) : (i = t.changes.map(e.changes), o = e.changes.mapDesc(t.changes, !0), a = e.changes.compose(i)), { changes: a, selection: t.selection ? t.selection.map(o) : (r = e.selection) === null || r === void 0 ? void 0 : r.map(i), effects: He.mapEffects(e.effects, i).concat(He.mapEffects(t.effects, o)), annotations: e.annotations.length ? e.annotations.concat(t.annotations) : t.annotations, scrollIntoView: e.scrollIntoView || t.scrollIntoView };
}
function Vd(e, t, n) {
  var r = t.selection, i = Ps(t.annotations);
  return t.userEvent && (i = i.concat(Fr.userEvent.of(t.userEvent))), { changes: t.changes instanceof qi ? t.changes : qi.of(t.changes || [], n, e.facet(EA)), selection: r && (r instanceof Ht ? r : Ht.single(r.anchor, r.head)), effects: Ps(t.effects), annotations: i, scrollIntoView: !!t.scrollIntoView };
}
function RA(e, t, n) {
  var r = Vd(e, t.length ? t[0] : {}, e.doc.length);
  t.length && t[0].filter === !1 && (n = !1);
  for (var i = 1; i < t.length; i++) {
    t[i].filter === !1 && (n = !1);
    var o = !!t[i].sequential;
    r = _j(r, Vd(e, t[i], o ? r.changes.newLength : e.doc.length), o);
  }
  var a = Fr.create(e, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return function(s) {
    for (var u = s.startState, c = u.facet(IA), l = s, f = c.length - 1; f >= 0; f--) {
      var h = c[f](s);
      h && Object.keys(h).length && (l = _j(s, Vd(u, h, s.changes.newLength), !0));
    }
    return l == s ? s : Fr.create(u, s.changes, s.selection, l.effects, l.annotations, l.scrollIntoView);
  }(n ? function(s) {
    var u, c = s.startState, l = !0, f = ut(c.facet(MA));
    try {
      for (f.s(); !(u = f.n()).done; ) {
        var h = (0, u.value)(s);
        if (h === !1) {
          l = !1;
          break;
        }
        Array.isArray(h) && (l = l === !0 ? h : hV(l, h));
      }
    } catch (b) {
      f.e(b);
    } finally {
      f.f();
    }
    if (l !== !0) {
      var d, p;
      if (l === !1)
        p = s.changes.invertedDesc, d = qi.empty(c.doc.length);
      else {
        var v = s.changes.filter(l);
        d = v.changes, p = v.filtered.mapDesc(v.changes).invertedDesc;
      }
      s = Fr.create(c, d, s.selection && s.selection.map(p), He.mapEffects(s.effects, p), s.annotations, s.scrollIntoView);
    }
    for (var m = c.facet(TA), g = m.length - 1; g >= 0; g--) {
      var y = m[g](s);
      s = y instanceof Fr ? y : Array.isArray(y) && y.length == 1 && y[0] instanceof Fr ? y[0] : RA(c, Ps(y), !1);
    }
    return s;
  }(a) : a);
}
Fr.time = Ma.define(), Fr.userEvent = Ma.define(), Fr.addToHistory = Ma.define(), Fr.remote = Ma.define();
var dV = [];
function Ps(e) {
  return e == null ? dV : Array.isArray(e) ? e : [e];
}
var jp, Nr = function(e) {
  return e[e.Word = 0] = "Word", e[e.Space = 1] = "Space", e[e.Other = 2] = "Other", e;
}(Nr || (Nr = {})), vV = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
try {
  jp = new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function pV(e) {
  return function(t) {
    if (!/\S/.test(t))
      return Nr.Space;
    if (function(r) {
      if (jp)
        return jp.test(r);
      for (var i = 0; i < r.length; i++) {
        var o = r[i];
        if (/\w/.test(o) || o > "\x80" && (o.toUpperCase() != o.toLowerCase() || vV.test(o)))
          return !0;
      }
      return !1;
    }(t))
      return Nr.Word;
    for (var n = 0; n < e.length; n++)
      if (t.indexOf(e[n]) > -1)
        return Nr.Word;
    return Nr.Other;
  };
}
var In = function() {
  function e(t, n, r, i, o, a) {
    Z(this, e), this.config = t, this.doc = n, this.selection = r, this.values = i, this.status = t.statusTemplate.slice(), this.computeSlot = o, a && (a._state = this);
    for (var s = 0; s < this.config.dynamicSlots.length; s++)
      Ku(this, s << 1);
    this.computeSlot = null;
  }
  return Y(e, [{ key: "field", value: function(t) {
    var n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], r = this.config.address[t.id];
    if (r != null)
      return Ku(this, r), qf(this, r);
    if (n)
      throw new RangeError("Field is not present in this state");
  } }, { key: "update", value: function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return RA(this, n, !0);
  } }, { key: "applyTransaction", value: function(t) {
    var n, r, i = this, o = this.config, a = o, s = a.base, u = a.compartments, c = ut(t.effects);
    try {
      for (c.s(); !(n = c.n()).done; ) {
        var l = n.value;
        l.is(Ju.reconfigure) ? (o && (u = /* @__PURE__ */ new Map(), o.compartments.forEach(function(f, h) {
          return u.set(h, f);
        }), o = null), u.set(l.value.compartment, l.value.extension)) : l.is(He.reconfigure) ? (o = null, s = l.value) : l.is(He.appendConfig) && (o = null, s = Ps(s).concat(l.value));
      }
    } catch (f) {
      c.e(f);
    } finally {
      c.f();
    }
    o ? r = t.startState.values.slice() : r = new e(o = $j.resolve(s, u, this), this.doc, this.selection, o.dynamicSlots.map(function() {
      return null;
    }), function(f, h) {
      return h.reconfigure(f, i);
    }, null).values, new e(o, t.newDoc, t.newSelection, r, function(f, h) {
      return h.update(f, t);
    }, t);
  } }, { key: "replaceSelection", value: function(t) {
    return typeof t == "string" && (t = this.toText(t)), this.changeByRange(function(n) {
      return { changes: { from: n.from, to: n.to, insert: t }, range: Ht.cursor(n.from + t.length) };
    });
  } }, { key: "changeByRange", value: function(t) {
    for (var n = this.selection, r = t(n.ranges[0]), i = this.changes(r.changes), o = [r.range], a = Ps(r.effects), s = 1; s < n.ranges.length; s++) {
      for (var u = t(n.ranges[s]), c = this.changes(u.changes), l = c.map(i), f = 0; f < s; f++)
        o[f] = o[f].map(l);
      var h = i.mapDesc(c, !0);
      o.push(u.range.map(h)), i = i.compose(l), a = He.mapEffects(a, l).concat(He.mapEffects(Ps(u.effects), h));
    }
    return { changes: i, selection: Ht.create(o, n.mainIndex), effects: a };
  } }, { key: "changes", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return t instanceof qi ? t : qi.of(t, this.doc.length, this.facet(e.lineSeparator));
  } }, { key: "toText", value: function(t) {
    return xn.of(t.split(this.facet(e.lineSeparator) || gp));
  } }, { key: "sliceDoc", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.doc.length;
    return this.doc.sliceString(t, n, this.lineBreak);
  } }, { key: "facet", value: function(t) {
    var n = this.config.address[t.id];
    return n == null ? t.default : (Ku(this, n), qf(this, n));
  } }, { key: "toJSON", value: function(t) {
    var n = { doc: this.sliceDoc(), selection: this.selection.toJSON() };
    if (t)
      for (var r in t) {
        var i = t[r];
        i instanceof br && this.config.address[i.id] != null && (n[r] = i.spec.toJSON(this.field(t[r]), this));
      }
    return n;
  } }, { key: "tabSize", get: function() {
    return this.facet(e.tabSize);
  } }, { key: "lineBreak", get: function() {
    return this.facet(e.lineSeparator) || `
`;
  } }, { key: "readOnly", get: function() {
    return this.facet(NA);
  } }, { key: "phrase", value: function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    var o, a = ut(this.facet(e.phrases));
    try {
      for (a.s(); !(o = a.n()).done; ) {
        var s = o.value;
        if (Object.prototype.hasOwnProperty.call(s, t)) {
          t = s[t];
          break;
        }
      }
    } catch (u) {
      a.e(u);
    } finally {
      a.f();
    }
    return r.length && (t = t.replace(/\$(\$|\d*)/g, function(u, c) {
      if (c == "$")
        return "$";
      var l = +(c || 1);
      return !l || l > r.length ? u : r[l - 1];
    })), t;
  } }, { key: "languageDataAt", value: function(t, n) {
    var r, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, o = [], a = ut(this.facet(AA));
    try {
      for (a.s(); !(r = a.n()).done; ) {
        var s, u = r.value, c = ut(u(this, n, i));
        try {
          for (c.s(); !(s = c.n()).done; ) {
            var l = s.value;
            Object.prototype.hasOwnProperty.call(l, t) && o.push(l[t]);
          }
        } catch (f) {
          c.e(f);
        } finally {
          c.f();
        }
      }
    } catch (f) {
      a.e(f);
    } finally {
      a.f();
    }
    return o;
  } }, { key: "charCategorizer", value: function(t) {
    return pV(this.languageDataAt("wordChars", t).join(""));
  } }, { key: "wordAt", value: function(t) {
    for (var n = this.doc.lineAt(t), r = n.text, i = n.from, o = n.length, a = this.charCategorizer(t), s = t - i, u = t - i; s > 0; ) {
      var c = Xr(r, s, !1);
      if (a(r.slice(c, s)) != Nr.Word)
        break;
      s = c;
    }
    for (; u < o; ) {
      var l = Xr(r, u);
      if (a(r.slice(u, l)) != Nr.Word)
        break;
      u = l;
    }
    return s == u ? null : Ht.range(s + i, u + i);
  } }], [{ key: "fromJSON", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
    if (!t || typeof t.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    var i = [];
    if (r)
      for (var o in r)
        Object.prototype.hasOwnProperty.call(t, o) && function() {
          var a = r[o], s = t[o];
          i.push(a.init(function(u) {
            return a.spec.fromJSON(s, u);
          }));
        }();
    return e.create({ doc: t.doc, selection: Ht.fromJSON(t.selection), extensions: n.extensions ? i.concat([n.extensions]) : i });
  } }, { key: "create", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = $j.resolve(t.extensions || [], /* @__PURE__ */ new Map()), r = t.doc instanceof xn ? t.doc : xn.of((t.doc || "").split(n.staticFacet(e.lineSeparator) || gp)), i = t.selection ? t.selection instanceof Ht ? t.selection : Ht.single(t.selection.anchor, t.selection.head) : Ht.single(0);
    return _A(i, r.length), n.staticFacet(PA) || (i = i.asSingle()), new e(n, r, i, n.dynamicSlots.map(function() {
      return null;
    }), function(o, a) {
      return a.create(o);
    }, null);
  } }]), e;
}();
function ko(e, t) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = {}, o = ut(e);
  try {
    for (o.s(); !(n = o.n()).done; )
      for (var a = n.value, s = 0, u = Object.keys(a); s < u.length; s++) {
        var c = u[s], l = a[c], f = i[c];
        if (f === void 0)
          i[c] = l;
        else if (!(f === l || l === void 0)) {
          if (!Object.hasOwnProperty.call(r, c))
            throw new Error("Config merge conflict for field " + c);
          i[c] = r[c](f, l);
        }
      }
  } catch (d) {
    o.e(d);
  } finally {
    o.f();
  }
  for (var h in t)
    i[h] === void 0 && (i[h] = t[h]);
  return i;
}
In.allowMultipleSelections = PA, In.tabSize = be.define({ combine: function(e) {
  return e.length ? e[0] : 4;
} }), In.lineSeparator = EA, In.readOnly = NA, In.phrases = be.define({ compare: function(e, t) {
  var n = Object.keys(e), r = Object.keys(t);
  return n.length == r.length && n.every(function(i) {
    return e[i] == t[i];
  });
} }), In.languageData = AA, In.changeFilter = MA, In.transactionFilter = TA, In.transactionExtender = IA, Ju.reconfigure = He.define();
var Ta = function() {
  function e() {
    Z(this, e);
  }
  return Y(e, [{ key: "eq", value: function(t) {
    return this == t;
  } }, { key: "range", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t;
    return Sp.create(t, n, this);
  } }]), e;
}();
Ta.prototype.startSide = Ta.prototype.endSide = 0, Ta.prototype.point = !1, Ta.prototype.mapMode = Ir.TrackDel;
var Sp = function() {
  function e(t, n, r) {
    Z(this, e), this.from = t, this.to = n, this.value = r;
  }
  return Y(e, null, [{ key: "create", value: function(t, n, r) {
    return new e(t, n, r);
  } }]), e;
}();
function $p(e, t) {
  return e.from - t.from || e.value.startSide - t.value.startSide;
}
var mV = function() {
  function e(t, n, r, i) {
    Z(this, e), this.from = t, this.to = n, this.value = r, this.maxPoint = i;
  }
  return Y(e, [{ key: "length", get: function() {
    return this.to[this.to.length - 1];
  } }, { key: "findIndex", value: function(t, n, r) {
    for (var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = r ? this.to : this.from, a = i, s = o.length; ; ) {
      if (a == s)
        return a;
      var u = a + s >> 1, c = o[u] - t || (r ? this.value[u].endSide : this.value[u].startSide) - n;
      if (u == a)
        return c >= 0 ? a : s;
      c >= 0 ? s = u : a = u + 1;
    }
  } }, { key: "between", value: function(t, n, r, i) {
    for (var o = this.findIndex(n, -1e9, !0), a = this.findIndex(r, 1e9, !1, o); o < a; o++)
      if (i(this.from[o] + t, this.to[o] + t, this.value[o]) === !1)
        return !1;
  } }, { key: "map", value: function(t, n) {
    for (var r = [], i = [], o = [], a = -1, s = -1, u = 0; u < this.value.length; u++) {
      var c = this.value[u], l = this.from[u] + t, f = this.to[u] + t, h = void 0, d = void 0;
      if (l == f) {
        var p = n.mapPos(l, c.startSide, c.mapMode);
        if (p == null || (h = d = p, c.startSide != c.endSide && (d = n.mapPos(l, c.endSide)) < h))
          continue;
      } else if ((h = n.mapPos(l, c.startSide)) > (d = n.mapPos(f, c.endSide)) || h == d && c.startSide > 0 && c.endSide <= 0)
        continue;
      (d - h || c.endSide - c.startSide) < 0 || (a < 0 && (a = h), c.point && (s = Math.max(s, d - h)), r.push(c), i.push(h - a), o.push(d - a));
    }
    return { mapped: r.length ? new e(i, o, r, s) : null, pos: a };
  } }]), e;
}(), Nn = function() {
  function e(t, n, r, i) {
    Z(this, e), this.chunkPos = t, this.chunk = n, this.nextLayer = r, this.maxPoint = i;
  }
  return Y(e, [{ key: "length", get: function() {
    var t = this.chunk.length - 1;
    return t < 0 ? 0 : Math.max(this.chunkEnd(t), this.nextLayer.length);
  } }, { key: "size", get: function() {
    if (this.isEmpty)
      return 0;
    var t, n = this.nextLayer.size, r = ut(this.chunk);
    try {
      for (r.s(); !(t = r.n()).done; )
        n += t.value.value.length;
    } catch (i) {
      r.e(i);
    } finally {
      r.f();
    }
    return n;
  } }, { key: "chunkEnd", value: function(t) {
    return this.chunkPos[t] + this.chunk[t].length;
  } }, { key: "update", value: function(t) {
    var n = t.add, r = n === void 0 ? [] : n, i = t.sort, o = i !== void 0 && i, a = t.filterFrom, s = a === void 0 ? 0 : a, u = t.filterTo, c = u === void 0 ? this.length : u, l = t.filter;
    if (r.length == 0 && !l)
      return this;
    if (o && (r = r.slice().sort($p)), this.isEmpty)
      return r.length ? e.of(r) : this;
    for (var f = new DA(this, null, -1).goto(0), h = 0, d = [], p = new Vs(); f.value || h < r.length; )
      if (h < r.length && (f.from - r[h].from || f.startSide - r[h].value.startSide) >= 0) {
        var v = r[h++];
        p.addInner(v.from, v.to, v.value) || d.push(v);
      } else
        f.rangeIndex == 1 && f.chunkIndex < this.chunk.length && (h == r.length || this.chunkEnd(f.chunkIndex) < r[h].from) && (!l || s > this.chunkEnd(f.chunkIndex) || c < this.chunkPos[f.chunkIndex]) && p.addChunk(this.chunkPos[f.chunkIndex], this.chunk[f.chunkIndex]) ? f.nextChunk() : ((!l || s > f.to || c < f.from || l(f.from, f.to, f.value)) && (p.addInner(f.from, f.to, f.value) || d.push(Sp.create(f.from, f.to, f.value))), f.next());
    return p.finishInner(this.nextLayer.isEmpty && !d.length ? e.empty : this.nextLayer.update({ add: d, filter: l, filterFrom: s, filterTo: c }));
  } }, { key: "map", value: function(t) {
    if (t.empty || this.isEmpty)
      return this;
    for (var n = [], r = [], i = -1, o = 0; o < this.chunk.length; o++) {
      var a = this.chunkPos[o], s = this.chunk[o], u = t.touchesRange(a, a + s.length);
      if (u === !1)
        i = Math.max(i, s.maxPoint), n.push(s), r.push(t.mapPos(a));
      else if (u === !0) {
        var c = s.map(a, t), l = c.mapped, f = c.pos;
        l && (i = Math.max(i, l.maxPoint), n.push(l), r.push(f));
      }
    }
    var h = this.nextLayer.map(t);
    return n.length == 0 ? h : new e(r, n, h || e.empty, i);
  } }, { key: "between", value: function(t, n, r) {
    if (!this.isEmpty) {
      for (var i = 0; i < this.chunk.length; i++) {
        var o = this.chunkPos[i], a = this.chunk[i];
        if (n >= o && t <= o + a.length && a.between(o, t - o, n - o, r) === !1)
          return;
      }
      this.nextLayer.between(t, n, r);
    }
  } }, { key: "iter", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return _p.from([this]).goto(t);
  } }, { key: "isEmpty", get: function() {
    return this.nextLayer == this;
  } }], [{ key: "create", value: function(t, n, r, i) {
    return new e(t, n, r, i);
  } }, { key: "iter", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return _p.from(t).goto(n);
  } }, { key: "compare", value: function(t, n, r, i) {
    var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : -1, a = t.filter(function(f) {
      return f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o;
    }), s = n.filter(function(f) {
      return f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o;
    }), u = Cj(a, s, r), c = new Ou(a, u, o), l = new Ou(s, u, o);
    r.iterGaps(function(f, h, d) {
      return Oj(c, f, l, h, d, i);
    }), r.empty && r.length == 0 && Oj(c, 0, l, 0, 0, i);
  } }, { key: "eq", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 ? arguments[3] : void 0;
    i == null && (i = 1e9);
    var o = t.filter(function(l) {
      return !l.isEmpty && n.indexOf(l) < 0;
    }), a = n.filter(function(l) {
      return !l.isEmpty && t.indexOf(l) < 0;
    });
    if (o.length != a.length)
      return !1;
    if (!o.length)
      return !0;
    for (var s = Cj(o, a), u = new Ou(o, s, 0).goto(r), c = new Ou(a, s, 0).goto(r); ; ) {
      if (u.to != c.to || !Cp(u.active, c.active) || u.point && (!c.point || !u.point.eq(c.point)))
        return !1;
      if (u.to > i)
        return !0;
      u.next(), c.next();
    }
  } }, { key: "spans", value: function(t, n, r, i) {
    for (var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : -1, a = new Ou(t, null, o).goto(n), s = n, u = a.openStart; ; ) {
      var c = Math.min(a.to, r);
      if (a.point ? (i.point(s, c, a.point, a.activeForPoint(a.to), u, a.pointRank), u = a.openEnd(c) + (a.to > c ? 1 : 0)) : c > s && (i.span(s, c, a.active, u), u = a.openEnd(c)), a.to > r)
        break;
      s = a.to, a.next();
    }
    return u;
  } }, { key: "of", value: function(t) {
    var n, r = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], i = new Vs(), o = ut(t instanceof Sp ? [t] : r ? gV(t) : t);
    try {
      for (o.s(); !(n = o.n()).done; ) {
        var a = n.value;
        i.add(a.from, a.to, a.value);
      }
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
    return i.finish();
  } }]), e;
}();
function gV(e) {
  if (e.length > 1)
    for (var t = e[0], n = 1; n < e.length; n++) {
      var r = e[n];
      if ($p(t, r) > 0)
        return e.slice().sort($p);
      t = r;
    }
  return e;
}
Nn.empty = new Nn([], [], null, -1), Nn.empty.nextLayer = Nn.empty;
var Vs = function() {
  function e() {
    Z(this, e), this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  return Y(e, [{ key: "finishChunk", value: function(t) {
    this.chunks.push(new mV(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, t && (this.from = [], this.to = [], this.value = []);
  } }, { key: "add", value: function(t, n, r) {
    this.addInner(t, n, r) || (this.nextLayer || (this.nextLayer = new e())).add(t, n, r);
  } }, { key: "addInner", value: function(t, n, r) {
    var i = t - this.lastTo || r.startSide - this.last.endSide;
    if (i <= 0 && (t - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return !(i < 0) && (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = t), this.from.push(t - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = t, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - t)), !0);
  } }, { key: "addChunk", value: function(t, n) {
    if ((t - this.lastTo || n.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(t);
    var r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + t, this.lastTo = n.to[r] + t, !0;
  } }, { key: "finish", value: function() {
    return this.finishInner(Nn.empty);
  } }, { key: "finishInner", value: function(t) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return t;
    var n = Nn.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(t) : t, this.setMaxPoint);
    return this.from = null, n;
  } }]), e;
}();
function Cj(e, t, n) {
  var r, i = /* @__PURE__ */ new Map(), o = ut(e);
  try {
    for (o.s(); !(r = o.n()).done; )
      for (var a = r.value, s = 0; s < a.chunk.length; s++)
        a.chunk[s].maxPoint <= 0 && i.set(a.chunk[s], a.chunkPos[s]);
  } catch (p) {
    o.e(p);
  } finally {
    o.f();
  }
  var u, c = /* @__PURE__ */ new Set(), l = ut(t);
  try {
    for (l.s(); !(u = l.n()).done; )
      for (var f = u.value, h = 0; h < f.chunk.length; h++) {
        var d = i.get(f.chunk[h]);
        d == null || (n ? n.mapPos(d) : d) != f.chunkPos[h] || (n == null ? void 0 : n.touchesRange(d, d + f.chunk[h].length)) || c.add(f.chunk[h]);
      }
  } catch (p) {
    l.e(p);
  } finally {
    l.f();
  }
  return c;
}
var DA = function() {
  function e(t, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    Z(this, e), this.layer = t, this.skip = n, this.minPoint = r, this.rank = i;
  }
  return Y(e, [{ key: "startSide", get: function() {
    return this.value ? this.value.startSide : 0;
  } }, { key: "endSide", get: function() {
    return this.value ? this.value.endSide : 0;
  } }, { key: "goto", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1e9;
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(t, n, !1), this;
  } }, { key: "gotoInner", value: function(t, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      var i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < t || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      var o = this.layer.chunk[this.chunkIndex].findIndex(t - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < o) && this.setRangeIndex(o);
    }
    this.next();
  } }, { key: "forward", value: function(t, n) {
    (this.to - t || this.endSide - n) < 0 && this.gotoInner(t, n, !0);
  } }, { key: "next", value: function() {
    for (; ; ) {
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      }
      var t = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = t + n.from[this.rangeIndex];
      if (this.from = r, this.to = t + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
        break;
    }
  } }, { key: "setRangeIndex", value: function(t) {
    if (t == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = t;
  } }, { key: "nextChunk", value: function() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  } }, { key: "compare", value: function(t) {
    return this.from - t.from || this.startSide - t.startSide || this.rank - t.rank || this.to - t.to || this.endSide - t.endSide;
  } }]), e;
}(), _p = function() {
  function e(t) {
    Z(this, e), this.heap = t;
  }
  return Y(e, [{ key: "startSide", get: function() {
    return this.value ? this.value.startSide : 0;
  } }, { key: "goto", value: function(t) {
    var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1e9, i = ut(this.heap);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value;
        o.goto(t, r);
      }
    } catch (s) {
      i.e(s);
    } finally {
      i.f();
    }
    for (var a = this.heap.length >> 1; a >= 0; a--)
      Hd(this.heap, a);
    return this.next(), this;
  } }, { key: "forward", value: function(t, n) {
    var r, i = ut(this.heap);
    try {
      for (i.s(); !(r = i.n()).done; )
        r.value.forward(t, n);
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    for (var o = this.heap.length >> 1; o >= 0; o--)
      Hd(this.heap, o);
    (this.to - t || this.value.endSide - n) < 0 && this.next();
  } }, { key: "next", value: function() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      var t = this.heap[0];
      this.from = t.from, this.to = t.to, this.value = t.value, this.rank = t.rank, t.value && t.next(), Hd(this.heap, 0);
    }
  } }], [{ key: "from", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, i = [], o = 0; o < t.length; o++)
      for (var a = t[o]; !a.isEmpty; a = a.nextLayer)
        a.maxPoint >= r && i.push(new DA(a, n, r, o));
    return i.length == 1 ? i[0] : new e(i);
  } }]), e;
}();
function Hd(e, t) {
  for (var n = e[t]; ; ) {
    var r = 1 + (t << 1);
    if (r >= e.length)
      break;
    var i = e[r];
    if (r + 1 < e.length && i.compare(e[r + 1]) >= 0 && (i = e[r + 1], r++), n.compare(i) < 0)
      break;
    e[r] = n, e[t] = i, t = r;
  }
}
var Ou = function() {
  function e(t, n, r) {
    Z(this, e), this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = _p.from(t, n, r);
  }
  return Y(e, [{ key: "goto", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1e9;
    return this.cursor.goto(t, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = t, this.endSide = n, this.openStart = -1, this.next(), this;
  } }, { key: "forward", value: function(t, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - t || this.active[this.minActive].endSide - n) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(t, n);
  } }, { key: "removeActive", value: function(t) {
    $l(this.active, t), $l(this.activeTo, t), $l(this.activeRank, t), this.minActive = Aj(this.active, this.activeTo);
  } }, { key: "addActive", value: function(t) {
    for (var n = 0, r = this.cursor, i = r.value, o = r.to, a = r.rank; n < this.activeRank.length && this.activeRank[n] <= a; )
      n++;
    _l(this.active, n, i), _l(this.activeTo, n, o), _l(this.activeRank, n, a), t && _l(t, n, this.cursor.from), this.minActive = Aj(this.active, this.activeTo);
  } }, { key: "next", value: function() {
    var t = this.to, n = this.point;
    this.point = null;
    for (var r = this.openStart < 0 ? [] : null, i = 0; ; ) {
      var o = this.minActive;
      if (o > -1 && (this.activeTo[o] - this.cursor.from || this.active[o].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[o] > t) {
          this.to = this.activeTo[o], this.endSide = this.active[o].endSide;
          break;
        }
        this.removeActive(o), r && $l(r, o);
      } else {
        if (!this.cursor.value) {
          this.to = this.endSide = 1e9;
          break;
        }
        if (this.cursor.from > t) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        }
        var a = this.cursor.value;
        if (a.point) {
          if (!(n && this.cursor.to == this.to && this.cursor.from < this.cursor.to)) {
            this.point = a, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = a.endSide, this.cursor.from < t && (i = 1), this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
          this.cursor.next();
        } else
          this.addActive(r), this.cursor.next();
      }
    }
    if (r) {
      for (var s = 0; s < r.length && r[s] < t; )
        s++;
      this.openStart = s + i;
    }
  } }, { key: "activeForPoint", value: function(t) {
    if (!this.active.length)
      return this.active;
    for (var n = [], r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > t || this.activeTo[r] == t && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    return n.reverse();
  } }, { key: "openEnd", value: function(t) {
    for (var n = 0, r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > t; r--)
      n++;
    return n;
  } }]), e;
}();
function Oj(e, t, n, r, i, o) {
  e.goto(t), n.goto(r);
  for (var a = r + i, s = r, u = r - t; ; ) {
    var c = e.to + u - n.to || e.endSide - n.endSide, l = c < 0 ? e.to + u : n.to, f = Math.min(l, a);
    if (e.point || n.point ? e.point && n.point && (e.point == n.point || e.point.eq(n.point)) && Cp(e.activeForPoint(e.to + u), n.activeForPoint(n.to)) || o.comparePoint(s, f, e.point, n.point) : f > s && !Cp(e.active, n.active) && o.compareRange(s, f, e.active, n.active), l > a)
      break;
    s = l, c <= 0 && e.next(), c >= 0 && n.next();
  }
}
function Cp(e, t) {
  if (e.length != t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] != t[n] && !e[n].eq(t[n]))
      return !1;
  return !0;
}
function $l(e, t) {
  for (var n = t, r = e.length - 1; n < r; n++)
    e[n] = e[n + 1];
  e.pop();
}
function _l(e, t, n) {
  for (var r = e.length - 1; r >= t; r--)
    e[r + 1] = e[r];
  e[t] = n;
}
function Aj(e, t) {
  for (var n = -1, r = 1e9, i = 0; i < t.length; i++)
    (t[i] - r || e[i].endSide - e[n].endSide) < 0 && (n = i, r = t[i]);
  return n;
}
function Xc(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.length, r = 0, i = 0; i < n; )
    e.charCodeAt(i) == 9 ? (r += t - r % t, i++) : (r++, i = Xr(e, i));
  return r;
}
function Op(e, t, n, r) {
  for (var i = 0, o = 0; ; ) {
    if (o >= t)
      return i;
    if (i == e.length)
      break;
    o += e.charCodeAt(i) == 9 ? n - o % n : 1, i = Xr(e, i);
  }
  return r === !0 ? -1 : e.length;
}
for (var Pj = typeof Symbol > "u" ? "__\u037C" : Symbol.for("\u037C"), Wd = typeof Symbol > "u" ? "__styleSet" + Math.floor(1e8 * Math.random()) : Symbol("styleSet"), Ej = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {}, ua = function() {
  function e(t, n) {
    Z(this, e), this.rules = [];
    var r = (n || {}).finish;
    function i(s) {
      return /^@/.test(s) ? [s] : s.split(/,\s*/);
    }
    function o(s, u, c, l) {
      var f = [], h = /^@(\w+)\b/.exec(s[0]), d = h && h[1] == "keyframes";
      if (h && u == null)
        return c.push(s[0] + ";");
      for (var p in u) {
        var v = u[p];
        if (/&/.test(p))
          o(p.split(/,\s*/).map(function(m) {
            return s.map(function(g) {
              return m.replace(/&/, g);
            });
          }).reduce(function(m, g) {
            return m.concat(g);
          }), v, c);
        else if (v && ne(v) == "object") {
          if (!h)
            throw new RangeError("The value of a property (" + p + ") should be a primitive value.");
          o(i(p), v, f, d);
        } else
          v != null && f.push(p.replace(/_.*/, "").replace(/[A-Z]/g, function(m) {
            return "-" + m.toLowerCase();
          }) + ": " + v + ";");
      }
      (f.length || d) && c.push((!r || h || l ? s : s.map(r)).join(", ") + " {" + f.join(" ") + "}");
    }
    for (var a in t)
      o(i(a), t[a], this.rules);
  }
  return Y(e, [{ key: "getRules", value: function() {
    return this.rules.join(`
`);
  } }], [{ key: "newName", value: function() {
    var t = Ej[Pj] || 1;
    return Ej[Pj] = t + 1, "\u037C" + t.toString(36);
  } }, { key: "mount", value: function(t, n) {
    (t[Wd] || new yV(t)).mount(Array.isArray(n) ? n : [n]);
  } }]), e;
}(), Cl = null, yV = function() {
  function e(t) {
    if (Z(this, e), !t.head && t.adoptedStyleSheets && typeof CSSStyleSheet < "u") {
      if (Cl)
        return t.adoptedStyleSheets = [Cl.sheet].concat(t.adoptedStyleSheets), t[Wd] = Cl;
      this.sheet = new CSSStyleSheet(), t.adoptedStyleSheets = [this.sheet].concat(t.adoptedStyleSheets), Cl = this;
    } else {
      this.styleTag = (t.ownerDocument || t).createElement("style");
      var n = t.head || t;
      n.insertBefore(this.styleTag, n.firstChild);
    }
    this.modules = [], t[Wd] = this;
  }
  return Y(e, [{ key: "mount", value: function(t) {
    for (var n = this.sheet, r = 0, i = 0, o = 0; o < t.length; o++) {
      var a = t[o], s = this.modules.indexOf(a);
      if (s < i && s > -1 && (this.modules.splice(s, 1), i--, s = -1), s == -1) {
        if (this.modules.splice(i++, 0, a), n)
          for (var u = 0; u < a.rules.length; u++)
            n.insertRule(a.rules[u], r++);
      } else {
        for (; i < s; )
          r += this.modules[i++].rules.length;
        r += a.rules.length, i++;
      }
    }
    if (!n) {
      for (var c = "", l = 0; l < this.modules.length; l++)
        c += this.modules[l].getRules() + `
`;
      this.styleTag.textContent = c;
    }
  } }]), e;
}(), ca = { 8: "Backspace", 9: "Tab", 10: "Enter", 12: "NumLock", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 44: "PrintScreen", 45: "Insert", 46: "Delete", 59: ";", 61: "=", 91: "Meta", 92: "Meta", 106: "*", 107: "+", 108: ",", 109: "-", 110: ".", 111: "/", 144: "NumLock", 145: "ScrollLock", 160: "Shift", 161: "Shift", 162: "Control", 163: "Control", 164: "Alt", 165: "Alt", 173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'", 229: "q" }, Es = { 48: ")", 49: "!", 50: "@", 51: "#", 52: "$", 53: "%", 54: "^", 55: "&", 56: "*", 57: "(", 59: ":", 61: "+", 173: "_", 186: ":", 187: "+", 188: "<", 189: "_", 190: ">", 191: "?", 192: "~", 219: "{", 220: "|", 221: "}", 222: '"', 229: "Q" }, Mj = typeof navigator < "u" && /Chrome\/(\d+)/.exec(navigator.userAgent), bV = typeof navigator < "u" && /Apple Computer/.test(navigator.vendor), kV = typeof navigator < "u" && /Gecko\/\d+/.test(navigator.userAgent), Tj = typeof navigator < "u" && /Mac/.test(navigator.platform), wV = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent), xV = Mj && (Tj || +Mj[1] < 57) || kV && Tj, pr = 0; pr < 10; pr++)
  ca[48 + pr] = ca[96 + pr] = String(pr);
for (pr = 1; pr <= 24; pr++)
  ca[pr + 111] = "F" + pr;
for (pr = 65; pr <= 90; pr++)
  ca[pr] = String.fromCharCode(pr + 32), Es[pr] = String.fromCharCode(pr);
for (var Ud in ca)
  Es.hasOwnProperty(Ud) || (Es[Ud] = ca[Ud]);
function Vf(e) {
  return (e.nodeType == 11 ? e.getSelection ? e : e.ownerDocument : e).getSelection();
}
function Hs(e, t) {
  return !!t && (e == t || e.contains(t.nodeType != 1 ? t.parentNode : t));
}
function Ap(e, t) {
  if (!t.anchorNode)
    return !1;
  try {
    return Hs(e, t.anchorNode);
  } catch {
    return !1;
  }
}
function fc(e) {
  return e.nodeType == 3 ? hc(e, 0, e.nodeValue.length).getClientRects() : e.nodeType == 1 ? e.getClientRects() : [];
}
function Hf(e, t, n, r) {
  return !!n && (Ij(e, t, n, r, -1) || Ij(e, t, n, r, 1));
}
function Pp(e) {
  for (var t = 0; ; t++)
    if (!(e = e.previousSibling))
      return t;
}
function Ij(e, t, n, r, i) {
  for (; ; ) {
    if (e == n && t == r)
      return !0;
    if (t == (i < 0 ? 0 : Wf(e))) {
      if (e.nodeName == "DIV")
        return !1;
      var o = e.parentNode;
      if (!o || o.nodeType != 1)
        return !1;
      t = Pp(e) + (i < 0 ? 0 : 1), e = o;
    } else {
      if (e.nodeType != 1 || (e = e.childNodes[t + (i < 0 ? -1 : 0)]).nodeType == 1 && e.contentEditable == "false")
        return !1;
      t = i < 0 ? Wf(e) : 0;
    }
  }
}
function Wf(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
var LA = { left: 0, right: 0, top: 0, bottom: 0 };
function ad(e, t) {
  var n = t ? e.left : e.right;
  return { left: n, right: n, top: e.top, bottom: e.bottom };
}
function jV(e) {
  return { left: 0, right: e.innerWidth, top: 0, bottom: e.innerHeight };
}
var Nj, SV = function() {
  function e() {
    Z(this, e), this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  return Y(e, [{ key: "eq", value: function(t) {
    return this.anchorNode == t.anchorNode && this.anchorOffset == t.anchorOffset && this.focusNode == t.focusNode && this.focusOffset == t.focusOffset;
  } }, { key: "setRange", value: function(t) {
    this.set(t.anchorNode, t.anchorOffset, t.focusNode, t.focusOffset);
  } }, { key: "set", value: function(t, n, r, i) {
    this.anchorNode = t, this.anchorOffset = n, this.focusNode = r, this.focusOffset = i;
  } }]), e;
}(), ms = null;
function zA(e) {
  if (e.setActive)
    return e.setActive();
  if (ms)
    return e.focus(ms);
  for (var t = [], n = e; n && (t.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode)
    ;
  if (e.focus(ms == null ? { get preventScroll() {
    return ms = { preventScroll: !0 }, !0;
  } } : void 0), !ms) {
    ms = !1;
    for (var r = 0; r < t.length; ) {
      var i = t[r++], o = t[r++], a = t[r++];
      i.scrollTop != o && (i.scrollTop = o), i.scrollLeft != a && (i.scrollLeft = a);
    }
  }
}
function hc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t, r = Nj || (Nj = document.createRange());
  return r.setEnd(e, n), r.setStart(e, t), r;
}
function Gu(e, t, n) {
  var r = { key: t, code: t, keyCode: n, which: n, cancelable: !0 }, i = new KeyboardEvent("keydown", r);
  i.synthetic = !0, e.dispatchEvent(i);
  var o = new KeyboardEvent("keyup", r);
  return o.synthetic = !0, e.dispatchEvent(o), i.defaultPrevented || o.defaultPrevented;
}
function $V(e) {
  for (; e; ) {
    if (e && (e.nodeType == 9 || e.nodeType == 11 && e.host))
      return e;
    e = e.assignedSlot || e.parentNode;
  }
  return null;
}
function BA(e) {
  for (; e.attributes.length; )
    e.removeAttributeNode(e.attributes[0]);
}
var qr = function() {
  function e(t, n) {
    var r = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
    Z(this, e), this.node = t, this.offset = n, this.precise = r;
  }
  return Y(e, null, [{ key: "before", value: function(t, n) {
    return new e(t.parentNode, Pp(t), n);
  } }, { key: "after", value: function(t, n) {
    return new e(t.parentNode, Pp(t) + 1, n);
  } }]), e;
}(), h0 = [], Zn = function() {
  function e() {
    Z(this, e), this.parent = null, this.dom = null, this.dirty = 2;
  }
  return Y(e, [{ key: "editorView", get: function() {
    if (!this.parent)
      throw new Error("Accessing view in orphan content view");
    return this.parent.editorView;
  } }, { key: "overrideDOMText", get: function() {
    return null;
  } }, { key: "posAtStart", get: function() {
    return this.parent ? this.parent.posBefore(this) : 0;
  } }, { key: "posAtEnd", get: function() {
    return this.posAtStart + this.length;
  } }, { key: "posBefore", value: function(t) {
    var n, r = this.posAtStart, i = ut(this.children);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value;
        if (o == t)
          return r;
        r += o.length + o.breakAfter;
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    throw new RangeError("Invalid child in posBefore");
  } }, { key: "posAfter", value: function(t) {
    return this.posBefore(t) + t.length;
  } }, { key: "coordsAt", value: function(t, n) {
    return null;
  } }, { key: "sync", value: function(t) {
    if (2 & this.dirty) {
      var n, r, i = this.dom, o = null, a = ut(this.children);
      try {
        for (a.s(); !(r = a.n()).done; ) {
          var s = r.value;
          if (s.dirty) {
            if (!s.dom && (n = o ? o.nextSibling : i.firstChild)) {
              var u = e.get(n);
              u && (u.parent || u.constructor != s.constructor) || s.reuseDOM(n);
            }
            s.sync(t), s.dirty = 0;
          }
          if (n = o ? o.nextSibling : i.firstChild, t && !t.written && t.node == i && n != s.dom && (t.written = !0), s.dom.parentNode == i)
            for (; n && n != s.dom; )
              n = Rj(n);
          else
            i.insertBefore(s.dom, n);
          o = s.dom;
        }
      } catch (h) {
        a.e(h);
      } finally {
        a.f();
      }
      for ((n = o ? o.nextSibling : i.firstChild) && t && t.node == i && (t.written = !0); n; )
        n = Rj(n);
    } else if (1 & this.dirty) {
      var c, l = ut(this.children);
      try {
        for (l.s(); !(c = l.n()).done; ) {
          var f = c.value;
          f.dirty && (f.sync(t), f.dirty = 0);
        }
      } catch (h) {
        l.e(h);
      } finally {
        l.f();
      }
    }
  } }, { key: "reuseDOM", value: function(t) {
  } }, { key: "localPosFromDOM", value: function(t, n) {
    var r;
    if (t == this.dom)
      r = this.dom.childNodes[n];
    else {
      for (var i = Wf(t) == 0 ? 0 : n == 0 ? -1 : 1; ; ) {
        var o = t.parentNode;
        if (o == this.dom)
          break;
        i == 0 && o.firstChild != o.lastChild && (i = t == o.firstChild ? -1 : 1), t = o;
      }
      r = i < 0 ? t : t.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !e.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (var a = 0, s = 0; ; a++) {
      var u = this.children[a];
      if (u.dom == r)
        return s;
      s += u.length + u.breakAfter;
    }
  } }, { key: "domBoundsAround", value: function(t, n) {
    for (var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = -1, o = -1, a = -1, s = -1, u = 0, c = r, l = r; u < this.children.length; u++) {
      var f = this.children[u], h = c + f.length;
      if (c < t && h > n)
        return f.domBoundsAround(t, n, c);
      if (h >= t && i == -1 && (i = u, o = c), c > n && f.dom.parentNode == this.dom) {
        a = u, s = l;
        break;
      }
      l = h, c = h + f.breakAfter;
    }
    return { from: o, to: s < 0 ? r + this.length : s, startDOM: (i ? this.children[i - 1].dom.nextSibling : null) || this.dom.firstChild, endDOM: a < this.children.length && a >= 0 ? this.children[a].dom : null };
  } }, { key: "markDirty", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    this.dirty |= 2, this.markParentsDirty(t);
  } }, { key: "markParentsDirty", value: function(t) {
    for (var n = this.parent; n; n = n.parent) {
      if (t && (n.dirty |= 2), 1 & n.dirty)
        return;
      n.dirty |= 1, t = !1;
    }
  } }, { key: "setParent", value: function(t) {
    this.parent != t && (this.parent = t, this.dirty && this.markParentsDirty(!0));
  } }, { key: "setDOM", value: function(t) {
    this.dom && (this.dom.cmView = null), this.dom = t, t.cmView = this;
  } }, { key: "rootView", get: function() {
    for (var t = this; ; ) {
      var n = t.parent;
      if (!n)
        return t;
      t = n;
    }
  } }, { key: "replaceChildren", value: function(t, n) {
    var r, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : h0;
    this.markDirty();
    for (var o = t; o < n; o++) {
      var a = this.children[o];
      a.parent == this && a.destroy();
    }
    (r = this.children).splice.apply(r, [t, n - t].concat(Pe(i)));
    for (var s = 0; s < i.length; s++)
      i[s].setParent(this);
  } }, { key: "ignoreMutation", value: function(t) {
    return !1;
  } }, { key: "ignoreEvent", value: function(t) {
    return !1;
  } }, { key: "childCursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.length;
    return new FA(this.children, t, this.children.length);
  } }, { key: "childPos", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return this.childCursor().findPos(t, n);
  } }, { key: "toString", value: function() {
    var t = this.constructor.name.replace("View", "");
    return t + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (t == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  } }, { key: "isEditable", get: function() {
    return !0;
  } }, { key: "merge", value: function(t, n, r, i, o, a) {
    return !1;
  } }, { key: "become", value: function(t) {
    return !1;
  } }, { key: "getSide", value: function() {
    return 0;
  } }, { key: "destroy", value: function() {
    this.parent = null;
  } }], [{ key: "get", value: function(t) {
    return t.cmView;
  } }]), e;
}();
function Rj(e) {
  var t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
Zn.prototype.breakAfter = 0;
var FA = function() {
  function e(t, n, r) {
    Z(this, e), this.children = t, this.pos = n, this.i = r, this.off = 0;
  }
  return Y(e, [{ key: "findPos", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1; ; ) {
      if (t > this.pos || t == this.pos && (n > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = t - this.pos, this;
      var r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  } }]), e;
}();
function qA(e, t, n, r, i, o, a, s, u) {
  var c = e.children, l = c.length ? c[t] : null, f = o.length ? o[o.length - 1] : null, h = f ? f.breakAfter : a;
  if (!(t == r && l && !a && !h && o.length < 2 && l.merge(n, i, o.length ? f : null, n == 0, s, u))) {
    if (r < c.length) {
      var d = c[r];
      d && i < d.length ? (t == r && (d = d.split(i), i = 0), !h && f && d.merge(0, i, f, !0, 0, u) ? o[o.length - 1] = d : (i && d.merge(0, i, null, !1, 0, u), o.push(d))) : d != null && d.breakAfter && (f ? f.breakAfter = 1 : a = 1), r++;
    }
    for (l && (l.breakAfter = a, n > 0 && (!a && o.length && l.merge(n, l.length, o[0], !1, s, 0) ? l.breakAfter = o.shift().breakAfter : (n < l.length || l.children.length && l.children[l.children.length - 1].length == 0) && l.merge(n, l.length, null, !1, s, 0), t++)); t < r && o.length; )
      if (c[r - 1].become(o[o.length - 1]))
        r--, o.pop(), u = o.length ? 0 : s;
      else {
        if (!c[t].become(o[0]))
          break;
        t++, o.shift(), s = o.length ? 0 : u;
      }
    !o.length && t && r < c.length && !c[t - 1].breakAfter && c[r].merge(0, 0, c[t - 1], !1, s, u) && t--, (t < r || o.length) && e.replaceChildren(t, r, o);
  }
}
function VA(e, t, n, r, i, o) {
  var a, s = e.childCursor(), u = s.findPos(n, 1), c = u.i, l = u.off, f = s.findPos(t, -1), h = f.i, d = f.off, p = t - n, v = ut(r);
  try {
    for (v.s(); !(a = v.n()).done; )
      p += a.value.length;
  } catch (m) {
    v.e(m);
  } finally {
    v.f();
  }
  e.length += p, qA(e, h, d, c, l, r, 0, i, o);
}
var Gr = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, Ep = typeof document < "u" ? document : { documentElement: { style: {} } }, Mp = /Edge\/(\d+)/.exec(Gr.userAgent), HA = /MSIE \d/.test(Gr.userAgent), Tp = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Gr.userAgent), sd = !!(HA || Tp || Mp), Dj = !sd && /gecko\/(\d+)/i.test(Gr.userAgent), Jd = !sd && /Chrome\/(\d+)/.exec(Gr.userAgent), Lj = "webkitFontSmoothing" in Ep.documentElement.style, WA = !sd && /Apple Computer/.test(Gr.vendor), zj = WA && (/Mobile\/\w+/.test(Gr.userAgent) || Gr.maxTouchPoints > 2), ye = { mac: zj || /Mac/.test(Gr.platform), windows: /Win/.test(Gr.platform), linux: /Linux|X11/.test(Gr.platform), ie: sd, ie_version: HA ? Ep.documentMode || 6 : Tp ? +Tp[1] : Mp ? +Mp[1] : 0, gecko: Dj, gecko_version: Dj ? +(/Firefox\/(\d+)/.exec(Gr.userAgent) || [0, 0])[1] : 0, chrome: !!Jd, chrome_version: Jd ? +Jd[1] : 0, ios: zj, android: /Android\b/.test(Gr.userAgent), webkit: Lj, safari: WA, webkit_version: Lj ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0, tabSize: Ep.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size" }, dc = function(e) {
  Et(n, Zn);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).text = r, i;
  }
  return Y(n, [{ key: "length", get: function() {
    return this.text.length;
  } }, { key: "createDOM", value: function(r) {
    this.setDOM(r || document.createTextNode(this.text));
  } }, { key: "sync", value: function(r) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (r && r.node == this.dom && (r.written = !0), this.dom.nodeValue = this.text);
  } }, { key: "reuseDOM", value: function(r) {
    r.nodeType == 3 && this.createDOM(r);
  } }, { key: "merge", value: function(r, i, o) {
    return (!o || o instanceof n && !(this.length - (i - r) + o.length > 256)) && (this.text = this.text.slice(0, r) + (o ? o.text : "") + this.text.slice(i), this.markDirty(), !0);
  } }, { key: "split", value: function(r) {
    var i = new n(this.text.slice(r));
    return this.text = this.text.slice(0, r), this.markDirty(), i;
  } }, { key: "localPosFromDOM", value: function(r, i) {
    return r == this.dom ? i : i ? this.text.length : 0;
  } }, { key: "domAtPos", value: function(r) {
    return new qr(this.dom, r);
  } }, { key: "domBoundsAround", value: function(r, i, o) {
    return { from: o, to: o + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  } }, { key: "coordsAt", value: function(r, i) {
    return Ip(this.dom, r, i);
  } }]), n;
}(), Ha = function(e) {
  Et(n, Zn);
  var t = Mt(n);
  function n(r) {
    var i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    Z(this, n), (i = t.call(this)).mark = r, i.children = o, i.length = a;
    var s, u = ut(o);
    try {
      for (u.s(); !(s = u.n()).done; ) {
        var c = s.value;
        c.setParent(he(i));
      }
    } catch (l) {
      u.e(l);
    } finally {
      u.f();
    }
    return i;
  }
  return Y(n, [{ key: "setAttrs", value: function(r) {
    if (BA(r), this.mark.class && (r.className = this.mark.class), this.mark.attrs)
      for (var i in this.mark.attrs)
        r.setAttribute(i, this.mark.attrs[i]);
    return r;
  } }, { key: "reuseDOM", value: function(r) {
    r.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(r), this.dirty |= 6);
  } }, { key: "sync", value: function(r) {
    this.dom ? 4 & this.dirty && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), Je(qe(n.prototype), "sync", this).call(this, r);
  } }, { key: "merge", value: function(r, i, o, a, s, u) {
    return (!o || !(!(o instanceof n && o.mark.eq(this.mark)) || r && s <= 0 || i < this.length && u <= 0)) && (VA(this, r, i, o ? o.children : [], s - 1, u - 1), this.markDirty(), !0);
  } }, { key: "split", value: function(r) {
    var i, o = [], a = 0, s = -1, u = 0, c = ut(this.children);
    try {
      for (c.s(); !(i = c.n()).done; ) {
        var l = i.value, f = a + l.length;
        f > r && o.push(a < r ? l.split(r - a) : l), s < 0 && a >= r && (s = u), a = f, u++;
      }
    } catch (d) {
      c.e(d);
    } finally {
      c.f();
    }
    var h = this.length - r;
    return this.length = r, s > -1 && (this.children.length = s, this.markDirty()), new n(this.mark, o, h);
  } }, { key: "domAtPos", value: function(r) {
    return KA(this.dom, this.children, r);
  } }, { key: "coordsAt", value: function(r, i) {
    return QA(this, r, i);
  } }]), n;
}();
function Ip(e, t, n) {
  var r = e.nodeValue.length;
  t > r && (t = r);
  var i = t, o = t, a = 0;
  t == 0 && n < 0 || t == r && n >= 0 ? ye.chrome || ye.gecko || (t ? (i--, a = 1) : o < r && (o++, a = -1)) : n < 0 ? i-- : o < r && o++;
  var s = hc(e, i, o).getClientRects();
  if (!s.length)
    return LA;
  var u = s[(a ? a < 0 : n >= 0) ? 0 : s.length - 1];
  return ye.safari && !a && u.width == 0 && (u = Array.prototype.find.call(s, function(c) {
    return c.width;
  }) || u), a ? ad(u, a < 0) : u || null;
}
var d0 = function(e) {
  Et(n, Zn);
  var t = Mt(n);
  function n(r, i, o) {
    var a;
    return Z(this, n), (a = t.call(this)).widget = r, a.length = i, a.side = o, a.prevWidget = null, a;
  }
  return Y(n, [{ key: "split", value: function(r) {
    var i = n.create(this.widget, this.length - r, this.side);
    return this.length -= r, i;
  } }, { key: "sync", value: function() {
    this.dom && this.widget.updateDOM(this.dom) || (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(this.editorView)), this.dom.contentEditable = "false");
  } }, { key: "getSide", value: function() {
    return this.side;
  } }, { key: "merge", value: function(r, i, o, a, s, u) {
    return !(o && (!(o instanceof n && this.widget.compare(o.widget)) || r > 0 && s <= 0 || i < this.length && u <= 0)) && (this.length = r + (o ? o.length : 0) + (this.length - i), !0);
  } }, { key: "become", value: function(r) {
    return r.length == this.length && r instanceof n && r.side == this.side && this.widget.constructor == r.widget.constructor && (this.widget.eq(r.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = r.widget, !0);
  } }, { key: "ignoreMutation", value: function() {
    return !0;
  } }, { key: "ignoreEvent", value: function(r) {
    return this.widget.ignoreEvent(r);
  } }, { key: "overrideDOMText", get: function() {
    if (this.length == 0)
      return xn.empty;
    for (var r = this; r.parent; )
      r = r.parent;
    var i = r.editorView, o = i && i.state.doc, a = this.posAtStart;
    return o ? o.slice(a, a + this.length) : xn.empty;
  } }, { key: "domAtPos", value: function(r) {
    return r == 0 ? qr.before(this.dom) : qr.after(this.dom, r == this.length);
  } }, { key: "domBoundsAround", value: function() {
    return null;
  } }, { key: "coordsAt", value: function(r, i) {
    var o = this.dom.getClientRects(), a = null;
    if (!o.length)
      return LA;
    for (var s = r > 0 ? o.length - 1 : 0; a = o[s], !(r > 0 ? s == 0 : s == o.length - 1 || a.top < a.bottom); s += r > 0 ? -1 : 1)
      ;
    return r == 0 && i > 0 || r == this.length && i <= 0 ? a : ad(a, r == 0);
  } }, { key: "isEditable", get: function() {
    return !1;
  } }, { key: "destroy", value: function() {
    Je(qe(n.prototype), "destroy", this).call(this), this.dom && this.widget.destroy(this.dom);
  } }], [{ key: "create", value: function(r, i, o) {
    return new (r.customView || n)(r, i, o);
  } }]), n;
}(), UA = function(e) {
  Et(n, d0);
  var t = Mt(n);
  function n() {
    return Z(this, n), t.apply(this, arguments);
  }
  return Y(n, [{ key: "domAtPos", value: function(r) {
    var i = this.widget, o = i.topView, a = i.text;
    return o ? Np(r, 0, o, a, function(s, u) {
      return s.domAtPos(u);
    }, function(s) {
      return new qr(a, Math.min(s, a.nodeValue.length));
    }) : new qr(a, Math.min(r, a.nodeValue.length));
  } }, { key: "sync", value: function() {
    this.setDOM(this.widget.toDOM());
  } }, { key: "localPosFromDOM", value: function(r, i) {
    var o = this.widget, a = o.topView, s = o.text;
    return a ? JA(r, i, a, s) : Math.min(i, this.length);
  } }, { key: "ignoreMutation", value: function() {
    return !1;
  } }, { key: "overrideDOMText", get: function() {
    return null;
  } }, { key: "coordsAt", value: function(r, i) {
    var o = this.widget, a = o.topView, s = o.text;
    return a ? Np(r, i, a, s, function(u, c, l) {
      return u.coordsAt(c, l);
    }, function(u, c) {
      return Ip(s, u, c);
    }) : Ip(s, r, i);
  } }, { key: "destroy", value: function() {
    var r;
    Je(qe(n.prototype), "destroy", this).call(this), (r = this.widget.topView) === null || r === void 0 || r.destroy();
  } }, { key: "isEditable", get: function() {
    return !0;
  } }]), n;
}();
function Np(e, t, n, r, i, o) {
  if (n instanceof Ha) {
    var a, s = ut(n.children);
    try {
      for (s.s(); !(a = s.n()).done; ) {
        var u = a.value, c = Hs(u.dom, r), l = c ? r.nodeValue.length : u.length;
        if (e < l || e == l && u.getSide() <= 0)
          return c ? Np(e, t, u, r, i, o) : i(u, e, t);
        e -= l;
      }
    } catch (f) {
      s.e(f);
    } finally {
      s.f();
    }
    return i(n, n.length, -1);
  }
  return n.dom == r ? o(e, t) : i(n, e, t);
}
function JA(e, t, n, r) {
  if (n instanceof Ha) {
    var i, o = ut(n.children);
    try {
      for (o.s(); !(i = o.n()).done; ) {
        var a = i.value, s = 0, u = Hs(a.dom, r);
        if (Hs(a.dom, e))
          return s + (u ? JA(e, t, a, r) : a.localPosFromDOM(e, t));
        s += u ? r.nodeValue.length : a.length;
      }
    } catch (c) {
      o.e(c);
    } finally {
      o.f();
    }
  } else if (n.dom == r)
    return Math.min(t, r.nodeValue.length);
  return n.localPosFromDOM(e, t);
}
var Rp = function(e) {
  Et(n, Zn);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).side = r, i;
  }
  return Y(n, [{ key: "length", get: function() {
    return 0;
  } }, { key: "merge", value: function() {
    return !1;
  } }, { key: "become", value: function(r) {
    return r instanceof n && r.side == this.side;
  } }, { key: "split", value: function() {
    return new n(this.side);
  } }, { key: "sync", value: function() {
    if (!this.dom) {
      var r = document.createElement("img");
      r.className = "cm-widgetBuffer", r.setAttribute("aria-hidden", "true"), this.setDOM(r);
    }
  } }, { key: "getSide", value: function() {
    return this.side;
  } }, { key: "domAtPos", value: function(r) {
    return qr.before(this.dom);
  } }, { key: "localPosFromDOM", value: function() {
    return 0;
  } }, { key: "domBoundsAround", value: function() {
    return null;
  } }, { key: "coordsAt", value: function(r) {
    var i = this.dom.getBoundingClientRect(), o = function(a, s) {
      for (var u = a.parent, c = u ? u.children.indexOf(a) : -1; u && c >= 0; )
        if (s < 0 ? c > 0 : c < u.children.length) {
          var l = u.children[c + s];
          if (l instanceof dc) {
            var f = l.coordsAt(s < 0 ? l.length : 0, s);
            if (f)
              return f;
          }
          c += s;
        } else {
          if (!(u instanceof Ha && u.parent)) {
            var h = u.dom.lastChild;
            if (h && h.nodeName == "BR")
              return h.getClientRects()[0];
            break;
          }
          c = u.parent.children.indexOf(u) + (s < 0 ? 0 : 1), u = u.parent;
        }
    }(this, this.side > 0 ? -1 : 1);
    return o && o.top < i.bottom && o.bottom > i.top ? { left: i.left, right: i.right, top: o.top, bottom: o.bottom } : i;
  } }, { key: "overrideDOMText", get: function() {
    return xn.empty;
  } }]), n;
}();
function KA(e, t, n) {
  for (var r = 0, i = 0; r < t.length; r++) {
    var o = t[r], a = i + o.length;
    if (!(a == i && o.getSide() <= 0)) {
      if (n > i && n < a && o.dom.parentNode == e)
        return o.domAtPos(n - i);
      if (n <= i)
        break;
      i = a;
    }
  }
  for (; r > 0; r--) {
    var s = t[r - 1].dom;
    if (s.parentNode == e)
      return qr.after(s);
  }
  return new qr(e, 0);
}
function GA(e, t, n) {
  var r, i = e.children;
  n > 0 && t instanceof Ha && i.length && (r = i[i.length - 1]) instanceof Ha && r.mark.eq(t.mark) ? GA(r, t.children[0], n - 1) : (i.push(t), t.setParent(e)), e.length += t.length;
}
function QA(e, t, n) {
  for (var r = 0, i = 0; i < e.children.length; i++) {
    var o = e.children[i], a = r + o.length, s = void 0;
    if ((n <= 0 || a == e.length || o.getSide() > 0 ? a >= t : a > t) && (t < a || i + 1 == e.children.length || (s = e.children[i + 1]).length || s.getSide() > 0)) {
      var u = 0;
      if (a == r) {
        if (o.getSide() <= 0)
          continue;
        u = n = -o.getSide();
      }
      var c = o.coordsAt(Math.max(0, t - r), n);
      return u && c ? ad(c, n < 0) : c;
    }
    r = a;
  }
  var l = e.dom.lastChild;
  if (!l)
    return e.dom.getBoundingClientRect();
  var f = fc(l);
  return f[f.length - 1] || null;
}
function Dp(e, t) {
  for (var n in e)
    n == "class" && t.class ? t.class += " " + e.class : n == "style" && t.style ? t.style += ";" + e.style : t[n] = e[n];
  return t;
}
function v0(e, t) {
  if (e == t)
    return !0;
  if (!e || !t)
    return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length != r.length)
    return !1;
  for (var i = 0, o = n; i < o.length; i++) {
    var a = o[i];
    if (r.indexOf(a) == -1 || e[a] !== t[a])
      return !1;
  }
  return !0;
}
function Lp(e, t, n) {
  var r = null;
  if (t)
    for (var i in t)
      n && i in n || e.removeAttribute(r = i);
  if (n)
    for (var o in n)
      t && t[o] == n[o] || e.setAttribute(r = o, n[o]);
  return !!r;
}
dc.prototype.children = d0.prototype.children = Rp.prototype.children = h0;
var ba = function() {
  function e() {
    Z(this, e);
  }
  return Y(e, [{ key: "eq", value: function(t) {
    return !1;
  } }, { key: "updateDOM", value: function(t) {
    return !1;
  } }, { key: "compare", value: function(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  } }, { key: "estimatedHeight", get: function() {
    return -1;
  } }, { key: "ignoreEvent", value: function(t) {
    return !0;
  } }, { key: "customView", get: function() {
    return null;
  } }, { key: "destroy", value: function(t) {
  } }]), e;
}(), Cn = function(e) {
  return e[e.Text = 0] = "Text", e[e.WidgetBefore = 1] = "WidgetBefore", e[e.WidgetAfter = 2] = "WidgetAfter", e[e.WidgetRange = 3] = "WidgetRange", e;
}(Cn || (Cn = {})), $e = function(e) {
  Et(n, Ta);
  var t = Mt(n);
  function n(r, i, o, a) {
    var s;
    return Z(this, n), (s = t.call(this)).startSide = r, s.endSide = i, s.widget = o, s.spec = a, s;
  }
  return Y(n, [{ key: "heightRelevant", get: function() {
    return !1;
  } }, { key: "hasHeight", value: function() {
    return !!this.widget && this.widget.estimatedHeight > -1;
  } }], [{ key: "mark", value: function(r) {
    return new XA(r);
  } }, { key: "widget", value: function(r) {
    var i = r.side || 0, o = !!r.block;
    return new vc(r, i += o ? i > 0 ? 3e8 : -4e8 : i > 0 ? 1e8 : -1e8, i, o, r.widget || null, !1);
  } }, { key: "replace", value: function(r) {
    var i, o, a = !!r.block;
    if (r.isBlockGap)
      i = -5e8, o = 4e8;
    else {
      var s = ZA(r, a);
      i = (s.start ? a ? -3e8 : -1 : 5e8) - 1, o = 1 + (s.end ? a ? 2e8 : 1 : -6e8);
    }
    return new vc(r, i, o, a, r.widget || null, !0);
  } }, { key: "line", value: function(r) {
    return new zp(r);
  } }, { key: "set", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return Nn.of(r, i);
  } }]), n;
}();
$e.none = Nn.empty;
var XA = function(e) {
  Et(n, $e);
  var t = Mt(n);
  function n(r) {
    var i;
    Z(this, n);
    var o = ZA(r), a = o.start, s = o.end;
    return (i = t.call(this, a ? -1 : 5e8, s ? 1 : -6e8, null, r)).tagName = r.tagName || "span", i.class = r.class || "", i.attrs = r.attributes || null, i;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return this == r || r instanceof n && this.tagName == r.tagName && this.class == r.class && v0(this.attrs, r.attrs);
  } }, { key: "range", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r;
    if (r >= i)
      throw new RangeError("Mark decorations may not be empty");
    return Je(qe(n.prototype), "range", this).call(this, r, i);
  } }]), n;
}();
XA.prototype.point = !1;
var zp = function(e) {
  Et(n, $e);
  var t = Mt(n);
  function n(r) {
    return Z(this, n), t.call(this, -2e8, -2e8, null, r);
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return r instanceof n && v0(this.spec.attributes, r.spec.attributes);
  } }, { key: "range", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r;
    if (i != r)
      throw new RangeError("Line decoration ranges must be zero-length");
    return Je(qe(n.prototype), "range", this).call(this, r, i);
  } }]), n;
}();
zp.prototype.mapMode = Ir.TrackBefore, zp.prototype.point = !0;
var vc = function(e) {
  Et(n, $e);
  var t = Mt(n);
  function n(r, i, o, a, s, u) {
    var c;
    return Z(this, n), (c = t.call(this, i, o, s, r)).block = a, c.isReplace = u, c.mapMode = a ? i <= 0 ? Ir.TrackBefore : Ir.TrackAfter : Ir.TrackDel, c;
  }
  return Y(n, [{ key: "type", get: function() {
    return this.startSide < this.endSide ? Cn.WidgetRange : this.startSide <= 0 ? Cn.WidgetBefore : Cn.WidgetAfter;
  } }, { key: "heightRelevant", get: function() {
    return this.block || !!this.widget && this.widget.estimatedHeight >= 5;
  } }, { key: "eq", value: function(r) {
    return r instanceof n && (i = this.widget, o = r.widget, i == o || !!(i && o && i.compare(o))) && this.block == r.block && this.startSide == r.startSide && this.endSide == r.endSide;
    var i, o;
  } }, { key: "range", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r;
    if (this.isReplace && (r > i || r == i && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && i != r)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return Je(qe(n.prototype), "range", this).call(this, r, i);
  } }]), n;
}();
function ZA(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = e.inclusiveStart, r = e.inclusiveEnd;
  return n == null && (n = e.inclusive), r == null && (r = e.inclusive), { start: n != null ? n : t, end: r != null ? r : t };
}
function Bp(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = n.length - 1;
  i >= 0 && n[i] + r >= e ? n[i] = Math.max(n[i], t) : n.push(e, t);
}
vc.prototype.point = !0;
var Ei = function(e) {
  Et(n, Zn);
  var t = Mt(n);
  function n() {
    var r;
    return Z(this, n), (r = t.apply(this, arguments)).children = [], r.length = 0, r.prevAttrs = void 0, r.attrs = null, r.breakAfter = 0, r;
  }
  return Y(n, [{ key: "merge", value: function(r, i, o, a, s, u) {
    if (o) {
      if (!(o instanceof n))
        return !1;
      this.dom || o.transferDOM(this);
    }
    return a && this.setDeco(o ? o.attrs : null), VA(this, r, i, o ? o.children : [], s, u), !0;
  } }, { key: "split", value: function(r) {
    var i = new n();
    if (i.breakAfter = this.breakAfter, this.length == 0)
      return i;
    var o = this.childPos(r), a = o.i, s = o.off;
    s && (i.append(this.children[a].split(s), 0), this.children[a].merge(s, this.children[a].length, null, !1, 0, 0), a++);
    for (var u = a; u < this.children.length; u++)
      i.append(this.children[u], 0);
    for (; a > 0 && this.children[a - 1].length == 0; )
      this.children[--a].destroy();
    return this.children.length = a, this.markDirty(), this.length = r, i;
  } }, { key: "transferDOM", value: function(r) {
    this.dom && (this.markDirty(), r.setDOM(this.dom), r.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  } }, { key: "setDeco", value: function(r) {
    v0(this.attrs, r) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = r);
  } }, { key: "append", value: function(r, i) {
    GA(this, r, i);
  } }, { key: "addLineDeco", value: function(r) {
    var i = r.spec.attributes, o = r.spec.class;
    i && (this.attrs = Dp(i, this.attrs || {})), o && (this.attrs = Dp({ class: o }, this.attrs || {}));
  } }, { key: "domAtPos", value: function(r) {
    return KA(this.dom, this.children, r);
  } }, { key: "reuseDOM", value: function(r) {
    r.nodeName == "DIV" && (this.setDOM(r), this.dirty |= 6);
  } }, { key: "sync", value: function(r) {
    var i;
    this.dom ? 4 & this.dirty && (BA(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (Lp(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), Je(qe(n.prototype), "sync", this).call(this, r);
    for (var o = this.dom.lastChild; o && Zn.get(o) instanceof Ha; )
      o = o.lastChild;
    if (!(o && this.length && (o.nodeName == "BR" || ((i = Zn.get(o)) === null || i === void 0 ? void 0 : i.isEditable) != 0 || ye.ios && this.children.some(function(s) {
      return s instanceof dc;
    })))) {
      var a = document.createElement("BR");
      a.cmIgnore = !0, this.dom.appendChild(a);
    }
  } }, { key: "measureTextSize", value: function() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    var r, i = 0, o = ut(this.children);
    try {
      for (o.s(); !(r = o.n()).done; ) {
        var a = r.value;
        if (!(a instanceof dc))
          return null;
        var s = fc(a.dom);
        if (s.length != 1)
          return null;
        i += s[0].width;
      }
    } catch (u) {
      o.e(u);
    } finally {
      o.f();
    }
    return { lineHeight: this.dom.getBoundingClientRect().height, charWidth: i / this.length };
  } }, { key: "coordsAt", value: function(r, i) {
    return QA(this, r, i);
  } }, { key: "become", value: function(r) {
    return !1;
  } }, { key: "type", get: function() {
    return Cn.Text;
  } }], [{ key: "find", value: function(r, i) {
    for (var o = 0, a = 0; o < r.children.length; o++) {
      var s = r.children[o], u = a + s.length;
      if (u >= i) {
        if (s instanceof n)
          return s;
        if (u > i)
          break;
      }
      a = u + s.breakAfter;
    }
    return null;
  } }]), n;
}(), Fp = function(e) {
  Et(n, Zn);
  var t = Mt(n);
  function n(r, i, o) {
    var a;
    return Z(this, n), (a = t.call(this)).widget = r, a.length = i, a.type = o, a.breakAfter = 0, a.prevWidget = null, a;
  }
  return Y(n, [{ key: "merge", value: function(r, i, o, a, s, u) {
    return !(o && (!(o instanceof n && this.widget.compare(o.widget)) || r > 0 && s <= 0 || i < this.length && u <= 0)) && (this.length = r + (o ? o.length : 0) + (this.length - i), !0);
  } }, { key: "domAtPos", value: function(r) {
    return r == 0 ? qr.before(this.dom) : qr.after(this.dom, r == this.length);
  } }, { key: "split", value: function(r) {
    var i = this.length - r;
    this.length = r;
    var o = new n(this.widget, i, this.type);
    return o.breakAfter = this.breakAfter, o;
  } }, { key: "children", get: function() {
    return h0;
  } }, { key: "sync", value: function() {
    this.dom && this.widget.updateDOM(this.dom) || (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(this.editorView)), this.dom.contentEditable = "false");
  } }, { key: "overrideDOMText", get: function() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : xn.empty;
  } }, { key: "domBoundsAround", value: function() {
    return null;
  } }, { key: "become", value: function(r) {
    return r instanceof n && r.type == this.type && r.widget.constructor == this.widget.constructor && (r.widget.eq(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = r.widget, this.length = r.length, this.breakAfter = r.breakAfter, !0);
  } }, { key: "ignoreMutation", value: function() {
    return !0;
  } }, { key: "ignoreEvent", value: function(r) {
    return this.widget.ignoreEvent(r);
  } }, { key: "destroy", value: function() {
    Je(qe(n.prototype), "destroy", this).call(this), this.dom && this.widget.destroy(this.dom);
  } }]), n;
}(), _V = function() {
  function e(t, n, r, i) {
    Z(this, e), this.doc = t, this.pos = n, this.end = r, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = t.iter(), this.skip = n;
  }
  return Y(e, [{ key: "posCovered", value: function() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    var t = this.content[this.content.length - 1];
    return !(t.breakAfter || t instanceof Fp && t.type == Cn.WidgetBefore);
  } }, { key: "getLine", value: function() {
    return this.curLine || (this.content.push(this.curLine = new Ei()), this.atCursorPos = !0), this.curLine;
  } }, { key: "flushBuffer", value: function(t) {
    this.pendingBuffer && (this.curLine.append(Ol(new Rp(-1), t), t.length), this.pendingBuffer = 0);
  } }, { key: "addBlockWidget", value: function(t) {
    this.flushBuffer([]), this.curLine = null, this.content.push(t);
  } }, { key: "finish", value: function(t) {
    t ? this.pendingBuffer = 0 : this.flushBuffer([]), this.posCovered() || this.getLine();
  } }, { key: "buildText", value: function(t, n, r) {
    for (; t > 0; ) {
      if (this.textOff == this.text.length) {
        var i = this.cursor.next(this.skip), o = i.value, a = i.lineBreak, s = i.done;
        if (this.skip = 0, s)
          throw new Error("Ran out of text content when drawing inline views");
        if (a) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer([]), this.curLine = null, t--;
          continue;
        }
        this.text = o, this.textOff = 0;
      }
      var u = Math.min(this.text.length - this.textOff, t, 512);
      this.flushBuffer(n.slice(0, r)), this.getLine().append(Ol(new dc(this.text.slice(this.textOff, this.textOff + u)), n), r), this.atCursorPos = !0, this.textOff += u, t -= u, r = 0;
    }
  } }, { key: "span", value: function(t, n, r, i) {
    this.buildText(n - t, r, i), this.pos = n, this.openStart < 0 && (this.openStart = i);
  } }, { key: "point", value: function(t, n, r, i, o, a) {
    if (this.disallowBlockEffectsFor[a] && r instanceof vc) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (n > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    var s = n - t;
    if (r instanceof vc)
      if (r.block) {
        var u = r.type;
        u != Cn.WidgetAfter || this.posCovered() || this.getLine(), this.addBlockWidget(new Fp(r.widget || new Bj("div"), s, u));
      } else {
        var c = d0.create(r.widget || new Bj("span"), s, r.startSide), l = this.atCursorPos && !c.isEditable && o <= i.length && (t < n || r.startSide > 0), f = !c.isEditable && (t < n || r.startSide <= 0), h = this.getLine();
        this.pendingBuffer != 2 || l || (this.pendingBuffer = 0), this.flushBuffer(i), l && (h.append(Ol(new Rp(1), i), o), o = i.length + Math.max(0, o - i.length)), h.append(Ol(c, i), o), this.atCursorPos = f, this.pendingBuffer = f ? t < n ? 1 : 2 : 0;
      }
    else
      this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    s && (this.textOff + s <= this.text.length ? this.textOff += s : (this.skip += s - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = n), this.openStart < 0 && (this.openStart = o);
  } }], [{ key: "build", value: function(t, n, r, i, o) {
    var a = new e(t, n, r, o);
    return a.openEnd = Nn.spans(i, n, r, a), a.openStart < 0 && (a.openStart = a.openEnd), a.finish(a.openEnd), a;
  } }]), e;
}();
function Ol(e, t) {
  var n, r = ut(t);
  try {
    for (r.s(); !(n = r.n()).done; ) {
      var i = n.value;
      e = new Ha(i, [e], e.length);
    }
  } catch (o) {
    r.e(o);
  } finally {
    r.f();
  }
  return e;
}
var Bj = function(e) {
  Et(n, ba);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).tag = r, i;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return r.tag == this.tag;
  } }, { key: "toDOM", value: function() {
    return document.createElement(this.tag);
  } }, { key: "updateDOM", value: function(r) {
    return r.nodeName.toLowerCase() == this.tag;
  } }]), n;
}(), YA = be.define(), tP = be.define(), eP = be.define(), nP = be.define(), qp = be.define(), rP = be.define(), iP = be.define({ combine: function(e) {
  return e.some(function(t) {
    return t;
  });
} }), Fj = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "nearest", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "nearest", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 5, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 5;
    Z(this, e), this.range = t, this.y = n, this.x = r, this.yMargin = i, this.xMargin = o;
  }
  return Y(e, [{ key: "map", value: function(t) {
    return t.empty ? this : new e(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin);
  } }]), e;
}(), qj = He.define({ map: function(e, t) {
  return e.map(t);
} });
function ei(e, t, n) {
  var r = e.facet(nP);
  r.length ? r[0](t) : window.onerror ? window.onerror(String(t), n, void 0, void 0, t) : n ? console.error(n + ":", t) : console.error(t);
}
var ud = be.define({ combine: function(e) {
  return !e.length || e[0];
} }), CV = 0, Iu = be.define(), wr = function() {
  function e(t, n, r, i) {
    Z(this, e), this.id = t, this.create = n, this.domEventHandlers = r, this.extension = i(this);
  }
  return Y(e, null, [{ key: "define", value: function(t, n) {
    var r = n || {}, i = r.eventHandlers, o = r.provide, a = r.decorations;
    return new e(CV++, t, i, function(s) {
      var u = [Iu.of(s)];
      return a && u.push(pc.of(function(c) {
        var l = c.plugin(s);
        return l ? a(l) : $e.none;
      })), o && u.push(o(s)), u;
    });
  } }, { key: "fromClass", value: function(t, n) {
    return e.define(function(r) {
      return new t(r);
    }, n);
  } }]), e;
}(), Kd = function() {
  function e(t) {
    Z(this, e), this.spec = t, this.mustUpdate = null, this.value = null;
  }
  return Y(e, [{ key: "update", value: function(t) {
    if (this.value) {
      if (this.mustUpdate) {
        var n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(n);
          } catch (r) {
            if (ei(n.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(t);
      } catch (r) {
        ei(t.state, r, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  } }, { key: "destroy", value: function(t) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        ei(t.state, r, "CodeMirror plugin crashed");
      }
  } }, { key: "deactivate", value: function() {
    this.spec = this.value = null;
  } }]), e;
}(), oP = be.define(), aP = be.define(), pc = be.define(), sP = be.define(), uP = be.define(), Nu = be.define(), mc = function() {
  function e(t, n, r, i) {
    Z(this, e), this.fromA = t, this.toA = n, this.fromB = r, this.toB = i;
  }
  return Y(e, [{ key: "join", value: function(t) {
    return new e(Math.min(this.fromA, t.fromA), Math.max(this.toA, t.toA), Math.min(this.fromB, t.fromB), Math.max(this.toB, t.toB));
  } }, { key: "addToSet", value: function(t) {
    for (var n = t.length, r = this; n > 0; n--) {
      var i = t[n - 1];
      if (!(i.fromA > r.toA)) {
        if (i.toA < r.fromA)
          break;
        r = r.join(i), t.splice(n - 1, 1);
      }
    }
    return t.splice(n, 0, r), t;
  } }], [{ key: "extendWithRanges", value: function(t, n) {
    if (n.length == 0)
      return t;
    for (var r = [], i = 0, o = 0, a = 0, s = 0; ; i++) {
      for (var u = i == t.length ? null : t[i], c = a - s, l = u ? u.fromB : 1e9; o < n.length && n[o] < l; ) {
        var f = n[o], h = n[o + 1], d = Math.max(s, f), p = Math.min(l, h);
        if (d <= p && new e(d + c, p + c, d, p).addToSet(r), h > l)
          break;
        o += 2;
      }
      if (!u)
        return r;
      new e(u.fromA, u.toA, u.fromB, u.toB).addToSet(r), a = u.toA, s = u.toB;
    }
  } }]), e;
}(), Vj = function() {
  function e(t, n, r) {
    Z(this, e), this.view = t, this.state = n, this.transactions = r, this.flags = 0, this.startState = t.state, this.changes = qi.empty(this.startState.doc.length);
    var i, o = ut(r);
    try {
      for (o.s(); !(i = o.n()).done; ) {
        var a = i.value;
        this.changes = this.changes.compose(a.changes);
      }
    } catch (c) {
      o.e(c);
    } finally {
      o.f();
    }
    var s = [];
    this.changes.iterChangedRanges(function(c, l, f, h) {
      return s.push(new mc(c, l, f, h));
    }), this.changedRanges = s;
    var u = t.hasFocus;
    u != t.inputState.notifiedFocused && (t.inputState.notifiedFocused = u, this.flags |= 1);
  }
  return Y(e, [{ key: "viewportChanged", get: function() {
    return (4 & this.flags) > 0;
  } }, { key: "heightChanged", get: function() {
    return (2 & this.flags) > 0;
  } }, { key: "geometryChanged", get: function() {
    return this.docChanged || (10 & this.flags) > 0;
  } }, { key: "focusChanged", get: function() {
    return (1 & this.flags) > 0;
  } }, { key: "docChanged", get: function() {
    return !this.changes.empty;
  } }, { key: "selectionSet", get: function() {
    return this.transactions.some(function(t) {
      return t.selection;
    });
  } }, { key: "empty", get: function() {
    return this.flags == 0 && this.transactions.length == 0;
  } }], [{ key: "create", value: function(t, n, r) {
    return new e(t, n, r);
  } }]), e;
}(), Wn = function(e) {
  return e[e.LTR = 0] = "LTR", e[e.RTL = 1] = "RTL", e;
}(Wn || (Wn = {})), Vp = Wn.LTR, OV = Wn.RTL;
function Hj(e) {
  for (var t = [], n = 0; n < e.length; n++)
    t.push(1 << +e[n]);
  return t;
}
for (var AV = Hj("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), PV = Hj("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), Hp = /* @__PURE__ */ Object.create(null), Ji = [], Gd = 0, Wj = ["()", "[]", "{}"]; Gd < Wj.length; Gd++) {
  var Uj = Wj[Gd], Jj = Uj.charCodeAt(0), Kj = Uj.charCodeAt(1);
  Hp[Jj] = Kj, Hp[Kj] = -Jj;
}
function EV(e) {
  return e <= 247 ? AV[e] : 1424 <= e && e <= 1524 ? 2 : 1536 <= e && e <= 1785 ? PV[e - 1536] : 1774 <= e && e <= 2220 ? 4 : 8192 <= e && e <= 8203 || e == 8204 ? 256 : 1;
}
var MV = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/, js = function() {
  function e(t, n, r) {
    Z(this, e), this.from = t, this.to = n, this.level = r;
  }
  return Y(e, [{ key: "dir", get: function() {
    return this.level % 2 ? OV : Vp;
  } }, { key: "side", value: function(t, n) {
    return this.dir == n == t ? this.to : this.from;
  } }], [{ key: "find", value: function(t, n, r, i) {
    for (var o = -1, a = 0; a < t.length; a++) {
      var s = t[a];
      if (s.from <= n && s.to >= n) {
        if (s.level == r)
          return a;
        (o < 0 || (i != 0 ? i < 0 ? s.from < n : s.to > n : t[o].level > s.level)) && (o = a);
      }
    }
    if (o < 0)
      throw new RangeError("Index out of range");
    return o;
  } }]), e;
}(), Vn = [];
function Gj(e) {
  return [new js(0, e, 0)];
}
var cP = "";
function TV(e, t, n, r, i) {
  var o, a = r.head - e.from, s = -1;
  if (a == 0) {
    if (!i || !e.length)
      return null;
    t[0].level != n && (a = t[0].side(!1, n), s = 0);
  } else if (a == e.length) {
    if (i)
      return null;
    var u = t[t.length - 1];
    u.level != n && (a = u.side(!0, n), s = t.length - 1);
  }
  s < 0 && (s = js.find(t, a, (o = r.bidiLevel) !== null && o !== void 0 ? o : -1, r.assoc));
  var c = t[s];
  a == c.side(i, n) && (a = (c = t[s += i ? 1 : -1]).side(!i, n));
  var l = i == (c.dir == n), f = Xr(e.text, a, l);
  if (cP = e.text.slice(Math.min(a, f), Math.max(a, f)), f != c.side(i, n))
    return Ht.cursor(f + e.from, l ? -1 : 1, c.level);
  var h = s == (i ? t.length - 1 : 0) ? null : t[s + (i ? 1 : -1)];
  return h || c.level == n ? h && h.level < c.level ? Ht.cursor(h.side(!i, n) + e.from, i ? 1 : -1, h.level) : Ht.cursor(f + e.from, i ? -1 : 1, c.level) : Ht.cursor(i ? e.to : e.from, i ? -1 : 1, n);
}
var lP = function() {
  function e(t, n) {
    Z(this, e), this.points = t, this.text = "", this.lineSeparator = n.facet(In.lineSeparator);
  }
  return Y(e, [{ key: "append", value: function(t) {
    this.text += t;
  } }, { key: "lineBreak", value: function() {
    this.text += "\uFFFF";
  } }, { key: "readRange", value: function(t, n) {
    if (!t)
      return this;
    for (var r = t.parentNode, i = t; ; ) {
      this.findPointBefore(r, i), this.readNode(i);
      var o = i.nextSibling;
      if (o == n)
        break;
      var a = Zn.get(i), s = Zn.get(o);
      (a && s ? a.breakAfter : (a ? a.breakAfter : Qj(i)) || Qj(o) && (i.nodeName != "BR" || i.cmIgnore)) && this.lineBreak(), i = o;
    }
    return this.findPointBefore(r, n), this;
  } }, { key: "readTextNode", value: function(t) {
    var n, r = t.nodeValue, i = ut(this.points);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value;
        o.node == t && (o.pos = this.text.length + Math.min(o.offset, r.length));
      }
    } catch (p) {
      i.e(p);
    } finally {
      i.f();
    }
    for (var a = 0, s = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      var u = -1, c = 1, l = void 0;
      if (this.lineSeparator ? (u = r.indexOf(this.lineSeparator, a), c = this.lineSeparator.length) : (l = s.exec(r)) && (u = l.index, c = l[0].length), this.append(r.slice(a, u < 0 ? r.length : u)), u < 0)
        break;
      if (this.lineBreak(), c > 1) {
        var f, h = ut(this.points);
        try {
          for (h.s(); !(f = h.n()).done; ) {
            var d = f.value;
            d.node == t && d.pos > this.text.length && (d.pos -= c - 1);
          }
        } catch (p) {
          h.e(p);
        } finally {
          h.f();
        }
      }
      a = u + c;
    }
  } }, { key: "readNode", value: function(t) {
    if (!t.cmIgnore) {
      var n = Zn.get(t), r = n && n.overrideDOMText;
      if (r != null) {
        this.findPointInside(t, r.length);
        for (var i = r.iter(); !i.next().done; )
          i.lineBreak ? this.lineBreak() : this.append(i.value);
      } else
        t.nodeType == 3 ? this.readTextNode(t) : t.nodeName == "BR" ? t.nextSibling && this.lineBreak() : t.nodeType == 1 && this.readRange(t.firstChild, null);
    }
  } }, { key: "findPointBefore", value: function(t, n) {
    var r, i = ut(this.points);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        o.node == t && t.childNodes[o.offset] == n && (o.pos = this.text.length);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
  } }, { key: "findPointInside", value: function(t, n) {
    var r, i = ut(this.points);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        (t.nodeType == 3 ? o.node == t : t.contains(o.node)) && (o.pos = this.text.length + Math.min(n, o.offset));
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
  } }]), e;
}();
function Qj(e) {
  return e.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(e.nodeName);
}
var Xj = Y(function e(t, n) {
  Z(this, e), this.node = t, this.offset = n, this.pos = -1;
}), Zj = function(e) {
  Et(n, Zn);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).view = r, i.compositionDeco = $e.none, i.decorations = [], i.dynamicDecorationMap = [], i.minWidth = 0, i.minWidthFrom = 0, i.minWidthTo = 0, i.impreciseAnchor = null, i.impreciseHead = null, i.forceSelection = !1, i.lastUpdate = Date.now(), i.setDOM(r.contentDOM), i.children = [new Ei()], i.children[0].setParent(he(i)), i.updateDeco(), i.updateInner([new mc(0, 0, 0, r.state.doc.length)], 0), i;
  }
  return Y(n, [{ key: "root", get: function() {
    return this.view.root;
  } }, { key: "editorView", get: function() {
    return this.view;
  } }, { key: "length", get: function() {
    return this.view.state.doc.length;
  } }, { key: "update", value: function(r) {
    var i = this, o = r.changedRanges;
    this.minWidth > 0 && o.length && (o.every(function(d) {
      var p = d.fromA;
      return d.toA < i.minWidthFrom || p > i.minWidthTo;
    }) ? (this.minWidthFrom = r.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = r.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.view.inputState.composing < 0 ? this.compositionDeco = $e.none : (r.transactions.length || this.dirty) && (this.compositionDeco = function(d, p) {
      var v = fP(d);
      if (!v)
        return $e.none;
      var m = v.from, g = v.to, y = v.node, b = v.text, k = p.mapPos(m, 1), w = Math.max(k, p.mapPos(g, -1)), x = d.state, S = y.nodeType == 3 ? y.nodeValue : new lP([], x).readRange(y.firstChild, null).text;
      if (w - k < S.length)
        if (x.doc.sliceString(k, Math.min(x.doc.length, k + S.length), "\uFFFF") == S)
          w = k + S.length;
        else {
          if (x.doc.sliceString(Math.max(0, w - S.length), w, "\uFFFF") != S)
            return $e.none;
          k = w - S.length;
        }
      else if (x.doc.sliceString(k, w, "\uFFFF") != S)
        return $e.none;
      var T = Zn.get(y);
      return T instanceof UA ? T = T.widget.topView : T && (T.parent = null), $e.set($e.replace({ widget: new NV(y, b, T), inclusive: !0 }).range(k, w));
    }(this.view, r.changes)), (ye.ie || ye.chrome) && !this.compositionDeco.size && r && r.state.doc.lines != r.startState.doc.lines && (this.forceSelection = !0);
    var a, s, u, c, l = this.decorations, f = this.updateDeco(), h = (a = l, s = f, u = r.changes, c = new DV(), Nn.compare(a, s, u, c), c.changes);
    return o = mc.extendWithRanges(o, h), (this.dirty != 0 || o.length != 0) && (this.updateInner(o, r.startState.doc.length), r.transactions.length && (this.lastUpdate = Date.now()), !0);
  } }, { key: "updateInner", value: function(r, i) {
    var o = this;
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(r, i);
    var a = this.view.observer;
    a.ignore(function() {
      o.dom.style.height = o.view.viewState.contentHeight + "px", o.dom.style.flexBasis = o.minWidth ? o.minWidth + "px" : "";
      var f = ye.chrome || ye.ios ? { node: a.selectionRange.focusNode, written: !1 } : void 0;
      o.sync(f), o.dirty = 0, f && (f.written || a.selectionRange.focusNode != f.node) && (o.forceSelection = !0), o.dom.style.height = "";
    });
    var s = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
      var u, c = ut(this.children);
      try {
        for (c.s(); !(u = c.n()).done; ) {
          var l = u.value;
          l instanceof Fp && l.widget instanceof Yj && s.push(l.dom);
        }
      } catch (f) {
        c.e(f);
      } finally {
        c.f();
      }
    }
    a.updateGaps(s);
  } }, { key: "updateChildren", value: function(r, i) {
    for (var o = this.childCursor(i), a = r.length - 1; ; a--) {
      var s = a >= 0 ? r[a] : null;
      if (!s)
        break;
      var u = s.fromA, c = s.toA, l = s.fromB, f = s.toB, h = _V.build(this.view.state.doc, l, f, this.decorations, this.dynamicDecorationMap), d = h.content, p = h.breakAtStart, v = h.openStart, m = h.openEnd, g = o.findPos(c, 1), y = g.i, b = g.off, k = o.findPos(u, -1);
      qA(this, k.i, k.off, y, b, d, p, v, m);
    }
  } }, { key: "updateSelection", value: function() {
    var r = this, i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    if (!i && this.view.observer.selectionRange.focusNode || this.view.observer.readSelectionRange(), !(!o && !this.mayControlSelection() || ye.ios && this.view.inputState.rapidCompositionStart)) {
      var a = this.forceSelection;
      this.forceSelection = !1;
      var s = this.view.state.selection.main, u = this.domAtPos(s.anchor), c = s.empty ? u : this.domAtPos(s.head);
      if (ye.gecko && s.empty && IV(u)) {
        var l = document.createTextNode("");
        this.view.observer.ignore(function() {
          return u.node.insertBefore(l, u.node.childNodes[u.offset] || null);
        }), u = c = new qr(l, 0), a = !0;
      }
      var f = this.view.observer.selectionRange;
      !a && f.focusNode && Hf(u.node, u.offset, f.anchorNode, f.anchorOffset) && Hf(c.node, c.offset, f.focusNode, f.focusOffset) || (this.view.observer.ignore(function() {
        ye.android && ye.chrome && r.dom.contains(f.focusNode) && LV(f.focusNode, r.dom) && (r.dom.blur(), r.dom.focus({ preventScroll: !0 }));
        var h = Vf(r.root);
        if (h)
          if (s.empty) {
            if (ye.gecko) {
              var d = RV(u.node, u.offset);
              if (d && d != 3) {
                var p = hP(u.node, u.offset, d == 1 ? 1 : -1);
                p && (u = new qr(p, d == 1 ? 0 : p.nodeValue.length));
              }
            }
            h.collapse(u.node, u.offset), s.bidiLevel != null && f.cursorBidiLevel != null && (f.cursorBidiLevel = s.bidiLevel);
          } else if (h.extend)
            h.collapse(u.node, u.offset), h.extend(c.node, c.offset);
          else {
            var v = document.createRange();
            if (s.anchor > s.head) {
              var m = [c, u];
              u = m[0], c = m[1];
            }
            v.setEnd(c.node, c.offset), v.setStart(u.node, u.offset), h.removeAllRanges(), h.addRange(v);
          }
      }), this.view.observer.setSelectionRange(u, c)), this.impreciseAnchor = u.precise ? null : new qr(f.anchorNode, f.anchorOffset), this.impreciseHead = c.precise ? null : new qr(f.focusNode, f.focusOffset);
    }
  } }, { key: "enforceCursorAssoc", value: function() {
    if (!this.compositionDeco.size) {
      var r = this.view.state.selection.main, i = Vf(this.root);
      if (i && r.empty && r.assoc && i.modify) {
        var o = Ei.find(this, r.head);
        if (o) {
          var a = o.posAtStart;
          if (r.head != a && r.head != a + o.length) {
            var s = this.coordsAt(r.head, -1), u = this.coordsAt(r.head, 1);
            if (s && u && !(s.bottom > u.top)) {
              var c = this.domAtPos(r.head + r.assoc);
              i.collapse(c.node, c.offset), i.modify("move", r.assoc < 0 ? "forward" : "backward", "lineboundary");
            }
          }
        }
      }
    }
  } }, { key: "mayControlSelection", value: function() {
    var r = this.root.activeElement;
    return r == this.dom || Ap(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
  } }, { key: "nearest", value: function(r) {
    for (var i = r; i; ) {
      var o = Zn.get(i);
      if (o && o.rootView == this)
        return o;
      i = i.parentNode;
    }
    return null;
  } }, { key: "posFromDOM", value: function(r, i) {
    var o = this.nearest(r);
    if (!o)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return o.localPosFromDOM(r, i) + o.posAtStart;
  } }, { key: "domAtPos", value: function(r) {
    for (var i = this.childCursor().findPos(r, -1), o = i.i, a = i.off; o < this.children.length - 1; ) {
      var s = this.children[o];
      if (a < s.length || s instanceof Ei)
        break;
      o++, a = 0;
    }
    return this.children[o].domAtPos(a);
  } }, { key: "coordsAt", value: function(r, i) {
    for (var o = this.length, a = this.children.length - 1; ; a--) {
      var s = this.children[a], u = o - s.breakAfter - s.length;
      if (r > u || r == u && s.type != Cn.WidgetBefore && s.type != Cn.WidgetAfter && (!a || i == 2 || this.children[a - 1].breakAfter || this.children[a - 1].type == Cn.WidgetBefore && i > -2))
        return s.coordsAt(r - u, i);
      o = u;
    }
  } }, { key: "measureVisibleLineHeights", value: function(r) {
    for (var i = [], o = r.from, a = r.to, s = this.view.contentDOM.clientWidth, u = s > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, c = -1, l = this.view.textDirection == Wn.LTR, f = 0, h = 0; h < this.children.length; h++) {
      var d = this.children[h], p = f + d.length;
      if (p > a)
        break;
      if (f >= o) {
        var v = d.dom.getBoundingClientRect();
        if (i.push(v.height), u) {
          var m = d.dom.lastChild, g = m ? fc(m) : [];
          if (g.length) {
            var y = g[g.length - 1], b = l ? y.right - v.left : v.right - y.left;
            b > c && (c = b, this.minWidth = s, this.minWidthFrom = f, this.minWidthTo = p);
          }
        }
      }
      f = p + d.breakAfter;
    }
    return i;
  } }, { key: "textDirectionAt", value: function(r) {
    var i = this.childPos(r, 1).i;
    return getComputedStyle(this.children[i].dom).direction == "rtl" ? Wn.RTL : Wn.LTR;
  } }, { key: "measureTextSize", value: function() {
    var r, i = this, o = ut(this.children);
    try {
      for (o.s(); !(r = o.n()).done; ) {
        var a = r.value;
        if (a instanceof Ei) {
          var s = a.measureTextSize();
          if (s)
            return s;
        }
      }
    } catch (f) {
      o.e(f);
    } finally {
      o.f();
    }
    var u, c, l = document.createElement("div");
    return l.className = "cm-line", l.style.width = "99999px", l.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(function() {
      i.dom.appendChild(l);
      var f = fc(l.firstChild)[0];
      u = l.getBoundingClientRect().height, c = f ? f.width / 27 : 7, l.remove();
    }), { lineHeight: u, charWidth: c };
  } }, { key: "childCursor", value: function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.length, i = this.children.length;
    return i && (r -= this.children[--i].length), new FA(this.children, r, i);
  } }, { key: "computeBlockGapDeco", value: function() {
    for (var r = [], i = this.view.viewState, o = 0, a = 0; ; a++) {
      var s = a == i.viewports.length ? null : i.viewports[a], u = s ? s.from - 1 : this.length;
      if (u > o) {
        var c = i.lineBlockAt(u).bottom - i.lineBlockAt(o).top;
        r.push($e.replace({ widget: new Yj(c), block: !0, inclusive: !0, isBlockGap: !0 }).range(o, u));
      }
      if (!s)
        break;
      o = s.to + 1;
    }
    return $e.set(r);
  } }, { key: "updateDeco", value: function() {
    for (var r = this, i = this.view.state.facet(pc).map(function(a, s) {
      return (r.dynamicDecorationMap[s] = typeof a == "function") ? a(r.view) : a;
    }), o = i.length; o < i.length + 3; o++)
      this.dynamicDecorationMap[o] = !1;
    return this.decorations = [].concat(Pe(i), [this.compositionDeco, this.computeBlockGapDeco(), this.view.viewState.lineGapDeco]);
  } }, { key: "scrollIntoView", value: function(r) {
    var i, o = this, a = r.range, s = this.coordsAt(a.head, a.empty ? a.assoc : a.head > a.anchor ? -1 : 1);
    if (s) {
      !a.empty && (i = this.coordsAt(a.anchor, a.anchor > a.head ? -1 : 1)) && (s = { left: Math.min(s.left, i.left), top: Math.min(s.top, i.top), right: Math.max(s.right, i.right), bottom: Math.max(s.bottom, i.bottom) });
      var u, c = 0, l = 0, f = 0, h = 0, d = ut(this.view.state.facet(uP).map(function(k) {
        return k(o.view);
      }));
      try {
        for (d.s(); !(u = d.n()).done; ) {
          var p = u.value;
          if (p) {
            var v = p.left, m = p.right, g = p.top, y = p.bottom;
            v != null && (c = Math.max(c, v)), m != null && (l = Math.max(l, m)), g != null && (f = Math.max(f, g)), y != null && (h = Math.max(h, y));
          }
        }
      } catch (k) {
        d.e(k);
      } finally {
        d.f();
      }
      var b = { left: s.left - c, top: s.top - f, right: s.right + l, bottom: s.bottom + h };
      (function(k, w, x, S, T, P, O, j) {
        for (var V = k.ownerDocument, E = V.defaultView, C = k; C; )
          if (C.nodeType == 1) {
            var H = void 0, X = C == V.body;
            if (X)
              H = jV(E);
            else {
              if (C.scrollHeight <= C.clientHeight && C.scrollWidth <= C.clientWidth) {
                C = C.parentNode;
                continue;
              }
              var F = C.getBoundingClientRect();
              H = { left: F.left, right: F.left + C.clientWidth, top: F.top, bottom: F.top + C.clientHeight };
            }
            var G = 0, M = 0;
            if (T == "nearest")
              w.top < H.top ? (M = -(H.top - w.top + O), x > 0 && w.bottom > H.bottom + M && (M = w.bottom - H.bottom + M + O)) : w.bottom > H.bottom && (M = w.bottom - H.bottom + O, x < 0 && w.top - M < H.top && (M = -(H.top + M - w.top + O)));
            else {
              var $ = w.bottom - w.top, q = H.bottom - H.top;
              M = (T == "center" && $ <= q ? w.top + $ / 2 - q / 2 : T == "start" || T == "center" && x < 0 ? w.top - O : w.bottom - q + O) - H.top;
            }
            if (S == "nearest" ? w.left < H.left ? (G = -(H.left - w.left + P), x > 0 && w.right > H.right + G && (G = w.right - H.right + G + P)) : w.right > H.right && (G = w.right - H.right + P, x < 0 && w.left < H.left + G && (G = -(H.left + G - w.left + P))) : G = (S == "center" ? w.left + (w.right - w.left) / 2 - (H.right - H.left) / 2 : S == "start" == j ? w.left - P : w.right - (H.right - H.left) + P) - H.left, G || M)
              if (X)
                E.scrollBy(G, M);
              else {
                if (M) {
                  var B = C.scrollTop;
                  C.scrollTop += M, M = C.scrollTop - B;
                }
                if (G) {
                  var D = C.scrollLeft;
                  C.scrollLeft += G, G = C.scrollLeft - D;
                }
                w = { left: w.left - G, top: w.top - M, right: w.right - G, bottom: w.bottom - M };
              }
            if (X)
              break;
            C = C.assignedSlot || C.parentNode, S = T = "nearest";
          } else {
            if (C.nodeType != 11)
              break;
            C = C.host;
          }
      })(this.view.scrollDOM, b, a.head < a.anchor ? -1 : 1, r.x, r.y, r.xMargin, r.yMargin, this.view.textDirection == Wn.LTR);
    }
  } }]), n;
}();
function IV(e) {
  return e.node.nodeType == 1 && e.node.firstChild && (e.offset == 0 || e.node.childNodes[e.offset - 1].contentEditable == "false") && (e.offset == e.node.childNodes.length || e.node.childNodes[e.offset].contentEditable == "false");
}
var Yj = function(e) {
  Et(n, ba);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).height = r, i;
  }
  return Y(n, [{ key: "toDOM", value: function() {
    var r = document.createElement("div");
    return this.updateDOM(r), r;
  } }, { key: "eq", value: function(r) {
    return r.height == this.height;
  } }, { key: "updateDOM", value: function(r) {
    return r.style.height = this.height + "px", !0;
  } }, { key: "estimatedHeight", get: function() {
    return this.height;
  } }]), n;
}();
function fP(e) {
  var t = e.observer.selectionRange, n = t.focusNode && hP(t.focusNode, t.focusOffset, 0);
  if (!n)
    return null;
  var r = e.docView.nearest(n);
  if (!r)
    return null;
  if (r instanceof Ei) {
    for (var i = n; i.parentNode != r.dom; )
      i = i.parentNode;
    for (var o = i.previousSibling; o && !Zn.get(o); )
      o = o.previousSibling;
    var a = o ? Zn.get(o).posAtEnd : r.posAtStart;
    return { from: a, to: a, node: i, text: n };
  }
  for (; ; ) {
    var s = r.parent;
    if (!s)
      return null;
    if (s instanceof Ei)
      break;
    r = s;
  }
  var u = r.posAtStart;
  return { from: u, to: u + r.length, node: r.dom, text: n };
}
var NV = function(e) {
  Et(n, ba);
  var t = Mt(n);
  function n(r, i, o) {
    var a;
    return Z(this, n), (a = t.call(this)).top = r, a.text = i, a.topView = o, a;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return this.top == r.top && this.text == r.text;
  } }, { key: "toDOM", value: function() {
    return this.top;
  } }, { key: "ignoreEvent", value: function() {
    return !1;
  } }, { key: "customView", get: function() {
    return UA;
  } }]), n;
}();
function hP(e, t, n) {
  for (; ; ) {
    if (e.nodeType == 3)
      return e;
    if (e.nodeType == 1 && t > 0 && n <= 0)
      t = Wf(e = e.childNodes[t - 1]);
    else {
      if (!(e.nodeType == 1 && t < e.childNodes.length && n >= 0))
        return null;
      e = e.childNodes[t], t = 0;
    }
  }
}
function RV(e, t) {
  return e.nodeType != 1 ? 0 : (t && e.childNodes[t - 1].contentEditable == "false" ? 1 : 0) | (t < e.childNodes.length && e.childNodes[t].contentEditable == "false" ? 2 : 0);
}
var DV = function() {
  function e() {
    Z(this, e), this.changes = [];
  }
  return Y(e, [{ key: "compareRange", value: function(t, n) {
    Bp(t, n, this.changes);
  } }, { key: "comparePoint", value: function(t, n) {
    Bp(t, n, this.changes);
  } }]), e;
}();
function LV(e, t) {
  for (var n = e; n && n != t; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == "false")
      return !0;
  return !1;
}
function zV(e, t) {
  return t.left > e ? t.left - e : Math.max(0, e - t.right);
}
function BV(e, t) {
  return t.top > e ? t.top - e : Math.max(0, e - t.bottom);
}
function Qd(e, t) {
  return e.top < t.bottom - 1 && e.bottom > t.top + 1;
}
function t4(e, t) {
  return t < e.top ? { top: t, left: e.left, right: e.right, bottom: e.bottom } : e;
}
function e4(e, t) {
  return t > e.bottom ? { top: e.top, left: e.left, right: e.right, bottom: t } : e;
}
function Wp(e, t, n) {
  for (var r, i, o, a, s, u, c, l, f = e.firstChild; f; f = f.nextSibling)
    for (var h = fc(f), d = 0; d < h.length; d++) {
      var p = h[d];
      i && Qd(i, p) && (p = t4(e4(p, i.bottom), i.top));
      var v = zV(t, p), m = BV(n, p);
      if (v == 0 && m == 0)
        return f.nodeType == 3 ? n4(f, t, n) : Wp(f, t, n);
      (!r || a > m || a == m && o > v) && (r = f, i = p, o = v, a = m), v == 0 ? n > p.bottom && (!c || c.bottom < p.bottom) ? (s = f, c = p) : n < p.top && (!l || l.top > p.top) && (u = f, l = p) : c && Qd(c, p) ? c = e4(c, p.bottom) : l && Qd(l, p) && (l = t4(l, p.top));
    }
  if (c && c.bottom >= n ? (r = s, i = c) : l && l.top <= n && (r = u, i = l), !r)
    return { node: e, offset: 0 };
  var g = Math.max(i.left, Math.min(i.right, t));
  return r.nodeType == 3 ? n4(r, g, n) : o || r.contentEditable != "true" ? { node: e, offset: Array.prototype.indexOf.call(e.childNodes, r) + (t >= (i.left + i.right) / 2 ? 1 : 0) } : Wp(r, g, n);
}
function n4(e, t, n) {
  for (var r = e.nodeValue.length, i = -1, o = 1e9, a = 0, s = 0; s < r; s++)
    for (var u = hc(e, s, s + 1).getClientRects(), c = 0; c < u.length; c++) {
      var l = u[c];
      if (l.top != l.bottom) {
        a || (a = t - l.left);
        var f = (l.top > n ? l.top - n : n - l.bottom) - 1;
        if (l.left - 1 <= t && l.right + 1 >= t && f < o) {
          var h = t >= (l.left + l.right) / 2, d = h;
          if ((ye.chrome || ye.gecko) && hc(e, s).getBoundingClientRect().left == l.right && (d = !h), f <= 0)
            return { node: e, offset: s + (d ? 1 : 0) };
          i = s + (d ? 1 : 0), o = f;
        }
      }
    }
  return { node: e, offset: i > -1 ? i : a > 0 ? e.nodeValue.length : 0 };
}
function r4(e, t, n) {
  var r, i, o = t.x, a = t.y, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, u = e.contentDOM.getBoundingClientRect(), c = u.top + e.viewState.paddingTop, l = e.viewState.docHeight, f = a - c;
  if (f < 0)
    return 0;
  if (f > l)
    return e.state.doc.length;
  for (var h = e.defaultLineHeight / 2, d = !1; (i = e.elementAtHeight(f)).type != Cn.Text; )
    for (; !((f = s > 0 ? i.bottom + h : i.top - h) >= 0 && f <= l); ) {
      if (d)
        return n ? null : 0;
      d = !0, s = -s;
    }
  a = c + f;
  var p = i.from;
  if (p < e.viewport.from)
    return e.viewport.from == 0 ? 0 : n ? null : i4(e, u, i, o, a);
  if (p > e.viewport.to)
    return e.viewport.to == e.state.doc.length ? e.state.doc.length : n ? null : i4(e, u, i, o, a);
  var v = e.dom.ownerDocument, m = e.root.elementFromPoint ? e.root : v, g = m.elementFromPoint(o, a);
  g && !e.contentDOM.contains(g) && (g = null), g || (o = Math.max(u.left + 1, Math.min(u.right - 1, o)), (g = m.elementFromPoint(o, a)) && !e.contentDOM.contains(g) && (g = null));
  var y, b = -1;
  if (g && ((r = e.docView.nearest(g)) === null || r === void 0 ? void 0 : r.isEditable) != 0) {
    if (v.caretPositionFromPoint) {
      var k = v.caretPositionFromPoint(o, a);
      k && (y = k.offsetNode, b = k.offset);
    } else if (v.caretRangeFromPoint) {
      var w = v.caretRangeFromPoint(o, a);
      w && (y = w.startContainer, b = w.startOffset, ye.safari && FV(y, b, o) && (y = void 0));
    }
  }
  if (!y || !e.docView.dom.contains(y)) {
    var x = Ei.find(e.docView, p);
    if (!x)
      return f > i.top + i.height / 2 ? i.to : i.from;
    var S = Wp(x.dom, o, a);
    y = S.node, b = S.offset;
  }
  return e.docView.posFromDOM(y, b);
}
function i4(e, t, n, r, i) {
  var o = Math.round((r - t.left) * e.defaultCharacterWidth);
  e.lineWrapping && n.height > 1.5 * e.defaultLineHeight && (o += Math.floor((i - n.top) / e.defaultLineHeight) * e.viewState.heightOracle.lineLength);
  var a = e.state.sliceDoc(n.from, n.to);
  return n.from + Op(a, o, e.state.tabSize);
}
function FV(e, t, n) {
  var r;
  if (e.nodeType != 3 || t != (r = e.nodeValue.length))
    return !1;
  for (var i = e.nextSibling; i; i = i.nextSibling)
    if (i.nodeType != 1 || i.nodeName != "BR")
      return !1;
  return hc(e, r - 1, r).getBoundingClientRect().left > n;
}
function qV(e, t, n, r) {
  var i = e.state.doc.lineAt(t.head), o = r && e.lineWrapping ? e.coordsAtPos(t.assoc < 0 && t.head > i.from ? t.head - 1 : t.head) : null;
  if (o) {
    var a = e.dom.getBoundingClientRect(), s = e.textDirectionAt(i.from), u = e.posAtCoords({ x: n == (s == Wn.LTR) ? a.right - 1 : a.left + 1, y: (o.top + o.bottom) / 2 });
    if (u != null)
      return Ht.cursor(u, n ? -1 : 1);
  }
  var c = Ei.find(e.docView, t.head), l = c ? n ? c.posAtEnd : c.posAtStart : n ? i.to : i.from;
  return Ht.cursor(l, n ? -1 : 1);
}
function o4(e, t, n, r) {
  for (var i = e.state.doc.lineAt(t.head), o = e.bidiSpans(i), a = e.textDirectionAt(i.from), s = t, u = null; ; ) {
    var c = TV(i, o, a, s, n), l = cP;
    if (!c) {
      if (i.number == (n ? e.state.doc.lines : 1))
        return s;
      l = `
`, i = e.state.doc.line(i.number + (n ? 1 : -1)), o = e.bidiSpans(i), c = Ht.cursor(n ? i.from : i.to);
    }
    if (u) {
      if (!u(l))
        return s;
    } else {
      if (!r)
        return c;
      u = r(l);
    }
    s = c;
  }
}
function Xd(e, t, n) {
  for (var r = e.state.facet(sP).map(function(s) {
    return s(e);
  }); ; ) {
    var i, o = !1, a = ut(r);
    try {
      for (a.s(); !(i = a.n()).done; )
        i.value.between(n.from - 1, n.from + 1, function(s, u, c) {
          n.from > s && n.from < u && (n = t.from > n.from ? Ht.cursor(s, 1) : Ht.cursor(u, -1), o = !0);
        });
    } catch (s) {
      a.e(s);
    } finally {
      a.f();
    }
    if (!o)
      return n;
  }
}
var VV = function() {
  function e(t) {
    var n = this;
    Z(this, e), this.lastKeyCode = 0, this.lastKeyTime = 0, this.chromeScrollHack = -1, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastEscPress = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.registeredEvents = [], this.customHandlers = [], this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.rapidCompositionStart = !1, this.mouseSelection = null;
    var r = function(o) {
      var a = hr[o];
      t.contentDOM.addEventListener(o, function(s) {
        a4(t, s) && !n.ignoreDuringComposition(s) && (o == "keydown" && n.keydown(t, s) || (n.mustFlushObserver(s) && t.observer.forceFlush(), n.runCustomHandlers(o, t, s) ? s.preventDefault() : a(t, s)));
      }), n.registeredEvents.push(o);
    };
    for (var i in hr)
      r(i);
    ye.chrome && ye.chrome_version >= 102 && t.scrollDOM.addEventListener("wheel", function() {
      n.chromeScrollHack < 0 ? t.contentDOM.style.pointerEvents = "none" : window.clearTimeout(n.chromeScrollHack), n.chromeScrollHack = setTimeout(function() {
        n.chromeScrollHack = -1, t.contentDOM.style.pointerEvents = "";
      }, 100);
    }, { passive: !0 }), this.notifiedFocused = t.hasFocus, ye.safari && t.contentDOM.addEventListener("input", function() {
      return null;
    });
  }
  return Y(e, [{ key: "setSelectionOrigin", value: function(t) {
    this.lastSelectionOrigin = t, this.lastSelectionTime = Date.now();
  } }, { key: "ensureHandlers", value: function(t, n) {
    var r, i, o = this;
    this.customHandlers = [];
    var a, s = ut(n);
    try {
      for (s.s(); !(a = s.n()).done; ) {
        var u = a.value;
        if (i = (r = u.update(t).spec) === null || r === void 0 ? void 0 : r.domEventHandlers) {
          this.customHandlers.push({ plugin: u.value, handlers: i });
          var c = function(f) {
            o.registeredEvents.indexOf(f) < 0 && f != "scroll" && (o.registeredEvents.push(f), t.contentDOM.addEventListener(f, function(h) {
              a4(t, h) && o.runCustomHandlers(f, t, h) && h.preventDefault();
            }));
          };
          for (var l in i)
            c(l);
        }
      }
    } catch (f) {
      s.e(f);
    } finally {
      s.f();
    }
  } }, { key: "runCustomHandlers", value: function(t, n, r) {
    var i, o = ut(this.customHandlers);
    try {
      for (o.s(); !(i = o.n()).done; ) {
        var a = i.value, s = a.handlers[t];
        if (s)
          try {
            if (s.call(a.plugin, r, n) || r.defaultPrevented)
              return !0;
          } catch (u) {
            ei(n.state, u);
          }
      }
    } catch (u) {
      o.e(u);
    } finally {
      o.f();
    }
    return !1;
  } }, { key: "runScrollHandlers", value: function(t, n) {
    var r, i = ut(this.customHandlers);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value, a = o.handlers.scroll;
        if (a)
          try {
            a.call(o.plugin, n, t);
          } catch (s) {
            ei(t.state, s);
          }
      }
    } catch (s) {
      i.e(s);
    } finally {
      i.f();
    }
  } }, { key: "keydown", value: function(t, n) {
    var r, i = this;
    return this.lastKeyCode = n.keyCode, this.lastKeyTime = Date.now(), n.keyCode == 9 && Date.now() < this.lastEscPress + 2e3 || (!ye.android || !ye.chrome || n.synthetic || n.keyCode != 13 && n.keyCode != 8 ? !(!ye.ios || !(r = dP.find(function(o) {
      return o.keyCode == n.keyCode;
    })) || n.ctrlKey || n.altKey || n.metaKey || n.synthetic) && (this.pendingIOSKey = r, setTimeout(function() {
      return i.flushIOSKey(t);
    }, 250), !0) : (t.observer.delayAndroidKey(n.key, n.keyCode), !0));
  } }, { key: "flushIOSKey", value: function(t) {
    var n = this.pendingIOSKey;
    return !!n && (this.pendingIOSKey = void 0, Gu(t.contentDOM, n.key, n.keyCode));
  } }, { key: "ignoreDuringComposition", value: function(t) {
    return !!/^key/.test(t.type) && (this.composing > 0 || !!(ye.safari && Date.now() - this.compositionEndedAt < 100) && (this.compositionEndedAt = 0, !0));
  } }, { key: "mustFlushObserver", value: function(t) {
    return t.type == "keydown" && t.keyCode != 229 || t.type == "compositionend" && !ye.ios;
  } }, { key: "startMouseSelection", value: function(t) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = t;
  } }, { key: "update", value: function(t) {
    this.mouseSelection && this.mouseSelection.update(t), t.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  } }, { key: "destroy", value: function() {
    this.mouseSelection && this.mouseSelection.destroy();
  } }]), e;
}(), dP = [{ key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" }, { key: "Enter", keyCode: 13, inputType: "insertParagraph" }, { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }], vP = [16, 17, 18, 20, 91, 92, 224, 225], HV = function() {
  function e(t, n, r, i) {
    Z(this, e), this.view = t, this.style = r, this.mustSelect = i, this.lastEvent = n;
    var o = t.contentDOM.ownerDocument;
    o.addEventListener("mousemove", this.move = this.move.bind(this)), o.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = t.state.facet(In.allowMultipleSelections) && function(a, s) {
      var u = a.state.facet(YA);
      return u.length ? u[0](s) : ye.mac ? s.metaKey : s.ctrlKey;
    }(t, n), this.dragMove = function(a, s) {
      var u = a.state.facet(tP);
      return u.length ? u[0](s) : ye.mac ? !s.altKey : !s.ctrlKey;
    }(t, n), this.dragging = !(!function(a, s) {
      if (a.state.selection.main.empty)
        return !1;
      var u = Vf(a.root);
      if (!u || u.rangeCount == 0)
        return !0;
      for (var c = u.getRangeAt(0).getClientRects(), l = 0; l < c.length; l++) {
        var f = c[l];
        if (f.left <= s.clientX && f.right >= s.clientX && f.top <= s.clientY && f.bottom >= s.clientY)
          return !0;
      }
      return !1;
    }(t, n) || Up(n) != 1) && null, this.dragging === !1 && (n.preventDefault(), this.select(n));
  }
  return Y(e, [{ key: "move", value: function(t) {
    if (t.buttons == 0)
      return this.destroy();
    this.dragging === !1 && this.select(this.lastEvent = t);
  } }, { key: "up", value: function(t) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || t.preventDefault(), this.destroy();
  } }, { key: "destroy", value: function() {
    var t = this.view.contentDOM.ownerDocument;
    t.removeEventListener("mousemove", this.move), t.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = null;
  } }, { key: "select", value: function(t) {
    var n = this.style.get(t, this.extend, this.multiple);
    !this.mustSelect && n.eq(this.view.state.selection) && n.main.assoc == this.view.state.selection.main.assoc || this.view.dispatch({ selection: n, userEvent: "select.pointer", scrollIntoView: !0 }), this.mustSelect = !1;
  } }, { key: "update", value: function(t) {
    var n = this;
    t.docChanged && this.dragging && (this.dragging = this.dragging.map(t.changes)), this.style.update(t) && setTimeout(function() {
      return n.select(n.lastEvent);
    }, 20);
  } }]), e;
}();
function a4(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (var n, r = t.target; r != e.contentDOM; r = r.parentNode)
    if (!r || r.nodeType == 11 || (n = Zn.get(r)) && n.ignoreEvent(t))
      return !1;
  return !0;
}
var hr = /* @__PURE__ */ Object.create(null), pP = ye.ie && ye.ie_version < 15 || ye.ios && ye.webkit_version < 604;
function s4(e, t) {
  var n, r = e.state, i = 1, o = r.toText(t), a = o.lines == r.selection.ranges.length;
  if (Jp != null && r.selection.ranges.every(function(u) {
    return u.empty;
  }) && Jp == o.toString()) {
    var s = -1;
    n = r.changeByRange(function(u) {
      var c = r.doc.lineAt(u.from);
      if (c.from == s)
        return { range: u };
      s = c.from;
      var l = r.toText((a ? o.line(i++).text : t) + r.lineBreak);
      return { changes: { from: c.from, insert: l }, range: Ht.cursor(u.from + l.length) };
    });
  } else
    n = a ? r.changeByRange(function(u) {
      var c = o.line(i++);
      return { changes: { from: u.from, to: u.to, insert: c.text }, range: Ht.cursor(u.from + c.length) };
    }) : r.replaceSelection(o);
  e.dispatch(n, { userEvent: "input.paste", scrollIntoView: !0 });
}
hr.keydown = function(e, t) {
  e.inputState.setSelectionOrigin("select"), t.keyCode == 27 ? e.inputState.lastEscPress = Date.now() : vP.indexOf(t.keyCode) < 0 && (e.inputState.lastEscPress = 0);
};
var u4 = 0;
function c4(e, t, n, r) {
  if (r == 1)
    return Ht.cursor(t, n);
  if (r == 2)
    return function(u, c) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, f = u.charCategorizer(c), h = u.doc.lineAt(c), d = c - h.from;
      if (h.length == 0)
        return Ht.cursor(c);
      d == 0 ? l = 1 : d == h.length && (l = -1);
      var p = d, v = d;
      l < 0 ? p = Xr(h.text, d, !1) : v = Xr(h.text, d);
      for (var m = f(h.text.slice(p, v)); p > 0; ) {
        var g = Xr(h.text, p, !1);
        if (f(h.text.slice(g, p)) != m)
          break;
        p = g;
      }
      for (; v < h.length; ) {
        var y = Xr(h.text, v);
        if (f(h.text.slice(v, y)) != m)
          break;
        v = y;
      }
      return Ht.range(p + h.from, v + h.from);
    }(e.state, t, n);
  var i = Ei.find(e.docView, t), o = e.state.doc.lineAt(i ? i.posAtEnd : t), a = i ? i.posAtStart : o.from, s = i ? i.posAtEnd : o.to;
  return s < e.state.doc.length && s == o.to && s++, Ht.range(a, s);
}
hr.touchstart = function(e, t) {
  u4 = Date.now(), e.inputState.setSelectionOrigin("select.pointer");
}, hr.touchmove = function(e) {
  e.inputState.setSelectionOrigin("select.pointer");
}, hr.mousedown = function(e, t) {
  if (e.observer.flush(), !(u4 > Date.now() - 2e3 && Up(t) == 1)) {
    var n, r = null, i = ut(e.state.facet(eP));
    try {
      for (i.s(); !(n = i.n()).done && !(r = (0, n.value)(e, t)); )
        ;
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    if (r || t.button != 0 || (r = function(a, s) {
      var u = f4(a, s), c = Up(s), l = a.state.selection, f = u, h = s;
      return { update: function(d) {
        d.docChanged && (u && (u.pos = d.changes.mapPos(u.pos)), l = l.map(d.changes), h = null);
      }, get: function(d, p, v) {
        var m;
        if (h && d.clientX == h.clientX && d.clientY == h.clientY ? m = f : (m = f = f4(a, d), h = d), !m || !u)
          return l;
        var g = c4(a, m.pos, m.bias, c);
        if (u.pos != m.pos && !p) {
          var y = c4(a, u.pos, u.bias, c), b = Math.min(y.from, g.from), k = Math.max(y.to, g.to);
          g = b < g.from ? Ht.range(b, k) : Ht.range(k, b);
        }
        return p ? l.replaceRange(l.main.extend(g.from, g.to)) : v ? l.addRange(g) : Ht.create([g]);
      } };
    }(e, t)), r) {
      var o = e.root.activeElement != e.contentDOM;
      o && e.observer.ignore(function() {
        return zA(e.contentDOM);
      }), e.inputState.startMouseSelection(new HV(e, t, r, o));
    }
  }
};
var mP = function(e, t) {
  return e >= t.top && e <= t.bottom;
}, l4 = function(e, t, n) {
  return mP(t, n) && e >= n.left && e <= n.right;
};
function WV(e, t, n, r) {
  var i = Ei.find(e.docView, t);
  if (!i)
    return 1;
  var o = t - i.posAtStart;
  if (o == 0)
    return 1;
  if (o == i.length)
    return -1;
  var a = i.coordsAt(o, -1);
  if (a && l4(n, r, a))
    return -1;
  var s = i.coordsAt(o, 1);
  return s && l4(n, r, s) ? 1 : a && mP(r, a) ? -1 : 1;
}
function f4(e, t) {
  var n = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1);
  return { pos: n, bias: WV(e, n, t.clientX, t.clientY) };
}
var UV = ye.ie && ye.ie_version <= 11, h4 = null, d4 = 0, v4 = 0;
function Up(e) {
  if (!UV)
    return e.detail;
  var t = h4, n = v4;
  return h4 = e, v4 = Date.now(), d4 = !t || n > Date.now() - 400 && Math.abs(t.clientX - e.clientX) < 2 && Math.abs(t.clientY - e.clientY) < 2 ? (d4 + 1) % 3 : 1;
}
function p4(e, t, n, r) {
  if (n) {
    var i = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1);
    t.preventDefault();
    var o = e.inputState.mouseSelection, a = r && o && o.dragging && o.dragMove ? { from: o.dragging.from, to: o.dragging.to } : null, s = { from: i, insert: n }, u = e.state.changes(a ? [a, s] : s);
    e.focus(), e.dispatch({ changes: u, selection: { anchor: u.mapPos(i, -1), head: u.mapPos(i, 1) }, userEvent: a ? "move.drop" : "input.drop" });
  }
}
hr.dragstart = function(e, t) {
  var n = e.state.selection.main, r = e.inputState.mouseSelection;
  r && (r.dragging = n), t.dataTransfer && (t.dataTransfer.setData("Text", e.state.sliceDoc(n.from, n.to)), t.dataTransfer.effectAllowed = "copyMove");
}, hr.drop = function(e, t) {
  if (t.dataTransfer) {
    if (e.state.readOnly)
      return t.preventDefault();
    var n = t.dataTransfer.files;
    n && n.length ? function() {
      t.preventDefault();
      for (var r = Array(n.length), i = 0, o = function() {
        ++i == n.length && p4(e, t, r.filter(function(u) {
          return u != null;
        }).join(e.state.lineBreak), !1);
      }, a = function(u) {
        var c = new FileReader();
        c.onerror = o, c.onload = function() {
          /[\x00-\x08\x0e-\x1f]{2}/.test(c.result) || (r[u] = c.result), o();
        }, c.readAsText(n[u]);
      }, s = 0; s < n.length; s++)
        a(s);
    }() : p4(e, t, t.dataTransfer.getData("Text"), !0);
  }
}, hr.paste = function(e, t) {
  if (e.state.readOnly)
    return t.preventDefault();
  e.observer.flush();
  var n = pP ? null : t.clipboardData;
  n ? (s4(e, n.getData("text/plain")), t.preventDefault()) : function(r) {
    var i = r.dom.parentNode;
    if (i) {
      var o = i.appendChild(document.createElement("textarea"));
      o.style.cssText = "position: fixed; left: -10000px; top: 10px", o.focus(), setTimeout(function() {
        r.focus(), o.remove(), s4(r, o.value);
      }, 50);
    }
  }(e);
};
var Jp = null;
function m4(e) {
  setTimeout(function() {
    e.hasFocus != e.inputState.notifiedFocused && e.update([]);
  }, 10);
}
function g4(e, t) {
  if (e.docView.compositionDeco.size) {
    e.inputState.rapidCompositionStart = t;
    try {
      e.update([]);
    } finally {
      e.inputState.rapidCompositionStart = !1;
    }
  }
}
hr.copy = hr.cut = function(e, t) {
  var n = function(s) {
    var u, c = [], l = [], f = !1, h = ut(s.selection.ranges);
    try {
      for (h.s(); !(u = h.n()).done; ) {
        var d = u.value;
        d.empty || (c.push(s.sliceDoc(d.from, d.to)), l.push(d));
      }
    } catch (b) {
      h.e(b);
    } finally {
      h.f();
    }
    if (!c.length) {
      var p, v = -1, m = ut(s.selection.ranges);
      try {
        for (m.s(); !(p = m.n()).done; ) {
          var g = p.value.from, y = s.doc.lineAt(g);
          y.number > v && (c.push(y.text), l.push({ from: y.from, to: Math.min(s.doc.length, y.to + 1) })), v = y.number;
        }
      } catch (b) {
        m.e(b);
      } finally {
        m.f();
      }
      f = !0;
    }
    return { text: c.join(s.lineBreak), ranges: l, linewise: f };
  }(e.state), r = n.text, i = n.ranges, o = n.linewise;
  if (r || o) {
    Jp = o ? r : null;
    var a = pP ? null : t.clipboardData;
    a ? (t.preventDefault(), a.clearData(), a.setData("text/plain", r)) : function(s, u) {
      var c = s.dom.parentNode;
      if (c) {
        var l = c.appendChild(document.createElement("textarea"));
        l.style.cssText = "position: fixed; left: -10000px; top: 10px", l.value = u, l.focus(), l.selectionEnd = u.length, l.selectionStart = 0, setTimeout(function() {
          l.remove(), s.focus();
        }, 50);
      }
    }(e, r), t.type != "cut" || e.state.readOnly || e.dispatch({ changes: i, scrollIntoView: !0, userEvent: "delete.cut" });
  }
}, hr.focus = m4, hr.blur = function(e) {
  e.observer.clearSelectionRange(), m4(e);
}, hr.compositionstart = hr.compositionupdate = function(e) {
  e.inputState.compositionFirstChange == null && (e.inputState.compositionFirstChange = !0), e.inputState.composing < 0 && (e.inputState.composing = 0, e.docView.compositionDeco.size && (e.observer.flush(), g4(e, !0)));
}, hr.compositionend = function(e) {
  e.inputState.composing = -1, e.inputState.compositionEndedAt = Date.now(), e.inputState.compositionFirstChange = null, setTimeout(function() {
    e.inputState.composing < 0 && g4(e, !1);
  }, 50);
}, hr.contextmenu = function(e) {
  e.inputState.lastContextMenu = Date.now();
}, hr.beforeinput = function(e, t) {
  var n, r;
  if (ye.chrome && ye.android && (r = dP.find(function(o) {
    return o.inputType == t.inputType;
  })) && (e.observer.delayAndroidKey(r.key, r.keyCode), r.key == "Backspace" || r.key == "Delete")) {
    var i = ((n = window.visualViewport) === null || n === void 0 ? void 0 : n.height) || 0;
    setTimeout(function() {
      var o;
      (((o = window.visualViewport) === null || o === void 0 ? void 0 : o.height) || 0) > i + 10 && e.hasFocus && (e.contentDOM.blur(), e.focus());
    }, 100);
  }
};
var y4 = ["pre-wrap", "normal", "pre-line", "break-spaces"], JV = function() {
  function e() {
    Z(this, e), this.doc = xn.empty, this.lineWrapping = !1, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.lineLength = 30, this.heightChanged = !1;
  }
  return Y(e, [{ key: "heightForGap", value: function(t, n) {
    var r = this.doc.lineAt(n).number - this.doc.lineAt(t).number + 1;
    return this.lineWrapping && (r += Math.ceil((n - t - r * this.lineLength * 0.5) / this.lineLength)), this.lineHeight * r;
  } }, { key: "heightForLine", value: function(t) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((t - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  } }, { key: "setDoc", value: function(t) {
    return this.doc = t, this;
  } }, { key: "mustRefreshForWrapping", value: function(t) {
    return y4.indexOf(t) > -1 != this.lineWrapping;
  } }, { key: "mustRefreshForHeights", value: function(t) {
    for (var n = !1, r = 0; r < t.length; r++) {
      var i = t[r];
      i < 0 ? r++ : this.heightSamples[Math.floor(10 * i)] || (n = !0, this.heightSamples[Math.floor(10 * i)] = !0);
    }
    return n;
  } }, { key: "refresh", value: function(t, n, r, i, o) {
    var a = y4.indexOf(t) > -1, s = Math.round(n) != Math.round(this.lineHeight) || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = n, this.charWidth = r, this.lineLength = i, s) {
      this.heightSamples = {};
      for (var u = 0; u < o.length; u++) {
        var c = o[u];
        c < 0 ? u++ : this.heightSamples[Math.floor(10 * c)] = !0;
      }
    }
    return s;
  } }]), e;
}(), KV = function() {
  function e(t, n) {
    Z(this, e), this.from = t, this.heights = n, this.index = 0;
  }
  return Y(e, [{ key: "more", get: function() {
    return this.index < this.heights.length;
  } }]), e;
}(), Ss = function() {
  function e(t, n, r, i, o) {
    Z(this, e), this.from = t, this.length = n, this.top = r, this.height = i, this.type = o;
  }
  return Y(e, [{ key: "to", get: function() {
    return this.from + this.length;
  } }, { key: "bottom", get: function() {
    return this.top + this.height;
  } }, { key: "join", value: function(t) {
    var n = (Array.isArray(this.type) ? this.type : [this]).concat(Array.isArray(t.type) ? t.type : [t]);
    return new e(this.from, this.length + t.length, this.top, this.height + t.height, n);
  } }]), e;
}(), Tn = function(e) {
  return e[e.ByPos = 0] = "ByPos", e[e.ByHeight = 1] = "ByHeight", e[e.ByPosNoHeight = 2] = "ByPosNoHeight", e;
}(Tn || (Tn = {})), co = function() {
  function e(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    Z(this, e), this.length = t, this.height = n, this.flags = r;
  }
  return Y(e, [{ key: "outdated", get: function() {
    return (2 & this.flags) > 0;
  }, set: function(t) {
    this.flags = (t ? 2 : 0) | -3 & this.flags;
  } }, { key: "setHeight", value: function(t, n) {
    this.height != n && (Math.abs(this.height - n) > 1e-3 && (t.heightChanged = !0), this.height = n);
  } }, { key: "replace", value: function(t, n, r) {
    return e.of(r);
  } }, { key: "decomposeLeft", value: function(t, n) {
    n.push(this);
  } }, { key: "decomposeRight", value: function(t, n) {
    n.push(this);
  } }, { key: "applyChanges", value: function(t, n, r, i) {
    for (var o = this, a = i.length - 1; a >= 0; a--) {
      var s = i[a], u = s.fromA, c = s.toA, l = s.fromB, f = s.toB, h = o.lineAt(u, Tn.ByPosNoHeight, n, 0, 0), d = h.to >= c ? h : o.lineAt(c, Tn.ByPosNoHeight, n, 0, 0);
      for (f += d.to - c, c = d.to; a > 0 && h.from <= i[a - 1].toA; )
        u = i[a - 1].fromA, l = i[a - 1].fromB, a--, u < h.from && (h = o.lineAt(u, Tn.ByPosNoHeight, n, 0, 0));
      l += h.from - u, u = h.from;
      var p = QV.build(r, t, l, f);
      o = o.replace(u, c, p);
    }
    return o.updateHeight(r, 0);
  } }], [{ key: "empty", value: function() {
    return new Yi(0, 0);
  } }, { key: "of", value: function(t) {
    if (t.length == 1)
      return t[0];
    for (var n = 0, r = t.length, i = 0, o = 0; ; )
      if (n == r)
        if (i > 2 * o) {
          var a = t[n - 1];
          a.break ? t.splice(--n, 1, a.left, null, a.right) : t.splice(--n, 1, a.left, a.right), r += 1 + a.break, i -= a.size;
        } else {
          if (!(o > 2 * i))
            break;
          var s = t[r];
          s.break ? t.splice(r, 1, s.left, null, s.right) : t.splice(r, 1, s.left, s.right), r += 2 + s.break, o -= s.size;
        }
      else if (i < o) {
        var u = t[n++];
        u && (i += u.size);
      } else {
        var c = t[--r];
        c && (o += c.size);
      }
    var l = 0;
    return t[n - 1] == null ? (l = 1, n--) : t[n] == null && (l = 1, r++), new GV(e.of(t.slice(0, n)), l, e.of(t.slice(r)));
  } }]), e;
}();
co.prototype.size = 1;
var gP = function(e) {
  Et(n, co);
  var t = Mt(n);
  function n(r, i, o) {
    var a;
    return Z(this, n), (a = t.call(this, r, i)).type = o, a;
  }
  return Y(n, [{ key: "blockAt", value: function(r, i, o, a) {
    return new Ss(a, this.length, o, this.height, this.type);
  } }, { key: "lineAt", value: function(r, i, o, a, s) {
    return this.blockAt(0, o, a, s);
  } }, { key: "forEachLine", value: function(r, i, o, a, s, u) {
    r <= s + this.length && i >= s && u(this.blockAt(0, o, a, s));
  } }, { key: "updateHeight", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = arguments.length > 3 ? arguments[3] : void 0;
    return o && o.from <= i && o.more && this.setHeight(r, o.heights[o.index++]), this.outdated = !1, this;
  } }, { key: "toString", value: function() {
    return "block(".concat(this.length, ")");
  } }]), n;
}(), Yi = function(e) {
  Et(n, gP);
  var t = Mt(n);
  function n(r, i) {
    var o;
    return Z(this, n), (o = t.call(this, r, i, Cn.Text)).collapsed = 0, o.widgetHeight = 0, o;
  }
  return Y(n, [{ key: "replace", value: function(r, i, o) {
    var a = o[0];
    return o.length == 1 && (a instanceof n || a instanceof Ms && 4 & a.flags) && Math.abs(this.length - a.length) < 10 ? (a instanceof Ms ? a = new n(a.length, this.height) : a.height = this.height, this.outdated || (a.outdated = !1), a) : co.of(o);
  } }, { key: "updateHeight", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], a = arguments.length > 3 ? arguments[3] : void 0;
    return a && a.from <= i && a.more ? this.setHeight(r, a.heights[a.index++]) : (o || this.outdated) && this.setHeight(r, Math.max(this.widgetHeight, r.heightForLine(this.length - this.collapsed))), this.outdated = !1, this;
  } }, { key: "toString", value: function() {
    return "line(".concat(this.length).concat(this.collapsed ? -this.collapsed : "").concat(this.widgetHeight ? ":" + this.widgetHeight : "", ")");
  } }]), n;
}(), Ms = function(e) {
  Et(n, co);
  var t = Mt(n);
  function n(r) {
    return Z(this, n), t.call(this, r, 0);
  }
  return Y(n, [{ key: "lines", value: function(r, i) {
    var o = r.lineAt(i).number, a = r.lineAt(i + this.length).number;
    return { firstLine: o, lastLine: a, lineHeight: this.height / (a - o + 1) };
  } }, { key: "blockAt", value: function(r, i, o, a) {
    var s = this.lines(i, a), u = s.firstLine, c = s.lastLine, l = s.lineHeight, f = Math.max(0, Math.min(c - u, Math.floor((r - o) / l))), h = i.line(u + f), d = h.from, p = h.length;
    return new Ss(d, p, o + l * f, l, Cn.Text);
  } }, { key: "lineAt", value: function(r, i, o, a, s) {
    if (i == Tn.ByHeight)
      return this.blockAt(r, o, a, s);
    if (i == Tn.ByPosNoHeight) {
      var u = o.lineAt(r), c = u.from, l = u.to;
      return new Ss(c, l - c, 0, 0, Cn.Text);
    }
    var f = this.lines(o, s), h = f.firstLine, d = f.lineHeight, p = o.lineAt(r), v = p.from, m = p.length, g = p.number;
    return new Ss(v, m, a + d * (g - h), d, Cn.Text);
  } }, { key: "forEachLine", value: function(r, i, o, a, s, u) {
    for (var c = this.lines(o, s), l = c.firstLine, f = c.lineHeight, h = Math.max(r, s), d = Math.min(s + this.length, i); h <= d; ) {
      var p = o.lineAt(h);
      h == r && (a += f * (p.number - l)), u(new Ss(p.from, p.length, a, f, Cn.Text)), a += f, h = p.to + 1;
    }
  } }, { key: "replace", value: function(r, i, o) {
    var a = this.length - i;
    if (a > 0) {
      var s = o[o.length - 1];
      s instanceof n ? o[o.length - 1] = new n(s.length + a) : o.push(null, new n(a - 1));
    }
    if (r > 0) {
      var u = o[0];
      u instanceof n ? o[0] = new n(r + u.length) : o.unshift(new n(r - 1), null);
    }
    return co.of(o);
  } }, { key: "decomposeLeft", value: function(r, i) {
    i.push(new n(r - 1), null);
  } }, { key: "decomposeRight", value: function(r, i) {
    i.push(null, new n(this.length - r - 1));
  } }, { key: "updateHeight", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], a = arguments.length > 3 ? arguments[3] : void 0, s = i + this.length;
    if (a && a.from <= i + this.length && a.more) {
      var u = [], c = Math.max(i, a.from), l = -1, f = r.heightChanged;
      for (a.from > i && u.push(new n(a.from - i - 1).updateHeight(r, i)); c <= s && a.more; ) {
        var h = r.doc.lineAt(c).length;
        u.length && u.push(null);
        var d = a.heights[a.index++];
        l == -1 ? l = d : Math.abs(d - l) >= 1e-3 && (l = -2);
        var p = new Yi(h, d);
        p.outdated = !1, u.push(p), c += h + 1;
      }
      c <= s && u.push(null, new n(s - c).updateHeight(r, c));
      var v = co.of(u);
      return r.heightChanged = f || l < 0 || Math.abs(v.height - this.height) >= 1e-3 || Math.abs(l - this.lines(r.doc, i).lineHeight) >= 1e-3, v;
    }
    return (o || this.outdated) && (this.setHeight(r, r.heightForGap(i, i + this.length)), this.outdated = !1), this;
  } }, { key: "toString", value: function() {
    return "gap(".concat(this.length, ")");
  } }]), n;
}(), GV = function(e) {
  Et(n, co);
  var t = Mt(n);
  function n(r, i, o) {
    var a;
    return Z(this, n), (a = t.call(this, r.length + i + o.length, r.height + o.height, i | (r.outdated || o.outdated ? 2 : 0))).left = r, a.right = o, a.size = r.size + o.size, a;
  }
  return Y(n, [{ key: "break", get: function() {
    return 1 & this.flags;
  } }, { key: "blockAt", value: function(r, i, o, a) {
    var s = o + this.left.height;
    return r < s ? this.left.blockAt(r, i, o, a) : this.right.blockAt(r, i, s, a + this.left.length + this.break);
  } }, { key: "lineAt", value: function(r, i, o, a, s) {
    var u = a + this.left.height, c = s + this.left.length + this.break, l = i == Tn.ByHeight ? r < u : r < c, f = l ? this.left.lineAt(r, i, o, a, s) : this.right.lineAt(r, i, o, u, c);
    if (this.break || (l ? f.to < c : f.from > c))
      return f;
    var h = i == Tn.ByPosNoHeight ? Tn.ByPosNoHeight : Tn.ByPos;
    return l ? f.join(this.right.lineAt(c, h, o, u, c)) : this.left.lineAt(c, h, o, a, s).join(f);
  } }, { key: "forEachLine", value: function(r, i, o, a, s, u) {
    var c = a + this.left.height, l = s + this.left.length + this.break;
    if (this.break)
      r < l && this.left.forEachLine(r, i, o, a, s, u), i >= l && this.right.forEachLine(r, i, o, c, l, u);
    else {
      var f = this.lineAt(l, Tn.ByPos, o, a, s);
      r < f.from && this.left.forEachLine(r, f.from - 1, o, a, s, u), f.to >= r && f.from <= i && u(f), i > f.to && this.right.forEachLine(f.to + 1, i, o, c, l, u);
    }
  } }, { key: "replace", value: function(r, i, o) {
    var a = this.left.length + this.break;
    if (i < a)
      return this.balanced(this.left.replace(r, i, o), this.right);
    if (r > this.left.length)
      return this.balanced(this.left, this.right.replace(r - a, i - a, o));
    var s = [];
    r > 0 && this.decomposeLeft(r, s);
    var u, c = s.length, l = ut(o);
    try {
      for (l.s(); !(u = l.n()).done; ) {
        var f = u.value;
        s.push(f);
      }
    } catch (d) {
      l.e(d);
    } finally {
      l.f();
    }
    if (r > 0 && b4(s, c - 1), i < this.length) {
      var h = s.length;
      this.decomposeRight(i, s), b4(s, h);
    }
    return co.of(s);
  } }, { key: "decomposeLeft", value: function(r, i) {
    var o = this.left.length;
    if (r <= o)
      return this.left.decomposeLeft(r, i);
    i.push(this.left), this.break && r >= ++o && i.push(null), r > o && this.right.decomposeLeft(r - o, i);
  } }, { key: "decomposeRight", value: function(r, i) {
    var o = this.left.length, a = o + this.break;
    if (r >= a)
      return this.right.decomposeRight(r - a, i);
    r < o && this.left.decomposeRight(r, i), this.break && r < a && i.push(null), i.push(this.right);
  } }, { key: "balanced", value: function(r, i) {
    return r.size > 2 * i.size || i.size > 2 * r.size ? co.of(this.break ? [r, null, i] : [r, i]) : (this.left = r, this.right = i, this.height = r.height + i.height, this.outdated = r.outdated || i.outdated, this.size = r.size + i.size, this.length = r.length + this.break + i.length, this);
  } }, { key: "updateHeight", value: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], a = arguments.length > 3 ? arguments[3] : void 0, s = this.left, u = this.right, c = i + s.length + this.break, l = null;
    return a && a.from <= i + s.length && a.more ? l = s = s.updateHeight(r, i, o, a) : s.updateHeight(r, i, o), a && a.from <= c + u.length && a.more ? l = u = u.updateHeight(r, c, o, a) : u.updateHeight(r, c, o), l ? this.balanced(s, u) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  } }, { key: "toString", value: function() {
    return this.left + (this.break ? " " : "-") + this.right;
  } }]), n;
}();
function b4(e, t) {
  var n, r;
  e[t] == null && (n = e[t - 1]) instanceof Ms && (r = e[t + 1]) instanceof Ms && e.splice(t - 1, 3, new Ms(n.length + 1 + r.length));
}
var QV = function() {
  function e(t, n) {
    Z(this, e), this.pos = t, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = t;
  }
  return Y(e, [{ key: "isCovered", get: function() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  } }, { key: "span", value: function(t, n) {
    if (this.lineStart > -1) {
      var r = Math.min(n, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof Yi ? i.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new Yi(r - this.pos, -1)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  } }, { key: "point", value: function(t, n, r) {
    if (t < n || r.heightRelevant) {
      var i = r.widget ? r.widget.estimatedHeight : 0;
      i < 0 && (i = this.oracle.lineHeight);
      var o = n - t;
      r.block ? this.addBlock(new gP(o, i, r.type)) : (o || i >= 5) && this.addLineDeco(i, o);
    } else
      n > t && this.span(t, n);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  } }, { key: "enterLine", value: function() {
    if (!(this.lineStart > -1)) {
      var t = this.oracle.doc.lineAt(this.pos), n = t.from, r = t.to;
      this.lineStart = n, this.lineEnd = r, this.writtenTo < n && ((this.writtenTo < n - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, n - 1)), this.nodes.push(null)), this.pos > n && this.nodes.push(new Yi(this.pos - n, -1)), this.writtenTo = this.pos;
    }
  } }, { key: "blankContent", value: function(t, n) {
    var r = new Ms(n - t);
    return this.oracle.doc.lineAt(t).to == n && (r.flags |= 4), r;
  } }, { key: "ensureLine", value: function() {
    this.enterLine();
    var t = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (t instanceof Yi)
      return t;
    var n = new Yi(0, -1);
    return this.nodes.push(n), n;
  } }, { key: "addBlock", value: function(t) {
    this.enterLine(), t.type != Cn.WidgetAfter || this.isCovered || this.ensureLine(), this.nodes.push(t), this.writtenTo = this.pos = this.pos + t.length, t.type != Cn.WidgetBefore && (this.covering = t);
  } }, { key: "addLineDeco", value: function(t, n) {
    var r = this.ensureLine();
    r.length += n, r.collapsed += n, r.widgetHeight = Math.max(r.widgetHeight, t), this.writtenTo = this.pos = this.pos + n;
  } }, { key: "finish", value: function(t) {
    var n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    !(this.lineStart > -1) || n instanceof Yi || this.isCovered ? (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos)) : this.nodes.push(new Yi(0, -1));
    var r, i = t, o = ut(this.nodes);
    try {
      for (o.s(); !(r = o.n()).done; ) {
        var a = r.value;
        a instanceof Yi && a.updateHeight(this.oracle, i), i += a ? a.length : 1;
      }
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
    return this.nodes;
  } }], [{ key: "build", value: function(t, n, r, i) {
    var o = new e(r, t);
    return Nn.spans(n, r, i, o, 0), o.finish(r);
  } }]), e;
}();
function XV(e, t, n) {
  var r = new ZV();
  return Nn.compare(e, t, n, r, 0), r.changes;
}
var ZV = function() {
  function e() {
    Z(this, e), this.changes = [];
  }
  return Y(e, [{ key: "compareRange", value: function() {
  } }, { key: "comparePoint", value: function(t, n, r, i) {
    (t < n || r && r.heightRelevant || i && i.heightRelevant) && Bp(t, n, this.changes, 5);
  } }]), e;
}();
function YV(e, t) {
  for (var n = e.getBoundingClientRect(), r = Math.max(0, n.left), i = Math.min(innerWidth, n.right), o = Math.max(0, n.top), a = Math.min(innerHeight, n.bottom), s = e.ownerDocument.body, u = e.parentNode; u && u != s; )
    if (u.nodeType == 1) {
      var c = u, l = window.getComputedStyle(c);
      if ((c.scrollHeight > c.clientHeight || c.scrollWidth > c.clientWidth) && l.overflow != "visible") {
        var f = c.getBoundingClientRect();
        r = Math.max(r, f.left), i = Math.min(i, f.right), o = Math.max(o, f.top), a = Math.min(a, f.bottom);
      }
      u = l.position == "absolute" || l.position == "fixed" ? c.offsetParent : c.parentNode;
    } else {
      if (u.nodeType != 11)
        break;
      u = u.host;
    }
  return { left: r - n.left, right: Math.max(r, i) - n.left, top: o - (n.top + t), bottom: Math.max(o, a) - (n.top + t) };
}
function tH(e, t) {
  var n = e.getBoundingClientRect();
  return { left: 0, right: n.right - n.left, top: t, bottom: n.bottom - (n.top + t) };
}
var Zd = function() {
  function e(t, n, r) {
    Z(this, e), this.from = t, this.to = n, this.size = r;
  }
  return Y(e, [{ key: "draw", value: function(t) {
    return $e.replace({ widget: new eH(this.size, t) }).range(this.from, this.to);
  } }], [{ key: "same", value: function(t, n) {
    if (t.length != n.length)
      return !1;
    for (var r = 0; r < t.length; r++) {
      var i = t[r], o = n[r];
      if (i.from != o.from || i.to != o.to || i.size != o.size)
        return !1;
    }
    return !0;
  } }]), e;
}(), eH = function(e) {
  Et(n, ba);
  var t = Mt(n);
  function n(r, i) {
    var o;
    return Z(this, n), (o = t.call(this)).size = r, o.vertical = i, o;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return r.size == this.size && r.vertical == this.vertical;
  } }, { key: "toDOM", value: function() {
    var r = document.createElement("div");
    return this.vertical ? r.style.height = this.size + "px" : (r.style.width = this.size + "px", r.style.height = "2px", r.style.display = "inline-block"), r;
  } }, { key: "estimatedHeight", get: function() {
    return this.vertical ? this.size : -1;
  } }]), n;
}(), k4 = function() {
  function e(t) {
    Z(this, e), this.state = t, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.heightOracle = new JV(), this.scaler = j4, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = Wn.RTL, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1, this.stateDeco = t.facet(pc).filter(function(n) {
      return typeof n != "function";
    }), this.heightMap = co.empty().applyChanges(this.stateDeco, xn.empty, this.heightOracle.setDoc(t.doc), [new mc(0, 0, 0, t.doc.length)]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = $e.set(this.lineGaps.map(function(n) {
      return n.draw(!1);
    })), this.computeVisibleRanges();
  }
  return Y(e, [{ key: "updateForViewport", value: function() {
    for (var t = this, n = [this.viewport], r = this.state.selection.main, i = function(a) {
      var s = a ? r.head : r.anchor;
      if (!n.some(function(f) {
        var h = f.from, d = f.to;
        return s >= h && s <= d;
      })) {
        var u = t.lineBlockAt(s), c = u.from, l = u.to;
        n.push(new Al(c, l));
      }
    }, o = 0; o <= 1; o++)
      i(o);
    this.viewports = n.sort(function(a, s) {
      return a.from - s.from;
    }), this.scaler = this.heightMap.height <= 7e6 ? j4 : new nH(this.heightOracle.doc, this.heightMap, this.viewports);
  } }, { key: "updateViewportLines", value: function() {
    var t = this;
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.state.doc, 0, 0, function(n) {
      t.viewportLines.push(t.scaler.scale == 1 ? n : Ru(n, t.scaler));
    });
  } }, { key: "update", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    this.state = t.state;
    var r = this.stateDeco;
    this.stateDeco = this.state.facet(pc).filter(function(c) {
      return typeof c != "function";
    });
    var i = t.changedRanges, o = mc.extendWithRanges(i, XV(r, this.stateDeco, t ? t.changes : qi.empty(this.state.doc.length))), a = this.heightMap.height;
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, t.startState.doc, this.heightOracle.setDoc(this.state.doc), o), this.heightMap.height != a && (t.flags |= 2);
    var s = o.length ? this.mapViewport(this.viewport, t.changes) : this.viewport;
    (n && (n.range.head < s.from || n.range.head > s.to) || !this.viewportIsAppropriate(s)) && (s = this.getViewport(0, n));
    var u = !t.changes.empty || 2 & t.flags || s.from != this.viewport.from || s.to != this.viewport.to;
    this.viewport = s, this.updateForViewport(), u && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, t.changes))), t.flags |= this.computeVisibleRanges(), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && t.selectionSet && t.view.lineWrapping && t.state.selection.main.empty && t.state.selection.main.assoc && (this.mustEnforceCursorAssoc = !0);
  } }, { key: "measure", value: function(t) {
    var n = t.contentDOM, r = window.getComputedStyle(n), i = this.heightOracle, o = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? Wn.RTL : Wn.LTR;
    var a = this.heightOracle.mustRefreshForWrapping(o), s = a || this.mustMeasureContent || this.contentDOMHeight != n.clientHeight;
    this.contentDOMHeight = n.clientHeight, this.mustMeasureContent = !1;
    var u = 0, c = 0, l = parseInt(r.paddingTop) || 0, f = parseInt(r.paddingBottom) || 0;
    this.paddingTop == l && this.paddingBottom == f || (this.paddingTop = l, this.paddingBottom = f, u |= 10), this.editorWidth != t.scrollDOM.clientWidth && (i.lineWrapping && (s = !0), this.editorWidth = t.scrollDOM.clientWidth, u |= 8);
    var h = (this.printing ? tH : YV)(n, this.paddingTop), d = h.top - this.pixelViewport.top, p = h.bottom - this.pixelViewport.bottom;
    this.pixelViewport = h;
    var v = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (v != this.inView && (this.inView = v, v && (s = !0)), !this.inView)
      return 0;
    var m = n.clientWidth;
    if (this.contentDOMWidth == m && this.editorHeight == t.scrollDOM.clientHeight || (this.contentDOMWidth = m, this.editorHeight = t.scrollDOM.clientHeight, u |= 8), s) {
      var g = t.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(g) && (a = !0), a || i.lineWrapping && Math.abs(m - this.contentDOMWidth) > i.charWidth) {
        var y = t.docView.measureTextSize(), b = y.lineHeight, k = y.charWidth;
        (a = i.refresh(o, b, k, m / k, g)) && (t.docView.minWidth = 0, u |= 8);
      }
      d > 0 && p > 0 ? c = Math.max(d, p) : d < 0 && p < 0 && (c = Math.min(d, p)), i.heightChanged = !1;
      var w, x = ut(this.viewports);
      try {
        for (x.s(); !(w = x.n()).done; ) {
          var S = w.value, T = S.from == this.viewport.from ? g : t.docView.measureVisibleLineHeights(S);
          this.heightMap = this.heightMap.updateHeight(i, 0, a, new KV(S.from, T));
        }
      } catch (O) {
        x.e(O);
      } finally {
        x.f();
      }
      i.heightChanged && (u |= 2);
    }
    var P = !this.viewportIsAppropriate(this.viewport, c) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return P && (this.viewport = this.getViewport(c, this.scrollTarget)), this.updateForViewport(), (2 & u || P) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(a ? [] : this.lineGaps)), u |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, t.docView.enforceCursorAssoc()), u;
  } }, { key: "visibleTop", get: function() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  } }, { key: "visibleBottom", get: function() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  } }, { key: "getViewport", value: function(t, n) {
    var r = 0.5 - Math.max(-0.5, Math.min(0.5, t / 1e3 / 2)), i = this.heightMap, o = this.state.doc, a = this.visibleTop, s = this.visibleBottom, u = new Al(i.lineAt(a - 1e3 * r, Tn.ByHeight, o, 0, 0).from, i.lineAt(s + 1e3 * (1 - r), Tn.ByHeight, o, 0, 0).to);
    if (n) {
      var c = n.range.head;
      if (c < u.from || c > u.to) {
        var l, f = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), h = i.lineAt(c, Tn.ByPos, o, 0, 0);
        l = n.y == "center" ? (h.top + h.bottom) / 2 - f / 2 : n.y == "start" || n.y == "nearest" && c < u.from ? h.top : h.bottom - f, u = new Al(i.lineAt(l - 500, Tn.ByHeight, o, 0, 0).from, i.lineAt(l + f + 500, Tn.ByHeight, o, 0, 0).to);
      }
    }
    return u;
  } }, { key: "mapViewport", value: function(t, n) {
    var r = n.mapPos(t.from, -1), i = n.mapPos(t.to, 1);
    return new Al(this.heightMap.lineAt(r, Tn.ByPos, this.state.doc, 0, 0).from, this.heightMap.lineAt(i, Tn.ByPos, this.state.doc, 0, 0).to);
  } }, { key: "viewportIsAppropriate", value: function(t) {
    var n = t.from, r = t.to, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!this.inView)
      return !0;
    var o = this.heightMap.lineAt(n, Tn.ByPos, this.state.doc, 0, 0), a = o.top, s = this.heightMap.lineAt(r, Tn.ByPos, this.state.doc, 0, 0), u = s.bottom, c = this.visibleTop, l = this.visibleBottom;
    return (n == 0 || a <= c - Math.max(10, Math.min(-i, 250))) && (r == this.state.doc.length || u >= l + Math.max(10, Math.min(i, 250))) && a > c - 2e3 && u < l + 2e3;
  } }, { key: "mapLineGaps", value: function(t, n) {
    if (!t.length || n.empty)
      return t;
    var r, i = [], o = ut(t);
    try {
      for (o.s(); !(r = o.n()).done; ) {
        var a = r.value;
        n.touchesRange(a.from, a.to) || i.push(new Zd(n.mapPos(a.from), n.mapPos(a.to), a.size));
      }
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
    return i;
  } }, { key: "ensureLineGaps", value: function(t) {
    var n = this, r = [];
    if (this.defaultTextDirection != Wn.LTR)
      return r;
    var i, o = ut(this.viewportLines);
    try {
      var a = function() {
        var s = i.value;
        if (s.length < 4e3)
          return "continue";
        var u = function(b, k, w) {
          var x = [], S = b, T = 0;
          return Nn.spans(w, b, k, { span: function() {
          }, point: function(P, O) {
            P > S && (x.push({ from: S, to: P }), T += P - S), S = O;
          } }, 20), S < k && (x.push({ from: S, to: k }), T += k - S), { total: T, ranges: x };
        }(s.from, s.to, n.stateDeco);
        if (u.total < 4e3)
          return "continue";
        var c = void 0, l = void 0;
        if (n.heightOracle.lineWrapping) {
          var f = 2e3 / n.heightOracle.lineLength * n.heightOracle.lineHeight;
          c = Pl(u, (n.visibleTop - s.top - f) / s.height), l = Pl(u, (n.visibleBottom - s.top + f) / s.height);
        } else {
          var h = u.total * n.heightOracle.charWidth, d = 2e3 * n.heightOracle.charWidth;
          c = Pl(u, (n.pixelViewport.left - d) / h), l = Pl(u, (n.pixelViewport.right + d) / h);
        }
        var p = [];
        c > s.from && p.push({ from: s.from, to: c }), l < s.to && p.push({ from: l, to: s.to });
        var v = n.state.selection.main;
        v.from >= s.from && v.from <= s.to && x4(p, v.from - 10, v.from + 10), !v.empty && v.to >= s.from && v.to <= s.to && x4(p, v.to - 10, v.to + 10);
        for (var m = function() {
          var b = y[g], k = b.from, w = b.to;
          w - k > 1e3 && r.push(function(x, S) {
            var T, P = ut(x);
            try {
              for (P.s(); !(T = P.n()).done; ) {
                var O = T.value;
                if (S(O))
                  return O;
              }
            } catch (j) {
              P.e(j);
            } finally {
              P.f();
            }
          }(t, function(x) {
            return x.from >= s.from && x.to <= s.to && Math.abs(x.from - k) < 1e3 && Math.abs(x.to - w) < 1e3;
          }) || new Zd(k, w, n.gapSize(s, k, w, u)));
        }, g = 0, y = p; g < y.length; g++)
          m();
      };
      for (o.s(); !(i = o.n()).done; )
        a();
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
    return r;
  } }, { key: "gapSize", value: function(t, n, r, i) {
    var o = w4(i, r) - w4(i, n);
    return this.heightOracle.lineWrapping ? t.height * o : i.total * this.heightOracle.charWidth * o;
  } }, { key: "updateLineGaps", value: function(t) {
    var n = this;
    Zd.same(t, this.lineGaps) || (this.lineGaps = t, this.lineGapDeco = $e.set(t.map(function(r) {
      return r.draw(n.heightOracle.lineWrapping);
    })));
  } }, { key: "computeVisibleRanges", value: function() {
    var t = this.stateDeco;
    this.lineGaps.length && (t = t.concat(this.lineGapDeco));
    var n = [];
    Nn.spans(t, this.viewport.from, this.viewport.to, { span: function(i, o) {
      n.push({ from: i, to: o });
    }, point: function() {
    } }, 20);
    var r = n.length != this.visibleRanges.length || this.visibleRanges.some(function(i, o) {
      return i.from != n[o].from || i.to != n[o].to;
    });
    return this.visibleRanges = n, r ? 4 : 0;
  } }, { key: "lineBlockAt", value: function(t) {
    return t >= this.viewport.from && t <= this.viewport.to && this.viewportLines.find(function(n) {
      return n.from <= t && n.to >= t;
    }) || Ru(this.heightMap.lineAt(t, Tn.ByPos, this.state.doc, 0, 0), this.scaler);
  } }, { key: "lineBlockAtHeight", value: function(t) {
    return Ru(this.heightMap.lineAt(this.scaler.fromDOM(t), Tn.ByHeight, this.state.doc, 0, 0), this.scaler);
  } }, { key: "elementAtHeight", value: function(t) {
    return Ru(this.heightMap.blockAt(this.scaler.fromDOM(t), this.state.doc, 0, 0), this.scaler);
  } }, { key: "docHeight", get: function() {
    return this.scaler.toDOM(this.heightMap.height);
  } }, { key: "contentHeight", get: function() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  } }]), e;
}(), Al = Y(function e(t, n) {
  Z(this, e), this.from = t, this.to = n;
});
function Pl(e, t) {
  var n = e.total, r = e.ranges;
  if (t <= 0)
    return r[0].from;
  if (t >= 1)
    return r[r.length - 1].to;
  for (var i = Math.floor(n * t), o = 0; ; o++) {
    var a = r[o], s = a.from, u = a.to - s;
    if (i <= u)
      return s + i;
    i -= u;
  }
}
function w4(e, t) {
  var n, r = 0, i = ut(e.ranges);
  try {
    for (i.s(); !(n = i.n()).done; ) {
      var o = n.value, a = o.from, s = o.to;
      if (t <= s) {
        r += t - a;
        break;
      }
      r += s - a;
    }
  } catch (u) {
    i.e(u);
  } finally {
    i.f();
  }
  return r / e.total;
}
function x4(e, t, n) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    if (i.from < n && i.to > t) {
      var o = [];
      i.from < t && o.push({ from: i.from, to: t }), i.to > n && o.push({ from: n, to: i.to }), e.splice.apply(e, [r, 1].concat(o)), r += o.length - 1;
    }
  }
}
var j4 = { toDOM: function(e) {
  return e;
}, fromDOM: function(e) {
  return e;
}, scale: 1 }, nH = function() {
  function e(t, n, r) {
    Z(this, e);
    var i = 0, o = 0, a = 0;
    this.viewports = r.map(function(l) {
      var f = l.from, h = l.to, d = n.lineAt(f, Tn.ByPos, t, 0, 0).top, p = n.lineAt(h, Tn.ByPos, t, 0, 0).bottom;
      return i += p - d, { from: f, to: h, top: d, bottom: p, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - i) / (n.height - i);
    var s, u = ut(this.viewports);
    try {
      for (u.s(); !(s = u.n()).done; ) {
        var c = s.value;
        c.domTop = a + (c.top - o) * this.scale, a = c.domBottom = c.domTop + (c.bottom - c.top), o = c.bottom;
      }
    } catch (l) {
      u.e(l);
    } finally {
      u.f();
    }
  }
  return Y(e, [{ key: "toDOM", value: function(t) {
    for (var n = 0, r = 0, i = 0; ; n++) {
      var o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || t < o.top)
        return i + (t - r) * this.scale;
      if (t <= o.bottom)
        return o.domTop + (t - o.top);
      r = o.bottom, i = o.domBottom;
    }
  } }, { key: "fromDOM", value: function(t) {
    for (var n = 0, r = 0, i = 0; ; n++) {
      var o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || t < o.domTop)
        return r + (t - i) / this.scale;
      if (t <= o.domBottom)
        return o.top + (t - o.domTop);
      r = o.bottom, i = o.domBottom;
    }
  } }]), e;
}();
function Ru(e, t) {
  if (t.scale == 1)
    return e;
  var n = t.toDOM(e.top), r = t.toDOM(e.bottom);
  return new Ss(e.from, e.length, n, r - n, Array.isArray(e.type) ? e.type.map(function(i) {
    return Ru(i, t);
  }) : e.type);
}
var El = be.define({ combine: function(e) {
  return e.join(" ");
} }), Kp = be.define({ combine: function(e) {
  return e.indexOf(!0) > -1;
} }), Gp = ua.newName(), yP = ua.newName(), bP = ua.newName(), kP = { "&light": "." + yP, "&dark": "." + bP };
function Qp(e, t, n) {
  return new ua(t, { finish: function(r) {
    return /&/.test(r) ? r.replace(/&\w*/, function(i) {
      if (i == "&")
        return e;
      if (!n || !n[i])
        throw new RangeError("Unsupported selector: ".concat(i));
      return n[i];
    }) : e + " " + r;
  } });
}
var rH = Qp("." + Gp, { "&.cm-editor": { position: "relative !important", boxSizing: "border-box", "&.cm-focused": { outline: "1px dotted #212121" }, display: "flex !important", flexDirection: "column" }, ".cm-scroller": { display: "flex !important", alignItems: "flex-start !important", fontFamily: "monospace", lineHeight: 1.4, height: "100%", overflowX: "auto", position: "relative", zIndex: 0 }, ".cm-content": { margin: 0, flexGrow: 2, flexShrink: 0, minHeight: "100%", display: "block", whiteSpace: "pre", wordWrap: "normal", boxSizing: "border-box", padding: "4px 0", outline: "none", "&[contenteditable=true]": { WebkitUserModify: "read-write-plaintext-only" } }, ".cm-lineWrapping": { whiteSpace_fallback: "pre-wrap", whiteSpace: "break-spaces", wordBreak: "break-word", overflowWrap: "anywhere", flexShrink: 1 }, "&light .cm-content": { caretColor: "black" }, "&dark .cm-content": { caretColor: "white" }, ".cm-line": { display: "block", padding: "0 2px 0 4px" }, ".cm-selectionLayer": { zIndex: -1, contain: "size style" }, ".cm-selectionBackground": { position: "absolute" }, "&light .cm-selectionBackground": { background: "#d9d9d9" }, "&dark .cm-selectionBackground": { background: "#222" }, "&light.cm-focused .cm-selectionBackground": { background: "#d7d4f0" }, "&dark.cm-focused .cm-selectionBackground": { background: "#233" }, ".cm-cursorLayer": { zIndex: 100, contain: "size style", pointerEvents: "none" }, "&.cm-focused .cm-cursorLayer": { animation: "steps(1) cm-blink 1.2s infinite" }, "@keyframes cm-blink": { "0%": {}, "50%": { visibility: "hidden" }, "100%": {} }, "@keyframes cm-blink2": { "0%": {}, "50%": { visibility: "hidden" }, "100%": {} }, ".cm-cursor, .cm-dropCursor": { position: "absolute", borderLeft: "1.2px solid black", marginLeft: "-0.6px", pointerEvents: "none" }, ".cm-cursor": { display: "none" }, "&dark .cm-cursor": { borderLeftColor: "#444" }, "&.cm-focused .cm-cursor": { display: "block" }, "&light .cm-activeLine": { backgroundColor: "#f3f9ff" }, "&dark .cm-activeLine": { backgroundColor: "#223039" }, "&light .cm-specialChar": { color: "red" }, "&dark .cm-specialChar": { color: "#f78" }, ".cm-gutters": { display: "flex", height: "100%", boxSizing: "border-box", left: 0, zIndex: 200 }, "&light .cm-gutters": { backgroundColor: "#f5f5f5", color: "#6c6c6c", borderRight: "1px solid #ddd" }, "&dark .cm-gutters": { backgroundColor: "#333338", color: "#ccc" }, ".cm-gutter": { display: "flex !important", flexDirection: "column", flexShrink: 0, boxSizing: "border-box", minHeight: "100%", overflow: "hidden" }, ".cm-gutterElement": { boxSizing: "border-box" }, ".cm-lineNumbers .cm-gutterElement": { padding: "0 3px 0 5px", minWidth: "20px", textAlign: "right", whiteSpace: "nowrap" }, "&light .cm-activeLineGutter": { backgroundColor: "#e2f2ff" }, "&dark .cm-activeLineGutter": { backgroundColor: "#222227" }, ".cm-panels": { boxSizing: "border-box", position: "sticky", left: 0, right: 0 }, "&light .cm-panels": { backgroundColor: "#f5f5f5", color: "black" }, "&light .cm-panels-top": { borderBottom: "1px solid #ddd" }, "&light .cm-panels-bottom": { borderTop: "1px solid #ddd" }, "&dark .cm-panels": { backgroundColor: "#333338", color: "white" }, ".cm-tab": { display: "inline-block", overflow: "hidden", verticalAlign: "bottom" }, ".cm-widgetBuffer": { verticalAlign: "text-top", height: "1em", display: "inline" }, ".cm-placeholder": { color: "#888", display: "inline-block", verticalAlign: "top" }, ".cm-button": { verticalAlign: "middle", color: "inherit", fontSize: "70%", padding: ".2em 1em", borderRadius: "1px" }, "&light .cm-button": { backgroundImage: "linear-gradient(#eff1f5, #d9d9df)", border: "1px solid #888", "&:active": { backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)" } }, "&dark .cm-button": { backgroundImage: "linear-gradient(#393939, #111)", border: "1px solid #888", "&:active": { backgroundImage: "linear-gradient(#111, #333)" } }, ".cm-textfield": { verticalAlign: "middle", color: "inherit", fontSize: "70%", border: "1px solid silver", padding: ".2em .5em" }, "&light .cm-textfield": { backgroundColor: "white" }, "&dark .cm-textfield": { border: "1px solid #555", backgroundColor: "inherit" } }, kP), iH = { childList: !0, characterData: !0, subtree: !0, attributes: !0, characterDataOldValue: !0 }, Yd = ye.ie && ye.ie_version <= 11, oH = function() {
  function e(t, n, r) {
    var i = this;
    Z(this, e), this.view = t, this.onChange = n, this.onScrollChanged = r, this.active = !1, this.selectionRange = new SV(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.scrollTargets = [], this.intersection = null, this.resize = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.parentCheck = -1, this.dom = t.contentDOM, this.observer = new MutationObserver(function(o) {
      var a, s = ut(o);
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var u = a.value;
          i.queue.push(u);
        }
      } catch (c) {
        s.e(c);
      } finally {
        s.f();
      }
      (ye.ie && ye.ie_version <= 11 || ye.ios && t.composing) && o.some(function(c) {
        return c.type == "childList" && c.removedNodes.length || c.type == "characterData" && c.oldValue.length > c.target.nodeValue.length;
      }) ? i.flushSoon() : i.flush();
    }), Yd && (this.onCharData = function(o) {
      i.queue.push({ target: o.target, type: "characterData", oldValue: o.prevValue }), i.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), window.addEventListener("resize", this.onResize = this.onResize.bind(this)), typeof ResizeObserver == "function" && (this.resize = new ResizeObserver(function() {
      i.view.docView.lastUpdate < Date.now() - 75 && i.onResize();
    }), this.resize.observe(t.scrollDOM)), window.addEventListener("beforeprint", this.onPrint = this.onPrint.bind(this)), this.start(), window.addEventListener("scroll", this.onScroll = this.onScroll.bind(this)), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver(function(o) {
      i.parentCheck < 0 && (i.parentCheck = setTimeout(i.listenForScroll.bind(i), 1e3)), o.length > 0 && o[o.length - 1].intersectionRatio > 0 != i.intersecting && (i.intersecting = !i.intersecting, i.intersecting != i.view.inView && i.onScrollChanged(document.createEvent("Event")));
    }, {}), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver(function(o) {
      o.length > 0 && o[o.length - 1].intersectionRatio > 0 && i.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange(), this.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  return Y(e, [{ key: "onScroll", value: function(t) {
    this.intersecting && this.flush(!1), this.onScrollChanged(t);
  } }, { key: "onResize", value: function() {
    var t = this;
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(function() {
      t.resizeTimeout = -1, t.view.requestMeasure();
    }, 50));
  } }, { key: "onPrint", value: function() {
    var t = this;
    this.view.viewState.printing = !0, this.view.measure(), setTimeout(function() {
      t.view.viewState.printing = !1, t.view.requestMeasure();
    }, 500);
  } }, { key: "updateGaps", value: function(t) {
    if (this.gapIntersection && (t.length != this.gaps.length || this.gaps.some(function(o, a) {
      return o != t[a];
    }))) {
      this.gapIntersection.disconnect();
      var n, r = ut(t);
      try {
        for (r.s(); !(n = r.n()).done; ) {
          var i = n.value;
          this.gapIntersection.observe(i);
        }
      } catch (o) {
        r.e(o);
      } finally {
        r.f();
      }
      this.gaps = t;
    }
  } }, { key: "onSelectionChange", value: function(t) {
    if (this.readSelectionRange() && !this.delayedAndroidKey) {
      var n = this.view, r = this.selectionRange;
      if (n.state.facet(ud) ? n.root.activeElement == this.dom : Ap(n.dom, r)) {
        var i = r.anchorNode && n.docView.nearest(r.anchorNode);
        i && i.ignoreEvent(t) || ((ye.ie && ye.ie_version <= 11 || ye.android && ye.chrome) && !n.state.selection.main.empty && r.focusNode && Hf(r.focusNode, r.focusOffset, r.anchorNode, r.anchorOffset) ? this.flushSoon() : this.flush(!1));
      }
    }
  } }, { key: "readSelectionRange", value: function() {
    var t = this.view.root, n = ye.safari && t.nodeType == 11 && function() {
      for (var r = document.activeElement; r && r.shadowRoot; )
        r = r.shadowRoot.activeElement;
      return r;
    }() == this.view.contentDOM && function(r) {
      var i = null;
      function o(h) {
        h.preventDefault(), h.stopImmediatePropagation(), i = h.getTargetRanges()[0];
      }
      if (r.contentDOM.addEventListener("beforeinput", o, !0), document.execCommand("indent"), r.contentDOM.removeEventListener("beforeinput", o, !0), !i)
        return null;
      var a = i.startContainer, s = i.startOffset, u = i.endContainer, c = i.endOffset, l = r.docView.domAtPos(r.state.selection.main.anchor);
      if (Hf(l.node, l.offset, u, c)) {
        var f = [u, c, a, s];
        a = f[0], s = f[1], u = f[2], c = f[3];
      }
      return { anchorNode: a, anchorOffset: s, focusNode: u, focusOffset: c };
    }(this.view) || Vf(t);
    return !(!n || this.selectionRange.eq(n)) && (this.selectionRange.setRange(n), this.selectionChanged = !0);
  } }, { key: "setSelectionRange", value: function(t, n) {
    this.selectionRange.set(t.node, t.offset, n.node, n.offset), this.selectionChanged = !1;
  } }, { key: "clearSelectionRange", value: function() {
    this.selectionRange.set(null, 0, null, 0);
  } }, { key: "listenForScroll", value: function() {
    this.parentCheck = -1;
    for (var t = 0, n = null, r = this.dom; r; )
      if (r.nodeType == 1)
        !n && t < this.scrollTargets.length && this.scrollTargets[t] == r ? t++ : n || (n = this.scrollTargets.slice(0, t)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      else {
        if (r.nodeType != 11)
          break;
        r = r.host;
      }
    if (t < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, t)), n) {
      var i, o = ut(this.scrollTargets);
      try {
        for (o.s(); !(i = o.n()).done; )
          i.value.removeEventListener("scroll", this.onScroll);
      } catch (u) {
        o.e(u);
      } finally {
        o.f();
      }
      var a, s = ut(this.scrollTargets = n);
      try {
        for (s.s(); !(a = s.n()).done; )
          a.value.addEventListener("scroll", this.onScroll);
      } catch (u) {
        s.e(u);
      } finally {
        s.f();
      }
    }
  } }, { key: "ignore", value: function(t) {
    if (!this.active)
      return t();
    try {
      return this.stop(), t();
    } finally {
      this.start(), this.clear();
    }
  } }, { key: "start", value: function() {
    this.active || (this.observer.observe(this.dom, iH), Yd && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  } }, { key: "stop", value: function() {
    this.active && (this.active = !1, this.observer.disconnect(), Yd && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  } }, { key: "clear", value: function() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  } }, { key: "delayAndroidKey", value: function(t, n) {
    var r = this;
    this.delayedAndroidKey || requestAnimationFrame(function() {
      var i = r.delayedAndroidKey;
      r.delayedAndroidKey = null, r.delayedFlush = -1, r.flush() || Gu(r.view.contentDOM, i.key, i.keyCode);
    }), this.delayedAndroidKey && t != "Enter" || (this.delayedAndroidKey = { key: t, keyCode: n });
  } }, { key: "flushSoon", value: function() {
    var t = this;
    this.delayedFlush < 0 && (this.delayedFlush = window.setTimeout(function() {
      t.delayedFlush = -1, t.flush();
    }, 20));
  } }, { key: "forceFlush", value: function() {
    this.delayedFlush >= 0 && (window.clearTimeout(this.delayedFlush), this.delayedFlush = -1, this.flush());
  } }, { key: "processRecords", value: function() {
    var t, n = this.queue, r = ut(this.observer.takeRecords());
    try {
      for (r.s(); !(t = r.n()).done; ) {
        var i = t.value;
        n.push(i);
      }
    } catch (h) {
      r.e(h);
    } finally {
      r.f();
    }
    n.length && (this.queue = []);
    var o, a = -1, s = -1, u = !1, c = ut(n);
    try {
      for (c.s(); !(o = c.n()).done; ) {
        var l = o.value, f = this.readMutation(l);
        f && (f.typeOver && (u = !0), a == -1 ? (a = f.from, s = f.to) : (a = Math.min(f.from, a), s = Math.max(f.to, s)));
      }
    } catch (h) {
      c.e(h);
    } finally {
      c.f();
    }
    return { from: a, to: s, typeOver: u };
  } }, { key: "flush", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    if (!(this.delayedFlush >= 0 || this.delayedAndroidKey)) {
      t && this.readSelectionRange();
      var n = this.processRecords(), r = n.from, i = n.to, o = n.typeOver, a = this.selectionChanged && Ap(this.dom, this.selectionRange);
      if (!(r < 0) || a) {
        this.selectionChanged = !1;
        var s = this.view.state, u = this.onChange(r, i, o);
        return this.view.state == s && this.view.update([]), u;
      }
    }
  } }, { key: "readMutation", value: function(t) {
    var n = this.view.docView.nearest(t.target);
    if (!n || n.ignoreMutation(t))
      return null;
    if (n.markDirty(t.type == "attributes"), t.type == "attributes" && (n.dirty |= 4), t.type == "childList") {
      var r = S4(n, t.previousSibling || t.target.previousSibling, -1), i = S4(n, t.nextSibling || t.target.nextSibling, 1);
      return { from: r ? n.posAfter(r) : n.posAtStart, to: i ? n.posBefore(i) : n.posAtEnd, typeOver: !1 };
    }
    return t.type == "characterData" ? { from: n.posAtStart, to: n.posAtEnd, typeOver: t.target.nodeValue == t.oldValue } : null;
  } }, { key: "destroy", value: function() {
    var t, n, r;
    this.stop(), (t = this.intersection) === null || t === void 0 || t.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resize) === null || r === void 0 || r.disconnect();
    var i, o = ut(this.scrollTargets);
    try {
      for (o.s(); !(i = o.n()).done; )
        i.value.removeEventListener("scroll", this.onScroll);
    } catch (a) {
      o.e(a);
    } finally {
      o.f();
    }
    window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onResize), window.removeEventListener("beforeprint", this.onPrint), this.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout);
  } }]), e;
}();
function S4(e, t, n) {
  for (; t; ) {
    var r = Zn.get(t);
    if (r && r.parent == e)
      return r;
    var i = t.parentNode;
    t = i != e.dom ? i : n > 0 ? t.nextSibling : t.previousSibling;
  }
  return null;
}
function aH(e, t, n, r) {
  var i, o, a = e.state.selection.main;
  if (t > -1) {
    var s = e.docView.domBoundsAround(t, n, 0);
    if (!s || e.state.readOnly)
      return !1;
    var u = s.from, c = s.to, l = e.docView.impreciseHead || e.docView.impreciseAnchor ? [] : function(M) {
      var $ = [];
      if (M.root.activeElement != M.contentDOM)
        return $;
      var q = M.observer.selectionRange, B = q.anchorNode, D = q.anchorOffset, _ = q.focusNode, L = q.focusOffset;
      return B && ($.push(new Xj(B, D)), _ == B && L == D || $.push(new Xj(_, L))), $;
    }(e), f = new lP(l, e.state);
    f.readRange(s.startDOM, s.endDOM);
    var h = a.from, d = null;
    (e.inputState.lastKeyCode === 8 && e.inputState.lastKeyTime > Date.now() - 100 || ye.android && f.text.length < c - u) && (h = a.to, d = "end");
    var p = function(M, $, q, B) {
      for (var D = Math.min(M.length, $.length), _ = 0; _ < D && M.charCodeAt(_) == $.charCodeAt(_); )
        _++;
      if (_ == D && M.length == $.length)
        return null;
      for (var L = M.length, J = $.length; L > 0 && J > 0 && M.charCodeAt(L - 1) == $.charCodeAt(J - 1); )
        L--, J--;
      return B == "end" && (q -= L + Math.max(0, _ - Math.min(L, J)) - _), L < _ && M.length < $.length ? (J = (_ -= q <= _ && q >= L ? _ - q : 0) + (J - L), L = _) : J < _ && (L = (_ -= q <= _ && q >= J ? _ - q : 0) + (L - J), J = _), { from: _, toA: L, toB: J };
    }(e.state.doc.sliceString(u, c, "\uFFFF"), f.text, h - u, d);
    p && (ye.chrome && e.inputState.lastKeyCode == 13 && p.toB == p.from + 2 && f.text.slice(p.from, p.toB) == "\uFFFF\uFFFF" && p.toB--, i = { from: u + p.from, to: u + p.toA, insert: xn.of(f.text.slice(p.from, p.toB).split("\uFFFF")) }), o = function(M, $) {
      if (M.length == 0)
        return null;
      var q = M[0].pos, B = M.length == 2 ? M[1].pos : q;
      return q > -1 && B > -1 ? Ht.single(q + $, B + $) : null;
    }(l, u);
  } else if (e.hasFocus || !e.state.facet(ud)) {
    var v = e.observer.selectionRange, m = e.docView, g = m.impreciseHead, y = m.impreciseAnchor, b = g && g.node == v.focusNode && g.offset == v.focusOffset || !Hs(e.contentDOM, v.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(v.focusNode, v.focusOffset), k = y && y.node == v.anchorNode && y.offset == v.anchorOffset || !Hs(e.contentDOM, v.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(v.anchorNode, v.anchorOffset);
    b == a.head && k == a.anchor || (o = Ht.single(k, b));
  }
  if (!i && !o)
    return !1;
  if (!i && r && !a.empty && o && o.main.empty ? i = { from: a.from, to: a.to, insert: e.state.doc.slice(a.from, a.to) } : i && i.from >= a.from && i.to <= a.to && (i.from != a.from || i.to != a.to) && a.to - a.from - (i.to - i.from) <= 4 ? i = { from: a.from, to: a.to, insert: e.state.doc.slice(a.from, i.from).append(i.insert).append(e.state.doc.slice(i.to, a.to)) } : (ye.mac || ye.android) && i && i.from == i.to && i.from == a.head - 1 && i.insert.toString() == "." && (i = { from: a.from, to: a.to, insert: xn.of([" "]) }), i) {
    var w = e.state;
    if (ye.ios && e.inputState.flushIOSKey(e) || ye.android && (i.from == a.from && i.to == a.to && i.insert.length == 1 && i.insert.lines == 2 && Gu(e.contentDOM, "Enter", 13) || i.from == a.from - 1 && i.to == a.to && i.insert.length == 0 && Gu(e.contentDOM, "Backspace", 8) || i.from == a.from && i.to == a.to + 1 && i.insert.length == 0 && Gu(e.contentDOM, "Delete", 46)))
      return !0;
    var x, S = i.insert.toString();
    if (e.state.facet(rP).some(function(M) {
      return M(e, i.from, i.to, S);
    }))
      return !0;
    if (e.inputState.composing >= 0 && e.inputState.composing++, i.from >= a.from && i.to <= a.to && i.to - i.from >= (a.to - a.from) / 3 && (!o || o.main.empty && o.main.from == i.from + i.insert.length) && e.inputState.composing < 0) {
      var T = a.from < i.from ? w.sliceDoc(a.from, i.from) : "", P = a.to > i.to ? w.sliceDoc(i.to, a.to) : "";
      x = w.replaceSelection(e.state.toText(T + i.insert.sliceString(0, void 0, e.state.lineBreak) + P));
    } else {
      var O = w.changes(i), j = o && !w.selection.main.eq(o.main) && o.main.to <= O.newLength ? o.main : void 0;
      if (w.selection.ranges.length > 1 && e.inputState.composing >= 0 && i.to <= a.to && i.to >= a.to - 10) {
        var V = e.state.sliceDoc(i.from, i.to), E = fP(e) || e.state.doc.lineAt(a.head), C = a.to - i.to, H = a.to - a.from;
        x = w.changeByRange(function(M) {
          if (M.from == a.from && M.to == a.to)
            return { changes: O, range: j || M.map(O) };
          var $ = M.to - C, q = $ - V.length;
          if (M.to - M.from != H || e.state.sliceDoc(q, $) != V || E && M.to >= E.from && M.from <= E.to)
            return { range: M };
          var B = w.changes({ from: q, to: $, insert: i.insert }), D = M.to - a.to;
          return { changes: B, range: j ? Ht.range(Math.max(0, j.anchor + D), Math.max(0, j.head + D)) : M.map(B) };
        });
      } else
        x = { changes: O, selection: j && w.selection.replaceRange(j) };
    }
    var X = "input.type";
    return e.composing && (X += ".compose", e.inputState.compositionFirstChange && (X += ".start", e.inputState.compositionFirstChange = !1)), e.dispatch(x, { scrollIntoView: !0, userEvent: X }), !0;
  }
  if (o && !o.main.eq(a)) {
    var F = !1, G = "select";
    return e.inputState.lastSelectionTime > Date.now() - 50 && (e.inputState.lastSelectionOrigin == "select" && (F = !0), G = e.inputState.lastSelectionOrigin), e.dispatch({ selection: o, scrollIntoView: F, userEvent: G }), !0;
  }
  return !1;
}
var we = function() {
  function e() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Z(this, e), this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.style.cssText = "position: absolute; top: -10000px", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), this._dispatch = n.dispatch || function(a) {
      return t.update([a]);
    }, this.dispatch = this.dispatch.bind(this), this.root = n.root || $V(n.parent) || document, this.viewState = new k4(n.state || In.create(n)), this.plugins = this.state.facet(Iu).map(function(a) {
      return new Kd(a);
    });
    var r, i = ut(this.plugins);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        o.update(this);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    this.observer = new oH(this, function(a, s, u) {
      return aH(t, a, s, u);
    }, function(a) {
      t.inputState.runScrollHandlers(t, a), t.observer.intersecting && t.measure();
    }), this.inputState = new VV(this), this.inputState.ensureHandlers(this, this.plugins), this.docView = new Zj(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), n.parent && n.parent.appendChild(this.dom);
  }
  return Y(e, [{ key: "state", get: function() {
    return this.viewState.state;
  } }, { key: "viewport", get: function() {
    return this.viewState.viewport;
  } }, { key: "visibleRanges", get: function() {
    return this.viewState.visibleRanges;
  } }, { key: "inView", get: function() {
    return this.viewState.inView;
  } }, { key: "composing", get: function() {
    return this.inputState.composing > 0;
  } }, { key: "compositionStarted", get: function() {
    return this.inputState.composing >= 0;
  } }, { key: "dispatch", value: function() {
    var t;
    this._dispatch(arguments.length == 1 && (arguments.length <= 0 ? void 0 : arguments[0]) instanceof Fr ? arguments.length <= 0 ? void 0 : arguments[0] : (t = this.state).update.apply(t, arguments));
  } }, { key: "update", value: function(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    var n, r, i = !1, o = !1, a = this.state, s = ut(t);
    try {
      for (s.s(); !(r = s.n()).done; ) {
        var u = r.value;
        if (u.startState != a)
          throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
        a = u.state;
      }
    } catch (b) {
      s.e(b);
    } finally {
      s.f();
    }
    if (this.destroyed)
      this.viewState.state = a;
    else {
      if (this.observer.clear(), a.facet(In.phrases) != this.state.facet(In.phrases))
        return this.setState(a);
      n = Vj.create(this, a, t);
      var c = this.viewState.scrollTarget;
      try {
        this.updateState = 2;
        var l, f = ut(t);
        try {
          for (f.s(); !(l = f.n()).done; ) {
            var h = l.value;
            if (c && (c = c.map(h.changes)), h.scrollIntoView) {
              var d = h.state.selection.main;
              c = new Fj(d.empty ? d : Ht.cursor(d.head, d.head > d.anchor ? -1 : 1));
            }
            var p, v = ut(h.effects);
            try {
              for (v.s(); !(p = v.n()).done; ) {
                var m = p.value;
                m.is(qj) && (c = m.value);
              }
            } catch (b) {
              v.e(b);
            } finally {
              v.f();
            }
          }
        } catch (b) {
          f.e(b);
        } finally {
          f.f();
        }
        this.viewState.update(n, c), this.bidiCache = _4.update(this.bidiCache, n.changes), n.empty || (this.updatePlugins(n), this.inputState.update(n)), i = this.docView.update(n), this.state.facet(Nu) != this.styleModules && this.mountStyles(), o = this.updateAttrs(), this.showAnnouncements(t), this.docView.updateSelection(i, t.some(function(b) {
          return b.isUserEvent("select.pointer");
        }));
      } finally {
        this.updateState = 0;
      }
      if (n.startState.facet(El) != n.state.facet(El) && (this.viewState.mustMeasureContent = !0), (i || o || c || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), !n.empty) {
        var g, y = ut(this.state.facet(qp));
        try {
          for (y.s(); !(g = y.n()).done; )
            (0, g.value)(n);
        } catch (b) {
          y.e(b);
        } finally {
          y.f();
        }
      }
    }
  } }, { key: "setState", value: function(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed)
      this.viewState.state = t;
    else {
      this.updateState = 2;
      var n = this.hasFocus;
      try {
        var r, i = ut(this.plugins);
        try {
          for (i.s(); !(r = i.n()).done; )
            r.value.destroy(this);
        } catch (s) {
          i.e(s);
        } finally {
          i.f();
        }
        this.viewState = new k4(t), this.plugins = t.facet(Iu).map(function(s) {
          return new Kd(s);
        }), this.pluginMap.clear();
        var o, a = ut(this.plugins);
        try {
          for (a.s(); !(o = a.n()).done; )
            o.value.update(this);
        } catch (s) {
          a.e(s);
        } finally {
          a.f();
        }
        this.docView = new Zj(this), this.inputState.ensureHandlers(this, this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
      } finally {
        this.updateState = 0;
      }
      n && this.focus(), this.requestMeasure();
    }
  } }, { key: "updatePlugins", value: function(t) {
    var n = t.startState.facet(Iu), r = t.state.facet(Iu);
    if (n != r) {
      var i, o = [], a = ut(r);
      try {
        for (a.s(); !(i = a.n()).done; ) {
          var s = i.value, u = n.indexOf(s);
          if (u < 0)
            o.push(new Kd(s));
          else {
            var c = this.plugins[u];
            c.mustUpdate = t, o.push(c);
          }
        }
      } catch (m) {
        a.e(m);
      } finally {
        a.f();
      }
      var l, f = ut(this.plugins);
      try {
        for (f.s(); !(l = f.n()).done; ) {
          var h = l.value;
          h.mustUpdate != t && h.destroy(this);
        }
      } catch (m) {
        f.e(m);
      } finally {
        f.f();
      }
      this.plugins = o, this.pluginMap.clear(), this.inputState.ensureHandlers(this, this.plugins);
    } else {
      var d, p = ut(this.plugins);
      try {
        for (p.s(); !(d = p.n()).done; )
          d.value.mustUpdate = t;
      } catch (m) {
        p.e(m);
      } finally {
        p.f();
      }
    }
    for (var v = 0; v < this.plugins.length; v++)
      this.plugins[v].update(this);
  } }, { key: "measure", value: function() {
    var t = this, n = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    if (!this.destroyed) {
      this.measureScheduled > -1 && cancelAnimationFrame(this.measureScheduled), this.measureScheduled = 0, n && this.observer.flush();
      var r = null;
      try {
        for (var i = 0; ; i++) {
          this.updateState = 1;
          var o = this.viewport, a = this.viewState.measure(this);
          if (!a && !this.measureRequests.length && this.viewState.scrollTarget == null)
            break;
          if (i > 5) {
            console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
            break;
          }
          var s = [];
          if (!(4 & a)) {
            var u = [s, this.measureRequests];
            this.measureRequests = u[0], s = u[1];
          }
          var c = s.map(function(y) {
            try {
              return y.read(t);
            } catch (b) {
              return ei(t.state, b), $4;
            }
          }), l = Vj.create(this, this.state, []), f = !1, h = !1;
          l.flags |= a, r ? r.flags |= a : r = l, this.updateState = 2, l.empty || (this.updatePlugins(l), this.inputState.update(l), this.updateAttrs(), f = this.docView.update(l));
          for (var d = 0; d < s.length; d++)
            if (c[d] != $4)
              try {
                var p = s[d];
                p.write && p.write(c[d], this);
              } catch (y) {
                ei(this.state, y);
              }
          if (this.viewState.scrollTarget && (this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, h = !0), f && this.docView.updateSelection(!0), this.viewport.from == o.from && this.viewport.to == o.to && !h && this.measureRequests.length == 0)
            break;
        }
      } finally {
        this.updateState = 0, this.measureScheduled = -1;
      }
      if (r && !r.empty) {
        var v, m = ut(this.state.facet(qp));
        try {
          for (m.s(); !(v = m.n()).done; ) {
            var g = v.value;
            g(r);
          }
        } catch (y) {
          m.e(y);
        } finally {
          m.f();
        }
      }
    }
  } }, { key: "themeClasses", get: function() {
    return Gp + " " + (this.state.facet(Kp) ? bP : yP) + " " + this.state.facet(El);
  } }, { key: "updateAttrs", value: function() {
    var t = this, n = C4(this, oP, { class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses }), r = { spellcheck: "false", autocorrect: "off", autocapitalize: "off", translate: "no", contenteditable: this.state.facet(ud) ? "true" : "false", class: "cm-content", style: "".concat(ye.tabSize, ": ").concat(this.state.tabSize), role: "textbox", "aria-multiline": "true" };
    this.state.readOnly && (r["aria-readonly"] = "true"), C4(this, aP, r);
    var i = this.observer.ignore(function() {
      var o = Lp(t.contentDOM, t.contentAttrs, r), a = Lp(t.dom, t.editorAttrs, n);
      return o || a;
    });
    return this.editorAttrs = n, this.contentAttrs = r, i;
  } }, { key: "showAnnouncements", value: function(t) {
    var n, r = !0, i = ut(t);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o, a = ut(n.value.effects);
        try {
          for (a.s(); !(o = a.n()).done; ) {
            var s = o.value;
            s.is(e.announce) && (r && (this.announceDOM.textContent = ""), r = !1, this.announceDOM.appendChild(document.createElement("div")).textContent = s.value);
          }
        } catch (u) {
          a.e(u);
        } finally {
          a.f();
        }
      }
    } catch (u) {
      i.e(u);
    } finally {
      i.f();
    }
  } }, { key: "mountStyles", value: function() {
    this.styleModules = this.state.facet(Nu), ua.mount(this.root, this.styleModules.concat(rH).reverse());
  } }, { key: "readMeasured", value: function() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  } }, { key: "requestMeasure", value: function(t) {
    var n = this;
    if (this.measureScheduled < 0 && (this.measureScheduled = requestAnimationFrame(function() {
      return n.measure();
    })), t) {
      if (t.key != null) {
        for (var r = 0; r < this.measureRequests.length; r++)
          if (this.measureRequests[r].key === t.key)
            return void (this.measureRequests[r] = t);
      }
      this.measureRequests.push(t);
    }
  } }, { key: "plugin", value: function(t) {
    var n = this.pluginMap.get(t);
    return (n === void 0 || n && n.spec != t) && this.pluginMap.set(t, n = this.plugins.find(function(r) {
      return r.spec == t;
    }) || null), n && n.update(this).value;
  } }, { key: "documentTop", get: function() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  } }, { key: "documentPadding", get: function() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  } }, { key: "elementAtHeight", value: function(t) {
    return this.readMeasured(), this.viewState.elementAtHeight(t);
  } }, { key: "lineBlockAtHeight", value: function(t) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(t);
  } }, { key: "viewportLineBlocks", get: function() {
    return this.viewState.viewportLines;
  } }, { key: "lineBlockAt", value: function(t) {
    return this.viewState.lineBlockAt(t);
  } }, { key: "contentHeight", get: function() {
    return this.viewState.contentHeight;
  } }, { key: "moveByChar", value: function(t, n, r) {
    return Xd(this, t, o4(this, t, n, r));
  } }, { key: "moveByGroup", value: function(t, n) {
    var r = this;
    return Xd(this, t, o4(this, t, n, function(i) {
      return function(o, a, s) {
        var u = o.state.charCategorizer(a), c = u(s);
        return function(l) {
          var f = u(l);
          return c == Nr.Space && (c = f), c == f;
        };
      }(r, t.head, i);
    }));
  } }, { key: "moveToLineBoundary", value: function(t, n) {
    var r = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
    return qV(this, t, n, r);
  } }, { key: "moveVertically", value: function(t, n, r) {
    return Xd(this, t, function(i, o, a, s) {
      var u = o.head, c = a ? 1 : -1;
      if (u == (a ? i.state.doc.length : 0))
        return Ht.cursor(u, o.assoc);
      var l, f = o.goalColumn, h = i.contentDOM.getBoundingClientRect(), d = i.coordsAtPos(u), p = i.documentTop;
      if (d)
        f == null && (f = d.left - h.left), l = c < 0 ? d.top : d.bottom;
      else {
        var v = i.viewState.lineBlockAt(u);
        f == null && (f = Math.min(h.right - h.left, i.defaultCharacterWidth * (u - v.from))), l = (c < 0 ? v.top : v.bottom) + p;
      }
      for (var m = h.left + f, g = s != null ? s : i.defaultLineHeight >> 1, y = 0; ; y += 10) {
        var b = l + (g + y) * c, k = r4(i, { x: m, y: b }, !1, c);
        if (b < h.top || b > h.bottom || (c < 0 ? k < u : k > u))
          return Ht.cursor(k, o.assoc, void 0, f);
      }
    }(this, t, n, r));
  } }, { key: "domAtPos", value: function(t) {
    return this.docView.domAtPos(t);
  } }, { key: "posAtDOM", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return this.docView.posFromDOM(t, n);
  } }, { key: "posAtCoords", value: function(t) {
    var n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
    return this.readMeasured(), r4(this, t, n);
  } }, { key: "coordsAtPos", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    this.readMeasured();
    var r = this.docView.coordsAt(t, n);
    if (!r || r.left == r.right)
      return r;
    var i = this.state.doc.lineAt(t), o = this.bidiSpans(i), a = o[js.find(o, t - i.from, -1, n)];
    return ad(r, a.dir == Wn.LTR == n > 0);
  } }, { key: "defaultCharacterWidth", get: function() {
    return this.viewState.heightOracle.charWidth;
  } }, { key: "defaultLineHeight", get: function() {
    return this.viewState.heightOracle.lineHeight;
  } }, { key: "textDirection", get: function() {
    return this.viewState.defaultTextDirection;
  } }, { key: "textDirectionAt", value: function(t) {
    return !this.state.facet(iP) || t < this.viewport.from || t > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(t));
  } }, { key: "lineWrapping", get: function() {
    return this.viewState.heightOracle.lineWrapping;
  } }, { key: "bidiSpans", value: function(t) {
    if (t.length > sH)
      return Gj(t.length);
    var n, r = this.textDirectionAt(t.from), i = ut(this.bidiCache);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value;
        if (o.from == t.from && o.dir == r)
          return o.order;
      }
    } catch (s) {
      i.e(s);
    } finally {
      i.f();
    }
    var a = function(s, u) {
      var c = s.length, l = u == Vp ? 1 : 2, f = u == Vp ? 2 : 1;
      if (!s || l == 1 && !MV.test(s))
        return Gj(c);
      for (var h = 0, d = l, p = l; h < c; h++) {
        var v = EV(s.charCodeAt(h));
        v == 512 ? v = d : v == 8 && p == 4 && (v = 16), Vn[h] = v == 4 ? 2 : v, 7 & v && (p = v), d = v;
      }
      for (var m = 0, g = l, y = l; m < c; m++) {
        var b = Vn[m];
        if (b == 128)
          m < c - 1 && g == Vn[m + 1] && 24 & g ? b = Vn[m] = g : Vn[m] = 256;
        else if (b == 64) {
          for (var k = m + 1; k < c && Vn[k] == 64; )
            k++;
          for (var w = m && g == 8 || k < c && Vn[k] == 8 ? y == 1 ? 1 : 8 : 256, x = m; x < k; x++)
            Vn[x] = w;
          m = k - 1;
        } else
          b == 8 && y == 1 && (Vn[m] = 1);
        g = b, 7 & b && (y = b);
      }
      for (var S, T, P, O = 0, j = 0, V = 0; O < c; O++)
        if (T = Hp[S = s.charCodeAt(O)])
          if (T < 0) {
            for (var E = j - 3; E >= 0; E -= 3)
              if (Ji[E + 1] == -T) {
                var C = Ji[E + 2], H = 2 & C ? l : 4 & C ? 1 & C ? f : l : 0;
                H && (Vn[O] = Vn[Ji[E]] = H), j = E;
                break;
              }
          } else {
            if (Ji.length == 189)
              break;
            Ji[j++] = O, Ji[j++] = S, Ji[j++] = V;
          }
        else if ((P = Vn[O]) == 2 || P == 1) {
          var X = P == l;
          V = X ? 0 : 1;
          for (var F = j - 3; F >= 0; F -= 3) {
            var G = Ji[F + 2];
            if (2 & G)
              break;
            if (X)
              Ji[F + 2] |= 2;
            else {
              if (4 & G)
                break;
              Ji[F + 2] |= 4;
            }
          }
        }
      for (var M = 0; M < c; M++)
        if (Vn[M] == 256) {
          for (var $ = M + 1; $ < c && Vn[$] == 256; )
            $++;
          for (var q = (M ? Vn[M - 1] : l) == 1, B = q == (($ < c ? Vn[$] : l) == 1) ? q ? 1 : 2 : l, D = M; D < $; D++)
            Vn[D] = B;
          M = $ - 1;
        }
      var _ = [];
      if (l == 1)
        for (var L = 0; L < c; ) {
          for (var J = L, st = Vn[L++] != 1; L < c && st == (Vn[L] != 1); )
            L++;
          if (st)
            for (var ht = L; ht > J; ) {
              for (var xt = ht, kt = Vn[--ht] != 2; ht > J && kt == (Vn[ht - 1] != 2); )
                ht--;
              _.push(new js(ht, xt, kt ? 2 : 1));
            }
          else
            _.push(new js(J, L, 0));
        }
      else
        for (var I = 0; I < c; ) {
          for (var R = I, it = Vn[I++] == 2; I < c && it == (Vn[I] == 2); )
            I++;
          _.push(new js(R, I, it ? 1 : 2));
        }
      return _;
    }(t.text, r);
    return this.bidiCache.push(new _4(t.from, t.to, r, a)), a;
  } }, { key: "hasFocus", get: function() {
    var t;
    return (document.hasFocus() || ye.safari && ((t = this.inputState) === null || t === void 0 ? void 0 : t.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  } }, { key: "focus", value: function() {
    var t = this;
    this.observer.ignore(function() {
      zA(t.contentDOM), t.docView.updateSelection();
    });
  } }, { key: "destroy", value: function() {
    var t, n = ut(this.plugins);
    try {
      for (n.s(); !(t = n.n()).done; )
        t.value.destroy(this);
    } catch (r) {
      n.e(r);
    } finally {
      n.f();
    }
    this.plugins = [], this.inputState.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  } }], [{ key: "scrollIntoView", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return qj.of(new Fj(typeof t == "number" ? Ht.cursor(t) : t, n.y, n.x, n.yMargin, n.xMargin));
  } }, { key: "domEventHandlers", value: function(t) {
    return wr.define(function() {
      return {};
    }, { eventHandlers: t });
  } }, { key: "theme", value: function(t, n) {
    var r = ua.newName(), i = [El.of(r), Nu.of(Qp(".".concat(r), t))];
    return n && n.dark && i.push(Kp.of(!0)), i;
  } }, { key: "baseTheme", value: function(t) {
    return Qc.lowest(Nu.of(Qp("." + Gp, t, kP)));
  } }, { key: "findFromDOM", value: function(t) {
    var n, r = t.querySelector(".cm-content"), i = r && Zn.get(r) || Zn.get(t);
    return ((n = i == null ? void 0 : i.rootView) === null || n === void 0 ? void 0 : n.view) || null;
  } }]), e;
}();
we.styleModule = Nu, we.inputHandler = rP, we.perLineTextDirection = iP, we.exceptionSink = nP, we.updateListener = qp, we.editable = ud, we.mouseSelectionStyle = eP, we.dragMovesSelection = tP, we.clickAddsSelectionRange = YA, we.decorations = pc, we.atomicRanges = sP, we.scrollMargins = uP, we.darkTheme = Kp, we.contentAttributes = aP, we.editorAttributes = oP, we.lineWrapping = we.contentAttributes.of({ class: "cm-lineWrapping" }), we.announce = He.define();
var sH = 4096, $4 = {}, _4 = function() {
  function e(t, n, r, i) {
    Z(this, e), this.from = t, this.to = n, this.dir = r, this.order = i;
  }
  return Y(e, null, [{ key: "update", value: function(t, n) {
    if (n.empty)
      return t;
    for (var r = [], i = t.length ? t[t.length - 1].dir : Wn.LTR, o = Math.max(0, t.length - 10); o < t.length; o++) {
      var a = t[o];
      a.dir != i || n.touchesRange(a.from, a.to) || r.push(new e(n.mapPos(a.from, 1), n.mapPos(a.to, -1), a.dir, a.order));
    }
    return r;
  } }]), e;
}();
function C4(e, t, n) {
  for (var r = e.state.facet(t), i = r.length - 1; i >= 0; i--) {
    var o = r[i], a = typeof o == "function" ? o(e) : o;
    a && Dp(a, n);
  }
  return n;
}
var uH = ye.mac ? "mac" : ye.windows ? "win" : ye.linux ? "linux" : "key";
function cH(e, t) {
  var n, r, i, o, a = e.split(/-(?!$)/), s = a[a.length - 1];
  s == "Space" && (s = " ");
  for (var u = 0; u < a.length - 1; ++u) {
    var c = a[u];
    if (/^(cmd|meta|m)$/i.test(c))
      o = !0;
    else if (/^a(lt)?$/i.test(c))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      r = !0;
    else if (/^s(hift)?$/i.test(c))
      i = !0;
    else {
      if (!/^mod$/i.test(c))
        throw new Error("Unrecognized modifier name: " + c);
      t == "mac" ? o = !0 : r = !0;
    }
  }
  return n && (s = "Alt-" + s), r && (s = "Ctrl-" + s), o && (s = "Meta-" + s), i && (s = "Shift-" + s), s;
}
function Ml(e, t, n) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n !== !1 && t.shiftKey && (e = "Shift-" + e), e;
}
var lH = we.domEventHandlers({ keydown: function(e, t) {
  return xP(wP(t.state), e, t, "editor");
} }), cd = be.define({ enables: lH }), O4 = /* @__PURE__ */ new WeakMap();
function wP(e) {
  var t = e.facet(cd), n = O4.get(t);
  return n || O4.set(t, n = function(r) {
    var i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : uH, a = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null), u = function(m, g) {
      var y = s[m];
      if (y == null)
        s[m] = g;
      else if (y != g)
        throw new Error("Key binding " + m + " is used both as a regular binding and as a multi-stroke prefix");
    }, c = function(m, g, y, b) {
      for (var k = a[m] || (a[m] = /* @__PURE__ */ Object.create(null)), w = g.split(/ (?!$)/).map(function(O) {
        return cH(O, o);
      }), x = function(O) {
        var j = w.slice(0, O).join(" ");
        u(j, !0), k[j] || (k[j] = { preventDefault: !0, commands: [function(V) {
          var E = Go = { view: V, prefix: j, scope: m };
          return setTimeout(function() {
            Go == E && (Go = null);
          }, 4e3), !0;
        }] });
      }, S = 1; S < w.length; S++)
        x(S);
      var T = w.join(" ");
      u(T, !1);
      var P = k[T] || (k[T] = { preventDefault: !1, commands: [] });
      P.commands.push(y), b && (P.preventDefault = !0);
    }, l = ut(r);
    try {
      for (l.s(); !(i = l.n()).done; ) {
        var f = i.value, h = f[o] || f.key;
        if (h) {
          var d, p = ut(f.scope ? f.scope.split(" ") : ["editor"]);
          try {
            for (p.s(); !(d = p.n()).done; ) {
              var v = d.value;
              c(v, h, f.run, f.preventDefault), f.shift && c(v, "Shift-" + h, f.shift, f.preventDefault);
            }
          } catch (m) {
            p.e(m);
          } finally {
            p.f();
          }
        }
      }
    } catch (m) {
      l.e(m);
    } finally {
      l.f();
    }
    return a;
  }(t.reduce(function(r, i) {
    return r.concat(i);
  }, []))), n;
}
var Go = null;
function xP(e, t, n, r) {
  var i = function(h) {
    var d = !(xV && (h.ctrlKey || h.altKey || h.metaKey) || (bV || wV) && h.shiftKey && h.key && h.key.length == 1) && h.key || (h.shiftKey ? Es : ca)[h.keyCode] || h.key || "Unidentified";
    return d == "Esc" && (d = "Escape"), d == "Del" && (d = "Delete"), d == "Left" && (d = "ArrowLeft"), d == "Up" && (d = "ArrowUp"), d == "Right" && (d = "ArrowRight"), d == "Down" && (d = "ArrowDown"), d;
  }(t), o = gr(i, 0), a = Jr(o) == i.length && i != " ", s = "", u = !1;
  Go && Go.view == n && Go.scope == r && (s = Go.prefix + " ", (u = vP.indexOf(t.keyCode) < 0) && (Go = null));
  var c, l = function(h) {
    if (h) {
      var d, p = ut(h.commands);
      try {
        for (p.s(); !(d = p.n()).done; )
          if ((0, d.value)(n))
            return !0;
      } catch (v) {
        p.e(v);
      } finally {
        p.f();
      }
      h.preventDefault && (u = !0);
    }
    return !1;
  }, f = e[r];
  if (f) {
    if (l(f[s + Ml(i, t, !a)]))
      return !0;
    if (a && (t.shiftKey || t.altKey || t.metaKey || o > 127) && (c = ca[t.keyCode]) && c != i) {
      if (l(f[s + Ml(c, t, !0)]) || t.shiftKey && Es[t.keyCode] != c && l(f[s + Ml(Es[t.keyCode], t, !1)]))
        return !0;
    } else if (a && t.shiftKey && l(f[s + Ml(i, t, !0)]))
      return !0;
  }
  return u;
}
var jP = !ye.ios, Du = be.define({ combine: function(e) {
  return ko(e, { cursorBlinkRate: 1200, drawRangeCursor: !0 }, { cursorBlinkRate: function(t, n) {
    return Math.min(t, n);
  }, drawRangeCursor: function(t, n) {
    return t || n;
  } });
} });
function fH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return [Du.of(e), hH, dH];
}
var SP = function() {
  function e(t, n, r, i, o) {
    Z(this, e), this.left = t, this.top = n, this.width = r, this.height = i, this.className = o;
  }
  return Y(e, [{ key: "draw", value: function() {
    var t = document.createElement("div");
    return t.className = this.className, this.adjust(t), t;
  } }, { key: "adjust", value: function(t) {
    t.style.left = this.left + "px", t.style.top = this.top + "px", this.width >= 0 && (t.style.width = this.width + "px"), t.style.height = this.height + "px";
  } }, { key: "eq", value: function(t) {
    return this.left == t.left && this.top == t.top && this.width == t.width && this.height == t.height && this.className == t.className;
  } }]), e;
}(), hH = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.view = t, this.rangePieces = [], this.cursors = [], this.measureReq = { read: this.readPos.bind(this), write: this.drawSel.bind(this) }, this.selectionLayer = t.scrollDOM.appendChild(document.createElement("div")), this.selectionLayer.className = "cm-selectionLayer", this.selectionLayer.setAttribute("aria-hidden", "true"), this.cursorLayer = t.scrollDOM.appendChild(document.createElement("div")), this.cursorLayer.className = "cm-cursorLayer", this.cursorLayer.setAttribute("aria-hidden", "true"), t.requestMeasure(this.measureReq), this.setBlinkRate();
  }
  return Y(e, [{ key: "setBlinkRate", value: function() {
    this.cursorLayer.style.animationDuration = this.view.state.facet(Du).cursorBlinkRate + "ms";
  } }, { key: "update", value: function(t) {
    var n = t.startState.facet(Du) != t.state.facet(Du);
    (n || t.selectionSet || t.geometryChanged || t.viewportChanged) && this.view.requestMeasure(this.measureReq), t.transactions.some(function(r) {
      return r.scrollIntoView;
    }) && (this.cursorLayer.style.animationName = this.cursorLayer.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink"), n && this.setBlinkRate();
  } }, { key: "readPos", value: function() {
    var t, n = this, r = this.view.state, i = r.facet(Du), o = r.selection.ranges.map(function(f) {
      return f.empty ? [] : function(h, d) {
        if (d.to <= h.viewport.from || d.from >= h.viewport.to)
          return [];
        var p = Math.max(d.from, h.viewport.from), v = Math.min(d.to, h.viewport.to), m = h.textDirection == Wn.LTR, g = h.contentDOM, y = g.getBoundingClientRect(), b = _P(h), k = window.getComputedStyle(g.firstChild), w = y.left + parseInt(k.paddingLeft) + Math.min(0, parseInt(k.textIndent)), x = y.right - parseInt(k.paddingRight), S = P4(h, p), T = P4(h, v), P = S.type == Cn.Text ? S : null, O = T.type == Cn.Text ? T : null;
        if (h.lineWrapping && (P && (P = A4(h, p, P)), O && (O = A4(h, v, O))), P && O && P.from == O.from)
          return H(X(d.from, d.to, P));
        var j = P ? X(d.from, null, P) : F(S, !1), V = O ? X(null, d.to, O) : F(T, !0), E = [];
        return (P || S).to < (O || T).from - 1 ? E.push(C(w, j.bottom, x, V.top)) : j.bottom < V.top && h.elementAtHeight((j.bottom + V.top) / 2).type == Cn.Text && (j.bottom = V.top = (j.bottom + V.top) / 2), H(j).concat(E).concat(H(V));
        function C(G, M, $, q) {
          return new SP(G - b.left, M - b.top - 0.01, $ - G, q - M + 0.01, "cm-selectionBackground");
        }
        function H(G) {
          for (var M = G.top, $ = G.bottom, q = G.horizontal, B = [], D = 0; D < q.length; D += 2)
            B.push(C(q[D], M, q[D + 1], $));
          return B;
        }
        function X(G, M, $) {
          var q = 1e9, B = -1e9, D = [];
          function _(yt, jt, Ft, zt, St) {
            var Gt = h.coordsAtPos(yt, yt == $.to ? -2 : 2), _e = h.coordsAtPos(Ft, Ft == $.from ? 2 : -2);
            q = Math.min(Gt.top, _e.top, q), B = Math.max(Gt.bottom, _e.bottom, B), St == Wn.LTR ? D.push(m && jt ? w : Gt.left, m && zt ? x : _e.right) : D.push(!m && zt ? w : _e.left, !m && jt ? x : Gt.right);
          }
          var L, J = G != null ? G : $.from, st = M != null ? M : $.to, ht = ut(h.visibleRanges);
          try {
            for (ht.s(); !(L = ht.n()).done; ) {
              var xt = L.value;
              if (xt.to > J && xt.from < st)
                for (var kt = Math.max(xt.from, J), I = Math.min(xt.to, st); ; ) {
                  var R, it = h.state.doc.lineAt(kt), N = ut(h.bidiSpans(it));
                  try {
                    for (N.s(); !(R = N.n()).done; ) {
                      var K = R.value, z = K.from + it.from, at = K.to + it.from;
                      if (z >= I)
                        break;
                      at > kt && _(Math.max(z, kt), G == null && z <= J, Math.min(at, I), M == null && at >= st, K.dir);
                    }
                  } catch (yt) {
                    N.e(yt);
                  } finally {
                    N.f();
                  }
                  if ((kt = it.to + 1) >= I)
                    break;
                }
            }
          } catch (yt) {
            ht.e(yt);
          } finally {
            ht.f();
          }
          return D.length == 0 && _(J, G == null, st, M == null, h.textDirection), { top: q, bottom: B, horizontal: D };
        }
        function F(G, M) {
          var $ = y.top + (M ? G.top : G.bottom);
          return { top: $, bottom: $, horizontal: [] };
        }
      }(n.view, f);
    }).reduce(function(f, h) {
      return f.concat(h);
    }), a = [], s = ut(r.selection.ranges);
    try {
      for (s.s(); !(t = s.n()).done; ) {
        var u = t.value, c = u == r.selection.main;
        if (u.empty ? !c || jP : i.drawRangeCursor) {
          var l = vH(this.view, u, c);
          l && a.push(l);
        }
      }
    } catch (f) {
      s.e(f);
    } finally {
      s.f();
    }
    return { rangePieces: o, cursors: a };
  } }, { key: "drawSel", value: function(t) {
    var n = this, r = t.rangePieces, i = t.cursors;
    if (r.length != this.rangePieces.length || r.some(function(h, d) {
      return !h.eq(n.rangePieces[d]);
    })) {
      this.selectionLayer.textContent = "";
      var o, a = ut(r);
      try {
        for (a.s(); !(o = a.n()).done; ) {
          var s = o.value;
          this.selectionLayer.appendChild(s.draw());
        }
      } catch (h) {
        a.e(h);
      } finally {
        a.f();
      }
      this.rangePieces = r;
    }
    if (i.length != this.cursors.length || i.some(function(h, d) {
      return !h.eq(n.cursors[d]);
    })) {
      var u = this.cursorLayer.children;
      if (u.length !== i.length) {
        this.cursorLayer.textContent = "";
        var c, l = ut(i);
        try {
          for (l.s(); !(c = l.n()).done; ) {
            var f = c.value;
            this.cursorLayer.appendChild(f.draw());
          }
        } catch (h) {
          l.e(h);
        } finally {
          l.f();
        }
      } else
        i.forEach(function(h, d) {
          return h.adjust(u[d]);
        });
      this.cursors = i;
    }
  } }, { key: "destroy", value: function() {
    this.selectionLayer.remove(), this.cursorLayer.remove();
  } }]), e;
}()), $P = { ".cm-line": { "& ::selection": { backgroundColor: "transparent !important" }, "&::selection": { backgroundColor: "transparent !important" } } };
jP && ($P[".cm-line"].caretColor = "transparent !important");
var dH = Qc.highest(we.theme($P));
function _P(e) {
  var t = e.scrollDOM.getBoundingClientRect();
  return { left: (e.textDirection == Wn.LTR ? t.left : t.right - e.scrollDOM.clientWidth) - e.scrollDOM.scrollLeft, top: t.top - e.scrollDOM.scrollTop };
}
function A4(e, t, n) {
  var r = Ht.cursor(t);
  return { from: Math.max(n.from, e.moveToLineBoundary(r, !1, !0).from), to: Math.min(n.to, e.moveToLineBoundary(r, !0, !0).from), type: Cn.Text };
}
function P4(e, t) {
  var n = e.lineBlockAt(t);
  if (Array.isArray(n.type)) {
    var r, i = ut(n.type);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        if (o.to > t || o.to == t && (o.to == n.to || o.type == Cn.Text))
          return o;
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
  }
  return n;
}
function vH(e, t, n) {
  var r = e.coordsAtPos(t.head, t.assoc || 1);
  if (!r)
    return null;
  var i = _P(e);
  return new SP(r.left - i.left, r.top - i.top, -1, r.bottom - r.top, n ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary");
}
var CP = He.define({ map: function(e, t) {
  return e == null ? null : t.mapPos(e);
} }), Lu = br.define({ create: function() {
  return null;
}, update: function(e, t) {
  return e != null && (e = t.changes.mapPos(e)), t.effects.reduce(function(n, r) {
    return r.is(CP) ? r.value : n;
  }, e);
} }), pH = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.view = t, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n, r = t.state.field(Lu);
    r == null ? this.cursor != null && ((n = this.cursor) === null || n === void 0 || n.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (t.startState.field(Lu) != r || t.docChanged || t.geometryChanged) && this.view.requestMeasure(this.measureReq));
  } }, { key: "readPos", value: function() {
    var t = this.view.state.field(Lu), n = t != null && this.view.coordsAtPos(t);
    if (!n)
      return null;
    var r = this.view.scrollDOM.getBoundingClientRect();
    return { left: n.left - r.left + this.view.scrollDOM.scrollLeft, top: n.top - r.top + this.view.scrollDOM.scrollTop, height: n.bottom - n.top };
  } }, { key: "drawCursor", value: function(t) {
    this.cursor && (t ? (this.cursor.style.left = t.left + "px", this.cursor.style.top = t.top + "px", this.cursor.style.height = t.height + "px") : this.cursor.style.left = "-100000px");
  } }, { key: "destroy", value: function() {
    this.cursor && this.cursor.remove();
  } }, { key: "setDropPos", value: function(t) {
    this.view.state.field(Lu) != t && this.view.dispatch({ effects: CP.of(t) });
  } }]), e;
}(), { eventHandlers: { dragover: function(e) {
  this.setDropPos(this.view.posAtCoords({ x: e.clientX, y: e.clientY }));
}, dragleave: function(e) {
  e.target != this.view.contentDOM && this.view.contentDOM.contains(e.relatedTarget) || this.setDropPos(null);
}, dragend: function() {
  this.setDropPos(null);
}, drop: function() {
  this.setDropPos(null);
} } });
function E4(e, t, n, r, i) {
  t.lastIndex = 0;
  for (var o, a = e.iterRange(n, r), s = n; !a.next().done; s += a.value.length)
    if (!a.lineBreak)
      for (; o = t.exec(a.value); )
        i(s + o.index, s + o.index + o[0].length, o);
}
var mH = function() {
  function e(t) {
    Z(this, e);
    var n = t.regexp, r = t.decoration, i = t.boundary, o = t.maxLength, a = o === void 0 ? 1e3 : o;
    if (!n.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    this.regexp = n, this.getDeco = typeof r == "function" ? r : function() {
      return r;
    }, this.boundary = i, this.maxLength = a;
  }
  return Y(e, [{ key: "createDeco", value: function(t) {
    var n, r = this, i = new Vs(), o = ut(function(c, l) {
      var f = c.visibleRanges;
      if (f.length == 1 && f[0].from == c.viewport.from && f[0].to == c.viewport.to)
        return f;
      var h, d = [], p = ut(f);
      try {
        for (p.s(); !(h = p.n()).done; ) {
          var v = h.value, m = v.from, g = v.to;
          m = Math.max(c.state.doc.lineAt(m).from, m - l), g = Math.min(c.state.doc.lineAt(g).to, g + l), d.length && d[d.length - 1].to >= m ? d[d.length - 1].to = g : d.push({ from: m, to: g });
        }
      } catch (y) {
        p.e(y);
      } finally {
        p.f();
      }
      return d;
    }(t, this.maxLength));
    try {
      for (o.s(); !(n = o.n()).done; ) {
        var a = n.value, s = a.from, u = a.to;
        E4(t.state.doc, this.regexp, s, u, function(c, l, f) {
          return i.add(c, l, r.getDeco(f, t, c));
        });
      }
    } catch (c) {
      o.e(c);
    } finally {
      o.f();
    }
    return i.finish();
  } }, { key: "updateDeco", value: function(t, n) {
    var r = 1e9, i = -1;
    return t.docChanged && t.changes.iterChanges(function(o, a, s, u) {
      u > t.view.viewport.from && s < t.view.viewport.to && (r = Math.min(s, r), i = Math.max(u, i));
    }), t.viewportChanged || i - r > 1e3 ? this.createDeco(t.view) : i > -1 ? this.updateRange(t.view, n.map(t.changes), r, i) : n;
  } }, { key: "updateRange", value: function(t, n, r, i) {
    var o, a = this, s = ut(t.visibleRanges);
    try {
      for (s.s(); !(o = s.n()).done; ) {
        var u = o.value, c = Math.max(u.from, r), l = Math.min(u.to, i);
        l > c && function() {
          var f = t.state.doc.lineAt(c), h = f.to < l ? t.state.doc.lineAt(l) : f, d = Math.max(u.from, f.from), p = Math.min(u.to, h.to);
          if (a.boundary) {
            for (; c > f.from; c--)
              if (a.boundary.test(f.text[c - 1 - f.from])) {
                d = c;
                break;
              }
            for (; l < h.to; l++)
              if (a.boundary.test(h.text[l - h.from])) {
                p = l;
                break;
              }
          }
          var v = [], m = void 0;
          if (f == h)
            for (a.regexp.lastIndex = d - f.from; (m = a.regexp.exec(f.text)) && m.index < p - f.from; ) {
              var g = m.index + f.from;
              v.push(a.getDeco(m, t, g).range(g, g + m[0].length));
            }
          else
            E4(t.state.doc, a.regexp, d, p, function(y, b, k) {
              return v.push(a.getDeco(k, t, y).range(y, b));
            });
          n = n.update({ filterFrom: d, filterTo: p, filter: function(y, b) {
            return y < d || b > p;
          }, add: v });
        }();
      }
    } catch (f) {
      s.e(f);
    } finally {
      s.f();
    }
    return n;
  } }]), e;
}(), Xp = /x/.unicode != null ? "gu" : "g", gH = new RegExp(`[\0-\b
-\x7F-\x9F\xAD\u061C\u200B\u200E\u200F\u2028\u2029\u202D\u202E\uFEFF\uFFF9-\uFFFC]`, Xp), yH = { 0: "null", 7: "bell", 8: "backspace", 10: "newline", 11: "vertical tab", 13: "carriage return", 27: "escape", 8203: "zero width space", 8204: "zero width non-joiner", 8205: "zero width joiner", 8206: "left-to-right mark", 8207: "right-to-left mark", 8232: "line separator", 8237: "left-to-right override", 8238: "right-to-left override", 8233: "paragraph separator", 65279: "zero width no-break space", 65532: "object replacement" }, tv = null, af = be.define({ combine: function(e) {
  var t = ko(e, { render: null, specialChars: gH, addSpecialChars: null });
  return (t.replaceTabs = !function() {
    var n;
    if (tv == null && typeof document < "u" && document.body) {
      var r = document.body.style;
      tv = ((n = r.tabSize) !== null && n !== void 0 ? n : r.MozTabSize) != null;
    }
    return tv || !1;
  }()) && (t.specialChars = new RegExp("	|" + t.specialChars.source, Xp)), t.addSpecialChars && (t.specialChars = new RegExp(t.specialChars.source + "|" + t.addSpecialChars.source, Xp)), t;
} });
function bH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return [af.of(e), kH()];
}
var M4 = null;
function kH() {
  return M4 || (M4 = wr.fromClass(function() {
    function e(t) {
      Z(this, e), this.view = t, this.decorations = $e.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(t.state.facet(af)), this.decorations = this.decorator.createDeco(t);
    }
    return Y(e, [{ key: "makeDecorator", value: function(t) {
      var n = this;
      return new mH({ regexp: t.specialChars, decoration: function(r, i, o) {
        var a = i.state.doc, s = gr(r[0], 0);
        if (s == 9) {
          var u = a.lineAt(o), c = i.state.tabSize, l = Xc(u.text, c, o - u.from);
          return $e.replace({ widget: new xH((c - l % c) * n.view.defaultCharacterWidth) });
        }
        return n.decorationCache[s] || (n.decorationCache[s] = $e.replace({ widget: new wH(t, s) }));
      }, boundary: t.replaceTabs ? void 0 : /[^]/ });
    } }, { key: "update", value: function(t) {
      var n = t.state.facet(af);
      t.startState.facet(af) != n ? (this.decorator = this.makeDecorator(n), this.decorations = this.decorator.createDeco(t.view)) : this.decorations = this.decorator.updateDeco(t, this.decorations);
    } }]), e;
  }(), { decorations: function(e) {
    return e.decorations;
  } }));
}
var wH = function(e) {
  Et(n, ba);
  var t = Mt(n);
  function n(r, i) {
    var o;
    return Z(this, n), (o = t.call(this)).options = r, o.code = i, o;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return r.code == this.code;
  } }, { key: "toDOM", value: function(r) {
    var i = function(u) {
      return u >= 32 ? "\u2022" : u == 10 ? "\u2424" : String.fromCharCode(9216 + u);
    }(this.code), o = r.state.phrase("Control character") + " " + (yH[this.code] || "0x" + this.code.toString(16)), a = this.options.render && this.options.render(this.code, o, i);
    if (a)
      return a;
    var s = document.createElement("span");
    return s.textContent = i, s.title = o, s.setAttribute("aria-label", o), s.className = "cm-specialChar", s;
  } }, { key: "ignoreEvent", value: function() {
    return !1;
  } }]), n;
}(), xH = function(e) {
  Et(n, ba);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).width = r, i;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return r.width == this.width;
  } }, { key: "toDOM", value: function() {
    var r = document.createElement("span");
    return r.textContent = "	", r.className = "cm-tab", r.style.width = this.width + "px", r;
  } }, { key: "ignoreEvent", value: function() {
    return !1;
  } }]), n;
}(), jH = $e.line({ class: "cm-activeLine" }), SH = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.decorations = this.getDeco(t);
  }
  return Y(e, [{ key: "update", value: function(t) {
    (t.docChanged || t.selectionSet) && (this.decorations = this.getDeco(t.view));
  } }, { key: "getDeco", value: function(t) {
    var n, r = -1, i = [], o = ut(t.state.selection.ranges);
    try {
      for (o.s(); !(n = o.n()).done; ) {
        var a = n.value;
        if (!a.empty)
          return $e.none;
        var s = t.lineBlockAt(a.head);
        s.from > r && (i.push(jH.range(s.from)), r = s.from);
      }
    } catch (u) {
      o.e(u);
    } finally {
      o.f();
    }
    return $e.set(i);
  } }]), e;
}(), { decorations: function(e) {
  return e.decorations;
} });
function T4(e, t) {
  var n = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1), r = e.state.doc.lineAt(n), i = n - r.from, o = i > 2e3 ? -1 : i == r.length ? function(a, s) {
    var u = a.coordsAtPos(a.viewport.from);
    return u ? Math.round(Math.abs((u.left - s) / a.defaultCharacterWidth)) : -1;
  }(e, t.clientX) : Xc(r.text, e.state.tabSize, n - r.from);
  return { line: r.number, col: o, off: i };
}
function $H(e, t) {
  var n = T4(e, t), r = e.state.selection;
  return n ? { update: function(i) {
    if (i.docChanged) {
      var o = i.changes.mapPos(i.startState.doc.line(n.line).from), a = i.state.doc.lineAt(o);
      n = { line: a.number, col: n.col, off: Math.min(n.off, a.length) }, r = r.map(i.changes);
    }
  }, get: function(i, o, a) {
    var s = T4(e, i);
    if (!s)
      return r;
    var u = function(c, l, f) {
      var h = Math.min(l.line, f.line), d = Math.max(l.line, f.line), p = [];
      if (l.off > 2e3 || f.off > 2e3 || l.col < 0 || f.col < 0)
        for (var v = Math.min(l.off, f.off), m = Math.max(l.off, f.off), g = h; g <= d; g++) {
          var y = c.doc.line(g);
          y.length <= m && p.push(Ht.range(y.from + v, y.to + m));
        }
      else
        for (var b = Math.min(l.col, f.col), k = Math.max(l.col, f.col), w = h; w <= d; w++) {
          var x = c.doc.line(w), S = Op(x.text, b, c.tabSize, !0);
          if (S > -1) {
            var T = Op(x.text, k, c.tabSize);
            p.push(Ht.range(x.from + S, x.from + T));
          }
        }
      return p;
    }(e.state, n, s);
    return u.length ? a ? Ht.create(u.concat(r.ranges)) : Ht.create(u) : r;
  } } : null;
}
function _H(e) {
  var t = (e == null ? void 0 : e.eventFilter) || function(n) {
    return n.altKey && n.button == 0;
  };
  return we.mouseSelectionStyle.of(function(n, r) {
    return t(r) ? $H(n, r) : null;
  });
}
var CH = { Alt: [18, function(e) {
  return e.altKey;
}], Control: [17, function(e) {
  return e.ctrlKey;
}], Shift: [16, function(e) {
  return e.shiftKey;
}], Meta: [91, function(e) {
  return e.metaKey;
}] }, OH = { style: "cursor: crosshair" };
function AH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = xe(CH[e.key || "Alt"], 2), n = t[0], r = t[1], i = wr.fromClass(function() {
    function o(a) {
      Z(this, o), this.view = a, this.isDown = !1;
    }
    return Y(o, [{ key: "set", value: function(a) {
      this.isDown != a && (this.isDown = a, this.view.update([]));
    } }]), o;
  }(), { eventHandlers: { keydown: function(o) {
    this.set(o.keyCode == n || r(o));
  }, keyup: function(o) {
    o.keyCode != n && r(o) || this.set(!1);
  } } });
  return [i, we.contentAttributes.of(function(o) {
    var a;
    return !((a = o.plugin(i)) === null || a === void 0) && a.isDown ? OH : null;
  })];
}
var OP = function() {
  function e(t, n, r) {
    Z(this, e), this.facet = n, this.createTooltipView = r, this.input = t.state.facet(n), this.tooltips = this.input.filter(function(i) {
      return i;
    }), this.tooltipViews = this.tooltips.map(r);
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n = t.state.facet(this.facet), r = n.filter(function(g) {
      return g;
    });
    if (n === this.input) {
      var i, o = ut(this.tooltipViews);
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var a = i.value;
          a.update && a.update(t);
        }
      } catch (g) {
        o.e(g);
      } finally {
        o.f();
      }
      return !1;
    }
    for (var s = [], u = 0; u < r.length; u++) {
      var c = r[u], l = -1;
      if (c) {
        for (var f = 0; f < this.tooltips.length; f++) {
          var h = this.tooltips[f];
          h && h.create == c.create && (l = f);
        }
        if (l < 0)
          s[u] = this.createTooltipView(c);
        else {
          var d = s[u] = this.tooltipViews[l];
          d.update && d.update(t);
        }
      }
    }
    var p, v = ut(this.tooltipViews);
    try {
      for (v.s(); !(p = v.n()).done; ) {
        var m = p.value;
        s.indexOf(m) < 0 && m.dom.remove();
      }
    } catch (g) {
      v.e(g);
    } finally {
      v.f();
    }
    return this.input = n, this.tooltips = r, this.tooltipViews = s, !0;
  } }]), e;
}();
function PH() {
  return { top: 0, left: 0, bottom: innerHeight, right: innerWidth };
}
var ev = be.define({ combine: function(e) {
  var t, n, r;
  return { position: ye.ios ? "absolute" : ((t = e.find(function(i) {
    return i.position;
  })) === null || t === void 0 ? void 0 : t.position) || "fixed", parent: ((n = e.find(function(i) {
    return i.parent;
  })) === null || n === void 0 ? void 0 : n.parent) || null, tooltipSpace: ((r = e.find(function(i) {
    return i.tooltipSpace;
  })) === null || r === void 0 ? void 0 : r.tooltipSpace) || PH };
} }), AP = wr.fromClass(function() {
  function e(t) {
    var n, r = this;
    Z(this, e), this.view = t, this.inView = !0, this.lastTransaction = 0, this.measureTimeout = -1;
    var i = t.state.facet(ev);
    this.position = i.position, this.parent = i.parent, this.classes = t.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.manager = new OP(t, ld, function(o) {
      return r.createTooltip(o);
    }), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver(function(o) {
      Date.now() > r.lastTransaction - 50 && o.length > 0 && o[o.length - 1].intersectionRatio < 1 && r.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), (n = t.dom.ownerDocument.defaultView) === null || n === void 0 || n.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  return Y(e, [{ key: "createContainer", value: function() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  } }, { key: "observeIntersection", value: function() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      var t, n = ut(this.manager.tooltipViews);
      try {
        for (n.s(); !(t = n.n()).done; ) {
          var r = t.value;
          this.intersectionObserver.observe(r.dom);
        }
      } catch (i) {
        n.e(i);
      } finally {
        n.f();
      }
    }
  } }, { key: "measureSoon", value: function() {
    var t = this;
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(function() {
      t.measureTimeout = -1, t.maybeMeasure();
    }, 50));
  } }, { key: "update", value: function(t) {
    t.transactions.length && (this.lastTransaction = Date.now());
    var n = this.manager.update(t);
    n && this.observeIntersection();
    var r = n || t.geometryChanged, i = t.state.facet(ev);
    if (i.position != this.position) {
      this.position = i.position;
      var o, a = ut(this.manager.tooltipViews);
      try {
        for (a.s(); !(o = a.n()).done; )
          o.value.dom.style.position = this.position;
      } catch (l) {
        a.e(l);
      } finally {
        a.f();
      }
      r = !0;
    }
    if (i.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = i.parent, this.createContainer();
      var s, u = ut(this.manager.tooltipViews);
      try {
        for (u.s(); !(s = u.n()).done; ) {
          var c = s.value;
          this.container.appendChild(c.dom);
        }
      } catch (l) {
        u.e(l);
      } finally {
        u.f();
      }
      r = !0;
    } else
      this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    r && this.maybeMeasure();
  } }, { key: "createTooltip", value: function(t) {
    var n = t.create(this.view);
    if (n.dom.classList.add("cm-tooltip"), t.arrow && !n.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      var r = document.createElement("div");
      r.className = "cm-tooltip-arrow", n.dom.appendChild(r);
    }
    return n.dom.style.position = this.position, n.dom.style.top = "-10000px", this.container.appendChild(n.dom), n.mount && n.mount(this.view), n;
  } }, { key: "destroy", value: function() {
    var t, n;
    (t = this.view.dom.ownerDocument.defaultView) === null || t === void 0 || t.removeEventListener("resize", this.measureSoon);
    var r, i = ut(this.manager.tooltipViews);
    try {
      for (i.s(); !(r = i.n()).done; )
        r.value.dom.remove();
    } catch (o) {
      i.e(o);
    } finally {
      i.f();
    }
    (n = this.intersectionObserver) === null || n === void 0 || n.disconnect(), clearTimeout(this.measureTimeout);
  } }, { key: "readMeasure", value: function() {
    var t = this, n = this.view.dom.getBoundingClientRect();
    return { editor: n, parent: this.parent ? this.container.getBoundingClientRect() : n, pos: this.manager.tooltips.map(function(r, i) {
      var o = t.manager.tooltipViews[i];
      return o.getCoords ? o.getCoords(r.pos) : t.view.coordsAtPos(r.pos);
    }), size: this.manager.tooltipViews.map(function(r) {
      return r.dom.getBoundingClientRect();
    }), space: this.view.state.facet(ev).tooltipSpace(this.view) };
  } }, { key: "writeMeasure", value: function(t) {
    for (var n = t.editor, r = t.space, i = [], o = 0; o < this.manager.tooltips.length; o++) {
      var a = this.manager.tooltips[o], s = this.manager.tooltipViews[o], u = s.dom, c = t.pos[o], l = t.size[o];
      if (!c || c.bottom <= Math.max(n.top, r.top) || c.top >= Math.min(n.bottom, r.bottom) || c.right < Math.max(n.left, r.left) - 0.1 || c.left > Math.min(n.right, r.right) + 0.1)
        u.style.top = "-10000px";
      else {
        var f = a.arrow ? s.dom.querySelector(".cm-tooltip-arrow") : null, h = f ? 7 : 0, d = l.right - l.left, p = l.bottom - l.top, v = s.offset || MH, m = this.view.textDirection == Wn.LTR, g = l.width > r.right - r.left ? m ? r.left : r.right - l.width : m ? Math.min(c.left - (f ? 14 : 0) + v.x, r.right - d) : Math.max(r.left, c.left - d + (f ? 14 : 0) - v.x), y = !!a.above;
        !a.strictSide && (y ? c.top - (l.bottom - l.top) - v.y < r.top : c.bottom + (l.bottom - l.top) + v.y > r.bottom) && y == r.bottom - c.bottom > c.top - r.top && (y = !y);
        var b = y ? c.top - p - h - v.y : c.bottom + h + v.y, k = g + d;
        if (s.overlap !== !0) {
          var w, x = ut(i);
          try {
            for (x.s(); !(w = x.n()).done; ) {
              var S = w.value;
              S.left < k && S.right > g && S.top < b + p && S.bottom > b && (b = y ? S.top - p - 2 - h : S.bottom + h + 2);
            }
          } catch (T) {
            x.e(T);
          } finally {
            x.f();
          }
        }
        this.position == "absolute" ? (u.style.top = b - t.parent.top + "px", u.style.left = g - t.parent.left + "px") : (u.style.top = b + "px", u.style.left = g + "px"), f && (f.style.left = "".concat(c.left + (m ? v.x : -v.x) - (g + 14 - 7), "px")), s.overlap !== !0 && i.push({ left: g, top: b, right: k, bottom: b + p }), u.classList.toggle("cm-tooltip-above", y), u.classList.toggle("cm-tooltip-below", !y), s.positioned && s.positioned();
      }
    }
  } }, { key: "maybeMeasure", value: function() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView))) {
      var t, n = ut(this.manager.tooltipViews);
      try {
        for (n.s(); !(t = n.n()).done; )
          t.value.dom.style.top = "-10000px";
      } catch (r) {
        n.e(r);
      } finally {
        n.f();
      }
    }
  } }]), e;
}(), { eventHandlers: { scroll: function() {
  this.maybeMeasure();
} } }), EH = we.baseTheme({ ".cm-tooltip": { zIndex: 100 }, "&light .cm-tooltip": { border: "1px solid #bbb", backgroundColor: "#f5f5f5" }, "&light .cm-tooltip-section:not(:first-child)": { borderTop: "1px solid #bbb" }, "&dark .cm-tooltip": { backgroundColor: "#333338", color: "white" }, ".cm-tooltip-arrow": { height: "".concat(7, "px"), width: "".concat(14, "px"), position: "absolute", zIndex: -1, overflow: "hidden", "&:before, &:after": { content: "''", position: "absolute", width: 0, height: 0, borderLeft: "".concat(7, "px solid transparent"), borderRight: "".concat(7, "px solid transparent") }, ".cm-tooltip-above &": { bottom: "-".concat(7, "px"), "&:before": { borderTop: "".concat(7, "px solid #bbb") }, "&:after": { borderTop: "".concat(7, "px solid #f5f5f5"), bottom: "1px" } }, ".cm-tooltip-below &": { top: "-".concat(7, "px"), "&:before": { borderBottom: "".concat(7, "px solid #bbb") }, "&:after": { borderBottom: "".concat(7, "px solid #f5f5f5"), top: "1px" } } }, "&dark .cm-tooltip .cm-tooltip-arrow": { "&:before": { borderTopColor: "#333338", borderBottomColor: "#333338" }, "&:after": { borderTopColor: "transparent", borderBottomColor: "transparent" } } }), MH = { x: 0, y: 0 }, ld = be.define({ enables: [AP, EH] }), Uf = be.define(), TH = function() {
  function e(t) {
    var n = this;
    Z(this, e), this.view = t, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new OP(t, Uf, function(r) {
      return n.createHostedView(r);
    });
  }
  return Y(e, [{ key: "createHostedView", value: function(t) {
    var n = t.create(this.view);
    return n.dom.classList.add("cm-tooltip-section"), this.dom.appendChild(n.dom), this.mounted && n.mount && n.mount(this.view), n;
  } }, { key: "mount", value: function(t) {
    var n, r = ut(this.manager.tooltipViews);
    try {
      for (r.s(); !(n = r.n()).done; ) {
        var i = n.value;
        i.mount && i.mount(t);
      }
    } catch (o) {
      r.e(o);
    } finally {
      r.f();
    }
    this.mounted = !0;
  } }, { key: "positioned", value: function() {
    var t, n = ut(this.manager.tooltipViews);
    try {
      for (n.s(); !(t = n.n()).done; ) {
        var r = t.value;
        r.positioned && r.positioned();
      }
    } catch (i) {
      n.e(i);
    } finally {
      n.f();
    }
  } }, { key: "update", value: function(t) {
    this.manager.update(t);
  } }], [{ key: "create", value: function(t) {
    return new e(t);
  } }]), e;
}(), IH = ld.compute([Uf], function(e) {
  var t = e.facet(Uf).filter(function(n) {
    return n;
  });
  return t.length === 0 ? null : { pos: Math.min.apply(Math, Pe(t.map(function(n) {
    return n.pos;
  }))), end: Math.max.apply(Math, Pe(t.filter(function(n) {
    return n.end != null;
  }).map(function(n) {
    return n.end;
  }))), create: TH.create, above: t[0].above, arrow: t.some(function(n) {
    return n.arrow;
  }) };
}), NH = function() {
  function e(t, n, r, i, o) {
    Z(this, e), this.view = t, this.source = n, this.field = r, this.setHover = i, this.hoverTime = o, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: t.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), t.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), t.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  return Y(e, [{ key: "update", value: function() {
    var t = this;
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(function() {
      return t.startHover();
    }, 20));
  } }, { key: "active", get: function() {
    return this.view.state.field(this.field);
  } }, { key: "checkHover", value: function() {
    if (this.hoverTimeout = -1, !this.active) {
      var t = Date.now() - this.lastMove.time;
      t < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - t) : this.startHover();
    }
  } }, { key: "startHover", value: function() {
    var t = this;
    clearTimeout(this.restartTimeout);
    var n = this.lastMove, r = this.view.contentDOM.contains(n.target) ? this.view.posAtCoords(n) : null;
    if (r != null) {
      var i = this.view.coordsAtPos(r);
      if (!(i == null || n.y < i.top || n.y > i.bottom || n.x < i.left - this.view.defaultCharacterWidth || n.x > i.right + this.view.defaultCharacterWidth)) {
        var o = this.view.bidiSpans(this.view.state.doc.lineAt(r)).find(function(c) {
          return c.from <= r && c.to >= r;
        }), a = o && o.dir == Wn.RTL ? -1 : 1, s = this.source(this.view, r, n.x < i.left ? -a : a);
        if (s != null && s.then) {
          var u = this.pending = { pos: r };
          s.then(function(c) {
            t.pending == u && (t.pending = null, c && t.view.dispatch({ effects: t.setHover.of(c) }));
          }, function(c) {
            return ei(t.view.state, c, "hover tooltip");
          });
        } else
          s && this.view.dispatch({ effects: this.setHover.of(s) });
      }
    }
  } }, { key: "mousemove", value: function(t) {
    var n;
    this.lastMove = { x: t.clientX, y: t.clientY, target: t.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    var r = this.active;
    if (r && !function(a) {
      for (var s = a; s; s = s.parentNode)
        if (s.nodeType == 1 && s.classList.contains("cm-tooltip"))
          return !0;
      return !1;
    }(this.lastMove.target) || this.pending) {
      var i = (r || this.pending).pos, o = (n = r == null ? void 0 : r.end) !== null && n !== void 0 ? n : i;
      (i == o ? this.view.posAtCoords(this.lastMove) == i : function(a, s, u, c, l, f) {
        var h = document.createRange(), d = a.domAtPos(s), p = a.domAtPos(u);
        h.setEnd(p.node, p.offset), h.setStart(d.node, d.offset);
        var v = h.getClientRects();
        h.detach();
        for (var m = 0; m < v.length; m++) {
          var g = v[m];
          if (Math.max(g.top - l, l - g.bottom, g.left - c, c - g.right) <= f)
            return !0;
        }
        return !1;
      }(this.view, i, o, t.clientX, t.clientY, 6)) || (this.view.dispatch({ effects: this.setHover.of(null) }), this.pending = null);
    }
  } }, { key: "mouseleave", value: function() {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1, this.active && this.view.dispatch({ effects: this.setHover.of(null) });
  } }, { key: "destroy", value: function() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  } }]), e;
}();
function RH(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = He.define(), r = br.define({ create: function() {
    return null;
  }, update: function(i, o) {
    if (i && (t.hideOnChange && (o.docChanged || o.selection) || t.hideOn && t.hideOn(o, i)))
      return null;
    if (i && o.docChanged) {
      var a = o.changes.mapPos(i.pos, -1, Ir.TrackDel);
      if (a == null)
        return null;
      var s = Object.assign(/* @__PURE__ */ Object.create(null), i);
      s.pos = a, i.end != null && (s.end = o.changes.mapPos(i.end)), i = s;
    }
    var u, c = ut(o.effects);
    try {
      for (c.s(); !(u = c.n()).done; ) {
        var l = u.value;
        l.is(n) && (i = l.value), l.is(LH) && (i = null);
      }
    } catch (f) {
      c.e(f);
    } finally {
      c.f();
    }
    return i;
  }, provide: function(i) {
    return Uf.from(i);
  } });
  return [r, wr.define(function(i) {
    return new NH(i, e, r, n, t.hoverTime || 300);
  }), IH];
}
function DH(e, t) {
  var n = e.plugin(AP);
  if (!n)
    return null;
  var r = n.manager.tooltips.indexOf(t);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
var LH = He.define(), I4 = be.define({ combine: function(e) {
  var t, n, r, i = ut(e);
  try {
    for (i.s(); !(r = i.n()).done; ) {
      var o = r.value;
      t = t || o.topContainer, n = n || o.bottomContainer;
    }
  } catch (a) {
    i.e(a);
  } finally {
    i.f();
  }
  return { topContainer: t, bottomContainer: n };
} });
function gc(e, t) {
  var n = e.plugin(PP), r = n ? n.specs.indexOf(t) : -1;
  return r > -1 ? n.panels[r] : null;
}
var PP = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.input = t.state.facet(yc), this.specs = this.input.filter(function(a) {
      return a;
    }), this.panels = this.specs.map(function(a) {
      return a(t);
    });
    var n = t.state.facet(I4);
    this.top = new Tl(t, !0, n.topContainer), this.bottom = new Tl(t, !1, n.bottomContainer), this.top.sync(this.panels.filter(function(a) {
      return a.top;
    })), this.bottom.sync(this.panels.filter(function(a) {
      return !a.top;
    }));
    var r, i = ut(this.panels);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        o.dom.classList.add("cm-panel"), o.mount && o.mount();
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n = t.state.facet(I4);
    this.top.container != n.topContainer && (this.top.sync([]), this.top = new Tl(t.view, !0, n.topContainer)), this.bottom.container != n.bottomContainer && (this.bottom.sync([]), this.bottom = new Tl(t.view, !1, n.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    var r = t.state.facet(yc);
    if (r != this.input) {
      var i, o = r.filter(function(k) {
        return k;
      }), a = [], s = [], u = [], c = [], l = ut(o);
      try {
        for (l.s(); !(i = l.n()).done; ) {
          var f = i.value, h = this.specs.indexOf(f), d = void 0;
          h < 0 ? (d = f(t.view), c.push(d)) : (d = this.panels[h]).update && d.update(t), a.push(d), (d.top ? s : u).push(d);
        }
      } catch (k) {
        l.e(k);
      } finally {
        l.f();
      }
      this.specs = o, this.panels = a, this.top.sync(s), this.bottom.sync(u);
      for (var p = 0, v = c; p < v.length; p++) {
        var m = v[p];
        m.dom.classList.add("cm-panel"), m.mount && m.mount();
      }
    } else {
      var g, y = ut(this.panels);
      try {
        for (y.s(); !(g = y.n()).done; ) {
          var b = g.value;
          b.update && b.update(t);
        }
      } catch (k) {
        y.e(k);
      } finally {
        y.f();
      }
    }
  } }, { key: "destroy", value: function() {
    this.top.sync([]), this.bottom.sync([]);
  } }]), e;
}(), { provide: function(e) {
  return we.scrollMargins.of(function(t) {
    var n = t.plugin(e);
    return n && { top: n.top.scrollMargin(), bottom: n.bottom.scrollMargin() };
  });
} }), Tl = function() {
  function e(t, n, r) {
    Z(this, e), this.view = t, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  return Y(e, [{ key: "sync", value: function(t) {
    var n, r = ut(this.panels);
    try {
      for (r.s(); !(n = r.n()).done; ) {
        var i = n.value;
        i.destroy && t.indexOf(i) < 0 && i.destroy();
      }
    } catch (o) {
      r.e(o);
    } finally {
      r.f();
    }
    this.panels = t, this.syncDOM();
  } }, { key: "syncDOM", value: function() {
    if (this.panels.length != 0) {
      if (!this.dom) {
        this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
        var t = this.container || this.view.dom;
        t.insertBefore(this.dom, this.top ? t.firstChild : null);
      }
      var n, r = this.dom.firstChild, i = ut(this.panels);
      try {
        for (i.s(); !(n = i.n()).done; ) {
          var o = n.value;
          if (o.dom.parentNode == this.dom) {
            for (; r != o.dom; )
              r = N4(r);
            r = r.nextSibling;
          } else
            this.dom.insertBefore(o.dom, r);
        }
      } catch (a) {
        i.e(a);
      } finally {
        i.f();
      }
      for (; r; )
        r = N4(r);
    } else
      this.dom && (this.dom.remove(), this.dom = void 0);
  } }, { key: "scrollMargin", value: function() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  } }, { key: "syncClasses", value: function() {
    if (this.container && this.classes != this.view.themeClasses) {
      var t, n = ut(this.classes.split(" "));
      try {
        for (n.s(); !(t = n.n()).done; ) {
          var r = t.value;
          r && this.container.classList.remove(r);
        }
      } catch (s) {
        n.e(s);
      } finally {
        n.f();
      }
      var i, o = ut((this.classes = this.view.themeClasses).split(" "));
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var a = i.value;
          a && this.container.classList.add(a);
        }
      } catch (s) {
        o.e(s);
      } finally {
        o.f();
      }
    }
  } }]), e;
}();
function N4(e) {
  var t = e.nextSibling;
  return e.remove(), t;
}
var yc = be.define({ enables: PP }), eo = function(e) {
  Et(n, Ta);
  var t = Mt(n);
  function n() {
    return Z(this, n), t.apply(this, arguments);
  }
  return Y(n, [{ key: "compare", value: function(r) {
    return this == r || this.constructor == r.constructor && this.eq(r);
  } }, { key: "eq", value: function(r) {
    return !1;
  } }, { key: "destroy", value: function(r) {
  } }]), n;
}();
eo.prototype.elementClass = "", eo.prototype.toDOM = void 0, eo.prototype.mapMode = Ir.TrackBefore, eo.prototype.startSide = eo.prototype.endSide = -1, eo.prototype.point = !0;
var sf = be.define(), zH = { class: "", renderEmptyElements: !1, elementStyle: "", markers: function() {
  return Nn.empty;
}, lineMarker: function() {
  return null;
}, lineMarkerChange: null, initialSpacer: null, updateSpacer: null, domEventHandlers: {} }, Qu = be.define();
function EP(e) {
  return [MP(), Qu.of(Object.assign(Object.assign({}, zH), e))];
}
var Zp = be.define({ combine: function(e) {
  return e.some(function(t) {
    return t;
  });
} });
function MP(e) {
  var t = [BH];
  return e && e.fixed === !1 && t.push(Zp.of(!0)), t;
}
var BH = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.view = t, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight + "px", this.gutters = t.state.facet(Qu).map(function(o) {
      return new D4(t, o);
    });
    var n, r = ut(this.gutters);
    try {
      for (r.s(); !(n = r.n()).done; ) {
        var i = n.value;
        this.dom.appendChild(i.dom);
      }
    } catch (o) {
      r.e(o);
    } finally {
      r.f();
    }
    this.fixed = !t.state.facet(Zp), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
  }
  return Y(e, [{ key: "update", value: function(t) {
    if (this.updateGutters(t)) {
      var n = this.prevViewport, r = t.view.viewport, i = Math.min(n.to, r.to) - Math.max(n.from, r.from);
      this.syncGutters(i < 0.8 * (r.to - r.from));
    }
    t.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight + "px"), this.view.state.facet(Zp) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = t.view.viewport;
  } }, { key: "syncGutters", value: function(t) {
    var n = this, r = this.dom.nextSibling;
    t && this.dom.remove();
    var i, o = Nn.iter(this.view.state.facet(sf), this.view.viewport.from), a = [], s = this.gutters.map(function(y) {
      return new FH(y, n.view.viewport, -n.view.documentPadding.top);
    }), u = ut(this.view.viewportLineBlocks);
    try {
      for (u.s(); !(i = u.n()).done; ) {
        var c = i.value, l = void 0;
        if (Array.isArray(c.type)) {
          var f, h = ut(c.type);
          try {
            for (h.s(); !(f = h.n()).done; ) {
              var d = f.value;
              if (d.type == Cn.Text) {
                l = d;
                break;
              }
            }
          } catch (y) {
            h.e(y);
          } finally {
            h.f();
          }
        } else
          l = c.type == Cn.Text ? c : void 0;
        if (l) {
          a.length && (a = []), TP(o, a, c.from);
          var p, v = ut(s);
          try {
            for (v.s(); !(p = v.n()).done; )
              p.value.line(this.view, l, a);
          } catch (y) {
            v.e(y);
          } finally {
            v.f();
          }
        }
      }
    } catch (y) {
      u.e(y);
    } finally {
      u.f();
    }
    var m, g = ut(s);
    try {
      for (g.s(); !(m = g.n()).done; )
        m.value.finish();
    } catch (y) {
      g.e(y);
    } finally {
      g.f();
    }
    t && this.view.scrollDOM.insertBefore(this.dom, r);
  } }, { key: "updateGutters", value: function(t) {
    var n = t.startState.facet(Qu), r = t.state.facet(Qu), i = t.docChanged || t.heightChanged || t.viewportChanged || !Nn.eq(t.startState.facet(sf), t.state.facet(sf), t.view.viewport.from, t.view.viewport.to);
    if (n == r) {
      var o, a = ut(this.gutters);
      try {
        for (a.s(); !(o = a.n()).done; )
          o.value.update(t) && (i = !0);
      } catch (y) {
        a.e(y);
      } finally {
        a.f();
      }
    } else {
      i = !0;
      var s, u = [], c = ut(r);
      try {
        for (c.s(); !(s = c.n()).done; ) {
          var l = s.value, f = n.indexOf(l);
          f < 0 ? u.push(new D4(this.view, l)) : (this.gutters[f].update(t), u.push(this.gutters[f]));
        }
      } catch (y) {
        c.e(y);
      } finally {
        c.f();
      }
      var h, d = ut(this.gutters);
      try {
        for (d.s(); !(h = d.n()).done; ) {
          var p = h.value;
          p.dom.remove(), u.indexOf(p) < 0 && p.destroy();
        }
      } catch (y) {
        d.e(y);
      } finally {
        d.f();
      }
      for (var v = 0, m = u; v < m.length; v++) {
        var g = m[v];
        this.dom.appendChild(g.dom);
      }
      this.gutters = u;
    }
    return i;
  } }, { key: "destroy", value: function() {
    var t, n = ut(this.gutters);
    try {
      for (n.s(); !(t = n.n()).done; )
        t.value.destroy();
    } catch (r) {
      n.e(r);
    } finally {
      n.f();
    }
    this.dom.remove();
  } }]), e;
}(), { provide: function(e) {
  return we.scrollMargins.of(function(t) {
    var n = t.plugin(e);
    return n && n.gutters.length != 0 && n.fixed ? t.textDirection == Wn.LTR ? { left: n.dom.offsetWidth } : { right: n.dom.offsetWidth } : null;
  });
} });
function R4(e) {
  return Array.isArray(e) ? e : [e];
}
function TP(e, t, n) {
  for (; e.value && e.from <= n; )
    e.from == n && t.push(e.value), e.next();
}
var FH = function() {
  function e(t, n, r) {
    Z(this, e), this.gutter = t, this.height = r, this.localMarkers = [], this.i = 0, this.cursor = Nn.iter(t.markers, n.from);
  }
  return Y(e, [{ key: "line", value: function(t, n, r) {
    this.localMarkers.length && (this.localMarkers = []), TP(this.cursor, this.localMarkers, n.from);
    var i = r.length ? this.localMarkers.concat(r) : this.localMarkers, o = this.gutter.config.lineMarker(t, n, i);
    o && i.unshift(o);
    var a = this.gutter;
    if (i.length != 0 || a.config.renderEmptyElements) {
      var s = n.top - this.height;
      if (this.i == a.elements.length) {
        var u = new IP(t, n.height, s, i);
        a.elements.push(u), a.dom.appendChild(u.dom);
      } else
        a.elements[this.i].update(t, n.height, s, i);
      this.height = n.bottom, this.i++;
    }
  } }, { key: "finish", value: function() {
    for (var t = this.gutter; t.elements.length > this.i; ) {
      var n = t.elements.pop();
      t.dom.removeChild(n.dom), n.destroy();
    }
  } }]), e;
}(), D4 = function() {
  function e(t, n) {
    var r = this;
    Z(this, e), this.view = t, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    var i = function(a) {
      r.dom.addEventListener(a, function(s) {
        var u = t.lineBlockAtHeight(s.clientY - t.documentTop);
        n.domEventHandlers[a](t, u, s) && s.preventDefault();
      });
    };
    for (var o in n.domEventHandlers)
      i(o);
    this.markers = R4(n.markers(t)), n.initialSpacer && (this.spacer = new IP(t, 0, 0, [n.initialSpacer(t)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n = this.markers;
    if (this.markers = R4(this.config.markers(t.view)), this.spacer && this.config.updateSpacer) {
      var r = this.config.updateSpacer(this.spacer.markers[0], t);
      r != this.spacer.markers[0] && this.spacer.update(t.view, 0, 0, [r]);
    }
    var i = t.view.viewport;
    return !Nn.eq(this.markers, n, i.from, i.to) || !!this.config.lineMarkerChange && this.config.lineMarkerChange(t);
  } }, { key: "destroy", value: function() {
    var t, n = ut(this.elements);
    try {
      for (n.s(); !(t = n.n()).done; )
        t.value.destroy();
    } catch (r) {
      n.e(r);
    } finally {
      n.f();
    }
  } }]), e;
}(), IP = function() {
  function e(t, n, r, i) {
    Z(this, e), this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(t, n, r, i);
  }
  return Y(e, [{ key: "update", value: function(t, n, r, i) {
    this.height != n && (this.dom.style.height = (this.height = n) + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), function(o, a) {
      if (o.length != a.length)
        return !1;
      for (var s = 0; s < o.length; s++)
        if (!o[s].compare(a[s]))
          return !1;
      return !0;
    }(this.markers, i) || this.setMarkers(t, i);
  } }, { key: "setMarkers", value: function(t, n) {
    for (var r = "cm-gutterElement", i = this.dom.firstChild, o = 0, a = 0; ; ) {
      var s = a, u = o < n.length ? n[o++] : null, c = !1;
      if (u) {
        var l = u.elementClass;
        l && (r += " " + l);
        for (var f = a; f < this.markers.length; f++)
          if (this.markers[f].compare(u)) {
            s = f, c = !0;
            break;
          }
      } else
        s = this.markers.length;
      for (; a < s; ) {
        var h = this.markers[a++];
        if (h.toDOM) {
          h.destroy(i);
          var d = i.nextSibling;
          i.remove(), i = d;
        }
      }
      if (!u)
        break;
      u.toDOM && (c ? i = i.nextSibling : this.dom.insertBefore(u.toDOM(t), i)), c && a++;
    }
    this.dom.className = r, this.markers = n;
  } }, { key: "destroy", value: function() {
    this.setMarkers(null, []);
  } }]), e;
}(), qH = be.define(), $s = be.define({ combine: function(e) {
  return ko(e, { formatNumber: String, domEventHandlers: {} }, { domEventHandlers: function(t, n) {
    var r = Object.assign({}, t), i = function(a) {
      var s = r[a], u = n[a];
      r[a] = s ? function(c, l, f) {
        return s(c, l, f) || u(c, l, f);
      } : u;
    };
    for (var o in n)
      i(o);
    return r;
  } });
} }), nv = function(e) {
  Et(n, eo);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).number = r, i;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return this.number == r.number;
  } }, { key: "toDOM", value: function() {
    return document.createTextNode(this.number);
  } }]), n;
}();
function rv(e, t) {
  return e.state.facet($s).formatNumber(t, e.state);
}
var VH = Qu.compute([$s], function(e) {
  return { class: "cm-lineNumbers", renderEmptyElements: !1, markers: function(t) {
    return t.state.facet(qH);
  }, lineMarker: function(t, n, r) {
    return r.some(function(i) {
      return i.toDOM;
    }) ? null : new nv(rv(t, t.state.doc.lineAt(n.from).number));
  }, lineMarkerChange: function(t) {
    return t.startState.facet($s) != t.state.facet($s);
  }, initialSpacer: function(t) {
    return new nv(rv(t, L4(t.state.doc.lines)));
  }, updateSpacer: function(t, n) {
    var r = rv(n.view, L4(n.view.state.doc.lines));
    return r == t.number ? t : new nv(r);
  }, domEventHandlers: e.facet($s).domEventHandlers };
});
function HH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return [$s.of(e), MP(), VH];
}
function L4(e) {
  for (var t = 9; t < e; )
    t = 10 * t + 9;
  return t;
}
var WH = new (function(e) {
  Et(n, eo);
  var t = Mt(n);
  function n() {
    var r;
    return Z(this, n), (r = t.apply(this, arguments)).elementClass = "cm-activeLineGutter", r;
  }
  return Y(n);
}())(), UH = sf.compute(["selection"], function(e) {
  var t, n = [], r = -1, i = ut(e.selection.ranges);
  try {
    for (i.s(); !(t = i.n()).done; ) {
      var o = t.value;
      if (o.empty) {
        var a = e.doc.lineAt(o.head).from;
        a > r && (r = a, n.push(WH.range(a)));
      }
    }
  } catch (s) {
    i.e(s);
  } finally {
    i.f();
  }
  return Nn.of(n);
}), JH = 0, iv = Y(function e(t, n) {
  Z(this, e), this.from = t, this.to = n;
}), bn = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Z(this, e), this.id = JH++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function() {
      throw new Error("This node type doesn't define a deserialize function");
    };
  }
  return Y(e, [{ key: "add", value: function(t) {
    var n = this;
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = po.match(t)), function(r) {
      var i = t(r);
      return i === void 0 ? null : [n, i];
    };
  } }]), e;
}();
bn.closedBy = new bn({ deserialize: function(e) {
  return e.split(" ");
} }), bn.openedBy = new bn({ deserialize: function(e) {
  return e.split(" ");
} }), bn.group = new bn({ deserialize: function(e) {
  return e.split(" ");
} }), bn.contextHash = new bn({ perNode: !0 }), bn.lookAhead = new bn({ perNode: !0 }), bn.mounted = new bn({ perNode: !0 });
var KH = /* @__PURE__ */ Object.create(null), po = function() {
  function e(t, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    Z(this, e), this.name = t, this.props = n, this.id = r, this.flags = i;
  }
  return Y(e, [{ key: "prop", value: function(t) {
    return this.props[t.id];
  } }, { key: "isTop", get: function() {
    return (1 & this.flags) > 0;
  } }, { key: "isSkipped", get: function() {
    return (2 & this.flags) > 0;
  } }, { key: "isError", get: function() {
    return (4 & this.flags) > 0;
  } }, { key: "isAnonymous", get: function() {
    return (8 & this.flags) > 0;
  } }, { key: "is", value: function(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      var n = this.prop(bn.group);
      return !!n && n.indexOf(t) > -1;
    }
    return this.id == t;
  } }], [{ key: "define", value: function(t) {
    var n = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : KH, r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new e(t.name || "", n, t.id, r);
    if (t.props) {
      var o, a = ut(t.props);
      try {
        for (a.s(); !(o = a.n()).done; ) {
          var s = o.value;
          if (Array.isArray(s) || (s = s(i)), s) {
            if (s[0].perNode)
              throw new RangeError("Can't store a per-node prop on a node type");
            n[s[0].id] = s[1];
          }
        }
      } catch (u) {
        a.e(u);
      } finally {
        a.f();
      }
    }
    return i;
  } }, { key: "match", value: function(t) {
    var n = /* @__PURE__ */ Object.create(null);
    for (var r in t) {
      var i, o = ut(r.split(" "));
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var a = i.value;
          n[a] = t[r];
        }
      } catch (s) {
        o.e(s);
      } finally {
        o.f();
      }
    }
    return function(s) {
      for (var u = s.prop(bn.group), c = -1; c < (u ? u.length : 0); c++) {
        var l = n[c < 0 ? s.name : u[c]];
        if (l)
          return l;
      }
    };
  } }]), e;
}();
po.none = new po("", /* @__PURE__ */ Object.create(null), 0, 8);
var Sr, Il = /* @__PURE__ */ new WeakMap(), z4 = /* @__PURE__ */ new WeakMap();
(function(e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Sr || (Sr = {}));
var Zr = function() {
  function e(t, n, r, i, o) {
    if (Z(this, e), this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      var a, s = ut(o);
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var u = xe(a.value, 2), c = u[0], l = u[1];
          this.props[typeof c == "number" ? c : c.id] = l;
        }
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
    }
  }
  return Y(e, [{ key: "toString", value: function() {
    var t = this.prop(bn.mounted);
    if (t && !t.overlay)
      return t.tree.toString();
    var n, r = "", i = ut(this.children);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value.toString();
        o && (r && (r += ","), r += o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (r.length ? "(" + r + ")" : "") : r;
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Gf(this.topNode, t);
  } }, { key: "cursorAt", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Il.get(this) || this.topNode, i = new Gf(r);
    return i.moveTo(t, n), Il.set(this, i._tree), i;
  } }, { key: "topNode", get: function() {
    return new bc(this, 0, 0, null);
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Ws(Il.get(this) || this.topNode, t, n, !1);
    return Il.set(this, r), r;
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Ws(z4.get(this) || this.topNode, t, n, !0);
    return z4.set(this, r), r;
  } }, { key: "iterate", value: function(t) {
    for (var n = t.enter, r = t.leave, i = t.from, o = i === void 0 ? 0 : i, a = t.to, s = a === void 0 ? this.length : a, u = this.cursor((t.mode || 0) | Sr.IncludeAnonymous); ; ) {
      var c = !1;
      if (u.from <= s && u.to >= o && (u.type.isAnonymous || n(u) !== !1)) {
        if (u.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && !u.type.isAnonymous && r(u), !u.nextSibling(); ) {
        if (!u.parent())
          return;
        c = !0;
      }
    }
  } }, { key: "prop", value: function(t) {
    return t.perNode ? this.props ? this.props[t.id] : void 0 : this.type.prop(t);
  } }, { key: "propValues", get: function() {
    var t = [];
    if (this.props)
      for (var n in this.props)
        t.push([+n, this.props[n]]);
    return t;
  } }, { key: "balance", value: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.children.length <= 8 ? this : m0(po.none, this.children, this.positions, 0, this.children.length, 0, this.length, function(r, i, o) {
      return new e(t.type, r, i, o, t.propValues);
    }, n.makeTree || function(r, i, o) {
      return new e(po.none, r, i, o);
    });
  } }], [{ key: "build", value: function(t) {
    return XH(t);
  } }]), e;
}();
Zr.empty = new Zr(po.none, [], [], 0);
var GH = function() {
  function e(t, n) {
    Z(this, e), this.buffer = t, this.index = n;
  }
  return Y(e, [{ key: "id", get: function() {
    return this.buffer[this.index - 4];
  } }, { key: "start", get: function() {
    return this.buffer[this.index - 3];
  } }, { key: "end", get: function() {
    return this.buffer[this.index - 2];
  } }, { key: "size", get: function() {
    return this.buffer[this.index - 1];
  } }, { key: "pos", get: function() {
    return this.index;
  } }, { key: "next", value: function() {
    this.index -= 4;
  } }, { key: "fork", value: function() {
    return new e(this.buffer, this.index);
  } }]), e;
}(), Zc = function() {
  function e(t, n, r) {
    Z(this, e), this.buffer = t, this.length = n, this.set = r;
  }
  return Y(e, [{ key: "type", get: function() {
    return po.none;
  } }, { key: "toString", value: function() {
    for (var t = [], n = 0; n < this.buffer.length; )
      t.push(this.childString(n)), n = this.buffer[n + 3];
    return t.join(",");
  } }, { key: "childString", value: function(t) {
    var n = this.buffer[t], r = this.buffer[t + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), r == (t += 4))
      return o;
    for (var a = []; t < r; )
      a.push(this.childString(t)), t = this.buffer[t + 3];
    return o + "(" + a.join(",") + ")";
  } }, { key: "findChild", value: function(t, n, r, i, o) {
    for (var a = this.buffer, s = -1, u = t; u != n && !(NP(o, i, a[u + 1], a[u + 2]) && (s = u, r > 0)); u = a[u + 3])
      ;
    return s;
  } }, { key: "slice", value: function(t, n, r, i) {
    for (var o = this.buffer, a = new Uint16Array(n - t), s = t, u = 0; s < n; )
      a[u++] = o[s++], a[u++] = o[s++] - r, a[u++] = o[s++] - r, a[u++] = o[s++] - t;
    return new e(a, i - r, this.set);
  } }]), e;
}();
function NP(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function RP(e, t) {
  for (var n = e.childBefore(t); n; ) {
    var r = n.lastChild;
    if (!r || r.to != n.to)
      break;
    r.type.isError && r.from == r.to ? (e = n, n = r.prevSibling) : n = r;
  }
  return e;
}
function Ws(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t); ) {
    var o = !r && e instanceof bc && e.index < 0 ? null : e.parent;
    if (!o)
      return e;
    e = o;
  }
  var a = r ? 0 : Sr.IgnoreOverlays;
  if (r)
    for (var s = e, u = s.parent; u; u = (s = u).parent)
      s instanceof bc && s.index < 0 && ((i = u.enter(t, n, a)) === null || i === void 0 ? void 0 : i.from) != s.from && (e = u);
  for (; ; ) {
    var c = e.enter(t, n, a);
    if (!c)
      return e;
    e = c;
  }
}
var bc = function() {
  function e(t, n, r, i) {
    Z(this, e), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  return Y(e, [{ key: "type", get: function() {
    return this._tree.type;
  } }, { key: "name", get: function() {
    return this._tree.type.name;
  } }, { key: "to", get: function() {
    return this.from + this._tree.length;
  } }, { key: "nextChild", value: function(t, n, r, i) {
    for (var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, a = this; ; ) {
      for (var s = a._tree, u = s.children, c = s.positions, l = n > 0 ? u.length : -1; t != l; t += n) {
        var f = u[t], h = c[t] + a.from;
        if (NP(i, r, h, h + f.length)) {
          if (f instanceof Zc) {
            if (o & Sr.ExcludeBuffers)
              continue;
            var d = f.findChild(0, f.buffer.length, n, r - h, i);
            if (d > -1)
              return new Yp(new QH(a, f, t, h), null, d);
          } else if (o & Sr.IncludeAnonymous || !f.type.isAnonymous || p0(f)) {
            var p = void 0;
            if (!(o & Sr.IgnoreMounts) && f.props && (p = f.prop(bn.mounted)) && !p.overlay)
              return new e(p.tree, h, t, a);
            var v = new e(f, h, t, a);
            return o & Sr.IncludeAnonymous || !v.type.isAnonymous ? v : v.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (o & Sr.IncludeAnonymous || !a.type.isAnonymous || (t = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)))
        return null;
    }
  } }, { key: "firstChild", get: function() {
    return this.nextChild(0, 1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.nextChild(0, 1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.nextChild(this._tree.children.length - 1, -1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!(i & Sr.IgnoreOverlays) && (r = this._tree.prop(bn.mounted)) && r.overlay) {
      var o, a = t - this.from, s = ut(r.overlay);
      try {
        for (s.s(); !(o = s.n()).done; ) {
          var u = o.value, c = u.from, l = u.to;
          if ((n > 0 ? c <= a : c < a) && (n < 0 ? l >= a : l > a))
            return new e(r.tree, r.overlay[0].from + this.from, -1, this);
        }
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
    }
    return this.nextChild(0, 1, t, n, i);
  } }, { key: "nextSignificantParent", value: function() {
    for (var t = this; t.type.isAnonymous && t._parent; )
      t = t._parent;
    return t;
  } }, { key: "parent", get: function() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  } }, { key: "nextSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
  } }, { key: "prevSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Gf(this, t);
  } }, { key: "tree", get: function() {
    return this._tree;
  } }, { key: "toTree", value: function() {
    return this._tree;
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Ws(this, t, n, !1);
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Ws(this, t, n, !0);
  } }, { key: "enterUnfinishedNodesBefore", value: function(t) {
    return RP(this, t);
  } }, { key: "getChild", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, i = Jf(this, t, n, r);
    return i.length ? i[0] : null;
  } }, { key: "getChildren", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Jf(this, t, n, r);
  } }, { key: "toString", value: function() {
    return this._tree.toString();
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "matchContext", value: function(t) {
    return Kf(this, t);
  } }]), e;
}();
function Jf(e, t, n, r) {
  var i = e.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (; !i.type.is(n); )
      if (!i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function Kf(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
var QH = Y(function e(t, n, r, i) {
  Z(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = i;
}), Yp = function() {
  function e(t, n, r) {
    Z(this, e), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
  }
  return Y(e, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "from", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  } }, { key: "to", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  } }, { key: "child", value: function(t, n, r) {
    var i = this.context.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
    return o < 0 ? null : new e(this.context, this, o);
  } }, { key: "firstChild", get: function() {
    return this.child(1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.child(-1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.child(1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.child(-1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (r & Sr.ExcludeBuffers)
      return null;
    var i = this.context.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
    return o < 0 ? null : new e(this.context, this, o);
  } }, { key: "parent", get: function() {
    return this._parent || this.context.parent.nextSignificantParent();
  } }, { key: "externalSibling", value: function(t) {
    return this._parent ? null : this.context.parent.nextChild(this.context.index + t, t, 0, 4);
  } }, { key: "nextSibling", get: function() {
    var t = this.context.buffer, n = t.buffer[this.index + 3];
    return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
  } }, { key: "prevSibling", get: function() {
    var t = this.context.buffer, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Gf(this, t);
  } }, { key: "tree", get: function() {
    return null;
  } }, { key: "toTree", value: function() {
    var t = [], n = [], r = this.context.buffer, i = this.index + 4, o = r.buffer[this.index + 3];
    if (o > i) {
      var a = r.buffer[this.index + 1], s = r.buffer[this.index + 2];
      t.push(r.slice(i, o, a, s)), n.push(0);
    }
    return new Zr(this.type, t, n, this.to - this.from);
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Ws(this, t, n, !1);
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Ws(this, t, n, !0);
  } }, { key: "enterUnfinishedNodesBefore", value: function(t) {
    return RP(this, t);
  } }, { key: "toString", value: function() {
    return this.context.buffer.childString(this.index);
  } }, { key: "getChild", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, i = Jf(this, t, n, r);
    return i.length ? i[0] : null;
  } }, { key: "getChildren", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Jf(this, t, n, r);
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "matchContext", value: function(t) {
    return Kf(this, t);
  } }]), e;
}(), Gf = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (Z(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof bc)
      this.yieldNode(t);
    else {
      this._tree = t.context.parent, this.buffer = t.context;
      for (var r = t._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = t, this.yieldBuf(t.index);
    }
  }
  return Y(e, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "yieldNode", value: function(t) {
    return !!t && (this._tree = t, this.type = t.type, this.from = t.from, this.to = t.to, !0);
  } }, { key: "yieldBuf", value: function(t, n) {
    this.index = t;
    var r = this.buffer, i = r.start, o = r.buffer;
    return this.type = n || o.set.types[o.buffer[t]], this.from = i + o.buffer[t + 1], this.to = i + o.buffer[t + 2], !0;
  } }, { key: "yield", value: function(t) {
    return !!t && (t instanceof bc ? (this.buffer = null, this.yieldNode(t)) : (this.buffer = t.context, this.yieldBuf(t.index, t.type)));
  } }, { key: "toString", value: function() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  } }, { key: "enterChild", value: function(t, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(t < 0 ? this._tree._tree.children.length - 1 : 0, t, n, r, this.mode));
    var i = this.buffer.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.buffer.start, r);
    return !(o < 0) && (this.stack.push(this.index), this.yieldBuf(o));
  } }, { key: "firstChild", value: function() {
    return this.enterChild(1, 0, 4);
  } }, { key: "lastChild", value: function() {
    return this.enterChild(-1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.enterChild(1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.enterChild(-1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.mode;
    return this.buffer ? !(r & Sr.ExcludeBuffers) && this.enterChild(1, t, n) : this.yield(this._tree.enter(t, n, r));
  } }, { key: "parent", value: function() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Sr.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    var t = this.mode & Sr.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(t);
  } }, { key: "sibling", value: function(t) {
    if (!this.buffer)
      return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + t, t, 0, 4, this.mode));
    var n = this.buffer.buffer, r = this.stack.length - 1;
    if (t < 0) {
      var i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(i, this.index, -1, 0, 4));
    } else {
      var o = n.buffer[this.index + 3];
      if (o < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(o);
    }
    return r < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + t, t, 0, 4, this.mode));
  } }, { key: "nextSibling", value: function() {
    return this.sibling(1);
  } }, { key: "prevSibling", value: function() {
    return this.sibling(-1);
  } }, { key: "atLastNode", value: function(t) {
    var n, r, i = this.buffer;
    if (i) {
      if (t > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (var o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      n = i.index, r = i.parent;
    } else {
      var a = this._tree;
      n = a.index, r = a._parent;
    }
    for (; r; n = (s = r).index, r = s._parent, s) {
      var s;
      if (n > -1)
        for (var u = n + t, c = t < 0 ? -1 : r._tree.children.length; u != c; u += t) {
          var l = r._tree.children[u];
          if (this.mode & Sr.IncludeAnonymous || l instanceof Zc || !l.type.isAnonymous || p0(l))
            return !1;
        }
    }
    return !0;
  } }, { key: "move", value: function(t, n) {
    if (n && this.enterChild(t, 0, 4))
      return !0;
    for (; ; ) {
      if (this.sibling(t))
        return !0;
      if (this.atLastNode(t) || !this.parent())
        return !1;
    }
  } }, { key: "next", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(1, t);
  } }, { key: "prev", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(-1, t);
  } }, { key: "moveTo", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0; (this.from == this.to || (n < 1 ? this.from >= t : this.from > t) || (n > -1 ? this.to <= t : this.to < t)) && this.parent(); )
      ;
    for (; this.enterChild(1, t, n); )
      ;
    return this;
  } }, { key: "node", get: function() {
    if (!this.buffer)
      return this._tree;
    var t = this.bufferNode, n = null, r = 0;
    if (t && t.context == this.buffer)
      t:
        for (var i = this.index, o = this.stack.length; o >= 0; ) {
          for (var a = t; a; a = a._parent)
            if (a.index == i) {
              if (i == this.index)
                return a;
              n = a, r = o + 1;
              break t;
            }
          i = this.stack[--o];
        }
    for (var s = r; s < this.stack.length; s++)
      n = new Yp(this.buffer, n, this.stack[s]);
    return this.bufferNode = new Yp(this.buffer, n, this.index);
  } }, { key: "tree", get: function() {
    return this.buffer ? null : this._tree._tree;
  } }, { key: "iterate", value: function(t, n) {
    for (var r = 0; ; ) {
      var i = !1;
      if (this.type.isAnonymous || t(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && n && n(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, i = !0;
      }
    }
  } }, { key: "matchContext", value: function(t) {
    if (!this.buffer)
      return Kf(this.node, t);
    for (var n = this.buffer.buffer, r = n.set.types, i = t.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return Kf(this.node, t, i);
      var a = r[n.buffer[this.stack[o]]];
      if (!a.isAnonymous) {
        if (t[i] && t[i] != a.name)
          return !1;
        i--;
      }
    }
    return !0;
  } }]), e;
}();
function p0(e) {
  return e.children.some(function(t) {
    return t instanceof Zc || !t.type.isAnonymous || p0(t);
  });
}
function XH(e) {
  var t, n = e.buffer, r = e.nodeSet, i = e.maxBufferLength, o = i === void 0 ? 1024 : i, a = e.reused, s = a === void 0 ? [] : a, u = e.minRepeatType, c = u === void 0 ? r.types.length : u, l = Array.isArray(n) ? new GH(n, n.length) : n, f = r.types, h = 0, d = 0;
  function p(w, x, S, T, P) {
    for (var O = l.id, j = l.start, V = l.end, E = l.size, C = d; E < 0; ) {
      if (l.next(), E == -1) {
        var H = s[O];
        return S.push(H), void T.push(j - w);
      }
      if (E == -3)
        return void (h = O);
      if (E == -4)
        return void (d = O);
      throw new RangeError("Unrecognized record size: ".concat(E));
    }
    var X, F, G = f[O], M = j - w;
    if (V - j <= o && (F = function(kt, I) {
      var R = l.fork(), it = 0, N = 0, K = 0, z = R.end - o, at = { size: 0, start: 0, skip: 0 };
      t:
        for (var yt = R.pos - kt; R.pos > yt; ) {
          var jt = R.size;
          if (R.id == I && jt >= 0)
            at.size = it, at.start = N, at.skip = K, K += 4, it += 4, R.next();
          else {
            var Ft = R.pos - jt;
            if (jt < 0 || Ft < yt || R.start < z)
              break;
            var zt = R.id >= c ? 4 : 0, St = R.start;
            for (R.next(); R.pos > Ft; ) {
              if (R.size < 0) {
                if (R.size != -3)
                  break t;
                zt += 4;
              } else
                R.id >= c && (zt += 4);
              R.next();
            }
            N = St, it += jt, K += zt;
          }
        }
      return (I < 0 || it == kt) && (at.size = it, at.start = N, at.skip = K), at.size > 4 ? at : void 0;
    }(l.pos - x, P))) {
      for (var $ = new Uint16Array(F.size - F.skip), q = l.pos - F.size, B = $.length; l.pos > q; )
        B = g(F.start, $, B);
      X = new Zc($, V - F.start, r), M = F.start - w;
    } else {
      var D = l.pos - E;
      l.next();
      for (var _ = [], L = [], J = O >= c ? O : -1, st = 0, ht = V; l.pos > D; )
        J >= 0 && l.id == J && l.size >= 0 ? (l.end <= ht - o && (v(_, L, j, st, l.end, ht, J, C), st = _.length, ht = l.end), l.next()) : p(j, D, _, L, J);
      if (J >= 0 && st > 0 && st < _.length && v(_, L, j, st, j, ht, J, C), _.reverse(), L.reverse(), J > -1 && st > 0) {
        var xt = function(kt) {
          return function(I, R, it) {
            var N, K, z = 0, at = I.length - 1;
            if (at >= 0 && (N = I[at]) instanceof Zr) {
              if (!at && N.type == kt && N.length == it)
                return N;
              (K = N.prop(bn.lookAhead)) && (z = R[at] + N.length + K);
            }
            return m(kt, I, R, it, z);
          };
        }(G);
        X = m0(G, _, L, 0, _.length, 0, V - j, xt, xt);
      } else
        X = m(G, _, L, V - j, C - V);
    }
    S.push(X), T.push(M);
  }
  function v(w, x, S, T, P, O, j, V) {
    for (var E = [], C = []; w.length > T; )
      E.push(w.pop()), C.push(x.pop() + S - P);
    w.push(m(r.types[j], E, C, O - P, V - O)), x.push(P - S);
  }
  function m(w, x, S, T) {
    var P = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, O = arguments.length > 5 ? arguments[5] : void 0;
    if (h) {
      var j = [bn.contextHash, h];
      O = O ? [j].concat(O) : [j];
    }
    if (P > 25) {
      var V = [bn.lookAhead, P];
      O = O ? [V].concat(O) : [V];
    }
    return new Zr(w, x, S, T, O);
  }
  function g(w, x, S) {
    var T = l.id, P = l.start, O = l.end, j = l.size;
    if (l.next(), j >= 0 && T < c) {
      var V = S;
      if (j > 4)
        for (var E = l.pos - (j - 4); l.pos > E; )
          S = g(w, x, S);
      x[--S] = V, x[--S] = O - w, x[--S] = P - w, x[--S] = T;
    } else
      j == -3 ? h = T : j == -4 && (d = T);
    return S;
  }
  for (var y = [], b = []; l.pos > 0; )
    p(e.start || 0, e.bufferStart || 0, y, b, -1);
  var k = (t = e.length) !== null && t !== void 0 ? t : y.length ? b[0] + y[0].length : 0;
  return new Zr(f[e.topID], y.reverse(), b.reverse(), k);
}
var B4 = /* @__PURE__ */ new WeakMap();
function uf(e, t) {
  if (!e.isAnonymous || t instanceof Zc || t.type != e)
    return 1;
  var n = B4.get(t);
  if (n == null) {
    n = 1;
    var r, i = ut(t.children);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        if (o.type != e || !(o instanceof Zr)) {
          n = 1;
          break;
        }
        n += uf(e, o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    B4.set(t, n);
  }
  return n;
}
function m0(e, t, n, r, i, o, a, s, u) {
  for (var c = 0, l = r; l < i; l++)
    c += uf(e, t[l]);
  var f = Math.ceil(1.5 * c / 8), h = [], d = [];
  return function p(v, m, g, y, b) {
    for (var k = g; k < y; ) {
      var w = k, x = m[k], S = uf(e, v[k]);
      for (k++; k < y; k++) {
        var T = uf(e, v[k]);
        if (S + T >= f)
          break;
        S += T;
      }
      if (k == w + 1) {
        if (S > f) {
          var P = v[w];
          p(P.children, P.positions, 0, P.children.length, m[w] + b);
          continue;
        }
        h.push(v[w]);
      } else {
        var O = m[k - 1] + v[k - 1].length - x;
        h.push(m0(e, v, m, w, k, x, O, null, u));
      }
      d.push(x + b - o);
    }
  }(t, n, r, i, 0), (s || u)(h, d, a);
}
var cf = function() {
  function e(t, n, r, i) {
    var o = arguments.length > 4 && arguments[4] !== void 0 && arguments[4], a = arguments.length > 5 && arguments[5] !== void 0 && arguments[5];
    Z(this, e), this.from = t, this.to = n, this.tree = r, this.offset = i, this.open = (o ? 1 : 0) | (a ? 2 : 0);
  }
  return Y(e, [{ key: "openStart", get: function() {
    return (1 & this.open) > 0;
  } }, { key: "openEnd", get: function() {
    return (2 & this.open) > 0;
  } }], [{ key: "addTree", value: function(t) {
    var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], o = [new e(0, t.length, t, 0, !1, i)], a = ut(r);
    try {
      for (a.s(); !(n = a.n()).done; ) {
        var s = n.value;
        s.to > t.length && o.push(s);
      }
    } catch (u) {
      a.e(u);
    } finally {
      a.f();
    }
    return o;
  } }, { key: "applyChanges", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 128;
    if (!n.length)
      return t;
    for (var i = [], o = 1, a = t.length ? t[0] : null, s = 0, u = 0, c = 0; ; s++) {
      var l = s < n.length ? n[s] : null, f = l ? l.fromA : 1e9;
      if (f - u >= r)
        for (; a && a.from < f; ) {
          var h = a;
          if (u >= h.from || f <= h.to || c) {
            var d = Math.max(h.from, u) - c, p = Math.min(h.to, f) - c;
            h = d >= p ? null : new e(d, p, h.tree, h.offset + c, s > 0, !!l);
          }
          if (h && i.push(h), a.to > f)
            break;
          a = o < t.length ? t[o++] : null;
        }
      if (!l)
        break;
      u = l.toA, c = l.toA - l.toB;
    }
    return i;
  } }]), e;
}(), ZH = function() {
  function e() {
    Z(this, e);
  }
  return Y(e, [{ key: "startParse", value: function(t, n, r) {
    return typeof t == "string" && (t = new YH(t)), r = r ? r.length ? r.map(function(i) {
      return new iv(i.from, i.to);
    }) : [new iv(0, 0)] : [new iv(0, t.length)], this.createParse(t, n || [], r);
  } }, { key: "parse", value: function(t, n, r) {
    for (var i = this.startParse(t, n, r); ; ) {
      var o = i.advance();
      if (o)
        return o;
    }
  } }]), e;
}(), YH = function() {
  function e(t) {
    Z(this, e), this.string = t;
  }
  return Y(e, [{ key: "length", get: function() {
    return this.string.length;
  } }, { key: "chunk", value: function(t) {
    return this.string.slice(t);
  } }, { key: "lineChunks", get: function() {
    return !1;
  } }, { key: "read", value: function(t, n) {
    return this.string.slice(t, n);
  } }]), e;
}();
new bn({ perNode: !0 });
var tW = 0, Hn = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Z(this, e), this.id = tW++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function() {
      throw new Error("This node type doesn't define a deserialize function");
    };
  }
  return Y(e, [{ key: "add", value: function(t) {
    var n = this;
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = Wa.match(t)), function(r) {
      var i = t(r);
      return i === void 0 ? null : [n, i];
    };
  } }]), e;
}();
Hn.closedBy = new Hn({ deserialize: function(e) {
  return e.split(" ");
} }), Hn.openedBy = new Hn({ deserialize: function(e) {
  return e.split(" ");
} }), Hn.group = new Hn({ deserialize: function(e) {
  return e.split(" ");
} }), Hn.contextHash = new Hn({ perNode: !0 }), Hn.lookAhead = new Hn({ perNode: !0 }), Hn.mounted = new Hn({ perNode: !0 });
var eW = /* @__PURE__ */ Object.create(null), Wa = function() {
  function e(t, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    Z(this, e), this.name = t, this.props = n, this.id = r, this.flags = i;
  }
  return Y(e, [{ key: "prop", value: function(t) {
    return this.props[t.id];
  } }, { key: "isTop", get: function() {
    return (1 & this.flags) > 0;
  } }, { key: "isSkipped", get: function() {
    return (2 & this.flags) > 0;
  } }, { key: "isError", get: function() {
    return (4 & this.flags) > 0;
  } }, { key: "isAnonymous", get: function() {
    return (8 & this.flags) > 0;
  } }, { key: "is", value: function(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      var n = this.prop(Hn.group);
      return !!n && n.indexOf(t) > -1;
    }
    return this.id == t;
  } }], [{ key: "define", value: function(t) {
    var n = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : eW, r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new e(t.name || "", n, t.id, r);
    if (t.props) {
      var o, a = ut(t.props);
      try {
        for (a.s(); !(o = a.n()).done; ) {
          var s = o.value;
          if (Array.isArray(s) || (s = s(i)), s) {
            if (s[0].perNode)
              throw new RangeError("Can't store a per-node prop on a node type");
            n[s[0].id] = s[1];
          }
        }
      } catch (u) {
        a.e(u);
      } finally {
        a.f();
      }
    }
    return i;
  } }, { key: "match", value: function(t) {
    var n = /* @__PURE__ */ Object.create(null);
    for (var r in t) {
      var i, o = ut(r.split(" "));
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var a = i.value;
          n[a] = t[r];
        }
      } catch (s) {
        o.e(s);
      } finally {
        o.f();
      }
    }
    return function(s) {
      for (var u = s.prop(Hn.group), c = -1; c < (u ? u.length : 0); c++) {
        var l = n[c < 0 ? s.name : u[c]];
        if (l)
          return l;
      }
    };
  } }]), e;
}();
Wa.none = new Wa("", /* @__PURE__ */ Object.create(null), 0, 8);
var Mr, Nl = /* @__PURE__ */ new WeakMap(), F4 = /* @__PURE__ */ new WeakMap();
(function(e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Mr || (Mr = {}));
var La = function() {
  function e(t, n, r, i, o) {
    if (Z(this, e), this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      var a, s = ut(o);
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var u = xe(a.value, 2), c = u[0], l = u[1];
          this.props[typeof c == "number" ? c : c.id] = l;
        }
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
    }
  }
  return Y(e, [{ key: "toString", value: function() {
    var t = this.prop(Hn.mounted);
    if (t && !t.overlay)
      return t.tree.toString();
    var n, r = "", i = ut(this.children);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value.toString();
        o && (r && (r += ","), r += o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (r.length ? "(" + r + ")" : "") : r;
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Zf(this.topNode, t);
  } }, { key: "cursorAt", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Nl.get(this) || this.topNode, i = new Zf(r);
    return i.moveTo(t, n), Nl.set(this, i._tree), i;
  } }, { key: "topNode", get: function() {
    return new kc(this, 0, 0, null);
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Us(Nl.get(this) || this.topNode, t, n, !1);
    return Nl.set(this, r), r;
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Us(F4.get(this) || this.topNode, t, n, !0);
    return F4.set(this, r), r;
  } }, { key: "iterate", value: function(t) {
    for (var n = t.enter, r = t.leave, i = t.from, o = i === void 0 ? 0 : i, a = t.to, s = a === void 0 ? this.length : a, u = this.cursor((t.mode || 0) | Mr.IncludeAnonymous); ; ) {
      var c = !1;
      if (u.from <= s && u.to >= o && (u.type.isAnonymous || n(u) !== !1)) {
        if (u.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && !u.type.isAnonymous && r(u), !u.nextSibling(); ) {
        if (!u.parent())
          return;
        c = !0;
      }
    }
  } }, { key: "prop", value: function(t) {
    return t.perNode ? this.props ? this.props[t.id] : void 0 : this.type.prop(t);
  } }, { key: "propValues", get: function() {
    var t = [];
    if (this.props)
      for (var n in this.props)
        t.push([+n, this.props[n]]);
    return t;
  } }, { key: "balance", value: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.children.length <= 8 ? this : y0(Wa.none, this.children, this.positions, 0, this.children.length, 0, this.length, function(r, i, o) {
      return new e(t.type, r, i, o, t.propValues);
    }, n.makeTree || function(r, i, o) {
      return new e(Wa.none, r, i, o);
    });
  } }], [{ key: "build", value: function(t) {
    return iW(t);
  } }]), e;
}();
La.empty = new La(Wa.none, [], [], 0);
var nW = function() {
  function e(t, n) {
    Z(this, e), this.buffer = t, this.index = n;
  }
  return Y(e, [{ key: "id", get: function() {
    return this.buffer[this.index - 4];
  } }, { key: "start", get: function() {
    return this.buffer[this.index - 3];
  } }, { key: "end", get: function() {
    return this.buffer[this.index - 2];
  } }, { key: "size", get: function() {
    return this.buffer[this.index - 1];
  } }, { key: "pos", get: function() {
    return this.index;
  } }, { key: "next", value: function() {
    this.index -= 4;
  } }, { key: "fork", value: function() {
    return new e(this.buffer, this.index);
  } }]), e;
}(), Yc = function() {
  function e(t, n, r) {
    Z(this, e), this.buffer = t, this.length = n, this.set = r;
  }
  return Y(e, [{ key: "type", get: function() {
    return Wa.none;
  } }, { key: "toString", value: function() {
    for (var t = [], n = 0; n < this.buffer.length; )
      t.push(this.childString(n)), n = this.buffer[n + 3];
    return t.join(",");
  } }, { key: "childString", value: function(t) {
    var n = this.buffer[t], r = this.buffer[t + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), r == (t += 4))
      return o;
    for (var a = []; t < r; )
      a.push(this.childString(t)), t = this.buffer[t + 3];
    return o + "(" + a.join(",") + ")";
  } }, { key: "findChild", value: function(t, n, r, i, o) {
    for (var a = this.buffer, s = -1, u = t; u != n && !(DP(o, i, a[u + 1], a[u + 2]) && (s = u, r > 0)); u = a[u + 3])
      ;
    return s;
  } }, { key: "slice", value: function(t, n, r, i) {
    for (var o = this.buffer, a = new Uint16Array(n - t), s = t, u = 0; s < n; )
      a[u++] = o[s++], a[u++] = o[s++] - r, a[u++] = o[s++] - r, a[u++] = o[s++] - t;
    return new e(a, i - r, this.set);
  } }]), e;
}();
function DP(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function LP(e, t) {
  for (var n = e.childBefore(t); n; ) {
    var r = n.lastChild;
    if (!r || r.to != n.to)
      break;
    r.type.isError && r.from == r.to ? (e = n, n = r.prevSibling) : n = r;
  }
  return e;
}
function Us(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t); ) {
    var o = !r && e instanceof kc && e.index < 0 ? null : e.parent;
    if (!o)
      return e;
    e = o;
  }
  var a = r ? 0 : Mr.IgnoreOverlays;
  if (r)
    for (var s = e, u = s.parent; u; u = (s = u).parent)
      s instanceof kc && s.index < 0 && ((i = u.enter(t, n, a)) === null || i === void 0 ? void 0 : i.from) != s.from && (e = u);
  for (; ; ) {
    var c = e.enter(t, n, a);
    if (!c)
      return e;
    e = c;
  }
}
var kc = function() {
  function e(t, n, r, i) {
    Z(this, e), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  return Y(e, [{ key: "type", get: function() {
    return this._tree.type;
  } }, { key: "name", get: function() {
    return this._tree.type.name;
  } }, { key: "to", get: function() {
    return this.from + this._tree.length;
  } }, { key: "nextChild", value: function(t, n, r, i) {
    for (var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, a = this; ; ) {
      for (var s = a._tree, u = s.children, c = s.positions, l = n > 0 ? u.length : -1; t != l; t += n) {
        var f = u[t], h = c[t] + a.from;
        if (DP(i, r, h, h + f.length)) {
          if (f instanceof Yc) {
            if (o & Mr.ExcludeBuffers)
              continue;
            var d = f.findChild(0, f.buffer.length, n, r - h, i);
            if (d > -1)
              return new tm(new rW(a, f, t, h), null, d);
          } else if (o & Mr.IncludeAnonymous || !f.type.isAnonymous || g0(f)) {
            var p = void 0;
            if (!(o & Mr.IgnoreMounts) && f.props && (p = f.prop(Hn.mounted)) && !p.overlay)
              return new e(p.tree, h, t, a);
            var v = new e(f, h, t, a);
            return o & Mr.IncludeAnonymous || !v.type.isAnonymous ? v : v.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (o & Mr.IncludeAnonymous || !a.type.isAnonymous || (t = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)))
        return null;
    }
  } }, { key: "firstChild", get: function() {
    return this.nextChild(0, 1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.nextChild(0, 1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.nextChild(this._tree.children.length - 1, -1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!(i & Mr.IgnoreOverlays) && (r = this._tree.prop(Hn.mounted)) && r.overlay) {
      var o, a = t - this.from, s = ut(r.overlay);
      try {
        for (s.s(); !(o = s.n()).done; ) {
          var u = o.value, c = u.from, l = u.to;
          if ((n > 0 ? c <= a : c < a) && (n < 0 ? l >= a : l > a))
            return new e(r.tree, r.overlay[0].from + this.from, -1, this);
        }
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
    }
    return this.nextChild(0, 1, t, n, i);
  } }, { key: "nextSignificantParent", value: function() {
    for (var t = this; t.type.isAnonymous && t._parent; )
      t = t._parent;
    return t;
  } }, { key: "parent", get: function() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  } }, { key: "nextSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
  } }, { key: "prevSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Zf(this, t);
  } }, { key: "tree", get: function() {
    return this._tree;
  } }, { key: "toTree", value: function() {
    return this._tree;
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Us(this, t, n, !1);
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Us(this, t, n, !0);
  } }, { key: "enterUnfinishedNodesBefore", value: function(t) {
    return LP(this, t);
  } }, { key: "getChild", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, i = Qf(this, t, n, r);
    return i.length ? i[0] : null;
  } }, { key: "getChildren", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Qf(this, t, n, r);
  } }, { key: "toString", value: function() {
    return this._tree.toString();
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "matchContext", value: function(t) {
    return Xf(this, t);
  } }]), e;
}();
function Qf(e, t, n, r) {
  var i = e.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (; !i.type.is(n); )
      if (!i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function Xf(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
var rW = Y(function e(t, n, r, i) {
  Z(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = i;
}), tm = function() {
  function e(t, n, r) {
    Z(this, e), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
  }
  return Y(e, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "from", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  } }, { key: "to", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  } }, { key: "child", value: function(t, n, r) {
    var i = this.context.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
    return o < 0 ? null : new e(this.context, this, o);
  } }, { key: "firstChild", get: function() {
    return this.child(1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.child(-1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.child(1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.child(-1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (r & Mr.ExcludeBuffers)
      return null;
    var i = this.context.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
    return o < 0 ? null : new e(this.context, this, o);
  } }, { key: "parent", get: function() {
    return this._parent || this.context.parent.nextSignificantParent();
  } }, { key: "externalSibling", value: function(t) {
    return this._parent ? null : this.context.parent.nextChild(this.context.index + t, t, 0, 4);
  } }, { key: "nextSibling", get: function() {
    var t = this.context.buffer, n = t.buffer[this.index + 3];
    return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
  } }, { key: "prevSibling", get: function() {
    var t = this.context.buffer, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Zf(this, t);
  } }, { key: "tree", get: function() {
    return null;
  } }, { key: "toTree", value: function() {
    var t = [], n = [], r = this.context.buffer, i = this.index + 4, o = r.buffer[this.index + 3];
    if (o > i) {
      var a = r.buffer[this.index + 1], s = r.buffer[this.index + 2];
      t.push(r.slice(i, o, a, s)), n.push(0);
    }
    return new La(this.type, t, n, this.to - this.from);
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Us(this, t, n, !1);
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Us(this, t, n, !0);
  } }, { key: "enterUnfinishedNodesBefore", value: function(t) {
    return LP(this, t);
  } }, { key: "toString", value: function() {
    return this.context.buffer.childString(this.index);
  } }, { key: "getChild", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, i = Qf(this, t, n, r);
    return i.length ? i[0] : null;
  } }, { key: "getChildren", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Qf(this, t, n, r);
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "matchContext", value: function(t) {
    return Xf(this, t);
  } }]), e;
}(), Zf = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (Z(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof kc)
      this.yieldNode(t);
    else {
      this._tree = t.context.parent, this.buffer = t.context;
      for (var r = t._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = t, this.yieldBuf(t.index);
    }
  }
  return Y(e, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "yieldNode", value: function(t) {
    return !!t && (this._tree = t, this.type = t.type, this.from = t.from, this.to = t.to, !0);
  } }, { key: "yieldBuf", value: function(t, n) {
    this.index = t;
    var r = this.buffer, i = r.start, o = r.buffer;
    return this.type = n || o.set.types[o.buffer[t]], this.from = i + o.buffer[t + 1], this.to = i + o.buffer[t + 2], !0;
  } }, { key: "yield", value: function(t) {
    return !!t && (t instanceof kc ? (this.buffer = null, this.yieldNode(t)) : (this.buffer = t.context, this.yieldBuf(t.index, t.type)));
  } }, { key: "toString", value: function() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  } }, { key: "enterChild", value: function(t, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(t < 0 ? this._tree._tree.children.length - 1 : 0, t, n, r, this.mode));
    var i = this.buffer.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.buffer.start, r);
    return !(o < 0) && (this.stack.push(this.index), this.yieldBuf(o));
  } }, { key: "firstChild", value: function() {
    return this.enterChild(1, 0, 4);
  } }, { key: "lastChild", value: function() {
    return this.enterChild(-1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.enterChild(1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.enterChild(-1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.mode;
    return this.buffer ? !(r & Mr.ExcludeBuffers) && this.enterChild(1, t, n) : this.yield(this._tree.enter(t, n, r));
  } }, { key: "parent", value: function() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Mr.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    var t = this.mode & Mr.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(t);
  } }, { key: "sibling", value: function(t) {
    if (!this.buffer)
      return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + t, t, 0, 4, this.mode));
    var n = this.buffer.buffer, r = this.stack.length - 1;
    if (t < 0) {
      var i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(i, this.index, -1, 0, 4));
    } else {
      var o = n.buffer[this.index + 3];
      if (o < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(o);
    }
    return r < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + t, t, 0, 4, this.mode));
  } }, { key: "nextSibling", value: function() {
    return this.sibling(1);
  } }, { key: "prevSibling", value: function() {
    return this.sibling(-1);
  } }, { key: "atLastNode", value: function(t) {
    var n, r, i = this.buffer;
    if (i) {
      if (t > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (var o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      n = i.index, r = i.parent;
    } else {
      var a = this._tree;
      n = a.index, r = a._parent;
    }
    for (; r; n = (s = r).index, r = s._parent, s) {
      var s;
      if (n > -1)
        for (var u = n + t, c = t < 0 ? -1 : r._tree.children.length; u != c; u += t) {
          var l = r._tree.children[u];
          if (this.mode & Mr.IncludeAnonymous || l instanceof Yc || !l.type.isAnonymous || g0(l))
            return !1;
        }
    }
    return !0;
  } }, { key: "move", value: function(t, n) {
    if (n && this.enterChild(t, 0, 4))
      return !0;
    for (; ; ) {
      if (this.sibling(t))
        return !0;
      if (this.atLastNode(t) || !this.parent())
        return !1;
    }
  } }, { key: "next", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(1, t);
  } }, { key: "prev", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(-1, t);
  } }, { key: "moveTo", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0; (this.from == this.to || (n < 1 ? this.from >= t : this.from > t) || (n > -1 ? this.to <= t : this.to < t)) && this.parent(); )
      ;
    for (; this.enterChild(1, t, n); )
      ;
    return this;
  } }, { key: "node", get: function() {
    if (!this.buffer)
      return this._tree;
    var t = this.bufferNode, n = null, r = 0;
    if (t && t.context == this.buffer)
      t:
        for (var i = this.index, o = this.stack.length; o >= 0; ) {
          for (var a = t; a; a = a._parent)
            if (a.index == i) {
              if (i == this.index)
                return a;
              n = a, r = o + 1;
              break t;
            }
          i = this.stack[--o];
        }
    for (var s = r; s < this.stack.length; s++)
      n = new tm(this.buffer, n, this.stack[s]);
    return this.bufferNode = new tm(this.buffer, n, this.index);
  } }, { key: "tree", get: function() {
    return this.buffer ? null : this._tree._tree;
  } }, { key: "iterate", value: function(t, n) {
    for (var r = 0; ; ) {
      var i = !1;
      if (this.type.isAnonymous || t(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && n && n(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, i = !0;
      }
    }
  } }, { key: "matchContext", value: function(t) {
    if (!this.buffer)
      return Xf(this.node, t);
    for (var n = this.buffer.buffer, r = n.set.types, i = t.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return Xf(this.node, t, i);
      var a = r[n.buffer[this.stack[o]]];
      if (!a.isAnonymous) {
        if (t[i] && t[i] != a.name)
          return !1;
        i--;
      }
    }
    return !0;
  } }]), e;
}();
function g0(e) {
  return e.children.some(function(t) {
    return t instanceof Yc || !t.type.isAnonymous || g0(t);
  });
}
function iW(e) {
  var t, n = e.buffer, r = e.nodeSet, i = e.maxBufferLength, o = i === void 0 ? 1024 : i, a = e.reused, s = a === void 0 ? [] : a, u = e.minRepeatType, c = u === void 0 ? r.types.length : u, l = Array.isArray(n) ? new nW(n, n.length) : n, f = r.types, h = 0, d = 0;
  function p(w, x, S, T, P) {
    for (var O = l.id, j = l.start, V = l.end, E = l.size, C = d; E < 0; ) {
      if (l.next(), E == -1) {
        var H = s[O];
        return S.push(H), void T.push(j - w);
      }
      if (E == -3)
        return void (h = O);
      if (E == -4)
        return void (d = O);
      throw new RangeError("Unrecognized record size: ".concat(E));
    }
    var X, F, G = f[O], M = j - w;
    if (V - j <= o && (F = function(kt, I) {
      var R = l.fork(), it = 0, N = 0, K = 0, z = R.end - o, at = { size: 0, start: 0, skip: 0 };
      t:
        for (var yt = R.pos - kt; R.pos > yt; ) {
          var jt = R.size;
          if (R.id == I && jt >= 0)
            at.size = it, at.start = N, at.skip = K, K += 4, it += 4, R.next();
          else {
            var Ft = R.pos - jt;
            if (jt < 0 || Ft < yt || R.start < z)
              break;
            var zt = R.id >= c ? 4 : 0, St = R.start;
            for (R.next(); R.pos > Ft; ) {
              if (R.size < 0) {
                if (R.size != -3)
                  break t;
                zt += 4;
              } else
                R.id >= c && (zt += 4);
              R.next();
            }
            N = St, it += jt, K += zt;
          }
        }
      return (I < 0 || it == kt) && (at.size = it, at.start = N, at.skip = K), at.size > 4 ? at : void 0;
    }(l.pos - x, P))) {
      for (var $ = new Uint16Array(F.size - F.skip), q = l.pos - F.size, B = $.length; l.pos > q; )
        B = g(F.start, $, B);
      X = new Yc($, V - F.start, r), M = F.start - w;
    } else {
      var D = l.pos - E;
      l.next();
      for (var _ = [], L = [], J = O >= c ? O : -1, st = 0, ht = V; l.pos > D; )
        J >= 0 && l.id == J && l.size >= 0 ? (l.end <= ht - o && (v(_, L, j, st, l.end, ht, J, C), st = _.length, ht = l.end), l.next()) : p(j, D, _, L, J);
      if (J >= 0 && st > 0 && st < _.length && v(_, L, j, st, j, ht, J, C), _.reverse(), L.reverse(), J > -1 && st > 0) {
        var xt = function(kt) {
          return function(I, R, it) {
            var N, K, z = 0, at = I.length - 1;
            if (at >= 0 && (N = I[at]) instanceof La) {
              if (!at && N.type == kt && N.length == it)
                return N;
              (K = N.prop(Hn.lookAhead)) && (z = R[at] + N.length + K);
            }
            return m(kt, I, R, it, z);
          };
        }(G);
        X = y0(G, _, L, 0, _.length, 0, V - j, xt, xt);
      } else
        X = m(G, _, L, V - j, C - V);
    }
    S.push(X), T.push(M);
  }
  function v(w, x, S, T, P, O, j, V) {
    for (var E = [], C = []; w.length > T; )
      E.push(w.pop()), C.push(x.pop() + S - P);
    w.push(m(r.types[j], E, C, O - P, V - O)), x.push(P - S);
  }
  function m(w, x, S, T) {
    var P = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, O = arguments.length > 5 ? arguments[5] : void 0;
    if (h) {
      var j = [Hn.contextHash, h];
      O = O ? [j].concat(O) : [j];
    }
    if (P > 25) {
      var V = [Hn.lookAhead, P];
      O = O ? [V].concat(O) : [V];
    }
    return new La(w, x, S, T, O);
  }
  function g(w, x, S) {
    var T = l.id, P = l.start, O = l.end, j = l.size;
    if (l.next(), j >= 0 && T < c) {
      var V = S;
      if (j > 4)
        for (var E = l.pos - (j - 4); l.pos > E; )
          S = g(w, x, S);
      x[--S] = V, x[--S] = O - w, x[--S] = P - w, x[--S] = T;
    } else
      j == -3 ? h = T : j == -4 && (d = T);
    return S;
  }
  for (var y = [], b = []; l.pos > 0; )
    p(e.start || 0, e.bufferStart || 0, y, b, -1);
  var k = (t = e.length) !== null && t !== void 0 ? t : y.length ? b[0] + y[0].length : 0;
  return new La(f[e.topID], y.reverse(), b.reverse(), k);
}
var q4 = /* @__PURE__ */ new WeakMap();
function lf(e, t) {
  if (!e.isAnonymous || t instanceof Yc || t.type != e)
    return 1;
  var n = q4.get(t);
  if (n == null) {
    n = 1;
    var r, i = ut(t.children);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        if (o.type != e || !(o instanceof La)) {
          n = 1;
          break;
        }
        n += lf(e, o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    q4.set(t, n);
  }
  return n;
}
function y0(e, t, n, r, i, o, a, s, u) {
  for (var c = 0, l = r; l < i; l++)
    c += lf(e, t[l]);
  var f = Math.ceil(1.5 * c / 8), h = [], d = [];
  return function p(v, m, g, y, b) {
    for (var k = g; k < y; ) {
      var w = k, x = m[k], S = lf(e, v[k]);
      for (k++; k < y; k++) {
        var T = lf(e, v[k]);
        if (S + T >= f)
          break;
        S += T;
      }
      if (k == w + 1) {
        if (S > f) {
          var P = v[w];
          p(P.children, P.positions, 0, P.children.length, m[w] + b);
          continue;
        }
        h.push(v[w]);
      } else {
        var O = m[k - 1] + v[k - 1].length - x;
        h.push(y0(e, v, m, w, k, x, O, null, u));
      }
      d.push(x + b - o);
    }
  }(t, n, r, i, 0), (s || u)(h, d, a);
}
new Hn({ perNode: !0 });
var oW = 0, Uo = function() {
  function e(t, n, r) {
    Z(this, e), this.set = t, this.base = n, this.modified = r, this.id = oW++;
  }
  return Y(e, null, [{ key: "define", value: function(t) {
    if (t != null && t.base)
      throw new Error("Can not derive from a modified tag");
    var n = new e([], null, []);
    if (n.set.push(n), t) {
      var r, i = ut(t.set);
      try {
        for (i.s(); !(r = i.n()).done; ) {
          var o = r.value;
          n.set.push(o);
        }
      } catch (a) {
        i.e(a);
      } finally {
        i.f();
      }
    }
    return n;
  } }, { key: "defineModifier", value: function() {
    var t = new V4();
    return function(n) {
      return n.modified.indexOf(t) > -1 ? n : V4.get(n.base || n, n.modified.concat(t).sort(function(r, i) {
        return r.id - i.id;
      }));
    };
  } }]), e;
}(), aW = 0, V4 = function() {
  function e() {
    Z(this, e), this.instances = [], this.id = aW++;
  }
  return Y(e, null, [{ key: "get", value: function(t, n) {
    if (!n.length)
      return t;
    var r = n[0].instances.find(function(v) {
      return v.base == t && (m = n, g = v.modified, m.length == g.length && m.every(function(y, b) {
        return y == g[b];
      }));
      var m, g;
    });
    if (r)
      return r;
    var i, o = [], a = new Uo(o, t, n), s = ut(n);
    try {
      for (s.s(); !(i = s.n()).done; )
        i.value.instances.push(a);
    } catch (v) {
      s.e(v);
    } finally {
      s.f();
    }
    var u, c = zP(n), l = ut(t.set);
    try {
      for (l.s(); !(u = l.n()).done; ) {
        var f, h = u.value, d = ut(c);
        try {
          for (d.s(); !(f = d.n()).done; ) {
            var p = f.value;
            o.push(e.get(h, p));
          }
        } catch (v) {
          d.e(v);
        } finally {
          d.f();
        }
      }
    } catch (v) {
      l.e(v);
    } finally {
      l.f();
    }
    return a;
  } }]), e;
}();
function zP(e) {
  for (var t = [e], n = 0; n < e.length; n++) {
    var r, i = ut(zP(e.slice(0, n).concat(e.slice(n + 1))));
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        t.push(o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
  }
  return t;
}
function BP(e) {
  var t = /* @__PURE__ */ Object.create(null);
  for (var n in e) {
    var r = e[n];
    Array.isArray(r) || (r = [r]);
    var i, o = ut(n.split(" "));
    try {
      for (o.s(); !(i = o.n()).done; ) {
        var a = i.value;
        if (a) {
          for (var s = [], u = 2, c = a, l = 0; ; ) {
            if (c == "..." && l > 0 && l + 3 == a.length) {
              u = 1;
              break;
            }
            var f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(c);
            if (!f)
              throw new RangeError("Invalid path: " + a);
            if (s.push(f[0] == "*" ? "" : f[0][0] == '"' ? JSON.parse(f[0]) : f[0]), (l += f[0].length) == a.length)
              break;
            var h = a[l++];
            if (l == a.length && h == "!") {
              u = 0;
              break;
            }
            if (h != "/")
              throw new RangeError("Invalid path: " + a);
            c = a.slice(l);
          }
          var d = s.length - 1, p = s[d];
          if (!p)
            throw new RangeError("Invalid path: " + a);
          var v = new sW(r, u, d > 0 ? s.slice(0, d) : null);
          t[p] = v.sort(t[p]);
        }
      }
    } catch (m) {
      o.e(m);
    } finally {
      o.f();
    }
  }
  return FP.add(t);
}
var FP = new Hn(), sW = function() {
  function e(t, n, r, i) {
    Z(this, e), this.tags = t, this.mode = n, this.context = r, this.next = i;
  }
  return Y(e, [{ key: "sort", value: function(t) {
    return !t || t.depth < this.depth ? (this.next = t, this) : (t.next = this.sort(t.next), t);
  } }, { key: "depth", get: function() {
    return this.context ? this.context.length : 0;
  } }]), e;
}();
function qP(e, t) {
  var n, r = /* @__PURE__ */ Object.create(null), i = ut(e);
  try {
    for (i.s(); !(n = i.n()).done; ) {
      var o = n.value;
      if (Array.isArray(o.tag)) {
        var a, s = ut(o.tag);
        try {
          for (s.s(); !(a = s.n()).done; ) {
            var u = a.value;
            r[u.id] = o.class;
          }
        } catch (d) {
          s.e(d);
        } finally {
          s.f();
        }
      } else
        r[o.tag.id] = o.class;
    }
  } catch (d) {
    i.e(d);
  } finally {
    i.f();
  }
  var c = t || {}, l = c.scope, f = c.all, h = f === void 0 ? null : f;
  return { style: function(d) {
    var p, v = h, m = ut(d);
    try {
      for (m.s(); !(p = m.n()).done; ) {
        var g, y = ut(p.value.set);
        try {
          for (y.s(); !(g = y.n()).done; ) {
            var b = g.value, k = r[b.id];
            if (k) {
              v = v ? v + " " + k : k;
              break;
            }
          }
        } catch (w) {
          y.e(w);
        } finally {
          y.f();
        }
      }
    } catch (w) {
      m.e(w);
    } finally {
      m.f();
    }
    return v;
  }, scope: l };
}
function uW(e, t) {
  var n, r = null, i = ut(e);
  try {
    for (i.s(); !(n = i.n()).done; ) {
      var o = n.value.style(t);
      o && (r = r ? r + " " + o : o);
    }
  } catch (a) {
    i.e(a);
  } finally {
    i.f();
  }
  return r;
}
function cW(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : e.length, o = new lW(r, Array.isArray(t) ? t : [t], n);
  o.highlightRange(e.cursor(), r, i, "", o.highlighters), o.flush(i);
}
var ov, lW = function() {
  function e(t, n, r) {
    Z(this, e), this.at = t, this.highlighters = n, this.span = r, this.class = "";
  }
  return Y(e, [{ key: "startSpan", value: function(t, n) {
    n != this.class && (this.flush(t), t > this.at && (this.at = t), this.class = n);
  } }, { key: "flush", value: function(t) {
    t > this.at && this.class && this.span(this.at, t, this.class);
  } }, { key: "highlightRange", value: function(t, n, r, i, o) {
    var a = t.type, s = t.from, u = t.to;
    if (!(s >= r || u <= n)) {
      a.isTop && (o = this.highlighters.filter(function(S) {
        return !S.scope || S.scope(a);
      }));
      for (var c = i, l = a.prop(FP), f = !1; l; ) {
        if (!l.context || t.matchContext(l.context)) {
          var h = uW(o, l.tags);
          h && (c && (c += " "), c += h, l.mode == 1 ? i += (i ? " " : "") + h : l.mode == 0 && (f = !0));
          break;
        }
        l = l.next;
      }
      if (this.startSpan(t.from, c), !f) {
        var d = t.tree && t.tree.prop(Hn.mounted);
        if (d && d.overlay) {
          for (var p = t.node.enter(d.overlay[0].from + s, 1), v = this.highlighters.filter(function(S) {
            return !S.scope || S.scope(d.tree.type);
          }), m = t.firstChild(), g = 0, y = s; ; g++) {
            var b = g < d.overlay.length ? d.overlay[g] : null, k = b ? b.from + s : u, w = Math.max(n, y), x = Math.min(r, k);
            if (w < x && m)
              for (; t.from < x && (this.highlightRange(t, w, x, i, o), this.startSpan(Math.min(r, t.to), c), !(t.to >= k) && t.nextSibling()); )
                ;
            if (!b || k > r)
              break;
            (y = b.to + s) > n && (this.highlightRange(p.cursor(), Math.max(n, b.from + s), Math.min(r, y), i, v), this.startSpan(y, c));
          }
          m && t.parent();
        } else if (t.firstChild()) {
          do
            if (!(t.to <= n)) {
              if (t.from >= r)
                break;
              this.highlightRange(t, n, r, i, o), this.startSpan(Math.min(r, t.to), c);
            }
          while (t.nextSibling());
          t.parent();
        }
      }
    }
  } }]), e;
}(), Zt = Uo.define, Rl = Zt(), Jo = Zt(), H4 = Zt(Jo), W4 = Zt(Jo), Ko = Zt(), Dl = Zt(Ko), av = Zt(Ko), Zi = Zt(), Sa = Zt(Zi), Ki = Zt(), Gi = Zt(), em = Zt(), Au = Zt(em), Ll = Zt(), Jt = { comment: Rl, lineComment: Zt(Rl), blockComment: Zt(Rl), docComment: Zt(Rl), name: Jo, variableName: Zt(Jo), typeName: H4, tagName: Zt(H4), propertyName: W4, attributeName: Zt(W4), className: Zt(Jo), labelName: Zt(Jo), namespace: Zt(Jo), macroName: Zt(Jo), literal: Ko, string: Dl, docString: Zt(Dl), character: Zt(Dl), attributeValue: Zt(Dl), number: av, integer: Zt(av), float: Zt(av), bool: Zt(Ko), regexp: Zt(Ko), escape: Zt(Ko), color: Zt(Ko), url: Zt(Ko), keyword: Ki, self: Zt(Ki), null: Zt(Ki), atom: Zt(Ki), unit: Zt(Ki), modifier: Zt(Ki), operatorKeyword: Zt(Ki), controlKeyword: Zt(Ki), definitionKeyword: Zt(Ki), moduleKeyword: Zt(Ki), operator: Gi, derefOperator: Zt(Gi), arithmeticOperator: Zt(Gi), logicOperator: Zt(Gi), bitwiseOperator: Zt(Gi), compareOperator: Zt(Gi), updateOperator: Zt(Gi), definitionOperator: Zt(Gi), typeOperator: Zt(Gi), controlOperator: Zt(Gi), punctuation: em, separator: Zt(em), bracket: Au, angleBracket: Zt(Au), squareBracket: Zt(Au), paren: Zt(Au), brace: Zt(Au), content: Zi, heading: Sa, heading1: Zt(Sa), heading2: Zt(Sa), heading3: Zt(Sa), heading4: Zt(Sa), heading5: Zt(Sa), heading6: Zt(Sa), contentSeparator: Zt(Zi), list: Zt(Zi), quote: Zt(Zi), emphasis: Zt(Zi), strong: Zt(Zi), link: Zt(Zi), monospace: Zt(Zi), strikethrough: Zt(Zi), inserted: Zt(), deleted: Zt(), changed: Zt(), invalid: Zt(), meta: Ll, documentMeta: Zt(Ll), annotation: Zt(Ll), processingInstruction: Zt(Ll), definition: Uo.defineModifier(), constant: Uo.defineModifier(), function: Uo.defineModifier(), standard: Uo.defineModifier(), local: Uo.defineModifier(), special: Uo.defineModifier() };
qP([{ tag: Jt.link, class: "tok-link" }, { tag: Jt.heading, class: "tok-heading" }, { tag: Jt.emphasis, class: "tok-emphasis" }, { tag: Jt.strong, class: "tok-strong" }, { tag: Jt.keyword, class: "tok-keyword" }, { tag: Jt.atom, class: "tok-atom" }, { tag: Jt.bool, class: "tok-bool" }, { tag: Jt.url, class: "tok-url" }, { tag: Jt.labelName, class: "tok-labelName" }, { tag: Jt.inserted, class: "tok-inserted" }, { tag: Jt.deleted, class: "tok-deleted" }, { tag: Jt.literal, class: "tok-literal" }, { tag: Jt.string, class: "tok-string" }, { tag: Jt.number, class: "tok-number" }, { tag: [Jt.regexp, Jt.escape, Jt.special(Jt.string)], class: "tok-string2" }, { tag: Jt.variableName, class: "tok-variableName" }, { tag: Jt.local(Jt.variableName), class: "tok-variableName tok-local" }, { tag: Jt.definition(Jt.variableName), class: "tok-variableName tok-definition" }, { tag: Jt.special(Jt.variableName), class: "tok-variableName2" }, { tag: Jt.definition(Jt.propertyName), class: "tok-propertyName tok-definition" }, { tag: Jt.typeName, class: "tok-typeName" }, { tag: Jt.namespace, class: "tok-namespace" }, { tag: Jt.className, class: "tok-className" }, { tag: Jt.macroName, class: "tok-macroName" }, { tag: Jt.propertyName, class: "tok-propertyName" }, { tag: Jt.operator, class: "tok-operator" }, { tag: Jt.comment, class: "tok-comment" }, { tag: Jt.meta, class: "tok-meta" }, { tag: Jt.invalid, class: "tok-invalid" }, { tag: Jt.punctuation, class: "tok-punctuation" }]);
var wc = new bn(), Mi = function() {
  function e(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    Z(this, e), this.data = t, In.prototype.hasOwnProperty("tree") || Object.defineProperty(In.prototype, "tree", { get: function() {
      return Or(this);
    } }), this.parser = n, this.extension = [la.of(this), In.languageData.of(function(i, o, a) {
      return i.facet(U4(i, o, a));
    })].concat(r);
  }
  return Y(e, [{ key: "isActiveAt", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    return U4(t, n, r) == this.data;
  } }, { key: "findRegions", value: function(t) {
    var n = this, r = t.facet(la);
    if ((r == null ? void 0 : r.data) == this.data)
      return [{ from: 0, to: t.doc.length }];
    if (!r || !r.allowsNesting)
      return [];
    var i = [];
    return function o(a, s) {
      if (a.prop(wc) != n.data) {
        var u = a.prop(bn.mounted);
        if (u) {
          if (u.tree.prop(wc) == n.data) {
            if (u.overlay) {
              var c, l = ut(u.overlay);
              try {
                for (l.s(); !(c = l.n()).done; ) {
                  var f = c.value;
                  i.push({ from: f.from + s, to: f.to + s });
                }
              } catch (v) {
                l.e(v);
              } finally {
                l.f();
              }
            } else
              i.push({ from: s, to: s + a.length });
            return;
          }
          if (u.overlay) {
            var h = i.length;
            if (o(u.tree, u.overlay[0].from + s), i.length > h)
              return;
          }
        }
        for (var d = 0; d < a.children.length; d++) {
          var p = a.children[d];
          p instanceof Zr && o(p, a.positions[d] + s);
        }
      } else
        i.push({ from: s, to: s + a.length });
    }(Or(t), 0), i;
  } }, { key: "allowsNesting", get: function() {
    return !0;
  } }]), e;
}();
function U4(e, t, n) {
  var r = e.facet(la);
  if (!r)
    return null;
  var i = r.data;
  if (r.allowsNesting)
    for (var o = Or(e).topNode; o; o = o.enter(t, n, Sr.ExcludeBuffers))
      i = o.type.prop(wc) || i;
  return i;
}
Mi.setState = He.define();
var fW = function(e) {
  Et(n, Mi);
  var t = Mt(n);
  function n(r, i) {
    var o;
    return Z(this, n), (o = t.call(this, r, i)).parser = i, o;
  }
  return Y(n, [{ key: "configure", value: function(r) {
    return new n(this.data, this.parser.configure(r));
  } }, { key: "allowsNesting", get: function() {
    return this.parser.hasWrappers();
  } }], [{ key: "define", value: function(r) {
    var i, o = (i = r.languageData, be.define({ combine: i ? function(a) {
      return a.concat(i);
    } : void 0 }));
    return new n(o, r.parser.configure({ props: [wc.add(function(a) {
      return a.isTop ? o : void 0;
    })] }));
  } }]), n;
}();
function Or(e) {
  var t = e.field(Mi.state, !1);
  return t ? t.tree : Zr.empty;
}
var hW = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t.length;
    Z(this, e), this.doc = t, this.length = n, this.cursorPos = 0, this.string = "", this.cursor = t.iter();
  }
  return Y(e, [{ key: "syncTo", value: function(t) {
    return this.string = this.cursor.next(t - this.cursorPos).value, this.cursorPos = t + this.string.length, this.cursorPos - this.string.length;
  } }, { key: "chunk", value: function(t) {
    return this.syncTo(t), this.string;
  } }, { key: "lineChunks", get: function() {
    return !0;
  } }, { key: "read", value: function(t, n) {
    var r = this.cursorPos - this.string.length;
    return t < r || n >= this.cursorPos ? this.doc.sliceString(t, n) : this.string.slice(t - r, n - r);
  } }]), e;
}(), Pu = null, dW = function() {
  function e(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], i = arguments.length > 3 ? arguments[3] : void 0, o = arguments.length > 4 ? arguments[4] : void 0, a = arguments.length > 5 ? arguments[5] : void 0, s = arguments.length > 6 ? arguments[6] : void 0, u = arguments.length > 7 ? arguments[7] : void 0;
    Z(this, e), this.parser = t, this.state = n, this.fragments = r, this.tree = i, this.treeLen = o, this.viewport = a, this.skipped = s, this.scheduleOn = u, this.parse = null, this.tempSkipped = [];
  }
  return Y(e, [{ key: "startParse", value: function() {
    return this.parser.startParse(new hW(this.state.doc), this.fragments);
  } }, { key: "work", value: function(t, n) {
    var r = this;
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != Zr.empty && this.isDone(n != null ? n : this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(function() {
      var i;
      if (typeof t == "number") {
        var o = Date.now() + t;
        t = function() {
          return Date.now() > o;
        };
      }
      for (r.parse || (r.parse = r.startParse()), n != null && (r.parse.stoppedAt == null || r.parse.stoppedAt > n) && n < r.state.doc.length && r.parse.stopAt(n); ; ) {
        var a = r.parse.advance();
        if (a) {
          if (r.fragments = r.withoutTempSkipped(cf.addTree(a, r.fragments, r.parse.stoppedAt != null)), r.treeLen = (i = r.parse.stoppedAt) !== null && i !== void 0 ? i : r.state.doc.length, r.tree = a, r.parse = null, !(r.treeLen < (n != null ? n : r.state.doc.length)))
            return !0;
          r.parse = r.startParse();
        }
        if (t())
          return !1;
      }
    });
  } }, { key: "takeTree", value: function() {
    var t, n, r = this;
    this.parse && (t = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > t) && this.parse.stopAt(t), this.withContext(function() {
      for (; !(n = r.parse.advance()); )
        ;
    }), this.treeLen = t, this.tree = n, this.fragments = this.withoutTempSkipped(cf.addTree(this.tree, this.fragments, !0)), this.parse = null);
  } }, { key: "withContext", value: function(t) {
    var n = Pu;
    Pu = this;
    try {
      return t();
    } finally {
      Pu = n;
    }
  } }, { key: "withoutTempSkipped", value: function(t) {
    for (var n; n = this.tempSkipped.pop(); )
      t = J4(t, n.from, n.to);
    return t;
  } }, { key: "changes", value: function(t, n) {
    var r = this.fragments, i = this.tree, o = this.treeLen, a = this.viewport, s = this.skipped;
    if (this.takeTree(), !t.empty) {
      var u = [];
      if (t.iterChangedRanges(function(p, v, m, g) {
        return u.push({ fromA: p, toA: v, fromB: m, toB: g });
      }), r = cf.applyChanges(r, u), i = Zr.empty, o = 0, a = { from: t.mapPos(a.from, -1), to: t.mapPos(a.to, 1) }, this.skipped.length) {
        s = [];
        var c, l = ut(this.skipped);
        try {
          for (l.s(); !(c = l.n()).done; ) {
            var f = c.value, h = t.mapPos(f.from, 1), d = t.mapPos(f.to, -1);
            h < d && s.push({ from: h, to: d });
          }
        } catch (p) {
          l.e(p);
        } finally {
          l.f();
        }
      }
    }
    return new e(this.parser, n, r, i, o, a, s, this.scheduleOn);
  } }, { key: "updateViewport", value: function(t) {
    if (this.viewport.from == t.from && this.viewport.to == t.to)
      return !1;
    this.viewport = t;
    for (var n = this.skipped.length, r = 0; r < this.skipped.length; r++) {
      var i = this.skipped[r], o = i.from, a = i.to;
      o < t.to && a > t.from && (this.fragments = J4(this.fragments, o, a), this.skipped.splice(r--, 1));
    }
    return !(this.skipped.length >= n) && (this.reset(), !0);
  } }, { key: "reset", value: function() {
    this.parse && (this.takeTree(), this.parse = null);
  } }, { key: "skipUntilInView", value: function(t, n) {
    this.skipped.push({ from: t, to: n });
  } }, { key: "isDone", value: function(t) {
    t = Math.min(t, this.state.doc.length);
    var n = this.fragments;
    return this.treeLen >= t && n.length && n[0].from == 0 && n[0].to >= t;
  } }], [{ key: "create", value: function(t, n, r) {
    return new e(t, n, [], Zr.empty, 0, r, [], null);
  } }, { key: "getSkippingParser", value: function(t) {
    return new (function(n) {
      Et(i, ZH);
      var r = Mt(i);
      function i() {
        return Z(this, i), r.apply(this, arguments);
      }
      return Y(i, [{ key: "createParse", value: function(o, a, s) {
        var u = s[0].from, c = s[s.length - 1].to;
        return { parsedPos: u, advance: function() {
          var l = Pu;
          if (l) {
            var f, h = ut(s);
            try {
              for (h.s(); !(f = h.n()).done; ) {
                var d = f.value;
                l.tempSkipped.push(d);
              }
            } catch (p) {
              h.e(p);
            } finally {
              h.f();
            }
            t && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, t]) : t);
          }
          return this.parsedPos = c, new Zr(po.none, [], [], c - u);
        }, stoppedAt: null, stopAt: function() {
        } };
      } }]), i;
    }())();
  } }, { key: "get", value: function() {
    return Pu;
  } }]), e;
}();
function J4(e, t, n) {
  return cf.applyChanges(e, [{ fromA: t, toA: n, fromB: t, toB: n }]);
}
var nm = function() {
  function e(t) {
    Z(this, e), this.context = t, this.tree = t.tree;
  }
  return Y(e, [{ key: "apply", value: function(t) {
    if (!t.docChanged && this.tree == this.context.tree)
      return this;
    var n = this.context.changes(t.changes, t.state), r = this.context.treeLen == t.startState.doc.length ? void 0 : Math.max(t.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new e(n);
  } }], [{ key: "init", value: function(t) {
    var n = Math.min(3e3, t.doc.length), r = dW.create(t.facet(la).parser, t, { from: 0, to: n });
    return r.work(20, n) || r.takeTree(), new e(r);
  } }]), e;
}();
Mi.state = br.define({ create: nm.init, update: function(e, t) {
  var n, r = ut(t.effects);
  try {
    for (r.s(); !(n = r.n()).done; ) {
      var i = n.value;
      if (i.is(Mi.setState))
        return i.value;
    }
  } catch (o) {
    r.e(o);
  } finally {
    r.f();
  }
  return t.startState.facet(la) != t.state.facet(la) ? nm.init(t.state) : e.apply(t);
} });
var VP = function(e) {
  var t = setTimeout(function() {
    return e();
  }, 500);
  return function() {
    return clearTimeout(t);
  };
};
typeof requestIdleCallback < "u" && (VP = function(e) {
  var t = -1, n = setTimeout(function() {
    t = requestIdleCallback(e, { timeout: 400 });
  }, 100);
  return function() {
    return t < 0 ? clearTimeout(n) : cancelIdleCallback(t);
  };
});
var sv = typeof navigator < "u" && ((ov = navigator.scheduling) === null || ov === void 0 ? void 0 : ov.isInputPending) ? function() {
  return navigator.scheduling.isInputPending();
} : null, vW = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.view = t, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n = this.view.state.field(Mi.state).context;
    (n.updateViewport(t.view.viewport) || this.view.viewport.to > n.treeLen) && this.scheduleWork(), t.docChanged && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(n);
  } }, { key: "scheduleWork", value: function() {
    if (!this.working) {
      var t = this.view.state, n = t.field(Mi.state);
      n.tree == n.context.tree && n.context.isDone(t.doc.length) || (this.working = VP(this.work));
    }
  } }, { key: "work", value: function(t) {
    this.working = null;
    var n = Date.now();
    if (this.chunkEnd < n && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = n + 3e4, this.chunkBudget = 3e3), !(this.chunkBudget <= 0)) {
      var r = this.view, i = r.state, o = r.viewport.to, a = i.field(Mi.state);
      if (a.tree != a.context.tree || !a.context.isDone(o + 1e5)) {
        var s = Date.now() + Math.min(this.chunkBudget, 100, t && !sv ? Math.max(25, t.timeRemaining() - 5) : 1e9), u = a.context.treeLen < o && i.doc.length > o + 1e3, c = a.context.work(function() {
          return sv && sv() || Date.now() > s;
        }, o + (u ? 0 : 1e5));
        this.chunkBudget -= Date.now() - n, (c || this.chunkBudget <= 0) && (a.context.takeTree(), this.view.dispatch({ effects: Mi.setState.of(new nm(a.context)) })), this.chunkBudget > 0 && (!c || u) && this.scheduleWork(), this.checkAsyncSchedule(a.context);
      }
    }
  } }, { key: "checkAsyncSchedule", value: function(t) {
    var n = this;
    t.scheduleOn && (this.workScheduled++, t.scheduleOn.then(function() {
      return n.scheduleWork();
    }).catch(function(r) {
      return ei(n.view.state, r);
    }).then(function() {
      return n.workScheduled--;
    }), t.scheduleOn = null);
  } }, { key: "destroy", value: function() {
    this.working && this.working();
  } }, { key: "isWorking", value: function() {
    return !!(this.working || this.workScheduled > 0);
  } }]), e;
}(), { eventHandlers: { focus: function() {
  this.scheduleWork();
} } }), la = be.define({ combine: function(e) {
  return e.length ? e[0] : null;
}, enables: [Mi.state, vW] }), pW = Y(function e(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  Z(this, e), this.language = t, this.support = n, this.extension = [t, n];
}), mW = be.define(), fd = be.define({ combine: function(e) {
  if (!e.length)
    return "  ";
  if (!/^(?: +|\t+)$/.test(e[0]))
    throw new Error("Invalid indent unit: " + JSON.stringify(e[0]));
  return e[0];
} });
function Yf(e) {
  var t = e.facet(fd);
  return t.charCodeAt(0) == 9 ? e.tabSize * t.length : t.length;
}
function xc(e, t) {
  var n = "", r = e.tabSize;
  if (e.facet(fd).charCodeAt(0) == 9)
    for (; t >= r; )
      n += "	", t -= r;
  for (var i = 0; i < t; i++)
    n += " ";
  return n;
}
function b0(e, t) {
  e instanceof In && (e = new hd(e));
  var n, r = ut(e.state.facet(mW));
  try {
    for (r.s(); !(n = r.n()).done; ) {
      var i = (0, n.value)(e, t);
      if (i != null)
        return i;
    }
  } catch (a) {
    r.e(a);
  } finally {
    r.f();
  }
  var o = Or(e.state);
  return o ? function(a, s, u) {
    return WP(s.resolveInner(u).enterUnfinishedNodesBefore(u), u, a);
  }(e, o, t) : null;
}
var hd = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Z(this, e), this.state = t, this.options = n, this.unit = Yf(t);
  }
  return Y(e, [{ key: "lineAt", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, r = this.state.doc.lineAt(t), i = this.options, o = i.simulateBreak, a = i.simulateDoubleBreak;
    return o != null && o >= r.from && o <= r.to ? a && o == t ? { text: "", from: t } : (n < 0 ? o < t : o <= t) ? { text: r.text.slice(o - r.from), from: o } : { text: r.text.slice(0, o - r.from), from: r.from } : r;
  } }, { key: "textAfterPos", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (this.options.simulateDoubleBreak && t == this.options.simulateBreak)
      return "";
    var r = this.lineAt(t, n), i = r.text, o = r.from;
    return i.slice(t - o, Math.min(i.length, t + 100 - o));
  } }, { key: "column", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, r = this.lineAt(t, n), i = r.text, o = r.from, a = this.countColumn(i, t - o), s = this.options.overrideIndentation ? this.options.overrideIndentation(o) : -1;
    return s > -1 && (a += s - this.countColumn(i, i.search(/\S|$/))), a;
  } }, { key: "countColumn", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t.length;
    return Xc(t, this.state.tabSize, n);
  } }, { key: "lineIndent", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, r = this.lineAt(t, n), i = r.text, o = r.from, a = this.options.overrideIndentation;
    if (a) {
      var s = a(o);
      if (s > -1)
        return s;
    }
    return this.countColumn(i, i.search(/\S|$/));
  } }, { key: "simulatedBreak", get: function() {
    return this.options.simulateBreak || null;
  } }]), e;
}(), HP = new bn();
function gW(e) {
  var t = e.type.prop(HP);
  if (t)
    return t;
  var n, r = e.firstChild;
  if (r && (n = r.type.prop(bn.closedBy))) {
    var i = e.lastChild, o = i && n.indexOf(i.name) > -1;
    return function(a) {
      return function(s, u, c, l, f) {
        var h = s.textAfter, d = h.match(/^\s*/)[0].length, p = l && h.slice(d, d + l.length) == l || f == s.pos + d, v = u ? function(m) {
          var g = m.node, y = g.childAfter(g.from), b = g.lastChild;
          if (!y)
            return null;
          for (var k = m.options.simulateBreak, w = m.state.doc.lineAt(y.from), x = k == null || k <= w.from ? w.to : Math.min(w.to, k), S = y.to; ; ) {
            var T = g.childAfter(S);
            if (!T || T == b)
              return null;
            if (!T.type.isSkipped)
              return T.from < x ? y : null;
            S = T.to;
          }
        }(s) : null;
        return v ? p ? s.column(v.from) : s.column(v.to) : s.baseIndent + (p ? 0 : s.unit * c);
      }(a, !0, 1, void 0, o && !function(s) {
        return s.pos == s.options.simulateBreak && s.options.simulateDoubleBreak;
      }(a) ? i.from : void 0);
    };
  }
  return e.parent == null ? yW : null;
}
function WP(e, t, n) {
  for (; e; e = e.parent) {
    var r = gW(e);
    if (r)
      return r(bW.create(n, t, e));
  }
  return null;
}
function yW() {
  return 0;
}
var bW = function(e) {
  Et(n, hd);
  var t = Mt(n);
  function n(r, i, o) {
    var a;
    return Z(this, n), (a = t.call(this, r.state, r.options)).base = r, a.pos = i, a.node = o, a;
  }
  return Y(n, [{ key: "textAfter", get: function() {
    return this.textAfterPos(this.pos);
  } }, { key: "baseIndent", get: function() {
    for (var r = this.state.doc.lineAt(this.node.from); ; ) {
      for (var i = this.node.resolve(r.from); i.parent && i.parent.from == i.from; )
        i = i.parent;
      if (kW(i, this.node))
        break;
      r = this.state.doc.lineAt(i.from);
    }
    return this.lineIndent(r.from);
  } }, { key: "continue", value: function() {
    var r = this.node.parent;
    return r ? WP(r, this.pos, this.base) : 0;
  } }], [{ key: "create", value: function(r, i, o) {
    return new n(r, i, o);
  } }]), n;
}();
function kW(e, t) {
  for (var n = t; n; n = n.parent)
    if (e == n)
      return !0;
  return !1;
}
function K4() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.except, n = e.units, r = n === void 0 ? 1 : n;
  return function(i) {
    var o = t && t.test(i.textAfter);
    return i.baseIndent + (o ? 0 : r * i.unit);
  };
}
var wW = be.define(), UP = new bn();
function th(e, t, n) {
  var r, i = ut(e.facet(wW));
  try {
    for (i.s(); !(r = i.n()).done; ) {
      var o = (0, r.value)(e, t, n);
      if (o)
        return o;
    }
  } catch (a) {
    i.e(a);
  } finally {
    i.f();
  }
  return function(a, s, u) {
    var c = Or(a);
    if (c.length < u)
      return null;
    for (var l, f, h = null, d = c.resolveInner(u); d; d = d.parent)
      if (!(d.to <= u || d.from > u)) {
        if (h && d.from < s)
          break;
        var p = d.type.prop(UP);
        if (p && (d.to < c.length - 50 || c.length == a.doc.length || (f = void 0, !(f = (l = d).lastChild) || f.to != l.to || !f.type.isError))) {
          var v = p(d, a);
          v && v.from <= u && v.from >= s && v.to > u && (h = v);
        }
      }
    return h;
  }(e, t, n);
}
function JP(e, t) {
  var n = t.mapPos(e.from, 1), r = t.mapPos(e.to, -1);
  return n >= r ? void 0 : { from: n, to: r };
}
var eh = He.define({ map: JP }), jc = He.define({ map: JP });
function G4(e) {
  var t, n = [], r = ut(e.state.selection.ranges);
  try {
    var i = function() {
      var o = t.value.head;
      if (n.some(function(a) {
        return a.from <= o && a.to >= o;
      }))
        return "continue";
      n.push(e.lineBlockAt(o));
    };
    for (r.s(); !(t = r.n()).done; )
      i();
  } catch (o) {
    r.e(o);
  } finally {
    r.f();
  }
  return n;
}
var Ua = br.define({ create: function() {
  return $e.none;
}, update: function(e, t) {
  e = e.map(t.changes);
  var n, r = ut(t.effects);
  try {
    var i = function() {
      var s = n.value;
      s.is(eh) && !function(u, c, l) {
        var f = !1;
        return u.between(c, c, function(h, d) {
          h == c && d == l && (f = !0);
        }), f;
      }(e, s.value.from, s.value.to) ? e = e.update({ add: [Z4.range(s.value.from, s.value.to)] }) : s.is(jc) && (e = e.update({ filter: function(u, c) {
        return s.value.from != u || s.value.to != c;
      }, filterFrom: s.value.from, filterTo: s.value.to }));
    };
    for (r.s(); !(n = r.n()).done; )
      i();
  } catch (s) {
    r.e(s);
  } finally {
    r.f();
  }
  if (t.selection) {
    var o = !1, a = t.selection.main.head;
    e.between(a, a, function(s, u) {
      s < a && u > a && (o = !0);
    }), o && (e = e.update({ filterFrom: a, filterTo: a, filter: function(s, u) {
      return u <= a || s >= a;
    } }));
  }
  return e;
}, provide: function(e) {
  return we.decorations.from(e);
}, toJSON: function(e, t) {
  var n = [];
  return e.between(0, t.doc.length, function(r, i) {
    n.push(r, i);
  }), n;
}, fromJSON: function(e) {
  if (!Array.isArray(e) || e.length % 2)
    throw new RangeError("Invalid JSON for fold state");
  for (var t = [], n = 0; n < e.length; ) {
    var r = e[n++], i = e[n++];
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid JSON for fold state");
    t.push(Z4.range(r, i));
  }
  return $e.set(t, !0);
} });
function nh(e, t, n) {
  var r, i = null;
  return (r = e.field(Ua, !1)) === null || r === void 0 || r.between(t, n, function(o, a) {
    (!i || i.from > o) && (i = { from: o, to: a });
  }), i;
}
function Q4(e, t) {
  return e.field(Ua, !1) ? t : t.concat(He.appendConfig.of(GP()));
}
function X4(e, t) {
  var n = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], r = e.state.doc.lineAt(t.from).number, i = e.state.doc.lineAt(t.to).number;
  return we.announce.of("".concat(e.state.phrase(n ? "Folded lines" : "Unfolded lines"), " ").concat(r, " ").concat(e.state.phrase("to"), " ").concat(i, "."));
}
var xW = [{ key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: function(e) {
  var t, n = ut(G4(e));
  try {
    for (n.s(); !(t = n.n()).done; ) {
      var r = t.value, i = th(e.state, r.from, r.to);
      if (i)
        return e.dispatch({ effects: Q4(e.state, [eh.of(i), X4(e, i)]) }), !0;
    }
  } catch (o) {
    n.e(o);
  } finally {
    n.f();
  }
  return !1;
} }, { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: function(e) {
  if (!e.state.field(Ua, !1))
    return !1;
  var t, n = [], r = ut(G4(e));
  try {
    for (r.s(); !(t = r.n()).done; ) {
      var i = t.value, o = nh(e.state, i.from, i.to);
      o && n.push(jc.of(o), X4(e, o, !1));
    }
  } catch (a) {
    r.e(a);
  } finally {
    r.f();
  }
  return n.length && e.dispatch({ effects: n }), n.length > 0;
} }, { key: "Ctrl-Alt-[", run: function(e) {
  for (var t = e.state, n = [], r = 0; r < t.doc.length; ) {
    var i = e.lineBlockAt(r), o = th(t, i.from, i.to);
    o && n.push(eh.of(o)), r = (o ? e.lineBlockAt(o.to) : i).to + 1;
  }
  return n.length && e.dispatch({ effects: Q4(e.state, n) }), !!n.length;
} }, { key: "Ctrl-Alt-]", run: function(e) {
  var t = e.state.field(Ua, !1);
  if (!t || !t.size)
    return !1;
  var n = [];
  return t.between(0, e.state.doc.length, function(r, i) {
    n.push(jc.of({ from: r, to: i }));
  }), e.dispatch({ effects: n }), !0;
} }], jW = { placeholderDOM: null, placeholderText: "\u2026" }, KP = be.define({ combine: function(e) {
  return ko(e, jW);
} });
function GP(e) {
  var t = [Ua, _W];
  return e && t.push(KP.of(e)), t;
}
var Z4 = $e.replace({ widget: new (function(e) {
  Et(n, ba);
  var t = Mt(n);
  function n() {
    return Z(this, n), t.apply(this, arguments);
  }
  return Y(n, [{ key: "toDOM", value: function(r) {
    var i = r.state, o = i.facet(KP), a = function(u) {
      var c = r.lineBlockAt(r.posAtDOM(u.target)), l = nh(r.state, c.from, c.to);
      l && r.dispatch({ effects: jc.of(l) }), u.preventDefault();
    };
    if (o.placeholderDOM)
      return o.placeholderDOM(r, a);
    var s = document.createElement("span");
    return s.textContent = o.placeholderText, s.setAttribute("aria-label", i.phrase("folded code")), s.title = i.phrase("unfold"), s.className = "cm-foldPlaceholder", s.onclick = a, s;
  } }]), n;
}())() }), SW = { openText: "\u2304", closedText: "\u203A", markerDOM: null, domEventHandlers: {}, foldingChanged: function() {
  return !1;
} }, uv = function(e) {
  Et(n, eo);
  var t = Mt(n);
  function n(r, i) {
    var o;
    return Z(this, n), (o = t.call(this)).config = r, o.open = i, o;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return this.config == r.config && this.open == r.open;
  } }, { key: "toDOM", value: function(r) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    var i = document.createElement("span");
    return i.textContent = this.open ? this.config.openText : this.config.closedText, i.title = r.state.phrase(this.open ? "Fold line" : "Unfold line"), i;
  } }]), n;
}();
function $W() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Object.assign(Object.assign({}, SW), e), n = new uv(t, !0), r = new uv(t, !1), i = wr.fromClass(function() {
    function a(s) {
      Z(this, a), this.from = s.viewport.from, this.markers = this.buildMarkers(s);
    }
    return Y(a, [{ key: "update", value: function(s) {
      (s.docChanged || s.viewportChanged || s.startState.facet(la) != s.state.facet(la) || s.startState.field(Ua, !1) != s.state.field(Ua, !1) || Or(s.startState) != Or(s.state) || t.foldingChanged(s)) && (this.markers = this.buildMarkers(s.view));
    } }, { key: "buildMarkers", value: function(s) {
      var u, c = new Vs(), l = ut(s.viewportLineBlocks);
      try {
        for (l.s(); !(u = l.n()).done; ) {
          var f = u.value, h = nh(s.state, f.from, f.to) ? r : th(s.state, f.from, f.to) ? n : null;
          h && c.add(f.from, f.from, h);
        }
      } catch (d) {
        l.e(d);
      } finally {
        l.f();
      }
      return c.finish();
    } }]), a;
  }()), o = t.domEventHandlers;
  return [i, EP({ class: "cm-foldGutter", markers: function(a) {
    var s;
    return ((s = a.plugin(i)) === null || s === void 0 ? void 0 : s.markers) || Nn.empty;
  }, initialSpacer: function() {
    return new uv(t, !1);
  }, domEventHandlers: Object.assign(Object.assign({}, o), { click: function(a, s, u) {
    if (o.click && o.click(a, s, u))
      return !0;
    var c = nh(a.state, s.from, s.to);
    if (c)
      return a.dispatch({ effects: jc.of(c) }), !0;
    var l = th(a.state, s.from, s.to);
    return !!l && (a.dispatch({ effects: eh.of(l) }), !0);
  } }) }), GP()];
}
var _W = we.baseTheme({ ".cm-foldPlaceholder": { backgroundColor: "#eee", border: "1px solid #ddd", color: "#888", borderRadius: ".2em", margin: "0 1px", padding: "0 1px", cursor: "pointer" }, ".cm-foldGutter span": { padding: "0 1px", cursor: "pointer" } }), k0 = function() {
  function e(t, n) {
    var r;
    function i(s) {
      var u = ua.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + u] = s, u;
    }
    Z(this, e);
    var o = typeof n.all == "string" ? n.all : n.all ? i(n.all) : void 0, a = n.scope;
    this.scope = a instanceof Mi ? function(s) {
      return s.prop(wc) == a.data;
    } : a ? function(s) {
      return s == a;
    } : void 0, this.style = qP(t.map(function(s) {
      return { tag: s.tag, class: s.class || i(Object.assign({}, s, { tag: null })) };
    }), { all: o }).style, this.module = r ? new ua(r) : null, this.themeType = n.themeType;
  }
  return Y(e, null, [{ key: "define", value: function(t, n) {
    return new e(t, n || {});
  } }]), e;
}(), rm = be.define(), QP = be.define({ combine: function(e) {
  return e.length ? [e[0]] : null;
} });
function cv(e) {
  var t = e.facet(rm);
  return t.length ? t : e.facet(QP);
}
function XP(e, t) {
  var n, r = [OW];
  return e instanceof k0 && (e.module && r.push(we.styleModule.of(e.module)), n = e.themeType), t != null && t.fallback ? r.push(QP.of(e)) : n ? r.push(rm.computeN([we.darkTheme], function(i) {
    return i.facet(we.darkTheme) == (n == "dark") ? [e] : [];
  })) : r.push(rm.of(e)), r;
}
var CW = function() {
  function e(t) {
    Z(this, e), this.markCache = /* @__PURE__ */ Object.create(null), this.tree = Or(t.state), this.decorations = this.buildDeco(t, cv(t.state));
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n = Or(t.state), r = cv(t.state), i = r != cv(t.startState);
    n.length < t.view.viewport.to && !i && n.type == this.tree.type ? this.decorations = this.decorations.map(t.changes) : (n != this.tree || t.viewportChanged || i) && (this.tree = n, this.decorations = this.buildDeco(t.view, r));
  } }, { key: "buildDeco", value: function(t, n) {
    var r = this;
    if (!n || !this.tree.length)
      return $e.none;
    var i, o = new Vs(), a = ut(t.visibleRanges);
    try {
      for (a.s(); !(i = a.n()).done; ) {
        var s = i.value, u = s.from, c = s.to;
        cW(this.tree, n, function(l, f, h) {
          o.add(l, f, r.markCache[h] || (r.markCache[h] = $e.mark({ class: h })));
        }, u, c);
      }
    } catch (l) {
      a.e(l);
    } finally {
      a.f();
    }
    return o.finish();
  } }]), e;
}(), OW = Qc.high(wr.fromClass(CW, { decorations: function(e) {
  return e.decorations;
} })), AW = k0.define([{ tag: Jt.meta, color: "#7a757a" }, { tag: Jt.link, textDecoration: "underline" }, { tag: Jt.heading, textDecoration: "underline", fontWeight: "bold" }, { tag: Jt.emphasis, fontStyle: "italic" }, { tag: Jt.strong, fontWeight: "bold" }, { tag: Jt.strikethrough, textDecoration: "line-through" }, { tag: Jt.keyword, color: "#708" }, { tag: [Jt.atom, Jt.bool, Jt.url, Jt.contentSeparator, Jt.labelName], color: "#219" }, { tag: [Jt.literal, Jt.inserted], color: "#164" }, { tag: [Jt.string, Jt.deleted], color: "#a11" }, { tag: [Jt.regexp, Jt.escape, Jt.special(Jt.string)], color: "#e40" }, { tag: Jt.definition(Jt.variableName), color: "#00f" }, { tag: Jt.local(Jt.variableName), color: "#30a" }, { tag: [Jt.typeName, Jt.namespace], color: "#085" }, { tag: Jt.className, color: "#167" }, { tag: [Jt.special(Jt.variableName), Jt.macroName], color: "#256" }, { tag: Jt.definition(Jt.propertyName), color: "#00c" }, { tag: Jt.comment, color: "#940" }, { tag: Jt.invalid, color: "#f00" }]), PW = we.baseTheme({ "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" }, "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" } }), ZP = be.define({ combine: function(e) {
  return ko(e, { afterCursor: !0, brackets: "()[]{}", maxScanDistance: 1e4, renderMatch: TW });
} }), EW = $e.mark({ class: "cm-matchingBracket" }), MW = $e.mark({ class: "cm-nonmatchingBracket" });
function TW(e) {
  var t = [], n = e.matched ? EW : MW;
  return t.push(n.range(e.start.from, e.start.to)), e.end && t.push(n.range(e.end.from, e.end.to)), t;
}
var IW = [br.define({ create: function() {
  return $e.none;
}, update: function(e, t) {
  if (!t.docChanged && !t.selection)
    return e;
  var n, r = [], i = t.state.facet(ZP), o = ut(t.state.selection.ranges);
  try {
    for (o.s(); !(n = o.n()).done; ) {
      var a = n.value;
      if (a.empty) {
        var s = ro(t.state, a.head, -1, i) || a.head > 0 && ro(t.state, a.head - 1, 1, i) || i.afterCursor && (ro(t.state, a.head, 1, i) || a.head < t.state.doc.length && ro(t.state, a.head + 1, -1, i));
        s && (r = r.concat(i.renderMatch(s, t.state)));
      }
    }
  } catch (u) {
    o.e(u);
  } finally {
    o.f();
  }
  return $e.set(r, !0);
}, provide: function(e) {
  return we.decorations.from(e);
} }), PW];
function NW() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return [ZP.of(e), IW];
}
function im(e, t, n) {
  var r = e.prop(t < 0 ? bn.openedBy : bn.closedBy);
  if (r)
    return r;
  if (e.name.length == 1) {
    var i = n.indexOf(e.name);
    if (i > -1 && i % 2 == (t < 0 ? 1 : 0))
      return [n[i + t]];
  }
  return null;
}
function ro(e, t, n) {
  for (var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = r.maxScanDistance || 1e4, o = r.brackets || "()[]{}", a = Or(e), s = a.resolveInner(t, n), u = s; u; u = u.parent) {
    var c = im(u.type, n, o);
    if (c && u.from < u.to)
      return RW(e, t, n, u, c, o);
  }
  return DW(e, t, n, a, s.type, i, o);
}
function RW(e, t, n, r, i, o) {
  var a = r.parent, s = { from: r.from, to: r.to }, u = 0, c = a == null ? void 0 : a.cursor();
  if (c && (n < 0 ? c.childBefore(r.from) : c.childAfter(r.to)))
    do
      if (n < 0 ? c.to <= r.from : c.from >= r.to) {
        if (u == 0 && i.indexOf(c.type.name) > -1 && c.from < c.to)
          return { start: s, end: { from: c.from, to: c.to }, matched: !0 };
        if (im(c.type, n, o))
          u++;
        else if (im(c.type, -n, o) && --u == 0)
          return { start: s, end: c.from == c.to ? void 0 : { from: c.from, to: c.to }, matched: !1 };
      }
    while (n < 0 ? c.prevSibling() : c.nextSibling());
  return { start: s, matched: !1 };
}
function DW(e, t, n, r, i, o, a) {
  var s = n < 0 ? e.sliceDoc(t - 1, t) : e.sliceDoc(t, t + 1), u = a.indexOf(s);
  if (u < 0 || u % 2 == 0 != n > 0)
    return null;
  for (var c = { from: n < 0 ? t - 1 : t, to: n > 0 ? t + 1 : t }, l = e.doc.iterRange(t, n > 0 ? e.doc.length : 0), f = 0, h = 0; !l.next().done && h <= o; ) {
    var d = l.value;
    n < 0 && (h += d.length);
    for (var p = t + h * n, v = n > 0 ? 0 : d.length - 1, m = n > 0 ? d.length : -1; v != m; v += n) {
      var g = a.indexOf(d[v]);
      if (!(g < 0 || r.resolveInner(p + v, 1).type != i))
        if (g % 2 == 0 == n > 0)
          f++;
        else {
          if (f == 1)
            return { start: c, end: { from: p + v, to: p + v + 1 }, matched: g >> 1 == u >> 1 };
          f--;
        }
    }
    n > 0 && (h += d.length);
  }
  return l.done ? { start: c, matched: !1 } : null;
}
for (var LW = /* @__PURE__ */ Object.create(null), Y4 = [po.none], t3 = [], zW = /* @__PURE__ */ Object.create(null), lv = 0, e3 = [["variable", "variableName"], ["variable-2", "variableName.special"], ["string-2", "string.special"], ["def", "variableName.definition"], ["tag", "tagName"], ["attribute", "attributeName"], ["type", "typeName"], ["builtin", "variableName.standard"], ["qualifier", "modifier"], ["error", "invalid"], ["header", "heading"], ["property", "propertyName"]]; lv < e3.length; lv++) {
  var n3 = xe(e3[lv], 2), BW = n3[0], FW = n3[1];
  zW[BW] = qW(LW, FW);
}
function fv(e, t) {
  t3.indexOf(e) > -1 || (t3.push(e), console.warn(t));
}
function qW(e, t) {
  var n, r = null, i = ut(t.split("."));
  try {
    for (i.s(); !(n = i.n()).done; ) {
      var o = n.value, a = e[o] || Jt[o];
      a ? typeof a == "function" ? r ? r = a(r) : fv(o, "Modifier ".concat(o, " used at start of tag")) : r ? fv(o, "Tag ".concat(o, " used as modifier")) : r = a : fv(o, "Unknown highlighting tag ".concat(o));
    }
  } catch (c) {
    i.e(c);
  } finally {
    i.f();
  }
  if (!r)
    return 0;
  var s = t.replace(/ /g, "_"), u = po.define({ id: Y4.length, name: s, props: [BP(na({}, s, r))] });
  return Y4.push(u), u.id;
}
var VW = 0, zn = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Z(this, e), this.id = VW++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function() {
      throw new Error("This node type doesn't define a deserialize function");
    };
  }
  return Y(e, [{ key: "add", value: function(t) {
    var n = this;
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = Ja.match(t)), function(r) {
      var i = t(r);
      return i === void 0 ? null : [n, i];
    };
  } }]), e;
}();
zn.closedBy = new zn({ deserialize: function(e) {
  return e.split(" ");
} }), zn.openedBy = new zn({ deserialize: function(e) {
  return e.split(" ");
} }), zn.group = new zn({ deserialize: function(e) {
  return e.split(" ");
} }), zn.contextHash = new zn({ perNode: !0 }), zn.lookAhead = new zn({ perNode: !0 }), zn.mounted = new zn({ perNode: !0 });
var HW = /* @__PURE__ */ Object.create(null), Ja = function() {
  function e(t, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    Z(this, e), this.name = t, this.props = n, this.id = r, this.flags = i;
  }
  return Y(e, [{ key: "prop", value: function(t) {
    return this.props[t.id];
  } }, { key: "isTop", get: function() {
    return (1 & this.flags) > 0;
  } }, { key: "isSkipped", get: function() {
    return (2 & this.flags) > 0;
  } }, { key: "isError", get: function() {
    return (4 & this.flags) > 0;
  } }, { key: "isAnonymous", get: function() {
    return (8 & this.flags) > 0;
  } }, { key: "is", value: function(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      var n = this.prop(zn.group);
      return !!n && n.indexOf(t) > -1;
    }
    return this.id == t;
  } }], [{ key: "define", value: function(t) {
    var n = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : HW, r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new e(t.name || "", n, t.id, r);
    if (t.props) {
      var o, a = ut(t.props);
      try {
        for (a.s(); !(o = a.n()).done; ) {
          var s = o.value;
          if (Array.isArray(s) || (s = s(i)), s) {
            if (s[0].perNode)
              throw new RangeError("Can't store a per-node prop on a node type");
            n[s[0].id] = s[1];
          }
        }
      } catch (u) {
        a.e(u);
      } finally {
        a.f();
      }
    }
    return i;
  } }, { key: "match", value: function(t) {
    var n = /* @__PURE__ */ Object.create(null);
    for (var r in t) {
      var i, o = ut(r.split(" "));
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var a = i.value;
          n[a] = t[r];
        }
      } catch (s) {
        o.e(s);
      } finally {
        o.f();
      }
    }
    return function(s) {
      for (var u = s.prop(zn.group), c = -1; c < (u ? u.length : 0); c++) {
        var l = n[c < 0 ? s.name : u[c]];
        if (l)
          return l;
      }
    };
  } }]), e;
}();
Ja.none = new Ja("", /* @__PURE__ */ Object.create(null), 0, 8);
var Tr, zl = /* @__PURE__ */ new WeakMap(), r3 = /* @__PURE__ */ new WeakMap();
(function(e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Tr || (Tr = {}));
var za = function() {
  function e(t, n, r, i, o) {
    if (Z(this, e), this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      var a, s = ut(o);
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var u = xe(a.value, 2), c = u[0], l = u[1];
          this.props[typeof c == "number" ? c : c.id] = l;
        }
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
    }
  }
  return Y(e, [{ key: "toString", value: function() {
    var t = this.prop(zn.mounted);
    if (t && !t.overlay)
      return t.tree.toString();
    var n, r = "", i = ut(this.children);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value.toString();
        o && (r && (r += ","), r += o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (r.length ? "(" + r + ")" : "") : r;
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new oh(this.topNode, t);
  } }, { key: "cursorAt", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = zl.get(this) || this.topNode, i = new oh(r);
    return i.moveTo(t, n), zl.set(this, i._tree), i;
  } }, { key: "topNode", get: function() {
    return new Sc(this, 0, 0, null);
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Js(zl.get(this) || this.topNode, t, n, !1);
    return zl.set(this, r), r;
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Js(r3.get(this) || this.topNode, t, n, !0);
    return r3.set(this, r), r;
  } }, { key: "iterate", value: function(t) {
    for (var n = t.enter, r = t.leave, i = t.from, o = i === void 0 ? 0 : i, a = t.to, s = a === void 0 ? this.length : a, u = this.cursor((t.mode || 0) | Tr.IncludeAnonymous); ; ) {
      var c = !1;
      if (u.from <= s && u.to >= o && (u.type.isAnonymous || n(u) !== !1)) {
        if (u.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && !u.type.isAnonymous && r(u), !u.nextSibling(); ) {
        if (!u.parent())
          return;
        c = !0;
      }
    }
  } }, { key: "prop", value: function(t) {
    return t.perNode ? this.props ? this.props[t.id] : void 0 : this.type.prop(t);
  } }, { key: "propValues", get: function() {
    var t = [];
    if (this.props)
      for (var n in this.props)
        t.push([+n, this.props[n]]);
    return t;
  } }, { key: "balance", value: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.children.length <= 8 ? this : x0(Ja.none, this.children, this.positions, 0, this.children.length, 0, this.length, function(r, i, o) {
      return new e(t.type, r, i, o, t.propValues);
    }, n.makeTree || function(r, i, o) {
      return new e(Ja.none, r, i, o);
    });
  } }], [{ key: "build", value: function(t) {
    return JW(t);
  } }]), e;
}();
za.empty = new za(Ja.none, [], [], 0);
var WW = function() {
  function e(t, n) {
    Z(this, e), this.buffer = t, this.index = n;
  }
  return Y(e, [{ key: "id", get: function() {
    return this.buffer[this.index - 4];
  } }, { key: "start", get: function() {
    return this.buffer[this.index - 3];
  } }, { key: "end", get: function() {
    return this.buffer[this.index - 2];
  } }, { key: "size", get: function() {
    return this.buffer[this.index - 1];
  } }, { key: "pos", get: function() {
    return this.index;
  } }, { key: "next", value: function() {
    this.index -= 4;
  } }, { key: "fork", value: function() {
    return new e(this.buffer, this.index);
  } }]), e;
}(), tl = function() {
  function e(t, n, r) {
    Z(this, e), this.buffer = t, this.length = n, this.set = r;
  }
  return Y(e, [{ key: "type", get: function() {
    return Ja.none;
  } }, { key: "toString", value: function() {
    for (var t = [], n = 0; n < this.buffer.length; )
      t.push(this.childString(n)), n = this.buffer[n + 3];
    return t.join(",");
  } }, { key: "childString", value: function(t) {
    var n = this.buffer[t], r = this.buffer[t + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), r == (t += 4))
      return o;
    for (var a = []; t < r; )
      a.push(this.childString(t)), t = this.buffer[t + 3];
    return o + "(" + a.join(",") + ")";
  } }, { key: "findChild", value: function(t, n, r, i, o) {
    for (var a = this.buffer, s = -1, u = t; u != n && !(YP(o, i, a[u + 1], a[u + 2]) && (s = u, r > 0)); u = a[u + 3])
      ;
    return s;
  } }, { key: "slice", value: function(t, n, r, i) {
    for (var o = this.buffer, a = new Uint16Array(n - t), s = t, u = 0; s < n; )
      a[u++] = o[s++], a[u++] = o[s++] - r, a[u++] = o[s++] - r, a[u++] = o[s++] - t;
    return new e(a, i - r, this.set);
  } }]), e;
}();
function YP(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function tE(e, t) {
  for (var n = e.childBefore(t); n; ) {
    var r = n.lastChild;
    if (!r || r.to != n.to)
      break;
    r.type.isError && r.from == r.to ? (e = n, n = r.prevSibling) : n = r;
  }
  return e;
}
function Js(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t); ) {
    var o = !r && e instanceof Sc && e.index < 0 ? null : e.parent;
    if (!o)
      return e;
    e = o;
  }
  var a = r ? 0 : Tr.IgnoreOverlays;
  if (r)
    for (var s = e, u = s.parent; u; u = (s = u).parent)
      s instanceof Sc && s.index < 0 && ((i = u.enter(t, n, a)) === null || i === void 0 ? void 0 : i.from) != s.from && (e = u);
  for (; ; ) {
    var c = e.enter(t, n, a);
    if (!c)
      return e;
    e = c;
  }
}
var Sc = function() {
  function e(t, n, r, i) {
    Z(this, e), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  return Y(e, [{ key: "type", get: function() {
    return this._tree.type;
  } }, { key: "name", get: function() {
    return this._tree.type.name;
  } }, { key: "to", get: function() {
    return this.from + this._tree.length;
  } }, { key: "nextChild", value: function(t, n, r, i) {
    for (var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, a = this; ; ) {
      for (var s = a._tree, u = s.children, c = s.positions, l = n > 0 ? u.length : -1; t != l; t += n) {
        var f = u[t], h = c[t] + a.from;
        if (YP(i, r, h, h + f.length)) {
          if (f instanceof tl) {
            if (o & Tr.ExcludeBuffers)
              continue;
            var d = f.findChild(0, f.buffer.length, n, r - h, i);
            if (d > -1)
              return new om(new UW(a, f, t, h), null, d);
          } else if (o & Tr.IncludeAnonymous || !f.type.isAnonymous || w0(f)) {
            var p = void 0;
            if (!(o & Tr.IgnoreMounts) && f.props && (p = f.prop(zn.mounted)) && !p.overlay)
              return new e(p.tree, h, t, a);
            var v = new e(f, h, t, a);
            return o & Tr.IncludeAnonymous || !v.type.isAnonymous ? v : v.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (o & Tr.IncludeAnonymous || !a.type.isAnonymous || (t = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)))
        return null;
    }
  } }, { key: "firstChild", get: function() {
    return this.nextChild(0, 1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.nextChild(0, 1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.nextChild(this._tree.children.length - 1, -1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!(i & Tr.IgnoreOverlays) && (r = this._tree.prop(zn.mounted)) && r.overlay) {
      var o, a = t - this.from, s = ut(r.overlay);
      try {
        for (s.s(); !(o = s.n()).done; ) {
          var u = o.value, c = u.from, l = u.to;
          if ((n > 0 ? c <= a : c < a) && (n < 0 ? l >= a : l > a))
            return new e(r.tree, r.overlay[0].from + this.from, -1, this);
        }
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
    }
    return this.nextChild(0, 1, t, n, i);
  } }, { key: "nextSignificantParent", value: function() {
    for (var t = this; t.type.isAnonymous && t._parent; )
      t = t._parent;
    return t;
  } }, { key: "parent", get: function() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  } }, { key: "nextSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
  } }, { key: "prevSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new oh(this, t);
  } }, { key: "tree", get: function() {
    return this._tree;
  } }, { key: "toTree", value: function() {
    return this._tree;
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Js(this, t, n, !1);
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Js(this, t, n, !0);
  } }, { key: "enterUnfinishedNodesBefore", value: function(t) {
    return tE(this, t);
  } }, { key: "getChild", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, i = rh(this, t, n, r);
    return i.length ? i[0] : null;
  } }, { key: "getChildren", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return rh(this, t, n, r);
  } }, { key: "toString", value: function() {
    return this._tree.toString();
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "matchContext", value: function(t) {
    return ih(this, t);
  } }]), e;
}();
function rh(e, t, n, r) {
  var i = e.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (; !i.type.is(n); )
      if (!i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function ih(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
var UW = Y(function e(t, n, r, i) {
  Z(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = i;
}), om = function() {
  function e(t, n, r) {
    Z(this, e), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
  }
  return Y(e, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "from", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  } }, { key: "to", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  } }, { key: "child", value: function(t, n, r) {
    var i = this.context.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
    return o < 0 ? null : new e(this.context, this, o);
  } }, { key: "firstChild", get: function() {
    return this.child(1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.child(-1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.child(1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.child(-1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (r & Tr.ExcludeBuffers)
      return null;
    var i = this.context.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
    return o < 0 ? null : new e(this.context, this, o);
  } }, { key: "parent", get: function() {
    return this._parent || this.context.parent.nextSignificantParent();
  } }, { key: "externalSibling", value: function(t) {
    return this._parent ? null : this.context.parent.nextChild(this.context.index + t, t, 0, 4);
  } }, { key: "nextSibling", get: function() {
    var t = this.context.buffer, n = t.buffer[this.index + 3];
    return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
  } }, { key: "prevSibling", get: function() {
    var t = this.context.buffer, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new oh(this, t);
  } }, { key: "tree", get: function() {
    return null;
  } }, { key: "toTree", value: function() {
    var t = [], n = [], r = this.context.buffer, i = this.index + 4, o = r.buffer[this.index + 3];
    if (o > i) {
      var a = r.buffer[this.index + 1], s = r.buffer[this.index + 2];
      t.push(r.slice(i, o, a, s)), n.push(0);
    }
    return new za(this.type, t, n, this.to - this.from);
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Js(this, t, n, !1);
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Js(this, t, n, !0);
  } }, { key: "enterUnfinishedNodesBefore", value: function(t) {
    return tE(this, t);
  } }, { key: "toString", value: function() {
    return this.context.buffer.childString(this.index);
  } }, { key: "getChild", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, i = rh(this, t, n, r);
    return i.length ? i[0] : null;
  } }, { key: "getChildren", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return rh(this, t, n, r);
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "matchContext", value: function(t) {
    return ih(this, t);
  } }]), e;
}(), oh = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (Z(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof Sc)
      this.yieldNode(t);
    else {
      this._tree = t.context.parent, this.buffer = t.context;
      for (var r = t._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = t, this.yieldBuf(t.index);
    }
  }
  return Y(e, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "yieldNode", value: function(t) {
    return !!t && (this._tree = t, this.type = t.type, this.from = t.from, this.to = t.to, !0);
  } }, { key: "yieldBuf", value: function(t, n) {
    this.index = t;
    var r = this.buffer, i = r.start, o = r.buffer;
    return this.type = n || o.set.types[o.buffer[t]], this.from = i + o.buffer[t + 1], this.to = i + o.buffer[t + 2], !0;
  } }, { key: "yield", value: function(t) {
    return !!t && (t instanceof Sc ? (this.buffer = null, this.yieldNode(t)) : (this.buffer = t.context, this.yieldBuf(t.index, t.type)));
  } }, { key: "toString", value: function() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  } }, { key: "enterChild", value: function(t, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(t < 0 ? this._tree._tree.children.length - 1 : 0, t, n, r, this.mode));
    var i = this.buffer.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.buffer.start, r);
    return !(o < 0) && (this.stack.push(this.index), this.yieldBuf(o));
  } }, { key: "firstChild", value: function() {
    return this.enterChild(1, 0, 4);
  } }, { key: "lastChild", value: function() {
    return this.enterChild(-1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.enterChild(1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.enterChild(-1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.mode;
    return this.buffer ? !(r & Tr.ExcludeBuffers) && this.enterChild(1, t, n) : this.yield(this._tree.enter(t, n, r));
  } }, { key: "parent", value: function() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Tr.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    var t = this.mode & Tr.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(t);
  } }, { key: "sibling", value: function(t) {
    if (!this.buffer)
      return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + t, t, 0, 4, this.mode));
    var n = this.buffer.buffer, r = this.stack.length - 1;
    if (t < 0) {
      var i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(i, this.index, -1, 0, 4));
    } else {
      var o = n.buffer[this.index + 3];
      if (o < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(o);
    }
    return r < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + t, t, 0, 4, this.mode));
  } }, { key: "nextSibling", value: function() {
    return this.sibling(1);
  } }, { key: "prevSibling", value: function() {
    return this.sibling(-1);
  } }, { key: "atLastNode", value: function(t) {
    var n, r, i = this.buffer;
    if (i) {
      if (t > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (var o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      n = i.index, r = i.parent;
    } else {
      var a = this._tree;
      n = a.index, r = a._parent;
    }
    for (; r; n = (s = r).index, r = s._parent, s) {
      var s;
      if (n > -1)
        for (var u = n + t, c = t < 0 ? -1 : r._tree.children.length; u != c; u += t) {
          var l = r._tree.children[u];
          if (this.mode & Tr.IncludeAnonymous || l instanceof tl || !l.type.isAnonymous || w0(l))
            return !1;
        }
    }
    return !0;
  } }, { key: "move", value: function(t, n) {
    if (n && this.enterChild(t, 0, 4))
      return !0;
    for (; ; ) {
      if (this.sibling(t))
        return !0;
      if (this.atLastNode(t) || !this.parent())
        return !1;
    }
  } }, { key: "next", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(1, t);
  } }, { key: "prev", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(-1, t);
  } }, { key: "moveTo", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0; (this.from == this.to || (n < 1 ? this.from >= t : this.from > t) || (n > -1 ? this.to <= t : this.to < t)) && this.parent(); )
      ;
    for (; this.enterChild(1, t, n); )
      ;
    return this;
  } }, { key: "node", get: function() {
    if (!this.buffer)
      return this._tree;
    var t = this.bufferNode, n = null, r = 0;
    if (t && t.context == this.buffer)
      t:
        for (var i = this.index, o = this.stack.length; o >= 0; ) {
          for (var a = t; a; a = a._parent)
            if (a.index == i) {
              if (i == this.index)
                return a;
              n = a, r = o + 1;
              break t;
            }
          i = this.stack[--o];
        }
    for (var s = r; s < this.stack.length; s++)
      n = new om(this.buffer, n, this.stack[s]);
    return this.bufferNode = new om(this.buffer, n, this.index);
  } }, { key: "tree", get: function() {
    return this.buffer ? null : this._tree._tree;
  } }, { key: "iterate", value: function(t, n) {
    for (var r = 0; ; ) {
      var i = !1;
      if (this.type.isAnonymous || t(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && n && n(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, i = !0;
      }
    }
  } }, { key: "matchContext", value: function(t) {
    if (!this.buffer)
      return ih(this.node, t);
    for (var n = this.buffer.buffer, r = n.set.types, i = t.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return ih(this.node, t, i);
      var a = r[n.buffer[this.stack[o]]];
      if (!a.isAnonymous) {
        if (t[i] && t[i] != a.name)
          return !1;
        i--;
      }
    }
    return !0;
  } }]), e;
}();
function w0(e) {
  return e.children.some(function(t) {
    return t instanceof tl || !t.type.isAnonymous || w0(t);
  });
}
function JW(e) {
  var t, n = e.buffer, r = e.nodeSet, i = e.maxBufferLength, o = i === void 0 ? 1024 : i, a = e.reused, s = a === void 0 ? [] : a, u = e.minRepeatType, c = u === void 0 ? r.types.length : u, l = Array.isArray(n) ? new WW(n, n.length) : n, f = r.types, h = 0, d = 0;
  function p(w, x, S, T, P) {
    for (var O = l.id, j = l.start, V = l.end, E = l.size, C = d; E < 0; ) {
      if (l.next(), E == -1) {
        var H = s[O];
        return S.push(H), void T.push(j - w);
      }
      if (E == -3)
        return void (h = O);
      if (E == -4)
        return void (d = O);
      throw new RangeError("Unrecognized record size: ".concat(E));
    }
    var X, F, G = f[O], M = j - w;
    if (V - j <= o && (F = function(kt, I) {
      var R = l.fork(), it = 0, N = 0, K = 0, z = R.end - o, at = { size: 0, start: 0, skip: 0 };
      t:
        for (var yt = R.pos - kt; R.pos > yt; ) {
          var jt = R.size;
          if (R.id == I && jt >= 0)
            at.size = it, at.start = N, at.skip = K, K += 4, it += 4, R.next();
          else {
            var Ft = R.pos - jt;
            if (jt < 0 || Ft < yt || R.start < z)
              break;
            var zt = R.id >= c ? 4 : 0, St = R.start;
            for (R.next(); R.pos > Ft; ) {
              if (R.size < 0) {
                if (R.size != -3)
                  break t;
                zt += 4;
              } else
                R.id >= c && (zt += 4);
              R.next();
            }
            N = St, it += jt, K += zt;
          }
        }
      return (I < 0 || it == kt) && (at.size = it, at.start = N, at.skip = K), at.size > 4 ? at : void 0;
    }(l.pos - x, P))) {
      for (var $ = new Uint16Array(F.size - F.skip), q = l.pos - F.size, B = $.length; l.pos > q; )
        B = g(F.start, $, B);
      X = new tl($, V - F.start, r), M = F.start - w;
    } else {
      var D = l.pos - E;
      l.next();
      for (var _ = [], L = [], J = O >= c ? O : -1, st = 0, ht = V; l.pos > D; )
        J >= 0 && l.id == J && l.size >= 0 ? (l.end <= ht - o && (v(_, L, j, st, l.end, ht, J, C), st = _.length, ht = l.end), l.next()) : p(j, D, _, L, J);
      if (J >= 0 && st > 0 && st < _.length && v(_, L, j, st, j, ht, J, C), _.reverse(), L.reverse(), J > -1 && st > 0) {
        var xt = function(kt) {
          return function(I, R, it) {
            var N, K, z = 0, at = I.length - 1;
            if (at >= 0 && (N = I[at]) instanceof za) {
              if (!at && N.type == kt && N.length == it)
                return N;
              (K = N.prop(zn.lookAhead)) && (z = R[at] + N.length + K);
            }
            return m(kt, I, R, it, z);
          };
        }(G);
        X = x0(G, _, L, 0, _.length, 0, V - j, xt, xt);
      } else
        X = m(G, _, L, V - j, C - V);
    }
    S.push(X), T.push(M);
  }
  function v(w, x, S, T, P, O, j, V) {
    for (var E = [], C = []; w.length > T; )
      E.push(w.pop()), C.push(x.pop() + S - P);
    w.push(m(r.types[j], E, C, O - P, V - O)), x.push(P - S);
  }
  function m(w, x, S, T) {
    var P = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, O = arguments.length > 5 ? arguments[5] : void 0;
    if (h) {
      var j = [zn.contextHash, h];
      O = O ? [j].concat(O) : [j];
    }
    if (P > 25) {
      var V = [zn.lookAhead, P];
      O = O ? [V].concat(O) : [V];
    }
    return new za(w, x, S, T, O);
  }
  function g(w, x, S) {
    var T = l.id, P = l.start, O = l.end, j = l.size;
    if (l.next(), j >= 0 && T < c) {
      var V = S;
      if (j > 4)
        for (var E = l.pos - (j - 4); l.pos > E; )
          S = g(w, x, S);
      x[--S] = V, x[--S] = O - w, x[--S] = P - w, x[--S] = T;
    } else
      j == -3 ? h = T : j == -4 && (d = T);
    return S;
  }
  for (var y = [], b = []; l.pos > 0; )
    p(e.start || 0, e.bufferStart || 0, y, b, -1);
  var k = (t = e.length) !== null && t !== void 0 ? t : y.length ? b[0] + y[0].length : 0;
  return new za(f[e.topID], y.reverse(), b.reverse(), k);
}
var i3 = /* @__PURE__ */ new WeakMap();
function ff(e, t) {
  if (!e.isAnonymous || t instanceof tl || t.type != e)
    return 1;
  var n = i3.get(t);
  if (n == null) {
    n = 1;
    var r, i = ut(t.children);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        if (o.type != e || !(o instanceof za)) {
          n = 1;
          break;
        }
        n += ff(e, o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    i3.set(t, n);
  }
  return n;
}
function x0(e, t, n, r, i, o, a, s, u) {
  for (var c = 0, l = r; l < i; l++)
    c += ff(e, t[l]);
  var f = Math.ceil(1.5 * c / 8), h = [], d = [];
  return function p(v, m, g, y, b) {
    for (var k = g; k < y; ) {
      var w = k, x = m[k], S = ff(e, v[k]);
      for (k++; k < y; k++) {
        var T = ff(e, v[k]);
        if (S + T >= f)
          break;
        S += T;
      }
      if (k == w + 1) {
        if (S > f) {
          var P = v[w];
          p(P.children, P.positions, 0, P.children.length, m[w] + b);
          continue;
        }
        h.push(v[w]);
      } else {
        var O = m[k - 1] + v[k - 1].length - x;
        h.push(x0(e, v, m, w, k, x, O, null, u));
      }
      d.push(x + b - o);
    }
  }(t, n, r, i, 0), (s || u)(h, d, a);
}
new zn({ perNode: !0 });
function j0(e, t) {
  return function(n) {
    var r = n.state, i = n.dispatch;
    if (r.readOnly)
      return !1;
    var o = e(t, r);
    return !!o && (i(r.update(o)), !0);
  };
}
var KW = j0(ZW, 0), GW = j0(eE, 0), QW = j0(function(e, t) {
  return eE(e, t, function(n) {
    var r, i = [], o = ut(n.selection.ranges);
    try {
      for (o.s(); !(r = o.n()).done; ) {
        var a = r.value, s = n.doc.lineAt(a.from), u = a.to <= s.to ? s : n.doc.lineAt(a.to), c = i.length - 1;
        c >= 0 && i[c].to > s.from ? i[c].to = u.to : i.push({ from: s.from, to: u.to });
      }
    } catch (l) {
      o.e(l);
    } finally {
      o.f();
    }
    return i;
  }(t));
}, 0);
function S0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.selection.main.head, n = e.languageDataAt("commentTokens", t);
  return n.length ? n[0] : {};
}
function XW(e, t, n, r) {
  var i, o, a = t.open, s = t.close, u = e.sliceDoc(n - 50, n), c = e.sliceDoc(r, r + 50), l = /\s*$/.exec(u)[0].length, f = /^\s*/.exec(c)[0].length, h = u.length - l;
  if (u.slice(h - a.length, h) == a && c.slice(f, f + s.length) == s)
    return { open: { pos: n - l, margin: l && 1 }, close: { pos: r + f, margin: f && 1 } };
  r - n <= 100 ? i = o = e.sliceDoc(n, r) : (i = e.sliceDoc(n, n + 50), o = e.sliceDoc(r - 50, r));
  var d = /^\s*/.exec(i)[0].length, p = /\s*$/.exec(o)[0].length, v = o.length - p - s.length;
  return i.slice(d, d + a.length) == a && o.slice(v, v + s.length) == s ? { open: { pos: n + d + a.length, margin: /\s/.test(i.charAt(d + a.length)) ? 1 : 0 }, close: { pos: r - p - s.length, margin: /\s/.test(o.charAt(v - 1)) ? 1 : 0 } } : null;
}
function eE(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.selection.ranges, r = n.map(function(h) {
    return S0(t, h.from).block;
  });
  if (!r.every(function(h) {
    return h;
  }))
    return null;
  var i = n.map(function(h, d) {
    return XW(t, r[d], h.from, h.to);
  });
  if (e != 2 && !i.every(function(h) {
    return h;
  }))
    return { changes: t.changes(n.map(function(h, d) {
      return i[d] ? [] : [{ from: h.from, insert: r[d].open + " " }, { from: h.to, insert: " " + r[d].close }];
    })) };
  if (e != 1 && i.some(function(h) {
    return h;
  })) {
    for (var o, a = [], s = 0; s < i.length; s++)
      if (o = i[s]) {
        var u = r[s], c = o, l = c.open, f = c.close;
        a.push({ from: l.pos - u.open.length, to: l.pos + l.margin }, { from: f.pos - f.margin, to: f.pos + u.close.length });
      }
    return { changes: a };
  }
  return null;
}
function ZW(e, t) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.selection.ranges, i = [], o = -1, a = ut(r);
  try {
    for (a.s(); !(n = a.n()).done; ) {
      for (var s = n.value, u = s.from, c = s.to, l = i.length, f = 1e9, h = u; h <= c; ) {
        var d = t.doc.lineAt(h);
        if (d.from > o && (u == c || c > d.from)) {
          o = d.from;
          var p = S0(t, h).line;
          if (!p)
            continue;
          var v = /^\s*/.exec(d.text)[0].length, m = v == d.length, g = d.text.slice(v, v + p.length) == p ? v : -1;
          v < d.text.length && v < f && (f = v), i.push({ line: d, comment: g, token: p, indent: v, empty: m, single: !1 });
        }
        h = d.to + 1;
      }
      if (f < 1e9)
        for (var y = l; y < i.length; y++)
          i[y].indent < i[y].line.text.length && (i[y].indent = f);
      i.length == l + 1 && (i[l].single = !0);
    }
  } catch (B) {
    a.e(B);
  } finally {
    a.f();
  }
  if (e != 2 && i.some(function(B) {
    return B.comment < 0 && (!B.empty || B.single);
  })) {
    var b, k = [], w = ut(i);
    try {
      for (w.s(); !(b = w.n()).done; ) {
        var x = b.value, S = x.line, T = x.token, P = x.indent, O = x.empty, j = x.single;
        !j && O || k.push({ from: S.from + P, insert: T + " " });
      }
    } catch (B) {
      w.e(B);
    } finally {
      w.f();
    }
    var V = t.changes(k);
    return { changes: V, selection: t.selection.map(V, 1) };
  }
  if (e != 1 && i.some(function(B) {
    return B.comment >= 0;
  })) {
    var E, C = [], H = ut(i);
    try {
      for (H.s(); !(E = H.n()).done; ) {
        var X = E.value, F = X.line, G = X.comment, M = X.token;
        if (G >= 0) {
          var $ = F.from + G, q = $ + M.length;
          F.text[q - F.from] == " " && q++, C.push({ from: $, to: q });
        }
      }
    } catch (B) {
      H.e(B);
    } finally {
      H.f();
    }
    return { changes: C };
  }
  return null;
}
var am = Ma.define(), YW = Ma.define(), tU = be.define(), nE = be.define({ combine: function(e) {
  return ko(e, { minDepth: 100, newGroupDelay: 500 }, { minDepth: Math.max, newGroupDelay: Math.min });
} }), $0 = br.define({ create: function() {
  return Xu.empty;
}, update: function(e, t) {
  var n, r, i = t.state.facet(nE), o = t.annotation(am);
  if (o) {
    var a = t.docChanged ? Ht.single((n = t.changes, r = 0, n.iterChangedRanges(function(p, v) {
      return r = v;
    }), r)) : void 0, s = $o.fromTransaction(t, a), u = o.side, c = u == 0 ? e.undone : e.done;
    return c = s ? sh(c, c.length, i.minDepth, s) : oE(c, t.startState.selection), new Xu(u == 0 ? o.rest : c, u == 0 ? c : o.rest);
  }
  var l = t.annotation(YW);
  if (l != "full" && l != "before" || (e = e.isolate()), t.annotation(Fr.addToHistory) === !1)
    return t.changes.empty ? e : e.addMapping(t.changes.desc);
  var f = $o.fromTransaction(t), h = t.annotation(Fr.time), d = t.annotation(Fr.userEvent);
  return f ? e = e.addChanges(f, h, d, i.newGroupDelay, i.minDepth) : t.selection && (e = e.addSelection(t.startState.selection, h, d, i.newGroupDelay)), l != "full" && l != "after" || (e = e.isolate()), e;
}, toJSON: function(e) {
  return { done: e.done.map(function(t) {
    return t.toJSON();
  }), undone: e.undone.map(function(t) {
    return t.toJSON();
  }) };
}, fromJSON: function(e) {
  return new Xu(e.done.map($o.fromJSON), e.undone.map($o.fromJSON));
} });
function eU() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return [$0, nE.of(e), we.domEventHandlers({ beforeinput: function(t, n) {
    var r = t.inputType == "historyUndo" ? _0 : t.inputType == "historyRedo" ? ah : null;
    return !!r && (t.preventDefault(), r(n));
  } })];
}
function dd(e, t) {
  return function(n) {
    var r = n.state, i = n.dispatch;
    if (!t && r.readOnly)
      return !1;
    var o = r.field($0, !1);
    if (!o)
      return !1;
    var a = o.pop(e, r, t);
    return !!a && (i(a), !0);
  };
}
var _0 = dd(0, !1), ah = dd(1, !1), nU = dd(0, !0), rU = dd(1, !0);
function rE(e) {
  return function(t) {
    var n = t.field($0, !1);
    if (!n)
      return 0;
    var r = e == 0 ? n.done : n.undone;
    return r.length - (r.length && !r[0].changes ? 1 : 0);
  };
}
var iU = rE(0), oU = rE(1), $o = function() {
  function e(t, n, r, i, o) {
    Z(this, e), this.changes = t, this.effects = n, this.mapped = r, this.startSelection = i, this.selectionsAfter = o;
  }
  return Y(e, [{ key: "setSelAfter", value: function(t) {
    return new e(this.changes, this.effects, this.mapped, this.startSelection, t);
  } }, { key: "toJSON", value: function() {
    var t, n, r;
    return { changes: (t = this.changes) === null || t === void 0 ? void 0 : t.toJSON(), mapped: (n = this.mapped) === null || n === void 0 ? void 0 : n.toJSON(), startSelection: (r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(), selectionsAfter: this.selectionsAfter.map(function(i) {
      return i.toJSON();
    }) };
  } }], [{ key: "fromJSON", value: function(t) {
    return new e(t.changes && qi.fromJSON(t.changes), [], t.mapped && As.fromJSON(t.mapped), t.startSelection && Ht.fromJSON(t.startSelection), t.selectionsAfter.map(Ht.fromJSON));
  } }, { key: "fromTransaction", value: function(t, n) {
    var r, i = vi, o = ut(t.startState.facet(tU));
    try {
      for (o.s(); !(r = o.n()).done; ) {
        var a = (0, r.value)(t);
        a.length && (i = i.concat(a));
      }
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
    return !i.length && t.changes.empty ? null : new e(t.changes.invert(t.startState.doc), i, void 0, n || t.startState.selection, vi);
  } }, { key: "selection", value: function(t) {
    return new e(void 0, vi, void 0, void 0, t);
  } }]), e;
}();
function sh(e, t, n, r) {
  var i = t + 1 > n + 20 ? t - n - 1 : 0, o = e.slice(i, t);
  return o.push(r), o;
}
function iE(e, t) {
  return e.length ? t.length ? e.concat(t) : e : t;
}
var vi = [];
function oE(e, t) {
  if (e.length) {
    var n = e[e.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - 200));
    return r.length && r[r.length - 1].eq(t) ? e : (r.push(t), sh(e, e.length - 1, 1e9, n.setSelAfter(r)));
  }
  return [$o.selection([t])];
}
function aU(e) {
  var t = e[e.length - 1], n = e.slice();
  return n[e.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1)), n;
}
function hv(e, t) {
  if (!e.length)
    return e;
  for (var n = e.length, r = vi; n; ) {
    var i = sU(e[n - 1], t, r);
    if (i.changes && !i.changes.empty || i.effects.length) {
      var o = e.slice(0, n);
      return o[n - 1] = i, o;
    }
    t = i.mapped, n--, r = i.selectionsAfter;
  }
  return r.length ? [$o.selection(r)] : vi;
}
function sU(e, t, n) {
  var r = iE(e.selectionsAfter.length ? e.selectionsAfter.map(function(s) {
    return s.map(t);
  }) : vi, n);
  if (!e.changes)
    return $o.selection(r);
  var i = e.changes.map(t), o = t.mapDesc(e.changes, !0), a = e.mapped ? e.mapped.composeDesc(o) : o;
  return new $o(i, He.mapEffects(e.effects, t), a, e.startSelection.map(o), r);
}
var uU = /^(input\.type|delete)($|\.)/, Xu = function() {
  function e(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : void 0;
    Z(this, e), this.done = t, this.undone = n, this.prevTime = r, this.prevUserEvent = i;
  }
  return Y(e, [{ key: "isolate", value: function() {
    return this.prevTime ? new e(this.done, this.undone) : this;
  } }, { key: "addChanges", value: function(t, n, r, i, o) {
    var a = this.done, s = a[a.length - 1];
    return new e(a = s && s.changes && !s.changes.empty && t.changes && (!r || uU.test(r)) && (!s.selectionsAfter.length && n - this.prevTime < i && function(u, c) {
      var l = [], f = !1;
      return u.iterChangedRanges(function(h, d) {
        return l.push(h, d);
      }), c.iterChangedRanges(function(h, d, p, v) {
        for (var m = 0; m < l.length; ) {
          var g = l[m++], y = l[m++];
          v >= g && p <= y && (f = !0);
        }
      }), f;
    }(s.changes, t.changes) || r == "input.type.compose") ? sh(a, a.length - 1, o, new $o(t.changes.compose(s.changes), iE(t.effects, s.effects), s.mapped, s.startSelection, vi)) : sh(a, a.length, o, t), vi, n, r);
  } }, { key: "addSelection", value: function(t, n, r, i) {
    var o, a, s = this.done.length ? this.done[this.done.length - 1].selectionsAfter : vi;
    return s.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && (o = s[s.length - 1], a = t, o.ranges.length == a.ranges.length && o.ranges.filter(function(u, c) {
      return u.empty != a.ranges[c].empty;
    }).length === 0) ? this : new e(oE(this.done, t), this.undone, n, r);
  } }, { key: "addMapping", value: function(t) {
    return new e(hv(this.done, t), hv(this.undone, t), this.prevTime, this.prevUserEvent);
  } }, { key: "pop", value: function(t, n, r) {
    var i = t == 0 ? this.done : this.undone;
    if (i.length == 0)
      return null;
    var o = i[i.length - 1];
    if (r && o.selectionsAfter.length)
      return n.update({ selection: o.selectionsAfter[o.selectionsAfter.length - 1], annotations: am.of({ side: t, rest: aU(i) }), userEvent: t == 0 ? "select.undo" : "select.redo", scrollIntoView: !0 });
    if (o.changes) {
      var a = i.length == 1 ? vi : i.slice(0, i.length - 1);
      return o.mapped && (a = hv(a, o.mapped)), n.update({ changes: o.changes, selection: o.startSelection, effects: o.effects, annotations: am.of({ side: t, rest: a }), filter: !1, userEvent: t == 0 ? "undo" : "redo", scrollIntoView: !0 });
    }
    return null;
  } }]), e;
}();
Xu.empty = new Xu(vi, vi);
var cU = [{ key: "Mod-z", run: _0, preventDefault: !0 }, { key: "Mod-y", mac: "Mod-Shift-z", run: ah, preventDefault: !0 }, { linux: "Ctrl-Shift-z", run: ah, preventDefault: !0 }, { key: "Mod-u", run: nU, preventDefault: !0 }, { key: "Alt-u", mac: "Mod-Shift-u", run: rU, preventDefault: !0 }];
function Ts(e, t) {
  return Ht.create(e.ranges.map(t), e.mainIndex);
}
function lo(e, t) {
  return e.update({ selection: t, scrollIntoView: !0, userEvent: "select" });
}
function _o(e, t) {
  var n = e.state, r = e.dispatch, i = Ts(n.selection, t);
  return !i.eq(n.selection) && (r(lo(n, i)), !0);
}
function vd(e, t) {
  return Ht.cursor(t ? e.to : e.from);
}
function aE(e, t) {
  return _o(e, function(n) {
    return n.empty ? e.moveByChar(n, t) : vd(n, t);
  });
}
function li(e) {
  return e.textDirectionAt(e.state.selection.main.head) == Wn.LTR;
}
var o3 = function(e) {
  return aE(e, !li(e));
}, a3 = function(e) {
  return aE(e, li(e));
};
function s3(e, t) {
  return _o(e, function(n) {
    return n.empty ? e.moveByGroup(n, t) : vd(n, t);
  });
}
function lU(e, t, n) {
  if (t.type.prop(n))
    return !0;
  var r = t.to - t.from;
  return r && (r > 2 || /[^\s,.;:]/.test(e.sliceDoc(t.from, t.to))) || t.firstChild;
}
function Bl(e, t, n) {
  for (var r = Or(e).resolveInner(t.head), i = n ? zn.closedBy : zn.openedBy, o = t.head; ; ) {
    var a = n ? r.childAfter(o) : r.childBefore(o);
    if (!a)
      break;
    lU(e, a, i) ? r = a : o = n ? a.to : a.from;
  }
  var s, u;
  return u = r.type.prop(i) && (s = n ? ro(e, r.from, 1) : ro(e, r.to, -1)) && s.matched ? n ? s.end.to : s.end.from : n ? r.to : r.from, Ht.cursor(u, n ? -1 : 1);
}
function sE(e, t) {
  return _o(e, function(n) {
    if (!n.empty)
      return vd(n, t);
    var r = e.moveVertically(n, t);
    return r.head != n.head ? r : e.moveToLineBoundary(n, t);
  });
}
var u3 = function(e) {
  return sE(e, !1);
}, c3 = function(e) {
  return sE(e, !0);
};
function uE(e) {
  return Math.max(e.defaultLineHeight, Math.min(e.dom.clientHeight, innerHeight) - 5);
}
function cE(e, t) {
  var n = e.state, r = Ts(n.selection, function(s) {
    return s.empty ? e.moveVertically(s, t, uE(e)) : vd(s, t);
  });
  if (r.eq(n.selection))
    return !1;
  var i, o = e.coordsAtPos(n.selection.main.head), a = e.scrollDOM.getBoundingClientRect();
  return o && o.top > a.top && o.bottom < a.bottom && o.top - a.top <= e.scrollDOM.scrollHeight - e.scrollDOM.scrollTop - e.scrollDOM.clientHeight && (i = we.scrollIntoView(r.main.head, { y: "start", yMargin: o.top - a.top })), e.dispatch(lo(n, r), { effects: i }), !0;
}
var l3 = function(e) {
  return cE(e, !1);
}, dv = function(e) {
  return cE(e, !0);
};
function pd(e, t, n) {
  var r = e.lineBlockAt(t.head), i = e.moveToLineBoundary(t, n);
  if (i.head == t.head && i.head != (n ? r.to : r.from) && (i = e.moveToLineBoundary(t, n, !1)), !n && i.head == r.from && r.length) {
    var o = /^\s*/.exec(e.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    o && t.head != r.from + o && (i = Ht.cursor(r.from + o));
  }
  return i;
}
var f3 = function(e) {
  return _o(e, function(t) {
    return pd(e, t, !0);
  });
}, h3 = function(e) {
  return _o(e, function(t) {
    return pd(e, t, !1);
  });
};
function io(e, t) {
  var n = Ts(e.state.selection, function(r) {
    var i = t(r);
    return Ht.range(r.anchor, i.head, i.goalColumn);
  });
  return !n.eq(e.state.selection) && (e.dispatch(lo(e.state, n)), !0);
}
function lE(e, t) {
  return io(e, function(n) {
    return e.moveByChar(n, t);
  });
}
var d3 = function(e) {
  return lE(e, !li(e));
}, v3 = function(e) {
  return lE(e, li(e));
};
function p3(e, t) {
  return io(e, function(n) {
    return e.moveByGroup(n, t);
  });
}
function fE(e, t) {
  return io(e, function(n) {
    return e.moveVertically(n, t);
  });
}
var m3 = function(e) {
  return fE(e, !1);
}, g3 = function(e) {
  return fE(e, !0);
};
function hE(e, t) {
  return io(e, function(n) {
    return e.moveVertically(n, t, uE(e));
  });
}
var y3 = function(e) {
  return hE(e, !1);
}, b3 = function(e) {
  return hE(e, !0);
}, k3 = function(e) {
  return io(e, function(t) {
    return pd(e, t, !0);
  });
}, w3 = function(e) {
  return io(e, function(t) {
    return pd(e, t, !1);
  });
}, x3 = function(e) {
  var t = e.state;
  return (0, e.dispatch)(lo(t, { anchor: 0 })), !0;
}, j3 = function(e) {
  var t = e.state;
  return (0, e.dispatch)(lo(t, { anchor: t.doc.length })), !0;
}, S3 = function(e) {
  var t = e.state;
  return (0, e.dispatch)(lo(t, { anchor: t.selection.main.anchor, head: 0 })), !0;
}, $3 = function(e) {
  var t = e.state;
  return (0, e.dispatch)(lo(t, { anchor: t.selection.main.anchor, head: t.doc.length })), !0;
};
function md(e, t) {
  var n = e.state, r = e.dispatch;
  if (n.readOnly)
    return !1;
  var i = "delete.selection", o = n.changeByRange(function(a) {
    var s = a.from, u = a.to;
    if (s == u) {
      var c = t(s);
      c < s ? i = "delete.backward" : c > s && (i = "delete.forward"), s = Math.min(s, c), u = Math.max(u, c);
    }
    return s == u ? { range: a } : { changes: { from: s, to: u }, range: Ht.cursor(s) };
  });
  return !o.changes.empty && (r(n.update(o, { scrollIntoView: !0, userEvent: i, effects: i == "delete.selection" ? we.announce.of(n.phrase("Selection deleted")) : void 0 })), !0);
}
function gd(e, t, n) {
  if (e instanceof we) {
    var r, i = ut(e.state.facet(we.atomicRanges).map(function(o) {
      return o(e);
    }));
    try {
      for (i.s(); !(r = i.n()).done; )
        r.value.between(t, t, function(o, a) {
          o < t && a > t && (t = n ? a : o);
        });
    } catch (o) {
      i.e(o);
    } finally {
      i.f();
    }
  }
  return t;
}
var dE = function(e, t) {
  return md(e, function(n) {
    var r, i, o = e.state, a = o.doc.lineAt(n);
    if (!t && n > a.from && n < a.from + 200 && !/[^ \t]/.test(r = a.text.slice(0, n - a.from))) {
      if (r[r.length - 1] == "	")
        return n - 1;
      for (var s = Xc(r, o.tabSize) % Yf(o) || Yf(o), u = 0; u < s && r[r.length - 1 - u] == " "; u++)
        n--;
      i = n;
    } else
      (i = Xr(a.text, n - a.from, t, t) + a.from) == n && a.number != (t ? o.doc.lines : 1) && (i += t ? 1 : -1);
    return gd(e, i, t);
  });
}, vv = function(e) {
  return dE(e, !1);
}, _3 = function(e) {
  return dE(e, !0);
}, vE = function(e, t) {
  return md(e, function(n) {
    for (var r = n, i = e.state, o = i.doc.lineAt(r), a = i.charCategorizer(r), s = null; ; ) {
      if (r == (t ? o.to : o.from)) {
        r == n && o.number != (t ? i.doc.lines : 1) && (r += t ? 1 : -1);
        break;
      }
      var u = Xr(o.text, r - o.from, t) + o.from, c = o.text.slice(Math.min(r, u) - o.from, Math.max(r, u) - o.from), l = a(c);
      if (s != null && l != s)
        break;
      c == " " && r == n || (s = l), r = u;
    }
    return gd(e, r, t);
  });
}, C3 = function(e) {
  return vE(e, !1);
}, O3 = function(e) {
  return md(e, function(t) {
    var n = e.lineBlockAt(t).to;
    return gd(e, t < n ? n : Math.min(e.state.doc.length, t + 1), !0);
  });
};
function uh(e) {
  var t, n = [], r = -1, i = ut(e.selection.ranges);
  try {
    for (i.s(); !(t = i.n()).done; ) {
      var o = t.value, a = e.doc.lineAt(o.from), s = e.doc.lineAt(o.to);
      if (o.empty || o.to != s.from || (s = e.doc.lineAt(o.to - 1)), r >= a.number) {
        var u = n[n.length - 1];
        u.to = s.to, u.ranges.push(o);
      } else
        n.push({ from: a.from, to: s.to, ranges: [o] });
      r = s.number + 1;
    }
  } catch (c) {
    i.e(c);
  } finally {
    i.f();
  }
  return n;
}
function A3(e, t, n) {
  if (e.readOnly)
    return !1;
  var r, i = [], o = [], a = ut(uh(e));
  try {
    for (a.s(); !(r = a.n()).done; ) {
      var s = r.value;
      if (n ? s.to != e.doc.length : s.from != 0) {
        var u = e.doc.lineAt(n ? s.to + 1 : s.from - 1), c = u.length + 1;
        if (n) {
          i.push({ from: s.to, to: u.to }, { from: s.from, insert: u.text + e.lineBreak });
          var l, f = ut(s.ranges);
          try {
            for (f.s(); !(l = f.n()).done; ) {
              var h = l.value;
              o.push(Ht.range(Math.min(e.doc.length, h.anchor + c), Math.min(e.doc.length, h.head + c)));
            }
          } catch (m) {
            f.e(m);
          } finally {
            f.f();
          }
        } else {
          i.push({ from: u.from, to: s.from }, { from: s.to, insert: e.lineBreak + u.text });
          var d, p = ut(s.ranges);
          try {
            for (p.s(); !(d = p.n()).done; ) {
              var v = d.value;
              o.push(Ht.range(v.anchor - c, v.head - c));
            }
          } catch (m) {
            p.e(m);
          } finally {
            p.f();
          }
        }
      }
    }
  } catch (m) {
    a.e(m);
  } finally {
    a.f();
  }
  return !!i.length && (t(e.update({ changes: i, scrollIntoView: !0, selection: Ht.create(o, e.selection.mainIndex), userEvent: "move.line" })), !0);
}
function P3(e, t, n) {
  if (e.readOnly)
    return !1;
  var r, i = [], o = ut(uh(e));
  try {
    for (o.s(); !(r = o.n()).done; ) {
      var a = r.value;
      n ? i.push({ from: a.from, insert: e.doc.slice(a.from, a.to) + e.lineBreak }) : i.push({ from: a.to, insert: e.lineBreak + e.doc.slice(a.from, a.to) });
    }
  } catch (s) {
    o.e(s);
  } finally {
    o.f();
  }
  return t(e.update({ changes: i, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
var fU = pE(!1);
function pE(e) {
  return function(t) {
    var n = t.state, r = t.dispatch;
    if (n.readOnly)
      return !1;
    var i = n.changeByRange(function(o) {
      var a = o.from, s = o.to, u = n.doc.lineAt(a), c = !e && a == s && function(d, p) {
        if (/\(\)|\[\]|\{\}/.test(d.sliceDoc(p - 1, p + 1)))
          return { from: p, to: p };
        var v, m = Or(d).resolveInner(p), g = m.childBefore(p), y = m.childAfter(p);
        return g && y && g.to <= p && y.from >= p && (v = g.type.prop(zn.closedBy)) && v.indexOf(y.name) > -1 && d.doc.lineAt(g.to).from == d.doc.lineAt(y.from).from ? { from: g.to, to: y.from } : null;
      }(n, a);
      e && (a = s = (s <= u.to ? u : n.doc.lineAt(s)).to);
      var l = new hd(n, { simulateBreak: a, simulateDoubleBreak: !!c }), f = b0(l, a);
      for (f == null && (f = /^\s*/.exec(n.doc.lineAt(a).text)[0].length); s < u.to && /\s/.test(u.text[s - u.from]); )
        s++;
      c ? (a = c.from, s = c.to) : a > u.from && a < u.from + 100 && !/\S/.test(u.text.slice(0, a)) && (a = u.from);
      var h = ["", xc(n, f)];
      return c && h.push(xc(n, l.lineIndent(u.from, -1))), { changes: { from: a, to: s, insert: xn.of(h) }, range: Ht.cursor(a + 1 + h[1].length) };
    });
    return r(n.update(i, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function C0(e, t) {
  var n = -1;
  return e.changeByRange(function(r) {
    for (var i = [], o = r.from; o <= r.to; ) {
      var a = e.doc.lineAt(o);
      a.number > n && (r.empty || r.to > a.from) && (t(a, i, r), n = a.number), o = a.to + 1;
    }
    var s = e.changes(i);
    return { changes: i, range: Ht.range(s.mapPos(r.anchor, 1), s.mapPos(r.head, 1)) };
  });
}
var mE = function(e) {
  var t = e.state, n = e.dispatch;
  return !t.readOnly && (n(t.update(C0(t, function(r, i) {
    i.push({ from: r.from, insert: t.facet(fd) });
  }), { userEvent: "input.indent" })), !0);
}, gE = function(e) {
  var t = e.state, n = e.dispatch;
  return !t.readOnly && (n(t.update(C0(t, function(r, i) {
    var o = /^\s*/.exec(r.text)[0];
    if (o) {
      for (var a = Xc(o, t.tabSize), s = 0, u = xc(t, Math.max(0, a - Yf(t))); s < o.length && s < u.length && o.charCodeAt(s) == u.charCodeAt(s); )
        s++;
      i.push({ from: r.from + s, to: r.from + o.length, insert: u.slice(s) });
    }
  }), { userEvent: "delete.dedent" })), !0);
}, hU = [{ key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: function(e) {
  return _o(e, function(t) {
    return Bl(e.state, t, !li(e));
  });
}, shift: function(e) {
  return io(e, function(t) {
    return Bl(e.state, t, !li(e));
  });
} }, { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: function(e) {
  return _o(e, function(t) {
    return Bl(e.state, t, li(e));
  });
}, shift: function(e) {
  return io(e, function(t) {
    return Bl(e.state, t, li(e));
  });
} }, { key: "Alt-ArrowUp", run: function(e) {
  return A3(e.state, e.dispatch, !1);
} }, { key: "Shift-Alt-ArrowUp", run: function(e) {
  return P3(e.state, e.dispatch, !1);
} }, { key: "Alt-ArrowDown", run: function(e) {
  return A3(e.state, e.dispatch, !0);
} }, { key: "Shift-Alt-ArrowDown", run: function(e) {
  return P3(e.state, e.dispatch, !0);
} }, { key: "Escape", run: function(e) {
  var t = e.state, n = e.dispatch, r = t.selection, i = null;
  return r.ranges.length > 1 ? i = Ht.create([r.main]) : r.main.empty || (i = Ht.create([Ht.cursor(r.main.head)])), !!i && (n(lo(t, i)), !0);
} }, { key: "Mod-Enter", run: pE(!0) }, { key: "Alt-l", mac: "Ctrl-l", run: function(e) {
  var t = e.state, n = e.dispatch, r = uh(t).map(function(i) {
    var o = i.from, a = i.to;
    return Ht.range(o, Math.min(a + 1, t.doc.length));
  });
  return n(t.update({ selection: Ht.create(r), userEvent: "select" })), !0;
} }, { key: "Mod-i", run: function(e) {
  var t = e.state, n = e.dispatch, r = Ts(t.selection, function(i) {
    for (var o, a = Or(t).resolveInner(i.head, 1); !(a.from < i.from && a.to >= i.to || a.to > i.to && a.from <= i.from) && ((o = a.parent) === null || o === void 0 ? void 0 : o.parent); )
      a = a.parent;
    return Ht.range(a.to, a.from);
  });
  return n(lo(t, r)), !0;
}, preventDefault: !0 }, { key: "Mod-[", run: gE }, { key: "Mod-]", run: mE }, { key: "Mod-Alt-\\", run: function(e) {
  var t = e.state, n = e.dispatch;
  if (t.readOnly)
    return !1;
  var r = /* @__PURE__ */ Object.create(null), i = new hd(t, { overrideIndentation: function(a) {
    var s = r[a];
    return s == null ? -1 : s;
  } }), o = C0(t, function(a, s, u) {
    var c = b0(i, a.from);
    if (c != null) {
      /\S/.test(a.text) || (c = 0);
      var l = /^\s*/.exec(a.text)[0], f = xc(t, c);
      (l != f || u.from < a.from + l.length) && (r[a.from] = c, s.push({ from: a.from, to: a.from + l.length, insert: f }));
    }
  });
  return o.changes.empty || n(t.update(o, { userEvent: "indent" })), !0;
} }, { key: "Shift-Mod-k", run: function(e) {
  if (e.state.readOnly)
    return !1;
  var t = e.state, n = t.changes(uh(t).map(function(i) {
    var o = i.from, a = i.to;
    return o > 0 ? o-- : a < t.doc.length && a++, { from: o, to: a };
  })), r = Ts(t.selection, function(i) {
    return e.moveVertically(i, !0);
  }).map(n);
  return e.dispatch({ changes: n, selection: r, scrollIntoView: !0, userEvent: "delete.line" }), !0;
} }, { key: "Shift-Mod-\\", run: function(e) {
  return function(t, n, r) {
    var i = !1, o = Ts(t.selection, function(a) {
      var s = ro(t, a.head, -1) || ro(t, a.head, 1) || a.head > 0 && ro(t, a.head - 1, 1) || a.head < t.doc.length && ro(t, a.head + 1, -1);
      if (!s || !s.end)
        return a;
      i = !0;
      var u = s.start.from == a.head ? s.end.to : s.end.from;
      return r ? Ht.range(a.anchor, u) : Ht.cursor(u);
    });
    return !!i && (n(lo(t, o)), !0);
  }(e.state, e.dispatch, !1);
} }, { key: "Mod-/", run: function(e) {
  var t = S0(e.state);
  return t.line ? KW(e) : !!t.block && QW(e);
} }, { key: "Alt-A", run: GW }].concat([{ key: "ArrowLeft", run: o3, shift: d3, preventDefault: !0 }, { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: function(e) {
  return s3(e, !li(e));
}, shift: function(e) {
  return p3(e, !li(e));
} }, { mac: "Cmd-ArrowLeft", run: h3, shift: w3 }, { key: "ArrowRight", run: a3, shift: v3, preventDefault: !0 }, { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: function(e) {
  return s3(e, li(e));
}, shift: function(e) {
  return p3(e, li(e));
} }, { mac: "Cmd-ArrowRight", run: f3, shift: k3 }, { key: "ArrowUp", run: u3, shift: m3, preventDefault: !0 }, { mac: "Cmd-ArrowUp", run: x3, shift: S3 }, { mac: "Ctrl-ArrowUp", run: l3, shift: y3 }, { key: "ArrowDown", run: c3, shift: g3, preventDefault: !0 }, { mac: "Cmd-ArrowDown", run: j3, shift: $3 }, { mac: "Ctrl-ArrowDown", run: dv, shift: b3 }, { key: "PageUp", run: l3, shift: y3 }, { key: "PageDown", run: dv, shift: b3 }, { key: "Home", run: h3, shift: w3, preventDefault: !0 }, { key: "Mod-Home", run: x3, shift: S3 }, { key: "End", run: f3, shift: k3, preventDefault: !0 }, { key: "Mod-End", run: j3, shift: $3 }, { key: "Enter", run: fU }, { key: "Mod-a", run: function(e) {
  var t = e.state;
  return (0, e.dispatch)(t.update({ selection: { anchor: 0, head: t.doc.length }, userEvent: "select" })), !0;
} }, { key: "Backspace", run: vv, shift: vv }, { key: "Delete", run: _3 }, { key: "Mod-Backspace", mac: "Alt-Backspace", run: C3 }, { key: "Mod-Delete", mac: "Alt-Delete", run: function(e) {
  return vE(e, !0);
} }, { mac: "Mod-Backspace", run: function(e) {
  return md(e, function(t) {
    var n = e.lineBlockAt(t).from;
    return gd(e, t > n ? n : Math.max(0, t - 1), !1);
  });
} }, { mac: "Mod-Delete", run: O3 }].concat([{ key: "Ctrl-b", run: o3, shift: d3, preventDefault: !0 }, { key: "Ctrl-f", run: a3, shift: v3 }, { key: "Ctrl-p", run: u3, shift: m3 }, { key: "Ctrl-n", run: c3, shift: g3 }, { key: "Ctrl-a", run: function(e) {
  return _o(e, function(t) {
    return Ht.cursor(e.lineBlockAt(t.head).from, 1);
  });
}, shift: function(e) {
  return io(e, function(t) {
    return Ht.cursor(e.lineBlockAt(t.head).from);
  });
} }, { key: "Ctrl-e", run: function(e) {
  return _o(e, function(t) {
    return Ht.cursor(e.lineBlockAt(t.head).to, -1);
  });
}, shift: function(e) {
  return io(e, function(t) {
    return Ht.cursor(e.lineBlockAt(t.head).to);
  });
} }, { key: "Ctrl-d", run: _3 }, { key: "Ctrl-h", run: vv }, { key: "Ctrl-k", run: O3 }, { key: "Ctrl-Alt-h", run: C3 }, { key: "Ctrl-o", run: function(e) {
  var t = e.state, n = e.dispatch;
  if (t.readOnly)
    return !1;
  var r = t.changeByRange(function(i) {
    return { changes: { from: i.from, to: i.to, insert: xn.of(["", ""]) }, range: Ht.cursor(i.from) };
  });
  return n(t.update(r, { scrollIntoView: !0, userEvent: "input" })), !0;
} }, { key: "Ctrl-t", run: function(e) {
  var t = e.state, n = e.dispatch;
  if (t.readOnly)
    return !1;
  var r = t.changeByRange(function(i) {
    if (!i.empty || i.from == 0 || i.from == t.doc.length)
      return { range: i };
    var o = i.from, a = t.doc.lineAt(o), s = o == a.from ? o - 1 : Xr(a.text, o - a.from, !1) + a.from, u = o == a.to ? o + 1 : Xr(a.text, o - a.from, !0) + a.from;
    return { changes: { from: s, to: u, insert: t.doc.slice(o, u).append(t.doc.slice(s, o)) }, range: Ht.cursor(u) };
  });
  return !r.changes.empty && (n(t.update(r, { scrollIntoView: !0, userEvent: "move.character" })), !0);
} }, { key: "Ctrl-v", run: dv }].map(function(e) {
  return { mac: e.key, run: e.run, shift: e.shift };
}))), dU = { key: "Tab", run: mE, shift: gE };
function Fn() {
  var e = arguments[0];
  typeof e == "string" && (e = document.createElement(e));
  var t = 1, n = arguments[1];
  if (n && ne(n) == "object" && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n)
      if (Object.prototype.hasOwnProperty.call(n, r)) {
        var i = n[r];
        typeof i == "string" ? e.setAttribute(r, i) : i != null && (e[r] = i);
      }
    t++;
  }
  for (; t < arguments.length; t++)
    yE(e, arguments[t]);
  return e;
}
function yE(e, t) {
  if (typeof t == "string")
    e.appendChild(document.createTextNode(t));
  else if (t != null)
    if (t.nodeType != null)
      e.appendChild(t);
    else {
      if (!Array.isArray(t))
        throw new RangeError("Unsupported child node: " + t);
      for (var n = 0; n < t.length; n++)
        yE(e, t[n]);
    }
}
var E3 = typeof String.prototype.normalize == "function" ? function(e) {
  return e.normalize("NFKD");
} : function(e) {
  return e;
}, Is = function() {
  function e(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : t.length, o = arguments.length > 4 ? arguments[4] : void 0;
    Z(this, e), this.value = { from: 0, to: 0 }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = t.iterRange(r, i), this.bufferStart = r, this.normalize = o ? function(a) {
      return o(E3(a));
    } : E3, this.query = this.normalize(n);
  }
  return Y(e, [{ key: "peek", value: function() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return gr(this.buffer, this.bufferPos);
  } }, { key: "next", value: function() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  } }, { key: "nextOverlapping", value: function() {
    for (; ; ) {
      var t = this.peek();
      if (t < 0)
        return this.done = !0, this;
      var n = l0(t), r = this.bufferStart + this.bufferPos;
      this.bufferPos += Jr(t);
      for (var i = this.normalize(n), o = 0, a = r; ; o++) {
        var s = i.charCodeAt(o), u = this.match(s, a);
        if (u)
          return this.value = u, this;
        if (o == i.length - 1)
          break;
        a == r && o < n.length && n.charCodeAt(o) == s && a++;
      }
    }
  } }, { key: "match", value: function(t, n) {
    for (var r = null, i = 0; i < this.matches.length; i += 2) {
      var o = this.matches[i], a = !1;
      this.query.charCodeAt(o) == t && (o == this.query.length - 1 ? r = { from: this.matches[i + 1], to: n + 1 } : (this.matches[i]++, a = !0)), a || (this.matches.splice(i, 2), i -= 2);
    }
    return this.query.charCodeAt(0) == t && (this.query.length == 1 ? r = { from: n, to: n + 1 } : this.matches.push(1, n)), r;
  } }]), e;
}();
typeof Symbol < "u" && (Is.prototype[Symbol.iterator] = function() {
  return this;
});
var bE = { from: -1, to: -1, match: /.*/.exec("") }, O0 = "gm" + (/x/.unicode == null ? "" : "u"), kE = function() {
  function e(t, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : t.length;
    if (Z(this, e), this.to = o, this.curLine = "", this.done = !1, this.value = bE, /\\[sWDnr]|\n|\r|\[\^/.test(n))
      return new wE(t, n, r, i, o);
    this.re = new RegExp(n, O0 + (r != null && r.ignoreCase ? "i" : "")), this.iter = t.iter();
    var a = t.lineAt(i);
    this.curLineStart = a.from, this.matchPos = i, this.getLine(this.curLineStart);
  }
  return Y(e, [{ key: "getLine", value: function(t) {
    this.iter.next(t), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  } }, { key: "nextLine", value: function() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  } }, { key: "next", value: function() {
    for (var t = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = t;
      var n = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (n) {
        var r = this.curLineStart + n.index, i = r + n[0].length;
        if (this.matchPos = i + (r == i ? 1 : 0), r == this.curLine.length && this.nextLine(), r < i || r > this.value.to)
          return this.value = { from: r, to: i, match: n }, this;
        t = this.matchPos - this.curLineStart;
      } else {
        if (!(this.curLineStart + this.curLine.length < this.to))
          return this.done = !0, this;
        this.nextLine(), t = 0;
      }
    }
  } }]), e;
}(), pv = /* @__PURE__ */ new WeakMap(), M3 = function() {
  function e(t, n) {
    Z(this, e), this.from = t, this.text = n;
  }
  return Y(e, [{ key: "to", get: function() {
    return this.from + this.text.length;
  } }], [{ key: "get", value: function(t, n, r) {
    var i = pv.get(t);
    if (!i || i.from >= r || i.to <= n) {
      var o = new e(n, t.sliceString(n, r));
      return pv.set(t, o), o;
    }
    if (i.from == n && i.to == r)
      return i;
    var a = i.text, s = i.from;
    return s > n && (a = t.sliceString(n, s) + a, s = n), i.to < r && (a += t.sliceString(i.to, r)), pv.set(t, new e(s, a)), new e(n, a.slice(n - s, r - s));
  } }]), e;
}(), wE = function() {
  function e(t, n, r, i, o) {
    Z(this, e), this.text = t, this.to = o, this.done = !1, this.value = bE, this.matchPos = i, this.re = new RegExp(n, O0 + (r != null && r.ignoreCase ? "i" : "")), this.flat = M3.get(t, i, this.chunkEnd(i + 5e3));
  }
  return Y(e, [{ key: "chunkEnd", value: function(t) {
    return t >= this.to ? this.to : this.text.lineAt(t).to;
  } }, { key: "next", value: function() {
    for (; ; ) {
      var t = this.re.lastIndex = this.matchPos - this.flat.from, n = this.re.exec(this.flat.text);
      if (n && !n[0] && n.index == t && (this.re.lastIndex = t + 1, n = this.re.exec(this.flat.text)), n && this.flat.to < this.to && n.index + n[0].length > this.flat.text.length - 10 && (n = null), n) {
        var r = this.flat.from + n.index, i = r + n[0].length;
        return this.value = { from: r, to: i, match: n }, this.matchPos = i + (r == i ? 1 : 0), this;
      }
      if (this.flat.to == this.to)
        return this.done = !0, this;
      this.flat = M3.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + 2 * this.flat.text.length));
    }
  } }]), e;
}();
function sm(e) {
  var t = Fn("input", { class: "cm-textfield", name: "line" });
  function n() {
    var r = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(t.value);
    if (r) {
      var i = e.state, o = i.doc.lineAt(i.selection.main.head), a = xe(r, 5), s = a[1], u = a[2], c = a[3], l = a[4], f = c ? +c.slice(1) : 0, h = u ? +u : o.number;
      if (u && l) {
        var d = h / 100;
        s && (d = d * (s == "-" ? -1 : 1) + o.number / i.doc.lines), h = Math.round(i.doc.lines * d);
      } else
        u && s && (h = h * (s == "-" ? -1 : 1) + o.number);
      var p = i.doc.line(Math.max(1, Math.min(i.doc.lines, h)));
      e.dispatch({ effects: ch.of(!1), selection: Ht.cursor(p.from + Math.max(0, Math.min(f, p.length))), scrollIntoView: !0 }), e.focus();
    }
  }
  return { dom: Fn("form", { class: "cm-gotoLine", onkeydown: function(r) {
    r.keyCode == 27 ? (r.preventDefault(), e.dispatch({ effects: ch.of(!1) }), e.focus()) : r.keyCode == 13 && (r.preventDefault(), n());
  }, onsubmit: function(r) {
    r.preventDefault(), n();
  } }, Fn("label", e.state.phrase("Go to line"), ": ", t), " ", Fn("button", { class: "cm-button", type: "submit" }, e.state.phrase("go"))) };
}
typeof Symbol < "u" && (kE.prototype[Symbol.iterator] = wE.prototype[Symbol.iterator] = function() {
  return this;
});
var ch = He.define(), T3 = br.define({ create: function() {
  return !0;
}, update: function(e, t) {
  var n, r = ut(t.effects);
  try {
    for (r.s(); !(n = r.n()).done; ) {
      var i = n.value;
      i.is(ch) && (e = i.value);
    }
  } catch (o) {
    r.e(o);
  } finally {
    r.f();
  }
  return e;
}, provide: function(e) {
  return yc.from(e, function(t) {
    return t ? sm : null;
  });
} }), vU = we.baseTheme({ ".cm-panel.cm-gotoLine": { padding: "2px 6px 4px", "& label": { fontSize: "80%" } } }), pU = { highlightWordAroundCursor: !1, minSelectionLength: 1, maxMatches: 100, wholeWords: !1 }, xE = be.define({ combine: function(e) {
  return ko(e, pU, { highlightWordAroundCursor: function(t, n) {
    return t || n;
  }, minSelectionLength: Math.min, maxMatches: Math.min });
} }), mU = $e.mark({ class: "cm-selectionMatch" }), gU = $e.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function I3(e, t, n, r) {
  return !(n != 0 && e(t.sliceDoc(n - 1, n)) == Nr.Word || r != t.doc.length && e(t.sliceDoc(r, r + 1)) == Nr.Word);
}
var yU = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.decorations = this.getDeco(t);
  }
  return Y(e, [{ key: "update", value: function(t) {
    (t.selectionSet || t.docChanged || t.viewportChanged) && (this.decorations = this.getDeco(t.view));
  } }, { key: "getDeco", value: function(t) {
    var n = t.state.facet(xE), r = t.state, i = r.selection;
    if (i.ranges.length > 1)
      return $e.none;
    var o, a = i.main, s = null;
    if (a.empty) {
      if (!n.highlightWordAroundCursor)
        return $e.none;
      var u = r.wordAt(a.head);
      if (!u)
        return $e.none;
      s = r.charCategorizer(a.head), o = r.sliceDoc(u.from, u.to);
    } else {
      var c = a.to - a.from;
      if (c < n.minSelectionLength || c > 200)
        return $e.none;
      if (n.wholeWords) {
        if (o = r.sliceDoc(a.from, a.to), !I3(s = r.charCategorizer(a.head), r, a.from, a.to) || !function(y, b, k, w) {
          return y(b.sliceDoc(k, k + 1)) == Nr.Word && y(b.sliceDoc(w - 1, w)) == Nr.Word;
        }(s, r, a.from, a.to))
          return $e.none;
      } else if (!(o = r.sliceDoc(a.from, a.to).trim()))
        return $e.none;
    }
    var l, f = [], h = ut(t.visibleRanges);
    try {
      for (h.s(); !(l = h.n()).done; )
        for (var d = l.value, p = new Is(r.doc, o, d.from, d.to); !p.next().done; ) {
          var v = p.value, m = v.from, g = v.to;
          if ((!s || I3(s, r, m, g)) && (a.empty && m <= a.from && g >= a.to ? f.push(gU.range(m, g)) : (m >= a.to || g <= a.from) && f.push(mU.range(m, g)), f.length > n.maxMatches))
            return $e.none;
        }
    } catch (y) {
      h.e(y);
    } finally {
      h.f();
    }
    return $e.set(f);
  } }]), e;
}(), { decorations: function(e) {
  return e.decorations;
} }), bU = we.baseTheme({ ".cm-selectionMatch": { backgroundColor: "#99ff7780" }, ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" } }), yd = be.define({ combine: function(e) {
  var t;
  return { top: e.reduce(function(n, r) {
    return n != null ? n : r.top;
  }, void 0) || !1, caseSensitive: e.reduce(function(n, r) {
    return n != null ? n : r.caseSensitive;
  }, void 0) || !1, createPanel: ((t = e.find(function(n) {
    return n.createPanel;
  })) === null || t === void 0 ? void 0 : t.createPanel) || function(n) {
    return new AU(n);
  } };
} });
function kU(e) {
  return e ? [yd.of(e), cm] : cm;
}
var jE = function() {
  function e(t) {
    Z(this, e), this.search = t.search, this.caseSensitive = !!t.caseSensitive, this.regexp = !!t.regexp, this.replace = t.replace || "", this.valid = !!this.search && (!this.regexp || function(n) {
      try {
        return new RegExp(n, O0), !0;
      } catch {
        return !1;
      }
    }(this.search)), this.unquoted = t.literal ? this.search : this.search.replace(/\\([nrt\\])/g, function(n, r) {
      return r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "	" : "\\";
    });
  }
  return Y(e, [{ key: "eq", value: function(t) {
    return this.search == t.search && this.replace == t.replace && this.caseSensitive == t.caseSensitive && this.regexp == t.regexp;
  } }, { key: "create", value: function() {
    return this.regexp ? new xU(this) : new wU(this);
  } }, { key: "getCursor", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length;
    return this.regexp ? ks(this, t, n, r) : bs(this, t, n, r);
  } }]), e;
}(), SE = Y(function e(t) {
  Z(this, e), this.spec = t;
});
function bs(e, t, n, r) {
  return new Is(t, e.unquoted, n, r, e.caseSensitive ? void 0 : function(i) {
    return i.toLowerCase();
  });
}
var wU = function(e) {
  Et(n, SE);
  var t = Mt(n);
  function n(r) {
    return Z(this, n), t.call(this, r);
  }
  return Y(n, [{ key: "nextMatch", value: function(r, i, o) {
    var a = bs(this.spec, r, o, r.length).nextOverlapping();
    return a.done && (a = bs(this.spec, r, 0, i).nextOverlapping()), a.done ? null : a.value;
  } }, { key: "prevMatchInRange", value: function(r, i, o) {
    for (var a = o; ; ) {
      for (var s = Math.max(i, a - 1e4 - this.spec.unquoted.length), u = bs(this.spec, r, s, a), c = null; !u.nextOverlapping().done; )
        c = u.value;
      if (c)
        return c;
      if (s == i)
        return null;
      a -= 1e4;
    }
  } }, { key: "prevMatch", value: function(r, i, o) {
    return this.prevMatchInRange(r, 0, i) || this.prevMatchInRange(r, o, r.length);
  } }, { key: "getReplacement", value: function(r) {
    return this.spec.replace;
  } }, { key: "matchAll", value: function(r, i) {
    for (var o = bs(this.spec, r, 0, r.length), a = []; !o.next().done; ) {
      if (a.length >= i)
        return null;
      a.push(o.value);
    }
    return a;
  } }, { key: "highlight", value: function(r, i, o, a) {
    for (var s = bs(this.spec, r, Math.max(0, i - this.spec.unquoted.length), Math.min(o + this.spec.unquoted.length, r.length)); !s.next().done; )
      a(s.value.from, s.value.to);
  } }]), n;
}();
function ks(e, t, n, r) {
  return new kE(t, e.search, e.caseSensitive ? void 0 : { ignoreCase: !0 }, n, r);
}
var xU = function(e) {
  Et(n, SE);
  var t = Mt(n);
  function n() {
    return Z(this, n), t.apply(this, arguments);
  }
  return Y(n, [{ key: "nextMatch", value: function(r, i, o) {
    var a = ks(this.spec, r, o, r.length).next();
    return a.done && (a = ks(this.spec, r, 0, i).next()), a.done ? null : a.value;
  } }, { key: "prevMatchInRange", value: function(r, i, o) {
    for (var a = 1; ; a++) {
      for (var s = Math.max(i, o - 1e4 * a), u = ks(this.spec, r, s, o), c = null; !u.next().done; )
        c = u.value;
      if (c && (s == i || c.from > s + 10))
        return c;
      if (s == i)
        return null;
    }
  } }, { key: "prevMatch", value: function(r, i, o) {
    return this.prevMatchInRange(r, 0, i) || this.prevMatchInRange(r, o, r.length);
  } }, { key: "getReplacement", value: function(r) {
    return this.spec.replace.replace(/\$([$&\d+])/g, function(i, o) {
      return o == "$" ? "$" : o == "&" ? r.match[0] : o != "0" && +o < r.match.length ? r.match[o] : i;
    });
  } }, { key: "matchAll", value: function(r, i) {
    for (var o = ks(this.spec, r, 0, r.length), a = []; !o.next().done; ) {
      if (a.length >= i)
        return null;
      a.push(o.value);
    }
    return a;
  } }, { key: "highlight", value: function(r, i, o, a) {
    for (var s = ks(this.spec, r, Math.max(0, i - 250), Math.min(o + 250, r.length)); !s.next().done; )
      a(s.value.from, s.value.to);
  } }]), n;
}(), $c = He.define(), A0 = He.define(), ta = br.define({ create: function(e) {
  return new mv(um(e).create(), null);
}, update: function(e, t) {
  var n, r = ut(t.effects);
  try {
    for (r.s(); !(n = r.n()).done; ) {
      var i = n.value;
      i.is($c) ? e = new mv(i.value.create(), e.panel) : i.is(A0) && (e = new mv(e.query, i.value ? P0 : null));
    }
  } catch (o) {
    r.e(o);
  } finally {
    r.f();
  }
  return e;
}, provide: function(e) {
  return yc.from(e, function(t) {
    return t.panel;
  });
} }), mv = Y(function e(t, n) {
  Z(this, e), this.query = t, this.panel = n;
}), jU = $e.mark({ class: "cm-searchMatch" }), SU = $e.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), $U = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.view = t, this.decorations = this.highlight(t.state.field(ta));
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n = t.state.field(ta);
    (n != t.startState.field(ta) || t.docChanged || t.selectionSet || t.viewportChanged) && (this.decorations = this.highlight(n));
  } }, { key: "highlight", value: function(t) {
    var n = t.query;
    if (!t.panel || !n.spec.valid)
      return $e.none;
    for (var r = this.view, i = new Vs(), o = 0, a = r.visibleRanges, s = a.length; o < s; o++) {
      for (var u = a[o], c = u.from, l = u.to; o < s - 1 && l > a[o + 1].from - 500; )
        l = a[++o].to;
      n.highlight(r.state.doc, c, l, function(f, h) {
        var d = r.state.selection.ranges.some(function(p) {
          return p.from == f && p.to == h;
        });
        i.add(f, h, d ? SU : jU);
      });
    }
    return i.finish();
  } }]), e;
}(), { decorations: function(e) {
  return e.decorations;
} });
function el(e) {
  return function(t) {
    var n = t.state.field(ta, !1);
    return n && n.query.spec.valid ? e(t, n) : E0(t);
  };
}
var lh = el(function(e, t) {
  var n = t.query, r = e.state.selection.main, i = r.from, o = r.to, a = n.nextMatch(e.state.doc, i, o);
  return !(!a || a.from == i && a.to == o) && (e.dispatch({ selection: { anchor: a.from, head: a.to }, scrollIntoView: !0, effects: T0(e, a), userEvent: "select.search" }), !0);
}), fh = el(function(e, t) {
  var n = t.query, r = e.state, i = r.selection.main, o = i.from, a = i.to, s = n.prevMatch(r.doc, o, a);
  return !!s && (e.dispatch({ selection: { anchor: s.from, head: s.to }, scrollIntoView: !0, effects: T0(e, s), userEvent: "select.search" }), !0);
}), _U = el(function(e, t) {
  var n = t.query.matchAll(e.state.doc, 1e3);
  return !(!n || !n.length) && (e.dispatch({ selection: Ht.create(n.map(function(r) {
    return Ht.range(r.from, r.to);
  })), userEvent: "select.search.matches" }), !0);
}), N3 = el(function(e, t) {
  var n = t.query, r = e.state, i = r.selection.main, o = i.from, a = i.to;
  if (r.readOnly)
    return !1;
  var s = n.nextMatch(r.doc, o, o);
  if (!s)
    return !1;
  var u, c, l = [], f = [];
  if (s.from == o && s.to == a && (c = r.toText(n.getReplacement(s)), l.push({ from: s.from, to: s.to, insert: c }), s = n.nextMatch(r.doc, s.from, s.to), f.push(we.announce.of(r.phrase("replaced match on line $", r.doc.lineAt(o).number) + "."))), s) {
    var h = l.length == 0 || l[0].from >= s.to ? 0 : s.to - s.from - c.length;
    u = { anchor: s.from - h, head: s.to - h }, f.push(T0(e, s));
  }
  return e.dispatch({ changes: l, selection: u, scrollIntoView: !!u, effects: f, userEvent: "input.replace" }), !0;
}), CU = el(function(e, t) {
  var n = t.query;
  if (e.state.readOnly)
    return !1;
  var r = n.matchAll(e.state.doc, 1e9).map(function(o) {
    return { from: o.from, to: o.to, insert: n.getReplacement(o) };
  });
  if (!r.length)
    return !1;
  var i = e.state.phrase("replaced $ matches", r.length) + ".";
  return e.dispatch({ changes: r, effects: we.announce.of(i), userEvent: "input.replace.all" }), !0;
});
function P0(e) {
  return e.state.facet(yd).createPanel(e);
}
function um(e, t) {
  var n, r = e.selection.main, i = r.empty || r.to > r.from + 100 ? "" : e.sliceDoc(r.from, r.to), o = (n = t == null ? void 0 : t.caseSensitive) !== null && n !== void 0 ? n : e.facet(yd).caseSensitive;
  return t && !i ? t : new jE({ search: i.replace(/\n/g, "\\n"), caseSensitive: o });
}
var E0 = function(e) {
  var t = e.state.field(ta, !1);
  if (t && t.panel) {
    var n = gc(e, P0);
    if (!n)
      return !1;
    var r = n.dom.querySelector("[main-field]");
    if (r && r != e.root.activeElement) {
      var i = um(e.state, t.query.spec);
      i.valid && e.dispatch({ effects: $c.of(i) }), r.focus(), r.select();
    }
  } else
    e.dispatch({ effects: [A0.of(!0), t ? $c.of(um(e.state, t.query.spec)) : He.appendConfig.of(cm)] });
  return !0;
}, M0 = function(e) {
  var t = e.state.field(ta, !1);
  if (!t || !t.panel)
    return !1;
  var n = gc(e, P0);
  return n && n.dom.contains(e.root.activeElement) && e.focus(), e.dispatch({ effects: A0.of(!1) }), !0;
}, OU = [{ key: "Mod-f", run: E0, scope: "editor search-panel" }, { key: "F3", run: lh, shift: fh, scope: "editor search-panel", preventDefault: !0 }, { key: "Mod-g", run: lh, shift: fh, scope: "editor search-panel", preventDefault: !0 }, { key: "Escape", run: M0, scope: "editor search-panel" }, { key: "Mod-Shift-l", run: function(e) {
  var t = e.state, n = e.dispatch, r = t.selection;
  if (r.ranges.length > 1 || r.main.empty)
    return !1;
  for (var i = r.main, o = i.from, a = i.to, s = [], u = 0, c = new Is(t.doc, t.sliceDoc(o, a)); !c.next().done; ) {
    if (s.length > 1e3)
      return !1;
    c.value.from == o && (u = s.length), s.push(Ht.range(c.value.from, c.value.to));
  }
  return n(t.update({ selection: Ht.create(s, u), userEvent: "select.search.matches" })), !0;
} }, { key: "Alt-g", run: function(e) {
  var t = gc(e, sm);
  if (!t) {
    var n = [ch.of(!0)];
    e.state.field(T3, !1) == null && n.push(He.appendConfig.of([T3, vU])), e.dispatch({ effects: n }), t = gc(e, sm);
  }
  return t && t.dom.querySelector("input").focus(), !0;
} }, { key: "Mod-d", run: function(e) {
  var t = e.state, n = e.dispatch, r = t.selection.ranges;
  if (r.some(function(a) {
    return a.from === a.to;
  }))
    return function(a) {
      var s = a.state, u = a.dispatch, c = s.selection, l = Ht.create(c.ranges.map(function(f) {
        return s.wordAt(f.head) || Ht.cursor(f.head);
      }), c.mainIndex);
      return !l.eq(c) && (u(s.update({ selection: l })), !0);
    }({ state: t, dispatch: n });
  var i = t.sliceDoc(r[0].from, r[0].to);
  if (t.selection.ranges.some(function(a) {
    return t.sliceDoc(a.from, a.to) != i;
  }))
    return !1;
  var o = function(a, s) {
    for (var u = a.selection, c = u.main, l = u.ranges, f = a.wordAt(c.head), h = f && f.from == c.from && f.to == c.to, d = function(g, y) {
      if (y.next(), !y.done) {
        if (g && l.some(function(k) {
          return k.from == y.value.from;
        }))
          return v = y, p = g, "continue";
        if (h) {
          var b = a.wordAt(y.value.from);
          if (!b || b.from != y.value.from || b.to != y.value.to)
            return v = y, p = g, "continue";
        }
        return p = g, v = y, { v: y.value };
      }
      if (g)
        return v = y, p = g, { v: null };
      y = new Is(a.doc, s, 0, Math.max(0, l[l.length - 1].from - 1)), p = g = !0, v = y;
    }, p = !1, v = new Is(a.doc, s, l[l.length - 1].to); ; ) {
      var m = d(p, v);
      if (m !== "continue" && ne(m) === "object")
        return m.v;
    }
  }(t, i);
  return !!o && (n(t.update({ selection: t.selection.addRange(Ht.range(o.from, o.to), !1), effects: we.scrollIntoView(o.to) })), !0);
}, preventDefault: !0 }], AU = function() {
  function e(t) {
    var n = this;
    Z(this, e), this.view = t;
    var r = this.query = t.state.field(ta).query.spec;
    function i(o, a, s) {
      return Fn("button", { class: "cm-button", name: o, onclick: a, type: "button" }, s);
    }
    this.commit = this.commit.bind(this), this.searchField = Fn("input", { value: r.search, placeholder: ui(t, "Find"), "aria-label": ui(t, "Find"), class: "cm-textfield", name: "search", "main-field": "true", onchange: this.commit, onkeyup: this.commit }), this.replaceField = Fn("input", { value: r.replace, placeholder: ui(t, "Replace"), "aria-label": ui(t, "Replace"), class: "cm-textfield", name: "replace", onchange: this.commit, onkeyup: this.commit }), this.caseField = Fn("input", { type: "checkbox", name: "case", checked: r.caseSensitive, onchange: this.commit }), this.reField = Fn("input", { type: "checkbox", name: "re", checked: r.regexp, onchange: this.commit }), this.dom = Fn("div", { onkeydown: function(o) {
      return n.keydown(o);
    }, class: "cm-search" }, [this.searchField, i("next", function() {
      return lh(t);
    }, [ui(t, "next")]), i("prev", function() {
      return fh(t);
    }, [ui(t, "previous")]), i("select", function() {
      return _U(t);
    }, [ui(t, "all")]), Fn("label", null, [this.caseField, ui(t, "match case")]), Fn("label", null, [this.reField, ui(t, "regexp")])].concat(Pe(t.state.readOnly ? [] : [Fn("br"), this.replaceField, i("replace", function() {
      return N3(t);
    }, [ui(t, "replace")]), i("replaceAll", function() {
      return CU(t);
    }, [ui(t, "replace all")]), Fn("button", { name: "close", onclick: function() {
      return M0(t);
    }, "aria-label": ui(t, "close"), type: "button" }, ["\xD7"])])));
  }
  return Y(e, [{ key: "commit", value: function() {
    var t = new jE({ search: this.searchField.value, caseSensitive: this.caseField.checked, regexp: this.reField.checked, replace: this.replaceField.value });
    t.eq(this.query) || (this.query = t, this.view.dispatch({ effects: $c.of(t) }));
  } }, { key: "keydown", value: function(t) {
    var n, r, i;
    n = this.view, r = t, i = "search-panel", xP(wP(n.state), r, n, i) ? t.preventDefault() : t.keyCode == 13 && t.target == this.searchField ? (t.preventDefault(), (t.shiftKey ? fh : lh)(this.view)) : t.keyCode == 13 && t.target == this.replaceField && (t.preventDefault(), N3(this.view));
  } }, { key: "update", value: function(t) {
    var n, r = ut(t.transactions);
    try {
      for (r.s(); !(n = r.n()).done; ) {
        var i, o = ut(n.value.effects);
        try {
          for (o.s(); !(i = o.n()).done; ) {
            var a = i.value;
            a.is($c) && !a.value.eq(this.query) && this.setQuery(a.value);
          }
        } catch (s) {
          o.e(s);
        } finally {
          o.f();
        }
      }
    } catch (s) {
      r.e(s);
    } finally {
      r.f();
    }
  } }, { key: "setQuery", value: function(t) {
    this.query = t, this.searchField.value = t.search, this.replaceField.value = t.replace, this.caseField.checked = t.caseSensitive, this.reField.checked = t.regexp;
  } }, { key: "mount", value: function() {
    this.searchField.select();
  } }, { key: "pos", get: function() {
    return 80;
  } }, { key: "top", get: function() {
    return this.view.state.facet(yd).top;
  } }]), e;
}();
function ui(e, t) {
  return e.state.phrase(t);
}
var Fl = /[\s\.,:;?!]/;
function T0(e, t) {
  var n = t.from, r = t.to, i = e.state.doc.lineAt(n), o = e.state.doc.lineAt(r).to, a = Math.max(i.from, n - 30), s = Math.min(o, r + 30), u = e.state.sliceDoc(a, s);
  if (a != i.from) {
    for (var c = 0; c < 30; c++)
      if (!Fl.test(u[c + 1]) && Fl.test(u[c])) {
        u = u.slice(c);
        break;
      }
  }
  if (s != o) {
    for (var l = u.length - 1; l > u.length - 30; l--)
      if (!Fl.test(u[l - 1]) && Fl.test(u[l])) {
        u = u.slice(0, l);
        break;
      }
  }
  return we.announce.of("".concat(e.state.phrase("current match"), ". ").concat(u, " ").concat(e.state.phrase("on line"), " ").concat(i.number, "."));
}
var PU = we.baseTheme({ ".cm-panel.cm-search": { padding: "2px 6px 4px", position: "relative", "& [name=close]": { position: "absolute", top: "0", right: "4px", backgroundColor: "inherit", border: "none", font: "inherit", padding: 0, margin: 0 }, "& input, & button, & label": { margin: ".2em .6em .2em 0" }, "& input[type=checkbox]": { marginRight: ".2em" }, "& label": { fontSize: "80%", whiteSpace: "pre" } }, "&light .cm-searchMatch": { backgroundColor: "#ffff0054" }, "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" }, "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" }, "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" } }), cm = [ta, Qc.lowest($U), PU], $E = function() {
  function e(t, n, r) {
    Z(this, e), this.state = t, this.pos = n, this.explicit = r, this.abortListeners = [];
  }
  return Y(e, [{ key: "tokenBefore", value: function(t) {
    for (var n = Or(this.state).resolveInner(this.pos, -1); n && t.indexOf(n.name) < 0; )
      n = n.parent;
    return n ? { from: n.from, to: this.pos, text: this.state.sliceDoc(n.from, this.pos), type: n.type } : null;
  } }, { key: "matchBefore", value: function(t) {
    var n = this.state.doc.lineAt(this.pos), r = Math.max(n.from, this.pos - 250), i = n.text.slice(r - n.from, this.pos - n.from), o = i.search(_E(t, !1));
    return o < 0 ? null : { from: r + o, to: this.pos, text: i.slice(o) };
  } }, { key: "aborted", get: function() {
    return this.abortListeners == null;
  } }, { key: "addEventListener", value: function(t, n) {
    t == "abort" && this.abortListeners && this.abortListeners.push(n);
  } }]), e;
}();
function R3(e) {
  var t = Object.keys(e).join(""), n = /\w/.test(t);
  return n && (t = t.replace(/\w/g, "")), "[".concat(n ? "\\w" : "").concat(t.replace(/[^\w\s]/g, "\\$&"), "]");
}
function EU(e) {
  var t = e.map(function(o) {
    return typeof o == "string" ? { label: o } : o;
  }), n = xe(t.every(function(o) {
    return /^\w+$/.test(o.label);
  }) ? [/\w*$/, /\w+$/] : function(o) {
    var a, s = /* @__PURE__ */ Object.create(null), u = /* @__PURE__ */ Object.create(null), c = ut(o);
    try {
      for (c.s(); !(a = c.n()).done; ) {
        var l = a.value.label;
        s[l[0]] = !0;
        for (var f = 1; f < l.length; f++)
          u[l[f]] = !0;
      }
    } catch (d) {
      c.e(d);
    } finally {
      c.f();
    }
    var h = R3(s) + R3(u) + "*$";
    return [new RegExp("^" + h), new RegExp(h)];
  }(t), 2), r = n[0], i = n[1];
  return function(o) {
    var a = o.matchBefore(i);
    return a || o.explicit ? { from: a ? a.from : o.pos, options: t, validFor: r } : null;
  };
}
var D3 = Y(function e(t, n, r) {
  Z(this, e), this.completion = t, this.source = n, this.match = r;
});
function ea(e) {
  return e.selection.main.head;
}
function _E(e, t) {
  var n, r = e.source, i = t && r[0] != "^", o = r[r.length - 1] != "$";
  return i || o ? new RegExp("".concat(i ? "^" : "", "(?:").concat(r, ")").concat(o ? "$" : ""), (n = e.flags) !== null && n !== void 0 ? n : e.ignoreCase ? "i" : "") : e;
}
function CE(e, t) {
  var n = t.completion.apply || t.completion.label, r = t.source;
  typeof n == "string" ? e.dispatch(function(i, o, a, s) {
    return Object.assign(Object.assign({}, i.changeByRange(function(u) {
      if (u == i.selection.main)
        return { changes: { from: a, to: s, insert: o }, range: Ht.cursor(a + o.length) };
      var c = s - a;
      return !u.empty || c && i.sliceDoc(u.from - c, u.from) != i.sliceDoc(a, s) ? { range: u } : { changes: { from: u.from - c, to: u.from, insert: o }, range: Ht.cursor(u.from - c + o.length) };
    })), { userEvent: "input.complete" });
  }(e.state, n, r.from, r.to)) : n(e, t.completion, r.from, r.to);
}
var L3 = /* @__PURE__ */ new WeakMap();
function MU(e) {
  if (!Array.isArray(e))
    return e;
  var t = L3.get(e);
  return t || L3.set(e, t = EU(e)), t;
}
var TU = function() {
  function e(t) {
    Z(this, e), this.pattern = t, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [];
    for (var n = 0; n < t.length; ) {
      var r = gr(t, n), i = Jr(r);
      this.chars.push(r);
      var o = t.slice(n, n + i), a = o.toUpperCase();
      this.folded.push(gr(a == o ? o.toLowerCase() : a, 0)), n += i;
    }
    this.astral = t.length != this.chars.length;
  }
  return Y(e, [{ key: "match", value: function(t) {
    if (this.pattern.length == 0)
      return [0];
    if (t.length < this.pattern.length)
      return null;
    var n = this.chars, r = this.folded, i = this.any, o = this.precise, a = this.byWord;
    if (n.length == 1) {
      var s = gr(t, 0);
      return s == n[0] ? [0, 0, Jr(s)] : s == r[0] ? [-200, 0, Jr(s)] : null;
    }
    var u = t.indexOf(this.pattern);
    if (u == 0)
      return [0, 0, this.pattern.length];
    var c = n.length, l = 0;
    if (u < 0) {
      for (var f = 0, h = Math.min(t.length, 200); f < h && l < c; ) {
        var d = gr(t, f);
        d != n[l] && d != r[l] || (i[l++] = f), f += Jr(d);
      }
      if (l < c)
        return null;
    }
    for (var p = 0, v = 0, m = !1, g = 0, y = -1, b = -1, k = /[a-z]/.test(t), w = !0, x = 0, S = Math.min(t.length, 200), T = 0; x < S && v < c; ) {
      var P = gr(t, x);
      u < 0 && (p < c && P == n[p] && (o[p++] = x), g < c && (P == n[g] || P == r[g] ? (g == 0 && (y = x), b = x + 1, g++) : g = 0));
      var O = void 0, j = P < 255 ? P >= 48 && P <= 57 || P >= 97 && P <= 122 ? 2 : P >= 65 && P <= 90 ? 1 : 0 : (O = l0(P)) != O.toLowerCase() ? 1 : O != O.toUpperCase() ? 2 : 0;
      (!x || j == 1 && k || T == 0 && j != 0) && (n[v] == P || r[v] == P && (m = !0) ? a[v++] = x : a.length && (w = !1)), T = j, x += Jr(P);
    }
    return v == c && a[0] == 0 && w ? this.result((m ? -200 : 0) - 100, a, t) : g == c && y == 0 ? [-200 - t.length, 0, b] : u > -1 ? [-700 - t.length, u, u + this.pattern.length] : g == c ? [-900 - t.length, y, b] : v == c ? this.result((m ? -200 : 0) - 100 - 700 + (w ? 0 : -1100), a, t) : n.length == 2 ? null : this.result((i[0] ? -700 : 0) - 200 - 1100, i, t);
  } }, { key: "result", value: function(t, n, r) {
    var i, o = [t - r.length], a = 1, s = ut(n);
    try {
      for (s.s(); !(i = s.n()).done; ) {
        var u = i.value, c = u + (this.astral ? Jr(gr(r, u)) : 1);
        a > 1 && o[a - 1] == u ? o[a - 1] = c : (o[a++] = u, o[a++] = c);
      }
    } catch (l) {
      s.e(l);
    } finally {
      s.f();
    }
    return o;
  } }]), e;
}(), fa = be.define({ combine: function(e) {
  return ko(e, { activateOnTyping: !0, override: null, closeOnBlur: !0, maxRenderedOptions: 100, defaultKeymap: !0, optionClass: function() {
    return "";
  }, aboveCursor: !1, icons: !0, addToOptions: [] }, { defaultKeymap: function(t, n) {
    return t && n;
  }, closeOnBlur: function(t, n) {
    return t && n;
  }, icons: function(t, n) {
    return t && n;
  }, optionClass: function(t, n) {
    return function(r) {
      return function(i, o) {
        return i ? o ? i + " " + o : i : o;
      }(t(r), n(r));
    };
  }, addToOptions: function(t, n) {
    return t.concat(n);
  } });
} });
function z3(e, t, n) {
  if (e <= n)
    return { from: 0, to: e };
  if (t <= e >> 1) {
    var r = Math.floor(t / n);
    return { from: r * n, to: (r + 1) * n };
  }
  var i = Math.floor((e - t) / n);
  return { from: e - (i + 1) * n, to: e - i * n };
}
var IU = function() {
  function e(t, n) {
    var r = this;
    Z(this, e), this.view = t, this.stateField = n, this.info = null, this.placeInfo = { read: function() {
      return r.measureInfo();
    }, write: function(c) {
      return r.positionInfo(c);
    }, key: this };
    var i = t.state.field(n), o = i.open, a = o.options, s = o.selected, u = t.state.facet(fa);
    this.optionContent = function(c) {
      var l = c.addToOptions.slice();
      return c.icons && l.push({ render: function(f) {
        var h, d = document.createElement("div");
        return d.classList.add("cm-completionIcon"), f.type && (h = d.classList).add.apply(h, Pe(f.type.split(/\s+/g).map(function(p) {
          return "cm-completionIcon-" + p;
        }))), d.setAttribute("aria-hidden", "true"), d;
      }, position: 20 }), l.push({ render: function(f, h, d) {
        var p = document.createElement("span");
        p.className = "cm-completionLabel";
        for (var v = f.label, m = 0, g = 1; g < d.length; ) {
          var y = d[g++], b = d[g++];
          y > m && p.appendChild(document.createTextNode(v.slice(m, y)));
          var k = p.appendChild(document.createElement("span"));
          k.appendChild(document.createTextNode(v.slice(y, b))), k.className = "cm-completionMatchedText", m = b;
        }
        return m < v.length && p.appendChild(document.createTextNode(v.slice(m))), p;
      }, position: 50 }, { render: function(f) {
        if (!f.detail)
          return null;
        var h = document.createElement("span");
        return h.className = "cm-completionDetail", h.textContent = f.detail, h;
      }, position: 80 }), l.sort(function(f, h) {
        return f.position - h.position;
      }).map(function(f) {
        return f.render;
      });
    }(u), this.optionClass = u.optionClass, this.range = z3(a.length, s, u.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.dom.addEventListener("mousedown", function(c) {
      for (var l, f = c.target; f && f != r.dom; f = f.parentNode)
        if (f.nodeName == "LI" && (l = /-(\d+)$/.exec(f.id)) && +l[1] < a.length)
          return CE(t, a[+l[1]]), void c.preventDefault();
    }), this.list = this.dom.appendChild(this.createListBox(a, i.id, this.range)), this.list.addEventListener("scroll", function() {
      r.info && r.view.requestMeasure(r.placeInfo);
    });
  }
  return Y(e, [{ key: "mount", value: function() {
    this.updateSel();
  } }, { key: "update", value: function(t) {
    t.state.field(this.stateField) != t.startState.field(this.stateField) && this.updateSel();
  } }, { key: "positioned", value: function() {
    this.info && this.view.requestMeasure(this.placeInfo);
  } }, { key: "updateSel", value: function() {
    var t = this, n = this.view.state.field(this.stateField), r = n.open;
    if ((r.selected < this.range.from || r.selected >= this.range.to) && (this.range = z3(r.options.length, r.selected, this.view.state.facet(fa).maxRenderedOptions), this.list.remove(), this.list = this.dom.appendChild(this.createListBox(r.options, n.id, this.range)), this.list.addEventListener("scroll", function() {
      t.info && t.view.requestMeasure(t.placeInfo);
    })), this.updateSelectedOption(r.selected)) {
      this.info && (this.info.remove(), this.info = null);
      var i = r.options[r.selected].completion, o = i.info;
      if (!o)
        return;
      var a = typeof o == "string" ? document.createTextNode(o) : o(i);
      if (!a)
        return;
      "then" in a ? a.then(function(s) {
        s && t.view.state.field(t.stateField, !1) == n && t.addInfoPane(s);
      }).catch(function(s) {
        return ei(t.view.state, s, "completion info");
      }) : this.addInfoPane(a);
    }
  } }, { key: "addInfoPane", value: function(t) {
    var n = this.info = document.createElement("div");
    n.className = "cm-tooltip cm-completionInfo", n.appendChild(t), this.dom.appendChild(n), this.view.requestMeasure(this.placeInfo);
  } }, { key: "updateSelectedOption", value: function(t) {
    for (var n = null, r = this.list.firstChild, i = this.range.from; r; r = r.nextSibling, i++)
      i == t ? r.hasAttribute("aria-selected") || (r.setAttribute("aria-selected", "true"), n = r) : r.hasAttribute("aria-selected") && r.removeAttribute("aria-selected");
    return n && function(o, a) {
      var s = o.getBoundingClientRect(), u = a.getBoundingClientRect();
      u.top < s.top ? o.scrollTop -= s.top - u.top : u.bottom > s.bottom && (o.scrollTop += u.bottom - s.bottom);
    }(this.list, n), n;
  } }, { key: "measureInfo", value: function() {
    var t = this.dom.querySelector("[aria-selected]");
    if (!t || !this.info)
      return null;
    var n = this.dom.getBoundingClientRect(), r = this.info.getBoundingClientRect(), i = t.getBoundingClientRect();
    if (i.top > Math.min(innerHeight, n.bottom) - 10 || i.bottom < Math.max(0, n.top) + 10)
      return null;
    var o = Math.max(0, Math.min(i.top, innerHeight - r.height)) - n.top, a = this.view.textDirection == Wn.RTL, s = n.left, u = innerWidth - n.right;
    return a && s < Math.min(r.width, u) ? a = !1 : !a && u < Math.min(r.width, s) && (a = !0), { top: o, left: a };
  } }, { key: "positionInfo", value: function(t) {
    this.info && (this.info.style.top = (t ? t.top : -1e6) + "px", t && (this.info.classList.toggle("cm-completionInfo-left", t.left), this.info.classList.toggle("cm-completionInfo-right", !t.left)));
  } }, { key: "createListBox", value: function(t, n, r) {
    var i = document.createElement("ul");
    i.id = n, i.setAttribute("role", "listbox"), i.setAttribute("aria-expanded", "true"), i.setAttribute("aria-label", this.view.state.phrase("Completions"));
    for (var o = r.from; o < r.to; o++) {
      var a = t[o], s = a.completion, u = a.match, c = i.appendChild(document.createElement("li"));
      c.id = n + "-" + o, c.setAttribute("role", "option");
      var l = this.optionClass(s);
      l && (c.className = l);
      var f, h = ut(this.optionContent);
      try {
        for (h.s(); !(f = h.n()).done; ) {
          var d = (0, f.value)(s, this.view.state, u);
          d && c.appendChild(d);
        }
      } catch (p) {
        h.e(p);
      } finally {
        h.f();
      }
    }
    return r.from && i.classList.add("cm-completionListIncompleteTop"), r.to < t.length && i.classList.add("cm-completionListIncompleteBottom"), i;
  } }]), e;
}();
function B3(e) {
  return 100 * (e.boost || 0) + (e.apply ? 10 : 0) + (e.info ? 5 : 0) + (e.type ? 1 : 0);
}
var NU = function() {
  function e(t, n, r, i, o) {
    Z(this, e), this.options = t, this.attrs = n, this.tooltip = r, this.timestamp = i, this.selected = o;
  }
  return Y(e, [{ key: "setSelected", value: function(t, n) {
    return t == this.selected || t >= this.options.length ? this : new e(this.options, F3(n, t), this.tooltip, this.timestamp, t);
  } }, { key: "map", value: function(t) {
    return new e(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: t.mapPos(this.tooltip.pos) }), this.timestamp, this.selected);
  } }], [{ key: "build", value: function(t, n, r, i, o) {
    var a = function(f, h) {
      var d, p = [], v = 0, m = ut(f);
      try {
        for (m.s(); !(d = m.n()).done; ) {
          var g = d.value;
          if (g.hasResult())
            if (g.result.filter === !1) {
              var y, b = g.result.getMatch, k = ut(g.result.options);
              try {
                for (k.s(); !(y = k.n()).done; ) {
                  var w = y.value, x = [1e9 - v++];
                  if (b) {
                    var S, T = ut(b(w));
                    try {
                      for (T.s(); !(S = T.n()).done; ) {
                        var P = S.value;
                        x.push(P);
                      }
                    } catch ($) {
                      T.e($);
                    } finally {
                      T.f();
                    }
                  }
                  p.push(new D3(w, g, x));
                }
              } catch ($) {
                k.e($);
              } finally {
                k.f();
              }
            } else {
              var O, j = new TU(h.sliceDoc(g.from, g.to)), V = void 0, E = ut(g.result.options);
              try {
                for (E.s(); !(O = E.n()).done; ) {
                  var C = O.value;
                  (V = j.match(C.label)) && (C.boost != null && (V[0] += C.boost), p.push(new D3(C, g, V)));
                }
              } catch ($) {
                E.e($);
              } finally {
                E.f();
              }
            }
        }
      } catch ($) {
        m.e($);
      } finally {
        m.f();
      }
      var H, X = [], F = null, G = ut(p.sort(zU));
      try {
        for (G.s(); !(H = G.n()).done; ) {
          var M = H.value;
          !F || F.label != M.completion.label || F.detail != M.completion.detail || F.type != null && M.completion.type != null && F.type != M.completion.type || F.apply != M.completion.apply ? X.push(M) : B3(M.completion) > B3(F) && (X[X.length - 1] = M), F = M.completion;
        }
      } catch ($) {
        G.e($);
      } finally {
        G.f();
      }
      return X;
    }(t, n);
    if (!a.length)
      return null;
    var s, u = 0;
    if (i && i.selected) {
      for (var c = i.options[i.selected].completion, l = 0; l < a.length; l++)
        if (a[l].completion == c) {
          u = l;
          break;
        }
    }
    return new e(a, F3(r, u), { pos: t.reduce(function(f, h) {
      return h.hasResult() ? Math.min(f, h.from) : f;
    }, 1e8), create: (s = hi, function(f) {
      return new IU(f, s);
    }), above: o.aboveCursor }, i ? i.timestamp : Date.now(), u);
  } }]), e;
}(), RU = function() {
  function e(t, n, r) {
    Z(this, e), this.active = t, this.id = n, this.open = r;
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n = this, r = t.state, i = r.facet(fa), o = (i.override || r.languageDataAt("autocomplete", ea(r)).map(MU)).map(function(l) {
      return (n.active.find(function(f) {
        return f.source == l;
      }) || new Ia(l, n.active.some(function(f) {
        return f.state != 0;
      }) ? 1 : 0)).update(t, i);
    });
    o.length == this.active.length && o.every(function(l, f) {
      return l == n.active[f];
    }) && (o = this.active);
    var a = t.selection || o.some(function(l) {
      return l.hasResult() && t.changes.touchesRange(l.from, l.to);
    }) || !function(l, f) {
      if (l == f)
        return !0;
      for (var h = 0, d = 0; ; ) {
        for (; h < l.length && !l[h].hasResult; )
          h++;
        for (; d < f.length && !f[d].hasResult; )
          d++;
        var p = h == l.length, v = d == f.length;
        if (p || v)
          return p == v;
        if (l[h++].result != f[d++].result)
          return !1;
      }
    }(o, this.active) ? NU.build(o, r, this.id, this.open, i) : this.open && t.docChanged ? this.open.map(t.changes) : this.open;
    !a && o.every(function(l) {
      return l.state != 1;
    }) && o.some(function(l) {
      return l.hasResult();
    }) && (o = o.map(function(l) {
      return l.hasResult() ? new Ia(l.source, 0) : l;
    }));
    var s, u = ut(t.effects);
    try {
      for (u.s(); !(s = u.n()).done; ) {
        var c = s.value;
        c.is(AE) && (a = a && a.setSelected(c.value, this.id));
      }
    } catch (l) {
      u.e(l);
    } finally {
      u.f();
    }
    return o == this.active && a == this.open ? this : new e(o, this.id, a);
  } }, { key: "tooltip", get: function() {
    return this.open ? this.open.tooltip : null;
  } }, { key: "attrs", get: function() {
    return this.open ? this.open.attrs : DU;
  } }], [{ key: "start", value: function() {
    return new e(LU, "cm-ac-" + Math.floor(2e6 * Math.random()).toString(36), null);
  } }]), e;
}(), DU = { "aria-autocomplete": "list" };
function F3(e, t) {
  return { "aria-autocomplete": "list", "aria-haspopup": "listbox", "aria-activedescendant": e + "-" + t, "aria-controls": e };
}
var LU = [];
function zU(e, t) {
  var n = t.match[0] - e.match[0];
  return n || e.completion.label.localeCompare(t.completion.label);
}
function lm(e) {
  return e.isUserEvent("input.type") ? "input" : e.isUserEvent("delete.backward") ? "delete" : null;
}
var Ia = function() {
  function e(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    Z(this, e), this.source = t, this.state = n, this.explicitPos = r;
  }
  return Y(e, [{ key: "hasResult", value: function() {
    return !1;
  } }, { key: "update", value: function(t, n) {
    var r = lm(t), i = this;
    r ? i = i.handleUserEvent(t, r, n) : t.docChanged ? i = i.handleChange(t) : t.selection && i.state != 0 && (i = new e(i.source, 0));
    var o, a = ut(t.effects);
    try {
      for (a.s(); !(o = a.n()).done; ) {
        var s = o.value;
        if (s.is(I0))
          i = new e(i.source, 1, s.value ? ea(t.state) : -1);
        else if (s.is(hh))
          i = new e(i.source, 0);
        else if (s.is(OE)) {
          var u, c = ut(s.value);
          try {
            for (c.s(); !(u = c.n()).done; ) {
              var l = u.value;
              l.source == i.source && (i = l);
            }
          } catch (f) {
            c.e(f);
          } finally {
            c.f();
          }
        }
      }
    } catch (f) {
      a.e(f);
    } finally {
      a.f();
    }
    return i;
  } }, { key: "handleUserEvent", value: function(t, n, r) {
    return n != "delete" && r.activateOnTyping ? new e(this.source, 1) : this.map(t.changes);
  } }, { key: "handleChange", value: function(t) {
    return t.changes.touchesRange(ea(t.startState)) ? new e(this.source, 0) : this.map(t.changes);
  } }, { key: "map", value: function(t) {
    return t.empty || this.explicitPos < 0 ? this : new e(this.source, this.state, t.mapPos(this.explicitPos));
  } }]), e;
}(), BU = function(e) {
  Et(n, Ia);
  var t = Mt(n);
  function n(r, i, o, a, s) {
    var u;
    return Z(this, n), (u = t.call(this, r, 2, i)).result = o, u.from = a, u.to = s, u;
  }
  return Y(n, [{ key: "hasResult", value: function() {
    return !0;
  } }, { key: "handleUserEvent", value: function(r, i, o) {
    var a, s = r.changes.mapPos(this.from), u = r.changes.mapPos(this.to, 1), c = ea(r.state);
    if ((this.explicitPos < 0 ? c <= s : c < this.from) || c > u || i == "delete" && ea(r.startState) == this.from)
      return new Ia(this.source, i == "input" && o.activateOnTyping ? 1 : 0);
    var l, f = this.explicitPos < 0 ? -1 : r.changes.mapPos(this.explicitPos);
    return function(h, d, p, v) {
      if (!h)
        return !1;
      var m = d.sliceDoc(p, v);
      return typeof h == "function" ? h(m, p, v, d) : _E(h, !0).test(m);
    }(this.result.validFor, r.state, s, u) ? new n(this.source, f, this.result, s, u) : this.result.update && (l = this.result.update(this.result, s, u, new $E(r.state, c, f >= 0))) ? new n(this.source, f, l, l.from, (a = l.to) !== null && a !== void 0 ? a : ea(r.state)) : new Ia(this.source, 1, f);
  } }, { key: "handleChange", value: function(r) {
    return r.changes.touchesRange(this.from, this.to) ? new Ia(this.source, 0) : this.map(r.changes);
  } }, { key: "map", value: function(r) {
    return r.empty ? this : new n(this.source, this.explicitPos < 0 ? -1 : r.mapPos(this.explicitPos), this.result, r.mapPos(this.from), r.mapPos(this.to, 1));
  } }]), n;
}(), I0 = He.define(), hh = He.define(), OE = He.define({ map: function(e, t) {
  return e.map(function(n) {
    return n.map(t);
  });
} }), AE = He.define(), hi = br.define({ create: function() {
  return RU.start();
}, update: function(e, t) {
  return e.update(t);
}, provide: function(e) {
  return [ld.from(e, function(t) {
    return t.tooltip;
  }), we.contentAttributes.from(e, function(t) {
    return t.attrs;
  })];
} });
function ql(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "option";
  return function(n) {
    var r = n.state.field(hi, !1);
    if (!r || !r.open || Date.now() - r.open.timestamp < 75)
      return !1;
    var i, o = 1;
    t == "page" && (i = DH(n, r.open.tooltip)) && (o = Math.max(2, Math.floor(i.dom.offsetHeight / i.dom.querySelector("li").offsetHeight) - 1));
    var a = r.open.selected + o * (e ? 1 : -1), s = r.open.options.length;
    return a < 0 ? a = t == "page" ? 0 : s - 1 : a >= s && (a = t == "page" ? s - 1 : 0), n.dispatch({ effects: AE.of(a) }), !0;
  };
}
var FU = Y(function e(t, n) {
  Z(this, e), this.active = t, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
}), qU = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.view = t, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.composing = 0;
    var n, r = ut(t.state.field(hi).active);
    try {
      for (r.s(); !(n = r.n()).done; ) {
        var i = n.value;
        i.state == 1 && this.startQuery(i);
      }
    } catch (o) {
      r.e(o);
    } finally {
      r.f();
    }
  }
  return Y(e, [{ key: "update", value: function(t) {
    var n = this, r = t.state.field(hi);
    if (t.selectionSet || t.docChanged || t.startState.field(hi) != r) {
      for (var i = t.transactions.some(function(p) {
        return (p.selection || p.docChanged) && !lm(p);
      }), o = 0; o < this.running.length; o++) {
        var a = this.running[o];
        if (i || a.updates.length + t.transactions.length > 50 && Date.now() - a.time > 1e3) {
          var s, u = ut(a.context.abortListeners);
          try {
            for (u.s(); !(s = u.n()).done; ) {
              var c = s.value;
              try {
                c();
              } catch (p) {
                ei(this.view.state, p);
              }
            }
          } catch (p) {
            u.e(p);
          } finally {
            u.f();
          }
          a.context.abortListeners = null, this.running.splice(o--, 1);
        } else {
          var l;
          (l = a.updates).push.apply(l, Pe(t.transactions));
        }
      }
      if (this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), this.debounceUpdate = r.active.some(function(p) {
        return p.state == 1 && !n.running.some(function(v) {
          return v.active.source == p.source;
        });
      }) ? setTimeout(function() {
        return n.startUpdate();
      }, 50) : -1, this.composing != 0) {
        var f, h = ut(t.transactions);
        try {
          for (h.s(); !(f = h.n()).done; ) {
            var d = f.value;
            lm(d) == "input" ? this.composing = 2 : this.composing == 2 && d.selection && (this.composing = 3);
          }
        } catch (p) {
          h.e(p);
        } finally {
          h.f();
        }
      }
    }
  } }, { key: "startUpdate", value: function() {
    var t = this;
    this.debounceUpdate = -1;
    var n, r = ut(this.view.state.field(hi).active);
    try {
      var i = function() {
        var o = n.value;
        o.state != 1 || t.running.some(function(a) {
          return a.active.source == o.source;
        }) || t.startQuery(o);
      };
      for (r.s(); !(n = r.n()).done; )
        i();
    } catch (o) {
      r.e(o);
    } finally {
      r.f();
    }
  } }, { key: "startQuery", value: function(t) {
    var n = this, r = this.view.state, i = ea(r), o = new $E(r, i, t.explicitPos == i), a = new FU(t, o);
    this.running.push(a), Promise.resolve(t.source(o)).then(function(s) {
      a.context.aborted || (a.done = s || null, n.scheduleAccept());
    }, function(s) {
      n.view.dispatch({ effects: hh.of(null) }), ei(n.view.state, s);
    });
  } }, { key: "scheduleAccept", value: function() {
    var t = this;
    this.running.every(function(n) {
      return n.done !== void 0;
    }) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(function() {
      return t.accept();
    }, 50));
  } }, { key: "accept", value: function() {
    var t, n = this;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    for (var r = [], i = this.view.state.facet(fa), o = function(s) {
      var u = n.running[s];
      if (u.done === void 0)
        return a = s, "continue";
      if (n.running.splice(s--, 1), u.done) {
        var c, l = new BU(u.active.source, u.active.explicitPos, u.done, u.done.from, (t = u.done.to) !== null && t !== void 0 ? t : ea(u.updates.length ? u.updates[0].startState : n.view.state)), f = ut(u.updates);
        try {
          for (f.s(); !(c = f.n()).done; ) {
            var h = c.value;
            l = l.update(h, i);
          }
        } catch (y) {
          f.e(y);
        } finally {
          f.f();
        }
        if (l.hasResult())
          return r.push(l), a = s, "continue";
      }
      var d = n.view.state.field(hi).active.find(function(y) {
        return y.source == u.active.source;
      });
      if (d && d.state == 1)
        if (u.done == null) {
          var p, v = new Ia(u.active.source, 0), m = ut(u.updates);
          try {
            for (m.s(); !(p = m.n()).done; ) {
              var g = p.value;
              v = v.update(g, i);
            }
          } catch (y) {
            m.e(y);
          } finally {
            m.f();
          }
          v.state != 1 && r.push(v);
        } else
          n.startQuery(d);
      a = s;
    }, a = 0; a < this.running.length; a++)
      o(a);
    r.length && this.view.dispatch({ effects: OE.of(r) });
  } }]), e;
}(), { eventHandlers: { blur: function() {
  var e = this.view.state.field(hi, !1);
  e && e.tooltip && this.view.state.facet(fa).closeOnBlur && this.view.dispatch({ effects: hh.of(null) });
}, compositionstart: function() {
  this.composing = 1;
}, compositionend: function() {
  var e = this;
  this.composing == 3 && setTimeout(function() {
    return e.view.dispatch({ effects: I0.of(!1) });
  }, 20), this.composing = 0;
} } }), VU = we.baseTheme({ ".cm-tooltip.cm-tooltip-autocomplete": { "& > ul": { fontFamily: "monospace", whiteSpace: "nowrap", overflow: "hidden auto", maxWidth_fallback: "700px", maxWidth: "min(700px, 95vw)", minWidth: "250px", maxHeight: "10em", listStyle: "none", margin: 0, padding: 0, "& > li": { overflowX: "hidden", textOverflow: "ellipsis", cursor: "pointer", padding: "1px 3px", lineHeight: 1.2 } } }, "&light .cm-tooltip-autocomplete ul li[aria-selected]": { background: "#17c", color: "white" }, "&dark .cm-tooltip-autocomplete ul li[aria-selected]": { background: "#347", color: "white" }, ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": { content: '"\xB7\xB7\xB7"', opacity: 0.5, display: "block", textAlign: "center" }, ".cm-tooltip.cm-completionInfo": { position: "absolute", padding: "3px 9px", width: "max-content", maxWidth: "300px" }, ".cm-completionInfo.cm-completionInfo-left": { right: "100%" }, ".cm-completionInfo.cm-completionInfo-right": { left: "100%" }, "&light .cm-snippetField": { backgroundColor: "#00000022" }, "&dark .cm-snippetField": { backgroundColor: "#ffffff22" }, ".cm-snippetFieldPosition": { verticalAlign: "text-top", width: 0, height: "1.15em", margin: "0 -0.7px -.7em", borderLeft: "1.4px dotted #888" }, ".cm-completionMatchedText": { textDecoration: "underline" }, ".cm-completionDetail": { marginLeft: "0.5em", fontStyle: "italic" }, ".cm-completionIcon": { fontSize: "90%", width: ".8em", display: "inline-block", textAlign: "center", paddingRight: ".6em", opacity: "0.6" }, ".cm-completionIcon-function, .cm-completionIcon-method": { "&:after": { content: "'\u0192'" } }, ".cm-completionIcon-class": { "&:after": { content: "'\u25CB'" } }, ".cm-completionIcon-interface": { "&:after": { content: "'\u25CC'" } }, ".cm-completionIcon-variable": { "&:after": { content: "'\u{1D465}'" } }, ".cm-completionIcon-constant": { "&:after": { content: "'\u{1D436}'" } }, ".cm-completionIcon-type": { "&:after": { content: "'\u{1D461}'" } }, ".cm-completionIcon-enum": { "&:after": { content: "'\u222A'" } }, ".cm-completionIcon-property": { "&:after": { content: "'\u25A1'" } }, ".cm-completionIcon-keyword": { "&:after": { content: "'\u{1F511}\uFE0E'" } }, ".cm-completionIcon-namespace": { "&:after": { content: "'\u25A2'" } }, ".cm-completionIcon-text": { "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" } } }), dh = { brackets: ["(", "[", "{", "'", '"'], before: ")]}:;>" }, Na = He.define({ map: function(e, t) {
  var n = t.mapPos(e, -1, Ir.TrackAfter);
  return n == null ? void 0 : n;
} }), N0 = He.define({ map: function(e, t) {
  return t.mapPos(e);
} }), fm = new (function(e) {
  Et(n, Ta);
  var t = Mt(n);
  function n() {
    return Z(this, n), t.apply(this, arguments);
  }
  return Y(n);
}())();
fm.startSide = 1, fm.endSide = -1;
var PE = br.define({ create: function() {
  return Nn.empty;
}, update: function(e, t) {
  if (t.selection) {
    var n = t.state.doc.lineAt(t.selection.main.head).from, r = t.startState.doc.lineAt(t.startState.selection.main.head).from;
    n != t.changes.mapPos(r, -1) && (e = Nn.empty);
  }
  e = e.map(t.changes);
  var i, o = ut(t.effects);
  try {
    var a = function() {
      var s = i.value;
      s.is(Na) ? e = e.update({ add: [fm.range(s.value, s.value + 1)] }) : s.is(N0) && (e = e.update({ filter: function(u) {
        return u != s.value;
      } }));
    };
    for (o.s(); !(i = o.n()).done; )
      a();
  } catch (s) {
    o.e(s);
  } finally {
    o.f();
  }
  return e;
} });
function EE(e) {
  for (var t = 0; t < 8; t += 2)
    if ("()[]{}<>".charCodeAt(t) == e)
      return "()[]{}<>".charAt(t + 1);
  return l0(e < 128 ? e : e + 1);
}
function ME(e, t) {
  return e.languageDataAt("closeBrackets", t)[0] || dh;
}
var HU = (typeof navigator > "u" ? "undefined" : ne(navigator)) == "object" && /Android\b/.test(navigator.userAgent), WU = we.inputHandler.of(function(e, t, n, r) {
  if ((HU ? e.composing : e.compositionStarted) || e.state.readOnly)
    return !1;
  var i = e.state.selection.main;
  if (r.length > 2 || r.length == 2 && Jr(gr(r, 0)) == 1 || t != i.from || n != i.to)
    return !1;
  var o = function(a, s) {
    var u, c = ME(a, a.selection.main.head), l = c.brackets || dh.brackets, f = ut(l);
    try {
      for (f.s(); !(u = f.n()).done; ) {
        var h = u.value, d = EE(gr(h, 0));
        if (s == h)
          return d == h ? GU(a, h, l.indexOf(h + h + h) > -1) : JU(a, h, d, c.before || dh.before);
        if (s == d && TE(a, a.selection.main.from))
          return KU(a, h, d);
      }
    } catch (p) {
      f.e(p);
    } finally {
      f.f();
    }
    return null;
  }(e.state, r);
  return !!o && (e.dispatch(o), !0);
}), UU = [{ key: "Backspace", run: function(e) {
  var t = e.state, n = e.dispatch;
  if (t.readOnly)
    return !1;
  var r = ME(t, t.selection.main.head).brackets || dh.brackets, i = null, o = t.changeByRange(function(a) {
    if (a.empty) {
      var s, u = function(f, h) {
        var d = f.sliceString(h - 2, h);
        return Jr(gr(d, 0)) == d.length ? d : d.slice(1);
      }(t.doc, a.head), c = ut(r);
      try {
        for (c.s(); !(s = c.n()).done; ) {
          var l = s.value;
          if (l == u && bd(t.doc, a.head) == EE(gr(l, 0)))
            return { changes: { from: a.head - l.length, to: a.head + l.length }, range: Ht.cursor(a.head - l.length), userEvent: "delete.backward" };
        }
      } catch (f) {
        c.e(f);
      } finally {
        c.f();
      }
    }
    return { range: i = a };
  });
  return i || n(t.update(o, { scrollIntoView: !0 })), !i;
} }];
function TE(e, t) {
  var n = !1;
  return e.field(PE).between(0, e.doc.length, function(r) {
    r == t && (n = !0);
  }), n;
}
function bd(e, t) {
  var n = e.sliceString(t, t + 2);
  return n.slice(0, Jr(gr(n, 0)));
}
function JU(e, t, n, r) {
  var i = null, o = e.changeByRange(function(a) {
    if (!a.empty)
      return { changes: [{ insert: t, from: a.from }, { insert: n, from: a.to }], effects: Na.of(a.to + t.length), range: Ht.range(a.anchor + t.length, a.head + t.length) };
    var s = bd(e.doc, a.head);
    return !s || /\s/.test(s) || r.indexOf(s) > -1 ? { changes: { insert: t + n, from: a.head }, effects: Na.of(a.head + t.length), range: Ht.cursor(a.head + t.length) } : { range: i = a };
  });
  return i ? null : e.update(o, { scrollIntoView: !0, userEvent: "input.type" });
}
function KU(e, t, n) {
  var r = null, i = e.selection.ranges.map(function(o) {
    return o.empty && bd(e.doc, o.head) == n ? Ht.cursor(o.head + n.length) : r = o;
  });
  return r ? null : e.update({ selection: Ht.create(i, e.selection.mainIndex), scrollIntoView: !0, effects: e.selection.ranges.map(function(o) {
    var a = o.from;
    return N0.of(a);
  }) });
}
function GU(e, t, n) {
  var r = null, i = e.changeByRange(function(o) {
    if (!o.empty)
      return { changes: [{ insert: t, from: o.from }, { insert: t, from: o.to }], effects: Na.of(o.to + t.length), range: Ht.range(o.anchor + t.length, o.head + t.length) };
    var a = o.head, s = bd(e.doc, a);
    if (s == t) {
      if (q3(e, a))
        return { changes: { insert: t + t, from: a }, effects: Na.of(a + t.length), range: Ht.cursor(a + t.length) };
      if (TE(e, a)) {
        var u = n && e.sliceDoc(a, a + 3 * t.length) == t + t + t;
        return { range: Ht.cursor(a + t.length * (u ? 3 : 1)), effects: N0.of(a) };
      }
    } else {
      if (n && e.sliceDoc(a - 2 * t.length, a) == t + t && q3(e, a - 2 * t.length))
        return { changes: { insert: t + t + t + t, from: a }, effects: Na.of(a + t.length), range: Ht.cursor(a + t.length) };
      if (e.charCategorizer(a)(s) != Nr.Word) {
        var c = e.sliceDoc(a - 1, a);
        if (c != t && e.charCategorizer(a)(c) != Nr.Word && !function(l, f, h) {
          for (var d = Or(l).resolveInner(f, -1), p = 0; p < 5; p++) {
            if (l.sliceDoc(d.from, d.from + h.length) == h)
              return !0;
            var v = d.to == f && d.parent;
            if (!v)
              break;
            d = v;
          }
          return !1;
        }(e, a, t))
          return { changes: { insert: t + t, from: a }, effects: Na.of(a + t.length), range: Ht.cursor(a + t.length) };
      }
    }
    return { range: r = o };
  });
  return r ? null : e.update(i, { scrollIntoView: !0, userEvent: "input.type" });
}
function q3(e, t) {
  var n = Or(e).resolveInner(t + 1);
  return n.parent && n.from == t;
}
function QU() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return [hi, fa.of(e), qU, XU, VU];
}
var IE = [{ key: "Ctrl-Space", run: function(e) {
  return !!e.state.field(hi, !1) && (e.dispatch({ effects: I0.of(!0) }), !0);
} }, { key: "Escape", run: function(e) {
  var t = e.state.field(hi, !1);
  return !(!t || !t.active.some(function(n) {
    return n.state != 0;
  })) && (e.dispatch({ effects: hh.of(null) }), !0);
} }, { key: "ArrowDown", run: ql(!0) }, { key: "ArrowUp", run: ql(!1) }, { key: "PageDown", run: ql(!0, "page") }, { key: "PageUp", run: ql(!1, "page") }, { key: "Enter", run: function(e) {
  var t = e.state.field(hi, !1);
  return !(e.state.readOnly || !t || !t.open || Date.now() - t.open.timestamp < 75) && (CE(e, t.open.options[t.open.selected]), !0);
} }], XU = Qc.highest(cd.computeN([fa], function(e) {
  return e.facet(fa).defaultKeymap ? [IE] : [];
})), ZU = Y(function e(t, n, r) {
  Z(this, e), this.from = t, this.to = n, this.diagnostic = r;
}), Eu = function() {
  function e(t, n, r) {
    Z(this, e), this.diagnostics = t, this.panel = n, this.selected = r;
  }
  return Y(e, null, [{ key: "init", value: function(t, n, r) {
    var i = t, o = r.facet(Ra).markerFilter;
    o && (i = o(i));
    var a = $e.set(i.map(function(s) {
      return s.from == s.to || s.from == s.to - 1 && r.doc.lineAt(s.from).to == s.from ? $e.widget({ widget: new iJ(s), diagnostic: s }).range(s.from) : $e.mark({ attributes: { class: "cm-lintRange cm-lintRange-" + s.severity }, diagnostic: s }).range(s.from, s.to);
    }), !0);
    return new e(a, n, Ks(a));
  } }]), e;
}();
function Ks(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, r = null;
  return e.between(n, 1e9, function(i, o, a) {
    var s = a.spec;
    if (!t || s.diagnostic == t)
      return r = new ZU(i, o, s.diagnostic), !1;
  }), r;
}
function NE(e, t) {
  return !(!e.effects.some(function(n) {
    return n.is(kd);
  }) && !e.changes.touchesRange(t.pos));
}
function RE(e, t) {
  return e.field(Yr, !1) ? t : t.concat(He.appendConfig.of([Yr, we.decorations.compute([Yr], function(n) {
    var r = n.field(Yr), i = r.selected, o = r.panel;
    return i && o && i.from != i.to ? $e.set([YU.range(i.from, i.to)]) : $e.none;
  }), RH(tJ, { hideOn: NE }), oJ]));
}
var kd = He.define(), R0 = He.define(), DE = He.define(), Yr = br.define({ create: function() {
  return new Eu($e.none, null, null);
}, update: function(e, t) {
  if (t.docChanged) {
    var n = e.diagnostics.map(t.changes), r = null;
    if (e.selected) {
      var i = t.changes.mapPos(e.selected.from, 1);
      r = Ks(n, e.selected.diagnostic, i) || Ks(n, null, i);
    }
    e = new Eu(n, e.panel, r);
  }
  var o, a = ut(t.effects);
  try {
    for (a.s(); !(o = a.n()).done; ) {
      var s = o.value;
      s.is(kd) ? e = Eu.init(s.value, e.panel, t.state) : s.is(R0) ? e = new Eu(e.diagnostics, s.value ? FE.open : null, e.selected) : s.is(DE) && (e = new Eu(e.diagnostics, e.panel, s.value));
    }
  } catch (u) {
    a.e(u);
  } finally {
    a.f();
  }
  return e;
}, provide: function(e) {
  return [yc.from(e, function(t) {
    return t.panel;
  }), we.decorations.from(e, function(t) {
    return t.diagnostics;
  })];
} }), YU = $e.mark({ class: "cm-lintRange cm-lintRange-active" });
function tJ(e, t, n) {
  var r = e.state.field(Yr).diagnostics, i = [], o = 2e8, a = 0;
  r.between(t - (n < 0 ? 1 : 0), t + (n > 0 ? 1 : 0), function(u, c, l) {
    var f = l.spec;
    t >= u && t <= c && (u == c || (t > u || n > 0) && (t < c || n < 0)) && (i.push(f.diagnostic), o = Math.min(u, o), a = Math.max(c, a));
  });
  var s = e.state.facet(Ra).tooltipFilter;
  return s && (i = s(i)), i.length ? { pos: o, end: a, above: e.state.doc.lineAt(o).to < a, create: function() {
    return { dom: LE(e, i) };
  } } : null;
}
function LE(e, t) {
  return Fn("ul", { class: "cm-tooltip-lint" }, t.map(function(n) {
    return BE(e, n, !1);
  }));
}
var V3 = function(e) {
  var t = e.state.field(Yr, !1);
  return !(!t || !t.panel) && (e.dispatch({ effects: R0.of(!1) }), !0);
}, eJ = [{ key: "Mod-Shift-m", run: function(e) {
  var t = e.state.field(Yr, !1);
  t && t.panel || e.dispatch({ effects: RE(e.state, [R0.of(!0)]) });
  var n = gc(e, FE.open);
  return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
} }, { key: "F8", run: function(e) {
  var t = e.state.field(Yr, !1);
  if (!t)
    return !1;
  var n = e.state.selection.main, r = t.diagnostics.iter(n.to + 1);
  return !(!r.value && (!(r = t.diagnostics.iter(0)).value || r.from == n.from && r.to == n.to)) && (e.dispatch({ selection: { anchor: r.from, head: r.to }, scrollIntoView: !0 }), !0);
} }], nJ = wr.fromClass(function() {
  function e(t) {
    Z(this, e), this.view = t, this.timeout = -1, this.set = !0;
    var n = t.state.facet(Ra).delay;
    this.lintTime = Date.now() + n, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, n);
  }
  return Y(e, [{ key: "run", value: function() {
    var t = this, n = Date.now();
    if (n < this.lintTime - 10)
      setTimeout(this.run, this.lintTime - n);
    else {
      this.set = !1;
      var r = this.view.state, i = r.facet(Ra).sources;
      Promise.all(i.map(function(o) {
        return Promise.resolve(o(t.view));
      })).then(function(o) {
        var a = o.reduce(function(s, u) {
          return s.concat(u);
        });
        t.view.state.doc == r.doc && t.view.dispatch(function(s, u) {
          return { effects: RE(s, [kd.of(u)]) };
        }(t.view.state, a));
      }, function(o) {
        ei(t.view.state, o);
      });
    }
  } }, { key: "update", value: function(t) {
    var n = t.state.facet(Ra);
    (t.docChanged || n != t.startState.facet(Ra)) && (this.lintTime = Date.now() + n.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, n.delay)));
  } }, { key: "force", value: function() {
    this.set && (this.lintTime = Date.now(), this.run());
  } }, { key: "destroy", value: function() {
    clearTimeout(this.timeout);
  } }]), e;
}()), Ra = be.define({ combine: function(e) {
  return Object.assign({ sources: e.map(function(t) {
    return t.source;
  }) }, ko(e.map(function(t) {
    return t.config;
  }), { delay: 750, markerFilter: null, tooltipFilter: null }));
}, enables: nJ });
function rJ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Ra.of({ source: e, config: t });
}
function zE(e) {
  var t = [];
  if (e) {
    var n, r = ut(e);
    try {
      t:
        for (r.s(); !(n = r.n()).done; ) {
          for (var i = n.value.name, o = function(s) {
            var u = i[s];
            if (/[a-zA-Z]/.test(u) && !t.some(function(c) {
              return c.toLowerCase() == u.toLowerCase();
            }))
              return t.push(u), "continue|actions";
          }, a = 0; a < i.length; a++)
            if (o(a) === "continue|actions")
              continue t;
          t.push("");
        }
    } catch (s) {
      r.e(s);
    } finally {
      r.f();
    }
  }
  return t;
}
function BE(e, t, n) {
  var r, i = n ? zE(t.actions) : [];
  return Fn("li", { class: "cm-diagnostic cm-diagnostic-" + t.severity }, Fn("span", { class: "cm-diagnosticText" }, t.renderMessage ? t.renderMessage() : t.message), (r = t.actions) === null || r === void 0 ? void 0 : r.map(function(o, a) {
    var s = function(f) {
      f.preventDefault();
      var h = Ks(e.state.field(Yr).diagnostics, t);
      h && o.apply(e, h.from, h.to);
    }, u = o.name, c = i[a] ? u.indexOf(i[a]) : -1, l = c < 0 ? u : [u.slice(0, c), Fn("u", u.slice(c, c + 1)), u.slice(c + 1)];
    return Fn("button", { type: "button", class: "cm-diagnosticAction", onclick: s, onmousedown: s, "aria-label": " Action: ".concat(u).concat(c < 0 ? "" : ' (access key "'.concat(i[a], ')"'), ".") }, l);
  }), t.source && Fn("div", { class: "cm-diagnosticSource" }, t.source));
}
var iJ = function(e) {
  Et(n, ba);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).diagnostic = r, i;
  }
  return Y(n, [{ key: "eq", value: function(r) {
    return r.diagnostic == this.diagnostic;
  } }, { key: "toDOM", value: function() {
    return Fn("span", { class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity });
  } }]), n;
}(), H3 = Y(function e(t, n) {
  Z(this, e), this.diagnostic = n, this.id = "item_" + Math.floor(4294967295 * Math.random()).toString(16), this.dom = BE(t, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
}), FE = function() {
  function e(t) {
    var n = this;
    Z(this, e), this.view = t, this.items = [], this.list = Fn("ul", { tabIndex: 0, role: "listbox", "aria-label": this.view.state.phrase("Diagnostics"), onkeydown: function(r) {
      if (r.keyCode == 27)
        V3(n.view), n.view.focus();
      else if (r.keyCode == 38 || r.keyCode == 33)
        n.moveSelection((n.selectedIndex - 1 + n.items.length) % n.items.length);
      else if (r.keyCode == 40 || r.keyCode == 34)
        n.moveSelection((n.selectedIndex + 1) % n.items.length);
      else if (r.keyCode == 36)
        n.moveSelection(0);
      else if (r.keyCode == 35)
        n.moveSelection(n.items.length - 1);
      else if (r.keyCode == 13)
        n.view.focus();
      else {
        if (!(r.keyCode >= 65 && r.keyCode <= 90 && n.selectedIndex >= 0))
          return;
        for (var i = n.items[n.selectedIndex].diagnostic, o = zE(i.actions), a = 0; a < o.length; a++)
          if (o[a].toUpperCase().charCodeAt(0) == r.keyCode) {
            var s = Ks(n.view.state.field(Yr).diagnostics, i);
            s && i.actions[a].apply(t, s.from, s.to);
          }
      }
      r.preventDefault();
    }, onclick: function(r) {
      for (var i = 0; i < n.items.length; i++)
        n.items[i].dom.contains(r.target) && n.moveSelection(i);
    } }), this.dom = Fn("div", { class: "cm-panel-lint" }, this.list, Fn("button", { type: "button", name: "close", "aria-label": this.view.state.phrase("close"), onclick: function() {
      return V3(n.view);
    } }, "\xD7")), this.update();
  }
  return Y(e, [{ key: "selectedIndex", get: function() {
    var t = this.view.state.field(Yr).selected;
    if (!t)
      return -1;
    for (var n = 0; n < this.items.length; n++)
      if (this.items[n].diagnostic == t.diagnostic)
        return n;
    return -1;
  } }, { key: "update", value: function() {
    var t = this, n = this.view.state.field(Yr), r = n.diagnostics, i = n.selected, o = 0, a = !1, s = null;
    for (r.between(0, this.view.state.doc.length, function(u, c, l) {
      for (var f, h = l.spec, d = -1, p = o; p < t.items.length; p++)
        if (t.items[p].diagnostic == h.diagnostic) {
          d = p;
          break;
        }
      d < 0 ? (f = new H3(t.view, h.diagnostic), t.items.splice(o, 0, f), a = !0) : (f = t.items[d], d > o && (t.items.splice(o, d - o), a = !0)), i && f.diagnostic == i.diagnostic ? f.dom.hasAttribute("aria-selected") || (f.dom.setAttribute("aria-selected", "true"), s = f) : f.dom.hasAttribute("aria-selected") && f.dom.removeAttribute("aria-selected"), o++;
    }); o < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      a = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new H3(this.view, { from: -1, to: -1, severity: "info", message: this.view.state.phrase("No diagnostics") })), a = !0), s ? (this.list.setAttribute("aria-activedescendant", s.id), this.view.requestMeasure({ key: this, read: function() {
      return { sel: s.dom.getBoundingClientRect(), panel: t.list.getBoundingClientRect() };
    }, write: function(u) {
      var c = u.sel, l = u.panel;
      c.top < l.top ? t.list.scrollTop -= l.top - c.top : c.bottom > l.bottom && (t.list.scrollTop += c.bottom - l.bottom);
    } })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), a && this.sync();
  } }, { key: "sync", value: function() {
    var t = this.list.firstChild;
    function n() {
      var a = t;
      t = a.nextSibling, a.remove();
    }
    var r, i = ut(this.items);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        if (o.dom.parentNode == this.list) {
          for (; t != o.dom; )
            n();
          t = o.dom.nextSibling;
        } else
          this.list.insertBefore(o.dom, t);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    for (; t; )
      n();
  } }, { key: "moveSelection", value: function(t) {
    if (!(this.selectedIndex < 0)) {
      var n = Ks(this.view.state.field(Yr).diagnostics, this.items[t].diagnostic);
      n && this.view.dispatch({ selection: { anchor: n.from, head: n.to }, scrollIntoView: !0, effects: DE.of(n) });
    }
  } }], [{ key: "open", value: function(t) {
    return new e(t);
  } }]), e;
}();
function hf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'viewBox="0 0 40 40"';
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" `.concat(t, ">").concat(encodeURIComponent(e), "</svg>')");
}
function gv(e) {
  return hf('<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="'.concat(e, '" fill="none" stroke-width=".7"/>'), 'width="6" height="3"');
}
var oJ = we.baseTheme({ ".cm-diagnostic": { padding: "3px 6px 3px 8px", marginLeft: "-1px", display: "block", whiteSpace: "pre-wrap" }, ".cm-diagnostic-error": { borderLeft: "5px solid #d11" }, ".cm-diagnostic-warning": { borderLeft: "5px solid orange" }, ".cm-diagnostic-info": { borderLeft: "5px solid #999" }, ".cm-diagnosticAction": { font: "inherit", border: "none", padding: "2px 4px", backgroundColor: "#444", color: "white", borderRadius: "3px", marginLeft: "8px" }, ".cm-diagnosticSource": { fontSize: "70%", opacity: 0.7 }, ".cm-lintRange": { backgroundPosition: "left bottom", backgroundRepeat: "repeat-x", paddingBottom: "0.7px" }, ".cm-lintRange-error": { backgroundImage: gv("#d11") }, ".cm-lintRange-warning": { backgroundImage: gv("orange") }, ".cm-lintRange-info": { backgroundImage: gv("#999") }, ".cm-lintRange-active": { backgroundColor: "#ffdd9980" }, ".cm-tooltip-lint": { padding: 0, margin: 0 }, ".cm-lintPoint": { position: "relative", "&:after": { content: '""', position: "absolute", bottom: 0, left: "-2px", borderLeft: "3px solid transparent", borderRight: "3px solid transparent", borderBottom: "4px solid #d11" } }, ".cm-lintPoint-warning": { "&:after": { borderBottomColor: "orange" } }, ".cm-lintPoint-info": { "&:after": { borderBottomColor: "#999" } }, ".cm-panel.cm-panel-lint": { position: "relative", "& ul": { maxHeight: "100px", overflowY: "auto", "& [aria-selected]": { backgroundColor: "#ddd", "& u": { textDecoration: "underline" } }, "&:focus [aria-selected]": { background_fallback: "#bdf", backgroundColor: "Highlight", color_fallback: "white", color: "HighlightText" }, "& u": { textDecoration: "none" }, padding: 0, margin: 0 }, "& [name=close]": { position: "absolute", top: "0", right: "2px", background: "inherit", border: "none", font: "inherit", padding: 0, margin: 0 } } }), aJ = function(e) {
  Et(n, eo);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), (i = t.call(this)).diagnostics = r, i.severity = r.reduce(function(o, a) {
      var s = a.severity;
      return s == "error" || s == "warning" && o == "info" ? s : o;
    }, "info"), i;
  }
  return Y(n, [{ key: "toDOM", value: function(r) {
    var i = document.createElement("div");
    i.className = "cm-lint-marker cm-lint-marker-" + this.severity;
    var o = this.diagnostics, a = r.state.facet(vh).tooltipFilter;
    return a && (o = a(o)), o.length && (i.onmouseover = function() {
      return function(s, u, c) {
        function l() {
          var d = s.elementAtHeight(u.getBoundingClientRect().top + 5 - s.documentTop);
          s.coordsAtPos(d.from) && s.dispatch({ effects: hm.of({ pos: d.from, above: !1, create: function() {
            return { dom: LE(s, c), getCoords: function() {
              return u.getBoundingClientRect();
            } };
          } }) }), u.onmouseout = u.onmousemove = null, function(p, v) {
            var m = function g(y) {
              var b = v.getBoundingClientRect();
              if (!(y.clientX > b.left - 10 && y.clientX < b.right + 10 && y.clientY > b.top - 10 && y.clientY < b.bottom + 10)) {
                for (var k = y.target; k; k = k.parentNode)
                  if (k.nodeType == 1 && k.classList.contains("cm-tooltip-lint"))
                    return;
                window.removeEventListener("mousemove", g), p.state.field(VE) && p.dispatch({ effects: hm.of(null) });
              }
            };
            window.addEventListener("mousemove", m);
          }(s, u);
        }
        var f = s.state.facet(vh).hoverTime, h = setTimeout(l, f);
        u.onmouseout = function() {
          clearTimeout(h), u.onmouseout = u.onmousemove = null;
        }, u.onmousemove = function() {
          clearTimeout(h), h = setTimeout(l, f);
        };
      }(r, i, o);
    }), i;
  } }]), n;
}();
function sJ(e, t) {
  var n, r = /* @__PURE__ */ Object.create(null), i = ut(t);
  try {
    for (i.s(); !(n = i.n()).done; ) {
      var o = n.value, a = e.lineAt(o.from);
      (r[a.from] || (r[a.from] = [])).push(o);
    }
  } catch (c) {
    i.e(c);
  } finally {
    i.f();
  }
  var s = [];
  for (var u in r)
    s.push(new aJ(r[u]).range(+u));
  return Nn.of(s, !0);
}
var uJ = EP({ class: "cm-gutter-lint", markers: function(e) {
  return e.state.field(qE);
} }), qE = br.define({ create: function() {
  return Nn.empty;
}, update: function(e, t) {
  e = e.map(t.changes);
  var n, r = t.state.facet(vh).markerFilter, i = ut(t.effects);
  try {
    for (i.s(); !(n = i.n()).done; ) {
      var o = n.value;
      if (o.is(kd)) {
        var a = o.value;
        r && (a = r(a || [])), e = sJ(t.state.doc, a.slice(0));
      }
    }
  } catch (s) {
    i.e(s);
  } finally {
    i.f();
  }
  return e;
} }), hm = He.define(), VE = br.define({ create: function() {
  return null;
}, update: function(e, t) {
  return e && t.docChanged && (e = NE(t, e) ? null : Object.assign(Object.assign({}, e), { pos: t.changes.mapPos(e.pos) })), t.effects.reduce(function(n, r) {
    return r.is(hm) ? r.value : n;
  }, e);
}, provide: function(e) {
  return ld.from(e);
} }), cJ = we.baseTheme({ ".cm-gutter-lint": { width: "1.4em", "& .cm-gutterElement": { padding: ".2em" } }, ".cm-lint-marker": { width: "1em", height: "1em" }, ".cm-lint-marker-info": { content: hf('<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>') }, ".cm-lint-marker-warning": { content: hf('<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>') }, ".cm-lint-marker-error:before": { content: hf('<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>') } }), vh = be.define({ combine: function(e) {
  return ko(e, { hoverTime: 300, markerFilter: null, tooltipFilter: null });
} });
function lJ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return [vh.of(e), qE, uJ, cJ, VE];
}
var fJ = function() {
  return [HH(), UH, bH(), eU(), $W(), fH(), [Lu, pH], In.allowMultipleSelections.of(!0), In.transactionFilter.of(function(n) {
    if (!n.docChanged || !n.isUserEvent("input.type") && !n.isUserEvent("input.complete"))
      return n;
    var r = n.startState.languageDataAt("indentOnInput", n.startState.selection.main.head);
    if (!r.length)
      return n;
    var i = n.newDoc, o = n.newSelection.main.head, a = i.lineAt(o);
    if (o > a.from + 200)
      return n;
    var s = i.sliceString(a.from, o);
    if (!r.some(function(y) {
      return y.test(s);
    }))
      return n;
    var u, c = n.state, l = -1, f = [], h = ut(c.selection.ranges);
    try {
      for (h.s(); !(u = h.n()).done; ) {
        var d = u.value.head, p = c.doc.lineAt(d);
        if (p.from != l) {
          l = p.from;
          var v = b0(c, p.from);
          if (v != null) {
            var m = /^\s*/.exec(p.text)[0], g = xc(c, v);
            m != g && f.push({ from: p.from, to: p.from + m.length, insert: g });
          }
        }
      }
    } catch (y) {
      h.e(y);
    } finally {
      h.f();
    }
    return f.length ? [n, { changes: f, sequential: !0 }] : n;
  }), XP(AW, { fallback: !0 }), NW(), [WU, PE], QU(), _H(), AH(), SH, (t = [bU, yU], e && t.push(xE.of(e)), t), cd.of([].concat(UU, Pe(hU), OU, cU, xW, IE, eJ))];
  var e, t;
}(), hJ = 0, yv = Y(function e(t, n) {
  Z(this, e), this.from = t, this.to = n;
}), Bn = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Z(this, e), this.id = hJ++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function() {
      throw new Error("This node type doesn't define a deserialize function");
    };
  }
  return Y(e, [{ key: "add", value: function(t) {
    var n = this;
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = Ao.match(t)), function(r) {
      var i = t(r);
      return i === void 0 ? null : [n, i];
    };
  } }]), e;
}();
Bn.closedBy = new Bn({ deserialize: function(e) {
  return e.split(" ");
} }), Bn.openedBy = new Bn({ deserialize: function(e) {
  return e.split(" ");
} }), Bn.group = new Bn({ deserialize: function(e) {
  return e.split(" ");
} }), Bn.contextHash = new Bn({ perNode: !0 }), Bn.lookAhead = new Bn({ perNode: !0 }), Bn.mounted = new Bn({ perNode: !0 });
var dJ = /* @__PURE__ */ Object.create(null), Ao = function() {
  function e(t, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    Z(this, e), this.name = t, this.props = n, this.id = r, this.flags = i;
  }
  return Y(e, [{ key: "prop", value: function(t) {
    return this.props[t.id];
  } }, { key: "isTop", get: function() {
    return (1 & this.flags) > 0;
  } }, { key: "isSkipped", get: function() {
    return (2 & this.flags) > 0;
  } }, { key: "isError", get: function() {
    return (4 & this.flags) > 0;
  } }, { key: "isAnonymous", get: function() {
    return (8 & this.flags) > 0;
  } }, { key: "is", value: function(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      var n = this.prop(Bn.group);
      return !!n && n.indexOf(t) > -1;
    }
    return this.id == t;
  } }], [{ key: "define", value: function(t) {
    var n = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : dJ, r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new e(t.name || "", n, t.id, r);
    if (t.props) {
      var o, a = ut(t.props);
      try {
        for (a.s(); !(o = a.n()).done; ) {
          var s = o.value;
          if (Array.isArray(s) || (s = s(i)), s) {
            if (s[0].perNode)
              throw new RangeError("Can't store a per-node prop on a node type");
            n[s[0].id] = s[1];
          }
        }
      } catch (u) {
        a.e(u);
      } finally {
        a.f();
      }
    }
    return i;
  } }, { key: "match", value: function(t) {
    var n = /* @__PURE__ */ Object.create(null);
    for (var r in t) {
      var i, o = ut(r.split(" "));
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var a = i.value;
          n[a] = t[r];
        }
      } catch (s) {
        o.e(s);
      } finally {
        o.f();
      }
    }
    return function(s) {
      for (var u = s.prop(Bn.group), c = -1; c < (u ? u.length : 0); c++) {
        var l = n[c < 0 ? s.name : u[c]];
        if (l)
          return l;
      }
    };
  } }]), e;
}();
Ao.none = new Ao("", /* @__PURE__ */ Object.create(null), 0, 8);
var $r, vJ = function() {
  function e(t) {
    Z(this, e), this.types = t;
    for (var n = 0; n < t.length; n++)
      if (t[n].id != n)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  return Y(e, [{ key: "extend", value: function() {
    for (var t = [], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var o, a = ut(this.types);
    try {
      for (a.s(); !(o = a.n()).done; ) {
        var s, u = o.value, c = null, l = ut(r);
        try {
          for (l.s(); !(s = l.n()).done; ) {
            var f = s.value, h = f(u);
            h && (c || (c = Object.assign({}, u.props)), c[h[0].id] = h[1]);
          }
        } catch (d) {
          l.e(d);
        } finally {
          l.f();
        }
        t.push(c ? new Ao(u.name, c, u.id, u.flags) : u);
      }
    } catch (d) {
      a.e(d);
    } finally {
      a.f();
    }
    return new e(t);
  } }]), e;
}(), Vl = /* @__PURE__ */ new WeakMap(), W3 = /* @__PURE__ */ new WeakMap();
(function(e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
})($r || ($r = {}));
var Ri = function() {
  function e(t, n, r, i, o) {
    if (Z(this, e), this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      var a, s = ut(o);
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var u = xe(a.value, 2), c = u[0], l = u[1];
          this.props[typeof c == "number" ? c : c.id] = l;
        }
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
    }
  }
  return Y(e, [{ key: "toString", value: function() {
    var t = this.prop(Bn.mounted);
    if (t && !t.overlay)
      return t.tree.toString();
    var n, r = "", i = ut(this.children);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value.toString();
        o && (r && (r += ","), r += o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (r.length ? "(" + r + ")" : "") : r;
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new gh(this.topNode, t);
  } }, { key: "cursorAt", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Vl.get(this) || this.topNode, i = new gh(r);
    return i.moveTo(t, n), Vl.set(this, i._tree), i;
  } }, { key: "topNode", get: function() {
    return new _c(this, 0, 0, null);
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Gs(Vl.get(this) || this.topNode, t, n, !1);
    return Vl.set(this, r), r;
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = Gs(W3.get(this) || this.topNode, t, n, !0);
    return W3.set(this, r), r;
  } }, { key: "iterate", value: function(t) {
    for (var n = t.enter, r = t.leave, i = t.from, o = i === void 0 ? 0 : i, a = t.to, s = a === void 0 ? this.length : a, u = this.cursor((t.mode || 0) | $r.IncludeAnonymous); ; ) {
      var c = !1;
      if (u.from <= s && u.to >= o && (u.type.isAnonymous || n(u) !== !1)) {
        if (u.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && !u.type.isAnonymous && r(u), !u.nextSibling(); ) {
        if (!u.parent())
          return;
        c = !0;
      }
    }
  } }, { key: "prop", value: function(t) {
    return t.perNode ? this.props ? this.props[t.id] : void 0 : this.type.prop(t);
  } }, { key: "propValues", get: function() {
    var t = [];
    if (this.props)
      for (var n in this.props)
        t.push([+n, this.props[n]]);
    return t;
  } }, { key: "balance", value: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.children.length <= 8 ? this : L0(Ao.none, this.children, this.positions, 0, this.children.length, 0, this.length, function(r, i, o) {
      return new e(t.type, r, i, o, t.propValues);
    }, n.makeTree || function(r, i, o) {
      return new e(Ao.none, r, i, o);
    });
  } }], [{ key: "build", value: function(t) {
    return gJ(t);
  } }]), e;
}();
Ri.empty = new Ri(Ao.none, [], [], 0);
var pJ = function() {
  function e(t, n) {
    Z(this, e), this.buffer = t, this.index = n;
  }
  return Y(e, [{ key: "id", get: function() {
    return this.buffer[this.index - 4];
  } }, { key: "start", get: function() {
    return this.buffer[this.index - 3];
  } }, { key: "end", get: function() {
    return this.buffer[this.index - 2];
  } }, { key: "size", get: function() {
    return this.buffer[this.index - 1];
  } }, { key: "pos", get: function() {
    return this.index;
  } }, { key: "next", value: function() {
    this.index -= 4;
  } }, { key: "fork", value: function() {
    return new e(this.buffer, this.index);
  } }]), e;
}(), nl = function() {
  function e(t, n, r) {
    Z(this, e), this.buffer = t, this.length = n, this.set = r;
  }
  return Y(e, [{ key: "type", get: function() {
    return Ao.none;
  } }, { key: "toString", value: function() {
    for (var t = [], n = 0; n < this.buffer.length; )
      t.push(this.childString(n)), n = this.buffer[n + 3];
    return t.join(",");
  } }, { key: "childString", value: function(t) {
    var n = this.buffer[t], r = this.buffer[t + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), r == (t += 4))
      return o;
    for (var a = []; t < r; )
      a.push(this.childString(t)), t = this.buffer[t + 3];
    return o + "(" + a.join(",") + ")";
  } }, { key: "findChild", value: function(t, n, r, i, o) {
    for (var a = this.buffer, s = -1, u = t; u != n && !(HE(o, i, a[u + 1], a[u + 2]) && (s = u, r > 0)); u = a[u + 3])
      ;
    return s;
  } }, { key: "slice", value: function(t, n, r, i) {
    for (var o = this.buffer, a = new Uint16Array(n - t), s = t, u = 0; s < n; )
      a[u++] = o[s++], a[u++] = o[s++] - r, a[u++] = o[s++] - r, a[u++] = o[s++] - t;
    return new e(a, i - r, this.set);
  } }]), e;
}();
function HE(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function WE(e, t) {
  for (var n = e.childBefore(t); n; ) {
    var r = n.lastChild;
    if (!r || r.to != n.to)
      break;
    r.type.isError && r.from == r.to ? (e = n, n = r.prevSibling) : n = r;
  }
  return e;
}
function Gs(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t); ) {
    var o = !r && e instanceof _c && e.index < 0 ? null : e.parent;
    if (!o)
      return e;
    e = o;
  }
  var a = r ? 0 : $r.IgnoreOverlays;
  if (r)
    for (var s = e, u = s.parent; u; u = (s = u).parent)
      s instanceof _c && s.index < 0 && ((i = u.enter(t, n, a)) === null || i === void 0 ? void 0 : i.from) != s.from && (e = u);
  for (; ; ) {
    var c = e.enter(t, n, a);
    if (!c)
      return e;
    e = c;
  }
}
var _c = function() {
  function e(t, n, r, i) {
    Z(this, e), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  return Y(e, [{ key: "type", get: function() {
    return this._tree.type;
  } }, { key: "name", get: function() {
    return this._tree.type.name;
  } }, { key: "to", get: function() {
    return this.from + this._tree.length;
  } }, { key: "nextChild", value: function(t, n, r, i) {
    for (var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, a = this; ; ) {
      for (var s = a._tree, u = s.children, c = s.positions, l = n > 0 ? u.length : -1; t != l; t += n) {
        var f = u[t], h = c[t] + a.from;
        if (HE(i, r, h, h + f.length)) {
          if (f instanceof nl) {
            if (o & $r.ExcludeBuffers)
              continue;
            var d = f.findChild(0, f.buffer.length, n, r - h, i);
            if (d > -1)
              return new dm(new mJ(a, f, t, h), null, d);
          } else if (o & $r.IncludeAnonymous || !f.type.isAnonymous || D0(f)) {
            var p = void 0;
            if (!(o & $r.IgnoreMounts) && f.props && (p = f.prop(Bn.mounted)) && !p.overlay)
              return new e(p.tree, h, t, a);
            var v = new e(f, h, t, a);
            return o & $r.IncludeAnonymous || !v.type.isAnonymous ? v : v.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (o & $r.IncludeAnonymous || !a.type.isAnonymous || (t = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)))
        return null;
    }
  } }, { key: "firstChild", get: function() {
    return this.nextChild(0, 1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.nextChild(0, 1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.nextChild(this._tree.children.length - 1, -1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!(i & $r.IgnoreOverlays) && (r = this._tree.prop(Bn.mounted)) && r.overlay) {
      var o, a = t - this.from, s = ut(r.overlay);
      try {
        for (s.s(); !(o = s.n()).done; ) {
          var u = o.value, c = u.from, l = u.to;
          if ((n > 0 ? c <= a : c < a) && (n < 0 ? l >= a : l > a))
            return new e(r.tree, r.overlay[0].from + this.from, -1, this);
        }
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
    }
    return this.nextChild(0, 1, t, n, i);
  } }, { key: "nextSignificantParent", value: function() {
    for (var t = this; t.type.isAnonymous && t._parent; )
      t = t._parent;
    return t;
  } }, { key: "parent", get: function() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  } }, { key: "nextSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
  } }, { key: "prevSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new gh(this, t);
  } }, { key: "tree", get: function() {
    return this._tree;
  } }, { key: "toTree", value: function() {
    return this._tree;
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Gs(this, t, n, !1);
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Gs(this, t, n, !0);
  } }, { key: "enterUnfinishedNodesBefore", value: function(t) {
    return WE(this, t);
  } }, { key: "getChild", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, i = ph(this, t, n, r);
    return i.length ? i[0] : null;
  } }, { key: "getChildren", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return ph(this, t, n, r);
  } }, { key: "toString", value: function() {
    return this._tree.toString();
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "matchContext", value: function(t) {
    return mh(this, t);
  } }]), e;
}();
function ph(e, t, n, r) {
  var i = e.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (; !i.type.is(n); )
      if (!i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function mh(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
var mJ = Y(function e(t, n, r, i) {
  Z(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = i;
}), dm = function() {
  function e(t, n, r) {
    Z(this, e), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
  }
  return Y(e, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "from", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  } }, { key: "to", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  } }, { key: "child", value: function(t, n, r) {
    var i = this.context.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
    return o < 0 ? null : new e(this.context, this, o);
  } }, { key: "firstChild", get: function() {
    return this.child(1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.child(-1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.child(1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.child(-1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (r & $r.ExcludeBuffers)
      return null;
    var i = this.context.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
    return o < 0 ? null : new e(this.context, this, o);
  } }, { key: "parent", get: function() {
    return this._parent || this.context.parent.nextSignificantParent();
  } }, { key: "externalSibling", value: function(t) {
    return this._parent ? null : this.context.parent.nextChild(this.context.index + t, t, 0, 4);
  } }, { key: "nextSibling", get: function() {
    var t = this.context.buffer, n = t.buffer[this.index + 3];
    return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
  } }, { key: "prevSibling", get: function() {
    var t = this.context.buffer, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
  } }, { key: "cursor", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new gh(this, t);
  } }, { key: "tree", get: function() {
    return null;
  } }, { key: "toTree", value: function() {
    var t = [], n = [], r = this.context.buffer, i = this.index + 4, o = r.buffer[this.index + 3];
    if (o > i) {
      var a = r.buffer[this.index + 1], s = r.buffer[this.index + 2];
      t.push(r.slice(i, o, a, s)), n.push(0);
    }
    return new Ri(this.type, t, n, this.to - this.from);
  } }, { key: "resolve", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Gs(this, t, n, !1);
  } }, { key: "resolveInner", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Gs(this, t, n, !0);
  } }, { key: "enterUnfinishedNodesBefore", value: function(t) {
    return WE(this, t);
  } }, { key: "toString", value: function() {
    return this.context.buffer.childString(this.index);
  } }, { key: "getChild", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, i = ph(this, t, n, r);
    return i.length ? i[0] : null;
  } }, { key: "getChildren", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return ph(this, t, n, r);
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "matchContext", value: function(t) {
    return mh(this, t);
  } }]), e;
}(), gh = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (Z(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof _c)
      this.yieldNode(t);
    else {
      this._tree = t.context.parent, this.buffer = t.context;
      for (var r = t._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = t, this.yieldBuf(t.index);
    }
  }
  return Y(e, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "yieldNode", value: function(t) {
    return !!t && (this._tree = t, this.type = t.type, this.from = t.from, this.to = t.to, !0);
  } }, { key: "yieldBuf", value: function(t, n) {
    this.index = t;
    var r = this.buffer, i = r.start, o = r.buffer;
    return this.type = n || o.set.types[o.buffer[t]], this.from = i + o.buffer[t + 1], this.to = i + o.buffer[t + 2], !0;
  } }, { key: "yield", value: function(t) {
    return !!t && (t instanceof _c ? (this.buffer = null, this.yieldNode(t)) : (this.buffer = t.context, this.yieldBuf(t.index, t.type)));
  } }, { key: "toString", value: function() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  } }, { key: "enterChild", value: function(t, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(t < 0 ? this._tree._tree.children.length - 1 : 0, t, n, r, this.mode));
    var i = this.buffer.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.buffer.start, r);
    return !(o < 0) && (this.stack.push(this.index), this.yieldBuf(o));
  } }, { key: "firstChild", value: function() {
    return this.enterChild(1, 0, 4);
  } }, { key: "lastChild", value: function() {
    return this.enterChild(-1, 0, 4);
  } }, { key: "childAfter", value: function(t) {
    return this.enterChild(1, t, 2);
  } }, { key: "childBefore", value: function(t) {
    return this.enterChild(-1, t, -2);
  } }, { key: "enter", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.mode;
    return this.buffer ? !(r & $r.ExcludeBuffers) && this.enterChild(1, t, n) : this.yield(this._tree.enter(t, n, r));
  } }, { key: "parent", value: function() {
    if (!this.buffer)
      return this.yieldNode(this.mode & $r.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    var t = this.mode & $r.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(t);
  } }, { key: "sibling", value: function(t) {
    if (!this.buffer)
      return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + t, t, 0, 4, this.mode));
    var n = this.buffer.buffer, r = this.stack.length - 1;
    if (t < 0) {
      var i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(i, this.index, -1, 0, 4));
    } else {
      var o = n.buffer[this.index + 3];
      if (o < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(o);
    }
    return r < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + t, t, 0, 4, this.mode));
  } }, { key: "nextSibling", value: function() {
    return this.sibling(1);
  } }, { key: "prevSibling", value: function() {
    return this.sibling(-1);
  } }, { key: "atLastNode", value: function(t) {
    var n, r, i = this.buffer;
    if (i) {
      if (t > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (var o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      n = i.index, r = i.parent;
    } else {
      var a = this._tree;
      n = a.index, r = a._parent;
    }
    for (; r; n = (s = r).index, r = s._parent, s) {
      var s;
      if (n > -1)
        for (var u = n + t, c = t < 0 ? -1 : r._tree.children.length; u != c; u += t) {
          var l = r._tree.children[u];
          if (this.mode & $r.IncludeAnonymous || l instanceof nl || !l.type.isAnonymous || D0(l))
            return !1;
        }
    }
    return !0;
  } }, { key: "move", value: function(t, n) {
    if (n && this.enterChild(t, 0, 4))
      return !0;
    for (; ; ) {
      if (this.sibling(t))
        return !0;
      if (this.atLastNode(t) || !this.parent())
        return !1;
    }
  } }, { key: "next", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(1, t);
  } }, { key: "prev", value: function() {
    var t = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(-1, t);
  } }, { key: "moveTo", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0; (this.from == this.to || (n < 1 ? this.from >= t : this.from > t) || (n > -1 ? this.to <= t : this.to < t)) && this.parent(); )
      ;
    for (; this.enterChild(1, t, n); )
      ;
    return this;
  } }, { key: "node", get: function() {
    if (!this.buffer)
      return this._tree;
    var t = this.bufferNode, n = null, r = 0;
    if (t && t.context == this.buffer)
      t:
        for (var i = this.index, o = this.stack.length; o >= 0; ) {
          for (var a = t; a; a = a._parent)
            if (a.index == i) {
              if (i == this.index)
                return a;
              n = a, r = o + 1;
              break t;
            }
          i = this.stack[--o];
        }
    for (var s = r; s < this.stack.length; s++)
      n = new dm(this.buffer, n, this.stack[s]);
    return this.bufferNode = new dm(this.buffer, n, this.index);
  } }, { key: "tree", get: function() {
    return this.buffer ? null : this._tree._tree;
  } }, { key: "iterate", value: function(t, n) {
    for (var r = 0; ; ) {
      var i = !1;
      if (this.type.isAnonymous || t(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && n && n(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, i = !0;
      }
    }
  } }, { key: "matchContext", value: function(t) {
    if (!this.buffer)
      return mh(this.node, t);
    for (var n = this.buffer.buffer, r = n.set.types, i = t.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return mh(this.node, t, i);
      var a = r[n.buffer[this.stack[o]]];
      if (!a.isAnonymous) {
        if (t[i] && t[i] != a.name)
          return !1;
        i--;
      }
    }
    return !0;
  } }]), e;
}();
function D0(e) {
  return e.children.some(function(t) {
    return t instanceof nl || !t.type.isAnonymous || D0(t);
  });
}
function gJ(e) {
  var t, n = e.buffer, r = e.nodeSet, i = e.maxBufferLength, o = i === void 0 ? 1024 : i, a = e.reused, s = a === void 0 ? [] : a, u = e.minRepeatType, c = u === void 0 ? r.types.length : u, l = Array.isArray(n) ? new pJ(n, n.length) : n, f = r.types, h = 0, d = 0;
  function p(w, x, S, T, P) {
    for (var O = l.id, j = l.start, V = l.end, E = l.size, C = d; E < 0; ) {
      if (l.next(), E == -1) {
        var H = s[O];
        return S.push(H), void T.push(j - w);
      }
      if (E == -3)
        return void (h = O);
      if (E == -4)
        return void (d = O);
      throw new RangeError("Unrecognized record size: ".concat(E));
    }
    var X, F, G = f[O], M = j - w;
    if (V - j <= o && (F = function(kt, I) {
      var R = l.fork(), it = 0, N = 0, K = 0, z = R.end - o, at = { size: 0, start: 0, skip: 0 };
      t:
        for (var yt = R.pos - kt; R.pos > yt; ) {
          var jt = R.size;
          if (R.id == I && jt >= 0)
            at.size = it, at.start = N, at.skip = K, K += 4, it += 4, R.next();
          else {
            var Ft = R.pos - jt;
            if (jt < 0 || Ft < yt || R.start < z)
              break;
            var zt = R.id >= c ? 4 : 0, St = R.start;
            for (R.next(); R.pos > Ft; ) {
              if (R.size < 0) {
                if (R.size != -3)
                  break t;
                zt += 4;
              } else
                R.id >= c && (zt += 4);
              R.next();
            }
            N = St, it += jt, K += zt;
          }
        }
      return (I < 0 || it == kt) && (at.size = it, at.start = N, at.skip = K), at.size > 4 ? at : void 0;
    }(l.pos - x, P))) {
      for (var $ = new Uint16Array(F.size - F.skip), q = l.pos - F.size, B = $.length; l.pos > q; )
        B = g(F.start, $, B);
      X = new nl($, V - F.start, r), M = F.start - w;
    } else {
      var D = l.pos - E;
      l.next();
      for (var _ = [], L = [], J = O >= c ? O : -1, st = 0, ht = V; l.pos > D; )
        J >= 0 && l.id == J && l.size >= 0 ? (l.end <= ht - o && (v(_, L, j, st, l.end, ht, J, C), st = _.length, ht = l.end), l.next()) : p(j, D, _, L, J);
      if (J >= 0 && st > 0 && st < _.length && v(_, L, j, st, j, ht, J, C), _.reverse(), L.reverse(), J > -1 && st > 0) {
        var xt = function(kt) {
          return function(I, R, it) {
            var N, K, z = 0, at = I.length - 1;
            if (at >= 0 && (N = I[at]) instanceof Ri) {
              if (!at && N.type == kt && N.length == it)
                return N;
              (K = N.prop(Bn.lookAhead)) && (z = R[at] + N.length + K);
            }
            return m(kt, I, R, it, z);
          };
        }(G);
        X = L0(G, _, L, 0, _.length, 0, V - j, xt, xt);
      } else
        X = m(G, _, L, V - j, C - V);
    }
    S.push(X), T.push(M);
  }
  function v(w, x, S, T, P, O, j, V) {
    for (var E = [], C = []; w.length > T; )
      E.push(w.pop()), C.push(x.pop() + S - P);
    w.push(m(r.types[j], E, C, O - P, V - O)), x.push(P - S);
  }
  function m(w, x, S, T) {
    var P = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, O = arguments.length > 5 ? arguments[5] : void 0;
    if (h) {
      var j = [Bn.contextHash, h];
      O = O ? [j].concat(O) : [j];
    }
    if (P > 25) {
      var V = [Bn.lookAhead, P];
      O = O ? [V].concat(O) : [V];
    }
    return new Ri(w, x, S, T, O);
  }
  function g(w, x, S) {
    var T = l.id, P = l.start, O = l.end, j = l.size;
    if (l.next(), j >= 0 && T < c) {
      var V = S;
      if (j > 4)
        for (var E = l.pos - (j - 4); l.pos > E; )
          S = g(w, x, S);
      x[--S] = V, x[--S] = O - w, x[--S] = P - w, x[--S] = T;
    } else
      j == -3 ? h = T : j == -4 && (d = T);
    return S;
  }
  for (var y = [], b = []; l.pos > 0; )
    p(e.start || 0, e.bufferStart || 0, y, b, -1);
  var k = (t = e.length) !== null && t !== void 0 ? t : y.length ? b[0] + y[0].length : 0;
  return new Ri(f[e.topID], y.reverse(), b.reverse(), k);
}
var U3 = /* @__PURE__ */ new WeakMap();
function df(e, t) {
  if (!e.isAnonymous || t instanceof nl || t.type != e)
    return 1;
  var n = U3.get(t);
  if (n == null) {
    n = 1;
    var r, i = ut(t.children);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        if (o.type != e || !(o instanceof Ri)) {
          n = 1;
          break;
        }
        n += df(e, o);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    U3.set(t, n);
  }
  return n;
}
function L0(e, t, n, r, i, o, a, s, u) {
  for (var c = 0, l = r; l < i; l++)
    c += df(e, t[l]);
  var f = Math.ceil(1.5 * c / 8), h = [], d = [];
  return function p(v, m, g, y, b) {
    for (var k = g; k < y; ) {
      var w = k, x = m[k], S = df(e, v[k]);
      for (k++; k < y; k++) {
        var T = df(e, v[k]);
        if (S + T >= f)
          break;
        S += T;
      }
      if (k == w + 1) {
        if (S > f) {
          var P = v[w];
          p(P.children, P.positions, 0, P.children.length, m[w] + b);
          continue;
        }
        h.push(v[w]);
      } else {
        var O = m[k - 1] + v[k - 1].length - x;
        h.push(L0(e, v, m, w, k, x, O, null, u));
      }
      d.push(x + b - o);
    }
  }(t, n, r, i, 0), (s || u)(h, d, a);
}
var yJ = function() {
  function e() {
    Z(this, e);
  }
  return Y(e, [{ key: "startParse", value: function(t, n, r) {
    return typeof t == "string" && (t = new bJ(t)), r = r ? r.length ? r.map(function(i) {
      return new yv(i.from, i.to);
    }) : [new yv(0, 0)] : [new yv(0, t.length)], this.createParse(t, n || [], r);
  } }, { key: "parse", value: function(t, n, r) {
    for (var i = this.startParse(t, n, r); ; ) {
      var o = i.advance();
      if (o)
        return o;
    }
  } }]), e;
}(), bJ = function() {
  function e(t) {
    Z(this, e), this.string = t;
  }
  return Y(e, [{ key: "length", get: function() {
    return this.string.length;
  } }, { key: "chunk", value: function(t) {
    return this.string.slice(t);
  } }, { key: "lineChunks", get: function() {
    return !1;
  } }, { key: "read", value: function(t, n) {
    return this.string.slice(t, n);
  } }]), e;
}();
new Bn({ perNode: !0 });
var J3, kJ = function() {
  function e(t, n, r, i, o, a, s, u, c) {
    var l = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : 0, f = arguments.length > 10 ? arguments[10] : void 0;
    Z(this, e), this.p = t, this.stack = n, this.state = r, this.reducePos = i, this.pos = o, this.score = a, this.buffer = s, this.bufferBase = u, this.curContext = c, this.lookAhead = l, this.parent = f;
  }
  return Y(e, [{ key: "toString", value: function() {
    return "[".concat(this.stack.filter(function(t, n) {
      return n % 3 == 0;
    }).concat(this.state), "]@").concat(this.pos).concat(this.score ? "!" + this.score : "");
  } }, { key: "context", get: function() {
    return this.curContext ? this.curContext.context : null;
  } }, { key: "pushState", value: function(t, n) {
    this.stack.push(this.state, n, this.bufferBase + this.buffer.length), this.state = t;
  } }, { key: "reduce", value: function(t) {
    var n = t >> 19, r = 65535 & t, i = this.p.parser, o = i.dynamicPrecedence(r);
    if (o && (this.score += o), n == 0)
      return this.pushState(i.getGoto(this.state, r, !0), this.reducePos), r < i.minRepeatTerm && this.storeNode(r, this.reducePos, this.reducePos, 4, !0), void this.reduceContext(r, this.reducePos);
    var a = this.stack.length - 3 * (n - 1) - (262144 & t ? 6 : 0), s = this.stack[a - 2], u = this.stack[a - 1], c = this.bufferBase + this.buffer.length - u;
    if (r < i.minRepeatTerm || 131072 & t) {
      var l = i.stateFlag(this.state, 1) ? this.pos : this.reducePos;
      this.storeNode(r, s, l, c + 4, !0);
    }
    if (262144 & t)
      this.state = this.stack[a];
    else {
      var f = this.stack[a - 3];
      this.state = i.getGoto(f, r, !0);
    }
    for (; this.stack.length > a; )
      this.stack.pop();
    this.reduceContext(r, s);
  } }, { key: "storeNode", value: function(t, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 4, o = arguments.length > 4 && arguments[4] !== void 0 && arguments[4];
    if (t == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      var a = this, s = this.buffer.length;
      if (s == 0 && a.parent && (s = a.bufferBase - a.parent.bufferBase, a = a.parent), s > 0 && a.buffer[s - 4] == 0 && a.buffer[s - 1] > -1) {
        if (n == r)
          return;
        if (a.buffer[s - 2] >= n)
          return void (a.buffer[s - 2] = r);
      }
    }
    if (o && this.pos != r) {
      var u = this.buffer.length;
      if (u > 0 && this.buffer[u - 4] != 0)
        for (; u > 0 && this.buffer[u - 2] > r; )
          this.buffer[u] = this.buffer[u - 4], this.buffer[u + 1] = this.buffer[u - 3], this.buffer[u + 2] = this.buffer[u - 2], this.buffer[u + 3] = this.buffer[u - 1], u -= 4, i > 4 && (i -= 4);
      this.buffer[u] = t, this.buffer[u + 1] = n, this.buffer[u + 2] = r, this.buffer[u + 3] = i;
    } else
      this.buffer.push(t, n, r, i);
  } }, { key: "shift", value: function(t, n, r) {
    var i = this.pos;
    if (131072 & t)
      this.pushState(65535 & t, this.pos);
    else if ((262144 & t) == 0) {
      var o = t, a = this.p.parser;
      (r > this.pos || n <= a.maxNode) && (this.pos = r, a.stateFlag(o, 1) || (this.reducePos = r)), this.pushState(o, i), this.shiftContext(n, i), n <= a.maxNode && this.buffer.push(n, i, r, 4);
    } else
      this.pos = r, this.shiftContext(n, i), n <= this.p.parser.maxNode && this.buffer.push(n, i, r, 4);
  } }, { key: "apply", value: function(t, n, r) {
    65536 & t ? this.reduce(t) : this.shift(t, n, r);
  } }, { key: "useNode", value: function(t, n) {
    var r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != t) && (this.p.reused.push(t), r++);
    var i = this.pos;
    this.reducePos = this.pos = i + t.length, this.pushState(n, i), this.buffer.push(r, i, this.reducePos, -1), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, t, this, this.p.stream.reset(this.pos - t.length)));
  } }, { key: "split", value: function() {
    for (var t = this, n = t.buffer.length; n > 0 && t.buffer[n - 2] > t.reducePos; )
      n -= 4;
    for (var r = t.buffer.slice(n), i = t.bufferBase + n; t && i == t.bufferBase; )
      t = t.parent;
    return new e(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, t);
  } }, { key: "recoverByDelete", value: function(t, n) {
    var r = t <= this.p.parser.maxNode;
    r && this.storeNode(t, this.pos, n, 4), this.storeNode(0, this.pos, n, r ? 8 : 4), this.pos = this.reducePos = n, this.score -= 190;
  } }, { key: "canShift", value: function(t) {
    for (var n = new wJ(this); ; ) {
      var r = this.p.parser.stateSlot(n.state, 4) || this.p.parser.hasAction(n.state, t);
      if ((65536 & r) == 0)
        return !0;
      if (r == 0)
        return !1;
      n.reduce(r);
    }
  } }, { key: "recoverByInsert", value: function(t) {
    if (this.stack.length >= 300)
      return [];
    var n = this.p.parser.nextStates(this.state);
    if (n.length > 8 || this.stack.length >= 120) {
      for (var r, i = [], o = 0; o < n.length; o += 2)
        (r = n[o + 1]) != this.state && this.p.parser.hasAction(r, t) && i.push(n[o], r);
      if (this.stack.length < 120)
        for (var a = function(h) {
          var d = n[h + 1];
          i.some(function(p, v) {
            return 1 & v && p == d;
          }) || i.push(n[h], d);
        }, s = 0; i.length < 8 && s < n.length; s += 2)
          a(s);
      n = i;
    }
    for (var u = [], c = 0; c < n.length && u.length < 4; c += 2) {
      var l = n[c + 1];
      if (l != this.state) {
        var f = this.split();
        f.pushState(l, this.pos), f.storeNode(0, f.pos, f.pos, 4, !0), f.shiftContext(n[c], this.pos), f.score -= 200, u.push(f);
      }
    }
    return u;
  } }, { key: "forceReduce", value: function() {
    var t = this.p.parser.stateSlot(this.state, 5);
    if ((65536 & t) == 0)
      return !1;
    var n = this.p.parser;
    if (!n.validAction(this.state, t)) {
      var r = t >> 19, i = 65535 & t, o = this.stack.length - 3 * r;
      if (o < 0 || n.getGoto(this.stack[o], i, !1) < 0)
        return !1;
      this.storeNode(0, this.reducePos, this.reducePos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(t), !0;
  } }, { key: "forceAll", value: function() {
    for (; !this.p.parser.stateFlag(this.state, 2); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  } }, { key: "deadEnd", get: function() {
    if (this.stack.length != 3)
      return !1;
    var t = this.p.parser;
    return t.data[t.stateSlot(this.state, 1)] == 65535 && !t.stateSlot(this.state, 4);
  } }, { key: "restart", value: function() {
    this.state = this.stack[0], this.stack.length = 0;
  } }, { key: "sameState", value: function(t) {
    if (this.state != t.state || this.stack.length != t.stack.length)
      return !1;
    for (var n = 0; n < this.stack.length; n += 3)
      if (this.stack[n] != t.stack[n])
        return !1;
    return !0;
  } }, { key: "parser", get: function() {
    return this.p.parser;
  } }, { key: "dialectEnabled", value: function(t) {
    return this.p.parser.dialect.flags[t];
  } }, { key: "shiftContext", value: function(t, n) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, t, this, this.p.stream.reset(n)));
  } }, { key: "reduceContext", value: function(t, n) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, t, this, this.p.stream.reset(n)));
  } }, { key: "emitContext", value: function() {
    var t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -3) && this.buffer.push(this.curContext.hash, this.reducePos, this.reducePos, -3);
  } }, { key: "emitLookAhead", value: function() {
    var t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -4) && this.buffer.push(this.lookAhead, this.reducePos, this.reducePos, -4);
  } }, { key: "updateContext", value: function(t) {
    if (t != this.curContext.context) {
      var n = new K3(this.curContext.tracker, t);
      n.hash != this.curContext.hash && this.emitContext(), this.curContext = n;
    }
  } }, { key: "setLookAhead", value: function(t) {
    t > this.lookAhead && (this.emitLookAhead(), this.lookAhead = t);
  } }, { key: "close", value: function() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  } }], [{ key: "start", value: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = t.parser.context;
    return new e(t, [], n, r, r, 0, [], 0, i ? new K3(i, i.start) : null, 0, null);
  } }]), e;
}(), K3 = Y(function e(t, n) {
  Z(this, e), this.tracker = t, this.context = n, this.hash = t.strict ? t.hash(n) : 0;
});
(function(e) {
  e[e.Insert = 200] = "Insert", e[e.Delete = 190] = "Delete", e[e.Reduce = 100] = "Reduce", e[e.MaxNext = 4] = "MaxNext", e[e.MaxInsertStackDepth = 300] = "MaxInsertStackDepth", e[e.DampenInsertStackDepth = 120] = "DampenInsertStackDepth";
})(J3 || (J3 = {}));
var wJ = function() {
  function e(t) {
    Z(this, e), this.start = t, this.state = t.state, this.stack = t.stack, this.base = this.stack.length;
  }
  return Y(e, [{ key: "reduce", value: function(t) {
    var n = 65535 & t, r = t >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= 3 * (r - 1);
    var i = this.start.p.parser.getGoto(this.stack[this.base - 3], n, !0);
    this.state = i;
  } }]), e;
}(), xJ = function() {
  function e(t, n, r) {
    Z(this, e), this.stack = t, this.pos = n, this.index = r, this.buffer = t.buffer, this.index == 0 && this.maybeNext();
  }
  return Y(e, [{ key: "maybeNext", value: function() {
    var t = this.stack.parent;
    t != null && (this.index = this.stack.bufferBase - t.bufferBase, this.stack = t, this.buffer = t.buffer);
  } }, { key: "id", get: function() {
    return this.buffer[this.index - 4];
  } }, { key: "start", get: function() {
    return this.buffer[this.index - 3];
  } }, { key: "end", get: function() {
    return this.buffer[this.index - 2];
  } }, { key: "size", get: function() {
    return this.buffer[this.index - 1];
  } }, { key: "next", value: function() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  } }, { key: "fork", value: function() {
    return new e(this.stack, this.pos, this.index);
  } }], [{ key: "create", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t.bufferBase + t.buffer.length;
    return new e(t, n, n - t.bufferBase);
  } }]), e;
}(), vf = Y(function e() {
  Z(this, e), this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
}), G3 = new vf(), jJ = function() {
  function e(t, n) {
    Z(this, e), this.input = t, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = G3, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
  }
  return Y(e, [{ key: "resolveOffset", value: function(t, n) {
    for (var r = this.range, i = this.rangeIndex, o = this.pos + t; o < r.from; ) {
      if (!i)
        return null;
      var a = this.ranges[--i];
      o -= r.from - a.to, r = a;
    }
    for (; n < 0 ? o > r.to : o >= r.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      var s = this.ranges[++i];
      o += s.from - r.to, r = s;
    }
    return o;
  } }, { key: "peek", value: function(t) {
    var n, r, i = this.chunkOff + t;
    if (i >= 0 && i < this.chunk.length)
      n = this.pos + t, r = this.chunk.charCodeAt(i);
    else {
      var o = this.resolveOffset(t, 1);
      if (o == null)
        return -1;
      if ((n = o) >= this.chunk2Pos && n < this.chunk2Pos + this.chunk2.length)
        r = this.chunk2.charCodeAt(n - this.chunk2Pos);
      else {
        for (var a = this.rangeIndex, s = this.range; s.to <= n; )
          s = this.ranges[++a];
        this.chunk2 = this.input.chunk(this.chunk2Pos = n), n + this.chunk2.length > s.to && (this.chunk2 = this.chunk2.slice(0, s.to - n)), r = this.chunk2.charCodeAt(0);
      }
    }
    return n >= this.token.lookAhead && (this.token.lookAhead = n + 1), r;
  } }, { key: "acceptToken", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = n ? this.resolveOffset(n, -1) : this.pos;
    if (r == null || r < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = t, this.token.end = r;
  } }, { key: "getChunk", value: function() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      var t = this.chunk, n = this.chunkPos;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = t, this.chunk2Pos = n, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      var r = this.input.chunk(this.pos), i = this.pos + r.length;
      this.chunk = i > this.range.to ? r.slice(0, this.range.to - this.pos) : r, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  } }, { key: "readNext", value: function() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  } }, { key: "advance", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    for (this.chunkOff += t; this.pos + t >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      t -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += t, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  } }, { key: "setDone", value: function() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  } }, { key: "reset", value: function(t, n) {
    if (n ? (this.token = n, n.start = t, n.lookAhead = t + 1, n.value = n.extended = -1) : this.token = G3, this.pos != t) {
      if (this.pos = t, t == this.end)
        return this.setDone(), this;
      for (; t < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; t >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      t >= this.chunkPos && t < this.chunkPos + this.chunk.length ? this.chunkOff = t - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  } }, { key: "read", value: function(t, n) {
    if (t >= this.chunkPos && n <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(t - this.chunkPos, n - this.chunkPos);
    if (t >= this.chunk2Pos && n <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(t - this.chunk2Pos, n - this.chunk2Pos);
    if (t >= this.range.from && n <= this.range.to)
      return this.input.read(t, n);
    var r, i = "", o = ut(this.ranges);
    try {
      for (o.s(); !(r = o.n()).done; ) {
        var a = r.value;
        if (a.from >= n)
          break;
        a.to > t && (i += this.input.read(Math.max(a.from, t), Math.min(a.to, n)));
      }
    } catch (s) {
      o.e(s);
    } finally {
      o.f();
    }
    return i;
  } }]), e;
}(), pf = function() {
  function e(t, n) {
    Z(this, e), this.data = t, this.id = n;
  }
  return Y(e, [{ key: "token", value: function(t, n) {
    (function(r, i, o, a) {
      var s = 0, u = 1 << a, c = o.p.parser, l = c.dialect;
      t:
        for (; (u & r[s]) != 0; ) {
          for (var f = r[s + 1], h = s + 3; h < f; h += 2)
            if ((r[h + 1] & u) > 0) {
              var d = r[h];
              if (l.allows(d) && (i.token.value == -1 || i.token.value == d || c.overrides(d, i.token.value))) {
                i.acceptToken(d);
                break;
              }
            }
          for (var p = i.next, v = 0, m = r[s + 2]; v < m; ) {
            var g = v + m >> 1, y = f + g + (g << 1), b = r[y], k = r[y + 1];
            if (p < b)
              m = g;
            else {
              if (!(p >= k)) {
                s = r[y + 2], i.advance();
                continue t;
              }
              v = g + 1;
            }
          }
          break;
        }
    })(this.data, t, n, this.id);
  } }]), e;
}();
function Hl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Uint16Array;
  if (typeof e != "string")
    return e;
  for (var n = null, r = 0, i = 0; r < e.length; ) {
    for (var o = 0; ; ) {
      var a = e.charCodeAt(r++), s = !1;
      if (a == 126) {
        o = 65535;
        break;
      }
      a >= 92 && a--, a >= 34 && a--;
      var u = a - 32;
      if (u >= 46 && (u -= 46, s = !0), o += u, s)
        break;
      o *= 46;
    }
    n ? n[i++] = o : n = new t(o);
  }
  return n;
}
pf.prototype.contextual = pf.prototype.fallback = pf.prototype.extend = !1;
var Q3, Si = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG), bv = null;
function X3(e, t, n) {
  var r = e.cursor($r.IncludeAnonymous);
  for (r.moveTo(t); ; )
    if (!(n < 0 ? r.childBefore(t) : r.childAfter(t)))
      for (; ; ) {
        if ((n < 0 ? r.to < t : r.from > t) && !r.type.isError)
          return n < 0 ? Math.max(0, Math.min(r.to - 1, t - 25)) : Math.min(e.length, Math.max(r.from + 1, t + 25));
        if (n < 0 ? r.prevSibling() : r.nextSibling())
          break;
        if (!r.parent())
          return n < 0 ? 0 : e.length;
      }
}
(function(e) {
  e[e.Margin = 25] = "Margin";
})(Q3 || (Q3 = {}));
var Z3, SJ = function() {
  function e(t, n) {
    Z(this, e), this.fragments = t, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  return Y(e, [{ key: "nextFragment", value: function() {
    var t = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (t) {
      for (this.safeFrom = t.openStart ? X3(t.tree, t.from + t.offset, 1) - t.offset : t.from, this.safeTo = t.openEnd ? X3(t.tree, t.to + t.offset, -1) - t.offset : t.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(t.tree), this.start.push(-t.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  } }, { key: "nodeAt", value: function(t) {
    if (t < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= t; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      var n = this.trees.length - 1;
      if (n < 0)
        return this.nextFragment(), null;
      var r = this.trees[n], i = this.index[n];
      if (i != r.children.length) {
        var o = r.children[i], a = this.start[n] + r.positions[i];
        if (a > t)
          return this.nextStart = a, null;
        if (o instanceof Ri) {
          if (a == t) {
            if (a < this.safeFrom)
              return null;
            var s = a + o.length;
            if (s <= this.safeTo) {
              var u = o.prop(Bn.lookAhead);
              if (!u || s + u < this.fragment.to)
                return o;
            }
          }
          this.index[n]++, a + o.length >= Math.max(this.safeFrom, t) && (this.trees.push(o), this.start.push(a), this.index.push(0));
        } else
          this.index[n]++, this.nextStart = a + o.length;
      } else
        this.trees.pop(), this.start.pop(), this.index.pop();
    }
  } }]), e;
}(), $J = function() {
  function e(t, n) {
    Z(this, e), this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = t.tokenizers.map(function(r) {
      return new vf();
    });
  }
  return Y(e, [{ key: "getActions", value: function(t) {
    for (var n = 0, r = null, i = t.p.parser, o = i.tokenizers, a = i.stateSlot(t.state, 3), s = t.curContext ? t.curContext.hash : 0, u = 0, c = 0; c < o.length; c++)
      if ((1 << c & a) != 0) {
        var l = o[c], f = this.tokens[c];
        if ((!r || l.fallback) && ((l.contextual || f.start != t.pos || f.mask != a || f.context != s) && (this.updateCachedToken(f, l, t), f.mask = a, f.context = s), f.lookAhead > f.end + 25 && (u = Math.max(f.lookAhead, u)), f.value != 0)) {
          var h = n;
          if (f.extended > -1 && (n = this.addActions(t, f.extended, f.end, n)), n = this.addActions(t, f.value, f.end, n), !l.extend && (r = f, n > h))
            break;
        }
      }
    for (; this.actions.length > n; )
      this.actions.pop();
    return u && t.setLookAhead(u), r || t.pos != this.stream.end || ((r = new vf()).value = t.p.parser.eofTerm, r.start = r.end = t.pos, n = this.addActions(t, r.value, r.end, n)), this.mainToken = r, this.actions;
  } }, { key: "getMainToken", value: function(t) {
    if (this.mainToken)
      return this.mainToken;
    var n = new vf(), r = t.pos, i = t.p;
    return n.start = r, n.end = Math.min(r + 1, i.stream.end), n.value = r == i.stream.end ? i.parser.eofTerm : 0, n;
  } }, { key: "updateCachedToken", value: function(t, n, r) {
    if (n.token(this.stream.reset(r.pos, t), r), t.value > -1) {
      for (var i = r.p.parser, o = 0; o < i.specialized.length; o++)
        if (i.specialized[o] == t.value) {
          var a = i.specializers[o](this.stream.read(t.start, t.end), r);
          if (a >= 0 && r.p.parser.dialect.allows(a >> 1)) {
            (1 & a) == 0 ? t.value = a >> 1 : t.extended = a >> 1;
            break;
          }
        }
    } else
      t.value = 0, t.end = Math.min(r.p.stream.end, r.pos + 1);
  } }, { key: "putAction", value: function(t, n, r, i) {
    for (var o = 0; o < i; o += 3)
      if (this.actions[o] == t)
        return i;
    return this.actions[i++] = t, this.actions[i++] = n, this.actions[i++] = r, i;
  } }, { key: "addActions", value: function(t, n, r, i) {
    for (var o = t.state, a = t.p.parser, s = a.data, u = 0; u < 2; u++)
      for (var c = a.stateSlot(o, u ? 2 : 1); ; c += 3) {
        if (s[c] == 65535) {
          if (s[c + 1] != 1) {
            i == 0 && s[c + 1] == 2 && (i = this.putAction(wo(s, c + 2), n, r, i));
            break;
          }
          c = wo(s, c + 2);
        }
        s[c] == n && (i = this.putAction(wo(s, c + 1), n, r, i));
      }
    return i;
  } }]), e;
}();
(function(e) {
  e[e.Distance = 5] = "Distance", e[e.MaxRemainingPerStep = 3] = "MaxRemainingPerStep", e[e.MinBufferLengthPrune = 500] = "MinBufferLengthPrune", e[e.ForceReduceLimit = 10] = "ForceReduceLimit", e[e.CutDepth = 15e3] = "CutDepth", e[e.CutTo = 9e3] = "CutTo";
})(Z3 || (Z3 = {}));
var _J = function() {
  function e(t, n, r, i) {
    Z(this, e), this.parser = t, this.input = n, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.stream = new jJ(n, i), this.tokens = new $J(t, this.stream), this.topTerm = t.top[1];
    var o = i[0].from;
    this.stacks = [kJ.start(this, t.top[0], o)], this.fragments = r.length && this.stream.end - o > 4 * t.bufferLength ? new SJ(r, t.nodeSet) : null;
  }
  return Y(e, [{ key: "parsedPos", get: function() {
    return this.minStackPos;
  } }, { key: "advance", value: function() {
    for (var t, n, r = this.stacks, i = this.minStackPos, o = this.stacks = [], a = 0; a < r.length; a++)
      for (var s = r[a]; ; ) {
        if (this.tokens.mainToken = null, s.pos > i)
          o.push(s);
        else {
          if (this.advanceStack(s, o, r))
            continue;
          t || (t = [], n = []), t.push(s);
          var u = this.tokens.getMainToken(s);
          n.push(u.value, u.end);
        }
        break;
      }
    if (!o.length) {
      var c = t && function(g) {
        var y, b = null, k = ut(g);
        try {
          for (k.s(); !(y = k.n()).done; ) {
            var w = y.value, x = w.p.stoppedAt;
            (w.pos == w.p.stream.end || x != null && w.pos > x) && w.p.parser.stateFlag(w.state, 2) && (!b || b.score < w.score) && (b = w);
          }
        } catch (S) {
          k.e(S);
        } finally {
          k.f();
        }
        return b;
      }(t);
      if (c)
        return this.stackToTree(c);
      if (this.parser.strict)
        throw Si && t && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + i);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && t) {
      var l = this.stoppedAt != null && t[0].pos > this.stoppedAt ? t[0] : this.runRecovery(t, n, o);
      if (l)
        return this.stackToTree(l.forceAll());
    }
    if (this.recovering) {
      var f = this.recovering == 1 ? 1 : 3 * this.recovering;
      if (o.length > f)
        for (o.sort(function(g, y) {
          return y.score - g.score;
        }); o.length > f; )
          o.pop();
      o.some(function(g) {
        return g.reducePos > i;
      }) && this.recovering--;
    } else if (o.length > 1)
      t:
        for (var h = 0; h < o.length - 1; h++)
          for (var d = o[h], p = h + 1; p < o.length; p++) {
            var v = o[p];
            if (d.sameState(v) || d.buffer.length > 500 && v.buffer.length > 500) {
              if (!((d.score - v.score || d.buffer.length - v.buffer.length) > 0)) {
                o.splice(h--, 1);
                continue t;
              }
              o.splice(p--, 1);
            }
          }
    this.minStackPos = o[0].pos;
    for (var m = 1; m < o.length; m++)
      o[m].pos < this.minStackPos && (this.minStackPos = o[m].pos);
    return null;
  } }, { key: "stopAt", value: function(t) {
    if (this.stoppedAt != null && this.stoppedAt < t)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = t;
  } }, { key: "advanceStack", value: function(t, n, r) {
    var i = t.pos, o = this.parser, a = Si ? this.stackID(t) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return t.forceReduce() ? t : null;
    if (this.fragments)
      for (var s = t.curContext && t.curContext.tracker.strict, u = s ? t.curContext.hash : 0, c = this.fragments.nodeAt(i); c; ) {
        var l = this.parser.nodeSet.types[c.type.id] == c.type ? o.getGoto(t.state, c.type.id) : -1;
        if (l > -1 && c.length && (!s || (c.prop(Bn.contextHash) || 0) == u))
          return t.useNode(c, l), Si && console.log(a + this.stackID(t) + " (via reuse of ".concat(o.getName(c.type.id), ")")), !0;
        if (!(c instanceof Ri) || c.children.length == 0 || c.positions[0] > 0)
          break;
        var f = c.children[0];
        if (!(f instanceof Ri && c.positions[0] == 0))
          break;
        c = f;
      }
    var h = o.stateSlot(t.state, 4);
    if (h > 0)
      return t.reduce(h), Si && console.log(a + this.stackID(t) + " (via always-reduce ".concat(o.getName(65535 & h), ")")), !0;
    if (t.stack.length >= 15e3)
      for (; t.stack.length > 9e3 && t.forceReduce(); )
        ;
    for (var d = this.tokens.getActions(t), p = 0; p < d.length; ) {
      var v = d[p++], m = d[p++], g = d[p++], y = p == d.length || !r, b = y ? t : t.split();
      if (b.apply(v, m, g), Si && console.log(a + this.stackID(b) + " (via ".concat((65536 & v) == 0 ? "shift" : "reduce of ".concat(o.getName(65535 & v)), " for ").concat(o.getName(m), " @ ").concat(i).concat(b == t ? "" : ", split", ")")), y)
        return !0;
      b.pos > i ? n.push(b) : r.push(b);
    }
    return !1;
  } }, { key: "advanceFully", value: function(t, n) {
    for (var r = t.pos; ; ) {
      if (!this.advanceStack(t, null, null))
        return !1;
      if (t.pos > r)
        return Y3(t, n), !0;
    }
  } }, { key: "runRecovery", value: function(t, n, r) {
    for (var i = null, o = !1, a = 0; a < t.length; a++) {
      var s = t[a], u = n[a << 1], c = n[1 + (a << 1)], l = Si ? this.stackID(s) + " -> " : "";
      if (!(s.deadEnd && (o || (o = !0, s.restart(), Si && console.log(l + this.stackID(s) + " (restarted)"), this.advanceFully(s, r))))) {
        for (var f = s.split(), h = l, d = 0; f.forceReduce() && d < 10 && (Si && console.log(h + this.stackID(f) + " (via force-reduce)"), !this.advanceFully(f, r)); d++)
          Si && (h = this.stackID(f) + " -> ");
        var p, v = ut(s.recoverByInsert(u));
        try {
          for (v.s(); !(p = v.n()).done; ) {
            var m = p.value;
            Si && console.log(l + this.stackID(m) + " (via recover-insert)"), this.advanceFully(m, r);
          }
        } catch (g) {
          v.e(g);
        } finally {
          v.f();
        }
        this.stream.end > s.pos ? (c == s.pos && (c++, u = 0), s.recoverByDelete(u, c), Si && console.log(l + this.stackID(s) + " (via recover-delete ".concat(this.parser.getName(u), ")")), Y3(s, r)) : (!i || i.score < s.score) && (i = s);
      }
    }
    return i;
  } }, { key: "stackToTree", value: function(t) {
    return t.close(), Ri.build({ buffer: xJ.create(t), nodeSet: this.parser.nodeSet, topID: this.topTerm, maxBufferLength: this.parser.bufferLength, reused: this.reused, start: this.ranges[0].from, length: t.pos - this.ranges[0].from, minRepeatType: this.parser.minRepeatTerm });
  } }, { key: "stackID", value: function(t) {
    var n = (bv || (bv = /* @__PURE__ */ new WeakMap())).get(t);
    return n || bv.set(t, n = String.fromCodePoint(this.nextStackID++)), n + t;
  } }]), e;
}();
function Y3(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    if (r.pos == e.pos && r.sameState(e))
      return void (t[n].score < e.score && (t[n] = e));
  }
  t.push(e);
}
var CJ = function() {
  function e(t, n, r) {
    Z(this, e), this.source = t, this.flags = n, this.disabled = r;
  }
  return Y(e, [{ key: "allows", value: function(t) {
    return !this.disabled || this.disabled[t] == 0;
  } }]), e;
}(), OJ = function(e) {
  Et(n, yJ);
  var t = Mt(n);
  function n(r) {
    var i, o;
    if (Z(this, n), (o = t.call(this)).wrappers = [], r.version != 14)
      throw new RangeError("Parser version (".concat(r.version, ") doesn't match runtime version (", 14, ")"));
    var a = r.nodeNames.split(" ");
    o.minRepeatTerm = a.length;
    for (var s = 0; s < r.repeatNodeCount; s++)
      a.push("");
    for (var u = Object.keys(r.topRules).map(function(x) {
      return r.topRules[x][1];
    }), c = [], l = 0; l < a.length; l++)
      c.push([]);
    function f(x, S, T) {
      c[x].push([S, S.deserialize(String(T))]);
    }
    if (r.nodeProps) {
      var h, d = ut(r.nodeProps);
      try {
        for (d.s(); !(h = d.n()).done; ) {
          var p = h.value, v = p[0];
          typeof v == "string" && (v = Bn[v]);
          for (var m = 1; m < p.length; ) {
            var g = p[m++];
            if (g >= 0)
              f(g, v, p[m++]);
            else {
              for (var y = p[m + -g], b = -g; b > 0; b--)
                f(p[m++], v, y);
              m++;
            }
          }
        }
      } catch (x) {
        d.e(x);
      } finally {
        d.f();
      }
    }
    o.nodeSet = new vJ(a.map(function(x, S) {
      return Ao.define({ name: S >= o.minRepeatTerm ? void 0 : x, id: S, props: c[S], top: u.indexOf(S) > -1, error: S == 0, skipped: r.skippedNodes && r.skippedNodes.indexOf(S) > -1 });
    })), r.propSources && (o.nodeSet = (i = o.nodeSet).extend.apply(i, Pe(r.propSources))), o.strict = !1, o.bufferLength = 1024;
    var k = Hl(r.tokenData);
    if (o.context = r.context, o.specialized = new Uint16Array(r.specialized ? r.specialized.length : 0), o.specializers = [], r.specialized)
      for (var w = 0; w < r.specialized.length; w++)
        o.specialized[w] = r.specialized[w].term, o.specializers[w] = r.specialized[w].get;
    return o.states = Hl(r.states, Uint32Array), o.data = Hl(r.stateData), o.goto = Hl(r.goto), o.maxTerm = r.maxTerm, o.tokenizers = r.tokenizers.map(function(x) {
      return typeof x == "number" ? new pf(k, x) : x;
    }), o.topRules = r.topRules, o.dialects = r.dialects || {}, o.dynamicPrecedences = r.dynamicPrecedences || null, o.tokenPrecTable = r.tokenPrec, o.termNames = r.termNames || null, o.maxNode = o.nodeSet.types.length - 1, o.dialect = o.parseDialect(), o.top = o.topRules[Object.keys(o.topRules)[0]], o;
  }
  return Y(n, [{ key: "createParse", value: function(r, i, o) {
    var a, s = new _J(this, r, i, o), u = ut(this.wrappers);
    try {
      for (u.s(); !(a = u.n()).done; )
        s = (0, a.value)(s, r, i, o);
    } catch (c) {
      u.e(c);
    } finally {
      u.f();
    }
    return s;
  } }, { key: "getGoto", value: function(r, i) {
    var o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], a = this.goto;
    if (i >= a[0])
      return -1;
    for (var s = a[i + 1]; ; ) {
      var u = a[s++], c = 1 & u, l = a[s++];
      if (c && o)
        return l;
      for (var f = s + (u >> 1); s < f; s++)
        if (a[s] == r)
          return l;
      if (c)
        return -1;
    }
  } }, { key: "hasAction", value: function(r, i) {
    for (var o = this.data, a = 0; a < 2; a++)
      for (var s, u = this.stateSlot(r, a ? 2 : 1); ; u += 3) {
        if ((s = o[u]) == 65535) {
          if (o[u + 1] != 1) {
            if (o[u + 1] == 2)
              return wo(o, u + 2);
            break;
          }
          s = o[u = wo(o, u + 2)];
        }
        if (s == i || s == 0)
          return wo(o, u + 1);
      }
    return 0;
  } }, { key: "stateSlot", value: function(r, i) {
    return this.states[6 * r + i];
  } }, { key: "stateFlag", value: function(r, i) {
    return (this.stateSlot(r, 0) & i) > 0;
  } }, { key: "validAction", value: function(r, i) {
    if (i == this.stateSlot(r, 4))
      return !0;
    for (var o = this.stateSlot(r, 1); ; o += 3) {
      if (this.data[o] == 65535) {
        if (this.data[o + 1] != 1)
          return !1;
        o = wo(this.data, o + 2);
      }
      if (i == wo(this.data, o + 1))
        return !0;
    }
  } }, { key: "nextStates", value: function(r) {
    for (var i = this, o = [], a = this.stateSlot(r, 1); ; a += 3) {
      if (this.data[a] == 65535) {
        if (this.data[a + 1] != 1)
          break;
        a = wo(this.data, a + 2);
      }
      (1 & this.data[a + 2]) == 0 && function() {
        var s = i.data[a + 1];
        o.some(function(u, c) {
          return 1 & c && u == s;
        }) || o.push(i.data[a], s);
      }();
    }
    return o;
  } }, { key: "overrides", value: function(r, i) {
    var o = tS(this.data, this.tokenPrecTable, i);
    return o < 0 || tS(this.data, this.tokenPrecTable, r) < o;
  } }, { key: "configure", value: function(r) {
    var i, o = Object.assign(Object.create(n.prototype), this);
    if (r.props && (o.nodeSet = (i = this.nodeSet).extend.apply(i, Pe(r.props))), r.top) {
      var a = this.topRules[r.top];
      if (!a)
        throw new RangeError("Invalid top rule name ".concat(r.top));
      o.top = a;
    }
    return r.tokenizers && (o.tokenizers = this.tokenizers.map(function(s) {
      var u = r.tokenizers.find(function(c) {
        return c.from == s;
      });
      return u ? u.to : s;
    })), r.contextTracker && (o.context = r.contextTracker), r.dialect && (o.dialect = this.parseDialect(r.dialect)), r.strict != null && (o.strict = r.strict), r.wrap && (o.wrappers = o.wrappers.concat(r.wrap)), r.bufferLength != null && (o.bufferLength = r.bufferLength), o;
  } }, { key: "hasWrappers", value: function() {
    return this.wrappers.length > 0;
  } }, { key: "getName", value: function(r) {
    return this.termNames ? this.termNames[r] : String(r <= this.maxNode && this.nodeSet.types[r].name || r);
  } }, { key: "eofTerm", get: function() {
    return this.maxNode + 1;
  } }, { key: "topNode", get: function() {
    return this.nodeSet.types[this.top[1]];
  } }, { key: "dynamicPrecedence", value: function(r) {
    var i = this.dynamicPrecedences;
    return i == null ? 0 : i[r] || 0;
  } }, { key: "parseDialect", value: function(r) {
    var i = Object.keys(this.dialects), o = i.map(function() {
      return !1;
    });
    if (r) {
      var a, s = ut(r.split(" "));
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var u = a.value, c = i.indexOf(u);
          c >= 0 && (o[c] = !0);
        }
      } catch (p) {
        s.e(p);
      } finally {
        s.f();
      }
    }
    for (var l = null, f = 0; f < i.length; f++)
      if (!o[f])
        for (var h, d = this.dialects[i[f]]; (h = this.data[d++]) != 65535; )
          (l || (l = new Uint8Array(this.maxTerm + 1)))[h] = 1;
    return new CJ(r, o, l);
  } }], [{ key: "deserialize", value: function(r) {
    return new n(r);
  } }]), n;
}();
function wo(e, t) {
  return e[t] | e[t + 1] << 16;
}
function tS(e, t, n) {
  for (var r, i = t; (r = e[i]) != 65535; i++)
    if (r == n)
      return i - t;
  return -1;
}
var AJ = BP({ String: Jt.string, Number: Jt.number, "True False": Jt.bool, PropertyName: Jt.propertyName, Null: Jt.null, ",": Jt.separator, "[ ]": Jt.squareBracket, "{ }": Jt.brace }), PJ = OJ.deserialize({ version: 14, states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#CjOOQO'#Cp'#CpQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CrOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59U,59UO!iQPO,59UOVQPO,59QOqQPO'#CkO!nQPO,59^OOQO1G.k1G.kOVQPO'#ClO!vQPO,59aOOQO1G.p1G.pOOQO1G.l1G.lOOQO,59V,59VOOQO-E6i-E6iOOQO,59W,59WOOQO-E6j-E6j", stateData: "#O~OcOS~OQSORSOSSOTSOWQO]ROePO~OVXOeUO~O[[O~PVOg^O~Oh_OVfX~OVaO~OhbO[iX~O[dO~Oh_OVfa~OhbO[ia~O", goto: "!kjPPPPPPkPPkqwPPk{!RPPP!XP!ePP!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R", nodeNames: "\u26A0 JsonText True False Null Number String } { Object Property PropertyName ] [ Array", maxTerm: 25, nodeProps: [["openedBy", 7, "{", 12, "["], ["closedBy", 8, "}", 13, "]"]], propSources: [AJ], skippedNodes: [0], repeatNodeCount: 2, tokenData: "(p~RaXY!WYZ!W]^!Wpq!Wrs!]|}$i}!O$n!Q!R$w!R![&V![!]&h!}#O&m#P#Q&r#Y#Z&w#b#c'f#h#i'}#o#p(f#q#r(k~!]Oc~~!`Upq!]qr!]rs!rs#O!]#O#P!w#P~!]~!wOe~~!zXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#g~#jR!Q![#s!c!i#s#T#Z#s~#vR!Q![$P!c!i$P#T#Z$P~$SR!Q![$]!c!i$]#T#Z$]~$`R!Q![!]!c!i!]#T#Z!]~$nOh~~$qQ!Q!R$w!R![&V~$|RT~!O!P%V!g!h%k#X#Y%k~%YP!Q![%]~%bRT~!Q![%]!g!h%k#X#Y%k~%nR{|%w}!O%w!Q![%}~%zP!Q![%}~&SPT~!Q![%}~&[ST~!O!P%V!Q![&V!g!h%k#X#Y%k~&mOg~~&rO]~~&wO[~~&zP#T#U&}~'QP#`#a'T~'WP#g#h'Z~'^P#X#Y'a~'fOR~~'iP#i#j'l~'oP#`#a'r~'uP#`#a'x~'}OS~~(QP#f#g(T~(WP#i#j(Z~(^P#X#Y(a~(fOQ~~(kOW~~(pOV~", tokenizers: [0], topRules: { JsonText: [0, 1] }, tokenPrec: 0 }), EJ = fW.define({ parser: PJ.configure({ props: [HP.add({ Object: K4({ except: /^\s*\}/ }), Array: K4({ except: /^\s*\]/ }) }), UP.add({ "Object Array": function(e) {
  var t = e.firstChild, n = e.lastChild;
  return t && t.to < n.from ? { from: t.to, to: n.type.isError ? e.to : n.from } : null;
} })] }), languageData: { closeBrackets: { brackets: ["[", "{", '"'] }, indentOnInput: /^\s*[\}\]]$/ } });
function kv(e, t) {
  var n = Date.now(), r = e();
  return t(Date.now() - n), r;
}
function MJ(e) {
  Te(e, "svelte-1oo7hnc", ".jse-status-bar.svelte-1oo7hnc.svelte-1oo7hnc{background:var(--jse-panel-background);color:var(--jse-panel-color-readonly);font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);margin:0;border-top:var(--jse-panel-border);border-left:var(--jse-main-border);border-right:var(--jse-main-border);display:flex;gap:var(--jse-padding)}.jse-status-bar.svelte-1oo7hnc.svelte-1oo7hnc:last-child{border-bottom:var(--jse-main-border)}.jse-status-bar.svelte-1oo7hnc .jse-status-bar-info.svelte-1oo7hnc{padding:2px}");
}
function eS(e) {
  var t, n, r;
  return { c: function() {
    t = rt("div"), n = Xt("Line: "), r = Xt(e[0]), A(t, "class", "jse-status-bar-info svelte-1oo7hnc");
  }, m: function(i, o) {
    pt(i, t, o), W(t, n), W(t, r);
  }, p: function(i, o) {
    1 & o && Ve(r, i[0]);
  }, d: function(i) {
    i && vt(t);
  } };
}
function nS(e) {
  var t, n, r;
  return { c: function() {
    t = rt("div"), n = Xt("Column: "), r = Xt(e[1]), A(t, "class", "jse-status-bar-info svelte-1oo7hnc");
  }, m: function(i, o) {
    pt(i, t, o), W(t, n), W(t, r);
  }, p: function(i, o) {
    2 & o && Ve(r, i[1]);
  }, d: function(i) {
    i && vt(t);
  } };
}
function rS(e) {
  var t, n, r, i;
  return { c: function() {
    t = rt("div"), n = Xt("Selection: "), r = Xt(e[2]), i = Xt(" characters"), A(t, "class", "jse-status-bar-info svelte-1oo7hnc");
  }, m: function(o, a) {
    pt(o, t, a), W(t, n), W(t, r), W(t, i);
  }, p: function(o, a) {
    4 & a && Ve(r, o[2]);
  }, d: function(o) {
    o && vt(t);
  } };
}
function TJ(e) {
  var t, n, r, i = e[0] !== void 0 && eS(e), o = e[1] !== void 0 && nS(e), a = e[2] !== void 0 && e[2] > 0 && rS(e);
  return { c: function() {
    t = rt("div"), i && i.c(), n = bt(), o && o.c(), r = bt(), a && a.c(), A(t, "class", "jse-status-bar svelte-1oo7hnc");
  }, m: function(s, u) {
    pt(s, t, u), i && i.m(t, null), W(t, n), o && o.m(t, null), W(t, r), a && a.m(t, null);
  }, p: function(s, u) {
    var c = xe(u, 1)[0];
    s[0] !== void 0 ? i ? i.p(s, c) : ((i = eS(s)).c(), i.m(t, n)) : i && (i.d(1), i = null), s[1] !== void 0 ? o ? o.p(s, c) : ((o = nS(s)).c(), o.m(t, r)) : o && (o.d(1), o = null), s[2] !== void 0 && s[2] > 0 ? a ? a.p(s, c) : ((a = rS(s)).c(), a.m(t, null)) : a && (a.d(1), a = null);
  }, i: Wt, o: Wt, d: function(s) {
    s && vt(t), i && i.d(), o && o.d(), a && a.d();
  } };
}
function IJ(e, t, n) {
  var r, i, o, a, s, u, c, l, f, h, d = t.editorState;
  return e.$$set = function(p) {
    "editorState" in p && n(3, d = p.editorState);
  }, e.$$.update = function() {
    56 & e.$$.dirty && n(9, u = n(5, i = n(4, r = d == null ? void 0 : d.selection) === null || r === void 0 ? void 0 : r.main) === null || i === void 0 ? void 0 : i.head), 584 & e.$$.dirty && n(10, c = n(6, o = d == null ? void 0 : d.doc) === null || o === void 0 ? void 0 : o.lineAt(u)), 1024 & e.$$.dirty && n(0, l = c ? c.number : void 0), 1536 & e.$$.dirty && n(1, f = c ? u - c.from + 1 : void 0), 392 & e.$$.dirty && n(2, h = n(8, s = n(7, a = d == null ? void 0 : d.selection) === null || a === void 0 ? void 0 : a.ranges) === null || s === void 0 ? void 0 : s.reduce(function(p, v) {
      return p + v.to - v.from;
    }, 0));
  }, [l, f, h, d, r, i, o, a, s, u, c];
}
var NJ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, IJ, TJ, ir, { editorState: 3 }, MJ), i;
  }
  return Y(n);
}(), z0 = k0.define([{ tag: Jt.propertyName, color: "var(--jse-key-color)" }, { tag: Jt.number, color: "var(--jse-value-color-number)" }, { tag: Jt.bool, color: "var(--jse-value-color-boolean)" }, { tag: Jt.string, color: "var(--jse-value-color-string)" }, { tag: Jt.keyword, color: "var(--jse-value-color-null)" }]), RJ = XP(z0), DJ = z0.style;
function LJ(e) {
  Te(e, "svelte-cmeafv", '.jse-text-mode.svelte-cmeafv.svelte-cmeafv{flex:1;box-sizing:border-box;display:flex;flex-direction:column;background:var(--jse-background-color)}.jse-text-mode.no-main-menu.svelte-cmeafv.svelte-cmeafv{border-top:var(--jse-main-border)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0;min-height:0;border-left:var(--jse-main-border);border-right:var(--jse-main-border)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv:last-child{border-bottom:var(--jse-main-border)}.jse-text-mode.svelte-cmeafv .jse-contents.jse-hidden.svelte-cmeafv{visibility:hidden}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor{flex:1;overflow:hidden}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-scroller{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);line-height:var(--jse-line-height);color:var(--jse-delimiter-color)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-gutters{background:var(--jse-panel-background);color:var(--jse-panel-color-readonly);border-right:var(--jse-panel-border)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-activeLine,.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-activeLineGutter{background:var(--jse-hover-background-color)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-selectionBackground{background:var(--jse-selection-background-color)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-searchMatch{background-color:var(--jse-search-match-color);outline:var(--jse-search-match-outline)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-searchMatch.cm-searchMatch-selected{background-color:var(--jse-search-match-active-color);outline:var(--jse-search-match-active-outline)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-foldPlaceholder{background:var(--jse-tag-background);color:var(--jse-tag-color);border:none;padding:0 var(--jse-padding)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-diagnostic{font-size:var(--jse-font-size);font-family:var(--jse-font-family)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-panels{border-bottom:var(--jse-panel-border)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-search{background:var(--jse-panel-background);color:var(--jse-panel-color);font-family:var(--jse-font-family);font-size:var(--jse-font-size)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-search input{font-family:var(--jse-font-family);font-size:var(--jse-font-size-text-mode-search);color:var(--jse-input-color);border:var(--jse-input-border);background:var(--jse-input-background);margin-right:2px}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-search button{font-family:var(--jse-font-family);font-size:var(--jse-font-size-text-mode-search);color:var(--jse-panel-button-color);background:var(--jse-panel-button-background);border:none;cursor:pointer;text-transform:capitalize;padding:calc(0.5 * var(--jse-padding)) var(--jse-padding);margin:0}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-search button:hover{color:var(--jse-panel-button-color-highlight);background:var(--jse-panel-button-background-highlight)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-search label{font-family:var(--jse-font-family);font-size:var(--jse-font-size-text-mode-search);padding-left:var(--jse-padding)}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-search label input{margin-right:2px}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-search button[name="close"]{width:32px;height:32px;font-size:24px;line-height:24px;padding:0;right:0;top:-4px}.jse-text-mode.svelte-cmeafv .jse-contents.svelte-cmeafv .cm-editor .cm-cursor-primary{border-color:var(--jse-text-color)}.jse-text-mode.svelte-cmeafv .jse-contents .jse-loading-space.svelte-cmeafv{flex:1}.jse-text-mode.svelte-cmeafv .jse-contents .jse-loading.svelte-cmeafv{flex:2;text-align:center;color:var(--jse-panel-color-readonly);box-sizing:border-box;font-family:var(--jse-font-family);font-size:var(--jse-font-size)}');
}
function iS(e) {
  var t, n;
  return t = new nV({ props: { readOnly: e[1], onFormat: e[17], onCompact: e[18], onSort: e[19], onTransform: e[20], onToggleSearch: e[21], onUndo: e[22], onRedo: e[23], canFormat: !e[15], canCompact: !e[15], canSort: !e[15], canTransform: !e[15], canUndo: e[10], canRedo: e[11], onRenderMenu: e[5] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2 & i[0] && (o.readOnly = r[1]), 32768 & i[0] && (o.canFormat = !r[15]), 32768 & i[0] && (o.canCompact = !r[15]), 32768 & i[0] && (o.canSort = !r[15]), 32768 & i[0] && (o.canTransform = !r[15]), 1024 & i[0] && (o.canUndo = r[10]), 2048 & i[0] && (o.canRedo = r[11]), 32 & i[0] && (o.onRenderMenu = r[5]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function zJ(e) {
  var t;
  return { c: function() {
    (t = rt("div")).innerHTML = `<div class="jse-loading-space svelte-cmeafv"></div> 
      <div class="jse-loading svelte-cmeafv">loading...</div>`, A(t, "class", "jse-contents svelte-cmeafv");
  }, m: function(n, r) {
    pt(n, t, r);
  }, p: Wt, i: Wt, o: Wt, d: function(n) {
    n && vt(t);
  } };
}
function BJ(e) {
  var t, n, r, i, o, a, s, u = e[14] && oS(e), c = e[3] && aS(e), l = e[12] && sS(e);
  return a = new bA({ props: { validationErrors: e[9], selectError: e[26] } }), { c: function() {
    u && u.c(), t = bt(), n = rt("div"), r = bt(), c && c.c(), i = bt(), l && l.c(), o = bt(), Pt(a.$$.fragment), A(n, "class", "jse-contents svelte-cmeafv"), Ut(n, "jse-hidden", e[14]);
  }, m: function(f, h) {
    u && u.m(f, h), pt(f, t, h), pt(f, n, h), e[46](n), pt(f, r, h), c && c.m(f, h), pt(f, i, h), l && l.m(f, h), pt(f, o, h), Ot(a, f, h), s = !0;
  }, p: function(f, h) {
    f[14] ? u ? (u.p(f, h), 16384 & h[0] && U(u, 1)) : ((u = oS(f)).c(), U(u, 1), u.m(t.parentNode, t)) : u && (qt(), tt(u, 1, 1, function() {
      u = null;
    }), Vt()), 16384 & h[0] && Ut(n, "jse-hidden", f[14]), f[3] ? c ? (c.p(f, h), 8 & h[0] && U(c, 1)) : ((c = aS(f)).c(), U(c, 1), c.m(i.parentNode, i)) : c && (qt(), tt(c, 1, 1, function() {
      c = null;
    }), Vt()), f[12] ? l ? (l.p(f, h), 4096 & h[0] && U(l, 1)) : ((l = sS(f)).c(), U(l, 1), l.m(o.parentNode, o)) : l && (qt(), tt(l, 1, 1, function() {
      l = null;
    }), Vt());
    var d = {};
    512 & h[0] && (d.validationErrors = f[9]), a.$set(d);
  }, i: function(f) {
    s || (U(u), U(c), U(l), U(a.$$.fragment, f), s = !0);
  }, o: function(f) {
    tt(u), tt(c), tt(l), tt(a.$$.fragment, f), s = !1;
  }, d: function(f) {
    u && u.d(f), f && vt(t), f && vt(n), e[46](null), f && vt(r), c && c.d(f), f && vt(i), l && l.d(f), f && vt(o), At(a, f);
  } };
}
function oS(e) {
  var t, n;
  return t = new ss({ props: { icon: pu, type: "error", message: "The JSON document is larger than ".concat(wl(10485760, 1024), ", ") + "and may crash your browser when loading it in text mode. Actual size: ".concat(wl(e[0].length, 1024), "."), actions: [{ text: "Open anyway", title: "Open the document in text mode. This may freeze or crash your browser.", onClick: e[24] }, { text: "Open in tree mode", title: "Open the document in tree mode. Tree mode can handle large documents.", onClick: e[4] }, { text: "Cancel", title: "Cancel opening this large document.", onClick: e[25] }] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i[0] && (o.message = "The JSON document is larger than ".concat(wl(10485760, 1024), ", ") + "and may crash your browser when loading it in text mode. Actual size: ".concat(wl(r[0].length, 1024), ".")), 16 & i[0] && (o.actions = [{ text: "Open anyway", title: "Open the document in text mode. This may freeze or crash your browser.", onClick: r[24] }, { text: "Open in tree mode", title: "Open the document in tree mode. Tree mode can handle large documents.", onClick: r[4] }, { text: "Cancel", title: "Cancel opening this large document.", onClick: r[25] }]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function aS(e) {
  var t, n;
  return t = new NJ({ props: { editorState: e[8] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    256 & i[0] && (o.editorState = r[8]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function sS(e) {
  var t, n;
  return t = new ss({ props: { type: "error", icon: pu, message: e[12].message, actions: e[13], onClick: e[47] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    4096 & i[0] && (o.message = r[12].message), 8192 & i[0] && (o.actions = r[13]), 4096 & i[0] && (o.onClick = r[47]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function FJ(e) {
  var t, n, r, i, o, a = e[2] && iS(e), s = [BJ, zJ], u = [];
  return r = function(c, l) {
    return c[16] ? 1 : 0;
  }(e), i = u[r] = s[r](e), { c: function() {
    t = rt("div"), a && a.c(), n = bt(), i.c(), A(t, "class", "jse-text-mode svelte-cmeafv"), Ut(t, "no-main-menu", !e[2]);
  }, m: function(c, l) {
    pt(c, t, l), a && a.m(t, null), W(t, n), u[r].m(t, null), e[48](t), o = !0;
  }, p: function(c, l) {
    c[2] ? a ? (a.p(c, l), 4 & l[0] && U(a, 1)) : ((a = iS(c)).c(), U(a, 1), a.m(t, n)) : a && (qt(), tt(a, 1, 1, function() {
      a = null;
    }), Vt()), i.p(c, l), 4 & l[0] && Ut(t, "no-main-menu", !c[2]);
  }, i: function(c) {
    o || (U(a), U(i), o = !0);
  }, o: function(c) {
    tt(a), tt(i), o = !1;
  }, d: function(c) {
    c && vt(t), a && a.d(), u[r].d(), e[48](null);
  } };
}
function qJ(e, t, n) {
  var r, i, o, a, s, u, c, l, f, h, d = t.readOnly, p = d !== void 0 && d, v = t.mainMenuBar, m = v === void 0 || v, g = t.statusBar, y = g === void 0 || g, b = t.text, k = b === void 0 ? "" : b, w = t.indentation, x = w === void 0 ? 2 : w, S = t.tabSize, T = S === void 0 ? 4 : S, P = t.escapeUnicodeCharacters, O = P !== void 0 && P, j = t.validator, V = j === void 0 ? null : j, E = t.onChange, C = E === void 0 ? null : E, H = t.onSwitchToTreeMode, X = H === void 0 ? Qe : H, F = t.onError, G = t.onFocus, M = G === void 0 ? Qe : G, $ = t.onBlur, q = $ === void 0 ? Qe : $, B = t.onRenderMenu, D = B === void 0 ? Qe : B, _ = t.onSortModal, L = t.onTransformModal, J = Ur("jsoneditor:TextMode"), st = { key: "Mod-i", run: St, shift: Gt, preventDefault: !0 }, ht = typeof window > "u";
  J("isSSR:", ht);
  var xt = !1, kt = [], I = new Ju(), R = new Ju(), it = new Ju(), N = O;
  yi(mn(de().mark(function gt() {
    return de().wrap(function(Kt) {
      for (; ; )
        switch (Kt.prev = Kt.next) {
          case 0:
            if (!ht) {
              Kt.next = 2;
              break;
            }
            return Kt.abrupt("return");
          case 2:
            try {
              c = oe({ target: u, initialText: o ? "" : k, readOnly: p, indentation: x }), jt();
            } catch (ae) {
              console.error(ae);
            }
          case 3:
          case "end":
            return Kt.stop();
        }
    }, gt);
  }))), Fa(function() {
    c && (J("Destroy CodeMirror editor"), c.destroy());
  });
  var K = !1, z = !1, at = qs(), yt = qs();
  function jt() {
    c && (J("focus"), c.focus());
  }
  var Ft = !1;
  function zt(gt) {
    J("patch", gt);
    var Kt = k, ae = JSON.parse(k), Yt = mt.exports.immutableJSONPatch(ae, gt), se = mt.exports.revertJSONPatch(ae, gt);
    return n(0, k = JSON.stringify(Yt, null, x)), k !== Kt && Bt(k, Kt), { json: Yt, previousJson: ae, undo: se, redo: gt };
  }
  function St() {
    if (J("format"), !p)
      try {
        var gt = k, Kt = JSON.parse(k);
        n(0, k = JSON.stringify(Kt, null, x)), k !== gt && Bt(k, gt);
      } catch (ae) {
        F(ae);
      }
  }
  function Gt() {
    if (J("compact"), !p)
      try {
        var gt = k, Kt = JSON.parse(k);
        n(0, k = JSON.stringify(Kt)), k !== gt && Bt(k, gt);
      } catch (ae) {
        F(ae);
      }
  }
  function _e() {
    if (J("repair"), !p)
      try {
        var gt = k;
        n(0, k = Zo(k)), n(44, ee = "valid"), n(12, ie = void 0), k !== gt && Bt(k, gt);
      } catch (Kt) {
        F(Kt);
      }
  }
  function Fe(gt) {
    var Kt = gt.id, ae = gt.selectedPath, Yt = gt.onTransform, se = gt.onClose;
    try {
      var Ae = JSON.parse(k);
      Ft = !0, L({ id: Kt || yt, json: Ae, selectedPath: ae, onTransform: Yt ? function(me) {
        Yt({ operations: me, json: Ae, transformedJson: mt.exports.immutableJSONPatch(Ae, me) });
      } : function(me) {
        J("onTransform", me), zt(me);
      }, onClose: function() {
        Ft = !1, jt(), se && se();
      } });
    } catch (me) {
      F(me);
    }
  }
  function fn(gt) {
    J("select parse error", gt);
    var Kt = sn(gt, !1);
    De(Kt.from, Kt.to), jt();
  }
  function De(gt, Kt) {
    J("setSelection", { anchor: gt, head: Kt }), c && c.dispatch(c.state.update({ selection: { anchor: gt, head: Kt }, scrollIntoView: !0 }));
  }
  function $t(gt, Kt) {
    if (Kt.state.selection.ranges.length === 1) {
      var ae = Kt.state.selection.ranges[0], Yt = k.slice(ae.from, ae.to);
      if (Yt === "{" || Yt === "[") {
        var se = Of.parse(k), Ae = Object.keys(se.pointers).find(function(Se) {
          var Oe;
          return ((Oe = se.pointers[Se].value) === null || Oe === void 0 ? void 0 : Oe.pos) === ae.from;
        }), me = se.pointers[Ae];
        Ae && me && me.value && me.valueEnd && (J("pointer found, selecting inner contents of path:", Ae, me), De(me.value.pos + 1, me.valueEnd.pos - 1));
      }
    }
  }
  function oe(gt) {
    var Kt = gt.target, ae = gt.initialText, Yt = gt.readOnly, se = gt.indentation;
    J("Create CodeMirror editor", { readOnly: Yt, indentation: se });
    var Ae = In.create({ doc: ae, extensions: [cd.of([dU, st]), rJ(function() {
      return Rt.flush(), function() {
        if (J("validate"), n(44, ee = "valid"), n(12, ie = null), n(9, kt = []), k.length > 104857600)
          return [{ from: 0, to: 0, message: "Validation turned off: the document is too large", severity: "info" }];
        if (k.length === 0)
          return [];
        try {
          var me = kv(function() {
            return JSON.parse(k);
          }, function(Oe) {
            return J("validate: parsed json in ".concat(Oe, " ms"));
          });
          return V ? (n(9, kt = kv(function() {
            return V(me);
          }, function(Oe) {
            return J("validate: validated json in ".concat(Oe, " ms"));
          })), kt.map(Ce)) : [];
        } catch (Oe) {
          var Se = kv(function() {
            return function(Ee) {
              if (Ee.length > 1048576)
                return !1;
              try {
                return JSON.parse(Zo(Ee)), !0;
              } catch {
                return !1;
              }
            }(k);
          }, function(Ee) {
            return J("validate: checked whether repairable in ".concat(Ee, " ms"));
          });
          return n(12, ie = rA(k, Oe.message || Oe.toString())), n(44, ee = Se ? "repairable" : "invalid"), [sn(ie, Se)];
        }
      }();
    }, { delay: 300 }), lJ(), fJ, RJ, we.domEventHandlers({ dblclick: $t }), we.updateListener.of(function(me) {
      n(8, h = me.state), me.docChanged && Rt();
    }), new pW(EJ), kU({ top: !0 }), I.of(In.readOnly.of(Yt)), it.of(In.tabSize.of(T)), R.of(lt(se)), we.lineWrapping] });
    return c = new we({ state: Ae, parent: Kt });
  }
  function Ce(gt) {
    var Kt = gt.path, ae = gt.message, Yt = gt.isChildError, se = function(Ae, me) {
      try {
        var Se = Of.parse(Ae), Oe = mt.exports.compileJSONPointer(me), Ee = Se.pointers[Oe];
        if (Ee)
          return { path: me, line: Ee.key ? Ee.key.line : Ee.value ? Ee.value.line : 0, column: Ee.key ? Ee.key.column : Ee.value ? Ee.value.column : 0, from: Ee.key ? Ee.key.pos : Ee.value ? Ee.value.pos : 0, to: Ee.keyEnd ? Ee.keyEnd.pos : Ee.valueEnd ? Ee.valueEnd.pos : 0 };
      } catch (kn) {
        console.error(kn);
      }
      return null;
    }(k, Kt);
    return { path: Kt, isChildError: Yt, line: se.line, column: se.column, from: se.from, to: se.to, message: ae, severity: "warning", actions: [] };
  }
  function sn(gt, Kt) {
    var ae = gt.line, Yt = gt.column, se = gt.position;
    return { path: null, line: ae, column: Yt, from: se || 0, to: se || 0, severity: "error", message: gt.message, actions: Kt && !p ? [{ name: "Auto repair", apply: function() {
      return _e();
    } }] : null };
  }
  function vn(gt) {
    var Kt = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    !o || Kt ? c && gt !== l && (J("setCodeMirrorValue length=", gt.length), l = gt, c.dispatch({ changes: { from: 0, to: c.state.doc.length, insert: a.escapeValue(gt) } }), wt()) : J("not applying text: editor is disabled");
  }
  function nt() {
    J("forceUpdateText", { escapeUnicodeCharacters: O }), c && c.dispatch({ changes: { from: 0, to: c.state.doc.length, insert: a.escapeValue(k) } });
  }
  function ct() {
    if (c && (l = c ? a.unescapeValue(c.state.doc.toString()) : "") !== k) {
      var gt = l;
      J("text changed"), n(0, k = l), wt(), Bt(k, gt);
    }
  }
  function lt(gt) {
    return fd.of(typeof gt == "number" ? " ".repeat(gt) : gt);
  }
  function wt() {
    n(10, K = iU(c.state) > 0), n(11, z = oU(c.state) > 0), J({ canUndo: K, canRedo: z });
  }
  mA({ onMount: yi, onDestroy: Fa, getWindow: function() {
    return cc(f);
  }, hasFocus: function() {
    return Ft && document.hasFocus() || dp(f);
  }, onFocus: M, onBlur: q });
  var Rt = fu(ct, 300);
  function Bt(gt, Kt) {
    C && C(gt, Kt);
  }
  var ee = "valid", ie = null;
  return e.$$set = function(gt) {
    "readOnly" in gt && n(1, p = gt.readOnly), "mainMenuBar" in gt && n(2, m = gt.mainMenuBar), "statusBar" in gt && n(3, y = gt.statusBar), "text" in gt && n(0, k = gt.text), "indentation" in gt && n(28, x = gt.indentation), "tabSize" in gt && n(29, T = gt.tabSize), "escapeUnicodeCharacters" in gt && n(30, O = gt.escapeUnicodeCharacters), "validator" in gt && n(31, V = gt.validator), "onChange" in gt && n(32, C = gt.onChange), "onSwitchToTreeMode" in gt && n(4, X = gt.onSwitchToTreeMode), "onError" in gt && n(33, F = gt.onError), "onFocus" in gt && n(34, M = gt.onFocus), "onBlur" in gt && n(35, q = gt.onBlur), "onRenderMenu" in gt && n(5, D = gt.onRenderMenu), "onSortModal" in gt && n(36, _ = gt.onSortModal), "onTransformModal" in gt && n(37, L = gt.onTransformModal);
  }, e.$$.update = function() {
    1 & e.$$.dirty[0] && n(15, r = k.length === 0), 1 & e.$$.dirty[0] && n(45, i = k && k.length > 10485760), 18432 & e.$$.dirty[1] && n(14, o = i && !xt), 1073741824 & e.$$.dirty[0] && (a = iA({ escapeControlCharacters: !1, escapeUnicodeCharacters: O })), 1 & e.$$.dirty[0] && vn(k), 268435456 & e.$$.dirty[0] && function(gt) {
      c && (J("updateIndentation", gt), c.dispatch({ effects: R.reconfigure(lt(gt)) }));
    }(x), 536870912 & e.$$.dirty[0] && function(gt) {
      c && (J("updateTabSize", gt), c.dispatch({ effects: it.reconfigure(In.tabSize.of(gt)) }));
    }(T), 2 & e.$$.dirty[0] && function(gt) {
      c && (J("updateReadOnly", gt), c.dispatch({ effects: I.reconfigure(In.readOnly.of(gt)) }));
    }(p), 1073741824 & e.$$.dirty[0] | 4096 & e.$$.dirty[1] && N !== O && (n(43, N = O), nt()), 2 & e.$$.dirty[0] | 1 & e.$$.dirty[1] && nt(), 2 & e.$$.dirty[0] | 8192 & e.$$.dirty[1] && n(13, s = ee !== "repairable" || p ? [] : [{ icon: u0, text: "Auto repair", title: "Automatically repair JSON", onClick: _e }]);
  }, [k, p, m, y, X, D, u, f, h, kt, K, z, ie, s, o, r, ht, St, Gt, function() {
    var gt;
    if (!p)
      try {
        var Kt = JSON.parse(k);
        Ft = !0, _({ id: at, json: Kt, selectedPath: [], onSort: (gt = mn(de().mark(function ae(Yt) {
          return de().wrap(function(se) {
            for (; ; )
              switch (se.prev = se.next) {
                case 0:
                  J("onSort", Yt), zt(Yt);
                case 2:
                case "end":
                  return se.stop();
              }
          }, ae);
        })), function(ae) {
          return gt.apply(this, arguments);
        }), onClose: function() {
          Ft = !1, jt();
        } });
      } catch (ae) {
        F(ae);
      }
  }, function() {
    p || Fe({ selectedPath: [] });
  }, function() {
    c && (u && u.querySelector(".cm-search") ? M0(c) : E0(c));
  }, function() {
    p || c && (_0(c), jt());
  }, function() {
    p || c && (ah(c), jt());
  }, function() {
    n(42, xt = !0), vn(k, !0);
  }, function() {
    ct();
  }, function(gt) {
    J("select validation error", gt);
    var Kt = Ce(gt);
    De(Kt.from, Kt.to), jt();
  }, fn, x, T, O, V, C, F, M, q, _, L, jt, zt, Fe, function() {
    J("refresh");
    var gt = c.state.doc.length;
    c.dispatch({ changes: { from: gt, to: gt, insert: " " } }), c.dispatch({ changes: { from: gt, to: gt + 1, insert: "" } });
  }, xt, N, ee, i, function(gt) {
    Be[gt ? "unshift" : "push"](function() {
      n(6, u = gt);
    });
  }, function() {
    return fn(ie);
  }, function(gt) {
    Be[gt ? "unshift" : "push"](function() {
      n(7, f = gt);
    });
  }];
}
z0.style = function(e) {
  return DJ(e || []);
};
var VJ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, qJ, FJ, Ue, { readOnly: 1, mainMenuBar: 2, statusBar: 3, text: 0, indentation: 28, tabSize: 29, escapeUnicodeCharacters: 30, validator: 31, onChange: 32, onSwitchToTreeMode: 4, onError: 33, onFocus: 34, onBlur: 35, onRenderMenu: 5, onSortModal: 36, onTransformModal: 37, focus: 38, patch: 39, openTransformModal: 40, refresh: 41 }, LJ, [-1, -1, -1]), i;
  }
  return Y(n, [{ key: "focus", get: function() {
    return this.$$.ctx[38];
  } }, { key: "patch", get: function() {
    return this.$$.ctx[39];
  } }, { key: "openTransformModal", get: function() {
    return this.$$.ctx[40];
  } }, { key: "refresh", get: function() {
    return this.$$.ctx[41];
  } }]), n;
}(), wv = Ur("jsoneditor:AutoScrollHandler"), HJ = function(e, t, n, r) {
  return (e /= r / 2) < 1 ? n / 2 * e * e + t : -n / 2 * (--e * (e - 2) - 1) + t;
}, WJ = function() {
  var e, t, n, r, i, o, a, s, u, c, l, f, h;
  function d() {
    return e.scrollY || e.pageYOffset || e.scrollTop;
  }
  function p(g) {
    return g.getBoundingClientRect().top - (e.getBoundingClientRect ? e.getBoundingClientRect().top : 0) + n;
  }
  function v(g) {
    e.scrollTo ? e.scrollTo(0, g) : e.scrollTop = g;
  }
  function m(g) {
    c || (c = g), v(o(l = g - c, n, s, u)), h = !0, l < u ? requestAnimationFrame(m) : function() {
      v(n + s), t && a && (t.setAttribute("tabindex", "-1"), t.focus()), typeof f == "function" && f(), c = !1, h = !1;
    }();
  }
  return function(g) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    switch (u = y.duration || 1e3, i = y.offset || 0, f = y.callback, o = y.easing || HJ, a = y.a11y || !1, ne(y.container)) {
      case "object":
        e = y.container;
        break;
      case "string":
        e = document.querySelector(y.container);
        break;
      default:
        e = window;
    }
    switch (n = d(), ne(g)) {
      case "number":
        t = void 0, a = !1, r = n + g;
        break;
      case "object":
        r = p(t = g);
        break;
      case "string":
        t = document.querySelector(g), r = p(t);
    }
    switch (s = r - n + i, ne(y.duration)) {
      case "number":
        u = y.duration;
        break;
      case "function":
        u = y.duration(s);
    }
    h ? c = !1 : requestAnimationFrame(m);
  };
};
function UE(e) {
  for (var t = Gg(e, function(s) {
    return s.start;
  }), n = [t[0]], r = 0; r < t.length; r++) {
    var i = n.length - 1, o = n[i], a = t[r];
    a.start <= o.end ? n[i] = { start: Math.min(o.start, a.start), end: Math.max(o.end, a.end) } : n.push(a);
  }
  return n;
}
function UJ(e, t) {
  return e.some(function(n) {
    return t >= n.start && t < n.end;
  });
}
function vm(e) {
  return yh(e) + 100;
}
function yh(e) {
  return 100 * Math.floor(e / 100);
}
function uS(e) {
  var t = { expandedMap: {}, enforceStringMap: {}, visibleSectionsMap: {}, selection: void 0 };
  return e != null && e.select && (t = Ct(Ct({}, t), {}, { selection: e.select(e.json, t) })), e != null && e.expand && (t = _i(e.json, t, [], e.expand)), t;
}
function wd(e, t) {
  return e.visibleSectionsMap[t] || qa;
}
function B0(e, t, n) {
  t.forEach(function(r) {
    var i = r.start, o = r.end;
    tA(i, Math.min(e.length, o), n);
  });
}
function xv(e, t, n) {
  for (var r = Ct({}, t.expandedMap), i = Ct({}, t.visibleSectionsMap), o = 0; o <= n.length; o++) {
    var a = n.slice(0, o), s = mt.exports.compileJSONPointer(a), u = mt.exports.getIn(e, a);
    if (ur(u) && (r[s] = !0), Array.isArray(u) && o < n.length) {
      var c = i[s] || qa, l = nr(n[o]);
      if (!UJ(c, l)) {
        var f = yh(l), h = { start: f, end: vm(f) };
        i[s] = UE(c.concat(h));
      }
    }
  }
  return Ct(Ct({}, t), {}, { expandedMap: r, visibleSectionsMap: i });
}
function _i(e, t, n, r) {
  var i = Ct({}, t.expandedMap), o = n.slice();
  return function a(s) {
    var u = o.length;
    if (Array.isArray(s)) {
      if (r(o)) {
        var c = mt.exports.compileJSONPointer(o);
        if (i[c] = !0, s.length > 0) {
          var l = wd(t, c);
          B0(s, l, function(v) {
            o[u] = String(v), a(s[v]);
          }), o.pop();
        }
      }
    } else if (mr(s) && r(o)) {
      i[mt.exports.compileJSONPointer(o)] = !0;
      var f = Object.keys(s);
      if (f.length > 0) {
        var h, d = ut(f);
        try {
          for (d.s(); !(h = d.n()).done; ) {
            var p = h.value;
            o[u] = p, a(s[p]);
          }
        } catch (v) {
          d.e(v);
        } finally {
          d.f();
        }
        o.pop();
      }
    }
  }(mt.exports.getIn(e, n)), Ct(Ct({}, t), {}, { expandedMap: i });
}
function JJ(e, t) {
  return Ct(Ct({}, e), {}, { expandedMap: Ct(Ct({}, e.expandedMap), {}, na({}, mt.exports.compileJSONPointer(t), !0)) });
}
function cS(e, t) {
  var n = Ns(e.expandedMap, t), r = Ns(e.enforceStringMap, t), i = Ns(e.visibleSectionsMap, t);
  return Ct(Ct({}, e), {}, { expandedMap: n, enforceStringMap: r, visibleSectionsMap: i });
}
function KJ(e, t, n) {
  if (n) {
    var r = Ct({}, e.enforceStringMap);
    return r[t] = n, Ct(Ct({}, e), {}, { enforceStringMap: r });
  }
  if (typeof e.enforceStringMap[t] == "boolean") {
    var i = Ct({}, e.enforceStringMap);
    return delete i[t], Ct(Ct({}, e), {}, { enforceStringMap: i });
  }
  return e;
}
function GJ(e, t, n) {
  var r = mt.exports.immutableJSONPatch(e, n), i = n.reduce(function(o, a) {
    return mt.exports.isJSONPatchAdd(a) ? lS(r, o, a) : mt.exports.isJSONPatchRemove(a) ? fS(r, o, a) : mt.exports.isJSONPatchReplace(a) ? function(s, u, c) {
      var l = c.path, f = _v(s, u.expandedMap), h = _v(s, u.enforceStringMap), d = _v(s, u.visibleSectionsMap);
      return Rr(c.value) || yr(c.value) || delete f[l], yr(c.value) || delete d[l], (Rr(c.value) || yr(c.value)) && delete h[l], Ct(Ct({}, u), {}, { expandedMap: f, enforceStringMap: h, visibleSectionsMap: d });
    }(r, o, a) : mt.exports.isJSONPatchCopy(a) || mt.exports.isJSONPatchMove(a) ? function(s, u, c) {
      if (mt.exports.isJSONPatchMove(c) && c.from === c.path)
        return u;
      var l = function(y) {
        return c.path + y.substring(c.from.length);
      }, f = $v(jv(u.expandedMap, c.from), l), h = $v(jv(u.enforceStringMap, c.from), l), d = $v(jv(u.visibleSectionsMap, c.from), l), p = u;
      mt.exports.isJSONPatchMove(c) && (p = fS(s, p, { op: "remove", path: c.from }));
      var v = Sv((p = lS(s, p, { op: "add", path: c.path, value: null })).expandedMap, f), m = Sv(p.enforceStringMap, h), g = Sv(p.visibleSectionsMap, d);
      return Ct(Ct({}, u), {}, { expandedMap: v, enforceStringMap: m, visibleSectionsMap: g });
    }(r, o, a) : o;
  }, t);
  return { json: r, documentState: i };
}
function lS(e, t, n) {
  var r = mt.exports.parsePath(e, n.path), i = Ge(r), o = mt.exports.compileJSONPointer(i);
  if (yr(mt.exports.getIn(e, i))) {
    var a = nr(ve(r)), s = Rs(t.expandedMap, i, a, 1), u = Rs(t.enforceStringMap, i, a, 1), c = Rs(t.visibleSectionsMap, i, a, 1);
    return c = JE(c, o, function(l) {
      return KE(l, a, 1);
    }), Ct(Ct({}, t), {}, { expandedMap: s, enforceStringMap: u, visibleSectionsMap: c });
  }
  return t;
}
function fS(e, t, n) {
  var r = mt.exports.parsePath(e, n.path), i = Ge(r), o = mt.exports.compileJSONPointer(i), a = mt.exports.getIn(e, i), s = t.expandedMap, u = t.enforceStringMap, c = t.visibleSectionsMap;
  if (s = Ns(s, r), u = Ns(u, r), c = Ns(c, r), yr(a)) {
    var l = nr(ve(r));
    s = Rs(s, i, l, -1), u = Rs(u, i, l, -1), c = JE(c = Rs(c, i, l, -1), o, function(f) {
      return KE(f, l, -1);
    });
  }
  return Ct(Ct({}, t), {}, { expandedMap: s, enforceStringMap: u, visibleSectionsMap: c });
}
function Ns(e, t) {
  var n = {}, r = mt.exports.compileJSONPointer(t);
  return Object.keys(e).forEach(function(i) {
    mt.exports.startsWithJSONPointer(i, r) || (n[i] = e[i]);
  }), n;
}
function jv(e, t) {
  var n = {};
  return Object.keys(e).forEach(function(r) {
    mt.exports.startsWithJSONPointer(r, t) && (n[r] = e[r]);
  }), n;
}
function Sv(e, t) {
  return Ct(Ct({}, e), t);
}
function $v(e, t) {
  var n = {};
  return Object.keys(e).forEach(function(r) {
    var i = t(r);
    n[i] = e[r];
  }), n;
}
function Rs(e, t, n, r) {
  for (var i = t.length, o = mt.exports.compileJSONPointer(t), a = [], s = 0, u = Object.keys(e); s < u.length; s++) {
    var c = u[s];
    if (mt.exports.startsWithJSONPointer(c, o)) {
      var l = mt.exports.parseJSONPointer(c), f = nr(l[i]);
      f >= n && (l[i] = String(f + r), a.push({ oldPointer: c, newPointer: mt.exports.compileJSONPointer(l), value: e[c] }));
    }
  }
  if (a.length === 0)
    return e;
  var h = Ct({}, e);
  return a.forEach(function(d) {
    delete h[d.oldPointer];
  }), a.forEach(function(d) {
    h[d.newPointer] = d.value;
  }), h;
}
function _v(e, t) {
  var n = {};
  return Object.keys(t).filter(function(r) {
    return mt.exports.existsIn(e, mt.exports.parsePath(e, r));
  }).forEach(function(r) {
    n[r] = t[r];
  }), n;
}
function JE(e, t, n) {
  var r = e[t];
  if (t in e) {
    var i = n(r);
    if (!rn(r, i)) {
      var o = Ct({}, e);
      return i === void 0 ? delete o[t] : o[t] = i, o;
    }
  }
  return e;
}
function KE(e, t, n) {
  return e.map(function(r) {
    return { start: r.start > t ? r.start + n : r.start, end: r.end >= t ? r.end + n : r.end };
  });
}
function rl(e, t, n) {
  var r, i = t ? t[n] : void 0;
  return typeof i == "boolean" ? i : typeof (r = e) == "string" && typeof Rc(r) != "string";
}
function il(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], r = e.indexOf(t);
  return r !== -1 ? n ? e.slice(r) : e.slice(r + 1) : [];
}
function F0(e, t) {
  var n = [];
  return function r(i, o) {
    n.push(o);
    var a = mt.exports.compileJSONPointer(o);
    if (i && t.expandedMap[a] === !0) {
      if (yr(i)) {
        var s = wd(t, a);
        B0(i, s, function(u) {
          r(i[u], o.concat(String(u)));
        });
      }
      Rr(i) && Object.keys(i).forEach(function(u) {
        r(i[u], o.concat(u));
      });
    }
  }(e, []), n;
}
function GE(e, t) {
  var n = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], r = [];
  function i(o, a) {
    r.push({ path: a, type: Oi.value });
    var s = mt.exports.compileJSONPointer(a);
    if (o && t.expandedMap[s] === !0) {
      if (n && r.push({ path: a, type: Oi.inside }), yr(o)) {
        var u = wd(t, s);
        B0(o, u, function(c) {
          var l = a.concat(String(c));
          i(o[c], l), n && r.push({ path: l, type: Oi.after });
        });
      }
      Rr(o) && Object.keys(o).forEach(function(c) {
        var l = a.concat(c);
        r.push({ path: l, type: Oi.key }), i(o[c], l), n && r.push({ path: l, type: Oi.after });
      });
    }
  }
  return i(e, []), r;
}
function QJ(e, t, n) {
  var r = F0(e, t), i = r.map(mt.exports.compileJSONPointer), o = mt.exports.compileJSONPointer(n), a = i.indexOf(o);
  return a !== -1 && a > 0 ? r[a - 1] : null;
}
function pm(e, t, n) {
  var r = F0(e, t), i = r.map(mt.exports.compileJSONPointer).indexOf(mt.exports.compileJSONPointer(n));
  return i !== -1 && i < r.length - 1 ? r[i + 1] : null;
}
var Wl = Ur("jsoneditor:History");
function XJ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.maxItems || 1e3, n = [], r = 0;
  function i() {
    return r < n.length;
  }
  function o() {
    return r > 0;
  }
  function a() {
    return { canUndo: i(), canRedo: o(), length: n.length };
  }
  function s() {
    e.onChange && e.onChange(a());
  }
  function u(h) {
    Wl("add", h), n = [h].concat(n.slice(r)).slice(0, t), r = 0, s();
  }
  function c() {
    Wl("clear"), n = [], r = 0, s();
  }
  function l() {
    if (i()) {
      var h = n[r];
      return r += 1, Wl("undo", h), s(), h;
    }
  }
  function f() {
    if (o())
      return Wl("redo", n[r -= 1]), s(), n[r];
  }
  return { add: u, clear: c, getState: a, undo: l, redo: f };
}
function ol(e, t) {
  for (var n = new Set(t), r = e.replace(/ \(copy( \d+)?\)$/, ""), i = e, o = 1; n.has(i); ) {
    var a = "copy" + (o > 1 ? " " + o : "");
    i = "".concat(r, " (").concat(a, ")"), o++;
  }
  return i;
}
function bh(e, t) {
  var n = t - 3;
  return e.length > t ? e.substring(0, n) + "..." : e;
}
function ZJ(e) {
  if (e === "")
    return "";
  var t = e.toLowerCase();
  if (t === "null")
    return null;
  if (t === "true")
    return !0;
  if (t === "false")
    return !1;
  if (t !== "undefined") {
    var n = Number(e), r = parseFloat(e);
    return isNaN(n) || isNaN(r) ? e : n;
  }
}
function Ti(e) {
  return e && e.type === gn.after;
}
function rr(e) {
  return e && e.type === gn.inside;
}
function Xn(e) {
  return e && e.type === gn.key;
}
function en(e) {
  return e && e.type === gn.value;
}
function nn(e) {
  return e && e.type === gn.multi;
}
function QE(e) {
  return rr(e) ? e.focusPath : Ge(e.focusPath);
}
function _s(e) {
  return nn(e) ? cr(e.paths) : e.focusPath;
}
function mf(e) {
  return nn(e) ? ve(e.paths) : e.focusPath;
}
function YJ(e, t) {
  return Cc(e.focusPath, t) && (e.focusPath.length > t.length || rr(e));
}
function hS(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], r = arguments.length > 3 && arguments[3] !== void 0 && arguments[3], i = t.selection, o = !r && nn(i) ? cr(i.paths) : i.focusPath, a = QJ(e, t, o);
  if (a === null)
    return null;
  var s = a, u = a;
  if (n)
    return Ti(i) || rr(i) ? tr(e, i.anchorPath, i.anchorPath) : tr(e, i.anchorPath, u);
  if (Xn(i)) {
    var c = Ge(a), l = mt.exports.getIn(e, c);
    return Array.isArray(l) || _n(a) ? Mn(a, !1) : Qr(a, !1);
  }
  return en(i) ? Mn(a, !1) : Ti(i) || rr(i) ? tr(e, o, o) : tr(e, s, u);
}
function dS(e, t, n) {
  var r = t.selection, i = GE(e, t, n), o = i.findIndex(function(a) {
    return rn(a.path, r.focusPath) && String(a.type) === String(r.type);
  });
  return { caret: o !== -1 ? i[o] : null, previous: o !== -1 && o > 0 ? i[o - 1] : null, next: o !== -1 && o < i.length - 1 ? i[o + 1] : null };
}
function Ul(e, t) {
  for (var n = F0(e, t), r = 0; r < n.length - 1 && n[r + 1].length > n[r].length; )
    r++;
  var i = n[r];
  return i.length === 0 || Array.isArray(mt.exports.getIn(e, Ge(i))) ? Mn(i, !1) : Qr(i, !1);
}
function Qs(e, t) {
  if (t.length === 1) {
    var n = cr(t);
    if (n.op === "replace" || n.op === "move")
      return Mn(mt.exports.parsePath(e, n.path), !1);
  }
  if (!_n(t) && t.every(function(a) {
    return a.op === "move";
  })) {
    var r = cr(t), i = t.slice(1);
    if ((mt.exports.isJSONPatchCopy(r) || mt.exports.isJSONPatchMove(r)) && r.from !== r.path && i.every(function(a) {
      return (mt.exports.isJSONPatchCopy(a) || mt.exports.isJSONPatchMove(a)) && a.from === a.path;
    }))
      return Qr(mt.exports.parsePath(e, r.path), !1);
  }
  var o = t.filter(function(a) {
    return a.op !== "test" && a.op !== "remove" && (a.op !== "move" || a.from !== a.path) && typeof a.path == "string";
  }).map(function(a) {
    return mt.exports.parsePath(e, a.path);
  });
  return _n(o) ? null : { type: gn.multi, paths: o, anchorPath: cr(o), focusPath: ve(o), pointersMap: XE(o) };
}
function XE(e) {
  var t = {};
  return e.forEach(function(n) {
    t[mt.exports.compileJSONPointer(n)] = !0;
  }), t;
}
function xd(e) {
  return na({}, mt.exports.compileJSONPointer(e), !0);
}
function mm(e) {
  return e && (Xn(e) || en(e) || nn(e) && e.paths.length === 1);
}
function vS(e, t) {
  return mm(t) && ur(mt.exports.getIn(e, t.focusPath)) ? t.focusPath : Ge(t.focusPath);
}
function Cc(e, t) {
  if (e.length < t.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Vo(e) {
  var t = e.selection;
  return (Xn(t) || en(t)) && t.edit ? Ct(Ct({}, e), {}, { selection: Ct(Ct({}, t), {}, { edit: !1 }) }) : e;
}
function Qr(e, t) {
  return { type: gn.key, anchorPath: e, focusPath: e, pointersMap: xd(e), edit: t };
}
function Mn(e, t) {
  return { type: gn.value, anchorPath: e, focusPath: e, pointersMap: xd(e), edit: t };
}
function oo(e) {
  return { type: gn.inside, anchorPath: e, focusPath: e, pointersMap: xd(e) };
}
function Po(e) {
  return { type: gn.after, anchorPath: e, focusPath: e, pointersMap: xd(e) };
}
function tr(e, t, n) {
  var r = function(o, a, s) {
    if (rn(a, s))
      return [a];
    var u = function(S, T) {
      for (var P = 0; P < S.length && P < T.length && S[P] === T[P]; )
        P++;
      return S.slice(0, P);
    }(a, s);
    if (a.length === u.length || s.length === u.length)
      return [u];
    var c = a[u.length], l = s[u.length], f = mt.exports.getIn(o, u);
    if (Rr(f)) {
      var h = Object.keys(f), d = h.indexOf(c), p = h.indexOf(l);
      if (d !== -1 && p !== -1) {
        for (var v = Math.min(d, p), m = Math.max(d, p), g = [], y = v; y <= m; y++)
          g.push(u.concat(h[y]));
        return g;
      }
    }
    if (yr(f)) {
      for (var b = Math.min(nr(c), nr(l)), k = Math.max(nr(c), nr(l)), w = [], x = b; x <= k; x++)
        w.push(u.concat(String(x)));
      return w;
    }
    throw new Error("Failed to create selection");
  }(e, t, n), i = Cc(n, ve(r)) || Cc(t, cr(r));
  return { type: gn.multi, anchorPath: i ? cr(r) : ve(r), focusPath: i ? ve(r) : cr(r), paths: r, pointersMap: XE(r) };
}
function pS(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
  if (Xn(t))
    return String(ve(t.focusPath));
  if (en(t)) {
    var r = mt.exports.getIn(e, t.focusPath);
    return typeof r == "string" ? r : JSON.stringify(r, null, n);
  }
  if (nn(t)) {
    if (_n(t.focusPath))
      return JSON.stringify(e, null, n);
    var i = QE(t), o = mt.exports.getIn(e, i);
    if (Array.isArray(o)) {
      if (t.paths.length === 1) {
        var a = mt.exports.getIn(e, cr(t.paths));
        return JSON.stringify(a, null, n);
      }
      return t.paths.map(function(s) {
        var u = mt.exports.getIn(e, s);
        return "".concat(JSON.stringify(u, null, n), ",");
      }).join(`
`);
    }
    return t.paths.map(function(s) {
      var u = ve(s), c = mt.exports.getIn(e, s);
      return "".concat(JSON.stringify(u), ": ").concat(JSON.stringify(c, null, n), ",");
    }).join(`
`);
  }
  return null;
}
function ZE(e) {
  return nn(e) ? e.paths : [e.focusPath];
}
function Zu(e) {
  return (Xn(e) || en(e)) && e.edit;
}
function gf(e) {
  return !!e && (!(!Xn(e) && !en(e)) || !(!nn(e) || e.paths.length !== 1) || void 0);
}
function gm(e) {
  switch (e.type) {
    case Oi.key:
      return Qr(e.path, !1);
    case Oi.value:
      return Mn(e.path, !1);
    case Oi.after:
      return Po(e.path);
    case Oi.inside:
      return oo(e.path);
  }
}
function mS(e, t, n) {
  switch (t) {
    case gn.key:
      return Qr(n, !1);
    case gn.value:
      return Mn(n, !1);
    case gn.after:
      return Po(n);
    case gn.inside:
      return oo(n);
    case gn.multi:
      return tr(e, n, n);
  }
}
function gS(e, t) {
  if (e)
    return Object.keys(e.pointersMap).some(function(n) {
      return mt.exports.startsWithJSONPointer(n, t) || mt.exports.startsWithJSONPointer(t, n);
    }) ? e : void 0;
}
function Jl(e, t, n) {
  var r = Ge(t), i = mt.exports.getIn(e, r);
  if (yr(i)) {
    var o = nr(ve(t));
    return n.map(function(c, l) {
      return { op: "add", path: mt.exports.compileJSONPointer(r.concat(String(o + l))), value: c.value };
    });
  }
  if (Rr(i)) {
    var a = ve(t), s = Object.keys(i), u = il(s, a, !0);
    return [].concat(Pe(n.map(function(c) {
      var l = ol(c.key, s);
      return { op: "add", path: mt.exports.compileJSONPointer(r.concat(l)), value: c.value };
    })), Pe(u.map(function(c) {
      return Ka(r, c);
    })));
  }
  throw new Error("Cannot create insert operations: parent must be an Object or Array");
}
function yS(e, t, n) {
  var r = mt.exports.getIn(e, t);
  if (Array.isArray(r)) {
    var i = r.length;
    return n.map(function(o, a) {
      return { op: "add", path: mt.exports.compileJSONPointer(t.concat(String(i + a))), value: o.value };
    });
  }
  return n.map(function(o) {
    var a = ol(o.key, Object.keys(r));
    return { op: "add", path: mt.exports.compileJSONPointer(t.concat(a)), value: o.value };
  });
}
function al(e, t, n, r) {
  var i = ol(r, t.filter(function(a) {
    return a !== n;
  })), o = il(t, n, !1);
  return [{ op: "move", from: mt.exports.compileJSONPointer(e.concat(n)), path: mt.exports.compileJSONPointer(e.concat(i)) }].concat(Pe(o.map(function(a) {
    return Ka(e, a);
  })));
}
function bS(e, t, n) {
  if (Xn(t)) {
    var r = eA(n), i = Ge(t.focusPath), o = mt.exports.getIn(e, i);
    return al(i, Object.keys(o), ve(t.focusPath), typeof r == "string" ? r : n);
  }
  if (en(t) || nn(t) && _n(t.focusPath))
    try {
      return [{ op: "replace", path: mt.exports.compileJSONPointer(t.focusPath), value: n0(n, e0) }];
    } catch {
      return [{ op: "replace", path: mt.exports.compileJSONPointer(t.focusPath), value: n }];
    }
  if (nn(t)) {
    var a = Cv(n);
    return function(w, x, S) {
      var T = Ge(cr(x)), P = mt.exports.getIn(w, T);
      if (yr(P)) {
        var O = cr(x), j = O ? nr(ve(O)) : 0;
        return [].concat(Pe(ym(x)), Pe(S.map(function(M, $) {
          return { op: "add", path: mt.exports.compileJSONPointer(T.concat(String($ + j))), value: M.value };
        })));
      }
      if (Rr(P)) {
        var V = ve(x), E = Ge(V), C = ve(V), H = Object.keys(P), X = il(H, C, !1), F = new Set(x.map(function(M) {
          return ve(M);
        })), G = H.filter(function(M) {
          return !F.has(M);
        });
        return [].concat(Pe(ym(x)), Pe(S.map(function(M) {
          var $ = ol(M.key, G);
          return { op: "add", path: mt.exports.compileJSONPointer(E.concat($)), value: M.value };
        })), Pe(X.map(function(M) {
          return Ka(E, M);
        })));
      }
      throw new Error("Cannot create replace operations: parent must be an Object or Array");
    }(e, t.paths, a);
  }
  if (Ti(t)) {
    var s = Cv(n), u = t.focusPath, c = Ge(u), l = mt.exports.getIn(e, c);
    if (yr(l)) {
      var f = nr(ve(u));
      return Jl(e, c.concat(String(f + 1)), s);
    }
    if (Rr(l)) {
      var h = String(ve(u)), d = Object.keys(l);
      if (_n(d) || ve(d) === h)
        return yS(e, c, s);
      var p = d.indexOf(h), v = d[p + 1];
      return Jl(e, c.concat(v), s);
    }
    throw new Error("Cannot create insert operations: parent must be an Object or Array");
  }
  if (rr(t)) {
    var m = Cv(n), g = t.focusPath, y = mt.exports.getIn(e, g);
    if (yr(y))
      return Jl(e, g.concat("0"), m);
    if (Rr(y)) {
      var b = Object.keys(y);
      if (_n(b))
        return yS(e, g, m);
      var k = cr(b);
      return Jl(e, g.concat(k), m);
    }
    throw new Error("Cannot create insert operations: parent must be an Object or Array");
  }
  throw new Error("Cannot insert: unsupported type of selection " + JSON.stringify(t));
}
function ym(e) {
  return e.map(function(t) {
    return { op: "remove", path: mt.exports.compileJSONPointer(t) };
  }).reverse();
}
function Ka(e, t) {
  return { op: "move", from: mt.exports.compileJSONPointer(e.concat(t)), path: mt.exports.compileJSONPointer(e.concat(t)) };
}
function Cv(e) {
  var t = /^\s*{/.test(e), n = /^\s*\[/.test(e), r = eA(e), i = r !== void 0 ? r : n0(e, e0);
  return t && mr(i) || n && Array.isArray(i) ? [{ key: "New item", value: i }] : Array.isArray(i) ? i.map(function(o, a) {
    return { key: "New item " + a, value: o };
  }) : mr(i) ? Object.keys(i).map(function(o) {
    return { key: o, value: i[o] };
  }) : [{ key: "New item", value: i }];
}
function kS(e, t) {
  if (Xn(t)) {
    var n = Ge(t.focusPath), r = mt.exports.getIn(e, n), i = al(n, Object.keys(r), ve(t.focusPath), "");
    return { operations: i, newSelection: Qs(e, i) };
  }
  if (en(t))
    return { operations: [{ op: "replace", path: mt.exports.compileJSONPointer(t.focusPath), value: "" }], newSelection: t };
  if (nn(t)) {
    var o = ym(t.paths), a = ve(t.paths);
    if (_n(a))
      return { operations: [{ op: "replace", path: "", value: "" }], newSelection: Mn([], !1) };
    var s = Ge(a), u = mt.exports.getIn(e, s);
    if (yr(u)) {
      var c = nr(ve(cr(t.paths)));
      return { operations: o, newSelection: c === 0 ? oo(s) : Po(s.concat(String(c - 1))) };
    }
    if (Rr(u)) {
      var l = Object.keys(u), f = ve(cr(t.paths)), h = l.indexOf(f), d = l[h - 1];
      return { operations: o, newSelection: h === 0 ? oo(s) : Po(s.concat(d)) };
    }
    throw new Error("Cannot create remove operations: parent must be an Object or Array");
  }
  throw new Error("Cannot remove: unsupported type of selection " + JSON.stringify(t));
}
function wS(e, t) {
  var n = Ge(t), r = ve(t), i = mt.exports.getIn(e, n);
  return Rr(i) ? il(Object.keys(i), r, !1).map(function(o) {
    return Ka(n, o);
  }) : [];
}
function tK(e) {
  var t = e.activeIndex < e.items.length - 1 ? e.activeIndex + 1 : e.items.length > 0 ? 0 : -1, n = e.items[t], r = e.items.map(function(i, o) {
    return Ct(Ct({}, i), {}, { active: o === t });
  });
  return Ct(Ct({}, e), {}, { items: r, itemsMap: Vc(r, function(i) {
    return mt.exports.compileJSONPointer(i.path);
  }), activeItem: n, activeIndex: t });
}
function eK(e) {
  var t = e.activeIndex > 0 ? e.activeIndex - 1 : e.items.length - 1, n = e.items[t], r = e.items.map(function(i, o) {
    return Ct(Ct({}, i), {}, { active: o === t });
  });
  return Ct(Ct({}, e), {}, { items: r, itemsMap: Vc(r, function(i) {
    return mt.exports.compileJSONPointer(i.path);
  }), activeItem: n, activeIndex: t });
}
function YE(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1 / 0, i = [], o = [];
  function a(c) {
    i.length < r && i.push(c);
  }
  function s(c, l) {
    if (yr(l)) {
      var f = o.length;
      o.push("0");
      for (var h = 0; h < l.length; h++)
        if (o[f] = String(h), s(c, l[h]), i.length >= r)
          return;
      o.pop();
    } else if (Rr(l)) {
      var d = Object.keys(l), p = o.length;
      o.push("");
      for (var v = 0, m = d; v < m.length; v++) {
        var g = m[v];
        if (o[p] = g, xS(g, c, o, Ni.key, a), s(c, l[g]), i.length >= r)
          return;
      }
      o.pop();
    } else
      xS(String(l), c, o, Ni.value, a);
  }
  if (typeof e == "string" && e !== "") {
    var u = e.toLowerCase();
    s(u, t);
  }
  return i;
}
function xS(e, t, n, r, i) {
  var o = e.toLowerCase(), a = 0, s = -1, u = -1;
  do
    (u = o.indexOf(t, s)) !== -1 && (s = u + t.length, i({ path: n.slice(0), field: r, fieldIndex: a, start: u, end: s }), a++);
  while (u !== -1);
}
function bm(e, t, n, r) {
  return e.substring(0, n) + t + e.substring(r);
}
function jS(e, t, n) {
  var r = e;
  return uc(n, function(i) {
    r = bm(r, t, i.start, i.end);
  }), r;
}
function nK(e, t, n, r) {
  var i = r.field, o = r.path, a = r.start, s = r.end;
  if (i === Ni.key) {
    var u = Ge(o), c = mt.exports.getIn(e, u), l = ve(o), f = al(u, Object.keys(c), l, bm(l, n, a, s));
    return { newSelection: Qs(e, f), operations: f };
  }
  if (i === Ni.value) {
    var h = mt.exports.getIn(e, o);
    if (h === void 0)
      throw new Error("Cannot replace: path not found ".concat(mt.exports.compileJSONPointer(o)));
    var d = typeof h == "string" ? h : String(h), p = mt.exports.compileJSONPointer(o), v = rl(h, t.enforceStringMap, p), m = bm(d, n, a, s), g = [{ op: "replace", path: mt.exports.compileJSONPointer(o), value: v ? m : Rc(m) }];
    return { newSelection: Qs(e, g), operations: g };
  }
  throw new Error("Cannot replace: unknown type of search result field ".concat(i));
}
function rK(e, t, n, r) {
  for (var i = YE(n, e, t, 1 / 0), o = [], a = 0; a < i.length; a++) {
    var s = i[a - 1], u = i[a];
    a !== 0 && u.field === s.field && rn(u.path, s.path) ? ve(o).items.push(u) : o.push({ path: u.path, field: u.field, items: [u] });
  }
  o.sort(function(f, h) {
    return f.field !== h.field ? f.field === Ni.key ? 1 : -1 : h.path.length - f.path.length;
  });
  var c = [], l = void 0;
  return o.forEach(function(f) {
    var h = f.field, d = f.path, p = f.items;
    if (h === Ni.key) {
      var v = Ge(d), m = mt.exports.getIn(e, v), g = ve(d), y = al(v, Object.keys(m), g, jS(g, r, p));
      c = c.concat(y), l = Qs(e, y);
    } else {
      if (h !== Ni.value)
        throw new Error("Cannot replace: unknown type of search result field ".concat(h));
      var b = mt.exports.getIn(e, d);
      if (b === void 0)
        throw new Error("Cannot replace: path not found ".concat(mt.exports.compileJSONPointer(d)));
      var k = typeof b == "string" ? b : String(b), w = mt.exports.compileJSONPointer(d), x = rl(b, t.enforceStringMap, w), S = jS(k, r, p), T = [{ op: "replace", path: mt.exports.compileJSONPointer(d), value: x ? S : Rc(S) }];
      c = c.concat(T), l = Qs(e, T);
    }
  }), { operations: c, newSelection: l };
}
function SS(e) {
  return e.path.concat(e.field, String(e.fieldIndex));
}
function iK(e, t) {
  var n, r = (n = e == null ? void 0 : e[t]) === null || n === void 0 ? void 0 : n.filter(function(i) {
    return i.field === Ni.key;
  });
  if (r && r.length !== 0)
    return r;
}
function $S(e, t) {
  var n, r = (n = e == null ? void 0 : e[t]) === null || n === void 0 ? void 0 : n.filter(function(i) {
    return i.field === Ni.value;
  });
  if (r && r.length !== 0)
    return r;
}
function oK(e) {
  Te(e, "svelte-d01h2s", ".jse-header.svelte-d01h2s.svelte-d01h2s{display:flex;background:var(--jse-theme-color);color:var(--jse-menu-color)}.jse-header.svelte-d01h2s .jse-title.svelte-d01h2s{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-d01h2s button.svelte-d01h2s{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-d01h2s button.svelte-d01h2s:hover{background:rgba(255, 255, 255, 0.1)}");
}
function aK(e) {
  var t, n, r, i, o, a, s, u, c;
  return a = new Le({ props: { data: Gc } }), { c: function() {
    t = rt("div"), n = rt("div"), r = Xt(e[0]), i = bt(), o = rt("button"), Pt(a.$$.fragment), A(n, "class", "jse-title svelte-d01h2s"), A(o, "type", "button"), A(o, "class", "jse-close svelte-d01h2s"), A(t, "class", "jse-header svelte-d01h2s");
  }, m: function(l, f) {
    pt(l, t, f), W(t, n), W(n, r), W(t, i), W(t, o), Ot(a, o, null), s = !0, u || (c = Nt(o, "click", e[1]), u = !0);
  }, p: function(l, f) {
    var h = xe(f, 1)[0];
    (!s || 1 & h) && Ve(r, l[0]);
  }, i: function(l) {
    s || (U(a.$$.fragment, l), s = !0);
  }, o: function(l) {
    tt(a.$$.fragment, l), s = !1;
  }, d: function(l) {
    l && vt(t), At(a), u = !1, c();
  } };
}
function sK(e, t, n) {
  var r = t.title, i = r === void 0 ? "Modal" : r, o = Hr("simple-modal").close;
  return e.$$set = function(a) {
    "title" in a && n(0, i = a.title);
  }, [i, o];
}
var tM = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, sK, aK, Ue, { title: 0 }, oK), i;
  }
  return Y(n);
}();
function uK(e) {
  Te(e, "svelte-t45ah0", ".jse-modal.svelte-t45ah0.svelte-t45ah0{--height:36px;--multiItemHeight:28px;--multiItemMargin:2px;--multiItemPadding:2px 8px;--multiClearTop:5px;--multiItemBorderRadius:6px;--clearSelectTop:2px;--clearSelectBottom:2px;--indicatorTop:8px;flex:1;display:flex;flex-direction:column;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;background:var(--jse-modal-background);color:var(--jse-text-color)}.jse-modal.svelte-t45ah0 .jse-contents.svelte-t45ah0{padding:20px;overflow:auto}.jse-modal.svelte-t45ah0 .jse-contents .jse-actions.svelte-t45ah0{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding)}.jse-modal.svelte-t45ah0 .jse-contents .jse-actions button.svelte-t45ah0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;background:var(--jse-button-primary-background);color:var(--jse-button-primary-color);padding:var(--jse-padding) calc(2 * var(--jse-padding));border-radius:3px}.jse-modal.svelte-t45ah0 .jse-contents .jse-actions button.svelte-t45ah0:hover{background:var(--jse-button-primary-background-highlight)}.jse-modal.svelte-t45ah0 .jse-contents .jse-actions button.svelte-t45ah0:disabled{background:var(--jse-button-primary-background-disabled)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-modal-overlay-background)}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-content{flex:1;display:flex;max-height:calc(100vh - 6rem);padding:0}.jse-modal.jse-copy-paste.svelte-t45ah0 .jse-shortcuts.svelte-t45ah0{display:flex;flex-wrap:wrap;justify-content:space-around;margin:calc(2 * var(--jse-padding)) 0}.jse-modal.jse-copy-paste.svelte-t45ah0 .jse-shortcuts .jse-shortcut .jse-key.svelte-t45ah0{font-size:200%;color:var(--jse-theme-color)}");
}
function cK(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b, k, w, x, S, T;
  return n = new tM({ props: { title: "Copying and pasting" } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), r = bt(), i = rt("div"), (o = rt("div")).textContent = "These actions are unavailable via the menu. Please use:", a = bt(), s = rt("div"), u = rt("div"), (c = rt("div")).textContent = "".concat(e[1], "+C"), l = Xt(`
        for copy`), f = bt(), h = rt("div"), (d = rt("div")).textContent = "".concat(e[1], "+X"), p = Xt(`
        for cut`), v = bt(), m = rt("div"), (g = rt("div")).textContent = "".concat(e[1], "+V"), y = Xt(`
        for paste`), b = bt(), k = rt("div"), (w = rt("button")).textContent = "Close", A(c, "class", "jse-key svelte-t45ah0"), A(u, "class", "jse-shortcut"), A(d, "class", "jse-key svelte-t45ah0"), A(h, "class", "jse-shortcut"), A(g, "class", "jse-key svelte-t45ah0"), A(m, "class", "jse-shortcut"), A(s, "class", "jse-shortcuts svelte-t45ah0"), A(w, "type", "button"), A(w, "class", "jse-primary svelte-t45ah0"), A(k, "class", "jse-actions svelte-t45ah0"), A(i, "class", "jse-contents svelte-t45ah0"), A(t, "class", "jse-modal jse-copy-paste svelte-t45ah0");
  }, m: function(P, O) {
    pt(P, t, O), Ot(n, t, null), W(t, r), W(t, i), W(i, o), W(i, a), W(i, s), W(s, u), W(u, c), W(u, l), W(s, f), W(s, h), W(h, d), W(h, p), W(s, v), W(s, m), W(m, g), W(m, y), W(i, b), W(i, k), W(k, w), x = !0, S || (T = Nt(w, "click", e[0]), S = !0);
  }, p: Wt, i: function(P) {
    x || (U(n.$$.fragment, P), x = !0);
  }, o: function(P) {
    tt(n.$$.fragment, P), x = !1;
  }, d: function(P) {
    P && vt(t), At(n), S = !1, T();
  } };
}
function lK(e) {
  return [Hr("simple-modal").close, fA ? "\u2318" : "Ctrl"];
}
var fK = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, lK, cK, Ue, {}, uK), i;
  }
  return Y(n);
}();
function hK(e) {
  Te(e, "svelte-gz09vf", ".jse-json-repair-component.svelte-gz09vf.svelte-gz09vf{flex:1;display:flex;flex-direction:column;background:var(--jse-background-color);color:var(--jse-text-color)}.jse-json-repair-component.svelte-gz09vf .jse-menu .jse-info.svelte-gz09vf{padding:0 var(--jse-padding)}.jse-json-repair-component.svelte-gz09vf .jse-json-text.svelte-gz09vf{flex:1;border:none;padding:2px;font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);background:var(--jse-background-color);color:var(--jse-text-color);resize:none;outline:none}");
}
function dK(e) {
  var t;
  return { c: function() {
    (t = rt("div")).textContent = "Repair invalid JSON, then click apply", A(t, "slot", "left"), A(t, "class", "jse-info svelte-gz09vf");
  }, m: function(n, r) {
    pt(n, t, r);
  }, p: Wt, d: function(n) {
    n && vt(t);
  } };
}
function vK(e) {
  var t, n;
  return t = new ss({ props: { type: "success", message: "JSON is valid now and can be parsed.", actions: e[5] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32 & i && (o.actions = r[5]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function pK(e) {
  var t, n;
  return t = new ss({ props: { type: "error", icon: pu, message: "Cannot parse JSON: ".concat(e[2].message), actions: e[6] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    4 & i && (o.message = "Cannot parse JSON: ".concat(r[2].message)), 64 & i && (o.actions = r[6]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function mK(e) {
  var t, n, r, i, o, a, s, u, c, l;
  n = new c0({ props: { items: e[7], $$slots: { left: [dK] }, $$scope: { ctx: e } } });
  var f = [pK, vK], h = [];
  function d(p, v) {
    return p[2] ? 0 : 1;
  }
  return i = d(e), o = h[i] = f[i](e), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), r = bt(), o.c(), a = bt(), (s = rt("textarea")).value = e[0], s.readOnly = e[1], A(s, "class", "jse-json-text svelte-gz09vf"), A(s, "autocomplete", "off"), A(s, "autocapitalize", "off"), A(s, "spellcheck", "false"), A(t, "class", "jse-json-repair-component svelte-gz09vf");
  }, m: function(p, v) {
    pt(p, t, v), Ot(n, t, null), W(t, r), h[i].m(t, null), W(t, a), W(t, s), e[19](s), e[20](t), u = !0, c || (l = Nt(s, "input", e[8]), c = !0);
  }, p: function(p, v) {
    var m = xe(v, 1)[0], g = {};
    128 & m && (g.items = p[7]), 134217728 & m && (g.$$scope = { dirty: m, ctx: p }), n.$set(g);
    var y = i;
    (i = d(p)) === y ? h[i].p(p, m) : (qt(), tt(h[y], 1, 1, function() {
      h[y] = null;
    }), Vt(), (o = h[i]) ? o.p(p, m) : (o = h[i] = f[i](p)).c(), U(o, 1), o.m(t, a)), (!u || 1 & m) && (s.value = p[0]), (!u || 2 & m) && (s.readOnly = p[1]);
  }, i: function(p) {
    u || (U(n.$$.fragment, p), U(o), u = !0);
  }, o: function(p) {
    tt(n.$$.fragment, p), tt(o), u = !1;
  }, d: function(p) {
    p && vt(t), At(n), h[i].d(), e[19](null), e[20](null), c = !1, l();
  } };
}
function gK(e, t, n) {
  var r, i, o, a, s, u, c, l, f, h, d = t.text, p = d === void 0 ? "" : d, v = t.readOnly, m = v !== void 0 && v, g = t.onParse, y = t.onRepair, b = t.onChange, k = b === void 0 ? null : b, w = t.onApply, x = t.onCancel, S = t.onRenderMenu, T = S === void 0 ? Qe : S, P = Ur("jsoneditor:JSONRepair");
  function O() {
    w(p);
  }
  return e.$$set = function(j) {
    "text" in j && n(0, p = j.text), "readOnly" in j && n(1, m = j.readOnly), "onParse" in j && n(9, g = j.onParse), "onRepair" in j && n(10, y = j.onRepair), "onChange" in j && n(11, k = j.onChange), "onApply" in j && n(12, w = j.onApply), "onCancel" in j && n(13, x = j.onCancel), "onRenderMenu" in j && n(14, T = j.onRenderMenu);
  }, e.$$.update = function() {
    1 & e.$$.dirty && n(2, r = function(j) {
      try {
        return g(j), null;
      } catch (V) {
        return rA(j, V.message);
      }
    }(p)), 1 & e.$$.dirty && n(17, i = function(j) {
      try {
        return y(j), !0;
      } catch {
        return !1;
      }
    }(p)), 4 & e.$$.dirty && P("error", r), 8192 & e.$$.dirty && n(18, o = [{ space: !0 }, { icon: Gc, title: "Cancel repair", className: "jse-cancel", onClick: x }]), 278528 & e.$$.dirty && n(7, a = T("repair", o) || o), 229376 & e.$$.dirty && n(6, c = i ? [s, u] : [s]), 2 & e.$$.dirty && n(5, l = [{ icon: pp, text: "Apply", title: "Apply fixed JSON", disabled: m, onClick: O }]);
  }, n(15, s = { icon: aq, text: "Show me", title: "Scroll to the error location", onClick: function() {
    h && r && r.position != null && (h.setSelectionRange(r.position, r.position), setTimeout(function() {
      h.focus();
    }));
  } }), n(16, u = { icon: u0, text: "Auto repair", title: "Automatically repair JSON", onClick: function() {
    try {
      n(0, p = y(p)), k && k(p);
    } catch {
    }
  } }), [p, m, r, f, h, l, c, a, function(j) {
    P("handleChange");
    var V = j.target.value;
    p !== V && (n(0, p = V), k && k(p));
  }, g, y, k, w, x, T, s, u, i, o, function(j) {
    Be[j ? "unshift" : "push"](function() {
      n(4, h = j);
    });
  }, function(j) {
    Be[j ? "unshift" : "push"](function() {
      n(3, f = j);
    });
  }];
}
var yK = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, gK, mK, Ue, { text: 0, readOnly: 1, onParse: 9, onRepair: 10, onChange: 11, onApply: 12, onCancel: 13, onRenderMenu: 14 }, hK), i;
  }
  return Y(n);
}();
function bK(e) {
  Te(e, "svelte-1ffm3pm", ".jse-modal.jse-repair.svelte-1ffm3pm{flex:1;display:flex;flex-direction:column;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;background:var(--jse-background-color);color:var(--jse-text-color)}");
}
function kK(e) {
  var t, n, r, i;
  function o(s) {
    e[7](s);
  }
  var a = { onParse: e[1], onRepair: e[2], onApply: e[4], onCancel: e[5], onRenderMenu: e[3] };
  return e[0] !== void 0 && (a.text = e[0]), n = new yK({ props: a }), Be.push(function() {
    return Kr(n, "text", o);
  }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-modal jse-repair svelte-1ffm3pm");
  }, m: function(s, u) {
    pt(s, t, u), Ot(n, t, null), i = !0;
  }, p: function(s, u) {
    var c = xe(u, 1)[0], l = {};
    2 & c && (l.onParse = s[1]), 4 & c && (l.onRepair = s[2]), 8 & c && (l.onRenderMenu = s[3]), !r && 1 & c && (r = !0, l.text = s[0], di(function() {
      return r = !1;
    })), n.$set(l);
  }, i: function(s) {
    i || (U(n.$$.fragment, s), i = !0);
  }, o: function(s) {
    tt(n.$$.fragment, s), i = !1;
  }, d: function(s) {
    s && vt(t), At(n);
  } };
}
function wK(e, t, n) {
  var r = t.text, i = t.onParse, o = t.onRepair, a = t.onApply, s = t.onRenderMenu, u = Hr("simple-modal").close;
  return e.$$set = function(c) {
    "text" in c && n(0, r = c.text), "onParse" in c && n(1, i = c.onParse), "onRepair" in c && n(2, o = c.onRepair), "onApply" in c && n(6, a = c.onApply), "onRenderMenu" in c && n(3, s = c.onRenderMenu);
  }, [r, i, o, s, function(c) {
    u(), a(c);
  }, function() {
    u();
  }, a, function(c) {
    n(0, r = c);
  }];
}
var xK = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, wK, kK, Ue, { text: 0, onParse: 1, onRepair: 2, onApply: 6, onRenderMenu: 3 }, bK), i;
  }
  return Y(n);
}();
function jK(e) {
  Te(e, "svelte-mojfmz", ".jse-dropdown-button.svelte-mojfmz.svelte-mojfmz{flex:1;line-height:normal;border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;position:relative;padding:0;display:flex}.jse-dropdown-button.svelte-mojfmz ul.svelte-mojfmz{margin:0;padding:0}.jse-dropdown-button.svelte-mojfmz ul li.svelte-mojfmz{margin:0;padding:0;list-style-type:none}.jse-dropdown-button.svelte-mojfmz button.jse-open-dropdown.svelte-mojfmz{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;width:2em;background:var(--jse-context-menu-background);color:var(--jse-context-menu-color);border-radius:0}.jse-dropdown-button.svelte-mojfmz button.jse-open-dropdown.jse-visible.svelte-mojfmz{background:var(--jse-context-menu-background)}.jse-dropdown-button.svelte-mojfmz button.jse-open-dropdown.svelte-mojfmz:hover{background:var(--jse-context-menu-background-highlight)}.jse-dropdown-button.svelte-mojfmz button.jse-open-dropdown.svelte-mojfmz:disabled{color:var(--jse-context-menu-color-disabled);background:unset}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items.svelte-mojfmz{display:none;position:absolute;top:100%;left:0;z-index:1;background:var(--jse-context-menu-background);color:var(--jse-context-menu-color);box-shadow:var(--jse-controls-box-shadow)}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items.jse-visible.svelte-mojfmz{display:block}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items button.svelte-mojfmz{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;width:100%;text-align:left;padding:var(--jse-padding);margin:0}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items button.svelte-mojfmz:hover{background:var(--jse-context-menu-background-highlight)}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items button.svelte-mojfmz:disabled{color:var(--jse-context-menu-color-disabled);background:unset}");
}
function _S(e, t, n) {
  var r = e.slice();
  return r[11] = t[n], r;
}
var SK = function(e) {
  return {};
}, CS = function(e) {
  return {};
};
function OS(e) {
  var t, n;
  return t = new Le({ props: { data: e[11].icon } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.data = r[11].icon), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function AS(e) {
  var t, n, r, i, o, a, s, u, c, l, f = e[11].text + "", h = e[11].icon && OS(e);
  function d() {
    return e[9](e[11]);
  }
  return { c: function() {
    t = rt("li"), n = rt("button"), h && h.c(), r = bt(), i = Xt(f), s = bt(), A(n, "type", "button"), A(n, "title", o = e[11].title), n.disabled = a = e[11].disabled, A(n, "class", "svelte-mojfmz"), A(t, "class", "svelte-mojfmz");
  }, m: function(p, v) {
    pt(p, t, v), W(t, n), h && h.m(n, null), W(n, r), W(n, i), W(t, s), u = !0, c || (l = Nt(n, "click", d), c = !0);
  }, p: function(p, v) {
    (e = p)[11].icon ? h ? (h.p(e, v), 1 & v && U(h, 1)) : ((h = OS(e)).c(), U(h, 1), h.m(n, r)) : h && (qt(), tt(h, 1, 1, function() {
      h = null;
    }), Vt()), (!u || 1 & v) && f !== (f = e[11].text + "") && Ve(i, f), (!u || 1 & v && o !== (o = e[11].title)) && A(n, "title", o), (!u || 1 & v && a !== (a = e[11].disabled)) && (n.disabled = a);
  }, i: function(p) {
    u || (U(h), u = !0);
  }, o: function(p) {
    tt(h), u = !1;
  }, d: function(p) {
    p && vt(t), h && h.d(), c = !1, l();
  } };
}
function $K(e) {
  var t, n, r, i, o, a, s, u, c, l, f = e[8].defaultItem, h = Di(f, e, e[7], CS);
  i = new Le({ props: { data: no } });
  for (var d = e[0], p = [], v = 0; v < d.length; v += 1)
    p[v] = AS(_S(e, d, v));
  var m = function(g) {
    return tt(p[g], 1, 1, function() {
      p[g] = null;
    });
  };
  return { c: function() {
    t = rt("div"), h && h.c(), n = bt(), r = rt("button"), Pt(i.$$.fragment), o = bt(), a = rt("div"), s = rt("ul");
    for (var g = 0; g < p.length; g += 1)
      p[g].c();
    A(r, "type", "button"), A(r, "class", "jse-open-dropdown svelte-mojfmz"), A(r, "data-type", "jse-open-dropdown"), r.disabled = e[4], Ut(r, "jse-visible", e[3]), A(s, "class", "svelte-mojfmz"), A(a, "class", "jse-dropdown-items svelte-mojfmz"), to(a, "width", e[2]), Ut(a, "jse-visible", e[3]), A(t, "class", "jse-dropdown-button svelte-mojfmz"), A(t, "title", e[1]);
  }, m: function(g, y) {
    pt(g, t, y), h && h.m(t, null), W(t, n), W(t, r), Ot(i, r, null), W(t, o), W(t, a), W(a, s);
    for (var b = 0; b < p.length; b += 1)
      p[b].m(s, null);
    u = !0, c || (l = [Nt(r, "click", e[5]), Nt(t, "click", e[6])], c = !0);
  }, p: function(g, y) {
    var b = xe(y, 1)[0];
    if (h && h.p && (!u || 128 & b) && zi(h, f, g, g[7], u ? Li(f, g[7], b, SK) : Bi(g[7]), CS), (!u || 16 & b) && (r.disabled = g[4]), 8 & b && Ut(r, "jse-visible", g[3]), 1 & b) {
      var k;
      for (d = g[0], k = 0; k < d.length; k += 1) {
        var w = _S(g, d, k);
        p[k] ? (p[k].p(w, b), U(p[k], 1)) : (p[k] = AS(w), p[k].c(), U(p[k], 1), p[k].m(s, null));
      }
      for (qt(), k = d.length; k < p.length; k += 1)
        m(k);
      Vt();
    }
    (!u || 4 & b) && to(a, "width", g[2]), 8 & b && Ut(a, "jse-visible", g[3]), (!u || 2 & b) && A(t, "title", g[1]);
  }, i: function(g) {
    if (!u) {
      U(h, g), U(i.$$.fragment, g);
      for (var y = 0; y < d.length; y += 1)
        U(p[y]);
      u = !0;
    }
  }, o: function(g) {
    tt(h, g), tt(i.$$.fragment, g), p = p.filter(Boolean);
    for (var y = 0; y < p.length; y += 1)
      tt(p[y]);
    u = !1;
  }, d: function(g) {
    g && vt(t), h && h.d(g), At(i), Ar(p, g), c = !1, Dn(l);
  } };
}
function _K(e, t, n) {
  var r, i = t.$$slots, o = i === void 0 ? {} : i, a = t.$$scope, s = t.items, u = s === void 0 ? [] : s, c = t.title, l = c === void 0 ? void 0 : c, f = t.width, h = f === void 0 ? "120px" : f, d = !1;
  function p() {
    n(3, d = !1);
  }
  function v(m) {
    vu(m) === "Escape" && (m.preventDefault(), n(3, d = !1));
  }
  return yi(function() {
    document.addEventListener("click", p), document.addEventListener("keydown", v);
  }), Fa(function() {
    document.removeEventListener("click", p), document.removeEventListener("keydown", v);
  }), e.$$set = function(m) {
    "items" in m && n(0, u = m.items), "title" in m && n(1, l = m.title), "width" in m && n(2, h = m.width), "$$scope" in m && n(7, a = m.$$scope);
  }, e.$$.update = function() {
    1 & e.$$.dirty && n(4, r = u.every(function(m) {
      return m.disabled === !0;
    }));
  }, [u, l, h, d, r, function() {
    var m = d;
    setTimeout(function() {
      return n(3, d = !m);
    });
  }, p, a, o, function(m) {
    return m.onClick();
  }];
}
var Ov = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, _K, $K, Ue, { items: 0, title: 1, width: 2 }, jK), i;
  }
  return Y(n);
}(), CK = { prefix: "far", iconName: "clock", icon: [512, 512, [128339, "clock-four"], "f017", "M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"] }, OK = { prefix: "far", iconName: "lightbulb", icon: [384, 512, [128161], "f0eb", "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM192 0C90.02 .3203 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.8 289.2 .0039 192 0zM288.4 260.1c-15.66 17.85-35.04 46.3-49.05 75.89h-94.61c-14.01-29.59-33.39-58.04-49.04-75.88C75.24 236.8 64 206.1 64 175.1C64 113.3 112.1 48.25 191.1 48C262.6 48 320 105.4 320 175.1C320 206.1 308.8 236.8 288.4 260.1zM176 80C131.9 80 96 115.9 96 160c0 8.844 7.156 16 16 16S128 168.8 128 160c0-26.47 21.53-48 48-48c8.844 0 16-7.148 16-15.99S184.8 80 176 80z"] }, kh = { prefix: "far", iconName: "square", icon: [448, 512, [9723, 9724, 61590, 9632], "f0c8", "M384 32C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H384zM384 80H64C55.16 80 48 87.16 48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80z"] }, wh = { prefix: "far", iconName: "square-check", icon: [448, 512, [9989, 61510, 9745, "check-square"], "f14a", "M211.8 339.8C200.9 350.7 183.1 350.7 172.2 339.8L108.2 275.8C97.27 264.9 97.27 247.1 108.2 236.2C119.1 225.3 136.9 225.3 147.8 236.2L192 280.4L300.2 172.2C311.1 161.3 328.9 161.3 339.8 172.2C350.7 183.1 350.7 200.9 339.8 211.8L211.8 339.8zM0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96zM48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80H64C55.16 80 48 87.16 48 96z"] };
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function AK(e) {
  Te(e, "svelte-1yai37q", ".jse-contextmenu.svelte-1yai37q.svelte-1yai37q{box-shadow:var(--jse-controls-box-shadow);font-family:var(--jse-font-family);font-size:var(--jse-font-size);background:var(--jse-context-menu-background);color:var(--jse-context-menu-color)}.jse-contextmenu.svelte-1yai37q button.svelte-1yai37q{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0}.jse-contextmenu.svelte-1yai37q button.svelte-1yai37q:focus{background:var(--jse-context-menu-background-highlight)}.jse-contextmenu.svelte-1yai37q .jse-row.svelte-1yai37q{display:flex;flex-direction:row;align-items:flex-start;justify-content:stretch}.jse-contextmenu.svelte-1yai37q .jse-row div.jse-label.svelte-1yai37q{flex:1;white-space:nowrap;padding:var(--jse-padding);color:var(--jse-context-menu-color-disabled);line-height:normal}.jse-contextmenu.svelte-1yai37q .jse-row div.jse-tip.svelte-1yai37q{flex:1;background:var(--jse-context-menu-tip-background);color:var(--jse-context-menu-tip-color);margin:calc(0.5 * var(--jse-padding));padding:calc(0.5 * var(--jse-padding)) var(--jse-padding);font-size:80%;line-height:1.3em;display:flex;flex-direction:row;align-items:center;gap:var(--jse-padding);border-radius:3px}.jse-contextmenu.svelte-1yai37q .jse-row div.jse-tip div.svelte-1yai37q{vertical-align:middle}.jse-contextmenu.svelte-1yai37q .jse-row button.svelte-1yai37q{flex:1;white-space:nowrap;padding:var(--jse-padding);color:inherit}.jse-contextmenu.svelte-1yai37q .jse-row button.svelte-1yai37q:hover{background:var(--jse-context-menu-background-highlight)}.jse-contextmenu.svelte-1yai37q .jse-row button.svelte-1yai37q:disabled{color:var(--jse-context-menu-color-disabled);background:unset}.jse-contextmenu.svelte-1yai37q .jse-row button .jse-insert.svelte-1yai37q{display:inline-block;position:relative;width:18px;height:18px;font-family:var(--jse-font-family-mono);font-weight:bold;font-size:16px}.jse-contextmenu.svelte-1yai37q .jse-row button .jse-insert .jse-quote.svelte-1yai37q,.jse-contextmenu.svelte-1yai37q .jse-row button .jse-insert .jse-plus.svelte-1yai37q{position:absolute;top:-4px;left:2px;font-size:24px}.jse-contextmenu.svelte-1yai37q .jse-column.svelte-1yai37q{flex:1;display:flex;flex-direction:column;align-items:stretch}.jse-contextmenu.svelte-1yai37q .jse-column.svelte-1yai37q:not(:last-child){border-right:1px solid var(--jse-context-menu-separator-color)}.jse-contextmenu.svelte-1yai37q .jse-column button.svelte-1yai37q{text-align:left;min-width:130px}.jse-contextmenu.svelte-1yai37q .jse-separator.svelte-1yai37q{width:100%;height:1px;background:var(--jse-context-menu-separator-color)}");
}
function PK(e) {
  var t, n, r, i, o, a, s;
  return n = new Le({ props: { data: s0 } }), { c: function() {
    t = rt("button"), Pt(n.$$.fragment), r = Xt(" Edit value"), A(t, "type", "button"), A(t, "slot", "defaultItem"), A(t, "title", "Edit the value (Double-click on the value)"), t.disabled = i = !e[2], A(t, "class", "svelte-1yai37q");
  }, m: function(u, c) {
    pt(u, t, c), Ot(n, t, null), W(t, r), o = !0, a || (s = Nt(t, "click", e[18]), a = !0);
  }, p: function(u, c) {
    (!o || 4 & c[0] && i !== (i = !u[2])) && (t.disabled = i);
  }, i: function(u) {
    o || (U(n.$$.fragment, u), o = !0);
  }, o: function(u) {
    tt(n.$$.fragment, u), o = !1;
  }, d: function(u) {
    u && vt(t), At(n), a = !1, s();
  } };
}
function EK(e) {
  var t, n, r, i, o, a, s;
  return n = new Le({ props: { data: mp } }), { c: function() {
    t = rt("button"), Pt(n.$$.fragment), r = Xt(" Cut"), A(t, "type", "button"), A(t, "slot", "defaultItem"), A(t, "title", "Cut selected contents, formatted with indentation (Ctrl+X)"), t.disabled = i = !e[1], A(t, "class", "svelte-1yai37q");
  }, m: function(u, c) {
    pt(u, t, c), Ot(n, t, null), W(t, r), o = !0, a || (s = Nt(t, "click", e[19]), a = !0);
  }, p: function(u, c) {
    (!o || 2 & c[0] && i !== (i = !u[1])) && (t.disabled = i);
  }, i: function(u) {
    o || (U(n.$$.fragment, u), o = !0);
  }, o: function(u) {
    tt(n.$$.fragment, u), o = !1;
  }, d: function(u) {
    u && vt(t), At(n), a = !1, s();
  } };
}
function MK(e) {
  var t, n, r, i, o, a, s;
  return n = new Le({ props: { data: Ff } }), { c: function() {
    t = rt("button"), Pt(n.$$.fragment), r = Xt(" Copy"), A(t, "type", "button"), A(t, "slot", "defaultItem"), A(t, "title", "Copy selected contents, formatted with indentation (Ctrl+C)"), t.disabled = i = !e[1], A(t, "class", "svelte-1yai37q");
  }, m: function(u, c) {
    pt(u, t, c), Ot(n, t, null), W(t, r), o = !0, a || (s = Nt(t, "click", e[20]), a = !0);
  }, p: function(u, c) {
    (!o || 2 & c[0] && i !== (i = !u[1])) && (t.disabled = i);
  }, i: function(u) {
    o || (U(n.$$.fragment, u), o = !0);
  }, o: function(u) {
    tt(n.$$.fragment, u), o = !1;
  }, d: function(u) {
    u && vt(t), At(n), a = !1, s();
  } };
}
function PS(e) {
  var t, n, r, i, o, a, s;
  return i = new Le({ props: { data: OK } }), { c: function() {
    t = rt("div"), n = rt("div"), r = rt("div"), Pt(i.$$.fragment), o = bt(), (a = rt("div")).textContent = "Tip: you can open this context menu via right-click or with Ctrl+Q", A(r, "class", "svelte-1yai37q"), A(a, "class", "svelte-1yai37q"), A(n, "class", "jse-tip svelte-1yai37q"), A(t, "class", "jse-row svelte-1yai37q");
  }, m: function(u, c) {
    pt(u, t, c), W(t, n), W(n, r), Ot(i, r, null), W(n, o), W(n, a), s = !0;
  }, p: Wt, i: function(u) {
    s || (U(i.$$.fragment, u), s = !0);
  }, o: function(u) {
    tt(i.$$.fragment, u), s = !1;
  }, d: function(u) {
    u && vt(t), At(i);
  } };
}
function TK(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b, k, w, x, S, T, P, O, j, V, E, C, H, X, F, G, M, $, q, B, D, _, L, J, st, ht, xt, kt, I, R, it, N, K, z, at, yt, jt, Ft, zt, St, Gt, _e, Fe, fn, De, $t, oe, Ce, sn, vn, nt, ct, lt, wt, Rt, Bt, ee, ie, gt, Kt, ae, Yt, se, Ae, me, Se, Oe, Ee, kn, Yn, It, un, hn, tn, on, an, oi, Hi;
  i = new Le({ props: { data: s0 } }), u = new Ov({ props: { width: "11em", items: e[8], $$slots: { defaultItem: [PK] }, $$scope: { ctx: e } } }), d = new Ov({ props: { width: "10em", items: e[7], $$slots: { defaultItem: [EK] }, $$scope: { ctx: e } } }), v = new Ov({ props: { width: "12em", items: e[6], $$slots: { defaultItem: [MK] }, $$scope: { ctx: e } } }), y = new Le({ props: { data: vq } }), j = new Le({ props: { data: Gc } }), X = new Le({ props: { data: lq } }), q = new Le({ props: { data: fq } }), J = new Le({ props: { data: i0 } }), I = new Le({ props: { data: o0 } }), Oe = new Le({ props: { data: mq } }), un = new Le({ props: { data: pq } });
  var wn = e[0] && PS();
  return { c: function() {
    t = rt("div"), n = rt("div"), r = rt("button"), Pt(i.$$.fragment), o = Xt(" Edit key"), s = bt(), Pt(u.$$.fragment), c = bt(), l = rt("div"), f = bt(), h = rt("div"), Pt(d.$$.fragment), p = bt(), Pt(v.$$.fragment), m = bt(), g = rt("button"), Pt(y.$$.fragment), b = Xt(" Paste"), w = bt(), x = rt("div"), S = bt(), T = rt("div"), P = rt("div"), O = rt("button"), Pt(j.$$.fragment), V = Xt(" Remove"), C = bt(), H = rt("button"), Pt(X.$$.fragment), F = Xt(" Duplicate"), M = bt(), $ = rt("button"), Pt(q.$$.fragment), B = Xt(" Extract"), _ = bt(), L = rt("button"), Pt(J.$$.fragment), st = Xt(" Sort"), xt = bt(), kt = rt("button"), Pt(I.$$.fragment), R = Xt(" Transform"), N = bt(), K = rt("div"), z = rt("div"), at = Xt(e[13]), yt = Xt(":"), jt = bt(), Ft = rt("button"), zt = rt("span"), (St = rt("span")).textContent = "+", Gt = Xt(" Structure"), fn = bt(), De = rt("button"), ($t = rt("span")).textContent = "{}", oe = Xt(" Object"), vn = bt(), nt = rt("button"), (ct = rt("span")).textContent = "[]", lt = Xt(" Array"), Bt = bt(), ee = rt("button"), (ie = rt("span")).innerHTML = '<span class="jse-quote svelte-1yai37q">&quot;</span>', gt = Xt(" Value"), Yt = bt(), se = rt("div"), Ae = bt(), me = rt("div"), Se = rt("button"), Pt(Oe.$$.fragment), Ee = Xt(" Insert before"), Yn = bt(), It = rt("button"), Pt(un.$$.fragment), hn = Xt(" Insert after"), on = bt(), wn && wn.c(), A(r, "type", "button"), A(r, "title", "Edit the key (Double-click on the key)"), r.disabled = a = !e[14], A(r, "class", "svelte-1yai37q"), A(n, "class", "jse-row svelte-1yai37q"), A(l, "class", "jse-separator svelte-1yai37q"), A(g, "type", "button"), A(g, "title", "Paste clipboard contents (Ctrl+V)"), g.disabled = k = !e[3], A(g, "class", "svelte-1yai37q"), A(h, "class", "jse-row svelte-1yai37q"), A(x, "class", "jse-separator svelte-1yai37q"), A(O, "type", "button"), A(O, "title", "Remove selected contents (Delete)"), O.disabled = E = !e[1], A(O, "class", "svelte-1yai37q"), A(H, "type", "button"), A(H, "title", "Duplicate selected contents (Ctrl+D)"), H.disabled = G = !e[16], A(H, "class", "svelte-1yai37q"), A($, "type", "button"), A($, "title", "Extract selected contents"), $.disabled = D = !e[15], A($, "class", "svelte-1yai37q"), A(L, "type", "button"), A(L, "title", "Sort array or object contents"), L.disabled = ht = !e[1], A(L, "class", "svelte-1yai37q"), A(kt, "type", "button"), A(kt, "title", "Transform array or object contents (filter, sort, project)"), kt.disabled = it = !e[1], A(kt, "class", "svelte-1yai37q"), A(P, "class", "jse-column svelte-1yai37q"), A(z, "class", "jse-label svelte-1yai37q"), A(St, "class", "jse-plus svelte-1yai37q"), A(zt, "class", "jse-insert svelte-1yai37q"), A(Ft, "type", "button"), A(Ft, "title", _e = e[13] + " structure"), Ft.disabled = Fe = !e[12], A(Ft, "class", "svelte-1yai37q"), A($t, "class", "jse-insert svelte-1yai37q"), A(De, "type", "button"), A(De, "title", Ce = e[13] + " object"), De.disabled = sn = !e[11], A(De, "class", "svelte-1yai37q"), A(ct, "class", "jse-insert svelte-1yai37q"), A(nt, "type", "button"), A(nt, "title", wt = e[13] + " array"), nt.disabled = Rt = !e[10], A(nt, "class", "svelte-1yai37q"), A(ie, "class", "jse-insert svelte-1yai37q"), A(ee, "type", "button"), A(ee, "title", Kt = e[13] + " value"), ee.disabled = ae = !e[9], A(ee, "class", "svelte-1yai37q"), A(K, "class", "jse-column svelte-1yai37q"), A(T, "class", "jse-row svelte-1yai37q"), A(se, "class", "jse-separator svelte-1yai37q"), A(Se, "type", "button"), A(Se, "title", "Select area before current entry to insert or paste contents"), Se.disabled = kn = !e[1] || e[4], A(Se, "class", "svelte-1yai37q"), A(It, "type", "button"), A(It, "title", "Select area after current entry to insert or paste contents"), It.disabled = tn = !e[1] || e[4], A(It, "class", "svelte-1yai37q"), A(me, "class", "jse-row svelte-1yai37q"), A(t, "class", "jse-contextmenu svelte-1yai37q");
  }, m: function(re, Ie) {
    pt(re, t, Ie), W(t, n), W(n, r), Ot(i, r, null), W(r, o), W(n, s), Ot(u, n, null), W(t, c), W(t, l), W(t, f), W(t, h), Ot(d, h, null), W(h, p), Ot(v, h, null), W(h, m), W(h, g), Ot(y, g, null), W(g, b), W(t, w), W(t, x), W(t, S), W(t, T), W(T, P), W(P, O), Ot(j, O, null), W(O, V), W(P, C), W(P, H), Ot(X, H, null), W(H, F), W(P, M), W(P, $), Ot(q, $, null), W($, B), W(P, _), W(P, L), Ot(J, L, null), W(L, st), W(P, xt), W(P, kt), Ot(I, kt, null), W(kt, R), W(T, N), W(T, K), W(K, z), W(z, at), W(z, yt), W(K, jt), W(K, Ft), W(Ft, zt), W(zt, St), W(Ft, Gt), W(K, fn), W(K, De), W(De, $t), W(De, oe), W(K, vn), W(K, nt), W(nt, ct), W(nt, lt), W(K, Bt), W(K, ee), W(ee, ie), W(ee, gt), W(t, Yt), W(t, se), W(t, Ae), W(t, me), W(me, Se), Ot(Oe, Se, null), W(Se, Ee), W(me, Yn), W(me, It), Ot(un, It, null), W(It, hn), W(t, on), wn && wn.m(t, null), e[58](t), an = !0, oi || (Hi = [Nt(r, "click", e[17]), Nt(g, "click", e[21]), Nt(O, "click", e[22]), Nt(H, "click", e[23]), Nt($, "click", e[24]), Nt(L, "click", e[26]), Nt(kt, "click", e[27]), Nt(Ft, "click", e[54]), Nt(De, "click", e[55]), Nt(nt, "click", e[56]), Nt(ee, "click", e[57]), Nt(Se, "click", e[28]), Nt(It, "click", e[29]), Nt(t, "keydown", e[30])], oi = !0);
  }, p: function(re, Ie) {
    (!an || 16384 & Ie[0] && a !== (a = !re[14])) && (r.disabled = a);
    var ai = {};
    256 & Ie[0] && (ai.items = re[8]), 4 & Ie[0] | 1 & Ie[2] && (ai.$$scope = { dirty: Ie, ctx: re }), u.$set(ai);
    var xi = {};
    128 & Ie[0] && (xi.items = re[7]), 2 & Ie[0] | 1 & Ie[2] && (xi.$$scope = { dirty: Ie, ctx: re }), d.$set(xi);
    var Pr = {};
    64 & Ie[0] && (Pr.items = re[6]), 2 & Ie[0] | 1 & Ie[2] && (Pr.$$scope = { dirty: Ie, ctx: re }), v.$set(Pr), (!an || 8 & Ie[0] && k !== (k = !re[3])) && (g.disabled = k), (!an || 2 & Ie[0] && E !== (E = !re[1])) && (O.disabled = E), (!an || 65536 & Ie[0] && G !== (G = !re[16])) && (H.disabled = G), (!an || 32768 & Ie[0] && D !== (D = !re[15])) && ($.disabled = D), (!an || 2 & Ie[0] && ht !== (ht = !re[1])) && (L.disabled = ht), (!an || 2 & Ie[0] && it !== (it = !re[1])) && (kt.disabled = it), (!an || 8192 & Ie[0]) && Ve(at, re[13]), (!an || 8192 & Ie[0] && _e !== (_e = re[13] + " structure")) && A(Ft, "title", _e), (!an || 4096 & Ie[0] && Fe !== (Fe = !re[12])) && (Ft.disabled = Fe), (!an || 8192 & Ie[0] && Ce !== (Ce = re[13] + " object")) && A(De, "title", Ce), (!an || 2048 & Ie[0] && sn !== (sn = !re[11])) && (De.disabled = sn), (!an || 8192 & Ie[0] && wt !== (wt = re[13] + " array")) && A(nt, "title", wt), (!an || 1024 & Ie[0] && Rt !== (Rt = !re[10])) && (nt.disabled = Rt), (!an || 8192 & Ie[0] && Kt !== (Kt = re[13] + " value")) && A(ee, "title", Kt), (!an || 512 & Ie[0] && ae !== (ae = !re[9])) && (ee.disabled = ae), (!an || 18 & Ie[0] && kn !== (kn = !re[1] || re[4])) && (Se.disabled = kn), (!an || 18 & Ie[0] && tn !== (tn = !re[1] || re[4])) && (It.disabled = tn), re[0] ? wn ? (wn.p(re, Ie), 1 & Ie[0] && U(wn, 1)) : ((wn = PS()).c(), U(wn, 1), wn.m(t, null)) : wn && (qt(), tt(wn, 1, 1, function() {
      wn = null;
    }), Vt());
  }, i: function(re) {
    an || (U(i.$$.fragment, re), U(u.$$.fragment, re), U(d.$$.fragment, re), U(v.$$.fragment, re), U(y.$$.fragment, re), U(j.$$.fragment, re), U(X.$$.fragment, re), U(q.$$.fragment, re), U(J.$$.fragment, re), U(I.$$.fragment, re), U(Oe.$$.fragment, re), U(un.$$.fragment, re), U(wn), an = !0);
  }, o: function(re) {
    tt(i.$$.fragment, re), tt(u.$$.fragment, re), tt(d.$$.fragment, re), tt(v.$$.fragment, re), tt(y.$$.fragment, re), tt(j.$$.fragment, re), tt(X.$$.fragment, re), tt(q.$$.fragment, re), tt(J.$$.fragment, re), tt(I.$$.fragment, re), tt(Oe.$$.fragment, re), tt(un.$$.fragment, re), tt(wn), an = !1;
  }, d: function(re) {
    re && vt(t), At(i), At(u), At(d), At(v), At(y), At(j), At(X), At(q), At(J), At(I), At(Oe), At(un), wn && wn.d(), e[58](null), oi = !1, Dn(Hi);
  } };
}
function IK(e, t, n) {
  var r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b, k, w, x, S, T = t.json, P = t.documentState, O = t.showTip, j = t.onCloseContextMenu, V = t.onEditKey, E = t.onEditValue, C = t.onToggleEnforceString, H = t.onCut, X = t.onCopy, F = t.onPaste, G = t.onRemove, M = t.onDuplicate, $ = t.onExtract, q = t.onInsertBefore, B = t.onInsert, D = t.onConvert, _ = t.onInsertAfter, L = t.onSort, J = t.onTransform;
  function st() {
    j(), E();
  }
  function ht() {
    j(), C();
  }
  function xt() {
    j(), H(!0);
  }
  function kt() {
    j(), H(!1);
  }
  function I() {
    j(), X(!0);
  }
  function R() {
    j(), X(!1);
  }
  function it(N) {
    j(), u ? D(N) : B(N);
  }
  return yi(function() {
    setTimeout(function() {
      var N = Pe(S.querySelectorAll("button")).find(function(K) {
        return !K.disabled;
      });
      N && N.focus();
    });
  }), e.$$set = function(N) {
    "json" in N && n(31, T = N.json), "documentState" in N && n(32, P = N.documentState), "showTip" in N && n(0, O = N.showTip), "onCloseContextMenu" in N && n(33, j = N.onCloseContextMenu), "onEditKey" in N && n(34, V = N.onEditKey), "onEditValue" in N && n(35, E = N.onEditValue), "onToggleEnforceString" in N && n(36, C = N.onToggleEnforceString), "onCut" in N && n(37, H = N.onCut), "onCopy" in N && n(38, X = N.onCopy), "onPaste" in N && n(39, F = N.onPaste), "onRemove" in N && n(40, G = N.onRemove), "onDuplicate" in N && n(41, M = N.onDuplicate), "onExtract" in N && n(42, $ = N.onExtract), "onInsertBefore" in N && n(43, q = N.onInsertBefore), "onInsert" in N && n(44, B = N.onInsert), "onConvert" in N && n(45, D = N.onConvert), "onInsertAfter" in N && n(46, _ = N.onInsertAfter), "onSort" in N && n(47, L = N.onSort), "onTransform" in N && n(48, J = N.onTransform);
  }, e.$$.update = function() {
    2 & e.$$.dirty[1] && n(50, r = P.selection), 1 & e.$$.dirty[1] && n(53, i = T !== void 0), 524288 & e.$$.dirty[1] && n(3, o = r != null), 8 & e.$$.dirty[0] | 524288 & e.$$.dirty[1] && n(4, a = o && _n(r.focusPath)), 8 & e.$$.dirty[0] | 524289 & e.$$.dirty[1] && n(51, s = o ? mt.exports.getIn(T, r.focusPath) : void 0), 4718592 & e.$$.dirty[1] && n(1, u = i && (nn(r) || Xn(r) || en(r))), 18 & e.$$.dirty[0] | 4194304 & e.$$.dirty[1] && n(16, c = i && u && !a), 16 & e.$$.dirty[0] | 4718592 & e.$$.dirty[1] && n(15, l = i && r != null && (nn(r) || en(r)) && !a), 16 & e.$$.dirty[0] | 4718593 & e.$$.dirty[1] && n(14, f = i && r != null && mm(r) && !a && !Array.isArray(mt.exports.getIn(T, Ge(r.focusPath)))), 5767168 & e.$$.dirty[1] && n(2, h = i && r != null && mm(r) && !ur(s)), 2 & e.$$.dirty[0] && n(52, d = u), 2097152 & e.$$.dirty[1] && n(13, p = d ? "Convert to" : "Insert"), 8 & e.$$.dirty[0] | 2097152 & e.$$.dirty[1] && n(12, v = !d && o), 8 & e.$$.dirty[0] | 3670016 & e.$$.dirty[1] && n(11, m = d ? gf(r) && !mr(s) : o), 8 & e.$$.dirty[0] | 3670016 & e.$$.dirty[1] && n(10, g = d ? gf(r) && !Array.isArray(s) : o), 8 & e.$$.dirty[0] | 3670016 & e.$$.dirty[1] && n(9, y = d ? gf(r) && ur(s) : o), 1572866 & e.$$.dirty[1] && n(49, b = r != null && rl(s, P.enforceStringMap, mt.exports.compileJSONPointer(r.focusPath))), 4 & e.$$.dirty[0] | 262144 & e.$$.dirty[1] && n(8, k = [{ icon: s0, text: "Edit value", title: "Edit the value (Double-click on the value)", onClick: st, disabled: !h }, { icon: b ? wh : kh, text: "Enforce string", title: "Enforce keeping the value as string when it contains a numeric value", onClick: ht, disabled: !h }]), 2 & e.$$.dirty[0] && n(7, w = [{ icon: mp, text: "Cut formatted", title: "Cut selected contents, formatted with indentation (Ctrl+X)", onClick: xt, disabled: !u }, { icon: mp, text: "Cut compacted", title: "Cut selected contents, without indentation (Ctrl+Shift+X)", onClick: kt, disabled: !u }]), 2 & e.$$.dirty[0] && n(6, x = [{ icon: Ff, text: "Copy formatted", title: "Copy selected contents, formatted with indentation (Ctrl+C)", onClick: I, disabled: !u }, { icon: Ff, text: "Copy compacted", title: "Copy selected contents, without indentation (Ctrl+Shift+C)", onClick: R, disabled: !u }]);
  }, [O, u, h, o, a, S, x, w, k, y, g, m, v, p, f, l, c, function() {
    j(), V();
  }, st, xt, I, function() {
    j(), F();
  }, function() {
    j(), G();
  }, function() {
    j(), M();
  }, function() {
    j(), $();
  }, it, function() {
    j(), L();
  }, function() {
    j(), J();
  }, function() {
    j(), q();
  }, function() {
    j(), _();
  }, function(N) {
    var K = vu(N).replace(/^Command\+/, "Ctrl+");
    if (K === "Up" || K === "Down" || K === "Left" || K === "Right") {
      N.preventDefault();
      var z = GF({ allElements: Array.from(S.querySelectorAll("button:not([disabled])")), currentElement: N.target, direction: K, hasPrio: function(at) {
        return at.getAttribute("data-type") !== "jse-open-dropdown";
      } });
      z && z.focus();
    }
  }, T, P, j, V, E, C, H, X, F, G, M, $, q, B, D, _, L, J, b, r, s, d, i, function() {
    return it("structure");
  }, function() {
    return it("object");
  }, function() {
    return it("array");
  }, function() {
    return it("value");
  }, function(N) {
    Be[N ? "unshift" : "push"](function() {
      n(5, S = N);
    });
  }];
}
var NK = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, IK, TK, Ue, { json: 31, documentState: 32, showTip: 0, onCloseContextMenu: 33, onEditKey: 34, onEditValue: 35, onToggleEnforceString: 36, onCut: 37, onCopy: 38, onPaste: 39, onRemove: 40, onDuplicate: 41, onExtract: 42, onInsertBefore: 43, onInsert: 44, onConvert: 45, onInsertAfter: 46, onSort: 47, onTransform: 48 }, AK, [-1, -1, -1]), i;
  }
  return Y(n);
}(), eM = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = ne(o);
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object")
            if (o.toString === Object.prototype.toString)
              for (var u in o)
                t.call(o, u) && o[u] && r.push(u);
            else
              r.push(o.toString());
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(eM);
var Xs = eM.exports;
function RK(e) {
  Te(e, "svelte-1knbf5w", "div.jse-collapsed-items.svelte-1knbf5w.svelte-1knbf5w{font-family:var(--jse-font-family);font-size:var(--jse-font-size);color:var(--jse-collapsed-items-link-color);padding:calc(0.5 * var(--jse-padding));border:8px solid transparent;border-width:8px 0;background-color:transparent;background-image:linear-gradient(var(--jse-collapsed-items-background-color), var(--jse-collapsed-items-background-color)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-background-color) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-background-color) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-background-color) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-background-color) 50.5%);background-repeat:repeat, repeat-x, repeat-x, repeat-x, repeat-x;background-position:0 0, 8px 0, 8px 0, 8px 100%, 8px 100%;background-size:auto auto, 16px 16px, 16px 16px, 16px 16px, 16px 16px;background-clip:padding-box, border-box, border-box, border-box, border-box;background-origin:padding-box, border-box, border-box, border-box, border-box;display:flex}div.jse-collapsed-items.svelte-1knbf5w div.jse-text.svelte-1knbf5w,div.jse-collapsed-items.svelte-1knbf5w button.jse-expand-items.svelte-1knbf5w{margin:0 calc(0.5 * var(--jse-padding))}div.jse-collapsed-items.svelte-1knbf5w div.jse-text.svelte-1knbf5w{display:inline}div.jse-collapsed-items.svelte-1knbf5w button.jse-expand-items.svelte-1knbf5w{font-family:inherit;font-size:inherit;color:var(--jse-collapsed-items-link-color);background:none;border:none;padding:0;text-decoration:underline;cursor:pointer}div.jse-collapsed-items.svelte-1knbf5w button.jse-expand-items.svelte-1knbf5w:hover,div.jse-collapsed-items.svelte-1knbf5w button.jse-expand-items.svelte-1knbf5w:focus{color:var(--jse-collapsed-items-link-color-highlight)}");
}
function ES(e, t, n) {
  var r = e.slice();
  return r[13] = t[n], r;
}
function MS(e) {
  var t, n, r, i, o, a, s, u, c = e[13].start + "", l = e[13].end + "";
  function f() {
    return e[12](e[13]);
  }
  return { c: function() {
    t = rt("button"), n = Xt("show "), r = Xt(c), i = Xt("-"), o = Xt(l), a = bt(), A(t, "type", "button"), A(t, "class", "jse-expand-items svelte-1knbf5w");
  }, m: function(h, d) {
    pt(h, t, d), W(t, n), W(t, r), W(t, i), W(t, o), W(t, a), s || (u = Nt(t, "click", f), s = !0);
  }, p: function(h, d) {
    e = h, 16 & d && c !== (c = e[13].start + "") && Ve(r, c), 16 & d && l !== (l = e[13].end + "") && Ve(o, l);
  }, d: function(h) {
    h && vt(t), s = !1, u();
  } };
}
function DK(e) {
  for (var t, n, r, i, o, a, s, u, c, l, f, h = e[4], d = [], p = 0; p < h.length; p += 1)
    d[p] = MS(ES(e, h, p));
  return { c: function() {
    t = rt("div"), n = rt("div"), r = rt("div"), i = Xt("Items "), o = Xt(e[3]), a = Xt("-"), s = Xt(e[2]), u = bt();
    for (var v = 0; v < d.length; v += 1)
      d[v].c();
    A(r, "class", "jse-text svelte-1knbf5w"), A(t, "class", "jse-collapsed-items svelte-1knbf5w"), A(t, "style", c = TS(e[0].length + 2)), Ut(t, "jse-selected", e[5]);
  }, m: function(v, m) {
    pt(v, t, m), W(t, n), W(n, r), W(r, i), W(r, o), W(r, a), W(r, s), W(n, u);
    for (var g = 0; g < d.length; g += 1)
      d[g].m(n, null);
    l || (f = Nt(t, "mousemove", LK), l = !0);
  }, p: function(v, m) {
    var g = xe(m, 1)[0];
    if (8 & g && Ve(o, v[3]), 4 & g && Ve(s, v[2]), 19 & g) {
      var y;
      for (h = v[4], y = 0; y < h.length; y += 1) {
        var b = ES(v, h, y);
        d[y] ? d[y].p(b, g) : (d[y] = MS(b), d[y].c(), d[y].m(n, null));
      }
      for (; y < d.length; y += 1)
        d[y].d(1);
      d.length = h.length;
    }
    1 & g && c !== (c = TS(v[0].length + 2)) && A(t, "style", c), 32 & g && Ut(t, "jse-selected", v[5]);
  }, i: Wt, o: Wt, d: function(v) {
    v && vt(t), Ar(d, v), l = !1, f();
  } };
}
function TS(e) {
  return "margin-left: calc(".concat(e, " * var(--jse-indent-size))");
}
function LK(e) {
  e.stopPropagation();
}
function zK(e, t, n) {
  var r, i, o, a, s, u = t.visibleSections, c = t.sectionIndex, l = t.total, f = t.path, h = t.pointer, d = t.selection, p = t.onExpandSection;
  return e.$$set = function(v) {
    "visibleSections" in v && n(6, u = v.visibleSections), "sectionIndex" in v && n(7, c = v.sectionIndex), "total" in v && n(8, l = v.total), "path" in v && n(0, f = v.path), "pointer" in v && n(9, h = v.pointer), "selection" in v && n(10, d = v.selection), "onExpandSection" in v && n(1, p = v.onExpandSection);
  }, e.$$.update = function() {
    192 & e.$$.dirty && n(11, r = u[c]), 2048 & e.$$.dirty && n(3, i = r.end), 448 & e.$$.dirty && n(2, o = u[c + 1] ? u[c + 1].start : l), 1544 & e.$$.dirty && n(5, a = !!nn(d) && d.pointersMap[mt.exports.appendToJSONPointer(h, i)] === !0), 12 & e.$$.dirty && n(4, s = function(v, m) {
      var g = { start: v, end: Math.min(vm(v), m) }, y = Math.max(yh((v + m) / 2), v), b = { start: y, end: Math.min(vm(y), m) }, k = yh(m), w = k === m ? k - 100 : k, x = { start: Math.max(w, v), end: m }, S = [g], T = b.start >= g.end && b.end <= x.start;
      return T && S.push(b), x.start >= (T ? b.end : g.end) && S.push(x), S;
    }(i, o));
  }, [f, p, o, i, s, a, u, c, l, h, d, r, function(v) {
    return p(f, v);
  }];
}
var BK = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, zK, DK, Ue, { visibleSections: 6, sectionIndex: 7, total: 8, path: 0, pointer: 9, selection: 10, onExpandSection: 1 }, RK), i;
  }
  return Y(n);
}();
function FK(e) {
  Te(e, "svelte-dol684", ".jse-context-menu-button.svelte-dol684{position:absolute;top:calc(-0.5 * var(--jse-context-menu-button-size));right:calc(-0.5 * var(--jse-context-menu-button-size));width:var(--jse-context-menu-button-size);height:var(--jse-context-menu-button-size);padding:0;margin:0;z-index:2;cursor:pointer;background:transparent;border-radius:2px;background:var(--jse-context-menu-button-background);color:var(--jse-context-menu-button-color);border:none;box-shadow:var(--jse-controls-box-shadow)}.jse-context-menu-button.svelte-dol684:hover{background:var(--jse-context-menu-button-background-highlight)}");
}
function qK(e) {
  var t, n, r, i, o;
  return n = new Le({ props: { data: no } }), { c: function() {
    t = rt("button"), Pt(n.$$.fragment), A(t, "type", "button"), A(t, "class", "jse-context-menu-button svelte-dol684"), A(t, "title", _C), Ut(t, "jse-selected", e[0]);
  }, m: function(a, s) {
    pt(a, t, s), Ot(n, t, null), r = !0, i || (o = Nt(t, "click", e[1]), i = !0);
  }, p: function(a, s) {
    1 & xe(s, 1)[0] && Ut(t, "jse-selected", a[0]);
  }, i: function(a) {
    r || (U(n.$$.fragment, a), r = !0);
  }, o: function(a) {
    tt(n.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && vt(t), At(n), i = !1, o();
  } };
}
function VK(e, t, n) {
  var r = t.selected, i = t.onContextMenu;
  return e.$$set = function(o) {
    "selected" in o && n(0, r = o.selected), "onContextMenu" in o && n(2, i = o.onContextMenu);
  }, [r, function(o) {
    for (var a = o.target; a && a.nodeName !== "BUTTON"; )
      a = a.parentNode;
    a && i({ anchor: a, left: 0, top: 0, width: 260, height: 336, offsetTop: 2, offsetLeft: 0, showTip: !0 });
  }, i];
}
var us = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, VK, qK, Ue, { selected: 0, onContextMenu: 2 }, FK), i;
  }
  return Y(n);
}();
function HK(e) {
  Te(e, "svelte-s6kbew", ".jse-highlight.svelte-s6kbew{background-color:var(--jse-search-match-color);outline:var(--jse-search-match-outline)}.jse-highlight.jse-active.svelte-s6kbew{background-color:var(--jse-search-match-active-color);outline:var(--jse-search-match-active-outline)}");
}
function IS(e, t, n) {
  var r = e.slice();
  return r[3] = t[n], r;
}
function WK(e) {
  var t, n, r = Va(e[3].text) + "";
  return { c: function() {
    t = rt("span"), n = Xt(r), A(t, "class", "jse-highlight svelte-s6kbew"), Ut(t, "jse-active", e[3].active);
  }, m: function(i, o) {
    pt(i, t, o), W(t, n);
  }, p: function(i, o) {
    1 & o && r !== (r = Va(i[3].text) + "") && Ve(n, r), 1 & o && Ut(t, "jse-active", i[3].active);
  }, d: function(i) {
    i && vt(t);
  } };
}
function UK(e) {
  var t, n = e[3].text + "";
  return { c: function() {
    t = Xt(n);
  }, m: function(r, i) {
    pt(r, t, i);
  }, p: function(r, i) {
    1 & i && n !== (n = r[3].text + "") && Ve(t, n);
  }, d: function(r) {
    r && vt(t);
  } };
}
function NS(e) {
  var t;
  function n(o, a) {
    return o[3].type === "normal" ? UK : WK;
  }
  var r = n(e), i = r(e);
  return { c: function() {
    i.c(), t = Ye();
  }, m: function(o, a) {
    i.m(o, a), pt(o, t, a);
  }, p: function(o, a) {
    r === (r = n(o)) && i ? i.p(o, a) : (i.d(1), (i = r(o)) && (i.c(), i.m(t.parentNode, t)));
  }, d: function(o) {
    i.d(o), o && vt(t);
  } };
}
function JK(e) {
  for (var t, n = e[0], r = [], i = 0; i < n.length; i += 1)
    r[i] = NS(IS(e, n, i));
  return { c: function() {
    for (var o = 0; o < r.length; o += 1)
      r[o].c();
    t = Ye();
  }, m: function(o, a) {
    for (var s = 0; s < r.length; s += 1)
      r[s].m(o, a);
    pt(o, t, a);
  }, p: function(o, a) {
    var s = xe(a, 1)[0];
    if (1 & s) {
      var u;
      for (n = o[0], u = 0; u < n.length; u += 1) {
        var c = IS(o, n, u);
        r[u] ? r[u].p(c, s) : (r[u] = NS(c), r[u].c(), r[u].m(t.parentNode, t));
      }
      for (; u < r.length; u += 1)
        r[u].d(1);
      r.length = n.length;
    }
  }, i: Wt, o: Wt, d: function(o) {
    Ar(r, o), o && vt(t);
  } };
}
function KK(e, t, n) {
  var r, i = t.text, o = t.searchResultItems;
  return e.$$set = function(a) {
    "text" in a && n(1, i = a.text), "searchResultItems" in a && n(2, o = a.searchResultItems);
  }, e.$$.update = function() {
    6 & e.$$.dirty && n(0, r = function(a, s) {
      var u, c = [], l = 0, f = ut(s);
      try {
        for (f.s(); !(u = f.n()).done; ) {
          var h = u.value, d = a.slice(l, h.start);
          d !== "" && c.push({ type: "normal", text: d, active: !1 });
          var p = a.slice(h.start, h.end);
          c.push({ type: "highlight", text: p, active: h.active }), l = h.end;
        }
      } catch (m) {
        f.e(m);
      } finally {
        f.f();
      }
      var v = ve(s);
      return v.end < a.length && c.push({ type: "normal", text: a.slice(v.end), active: !1 }), c;
    }(String(i), o));
  }, [r, i, o];
}
var nM = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, KK, JK, ir, { text: 1, searchResultItems: 2 }, HK), i;
  }
  return Y(n);
}();
function GK(e) {
  Te(e, "svelte-rw77oa", ".jse-value.jse-string.svelte-rw77oa{color:var(--jse-value-color-string)}.jse-value.jse-object.svelte-rw77oa,.jse-value.jse-array.svelte-rw77oa{min-width:16px;color:var(--jse-delimiter-color)}.jse-value.jse-number.svelte-rw77oa{color:var(--jse-value-color-number)}.jse-value.jse-boolean.svelte-rw77oa{color:var(--jse-value-color-boolean)}.jse-value.jse-null.svelte-rw77oa{color:var(--jse-value-color-null)}.jse-value.jse-invalid.svelte-rw77oa{color:var(--jse-text-color)}.jse-value.jse-url.svelte-rw77oa{color:var(--jse-value-color-url);text-decoration:underline}div.jse-editable-div.svelte-rw77oa{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;word-break:normal;white-space:pre-wrap;overflow-wrap:anywhere}div.jse-editable-div.jse-short-text.svelte-rw77oa{overflow-wrap:normal}div.jse-editable-div[contenteditable=true].svelte-rw77oa{outline:var(--jse-edit-outline);background:inherit !important;position:relative;border-radius:0;z-index:3}div.jse-editable-div.jse-empty.svelte-rw77oa:not(:focus){outline:1px dotted var(--jse-tag-background);-moz-outline-radius:2px}div.jse-editable-div.jse-empty.svelte-rw77oa::after{pointer-events:none;color:var(--jse-tag-background)}");
}
function QK(e) {
  var t, n, r, i;
  return { c: function() {
    A(t = rt("div"), "class", n = er(Xs("jse-editable-div", e[2], { "jse-short-text": e[0] })) + " svelte-rw77oa"), A(t, "contenteditable", "true"), A(t, "spellcheck", "false");
  }, m: function(o, a) {
    pt(o, t, a), e[13](t), r || (i = [Nt(t, "input", e[3]), Nt(t, "keydown", e[4]), Nt(t, "paste", e[5]), Nt(t, "blur", e[6])], r = !0);
  }, p: function(o, a) {
    5 & xe(a, 1)[0] && n !== (n = er(Xs("jse-editable-div", o[2], { "jse-short-text": o[0] })) + " svelte-rw77oa") && A(t, "class", n);
  }, i: Wt, o: Wt, d: function(o) {
    o && vt(t), e[13](null), r = !1, Dn(i);
  } };
}
function XK(e, t, n) {
  var r, i = Ur("jsoneditor:EditableDiv"), o = t.value, a = t.shortText, s = a !== void 0 && a, u = t.onChange, c = t.onCancel, l = t.onFind, f = t.onPaste, h = f === void 0 ? Qe : f, d = t.onValueClass, p = d === void 0 ? function() {
    return "";
  } : d, v = p(o), m = !1;
  function g() {
    return function(b) {
      return b.replace(/\n$/, "");
    }(r.innerText);
  }
  function y(b) {
    n(1, r.innerText = Va(b), r);
  }
  return yi(function() {
    i("onMount", { value: o }), y(o), setTimeout(function() {
      return lA(r);
    });
  }), Fa(function() {
    var b = g();
    i("onDestroy", { closed: m, value: o, newValue: b }), m || b === o || u(b, cL);
  }), e.$$set = function(b) {
    "value" in b && n(7, o = b.value), "shortText" in b && n(0, s = b.shortText), "onChange" in b && n(8, u = b.onChange), "onCancel" in b && n(9, c = b.onCancel), "onFind" in b && n(10, l = b.onFind), "onPaste" in b && n(11, h = b.onPaste), "onValueClass" in b && n(12, p = b.onValueClass);
  }, [s, r, v, function() {
    var b = g();
    b === "" && y(""), n(2, v = p(b));
  }, function(b) {
    b.stopPropagation();
    var k = vu(b).replace(/^Command\+/, "Ctrl+");
    if (k === "Escape" && (m = !0, c()), k === "Enter" || k === "Tab") {
      m = !0;
      var w = g();
      u(w, Um);
    }
    k === "Ctrl+F" && (b.preventDefault(), l(!1)), k === "Ctrl+H" && (b.preventDefault(), l(!0));
  }, function(b) {
    if (h) {
      var k = b.clipboardData.getData("text/plain");
      h(k);
    }
  }, function() {
    var b = document.hasFocus(), k = g();
    i("handleBlur", { hasFocus: b, closed: m, value: o, newValue: k }), document.hasFocus() && !m && (m = !0, k !== o ? u(k, Wm) : c());
  }, o, u, c, l, h, p, function(b) {
    Be[b ? "unshift" : "push"](function() {
      n(1, r = b);
    });
  }];
}
var rM = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, XK, QK, Ue, { value: 7, shortText: 0, onChange: 8, onCancel: 9, onFind: 10, onPaste: 11, onValueClass: 12 }, GK), i;
  }
  return Y(n);
}();
function ZK(e) {
  Te(e, "svelte-566egb", '.jse-key.svelte-566egb{display:inline-block;min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;color:var(--jse-key-color);word-break:normal;overflow-wrap:normal;white-space:pre-wrap}.jse-key.svelte-566egb:hover{background:var(--jse-hover-background-color)}.jse-key.svelte-566egb:hover{background:var(--jse-hover-background-color)}.jse-key.jse-empty.svelte-566egb{min-width:3em;outline:1px dotted var(--jse-tag-background);-moz-outline-radius:2px}.jse-key.jse-empty.svelte-566egb::after{pointer-events:none;color:var(--jse-tag-background);content:"key"}');
}
function YK(e) {
  var t, n, r, i, o, a, s, u = [nG, eG], c = [];
  function l(f, h) {
    return f[1] ? 0 : 1;
  }
  return n = l(e), r = c[n] = u[n](e), { c: function() {
    t = rt("div"), r.c(), A(t, "data-type", "selectable-key"), A(t, "class", i = er(e[6](e[0])) + " svelte-566egb");
  }, m: function(f, h) {
    pt(f, t, h), c[n].m(t, null), o = !0, a || (s = Nt(t, "dblclick", e[5]), a = !0);
  }, p: function(f, h) {
    var d = n;
    (n = l(f)) === d ? c[n].p(f, h) : (qt(), tt(c[d], 1, 1, function() {
      c[d] = null;
    }), Vt(), (r = c[n]) ? r.p(f, h) : (r = c[n] = u[n](f)).c(), U(r, 1), r.m(t, null)), (!o || 1 & h && i !== (i = er(f[6](f[0])) + " svelte-566egb")) && A(t, "class", i);
  }, i: function(f) {
    o || (U(r), o = !0);
  }, o: function(f) {
    tt(r), o = !1;
  }, d: function(f) {
    f && vt(t), c[n].d(), a = !1, s();
  } };
}
function tG(e) {
  var t, n;
  return t = new rM({ props: { value: e[2].normalization.escapeValue(e[0]), shortText: !0, onChange: e[7], onCancel: e[8], onFind: e[2].onFind } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    5 & i && (o.value = r[2].normalization.escapeValue(r[0])), 4 & i && (o.onFind = r[2].onFind), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function eG(e) {
  var t, n = Va(e[2].normalization.escapeValue(e[0])) + "";
  return { c: function() {
    t = Xt(n);
  }, m: function(r, i) {
    pt(r, t, i);
  }, p: function(r, i) {
    5 & i && n !== (n = Va(r[2].normalization.escapeValue(r[0])) + "") && Ve(t, n);
  }, i: Wt, o: Wt, d: function(r) {
    r && vt(t);
  } };
}
function nG(e) {
  var t, n;
  return t = new nM({ props: { text: e[2].normalization.escapeValue(e[0]), searchResultItems: e[1] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    5 & i && (o.text = r[2].normalization.escapeValue(r[0])), 2 & i && (o.searchResultItems = r[1]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function RS(e) {
  var t, n;
  return t = new us({ props: { selected: !0, onContextMenu: e[2].onContextMenu } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    4 & i && (o.onContextMenu = r[2].onContextMenu), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function rG(e) {
  var t, n, r, i, o, a = [tG, YK], s = [];
  function u(l, f) {
    return l[4] ? 0 : 1;
  }
  t = u(e), n = s[t] = a[t](e);
  var c = !e[2].readOnly && e[3] && !e[4] && RS(e);
  return { c: function() {
    n.c(), r = bt(), c && c.c(), i = Ye();
  }, m: function(l, f) {
    s[t].m(l, f), pt(l, r, f), c && c.m(l, f), pt(l, i, f), o = !0;
  }, p: function(l, f) {
    var h = xe(f, 1)[0], d = t;
    (t = u(l)) === d ? s[t].p(l, h) : (qt(), tt(s[d], 1, 1, function() {
      s[d] = null;
    }), Vt(), (n = s[t]) ? n.p(l, h) : (n = s[t] = a[t](l)).c(), U(n, 1), n.m(r.parentNode, r)), l[2].readOnly || !l[3] || l[4] ? c && (qt(), tt(c, 1, 1, function() {
      c = null;
    }), Vt()) : c ? (c.p(l, h), 28 & h && U(c, 1)) : ((c = RS(l)).c(), U(c, 1), c.m(i.parentNode, i));
  }, i: function(l) {
    o || (U(n), U(c), o = !0);
  }, o: function(l) {
    tt(n), tt(c), o = !1;
  }, d: function(l) {
    s[t].d(l), l && vt(r), c && c.d(l), l && vt(i);
  } };
}
function iG(e, t, n) {
  var r, i, o = t.path, a = t.pointer, s = t.key, u = t.selection, c = t.searchResultItems, l = t.onUpdateKey, f = t.context;
  return e.$$set = function(h) {
    "path" in h && n(9, o = h.path), "pointer" in h && n(10, a = h.pointer), "key" in h && n(0, s = h.key), "selection" in h && n(11, u = h.selection), "searchResultItems" in h && n(1, c = h.searchResultItems), "onUpdateKey" in h && n(12, l = h.onUpdateKey), "context" in h && n(2, f = h.context);
  }, e.$$.update = function() {
    3072 & e.$$.dirty && n(3, r = u ? u.pointersMap[a] === !0 && Xn(u) : void 0), 2056 & e.$$.dirty && n(4, i = r && Zu(u));
  }, [s, c, f, r, i, function(h) {
    i || f.readOnly || (h.preventDefault(), f.onSelect(Qr(o, !0)));
  }, function(h) {
    return Xs("jse-key", { "jse-empty": h === "" });
  }, function(h, d) {
    var p = l(s, f.normalization.unescapeValue(h)), v = Ge(o).concat(p);
    f.onSelect(d === Um ? Mn(v, !1) : Qr(v, !1)), d !== Wm && f.focus();
  }, function() {
    f.onSelect(Qr(o, !1)), f.focus();
  }, o, a, u, l];
}
var oG = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, iG, rG, Ue, { path: 9, pointer: 10, key: 0, selection: 11, searchResultItems: 1, onUpdateKey: 12, context: 2 }, ZK), i;
  }
  return Y(n);
}();
function DS(e, t, n) {
  var r = e.slice();
  return r[9] = t[n], r;
}
function LS(e) {
  var t, n, r, i = [e[9].props], o = e[9].component;
  function a(s) {
    for (var u = {}, c = 0; c < i.length; c += 1)
      u = da(u, i[c]);
    return { props: u };
  }
  return o && (t = new o(a())), { c: function() {
    t && Pt(t.$$.fragment), n = Ye();
  }, m: function(s, u) {
    t && Ot(t, s, u), pt(s, n, u), r = !0;
  }, p: function(s, u) {
    var c = 1 & u ? ts(i, [Mh(s[9].props)]) : {};
    if (o !== (o = s[9].component)) {
      if (t) {
        qt();
        var l = t;
        tt(l.$$.fragment, 1, 0, function() {
          At(l, 1);
        }), Vt();
      }
      o ? (Pt((t = new o(a())).$$.fragment), U(t.$$.fragment, 1), Ot(t, n.parentNode, n)) : t = null;
    } else
      o && t.$set(c);
  }, i: function(s) {
    r || (t && U(t.$$.fragment, s), r = !0);
  }, o: function(s) {
    t && tt(t.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && vt(n), t && At(t, s);
  } };
}
function aG(e) {
  for (var t, n, r = e[0], i = [], o = 0; o < r.length; o += 1)
    i[o] = LS(DS(e, r, o));
  var a = function(s) {
    return tt(i[s], 1, 1, function() {
      i[s] = null;
    });
  };
  return { c: function() {
    for (var s = 0; s < i.length; s += 1)
      i[s].c();
    t = Ye();
  }, m: function(s, u) {
    for (var c = 0; c < i.length; c += 1)
      i[c].m(s, u);
    pt(s, t, u), n = !0;
  }, p: function(s, u) {
    var c = xe(u, 1)[0];
    if (1 & c) {
      var l;
      for (r = s[0], l = 0; l < r.length; l += 1) {
        var f = DS(s, r, l);
        i[l] ? (i[l].p(f, c), U(i[l], 1)) : (i[l] = LS(f), i[l].c(), U(i[l], 1), i[l].m(t.parentNode, t));
      }
      for (qt(), l = r.length; l < i.length; l += 1)
        a(l);
      Vt();
    }
  }, i: function(s) {
    if (!n) {
      for (var u = 0; u < r.length; u += 1)
        U(i[u]);
      n = !0;
    }
  }, o: function(s) {
    i = i.filter(Boolean);
    for (var u = 0; u < i.length; u += 1)
      tt(i[u]);
    n = !1;
  }, d: function(s) {
    Ar(i, s), s && vt(t);
  } };
}
function sG(e, t, n) {
  var r, i, o = t.path, a = t.value, s = t.context, u = t.isSelected, c = t.enforceString, l = t.selection, f = t.searchResultItems;
  return e.$$set = function(h) {
    "path" in h && n(1, o = h.path), "value" in h && n(2, a = h.value), "context" in h && n(3, s = h.context), "isSelected" in h && n(4, u = h.isSelected), "enforceString" in h && n(5, c = h.enforceString), "selection" in h && n(6, l = h.selection), "searchResultItems" in h && n(7, f = h.searchResultItems);
  }, e.$$.update = function() {
    72 & e.$$.dirty && n(8, r = !s.readOnly && en(l) && Zu(l)), 510 & e.$$.dirty && n(0, i = s.onRenderValue({ path: o, value: a, readOnly: s.readOnly, enforceString: c, isSelected: u, isEditing: r, normalization: s.normalization, selection: l, searchResultItems: f, onPatch: s.onPatch, onPasteJson: s.onPasteJson, onSelect: s.onSelect, onFind: s.onFind, focus: s.focus }));
  }, [i, o, a, s, u, c, l, f, r];
}
var uG = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, sG, aG, Ue, { path: 1, value: 2, context: 3, isSelected: 4, enforceString: 5, selection: 6, searchResultItems: 7 }), i;
  }
  return Y(n);
}(), fr = { selecting: !1, selectionAnchor: null, selectionAnchorType: null, selectionFocus: null, dragging: !1 };
function Av(e) {
  var t = e.json, n = e.documentState, r = e.deltaY, i = e.items, o = n.selection, a = r < 0 ? function(l) {
    for (var f = l.items, h = l.selection, d = l.deltaY, p = _s(h), v = f.findIndex(function(w) {
      return rn(w.path, p);
    }), m = function() {
      var w;
      return (w = f[g - 1]) === null || w === void 0 ? void 0 : w.height;
    }, g = v, y = 0; m() !== void 0 && Math.abs(d) > y + m() / 2; )
      y += m(), g -= 1;
    var b = f[g].path, k = g - v;
    return g !== v && f[g] !== void 0 ? { beforePath: b, offset: k } : void 0;
  }({ json: t, selection: o, deltaY: r, items: i }) : function(l) {
    for (var f, h = l.json, d = l.items, p = l.selection, v = l.deltaY, m = mf(p), g = d.findIndex(function(O) {
      return rn(O.path, m);
    }), y = 0, b = g, k = function() {
      var O;
      return (O = d[b + 1]) === null || O === void 0 ? void 0 : O.height;
    }; k() !== void 0 && Math.abs(v) > y + k() / 2; )
      y += k(), b += 1;
    var w = Ge(m), x = mt.exports.getIn(h, w), S = Array.isArray(x), T = (f = d[S ? b : b + 1]) === null || f === void 0 ? void 0 : f.path, P = b - g;
    return T ? { beforePath: T, offset: P } : { append: !0, offset: P };
  }({ json: t, selection: o, deltaY: r, items: i });
  if (!a || a.offset === 0)
    return { operations: void 0, updatedSelection: void 0, offset: 0 };
  var s = function(l, f, h) {
    var d = h.beforePath, p = h.append, v = Ge(f.focusPath), m = mt.exports.getIn(l, v);
    if (!(p || d && Cc(d, v) && d.length > v.length))
      return [];
    var g = _s(f), y = mf(f), b = ve(g), k = ve(y), w = d ? d[v.length] : void 0;
    if (!Rr(m)) {
      if (yr(m)) {
        var x = nr(b), S = nr(k), T = w !== void 0 ? nr(w) : m.length;
        return Zg(S - x + 1, T < x ? function(E) {
          return { op: "move", from: mt.exports.compileJSONPointer(v.concat(String(x + E))), path: mt.exports.compileJSONPointer(v.concat(String(T + E))) };
        } : function() {
          return { op: "move", from: mt.exports.compileJSONPointer(v.concat(String(x))), path: mt.exports.compileJSONPointer(v.concat(String(T))) };
        });
      }
      throw new Error("Cannot create move operations: parent must be an Object or Array");
    }
    var P = Object.keys(m), O = P.indexOf(b), j = P.indexOf(k), V = p ? P.length : P.indexOf(w);
    return O !== -1 && j !== -1 && V !== -1 ? V > O ? [].concat(Pe(P.slice(O, j + 1)), Pe(P.slice(V, P.length))).map(function(E) {
      return Ka(v, E);
    }) : [].concat(Pe(P.slice(V, O)), Pe(P.slice(j + 1, P.length))).map(function(E) {
      return Ka(v, E);
    }) : void 0;
  }(t, n.selection, a), u = Ge(_s(o)), c = mt.exports.getIn(t, u);
  return Array.isArray(c) ? { operations: s, updatedSelection: function(l) {
    var f, h, d = l.items, p = l.json, v = l.selection, m = l.offset, g = _s(v), y = mf(v), b = d.findIndex(function(S) {
      return rn(S.path, g);
    }), k = d.findIndex(function(S) {
      return rn(S.path, y);
    }), w = (f = d[b + m]) === null || f === void 0 ? void 0 : f.path, x = (h = d[k + m]) === null || h === void 0 ? void 0 : h.path;
    return tr(p, w, x);
  }({ items: i, json: t, selection: o, offset: a.offset }), offset: a.offset } : { operations: s, updatedSelection: void 0, offset: a.offset };
}
function Qi(e, t) {
  return function(n, r) {
    if (n) {
      for (var i = {}, o = 0, a = Object.keys(n); o < a.length; o++) {
        var s = a[o];
        r(s, n[s]) && (i[s] = n[s]);
      }
      return Object.keys(i).length > 0 ? i : void 0;
    }
  }(e, function(n) {
    return mt.exports.startsWithJSONPointer(n, t);
  });
}
function cG(e) {
  Te(e, "svelte-r4omvg", ".jse-tooltip.svelte-r4omvg{font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;padding:calc(0.5 * var(--jse-padding)) var(--jse-padding);border-radius:3px;background:var(--jse-context-menu-background);color:var(--jse-context-menu-color);white-space:nowrap;box-shadow:var(--jse-controls-box-shadow)}");
}
function lG(e) {
  var t, n;
  return { c: function() {
    t = rt("div"), n = Xt(e[0]), A(t, "class", "jse-tooltip svelte-r4omvg");
  }, m: function(r, i) {
    pt(r, t, i), W(t, n);
  }, p: function(r, i) {
    1 & xe(i, 1)[0] && Ve(n, r[0]);
  }, i: Wt, o: Wt, d: function(r) {
    r && vt(t);
  } };
}
function fG(e, t, n) {
  var r = t.text;
  return e.$$set = function(i) {
    "text" in i && n(0, r = i.text);
  }, [r];
}
var hG = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, fG, lG, ir, { text: 0 }, cG), i;
  }
  return Y(n);
}();
function iM(e, t) {
  var n, r = t.text, i = t.openAbsolutePopup, o = t.closeAbsolutePopup;
  function a() {
    n = i(hG, { text: r }, { position: "top", width: 10 * r.length, offsetTop: 3, anchor: e, closeOnOuterClick: !0 });
  }
  function s() {
    o(n);
  }
  return e.addEventListener("mouseenter", a), e.addEventListener("mouseleave", s), { destroy: function() {
    e.removeEventListener("mouseenter", a), e.removeEventListener("mouseleave", s);
  } };
}
function dG(e) {
  Te(e, "svelte-1q62mys", "button.jse-validation-error.svelte-1q62mys{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;color:var(--jse-warning-color);padding:0 5px;margin:0;font-size:var(--jse-font-size-mono);height:var(--jse-line-height);overflow:hidden}");
}
function vG(e) {
  var t, n, r, i, o, a;
  return n = new Le({ props: { data: pu } }), { c: function() {
    t = rt("button"), Pt(n.$$.fragment), A(t, "type", "button"), A(t, "class", "jse-validation-error svelte-1q62mys");
  }, m: function(s, u) {
    pt(s, t, u), Ot(n, t, null), i = !0, o || (a = [Nt(t, "click", function() {
      Ai(e[0]) && e[0].apply(this, arguments);
    }), Ic(r = iM.call(null, t, Ct({ text: e[1] }, e[2])))], o = !0);
  }, p: function(s, u) {
    var c = xe(u, 1)[0];
    e = s, r && Ai(r.update) && 2 & c && r.update.call(null, Ct({ text: e[1] }, e[2]));
  }, i: function(s) {
    i || (U(n.$$.fragment, s), i = !0);
  }, o: function(s) {
    tt(n.$$.fragment, s), i = !1;
  }, d: function(s) {
    s && vt(t), At(n), o = !1, Dn(a);
  } };
}
function pG(e, t, n) {
  var r, i = Hr("absolute-popup"), o = t.validationError, a = t.onExpand;
  return e.$$set = function(s) {
    "validationError" in s && n(3, o = s.validationError), "onExpand" in s && n(0, a = s.onExpand);
  }, e.$$.update = function() {
    8 & e.$$.dirty && n(1, r = o.isChildError ? "Contains invalid data" : o.message);
  }, [a, r, i, o];
}
var q0 = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, pG, vG, ir, { validationError: 3, onExpand: 0 }, dG), i;
  }
  return Y(n);
}();
function mG(e) {
  Te(e, "svelte-uj4yd7", ".jse-json-node.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{position:relative;color:var(--jse-text-color)}.jse-json-node.jse-root.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{min-height:100%;padding-bottom:2px;box-sizing:border-box}.jse-json-node.jse-root.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7 .jse-context-menu-button,.jse-json-node.jse-root.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7 .jse-context-menu-button{top:0;right:calc(-2px - var(--jse-context-menu-button-size))}.jse-json-node.jse-root.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7.svelte-uj4yd7{padding-left:0}.jse-json-node.jse-hovered.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{background:var(--jse-hover-background-color)}.jse-json-node.svelte-uj4yd7 .jse-props.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.svelte-uj4yd7 .jse-items.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{position:relative}.jse-json-node.svelte-uj4yd7 .jse-header-outer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.svelte-uj4yd7 .jse-footer-outer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex}.jse-json-node.svelte-uj4yd7 .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{position:relative}.jse-json-node.svelte-uj4yd7 .jse-header .jse-meta.svelte-uj4yd7>.jse-meta-inner.svelte-uj4yd7.svelte-uj4yd7{display:flex;justify-content:center}.jse-json-node.svelte-uj4yd7 .jse-contents-outer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex}.jse-json-node.svelte-uj4yd7 .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.svelte-uj4yd7 .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex;flex-direction:row}.jse-json-node.svelte-uj4yd7 .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{padding-left:var(--jse-indent-size)}.jse-json-node.svelte-uj4yd7 .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:inline-flex;padding-left:calc(var(--jse-indent-size) + 5px)}.jse-json-node.svelte-uj4yd7 .jse-insert-selection-area.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{visibility:hidden;padding:0 calc(0.5 * var(--jse-padding));flex:1}.jse-json-node.svelte-uj4yd7 .jse-insert-selection-area.jse-inside.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:inline-flex;align-items:center}.jse-json-node.svelte-uj4yd7 .jse-insert-selection-area.jse-after.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex;align-items:flex-end}.jse-json-node.svelte-uj4yd7:hover>.jse-contents-outer .jse-insert-selection-area.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7:not(.jse-selected),.jse-json-node.svelte-uj4yd7 .jse-header-outer.svelte-uj4yd7:hover>.jse-insert-selection-area.svelte-uj4yd7.svelte-uj4yd7:not(.jse-selected),.jse-json-node.svelte-uj4yd7 .jse-footer-outer:hover .jse-insert-selection-area.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7:not(.jse-selected){visibility:visible;z-index:1}.jse-json-node.svelte-uj4yd7 .jse-context-menu-button-anchor.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{position:relative}.jse-json-node.svelte-uj4yd7 .jse-insert-area.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex;position:relative;max-width:250px;min-width:100px;height:0;margin-right:calc(0.5 * var(--jse-padding));outline:1px solid}.jse-json-node.svelte-uj4yd7 .jse-insert-area.svelte-uj4yd7 .jse-context-menu-button{right:-1px;background:var(--jse-selection-background-color)}.jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-hovered.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{outline-color:var(--jse-selection-background-color)}.jse-json-node.jse-selected.svelte-uj4yd7 .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-value{background:var(--jse-selection-background-color) !important;cursor:grab}.jse-json-node.jse-selected.svelte-uj4yd7 .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{cursor:pointer}.jse-json-node.jse-selected-key.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7>.jse-identifier>.jse-key,.jse-json-node.jse-selected-key.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-identifier>.jse-key{background:var(--jse-selection-background-color);cursor:grab}.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7>.jse-value{background:var(--jse-selection-background-color);cursor:grab}.jse-json-node.svelte-uj4yd7 .jse-collapsed-items.jse-selected,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-collapsed-items,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-collapsed-items{background-color:var(--jse-selection-background-color);cursor:grab;background-image:linear-gradient(var(--jse-collapsed-items-selected-background-color), var(--jse-collapsed-items-selected-background-color)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%)}.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{background:var(--jse-selection-background-color) !important}.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7 .jse-value{background:var(--jse-selection-background-color);cursor:grab}.jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{z-index:2;outline-color:var(--jse-context-menu-button-background)}.jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7 .jse-context-menu-button{background:var(--jse-context-menu-button-background)}.jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7 .jse-context-menu-button:hover{background:var(--jse-context-menu-button-background-highlight)}.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-value{background:var(--jse-selection-background-light-color) !important;cursor:grab}.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{cursor:pointer}.jse-main:not(.jse-focus) .jse-json-node.jse-selected-key.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7>.jse-identifier>.jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-key.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-identifier>.jse-key{background:var(--jse-selection-background-light-color);cursor:grab}.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7>.jse-value{background:var(--jse-selection-background-light-color);cursor:grab}.jse-main:not(.jse-focus) .jse-json-node.svelte-uj4yd7 .jse-collapsed-items.jse-selected,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-collapsed-items,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-collapsed-items{background-color:var(--jse-selection-background-light-color);cursor:grab;background-image:linear-gradient(var(--jse-collapsed-items-selected-background-color), var(--jse-collapsed-items-selected-background-color)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%)}.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{background:var(--jse-selection-background-light-color) !important}.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7 .jse-value{background:var(--jse-selection-background-light-color);cursor:grab}.jse-main:not(.jse-focus) .jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{z-index:2;outline-color:var(--jse-selection-background-color)}.jse-main:not(.jse-focus) .jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7 .jse-context-menu-button{background:var(--jse-selection-background-color)}.jse-main:not(.jse-focus) .jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7 .jse-context-menu-button:hover{background:var(--jse-selection-background-color)}.jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{width:var(--jse-indent-size);padding:0;margin:0;border:none;cursor:pointer;background:transparent;color:var(--jse-delimiter-color);font-size:var(--jse-font-size-mono);height:var(--jse-line-height)}.jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7:hover{opacity:0.8}.jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-separator.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-index.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-bracket.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{vertical-align:top;color:var(--jse-delimiter-color)}.jse-index.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{padding:0 calc(0.5 * var(--jse-padding))}.jse-bracket.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{padding:0 2px}.jse-bracket.jse-expanded.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{padding-right:var(--jse-padding)}.jse-tag.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{border:none;font-size:80%;font-family:var(--jse-font-family);color:var(--jse-tag-color);background:var(--jse-tag-background);border-radius:2px;cursor:pointer;position:relative;display:inline-block;padding:0 4px;line-height:normal;margin:1px 0}.jse-tag.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7:hover{opacity:0.8}.jse-tag.jse-expanded.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{opacity:0.7;cursor:inherit}.jse-identifier.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{vertical-align:top;position:relative}");
}
var gG = function(e) {
  return {};
}, zS = function(e) {
  return {};
};
function BS(e, t, n) {
  var r = e.slice();
  return r[54] = t[n], r;
}
var yG = function(e) {
  return {};
}, FS = function(e) {
  return {};
};
function qS(e, t, n) {
  var r = e.slice();
  return r[48] = t[n], r[50] = n, r;
}
function VS(e, t, n) {
  var r = e.slice();
  return r[51] = t[n], r;
}
var bG = function(e) {
  return {};
}, HS = function(e) {
  return {};
};
function kG(e) {
  var t, n, r, i, o, a, s, u, c, l = !e[8].readOnly && e[16] && e[7] && (en(e[7]) || nn(e[7])) && !e[7].edit && rn(e[7].focusPath, e[1]), f = e[35].identifier, h = Di(f, e, e[36], zS), d = !e[17] && WS();
  o = new uG({ props: { path: e[1], value: e[0], enforceString: e[13], isSelected: e[16], selection: e[16] ? e[7] : void 0, searchResultItems: $S(e[6], e[9]), context: e[8] } });
  var p = l && US(e), v = e[15] && JS(e), m = !e[17] && KS(e);
  return { c: function() {
    t = rt("div"), n = rt("div"), h && h.c(), r = bt(), d && d.c(), i = bt(), Pt(o.$$.fragment), a = bt(), p && p.c(), s = bt(), v && v.c(), u = bt(), m && m.c(), A(n, "class", "jse-contents svelte-uj4yd7"), A(t, "class", "jse-contents-outer svelte-uj4yd7"), A(t, "style", e[18]);
  }, m: function(g, y) {
    pt(g, t, y), W(t, n), h && h.m(n, null), W(n, r), d && d.m(n, null), W(n, i), Ot(o, n, null), W(n, a), p && p.m(n, null), W(t, s), v && v.m(t, null), W(t, u), m && m.m(t, null), c = !0;
  }, p: function(g, y) {
    h && h.p && (!c || 32 & y[1]) && zi(h, f, g, g[36], c ? Li(f, g[36], y, gG) : Bi(g[36]), zS), g[17] ? d && (d.d(1), d = null) : d || ((d = WS()).c(), d.m(n, i));
    var b = {};
    2 & y[0] && (b.path = g[1]), 1 & y[0] && (b.value = g[0]), 8192 & y[0] && (b.enforceString = g[13]), 65536 & y[0] && (b.isSelected = g[16]), 65664 & y[0] && (b.selection = g[16] ? g[7] : void 0), 576 & y[0] && (b.searchResultItems = $S(g[6], g[9])), 256 & y[0] && (b.context = g[8]), o.$set(b), 65922 & y[0] && (l = !g[8].readOnly && g[16] && g[7] && (en(g[7]) || nn(g[7])) && !g[7].edit && rn(g[7].focusPath, g[1])), l ? p ? (p.p(g, y), 65922 & y[0] && U(p, 1)) : ((p = US(g)).c(), U(p, 1), p.m(n, null)) : p && (qt(), tt(p, 1, 1, function() {
      p = null;
    }), Vt()), g[15] ? v ? (v.p(g, y), 32768 & y[0] && U(v, 1)) : ((v = JS(g)).c(), U(v, 1), v.m(t, u)) : v && (qt(), tt(v, 1, 1, function() {
      v = null;
    }), Vt()), g[17] ? m && (m.d(1), m = null) : m ? m.p(g, y) : ((m = KS(g)).c(), m.m(t, null)), (!c || 262144 & y[0]) && A(t, "style", g[18]);
  }, i: function(g) {
    c || (U(h, g), U(o.$$.fragment, g), U(p), U(v), c = !0);
  }, o: function(g) {
    tt(h, g), tt(o.$$.fragment, g), tt(p), tt(v), c = !1;
  }, d: function(g) {
    g && vt(t), h && h.d(g), d && d.d(), At(o), p && p.d(), v && v.d(), m && m.d();
  } };
}
function wG(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b = !e[8].readOnly && e[16] && e[7] && (en(e[7]) || nn(e[7])) && !e[7].edit && rn(e[7].focusPath, e[1]), k = [SG, jG], w = [];
  function x(M, $) {
    return M[12] ? 0 : 1;
  }
  i = x(e), o = w[i] = k[i](e);
  var S = e[35].identifier, T = Di(S, e, e[36], FS), P = !e[17] && GS();
  function O(M, $) {
    return M[12] ? _G : $G;
  }
  var j = O(e), V = j(e), E = b && QS(e), C = e[15] && (!e[12] || !e[15].isChildError) && XS(e);
  function H(M, $) {
    return M[12] ? OG : M[17] ? void 0 : CG;
  }
  var X = H(e), F = X && X(e), G = e[12] && ZS(e);
  return { c: function() {
    t = rt("div"), n = rt("div"), r = rt("button"), o.c(), a = bt(), T && T.c(), s = bt(), P && P.c(), u = bt(), c = rt("div"), l = rt("div"), V.c(), f = bt(), E && E.c(), h = bt(), C && C.c(), d = bt(), F && F.c(), p = bt(), G && G.c(), v = Ye(), A(r, "type", "button"), A(r, "class", "jse-expand svelte-uj4yd7"), A(r, "title", "Expand or collapse this object (Ctrl+Click to expand/collapse recursively)"), A(l, "class", "jse-meta-inner svelte-uj4yd7"), A(c, "class", "jse-meta svelte-uj4yd7"), A(c, "data-type", "selectable-value"), A(n, "class", "jse-header svelte-uj4yd7"), A(t, "class", "jse-header-outer svelte-uj4yd7"), A(t, "style", e[18]);
  }, m: function(M, $) {
    pt(M, t, $), W(t, n), W(n, r), w[i].m(r, null), W(n, a), T && T.m(n, null), W(n, s), P && P.m(n, null), W(n, u), W(n, c), W(c, l), V.m(l, null), W(n, f), E && E.m(n, null), W(t, h), C && C.m(t, null), W(t, d), F && F.m(t, null), pt(M, p, $), G && G.m(M, $), pt(M, v, $), m = !0, g || (y = Nt(r, "click", e[22]), g = !0);
  }, p: function(M, $) {
    var q = i;
    (i = x(M)) === q ? w[i].p(M, $) : (qt(), tt(w[q], 1, 1, function() {
      w[q] = null;
    }), Vt(), (o = w[i]) ? o.p(M, $) : (o = w[i] = k[i](M)).c(), U(o, 1), o.m(r, null)), T && T.p && (!m || 32 & $[1]) && zi(T, S, M, M[36], m ? Li(S, M[36], $, yG) : Bi(M[36]), FS), M[17] ? P && (P.d(1), P = null) : P || ((P = GS()).c(), P.m(n, u)), j === (j = O(M)) && V ? V.p(M, $) : (V.d(1), (V = j(M)) && (V.c(), V.m(l, null))), 65922 & $[0] && (b = !M[8].readOnly && M[16] && M[7] && (en(M[7]) || nn(M[7])) && !M[7].edit && rn(M[7].focusPath, M[1])), b ? E ? (E.p(M, $), 65922 & $[0] && U(E, 1)) : ((E = QS(M)).c(), U(E, 1), E.m(n, null)) : E && (qt(), tt(E, 1, 1, function() {
      E = null;
    }), Vt()), !M[15] || M[12] && M[15].isChildError ? C && (qt(), tt(C, 1, 1, function() {
      C = null;
    }), Vt()) : C ? (C.p(M, $), 36864 & $[0] && U(C, 1)) : ((C = XS(M)).c(), U(C, 1), C.m(t, d)), X === (X = H(M)) && F ? F.p(M, $) : (F && F.d(1), (F = X && X(M)) && (F.c(), F.m(t, null))), (!m || 262144 & $[0]) && A(t, "style", M[18]), M[12] ? G ? (G.p(M, $), 4096 & $[0] && U(G, 1)) : ((G = ZS(M)).c(), U(G, 1), G.m(v.parentNode, v)) : G && (qt(), tt(G, 1, 1, function() {
      G = null;
    }), Vt());
  }, i: function(M) {
    m || (U(o), U(T, M), U(E), U(C), U(G), m = !0);
  }, o: function(M) {
    tt(o), tt(T, M), tt(E), tt(C), tt(G), m = !1;
  }, d: function(M) {
    M && vt(t), w[i].d(), T && T.d(M), P && P.d(), V.d(), E && E.d(), C && C.d(), F && F.d(), M && vt(p), G && G.d(M), M && vt(v), g = !1, y();
  } };
}
function xG(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b = !e[8].readOnly && e[16] && e[7] && (en(e[7]) || nn(e[7])) && !e[7].edit && rn(e[7].focusPath, e[1]), k = [EG, PG], w = [];
  function x(M, $) {
    return M[12] ? 0 : 1;
  }
  i = x(e), o = w[i] = k[i](e);
  var S = e[35].identifier, T = Di(S, e, e[36], HS), P = !e[17] && n$();
  function O(M, $) {
    return M[12] ? TG : MG;
  }
  var j = O(e), V = j(e), E = b && r$(e), C = e[15] && (!e[12] || !e[15].isChildError) && i$(e);
  function H(M, $) {
    return M[12] ? NG : IG;
  }
  var X = H(e), F = X(e), G = e[12] && o$(e);
  return { c: function() {
    t = rt("div"), n = rt("div"), r = rt("button"), o.c(), a = bt(), T && T.c(), s = bt(), P && P.c(), u = bt(), c = rt("div"), l = rt("div"), V.c(), f = bt(), E && E.c(), h = bt(), C && C.c(), d = bt(), F.c(), p = bt(), G && G.c(), v = Ye(), A(r, "type", "button"), A(r, "class", "jse-expand svelte-uj4yd7"), A(r, "title", "Expand or collapse this array (Ctrl+Click to expand/collapse recursively)"), A(l, "class", "jse-meta-inner svelte-uj4yd7"), A(l, "data-type", "selectable-value"), A(c, "class", "jse-meta svelte-uj4yd7"), A(n, "class", "jse-header svelte-uj4yd7"), A(t, "class", "jse-header-outer svelte-uj4yd7"), A(t, "style", e[18]);
  }, m: function(M, $) {
    pt(M, t, $), W(t, n), W(n, r), w[i].m(r, null), W(n, a), T && T.m(n, null), W(n, s), P && P.m(n, null), W(n, u), W(n, c), W(c, l), V.m(l, null), W(n, f), E && E.m(n, null), W(t, h), C && C.m(t, null), W(t, d), F.m(t, null), pt(M, p, $), G && G.m(M, $), pt(M, v, $), m = !0, g || (y = Nt(r, "click", e[22]), g = !0);
  }, p: function(M, $) {
    var q = i;
    (i = x(M)) === q ? w[i].p(M, $) : (qt(), tt(w[q], 1, 1, function() {
      w[q] = null;
    }), Vt(), (o = w[i]) ? o.p(M, $) : (o = w[i] = k[i](M)).c(), U(o, 1), o.m(r, null)), T && T.p && (!m || 32 & $[1]) && zi(T, S, M, M[36], m ? Li(S, M[36], $, bG) : Bi(M[36]), HS), M[17] ? P && (P.d(1), P = null) : P || ((P = n$()).c(), P.m(n, u)), j === (j = O(M)) && V ? V.p(M, $) : (V.d(1), (V = j(M)) && (V.c(), V.m(l, null))), 65922 & $[0] && (b = !M[8].readOnly && M[16] && M[7] && (en(M[7]) || nn(M[7])) && !M[7].edit && rn(M[7].focusPath, M[1])), b ? E ? (E.p(M, $), 65922 & $[0] && U(E, 1)) : ((E = r$(M)).c(), U(E, 1), E.m(n, null)) : E && (qt(), tt(E, 1, 1, function() {
      E = null;
    }), Vt()), !M[15] || M[12] && M[15].isChildError ? C && (qt(), tt(C, 1, 1, function() {
      C = null;
    }), Vt()) : C ? (C.p(M, $), 36864 & $[0] && U(C, 1)) : ((C = i$(M)).c(), U(C, 1), C.m(t, d)), X === (X = H(M)) && F ? F.p(M, $) : (F.d(1), (F = X(M)) && (F.c(), F.m(t, null))), (!m || 262144 & $[0]) && A(t, "style", M[18]), M[12] ? G ? (G.p(M, $), 4096 & $[0] && U(G, 1)) : ((G = o$(M)).c(), U(G, 1), G.m(v.parentNode, v)) : G && (qt(), tt(G, 1, 1, function() {
      G = null;
    }), Vt());
  }, i: function(M) {
    m || (U(o), U(T, M), U(E), U(C), U(G), m = !0);
  }, o: function(M) {
    tt(o), tt(T, M), tt(E), tt(C), tt(G), m = !1;
  }, d: function(M) {
    M && vt(t), w[i].d(), T && T.d(M), P && P.d(), V.d(), E && E.d(), C && C.d(), F.d(), M && vt(p), G && G.d(M), M && vt(v), g = !1, y();
  } };
}
function WS(e) {
  var t;
  return { c: function() {
    (t = rt("div")).textContent = ":", A(t, "class", "jse-separator svelte-uj4yd7");
  }, m: function(n, r) {
    pt(n, t, r);
  }, d: function(n) {
    n && vt(t);
  } };
}
function US(e) {
  var t, n, r;
  return n = new us({ props: { selected: !0, onContextMenu: e[8].onContextMenu } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-context-menu-button-anchor svelte-uj4yd7");
  }, m: function(i, o) {
    pt(i, t, o), Ot(n, t, null), r = !0;
  }, p: function(i, o) {
    var a = {};
    256 & o[0] && (a.onContextMenu = i[8].onContextMenu), n.$set(a);
  }, i: function(i) {
    r || (U(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    tt(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && vt(t), At(n);
  } };
}
function JS(e) {
  var t, n;
  return t = new q0({ props: { validationError: e[15], onExpand: e[23] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32768 & i[0] && (o.validationError = r[15]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function KS(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    pt(i, t, o), n || (r = Nt(t, "click", e[31]), n = !0);
  }, p: Wt, d: function(i) {
    i && vt(t), n = !1, r();
  } };
}
function jG(e) {
  var t, n;
  return t = new Le({ props: { data: Qo } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: Wt, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function SG(e) {
  var t, n;
  return t = new Le({ props: { data: no } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: Wt, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function GS(e) {
  var t;
  return { c: function() {
    (t = rt("div")).textContent = ":", A(t, "class", "jse-separator svelte-uj4yd7");
  }, m: function(n, r) {
    pt(n, t, r);
  }, d: function(n) {
    n && vt(t);
  } };
}
function $G(e) {
  var t, n, r, i, o, a, s, u, c, l, f = Object.keys(e[0]).length + "", h = Object.keys(e[0]).length === 1 ? "prop" : "props";
  return { c: function() {
    (t = rt("div")).textContent = "{", n = bt(), r = rt("button"), i = Xt(f), o = bt(), a = Xt(h), s = bt(), (u = rt("div")).textContent = "}", A(t, "class", "jse-bracket svelte-uj4yd7"), A(r, "type", "button"), A(r, "class", "jse-tag svelte-uj4yd7"), A(u, "class", "jse-bracket svelte-uj4yd7");
  }, m: function(d, p) {
    pt(d, t, p), pt(d, n, p), pt(d, r, p), W(r, i), W(r, o), W(r, a), pt(d, s, p), pt(d, u, p), c || (l = Nt(r, "click", e[23]), c = !0);
  }, p: function(d, p) {
    1 & p[0] && f !== (f = Object.keys(d[0]).length + "") && Ve(i, f), 1 & p[0] && h !== (h = Object.keys(d[0]).length === 1 ? "prop" : "props") && Ve(a, h);
  }, d: function(d) {
    d && vt(t), d && vt(n), d && vt(r), d && vt(s), d && vt(u), c = !1, l();
  } };
}
function _G(e) {
  var t;
  return { c: function() {
    (t = rt("div")).textContent = "{", A(t, "class", "jse-bracket jse-expanded svelte-uj4yd7");
  }, m: function(n, r) {
    pt(n, t, r);
  }, p: Wt, d: function(n) {
    n && vt(t);
  } };
}
function QS(e) {
  var t, n, r;
  return n = new us({ props: { selected: !0, onContextMenu: e[8].onContextMenu } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-context-menu-button-anchor svelte-uj4yd7");
  }, m: function(i, o) {
    pt(i, t, o), Ot(n, t, null), r = !0;
  }, p: function(i, o) {
    var a = {};
    256 & o[0] && (a.onContextMenu = i[8].onContextMenu), n.$set(a);
  }, i: function(i) {
    r || (U(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    tt(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && vt(t), At(n);
  } };
}
function XS(e) {
  var t, n;
  return t = new q0({ props: { validationError: e[15], onExpand: e[23] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32768 & i[0] && (o.validationError = r[15]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function CG(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    pt(i, t, o), n || (r = Nt(t, "click", e[31]), n = !0);
  }, p: Wt, d: function(i) {
    i && vt(t), n = !1, r();
  } };
}
function OG(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("div"), "class", "jse-insert-selection-area jse-inside svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-inside");
  }, m: function(i, o) {
    pt(i, t, o), n || (r = Nt(t, "click", e[30]), n = !0);
  }, p: Wt, d: function(i) {
    i && vt(t), n = !1, r();
  } };
}
function ZS(e) {
  for (var t, n, r, i, o, a, s, u = !e[8].readOnly && (e[10] === "hover-insert-inside" || e[16] && rr(e[7])), c = u && YS(e), l = e[20](e[1], e[0], e[2], e[3], e[4], e[5], e[6], e[7], e[11]), f = [], h = 0; h < l.length; h += 1)
    f[h] = t$(BS(e, l, h));
  var d = function(v) {
    return tt(f[v], 1, 1, function() {
      f[v] = null;
    });
  }, p = !e[17] && e$(e);
  return { c: function() {
    t = rt("div"), c && c.c(), n = bt();
    for (var v = 0; v < f.length; v += 1)
      f[v].c();
    r = bt(), i = rt("div"), (o = rt("div")).innerHTML = '<div class="jse-bracket svelte-uj4yd7">}</div>', a = bt(), p && p.c(), A(t, "class", "jse-props svelte-uj4yd7"), A(o, "data-type", "selectable-value"), A(o, "class", "jse-footer svelte-uj4yd7"), A(i, "class", "jse-footer-outer svelte-uj4yd7"), A(i, "style", e[18]);
  }, m: function(v, m) {
    pt(v, t, m), c && c.m(t, null), W(t, n);
    for (var g = 0; g < f.length; g += 1)
      f[g].m(t, null);
    pt(v, r, m), pt(v, i, m), W(i, o), W(i, a), p && p.m(i, null), s = !0;
  }, p: function(v, m) {
    if (66944 & m[0] && (u = !v[8].readOnly && (v[10] === "hover-insert-inside" || v[16] && rr(v[7]))), u ? c ? (c.p(v, m), 66944 & m[0] && U(c, 1)) : ((c = YS(v)).c(), U(c, 1), c.m(t, n)) : c && (qt(), tt(c, 1, 1, function() {
      c = null;
    }), Vt()), 152046079 & m[0]) {
      var g;
      for (l = v[20](v[1], v[0], v[2], v[3], v[4], v[5], v[6], v[7], v[11]), g = 0; g < l.length; g += 1) {
        var y = BS(v, l, g);
        f[g] ? (f[g].p(y, m), U(f[g], 1)) : (f[g] = t$(y), f[g].c(), U(f[g], 1), f[g].m(t, null));
      }
      for (qt(), g = l.length; g < f.length; g += 1)
        d(g);
      Vt();
    }
    v[17] ? p && (p.d(1), p = null) : p ? p.p(v, m) : ((p = e$(v)).c(), p.m(i, null)), (!s || 262144 & m[0]) && A(i, "style", v[18]);
  }, i: function(v) {
    if (!s) {
      U(c);
      for (var m = 0; m < l.length; m += 1)
        U(f[m]);
      s = !0;
    }
  }, o: function(v) {
    tt(c), f = f.filter(Boolean);
    for (var m = 0; m < f.length; m += 1)
      tt(f[m]);
    s = !1;
  }, d: function(v) {
    v && vt(t), c && c.d(), Ar(f, v), v && vt(r), v && vt(i), p && p.d();
  } };
}
function YS(e) {
  var t, n, r, i;
  return n = new us({ props: { selected: e[16] && rr(e[7]), onContextMenu: e[32] } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-insert-area jse-inside svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-inside"), A(t, "style", r = Oc(e[1].length + 1)), A(t, "title", Hm), Ut(t, "jse-hovered", e[10] === "hover-insert-inside"), Ut(t, "jse-selected", e[16] && rr(e[7]));
  }, m: function(o, a) {
    pt(o, t, a), Ot(n, t, null), i = !0;
  }, p: function(o, a) {
    var s = {};
    65664 & a[0] && (s.selected = o[16] && rr(o[7])), n.$set(s), (!i || 2 & a[0] && r !== (r = Oc(o[1].length + 1))) && A(t, "style", r), 1024 & a[0] && Ut(t, "jse-hovered", o[10] === "hover-insert-inside"), 65664 & a[0] && Ut(t, "jse-selected", o[16] && rr(o[7]));
  }, i: function(o) {
    i || (U(n.$$.fragment, o), i = !0);
  }, o: function(o) {
    tt(n.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && vt(t), At(n);
  } };
}
function AG(e) {
  var t, n, r, i;
  return n = new oG({ props: { path: e[54].path, pointer: e[54].pointer, key: e[54].key, selection: e[54].selection, searchResultItems: e[54].keySearchResultItemsMap, context: e[8], onUpdateKey: e[24] } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), r = bt(), A(t, "slot", "identifier"), A(t, "class", "jse-identifier svelte-uj4yd7");
  }, m: function(o, a) {
    pt(o, t, a), Ot(n, t, null), W(t, r), i = !0;
  }, p: function(o, a) {
    var s = {};
    2303 & a[0] && (s.path = o[54].path), 2303 & a[0] && (s.pointer = o[54].pointer), 2303 & a[0] && (s.key = o[54].key), 2303 & a[0] && (s.selection = o[54].selection), 2303 & a[0] && (s.searchResultItems = o[54].keySearchResultItemsMap), 256 & a[0] && (s.context = o[8]), n.$set(s);
  }, i: function(o) {
    i || (U(n.$$.fragment, o), i = !0);
  }, o: function(o) {
    tt(n.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && vt(t), At(n);
  } };
}
function t$(e) {
  var t, n;
  return t = new V0({ props: { value: e[54].value, path: e[54].path, expandedMap: e[54].expandedMap, enforceStringMap: e[54].enforceStringMap, visibleSectionsMap: e[54].visibleSectionsMap, validationErrorsMap: e[54].validationErrorsMap, searchResultItemsMap: e[54].valueSearchResultItemsMap, selection: e[54].selection, context: e[8], onDragSelectionStart: e[27], $$slots: { identifier: [AG] }, $$scope: { ctx: e } } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2303 & i[0] && (o.value = r[54].value), 2303 & i[0] && (o.path = r[54].path), 2303 & i[0] && (o.expandedMap = r[54].expandedMap), 2303 & i[0] && (o.enforceStringMap = r[54].enforceStringMap), 2303 & i[0] && (o.visibleSectionsMap = r[54].visibleSectionsMap), 2303 & i[0] && (o.validationErrorsMap = r[54].validationErrorsMap), 2303 & i[0] && (o.searchResultItemsMap = r[54].valueSearchResultItemsMap), 2303 & i[0] && (o.selection = r[54].selection), 256 & i[0] && (o.context = r[8]), 2559 & i[0] | 32 & i[1] && (o.$$scope = { dirty: i, ctx: r }), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function e$(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    pt(i, t, o), n || (r = Nt(t, "click", e[31]), n = !0);
  }, p: Wt, d: function(i) {
    i && vt(t), n = !1, r();
  } };
}
function PG(e) {
  var t, n;
  return t = new Le({ props: { data: Qo } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: Wt, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function EG(e) {
  var t, n;
  return t = new Le({ props: { data: no } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: Wt, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function n$(e) {
  var t;
  return { c: function() {
    (t = rt("div")).textContent = ":", A(t, "class", "jse-separator svelte-uj4yd7");
  }, m: function(n, r) {
    pt(n, t, r);
  }, d: function(n) {
    n && vt(t);
  } };
}
function MG(e) {
  var t, n, r, i, o, a, s, u, c, l, f = e[0].length + "", h = e[0].length === 1 ? "item" : "items";
  return { c: function() {
    (t = rt("div")).textContent = "[", n = bt(), r = rt("button"), i = Xt(f), o = bt(), a = Xt(h), s = bt(), (u = rt("div")).textContent = "]", A(t, "class", "jse-bracket svelte-uj4yd7"), A(r, "type", "button"), A(r, "class", "jse-tag svelte-uj4yd7"), A(u, "class", "jse-bracket svelte-uj4yd7");
  }, m: function(d, p) {
    pt(d, t, p), pt(d, n, p), pt(d, r, p), W(r, i), W(r, o), W(r, a), pt(d, s, p), pt(d, u, p), c || (l = Nt(r, "click", e[23]), c = !0);
  }, p: function(d, p) {
    1 & p[0] && f !== (f = d[0].length + "") && Ve(i, f), 1 & p[0] && h !== (h = d[0].length === 1 ? "item" : "items") && Ve(a, h);
  }, d: function(d) {
    d && vt(t), d && vt(n), d && vt(r), d && vt(s), d && vt(u), c = !1, l();
  } };
}
function TG(e) {
  var t, n, r, i, o, a, s = e[0].length + "", u = e[0].length === 1 ? "item" : "items";
  return { c: function() {
    (t = rt("div")).textContent = "[", n = bt(), r = rt("span"), i = Xt(s), o = bt(), a = Xt(u), A(t, "class", "jse-bracket svelte-uj4yd7"), A(r, "class", "jse-tag jse-expanded svelte-uj4yd7");
  }, m: function(c, l) {
    pt(c, t, l), pt(c, n, l), pt(c, r, l), W(r, i), W(r, o), W(r, a);
  }, p: function(c, l) {
    1 & l[0] && s !== (s = c[0].length + "") && Ve(i, s), 1 & l[0] && u !== (u = c[0].length === 1 ? "item" : "items") && Ve(a, u);
  }, d: function(c) {
    c && vt(t), c && vt(n), c && vt(r);
  } };
}
function r$(e) {
  var t, n, r;
  return n = new us({ props: { selected: !0, onContextMenu: e[8].onContextMenu } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-context-menu-button-anchor svelte-uj4yd7");
  }, m: function(i, o) {
    pt(i, t, o), Ot(n, t, null), r = !0;
  }, p: function(i, o) {
    var a = {};
    256 & o[0] && (a.onContextMenu = i[8].onContextMenu), n.$set(a);
  }, i: function(i) {
    r || (U(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    tt(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && vt(t), At(n);
  } };
}
function i$(e) {
  var t, n;
  return t = new q0({ props: { validationError: e[15], onExpand: e[23] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32768 & i[0] && (o.validationError = r[15]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function IG(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    pt(i, t, o), n || (r = Nt(t, "click", e[31]), n = !0);
  }, p: Wt, d: function(i) {
    i && vt(t), n = !1, r();
  } };
}
function NG(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("div"), "class", "jse-insert-selection-area jse-inside svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-inside");
  }, m: function(i, o) {
    pt(i, t, o), n || (r = Nt(t, "click", e[30]), n = !0);
  }, p: Wt, d: function(i) {
    i && vt(t), n = !1, r();
  } };
}
function o$(e) {
  for (var t, n, r, i, o, a, s, u = !e[8].readOnly && (e[10] === "hover-insert-inside" || e[16] && rr(e[7])), c = [], l = /* @__PURE__ */ new Map(), f = u && a$(e), h = e[14] || qa, d = function(y) {
    return y[50];
  }, p = 0; p < h.length; p += 1) {
    var v = qS(e, h, p), m = d(v);
    l.set(m, c[p] = c$(m, v));
  }
  var g = !e[17] && l$(e);
  return { c: function() {
    t = rt("div"), f && f.c(), n = bt();
    for (var y = 0; y < c.length; y += 1)
      c[y].c();
    r = bt(), i = rt("div"), (o = rt("div")).innerHTML = '<span class="jse-bracket svelte-uj4yd7">]</span>', a = bt(), g && g.c(), A(t, "class", "jse-items svelte-uj4yd7"), A(o, "data-type", "selectable-value"), A(o, "class", "jse-footer svelte-uj4yd7"), A(i, "class", "jse-footer-outer svelte-uj4yd7"), A(i, "style", e[18]);
  }, m: function(y, b) {
    pt(y, t, b), f && f.m(t, null), W(t, n);
    for (var k = 0; k < c.length; k += 1)
      c[k].m(t, null);
    pt(y, r, b), pt(y, i, b), W(i, o), W(i, a), g && g.m(i, null), s = !0;
  }, p: function(y, b) {
    66944 & b[0] && (u = !y[8].readOnly && (y[10] === "hover-insert-inside" || y[16] && rr(y[7]))), u ? f ? (f.p(y, b), 66944 & b[0] && U(f, 1)) : ((f = a$(y)).c(), U(f, 1), f.m(t, n)) : f && (qt(), tt(f, 1, 1, function() {
      f = null;
    }), Vt()), 136334335 & b[0] && (h = y[14] || qa, qt(), c = Nc(c, b, d, 1, y, h, l, t, Eh, c$, null, qS), Vt()), y[17] ? g && (g.d(1), g = null) : g ? g.p(y, b) : ((g = l$(y)).c(), g.m(i, null)), (!s || 262144 & b[0]) && A(i, "style", y[18]);
  }, i: function(y) {
    if (!s) {
      U(f);
      for (var b = 0; b < h.length; b += 1)
        U(c[b]);
      s = !0;
    }
  }, o: function(y) {
    tt(f);
    for (var b = 0; b < c.length; b += 1)
      tt(c[b]);
    s = !1;
  }, d: function(y) {
    y && vt(t), f && f.d();
    for (var b = 0; b < c.length; b += 1)
      c[b].d();
    y && vt(r), y && vt(i), g && g.d();
  } };
}
function a$(e) {
  var t, n, r, i;
  return n = new us({ props: { selected: e[16] && rr(e[7]), onContextMenu: e[32] } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-insert-area jse-inside svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-inside"), A(t, "style", r = Oc(e[1].length + 1)), A(t, "title", Hm), Ut(t, "jse-hovered", e[10] === "hover-insert-inside"), Ut(t, "jse-selected", e[16] && rr(e[7]));
  }, m: function(o, a) {
    pt(o, t, a), Ot(n, t, null), i = !0;
  }, p: function(o, a) {
    var s = {};
    65664 & a[0] && (s.selected = o[16] && rr(o[7])), n.$set(s), (!i || 2 & a[0] && r !== (r = Oc(o[1].length + 1))) && A(t, "style", r), 1024 & a[0] && Ut(t, "jse-hovered", o[10] === "hover-insert-inside"), 65664 & a[0] && Ut(t, "jse-selected", o[16] && rr(o[7]));
  }, i: function(o) {
    i || (U(n.$$.fragment, o), i = !0);
  }, o: function(o) {
    tt(n.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && vt(t), At(n);
  } };
}
function RG(e) {
  var t, n, r, i = e[51].index + "";
  return { c: function() {
    t = rt("div"), n = rt("div"), r = Xt(i), A(n, "class", "jse-index svelte-uj4yd7"), A(t, "slot", "identifier"), A(t, "class", "jse-identifier svelte-uj4yd7");
  }, m: function(o, a) {
    pt(o, t, a), W(t, n), W(n, r);
  }, p: function(o, a) {
    18687 & a[0] && i !== (i = o[51].index + "") && Ve(r, i);
  }, d: function(o) {
    o && vt(t);
  } };
}
function s$(e, t) {
  var n, r, i;
  return r = new V0({ props: { value: t[51].value, path: t[51].path, expandedMap: t[51].expandedMap, enforceStringMap: t[51].enforceStringMap, visibleSectionsMap: t[51].visibleSectionsMap, validationErrorsMap: t[51].validationErrorsMap, searchResultItemsMap: t[51].searchResultItemsMap, selection: t[51].selection, context: t[8], onDragSelectionStart: t[27], $$slots: { identifier: [RG] }, $$scope: { ctx: t } } }), { key: e, first: null, c: function() {
    n = Ye(), Pt(r.$$.fragment), this.first = n;
  }, m: function(o, a) {
    pt(o, n, a), Ot(r, o, a), i = !0;
  }, p: function(o, a) {
    t = o;
    var s = {};
    18687 & a[0] && (s.value = t[51].value), 18687 & a[0] && (s.path = t[51].path), 18687 & a[0] && (s.expandedMap = t[51].expandedMap), 18687 & a[0] && (s.enforceStringMap = t[51].enforceStringMap), 18687 & a[0] && (s.visibleSectionsMap = t[51].visibleSectionsMap), 18687 & a[0] && (s.validationErrorsMap = t[51].validationErrorsMap), 18687 & a[0] && (s.searchResultItemsMap = t[51].searchResultItemsMap), 18687 & a[0] && (s.selection = t[51].selection), 256 & a[0] && (s.context = t[8]), 18687 & a[0] | 32 & a[1] && (s.$$scope = { dirty: a, ctx: t }), r.$set(s);
  }, i: function(o) {
    i || (U(r.$$.fragment, o), i = !0);
  }, o: function(o) {
    tt(r.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && vt(n), At(r, o);
  } };
}
function u$(e) {
  var t, n;
  return t = new BK({ props: { visibleSections: e[14] || qa, sectionIndex: e[50], total: e[0].length, path: e[1], pointer: e[9], onExpandSection: e[8].onExpandSection, selection: e[7] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    16384 & i[0] && (o.visibleSections = r[14] || qa), 16384 & i[0] && (o.sectionIndex = r[50]), 1 & i[0] && (o.total = r[0].length), 2 & i[0] && (o.path = r[1]), 512 & i[0] && (o.pointer = r[9]), 256 & i[0] && (o.onExpandSection = r[8].onExpandSection), 128 & i[0] && (o.selection = r[7]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function c$(e, t) {
  for (var n, r, i, o, a = [], s = /* @__PURE__ */ new Map(), u = t[21](t[1], t[0], t[48], t[2], t[3], t[4], t[5], t[6], t[7], t[11]), c = function(p) {
    return p[51].index;
  }, l = 0; l < u.length; l += 1) {
    var f = VS(t, u, l), h = c(f);
    s.set(h, a[l] = s$(h, f));
  }
  var d = t[48].end < t[0].length && u$(t);
  return { key: e, first: null, c: function() {
    n = Ye();
    for (var p = 0; p < a.length; p += 1)
      a[p].c();
    r = bt(), d && d.c(), i = Ye(), this.first = n;
  }, m: function(p, v) {
    pt(p, n, v);
    for (var m = 0; m < a.length; m += 1)
      a[m].m(p, v);
    pt(p, r, v), d && d.m(p, v), pt(p, i, v), o = !0;
  }, p: function(p, v) {
    t = p, 136333823 & v[0] && (u = t[21](t[1], t[0], t[48], t[2], t[3], t[4], t[5], t[6], t[7], t[11]), qt(), a = Nc(a, v, c, 1, t, u, s, r.parentNode, Eh, s$, r, VS), Vt()), t[48].end < t[0].length ? d ? (d.p(t, v), 16385 & v[0] && U(d, 1)) : ((d = u$(t)).c(), U(d, 1), d.m(i.parentNode, i)) : d && (qt(), tt(d, 1, 1, function() {
      d = null;
    }), Vt());
  }, i: function(p) {
    if (!o) {
      for (var v = 0; v < u.length; v += 1)
        U(a[v]);
      U(d), o = !0;
    }
  }, o: function(p) {
    for (var v = 0; v < a.length; v += 1)
      tt(a[v]);
    tt(d), o = !1;
  }, d: function(p) {
    p && vt(n);
    for (var v = 0; v < a.length; v += 1)
      a[v].d(p);
    p && vt(r), d && d.d(p), p && vt(i);
  } };
}
function l$(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    pt(i, t, o), n || (r = Nt(t, "click", e[31]), n = !0);
  }, p: Wt, d: function(i) {
    i && vt(t), n = !1, r();
  } };
}
function f$(e) {
  var t, n, r;
  return n = new us({ props: { selected: e[16] && Ti(e[7]), onContextMenu: e[33] } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-insert-area jse-after svelte-uj4yd7"), A(t, "data-type", "insert-selection-area-after"), A(t, "style", e[18]), A(t, "title", Hm), Ut(t, "jse-hovered", e[10] === "hover-insert-after"), Ut(t, "jse-selected", e[16] && Ti(e[7]));
  }, m: function(i, o) {
    pt(i, t, o), Ot(n, t, null), r = !0;
  }, p: function(i, o) {
    var a = {};
    65664 & o[0] && (a.selected = i[16] && Ti(i[7])), n.$set(a), (!r || 262144 & o[0]) && A(t, "style", i[18]), 1024 & o[0] && Ut(t, "jse-hovered", i[10] === "hover-insert-after"), 65664 & o[0] && Ut(t, "jse-selected", i[16] && Ti(i[7]));
  }, i: function(i) {
    r || (U(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    tt(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && vt(t), At(n);
  } };
}
function DG(e) {
  var t, n, r, i, o, a, s, u, c, l = !e[8].readOnly && (e[10] === "hover-insert-after" || e[16] && Ti(e[7])), f = [xG, wG, kG], h = [];
  function d(v, m) {
    return v[19] === "array" ? 0 : v[19] === "object" ? 1 : 2;
  }
  n = d(e), r = h[n] = f[n](e);
  var p = l && f$(e);
  return { c: function() {
    t = rt("div"), r.c(), i = bt(), p && p.c(), A(t, "class", o = er(Xs("jse-json-node", { "jse-expanded": e[12] }, e[8].onClassName(e[1], e[0]))) + " svelte-uj4yd7"), A(t, "data-path", a = vp(e[1])), Ut(t, "jse-root", e[17]), Ut(t, "jse-selected", e[16] && nn(e[7])), Ut(t, "jse-selected-key", e[16] && Xn(e[7])), Ut(t, "jse-selected-value", e[16] && en(e[7])), Ut(t, "jse-hovered", e[10] === "hover-collection");
  }, m: function(v, m) {
    pt(v, t, m), h[n].m(t, null), W(t, i), p && p.m(t, null), s = !0, u || (c = [Nt(t, "mousedown", e[25]), Nt(t, "mousemove", e[26]), Nt(t, "mouseover", e[28]), Nt(t, "mouseout", e[29]), Nt(t, "focus", void 0), Nt(t, "blur", void 0)], u = !0);
  }, p: function(v, m) {
    var g = n;
    (n = d(v)) === g ? h[n].p(v, m) : (qt(), tt(h[g], 1, 1, function() {
      h[g] = null;
    }), Vt(), (r = h[n]) ? r.p(v, m) : (r = h[n] = f[n](v)).c(), U(r, 1), r.m(t, i)), 66944 & m[0] && (l = !v[8].readOnly && (v[10] === "hover-insert-after" || v[16] && Ti(v[7]))), l ? p ? (p.p(v, m), 66944 & m[0] && U(p, 1)) : ((p = f$(v)).c(), U(p, 1), p.m(t, null)) : p && (qt(), tt(p, 1, 1, function() {
      p = null;
    }), Vt()), (!s || 4355 & m[0] && o !== (o = er(Xs("jse-json-node", { "jse-expanded": v[12] }, v[8].onClassName(v[1], v[0]))) + " svelte-uj4yd7")) && A(t, "class", o), (!s || 2 & m[0] && a !== (a = vp(v[1]))) && A(t, "data-path", a), 135427 & m[0] && Ut(t, "jse-root", v[17]), 70019 & m[0] && Ut(t, "jse-selected", v[16] && nn(v[7])), 70019 & m[0] && Ut(t, "jse-selected-key", v[16] && Xn(v[7])), 70019 & m[0] && Ut(t, "jse-selected-value", v[16] && en(v[7])), 5379 & m[0] && Ut(t, "jse-hovered", v[10] === "hover-collection");
  }, i: function(v) {
    s || (U(r), U(p), s = !0);
  }, o: function(v) {
    tt(r), tt(p), s = !1;
  }, d: function(v) {
    v && vt(t), h[n].d(), p && p.d(), u = !1, Dn(c);
  } };
}
function Oc(e) {
  return "margin-left: calc(".concat(e, " * var(--jse-indent-size))");
}
function LG(e, t, n) {
  var r, i, o, a, s, u, c, l, f, h = t.$$slots, d = h === void 0 ? {} : h, p = t.$$scope, v = t.value, m = t.path, g = t.expandedMap, y = t.enforceStringMap, b = t.visibleSectionsMap, k = t.validationErrorsMap, w = t.searchResultItemsMap, x = t.selection, S = t.context, T = t.onDragSelectionStart, P = Ur("jsoneditor:JSONNode"), O = void 0, j = void 0, V = void 0, E = su(function($) {
    return $;
  }, sa);
  function C($) {
    S.onDrag($);
  }
  function H($) {
    fr.selecting && (fr.selecting = !1, $.stopPropagation()), S.onDragEnd(), document.removeEventListener("mousemove", C, !0), document.removeEventListener("mouseup", H);
  }
  function X() {
    var $, q;
    return ((q = ($ = S.findElement([])) === null || $ === void 0 ? void 0 : $.getBoundingClientRect()) === null || q === void 0 ? void 0 : q.top) || 0;
  }
  function F($, q) {
    var B = X() - $.initialContentTop;
    return q.clientY - $.initialClientY - B;
  }
  function G($) {
    if (V) {
      var q = S.getJson(), B = S.getDocumentState(), D = F(V, $), _ = Av({ json: q, documentState: B, deltaY: D, items: V.items }).offset;
      _ !== V.offset && (P("drag selection", _, D), n(11, V = Ct(Ct({}, V), {}, { offset: _, didMoveItems: !0 })));
    }
  }
  function M($) {
    if (V) {
      var q = S.getJson(), B = Av({ json: q, documentState: S.getDocumentState(), deltaY: F(V, $), items: V.items }), D = B.operations, _ = B.updatedSelection;
      if (D)
        S.onPatch(D, function(st, ht) {
          return { state: Ct(Ct({}, ht), {}, { selection: _ || x }) };
        });
      else if ($.target === V.initialTarget && !V.didMoveItems) {
        var L = Fd($.target), J = KF($.target);
        J && S.onSelect(mS(q, L, J));
      }
      n(11, V = void 0), fr.dragging = !1, document.removeEventListener("mousemove", G, !0), document.removeEventListener("mouseup", M);
    }
  }
  return e.$$set = function($) {
    "value" in $ && n(0, v = $.value), "path" in $ && n(1, m = $.path), "expandedMap" in $ && n(2, g = $.expandedMap), "enforceStringMap" in $ && n(3, y = $.enforceStringMap), "visibleSectionsMap" in $ && n(4, b = $.visibleSectionsMap), "validationErrorsMap" in $ && n(5, k = $.validationErrorsMap), "searchResultItemsMap" in $ && n(6, w = $.searchResultItemsMap), "selection" in $ && n(7, x = $.selection), "context" in $ && n(8, S = $.context), "onDragSelectionStart" in $ && n(34, T = $.onDragSelectionStart), "$$scope" in $ && n(36, p = $.$$scope);
  }, e.$$.update = function() {
    2 & e.$$.dirty[0] && n(9, a = mt.exports.compileJSONPointer(m)), 516 & e.$$.dirty[0] && n(12, s = !!g && g[a] === !0), 521 & e.$$.dirty[0] && n(13, u = rl(v, y, a)), 528 & e.$$.dirty[0] && n(14, c = b ? b[a] : void 0), 544 & e.$$.dirty[0] && n(15, l = k ? k[a] : void 0), 640 & e.$$.dirty[0] && n(16, f = !!x && x.pointersMap[a] === !0), 2 & e.$$.dirty[0] && n(17, r = m.length === 0), 1 & e.$$.dirty[0] && n(19, i = Jm(v)), 2 & e.$$.dirty[0] && n(18, o = Oc(m.length));
  }, [v, m, g, y, b, k, w, x, S, a, O, V, s, u, c, l, f, r, o, i, function($, q, B, D, _, L, J, st, ht) {
    var xt = Object.keys(q).map(function(kt) {
      var I = mt.exports.appendToJSONPointer(a, kt);
      return { key: kt, value: q[kt], path: E($.concat(kt)), pointer: I, expandedMap: Qi(B, I), enforceStringMap: Qi(D, I), visibleSectionsMap: Qi(_, I), validationErrorsMap: Qi(L, I), keySearchResultItemsMap: iK(J, I), valueSearchResultItemsMap: Qi(J, I), selection: gS(st, I) };
    });
    return ht && ht.offset !== 0 && (xt = Ux(xt, ht.selectionStartIndex, ht.selectionItemsCount, ht.offset)), xt;
  }, function($, q, B, D, _, L, J, st, ht, xt) {
    for (var kt = B.start, I = Math.min(B.end, q.length), R = [], it = kt; it < I; it++) {
      var N = mt.exports.appendToJSONPointer(a, it);
      R.push({ index: it, value: q[it], path: E($.concat(String(it))), pointer: N, expandedMap: Qi(D, N), enforceStringMap: Qi(_, N), visibleSectionsMap: Qi(L, N), validationErrorsMap: Qi(J, N), searchResultItemsMap: Qi(st, N), selection: gS(ht, N) });
    }
    if (xt && xt.offset !== 0) {
      var K = R.map(function(at) {
        return at.index;
      });
      R = Ux(R, xt.selectionStartIndex, xt.selectionItemsCount, xt.offset);
      for (var z = 0; z < R.length; z++)
        R[z].index = K[z];
    }
    return R;
  }, function($) {
    $.stopPropagation();
    var q = $.ctrlKey;
    S.onExpand(m, !s, q);
  }, function($) {
    $.stopPropagation(), S.onExpand(m, !0);
  }, function($, q) {
    var B = al(m, Object.keys(v), $, q);
    return S.onPatch(B), ve(mt.exports.parseJSONPointer(B[0].path));
  }, function($) {
    if (!(function(L) {
      return L.nodeName === "DIV" && L.contentEditable === "true";
    }($.target) || $.which === 1 && cA($.target, "BUTTON"))) {
      $.stopPropagation(), $.preventDefault(), document.addEventListener("mousemove", C, !0), document.addEventListener("mouseup", H);
      var q = Fd($.target), B = S.getJson(), D = S.getDocumentState();
      if (function(L, J, st) {
        if (!L)
          return !1;
        var ht = J.slice(0);
        if (nn(L))
          for (; ht.length > 0; ) {
            if (L.pointersMap[mt.exports.compileJSONPointer(ht)] === !0)
              return !0;
            ht.pop();
          }
        return Xn(L) ? st === gn.key && rn(L.focusPath, J) : !!(en(L) && (st === gn.value && rn(L.focusPath, J) || Cc(J, L.focusPath) && J.length > L.focusPath.length && (st === gn.key || st === gn.value || st === gn.multi)));
      }(x, m, q))
        $.button === 0 && T($);
      else {
        if (fr.selecting = !0, fr.selectionAnchor = m, fr.selectionAnchorType = q, fr.selectionFocus = m, $.shiftKey)
          x && S.onSelect(tr(B, x.anchorPath, m));
        else if (q === gn.multi)
          if (r && $.target.hasAttribute("data-path")) {
            var _ = ve(GE(v, D));
            S.onSelect(gm(_));
          } else
            S.onSelect(tr(B, m, m));
        else
          S.onSelect(mS(B, q, m));
        S.focus();
      }
    }
  }, function($) {
    if (fr.selecting) {
      $.preventDefault(), $.stopPropagation(), fr.selectionFocus == null && window.getSelection && window.getSelection().empty();
      var q = Fd($.target);
      if (!rn(m, fr.selectionFocus) || q !== fr.selectionAnchorType) {
        fr.selectionFocus = m, fr.selectionAnchorType = q;
        var B = S.getJson();
        S.onSelect(tr(B, fr.selectionAnchor, fr.selectionFocus));
      }
    }
  }, function($) {
    if (!S.readOnly) {
      var q = Ge(x.focusPath);
      if (rn(m, q)) {
        var B = function(J, st) {
          var ht = [];
          function xt(at) {
            var yt = m.concat(at), jt = S.findElement(yt);
            jt != null && ht.push({ path: yt, height: jt.clientHeight });
          }
          if (Array.isArray(v)) {
            var kt = _s(J), I = mf(J), R = ve(kt), it = ve(I), N = st.find(function(at) {
              return R >= at.start && it <= at.end;
            });
            if (!N)
              return null;
            var K = N.start, z = N.end;
            tA(K, Math.min(v.length, z), function(at) {
              return xt(String(at));
            });
          } else
            Object.keys(v).forEach(xt);
          return ht;
        }(x, c || qa);
        if (P("dragSelectionStart", { selection: x, items: B }), B) {
          var D = _s(x), _ = B.findIndex(function(J) {
            return rn(J.path, D);
          }), L = Av({ json: S.getJson(), documentState: S.getDocumentState(), deltaY: 0, items: B }).offset;
          n(11, V = { initialTarget: $.target, initialClientY: $.clientY, initialContentTop: X(), selectionStartIndex: _, selectionItemsCount: ZE(x).length, items: B, offset: L, didMoveItems: !1 }), fr.dragging = !0, document.addEventListener("mousemove", G, !0), document.addEventListener("mouseup", M);
        } else
          P("Cannot drag the current selection (probably spread over multiple sections)");
      } else
        T($);
    }
  }, function($) {
    fr.selecting || fr.dragging || ($.stopPropagation(), Ea($.target, "data-type", "selectable-value") ? n(10, O = "hover-collection") : Ea($.target, "data-type", "insert-selection-area-inside") ? n(10, O = "hover-insert-inside") : Ea($.target, "data-type", "insert-selection-area-after") && n(10, O = "hover-insert-after"), clearTimeout(j));
  }, function($) {
    $.stopPropagation(), j = setTimeout(function() {
      return n(10, O = void 0);
    });
  }, function($) {
    $.shiftKey || ($.stopPropagation(), $.preventDefault(), S.onSelect(oo(m)));
  }, function($) {
    $.shiftKey || ($.stopPropagation(), $.preventDefault(), S.onSelect(Po(m)));
  }, function($) {
    S.onSelect(oo(m)), S.onContextMenu($);
  }, function($) {
    S.onSelect(Po(m)), S.onContextMenu($);
  }, T, d, p];
}
var V0 = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, LG, DG, Ue, { value: 0, path: 1, expandedMap: 2, enforceStringMap: 3, visibleSectionsMap: 4, validationErrorsMap: 5, searchResultItemsMap: 6, selection: 7, context: 8, onDragSelectionStart: 34 }, mG, [-1, -1]), i;
  }
  return Y(n);
}();
function zG(e) {
  var t, n;
  return t = new c0({ props: { items: e[0] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & xe(i, 1)[0] && (o.items = r[0]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function BG(e, t, n) {
  var r, i, o, a, s, u, c, l = t.json, f = t.selection, h = t.readOnly, d = t.showSearch, p = d !== void 0 && d, v = t.historyState, m = t.onExpandAll, g = t.onCollapseAll, y = t.onUndo, b = t.onRedo, k = t.onSort, w = t.onTransform, x = t.onContextMenu, S = t.onCopy, T = t.onRenderMenu, P = T === void 0 ? Qe : T;
  function O() {
    n(1, p = !p);
  }
  return e.$$set = function(j) {
    "json" in j && n(2, l = j.json), "selection" in j && n(3, f = j.selection), "readOnly" in j && n(4, h = j.readOnly), "showSearch" in j && n(1, p = j.showSearch), "historyState" in j && n(5, v = j.historyState), "onExpandAll" in j && n(6, m = j.onExpandAll), "onCollapseAll" in j && n(7, g = j.onCollapseAll), "onUndo" in j && n(8, y = j.onUndo), "onRedo" in j && n(9, b = j.onRedo), "onSort" in j && n(10, k = j.onSort), "onTransform" in j && n(11, w = j.onTransform), "onContextMenu" in j && n(12, x = j.onContextMenu), "onCopy" in j && n(13, S = j.onCopy), "onRenderMenu" in j && n(14, P = j.onRenderMenu);
  }, e.$$.update = function() {
    4 & e.$$.dirty && n(20, r = l !== void 0), e.$$.dirty, 1048584 & e.$$.dirty && n(17, i = r && (nn(f) || Xn(f) || en(f))), 68 & e.$$.dirty && n(19, o = { icon: qq, title: "Expand all", className: "jse-expand-all", onClick: m, disabled: !ur(l) }), 132 & e.$$.dirty && n(18, a = { icon: Vq, title: "Collapse all", className: "jse-collapse-all", onClick: g, disabled: !ur(l) }), 4 & e.$$.dirty && n(16, s = { icon: a0, title: "Search (Ctrl+F)", className: "jse-search", onClick: O, disabled: l === void 0 }), 999220 & e.$$.dirty && n(15, u = h ? [o, a, { separator: !0 }, { icon: Ff, title: "Copy (Ctrl+C)", className: "jse-copy", onClick: S, disabled: !i }, { separator: !0 }, s, { space: !0 }] : [o, a, { separator: !0 }, { icon: i0, title: "Sort", className: "jse-sort", onClick: k, disabled: h || l === void 0 }, { icon: o0, title: "Transform contents (filter, sort, project)", className: "jse-transform", onClick: w, disabled: h || l === void 0 }, s, { icon: hq, title: _C, className: "jse-contextmenu", onClick: x }, { separator: !0 }, { icon: vA, title: "Undo (Ctrl+Z)", className: "jse-undo", onClick: y, disabled: !v.canUndo }, { icon: pA, title: "Redo (Ctrl+Shift+Z)", className: "jse-redo", onClick: b, disabled: !v.canRedo }, { space: !0 }]), 49152 & e.$$.dirty && n(0, c = P("tree", u) || u);
  }, [c, p, l, f, h, v, m, g, y, b, k, w, x, S, P, u, s, i, a, o, r];
}
var FG = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, BG, zG, Ue, { json: 2, selection: 3, readOnly: 4, showSearch: 1, historyState: 5, onExpandAll: 6, onCollapseAll: 7, onUndo: 8, onRedo: 9, onSort: 10, onTransform: 11, onContextMenu: 12, onCopy: 13, onRenderMenu: 14 }), i;
  }
  return Y(n);
}();
function qG(e) {
  Te(e, "svelte-1q2qkk2", '@charset "UTF-8";.jse-welcome.svelte-1q2qkk2.svelte-1q2qkk2{flex:1;overflow:auto;font-family:var(--jse-font-family);font-size:var(--jse-font-size);display:flex;flex-direction:column;align-items:center;border-left:var(--jse-main-border);border-right:var(--jse-main-border)}.jse-welcome.svelte-1q2qkk2.svelte-1q2qkk2:last-child{border-bottom:var(--jse-main-border)}.jse-welcome.svelte-1q2qkk2 .jse-space.jse-before.svelte-1q2qkk2{flex:1}.jse-welcome.svelte-1q2qkk2 .jse-space.jse-after.svelte-1q2qkk2{flex:2}.jse-welcome.svelte-1q2qkk2 .jse-contents.svelte-1q2qkk2{margin:2em var(--jse-padding) 0;color:var(--jse-panel-color-readonly)}.jse-welcome.svelte-1q2qkk2 .jse-contents ul.svelte-1q2qkk2{list-style:"\u25CF";list-style-position:outside;padding-left:20px}.jse-welcome.svelte-1q2qkk2 .jse-contents ul li.svelte-1q2qkk2{padding-left:10px}.jse-welcome.svelte-1q2qkk2 .jse-contents ul li span.jse-bold.svelte-1q2qkk2{font-family:var(--jse-font-family-mono);font-weight:bold}');
}
function h$(e) {
  var t;
  return { c: function() {
    (t = rt("ul")).innerHTML = `<li class="svelte-1q2qkk2">Click inside the editor</li> 
        <li class="svelte-1q2qkk2">Paste clipboard data using <span class="jse-bold svelte-1q2qkk2">Ctrl+V</span></li> 
        <li class="svelte-1q2qkk2">Create a new object by typing <span class="jse-bold svelte-1q2qkk2">{</span></li> 
        <li class="svelte-1q2qkk2">Create a new array by typing <span class="jse-bold svelte-1q2qkk2">[</span></li>`, A(t, "class", "svelte-1q2qkk2");
  }, m: function(n, r) {
    pt(n, t, r);
  }, d: function(n) {
    n && vt(t);
  } };
}
function VG(e) {
  var t, n, r, i, o, a, s, u = !e[0] && h$();
  return { c: function() {
    t = rt("div"), n = rt("div"), r = bt(), i = rt("div"), o = Xt(`Empty document
    `), u && u.c(), a = bt(), s = rt("div"), A(n, "class", "jse-space jse-before svelte-1q2qkk2"), A(i, "class", "jse-contents svelte-1q2qkk2"), A(s, "class", "jse-space jse-after svelte-1q2qkk2"), A(t, "class", "jse-welcome svelte-1q2qkk2");
  }, m: function(c, l) {
    pt(c, t, l), W(t, n), W(t, r), W(t, i), W(i, o), u && u.m(i, null), W(t, a), W(t, s);
  }, p: function(c, l) {
    xe(l, 1)[0], c[0] ? u && (u.d(1), u = null) : u || ((u = h$()).c(), u.m(i, null));
  }, i: Wt, o: Wt, d: function(c) {
    c && vt(t), u && u.d();
  } };
}
function HG(e, t, n) {
  var r = t.readOnly;
  return e.$$set = function(i) {
    "readOnly" in i && n(0, r = i.readOnly);
  }, [r];
}
var WG = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, HG, VG, Ue, { readOnly: 0 }, qG), i;
  }
  return Y(n);
}();
function UG(e) {
  Te(e, "svelte-6hb2gf", ".jse-navigation-bar-dropdown.svelte-6hb2gf.svelte-6hb2gf{position:absolute;top:100%;left:0;z-index:3;background:var(--jse-navigation-bar-background);color:var(--jse-navigation-bar-dropdown-color);box-shadow:var(--jse-controls-box-shadow);display:flex;flex-direction:column;max-height:300px;overflow:auto;min-width:80px}.jse-navigation-bar-dropdown.svelte-6hb2gf button.jse-navigation-bar-dropdown-item.svelte-6hb2gf{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);border:none;background:transparent;color:inherit;cursor:pointer;outline:none;text-align:left;white-space:nowrap;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding)) 36px}.jse-navigation-bar-dropdown.svelte-6hb2gf button.jse-navigation-bar-dropdown-item.svelte-6hb2gf:focus,.jse-navigation-bar-dropdown.svelte-6hb2gf button.jse-navigation-bar-dropdown-item.svelte-6hb2gf:hover{background:var(--jse-navigation-bar-background-highlight)}.jse-navigation-bar-dropdown.svelte-6hb2gf button.jse-navigation-bar-dropdown-item.jse-selected.svelte-6hb2gf{background:var(--jse-navigation-bar-dropdown-color);color:var(--jse-navigation-bar-background)}");
}
function d$(e, t, n) {
  var r = e.slice();
  return r[4] = t[n], r;
}
function v$(e, t) {
  var n, r, i, o, a, s = bh(t[4], m$) + "";
  function u() {
    return t[3](t[4]);
  }
  return { key: e, first: null, c: function() {
    n = rt("button"), r = Xt(s), A(n, "type", "button"), A(n, "class", "jse-navigation-bar-dropdown-item svelte-6hb2gf"), A(n, "title", i = t[4]), Ut(n, "jse-selected", t[4] === t[1]), this.first = n;
  }, m: function(c, l) {
    pt(c, n, l), W(n, r), o || (a = Nt(n, "click", bC(u)), o = !0);
  }, p: function(c, l) {
    t = c, 1 & l && s !== (s = bh(t[4], m$) + "") && Ve(r, s), 1 & l && i !== (i = t[4]) && A(n, "title", i), 3 & l && Ut(n, "jse-selected", t[4] === t[1]);
  }, d: function(c) {
    c && vt(n), o = !1, a();
  } };
}
function p$(e) {
  var t, n;
  return { c: function() {
    t = rt("button"), n = Xt("..."), A(t, "type", "button"), A(t, "class", "jse-navigation-bar-dropdown-item svelte-6hb2gf"), A(t, "title", "Limited to " + zu + " items");
  }, m: function(r, i) {
    pt(r, t, i), W(t, n);
  }, p: Wt, d: function(r) {
    r && vt(t);
  } };
}
function JG(e) {
  for (var t, n, r = [], i = /* @__PURE__ */ new Map(), o = Vx(e[0], zu), a = function(f) {
    return f[4];
  }, s = 0; s < o.length; s += 1) {
    var u = d$(e, o, s), c = a(u);
    i.set(c, r[s] = v$(c, u));
  }
  var l = e[0].length > zu && p$();
  return { c: function() {
    t = rt("div");
    for (var f = 0; f < r.length; f += 1)
      r[f].c();
    n = bt(), l && l.c(), A(t, "class", "jse-navigation-bar-dropdown svelte-6hb2gf");
  }, m: function(f, h) {
    pt(f, t, h);
    for (var d = 0; d < r.length; d += 1)
      r[d].m(t, null);
    W(t, n), l && l.m(t, null);
  }, p: function(f, h) {
    var d = xe(h, 1)[0];
    7 & d && (o = Vx(f[0], zu), r = Nc(r, d, a, 1, f, o, i, t, UD, v$, n, d$)), f[0].length > zu ? l ? l.p(f, d) : ((l = p$()).c(), l.m(t, null)) : l && (l.d(1), l = null);
  }, i: Wt, o: Wt, d: function(f) {
    f && vt(t);
    for (var h = 0; h < r.length; h += 1)
      r[h].d();
    l && l.d();
  } };
}
var zu = 100, m$ = 30;
function KG(e, t, n) {
  var r = t.items, i = t.selectedItem, o = t.onSelect;
  return e.$$set = function(a) {
    "items" in a && n(0, r = a.items), "selectedItem" in a && n(1, i = a.selectedItem), "onSelect" in a && n(2, o = a.onSelect);
  }, [r, i, o, function(a) {
    return o(a);
  }];
}
var GG = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, KG, JG, Ue, { items: 0, selectedItem: 1, onSelect: 2 }, UG), i;
  }
  return Y(n);
}();
function QG(e) {
  Te(e, "svelte-1r1k9th", ".jse-navigation-bar-item.svelte-1r1k9th.svelte-1r1k9th{position:relative;display:flex}.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.svelte-1r1k9th{font-family:inherit;font-size:inherit;padding:calc(0.5 * var(--jse-padding)) 2px;border:none;background:transparent;color:inherit;cursor:pointer;outline:none;min-width:2em;white-space:nowrap}.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.svelte-1r1k9th:focus,.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.svelte-1r1k9th:hover{background:var(--jse-panel-button-background-highlight);color:var(--jse-panel-button-color-highlight)}.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.jse-navigation-bar-arrow.svelte-1r1k9th{padding:2px var(--jse-padding) 0}.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.jse-navigation-bar-arrow.jse-open.svelte-1r1k9th{background:var(--jse-navigation-bar-background);color:var(--jse-navigation-bar-dropdown-color)}.jse-navigation-bar-item.svelte-1r1k9th.svelte-1r1k9th:last-child{padding-right:var(--jse-padding)}");
}
function g$(e) {
  var t, n, r, i;
  return { c: function() {
    t = rt("button"), n = Xt(e[2]), A(t, "type", "button"), A(t, "class", "jse-navigation-bar-button svelte-1r1k9th");
  }, m: function(o, a) {
    pt(o, t, a), W(t, n), r || (i = Nt(t, "click", e[9]), r = !0);
  }, p: function(o, a) {
    4 & a && Ve(n, o[2]);
  }, d: function(o) {
    o && vt(t), r = !1, i();
  } };
}
function XG(e) {
  var t, n, r, i, o, a, s;
  r = new Le({ props: { data: dA } });
  var u = e[2] !== void 0 && g$(e);
  return { c: function() {
    t = rt("div"), n = rt("button"), Pt(r.$$.fragment), i = bt(), u && u.c(), A(n, "type", "button"), A(n, "class", "jse-navigation-bar-button jse-navigation-bar-arrow svelte-1r1k9th"), Ut(n, "jse-open", e[1]), A(t, "class", "jse-navigation-bar-item svelte-1r1k9th");
  }, m: function(c, l) {
    pt(c, t, l), W(t, n), Ot(r, n, null), W(t, i), u && u.m(t, null), e[10](t), o = !0, a || (s = Nt(n, "click", e[4]), a = !0);
  }, p: function(c, l) {
    var f = xe(l, 1)[0];
    2 & f && Ut(n, "jse-open", c[1]), c[2] !== void 0 ? u ? u.p(c, f) : ((u = g$(c)).c(), u.m(t, null)) : u && (u.d(1), u = null);
  }, i: function(c) {
    o || (U(r.$$.fragment, c), o = !0);
  }, o: function(c) {
    tt(r.$$.fragment, c), o = !1;
  }, d: function(c) {
    c && vt(t), At(r), u && u.d(), e[10](null), a = !1, s();
  } };
}
function ZG(e, t, n) {
  var r, i, o, a, s = Hr("absolute-popup"), u = s.openAbsolutePopup, c = s.closeAbsolutePopup, l = t.path, f = t.index, h = t.onSelect, d = t.getItems, p = !1;
  function v(m) {
    c(a), h(r.concat(m));
  }
  return e.$$set = function(m) {
    "path" in m && n(5, l = m.path), "index" in m && n(6, f = m.index), "onSelect" in m && n(7, h = m.onSelect), "getItems" in m && n(8, d = m.getItems);
  }, e.$$.update = function() {
    96 & e.$$.dirty && (r = l.slice(0, f)), 96 & e.$$.dirty && n(2, i = l[f]);
  }, [o, p, i, v, function() {
    if (o) {
      n(1, p = !0);
      var m = { items: d(r), selectedItem: i, onSelect: v };
      a = u(GG, m, { anchor: o, closeOnOuterClick: !0, onClose: function() {
        n(1, p = !1);
      } });
    }
  }, l, f, h, d, function() {
    return v(i);
  }, function(m) {
    Be[m ? "unshift" : "push"](function() {
      n(0, o = m);
    });
  }];
}
var oM = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, ZG, XG, Ue, { path: 5, index: 6, onSelect: 7, getItems: 8 }, QG), i;
  }
  return Y(n);
}(), aM = { exports: {} }, y$ = function(e, t) {
  var n, r, i = 1, o = 0, a = 0, s = String.alphabet;
  function u(c, l, f) {
    if (f) {
      for (n = l; (f = u(c, n)) < 76 && f > 65; )
        ++n;
      return +c.slice(l - 1, n);
    }
    return (f = s && s.indexOf(c.charAt(l))) > -1 ? f + 76 : (f = c.charCodeAt(l) || 0) < 45 || f > 127 ? f : f < 46 ? 65 : f < 48 ? f - 1 : f < 58 ? f + 18 : f < 65 ? f - 11 : f < 91 ? f + 11 : f < 97 ? f - 37 : f < 123 ? f + 5 : f - 63;
  }
  if ((e += "") != (t += "")) {
    for (; i; )
      if (r = u(e, o++), i = u(t, a++), r < 76 && i < 76 && r > 66 && i > 66 && (r = u(e, o, o), i = u(t, a, o = n), a = n), r != i)
        return r < i ? -1 : 1;
  }
  return 0;
};
try {
  aM.exports = y$;
} catch {
  String.naturalCompare = y$;
}
function H0(e, t) {
  var n = typeof e == "string" ? e.toLowerCase() : e, r = typeof t == "string" ? t.toLowerCase() : t;
  return aM.exports(n, r);
}
function YG(e, t) {
  return function(n, r) {
    var i = mt.exports.getIn(n, e), o = mt.exports.getIn(r, e);
    return i === void 0 ? t : o === void 0 ? -t : typeof i != "string" && typeof o != "string" ? i > o ? t : i < o ? -t : 0 : t * H0(i, o);
  };
}
function tQ(e) {
  Te(e, "svelte-5lwyke", ".jse-navigation-bar.svelte-5lwyke.svelte-5lwyke{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);background:var(--jse-panel-background);color:var(--jse-panel-button-color);padding:0;margin:0;display:flex;overflow:auto;border-left:var(--jse-main-border);border-right:var(--jse-main-border)}.jse-navigation-bar.svelte-5lwyke .jse-navigation-bar-space.svelte-5lwyke{padding:calc(0.5 * var(--jse-padding)) var(--jse-padding);color:var(--jse-navigation-bar-color)}");
}
function b$(e, t, n) {
  var r = e.slice();
  return r[11] = t[n], r[13] = n, r;
}
function k$(e, t) {
  var n, r, i;
  return r = new oM({ props: { getItems: t[4], path: t[1], index: t[13], onSelect: t[5] } }), { key: e, first: null, c: function() {
    n = Ye(), Pt(r.$$.fragment), this.first = n;
  }, m: function(o, a) {
    pt(o, n, a), Ot(r, o, a), i = !0;
  }, p: function(o, a) {
    t = o;
    var s = {};
    2 & a && (s.path = t[1]), 2 & a && (s.index = t[13]), r.$set(s);
  }, i: function(o) {
    i || (U(r.$$.fragment, o), i = !0);
  }, o: function(o) {
    tt(r.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && vt(n), At(r, o);
  } };
}
function w$(e) {
  var t, n;
  return t = new oM({ props: { getItems: e[4], path: e[1], index: void 0, onSelect: e[5] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2 & i && (o.path = r[1]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function eQ(e) {
  for (var t, n, r, i, o, a, s = [], u = /* @__PURE__ */ new Map(), c = ur(e[0]) ? "\xA0" : "Navigation bar", l = e[1], f = function(m) {
    return m[13];
  }, h = 0; h < l.length; h += 1) {
    var d = b$(e, l, h), p = f(d);
    u.set(p, s[h] = k$(p, d));
  }
  var v = e[3] && w$(e);
  return { c: function() {
    t = rt("div");
    for (var m = 0; m < s.length; m += 1)
      s[m].c();
    n = bt(), v && v.c(), r = bt(), i = rt("div"), o = Xt(c), A(i, "class", "jse-navigation-bar-space svelte-5lwyke"), A(t, "class", "jse-navigation-bar svelte-5lwyke");
  }, m: function(m, g) {
    pt(m, t, g);
    for (var y = 0; y < s.length; y += 1)
      s[y].m(t, null);
    W(t, n), v && v.m(t, null), W(t, r), W(t, i), W(i, o), e[8](t), a = !0;
  }, p: function(m, g) {
    var y = xe(g, 1)[0];
    50 & y && (l = m[1], qt(), s = Nc(s, y, f, 1, m, l, u, t, Eh, k$, n, b$), Vt()), m[3] ? v ? (v.p(m, y), 8 & y && U(v, 1)) : ((v = w$(m)).c(), U(v, 1), v.m(t, r)) : v && (qt(), tt(v, 1, 1, function() {
      v = null;
    }), Vt()), (!a || 1 & y) && c !== (c = ur(m[0]) ? "\xA0" : "Navigation bar") && Ve(o, c);
  }, i: function(m) {
    if (!a) {
      for (var g = 0; g < l.length; g += 1)
        U(s[g]);
      U(v), a = !0;
    }
  }, o: function(m) {
    for (var g = 0; g < s.length; g += 1)
      tt(s[g]);
    tt(v), a = !1;
  }, d: function(m) {
    m && vt(t);
    for (var g = 0; g < s.length; g += 1)
      s[g].d();
    v && v.d(), e[8](null);
  } };
}
function nQ(e, t, n) {
  var r, i, o, a = Ur("jsoneditor:NavigationBar"), s = t.json, u = t.documentState, c = t.onSelect;
  return e.$$set = function(l) {
    "json" in l && n(0, s = l.json), "documentState" in l && n(6, u = l.documentState), "onSelect" in l && n(7, c = l.onSelect);
  }, e.$$.update = function() {
    64 & e.$$.dirty && n(1, r = u.selection ? u.selection.focusPath : []), 3 & e.$$.dirty && n(3, i = ur(mt.exports.getIn(s, r))), 2 & e.$$.dirty && setTimeout(function() {
      if (o && o.scrollTo) {
        var l = o.scrollWidth - o.clientWidth;
        l > 0 && (a("scrollTo ", l), o.scrollTo({ left: l, behavior: "smooth" }));
      }
    });
  }, [s, r, o, i, function(l) {
    a("get items for path", l);
    var f = mt.exports.getIn(s, l);
    if (Array.isArray(f))
      return Kg(0, f.length).map(String);
    if (mr(f)) {
      var h = Object.keys(f).slice(0);
      return h.sort(H0), h;
    }
    return [];
  }, function(l) {
    a("select path", JSON.stringify(l)), c(tr(s, l, l));
  }, u, c, function(l) {
    Be[l ? "unshift" : "push"](function() {
      n(2, o = l);
    });
  }];
}
var rQ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, nQ, eQ, Ue, { json: 0, documentState: 6, onSelect: 7 }, tQ), i;
  }
  return Y(n);
}();
function iQ(e) {
  Te(e, "svelte-18vllqh", ".jse-search-box.svelte-18vllqh.svelte-18vllqh{border:var(--jse-panel-border);border-radius:3px;font-family:var(--jse-font-family);font-size:var(--jse-font-size);background:var(--jse-panel-background);color:var(--jse-panel-color-readonly);box-shadow:var(--jse-controls-box-shadow);display:inline-block;width:400px;max-width:100%;overflow:auto}.jse-search-box.svelte-18vllqh .jse-search-form.svelte-18vllqh{display:flex;align-items:stretch}.jse-search-box.svelte-18vllqh .jse-search-form button.svelte-18vllqh,.jse-search-box.svelte-18vllqh .jse-search-form input.svelte-18vllqh{font-family:inherit;font-size:inherit}.jse-search-box.svelte-18vllqh .jse-search-form button.svelte-18vllqh{display:block;text-align:center;border:none;padding:0 5px;margin:0;cursor:pointer;color:var(--jse-panel-button-color);background:var(--jse-panel-button-background)}.jse-search-box.svelte-18vllqh .jse-search-form button.svelte-18vllqh:hover{color:var(--jse-panel-button-color-highlight);background:var(--jse-panel-button-background-highlight)}.jse-search-box.svelte-18vllqh .jse-search-form input.svelte-18vllqh{color:var(--jse-panel-color);border:var(--jse-input-border);border-radius:3px;background:var(--jse-input-background);height:28px;padding:0 5px;margin:0;flex:1;outline:none}.jse-search-box.svelte-18vllqh .jse-search-form .jse-replace-toggle.svelte-18vllqh{padding:var(--jse-padding) calc(0.5 * var(--jse-padding));min-width:20px;background:var(--jse-panel-button-background-highlight)}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents.svelte-18vllqh{flex:1;display:flex;flex-direction:column;padding:calc(0.5 * var(--jse-padding));gap:calc(0.5 * var(--jse-padding))}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section.svelte-18vllqh{flex:1;display:flex;align-items:center;position:relative;padding-left:32px}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section .jse-search-icon.svelte-18vllqh{color:inherit;cursor:inherit;background:inherit;position:absolute;top:calc(0.5 * var(--jse-padding));left:calc(0.5 * var(--jse-padding))}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section label.jse-search-input-label.svelte-18vllqh{flex:1;display:flex}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.svelte-18vllqh{color:inherit;font-size:80%;visibility:hidden;padding:0 5px;min-width:36px;text-align:center}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.jse-visible.svelte-18vllqh{visibility:visible}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-replace-section.svelte-18vllqh{padding-left:32px;flex:1;display:flex}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-replace-section button.svelte-18vllqh{width:auto}");
}
function x$(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b, k, w, x, S, T, P, O, j, V, E = (e[3] !== -1 ? "".concat(e[3] + 1, "/") : "") + "", C = !e[4] && j$(e), H = [aQ, oQ], X = [];
  function F(M, $) {
    return M[2] ? 0 : 1;
  }
  s = F(e), u = X[s] = H[s](e), y = new Le({ props: { data: sq } }), w = new Le({ props: { data: uq } }), T = new Le({ props: { data: Gc } });
  var G = e[0] && !e[4] && S$(e);
  return { c: function() {
    t = rt("div"), n = rt("form"), C && C.c(), r = bt(), i = rt("div"), o = rt("div"), a = rt("div"), u.c(), c = bt(), l = rt("label"), f = rt("input"), h = bt(), d = rt("div"), p = Xt(E), v = Xt(e[10]), m = bt(), g = rt("button"), Pt(y.$$.fragment), b = bt(), k = rt("button"), Pt(w.$$.fragment), x = bt(), S = rt("button"), Pt(T.$$.fragment), P = bt(), G && G.c(), A(a, "class", "jse-search-icon svelte-18vllqh"), A(f, "class", "jse-search-input svelte-18vllqh"), A(f, "title", "Enter text to search"), A(f, "type", "text"), A(f, "placeholder", "Find"), A(l, "class", "jse-search-input-label svelte-18vllqh"), A(l, "about", "jse-search input"), A(d, "class", "jse-search-count svelte-18vllqh"), Ut(d, "jse-visible", e[8] !== ""), A(g, "type", "button"), A(g, "class", "jse-search-next svelte-18vllqh"), A(g, "title", "Go to next search result (Enter)"), A(k, "type", "button"), A(k, "class", "jse-search-previous svelte-18vllqh"), A(k, "title", "Go to previous search result (Shift+Enter)"), A(S, "type", "button"), A(S, "class", "jse-search-clear svelte-18vllqh"), A(S, "title", "Close search box (Esc)"), A(o, "class", "jse-search-section svelte-18vllqh"), A(i, "class", "jse-search-contents svelte-18vllqh"), A(n, "class", "jse-search-form svelte-18vllqh"), A(t, "class", "jse-search-box svelte-18vllqh");
  }, m: function(M, $) {
    pt(M, t, $), W(t, n), C && C.m(n, null), W(n, r), W(n, i), W(i, o), W(o, a), X[s].m(a, null), W(o, c), W(o, l), W(l, f), ra(f, e[8]), W(o, h), W(o, d), W(d, p), W(d, v), W(o, m), W(o, g), Ot(y, g, null), W(o, b), W(o, k), Ot(w, k, null), W(o, x), W(o, S), Ot(T, S, null), W(i, P), G && G.m(i, null), O = !0, j || (V = [Nt(f, "input", e[21]), Ic(uQ.call(null, f)), Nt(g, "click", e[22]), Nt(k, "click", e[23]), Nt(S, "click", e[24]), Nt(n, "submit", e[12]), Nt(n, "keydown", e[13])], j = !0);
  }, p: function(M, $) {
    M[4] ? C && (qt(), tt(C, 1, 1, function() {
      C = null;
    }), Vt()) : C ? (C.p(M, $), 16 & $ && U(C, 1)) : ((C = j$(M)).c(), U(C, 1), C.m(n, r));
    var q = s;
    (s = F(M)) === q ? X[s].p(M, $) : (qt(), tt(X[q], 1, 1, function() {
      X[q] = null;
    }), Vt(), (u = X[s]) ? u.p(M, $) : (u = X[s] = H[s](M)).c(), U(u, 1), u.m(a, null)), 256 & $ && f.value !== M[8] && ra(f, M[8]), (!O || 8 & $) && E !== (E = (M[3] !== -1 ? "".concat(M[3] + 1, "/") : "") + "") && Ve(p, E), (!O || 1024 & $) && Ve(v, M[10]), 256 & $ && Ut(d, "jse-visible", M[8] !== ""), M[0] && !M[4] ? G ? G.p(M, $) : ((G = S$(M)).c(), G.m(i, null)) : G && (G.d(1), G = null);
  }, i: function(M) {
    O || (U(C), U(u), U(y.$$.fragment, M), U(w.$$.fragment, M), U(T.$$.fragment, M), O = !0);
  }, o: function(M) {
    tt(C), tt(u), tt(y.$$.fragment, M), tt(w.$$.fragment, M), tt(T.$$.fragment, M), O = !1;
  }, d: function(M) {
    M && vt(t), C && C.d(), X[s].d(), At(y), At(w), At(T), G && G.d(), j = !1, Dn(V);
  } };
}
function j$(e) {
  var t, n, r, i, o;
  return n = new Le({ props: { data: e[0] ? no : Qo } }), { c: function() {
    t = rt("button"), Pt(n.$$.fragment), A(t, "type", "button"), A(t, "class", "jse-replace-toggle svelte-18vllqh"), A(t, "title", "Toggle visibility of replace options (Ctrl+H)");
  }, m: function(a, s) {
    pt(a, t, s), Ot(n, t, null), r = !0, i || (o = Nt(t, "click", e[11]), i = !0);
  }, p: function(a, s) {
    var u = {};
    1 & s && (u.data = a[0] ? no : Qo), n.$set(u);
  }, i: function(a) {
    r || (U(n.$$.fragment, a), r = !0);
  }, o: function(a) {
    tt(n.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && vt(t), At(n), i = !1, o();
  } };
}
function oQ(e) {
  var t, n;
  return t = new Le({ props: { data: a0 } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: Wt, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function aQ(e) {
  var t, n;
  return t = new Le({ props: { data: cq, spin: !0 } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: Wt, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function S$(e) {
  var t, n, r, i, o, a, s, u;
  return { c: function() {
    t = rt("div"), n = rt("input"), r = bt(), (i = rt("button")).textContent = "Replace", o = bt(), (a = rt("button")).textContent = "All", A(n, "class", "jse-replace-input svelte-18vllqh"), A(n, "title", "Enter replacement text"), A(n, "type", "text"), A(n, "placeholder", "Replace"), A(i, "type", "button"), A(i, "title", "Replace current occurrence (Ctrl+Enter)"), A(i, "class", "svelte-18vllqh"), A(a, "type", "button"), A(a, "title", "Replace all occurrences"), A(a, "class", "svelte-18vllqh"), A(t, "class", "jse-replace-section svelte-18vllqh");
  }, m: function(c, l) {
    pt(c, t, l), W(t, n), ra(n, e[9]), W(t, r), W(t, i), W(t, o), W(t, a), s || (u = [Nt(n, "input", e[25]), Nt(i, "click", e[14]), Nt(a, "click", e[15])], s = !0);
  }, p: function(c, l) {
    512 & l && n.value !== c[9] && ra(n, c[9]);
  }, d: function(c) {
    c && vt(t), s = !1, Dn(u);
  } };
}
function sQ(e) {
  var t, n, r = e[1] && x$(e);
  return { c: function() {
    r && r.c(), t = Ye();
  }, m: function(i, o) {
    r && r.m(i, o), pt(i, t, o), n = !0;
  }, p: function(i, o) {
    var a = xe(o, 1)[0];
    i[1] ? r ? (r.p(i, a), 2 & a && U(r, 1)) : ((r = x$(i)).c(), U(r, 1), r.m(t.parentNode, t)) : r && (qt(), tt(r, 1, 1, function() {
      r = null;
    }), Vt());
  }, i: function(i) {
    n || (U(r), n = !0);
  }, o: function(i) {
    tt(r), n = !1;
  }, d: function(i) {
    r && r.d(i), i && vt(t);
  } };
}
function uQ(e) {
  e.select();
}
function cQ(e, t, n) {
  var r, i, o = t.show, a = o !== void 0 && o, s = t.searching, u = t.resultCount, c = u === void 0 ? 0 : u, l = t.activeIndex, f = l === void 0 ? 0 : l, h = t.showReplace, d = h !== void 0 && h, p = t.readOnly, v = p !== void 0 && p, m = t.onChange, g = m === void 0 ? Qe : m, y = t.onPrevious, b = y === void 0 ? Qe : y, k = t.onNext, w = k === void 0 ? Qe : k, x = t.onReplace, S = x === void 0 ? Qe : x, T = t.onReplaceAll, P = T === void 0 ? Qe : T, O = t.onClose, j = O === void 0 ? Qe : O, V = "", E = "", C = "";
  function H() {
    n(0, d = !d && !v);
  }
  function X() {
    v || S(V, C);
  }
  return e.$$set = function(F) {
    "show" in F && n(1, a = F.show), "searching" in F && n(2, s = F.searching), "resultCount" in F && n(16, c = F.resultCount), "activeIndex" in F && n(3, f = F.activeIndex), "showReplace" in F && n(0, d = F.showReplace), "readOnly" in F && n(4, v = F.readOnly), "onChange" in F && n(17, g = F.onChange), "onPrevious" in F && n(5, b = F.onPrevious), "onNext" in F && n(6, w = F.onNext), "onReplace" in F && n(18, S = F.onReplace), "onReplaceAll" in F && n(19, P = F.onReplaceAll), "onClose" in F && n(7, j = F.onClose);
  }, e.$$.update = function() {
    65536 & e.$$.dirty && n(10, r = c >= 1e3 ? "".concat(999, "+") : String(c)), 131072 & e.$$.dirty && n(20, i = fu(g, 300)), 1048832 & e.$$.dirty && i(V), 2 & e.$$.dirty && a && V !== "" && g(V);
  }, [d, a, s, f, v, b, w, j, V, C, r, H, function(F) {
    F.preventDefault(), V !== E ? (E = V, i.cancel(), g(V)) : w();
  }, function(F) {
    F.stopPropagation();
    var G = vu(F);
    G === "Enter" && (F.preventDefault(), w()), G === "Shift+Enter" && (F.preventDefault(), b()), G !== "Ctrl+Enter" && G !== "Command+Enter" || (F.preventDefault(), d ? X() : w()), G === "Ctrl+H" && (F.preventDefault(), H()), G === "Escape" && (F.preventDefault(), j());
  }, X, function() {
    v || P(V, C);
  }, c, g, S, P, i, function() {
    V = this.value, n(8, V);
  }, function() {
    return w();
  }, function() {
    return b();
  }, function() {
    return j();
  }, function() {
    C = this.value, n(9, C);
  }];
}
var lQ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, cQ, sQ, Ue, { show: 1, searching: 2, resultCount: 16, activeIndex: 3, showReplace: 0, readOnly: 4, onChange: 17, onPrevious: 5, onNext: 6, onReplace: 18, onReplaceAll: 19, onClose: 7 }, iQ), i;
  }
  return Y(n);
}(), fQ = Vm.window;
function hQ(e) {
  Te(e, "svelte-1wno2xw", ".jse-tree-mode.svelte-1wno2xw.svelte-1wno2xw{flex:1;display:flex;flex-direction:column;position:relative;background:var(--jse-background-color);min-width:0;min-height:0;font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);color:var(--jse-text-color);line-height:var(--jse-line-height)}.jse-tree-mode.svelte-1wno2xw .jse-hidden-input-label.svelte-1wno2xw{position:absolute;right:0;top:0;width:0;height:0}.jse-tree-mode.svelte-1wno2xw .jse-hidden-input-label .jse-hidden-input.svelte-1wno2xw{width:0;height:0;padding:0;border:0;outline:none}.jse-tree-mode.svelte-1wno2xw .jse-search-box-container.svelte-1wno2xw{position:relative;height:0;top:var(--jse-padding);margin-right:calc(var(--jse-padding) + 20px);margin-left:var(--jse-padding);text-align:right;z-index:3}.jse-tree-mode.no-main-menu.svelte-1wno2xw.svelte-1wno2xw{border-top:var(--jse-main-border)}.jse-tree-mode.svelte-1wno2xw .jse-contents.svelte-1wno2xw{border-left:var(--jse-main-border);border-right:var(--jse-main-border);flex:1;overflow:auto;position:relative;padding:2px;display:flex;flex-direction:column}.jse-tree-mode.svelte-1wno2xw .jse-contents.svelte-1wno2xw:last-child{border-bottom:var(--jse-main-border)}.jse-tree-mode.svelte-1wno2xw .jse-contents .jse-loading-space.svelte-1wno2xw{flex:1}.jse-tree-mode.svelte-1wno2xw .jse-contents .jse-loading.svelte-1wno2xw{flex:2;text-align:center;color:var(--jse-panel-color-readonly);box-sizing:border-box;font-family:var(--jse-font-family);font-size:var(--jse-font-size)}.jse-tree-mode.svelte-1wno2xw .jse-preview.svelte-1wno2xw{flex:1;color:var(--jse-panel-color-readonly);overflow:auto;white-space:pre-wrap;padding:2px}");
}
function $$(e) {
  var t, n, r;
  function i(a) {
    e[69](a);
  }
  var o = { json: e[7], selection: e[13].selection, readOnly: e[0], historyState: e[19], onExpandAll: e[37], onCollapseAll: e[38], onUndo: e[33], onRedo: e[34], onSort: e[35], onTransform: e[36], onContextMenu: e[42], onCopy: e[31], onRenderMenu: e[4] };
  return e[16] !== void 0 && (o.showSearch = e[16]), t = new FG({ props: o }), Be.push(function() {
    return Kr(t, "showSearch", i);
  }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(a, s) {
    Ot(t, a, s), r = !0;
  }, p: function(a, s) {
    var u = {};
    128 & s[0] && (u.json = a[7]), 8192 & s[0] && (u.selection = a[13].selection), 1 & s[0] && (u.readOnly = a[0]), 524288 & s[0] && (u.historyState = a[19]), 16 & s[0] && (u.onRenderMenu = a[4]), !n && 65536 & s[0] && (n = !0, u.showSearch = a[16], di(function() {
      return n = !1;
    })), t.$set(u);
  }, i: function(a) {
    r || (U(t.$$.fragment, a), r = !0);
  }, o: function(a) {
    tt(t.$$.fragment, a), r = !1;
  }, d: function(a) {
    At(t, a);
  } };
}
function _$(e) {
  var t, n;
  return t = new rQ({ props: { json: e[7], documentState: e[13], onSelect: e[45] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    128 & i[0] && (o.json = r[7]), 8192 & i[0] && (o.documentState = r[13]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function dQ(e) {
  var t;
  return { c: function() {
    (t = rt("div")).innerHTML = `<div class="jse-loading-space svelte-1wno2xw"></div> 
      <div class="jse-loading svelte-1wno2xw">loading...</div>`, A(t, "class", "jse-contents svelte-1wno2xw");
  }, m: function(n, r) {
    pt(n, t, r);
  }, p: Wt, i: Wt, o: Wt, d: function(n) {
    n && vt(t);
  } };
}
function vQ(e) {
  var t, n, r, i, o, a, s, u, c, l = [mQ, pQ], f = [];
  function h(d, p) {
    return d[7] === void 0 ? 0 : 1;
  }
  return i = h(e), o = f[i] = l[i](e), { c: function() {
    t = rt("label"), n = rt("input"), r = bt(), o.c(), a = Ye(), A(n, "class", "jse-hidden-input svelte-1wno2xw"), A(n, "tabindex", "-1"), A(t, "class", "jse-hidden-input-label svelte-1wno2xw");
  }, m: function(d, p) {
    pt(d, t, p), W(t, n), e[70](n), pt(d, r, p), f[i].m(d, p), pt(d, a, p), s = !0, u || (c = Nt(n, "paste", e[32]), u = !0);
  }, p: function(d, p) {
    var v = i;
    (i = h(d)) === v ? f[i].p(d, p) : (qt(), tt(f[v], 1, 1, function() {
      f[v] = null;
    }), Vt(), (o = f[i]) ? o.p(d, p) : (o = f[i] = l[i](d)).c(), U(o, 1), o.m(a.parentNode, a));
  }, i: function(d) {
    s || (U(o), s = !0);
  }, o: function(d) {
    tt(o), s = !1;
  }, d: function(d) {
    d && vt(t), e[70](null), d && vt(r), f[i].d(d), d && vt(a), u = !1, c();
  } };
}
function pQ(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p;
  a = new lQ({ props: { show: e[16], resultCount: ((t = e[14]) === null || t === void 0 || (n = t.items) === null || n === void 0 ? void 0 : n.length) || 0, activeIndex: ((r = e[14]) === null || r === void 0 ? void 0 : r.activeIndex) || 0, showReplace: e[17], searching: e[18], readOnly: e[0], onChange: e[24], onNext: e[25], onPrevious: e[26], onReplace: e[27], onReplaceAll: e[28], onClose: e[29] } }), c = new V0({ props: { value: e[7], path: e[23], expandedMap: e[13].expandedMap, enforceStringMap: e[13].enforceStringMap, visibleSectionsMap: e[13].visibleSectionsMap, validationErrorsMap: e[21], searchResultItemsMap: (i = e[14]) === null || i === void 0 ? void 0 : i.itemsMap, selection: e[13].selection, context: e[10], onDragSelectionStart: Qe } });
  var v = e[15] && C$(e), m = e[20] && O$(e);
  return d = new bA({ props: { validationErrors: e[9], selectError: e[30] } }), { c: function() {
    o = rt("div"), Pt(a.$$.fragment), s = bt(), u = rt("div"), Pt(c.$$.fragment), l = bt(), v && v.c(), f = bt(), m && m.c(), h = bt(), Pt(d.$$.fragment), A(o, "class", "jse-search-box-container svelte-1wno2xw"), A(u, "class", "jse-contents svelte-1wno2xw"), A(u, "data-jsoneditor-scrollable-contents", !0);
  }, m: function(g, y) {
    pt(g, o, y), Ot(a, o, null), pt(g, s, y), pt(g, u, y), Ot(c, u, null), e[71](u), pt(g, l, y), v && v.m(g, y), pt(g, f, y), m && m.m(g, y), pt(g, h, y), Ot(d, g, y), p = !0;
  }, p: function(g, y) {
    var b, k, w, x, S = {};
    65536 & y[0] && (S.show = g[16]), 16384 & y[0] && (S.resultCount = ((b = g[14]) === null || b === void 0 || (k = b.items) === null || k === void 0 ? void 0 : k.length) || 0), 16384 & y[0] && (S.activeIndex = ((w = g[14]) === null || w === void 0 ? void 0 : w.activeIndex) || 0), 131072 & y[0] && (S.showReplace = g[17]), 262144 & y[0] && (S.searching = g[18]), 1 & y[0] && (S.readOnly = g[0]), a.$set(S);
    var T = {};
    128 & y[0] && (T.value = g[7]), 8192 & y[0] && (T.expandedMap = g[13].expandedMap), 8192 & y[0] && (T.enforceStringMap = g[13].enforceStringMap), 8192 & y[0] && (T.visibleSectionsMap = g[13].visibleSectionsMap), 2097152 & y[0] && (T.validationErrorsMap = g[21]), 16384 & y[0] && (T.searchResultItemsMap = (x = g[14]) === null || x === void 0 ? void 0 : x.itemsMap), 8192 & y[0] && (T.selection = g[13].selection), 1024 & y[0] && (T.context = g[10]), c.$set(T), g[15] ? v ? (v.p(g, y), 32768 & y[0] && U(v, 1)) : ((v = C$(g)).c(), U(v, 1), v.m(f.parentNode, f)) : v && (qt(), tt(v, 1, 1, function() {
      v = null;
    }), Vt()), g[20] ? m ? (m.p(g, y), 1048576 & y[0] && U(m, 1)) : ((m = O$(g)).c(), U(m, 1), m.m(h.parentNode, h)) : m && (qt(), tt(m, 1, 1, function() {
      m = null;
    }), Vt());
    var P = {};
    512 & y[0] && (P.validationErrors = g[9]), d.$set(P);
  }, i: function(g) {
    p || (U(a.$$.fragment, g), U(c.$$.fragment, g), U(v), U(m), U(d.$$.fragment, g), p = !0);
  }, o: function(g) {
    tt(a.$$.fragment, g), tt(c.$$.fragment, g), tt(v), tt(m), tt(d.$$.fragment, g), p = !1;
  }, d: function(g) {
    g && vt(o), At(a), g && vt(s), g && vt(u), At(c), e[71](null), g && vt(l), v && v.d(g), g && vt(f), m && m.d(g), g && vt(h), At(d, g);
  } };
}
function mQ(e) {
  var t, n, r, i, o = [yQ, gQ], a = [];
  function s(u, c) {
    return u[8] === "" || u[8] === void 0 ? 0 : 1;
  }
  return t = s(e), n = a[t] = o[t](e), { c: function() {
    n.c(), r = Ye();
  }, m: function(u, c) {
    a[t].m(u, c), pt(u, r, c), i = !0;
  }, p: function(u, c) {
    var l = t;
    (t = s(u)) === l ? a[t].p(u, c) : (qt(), tt(a[l], 1, 1, function() {
      a[l] = null;
    }), Vt(), (n = a[t]) ? n.p(u, c) : (n = a[t] = o[t](u)).c(), U(n, 1), n.m(r.parentNode, r));
  }, i: function(u) {
    i || (U(n), i = !0);
  }, o: function(u) {
    tt(n), i = !1;
  }, d: function(u) {
    a[t].d(u), u && vt(r);
  } };
}
function C$(e) {
  var t, n;
  return t = new ss({ props: { type: "info", message: "You pasted a JSON ".concat(Array.isArray(e[15].contents) ? "array" : "object", " as text"), actions: [{ icon: u0, text: "Paste as JSON instead", onMouseDown: e[43] }, { text: "Leave as is", onClick: e[44] }] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32768 & i[0] && (o.message = "You pasted a JSON ".concat(Array.isArray(r[15].contents) ? "array" : "object", " as text")), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function O$(e) {
  var t, n;
  return t = new ss({ props: { type: "success", message: "The loaded JSON document was invalid but is successfully repaired.", actions: e[0] ? [] : [{ icon: pp, text: "Ok", onClick: e[5] }, { icon: Bf, text: "Repair manually instead", onClick: e[3] }] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    9 & i[0] && (o.actions = r[0] ? [] : [{ icon: pp, text: "Ok", onClick: r[5] }, { icon: Bf, text: "Repair manually instead", onClick: r[3] }]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function gQ(e) {
  var t, n, r, i, o, a = bh(e[8], 2e4) + "";
  return t = new ss({ props: { type: "error", message: "The loaded JSON document is invalid and could not be repaired automatically.", actions: e[0] ? [] : [{ icon: Bf, text: "Repair manually", onClick: e[3] }] } }), { c: function() {
    Pt(t.$$.fragment), n = bt(), r = rt("div"), i = Xt(a), A(r, "class", "jse-preview svelte-1wno2xw");
  }, m: function(s, u) {
    Ot(t, s, u), pt(s, n, u), pt(s, r, u), W(r, i), o = !0;
  }, p: function(s, u) {
    var c = {};
    9 & u[0] && (c.actions = s[0] ? [] : [{ icon: Bf, text: "Repair manually", onClick: s[3] }]), t.$set(c), (!o || 256 & u[0]) && a !== (a = bh(s[8], 2e4) + "") && Ve(i, a);
  }, i: function(s) {
    o || (U(t.$$.fragment, s), o = !0);
  }, o: function(s) {
    tt(t.$$.fragment, s), o = !1;
  }, d: function(s) {
    At(t, s), s && vt(n), s && vt(r);
  } };
}
function yQ(e) {
  var t, n;
  return t = new WG({ props: { readOnly: e[0] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i[0] && (o.readOnly = r[0]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function bQ(e) {
  var t, n, r, i, o, a, s, u, c = e[1] && $$(e), l = e[2] && _$(e), f = [vQ, dQ], h = [];
  return i = function(d, p) {
    return d[22] ? 1 : 0;
  }(e), o = h[i] = f[i](e), { c: function() {
    t = rt("div"), c && c.c(), n = bt(), l && l.c(), r = bt(), o.c(), A(t, "class", "jse-tree-mode svelte-1wno2xw"), Ut(t, "no-main-menu", !e[1]);
  }, m: function(d, p) {
    pt(d, t, p), c && c.m(t, null), W(t, n), l && l.m(t, null), W(t, r), h[i].m(t, null), e[72](t), a = !0, s || (u = [Nt(fQ, "mousedown", e[46]), Nt(t, "keydown", e[39]), Nt(t, "mousedown", e[40]), Nt(t, "contextmenu", e[41])], s = !0);
  }, p: function(d, p) {
    d[1] ? c ? (c.p(d, p), 2 & p[0] && U(c, 1)) : ((c = $$(d)).c(), U(c, 1), c.m(t, n)) : c && (qt(), tt(c, 1, 1, function() {
      c = null;
    }), Vt()), d[2] ? l ? (l.p(d, p), 4 & p[0] && U(l, 1)) : ((l = _$(d)).c(), U(l, 1), l.m(t, r)) : l && (qt(), tt(l, 1, 1, function() {
      l = null;
    }), Vt()), o.p(d, p), 2 & p[0] && Ut(t, "no-main-menu", !d[1]);
  }, i: function(d) {
    a || (U(c), U(l), U(o), a = !0);
  }, o: function(d) {
    tt(c), tt(l), tt(o), a = !1;
  }, d: function(d) {
    d && vt(t), c && c.d(), l && l.d(), h[i].d(), e[72](null), s = !1, Dn(u);
  } };
}
function gs(e) {
  return e.length === 0 || e.length === 1 && e[0] === "0";
}
function Kl() {
  return !0;
}
function kQ(e, t, n) {
  var r, i = Ur("jsoneditor:TreeMode"), o = typeof window > "u";
  i("isSSR:", o);
  var a, s, u, c, l, f = Hr("simple-modal").open, h = qs(), d = qs(), p = Hr("absolute-popup"), v = p.openAbsolutePopup, m = p.closeAbsolutePopup, g = !1, y = WJ(), b = t.readOnly, k = b !== void 0 && b, w = t.externalContent, x = t.mainMenuBar, S = x === void 0 || x, T = t.navigationBar, P = T === void 0 || T, O = t.escapeControlCharacters, j = O !== void 0 && O, V = t.escapeUnicodeCharacters, E = V !== void 0 && V, C = t.validator, H = C === void 0 ? null : C, X = t.indentation, F = X === void 0 ? 2 : X, G = t.onError, M = t.onChange, $ = t.onRenderValue, q = t.onRequestRepair, B = q === void 0 ? Qe : q, D = t.onRenderMenu, _ = D === void 0 ? Qe : D, L = t.onClassName, J = t.onFocus, st = t.onBlur, ht = t.onSortModal, xt = t.onTransformModal, kt = !1;
  mA({ onMount: yi, onDestroy: Fa, getWindow: function() {
    return cc(u);
  }, hasFocus: function() {
    return kt && document.hasFocus() || dp(u);
  }, onFocus: function() {
    g = !0, J && J();
  }, onBlur: function() {
    g = !1, st && st();
  } });
  var I = [];
  function R(et) {
    i("updateSelection", et);
    var dt = typeof et == "function" ? et(z.selection) : et;
    rn(dt, z.selection) || n(13, z = Ct(Ct({}, z), {}, { selection: dt }));
  }
  var it, N, K, z = uS({ json: c, expand: at(c) });
  function at(et) {
    return Jx({ json: et }, 10240) ? gs : Kl;
  }
  var yt = !1, jt = !1, Ft = !1, zt = "";
  function St(et) {
    return Gt.apply(this, arguments);
  }
  function Gt() {
    return (Gt = mn(de().mark(function et(dt) {
      return de().wrap(function(_t) {
        for (; ; )
          switch (_t.prev = _t.next) {
            case 0:
              return i("search text updated", dt), n(68, zt = dt), _t.next = 4, Qn();
            case 4:
              return _t.next = 6, $t();
            case 6:
            case "end":
              return _t.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function _e() {
    return (_e = mn(de().mark(function et() {
      return de().wrap(function(dt) {
        for (; ; )
          switch (dt.prev = dt.next) {
            case 0:
              return n(14, it = it ? tK(it) : void 0), dt.next = 3, $t();
            case 3:
            case "end":
              return dt.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function Fe() {
    return (Fe = mn(de().mark(function et() {
      return de().wrap(function(dt) {
        for (; ; )
          switch (dt.prev = dt.next) {
            case 0:
              return n(14, it = it ? eK(it) : void 0), dt.next = 3, $t();
            case 3:
            case "end":
              return dt.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function fn() {
    return (fn = mn(de().mark(function et(dt, _t) {
      var Tt, Dt, Lt, Qt;
      return de().wrap(function(ue) {
        for (; ; )
          switch (ue.prev = ue.next) {
            case 0:
              if (Tt = it == null ? void 0 : it.activeItem, i("handleReplace", { replacementText: _t, activeItem: Tt }), Tt) {
                ue.next = 4;
                break;
              }
              return ue.abrupt("return");
            case 4:
              return Dt = nK(c, z, _t, Tt), Lt = Dt.operations, Qt = Dt.newSelection, vr(Lt, function(te, Xe) {
                return { state: Ct(Ct({}, Xe), {}, { selection: Qt }) };
              }), ue.next = 8, Qn();
            case 8:
              return ue.next = 10, $t();
            case 10:
            case "end":
              return ue.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function De() {
    return (De = mn(de().mark(function et(dt, _t) {
      var Tt, Dt, Lt;
      return de().wrap(function(Qt) {
        for (; ; )
          switch (Qt.prev = Qt.next) {
            case 0:
              return i("handleReplaceAll", { text: dt, replacementText: _t }), Tt = rK(c, z, dt, _t), Dt = Tt.operations, Lt = Tt.newSelection, vr(Dt, function(ue, te) {
                return { state: Ct(Ct({}, te), {}, { selection: Lt }) };
              }), Qt.next = 5, Qn();
            case 5:
              return Qt.next = 7, $t();
            case 7:
            case "end":
              return Qt.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function $t() {
    return oe.apply(this, arguments);
  }
  function oe() {
    return (oe = mn(de().mark(function et() {
      var dt, _t;
      return de().wrap(function(Tt) {
        for (; ; )
          switch (Tt.prev = Tt.next) {
            case 0:
              if (dt = it == null ? void 0 : it.activeItem, i("focusActiveSearchResult", it), !dt) {
                Tt.next = 9;
                break;
              }
              return _t = dt.path, n(13, z = Ct(Ct({}, xv(c, z, _t)), {}, { selection: void 0 })), Tt.next = 7, Qn();
            case 7:
              return Tt.next = 9, Wi(_t);
            case 9:
            case "end":
              return Tt.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  var Ce = XJ({ onChange: function(et) {
    n(19, sn = et);
  } }), sn = Ce.getState(), vn, nt, ct = Xg(function() {
    if (zt === "")
      return i("clearing search result"), void (it !== void 0 && n(14, it = void 0));
    n(18, Ft = !0), setTimeout(function() {
      i("searching...", zt);
      var et = YE(zt, c, z, 1e3);
      n(14, it = function(dt, _t, Tt) {
        var Dt = Tt != null && Tt.activeItem ? SS(Tt.activeItem) : void 0, Lt = _t.findIndex(function(Xe) {
          return rn(Dt, SS(Xe));
        }), Qt = Lt !== -1 ? Lt : (Tt == null ? void 0 : Tt.activeIndex) < _t.length ? Tt == null ? void 0 : Tt.activeIndex : _t.length > 0 ? 0 : -1, ue = _t.map(function(Xe, Ze) {
          return Ct(Ct({}, Xe), {}, { active: Ze === Qt });
        }), te = ue[Qt];
        return { items: ue, itemsMap: Vc(ue, function(Xe) {
          return mt.exports.compileJSONPointer(Xe.path);
        }), activeItem: te, activeIndex: Qt };
      }(0, et, it)), n(18, Ft = !1);
    });
  }, 300), lt = !1, wt = [];
  function Rt() {
    return c;
  }
  function Bt() {
    return z;
  }
  function ee(et) {
    et.json !== void 0 && function(dt) {
      if (dt !== void 0) {
        var _t = !rn(c, dt);
        if (i("update external json", { isChanged: _t, currentlyText: c === void 0 }), !!_t) {
          var Tt = z, Dt = c, Lt = l, Qt = lt;
          n(7, c = dt), n(13, z = _i(c, z, I, at(c))), n(8, l = void 0), n(20, lt = !1), ie(c), gt({ previousJson: Dt, previousState: Tt, previousText: Lt, previousTextIsRepaired: Qt });
        }
      }
    }(et.json), et.text !== void 0 && function(dt) {
      if (!(dt === void 0 || w.json !== void 0) && dt !== l) {
        i("update external text");
        var _t = c, Tt = z, Dt = l, Lt = lt;
        try {
          n(7, c = JSON.parse(dt)), n(13, z = _i(c, z, I, at(c))), n(8, l = dt), n(20, lt = !1), ie(c);
        } catch {
          try {
            n(7, c = JSON.parse(Zo(dt))), n(13, z = _i(c, z, I, at(c))), n(8, l = dt), n(20, lt = !0), ie(c);
          } catch {
            n(7, c = void 0), n(8, l = w.text), n(20, lt = !1), ie(c);
          }
        }
        gt({ previousJson: _t, previousState: Tt, previousText: Dt, previousTextIsRepaired: Lt });
      }
    }(et.text);
  }
  function ie(et) {
    z.selection !== void 0 && (z.selection && mt.exports.existsIn(et, z.selection.anchorPath) && mt.exports.existsIn(et, z.selection.focusPath) || (i("clearing selection: path does not exist anymore", z.selection), n(13, z = Ct(Ct({}, z), {}, { selection: void 0 }))));
  }
  function gt(et) {
    var dt = et.previousJson, _t = et.previousState, Tt = et.previousText, Dt = et.previousTextIsRepaired;
    dt === void 0 && Tt === void 0 || (c !== void 0 ? dt !== void 0 ? Ce.add({ undo: { patch: [{ op: "replace", path: "", value: dt }], state: Vo(_t), json: void 0, text: Tt, textIsRepaired: Dt }, redo: { patch: [{ op: "replace", path: "", value: c }], state: Vo(z), json: void 0, text: l, textIsRepaired: lt } }) : Ce.add({ undo: { patch: void 0, json: void 0, text: Tt, state: Vo(_t), textIsRepaired: Dt }, redo: { patch: void 0, json: c, state: Vo(z), text: l, textIsRepaired: lt } }) : dt !== void 0 && Ce.add({ undo: { patch: void 0, json: dt, state: Vo(_t), text: Tt, textIsRepaired: Dt }, redo: { patch: void 0, json: void 0, text: l, textIsRepaired: lt, state: Vo(z) } }));
  }
  function Kt() {
    i("createDefaultSelection"), n(13, z = Ct(Ct({}, z), {}, { selection: tr(c || {}, [], []) }));
  }
  function ae(et, dt) {
    if (i("patch", et, dt), c === void 0)
      throw new Error("Cannot apply patch: no JSON");
    var _t = c, Tt = z, Dt = l, Lt = lt, Qt = function(pn, ft) {
      return mt.exports.revertJSONPatch(pn, ft, { before: function(le, ge, fe) {
        if (mt.exports.isJSONPatchRemove(ge)) {
          var Ln = mt.exports.parseJSONPointer(ge.path);
          return { revertOperations: [].concat(Pe(fe), Pe(wS(le, Ln))) };
        }
        if (mt.exports.isJSONPatchMove(ge)) {
          var ar = mt.exports.parseJSONPointer(ge.from);
          return { revertOperations: [].concat(Pe(fe), Pe(wS(le, ar))) };
        }
        return { revertOperations: fe };
      } });
    }(c, et), ue = GJ(c, z, et), te = Qs(c, et), Xe = function(pn, ft) {
      var le = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
      return ft !== void 0 || le ? Ct(Ct({}, pn), {}, { selection: ft }) : pn;
    }(ue.documentState, te, !1);
    i("patch updatedSelection", te);
    var Ze = typeof dt == "function" ? dt(ue.json, Xe) : void 0;
    n(7, c = Ze && Ze.json !== void 0 ? Ze.json : ue.json);
    var Jn = Ze && Ze.state !== void 0 ? Ze.state : Xe;
    return n(13, z = Jn), n(8, l = void 0), n(20, lt = !1), ie(c), Ce.add({ undo: { patch: Qt, json: void 0, text: Dt, state: Vo(Tt), textIsRepaired: Lt }, redo: { patch: et, json: void 0, state: Vo(Jn), text: l, textIsRepaired: lt } }), { json: c, previousJson: _t, undo: Qt, redo: et };
  }
  function Yt(et) {
    return nn(et) || Xn(et) || en(et);
  }
  function se() {
    !k && z.selection && R(Qr(z.selection.focusPath, !0));
  }
  function Ae() {
    !k && z.selection && R(Mn(z.selection.focusPath, !0));
  }
  function me() {
    if (!k && en(z.selection)) {
      var et = z.selection.focusPath, dt = mt.exports.compileJSONPointer(et), _t = mt.exports.getIn(c, et), Tt = !rl(_t, z.enforceStringMap, dt), Dt = Tt ? String(_t) : Rc(String(_t));
      i("handleToggleEnforceString", { enforceString: Tt, value: _t, updatedValue: Dt }), vr([{ op: "replace", path: mt.exports.compileJSONPointer(et), value: Dt }], function(Lt, Qt) {
        return { state: KJ(Qt, dt, Tt) };
      });
    }
  }
  function Se() {
    return Oe.apply(this, arguments);
  }
  function Oe() {
    return (Oe = mn(de().mark(function et() {
      var dt, _t, Tt, Dt, Lt, Qt, ue = arguments;
      return de().wrap(function(te) {
        for (; ; )
          switch (te.prev = te.next) {
            case 0:
              if (dt = !(ue.length > 0 && ue[0] !== void 0) || ue[0], !k && Yt(z.selection)) {
                te.next = 3;
                break;
              }
              return te.abrupt("return");
            case 3:
              if (_t = dt ? F : null, (Tt = pS(c, z.selection, _t)) != null) {
                te.next = 7;
                break;
              }
              return te.abrupt("return");
            case 7:
              return i("cut", { selection: z.selection, clipboard: Tt, indent: dt }), te.prev = 8, te.next = 11, navigator.clipboard.writeText(Tt);
            case 11:
              te.next = 16;
              break;
            case 13:
              te.prev = 13, te.t0 = te.catch(8), G(te.t0);
            case 16:
              Dt = kS(c, z.selection), Lt = Dt.operations, Qt = Dt.newSelection, vr(Lt, function(Xe, Ze) {
                return { state: Ct(Ct({}, Ze), {}, { selection: Qt }) };
              });
            case 18:
            case "end":
              return te.stop();
          }
      }, et, null, [[8, 13]]);
    }))).apply(this, arguments);
  }
  function Ee() {
    return kn.apply(this, arguments);
  }
  function kn() {
    return (kn = mn(de().mark(function et() {
      var dt, _t, Tt, Dt = arguments;
      return de().wrap(function(Lt) {
        for (; ; )
          switch (Lt.prev = Lt.next) {
            case 0:
              if (dt = !(Dt.length > 0 && Dt[0] !== void 0) || Dt[0], _t = dt ? F : null, (Tt = pS(c, z.selection, _t)) != null) {
                Lt.next = 5;
                break;
              }
              return Lt.abrupt("return");
            case 5:
              return i("copy", { clipboard: Tt, indent: dt }), Lt.prev = 6, Lt.next = 9, navigator.clipboard.writeText(Tt);
            case 9:
              Lt.next = 14;
              break;
            case 11:
              Lt.prev = 11, Lt.t0 = Lt.catch(6), G(Lt.t0);
            case 14:
            case "end":
              return Lt.stop();
          }
      }, et, null, [[6, 11]]);
    }))).apply(this, arguments);
  }
  function Yn() {
    f(fK, {}, Ct(Ct({}, _f), {}, { styleWindow: { width: "450px" } }), { onClose: function() {
      return lr();
    } });
  }
  function It(et) {
    if (c !== void 0) {
      z.selection || Kt();
      var dt = bS(c, z.selection, et);
      i("paste", { clipboardText: et, operations: dt, selection: z.selection }), vr(dt, function(_t, Tt) {
        var Dt = Tt;
        return dt.filter(function(Lt) {
          return (mt.exports.isJSONPatchAdd(Lt) || mt.exports.isJSONPatchReplace(Lt)) && ur(Lt.value);
        }).forEach(function(Lt) {
          var Qt = mt.exports.parsePath(c, Lt.path);
          Dt = ji(_t, Dt, Qt);
        }), { state: Dt };
      });
    } else
      i("paste text", { clipboardText: et }), function(_t, Tt) {
        i("handleChangeText");
        var Dt = z, Lt = c, Qt = l, ue = { json: c, text: l }, te = lt;
        try {
          n(7, c = JSON.parse(_t)), n(13, z = _i(c, z, I, gs)), n(8, l = void 0), n(20, lt = !1);
        } catch {
          try {
            n(7, c = JSON.parse(Zo(_t))), n(13, z = _i(c, z, I, gs)), n(8, l = _t), n(20, lt = !0);
          } catch {
            n(7, c = void 0), n(13, z = uS({ json: c, expand: gs })), n(8, l = _t), n(20, lt = !1);
          }
        }
        if (typeof Tt == "function") {
          var Xe = Tt(c, z);
          n(7, c = Xe && Xe.json ? Xe.json : c), n(13, z = Xe && Xe.state ? Xe.state : z);
        }
        ie(c), gt({ previousJson: Lt, previousState: Dt, previousText: Qt, previousTextIsRepaired: te }), zo(ue, null);
      }(et, function(_t, Tt) {
        if (_t)
          return { state: ji(_t, Tt, []) };
      });
  }
  function un() {
    if (!k && z.selection) {
      var et = Xn(z.selection) || en(z.selection) ? tr(c, z.selection.anchorPath, z.selection.focusPath) : z.selection;
      if (_n(z.selection.focusPath))
        i("remove root", { selection: z.selection }), M({ text: "", json: void 0 }, { text: l, json: c }, null);
      else {
        var dt = kS(c, et), _t = dt.operations, Tt = dt.newSelection;
        i("remove", { operations: _t, selection: z.selection, newSelection: Tt }), vr(_t, function(Dt, Lt) {
          return { state: Ct(Ct({}, Lt), {}, { selection: Tt }) };
        });
      }
    }
  }
  function hn() {
    k || !Yt(z.selection) || _n(z.selection.focusPath) || (i("duplicate", { selection: z.selection }), vr(function(et, dt) {
      var _t = ve(dt);
      if (_n(_t))
        throw new Error("Cannot duplicate root object");
      var Tt = Ge(_t), Dt = ve(_t), Lt = mt.exports.getIn(et, Tt);
      if (yr(Lt)) {
        var Qt = ve(dt), ue = Qt ? nr(ve(Qt)) + 1 : 0;
        return Pe(dt.map(function(Ze, Jn) {
          return { op: "copy", from: mt.exports.compileJSONPointer(Ze), path: mt.exports.compileJSONPointer(Tt.concat(String(Jn + ue))) };
        }));
      }
      if (Rr(Lt)) {
        var te = Object.keys(Lt), Xe = il(te, Dt, !1);
        return [].concat(Pe(dt.map(function(Ze) {
          var Jn = ol(ve(Ze), te);
          return { op: "copy", from: mt.exports.compileJSONPointer(Ze), path: mt.exports.compileJSONPointer(Tt.concat(Jn)) };
        })), Pe(Xe.map(function(Ze) {
          return Ka(Tt, Ze);
        })));
      }
      throw new Error("Cannot create duplicate operations: parent must be an Object or Array");
    }(c, ZE(z.selection))));
  }
  function tn() {
    k || !z.selection || !nn(z.selection) && !en(z.selection) || _n(z.selection.focusPath) || (i("extract", { selection: z.selection }), vr(function(et, dt) {
      if (en(dt))
        return [{ op: "move", from: mt.exports.compileJSONPointer(dt.focusPath), path: "" }];
      if (!nn(dt))
        throw new Error("Cannot create extract operations: parent must be an Object or Array");
      var _t = Ge(dt.focusPath), Tt = mt.exports.getIn(et, _t);
      if (yr(Tt))
        return [{ op: "replace", path: "", value: dt.paths.map(function(Lt) {
          var Qt = nr(ve(Lt));
          return Tt[Qt];
        }) }];
      if (Rr(Tt)) {
        var Dt = {};
        return dt.paths.forEach(function(Lt) {
          var Qt = String(ve(Lt));
          Dt[Qt] = Tt[Qt];
        }), [{ op: "replace", path: "", value: Dt }];
      }
      throw new Error("Cannot extract: unsupported type of selection " + JSON.stringify(dt));
    }(c, z.selection), function(et, dt) {
      if (ur(et))
        return { state: ji(et, dt, []) };
    }));
  }
  function on(et) {
    if (!k && z.selection) {
      var dt = function(Qt, ue, te) {
        if (te === "object")
          return {};
        if (te === "array")
          return [];
        if (te === "structure") {
          var Xe = QE(ue), Ze = mt.exports.getIn(Qt, Xe);
          if (Array.isArray(Ze) && !_n(Ze)) {
            var Jn = cr(Ze);
            return ur(Jn) ? mg(Jn, function(pn) {
              return Array.isArray(pn) ? [] : mr(pn) ? void 0 : "";
            }) : "";
          }
        }
        return "";
      }(c, z.selection, et);
      if (c !== void 0) {
        var _t = JSON.stringify(dt), Tt = bS(c, z.selection, _t);
        i("handleInsert", { type: et, operations: Tt, newValue: dt, data: _t });
        var Dt = ve(Tt.filter(function(Qt) {
          return Qt.op === "add" || Qt.op === "replace";
        }));
        vr(Tt, function(Qt, ue) {
          if (Dt) {
            var te = mt.exports.parsePath(Qt, Dt.path);
            if (ur(dt))
              return { state: Ct(Ct({}, _i(Qt, ue, te, Kl)), {}, { selection: oo(te) }) };
            if (dt === "") {
              var Xe = _n(te) ? null : mt.exports.getIn(Qt, Ge(te));
              return i("test A", te, oo(te)), { state: xv(Qt, Ct(Ct({}, z), {}, { selection: mr(Xe) ? Qr(te, !0) : Mn(te, !0) }), te) };
            }
          }
        }), i("after patch"), Dt && dt === "" && Qn().then(function() {
          setTimeout(function() {
            return re("", !0);
          });
        });
      } else {
        i("handleInsert", { type: et, newValue: dt });
        var Lt = [];
        wu(dt, function(Qt, ue) {
          return { state: Ct(Ct({}, ji(Qt, ue, Lt)), {}, { selection: oo(Lt) }) };
        });
      }
    }
  }
  function an(et) {
    Xn(z.selection) && R(Mn(z.selection.focusPath, !1)), on(et);
  }
  function oi(et) {
    if (!k && z.selection)
      if (gf(z.selection))
        try {
          var dt = z.selection.anchorPath, _t = mt.exports.getIn(c, dt), Tt = function(Lt, Qt) {
            if (Qt === "array") {
              if (Array.isArray(Lt))
                return Lt;
              if (mr(Lt))
                return Wx(Lt);
              if (typeof Lt == "string") {
                var ue = JSON.parse(Lt);
                if (Array.isArray(ue))
                  return ue;
                if (mr(ue))
                  return Wx(ue);
              }
            }
            if (Qt === "object") {
              if (Array.isArray(Lt))
                return Hx(Lt);
              if (mr(Lt))
                return Lt;
              if (typeof Lt == "string") {
                var te = JSON.parse(Lt);
                if (mr(te))
                  return te;
                if (Array.isArray(te))
                  return Hx(te);
              }
            }
            if (Qt === "value")
              return ur(Lt) ? JSON.stringify(Lt) : Lt;
            throw new Error("Cannot convert ".concat(Jm(Lt), " to ").concat(Qt));
          }(_t, et);
          if (Tt === _t)
            return;
          var Dt = [{ op: "replace", path: mt.exports.compileJSONPointer(dt), value: Tt }];
          i("handleConvert", { selection: z.selection, path: dt, type: et, operations: Dt }), vr(Dt, function(Lt, Qt) {
            return { state: ji(Lt, Qt, z.selection.focusPath) };
          });
        } catch (Lt) {
          G(Lt);
        }
      else
        G(new Error("Cannot convert current selection to ".concat(et)));
  }
  function Hi() {
    var et = hS(c, z, !1), dt = Ge(z.selection.focusPath);
    !_n(et.focusPath) && rn(dt, Ge(et.focusPath)) ? R(Po(et.focusPath)) : R(oo(dt)), i("insert before", { selection: z.selection, selectionBefore: et, parentPath: dt }), Qn().then(Fo);
  }
  function wn() {
    var et = nn(z.selection) ? ve(z.selection.paths) : z.selection.focusPath;
    i("insert after", et), R(Po(et)), Qn().then(Fo);
  }
  function re(et, dt) {
    var _t = cc(u).document.activeElement;
    _t.isContentEditable && (_t.textContent = dt ? et : _t.textContent + et, lA(_t));
  }
  function Ie(et) {
    return ai.apply(this, arguments);
  }
  function ai() {
    return (ai = mn(de().mark(function et(dt) {
      var _t, Tt;
      return de().wrap(function(Dt) {
        for (; ; )
          switch (Dt.prev = Dt.next) {
            case 0:
              if (!k && z.selection) {
                Dt.next = 2;
                break;
              }
              return Dt.abrupt("return");
            case 2:
              if (!Xn(z.selection)) {
                Dt.next = 9;
                break;
              }
              return _t = !z.selection.edit, R(Ct(Ct({}, z.selection), {}, { edit: !0 })), Dt.next = 7, Qn();
            case 7:
              return setTimeout(function() {
                return re(dt, _t);
              }), Dt.abrupt("return");
            case 9:
              if (dt !== "{") {
                Dt.next = 13;
                break;
              }
              on("object"), Dt.next = 28;
              break;
            case 13:
              if (dt !== "[") {
                Dt.next = 17;
                break;
              }
              on("array"), Dt.next = 28;
              break;
            case 17:
              if (!en(z.selection)) {
                Dt.next = 26;
                break;
              }
              if (ur(mt.exports.getIn(c, z.selection.focusPath))) {
                Dt.next = 24;
                break;
              }
              return Tt = !z.selection.edit, R(Ct(Ct({}, z.selection), {}, { edit: !0 })), Dt.next = 23, Qn();
            case 23:
              setTimeout(function() {
                return re(dt, Tt);
              });
            case 24:
              Dt.next = 28;
              break;
            case 26:
              return Dt.next = 28, xi(dt);
            case 28:
            case "end":
              return Dt.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function xi(et) {
    return Pr.apply(this, arguments);
  }
  function Pr() {
    return (Pr = mn(de().mark(function et(dt) {
      var _t, Tt, Dt;
      return de().wrap(function(Lt) {
        for (; ; )
          switch (Lt.prev = Lt.next) {
            case 0:
              if (!k && z.selection) {
                Lt.next = 2;
                break;
              }
              return Lt.abrupt("return");
            case 2:
              return on("value"), _t = !Zu(z.selection), Tt = z.selection.focusPath, Dt = mt.exports.getIn(c, Ge(Tt)), Array.isArray(Dt) || !Dt || en(z.selection) ? R(Mn(Tt, !0)) : R(Qr(Tt, !0)), Lt.next = 9, Qn();
            case 9:
              setTimeout(function() {
                return re(dt, _t);
              });
            case 10:
            case "end":
              return Lt.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function fs() {
    if (!k && Ce.getState().canUndo) {
      var et = Ce.undo();
      if (et) {
        var dt = { json: c, text: l };
        n(7, c = et.undo.patch ? mt.exports.immutableJSONPatch(c, et.undo.patch) : et.undo.json), n(13, z = et.undo.state), n(8, l = et.undo.text), n(20, lt = et.undo.textIsRepaired), i("undo", { item: et, json: c, documentState: z }), zo(dt, { json: c, previousJson: dt.json, redo: et.undo.patch, undo: et.redo.patch }), lr(), z.selection && Wi(z.selection.focusPath, !1);
      }
    }
  }
  function hs() {
    if (!k && Ce.getState().canRedo) {
      var et = Ce.redo();
      if (et) {
        var dt = { json: c, text: l };
        n(7, c = et.redo.patch ? mt.exports.immutableJSONPatch(c, et.redo.patch) : et.redo.json), n(13, z = et.redo.state), n(8, l = et.redo.text), n(20, lt = et.redo.textIsRepaired), i("redo", { item: et, json: c, documentState: z }), zo(dt, { json: c, previousJson: dt.json, redo: et.redo.patch, undo: et.undo.patch }), lr(), z.selection && Wi(z.selection.focusPath, !1);
      }
    }
  }
  function ds(et) {
    var dt;
    k || (kt = !0, ht({ id: h, json: c, selectedPath: et, onSort: (dt = mn(de().mark(function _t(Tt) {
      return de().wrap(function(Dt) {
        for (; ; )
          switch (Dt.prev = Dt.next) {
            case 0:
              i("onSort", et, Tt), vr(Tt, function(Lt, Qt) {
                return { state: Ct(Ct({}, ji(Lt, Qt, et)), {}, { selection: Mn(et, !1) }) };
              });
            case 2:
            case "end":
              return Dt.stop();
          }
      }, _t);
    })), function(_t) {
      return dt.apply(this, arguments);
    }), onClose: function() {
      kt = !1, lr();
    } }));
  }
  function sl() {
    z.selection && ds(vS(c, z.selection));
  }
  function vs(et) {
    var dt = et.id, _t = et.selectedPath, Tt = et.onTransform, Dt = et.onClose;
    kt = !0, xt({ id: dt || d, json: c, selectedPath: _t, onTransform: Tt ? function(Lt) {
      Tt({ operations: Lt, json: c, transformedJson: mt.exports.immutableJSONPatch(c, Lt) });
    } : function(Lt) {
      i("onTransform", _t, Lt), vr(Lt, function(Qt, ue) {
        return { state: Ct(Ct({}, ji(Qt, ue, _t)), {}, { selection: Mn(_t, !1) }) };
      });
    }, onClose: function() {
      kt = !1, lr(), Dt && Dt();
    } });
  }
  function ul() {
    z.selection && vs({ selectedPath: vS(c, z.selection) });
  }
  function Wi(et) {
    return ku.apply(this, arguments);
  }
  function ku() {
    return (ku = mn(de().mark(function et(dt) {
      var _t, Tt, Dt, Lt, Qt, ue = arguments;
      return de().wrap(function(te) {
        for (; ; )
          switch (te.prev = te.next) {
            case 0:
              return _t = !(ue.length > 1 && ue[1] !== void 0) || ue[1], n(13, z = xv(c, z, Ge(dt))), te.next = 4, Qn();
            case 4:
              if (!(Tt = ka(dt))) {
                te.next = 14;
                break;
              }
              if (i("scrollTo", { path: dt, elem: Tt, refContents: a }), Dt = a.getBoundingClientRect(), Lt = Tt.getBoundingClientRect(), _t) {
                te.next = 12;
                break;
              }
              if (!(Lt.bottom > Dt.top && Lt.top < Dt.bottom)) {
                te.next = 12;
                break;
              }
              return te.abrupt("return");
            case 12:
              Qt = -Dt.height / 4, y(Tt, { container: a, offset: Qt, duration: 300 });
            case 14:
            case "end":
              return te.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function ka(et) {
    return a ? a.querySelector('div[data-path="'.concat(vp(et), '"]')) : null;
  }
  function wa(et) {
    var dt = ka(et);
    if (dt && a) {
      var _t = a.getBoundingClientRect(), Tt = dt.getBoundingClientRect(), Dt = ur(mt.exports.getIn(c, et)) ? 20 : Tt.height;
      Tt.top < _t.top + 20 ? y(dt, { container: a, offset: -20, duration: 0 }) : Tt.top + Dt > _t.bottom - 20 && y(dt, { container: a, offset: -(_t.height - Dt - 20), duration: 0 });
    }
  }
  function zo(et, dt) {
    l !== void 0 ? M({ text: l, json: void 0 }, et, dt) : c !== void 0 && M({ text: void 0, json: c }, et, dt);
  }
  function vr(et, dt) {
    if (!k) {
      i("handlePatch", et, dt);
      var _t = { json: c, text: l }, Tt = ae(et, dt);
      return n(15, K = void 0), zo(_t, Tt), Tt;
    }
  }
  function wu(et, dt) {
    var _t = z, Tt = c, Dt = l, Lt = { json: c, text: l }, Qt = lt, ue = _i(c, z, I, gs), te = typeof dt == "function" ? dt(et, ue) : void 0;
    n(7, c = te && te.json !== void 0 ? te.json : et), n(13, z = te && te.state !== void 0 ? te.state : ue), n(8, l = void 0), n(20, lt = !1), ie(c), gt({ previousJson: Tt, previousState: _t, previousText: Dt, previousTextIsRepaired: Qt }), zo(Lt, null);
  }
  function ji(et, dt, _t) {
    return _i(et, dt, _t, Jx({ json: mt.exports.getIn(et, _t) }, 10240) ? gs : Kl);
  }
  function Bo(et, dt) {
    var _t = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
    i("expand", { path: et, expanded: dt, recursive: _t }), n(13, z = dt ? _t ? _i(c, z, et, Kl) : JJ(z, et) : cS(z, et)), z.selection && !dt && YJ(z.selection, et) && R(void 0), setTimeout(function() {
      dp(u) || lr();
    });
  }
  function xu(et) {
    i("openFind", { findAndReplace: et }), n(16, yt = !1), n(17, jt = !1), Qn().then(function() {
      n(16, yt = !0), n(17, jt = et);
    });
  }
  function cl(et, dt) {
    i("handleExpandSection", et, dt);
    var _t = mt.exports.compileJSONPointer(et);
    n(13, z = function(Tt, Dt, Lt, Qt) {
      return Ct(Ct({}, Dt), {}, { visibleSectionsMap: Ct(Ct({}, Dt.visibleSectionsMap), {}, na({}, Lt, UE(wd(Dt, Lt).concat(Qt)))) });
    }(0, z, _t, dt));
  }
  function On(et) {
    i("pasted json as text", et), n(15, K = et);
  }
  function si(et) {
    var dt = et.anchor, _t = et.left, Tt = et.top, Dt = et.width, Lt = et.height, Qt = et.offsetTop, ue = et.offsetLeft, te = et.showTip;
    kt = !0;
    var Xe = v(NK, { json: c, documentState: z, showTip: te, onEditKey: se, onEditValue: Ae, onToggleEnforceString: me, onCut: Se, onCopy: Ee, onPaste: Yn, onRemove: un, onDuplicate: hn, onExtract: tn, onInsertBefore: Hi, onInsert: an, onConvert: oi, onInsertAfter: wn, onSort: sl, onTransform: ul, onCloseContextMenu: function() {
      m(Xe), lr();
    } }, { left: _t, top: Tt, offsetTop: Qt, offsetLeft: ue, width: Dt, height: Lt, anchor: dt, closeOnOuterClick: !0, onClose: function() {
      kt = !1, lr();
    } });
  }
  function Fo(et) {
    if (!k && !Zu(z.selection)) {
      if (et && (et.stopPropagation(), et.preventDefault()), et && et.type === "contextmenu" && et.target !== s)
        si({ left: et.clientX, top: et.clientY, width: 260, height: 336, showTip: !1 });
      else {
        var dt = a == null ? void 0 : a.querySelector(".jse-context-menu-button.jse-selected");
        if (dt)
          si({ anchor: dt, offsetTop: 2, width: 260, height: 336, showTip: !1 });
        else {
          var _t = a == null ? void 0 : a.getBoundingClientRect();
          _t && si({ top: _t.top + 2, left: _t.left + 2, width: 260, height: 336, showTip: !1 });
        }
      }
      return !1;
    }
  }
  function ps() {
    return (ps = mn(de().mark(function et() {
      var dt, _t, Tt;
      return de().wrap(function(Dt) {
        for (; ; )
          switch (Dt.prev = Dt.next) {
            case 0:
              return i("apply pasted json", K), _t = (dt = K).path, Tt = dt.contents, R(Mn(_t, !1)), Dt.next = 5, Qn();
            case 5:
              vr([{ op: "replace", path: mt.exports.compileJSONPointer(_t), value: Tt }], function(Lt, Qt) {
                return { state: ji(Lt, Qt, _t) };
              });
            case 7:
            case "end":
              return Dt.stop();
          }
      }, et);
    }))).apply(this, arguments);
  }
  function lr() {
    i("focus"), s && (s.focus(), s.select());
  }
  function ju(et) {
    r && r.onDrag(et);
  }
  function qo() {
    r && r.onDragEnd();
  }
  return e.$$set = function(et) {
    "readOnly" in et && n(0, k = et.readOnly), "externalContent" in et && n(47, w = et.externalContent), "mainMenuBar" in et && n(1, S = et.mainMenuBar), "navigationBar" in et && n(2, P = et.navigationBar), "escapeControlCharacters" in et && n(48, j = et.escapeControlCharacters), "escapeUnicodeCharacters" in et && n(49, E = et.escapeUnicodeCharacters), "validator" in et && n(50, H = et.validator), "indentation" in et && n(51, F = et.indentation), "onError" in et && n(52, G = et.onError), "onChange" in et && n(53, M = et.onChange), "onRenderValue" in et && n(54, $ = et.onRenderValue), "onRequestRepair" in et && n(3, B = et.onRequestRepair), "onRenderMenu" in et && n(4, _ = et.onRenderMenu), "onClassName" in et && n(55, L = et.onClassName), "onFocus" in et && n(56, J = et.onFocus), "onBlur" in et && n(57, st = et.onBlur), "onSortModal" in et && n(58, ht = et.onSortModal), "onTransformModal" in et && n(59, xt = et.onTransformModal);
  }, e.$$.update = function() {
    393216 & e.$$.dirty[1] && n(67, N = iA({ escapeControlCharacters: j, escapeUnicodeCharacters: E })), 65536 & e.$$.dirty[1] && ee(w), 128 & e.$$.dirty[0] | 64 & e.$$.dirty[2] && ct(zt, c), e.$$.dirty[0], 128 & e.$$.dirty[0] | 524288 & e.$$.dirty[1] && function(et, dt) {
      var _t = dt ? dt(et) : [];
      rn(_t, wt) || (i("updateValidationErrors", _t), n(9, wt = _t));
    }(c, H), 512 & e.$$.dirty[0] && n(21, vn = function(et) {
      var dt = {};
      return et.forEach(function(_t) {
        dt[mt.exports.compileJSONPointer(_t.path)] = _t;
      }), et.forEach(function(_t) {
        for (var Tt = _t.path; Tt.length > 0; ) {
          Tt = Ge(Tt);
          var Dt = mt.exports.compileJSONPointer(Tt);
          Dt in dt || (dt[Dt] = { isChildError: !0, path: Tt, message: "Contains invalid data" });
        }
      }), dt;
    }(wt)), 64 & e.$$.dirty[0] && (r = a ? function(et) {
      var dt, _t;
      function Tt(ue) {
        return ue < 20 ? 200 : ue < 50 ? 400 : 1200;
      }
      function Dt() {
        if (et) {
          var ue = 0.05 * dt;
          et.scrollTop += ue;
        }
      }
      function Lt(ue) {
        _t && ue === dt || (Qt(), wv("startAutoScroll", ue), dt = ue, _t = setInterval(Dt, 50));
      }
      function Qt() {
        _t && (wv("stopAutoScroll"), clearInterval(_t), _t = void 0, dt = void 0);
      }
      return wv("createAutoScrollHandler", et), { onDrag: function(ue) {
        if (et) {
          var te = ue.clientY, Xe = et.getBoundingClientRect(), Ze = Xe.top, Jn = Xe.bottom;
          te < Ze ? Lt(-Tt(Ze - te)) : te > Jn ? Lt(Tt(te - Jn)) : Qt();
        }
      }, onDragEnd: function() {
        Qt();
      } };
    }(a) : void 0), 1 & e.$$.dirty[0] | 25165824 & e.$$.dirty[1] | 32 & e.$$.dirty[2] && n(10, nt = { readOnly: k, normalization: N, getJson: Rt, getDocumentState: Bt, findElement: ka, focus: lr, onPatch: vr, onInsert: on, onExpand: Bo, onSelect: R, onFind: xu, onExpandSection: cl, onPasteJson: On, onRenderValue: $, onContextMenu: si, onClassName: L || function() {
    }, onDrag: ju, onDragEnd: qo }), 1024 & e.$$.dirty[0] && i("context changed", nt);
  }, [k, S, P, B, _, function() {
    return lt && c !== void 0 && wu(c), { json: c, text: l };
  }, a, c, l, wt, nt, s, u, z, it, K, yt, jt, Ft, sn, lt, vn, o, I, St, function() {
    return _e.apply(this, arguments);
  }, function() {
    return Fe.apply(this, arguments);
  }, function(et, dt) {
    return fn.apply(this, arguments);
  }, function(et, dt) {
    return De.apply(this, arguments);
  }, function() {
    n(16, yt = !1), n(17, jt = !1), St(""), lr();
  }, function(et) {
    i("select validation error", et), R(Mn(et.path, !1)), Wi(et.path);
  }, Ee, function(et) {
    if (et.preventDefault(), !k) {
      var dt = et.clipboardData.getData("text/plain");
      try {
        It(dt);
      } catch {
        (function(Tt, Dt) {
          f(xK, { text: Tt, onParse: n0, onRepair: DF, onApply: Dt, onRenderMenu: _ }, Ct(Ct({}, _f), {}, { styleWindow: { width: "600px", height: "500px" }, styleContent: { padding: 0, height: "100%" } }), { onClose: function() {
            return lr();
          } });
        })(dt, function(Tt) {
          i("repaired pasted text: ", Tt), It(Tt);
        });
      }
    }
  }, fs, hs, function() {
    ds([]);
  }, function() {
    vs({ selectedPath: [] });
  }, function() {
    Bo([], !0, !0);
  }, function() {
    Bo([], !1, !0);
  }, function(et) {
    var dt = vu(et).replace(/^Command\+/, "Ctrl+"), _t = et.shiftKey;
    if (dt === "Ctrl+X" && (et.preventDefault(), Se(!0)), dt === "Ctrl+Shift+X" && (et.preventDefault(), Se(!1)), dt === "Ctrl+C" && (et.preventDefault(), Ee(!0)), dt === "Ctrl+Shift+C" && (et.preventDefault(), Ee(!1)), dt === "Ctrl+D" && (et.preventDefault(), hn()), dt !== "Delete" && dt !== "Backspace" || (et.preventDefault(), un()), dt === "Insert" && (et.preventDefault(), on("structure")), dt === "Ctrl+A" && (et.preventDefault(), R(Mn([], !1))), dt === "Ctrl+Q" && Fo(et), dt === "Up" || dt === "Shift+Up") {
      et.preventDefault();
      var Tt = z.selection ? hS(c, z, _t, !0) || z.selection : Ul(c, z);
      R(Tt), wa(Tt.focusPath);
    }
    if (dt === "Down" || dt === "Shift+Down") {
      et.preventDefault();
      var Dt = z.selection ? function(pn, ft) {
        var le = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], ge = arguments.length > 3 && arguments[3] !== void 0 && arguments[3], fe = ft.selection, Ln = !ge && nn(fe) ? ve(fe.paths) : fe.focusPath, ar = pm(pn, ft, Ln), xr = ar, sr = ar;
        if (ar === null)
          return null;
        if (le) {
          var xa = pm(pn, ur(mt.exports.getIn(pn, Ln)) ? cS(ft, Ln) : ft, Ln);
          return xa === null ? null : Ti(fe) ? tr(pn, xa, xa) : rr(fe) ? tr(pn, xr, sr) : tr(pn, fe.anchorPath, xa);
        }
        if (Xn(fe)) {
          var RM = Ge(ar), DM = mt.exports.getIn(pn, RM);
          return Array.isArray(DM) ? Mn(sr, !1) : Qr(sr, !1);
        }
        return en(fe) ? Mn(sr, !1) : rr(fe) ? tr(pn, xr, sr) : tr(pn, ar, ar);
      }(c, z, _t, !0) || z.selection : Ul(c, z);
      R(Dt), wa(Dt.focusPath);
    }
    if (dt === "Left" || dt === "Shift+Left") {
      et.preventDefault();
      var Lt = z.selection ? function(pn, ft) {
        var le = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], ge = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], fe = ft.selection, Ln = dS(pn, ft, ge), ar = Ln.caret, xr = Ln.previous;
        if (le)
          return nn(fe) ? null : tr(pn, fe.anchorPath, fe.focusPath);
        if (ar && xr)
          return gm(xr);
        var sr = Ge(fe.focusPath), xa = mt.exports.getIn(pn, sr);
        return en(fe) && Array.isArray(xa) ? tr(pn, fe.focusPath, fe.focusPath) : nn(fe) && !Array.isArray(xa) ? Qr(fe.focusPath, !1) : null;
      }(c, z, _t, !k) || z.selection : Ul(c, z);
      R(Lt), wa(Lt.focusPath);
    }
    if (dt === "Right" || dt === "Shift+Right") {
      et.preventDefault();
      var Qt = z.selection ? function(pn, ft) {
        var le = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], ge = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], fe = ft.selection, Ln = dS(pn, ft, ge), ar = Ln.caret, xr = Ln.next;
        return le ? nn(fe) ? null : tr(pn, fe.anchorPath, fe.focusPath) : ar && xr ? gm(xr) : nn(fe) ? Mn(fe.focusPath, !1) : null;
      }(c, z, _t, !k) || z.selection : Ul(c, z);
      R(Qt), wa(Qt.focusPath);
    }
    if (dt === "Enter" && z.selection) {
      if (!k && nn(z.selection) && z.selection.paths.length === 1) {
        var ue = z.selection.focusPath, te = mt.exports.getIn(c, Ge(ue));
        Array.isArray(te) && R(Mn(ue, !1));
      }
      !k && Xn(z.selection) && (et.preventDefault(), R(Ct(Ct({}, z.selection), {}, { edit: !0 }))), en(z.selection) && (et.preventDefault(), ur(mt.exports.getIn(c, z.selection.focusPath)) ? Bo(z.selection.focusPath, !0) : k || R(Ct(Ct({}, z.selection), {}, { edit: !0 })));
    }
    if (dt.length === (dt.startsWith("Shift+") ? 7 : 1) && z.selection)
      return et.preventDefault(), void Ie(et.key);
    if (dt === "Enter" && (Ti(z.selection) || rr(z.selection)))
      return et.preventDefault(), void Ie("");
    if (dt === "Ctrl+Enter" && en(z.selection)) {
      var Xe = mt.exports.getIn(c, z.selection.focusPath);
      Km(Xe) && window.open(String(Xe), "_blank");
    }
    if (dt === "Escape" && z.selection && (et.preventDefault(), R(void 0)), dt === "Ctrl+F" && (et.preventDefault(), xu(!1)), dt === "Ctrl+H" && (et.preventDefault(), xu(!0)), dt === "Ctrl+Z") {
      et.preventDefault();
      var Ze = document.activeElement;
      Ze && Ze.blur && Ze.focus ? (Ze.blur(), setTimeout(function() {
        fs(), setTimeout(function() {
          return Ze.select();
        });
      })) : fs();
    }
    if (dt === "Ctrl+Shift+Z") {
      et.preventDefault();
      var Jn = document.activeElement;
      Jn && Jn.blur && Jn.focus ? (Jn.blur(), setTimeout(function() {
        hs(), setTimeout(function() {
          return Jn.select();
        });
      })) : hs();
    }
  }, function(et) {
    i("handleMouseDown", et), setTimeout(function() {
      setTimeout(function() {
        g || cA(et.target, "BUTTON") || (lr(), z.selection || c !== void 0 || l !== "" && l !== void 0 || Kt());
      });
    });
  }, Fo, function(et) {
    k || si({ anchor: JF(et.target, "BUTTON"), offsetTop: 0, width: 260, height: 336, showTip: !0 });
  }, function() {
    return ps.apply(this, arguments);
  }, function() {
    i("clear pasted json"), n(15, K = void 0);
  }, function(et) {
    R(et), lr(), Wi(et.focusPath);
  }, function(et) {
    !Kc(et.target, function(dt) {
      return dt === u;
    }) && Zu(z.selection) && (i("click outside the editor, stop edit mode"), R(function(dt) {
      return Xn(dt) || en(dt) ? Ct(Ct({}, dt), {}, { edit: !1 }) : dt;
    }), g && s && (s.focus(), s.blur()), Qn().then(function() {
      setTimeout(function() {
        s && s.blur();
      });
    }));
  }, w, j, E, H, F, G, M, $, L, J, st, ht, xt, function() {
    var et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      return !0;
    };
    i("expand");
    var dt = Ct(Ct({}, z), {}, { expandedMap: {}, visibleSectionsMap: {} });
    n(13, z = _i(c, dt, I, et));
  }, Rt, ae, vs, Wi, ka, lr, N, zt, function(et) {
    n(16, yt = et);
  }, function(et) {
    Be[et ? "unshift" : "push"](function() {
      n(11, s = et);
    });
  }, function(et) {
    Be[et ? "unshift" : "push"](function() {
      n(6, a = et);
    });
  }, function(et) {
    Be[et ? "unshift" : "push"](function() {
      n(12, u = et);
    });
  }];
}
var W0 = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, kQ, bQ, Ue, { readOnly: 0, externalContent: 47, mainMenuBar: 1, navigationBar: 2, escapeControlCharacters: 48, escapeUnicodeCharacters: 49, validator: 50, indentation: 51, onError: 52, onChange: 53, onRenderValue: 54, onRequestRepair: 3, onRenderMenu: 4, onClassName: 55, onFocus: 56, onBlur: 57, onSortModal: 58, onTransformModal: 59, expand: 60, getJson: 61, patch: 62, acceptAutoRepair: 5, openTransformModal: 63, scrollTo: 64, findElement: 65, focus: 66 }, hQ, [-1, -1, -1, -1, -1]), i;
  }
  return Y(n, [{ key: "expand", get: function() {
    return this.$$.ctx[60];
  } }, { key: "getJson", get: function() {
    return this.$$.ctx[61];
  } }, { key: "patch", get: function() {
    return this.$$.ctx[62];
  } }, { key: "acceptAutoRepair", get: function() {
    return this.$$.ctx[5];
  } }, { key: "openTransformModal", get: function() {
    return this.$$.ctx[63];
  } }, { key: "scrollTo", get: function() {
    return this.$$.ctx[64];
  } }, { key: "findElement", get: function() {
    return this.$$.ctx[65];
  } }, { key: "focus", get: function() {
    return this.$$.ctx[66];
  } }]), n;
}(), wQ = { id: "javascript", name: "JavaScript", description: `
<p>
  Enter a JavaScript function to filter, sort, or transform the data.
</p>
`, createQuery: function(e, t) {
  var n = t.filter, r = t.sort, i = t.projection, o = [];
  if (n && n.path && n.relation && n.value) {
    var a = "item => item".concat(ja(n.path)), s = typeof ZJ(n.value) == "string" ? "'".concat(n.value, "'") : n.value;
    o.push("  data = data.filter(".concat(a, " ").concat(n.relation, " ").concat(s, `)
`));
  }
  if (r && r.path && r.direction && (r.direction === "desc" ? o.push(`  data = data.slice().sort((a, b) => {
    // sort descending
` + "    const valueA = a".concat(ja(r.path), `
`) + "    const valueB = b".concat(ja(r.path), `
`) + `    return valueA > valueB ? -1 : valueA < valueB ? 1 : 0
  })
`) : o.push(`  data = data.slice().sort((a, b) => {
    // sort ascending
` + "    const valueA = a".concat(ja(r.path), `
`) + "    const valueB = b".concat(ja(r.path), `
`) + `    return valueA > valueB ? 1 : valueA < valueB ? -1 : 0
  })
`)), i && i.paths)
    if (i.paths.length > 1) {
      var u = i.paths.map(function(l) {
        var f = l[l.length - 1] || "item", h = "item".concat(ja(l));
        return "    ".concat(JSON.stringify(f), ": ").concat(h);
      });
      o.push(`  data = data.map(item => ({
`.concat(u.join(`,
`), `})
  )
`));
    } else {
      var c = "item".concat(ja(i.paths[0]));
      o.push("  data = data.map(item => ".concat(c, `)
`));
    }
  return o.push(`  return data
`), `function query (data) {
`.concat(o.join(""), "}");
}, executeQuery: function(e, t) {
  var n = new Function(`"use strict";

` + t + `

if (typeof query !== "function") {
  throw new Error("Cannot execute query: expecting a function named 'query' but is undefined")
}

return query;
`)()(e);
  return n !== void 0 ? n : null;
} };
function xQ(e) {
  Te(e, "svelte-zs5o25", ".jse-boolean-toggle.svelte-zs5o25{color:var(--jse-value-color-boolean);position:relative;padding-left:calc(0.5 * var(--jse-padding));padding-top:1px;height:var(--jse-line-height)}");
}
function jQ(e) {
  var t, n, r, i, o, a;
  return n = new Le({ props: { data: e[0] === !0 ? wh : kh } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-boolean-toggle svelte-zs5o25"), A(t, "title", r = e[1] ? "Boolean value ".concat(e[0]) : "Click to toggle this boolean value");
  }, m: function(s, u) {
    pt(s, t, u), Ot(n, t, null), i = !0, o || (a = Nt(t, "mousedown", e[2]), o = !0);
  }, p: function(s, u) {
    var c = xe(u, 1)[0], l = {};
    1 & c && (l.data = s[0] === !0 ? wh : kh), n.$set(l), (!i || 3 & c && r !== (r = s[1] ? "Boolean value ".concat(s[0]) : "Click to toggle this boolean value")) && A(t, "title", r);
  }, i: function(s) {
    i || (U(n.$$.fragment, s), i = !0);
  }, o: function(s) {
    tt(n.$$.fragment, s), i = !1;
  }, d: function(s) {
    s && vt(t), At(n), o = !1, a();
  } };
}
function SQ(e, t, n) {
  var r = t.path, i = t.value, o = t.readOnly, a = t.onPatch, s = t.focus;
  return e.$$set = function(u) {
    "path" in u && n(3, r = u.path), "value" in u && n(0, i = u.value), "readOnly" in u && n(1, o = u.readOnly), "onPatch" in u && n(4, a = u.onPatch), "focus" in u && n(5, s = u.focus);
  }, [i, o, function(u) {
    u.stopPropagation(), o || (a([{ op: "replace", path: mt.exports.compileJSONPointer(r), value: !i }]), setTimeout(s));
  }, r, a, s];
}
var $Q = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, SQ, jQ, Ue, { path: 3, value: 0, readOnly: 1, onPatch: 4, focus: 5 }, xQ), i;
  }
  return Y(n);
}();
function _Q(e) {
  Te(e, "svelte-1gn8yt9", ".jse-color-picker-popup.svelte-1gn8yt9 .picker_wrapper.popup,.jse-color-picker-popup.svelte-1gn8yt9 .picker_wrapper.popup .picker_arrow::before,.jse-color-picker-popup.svelte-1gn8yt9 .picker_wrapper.popup .picker_arrow::after{background:var(--jse-color-picker-background);line-height:normal}.jse-color-picker-popup.svelte-1gn8yt9 .picker_slider,.jse-color-picker-popup.svelte-1gn8yt9 .picker_sl,.jse-color-picker-popup.svelte-1gn8yt9 .picker_editor input,.jse-color-picker-popup.svelte-1gn8yt9 .picker_sample,.jse-color-picker-popup.svelte-1gn8yt9 .picker_done button{box-shadow:var(--jse-color-picker-border-box-shadow)}.jse-color-picker-popup.svelte-1gn8yt9 .picker_editor input{background:var(--jse-background-color);color:var(--jse-text-color)}.jse-color-picker-popup.svelte-1gn8yt9 .picker_done button{background:var(--jse-button-background);color:var(--jse-button-color)}.jse-color-picker-popup.svelte-1gn8yt9 .picker_done button:hover{background:var(--jse-button-background-highlight)}");
}
function CQ(e) {
  var t;
  return { c: function() {
    A(t = rt("div"), "class", "jse-color-picker-popup svelte-1gn8yt9");
  }, m: function(n, r) {
    pt(n, t, r), e[4](t);
  }, p: Wt, i: Wt, o: Wt, d: function(n) {
    n && vt(t), e[4](null);
  } };
}
function OQ(e, t, n) {
  var r, i, o = t.color, a = t.onChange, s = t.showOnTop;
  return yi(mn(de().mark(function u() {
    var c;
    return de().wrap(function(l) {
      for (; ; )
        switch (l.prev = l.next) {
          case 0:
            return l.next = 2, Promise.resolve().then(function() {
              return bZ;
            });
          case 2:
            c = l.sent.default, (i = new c({ parent: r, color: o, popup: s ? "top" : "bottom", onDone: function(f) {
              var h = f.rgba[3] === 1 ? f.hex.substring(0, 7) : f.hex;
              a(h);
            } })).show();
          case 5:
          case "end":
            return l.stop();
        }
    }, u);
  }))), Fa(function() {
    i && i.destroy();
  }), e.$$set = function(u) {
    "color" in u && n(1, o = u.color), "onChange" in u && n(2, a = u.onChange), "showOnTop" in u && n(3, s = u.showOnTop);
  }, [r, o, a, s, function(u) {
    Be[u ? "unshift" : "push"](function() {
      n(0, r = u);
    });
  }];
}
var AQ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, OQ, CQ, ir, { color: 1, onChange: 2, showOnTop: 3 }, _Q), i;
  }
  return Y(n);
}();
function PQ(e) {
  Te(e, "svelte-fk1u9y", ".jse-color-picker-button.svelte-fk1u9y{font-size:var(--jse-font-size-mono);width:var(--jse-color-picker-button-size);height:var(--jse-color-picker-button-size);box-sizing:border-box;padding:0;margin:2px;border:1px solid var(--jse-text-color);border-radius:2px;background:inherit;outline:none;cursor:pointer}");
}
function EQ(e) {
  var t, n, r, i;
  return { c: function() {
    A(t = rt("button"), "class", "jse-color-picker-button svelte-fk1u9y"), to(t, "background", e[2]), A(t, "title", n = e[1] ? "Color ".concat(e[0]) : "Click to open a color picker");
  }, m: function(o, a) {
    pt(o, t, a), r || (i = Nt(t, "click", e[3]), r = !0);
  }, p: function(o, a) {
    var s = xe(a, 1)[0];
    4 & s && to(t, "background", o[2]), 3 & s && n !== (n = o[1] ? "Color ".concat(o[0]) : "Click to open a color picker") && A(t, "title", n);
  }, i: Wt, o: Wt, d: function(o) {
    o && vt(t), r = !1, i();
  } };
}
function MQ(e, t, n) {
  var r, i = Hr("absolute-popup").openAbsolutePopup, o = t.path, a = t.value, s = t.readOnly, u = t.onPatch, c = t.focus;
  function l(h) {
    u([{ op: "replace", path: mt.exports.compileJSONPointer(o), value: h }]), f();
  }
  function f() {
    c();
  }
  return e.$$set = function(h) {
    "path" in h && n(4, o = h.path), "value" in h && n(0, a = h.value), "readOnly" in h && n(1, s = h.readOnly), "onPatch" in h && n(5, u = h.onPatch), "focus" in h && n(6, c = h.focus);
  }, e.$$.update = function() {
    1 & e.$$.dirty && n(2, r = CC(a));
  }, [a, s, r, function(h) {
    if (!s) {
      var d = h.target.getBoundingClientRect().top, p = cc(h.target).innerHeight;
      i(AQ, { color: a, onChange: l, showOnTop: p - d < 300 && d > 300 }, { anchor: h.target, closeOnOuterClick: !0, onClose: f, offsetTop: 18, offsetLeft: -8, height: 300 });
    }
  }, o, u, c];
}
var TQ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, MQ, EQ, Ue, { path: 4, value: 0, readOnly: 1, onPatch: 5, focus: 6 }, PQ), i;
  }
  return Y(n);
}();
function Ac(e) {
  var t = Jm(e);
  return Xs("jse-value", "jse-" + t, { "jse-url": Km(e), "jse-empty": typeof e == "string" && e.length === 0 });
}
function IQ(e) {
  var t, n;
  return t = new rM({ props: { value: e[1].escapeValue(e[0]), onChange: e[3], onCancel: e[4], onPaste: e[5], onFind: e[2], onValueClass: e[6] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = xe(i, 1)[0], a = {};
    3 & o && (a.value = r[1].escapeValue(r[0])), 4 & o && (a.onFind = r[2]), t.$set(a);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function NQ(e, t, n) {
  var r = t.path, i = t.value, o = t.normalization, a = t.enforceString, s = t.onPatch, u = t.onPasteJson, c = t.onSelect, l = t.onFind, f = t.focus;
  function h(d) {
    return a ? d : Rc(d);
  }
  return e.$$set = function(d) {
    "path" in d && n(7, r = d.path), "value" in d && n(0, i = d.value), "normalization" in d && n(1, o = d.normalization), "enforceString" in d && n(8, a = d.enforceString), "onPatch" in d && n(9, s = d.onPatch), "onPasteJson" in d && n(10, u = d.onPasteJson), "onSelect" in d && n(11, c = d.onSelect), "onFind" in d && n(2, l = d.onFind), "focus" in d && n(12, f = d.focus);
  }, [i, o, l, function(d, p) {
    s([{ op: "replace", path: mt.exports.compileJSONPointer(r), value: h(o.unescapeValue(d)) }], function(v, m) {
      var g = p === Um ? function(y, b, k) {
        var w = Ge(k), x = [ve(k)], S = pm(mt.exports.getIn(y, w), b, x);
        return S ? Mn(w.concat(S), !1) : Po(k);
      }(v, m, r) || m.selection : Mn(r, !1);
      return { state: Ct(Ct({}, m), {}, { selection: g }) };
    }), p !== Wm && f();
  }, function() {
    c(Mn(r, !1)), f();
  }, function(d) {
    try {
      var p = JSON.parse(d);
      ur(p) && u({ path: r, contents: p });
    } catch {
    }
  }, function(d) {
    return Ac(h(o.unescapeValue(d)));
  }, r, a, s, u, c, f];
}
var RQ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, NQ, IQ, Ue, { path: 7, value: 0, normalization: 1, enforceString: 8, onPatch: 9, onPasteJson: 10, onSelect: 11, onFind: 2, focus: 12 }), i;
  }
  return Y(n);
}();
function DQ(e) {
  Te(e, "svelte-6ci2p7", '.jse-value.jse-string.svelte-6ci2p7{color:var(--jse-value-color-string)}.jse-value.jse-object.svelte-6ci2p7,.jse-value.jse-array.svelte-6ci2p7{min-width:16px;color:var(--jse-delimiter-color)}.jse-value.jse-number.svelte-6ci2p7{color:var(--jse-value-color-number)}.jse-value.jse-boolean.svelte-6ci2p7{color:var(--jse-value-color-boolean)}.jse-value.jse-null.svelte-6ci2p7{color:var(--jse-value-color-null)}.jse-value.jse-invalid.svelte-6ci2p7{color:var(--jse-text-color)}.jse-value.jse-url.svelte-6ci2p7{color:var(--jse-value-color-url);text-decoration:underline}.jse-value.svelte-6ci2p7{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;word-break:normal;overflow-wrap:anywhere;white-space:pre-wrap}.jse-value.svelte-6ci2p7:hover{background:var(--jse-hover-background-color)}.jse-value.jse-empty.svelte-6ci2p7{min-width:4em;outline:1px dotted var(--jse-tag-background);-moz-outline-radius:2px}.jse-value.jse-empty.svelte-6ci2p7::after{pointer-events:none;color:var(--jse-tag-background);content:"value"}');
}
function LQ(e) {
  var t, n = Va(e[1].escapeValue(e[0])) + "";
  return { c: function() {
    t = Xt(n);
  }, m: function(r, i) {
    pt(r, t, i);
  }, p: function(r, i) {
    3 & i && n !== (n = Va(r[1].escapeValue(r[0])) + "") && Ve(t, n);
  }, i: Wt, o: Wt, d: function(r) {
    r && vt(t);
  } };
}
function zQ(e) {
  var t, n;
  return t = new nM({ props: { text: e[1].escapeValue(e[0]), searchResultItems: e[2] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    3 & i && (o.text = r[1].escapeValue(r[0])), 4 & i && (o.searchResultItems = r[2]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function BQ(e) {
  var t, n, r, i, o, a, s, u, c = [zQ, LQ], l = [];
  function f(h, d) {
    return h[2] ? 0 : 1;
  }
  return n = f(e), r = l[n] = c[n](e), { c: function() {
    t = rt("div"), r.c(), A(t, "data-type", "selectable-value"), A(t, "class", i = er(Ac(e[0])) + " svelte-6ci2p7"), A(t, "title", o = e[3] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null);
  }, m: function(h, d) {
    pt(h, t, d), l[n].m(t, null), a = !0, s || (u = [Nt(t, "click", e[4]), Nt(t, "dblclick", e[5])], s = !0);
  }, p: function(h, d) {
    var p = xe(d, 1)[0], v = n;
    (n = f(h)) === v ? l[n].p(h, p) : (qt(), tt(l[v], 1, 1, function() {
      l[v] = null;
    }), Vt(), (r = l[n]) ? r.p(h, p) : (r = l[n] = c[n](h)).c(), U(r, 1), r.m(t, null)), (!a || 1 & p && i !== (i = er(Ac(h[0])) + " svelte-6ci2p7")) && A(t, "class", i), (!a || 8 & p && o !== (o = h[3] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null)) && A(t, "title", o);
  }, i: function(h) {
    a || (U(r), a = !0);
  }, o: function(h) {
    tt(r), a = !1;
  }, d: function(h) {
    h && vt(t), l[n].d(), s = !1, Dn(u);
  } };
}
function FQ(e, t, n) {
  var r, i = t.path, o = t.value, a = t.readOnly, s = t.normalization, u = t.onSelect, c = t.searchResultItems;
  return e.$$set = function(l) {
    "path" in l && n(6, i = l.path), "value" in l && n(0, o = l.value), "readOnly" in l && n(7, a = l.readOnly), "normalization" in l && n(1, s = l.normalization), "onSelect" in l && n(8, u = l.onSelect), "searchResultItems" in l && n(2, c = l.searchResultItems);
  }, e.$$.update = function() {
    1 & e.$$.dirty && n(3, r = Km(o));
  }, [o, s, c, r, function(l) {
    typeof o == "string" && r && l.ctrlKey && (l.preventDefault(), l.stopPropagation(), window.open(o, "_blank"));
  }, function(l) {
    a || (l.preventDefault(), u(Mn(i, !0)));
  }, i, a, u];
}
var qQ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, FQ, BQ, Ue, { path: 6, value: 0, readOnly: 7, normalization: 1, onSelect: 8, searchResultItems: 2 }, DQ), i;
  }
  return Y(n);
}();
function VQ(e) {
  Te(e, "svelte-1u00zub", ".jse-timestamp.svelte-1u00zub{padding:0;margin:0;height:var(--jse-line-height);color:var(--jse-value-color-number);border-radius:3px}");
}
function HQ(e) {
  var t, n, r, i, o, a;
  return n = new Le({ props: { data: CK } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-timestamp svelte-1u00zub");
  }, m: function(s, u) {
    pt(s, t, u), Ot(n, t, null), i = !0, o || (a = Ic(r = iM.call(null, t, Ct({ text: e[0] }, e[1]))), o = !0);
  }, p: function(s, u) {
    var c = xe(u, 1)[0];
    r && Ai(r.update) && 1 & c && r.update.call(null, Ct({ text: s[0] }, s[1]));
  }, i: function(s) {
    i || (U(n.$$.fragment, s), i = !0);
  }, o: function(s) {
    tt(n.$$.fragment, s), i = !1;
  }, d: function(s) {
    s && vt(t), At(n), o = !1, a();
  } };
}
function WQ(e, t, n) {
  var r, i = Hr("absolute-popup"), o = t.value;
  return e.$$set = function(a) {
    "value" in a && n(2, o = a.value);
  }, e.$$.update = function() {
    4 & e.$$.dirty && n(0, r = "Time: ".concat(new Date(o).toString()));
  }, [r, i, o];
}
var UQ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, WQ, HQ, Ue, { value: 2 }, VQ), i;
  }
  return Y(n);
}();
function JQ(e) {
  var t = e.path, n = e.value, r = e.readOnly, i = e.enforceString, o = e.searchResultItems, a = e.isEditing, s = e.normalization, u = e.onPatch, c = e.onPasteJson, l = e.onSelect, f = e.onFind, h = e.focus, d = [];
  return !a && function(p) {
    return p === !0 || p === !1;
  }(n) && d.push({ component: $Q, props: { path: t, value: n, readOnly: r, onPatch: u, focus: h } }), !a && function(p) {
    return typeof p == "string" && !!CC(p);
  }(n) && d.push({ component: TQ, props: { path: t, value: n, readOnly: r, onPatch: u, focus: h } }), a && d.push({ component: RQ, props: { path: t, value: n, enforceString: i, normalization: s, onPatch: u, onPasteJson: c, onSelect: l, onFind: f, focus: h } }), a || d.push({ component: qQ, props: { path: t, value: n, readOnly: r, normalization: s, searchResultItems: o, onSelect: l } }), !a && function(p) {
    return typeof p == "number" && p > 9466848e5 && isFinite(p) && Math.floor(p) === p && !isNaN(new Date(p).valueOf());
  }(n) && d.push({ component: UQ, props: { value: n } }), d;
}
var $i = {};
function KQ(e) {
  Te(e, "svelte-3e0qet", ".item.svelte-3e0qet{cursor:default;height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--itemPadding, 0 20px);color:var(--itemColor, inherit);text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.groupHeader.svelte-3e0qet{text-transform:var(--groupTitleTextTransform, uppercase)}.groupItem.svelte-3e0qet{padding-left:var(--groupItemPaddingLeft, 40px)}.item.svelte-3e0qet:active{background:var(--itemActiveBackground, #b9daff)}.item.active.svelte-3e0qet{background:var(--itemIsActiveBG, #007aff);color:var(--itemIsActiveColor, #fff)}.item.notSelectable.svelte-3e0qet{color:var(--itemIsNotSelectableColor, #999)}.item.first.svelte-3e0qet{border-radius:var(--itemFirstBorderRadius, 4px 4px 0 0)}.item.hover.svelte-3e0qet:not(.active){background:var(--itemHoverBG, #e7f2ff);color:var(--itemHoverColor, inherit)}");
}
function GQ(e) {
  var t, n, r = e[0](e[1], e[2]) + "";
  return { c: function() {
    A(t = rt("div"), "class", n = "item " + e[3] + " svelte-3e0qet");
  }, m: function(i, o) {
    pt(i, t, o), t.innerHTML = r;
  }, p: function(i, o) {
    var a = xe(o, 1)[0];
    7 & a && r !== (r = i[0](i[1], i[2]) + "") && (t.innerHTML = r), 8 & a && n !== (n = "item " + i[3] + " svelte-3e0qet") && A(t, "class", n);
  }, i: Wt, o: Wt, d: function(i) {
    i && vt(t);
  } };
}
function QQ(e, t, n) {
  var r = t.isActive, i = r !== void 0 && r, o = t.isFirst, a = o !== void 0 && o, s = t.isHover, u = s !== void 0 && s, c = t.isSelectable, l = c !== void 0 && c, f = t.getOptionLabel, h = f === void 0 ? void 0 : f, d = t.item, p = d === void 0 ? void 0 : d, v = t.filterText, m = v === void 0 ? "" : v, g = "";
  return e.$$set = function(y) {
    "isActive" in y && n(4, i = y.isActive), "isFirst" in y && n(5, a = y.isFirst), "isHover" in y && n(6, u = y.isHover), "isSelectable" in y && n(7, l = y.isSelectable), "getOptionLabel" in y && n(0, h = y.getOptionLabel), "item" in y && n(1, p = y.item), "filterText" in y && n(2, m = y.filterText);
  }, e.$$.update = function() {
    if (242 & e.$$.dirty) {
      var y = [];
      i && y.push("active"), a && y.push("first"), u && y.push("hover"), p.isGroupHeader && y.push("groupHeader"), p.isGroupItem && y.push("groupItem"), l || y.push("notSelectable"), n(3, g = y.join(" "));
    }
  }, [h, p, m, g, i, a, u, l];
}
var sM = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, QQ, GQ, ir, { isActive: 4, isFirst: 5, isHover: 6, isSelectable: 7, getOptionLabel: 0, item: 1, filterText: 2 }, KQ), i;
  }
  return Y(n);
}();
function XQ(e) {
  Te(e, "svelte-1uyqfml", ".listContainer.svelte-1uyqfml{box-shadow:var(--listShadow, 0 2px 3px 0 rgba(44, 62, 80, 0.24));border-radius:var(--listBorderRadius, 4px);max-height:var(--listMaxHeight, 250px);overflow-y:auto;background:var(--listBackground, #fff);border:var(--listBorder, none);position:var(--listPosition, absolute);z-index:var(--listZIndex, 2);width:100%;left:var(--listLeft, 0);right:var(--listRight, 0)}.virtualList.svelte-1uyqfml{height:var(--virtualListHeight, 200px)}.listGroupTitle.svelte-1uyqfml{color:var(--groupTitleColor, #8f8f8f);cursor:default;font-size:var(--groupTitleFontSize, 12px);font-weight:var(--groupTitleFontWeight, 600);height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--groupTitlePadding, 0 20px);text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;text-transform:var(--groupTitleTextTransform, uppercase)}.empty.svelte-1uyqfml{text-align:var(--listEmptyTextAlign, center);padding:var(--listEmptyPadding, 20px 0);color:var(--listEmptyColor, #78848f)}");
}
function A$(e, t, n) {
  var r = e.slice();
  return r[41] = t[n], r[42] = n, r;
}
function ZQ(e) {
  for (var t, n, r = e[1], i = [], o = 0; o < r.length; o += 1)
    i[o] = M$(A$(e, r, o));
  var a = function(u) {
    return tt(i[u], 1, 1, function() {
      i[u] = null;
    });
  }, s = null;
  return r.length || (s = P$(e)), { c: function() {
    for (var u = 0; u < i.length; u += 1)
      i[u].c();
    t = Ye(), s && s.c();
  }, m: function(u, c) {
    for (var l = 0; l < i.length; l += 1)
      i[l].m(u, c);
    pt(u, t, c), s && s.m(u, c), n = !0;
  }, p: function(u, c) {
    if (114390 & c[0]) {
      var l;
      for (r = u[1], l = 0; l < r.length; l += 1) {
        var f = A$(u, r, l);
        i[l] ? (i[l].p(f, c), U(i[l], 1)) : (i[l] = M$(f), i[l].c(), U(i[l], 1), i[l].m(t.parentNode, t));
      }
      for (qt(), l = r.length; l < i.length; l += 1)
        a(l);
      Vt(), !r.length && s ? s.p(u, c) : r.length ? s && (s.d(1), s = null) : ((s = P$(u)).c(), s.m(t.parentNode, t));
    }
  }, i: function(u) {
    if (!n) {
      for (var c = 0; c < r.length; c += 1)
        U(i[c]);
      n = !0;
    }
  }, o: function(u) {
    i = i.filter(Boolean);
    for (var c = 0; c < i.length; c += 1)
      tt(i[c]);
    n = !1;
  }, d: function(u) {
    Ar(i, u), u && vt(t), s && s.d(u);
  } };
}
function YQ(e) {
  var t, n, r, i = e[3];
  function o(a) {
    return { props: { items: a[1], itemHeight: a[8], $$slots: { default: [nX, function(s) {
      return { 41: s.item, 42: s.i };
    }, function(s) {
      return [0, (s.item ? 1024 : 0) | (s.i ? 2048 : 0)];
    }] }, $$scope: { ctx: a } } };
  }
  return i && (t = new i(o(e))), { c: function() {
    t && Pt(t.$$.fragment), n = Ye();
  }, m: function(a, s) {
    t && Ot(t, a, s), pt(a, n, s), r = !0;
  }, p: function(a, s) {
    var u = {};
    if (2 & s[0] && (u.items = a[1]), 256 & s[0] && (u.itemHeight = a[8]), 9814 & s[0] | 11264 & s[1] && (u.$$scope = { dirty: s, ctx: a }), i !== (i = a[3])) {
      if (t) {
        qt();
        var c = t;
        tt(c.$$.fragment, 1, 0, function() {
          At(c, 1);
        }), Vt();
      }
      i ? (Pt((t = new i(o(a))).$$.fragment), U(t.$$.fragment, 1), Ot(t, n.parentNode, n)) : t = null;
    } else
      i && t.$set(u);
  }, i: function(a) {
    r || (t && U(t.$$.fragment, a), r = !0);
  }, o: function(a) {
    t && tt(t.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && vt(n), t && At(t, a);
  } };
}
function P$(e) {
  var t, n = !e[11] && E$(e);
  return { c: function() {
    n && n.c(), t = Ye();
  }, m: function(r, i) {
    n && n.m(r, i), pt(r, t, i);
  }, p: function(r, i) {
    r[11] ? n && (n.d(1), n = null) : n ? n.p(r, i) : ((n = E$(r)).c(), n.m(t.parentNode, t));
  }, d: function(r) {
    n && n.d(r), r && vt(t);
  } };
}
function E$(e) {
  var t, n;
  return { c: function() {
    t = rt("div"), n = Xt(e[12]), A(t, "class", "empty svelte-1uyqfml");
  }, m: function(r, i) {
    pt(r, t, i), W(t, n);
  }, p: function(r, i) {
    4096 & i[0] && Ve(n, r[12]);
  }, d: function(r) {
    r && vt(t);
  } };
}
function tX(e) {
  var t, n, r, i, o, a, s = e[4];
  function u(h) {
    return { props: { item: h[41], filterText: h[13], getOptionLabel: h[6], isFirst: km(h[42]), isActive: xh(h[41], h[9], h[10]), isHover: jh(h[2], h[41], h[42], h[1]), isSelectable: Ga(h[41]) } };
  }
  function c() {
    return e[29](e[42]);
  }
  function l() {
    return e[30](e[42]);
  }
  function f() {
    for (var h, d = arguments.length, p = new Array(d), v = 0; v < d; v++)
      p[v] = arguments[v];
    return (h = e)[31].apply(h, [e[41], e[42]].concat(p));
  }
  return s && (n = new s(u(e))), { c: function() {
    t = rt("div"), n && Pt(n.$$.fragment), r = bt(), A(t, "class", "listItem"), A(t, "tabindex", "-1");
  }, m: function(h, d) {
    pt(h, t, d), n && Ot(n, t, null), W(t, r), i = !0, o || (a = [Nt(t, "mouseover", c), Nt(t, "focus", l), Nt(t, "click", f)], o = !0);
  }, p: function(h, d) {
    e = h;
    var p = {};
    if (2 & d[0] && (p.item = e[41]), 8192 & d[0] && (p.filterText = e[13]), 64 & d[0] && (p.getOptionLabel = e[6]), 1538 & d[0] && (p.isActive = xh(e[41], e[9], e[10])), 6 & d[0] && (p.isHover = jh(e[2], e[41], e[42], e[1])), 2 & d[0] && (p.isSelectable = Ga(e[41])), s !== (s = e[4])) {
      if (n) {
        qt();
        var v = n;
        tt(v.$$.fragment, 1, 0, function() {
          At(v, 1);
        }), Vt();
      }
      s ? (Pt((n = new s(u(e))).$$.fragment), U(n.$$.fragment, 1), Ot(n, t, r)) : n = null;
    } else
      s && n.$set(p);
  }, i: function(h) {
    i || (n && U(n.$$.fragment, h), i = !0);
  }, o: function(h) {
    n && tt(n.$$.fragment, h), i = !1;
  }, d: function(h) {
    h && vt(t), n && At(n), o = !1, Dn(a);
  } };
}
function eX(e) {
  var t, n, r = e[7](e[41]) + "";
  return { c: function() {
    t = rt("div"), n = Xt(r), A(t, "class", "listGroupTitle svelte-1uyqfml");
  }, m: function(i, o) {
    pt(i, t, o), W(t, n);
  }, p: function(i, o) {
    130 & o[0] && r !== (r = i[7](i[41]) + "") && Ve(n, r);
  }, i: Wt, o: Wt, d: function(i) {
    i && vt(t);
  } };
}
function M$(e) {
  var t, n, r, i, o = [eX, tX], a = [];
  function s(u, c) {
    return u[41].isGroupHeader && !u[41].isSelectable ? 0 : 1;
  }
  return t = s(e), n = a[t] = o[t](e), { c: function() {
    n.c(), r = Ye();
  }, m: function(u, c) {
    a[t].m(u, c), pt(u, r, c), i = !0;
  }, p: function(u, c) {
    var l = t;
    (t = s(u)) === l ? a[t].p(u, c) : (qt(), tt(a[l], 1, 1, function() {
      a[l] = null;
    }), Vt(), (n = a[t]) ? n.p(u, c) : (n = a[t] = o[t](u)).c(), U(n, 1), n.m(r.parentNode, r));
  }, i: function(u) {
    i || (U(n), i = !0);
  }, o: function(u) {
    tt(n), i = !1;
  }, d: function(u) {
    a[t].d(u), u && vt(r);
  } };
}
function nX(e) {
  var t, n, r, i, o, a = e[4];
  function s(f) {
    return { props: { item: f[41], filterText: f[13], getOptionLabel: f[6], isFirst: km(f[42]), isActive: xh(f[41], f[9], f[10]), isHover: jh(f[2], f[41], f[42], f[1]), isSelectable: Ga(f[41]) } };
  }
  function u() {
    return e[26](e[42]);
  }
  function c() {
    return e[27](e[42]);
  }
  function l() {
    for (var f, h = arguments.length, d = new Array(h), p = 0; p < h; p++)
      d[p] = arguments[p];
    return (f = e)[28].apply(f, [e[41], e[42]].concat(d));
  }
  return a && (n = new a(s(e))), { c: function() {
    t = rt("div"), n && Pt(n.$$.fragment), A(t, "class", "listItem");
  }, m: function(f, h) {
    pt(f, t, h), n && Ot(n, t, null), r = !0, i || (o = [Nt(t, "mouseover", u), Nt(t, "focus", c), Nt(t, "click", l)], i = !0);
  }, p: function(f, h) {
    e = f;
    var d = {};
    if (1024 & h[1] && (d.item = e[41]), 8192 & h[0] && (d.filterText = e[13]), 64 & h[0] && (d.getOptionLabel = e[6]), 2048 & h[1] && (d.isFirst = km(e[42])), 1536 & h[0] | 1024 & h[1] && (d.isActive = xh(e[41], e[9], e[10])), 6 & h[0] | 3072 & h[1] && (d.isHover = jh(e[2], e[41], e[42], e[1])), 1024 & h[1] && (d.isSelectable = Ga(e[41])), a !== (a = e[4])) {
      if (n) {
        qt();
        var p = n;
        tt(p.$$.fragment, 1, 0, function() {
          At(p, 1);
        }), Vt();
      }
      a ? (Pt((n = new a(s(e))).$$.fragment), U(n.$$.fragment, 1), Ot(n, t, null)) : n = null;
    } else
      a && n.$set(d);
  }, i: function(f) {
    r || (n && U(n.$$.fragment, f), r = !0);
  }, o: function(f) {
    n && tt(n.$$.fragment, f), r = !1;
  }, d: function(f) {
    f && vt(t), n && At(n), i = !1, Dn(o);
  } };
}
function rX(e) {
  var t, n, r, i, o, a, s = [YQ, ZQ], u = [];
  function c(l, f) {
    return l[5] ? 0 : 1;
  }
  return n = c(e), r = u[n] = s[n](e), { c: function() {
    t = rt("div"), r.c(), A(t, "class", "listContainer svelte-1uyqfml"), A(t, "style", e[14]), Ut(t, "virtualList", e[5]);
  }, m: function(l, f) {
    pt(l, t, f), u[n].m(t, null), e[32](t), i = !0, o || (a = [Nt(window, "keydown", e[17]), Nt(window, "resize", e[18])], o = !0);
  }, p: function(l, f) {
    var h = n;
    (n = c(l)) === h ? u[n].p(l, f) : (qt(), tt(u[h], 1, 1, function() {
      u[h] = null;
    }), Vt(), (r = u[n]) ? r.p(l, f) : (r = u[n] = s[n](l)).c(), U(r, 1), r.m(t, null)), (!i || 16384 & f[0]) && A(t, "style", l[14]), 32 & f[0] && Ut(t, "virtualList", l[5]);
  }, i: function(l) {
    i || (U(r), i = !0);
  }, o: function(l) {
    tt(r), i = !1;
  }, d: function(l) {
    l && vt(t), u[n].d(), e[32](null), o = !1, Dn(a);
  } };
}
function xh(e, t, n) {
  return t && t[n] === e[n];
}
function km(e) {
  return e === 0;
}
function jh(e, t, n, r) {
  return Ga(t) && (e === n || r.length === 1);
}
function Ga(e) {
  return e.isGroupHeader && e.isSelectable || e.selectable || !e.hasOwnProperty("selectable");
}
function iX(e, t, n) {
  var r, i, o = Ph(), a = t.container, s = a === void 0 ? void 0 : a, u = t.VirtualList, c = u === void 0 ? null : u, l = t.Item, f = l === void 0 ? sM : l, h = t.isVirtualList, d = h !== void 0 && h, p = t.items, v = p === void 0 ? [] : p, m = t.labelIdentifier, g = m === void 0 ? "label" : m, y = t.getOptionLabel, b = y === void 0 ? function(St, Gt) {
    if (St)
      return St.isCreator ? 'Create "'.concat(Gt, '"') : St[g];
  } : y, k = t.getGroupHeaderLabel, w = k === void 0 ? null : k, x = t.itemHeight, S = x === void 0 ? 40 : x, T = t.hoverItemIndex, P = T === void 0 ? 0 : T, O = t.value, j = O === void 0 ? void 0 : O, V = t.optionIdentifier, E = V === void 0 ? "value" : V, C = t.hideEmptyState, H = C !== void 0 && C, X = t.noOptionsMessage, F = X === void 0 ? "No options" : X, G = t.isMulti, M = G !== void 0 && G, $ = t.activeItemIndex, q = $ === void 0 ? 0 : $, B = t.filterText, D = B === void 0 ? "" : B, _ = t.parent, L = _ === void 0 ? null : _, J = t.listPlacement, st = J === void 0 ? null : J, ht = t.listAutoWidth, xt = ht === void 0 ? null : ht, kt = t.listOffset, I = kt === void 0 ? 5 : kt, R = 0, it = !1;
  function N(St) {
    St.isCreator || o("itemSelected", St);
  }
  function K(St) {
    it || n(2, P = St);
  }
  function z(St) {
    var Gt = St.item, _e = St.i;
    if (St.event.stopPropagation(), j && !M && j[E] === Gt[E])
      return at();
    Gt.isCreator ? o("itemCreated", D) : Ga(Gt) && (n(19, q = _e), n(2, P = _e), N(Gt));
  }
  function at() {
    o("closeList");
  }
  function yt(St) {
    return jt.apply(this, arguments);
  }
  function jt() {
    return (jt = mn(de().mark(function St(Gt) {
      var _e;
      return de().wrap(function(Fe) {
        for (; ; )
          switch (Fe.prev = Fe.next) {
            case 0:
              if (!d) {
                Fe.next = 2;
                break;
              }
              return Fe.abrupt("return");
            case 2:
              for (_e = !0; _e; )
                Gt > 0 && P === v.length - 1 ? n(2, P = 0) : n(2, Gt < 0 && P === 0 ? P = v.length - 1 : P += Gt), _e = !Ga(v[P]);
              return Fe.next = 6, Qn();
            case 6:
              Ft("hover");
            case 7:
            case "end":
              return Fe.stop();
          }
      }, St);
    }))).apply(this, arguments);
  }
  function Ft(St) {
    if (!d && s) {
      var Gt, _e = s.querySelector(".listItem .".concat(St));
      _e && (Gt = s.getBoundingClientRect().bottom - _e.getBoundingClientRect().bottom), n(0, s.scrollTop -= Gt, s);
    }
  }
  function zt() {
    var St = L.getBoundingClientRect(), Gt = St.height, _e = St.width;
    n(14, i = ""), n(14, i += "min-width:".concat(_e, "px;width:").concat(xt ? "auto" : "100%", ";")), st === "top" || st === "auto" && function(Fe, fn) {
      var De = Fe.getBoundingClientRect(), $t = fn.getBoundingClientRect(), oe = {};
      return oe.top = De.top < 0, oe.left = De.left < 0, oe.bottom = De.bottom + $t.height > (window.innerHeight || document.documentElement.clientHeight), oe.right = De.right > (window.innerWidth || document.documentElement.clientWidth), oe.any = oe.top || oe.left || oe.bottom || oe.right, oe;
    }(L, s).bottom ? n(14, i += "bottom:".concat(Gt + I, "px;")) : n(14, i += "top:".concat(Gt + I, "px;"));
  }
  return yi(function() {
    if (v.length > 0 && !M && j) {
      var St = v.findIndex(function(Gt) {
        return Gt[E] === j[E];
      });
      St && n(2, P = St);
    }
    Ft("active"), s.addEventListener("scroll", function() {
      clearTimeout(R), R = setTimeout(function() {
        it = !1;
      }, 100);
    }, !1);
  }), wC(function() {
    v || n(1, v = []), v !== r && v.length > 0 && n(2, P = 0), r = v;
  }), e.$$set = function(St) {
    "container" in St && n(0, s = St.container), "VirtualList" in St && n(3, c = St.VirtualList), "Item" in St && n(4, f = St.Item), "isVirtualList" in St && n(5, d = St.isVirtualList), "items" in St && n(1, v = St.items), "labelIdentifier" in St && n(20, g = St.labelIdentifier), "getOptionLabel" in St && n(6, b = St.getOptionLabel), "getGroupHeaderLabel" in St && n(7, w = St.getGroupHeaderLabel), "itemHeight" in St && n(8, S = St.itemHeight), "hoverItemIndex" in St && n(2, P = St.hoverItemIndex), "value" in St && n(9, j = St.value), "optionIdentifier" in St && n(10, E = St.optionIdentifier), "hideEmptyState" in St && n(11, H = St.hideEmptyState), "noOptionsMessage" in St && n(12, F = St.noOptionsMessage), "isMulti" in St && n(21, M = St.isMulti), "activeItemIndex" in St && n(19, q = St.activeItemIndex), "filterText" in St && n(13, D = St.filterText), "parent" in St && n(22, L = St.parent), "listPlacement" in St && n(23, st = St.listPlacement), "listAutoWidth" in St && n(24, xt = St.listAutoWidth), "listOffset" in St && n(25, I = St.listOffset);
  }, e.$$.update = function() {
    4194305 & e.$$.dirty[0] && L && s && zt();
  }, [s, v, P, c, f, d, b, w, S, j, E, H, F, D, i, K, z, function(St) {
    switch (St.key) {
      case "Escape":
        St.preventDefault(), at();
        break;
      case "ArrowDown":
        St.preventDefault(), v.length && yt(1);
        break;
      case "ArrowUp":
        St.preventDefault(), v.length && yt(-1);
        break;
      case "Enter":
        if (St.preventDefault(), v.length === 0)
          break;
        var Gt = v[P];
        if (j && !M && j[E] === Gt[E]) {
          at();
          break;
        }
        Gt.isCreator ? o("itemCreated", D) : (n(19, q = P), N(v[P]));
        break;
      case "Tab":
        if (St.preventDefault(), v.length === 0 || j && j[E] === v[P][E])
          return at();
        n(19, q = P), N(v[P]);
    }
  }, zt, q, g, M, L, st, xt, I, function(St) {
    return K(St);
  }, function(St) {
    return K(St);
  }, function(St, Gt, _e) {
    return z({ item: St, i: Gt, event: _e });
  }, function(St) {
    return K(St);
  }, function(St) {
    return K(St);
  }, function(St, Gt, _e) {
    return z({ item: St, i: Gt, event: _e });
  }, function(St) {
    Be[St ? "unshift" : "push"](function() {
      n(0, s = St);
    });
  }];
}
var oX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, iX, rX, ir, { container: 0, VirtualList: 3, Item: 4, isVirtualList: 5, items: 1, labelIdentifier: 20, getOptionLabel: 6, getGroupHeaderLabel: 7, itemHeight: 8, hoverItemIndex: 2, value: 9, optionIdentifier: 10, hideEmptyState: 11, noOptionsMessage: 12, isMulti: 21, activeItemIndex: 19, filterText: 13, parent: 22, listPlacement: 23, listAutoWidth: 24, listOffset: 25 }, XQ, [-1, -1]), i;
  }
  return Y(n);
}();
function aX(e) {
  Te(e, "svelte-pu1q1n", ".selection.svelte-pu1q1n{text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap}");
}
function sX(e) {
  var t, n = e[0](e[1]) + "";
  return { c: function() {
    A(t = rt("div"), "class", "selection svelte-pu1q1n");
  }, m: function(r, i) {
    pt(r, t, i), t.innerHTML = n;
  }, p: function(r, i) {
    3 & xe(i, 1)[0] && n !== (n = r[0](r[1]) + "") && (t.innerHTML = n);
  }, i: Wt, o: Wt, d: function(r) {
    r && vt(t);
  } };
}
function uX(e, t, n) {
  var r = t.getSelectionLabel, i = r === void 0 ? void 0 : r, o = t.item, a = o === void 0 ? void 0 : o;
  return e.$$set = function(s) {
    "getSelectionLabel" in s && n(0, i = s.getSelectionLabel), "item" in s && n(1, a = s.item);
  }, [i, a];
}
var cX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, uX, sX, ir, { getSelectionLabel: 0, item: 1 }, aX), i;
  }
  return Y(n);
}();
function lX(e) {
  Te(e, "svelte-liu9pa", ".multiSelectItem.svelte-liu9pa.svelte-liu9pa{background:var(--multiItemBG, #ebedef);margin:var(--multiItemMargin, 5px 5px 0 0);border-radius:var(--multiItemBorderRadius, 16px);height:var(--multiItemHeight, 32px);line-height:var(--multiItemHeight, 32px);display:flex;cursor:default;padding:var(--multiItemPadding, 0 10px 0 15px);max-width:100%}.multiSelectItem_label.svelte-liu9pa.svelte-liu9pa{margin:var(--multiLabelMargin, 0 5px 0 0);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.multiSelectItem.svelte-liu9pa.svelte-liu9pa:hover,.multiSelectItem.active.svelte-liu9pa.svelte-liu9pa{background-color:var(--multiItemActiveBG, #006fff);color:var(--multiItemActiveColor, #fff)}.multiSelectItem.disabled.svelte-liu9pa.svelte-liu9pa:hover{background:var(--multiItemDisabledHoverBg, #ebedef);color:var(--multiItemDisabledHoverColor, #c1c6cc)}.multiSelectItem_clear.svelte-liu9pa.svelte-liu9pa{border-radius:var(--multiClearRadius, 50%);background:var(--multiClearBG, #52616f);min-width:var(--multiClearWidth, 16px);max-width:var(--multiClearWidth, 16px);height:var(--multiClearHeight, 16px);position:relative;top:var(--multiClearTop, 8px);text-align:var(--multiClearTextAlign, center);padding:var(--multiClearPadding, 1px)}.multiSelectItem_clear.svelte-liu9pa.svelte-liu9pa:hover,.active.svelte-liu9pa .multiSelectItem_clear.svelte-liu9pa{background:var(--multiClearHoverBG, #fff)}.multiSelectItem_clear.svelte-liu9pa:hover svg.svelte-liu9pa,.active.svelte-liu9pa .multiSelectItem_clear svg.svelte-liu9pa{fill:var(--multiClearHoverFill, #006fff)}.multiSelectItem_clear.svelte-liu9pa svg.svelte-liu9pa{fill:var(--multiClearFill, #ebedef);vertical-align:top}");
}
function T$(e, t, n) {
  var r = e.slice();
  return r[9] = t[n], r[11] = n, r;
}
function I$(e) {
  var t, n, r;
  function i() {
    for (var o, a = arguments.length, s = new Array(a), u = 0; u < a; u++)
      s[u] = arguments[u];
    return (o = e)[6].apply(o, [e[11]].concat(s));
  }
  return { c: function() {
    (t = rt("div")).innerHTML = '<svg width="100%" height="100%" viewBox="-2 -2 50 50" focusable="false" aria-hidden="true" role="presentation" class="svelte-liu9pa"><path d="M34.923,37.251L24,26.328L13.077,37.251L9.436,33.61l10.923-10.923L9.436,11.765l3.641-3.641L24,19.047L34.923,8.124 l3.641,3.641L27.641,22.688L38.564,33.61L34.923,37.251z"></path></svg>', A(t, "class", "multiSelectItem_clear svelte-liu9pa");
  }, m: function(o, a) {
    pt(o, t, a), n || (r = Nt(t, "click", i), n = !0);
  }, p: function(o, a) {
    e = o;
  }, d: function(o) {
    o && vt(t), n = !1, r();
  } };
}
function N$(e) {
  var t, n, r, i, o, a, s, u = e[4](e[9]) + "", c = !e[2] && !e[3] && I$(e);
  function l() {
    for (var f, h = arguments.length, d = new Array(h), p = 0; p < h; p++)
      d[p] = arguments[p];
    return (f = e)[7].apply(f, [e[11]].concat(d));
  }
  return { c: function() {
    t = rt("div"), n = rt("div"), r = bt(), c && c.c(), i = bt(), A(n, "class", "multiSelectItem_label svelte-liu9pa"), A(t, "class", o = "multiSelectItem " + (e[1] === e[11] ? "active" : "") + " " + (e[2] ? "disabled" : "") + " svelte-liu9pa");
  }, m: function(f, h) {
    pt(f, t, h), W(t, n), n.innerHTML = u, W(t, r), c && c.m(t, null), W(t, i), a || (s = Nt(t, "click", l), a = !0);
  }, p: function(f, h) {
    e = f, 17 & h && u !== (u = e[4](e[9]) + "") && (n.innerHTML = u), e[2] || e[3] ? c && (c.d(1), c = null) : c ? c.p(e, h) : ((c = I$(e)).c(), c.m(t, i)), 6 & h && o !== (o = "multiSelectItem " + (e[1] === e[11] ? "active" : "") + " " + (e[2] ? "disabled" : "") + " svelte-liu9pa") && A(t, "class", o);
  }, d: function(f) {
    f && vt(t), c && c.d(), a = !1, s();
  } };
}
function fX(e) {
  for (var t, n = e[0], r = [], i = 0; i < n.length; i += 1)
    r[i] = N$(T$(e, n, i));
  return { c: function() {
    for (var o = 0; o < r.length; o += 1)
      r[o].c();
    t = Ye();
  }, m: function(o, a) {
    for (var s = 0; s < r.length; s += 1)
      r[s].m(o, a);
    pt(o, t, a);
  }, p: function(o, a) {
    var s = xe(a, 1)[0];
    if (63 & s) {
      var u;
      for (n = o[0], u = 0; u < n.length; u += 1) {
        var c = T$(o, n, u);
        r[u] ? r[u].p(c, s) : (r[u] = N$(c), r[u].c(), r[u].m(t.parentNode, t));
      }
      for (; u < r.length; u += 1)
        r[u].d(1);
      r.length = n.length;
    }
  }, i: Wt, o: Wt, d: function(o) {
    Ar(r, o), o && vt(t);
  } };
}
function hX(e, t, n) {
  var r = Ph(), i = t.value, o = i === void 0 ? [] : i, a = t.activeValue, s = a === void 0 ? void 0 : a, u = t.isDisabled, c = u !== void 0 && u, l = t.multiFullItemClearable, f = l !== void 0 && l, h = t.getSelectionLabel, d = h === void 0 ? void 0 : h;
  function p(v, m) {
    m.stopPropagation(), r("multiItemClear", { i: v });
  }
  return e.$$set = function(v) {
    "value" in v && n(0, o = v.value), "activeValue" in v && n(1, s = v.activeValue), "isDisabled" in v && n(2, c = v.isDisabled), "multiFullItemClearable" in v && n(3, f = v.multiFullItemClearable), "getSelectionLabel" in v && n(4, d = v.getSelectionLabel);
  }, [o, s, c, f, d, p, function(v, m) {
    return p(v, m);
  }, function(v, m) {
    return f ? p(v, m) : {};
  }];
}
var dX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, hX, fX, ir, { value: 0, activeValue: 1, isDisabled: 2, multiFullItemClearable: 3, getSelectionLabel: 4 }, lX), i;
  }
  return Y(n);
}();
function vX(e) {
  Te(e, "svelte-g2cagw", "svelte-virtual-list-viewport.svelte-g2cagw{position:relative;overflow-y:auto;-webkit-overflow-scrolling:touch;display:block}svelte-virtual-list-contents.svelte-g2cagw,svelte-virtual-list-row.svelte-g2cagw{display:block}svelte-virtual-list-row.svelte-g2cagw{overflow:hidden}");
}
function R$(e, t, n) {
  var r = e.slice();
  return r[23] = t[n], r;
}
var pX = function(e) {
  return { item: 32 & e, i: 32 & e, hoverItemIndex: 2 & e };
}, D$ = function(e) {
  return { item: e[23].data, i: e[23].index, hoverItemIndex: e[1] };
};
function L$(e, t) {
  var n, r, i, o = t[15].default, a = Di(o, t, t[14], D$), s = a || function(u) {
    var c;
    return { c: function() {
      c = Xt("Missing template");
    }, m: function(l, f) {
      pt(l, c, f);
    }, d: function(l) {
      l && vt(c);
    } };
  }();
  return { key: e, first: null, c: function() {
    n = rt("svelte-virtual-list-row"), s && s.c(), r = bt(), Jv(n, "class", "svelte-g2cagw"), this.first = n;
  }, m: function(u, c) {
    pt(u, n, c), s && s.m(n, null), W(n, r), i = !0;
  }, p: function(u, c) {
    t = u, a && a.p && (!i || 16418 & c) && zi(a, o, t, t[14], i ? Li(o, t[14], c, pX) : Bi(t[14]), D$);
  }, i: function(u) {
    i || (U(s, u), i = !0);
  }, o: function(u) {
    tt(s, u), i = !1;
  }, d: function(u) {
    u && vt(n), s && s.d(u);
  } };
}
function mX(e) {
  for (var t, n, r, i, o, a, s = [], u = /* @__PURE__ */ new Map(), c = e[5], l = function(p) {
    return p[23].index;
  }, f = 0; f < c.length; f += 1) {
    var h = R$(e, c, f), d = l(h);
    u.set(d, s[f] = L$(d, h));
  }
  return { c: function() {
    t = rt("svelte-virtual-list-viewport"), n = rt("svelte-virtual-list-contents");
    for (var p = 0; p < s.length; p += 1)
      s[p].c();
    to(n, "padding-top", e[6] + "px"), to(n, "padding-bottom", e[7] + "px"), Jv(n, "class", "svelte-g2cagw"), to(t, "height", e[0]), Jv(t, "class", "svelte-g2cagw"), ia(function() {
      return e[18].call(t);
    });
  }, m: function(p, v) {
    pt(p, t, v), W(t, n);
    for (var m = 0; m < s.length; m += 1)
      s[m].m(n, null);
    e[16](n), e[17](t), r = function(g, y) {
      getComputedStyle(g).position === "static" && (g.style.position = "relative");
      var b = rt("iframe");
      b.setAttribute("style", "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;"), b.setAttribute("aria-hidden", "true"), b.tabIndex = -1;
      var k, w = zD();
      return w ? (b.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}<\/script>", k = Nt(window, "message", function(x) {
        x.source === b.contentWindow && y();
      })) : (b.src = "about:blank", b.onload = function() {
        k = Nt(b.contentWindow, "resize", y);
      }), W(g, b), function() {
        (w || k && b.contentWindow) && k(), vt(b);
      };
    }(t, e[18].bind(t)), i = !0, o || (a = Nt(t, "scroll", e[8]), o = !0);
  }, p: function(p, v) {
    var m = xe(v, 1)[0];
    16418 & m && (c = p[5], qt(), s = Nc(s, m, l, 1, p, c, u, n, Eh, L$, null, R$), Vt()), (!i || 64 & m) && to(n, "padding-top", p[6] + "px"), (!i || 128 & m) && to(n, "padding-bottom", p[7] + "px"), (!i || 1 & m) && to(t, "height", p[0]);
  }, i: function(p) {
    if (!i) {
      for (var v = 0; v < c.length; v += 1)
        U(s[v]);
      i = !0;
    }
  }, o: function(p) {
    for (var v = 0; v < s.length; v += 1)
      tt(s[v]);
    i = !1;
  }, d: function(p) {
    p && vt(t);
    for (var v = 0; v < s.length; v += 1)
      s[v].d();
    e[16](null), e[17](null), r(), o = !1, a();
  } };
}
function gX(e, t, n) {
  var r, i, o, a, s, u, c = t.$$slots, l = c === void 0 ? {} : c, f = t.$$scope, h = t.items, d = h === void 0 ? void 0 : h, p = t.height, v = p === void 0 ? "100%" : p, m = t.itemHeight, g = m === void 0 ? 40 : m, y = t.hoverItemIndex, b = y === void 0 ? 0 : y, k = t.start, w = k === void 0 ? 0 : k, x = t.end, S = x === void 0 ? 0 : x, T = [], P = 0, O = 0, j = 0;
  function V() {
    return (V = mn(de().mark(function C(H, X, F) {
      var G, M, $, q, B, D;
      return de().wrap(function(_) {
        for (; ; )
          switch (_.prev = _.next) {
            case 0:
              return G = i.scrollTop, _.next = 3, Qn();
            case 3:
              M = O - G, $ = w;
            case 5:
              if (!(M < X && $ < H.length)) {
                _.next = 17;
                break;
              }
              if (q = r[$ - w]) {
                _.next = 12;
                break;
              }
              return n(10, S = $ + 1), _.next = 11, Qn();
            case 11:
              q = r[$ - w];
            case 12:
              B = T[$] = F || q.offsetHeight, M += B, $ += 1, _.next = 5;
              break;
            case 17:
              n(10, S = $), D = H.length - S, n(7, j = D * (u = (O + M) / S)), T.length = H.length, i && n(3, i.scrollTop = 0, i);
            case 23:
            case "end":
              return _.stop();
          }
      }, C);
    }))).apply(this, arguments);
  }
  function E() {
    return (E = mn(de().mark(function C() {
      var H, X, F, G, M, $, q, B, D, _, L;
      return de().wrap(function(J) {
        for (; ; )
          switch (J.prev = J.next) {
            case 0:
              for (H = i.scrollTop, X = w, F = 0; F < r.length; F += 1)
                T[w + F] = g || r[F].offsetHeight;
              G = 0, M = 0;
            case 5:
              if (!(G < d.length)) {
                J.next = 15;
                break;
              }
              if ($ = T[G] || u, !(M + $ > H)) {
                J.next = 11;
                break;
              }
              return n(9, w = G), n(6, O = M), J.abrupt("break", 15);
            case 11:
              M += $, G += 1, J.next = 5;
              break;
            case 15:
              if (!(G < d.length)) {
                J.next = 22;
                break;
              }
              if (M += T[G] || u, G += 1, !(M > H + P)) {
                J.next = 20;
                break;
              }
              return J.abrupt("break", 22);
            case 20:
              J.next = 15;
              break;
            case 22:
              for (n(10, S = G), q = d.length - S, u = M / S; G < d.length; )
                T[G++] = u;
              if (n(7, j = q * u), !(w < X)) {
                J.next = 35;
                break;
              }
              return J.next = 30, Qn();
            case 30:
              for (B = 0, D = 0, _ = w; _ < X; _ += 1)
                r[_ - w] && (B += T[_], D += g || r[_ - w].offsetHeight);
              L = D - B, i.scrollTo(0, H + L);
            case 35:
            case "end":
              return J.stop();
          }
      }, C);
    }))).apply(this, arguments);
  }
  return yi(function() {
    r = o.getElementsByTagName("svelte-virtual-list-row"), n(13, s = !0);
  }), e.$$set = function(C) {
    "items" in C && n(11, d = C.items), "height" in C && n(0, v = C.height), "itemHeight" in C && n(12, g = C.itemHeight), "hoverItemIndex" in C && n(1, b = C.hoverItemIndex), "start" in C && n(9, w = C.start), "end" in C && n(10, S = C.end), "$$scope" in C && n(14, f = C.$$scope);
  }, e.$$.update = function() {
    3584 & e.$$.dirty && n(5, a = d.slice(w, S).map(function(C, H) {
      return { index: H + w, data: C };
    })), 14340 & e.$$.dirty && s && function(C, H, X) {
      V.apply(this, arguments);
    }(d, P, g);
  }, [v, b, P, i, o, a, O, j, function() {
    return E.apply(this, arguments);
  }, w, S, d, g, s, f, l, function(C) {
    Be[C ? "unshift" : "push"](function() {
      n(4, o = C);
    });
  }, function(C) {
    Be[C ? "unshift" : "push"](function() {
      n(3, i = C);
    });
  }, function() {
    P = this.offsetHeight, n(2, P);
  }];
}
var yX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, gX, mX, ir, { items: 11, height: 0, itemHeight: 12, hoverItemIndex: 1, start: 9, end: 10 }, vX), i;
  }
  return Y(n);
}();
function bX(e) {
  var t, n;
  return { c: function() {
    t = Co("svg"), A(n = Co("path"), "fill", "currentColor"), A(n, "d", `M34.923,37.251L24,26.328L13.077,37.251L9.436,33.61l10.923-10.923L9.436,11.765l3.641-3.641L24,19.047L34.923,8.124
    l3.641,3.641L27.641,22.688L38.564,33.61L34.923,37.251z`), A(t, "width", "100%"), A(t, "height", "100%"), A(t, "viewBox", "-2 -2 50 50"), A(t, "focusable", "false"), A(t, "aria-hidden", "true"), A(t, "role", "presentation");
  }, m: function(r, i) {
    pt(r, t, i), W(t, n);
  }, p: Wt, i: Wt, o: Wt, d: function(r) {
    r && vt(t);
  } };
}
var kX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, null, bX, ir, {}), i;
  }
  return Y(n);
}();
function wX(e) {
  Te(e, "svelte-17l1npl", ".selectContainer.svelte-17l1npl.svelte-17l1npl{--internalPadding:0 16px;border:var(--border, 1px solid #d8dbdf);border-radius:var(--borderRadius, 3px);box-sizing:border-box;height:var(--height, 42px);position:relative;display:flex;align-items:center;padding:var(--padding, var(--internalPadding));background:var(--background, #fff);margin:var(--margin, 0)}.selectContainer.svelte-17l1npl input.svelte-17l1npl{cursor:default;border:none;color:var(--inputColor, #3f4f5f);height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--inputPadding, var(--padding, var(--internalPadding)));width:100%;background:transparent;font-size:var(--inputFontSize, 14px);letter-spacing:var(--inputLetterSpacing, -0.08px);position:absolute;left:var(--inputLeft, 0);margin:var(--inputMargin, 0)}.selectContainer.svelte-17l1npl input.svelte-17l1npl::placeholder{color:var(--placeholderColor, #78848f);opacity:var(--placeholderOpacity, 1)}.selectContainer.svelte-17l1npl input.svelte-17l1npl:focus{outline:none}.selectContainer.svelte-17l1npl.svelte-17l1npl:hover{border-color:var(--borderHoverColor, #b2b8bf)}.selectContainer.focused.svelte-17l1npl.svelte-17l1npl{border-color:var(--borderFocusColor, #006fe8)}.selectContainer.disabled.svelte-17l1npl.svelte-17l1npl{background:var(--disabledBackground, #ebedef);border-color:var(--disabledBorderColor, #ebedef);color:var(--disabledColor, #c1c6cc)}.selectContainer.disabled.svelte-17l1npl input.svelte-17l1npl::placeholder{color:var(--disabledPlaceholderColor, #c1c6cc);opacity:var(--disabledPlaceholderOpacity, 1)}.selectedItem.svelte-17l1npl.svelte-17l1npl{line-height:var(--height, 42px);height:var(--height, 42px);overflow-x:hidden;padding:var(--selectedItemPadding, 0 20px 0 0)}.selectedItem.svelte-17l1npl.svelte-17l1npl:focus{outline:none}.clearSelect.svelte-17l1npl.svelte-17l1npl{position:absolute;right:var(--clearSelectRight, 10px);top:var(--clearSelectTop, 11px);bottom:var(--clearSelectBottom, 11px);width:var(--clearSelectWidth, 20px);color:var(--clearSelectColor, #c5cacf);flex:none !important}.clearSelect.svelte-17l1npl.svelte-17l1npl:hover{color:var(--clearSelectHoverColor, #2c3e50)}.selectContainer.focused.svelte-17l1npl .clearSelect.svelte-17l1npl{color:var(--clearSelectFocusColor, #3f4f5f)}.indicator.svelte-17l1npl.svelte-17l1npl{position:absolute;right:var(--indicatorRight, 10px);top:var(--indicatorTop, 11px);width:var(--indicatorWidth, 20px);height:var(--indicatorHeight, 20px);color:var(--indicatorColor, #c5cacf)}.indicator.svelte-17l1npl svg.svelte-17l1npl{display:inline-block;fill:var(--indicatorFill, currentcolor);line-height:1;stroke:var(--indicatorStroke, currentcolor);stroke-width:0}.spinner.svelte-17l1npl.svelte-17l1npl{position:absolute;right:var(--spinnerRight, 10px);top:var(--spinnerLeft, 11px);width:var(--spinnerWidth, 20px);height:var(--spinnerHeight, 20px);color:var(--spinnerColor, #51ce6c);animation:svelte-17l1npl-rotate 0.75s linear infinite}.spinner_icon.svelte-17l1npl.svelte-17l1npl{display:block;height:100%;transform-origin:center center;width:100%;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;-webkit-transform:none}.spinner_path.svelte-17l1npl.svelte-17l1npl{stroke-dasharray:90;stroke-linecap:round}.multiSelect.svelte-17l1npl.svelte-17l1npl{display:flex;padding:var(--multiSelectPadding, 0 35px 0 16px);height:auto;flex-wrap:wrap;align-items:stretch}.multiSelect.svelte-17l1npl>.svelte-17l1npl{flex:1 1 50px}.selectContainer.multiSelect.svelte-17l1npl input.svelte-17l1npl{padding:var(--multiSelectInputPadding, 0);position:relative;margin:var(--multiSelectInputMargin, 0)}.hasError.svelte-17l1npl.svelte-17l1npl{border:var(--errorBorder, 1px solid #ff2d55);background:var(--errorBackground, #fff)}.a11yText.svelte-17l1npl.svelte-17l1npl{z-index:9999;border:0px;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0px;white-space:nowrap}@keyframes svelte-17l1npl-rotate{100%{transform:rotate(360deg)}}");
}
function z$(e, t, n) {
  var r = e.slice();
  return r[103] = t[n], r;
}
function B$(e) {
  var t, n, r, i, o;
  return { c: function() {
    t = rt("span"), n = Xt(e[33]), r = bt(), i = rt("span"), o = Xt(e[32]), A(t, "id", "aria-selection"), A(i, "id", "aria-context");
  }, m: function(a, s) {
    pt(a, t, s), W(t, n), pt(a, r, s), pt(a, i, s), W(i, o);
  }, p: function(a, s) {
    4 & s[1] && Ve(n, a[33]), 2 & s[1] && Ve(o, a[32]);
  }, d: function(a) {
    a && vt(t), a && vt(r), a && vt(i);
  } };
}
function F$(e) {
  var t, n, r, i = [e[18]], o = e[17];
  function a(s) {
    for (var u = {}, c = 0; c < i.length; c += 1)
      u = da(u, i[c]);
    return { props: u };
  }
  return o && (t = new o(a())), { c: function() {
    t && Pt(t.$$.fragment), n = Ye();
  }, m: function(s, u) {
    t && Ot(t, s, u), pt(s, n, u), r = !0;
  }, p: function(s, u) {
    var c = 262144 & u[0] ? ts(i, [Mh(s[18])]) : {};
    if (o !== (o = s[17])) {
      if (t) {
        qt();
        var l = t;
        tt(l.$$.fragment, 1, 0, function() {
          At(l, 1);
        }), Vt();
      }
      o ? (Pt((t = new o(a())).$$.fragment), U(t.$$.fragment, 1), Ot(t, n.parentNode, n)) : t = null;
    } else
      o && t.$set(c);
  }, i: function(s) {
    r || (t && U(t.$$.fragment, s), r = !0);
  }, o: function(s) {
    t && tt(t.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && vt(n), t && At(t, s);
  } };
}
function q$(e) {
  var t, n, r, i = e[26];
  function o(a) {
    return { props: { value: a[2], getSelectionLabel: a[12], activeValue: a[30], isDisabled: a[9], multiFullItemClearable: a[8] } };
  }
  return i && ((t = new i(o(e))).$on("multiItemClear", e[38]), t.$on("focus", e[40])), { c: function() {
    t && Pt(t.$$.fragment), n = Ye();
  }, m: function(a, s) {
    t && Ot(t, a, s), pt(a, n, s), r = !0;
  }, p: function(a, s) {
    var u = {};
    if (4 & s[0] && (u.value = a[2]), 4096 & s[0] && (u.getSelectionLabel = a[12]), 1073741824 & s[0] && (u.activeValue = a[30]), 512 & s[0] && (u.isDisabled = a[9]), 256 & s[0] && (u.multiFullItemClearable = a[8]), i !== (i = a[26])) {
      if (t) {
        qt();
        var c = t;
        tt(c.$$.fragment, 1, 0, function() {
          At(c, 1);
        }), Vt();
      }
      i ? ((t = new i(o(a))).$on("multiItemClear", a[38]), t.$on("focus", a[40]), Pt(t.$$.fragment), U(t.$$.fragment, 1), Ot(t, n.parentNode, n)) : t = null;
    } else
      i && t.$set(u);
  }, i: function(a) {
    r || (t && U(t.$$.fragment, a), r = !0);
  }, o: function(a) {
    t && tt(t.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && vt(n), t && At(t, a);
  } };
}
function V$(e) {
  var t, n, r, i, o, a = e[25];
  function s(u) {
    return { props: { item: u[2], getSelectionLabel: u[12] } };
  }
  return a && (n = new a(s(e))), { c: function() {
    t = rt("div"), n && Pt(n.$$.fragment), A(t, "class", "selectedItem svelte-17l1npl");
  }, m: function(u, c) {
    pt(u, t, c), n && Ot(n, t, null), r = !0, i || (o = Nt(t, "focus", e[40]), i = !0);
  }, p: function(u, c) {
    var l = {};
    if (4 & c[0] && (l.item = u[2]), 4096 & c[0] && (l.getSelectionLabel = u[12]), a !== (a = u[25])) {
      if (n) {
        qt();
        var f = n;
        tt(f.$$.fragment, 1, 0, function() {
          At(f, 1);
        }), Vt();
      }
      a ? (Pt((n = new a(s(u))).$$.fragment), U(n.$$.fragment, 1), Ot(n, t, null)) : n = null;
    } else
      a && n.$set(l);
  }, i: function(u) {
    r || (n && U(n.$$.fragment, u), r = !0);
  }, o: function(u) {
    n && tt(n.$$.fragment, u), r = !1;
  }, d: function(u) {
    u && vt(t), n && At(n), i = !1, o();
  } };
}
function H$(e) {
  var t, n, r, i, o, a = e[23];
  return a && (n = new a({})), { c: function() {
    t = rt("div"), n && Pt(n.$$.fragment), A(t, "class", "clearSelect svelte-17l1npl"), A(t, "aria-hidden", "true");
  }, m: function(s, u) {
    var c;
    pt(s, t, u), n && Ot(n, t, null), r = !0, i || (o = Nt(t, "click", (c = e[27], function(l) {
      return l.preventDefault(), c.call(this, l);
    })), i = !0);
  }, p: function(s, u) {
    if (a !== (a = s[23])) {
      if (n) {
        qt();
        var c = n;
        tt(c.$$.fragment, 1, 0, function() {
          At(c, 1);
        }), Vt();
      }
      a ? (Pt((n = new a({})).$$.fragment), U(n.$$.fragment, 1), Ot(n, t, null)) : n = null;
    }
  }, i: function(s) {
    r || (n && U(n.$$.fragment, s), r = !0);
  }, o: function(s) {
    n && tt(n.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && vt(t), n && At(n), i = !1, o();
  } };
}
function W$(e) {
  var t;
  function n(o, a) {
    return o[22] ? jX : xX;
  }
  var r = n(e), i = r(e);
  return { c: function() {
    t = rt("div"), i.c(), A(t, "class", "indicator svelte-17l1npl"), A(t, "aria-hidden", "true");
  }, m: function(o, a) {
    pt(o, t, a), i.m(t, null);
  }, p: function(o, a) {
    r === (r = n(o)) && i ? i.p(o, a) : (i.d(1), (i = r(o)) && (i.c(), i.m(t, null)));
  }, d: function(o) {
    o && vt(t), i.d();
  } };
}
function xX(e) {
  var t, n;
  return { c: function() {
    t = Co("svg"), A(n = Co("path"), "d", `M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747
          3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0
          1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502
          0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0
          0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z`), A(t, "width", "100%"), A(t, "height", "100%"), A(t, "viewBox", "0 0 20 20"), A(t, "focusable", "false"), A(t, "aria-hidden", "true"), A(t, "class", "svelte-17l1npl");
  }, m: function(r, i) {
    pt(r, t, i), W(t, n);
  }, p: Wt, d: function(r) {
    r && vt(t);
  } };
}
function jX(e) {
  var t, n;
  return { c: function() {
    t = new BD(!1), n = Ye(), t.a = n;
  }, m: function(r, i) {
    t.m(e[22], r, i), pt(r, n, i);
  }, p: function(r, i) {
    4194304 & i[0] && t.p(r[22]);
  }, d: function(r) {
    r && vt(n), r && t.d();
  } };
}
function U$(e) {
  var t;
  return { c: function() {
    (t = rt("div")).innerHTML = '<svg class="spinner_icon svelte-17l1npl" viewBox="25 25 50 50"><circle class="spinner_path svelte-17l1npl" cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5" stroke-miterlimit="10"></circle></svg>', A(t, "class", "spinner svelte-17l1npl");
  }, m: function(n, r) {
    pt(n, t, r);
  }, d: function(n) {
    n && vt(t);
  } };
}
function J$(e) {
  var t, n, r, i, o = [e[34]];
  function a(c) {
    e[84](c);
  }
  var s = e[24];
  function u(c) {
    for (var l = {}, f = 0; f < o.length; f += 1)
      l = da(l, o[f]);
    return c[28] !== void 0 && (l.hoverItemIndex = c[28]), { props: l };
  }
  return s && (t = new s(u(e)), Be.push(function() {
    return Kr(t, "hoverItemIndex", a);
  }), t.$on("itemSelected", e[43]), t.$on("itemCreated", e[44]), t.$on("closeList", e[45])), { c: function() {
    t && Pt(t.$$.fragment), r = Ye();
  }, m: function(c, l) {
    t && Ot(t, c, l), pt(c, r, l), i = !0;
  }, p: function(c, l) {
    var f = 8 & l[1] ? ts(o, [Mh(c[34])]) : {};
    if (!n && 268435456 & l[0] && (n = !0, f.hoverItemIndex = c[28], di(function() {
      return n = !1;
    })), s !== (s = c[24])) {
      if (t) {
        qt();
        var h = t;
        tt(h.$$.fragment, 1, 0, function() {
          At(h, 1);
        }), Vt();
      }
      s ? (t = new s(u(c)), Be.push(function() {
        return Kr(t, "hoverItemIndex", a);
      }), t.$on("itemSelected", c[43]), t.$on("itemCreated", c[44]), t.$on("closeList", c[45]), Pt(t.$$.fragment), U(t.$$.fragment, 1), Ot(t, r.parentNode, r)) : t = null;
    } else
      s && t.$set(f);
  }, i: function(c) {
    i || (t && U(t.$$.fragment, c), i = !0);
  }, o: function(c) {
    t && tt(t.$$.fragment, c), i = !1;
  }, d: function(c) {
    c && vt(r), t && At(t, c);
  } };
}
function K$(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("input"), "name", n = e[16].name), A(t, "type", "hidden"), t.value = r = e[2] ? e[12](e[2]) : null, A(t, "class", "svelte-17l1npl");
  }, m: function(i, o) {
    pt(i, t, o);
  }, p: function(i, o) {
    65536 & o[0] && n !== (n = i[16].name) && A(t, "name", n), 4100 & o[0] && r !== (r = i[2] ? i[12](i[2]) : null) && (t.value = r);
  }, d: function(i) {
    i && vt(t);
  } };
}
function G$(e) {
  for (var t, n = e[2], r = [], i = 0; i < n.length; i += 1)
    r[i] = Q$(z$(e, n, i));
  return { c: function() {
    for (var o = 0; o < r.length; o += 1)
      r[o].c();
    t = Ye();
  }, m: function(o, a) {
    for (var s = 0; s < r.length; s += 1)
      r[s].m(o, a);
    pt(o, t, a);
  }, p: function(o, a) {
    if (69636 & a[0]) {
      var s;
      for (n = o[2], s = 0; s < n.length; s += 1) {
        var u = z$(o, n, s);
        r[s] ? r[s].p(u, a) : (r[s] = Q$(u), r[s].c(), r[s].m(t.parentNode, t));
      }
      for (; s < r.length; s += 1)
        r[s].d(1);
      r.length = n.length;
    }
  }, d: function(o) {
    Ar(r, o), o && vt(t);
  } };
}
function Q$(e) {
  var t, n, r;
  return { c: function() {
    A(t = rt("input"), "name", n = e[16].name), A(t, "type", "hidden"), t.value = r = e[103] ? e[12](e[103]) : null, A(t, "class", "svelte-17l1npl");
  }, m: function(i, o) {
    pt(i, t, o);
  }, p: function(i, o) {
    65536 & o[0] && n !== (n = i[16].name) && A(t, "name", n), 4100 & o[0] && r !== (r = i[103] ? i[12](i[103]) : null) && (t.value = r);
  }, d: function(i) {
    i && vt(t);
  } };
}
function SX(e) {
  for (var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b = e[1] && B$(e), k = e[17] && F$(e), w = e[35] && q$(e), x = [{ readOnly: s = !e[13] }, e[31], { placeholder: e[36] }, { style: e[14] }, { disabled: e[9] }], S = {}, T = 0; T < x.length; T += 1)
    S = da(S, x[T]);
  var P = !e[7] && e[29] && V$(e), O = e[37] && H$(e), j = !e[37] && (e[20] || e[19] && !e[2] || !e[13] && !e[9] && !e[4] && (e[29] && !e[15] || !e[29])) && W$(e), V = e[4] && U$(), E = e[5] && J$(e), C = (!e[7] || e[7] && !e[35]) && K$(e), H = e[7] && e[35] && G$(e);
  return { c: function() {
    t = rt("div"), n = rt("span"), b && b.c(), r = bt(), k && k.c(), i = bt(), w && w.c(), o = bt(), a = rt("input"), u = bt(), P && P.c(), c = bt(), O && O.c(), l = bt(), j && j.c(), f = bt(), V && V.c(), h = bt(), E && E.c(), d = bt(), C && C.c(), p = bt(), H && H.c(), A(n, "aria-live", "polite"), A(n, "aria-atomic", "false"), A(n, "aria-relevant", "additions text"), A(n, "class", "a11yText svelte-17l1npl"), Q2(a, S), Ut(a, "svelte-17l1npl", !0), A(t, "class", v = "selectContainer " + e[21] + " svelte-17l1npl"), A(t, "style", e[11]), Ut(t, "hasError", e[10]), Ut(t, "multiSelect", e[7]), Ut(t, "disabled", e[9]), Ut(t, "focused", e[1]);
  }, m: function(X, F) {
    pt(X, t, F), W(t, n), b && b.m(n, null), W(t, r), k && k.m(t, null), W(t, i), w && w.m(t, null), W(t, o), W(t, a), a.autofocus && a.focus(), e[82](a), ra(a, e[3]), W(t, u), P && P.m(t, null), W(t, c), O && O.m(t, null), W(t, l), j && j.m(t, null), W(t, f), V && V.m(t, null), W(t, h), E && E.m(t, null), W(t, d), C && C.m(t, null), W(t, p), H && H.m(t, null), e[85](t), m = !0, g || (y = [Nt(window, "click", e[41]), Nt(window, "focusin", e[41]), Nt(window, "keydown", e[39]), Nt(a, "focus", e[40]), Nt(a, "input", e[83]), Nt(t, "click", e[42])], g = !0);
  }, p: function(X, F) {
    X[1] ? b ? b.p(X, F) : ((b = B$(X)).c(), b.m(n, null)) : b && (b.d(1), b = null), X[17] ? k ? (k.p(X, F), 131072 & F[0] && U(k, 1)) : ((k = F$(X)).c(), U(k, 1), k.m(t, i)) : k && (qt(), tt(k, 1, 1, function() {
      k = null;
    }), Vt()), X[35] ? w ? (w.p(X, F), 16 & F[1] && U(w, 1)) : ((w = q$(X)).c(), U(w, 1), w.m(t, o)) : w && (qt(), tt(w, 1, 1, function() {
      w = null;
    }), Vt()), Q2(a, S = ts(x, [(!m || 8192 & F[0] && s !== (s = !X[13])) && { readOnly: s }, 1 & F[1] && X[31], (!m || 32 & F[1]) && { placeholder: X[36] }, (!m || 16384 & F[0]) && { style: X[14] }, (!m || 512 & F[0]) && { disabled: X[9] }])), 8 & F[0] && a.value !== X[3] && ra(a, X[3]), Ut(a, "svelte-17l1npl", !0), !X[7] && X[29] ? P ? (P.p(X, F), 536871040 & F[0] && U(P, 1)) : ((P = V$(X)).c(), U(P, 1), P.m(t, c)) : P && (qt(), tt(P, 1, 1, function() {
      P = null;
    }), Vt()), X[37] ? O ? (O.p(X, F), 64 & F[1] && U(O, 1)) : ((O = H$(X)).c(), U(O, 1), O.m(t, l)) : O && (qt(), tt(O, 1, 1, function() {
      O = null;
    }), Vt()), X[37] || !(X[20] || X[19] && !X[2]) && (X[13] || X[9] || X[4] || (!X[29] || X[15]) && X[29]) ? j && (j.d(1), j = null) : j ? j.p(X, F) : ((j = W$(X)).c(), j.m(t, f)), X[4] ? V || ((V = U$()).c(), V.m(t, h)) : V && (V.d(1), V = null), X[5] ? E ? (E.p(X, F), 32 & F[0] && U(E, 1)) : ((E = J$(X)).c(), U(E, 1), E.m(t, d)) : E && (qt(), tt(E, 1, 1, function() {
      E = null;
    }), Vt()), !X[7] || X[7] && !X[35] ? C ? C.p(X, F) : ((C = K$(X)).c(), C.m(t, p)) : C && (C.d(1), C = null), X[7] && X[35] ? H ? H.p(X, F) : ((H = G$(X)).c(), H.m(t, null)) : H && (H.d(1), H = null), (!m || 2097152 & F[0] && v !== (v = "selectContainer " + X[21] + " svelte-17l1npl")) && A(t, "class", v), (!m || 2048 & F[0]) && A(t, "style", X[11]), 2098176 & F[0] && Ut(t, "hasError", X[10]), 2097280 & F[0] && Ut(t, "multiSelect", X[7]), 2097664 & F[0] && Ut(t, "disabled", X[9]), 2097154 & F[0] && Ut(t, "focused", X[1]);
  }, i: function(X) {
    m || (U(k), U(w), U(P), U(O), U(E), m = !0);
  }, o: function(X) {
    tt(k), tt(w), tt(P), tt(O), tt(E), m = !1;
  }, d: function(X) {
    X && vt(t), b && b.d(), k && k.d(), w && w.d(), e[82](null), P && P.d(), O && O.d(), j && j.d(), V && V.d(), E && E.d(), C && C.d(), H && H.d(), e[85](null), g = !1, Dn(y);
  } };
}
function X$(e) {
  return e.map(function(t, n) {
    return { index: n, value: t, label: "".concat(t) };
  });
}
function $X(e, t, n) {
  var r, i, o, a, s, u, c, l, f = Ph(), h = t.id, d = h === void 0 ? null : h, p = t.container, v = p === void 0 ? void 0 : p, m = t.input, g = m === void 0 ? void 0 : m, y = t.isMulti, b = y !== void 0 && y, k = t.multiFullItemClearable, w = k !== void 0 && k, x = t.isDisabled, S = x !== void 0 && x, T = t.isCreatable, P = T !== void 0 && T, O = t.isFocused, j = O !== void 0 && O, V = t.value, E = V === void 0 ? null : V, C = t.filterText, H = C === void 0 ? "" : C, X = t.placeholder, F = X === void 0 ? "Select..." : X, G = t.placeholderAlwaysShow, M = G !== void 0 && G, $ = t.items, q = $ === void 0 ? null : $, B = t.itemFilter, D = B === void 0 ? function(ft, le, ge) {
    return "".concat(ft).toLowerCase().includes(le.toLowerCase());
  } : B, _ = t.groupBy, L = _ === void 0 ? void 0 : _, J = t.groupFilter, st = J === void 0 ? function(ft) {
    return ft;
  } : J, ht = t.isGroupHeaderSelectable, xt = ht !== void 0 && ht, kt = t.getGroupHeaderLabel, I = kt === void 0 ? function(ft) {
    return ft[it] || ft.id;
  } : kt, R = t.labelIdentifier, it = R === void 0 ? "label" : R, N = t.getOptionLabel, K = N === void 0 ? function(ft, le) {
    return ft.isCreator ? 'Create "'.concat(le, '"') : ft[it];
  } : N, z = t.optionIdentifier, at = z === void 0 ? "value" : z, yt = t.loadOptions, jt = yt === void 0 ? void 0 : yt, Ft = t.hasError, zt = Ft !== void 0 && Ft, St = t.containerStyles, Gt = St === void 0 ? "" : St, _e = t.getSelectionLabel, Fe = _e === void 0 ? function(ft) {
    return ft ? ft[it] : null;
  } : _e, fn = t.createGroupHeaderItem, De = fn === void 0 ? function(ft) {
    return { value: ft, label: ft };
  } : fn, $t = t.createItem, oe = $t === void 0 ? function(ft) {
    return { value: ft, label: ft };
  } : $t, Ce = t.isSearchable, sn = Ce === void 0 || Ce, vn = t.inputStyles, nt = vn === void 0 ? "" : vn, ct = t.isClearable, lt = ct === void 0 || ct, wt = t.isWaiting, Rt = wt !== void 0 && wt, Bt = t.listPlacement, ee = Bt === void 0 ? "auto" : Bt, ie = t.listOpen, gt = ie !== void 0 && ie, Kt = t.isVirtualList, ae = Kt !== void 0 && Kt, Yt = t.loadOptionsInterval, se = Yt === void 0 ? 300 : Yt, Ae = t.noOptionsMessage, me = Ae === void 0 ? "No options" : Ae, Se = t.hideEmptyState, Oe = Se !== void 0 && Se, Ee = t.inputAttributes, kn = Ee === void 0 ? {} : Ee, Yn = t.listAutoWidth, It = Yn === void 0 || Yn, un = t.itemHeight, hn = un === void 0 ? 40 : un, tn = t.Icon, on = tn === void 0 ? void 0 : tn, an = t.iconProps, oi = an === void 0 ? {} : an, Hi = t.showChevron, wn = Hi !== void 0 && Hi, re = t.showIndicator, Ie = re !== void 0 && re, ai = t.containerClasses, xi = ai === void 0 ? "" : ai, Pr = t.indicatorSvg, fs = Pr === void 0 ? void 0 : Pr, hs = t.listOffset, ds = hs === void 0 ? 5 : hs, sl = t.ClearIcon, vs = sl === void 0 ? kX : sl, ul = t.Item, Wi = ul === void 0 ? sM : ul, ku = t.List, ka = ku === void 0 ? oX : ku, wa = t.Selection, zo = wa === void 0 ? cX : wa, vr = t.MultiSelection, wu = vr === void 0 ? dX : vr, ji = t.VirtualList, Bo = ji === void 0 ? yX : ji;
  function xu(ft) {
    if (!(ft.loadOptions && ft.filterText.length > 0)) {
      if (!ft.items)
        return [];
      ft.items && ft.items.length > 0 && ne(ft.items[0]) !== "object" && (ft.items = X$(ft.items));
      var le = ft.items.filter(function(ge) {
        var fe = D(K(ge, ft.filterText), ft.filterText, ge);
        return fe && ft.isMulti && ft.value && Array.isArray(ft.value) && (fe = !ft.value.some(function(Ln) {
          return Ln[ft.optionIdentifier] === ge[ft.optionIdentifier];
        })), fe;
      });
      return ft.groupBy && (le = function(ge) {
        var fe = [], Ln = {};
        ge.forEach(function(xr) {
          var sr = L(xr);
          fe.includes(sr) || (fe.push(sr), Ln[sr] = [], sr && Ln[sr].push(Object.assign(De(sr, xr), { id: sr, isGroupHeader: !0, isSelectable: xt }))), Ln[sr].push(Object.assign({ isGroupItem: !!sr }, xr));
        });
        var ar = [];
        return st(fe).forEach(function(xr) {
          ar.push.apply(ar, Pe(Ln[xr]));
        }), ar;
      }(le)), ft.isCreatable && (le = cl(le, ft.filterText)), le;
    }
  }
  function cl(ft, le) {
    if (le.length === 0)
      return ft;
    var ge = oe(le);
    return ft[0] && le === ft[0][it] ? ft : (ge.isCreator = !0, [].concat(Pe(ft), [ge]));
  }
  var On, si, Fo, ps, lr, ju, qo, et = t.selectedValue, dt = et === void 0 ? null : et, _t = function(ft, le, ge) {
    var fe;
    return function() {
      var Ln = this, ar = arguments, xr = function() {
        fe = null, ge || ft.apply(Ln, ar);
      }, sr = ge && !fe;
      clearTimeout(fe), fe = setTimeout(xr, le), sr && ft.apply(Ln, ar);
    };
  }(mn(de().mark(function ft() {
    var le;
    return de().wrap(function(ge) {
      for (; ; )
        switch (ge.prev = ge.next) {
          case 0:
            return n(4, Rt = !0), ge.next = 3, jt(H).catch(function(fe) {
              console.warn("svelte-select loadOptions error :>> ", fe), f("error", { type: "loadOptions", details: fe });
            });
          case 3:
            (le = ge.sent) && !le.cancelled && (le ? (le && le.length > 0 && ne(le[0]) !== "object" && (le = X$(le)), n(81, r = Pe(le)), f("loaded", { items: r })) : n(81, r = []), P && n(81, r = cl(r, H)), n(4, Rt = !1), n(1, j = !0), n(5, gt = !0));
          case 5:
          case "end":
            return ge.stop();
        }
    }, ft);
  })), se);
  function Tt() {
    var ft = !0;
    if (E) {
      var le = [], ge = [];
      E.forEach(function(fe) {
        le.includes(fe[at]) ? ft = !1 : (le.push(fe[at]), ge.push(fe));
      }), ft || n(2, E = ge);
    }
    return ft;
  }
  function Dt(ft) {
    var le = ft ? ft[at] : E[at];
    return q.find(function(ge) {
      return ge[at] === le;
    });
  }
  function Lt(ft) {
    var le = ft.detail, ge = E[le ? le.i : E.length - 1];
    E.length === 1 ? n(2, E = void 0) : n(2, E = E.filter(function(fe) {
      return fe !== ge;
    })), f("clear", ge);
  }
  function Qt() {
    n(1, j = !0), g && g.focus();
  }
  wC(mn(de().mark(function ft() {
    return de().wrap(function(le) {
      for (; ; )
        switch (le.prev = le.next) {
          case 0:
            n(77, si = E), n(78, Fo = H), n(79, ps = j), n(80, lr = b);
          case 4:
          case "end":
            return le.stop();
        }
    }, ft);
  }))), yi(function() {
    j && g && g.focus();
  });
  var ue = t.ariaValues, te = ue === void 0 ? function(ft) {
    return "Option ".concat(ft, ", selected.");
  } : ue, Xe = t.ariaListOpen, Ze = Xe === void 0 ? function(ft, le) {
    return "You are currently focused on option ".concat(ft, ". There are ").concat(le, " results available.");
  } : Xe, Jn = t.ariaFocused, pn = Jn === void 0 ? function() {
    return "Select is focused, type to refine list, press down to open the menu.";
  } : Jn;
  return e.$$set = function(ft) {
    "id" in ft && n(46, d = ft.id), "container" in ft && n(0, v = ft.container), "input" in ft && n(6, g = ft.input), "isMulti" in ft && n(7, b = ft.isMulti), "multiFullItemClearable" in ft && n(8, w = ft.multiFullItemClearable), "isDisabled" in ft && n(9, S = ft.isDisabled), "isCreatable" in ft && n(47, P = ft.isCreatable), "isFocused" in ft && n(1, j = ft.isFocused), "value" in ft && n(2, E = ft.value), "filterText" in ft && n(3, H = ft.filterText), "placeholder" in ft && n(48, F = ft.placeholder), "placeholderAlwaysShow" in ft && n(49, M = ft.placeholderAlwaysShow), "items" in ft && n(50, q = ft.items), "itemFilter" in ft && n(51, D = ft.itemFilter), "groupBy" in ft && n(52, L = ft.groupBy), "groupFilter" in ft && n(53, st = ft.groupFilter), "isGroupHeaderSelectable" in ft && n(54, xt = ft.isGroupHeaderSelectable), "getGroupHeaderLabel" in ft && n(55, I = ft.getGroupHeaderLabel), "labelIdentifier" in ft && n(56, it = ft.labelIdentifier), "getOptionLabel" in ft && n(57, K = ft.getOptionLabel), "optionIdentifier" in ft && n(58, at = ft.optionIdentifier), "loadOptions" in ft && n(59, jt = ft.loadOptions), "hasError" in ft && n(10, zt = ft.hasError), "containerStyles" in ft && n(11, Gt = ft.containerStyles), "getSelectionLabel" in ft && n(12, Fe = ft.getSelectionLabel), "createGroupHeaderItem" in ft && n(60, De = ft.createGroupHeaderItem), "createItem" in ft && n(61, oe = ft.createItem), "isSearchable" in ft && n(13, sn = ft.isSearchable), "inputStyles" in ft && n(14, nt = ft.inputStyles), "isClearable" in ft && n(15, lt = ft.isClearable), "isWaiting" in ft && n(4, Rt = ft.isWaiting), "listPlacement" in ft && n(63, ee = ft.listPlacement), "listOpen" in ft && n(5, gt = ft.listOpen), "isVirtualList" in ft && n(64, ae = ft.isVirtualList), "loadOptionsInterval" in ft && n(65, se = ft.loadOptionsInterval), "noOptionsMessage" in ft && n(66, me = ft.noOptionsMessage), "hideEmptyState" in ft && n(67, Oe = ft.hideEmptyState), "inputAttributes" in ft && n(16, kn = ft.inputAttributes), "listAutoWidth" in ft && n(68, It = ft.listAutoWidth), "itemHeight" in ft && n(69, hn = ft.itemHeight), "Icon" in ft && n(17, on = ft.Icon), "iconProps" in ft && n(18, oi = ft.iconProps), "showChevron" in ft && n(19, wn = ft.showChevron), "showIndicator" in ft && n(20, Ie = ft.showIndicator), "containerClasses" in ft && n(21, xi = ft.containerClasses), "indicatorSvg" in ft && n(22, fs = ft.indicatorSvg), "listOffset" in ft && n(70, ds = ft.listOffset), "ClearIcon" in ft && n(23, vs = ft.ClearIcon), "Item" in ft && n(71, Wi = ft.Item), "List" in ft && n(24, ka = ft.List), "Selection" in ft && n(25, zo = ft.Selection), "MultiSelection" in ft && n(26, wu = ft.MultiSelection), "VirtualList" in ft && n(72, Bo = ft.VirtualList), "selectedValue" in ft && n(73, dt = ft.selectedValue), "ariaValues" in ft && n(74, te = ft.ariaValues), "ariaListOpen" in ft && n(75, Ze = ft.ariaListOpen), "ariaFocused" in ft && n(76, pn = ft.ariaFocused);
  }, e.$$.update = function() {
    var ft, le;
    140 & e.$$.dirty[0] | 405340160 & e.$$.dirty[1] && n(81, r = xu({ loadOptions: jt, filterText: H, items: q, value: E, isMulti: b, optionIdentifier: at, groupBy: L, isCreatable: P })), 2048 & e.$$.dirty[2] && dt && console.warn("selectedValue is no longer used. Please use value instead."), 524288 & e.$$.dirty[1] && function(ge) {
      ge && ge.length !== 0 && !ge.some(function(fe) {
        return ne(fe) !== "object";
      }) && E && (b ? !E.some(function(fe) {
        return !fe || !fe[at];
      }) : E[at]) && (Array.isArray(E) ? n(2, E = E.map(function(fe) {
        return Dt(fe) || fe;
      })) : n(2, E = Dt() || E));
    }(q), 4 & e.$$.dirty[0] && E && (typeof E == "string" ? n(2, (na(ft = {}, at, E), na(ft, "label", E), E = ft)) : b && Array.isArray(E) && E.length > 0 && n(2, E = E.map(function(ge) {
      return typeof ge == "string" ? { value: ge, label: ge } : ge;
    }))), 73728 & e.$$.dirty[0] && (!kn && sn || (n(31, qo = Object.assign({ autocapitalize: "none", autocomplete: "off", autocorrect: "off", spellcheck: !1, tabindex: 0, type: "text", "aria-autocomplete": "list" }, kn)), d && n(31, qo.id = d, qo), sn || n(31, qo.readonly = !0, qo))), 128 & e.$$.dirty[0] | 262144 & e.$$.dirty[2] && (b && E && (Array.isArray(E) ? n(2, E = Pe(E)) : n(2, E = [E])), lr && !b && E && n(2, E = null)), 132 & e.$$.dirty[0] && b && E && E.length > 1 && Tt(), 4 & e.$$.dirty[0] && E && (b ? JSON.stringify(E) !== JSON.stringify(si) && Tt() && f("select", E) : si && JSON.stringify(E[at]) === JSON.stringify(si[at]) || f("select", E)), 132 & e.$$.dirty[0] | 32768 & e.$$.dirty[2] && !E && b && si && f("select", E), 2 & e.$$.dirty[0] | 131072 & e.$$.dirty[2] && j !== ps && (j || gt ? Qt() : g && g.blur()), 8 & e.$$.dirty[0] | 65536 & e.$$.dirty[2] && H !== Fo && H.length !== 0 && (n(1, j = !0), n(5, gt = !0), jt ? _t() : (n(5, gt = !0), b && n(30, On = void 0))), 12 & e.$$.dirty[0] && n(29, i = E && H.length === 0), 536904208 & e.$$.dirty[0] && n(37, o = i && lt && !S && !Rt), 132 & e.$$.dirty[0] | 393216 & e.$$.dirty[1] && n(36, a = M && b ? F : E ? "" : F), 132 & e.$$.dirty[0] && n(35, s = b && E && E.length > 0), 141 & e.$$.dirty[0] | 218103808 & e.$$.dirty[1] | 526326 & e.$$.dirty[2] && n(34, u = { Item: Wi, filterText: H, optionIdentifier: at, noOptionsMessage: me, hideEmptyState: Oe, isVirtualList: ae, VirtualList: Bo, value: E, isMulti: b, getGroupHeaderLabel: I, items: r, itemHeight: hn, getOptionLabel: K, listPlacement: ee, parent: v, listAutoWidth: It, listOffset: ds }), 132 & e.$$.dirty[0] && n(33, c = E ? (le = void 0, le = b && E.length > 0 ? E.map(function(ge) {
      return Fe(ge);
    }).join(", ") : Fe(E), te(le)) : ""), 268435490 & e.$$.dirty[0] | 524288 & e.$$.dirty[2] && n(32, l = function() {
      if (!j || !r || r.length === 0)
        return "";
      var ge = r[ju];
      if (gt && ge) {
        var fe = Fe(ge), Ln = r ? r.length : 0;
        return Ze(fe, Ln);
      }
      return pn();
    }());
  }, [v, j, E, H, Rt, gt, g, b, w, S, zt, Gt, Fe, sn, nt, lt, kn, on, oi, wn, Ie, xi, fs, vs, ka, zo, wu, function() {
    n(2, E = void 0), n(5, gt = !1), f("clear", E), Qt();
  }, ju, i, On, qo, l, c, u, s, a, o, Lt, function(ft) {
    if (j)
      switch (ft.key) {
        case "ArrowDown":
        case "ArrowUp":
          ft.preventDefault(), n(5, gt = !0), n(30, On = void 0);
          break;
        case "Tab":
          gt || n(1, j = !1);
          break;
        case "Backspace":
          if (!b || H.length > 0)
            return;
          if (b && E && E.length > 0) {
            if (Lt(On !== void 0 ? On : E.length - 1), On === 0 || On === void 0)
              break;
            n(30, On = E.length > On ? On - 1 : void 0);
          }
          break;
        case "ArrowLeft":
          if (!b || H.length > 0)
            return;
          On === void 0 ? n(30, On = E.length - 1) : E.length > On && On !== 0 && n(30, On -= 1);
          break;
        case "ArrowRight":
          if (!b || H.length > 0 || On === void 0)
            return;
          On === E.length - 1 ? n(30, On = void 0) : On < E.length - 1 && n(30, On += 1);
      }
  }, Qt, function(ft) {
    if (v) {
      var le = ft.path && ft.path.length > 0 ? ft.path[0] : ft.target;
      v.contains(le) || v.contains(ft.relatedTarget) || (n(1, j = !1), n(5, gt = !1), n(30, On = void 0), g && g.blur());
    }
  }, function() {
    S || (n(1, j = !0), n(5, gt = !gt));
  }, function(ft) {
    var le = ft.detail;
    if (le) {
      n(3, H = "");
      var ge = Object.assign({}, le);
      ge.isGroupHeader && !ge.isSelectable || (n(2, E = b ? E ? E.concat([ge]) : [ge] : ge), n(2, E), setTimeout(function() {
        n(5, gt = !1), n(30, On = void 0);
      }));
    }
  }, function(ft) {
    var le = ft.detail;
    b ? (n(2, E = E || []), n(2, E = [].concat(Pe(E), [oe(le)]))) : n(2, E = oe(le)), f("itemCreated", le), n(3, H = ""), n(5, gt = !1), n(30, On = void 0);
  }, function() {
    n(3, H = ""), n(5, gt = !1);
  }, d, P, F, M, q, D, L, st, xt, I, it, K, at, jt, De, oe, function() {
    return r;
  }, ee, ae, se, me, Oe, It, hn, ds, Wi, Bo, dt, te, Ze, pn, si, Fo, ps, lr, r, function(ft) {
    Be[ft ? "unshift" : "push"](function() {
      n(6, g = ft);
    });
  }, function() {
    H = this.value, n(3, H);
  }, function(ft) {
    n(28, ju = ft);
  }, function(ft) {
    Be[ft ? "unshift" : "push"](function() {
      n(0, v = ft);
    });
  }];
}
var Aa = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, $X, SX, ir, { id: 46, container: 0, input: 6, isMulti: 7, multiFullItemClearable: 8, isDisabled: 9, isCreatable: 47, isFocused: 1, value: 2, filterText: 3, placeholder: 48, placeholderAlwaysShow: 49, items: 50, itemFilter: 51, groupBy: 52, groupFilter: 53, isGroupHeaderSelectable: 54, getGroupHeaderLabel: 55, labelIdentifier: 56, getOptionLabel: 57, optionIdentifier: 58, loadOptions: 59, hasError: 10, containerStyles: 11, getSelectionLabel: 12, createGroupHeaderItem: 60, createItem: 61, getFilteredItems: 62, isSearchable: 13, inputStyles: 14, isClearable: 15, isWaiting: 4, listPlacement: 63, listOpen: 5, isVirtualList: 64, loadOptionsInterval: 65, noOptionsMessage: 66, hideEmptyState: 67, inputAttributes: 16, listAutoWidth: 68, itemHeight: 69, Icon: 17, iconProps: 18, showChevron: 19, showIndicator: 20, containerClasses: 21, indicatorSvg: 22, listOffset: 70, ClearIcon: 23, Item: 71, List: 24, Selection: 25, MultiSelection: 26, VirtualList: 72, selectedValue: 73, handleClear: 27, ariaValues: 74, ariaListOpen: 75, ariaFocused: 76 }, wX, [-1, -1, -1, -1]), i;
  }
  return Y(n, [{ key: "getFilteredItems", get: function() {
    return this.$$.ctx[62];
  } }, { key: "handleClear", get: function() {
    return this.$$.ctx[27];
  } }]), n;
}();
function _X(e) {
  Te(e, "svelte-13taczd", "table.jse-transform-wizard.svelte-13taczd.svelte-13taczd{border-collapse:collapse;border-spacing:0;width:100%}table.jse-transform-wizard.svelte-13taczd input.svelte-13taczd{font-family:inherit;font-size:inherit}table.jse-transform-wizard.svelte-13taczd tr th.svelte-13taczd{font-weight:normal;text-align:left;width:60px}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd{width:100%;display:flex;flex-direction:row;margin-bottom:calc(0.5 * var(--jse-padding))}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-filter-path{flex:4;margin-right:calc(0.5 * var(--jse-padding))}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-filter-relation{flex:1.5;margin-right:calc(0.5 * var(--jse-padding))}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-sort-path{flex:3;margin-right:calc(0.5 * var(--jse-padding))}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-sort-direction{flex:1}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-projection-paths{flex:1}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer input{box-sizing:border-box}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal .jse-filter-value.svelte-13taczd{flex:4;padding:4px 8px;border:var(--jse-input-border);border-radius:var(--jse-input-radius);outline:none;background:var(--jse-input-background);color:inherit}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal .jse-filter-value.svelte-13taczd:focus{border:var(--jse-input-border-focus)}");
}
function CX(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b, k, w, x, S, T, P, O, j, V, E, C, H, X, F, G, M;
  function $(kt) {
    e[18](kt);
  }
  var q = { containerClasses: "jse-filter-path", showIndicator: !0, items: e[6] };
  function B(kt) {
    e[19](kt);
  }
  e[0] !== void 0 && (q.value = e[0]), s = new Aa({ props: q }), Be.push(function() {
    return Kr(s, "value", $);
  });
  var D = { containerClasses: "jse-filter-relation", showIndicator: !0, items: e[8] };
  function _(kt) {
    e[21](kt);
  }
  e[1] !== void 0 && (D.value = e[1]), l = new Aa({ props: D }), Be.push(function() {
    return Kr(l, "value", B);
  });
  var L = { containerClasses: "jse-sort-path", showIndicator: !0, items: e[6] };
  function J(kt) {
    e[22](kt);
  }
  e[3] !== void 0 && (L.value = e[3]), k = new Aa({ props: L }), Be.push(function() {
    return Kr(k, "value", _);
  });
  var st = { containerClasses: "jse-sort-direction", showIndicator: !0, items: e[9] };
  function ht(kt) {
    e[23](kt);
  }
  e[4] !== void 0 && (st.value = e[4]), S = new Aa({ props: st }), Be.push(function() {
    return Kr(S, "value", J);
  });
  var xt = { containerClasses: "jse-projection-paths", isMulti: !0, showIndicator: !0, items: e[7] };
  return e[5] !== void 0 && (xt.value = e[5]), H = new Aa({ props: xt }), Be.push(function() {
    return Kr(H, "value", ht);
  }), { c: function() {
    t = rt("table"), n = rt("tr"), (r = rt("th")).textContent = "Filter", i = bt(), o = rt("td"), a = rt("div"), Pt(s.$$.fragment), c = bt(), Pt(l.$$.fragment), h = bt(), d = rt("input"), p = bt(), v = rt("tr"), (m = rt("th")).textContent = "Sort", g = bt(), y = rt("td"), b = rt("div"), Pt(k.$$.fragment), x = bt(), Pt(S.$$.fragment), P = bt(), O = rt("tr"), (j = rt("th")).textContent = "Pick", V = bt(), E = rt("td"), C = rt("div"), Pt(H.$$.fragment), A(r, "class", "svelte-13taczd"), A(d, "class", "jse-filter-value svelte-13taczd"), A(a, "class", "jse-horizontal svelte-13taczd"), A(m, "class", "svelte-13taczd"), A(b, "class", "jse-horizontal svelte-13taczd"), A(j, "class", "svelte-13taczd"), A(C, "class", "jse-horizontal svelte-13taczd"), A(t, "class", "jse-transform-wizard svelte-13taczd");
  }, m: function(kt, I) {
    pt(kt, t, I), W(t, n), W(n, r), W(n, i), W(n, o), W(o, a), Ot(s, a, null), W(a, c), Ot(l, a, null), W(a, h), W(a, d), ra(d, e[2]), W(t, p), W(t, v), W(v, m), W(v, g), W(v, y), W(y, b), Ot(k, b, null), W(b, x), Ot(S, b, null), W(t, P), W(t, O), W(O, j), W(O, V), W(O, E), W(E, C), Ot(H, C, null), F = !0, G || (M = Nt(d, "input", e[20]), G = !0);
  }, p: function(kt, I) {
    var R = {};
    64 & I[0] && (R.items = kt[6]), !u && 1 & I[0] && (u = !0, R.value = kt[0], di(function() {
      return u = !1;
    })), s.$set(R);
    var it = {};
    !f && 2 & I[0] && (f = !0, it.value = kt[1], di(function() {
      return f = !1;
    })), l.$set(it), 4 & I[0] && d.value !== kt[2] && ra(d, kt[2]);
    var N = {};
    64 & I[0] && (N.items = kt[6]), !w && 8 & I[0] && (w = !0, N.value = kt[3], di(function() {
      return w = !1;
    })), k.$set(N);
    var K = {};
    !T && 16 & I[0] && (T = !0, K.value = kt[4], di(function() {
      return T = !1;
    })), S.$set(K);
    var z = {};
    128 & I[0] && (z.items = kt[7]), !X && 32 & I[0] && (X = !0, z.value = kt[5], di(function() {
      return X = !1;
    })), H.$set(z);
  }, i: function(kt) {
    F || (U(s.$$.fragment, kt), U(l.$$.fragment, kt), U(k.$$.fragment, kt), U(S.$$.fragment, kt), U(H.$$.fragment, kt), F = !0);
  }, o: function(kt) {
    tt(s.$$.fragment, kt), tt(l.$$.fragment, kt), tt(k.$$.fragment, kt), tt(S.$$.fragment, kt), tt(H.$$.fragment, kt), F = !1;
  }, d: function(kt) {
    kt && vt(t), At(s), At(l), At(k), At(S), At(H), G = !1, M();
  } };
}
function OX(e, t, n) {
  var r, i, o, a, s, u, c, l, f, h, d, p, v = Ur("jsoneditor:TransformWizard"), m = t.json, g = t.queryOptions, y = g === void 0 ? {} : g, b = t.onChange, k = ["==", "!=", "<", "<=", ">", ">="].map(function(E) {
    return { value: E, label: E };
  }), w = [{ value: "asc", label: "ascending" }, { value: "desc", label: "descending" }], x = !((u = y == null ? void 0 : y.filter) === null || u === void 0) && u.path ? V(y.filter.path) : null, S = !((c = y == null ? void 0 : y.filter) === null || c === void 0) && c.relation ? k.find(function(E) {
    return E.value === y.filter.relation;
  }) : null, T = ((l = y == null ? void 0 : y.filter) === null || l === void 0 ? void 0 : l.value) || "", P = !((f = y == null ? void 0 : y.sort) === null || f === void 0) && f.path ? V(y.sort.path) : null, O = !((h = y == null ? void 0 : y.sort) === null || h === void 0) && h.direction ? w.find(function(E) {
    return E.value === y.sort.direction;
  }) : null, j = !((d = y == null ? void 0 : y.projection) === null || d === void 0) && d.paths ? y.projection.paths.map(V) : null;
  function V(E) {
    return { value: E, label: _n(E) ? "(whole item)" : sa(E) };
  }
  return e.$$set = function(E) {
    "json" in E && n(11, m = E.json), "queryOptions" in E && n(10, y = E.queryOptions), "onChange" in E && n(12, b = E.onChange);
  }, e.$$.update = function() {
    2048 & e.$$.dirty[0] && n(17, r = Array.isArray(m)), 133120 & e.$$.dirty[0] && n(16, i = r ? fp(m) : []), 133120 & e.$$.dirty[0] && n(15, o = r ? fp(m, !0) : []), 65536 & e.$$.dirty[0] && n(6, a = i.map(V)), 32768 & e.$$.dirty[0] && n(7, s = o ? o.map(V) : []), 17472 & e.$$.dirty[0] && (n(14, p = y == null ? void 0 : y.filter) === null || p === void 0 ? void 0 : p.path) && a.find(function(E) {
      var C;
      return rn(E.value, (C = y == null ? void 0 : y.filter) === null || C === void 0 ? void 0 : C.path);
    }), 1 & e.$$.dirty[0] && function(E) {
      var C;
      rn((C = y == null ? void 0 : y.filter) === null || C === void 0 ? void 0 : C.path, E) || (v("changeFilterPath", E), n(10, y = mt.exports.setIn(y, ["filter", "path"], E, !0)), b(y));
    }((x == null ? void 0 : x.value) || null), 2 & e.$$.dirty[0] && function(E) {
      var C;
      rn((C = y == null ? void 0 : y.filter) === null || C === void 0 ? void 0 : C.relation, E) || (v("changeFilterRelation", E), n(10, y = mt.exports.setIn(y, ["filter", "relation"], E, !0)), b(y));
    }((S == null ? void 0 : S.value) || null), 4 & e.$$.dirty[0] && function(E) {
      var C;
      rn((C = y == null ? void 0 : y.filter) === null || C === void 0 ? void 0 : C.value, E) || (v("changeFilterValue", E), n(10, y = mt.exports.setIn(y, ["filter", "value"], E, !0)), b(y));
    }(T || null), 8 & e.$$.dirty[0] && function(E) {
      var C;
      rn((C = y == null ? void 0 : y.sort) === null || C === void 0 ? void 0 : C.path, E) || (v("changeSortPath", E), n(10, y = mt.exports.setIn(y, ["sort", "path"], E, !0)), b(y));
    }((P == null ? void 0 : P.value) || null), 16 & e.$$.dirty[0] && function(E) {
      var C;
      rn((C = y == null ? void 0 : y.sort) === null || C === void 0 ? void 0 : C.direction, E) || (v("changeSortDirection", E), n(10, y = mt.exports.setIn(y, ["sort", "direction"], E, !0)), b(y));
    }((O == null ? void 0 : O.value) || null), 32 & e.$$.dirty[0] && function(E) {
      var C;
      rn((C = y == null ? void 0 : y.projection) === null || C === void 0 ? void 0 : C.paths, E) || (v("changeProjectionPaths", E), n(10, y = mt.exports.setIn(y, ["projection", "paths"], E, !0)), b(y));
    }(j ? j.map(function(E) {
      return E.value;
    }) : null);
  }, [x, S, T, P, O, j, a, s, k, w, y, m, b, u, p, o, i, r, function(E) {
    n(0, x = E);
  }, function(E) {
    n(1, S = E);
  }, function() {
    T = this.value, n(2, T);
  }, function(E) {
    n(3, P = E);
  }, function(E) {
    n(4, O = E);
  }, function(E) {
    n(5, j = E);
  }];
}
var AX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, OX, CX, Ue, { json: 11, queryOptions: 10, onChange: 12 }, _X, [-1, -1]), i;
  }
  return Y(n);
}();
function PX(e) {
  Te(e, "svelte-19cxesy", ".jse-select-query-language.svelte-19cxesy.svelte-19cxesy{position:relative;width:32px}.jse-select-query-language.svelte-19cxesy .jse-select-query-language-container.svelte-19cxesy{position:absolute;top:0;right:0;display:flex;flex-direction:column;box-shadow:var(--jse-controls-box-shadow)}.jse-select-query-language.svelte-19cxesy .jse-select-query-language-container .jse-query-language.svelte-19cxesy{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;text-align:left;padding:var(--jse-padding) calc(2 * var(--jse-padding));white-space:nowrap;color:var(--jse-context-menu-color);background:var(--jse-context-menu-background)}.jse-select-query-language.svelte-19cxesy .jse-select-query-language-container .jse-query-language.svelte-19cxesy:hover{background:var(--jse-context-menu-background-highlight)}");
}
function Z$(e, t, n) {
  var r = e.slice();
  return r[5] = t[n], r;
}
function EX(e) {
  var t, n;
  return t = new Le({ props: { data: kh } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: Wt, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function MX(e) {
  var t, n;
  return t = new Le({ props: { data: wh } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: Wt, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function Y$(e) {
  var t, n, r, i, o, a, s, u, c, l, f = e[5].name + "", h = [MX, EX], d = [];
  function p(m, g) {
    return m[5].id === m[0] ? 0 : 1;
  }
  function v() {
    return e[4](e[5]);
  }
  return n = p(e), r = d[n] = h[n](e), { c: function() {
    t = rt("button"), r.c(), i = bt(), o = Xt(f), a = bt(), A(t, "type", "button"), A(t, "class", "jse-query-language svelte-19cxesy"), A(t, "title", s = "Select ".concat(e[5].name, " as query language")), Ut(t, "selected", e[5].id === e[0]);
  }, m: function(m, g) {
    pt(m, t, g), d[n].m(t, null), W(t, i), W(t, o), W(t, a), u = !0, c || (l = Nt(t, "click", v), c = !0);
  }, p: function(m, g) {
    var y = n;
    (n = p(e = m)) === y ? d[n].p(e, g) : (qt(), tt(d[y], 1, 1, function() {
      d[y] = null;
    }), Vt(), (r = d[n]) ? r.p(e, g) : (r = d[n] = h[n](e)).c(), U(r, 1), r.m(t, i)), (!u || 2 & g) && f !== (f = e[5].name + "") && Ve(o, f), (!u || 2 & g && s !== (s = "Select ".concat(e[5].name, " as query language"))) && A(t, "title", s), 3 & g && Ut(t, "selected", e[5].id === e[0]);
  }, i: function(m) {
    u || (U(r), u = !0);
  }, o: function(m) {
    tt(r), u = !1;
  }, d: function(m) {
    m && vt(t), d[n].d(), c = !1, l();
  } };
}
function TX(e) {
  for (var t, n, r, i = e[1], o = [], a = 0; a < i.length; a += 1)
    o[a] = Y$(Z$(e, i, a));
  var s = function(u) {
    return tt(o[u], 1, 1, function() {
      o[u] = null;
    });
  };
  return { c: function() {
    t = rt("div"), n = rt("div");
    for (var u = 0; u < o.length; u += 1)
      o[u].c();
    A(n, "class", "jse-select-query-language-container svelte-19cxesy"), A(t, "class", "jse-select-query-language svelte-19cxesy");
  }, m: function(u, c) {
    pt(u, t, c), W(t, n);
    for (var l = 0; l < o.length; l += 1)
      o[l].m(n, null);
    r = !0;
  }, p: function(u, c) {
    var l = xe(c, 1)[0];
    if (7 & l) {
      var f;
      for (i = u[1], f = 0; f < i.length; f += 1) {
        var h = Z$(u, i, f);
        o[f] ? (o[f].p(h, l), U(o[f], 1)) : (o[f] = Y$(h), o[f].c(), U(o[f], 1), o[f].m(n, null));
      }
      for (qt(), f = i.length; f < o.length; f += 1)
        s(f);
      Vt();
    }
  }, i: function(u) {
    if (!r) {
      for (var c = 0; c < i.length; c += 1)
        U(o[c]);
      r = !0;
    }
  }, o: function(u) {
    o = o.filter(Boolean);
    for (var c = 0; c < o.length; c += 1)
      tt(o[c]);
    r = !1;
  }, d: function(u) {
    u && vt(t), Ar(o, u);
  } };
}
function IX(e, t, n) {
  var r = t.queryLanguages, i = t.queryLanguageId, o = t.onChangeQueryLanguage;
  function a(s) {
    n(0, i = s), o(s);
  }
  return e.$$set = function(s) {
    "queryLanguages" in s && n(1, r = s.queryLanguages), "queryLanguageId" in s && n(0, i = s.queryLanguageId), "onChangeQueryLanguage" in s && n(3, o = s.onChangeQueryLanguage);
  }, [i, r, a, o, function(s) {
    return a(s.id);
  }];
}
var NX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, IX, TX, ir, { queryLanguages: 1, queryLanguageId: 0, onChangeQueryLanguage: 3 }, PX), i;
  }
  return Y(n);
}();
function RX(e) {
  Te(e, "svelte-d01h2s", ".jse-header.svelte-d01h2s.svelte-d01h2s{display:flex;background:var(--jse-theme-color);color:var(--jse-menu-color)}.jse-header.svelte-d01h2s .jse-title.svelte-d01h2s{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-d01h2s button.svelte-d01h2s{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-d01h2s button.svelte-d01h2s:hover{background:rgba(255, 255, 255, 0.1)}");
}
function t_(e) {
  var t, n, r, i, o;
  return n = new Le({ props: { data: dq } }), { c: function() {
    t = rt("button"), Pt(n.$$.fragment), A(t, "type", "button"), A(t, "class", "jse-config svelte-d01h2s"), A(t, "title", "Select a query language");
  }, m: function(a, s) {
    pt(a, t, s), Ot(n, t, null), e[6](t), r = !0, i || (o = Nt(t, "click", e[3]), i = !0);
  }, p: Wt, i: function(a) {
    r || (U(n.$$.fragment, a), r = !0);
  }, o: function(a) {
    tt(n.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && vt(t), At(n), e[6](null), i = !1, o();
  } };
}
function DX(e) {
  var t, n, r, i, o, a, s, u, c, l = e[0].length > 1 && t_(e);
  return a = new Le({ props: { data: Gc } }), { c: function() {
    t = rt("div"), (n = rt("div")).textContent = "Transform", r = bt(), l && l.c(), i = bt(), o = rt("button"), Pt(a.$$.fragment), A(n, "class", "jse-title svelte-d01h2s"), A(o, "type", "button"), A(o, "class", "jse-close svelte-d01h2s"), A(t, "class", "jse-header svelte-d01h2s");
  }, m: function(f, h) {
    pt(f, t, h), W(t, n), W(t, r), l && l.m(t, null), W(t, i), W(t, o), Ot(a, o, null), s = !0, u || (c = Nt(o, "click", e[2]), u = !0);
  }, p: function(f, h) {
    var d = xe(h, 1)[0];
    f[0].length > 1 ? l ? (l.p(f, d), 1 & d && U(l, 1)) : ((l = t_(f)).c(), U(l, 1), l.m(t, i)) : l && (qt(), tt(l, 1, 1, function() {
      l = null;
    }), Vt());
  }, i: function(f) {
    s || (U(l), U(a.$$.fragment, f), s = !0);
  }, o: function(f) {
    tt(l), tt(a.$$.fragment, f), s = !1;
  }, d: function(f) {
    f && vt(t), l && l.d(), At(a), u = !1, c();
  } };
}
function LX(e, t, n) {
  var r, i, o = t.queryLanguages, a = t.queryLanguageId, s = t.onChangeQueryLanguage, u = Hr("simple-modal").close, c = Hr("absolute-popup"), l = c.openAbsolutePopup, f = c.closeAbsolutePopup;
  return e.$$set = function(h) {
    "queryLanguages" in h && n(0, o = h.queryLanguages), "queryLanguageId" in h && n(4, a = h.queryLanguageId), "onChangeQueryLanguage" in h && n(5, s = h.onChangeQueryLanguage);
  }, [o, r, u, function() {
    i = l(NX, { queryLanguages: o, queryLanguageId: a, onChangeQueryLanguage: function(h) {
      f(i), s(h);
    } }, { position: "bottom", offsetTop: -2, offsetLeft: 0, anchor: r, closeOnOuterClick: !0 });
  }, a, s, function(h) {
    Be[h ? "unshift" : "push"](function() {
      n(1, r = h);
    });
  }];
}
var zX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, LX, DX, Ue, { queryLanguages: 0, queryLanguageId: 4, onChangeQueryLanguage: 5 }, RX), i;
  }
  return Y(n);
}();
function BX(e) {
  Te(e, "svelte-15uz9w0", ".jse-modal.svelte-15uz9w0.svelte-15uz9w0{--height:36px;--multiItemHeight:28px;--multiItemMargin:2px;--multiItemPadding:2px 8px;--multiClearTop:5px;--multiItemBorderRadius:6px;--clearSelectTop:2px;--clearSelectBottom:2px;--indicatorTop:8px;flex:1;display:flex;flex-direction:column;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;background:var(--jse-modal-background);color:var(--jse-text-color)}.jse-modal.svelte-15uz9w0 .jse-contents.svelte-15uz9w0{padding:20px;overflow:auto}.jse-modal.svelte-15uz9w0 .jse-contents .jse-actions.svelte-15uz9w0{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding)}.jse-modal.svelte-15uz9w0 .jse-contents .jse-actions button.svelte-15uz9w0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;background:var(--jse-button-primary-background);color:var(--jse-button-primary-color);padding:var(--jse-padding) calc(2 * var(--jse-padding));border-radius:3px}.jse-modal.svelte-15uz9w0 .jse-contents .jse-actions button.svelte-15uz9w0:hover{background:var(--jse-button-primary-background-highlight)}.jse-modal.svelte-15uz9w0 .jse-contents .jse-actions button.svelte-15uz9w0:disabled{background:var(--jse-button-primary-background-disabled)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-modal-overlay-background)}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-content{flex:1;display:flex;max-height:calc(100vh - 6rem);padding:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents.svelte-15uz9w0{flex:1;display:flex;flex-direction:column;color:inherit;min-height:0;padding:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents.svelte-15uz9w0{flex:1;display:flex;gap:calc(2 * var(--jse-padding));min-height:0;box-sizing:border-box;padding:0 calc(2 * var(--jse-padding)) var(--jse-padding)}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents.svelte-15uz9w0{flex:1;display:flex;flex-direction:column}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents .jse-description.svelte-15uz9w0 p{margin:var(--jse-padding) 0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents .jse-description.svelte-15uz9w0 p:first-child{margin-top:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents .jse-description.svelte-15uz9w0 p:last-child{margin-bottom:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents .jse-description.svelte-15uz9w0 code{background:var(--jse-modal-code-background);font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono)}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-15uz9w0{flex:1;outline:none;resize:vertical}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents.svelte-15uz9w0{flex:1;display:flex;flex-direction:column;gap:calc(2 * var(--jse-padding))}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents .jse-original-data.svelte-15uz9w0{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents .jse-original-data.jse-hide.svelte-15uz9w0{flex:none}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents .jse-preview-data.svelte-15uz9w0{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents.jse-hide-original-data.svelte-15uz9w0{flex-direction:column;gap:0;margin-bottom:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-actions.svelte-15uz9w0{padding:var(--jse-padding) calc(2 * var(--jse-padding)) calc(2 * var(--jse-padding))}@media screen and (max-width: 1200px){.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents.svelte-15uz9w0{flex-direction:column;overflow:auto}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-15uz9w0{min-height:150px;flex:none}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents.svelte-15uz9w0 .jse-tree-mode{height:300px;flex:none}}.jse-modal.jse-transform.svelte-15uz9w0 .jse-label.svelte-15uz9w0{font-weight:bold;display:block;box-sizing:border-box}.jse-modal.jse-transform.svelte-15uz9w0 .jse-label .jse-label-inner.svelte-15uz9w0{margin-top:calc(2 * var(--jse-padding));margin-bottom:calc(0.5 * var(--jse-padding));box-sizing:border-box}.jse-modal.jse-transform.svelte-15uz9w0 .jse-label .jse-label-inner button.svelte-15uz9w0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;font-weight:bold;padding:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-tree-mode{flex:1;background:var(--jse-input-background-readonly);box-shadow:none;box-sizing:border-box;--jse-main-border:var(--jse-input-border)}.jse-modal.jse-transform.svelte-15uz9w0 input.svelte-15uz9w0,.jse-modal.jse-transform.svelte-15uz9w0 textarea.svelte-15uz9w0{border:var(--jse-input-border);outline:none;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding));font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);color:inherit;background:var(--jse-input-background)}.jse-modal.jse-transform.svelte-15uz9w0 input.svelte-15uz9w0:focus,.jse-modal.jse-transform.svelte-15uz9w0 textarea.svelte-15uz9w0:focus{border:var(--jse-input-border-focus)}.jse-modal.jse-transform.svelte-15uz9w0 input.svelte-15uz9w0:read-only,.jse-modal.jse-transform.svelte-15uz9w0 textarea.svelte-15uz9w0:read-only{background:var(--jse-input-background-readonly)}.jse-modal.jse-transform.svelte-15uz9w0 .jse-preview.jse-error.svelte-15uz9w0{flex:1;background:var(--jse-input-background-readonly);border:var(--jse-input-border);color:var(--jse-error-color);padding:calc(0.5 * var(--jse-padding))}.jse-modal.jse-transform.svelte-15uz9w0 a{color:var(--jse-a-color)}.jse-modal.jse-transform.svelte-15uz9w0 a:hover{color:var(--jse-a-color-highlight)}");
}
function e_(e) {
  var t, n, r, i, o, a = [qX, FX], s = [];
  function u(c, l) {
    return 512 & l[0] && (t = null), t == null && (t = !!Array.isArray(c[9])), t ? 0 : 1;
  }
  return n = u(e, [-1, -1]), r = s[n] = a[n](e), { c: function() {
    r.c(), i = Ye();
  }, m: function(c, l) {
    s[n].m(c, l), pt(c, i, l), o = !0;
  }, p: function(c, l) {
    var f = n;
    (n = u(c, l)) === f ? s[n].p(c, l) : (qt(), tt(s[f], 1, 1, function() {
      s[f] = null;
    }), Vt(), (r = s[n]) ? r.p(c, l) : (r = s[n] = a[n](c)).c(), U(r, 1), r.m(i.parentNode, i));
  }, i: function(c) {
    o || (U(r), o = !0);
  }, o: function(c) {
    tt(r), o = !1;
  }, d: function(c) {
    s[n].d(c), c && vt(i);
  } };
}
function FX(e) {
  var t;
  return { c: function() {
    t = Xt("(Only available for arrays, not for objects)");
  }, m: function(n, r) {
    pt(n, t, r);
  }, p: Wt, i: Wt, o: Wt, d: function(n) {
    n && vt(t);
  } };
}
function qX(e) {
  var t, n;
  return t = new AX({ props: { queryOptions: e[7], json: e[9], onChange: e[16] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    128 & i[0] && (o.queryOptions = r[7]), 512 & i[0] && (o.json = r[9]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function n_(e) {
  var t, n;
  return t = new W0({ props: { externalContent: e[14], readOnly: !0, mainMenuBar: !1, navigationBar: !1, escapeControlCharacters: e[2], escapeUnicodeCharacters: e[3], onRenderValue: e[5], onError: console.error, onChange: Qe, onFocus: Qe, onBlur: Qe, onSortModal: Qe, onTransformModal: Qe, onClassName: e[6] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    16384 & i[0] && (o.externalContent = r[14]), 4 & i[0] && (o.escapeControlCharacters = r[2]), 8 & i[0] && (o.escapeUnicodeCharacters = r[3]), 32 & i[0] && (o.onRenderValue = r[5]), 64 & i[0] && (o.onClassName = r[6]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function VX(e) {
  var t, n, r = e[12].toString() + "";
  return { c: function() {
    t = rt("div"), n = Xt(r), A(t, "class", "jse-preview jse-error svelte-15uz9w0");
  }, m: function(i, o) {
    pt(i, t, o), W(t, n);
  }, p: function(i, o) {
    4096 & o[0] && r !== (r = i[12].toString() + "") && Ve(n, r);
  }, i: Wt, o: Wt, d: function(i) {
    i && vt(t);
  } };
}
function HX(e) {
  var t, n;
  return t = new W0({ props: { externalContent: e[13], readOnly: !0, mainMenuBar: !1, navigationBar: !1, escapeControlCharacters: e[2], escapeUnicodeCharacters: e[3], onRenderValue: e[5], onError: console.error, onChange: Qe, onFocus: Qe, onBlur: Qe, onSortModal: Qe, onTransformModal: Qe, onClassName: e[6] } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    8192 & i[0] && (o.externalContent = r[13]), 4 & i[0] && (o.escapeControlCharacters = r[2]), 8 & i[0] && (o.escapeUnicodeCharacters = r[3]), 32 & i[0] && (o.onRenderValue = r[5]), 64 & i[0] && (o.onClassName = r[6]), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function WX(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b, k, w, x, S, T, P, O, j, V, E, C, H, X, F, G, M, $, q, B, D, _, L, J, st, ht, xt, kt, I, R = e[15](e[0]).description + "";
  t = new zX({ props: { queryLanguages: e[4], queryLanguageId: e[0], onChangeQueryLanguage: e[21] } }), y = new Le({ props: { data: e[10] ? no : Qo } });
  var it = e[10] && e_(e);
  H = new Le({ props: { data: e[11] ? no : Qo } });
  var N = e[11] && n_(e), K = [HX, VX], z = [];
  function at(yt, jt) {
    return yt[12] ? 1 : 0;
  }
  return B = at(e), D = z[B] = K[B](e), { c: function() {
    Pt(t.$$.fragment), n = bt(), r = rt("div"), i = rt("div"), o = rt("div"), (a = rt("div")).innerHTML = '<div class="jse-label-inner svelte-15uz9w0">Language</div>', s = bt(), u = rt("div"), c = bt(), (l = rt("div")).innerHTML = '<div class="jse-label-inner svelte-15uz9w0">Path</div>', f = bt(), h = rt("input"), p = bt(), v = rt("div"), m = rt("div"), g = rt("button"), Pt(y.$$.fragment), b = Xt(`
                Wizard`), k = bt(), it && it.c(), w = bt(), (x = rt("div")).innerHTML = '<div class="jse-label-inner svelte-15uz9w0">Query</div>', S = bt(), T = rt("textarea"), P = bt(), O = rt("div"), j = rt("div"), V = rt("div"), E = rt("div"), C = rt("button"), Pt(H.$$.fragment), X = Xt(`
                  Original`), F = bt(), N && N.c(), G = bt(), M = rt("div"), ($ = rt("div")).innerHTML = '<div class="jse-label-inner svelte-15uz9w0">Preview</div>', q = bt(), D.c(), _ = bt(), L = rt("div"), J = rt("button"), st = Xt("Transform"), A(a, "class", "jse-label svelte-15uz9w0"), A(u, "class", "jse-description svelte-15uz9w0"), A(l, "class", "jse-label svelte-15uz9w0"), A(h, "class", "jse-path svelte-15uz9w0"), A(h, "type", "text"), h.readOnly = !0, A(h, "title", "Selected path"), h.value = d = _n(e[1]) ? "(whole document)" : sa(e[1]), A(g, "type", "button"), A(g, "class", "svelte-15uz9w0"), A(m, "class", "jse-label-inner svelte-15uz9w0"), A(v, "class", "jse-label svelte-15uz9w0"), A(x, "class", "jse-label svelte-15uz9w0"), A(T, "class", "jse-query svelte-15uz9w0"), A(T, "spellcheck", "false"), T.value = e[8], A(o, "class", "jse-query-contents svelte-15uz9w0"), A(C, "type", "button"), A(C, "class", "svelte-15uz9w0"), A(E, "class", "jse-label-inner svelte-15uz9w0"), A(V, "class", "jse-label svelte-15uz9w0"), A(j, "class", "jse-original-data svelte-15uz9w0"), Ut(j, "jse-hide", !e[11]), A($, "class", "jse-label svelte-15uz9w0"), A(M, "class", "jse-preview-data svelte-15uz9w0"), A(O, "class", "jse-data-contents svelte-15uz9w0"), Ut(O, "jse-hide-original-data", !e[11]), A(i, "class", "jse-main-contents svelte-15uz9w0"), A(J, "type", "button"), A(J, "class", "jse-primary svelte-15uz9w0"), J.disabled = ht = !!e[12], A(L, "class", "jse-actions svelte-15uz9w0"), A(r, "class", "jse-contents svelte-15uz9w0");
  }, m: function(yt, jt) {
    Ot(t, yt, jt), pt(yt, n, jt), pt(yt, r, jt), W(r, i), W(i, o), W(o, a), W(o, s), W(o, u), u.innerHTML = R, W(o, c), W(o, l), W(o, f), W(o, h), W(o, p), W(o, v), W(v, m), W(m, g), Ot(y, g, null), W(g, b), W(o, k), it && it.m(o, null), W(o, w), W(o, x), W(o, S), W(o, T), W(i, P), W(i, O), W(O, j), W(j, V), W(V, E), W(E, C), Ot(H, C, null), W(C, X), W(j, F), N && N.m(j, null), W(O, G), W(O, M), W(M, $), W(M, q), z[B].m(M, null), W(r, _), W(r, L), W(L, J), W(J, st), xt = !0, kt || (I = [Nt(g, "click", e[19]), Nt(T, "input", e[17]), Nt(C, "click", e[20]), Nt(J, "click", e[18]), Ic(JX.call(null, J))], kt = !0);
  }, p: function(yt, jt) {
    var Ft = {};
    16 & jt[0] && (Ft.queryLanguages = yt[4]), 1 & jt[0] && (Ft.queryLanguageId = yt[0]), t.$set(Ft), (!xt || 1 & jt[0]) && R !== (R = yt[15](yt[0]).description + "") && (u.innerHTML = R), (!xt || 2 & jt[0] && d !== (d = _n(yt[1]) ? "(whole document)" : sa(yt[1])) && h.value !== d) && (h.value = d);
    var zt = {};
    1024 & jt[0] && (zt.data = yt[10] ? no : Qo), y.$set(zt), yt[10] ? it ? (it.p(yt, jt), 1024 & jt[0] && U(it, 1)) : ((it = e_(yt)).c(), U(it, 1), it.m(o, w)) : it && (qt(), tt(it, 1, 1, function() {
      it = null;
    }), Vt()), (!xt || 256 & jt[0]) && (T.value = yt[8]);
    var St = {};
    2048 & jt[0] && (St.data = yt[11] ? no : Qo), H.$set(St), yt[11] ? N ? (N.p(yt, jt), 2048 & jt[0] && U(N, 1)) : ((N = n_(yt)).c(), U(N, 1), N.m(j, null)) : N && (qt(), tt(N, 1, 1, function() {
      N = null;
    }), Vt()), 2048 & jt[0] && Ut(j, "jse-hide", !yt[11]);
    var Gt = B;
    (B = at(yt)) === Gt ? z[B].p(yt, jt) : (qt(), tt(z[Gt], 1, 1, function() {
      z[Gt] = null;
    }), Vt(), (D = z[B]) ? D.p(yt, jt) : (D = z[B] = K[B](yt)).c(), U(D, 1), D.m(M, null)), 2048 & jt[0] && Ut(O, "jse-hide-original-data", !yt[11]), (!xt || 4096 & jt[0] && ht !== (ht = !!yt[12])) && (J.disabled = ht);
  }, i: function(yt) {
    xt || (U(t.$$.fragment, yt), U(y.$$.fragment, yt), U(it), U(H.$$.fragment, yt), U(N), U(D), xt = !0);
  }, o: function(yt) {
    tt(t.$$.fragment, yt), tt(y.$$.fragment, yt), tt(it), tt(H.$$.fragment, yt), tt(N), tt(D), xt = !1;
  }, d: function(yt) {
    At(t, yt), yt && vt(n), yt && vt(r), At(y), it && it.d(), At(H), N && N.d(), z[B].d(), kt = !1, Dn(I);
  } };
}
function UX(e) {
  var t, n, r;
  return n = new hA({ props: { $$slots: { default: [WX] }, $$scope: { ctx: e } } }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), A(t, "class", "jse-modal jse-transform svelte-15uz9w0");
  }, m: function(i, o) {
    pt(i, t, o), Ot(n, t, null), r = !0;
  }, p: function(i, o) {
    var a = {};
    32767 & o[0] | 8 & o[1] && (a.$$scope = { dirty: o, ctx: i }), n.$set(a);
  }, i: function(i) {
    r || (U(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    tt(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && vt(t), At(n);
  } };
}
function JX(e) {
  e.focus();
}
function KX(e, t, n) {
  var r, i, o = Ur("jsoneditor:TransformModal"), a = t.id, s = a === void 0 ? "transform-modal-" + Cf() : a, u = t.json, c = t.selectedPath, l = c === void 0 ? [] : c, f = t.escapeControlCharacters, h = t.escapeUnicodeCharacters, d = t.queryLanguages, p = t.queryLanguageId, v = t.onChangeQueryLanguage, m = t.onRenderValue, g = t.onClassName, y = t.onTransform, b = Hr("simple-modal").close, k = "".concat(s, ":").concat(mt.exports.compileJSONPointer(l)), w = $i[k] || {}, x = $i.showWizard !== !1, S = $i.showOriginal !== !1, T = w.queryOptions || {}, P = p === w.queryLanguageId && w.query ? w.query : E(p).createQuery(u, w.queryOptions || {}), O = w.isManual || !1, j = void 0, V = { text: "" };
  function E(H) {
    return d.find(function(X) {
      return X.id === H;
    }) || d[0];
  }
  var C = fu(function(H, X) {
    try {
      o("previewTransform", { query: X });
      var F = E(p).executeQuery(H, X);
      n(13, V = { json: F }), n(12, j = void 0);
    } catch (G) {
      n(13, V = { text: "" }), n(12, j = G);
    }
  }, 300);
  return e.$$set = function(H) {
    "id" in H && n(22, s = H.id), "json" in H && n(23, u = H.json), "selectedPath" in H && n(1, l = H.selectedPath), "escapeControlCharacters" in H && n(2, f = H.escapeControlCharacters), "escapeUnicodeCharacters" in H && n(3, h = H.escapeUnicodeCharacters), "queryLanguages" in H && n(4, d = H.queryLanguages), "queryLanguageId" in H && n(0, p = H.queryLanguageId), "onChangeQueryLanguage" in H && n(24, v = H.onChangeQueryLanguage), "onRenderValue" in H && n(5, m = H.onRenderValue), "onClassName" in H && n(6, g = H.onClassName), "onTransform" in H && n(25, y = H.onTransform);
  }, e.$$.update = function() {
    8388610 & e.$$.dirty[0] && n(9, r = mt.exports.getIn(u, l)), 512 & e.$$.dirty[0] && n(14, i = { json: r }), 768 & e.$$.dirty[0] && C(r, P), 201326977 & e.$$.dirty[0] && (n(26, $i[k] = { queryOptions: T, query: P, queryLanguageId: p, isManual: O }, $i), o("store state in memory", k, $i[k]));
  }, [p, l, f, h, d, m, g, T, P, r, x, S, j, V, i, E, function(H) {
    n(7, T = H), n(8, P = E(p).createQuery(u, H)), n(27, O = !1), o("updateQueryByWizard", { queryOptions: T, query: P, isManual: O });
  }, function(H) {
    n(8, P = H.target.value), n(27, O = !0), o("handleChangeQuery", { query: P, isManual: O });
  }, function() {
    try {
      o("handleTransform", { query: P });
      var H = E(p).executeQuery(r, P);
      y([{ op: "replace", path: mt.exports.compileJSONPointer(l), value: H }]), b();
    } catch (X) {
      console.error(X), n(13, V = { text: "" }), n(12, j = X.toString());
    }
  }, function() {
    n(10, x = !x), n(26, $i.showWizard = x, $i);
  }, function() {
    n(11, S = !S), n(26, $i.showOriginal = S, $i);
  }, function(H) {
    o("handleChangeQueryLanguage", H), n(0, p = H), v(H);
    var X = E(p);
    n(8, P = X.createQuery(u, T)), n(27, O = !1);
  }, s, u, v, y, $i, O];
}
var GX = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, KX, UX, Ue, { id: 22, json: 23, selectedPath: 1, escapeControlCharacters: 2, escapeUnicodeCharacters: 3, queryLanguages: 4, queryLanguageId: 0, onChangeQueryLanguage: 24, onRenderValue: 5, onClassName: 6, onTransform: 25 }, BX, [-1, -1]), i;
  }
  return Y(n);
}(), Ho = {};
function QX(e) {
  Te(e, "svelte-ery7bx", ".jse-modal.svelte-ery7bx.svelte-ery7bx{--height:36px;--multiItemHeight:28px;--multiItemMargin:2px;--multiItemPadding:2px 8px;--multiClearTop:5px;--multiItemBorderRadius:6px;--clearSelectTop:2px;--clearSelectBottom:2px;--indicatorTop:8px;flex:1;display:flex;flex-direction:column;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;background:var(--jse-modal-background);color:var(--jse-text-color)}.jse-modal.svelte-ery7bx .jse-contents.svelte-ery7bx{padding:20px;overflow:auto}.jse-modal.svelte-ery7bx .jse-contents .jse-actions.svelte-ery7bx{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding)}.jse-modal.svelte-ery7bx .jse-contents .jse-actions button.svelte-ery7bx{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;background:var(--jse-button-primary-background);color:var(--jse-button-primary-color);padding:var(--jse-padding) calc(2 * var(--jse-padding));border-radius:3px}.jse-modal.svelte-ery7bx .jse-contents .jse-actions button.svelte-ery7bx:hover{background:var(--jse-button-primary-background-highlight)}.jse-modal.svelte-ery7bx .jse-contents .jse-actions button.svelte-ery7bx:disabled{background:var(--jse-button-primary-background-disabled)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-modal-overlay-background)}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-content{flex:1;display:flex;max-height:calc(100vh - 6rem);padding:0}.jse-modal.jse-sort.svelte-ery7bx table.svelte-ery7bx{width:100%;border-collapse:collapse;border-spacing:0}.jse-modal.jse-sort.svelte-ery7bx table th.svelte-ery7bx,.jse-modal.jse-sort.svelte-ery7bx table td.svelte-ery7bx{text-align:left;vertical-align:middle;font-weight:normal;padding-bottom:var(--jse-padding)}.jse-modal.jse-sort.svelte-ery7bx table th input.jse-path.svelte-ery7bx,.jse-modal.jse-sort.svelte-ery7bx table td input.jse-path.svelte-ery7bx{width:100%;box-sizing:border-box;padding:6px 16px;border:var(--jse-input-border);border-radius:var(--jse-input-radius);font-family:inherit;font-size:inherit;background:inherit;color:inherit;outline:none}.jse-modal.jse-sort.svelte-ery7bx table th input.jse-path.svelte-ery7bx:read-only,.jse-modal.jse-sort.svelte-ery7bx table td input.jse-path.svelte-ery7bx:read-only{background:var(--jse-input-background-readonly)}.jse-modal.jse-sort.svelte-ery7bx table th.svelte-ery7bx .selectContainer input,.jse-modal.jse-sort.svelte-ery7bx table td.svelte-ery7bx .selectContainer input{box-sizing:border-box}.jse-modal.jse-sort.svelte-ery7bx .jse-space.svelte-ery7bx{height:200px}");
}
function r_(e) {
  var t, n, r, i, o, a, s;
  function u(l) {
    e[12](l);
  }
  var c = { showIndicator: !0, items: e[4] };
  return e[1] !== void 0 && (c.value = e[1]), o = new Aa({ props: c }), Be.push(function() {
    return Kr(o, "value", u);
  }), { c: function() {
    t = rt("tr"), (n = rt("th")).textContent = "Property", r = bt(), i = rt("td"), Pt(o.$$.fragment), A(n, "class", "svelte-ery7bx"), A(i, "class", "svelte-ery7bx");
  }, m: function(l, f) {
    pt(l, t, f), W(t, n), W(t, r), W(t, i), Ot(o, i, null), s = !0;
  }, p: function(l, f) {
    var h = {};
    16 & f && (h.items = l[4]), !a && 2 & f && (a = !0, h.value = l[1], di(function() {
      return a = !1;
    })), o.$set(h);
  }, i: function(l) {
    s || (U(o.$$.fragment, l), s = !0);
  }, o: function(l) {
    tt(o.$$.fragment, l), s = !1;
  }, d: function(l) {
    l && vt(t), At(o);
  } };
}
function XX(e) {
  var t, n, r, i, o, a, s, u, c, l, f, h, d, p, v, m, g, y, b, k, w, x, S, T, P, O, j, V, E, C, H, X;
  n = new tM({ props: { title: e[3] ? "Sort array items" : "Sort object keys" } });
  var F = e[3] && (e[4].length > 1 || e[1] === void 0) && r_(e);
  function G($) {
    e[13]($);
  }
  var M = { showIndicator: !0, items: e[5], isClearable: !1 };
  return e[2] !== void 0 && (M.value = e[2]), w = new Aa({ props: M }), Be.push(function() {
    return Kr(w, "value", G);
  }), { c: function() {
    t = rt("div"), Pt(n.$$.fragment), r = bt(), i = rt("div"), o = rt("table"), (a = rt("colgroup")).innerHTML = `<col width="25%"/> 
        <col width="75%"/>`, s = bt(), u = rt("tbody"), c = rt("tr"), (l = rt("th")).textContent = "Path", f = bt(), h = rt("td"), d = rt("input"), v = bt(), F && F.c(), m = bt(), g = rt("tr"), (y = rt("th")).textContent = "Direction", b = bt(), k = rt("td"), Pt(w.$$.fragment), S = bt(), T = rt("div"), P = bt(), O = rt("div"), j = rt("button"), V = Xt("Sort"), A(l, "class", "svelte-ery7bx"), A(d, "class", "jse-path svelte-ery7bx"), A(d, "type", "text"), d.readOnly = !0, A(d, "title", "Selected path"), d.value = p = _n(e[0]) ? "(whole document)" : sa(e[0]), A(h, "class", "svelte-ery7bx"), A(y, "class", "svelte-ery7bx"), A(k, "class", "svelte-ery7bx"), A(o, "class", "svelte-ery7bx"), A(T, "class", "jse-space svelte-ery7bx"), A(j, "type", "button"), A(j, "class", "jse-primary svelte-ery7bx"), j.disabled = E = !!e[3] && !e[1], A(O, "class", "jse-actions svelte-ery7bx"), A(i, "class", "jse-contents svelte-ery7bx"), A(t, "class", "jse-modal jse-sort svelte-ery7bx");
  }, m: function($, q) {
    pt($, t, q), Ot(n, t, null), W(t, r), W(t, i), W(i, o), W(o, a), W(o, s), W(o, u), W(u, c), W(c, l), W(c, f), W(c, h), W(h, d), W(u, v), F && F.m(u, null), W(u, m), W(u, g), W(g, y), W(g, b), W(g, k), Ot(w, k, null), W(i, S), W(i, T), W(i, P), W(i, O), W(O, j), W(j, V), C = !0, H || (X = [Nt(j, "click", e[6]), Ic(ZX.call(null, j))], H = !0);
  }, p: function($, q) {
    var B = xe(q, 1)[0], D = {};
    8 & B && (D.title = $[3] ? "Sort array items" : "Sort object keys"), n.$set(D), (!C || 1 & B && p !== (p = _n($[0]) ? "(whole document)" : sa($[0])) && d.value !== p) && (d.value = p), $[3] && ($[4].length > 1 || $[1] === void 0) ? F ? (F.p($, B), 26 & B && U(F, 1)) : ((F = r_($)).c(), U(F, 1), F.m(u, m)) : F && (qt(), tt(F, 1, 1, function() {
      F = null;
    }), Vt());
    var _ = {};
    !x && 4 & B && (x = !0, _.value = $[2], di(function() {
      return x = !1;
    })), w.$set(_), (!C || 10 & B && E !== (E = !!$[3] && !$[1])) && (j.disabled = E);
  }, i: function($) {
    C || (U(n.$$.fragment, $), U(F), U(w.$$.fragment, $), C = !0);
  }, o: function($) {
    tt(n.$$.fragment, $), tt(F), tt(w.$$.fragment, $), C = !1;
  }, d: function($) {
    $ && vt(t), At(n), F && F.d(), At(w), H = !1, Dn(X);
  } };
}
function ZX(e) {
  e.focus();
}
function YX(e, t, n) {
  var r, i, o, a = Ur("jsoneditor:SortModal"), s = t.id, u = t.json, c = t.selectedPath, l = t.onSort, f = Hr("simple-modal").close, h = "".concat(s, ":").concat(mt.exports.compileJSONPointer(c)), d = mt.exports.getIn(u, c), p = { value: 1, label: "ascending" }, v = [p, { value: -1, label: "descending" }], m = Ho[h] && Ho[h].selectedProperty || void 0, g = Ho[h] && Ho[h].selectedDirection || p;
  function y(b) {
    return { value: b, label: _n(b) ? "(whole item)" : mt.exports.compileJSONPointer(b) };
  }
  return e.$$set = function(b) {
    "id" in b && n(7, s = b.id), "json" in b && n(8, u = b.json), "selectedPath" in b && n(0, c = b.selectedPath), "onSort" in b && n(9, l = b.onSort);
  }, e.$$.update = function() {
    8 & e.$$.dirty && n(11, i = r ? fp(d) : void 0), 2048 & e.$$.dirty && n(4, o = i ? i.map(y) : void 0), 18 & e.$$.dirty && m === void 0 && o && o.length === 1 && n(1, m = o[0]), 1030 & e.$$.dirty && (n(10, Ho[h] = { selectedProperty: m, selectedDirection: g }, Ho), a("store state in memory", h, Ho[h]));
  }, n(3, r = Array.isArray(d)), [c, m, g, r, o, v, function() {
    if (r) {
      if (!m)
        return;
      var b = m.value, k = g.value, w = function(T) {
        var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], O = YG(arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1), j = mt.exports.getIn(T, P);
        return [{ op: "replace", path: mt.exports.compileJSONPointer(P), value: j.slice(0).sort(O) }];
      }(u, c, b, k);
      l(w);
    } else if (mr(d)) {
      var x = g.value, S = function(T) {
        var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, j = mt.exports.getIn(T, P), V = Object.keys(j).slice();
        V.sort(function(F, G) {
          return O * H0(F, G);
        });
        for (var E = [], C = 0; C < V.length; C++) {
          var H = V[C], X = mt.exports.compileJSONPointer(P.concat(H));
          E.push({ op: "move", from: X, path: X });
        }
        return E;
      }(u, c, x);
      l(S);
    } else
      console.error("Cannot sort: no array or object");
    f();
  }, s, u, l, Ho, i, function(b) {
    n(1, m = b), n(4, o), n(11, i), n(3, r);
  }, function(b) {
    n(2, g = b);
  }];
}
var tZ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, YX, XX, Ue, { id: 7, json: 8, selectedPath: 0, onSort: 9 }, QX), i;
  }
  return Y(n);
}();
function eZ(e, t, n) {
  var r = Hr("simple-modal");
  return [r.open, r.close];
}
var nZ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, eZ, null, Ue, { open: 0, close: 1 }), i;
  }
  return Y(n, [{ key: "open", get: function() {
    return this.$$.ctx[0];
  } }, { key: "close", get: function() {
    return this.$$.ctx[1];
  } }]), n;
}();
function rZ(e) {
  Te(e, "svelte-1tkifqe", `:root{--jse-font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,
    Cantarell, "Helvetica Neue", sans-serif;--jse-font-family-mono:consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace;--jse-font-size-mono:14px;--jse-font-size:16px;--jse-font-size-text-mode-search:80%;--jse-line-height:calc(1em + 4px);--jse-indent-size:calc(1em + 4px);--jse-color-picker-button-size:1em;--jse-padding:10px;--jse-theme-color:#3883fa;--jse-theme-color-highlight:#5f9dff;--jse-background-color:#fff;--jse-text-color:#4d4d4d;--jse-text-color-inverse:#fff;--jse-error-color:#ee5341;--jse-warning-color:#fdc539;--jse-main-border:1px solid #d7d7d7;--jse-menu-color:var(--jse-text-color-inverse);--jse-menu-button-size:32px;--jse-modal-background:#f5f5f5;--jse-modal-overlay-background:rgba(0, 0, 0, 0.3);--jse-modal-code-background:rgba(0, 0, 0, 0.05);--jse-panel-background:#ebebeb;--jse-panel-color:var(--jse-text-color);--jse-panel-color-readonly:#b2b2b2;--jse-panel-border:var(--jse-main-border);--jse-panel-button-color:inherit;--jse-panel-button-background:transparent;--jse-panel-button-color-highlight:var(--jse-text-color);--jse-panel-button-background-highlight:#e0e0e0;--jse-navigation-bar-color:#656565;--jse-navigation-bar-background:var(--jse-background-color);--jse-navigation-bar-background-highlight:#e5e5e5;--jse-navigation-bar-dropdown-color:#656565;--jse-context-menu-background:#656565;--jse-context-menu-background-highlight:#7a7a7a;--jse-context-menu-color:var(--jse-text-color-inverse);--jse-context-menu-color-disabled:#9d9d9d;--jse-context-menu-separator-color:#7a7a7a;--jse-context-menu-button-background:var(--jse-context-menu-background);--jse-context-menu-button-background-highlight:var(--jse-context-menu-background-highlight);--jse-context-menu-button-color:var(--jse-context-menu-color);--jse-context-menu-button-size:calc(1em + 4px);--jse-context-menu-tip-background:rgba(255, 255, 255, 0.2);--jse-context-menu-tip-color:inherit;--jse-key-color:#1a1a1a;--jse-value-color:#1a1a1a;--jse-value-color-number:#ee422e;--jse-value-color-boolean:#ff8c00;--jse-value-color-null:#004ed0;--jse-value-color-string:#008000;--jse-value-color-url:#008000;--jse-delimiter-color:rgba(0, 0, 0, 0.38);--jse-edit-outline:2px solid #656565;--jse-hover-background-color:rgba(0, 0, 0, 0.06);--jse-selection-background-color:#d3d3d3;--jse-selection-background-light-color:#e8e8e8;--jse-collapsed-items-background-color:#f5f5f5;--jse-collapsed-items-selected-background-color:#c2c2c2;--jse-collapsed-items-link-color:rgba(0, 0, 0, 0.38);--jse-collapsed-items-link-color-highlight:#ee5341;--jse-search-match-color:#ffe665;--jse-search-match-outline:1px solid #ffd700;--jse-search-match-active-color:#ffd700;--jse-search-match-active-outline:1px solid #e1be00;--jse-tag-background:rgba(0, 0, 0, 0.2);--jse-tag-color:var(--jse-text-color-inverse);--jse-controls-box-shadow:0 2px 6px 0 rgba(0, 0, 0, 0.24);--jse-input-background:var(--jse-background-color);--jse-input-background-readonly:transparent;--jse-input-border:1px solid #d8dbdf;--jse-input-border-focus:1px solid var(--jse-theme-color);--jse-input-radius:3px;--jse-button-background:#e0e0e0;--jse-button-background-highlight:#e7e7e7;--jse-button-color:var(--jse-text-color);--jse-button-primary-background:var(--jse-theme-color);--jse-button-primary-background-highlight:var(--jse-theme-color-highlight);--jse-button-primary-background-disabled:#9d9d9d;--jse-button-primary-color:var(--jse-text-color-inverse);--jse-a-color:#156fc5;--jse-a-color-highlight:#0f508d;--jse-message-error-background:var(--jse-error-color);--jse-message-error-color:var(--jse-text-color-inverse);--jse-message-warning-background:#ffde5c;--jse-message-warning-color:var(--jse-text-color);--jse-message-success-background:#9ac45d;--jse-message-success-color:var(--jse-text-color-inverse);--jse-message-info-background:#9d9d9d;--jse-message-info-color:var(--jse-text-color-inverse);--jse-message-action-background:rgba(255, 255, 255, 0.2);--jse-message-action-background-highlight:rgba(255, 255, 255, 0.3);--itemIsActiveBG:#3883fa;--border:1px solid #d8dbdf;--borderRadius:3px;--background:#fff;--jse-color-picker-background:var(--jse-panel-background);--jse-color-picker-border-box-shadow:#cbcbcb 0 0 0 1px}.jse-main.svelte-1tkifqe{width:100%;height:100%;min-width:0;min-height:150px;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;position:relative;display:flex;flex-direction:row}`);
}
function iZ(e) {
  var t, n, r = { readOnly: e[2], indentation: e[3], externalContent: e[0], mainMenuBar: e[5], navigationBar: e[6], escapeControlCharacters: e[8], escapeUnicodeCharacters: e[9], validator: e[10], onError: e[13], onChange: e[22], onRequestRepair: e[24], onRenderValue: e[11], onClassName: e[12], onFocus: e[26], onBlur: e[27], onRenderMenu: e[20], onSortModal: e[29], onTransformModal: e[28] };
  return t = new W0({ props: r }), e[54](t), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(i, o) {
    Ot(t, i, o), n = !0;
  }, p: function(i, o) {
    var a = {};
    4 & o[0] && (a.readOnly = i[2]), 8 & o[0] && (a.indentation = i[3]), 1 & o[0] && (a.externalContent = i[0]), 32 & o[0] && (a.mainMenuBar = i[5]), 64 & o[0] && (a.navigationBar = i[6]), 256 & o[0] && (a.escapeControlCharacters = i[8]), 512 & o[0] && (a.escapeUnicodeCharacters = i[9]), 1024 & o[0] && (a.validator = i[10]), 8192 & o[0] && (a.onError = i[13]), 2048 & o[0] && (a.onRenderValue = i[11]), 4096 & o[0] && (a.onClassName = i[12]), 1048576 & o[0] && (a.onRenderMenu = i[20]), t.$set(a);
  }, i: function(i) {
    n || (U(t.$$.fragment, i), n = !0);
  }, o: function(i) {
    tt(t.$$.fragment, i), n = !1;
  }, d: function(i) {
    e[54](null), At(t, i);
  } };
}
function oZ(e) {
  var t, n, r = { text: e[21](e[0]), readOnly: e[2], indentation: e[3], tabSize: e[4], mainMenuBar: e[5], statusBar: e[7], escapeUnicodeCharacters: e[9], validator: e[10], onChange: e[23], onSwitchToTreeMode: e[25], onError: e[13], onFocus: e[26], onBlur: e[27], onRenderMenu: e[20], onSortModal: e[29], onTransformModal: e[28] };
  return t = new VJ({ props: r }), e[53](t), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(i, o) {
    Ot(t, i, o), n = !0;
  }, p: function(i, o) {
    var a = {};
    1 & o[0] && (a.text = i[21](i[0])), 4 & o[0] && (a.readOnly = i[2]), 8 & o[0] && (a.indentation = i[3]), 16 & o[0] && (a.tabSize = i[4]), 32 & o[0] && (a.mainMenuBar = i[5]), 128 & o[0] && (a.statusBar = i[7]), 512 & o[0] && (a.escapeUnicodeCharacters = i[9]), 1024 & o[0] && (a.validator = i[10]), 8192 & o[0] && (a.onError = i[13]), 1048576 & o[0] && (a.onRenderMenu = i[20]), t.$set(a);
  }, i: function(i) {
    n || (U(t.$$.fragment, i), n = !0);
  }, o: function(i) {
    tt(t.$$.fragment, i), n = !1;
  }, d: function(i) {
    e[53](null), At(t, i);
  } };
}
function i_(e) {
  var t, n, r, i, o = [oZ, iZ], a = [];
  function s(u, c) {
    return u[1] === ci.text || u[1] === "code" ? 0 : 1;
  }
  return t = s(e), n = a[t] = o[t](e), { c: function() {
    n.c(), r = Ye();
  }, m: function(u, c) {
    a[t].m(u, c), pt(u, r, c), i = !0;
  }, p: function(u, c) {
    var l = t;
    (t = s(u)) === l ? a[t].p(u, c) : (qt(), tt(a[l], 1, 1, function() {
      a[l] = null;
    }), Vt(), (n = a[t]) ? n.p(u, c) : (n = a[t] = o[t](u)).c(), U(n, 1), n.m(r.parentNode, r));
  }, i: function(u) {
    i || (U(n), i = !0);
  }, o: function(u) {
    tt(n), i = !1;
  }, d: function(u) {
    a[t].d(u), u && vt(r);
  } };
}
function aZ(e) {
  var t, n, r = e[14], i = i_(e);
  return { c: function() {
    t = rt("div"), i.c(), A(t, "class", "jse-main svelte-1tkifqe"), Ut(t, "jse-focus", e[15]);
  }, m: function(o, a) {
    pt(o, t, a), i.m(t, null), e[55](t), n = !0;
  }, p: function(o, a) {
    16384 & a[0] && Ue(r, r = o[14]) ? (qt(), tt(i, 1, 1, Wt), Vt(), (i = i_(o)).c(), U(i, 1), i.m(t, null)) : i.p(o, a), 32768 & a[0] && Ut(t, "jse-focus", o[15]);
  }, i: function(o) {
    n || (U(i), n = !0);
  }, o: function(o) {
    tt(i), n = !1;
  }, d: function(o) {
    o && vt(t), i.d(o), e[55](null);
  } };
}
function sZ(e) {
  var t, n, r, i, o;
  function a(u) {
    e[52](u);
  }
  var s = {};
  return e[19] !== void 0 && (s.open = e[19]), t = new nZ({ props: s }), Be.push(function() {
    return Kr(t, "open", a);
  }), i = new hA({ props: { $$slots: { default: [aZ] }, $$scope: { ctx: e } } }), { c: function() {
    Pt(t.$$.fragment), r = bt(), Pt(i.$$.fragment);
  }, m: function(u, c) {
    Ot(t, u, c), pt(u, r, c), Ot(i, u, c), o = !0;
  }, p: function(u, c) {
    var l = {};
    !n && 524288 & c[0] && (n = !0, l.open = u[19], di(function() {
      return n = !1;
    })), t.$set(l);
    var f = {};
    1572863 & c[0] | 536870912 & c[1] && (f.$$scope = { dirty: c, ctx: u }), i.$set(f);
  }, i: function(u) {
    o || (U(t.$$.fragment, u), U(i.$$.fragment, u), o = !0);
  }, o: function(u) {
    tt(t.$$.fragment, u), tt(i.$$.fragment, u), o = !1;
  }, d: function(u) {
    At(t, u), u && vt(r), At(i, u);
  } };
}
function uZ(e) {
  var t, n;
  return t = new aL({ props: { $$slots: { default: [sZ] }, $$scope: { ctx: e } } }), { c: function() {
    Pt(t.$$.fragment);
  }, m: function(r, i) {
    Ot(t, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2097151 & i[0] | 536870912 & i[1] && (o.$$scope = { dirty: i, ctx: r }), t.$set(o);
  }, i: function(r) {
    n || (U(t.$$.fragment, r), n = !0);
  }, o: function(r) {
    tt(t.$$.fragment, r), n = !1;
  }, d: function(r) {
    At(t, r);
  } };
}
function uM(e) {
  this.$set(e);
}
function cM() {
  this.$destroy();
}
function cZ(e, t, n) {
  var r, i, o, a, s, u, c = Ur("jsoneditor:Main"), l = t.content, f = l === void 0 ? { text: "" } : l, h = t.readOnly, d = h !== void 0 && h, p = t.indentation, v = p === void 0 ? 2 : p, m = t.tabSize, g = m === void 0 ? 4 : m, y = t.mode, b = y === void 0 ? ci.tree : y, k = t.mainMenuBar, w = k === void 0 || k, x = t.navigationBar, S = x === void 0 || x, T = t.statusBar, P = T === void 0 || T, O = t.escapeControlCharacters, j = O !== void 0 && O, V = t.escapeUnicodeCharacters, E = V !== void 0 && V, C = t.validator, H = C === void 0 ? null : C, X = t.queryLanguages, F = X === void 0 ? [wQ] : X, G = t.queryLanguageId, M = G === void 0 ? F[0].id : G, $ = t.onChangeQueryLanguage, q = $ === void 0 ? Qe : $, B = t.onChange, D = B === void 0 ? null : B, _ = t.onRenderValue, L = _ === void 0 ? JQ : _, J = t.onClassName, st = J === void 0 ? function() {
  } : J, ht = t.onRenderMenu, xt = ht === void 0 ? Qe : ht, kt = t.onChangeMode, I = kt === void 0 ? Qe : kt, R = t.onError, it = R === void 0 ? function($t) {
    console.error($t), alert($t.toString());
  } : R, N = t.onFocus, K = N === void 0 ? Qe : N, z = t.onBlur, at = z === void 0 ? Qe : z, yt = Cf(), jt = !1;
  function Ft() {
    a ? a.focus() : o && o.focus();
  }
  function zt($t, oe, Ce) {
    n(0, f = $t), D && D($t, oe, Ce);
  }
  function St() {
    return (St = mn(de().mark(function $t() {
      return de().wrap(function(oe) {
        for (; ; )
          switch (oe.prev = oe.next) {
            case 0:
              return n(1, b = ci.text), oe.next = 3, Qn();
            case 3:
              I(ci.text);
            case 4:
            case "end":
              return oe.stop();
          }
      }, $t);
    }))).apply(this, arguments);
  }
  function Gt() {
    return (Gt = mn(de().mark(function $t() {
      return de().wrap(function(oe) {
        for (; ; )
          switch (oe.prev = oe.next) {
            case 0:
              return n(1, b = ci.tree), oe.next = 3, Qn();
            case 3:
              I(ci.tree);
            case 4:
            case "end":
              return oe.stop();
          }
      }, $t);
    }))).apply(this, arguments);
  }
  function _e($t) {
    return Fe.apply(this, arguments);
  }
  function Fe() {
    return (Fe = mn(de().mark(function $t(oe) {
      return de().wrap(function(Ce) {
        for (; ; )
          switch (Ce.prev = Ce.next) {
            case 0:
              if (b !== oe) {
                Ce.next = 2;
                break;
              }
              return Ce.abrupt("return");
            case 2:
              return n(1, b = oe), Ce.next = 5, Qn();
            case 5:
              Ft(), I(oe);
            case 7:
            case "end":
              return Ce.stop();
          }
      }, $t);
    }))).apply(this, arguments);
  }
  var fn = { separator: !0 };
  function De($t) {
    c("handleChangeQueryLanguage", $t), n(30, M = $t), q($t);
  }
  return e.$$set = function($t) {
    "content" in $t && n(0, f = $t.content), "readOnly" in $t && n(2, d = $t.readOnly), "indentation" in $t && n(3, v = $t.indentation), "tabSize" in $t && n(4, g = $t.tabSize), "mode" in $t && n(1, b = $t.mode), "mainMenuBar" in $t && n(5, w = $t.mainMenuBar), "navigationBar" in $t && n(6, S = $t.navigationBar), "statusBar" in $t && n(7, P = $t.statusBar), "escapeControlCharacters" in $t && n(8, j = $t.escapeControlCharacters), "escapeUnicodeCharacters" in $t && n(9, E = $t.escapeUnicodeCharacters), "validator" in $t && n(10, H = $t.validator), "queryLanguages" in $t && n(31, F = $t.queryLanguages), "queryLanguageId" in $t && n(30, M = $t.queryLanguageId), "onChangeQueryLanguage" in $t && n(32, q = $t.onChangeQueryLanguage), "onChange" in $t && n(33, D = $t.onChange), "onRenderValue" in $t && n(11, L = $t.onRenderValue), "onClassName" in $t && n(12, st = $t.onClassName), "onRenderMenu" in $t && n(34, xt = $t.onRenderMenu), "onChangeMode" in $t && n(35, I = $t.onChangeMode), "onError" in $t && n(13, it = $t.onError), "onFocus" in $t && n(36, K = $t.onFocus), "onBlur" in $t && n(37, at = $t.onBlur);
  }, e.$$.update = function() {
    if (1 & e.$$.dirty[0]) {
      var $t = Bd(f);
      $t && console.error("Error: " + $t);
    }
    2 & e.$$.dirty[0] && n(51, u = [{ text: "text", title: "Switch to text mode (current mode: ".concat(b, ")"), className: "jse-group-button jse-first" + (b === ci.text || b === "code" ? " jse-selected" : ""), onClick: function() {
      return _e(ci.text);
    } }, { text: "tree", title: "Switch to tree mode (current mode: ".concat(b, ")"), className: "jse-group-button jse-last" + (b === ci.tree ? " jse-selected" : ""), onClick: function() {
      return _e(ci.tree);
    } }]), 1048584 & e.$$.dirty[1] && n(20, r = function(oe, Ce) {
      var sn, vn = (sn = Ce[0]) && sn.space === !0 && Object.keys(sn).length === 1 ? u.concat(Ce) : u.concat(fn, Ce);
      return xt(oe, vn) || vn;
    }), 2 & e.$$.dirty[0] && (c("mode changed to", b), b === "code" && console.warn('Deprecation warning: "code" mode is renamed to "text". Please use mode="text" instead.'));
  }, [f, b, d, v, g, w, S, P, j, E, H, L, st, it, yt, jt, i, o, a, s, r, function($t) {
    return hp($t) ? $t.text : JSON.stringify($t.json, null, v);
  }, zt, function($t, oe) {
    zt({ text: $t, json: void 0 }, { text: oe, json: void 0 }, null);
  }, function() {
    return St.apply(this, arguments);
  }, function() {
    return Gt.apply(this, arguments);
  }, function() {
    n(15, jt = !0), K && K();
  }, function() {
    n(15, jt = !1), at && at();
  }, function($t) {
    var oe = $t.id, Ce = $t.json, sn = $t.selectedPath, vn = $t.onTransform, nt = $t.onClose;
    d || s(GX, { id: oe, json: Ce, selectedPath: sn, escapeControlCharacters: j, escapeUnicodeCharacters: E, queryLanguages: F, queryLanguageId: M, onChangeQueryLanguage: De, onRenderValue: L, onClassName: st, onTransform: vn }, uL, { onClose: nt });
  }, function($t) {
    var oe = $t.id, Ce = $t.json, sn = $t.selectedPath, vn = $t.onSort, nt = $t.onClose;
    d || s(tZ, { id: oe, json: Ce, selectedPath: sn, onSort: vn }, sL, { onClose: nt });
  }, M, F, q, D, xt, I, K, at, function() {
    return f;
  }, function($t) {
    c("set");
    var oe = Bd($t);
    if (oe)
      throw new Error(oe);
    n(14, yt = Cf()), n(0, f = $t);
  }, function($t) {
    c("update");
    var oe = Bd($t);
    if (oe)
      throw new Error(oe);
    n(0, f = $t);
  }, function($t) {
    if (hp(f))
      try {
        n(0, f = { json: JSON.parse(f.text), text: void 0 });
      } catch {
        throw new Error("Cannot apply patch: current document contains invalid JSON");
      }
    return o ? o.patch($t) : a ? a.patch($t) : void 0;
  }, function($t) {
    if (o)
      return o.expand($t);
    throw new Error('Method expand is not available in mode "'.concat(b, '"'));
  }, function($t) {
    if (a)
      a.openTransformModal($t);
    else {
      if (!o)
        throw new Error('Method transform is not available in mode "'.concat(b, '"'));
      o.openTransformModal($t);
    }
  }, function() {
    return o ? o.acceptAutoRepair() : f;
  }, function($t) {
    if (o)
      return o.scrollTo($t);
    throw new Error('Method scrollTo is not available in mode "'.concat(b, '"'));
  }, function($t) {
    if (o)
      return o.findElement($t);
    throw new Error('Method findElement is not available in mode "'.concat(b, '"'));
  }, Ft, function() {
    a && a.refresh();
  }, uM, cM, u, function($t) {
    n(19, s = $t);
  }, function($t) {
    Be[$t ? "unshift" : "push"](function() {
      n(18, a = $t);
    });
  }, function($t) {
    Be[$t ? "unshift" : "push"](function() {
      n(17, o = $t);
    });
  }, function($t) {
    Be[$t ? "unshift" : "push"](function() {
      n(16, i = $t);
    });
  }];
}
var lZ = function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, cZ, uZ, Ue, { content: 0, readOnly: 2, indentation: 3, tabSize: 4, mode: 1, mainMenuBar: 5, navigationBar: 6, statusBar: 7, escapeControlCharacters: 8, escapeUnicodeCharacters: 9, validator: 10, queryLanguages: 31, queryLanguageId: 30, onChangeQueryLanguage: 32, onChange: 33, onRenderValue: 11, onClassName: 12, onRenderMenu: 34, onChangeMode: 35, onError: 13, onFocus: 36, onBlur: 37, get: 38, set: 39, update: 40, patch: 41, expand: 42, transform: 43, acceptAutoRepair: 44, scrollTo: 45, findElement: 46, focus: 47, refresh: 48, updateProps: 49, destroy: 50 }, rZ, [-1, -1]), i;
  }
  return Y(n, [{ key: "get", get: function() {
    return this.$$.ctx[38];
  } }, { key: "set", get: function() {
    return this.$$.ctx[39];
  } }, { key: "update", get: function() {
    return this.$$.ctx[40];
  } }, { key: "patch", get: function() {
    return this.$$.ctx[41];
  } }, { key: "expand", get: function() {
    return this.$$.ctx[42];
  } }, { key: "transform", get: function() {
    return this.$$.ctx[43];
  } }, { key: "acceptAutoRepair", get: function() {
    return this.$$.ctx[44];
  } }, { key: "scrollTo", get: function() {
    return this.$$.ctx[45];
  } }, { key: "findElement", get: function() {
    return this.$$.ctx[46];
  } }, { key: "focus", get: function() {
    return this.$$.ctx[47];
  } }, { key: "refresh", get: function() {
    return this.$$.ctx[48];
  } }, { key: "updateProps", get: function() {
    return uM;
  } }, { key: "destroy", get: function() {
    return cM;
  } }]), n;
}();
function fZ(e) {
  Te(e, "svelte-rc6e9m", ".jse-value.jse-string.svelte-rc6e9m{color:var(--jse-value-color-string)}.jse-value.jse-object.svelte-rc6e9m,.jse-value.jse-array.svelte-rc6e9m{min-width:16px;color:var(--jse-delimiter-color)}.jse-value.jse-number.svelte-rc6e9m{color:var(--jse-value-color-number)}.jse-value.jse-boolean.svelte-rc6e9m{color:var(--jse-value-color-boolean)}.jse-value.jse-null.svelte-rc6e9m{color:var(--jse-value-color-null)}.jse-value.jse-invalid.svelte-rc6e9m{color:var(--jse-text-color)}.jse-value.jse-url.svelte-rc6e9m{color:var(--jse-value-color-url);text-decoration:underline}.jse-enum-value.svelte-rc6e9m{background:var(--jse-hover-background-color);border:none;padding:0;font-family:inherit;font-size:inherit;cursor:pointer;outline:none}.jse-enum-value.jse-selected.svelte-rc6e9m{background:var(--jse-selection-background-color);color:inherit}.jse-enum-value.jse-value.svelte-rc6e9m:focus{color:var(--jse-text-color)}.jse-json-node.jse-selected .jse-enum-value.svelte-rc6e9m{background:transparent}");
}
function o_(e, t, n) {
  var r = e.slice();
  return r[12] = t[n], r;
}
function a_(e) {
  var t, n, r, i = e[12].text + "";
  return { c: function() {
    t = rt("option"), n = Xt(i), t.__value = r = e[12].value, t.value = t.__value;
  }, m: function(o, a) {
    pt(o, t, a), W(t, n);
  }, p: function(o, a) {
    2 & a && i !== (i = o[12].text + "") && Ve(n, i), 2 & a && r !== (r = o[12].value) && (t.__value = r, t.value = t.__value);
  }, d: function(o) {
    o && vt(t);
  } };
}
function hZ(e) {
  for (var t, n, r, i, o = e[1], a = [], s = 0; s < o.length; s += 1)
    a[s] = a_(o_(e, o, s));
  return { c: function() {
    t = rt("select");
    for (var u = 0; u < a.length; u += 1)
      a[u].c();
    A(t, "class", n = er("jse-enum-value ".concat(Ac(e[3]))) + " svelte-rc6e9m"), e[3] === void 0 && ia(function() {
      return e[9].call(t);
    }), Ut(t, "jse-selected", e[0]);
  }, m: function(u, c) {
    pt(u, t, c);
    for (var l = 0; l < a.length; l += 1)
      a[l].m(t, null);
    X2(t, e[3]), e[10](t), r || (i = [Nt(t, "change", e[9]), Nt(t, "change", e[4]), Nt(t, "mousedown", dZ)], r = !0);
  }, p: function(u, c) {
    var l = xe(c, 1)[0];
    if (2 & l) {
      var f;
      for (o = u[1], f = 0; f < o.length; f += 1) {
        var h = o_(u, o, f);
        a[f] ? a[f].p(h, l) : (a[f] = a_(h), a[f].c(), a[f].m(t, null));
      }
      for (; f < a.length; f += 1)
        a[f].d(1);
      a.length = o.length;
    }
    8 & l && n !== (n = er("jse-enum-value ".concat(Ac(u[3]))) + " svelte-rc6e9m") && A(t, "class", n), 8 & l && X2(t, u[3]), 9 & l && Ut(t, "jse-selected", u[0]);
  }, i: Wt, o: Wt, d: function(u) {
    u && vt(t), Ar(a, u), e[10](null), r = !1, Dn(i);
  } };
}
function dZ(e) {
  e.stopPropagation();
}
function vZ(e, t, n) {
  var r, i = t.path, o = t.value, a = t.readOnly, s = t.isSelected, u = t.onPatch, c = t.options, l = o;
  return e.$$set = function(f) {
    "path" in f && n(5, i = f.path), "value" in f && n(6, o = f.value), "readOnly" in f && n(7, a = f.readOnly), "isSelected" in f && n(0, s = f.isSelected), "onPatch" in f && n(8, u = f.onPatch), "options" in f && n(1, c = f.options);
  }, e.$$.update = function() {
    64 & e.$$.dirty && n(3, l = o), 1 & e.$$.dirty && function(f) {
      f && r && r.focus();
    }(s);
  }, [s, c, r, l, function(f) {
    f.stopPropagation(), a || u([{ op: "replace", path: mt.exports.compileJSONPointer(i), value: l }]);
  }, i, o, a, u, function() {
    var f, h;
    h = (f = this).querySelector(":checked") || f.options[0], l = h && h.__value, n(3, l), n(6, o);
  }, function(f) {
    Be[f ? "unshift" : "push"](function() {
      n(2, r = f), n(1, c);
    });
  }];
}
(function(e) {
  Et(n, pe);
  var t = Mt(n);
  function n(r) {
    var i;
    return Z(this, n), ke(he(i = t.call(this)), r, vZ, hZ, Ue, { path: 5, value: 6, readOnly: 7, isSelected: 0, onPatch: 8, options: 1 }, fZ), i;
  }
  return Y(n);
})();
function Pv(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
fL(function e(t, n, r) {
  function i(s, u) {
    if (!n[s]) {
      if (!t[s]) {
        if (!u && Pv)
          return Pv(s);
        if (o)
          return o(s, !0);
        var c = new Error("Cannot find module '" + s + "'");
        throw c.code = "MODULE_NOT_FOUND", c;
      }
      var l = n[s] = { exports: {} };
      t[s][0].call(l.exports, function(f) {
        return i(t[s][1][f] || f);
      }, l, l.exports, e, t, n, r);
    }
    return n[s].exports;
  }
  for (var o = Pv, a = 0; a < r.length; a++)
    i(r[a]);
  return i;
}({ 1: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.regexpCode = n.getEsmExportName = n.getProperty = n.safeStringify = n.stringify = n.strConcat = n.addCodeArg = n.str = n._ = n.nil = n._Code = n.Name = n.IDENTIFIER = n._CodeOrName = void 0;
  var r = Y(function h() {
    Z(this, h);
  });
  n._CodeOrName = r, n.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
  var i = function(h) {
    Et(p, h);
    var d = Mt(p);
    function p(v) {
      var m;
      if (Z(this, p), m = d.call(this), !n.IDENTIFIER.test(v))
        throw new Error("CodeGen: name must be a valid identifier");
      return m.str = v, fC(m);
    }
    return Y(p, [{ key: "toString", value: function() {
      return this.str;
    } }, { key: "emptyStr", value: function() {
      return !1;
    } }, { key: "names", get: function() {
      return na({}, this.str, 1);
    } }]), p;
  }(r);
  n.Name = i;
  var o = function(h) {
    Et(p, h);
    var d = Mt(p);
    function p(v) {
      var m;
      return Z(this, p), (m = d.call(this))._items = typeof v == "string" ? [v] : v, m;
    }
    return Y(p, [{ key: "toString", value: function() {
      return this.str;
    } }, { key: "emptyStr", value: function() {
      if (this._items.length > 1)
        return !1;
      var v = this._items[0];
      return v === "" || v === '""';
    } }, { key: "str", get: function() {
      var v;
      return (v = this._str) !== null && v !== void 0 ? v : this._str = this._items.reduce(function(m, g) {
        return "".concat(m).concat(g);
      }, "");
    } }, { key: "names", get: function() {
      var v;
      return (v = this._names) !== null && v !== void 0 ? v : this._names = this._items.reduce(function(m, g) {
        return g instanceof i && (m[g.str] = (m[g.str] || 0) + 1), m;
      }, {});
    } }]), p;
  }(r);
  function a(h) {
    for (var d = [h[0]], p = 0, v = arguments.length, m = new Array(v > 1 ? v - 1 : 0), g = 1; g < v; g++)
      m[g - 1] = arguments[g];
    for (; p < m.length; )
      c(d, m[p]), d.push(h[++p]);
    return new o(d);
  }
  n._Code = o, n.nil = new o(""), n._ = a;
  var s = new o("+");
  function u(h) {
    for (var d = [f(h[0])], p = 0, v = arguments.length, m = new Array(v > 1 ? v - 1 : 0), g = 1; g < v; g++)
      m[g - 1] = arguments[g];
    for (; p < m.length; )
      d.push(s), c(d, m[p]), d.push(s, f(h[++p]));
    return function(y) {
      for (var b = 1; b < y.length - 1; ) {
        if (y[b] === s) {
          var k = l(y[b - 1], y[b + 1]);
          if (k !== void 0) {
            y.splice(b - 1, 3, k);
            continue;
          }
          y[b++] = "+";
        }
        b++;
      }
    }(d), new o(d);
  }
  function c(h, d) {
    var p;
    d instanceof o ? h.push.apply(h, Pe(d._items)) : h.push(d instanceof i ? d : typeof (p = d) == "number" || typeof p == "boolean" || p === null ? p : f(Array.isArray(p) ? p.join(",") : p));
  }
  function l(h, d) {
    return d === '""' ? h : h === '""' ? d : typeof h == "string" ? d instanceof i || h[h.length - 1] !== '"' ? void 0 : typeof d != "string" ? "".concat(h.slice(0, -1)).concat(d, '"') : d[0] === '"' ? h.slice(0, -1) + d.slice(1) : void 0 : typeof d != "string" || d[0] !== '"' || h instanceof i ? void 0 : '"'.concat(h).concat(d.slice(1));
  }
  function f(h) {
    return JSON.stringify(h).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  }
  n.str = u, n.addCodeArg = c, n.strConcat = function(h, d) {
    return d.emptyStr() ? h : h.emptyStr() ? d : u(I1 || (I1 = ot(["", "", ""])), h, d);
  }, n.stringify = function(h) {
    return new o(f(h));
  }, n.safeStringify = f, n.getProperty = function(h) {
    return typeof h == "string" && n.IDENTIFIER.test(h) ? new o(".".concat(h)) : a(N1 || (N1 = ot(["[", "]"])), h);
  }, n.getEsmExportName = function(h) {
    if (typeof h == "string" && n.IDENTIFIER.test(h))
      return new o("".concat(h));
    throw new Error("CodeGen: invalid export name: ".concat(h, ", use explicit $id name mapping"));
  }, n.regexpCode = function(h) {
    return new o(h.toString());
  };
}, {}], 2: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.or = n.and = n.not = n.CodeGen = n.operators = n.varKinds = n.ValueScopeName = n.ValueScope = n.Scope = n.Name = n.regexpCode = n.stringify = n.getProperty = n.nil = n.strConcat = n.str = n._ = void 0;
  var r = e("./code"), i = e("./scope"), o = e("./code");
  Object.defineProperty(n, "_", { enumerable: !0, get: function() {
    return o._;
  } }), Object.defineProperty(n, "str", { enumerable: !0, get: function() {
    return o.str;
  } }), Object.defineProperty(n, "strConcat", { enumerable: !0, get: function() {
    return o.strConcat;
  } }), Object.defineProperty(n, "nil", { enumerable: !0, get: function() {
    return o.nil;
  } }), Object.defineProperty(n, "getProperty", { enumerable: !0, get: function() {
    return o.getProperty;
  } }), Object.defineProperty(n, "stringify", { enumerable: !0, get: function() {
    return o.stringify;
  } }), Object.defineProperty(n, "regexpCode", { enumerable: !0, get: function() {
    return o.regexpCode;
  } }), Object.defineProperty(n, "Name", { enumerable: !0, get: function() {
    return o.Name;
  } });
  var a = e("./scope");
  Object.defineProperty(n, "Scope", { enumerable: !0, get: function() {
    return a.Scope;
  } }), Object.defineProperty(n, "ValueScope", { enumerable: !0, get: function() {
    return a.ValueScope;
  } }), Object.defineProperty(n, "ValueScopeName", { enumerable: !0, get: function() {
    return a.ValueScopeName;
  } }), Object.defineProperty(n, "varKinds", { enumerable: !0, get: function() {
    return a.varKinds;
  } }), n.operators = { GT: new r._Code(">"), GTE: new r._Code(">="), LT: new r._Code("<"), LTE: new r._Code("<="), EQ: new r._Code("==="), NEQ: new r._Code("!=="), NOT: new r._Code("!"), OR: new r._Code("||"), AND: new r._Code("&&"), ADD: new r._Code("+") };
  var s = function() {
    function B() {
      Z(this, B);
    }
    return Y(B, [{ key: "optimizeNodes", value: function() {
      return this;
    } }, { key: "optimizeNames", value: function(D, _) {
      return this;
    } }]), B;
  }(), u = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L, J, st) {
      var ht;
      return Z(this, _), (ht = D.call(this)).varKind = L, ht.name = J, ht.rhs = st, ht;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = L.es5, st = L._n;
      return "".concat(J ? i.varKinds.var : this.varKind, " ").concat(this.name).concat(this.rhs === void 0 ? "" : " = ".concat(this.rhs), ";") + st;
    } }, { key: "optimizeNames", value: function(L, J) {
      if (L[this.name.str])
        return this.rhs && (this.rhs = H(this.rhs, L, J)), this;
    } }, { key: "names", get: function() {
      return this.rhs instanceof r._CodeOrName ? this.rhs.names : {};
    } }]), _;
  }(s), c = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L, J, st) {
      var ht;
      return Z(this, _), (ht = D.call(this)).lhs = L, ht.rhs = J, ht.sideEffects = st, ht;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = L._n;
      return "".concat(this.lhs, " = ").concat(this.rhs, ";") + J;
    } }, { key: "optimizeNames", value: function(L, J) {
      if (!(this.lhs instanceof r.Name) || L[this.lhs.str] || this.sideEffects)
        return this.rhs = H(this.rhs, L, J), this;
    } }, { key: "names", get: function() {
      return C(this.lhs instanceof r.Name ? {} : Ct({}, this.lhs.names), this.rhs);
    } }]), _;
  }(s), l = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L, J, st, ht) {
      var xt;
      return Z(this, _), (xt = D.call(this, L, st, ht)).op = J, xt;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = L._n;
      return "".concat(this.lhs, " ").concat(this.op, "= ").concat(this.rhs, ";") + J;
    } }]), _;
  }(c), f = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L) {
      var J;
      return Z(this, _), (J = D.call(this)).label = L, J.names = {}, J;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = L._n;
      return "".concat(this.label, ":") + J;
    } }]), _;
  }(s), h = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L) {
      var J;
      return Z(this, _), (J = D.call(this)).label = L, J.names = {}, J;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = L._n;
      return "break".concat(this.label ? " ".concat(this.label) : "", ";") + J;
    } }]), _;
  }(s), d = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L) {
      var J;
      return Z(this, _), (J = D.call(this)).error = L, J;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = L._n;
      return "throw ".concat(this.error, ";") + J;
    } }, { key: "names", get: function() {
      return this.error.names;
    } }]), _;
  }(s), p = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L) {
      var J;
      return Z(this, _), (J = D.call(this)).code = L, J;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = L._n;
      return "".concat(this.code, ";") + J;
    } }, { key: "optimizeNodes", value: function() {
      return "".concat(this.code) ? this : void 0;
    } }, { key: "optimizeNames", value: function(L, J) {
      return this.code = H(this.code, L, J), this;
    } }, { key: "names", get: function() {
      return this.code instanceof r._CodeOrName ? this.code.names : {};
    } }]), _;
  }(s), v = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _() {
      var L, J = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return Z(this, _), (L = D.call(this)).nodes = J, L;
    }
    return Y(_, [{ key: "render", value: function(L) {
      return this.nodes.reduce(function(J, st) {
        return J + st.render(L);
      }, "");
    } }, { key: "optimizeNodes", value: function() {
      for (var L = this.nodes, J = L.length; J--; ) {
        var st = L[J].optimizeNodes();
        Array.isArray(st) ? L.splice.apply(L, [J, 1].concat(Pe(st))) : st ? L[J] = st : L.splice(J, 1);
      }
      return L.length > 0 ? this : void 0;
    } }, { key: "optimizeNames", value: function(L, J) {
      for (var st = this.nodes, ht = st.length; ht--; ) {
        var xt = st[ht];
        xt.optimizeNames(L, J) || (X(L, xt.names), st.splice(ht, 1));
      }
      return st.length > 0 ? this : void 0;
    } }, { key: "names", get: function() {
      return this.nodes.reduce(function(L, J) {
        return E(L, J.names);
      }, {});
    } }]), _;
  }(s), m = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _() {
      return Z(this, _), D.apply(this, arguments);
    }
    return Y(_, [{ key: "render", value: function(L) {
      return "{" + L._n + Je(qe(_.prototype), "render", this).call(this, L) + "}" + L._n;
    } }]), _;
  }(v), g = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _() {
      return Z(this, _), D.apply(this, arguments);
    }
    return Y(_);
  }(v), y = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _() {
      return Z(this, _), D.apply(this, arguments);
    }
    return Y(_);
  }(m);
  y.kind = "else";
  var b = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L, J) {
      var st;
      return Z(this, _), (st = D.call(this, J)).condition = L, st;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = "if(".concat(this.condition, ")") + Je(qe(_.prototype), "render", this).call(this, L);
      return this.else && (J += "else " + this.else.render(L)), J;
    } }, { key: "optimizeNodes", value: function() {
      Je(qe(_.prototype), "optimizeNodes", this).call(this);
      var L = this.condition;
      if (L === !0)
        return this.nodes;
      var J = this.else;
      if (J) {
        var st = J.optimizeNodes();
        J = this.else = Array.isArray(st) ? new y(st) : st;
      }
      return J ? L === !1 ? J instanceof _ ? J : J.nodes : this.nodes.length ? this : new _(F(L), J instanceof _ ? [J] : J.nodes) : L !== !1 && this.nodes.length ? this : void 0;
    } }, { key: "optimizeNames", value: function(L, J) {
      var st;
      if (this.else = (st = this.else) === null || st === void 0 ? void 0 : st.optimizeNames(L, J), Je(qe(_.prototype), "optimizeNames", this).call(this, L, J) || this.else)
        return this.condition = H(this.condition, L, J), this;
    } }, { key: "names", get: function() {
      var L = Je(qe(_.prototype), "names", this);
      return C(L, this.condition), this.else && E(L, this.else.names), L;
    } }]), _;
  }(m);
  b.kind = "if";
  var k = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _() {
      return Z(this, _), D.apply(this, arguments);
    }
    return Y(_);
  }(m);
  k.kind = "for";
  var w = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L) {
      var J;
      return Z(this, _), (J = D.call(this)).iteration = L, J;
    }
    return Y(_, [{ key: "render", value: function(L) {
      return "for(".concat(this.iteration, ")") + Je(qe(_.prototype), "render", this).call(this, L);
    } }, { key: "optimizeNames", value: function(L, J) {
      if (Je(qe(_.prototype), "optimizeNames", this).call(this, L, J))
        return this.iteration = H(this.iteration, L, J), this;
    } }, { key: "names", get: function() {
      return E(Je(qe(_.prototype), "names", this), this.iteration.names);
    } }]), _;
  }(k), x = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L, J, st, ht) {
      var xt;
      return Z(this, _), (xt = D.call(this)).varKind = L, xt.name = J, xt.from = st, xt.to = ht, xt;
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = L.es5 ? i.varKinds.var : this.varKind, st = this.name, ht = this.from, xt = this.to;
      return "for(".concat(J, " ").concat(st, "=").concat(ht, "; ").concat(st, "<").concat(xt, "; ").concat(st, "++)") + Je(qe(_.prototype), "render", this).call(this, L);
    } }, { key: "names", get: function() {
      var L = C(Je(qe(_.prototype), "names", this), this.from);
      return C(L, this.to);
    } }]), _;
  }(k), S = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L, J, st, ht) {
      var xt;
      return Z(this, _), (xt = D.call(this)).loop = L, xt.varKind = J, xt.name = st, xt.iterable = ht, xt;
    }
    return Y(_, [{ key: "render", value: function(L) {
      return "for(".concat(this.varKind, " ").concat(this.name, " ").concat(this.loop, " ").concat(this.iterable, ")") + Je(qe(_.prototype), "render", this).call(this, L);
    } }, { key: "optimizeNames", value: function(L, J) {
      if (Je(qe(_.prototype), "optimizeNames", this).call(this, L, J))
        return this.iterable = H(this.iterable, L, J), this;
    } }, { key: "names", get: function() {
      return E(Je(qe(_.prototype), "names", this), this.iterable.names);
    } }]), _;
  }(k), T = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L, J, st) {
      var ht;
      return Z(this, _), (ht = D.call(this)).name = L, ht.args = J, ht.async = st, ht;
    }
    return Y(_, [{ key: "render", value: function(L) {
      return "".concat(this.async ? "async " : "", "function ").concat(this.name, "(").concat(this.args, ")") + Je(qe(_.prototype), "render", this).call(this, L);
    } }]), _;
  }(m);
  T.kind = "func";
  var P = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _() {
      return Z(this, _), D.apply(this, arguments);
    }
    return Y(_, [{ key: "render", value: function(L) {
      return "return " + Je(qe(_.prototype), "render", this).call(this, L);
    } }]), _;
  }(v);
  P.kind = "return";
  var O = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _() {
      return Z(this, _), D.apply(this, arguments);
    }
    return Y(_, [{ key: "render", value: function(L) {
      var J = "try" + Je(qe(_.prototype), "render", this).call(this, L);
      return this.catch && (J += this.catch.render(L)), this.finally && (J += this.finally.render(L)), J;
    } }, { key: "optimizeNodes", value: function() {
      var L, J;
      return Je(qe(_.prototype), "optimizeNodes", this).call(this), (L = this.catch) === null || L === void 0 || L.optimizeNodes(), (J = this.finally) === null || J === void 0 || J.optimizeNodes(), this;
    } }, { key: "optimizeNames", value: function(L, J) {
      var st, ht;
      return Je(qe(_.prototype), "optimizeNames", this).call(this, L, J), (st = this.catch) === null || st === void 0 || st.optimizeNames(L, J), (ht = this.finally) === null || ht === void 0 || ht.optimizeNames(L, J), this;
    } }, { key: "names", get: function() {
      var L = Je(qe(_.prototype), "names", this);
      return this.catch && E(L, this.catch.names), this.finally && E(L, this.finally.names), L;
    } }]), _;
  }(m), j = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _(L) {
      var J;
      return Z(this, _), (J = D.call(this)).error = L, J;
    }
    return Y(_, [{ key: "render", value: function(L) {
      return "catch(".concat(this.error, ")") + Je(qe(_.prototype), "render", this).call(this, L);
    } }]), _;
  }(m);
  j.kind = "catch";
  var V = function(B) {
    Et(_, B);
    var D = Mt(_);
    function _() {
      return Z(this, _), D.apply(this, arguments);
    }
    return Y(_, [{ key: "render", value: function(L) {
      return "finally" + Je(qe(_.prototype), "render", this).call(this, L);
    } }]), _;
  }(m);
  function E(B, D) {
    for (var _ in D)
      B[_] = (B[_] || 0) + (D[_] || 0);
    return B;
  }
  function C(B, D) {
    return D instanceof r._CodeOrName ? E(B, D.names) : B;
  }
  function H(B, D, _) {
    return B instanceof r.Name ? J(B) : (L = B) instanceof r._Code && L._items.some(function(st) {
      return st instanceof r.Name && D[st.str] === 1 && _[st.str] !== void 0;
    }) ? new r._Code(B._items.reduce(function(st, ht) {
      return ht instanceof r.Name && (ht = J(ht)), ht instanceof r._Code ? st.push.apply(st, Pe(ht._items)) : st.push(ht), st;
    }, [])) : B;
    var L;
    function J(st) {
      var ht = _[st.str];
      return ht === void 0 || D[st.str] !== 1 ? st : (delete D[st.str], ht);
    }
  }
  function X(B, D) {
    for (var _ in D)
      B[_] = (B[_] || 0) - (D[_] || 0);
  }
  function F(B) {
    return typeof B == "boolean" || typeof B == "number" || B === null ? !B : r._(R1 || (R1 = ot(["!", ""])), q(B));
  }
  V.kind = "finally", n.CodeGen = function() {
    function B(D) {
      var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      Z(this, B), this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = Ct(Ct({}, _), {}, { _n: _.lines ? `
` : "" }), this._extScope = D, this._scope = new i.Scope({ parent: D }), this._nodes = [new g()];
    }
    return Y(B, [{ key: "toString", value: function() {
      return this._root.render(this.opts);
    } }, { key: "name", value: function(D) {
      return this._scope.name(D);
    } }, { key: "scopeName", value: function(D) {
      return this._extScope.name(D);
    } }, { key: "scopeValue", value: function(D, _) {
      var L = this._extScope.value(D, _);
      return (this._values[L.prefix] || (this._values[L.prefix] = /* @__PURE__ */ new Set())).add(L), L;
    } }, { key: "getScopeValue", value: function(D, _) {
      return this._extScope.getValue(D, _);
    } }, { key: "scopeRefs", value: function(D) {
      return this._extScope.scopeRefs(D, this._values);
    } }, { key: "scopeCode", value: function() {
      return this._extScope.scopeCode(this._values);
    } }, { key: "_def", value: function(D, _, L, J) {
      var st = this._scope.toName(_);
      return L !== void 0 && J && (this._constants[st.str] = L), this._leafNode(new u(D, st, L)), st;
    } }, { key: "const", value: function(D, _, L) {
      return this._def(i.varKinds.const, D, _, L);
    } }, { key: "let", value: function(D, _, L) {
      return this._def(i.varKinds.let, D, _, L);
    } }, { key: "var", value: function(D, _, L) {
      return this._def(i.varKinds.var, D, _, L);
    } }, { key: "assign", value: function(D, _, L) {
      return this._leafNode(new c(D, _, L));
    } }, { key: "add", value: function(D, _) {
      return this._leafNode(new l(D, n.operators.ADD, _));
    } }, { key: "code", value: function(D) {
      return typeof D == "function" ? D() : D !== r.nil && this._leafNode(new p(D)), this;
    } }, { key: "object", value: function() {
      for (var D = ["{"], _ = arguments.length, L = new Array(_), J = 0; J < _; J++)
        L[J] = arguments[J];
      for (var st = 0, ht = L; st < ht.length; st++) {
        var xt = xe(ht[st], 2), kt = xt[0], I = xt[1];
        D.length > 1 && D.push(","), D.push(kt), (kt !== I || this.opts.es5) && (D.push(":"), (0, r.addCodeArg)(D, I));
      }
      return D.push("}"), new r._Code(D);
    } }, { key: "if", value: function(D, _, L) {
      if (this._blockNode(new b(D)), _ && L)
        this.code(_).else().code(L).endIf();
      else if (_)
        this.code(_).endIf();
      else if (L)
        throw new Error('CodeGen: "else" body without "then" body');
      return this;
    } }, { key: "elseIf", value: function(D) {
      return this._elseNode(new b(D));
    } }, { key: "else", value: function() {
      return this._elseNode(new y());
    } }, { key: "endIf", value: function() {
      return this._endBlockNode(b, y);
    } }, { key: "_for", value: function(D, _) {
      return this._blockNode(D), _ && this.code(_).endFor(), this;
    } }, { key: "for", value: function(D, _) {
      return this._for(new w(D), _);
    } }, { key: "forRange", value: function(D, _, L, J) {
      var st = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.opts.es5 ? i.varKinds.var : i.varKinds.let, ht = this._scope.toName(D);
      return this._for(new x(st, ht, _, L), function() {
        return J(ht);
      });
    } }, { key: "forOf", value: function(D, _, L) {
      var J = this, st = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : i.varKinds.const, ht = this._scope.toName(D);
      if (this.opts.es5) {
        var xt = _ instanceof r.Name ? _ : this.var("_arr", _);
        return this.forRange("_i", 0, r._(D1 || (D1 = ot(["", ".length"])), xt), function(kt) {
          J.var(ht, r._(L1 || (L1 = ot(["", "[", "]"])), xt, kt)), L(ht);
        });
      }
      return this._for(new S("of", st, ht, _), function() {
        return L(ht);
      });
    } }, { key: "forIn", value: function(D, _, L) {
      var J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this.opts.es5 ? i.varKinds.var : i.varKinds.const;
      if (this.opts.ownProperties)
        return this.forOf(D, r._(z1 || (z1 = ot(["Object.keys(", ")"])), _), L);
      var st = this._scope.toName(D);
      return this._for(new S("in", J, st, _), function() {
        return L(st);
      });
    } }, { key: "endFor", value: function() {
      return this._endBlockNode(k);
    } }, { key: "label", value: function(D) {
      return this._leafNode(new f(D));
    } }, { key: "break", value: function(D) {
      return this._leafNode(new h(D));
    } }, { key: "return", value: function(D) {
      var _ = new P();
      if (this._blockNode(_), this.code(D), _.nodes.length !== 1)
        throw new Error('CodeGen: "return" should have one node');
      return this._endBlockNode(P);
    } }, { key: "try", value: function(D, _, L) {
      if (!_ && !L)
        throw new Error('CodeGen: "try" without "catch" and "finally"');
      var J = new O();
      if (this._blockNode(J), this.code(D), _) {
        var st = this.name("e");
        this._currNode = J.catch = new j(st), _(st);
      }
      return L && (this._currNode = J.finally = new V(), this.code(L)), this._endBlockNode(j, V);
    } }, { key: "throw", value: function(D) {
      return this._leafNode(new d(D));
    } }, { key: "block", value: function(D, _) {
      return this._blockStarts.push(this._nodes.length), D && this.code(D).endBlock(_), this;
    } }, { key: "endBlock", value: function(D) {
      var _ = this._blockStarts.pop();
      if (_ === void 0)
        throw new Error("CodeGen: not in self-balancing block");
      var L = this._nodes.length - _;
      if (L < 0 || D !== void 0 && L !== D)
        throw new Error("CodeGen: wrong number of nodes: ".concat(L, " vs ").concat(D, " expected"));
      return this._nodes.length = _, this;
    } }, { key: "func", value: function(D) {
      var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r.nil, L = arguments.length > 2 ? arguments[2] : void 0, J = arguments.length > 3 ? arguments[3] : void 0;
      return this._blockNode(new T(D, _, L)), J && this.code(J).endFunc(), this;
    } }, { key: "endFunc", value: function() {
      return this._endBlockNode(T);
    } }, { key: "optimize", value: function() {
      for (var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1; D-- > 0; )
        this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
    } }, { key: "_leafNode", value: function(D) {
      return this._currNode.nodes.push(D), this;
    } }, { key: "_blockNode", value: function(D) {
      this._currNode.nodes.push(D), this._nodes.push(D);
    } }, { key: "_endBlockNode", value: function(D, _) {
      var L = this._currNode;
      if (L instanceof D || _ && L instanceof _)
        return this._nodes.pop(), this;
      throw new Error('CodeGen: not in block "'.concat(_ ? "".concat(D.kind, "/").concat(_.kind) : D.kind, '"'));
    } }, { key: "_elseNode", value: function(D) {
      var _ = this._currNode;
      if (!(_ instanceof b))
        throw new Error('CodeGen: "else" without "if"');
      return this._currNode = _.else = D, this;
    } }, { key: "_root", get: function() {
      return this._nodes[0];
    } }, { key: "_currNode", get: function() {
      var D = this._nodes;
      return D[D.length - 1];
    }, set: function(D) {
      var _ = this._nodes;
      _[_.length - 1] = D;
    } }]), B;
  }(), n.not = F;
  var G = $(n.operators.AND);
  n.and = function() {
    for (var B = arguments.length, D = new Array(B), _ = 0; _ < B; _++)
      D[_] = arguments[_];
    return D.reduce(G);
  };
  var M = $(n.operators.OR);
  function $(B) {
    return function(D, _) {
      return D === r.nil ? _ : _ === r.nil ? D : r._(B1 || (B1 = ot(["", " ", " ", ""])), q(D), B, q(_));
    };
  }
  function q(B) {
    return B instanceof r.Name ? B : r._(F1 || (F1 = ot(["(", ")"])), B);
  }
  n.or = function() {
    for (var B = arguments.length, D = new Array(B), _ = 0; _ < B; _++)
      D[_] = arguments[_];
    return D.reduce(M);
  };
}, { "./code": 1, "./scope": 3 }], 3: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.ValueScope = n.ValueScopeName = n.Scope = n.varKinds = n.UsedValueState = void 0;
  var r, i = e("./code"), o = function(c) {
    Et(f, Xl(Error));
    var l = Mt(f);
    function f(h) {
      var d;
      return Z(this, f), (d = l.call(this, 'CodeGen: "code" for '.concat(h, " not defined"))).value = h.value, d;
    }
    return Y(f);
  }();
  (function(c) {
    c[c.Started = 0] = "Started", c[c.Completed = 1] = "Completed";
  })(r = n.UsedValueState || (n.UsedValueState = {})), n.varKinds = { const: new i.Name("const"), let: new i.Name("let"), var: new i.Name("var") };
  var a = function() {
    function c() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = l.prefixes, h = l.parent;
      Z(this, c), this._names = {}, this._prefixes = f, this._parent = h;
    }
    return Y(c, [{ key: "toName", value: function(l) {
      return l instanceof i.Name ? l : this.name(l);
    } }, { key: "name", value: function(l) {
      return new i.Name(this._newName(l));
    } }, { key: "_newName", value: function(l) {
      return "".concat(l).concat((this._names[l] || this._nameGroup(l)).index++);
    } }, { key: "_nameGroup", value: function(l) {
      var f, h;
      if (((h = (f = this._parent) === null || f === void 0 ? void 0 : f._prefixes) === null || h === void 0 ? void 0 : h.has(l)) || this._prefixes && !this._prefixes.has(l))
        throw new Error('CodeGen: prefix "'.concat(l, '" is not allowed in this scope'));
      return this._names[l] = { prefix: l, index: 0 };
    } }]), c;
  }();
  n.Scope = a;
  var s = function(c) {
    Et(f, c);
    var l = Mt(f);
    function f(h, d) {
      var p;
      return Z(this, f), (p = l.call(this, d)).prefix = h, p;
    }
    return Y(f, [{ key: "setValue", value: function(h, d) {
      var p = d.property, v = d.itemIndex;
      this.value = h, this.scopePath = i._(q1 || (q1 = ot([".", "[", "]"])), new i.Name(p), v);
    } }]), f;
  }(i.Name);
  n.ValueScopeName = s;
  var u = i._(V1 || (V1 = ot([`
`], ["\\n"])));
  n.ValueScope = function(c) {
    Et(f, c);
    var l = Mt(f);
    function f(h) {
      var d;
      return Z(this, f), (d = l.call(this, h))._values = {}, d._scope = h.scope, d.opts = Ct(Ct({}, h), {}, { _n: h.lines ? u : i.nil }), d;
    }
    return Y(f, [{ key: "get", value: function() {
      return this._scope;
    } }, { key: "name", value: function(h) {
      return new s(h, this._newName(h));
    } }, { key: "value", value: function(h, d) {
      var p;
      if (d.ref === void 0)
        throw new Error("CodeGen: ref must be passed in value");
      var v = this.toName(h), m = v.prefix, g = (p = d.key) !== null && p !== void 0 ? p : d.ref, y = this._values[m];
      if (y) {
        var b = y.get(g);
        if (b)
          return b;
      } else
        y = this._values[m] = /* @__PURE__ */ new Map();
      y.set(g, v);
      var k = this._scope[m] || (this._scope[m] = []), w = k.length;
      return k[w] = d.ref, v.setValue(d, { property: m, itemIndex: w }), v;
    } }, { key: "getValue", value: function(h, d) {
      var p = this._values[h];
      if (p)
        return p.get(d);
    } }, { key: "scopeRefs", value: function(h) {
      var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._values;
      return this._reduceValues(d, function(p) {
        if (p.scopePath === void 0)
          throw new Error('CodeGen: name "'.concat(p, '" has no value'));
        return i._(H1 || (H1 = ot(["", "", ""])), h, p.scopePath);
      });
    } }, { key: "scopeCode", value: function() {
      var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._values, d = arguments.length > 1 ? arguments[1] : void 0, p = arguments.length > 2 ? arguments[2] : void 0;
      return this._reduceValues(h, function(v) {
        if (v.value === void 0)
          throw new Error('CodeGen: name "'.concat(v, '" has no value'));
        return v.value.code;
      }, d, p);
    } }, { key: "_reduceValues", value: function(h, d) {
      var p = this, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, m = arguments.length > 3 ? arguments[3] : void 0, g = i.nil, y = function(k) {
        var w = h[k];
        if (!w)
          return "continue";
        var x = v[k] = v[k] || /* @__PURE__ */ new Map();
        w.forEach(function(S) {
          if (!x.has(S)) {
            x.set(S, r.Started);
            var T = d(S);
            if (T)
              g = i._(W1 || (W1 = ot(["", "", " ", " = ", ";", ""])), g, p.opts.es5 ? n.varKinds.var : n.varKinds.const, S, T, p.opts._n);
            else {
              if (!(T = m == null ? void 0 : m(S)))
                throw new o(S);
              g = i._(U1 || (U1 = ot(["", "", "", ""])), g, T, p.opts._n);
            }
            x.set(S, r.Completed);
          }
        });
      };
      for (var b in h)
        y(b);
      return g;
    } }]), f;
  }(a);
}, { "./code": 1 }], 4: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.extendErrors = n.resetErrorsCount = n.reportExtraError = n.reportError = n.keyword$DataError = n.keywordError = void 0;
  var r = e("./codegen"), i = e("./util"), o = e("./names");
  function a(h, d) {
    var p = h.const("err", d);
    h.if(r._(J1 || (J1 = ot(["", " === null"])), o.default.vErrors), function() {
      return h.assign(o.default.vErrors, r._(K1 || (K1 = ot(["[", "]"])), p));
    }, r._(G1 || (G1 = ot(["", ".push(", ")"])), o.default.vErrors, p)), h.code(r._(Q1 || (Q1 = ot(["", "++"])), o.default.errors));
  }
  function s(h, d) {
    var p = h.gen, v = h.validateName;
    h.schemaEnv.$async ? p.throw(r._(X1 || (X1 = ot(["new ", "(", ")"])), h.ValidationError, d)) : (p.assign(r._(Z1 || (Z1 = ot(["", ".errors"])), v), d), p.return(!1));
  }
  n.keywordError = { message: function(h) {
    var d = h.keyword;
    return r.str(Y1 || (Y1 = ot(['must pass "', '" keyword validation'])), d);
  } }, n.keyword$DataError = { message: function(h) {
    var d = h.keyword, p = h.schemaType;
    return p ? r.str(ty || (ty = ot(['"', '" keyword must be ', " ($data)"])), d, p) : r.str(ey || (ey = ot(['"', '" keyword is invalid ($data)'])), d);
  } }, n.reportError = function(h) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n.keywordError, p = arguments.length > 2 ? arguments[2] : void 0, v = arguments.length > 3 ? arguments[3] : void 0, m = h.it, g = m.gen, y = m.compositeRule, b = m.allErrors, k = c(h, d, p);
    (v != null ? v : y || b) ? a(g, k) : s(m, r._(ny || (ny = ot(["[", "]"])), k));
  }, n.reportExtraError = function(h) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n.keywordError, p = arguments.length > 2 ? arguments[2] : void 0, v = h.it, m = v.gen, g = v.compositeRule, y = v.allErrors;
    a(m, c(h, d, p)), g || y || s(v, o.default.vErrors);
  }, n.resetErrorsCount = function(h, d) {
    h.assign(o.default.errors, d), h.if(r._(ry || (ry = ot(["", " !== null"])), o.default.vErrors), function() {
      return h.if(d, function() {
        return h.assign(r._(iy || (iy = ot(["", ".length"])), o.default.vErrors), d);
      }, function() {
        return h.assign(o.default.vErrors, null);
      });
    });
  }, n.extendErrors = function(h) {
    var d = h.gen, p = h.keyword, v = h.schemaValue, m = h.data, g = h.errsCount, y = h.it;
    if (g === void 0)
      throw new Error("ajv implementation error");
    var b = d.name("err");
    d.forRange("i", g, o.default.errors, function(k) {
      d.const(b, r._(oy || (oy = ot(["", "[", "]"])), o.default.vErrors, k)), d.if(r._(ay || (ay = ot(["", ".instancePath === undefined"])), b), function() {
        return d.assign(r._(sy || (sy = ot(["", ".instancePath"])), b), (0, r.strConcat)(o.default.instancePath, y.errorPath));
      }), d.assign(r._(uy || (uy = ot(["", ".schemaPath"])), b), r.str(cy || (cy = ot(["", "/", ""])), y.errSchemaPath, p)), y.opts.verbose && (d.assign(r._(ly || (ly = ot(["", ".schema"])), b), v), d.assign(r._(fy || (fy = ot(["", ".data"])), b), m));
    });
  };
  var u = { keyword: new r.Name("keyword"), schemaPath: new r.Name("schemaPath"), params: new r.Name("params"), propertyName: new r.Name("propertyName"), message: new r.Name("message"), schema: new r.Name("schema"), parentSchema: new r.Name("parentSchema") };
  function c(h, d, p) {
    return h.it.createErrors === !1 ? r._(hy || (hy = ot(["{}"]))) : function(v, m) {
      var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, y = v.gen, b = [l(v.it, g), f(v, g)];
      return function(k, w, x) {
        var S = w.params, T = w.message, P = k.keyword, O = k.data, j = k.schemaValue, V = k.it, E = V.opts, C = V.propertyName, H = V.topSchemaRef, X = V.schemaPath;
        x.push([u.keyword, P], [u.params, typeof S == "function" ? S(k) : S || r._(dy || (dy = ot(["{}"])))]), E.messages && x.push([u.message, typeof T == "function" ? T(k) : T]), E.verbose && x.push([u.schema, j], [u.parentSchema, r._(vy || (vy = ot(["", "", ""])), H, X)], [o.default.data, O]), C && x.push([u.propertyName, C]);
      }(v, m, b), y.object.apply(y, b);
    }(h, d, p);
  }
  function l(h, d) {
    var p = h.errorPath, v = d.instancePath, m = v ? r.str(py || (py = ot(["", "", ""])), p, (0, i.getErrorPath)(v, i.Type.Str)) : p;
    return [o.default.instancePath, (0, r.strConcat)(o.default.instancePath, m)];
  }
  function f(h, d) {
    var p = h.keyword, v = h.it.errSchemaPath, m = d.schemaPath, g = d.parentSchema ? v : r.str(my || (my = ot(["", "/", ""])), v, p);
    return m && (g = r.str(gy || (gy = ot(["", "", ""])), g, (0, i.getErrorPath)(m, i.Type.Str))), [u.schemaPath, g];
  }
}, { "./codegen": 2, "./names": 6, "./util": 10 }], 5: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.resolveSchema = n.getCompilingSchema = n.resolveRef = n.compileSchema = n.SchemaEnv = void 0;
  var r = e("./codegen"), i = e("../runtime/validation_error"), o = e("./names"), a = e("./resolve"), s = e("./util"), u = e("./validate"), c = Y(function g(y) {
    var b, k;
    Z(this, g), this.refs = {}, this.dynamicAnchors = {}, ne(y.schema) == "object" && (k = y.schema), this.schema = y.schema, this.schemaId = y.schemaId, this.root = y.root || this, this.baseId = (b = y.baseId) !== null && b !== void 0 ? b : (0, a.normalizeId)(k == null ? void 0 : k[y.schemaId || "$id"]), this.schemaPath = y.schemaPath, this.localRefs = y.localRefs, this.meta = y.meta, this.$async = k == null ? void 0 : k.$async, this.refs = {};
  });
  function l(g) {
    var y = h.call(this, g);
    if (y)
      return y;
    var b, k = (0, a.getFullPath)(this.opts.uriResolver, g.root.baseId), w = this.opts.code, x = w.es5, S = w.lines, T = this.opts.ownProperties, P = new r.CodeGen(this.scope, { es5: x, lines: S, ownProperties: T });
    g.$async && (b = P.scopeValue("Error", { ref: i.default, code: r._(yy || (yy = ot(['require("ajv/dist/runtime/validation_error").default']))) }));
    var O = P.scopeName("validate");
    g.validateName = O;
    var j, V = { gen: P, allErrors: this.opts.allErrors, data: o.default.data, parentData: o.default.parentData, parentDataProperty: o.default.parentDataProperty, dataNames: [o.default.data], dataPathArr: [r.nil], dataLevel: 0, dataTypes: [], definedProperties: /* @__PURE__ */ new Set(), topSchemaRef: P.scopeValue("schema", this.opts.code.source === !0 ? { ref: g.schema, code: (0, r.stringify)(g.schema) } : { ref: g.schema }), validateName: O, ValidationError: b, schema: g.schema, schemaEnv: g, rootId: k, baseId: g.baseId || k, schemaPath: r.nil, errSchemaPath: g.schemaPath || (this.opts.jtd ? "" : "#"), errorPath: r._(by || (by = ot(['""']))), opts: this.opts, self: this };
    try {
      this._compilations.add(g), (0, u.validateFunctionCode)(V), P.optimize(this.opts.code.optimize);
      var E = P.toString();
      j = "".concat(P.scopeRefs(o.default.scope), "return ").concat(E), this.opts.code.process && (j = this.opts.code.process(j, g));
      var C = new Function("".concat(o.default.self), "".concat(o.default.scope), j)(this, this.scope.get());
      if (this.scope.value(O, { ref: C }), C.errors = null, C.schema = g.schema, C.schemaEnv = g, g.$async && (C.$async = !0), this.opts.code.source === !0 && (C.source = { validateName: O, validateCode: E, scopeValues: P._values }), this.opts.unevaluated) {
        var H = V.props, X = V.items;
        C.evaluated = { props: H instanceof r.Name ? void 0 : H, items: X instanceof r.Name ? void 0 : X, dynamicProps: H instanceof r.Name, dynamicItems: X instanceof r.Name }, C.source && (C.source.evaluated = (0, r.stringify)(C.evaluated));
      }
      return g.validate = C, g;
    } catch (F) {
      throw delete g.validate, delete g.validateName, j && this.logger.error("Error compiling schema, function code:", j), F;
    } finally {
      this._compilations.delete(g);
    }
  }
  function f(g) {
    return (0, a.inlineRef)(g.schema, this.opts.inlineRefs) ? g.schema : g.validate ? g : l.call(this, g);
  }
  function h(g) {
    var y, b, k, w = ut(this._compilations);
    try {
      for (w.s(); !(y = w.n()).done; ) {
        var x = y.value;
        if ((b = x).schema === (k = g).schema && b.root === k.root && b.baseId === k.baseId)
          return x;
      }
    } catch (S) {
      w.e(S);
    } finally {
      w.f();
    }
  }
  function d(g, y) {
    for (var b; typeof (b = this.refs[y]) == "string"; )
      y = b;
    return b || this.schemas[y] || p.call(this, g, y);
  }
  function p(g, y) {
    var b = this.opts.uriResolver.parse(y), k = (0, a._getFullPath)(this.opts.uriResolver, b), w = (0, a.getFullPath)(this.opts.uriResolver, g.baseId, void 0);
    if (Object.keys(g.schema).length > 0 && k === w)
      return m.call(this, b, g);
    var x = (0, a.normalizeId)(k), S = this.refs[x] || this.schemas[x];
    if (typeof S == "string") {
      var T = p.call(this, g, S);
      return ne(T == null ? void 0 : T.schema) != "object" ? void 0 : m.call(this, b, T);
    }
    if (ne(S == null ? void 0 : S.schema) == "object") {
      if (S.validate || l.call(this, S), x === (0, a.normalizeId)(y)) {
        var P = S.schema, O = this.opts.schemaId, j = P[O];
        return j && (w = (0, a.resolveUrl)(this.opts.uriResolver, w, j)), new c({ schema: P, schemaId: O, root: g, baseId: w });
      }
      return m.call(this, b, S);
    }
  }
  n.SchemaEnv = c, n.compileSchema = l, n.resolveRef = function(g, y, b) {
    var k;
    b = (0, a.resolveUrl)(this.opts.uriResolver, y, b);
    var w = g.refs[b];
    if (w)
      return w;
    var x = d.call(this, g, b);
    if (x === void 0) {
      var S = (k = g.localRefs) === null || k === void 0 ? void 0 : k[b], T = this.opts.schemaId;
      S && (x = new c({ schema: S, schemaId: T, root: g, baseId: y }));
    }
    return x !== void 0 ? g.refs[b] = f.call(this, x) : void 0;
  }, n.getCompilingSchema = h, n.resolveSchema = p;
  var v = /* @__PURE__ */ new Set(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
  function m(g, y) {
    var b, k = y.baseId, w = y.schema, x = y.root;
    if (((b = g.fragment) === null || b === void 0 ? void 0 : b[0]) === "/") {
      var S, T, P = ut(g.fragment.slice(1).split("/"));
      try {
        for (P.s(); !(S = P.n()).done; ) {
          var O = S.value;
          if (typeof w == "boolean")
            return;
          var j = w[(0, s.unescapeFragment)(O)];
          if (j === void 0)
            return;
          var V = ne(w = j) == "object" && w[this.opts.schemaId];
          !v.has(O) && V && (k = (0, a.resolveUrl)(this.opts.uriResolver, k, V));
        }
      } catch (H) {
        P.e(H);
      } finally {
        P.f();
      }
      if (typeof w != "boolean" && w.$ref && !(0, s.schemaHasRulesButRef)(w, this.RULES)) {
        var E = (0, a.resolveUrl)(this.opts.uriResolver, k, w.$ref);
        T = p.call(this, x, E);
      }
      var C = this.opts.schemaId;
      return (T = T || new c({ schema: w, schemaId: C, root: x, baseId: k })).schema !== T.root.schema ? T : void 0;
    }
  }
}, { "../runtime/validation_error": 24, "./codegen": 2, "./names": 6, "./resolve": 8, "./util": 10, "./validate": 15 }], 6: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("./codegen"), i = { data: new r.Name("data"), valCxt: new r.Name("valCxt"), instancePath: new r.Name("instancePath"), parentData: new r.Name("parentData"), parentDataProperty: new r.Name("parentDataProperty"), rootData: new r.Name("rootData"), dynamicAnchors: new r.Name("dynamicAnchors"), vErrors: new r.Name("vErrors"), errors: new r.Name("errors"), this: new r.Name("this"), self: new r.Name("self"), scope: new r.Name("scope"), json: new r.Name("json"), jsonPos: new r.Name("jsonPos"), jsonLen: new r.Name("jsonLen"), jsonPart: new r.Name("jsonPart") };
  n.default = i;
}, { "./codegen": 2 }], 7: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("./resolve"), i = function(o) {
    Et(s, Xl(Error));
    var a = Mt(s);
    function s(u, c, l, f) {
      var h;
      return Z(this, s), (h = a.call(this, f || "can't resolve reference ".concat(l, " from id ").concat(c))).missingRef = (0, r.resolveUrl)(u, c, l), h.missingSchema = (0, r.normalizeId)((0, r.getFullPath)(u, h.missingRef)), h;
    }
    return Y(s);
  }();
  n.default = i;
}, { "./resolve": 8 }], 8: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.getSchemaRefs = n.resolveUrl = n.normalizeId = n._getFullPath = n.getFullPath = n.inlineRef = void 0;
  var r = e("./util"), i = e("fast-deep-equal"), o = e("json-schema-traverse"), a = /* @__PURE__ */ new Set(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum", "const"]);
  n.inlineRef = function(v) {
    var m = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
    return typeof v == "boolean" || (m === !0 ? !u(v) : !!m && c(v) <= m);
  };
  var s = /* @__PURE__ */ new Set(["$ref", "$recursiveRef", "$recursiveAnchor", "$dynamicRef", "$dynamicAnchor"]);
  function u(v) {
    for (var m in v) {
      if (s.has(m))
        return !0;
      var g = v[m];
      if (Array.isArray(g) && g.some(u) || ne(g) == "object" && u(g))
        return !0;
    }
    return !1;
  }
  function c(v) {
    var m = 0;
    for (var g in v)
      if (g === "$ref" || (m++, !a.has(g) && (ne(v[g]) == "object" && (0, r.eachItem)(v[g], function(y) {
        return m += c(y);
      }), 1 / 0 === m)))
        return 1 / 0;
    return m;
  }
  function l(v) {
    var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (arguments.length > 2 ? arguments[2] : void 0) !== !1 && (m = d(m));
    var g = v.parse(m);
    return f(v, g);
  }
  function f(v, m) {
    return v.serialize(m).split("#")[0] + "#";
  }
  n.getFullPath = l, n._getFullPath = f;
  var h = /#\/?$/;
  function d(v) {
    return v ? v.replace(h, "") : "";
  }
  n.normalizeId = d, n.resolveUrl = function(v, m, g) {
    return g = d(g), v.resolve(m, g);
  };
  var p = /^[a-z_][-a-z0-9._]*$/i;
  n.getSchemaRefs = function(v, m) {
    var g = this;
    if (typeof v == "boolean")
      return {};
    var y = this.opts, b = y.schemaId, k = y.uriResolver, w = d(v[b] || m), x = { "": w }, S = l(k, w, !1), T = {}, P = /* @__PURE__ */ new Set();
    return o(v, { allKeys: !0 }, function(V, E, C, H) {
      if (H !== void 0) {
        var X = S + E, F = x[H];
        typeof V[b] == "string" && (F = G.call(g, V[b])), M.call(g, V.$anchor), M.call(g, V.$dynamicAnchor), x[E] = F;
      }
      function G($) {
        if ($ = d(F ? (0, this.opts.uriResolver.resolve)(F, $) : $), P.has($))
          throw j($);
        P.add($);
        var q = this.refs[$];
        return typeof q == "string" && (q = this.refs[q]), ne(q) == "object" ? O(V, q.schema, $) : $ !== d(X) && ($[0] === "#" ? (O(V, T[$], $), T[$] = V) : this.refs[$] = X), $;
      }
      function M($) {
        if (typeof $ == "string") {
          if (!p.test($))
            throw new Error('invalid anchor "'.concat($, '"'));
          G.call(this, "#".concat($));
        }
      }
    }), T;
    function O(V, E, C) {
      if (E !== void 0 && !i(V, E))
        throw j(C);
    }
    function j(V) {
      return new Error('reference "'.concat(V, '" resolves to more than one schema'));
    }
  };
}, { "./util": 10, "fast-deep-equal": 63, "json-schema-traverse": 64 }], 9: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.getRules = n.isJSONType = void 0;
  var r = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null", "object", "array"]);
  n.isJSONType = function(i) {
    return typeof i == "string" && r.has(i);
  }, n.getRules = function() {
    var i = { number: { type: "number", rules: [] }, string: { type: "string", rules: [] }, array: { type: "array", rules: [] }, object: { type: "object", rules: [] } };
    return { types: Ct(Ct({}, i), {}, { integer: !0, boolean: !0, null: !0 }), rules: [{ rules: [] }, i.number, i.string, i.array, i.object], post: { rules: [] }, all: {}, keywords: {} };
  };
}, {}], 10: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.checkStrictMode = n.getErrorPath = n.Type = n.useFunc = n.setEvaluated = n.evaluatedPropsToName = n.mergeEvaluated = n.eachItem = n.unescapeJsonPointer = n.escapeJsonPointer = n.escapeFragment = n.unescapeFragment = n.schemaRefOrVal = n.schemaHasRulesButRef = n.schemaHasRules = n.checkUnknownRules = n.alwaysValidSchema = n.toHash = void 0;
  var r = e("./codegen"), i = e("./codegen/code");
  function o(v) {
    var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : v.schema, g = v.opts, y = v.self;
    if (g.strictSchema && typeof m != "boolean") {
      var b = y.RULES.keywords;
      for (var k in m)
        b[k] || p(v, 'unknown keyword: "'.concat(k, '"'));
    }
  }
  function a(v, m) {
    if (typeof v == "boolean")
      return !v;
    for (var g in v)
      if (m[g])
        return !0;
    return !1;
  }
  function s(v) {
    return typeof v == "number" ? "".concat(v) : v.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  function u(v) {
    return v.replace(/~1/g, "/").replace(/~0/g, "~");
  }
  function c(v) {
    var m = v.mergeNames, g = v.mergeToName, y = v.mergeValues, b = v.resultToName;
    return function(k, w, x, S) {
      var T = x === void 0 ? w : x instanceof r.Name ? (w instanceof r.Name ? m(k, w, x) : g(k, w, x), x) : w instanceof r.Name ? (g(k, x, w), w) : y(w, x);
      return S !== r.Name || T instanceof r.Name ? T : b(k, T);
    };
  }
  function l(v, m) {
    if (m === !0)
      return v.var("props", !0);
    var g = v.var("props", r._(ky || (ky = ot(["{}"]))));
    return m !== void 0 && f(v, g, m), g;
  }
  function f(v, m, g) {
    Object.keys(g).forEach(function(y) {
      return v.assign(r._(wy || (wy = ot(["", "", ""])), m, (0, r.getProperty)(y)), !0);
    });
  }
  n.toHash = function(v) {
    var m, g = {}, y = ut(v);
    try {
      for (y.s(); !(m = y.n()).done; )
        g[m.value] = !0;
    } catch (b) {
      y.e(b);
    } finally {
      y.f();
    }
    return g;
  }, n.alwaysValidSchema = function(v, m) {
    return typeof m == "boolean" ? m : Object.keys(m).length === 0 || (o(v, m), !a(m, v.self.RULES.all));
  }, n.checkUnknownRules = o, n.schemaHasRules = a, n.schemaHasRulesButRef = function(v, m) {
    if (typeof v == "boolean")
      return !v;
    for (var g in v)
      if (g !== "$ref" && m.all[g])
        return !0;
    return !1;
  }, n.schemaRefOrVal = function(v, m, g, y) {
    var b = v.topSchemaRef, k = v.schemaPath;
    if (!y) {
      if (typeof m == "number" || typeof m == "boolean")
        return m;
      if (typeof m == "string")
        return r._(xy || (xy = ot(["", ""])), m);
    }
    return r._(jy || (jy = ot(["", "", "", ""])), b, k, (0, r.getProperty)(g));
  }, n.unescapeFragment = function(v) {
    return u(decodeURIComponent(v));
  }, n.escapeFragment = function(v) {
    return encodeURIComponent(s(v));
  }, n.escapeJsonPointer = s, n.unescapeJsonPointer = u, n.eachItem = function(v, m) {
    if (Array.isArray(v)) {
      var g, y = ut(v);
      try {
        for (y.s(); !(g = y.n()).done; )
          m(g.value);
      } catch (b) {
        y.e(b);
      } finally {
        y.f();
      }
    } else
      m(v);
  }, n.mergeEvaluated = { props: c({ mergeNames: function(v, m, g) {
    return v.if(r._(Sy || (Sy = ot(["", " !== true && ", " !== undefined"])), g, m), function() {
      v.if(r._($y || ($y = ot(["", " === true"])), m), function() {
        return v.assign(g, !0);
      }, function() {
        return v.assign(g, r._(_y || (_y = ot(["", " || {}"])), g)).code(r._(Cy || (Cy = ot(["Object.assign(", ", ", ")"])), g, m));
      });
    });
  }, mergeToName: function(v, m, g) {
    return v.if(r._(Oy || (Oy = ot(["", " !== true"])), g), function() {
      m === !0 ? v.assign(g, !0) : (v.assign(g, r._(Ay || (Ay = ot(["", " || {}"])), g)), f(v, g, m));
    });
  }, mergeValues: function(v, m) {
    return v === !0 || Ct(Ct({}, v), m);
  }, resultToName: l }), items: c({ mergeNames: function(v, m, g) {
    return v.if(r._(Py || (Py = ot(["", " !== true && ", " !== undefined"])), g, m), function() {
      return v.assign(g, r._(Ey || (Ey = ot(["", " === true ? true : ", " > ", " ? ", " : ", ""])), m, g, m, g, m));
    });
  }, mergeToName: function(v, m, g) {
    return v.if(r._(My || (My = ot(["", " !== true"])), g), function() {
      return v.assign(g, m === !0 || r._(Ty || (Ty = ot(["", " > ", " ? ", " : ", ""])), g, m, g, m));
    });
  }, mergeValues: function(v, m) {
    return v === !0 || Math.max(v, m);
  }, resultToName: function(v, m) {
    return v.var("items", m);
  } }) }, n.evaluatedPropsToName = l, n.setEvaluated = f;
  var h, d = {};
  function p(v, m) {
    var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : v.opts.strictSchema;
    if (g) {
      if (m = "strict mode: ".concat(m), g === !0)
        throw new Error(m);
      v.self.logger.warn(m);
    }
  }
  n.useFunc = function(v, m) {
    return v.scopeValue("func", { ref: m, code: d[m.code] || (d[m.code] = new i._Code(m.code)) });
  }, function(v) {
    v[v.Num = 0] = "Num", v[v.Str = 1] = "Str";
  }(h = n.Type || (n.Type = {})), n.getErrorPath = function(v, m, g) {
    if (v instanceof r.Name) {
      var y = m === h.Num;
      return g ? y ? r._(Iy || (Iy = ot(['"[" + ', ' + "]"'])), v) : r._(Ny || (Ny = ot([`"['" + `, ` + "']"`])), v) : y ? r._(Ry || (Ry = ot(['"/" + ', ""])), v) : r._(Dy || (Dy = ot(['"/" + ', '.replace(/~/g, "~0").replace(/\\//g, "~1")'], ['"/" + ', '.replace(/~/g, "~0").replace(/\\\\//g, "~1")'])), v);
    }
    return g ? (0, r.getProperty)(v).toString() : "/" + s(v);
  }, n.checkStrictMode = p;
}, { "./codegen": 2, "./codegen/code": 1 }], 11: [function(e, t, n) {
  function r(o, a) {
    return a.rules.some(function(s) {
      return i(o, s);
    });
  }
  function i(o, a) {
    var s;
    return o[a.keyword] !== void 0 || ((s = a.definition.implements) === null || s === void 0 ? void 0 : s.some(function(u) {
      return o[u] !== void 0;
    }));
  }
  Object.defineProperty(n, "__esModule", { value: !0 }), n.shouldUseRule = n.shouldUseGroup = n.schemaHasRulesForType = void 0, n.schemaHasRulesForType = function(o, a) {
    var s = o.schema, u = o.self.RULES.types[a];
    return u && u !== !0 && r(s, u);
  }, n.shouldUseGroup = r, n.shouldUseRule = i;
}, {}], 12: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.boolOrEmptySchema = n.topBoolOrEmptySchema = void 0;
  var r = e("../errors"), i = e("../codegen"), o = e("../names"), a = { message: "boolean schema is false" };
  function s(u, c) {
    var l = u.gen, f = u.data;
    (0, r.reportError)({ gen: l, keyword: "false schema", data: f, schema: !1, schemaCode: !1, schemaValue: !1, params: {}, it: u }, a, void 0, c);
  }
  n.topBoolOrEmptySchema = function(u) {
    var c = u.gen, l = u.schema, f = u.validateName;
    l === !1 ? s(u, !1) : ne(l) == "object" && l.$async === !0 ? c.return(o.default.data) : (c.assign(i._(Ly || (Ly = ot(["", ".errors"])), f), null), c.return(!0));
  }, n.boolOrEmptySchema = function(u, c) {
    var l = u.gen;
    u.schema === !1 ? (l.var(c, !1), s(u)) : l.var(c, !0);
  };
}, { "../codegen": 2, "../errors": 4, "../names": 6 }], 13: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.reportTypeError = n.checkDataTypes = n.checkDataType = n.coerceAndCheckDataType = n.getJSONTypes = n.getSchemaTypes = n.DataType = void 0;
  var r, i = e("../rules"), o = e("./applicability"), a = e("../errors"), s = e("../codegen"), u = e("../util");
  function c(v) {
    var m = Array.isArray(v) ? v : v ? [v] : [];
    if (m.every(i.isJSONType))
      return m;
    throw new Error("type must be JSONType or JSONType[]: " + m.join(","));
  }
  (function(v) {
    v[v.Correct = 0] = "Correct", v[v.Wrong = 1] = "Wrong";
  })(r = n.DataType || (n.DataType = {})), n.getSchemaTypes = function(v) {
    var m = c(v.type);
    if (m.includes("null")) {
      if (v.nullable === !1)
        throw new Error("type: null contradicts nullable: false");
    } else {
      if (!m.length && v.nullable !== void 0)
        throw new Error('"nullable" cannot be used without "type"');
      v.nullable === !0 && m.push("null");
    }
    return m;
  }, n.getJSONTypes = c, n.coerceAndCheckDataType = function(v, m) {
    var g = v.gen, y = v.data, b = v.opts, k = function(S, T) {
      return T ? S.filter(function(P) {
        return l.has(P) || T === "array" && P === "array";
      }) : [];
    }(m, b.coerceTypes), w = m.length > 0 && !(k.length === 0 && m.length === 1 && (0, o.schemaHasRulesForType)(v, m[0]));
    if (w) {
      var x = h(m, y, b.strictNumbers, r.Wrong);
      g.if(x, function() {
        k.length ? function(S, T, P) {
          var O = S.gen, j = S.data, V = S.opts, E = O.let("dataType", s._(zy || (zy = ot(["typeof ", ""])), j)), C = O.let("coerced", s._(By || (By = ot(["undefined"]))));
          V.coerceTypes === "array" && O.if(s._(Fy || (Fy = ot(["", " == 'object' && Array.isArray(", ") && ", ".length == 1"])), E, j, j), function() {
            return O.assign(j, s._(qy || (qy = ot(["", "[0]"])), j)).assign(E, s._(Vy || (Vy = ot(["typeof ", ""])), j)).if(h(T, j, V.strictNumbers), function() {
              return O.assign(C, j);
            });
          }), O.if(s._(Hy || (Hy = ot(["", " !== undefined"])), C));
          var H, X = ut(P);
          try {
            for (X.s(); !(H = X.n()).done; ) {
              var F = H.value;
              (l.has(F) || F === "array" && V.coerceTypes === "array") && G(F);
            }
          } catch (M) {
            X.e(M);
          } finally {
            X.f();
          }
          function G(M) {
            switch (M) {
              case "string":
                return void O.elseIf(s._(Wy || (Wy = ot(["", ' == "number" || ', ' == "boolean"'])), E, E)).assign(C, s._(Uy || (Uy = ot(['"" + ', ""])), j)).elseIf(s._(Jy || (Jy = ot(["", " === null"])), j)).assign(C, s._(Ky || (Ky = ot(['""']))));
              case "number":
                return void O.elseIf(s._(Gy || (Gy = ot(["", ' == "boolean" || ', ` === null
	              || (`, ' == "string" && ', " && ", " == +", ")"])), E, j, E, j, j, j)).assign(C, s._(Qy || (Qy = ot(["+", ""])), j));
              case "integer":
                return void O.elseIf(s._(Xy || (Xy = ot(["", ' === "boolean" || ', ` === null
	              || (`, ' === "string" && ', " && ", " == +", " && !(", " % 1))"])), E, j, E, j, j, j, j)).assign(C, s._(Zy || (Zy = ot(["+", ""])), j));
              case "boolean":
                return void O.elseIf(s._(Yy || (Yy = ot(["", ' === "false" || ', " === 0 || ", " === null"])), j, j, j)).assign(C, !1).elseIf(s._(tb || (tb = ot(["", ' === "true" || ', " === 1"])), j, j)).assign(C, !0);
              case "null":
                return O.elseIf(s._(eb || (eb = ot(["", ' === "" || ', " === 0 || ", " === false"])), j, j, j)), void O.assign(C, null);
              case "array":
                O.elseIf(s._(nb || (nb = ot(["", ' === "string" || ', ` === "number"
	              || `, ' === "boolean" || ', " === null"])), E, E, E, j)).assign(C, s._(rb || (rb = ot(["[", "]"])), j));
            }
          }
          O.else(), p(S), O.endIf(), O.if(s._(ib || (ib = ot(["", " !== undefined"])), C), function() {
            O.assign(j, C), function(M, $) {
              var q = M.gen, B = M.parentData, D = M.parentDataProperty;
              q.if(s._(ob || (ob = ot(["", " !== undefined"])), B), function() {
                return q.assign(s._(ab || (ab = ot(["", "[", "]"])), B, D), $);
              });
            }(S, C);
          });
        }(v, m, k) : p(v);
      });
    }
    return w;
  };
  var l = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null"]);
  function f(v, m, g) {
    var y, b = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : r.Correct, k = b === r.Correct ? s.operators.EQ : s.operators.NEQ;
    switch (v) {
      case "null":
        return s._(sb || (sb = ot(["", " ", " null"])), m, k);
      case "array":
        y = s._(ub || (ub = ot(["Array.isArray(", ")"])), m);
        break;
      case "object":
        y = s._(cb || (cb = ot(["", " && typeof ", ' == "object" && !Array.isArray(', ")"])), m, m, m);
        break;
      case "integer":
        y = w(s._(lb || (lb = ot(["!(", " % 1) && !isNaN(", ")"])), m, m));
        break;
      case "number":
        y = w();
        break;
      default:
        return s._(fb || (fb = ot(["typeof ", " ", " ", ""])), m, k, v);
    }
    return b === r.Correct ? y : (0, s.not)(y);
    function w() {
      var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s.nil;
      return (0, s.and)(s._(hb || (hb = ot(["typeof ", ' == "number"'])), m), x, g ? s._(db || (db = ot(["isFinite(", ")"])), m) : s.nil);
    }
  }
  function h(v, m, g, y) {
    if (v.length === 1)
      return f(v[0], m, g, y);
    var b, k = (0, u.toHash)(v);
    if (k.array && k.object) {
      var w = s._(vb || (vb = ot(["typeof ", ' != "object"'])), m);
      b = k.null ? w : s._(pb || (pb = ot(["!", " || ", ""])), m, w), delete k.null, delete k.array, delete k.object;
    } else
      b = s.nil;
    for (var x in k.number && delete k.integer, k)
      b = (0, s.and)(b, f(x, m, g, y));
    return b;
  }
  n.checkDataType = f, n.checkDataTypes = h;
  var d = { message: function(v) {
    var m = v.schema;
    return "must be ".concat(m);
  }, params: function(v) {
    var m = v.schema, g = v.schemaValue;
    return typeof m == "string" ? s._(mb || (mb = ot(["{type: ", "}"])), m) : s._(gb || (gb = ot(["{type: ", "}"])), g);
  } };
  function p(v) {
    var m = function(g) {
      var y = g.gen, b = g.data, k = g.schema, w = (0, u.schemaRefOrVal)(g, k, "type");
      return { gen: y, keyword: "type", data: b, schema: k.type, schemaCode: w, schemaValue: w, parentSchema: k, params: {}, it: g };
    }(v);
    (0, a.reportError)(m, d);
  }
  n.reportTypeError = p;
}, { "../codegen": 2, "../errors": 4, "../rules": 9, "../util": 10, "./applicability": 11 }], 14: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.assignDefaults = void 0;
  var r = e("../codegen"), i = e("../util");
  function o(a, s, u) {
    var c = a.gen, l = a.compositeRule, f = a.data, h = a.opts;
    if (u !== void 0) {
      var d = r._(yb || (yb = ot(["", "", ""])), f, (0, r.getProperty)(s));
      if (l)
        (0, i.checkStrictMode)(a, "default is ignored for: ".concat(d));
      else {
        var p = r._(bb || (bb = ot(["", " === undefined"])), d);
        h.useDefaults === "empty" && (p = r._(kb || (kb = ot(["", " || ", " === null || ", ' === ""'])), p, d, d)), c.if(p, r._(wb || (wb = ot(["", " = ", ""])), d, (0, r.stringify)(u)));
      }
    }
  }
  n.assignDefaults = function(a, s) {
    var u = a.schema, c = u.properties, l = u.items;
    if (s === "object" && c)
      for (var f in c)
        o(a, f, c[f].default);
    else
      s === "array" && Array.isArray(l) && l.forEach(function(h, d) {
        return o(a, d, h.default);
      });
  };
}, { "../codegen": 2, "../util": 10 }], 15: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.getData = n.KeywordCxt = n.validateFunctionCode = void 0;
  var r = e("./boolSchema"), i = e("./dataType"), o = e("./applicability"), a = e("./dataType"), s = e("./defaults"), u = e("./keyword"), c = e("./subschema"), l = e("../codegen"), f = e("../names"), h = e("../resolve"), d = e("../util"), p = e("../errors");
  function v(F, G) {
    var M = F.gen, $ = F.validateName, q = F.schema, B = F.schemaEnv, D = F.opts;
    D.code.es5 ? M.func($, l._(xb || (xb = ot(["", ", ", ""])), f.default.data, f.default.valCxt), B.$async, function() {
      M.code(l._(jb || (jb = ot(['"use strict"; ', ""])), m(q, D))), function(_, L) {
        _.if(f.default.valCxt, function() {
          _.var(f.default.instancePath, l._(Sb || (Sb = ot(["", ".", ""])), f.default.valCxt, f.default.instancePath)), _.var(f.default.parentData, l._($b || ($b = ot(["", ".", ""])), f.default.valCxt, f.default.parentData)), _.var(f.default.parentDataProperty, l._(_b || (_b = ot(["", ".", ""])), f.default.valCxt, f.default.parentDataProperty)), _.var(f.default.rootData, l._(Cb || (Cb = ot(["", ".", ""])), f.default.valCxt, f.default.rootData)), L.dynamicRef && _.var(f.default.dynamicAnchors, l._(Ob || (Ob = ot(["", ".", ""])), f.default.valCxt, f.default.dynamicAnchors));
        }, function() {
          _.var(f.default.instancePath, l._(Ab || (Ab = ot(['""'])))), _.var(f.default.parentData, l._(Pb || (Pb = ot(["undefined"])))), _.var(f.default.parentDataProperty, l._(Eb || (Eb = ot(["undefined"])))), _.var(f.default.rootData, f.default.data), L.dynamicRef && _.var(f.default.dynamicAnchors, l._(Mb || (Mb = ot(["{}"]))));
        });
      }(M, D), M.code(G);
    }) : M.func($, l._(Tb || (Tb = ot(["", ", ", ""])), f.default.data, function(_) {
      return l._(Ib || (Ib = ot(["{", '="", ', ", ", ", ", "=", "", "}={}"])), f.default.instancePath, f.default.parentData, f.default.parentDataProperty, f.default.rootData, f.default.data, _.dynamicRef ? l._(Nb || (Nb = ot([", ", "={}"])), f.default.dynamicAnchors) : l.nil);
    }(D)), B.$async, function() {
      return M.code(m(q, D)).code(G);
    });
  }
  function m(F, G) {
    var M = ne(F) == "object" && F[G.schemaId];
    return M && (G.code.source || G.code.process) ? l._(Rb || (Rb = ot(["/*# sourceURL=", " */"])), M) : l.nil;
  }
  function g(F, G) {
    b(F) && (k(F), y(F)) ? function(M, $) {
      var q = M.schema, B = M.gen;
      M.opts.$comment && q.$comment && x(M), function(_) {
        var L = _.schema[_.opts.schemaId];
        L && (_.baseId = (0, h.resolveUrl)(_.opts.uriResolver, _.baseId, L));
      }(M), function(_) {
        if (_.schema.$async && !_.schemaEnv.$async)
          throw new Error("async schema in sync schema");
      }(M);
      var D = B.const("_errs", f.default.errors);
      w(M, D), B.var($, l._(Db || (Db = ot(["", " === ", ""])), D, f.default.errors));
    }(F, G) : (0, r.boolOrEmptySchema)(F, G);
  }
  function y(F) {
    var G = F.schema, M = F.self;
    if (typeof G == "boolean")
      return !G;
    for (var $ in G)
      if (M.RULES.all[$])
        return !0;
    return !1;
  }
  function b(F) {
    return typeof F.schema != "boolean";
  }
  function k(F) {
    (0, d.checkUnknownRules)(F), function(G) {
      var M = G.schema, $ = G.errSchemaPath, q = G.opts, B = G.self;
      M.$ref && q.ignoreKeywordsWithRef && (0, d.schemaHasRulesButRef)(M, B.RULES) && B.logger.warn('$ref: keywords ignored in schema at path "'.concat($, '"'));
    }(F);
  }
  function w(F, G) {
    if (F.opts.jtd)
      return S(F, [], !1, G);
    var M = (0, i.getSchemaTypes)(F.schema);
    S(F, M, !(0, i.coerceAndCheckDataType)(F, M), G);
  }
  function x(F) {
    var G = F.gen, M = F.schemaEnv, $ = F.schema, q = F.errSchemaPath, B = F.opts, D = $.$comment;
    if (B.$comment === !0)
      G.code(l._(Lb || (Lb = ot(["", ".logger.log(", ")"])), f.default.self, D));
    else if (typeof B.$comment == "function") {
      var _ = l.str(zb || (zb = ot(["", "/$comment"])), q), L = G.scopeValue("root", { ref: M.root });
      G.code(l._(Bb || (Bb = ot(["", ".opts.$comment(", ", ", ", ", ".schema)"])), f.default.self, D, _, L));
    }
  }
  function S(F, G, M, $) {
    var q = F.gen, B = F.schema, D = F.data, _ = F.allErrors, L = F.opts, J = F.self.RULES;
    function st(ht) {
      (0, o.shouldUseGroup)(B, ht) && (ht.type ? (q.if((0, a.checkDataType)(ht.type, D, L.strictNumbers)), T(F, ht), G.length === 1 && G[0] === ht.type && M && (q.else(), (0, a.reportTypeError)(F)), q.endIf()) : T(F, ht), _ || q.if(l._(Fb || (Fb = ot(["", " === ", ""])), f.default.errors, $ || 0)));
    }
    !B.$ref || !L.ignoreKeywordsWithRef && (0, d.schemaHasRulesButRef)(B, J) ? (L.jtd || function(ht, xt) {
      !ht.schemaEnv.meta && ht.opts.strictTypes && (function(kt, I) {
        I.length && (kt.dataTypes.length ? (I.forEach(function(R) {
          O(kt.dataTypes, R) || j(kt, 'type "'.concat(R, '" not allowed by context "').concat(kt.dataTypes.join(","), '"'));
        }), kt.dataTypes = kt.dataTypes.filter(function(R) {
          return O(I, R);
        })) : kt.dataTypes = I);
      }(ht, xt), ht.opts.allowUnionTypes || function(kt, I) {
        I.length > 1 && (I.length !== 2 || !I.includes("null")) && j(kt, "use allowUnionTypes to allow union type keyword");
      }(ht, xt), function(kt, I) {
        var R = kt.self.RULES.all;
        for (var it in R) {
          var N = R[it];
          if (ne(N) == "object" && (0, o.shouldUseRule)(kt.schema, N)) {
            var K = N.definition.type;
            K.length && !K.some(function(z) {
              return P(I, z);
            }) && j(kt, 'missing type "'.concat(K.join(","), '" for keyword "').concat(it, '"'));
          }
        }
      }(ht, ht.dataTypes));
    }(F, G), q.block(function() {
      var ht, xt = ut(J.rules);
      try {
        for (xt.s(); !(ht = xt.n()).done; )
          st(ht.value);
      } catch (kt) {
        xt.e(kt);
      } finally {
        xt.f();
      }
      st(J.post);
    })) : q.block(function() {
      return E(F, "$ref", J.all.$ref.definition);
    });
  }
  function T(F, G) {
    var M = F.gen, $ = F.schema;
    F.opts.useDefaults && (0, s.assignDefaults)(F, G.type), M.block(function() {
      var q, B = ut(G.rules);
      try {
        for (B.s(); !(q = B.n()).done; ) {
          var D = q.value;
          (0, o.shouldUseRule)($, D) && E(F, D.keyword, D.definition, G.type);
        }
      } catch (_) {
        B.e(_);
      } finally {
        B.f();
      }
    });
  }
  function P(F, G) {
    return F.includes(G) || G === "number" && F.includes("integer");
  }
  function O(F, G) {
    return F.includes(G) || G === "integer" && F.includes("number");
  }
  function j(F, G) {
    (0, d.checkStrictMode)(F, G += ' at "'.concat(F.schemaEnv.baseId + F.errSchemaPath, '" (strictTypes)'), F.opts.strictTypes);
  }
  n.validateFunctionCode = function(F) {
    b(F) && (k(F), y(F)) ? function(G) {
      var M = G.schema, $ = G.opts, q = G.gen;
      v(G, function() {
        $.$comment && M.$comment && x(G), function(B) {
          var D = B.schema, _ = B.opts;
          D.default !== void 0 && _.useDefaults && _.strictSchema && (0, d.checkStrictMode)(B, "default is ignored in the schema root");
        }(G), q.let(f.default.vErrors, null), q.let(f.default.errors, 0), $.unevaluated && function(B) {
          var D = B.gen, _ = B.validateName;
          B.evaluated = D.const("evaluated", l._(qb || (qb = ot(["", ".evaluated"])), _)), D.if(l._(Vb || (Vb = ot(["", ".dynamicProps"])), B.evaluated), function() {
            return D.assign(l._(Hb || (Hb = ot(["", ".props"])), B.evaluated), l._(Wb || (Wb = ot(["undefined"]))));
          }), D.if(l._(Ub || (Ub = ot(["", ".dynamicItems"])), B.evaluated), function() {
            return D.assign(l._(Jb || (Jb = ot(["", ".items"])), B.evaluated), l._(Kb || (Kb = ot(["undefined"]))));
          });
        }(G), w(G), function(B) {
          var D = B.gen, _ = B.schemaEnv, L = B.validateName, J = B.ValidationError, st = B.opts;
          _.$async ? D.if(l._(Gb || (Gb = ot(["", " === 0"])), f.default.errors), function() {
            return D.return(f.default.data);
          }, function() {
            return D.throw(l._(Qb || (Qb = ot(["new ", "(", ")"])), J, f.default.vErrors));
          }) : (D.assign(l._(Xb || (Xb = ot(["", ".errors"])), L), f.default.vErrors), st.unevaluated && function(ht) {
            var xt = ht.gen, kt = ht.evaluated, I = ht.props, R = ht.items;
            I instanceof l.Name && xt.assign(l._(Zb || (Zb = ot(["", ".props"])), kt), I), R instanceof l.Name && xt.assign(l._(Yb || (Yb = ot(["", ".items"])), kt), R);
          }(B), D.return(l._(tk || (tk = ot(["", " === 0"])), f.default.errors)));
        }(G);
      });
    }(F) : v(F, function() {
      return (0, r.topBoolOrEmptySchema)(F);
    });
  };
  var V = function() {
    function F(G, M, $) {
      if (Z(this, F), (0, u.validateKeywordUsage)(G, M, $), this.gen = G.gen, this.allErrors = G.allErrors, this.keyword = $, this.data = G.data, this.schema = G.schema[$], this.$data = M.$data && G.opts.$data && this.schema && this.schema.$data, this.schemaValue = (0, d.schemaRefOrVal)(G, this.schema, $, this.$data), this.schemaType = M.schemaType, this.parentSchema = G.schema, this.params = {}, this.it = G, this.def = M, this.$data)
        this.schemaCode = G.gen.const("vSchema", X(this.$data, G));
      else if (this.schemaCode = this.schemaValue, !(0, u.validSchemaType)(this.schema, M.schemaType, M.allowUndefined))
        throw new Error("".concat($, " value must be ").concat(JSON.stringify(M.schemaType)));
      ("code" in M ? M.trackErrors : M.errors !== !1) && (this.errsCount = G.gen.const("_errs", f.default.errors));
    }
    return Y(F, [{ key: "result", value: function(G, M, $) {
      this.failResult((0, l.not)(G), M, $);
    } }, { key: "failResult", value: function(G, M, $) {
      this.gen.if(G), $ ? $() : this.error(), M ? (this.gen.else(), M(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
    } }, { key: "pass", value: function(G, M) {
      this.failResult((0, l.not)(G), void 0, M);
    } }, { key: "fail", value: function(G) {
      if (G === void 0)
        return this.error(), void (this.allErrors || this.gen.if(!1));
      this.gen.if(G), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
    } }, { key: "fail$data", value: function(G) {
      if (!this.$data)
        return this.fail(G);
      var M = this.schemaCode;
      this.fail(l._(ek || (ek = ot(["", " !== undefined && (", ")"])), M, (0, l.or)(this.invalid$data(), G)));
    } }, { key: "error", value: function(G, M, $) {
      if (M)
        return this.setParams(M), this._error(G, $), void this.setParams({});
      this._error(G, $);
    } }, { key: "_error", value: function(G, M) {
      (G ? p.reportExtraError : p.reportError)(this, this.def.error, M);
    } }, { key: "$dataError", value: function() {
      (0, p.reportError)(this, this.def.$dataError || p.keyword$DataError);
    } }, { key: "reset", value: function() {
      if (this.errsCount === void 0)
        throw new Error('add "trackErrors" to keyword definition');
      (0, p.resetErrorsCount)(this.gen, this.errsCount);
    } }, { key: "ok", value: function(G) {
      this.allErrors || this.gen.if(G);
    } }, { key: "setParams", value: function(G, M) {
      M ? Object.assign(this.params, G) : this.params = G;
    } }, { key: "block$data", value: function(G, M) {
      var $ = this, q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : l.nil;
      this.gen.block(function() {
        $.check$data(G, q), M();
      });
    } }, { key: "check$data", value: function() {
      var G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : l.nil, M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l.nil;
      if (this.$data) {
        var $ = this.gen, q = this.schemaCode, B = this.schemaType, D = this.def;
        $.if((0, l.or)(l._(nk || (nk = ot(["", " === undefined"])), q), M)), G !== l.nil && $.assign(G, !0), (B.length || D.validateSchema) && ($.elseIf(this.invalid$data()), this.$dataError(), G !== l.nil && $.assign(G, !1)), $.else();
      }
    } }, { key: "invalid$data", value: function() {
      var G = this.gen, M = this.schemaCode, $ = this.schemaType, q = this.def, B = this.it;
      return (0, l.or)(function() {
        if ($.length) {
          if (!(M instanceof l.Name))
            throw new Error("ajv implementation error");
          var D = Array.isArray($) ? $ : [$];
          return l._(rk || (rk = ot(["", ""])), (0, a.checkDataTypes)(D, M, B.opts.strictNumbers, a.DataType.Wrong));
        }
        return l.nil;
      }(), function() {
        if (q.validateSchema) {
          var D = G.scopeValue("validate$data", { ref: q.validateSchema });
          return l._(ik || (ik = ot(["!", "(", ")"])), D, M);
        }
        return l.nil;
      }());
    } }, { key: "subschema", value: function(G, M) {
      var $ = (0, c.getSubschema)(this.it, G);
      (0, c.extendSubschemaData)($, this.it, G), (0, c.extendSubschemaMode)($, G);
      var q = Ct(Ct(Ct({}, this.it), $), {}, { items: void 0, props: void 0 });
      return g(q, M), q;
    } }, { key: "mergeEvaluated", value: function(G, M) {
      var $ = this.it, q = this.gen;
      $.opts.unevaluated && ($.props !== !0 && G.props !== void 0 && ($.props = d.mergeEvaluated.props(q, G.props, $.props, M)), $.items !== !0 && G.items !== void 0 && ($.items = d.mergeEvaluated.items(q, G.items, $.items, M)));
    } }, { key: "mergeValidEvaluated", value: function(G, M) {
      var $ = this, q = this.it, B = this.gen;
      if (q.opts.unevaluated && (q.props !== !0 || q.items !== !0))
        return B.if(M, function() {
          return $.mergeEvaluated(G, l.Name);
        }), !0;
    } }]), F;
  }();
  function E(F, G, M, $) {
    var q = new V(F, M, G);
    "code" in M ? M.code(q, $) : q.$data && M.validate ? (0, u.funcKeywordCode)(q, M) : "macro" in M ? (0, u.macroKeywordCode)(q, M) : (M.compile || M.validate) && (0, u.funcKeywordCode)(q, M);
  }
  n.KeywordCxt = V;
  var C = /^\/(?:[^~]|~0|~1)*$/, H = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
  function X(F, G) {
    var M, $, q = G.dataLevel, B = G.dataNames, D = G.dataPathArr;
    if (F === "")
      return f.default.rootData;
    if (F[0] === "/") {
      if (!C.test(F))
        throw new Error("Invalid JSON-pointer: ".concat(F));
      M = F, $ = f.default.rootData;
    } else {
      var _ = H.exec(F);
      if (!_)
        throw new Error("Invalid JSON-pointer: ".concat(F));
      var L = +_[1];
      if ((M = _[2]) === "#") {
        if (L >= q)
          throw new Error(kt("property/index", L));
        return D[q - L];
      }
      if (L > q)
        throw new Error(kt("data", L));
      if ($ = B[q - L], !M)
        return $;
    }
    var J, st = $, ht = ut(M.split("/"));
    try {
      for (ht.s(); !(J = ht.n()).done; ) {
        var xt = J.value;
        xt && ($ = l._(ok || (ok = ot(["", "", ""])), $, (0, l.getProperty)((0, d.unescapeJsonPointer)(xt))), st = l._(ak || (ak = ot(["", " && ", ""])), st, $));
      }
    } catch (I) {
      ht.e(I);
    } finally {
      ht.f();
    }
    return st;
    function kt(I, R) {
      return "Cannot access ".concat(I, " ").concat(R, " levels up, current level is ").concat(q);
    }
  }
  n.getData = X;
}, { "../codegen": 2, "../errors": 4, "../names": 6, "../resolve": 8, "../util": 10, "./applicability": 11, "./boolSchema": 12, "./dataType": 13, "./defaults": 14, "./keyword": 16, "./subschema": 17 }], 16: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.validateKeywordUsage = n.validSchemaType = n.funcKeywordCode = n.macroKeywordCode = void 0;
  var r = e("../codegen"), i = e("../names"), o = e("../../vocabularies/code"), a = e("../errors");
  function s(c) {
    var l = c.gen, f = c.data, h = c.it;
    l.if(h.parentData, function() {
      return l.assign(f, r._(sk || (sk = ot(["", "[", "]"])), h.parentData, h.parentDataProperty));
    });
  }
  function u(c, l, f) {
    if (f === void 0)
      throw new Error('keyword "'.concat(l, '" failed to compile'));
    return c.scopeValue("keyword", typeof f == "function" ? { ref: f } : { ref: f, code: (0, r.stringify)(f) });
  }
  n.macroKeywordCode = function(c, l) {
    var f = c.gen, h = c.keyword, d = c.schema, p = c.parentSchema, v = c.it, m = l.macro.call(v.self, d, p, v), g = u(f, h, m);
    v.opts.validateSchema !== !1 && v.self.validateSchema(m, !0);
    var y = f.name("valid");
    c.subschema({ schema: m, schemaPath: r.nil, errSchemaPath: "".concat(v.errSchemaPath, "/").concat(h), topSchemaRef: g, compositeRule: !0 }, y), c.pass(y, function() {
      return c.error(!0);
    });
  }, n.funcKeywordCode = function(c, l) {
    var f, h = c.gen, d = c.keyword, p = c.schema, v = c.parentSchema, m = c.$data, g = c.it;
    (function(S, T) {
      var P = S.schemaEnv;
      if (T.async && !P.$async)
        throw new Error("async keyword in sync schema");
    })(g, l);
    var y = !m && l.compile ? l.compile.call(g.self, p, v, g) : l.validate, b = u(h, d, y), k = h.let("valid");
    function w() {
      var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : l.async ? r._(uk || (uk = ot(["await "]))) : r.nil;
      h.assign(k, r._(ck || (ck = ot(["", "", ""])), S, (0, o.callValidateCode)(c, b, g.opts.passContext ? i.default.this : i.default.self, !("compile" in l && !m || l.schema === !1))), l.modifying);
    }
    function x(S) {
      var T;
      h.if((0, r.not)((T = l.valid) !== null && T !== void 0 ? T : k), S);
    }
    c.block$data(k, function() {
      if (l.errors === !1)
        w(), l.modifying && s(c), x(function() {
          return c.error();
        });
      else {
        var S = l.async ? function() {
          var T = h.let("ruleErrs", null);
          return h.try(function() {
            return w(r._(lk || (lk = ot(["await "]))));
          }, function(P) {
            return h.assign(k, !1).if(r._(fk || (fk = ot(["", " instanceof ", ""])), P, g.ValidationError), function() {
              return h.assign(T, r._(hk || (hk = ot(["", ".errors"])), P));
            }, function() {
              return h.throw(P);
            });
          }), T;
        }() : function() {
          var T = r._(dk || (dk = ot(["", ".errors"])), b);
          return h.assign(T, null), w(r.nil), T;
        }();
        l.modifying && s(c), x(function() {
          return function(T, P) {
            var O = T.gen;
            O.if(r._(vk || (vk = ot(["Array.isArray(", ")"])), P), function() {
              O.assign(i.default.vErrors, r._(pk || (pk = ot(["", " === null ? ", " : ", ".concat(", ")"])), i.default.vErrors, P, i.default.vErrors, P)).assign(i.default.errors, r._(mk || (mk = ot(["", ".length"])), i.default.vErrors)), (0, a.extendErrors)(T);
            }, function() {
              return T.error();
            });
          }(c, S);
        });
      }
    }), c.ok((f = l.valid) !== null && f !== void 0 ? f : k);
  }, n.validSchemaType = function(c, l) {
    var f = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
    return !l.length || l.some(function(h) {
      return h === "array" ? Array.isArray(c) : h === "object" ? c && ne(c) == "object" && !Array.isArray(c) : ne(c) == h || f && c === void 0;
    });
  }, n.validateKeywordUsage = function(c, l, f) {
    var h = c.schema, d = c.opts, p = c.self, v = c.errSchemaPath;
    if (Array.isArray(l.keyword) ? !l.keyword.includes(f) : l.keyword !== f)
      throw new Error("ajv implementation error");
    var m = l.dependencies;
    if (m != null && m.some(function(y) {
      return !Object.prototype.hasOwnProperty.call(h, y);
    }))
      throw new Error("parent schema must have dependencies of ".concat(f, ": ").concat(m.join(",")));
    if (l.validateSchema && !l.validateSchema(h[f])) {
      var g = 'keyword "'.concat(f, '" value is invalid at path "').concat(v, '": ') + p.errorsText(l.validateSchema.errors);
      if (d.validateSchema !== "log")
        throw new Error(g);
      p.logger.error(g);
    }
  };
}, { "../../vocabularies/code": 42, "../codegen": 2, "../errors": 4, "../names": 6 }], 17: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.extendSubschemaMode = n.extendSubschemaData = n.getSubschema = void 0;
  var r = e("../codegen"), i = e("../util");
  n.getSubschema = function(o, a) {
    var s = a.keyword, u = a.schemaProp, c = a.schema, l = a.schemaPath, f = a.errSchemaPath, h = a.topSchemaRef;
    if (s !== void 0 && c !== void 0)
      throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (s !== void 0) {
      var d = o.schema[s];
      return u === void 0 ? { schema: d, schemaPath: r._(gk || (gk = ot(["", "", ""])), o.schemaPath, (0, r.getProperty)(s)), errSchemaPath: "".concat(o.errSchemaPath, "/").concat(s) } : { schema: d[u], schemaPath: r._(yk || (yk = ot(["", "", "", ""])), o.schemaPath, (0, r.getProperty)(s), (0, r.getProperty)(u)), errSchemaPath: "".concat(o.errSchemaPath, "/").concat(s, "/").concat((0, i.escapeFragment)(u)) };
    }
    if (c !== void 0) {
      if (l === void 0 || f === void 0 || h === void 0)
        throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
      return { schema: c, schemaPath: l, topSchemaRef: h, errSchemaPath: f };
    }
    throw new Error('either "keyword" or "schema" must be passed');
  }, n.extendSubschemaData = function(o, a, s) {
    var u = s.dataProp, c = s.dataPropType, l = s.data, f = s.dataTypes, h = s.propertyName;
    if (l !== void 0 && u !== void 0)
      throw new Error('both "data" and "dataProp" passed, only one allowed');
    var d = a.gen;
    if (u !== void 0) {
      var p = a.errorPath, v = a.dataPathArr, m = a.opts;
      g(d.let("data", r._(bk || (bk = ot(["", "", ""])), a.data, (0, r.getProperty)(u)), !0)), o.errorPath = r.str(kk || (kk = ot(["", "", ""])), p, (0, i.getErrorPath)(u, c, m.jsPropertySyntax)), o.parentDataProperty = r._(wk || (wk = ot(["", ""])), u), o.dataPathArr = [].concat(Pe(v), [o.parentDataProperty]);
    }
    function g(y) {
      o.data = y, o.dataLevel = a.dataLevel + 1, o.dataTypes = [], a.definedProperties = /* @__PURE__ */ new Set(), o.parentData = a.data, o.dataNames = [].concat(Pe(a.dataNames), [y]);
    }
    l !== void 0 && (g(l instanceof r.Name ? l : d.let("data", l, !0)), h !== void 0 && (o.propertyName = h)), f && (o.dataTypes = f);
  }, n.extendSubschemaMode = function(o, a) {
    var s = a.jtdDiscriminator, u = a.jtdMetadata, c = a.compositeRule, l = a.createErrors, f = a.allErrors;
    c !== void 0 && (o.compositeRule = c), l !== void 0 && (o.createErrors = l), f !== void 0 && (o.allErrors = f), o.jtdDiscriminator = s, o.jtdMetadata = u;
  };
}, { "../codegen": 2, "../util": 10 }], 18: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.CodeGen = n.Name = n.nil = n.stringify = n.str = n._ = n.KeywordCxt = void 0;
  var r = e("./compile/validate");
  Object.defineProperty(n, "KeywordCxt", { enumerable: !0, get: function() {
    return r.KeywordCxt;
  } });
  var i = e("./compile/codegen");
  Object.defineProperty(n, "_", { enumerable: !0, get: function() {
    return i._;
  } }), Object.defineProperty(n, "str", { enumerable: !0, get: function() {
    return i.str;
  } }), Object.defineProperty(n, "stringify", { enumerable: !0, get: function() {
    return i.stringify;
  } }), Object.defineProperty(n, "nil", { enumerable: !0, get: function() {
    return i.nil;
  } }), Object.defineProperty(n, "Name", { enumerable: !0, get: function() {
    return i.Name;
  } }), Object.defineProperty(n, "CodeGen", { enumerable: !0, get: function() {
    return i.CodeGen;
  } });
  var o = e("./runtime/validation_error"), a = e("./compile/ref_error"), s = e("./compile/rules"), u = e("./compile"), c = e("./compile/codegen"), l = e("./compile/resolve"), f = e("./compile/validate/dataType"), h = e("./compile/util"), d = e("./refs/data.json"), p = e("./runtime/uri"), v = function($, q) {
    return new RegExp($, q);
  };
  v.code = "new RegExp";
  var m = ["removeAdditional", "useDefaults", "coerceTypes"], g = /* @__PURE__ */ new Set(["validate", "serialize", "parse", "wrapper", "root", "schema", "keyword", "pattern", "formats", "validate$data", "func", "obj", "Error"]), y = { errorDataPath: "", format: "`validateFormats: false` can be used instead.", nullable: '"nullable" keyword is supported by default.', jsonPointers: "Deprecated jsPropertySyntax can be used instead.", extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.", missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.", processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`", sourceCode: "Use option `code: {source: true}`", strictDefaults: "It is default now, see option `strict`.", strictKeywords: "It is default now, see option `strict`.", uniqueItems: '"uniqueItems" keyword is always validated.', unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).", cache: "Map is used as cache, schema object as key.", serialize: "Map is used as cache, schema object as key.", ajvErrors: "It is default now." }, b = { ignoreKeywordsWithRef: "", jsPropertySyntax: "", unicode: '"minLength"/"maxLength" account for unicode characters by default.' };
  function k($) {
    var q, B, D, _, L, J, st, ht, xt, kt, I, R, it, N, K, z, at, yt, jt, Ft, zt, St, Gt, _e, Fe, fn = $.strict, De = (q = $.code) === null || q === void 0 ? void 0 : q.optimize, $t = De === !0 || De === void 0 ? 1 : De || 0, oe = (D = (B = $.code) === null || B === void 0 ? void 0 : B.regExp) !== null && D !== void 0 ? D : v, Ce = (_ = $.uriResolver) !== null && _ !== void 0 ? _ : p.default;
    return { strictSchema: (J = (L = $.strictSchema) !== null && L !== void 0 ? L : fn) === null || J === void 0 || J, strictNumbers: (ht = (st = $.strictNumbers) !== null && st !== void 0 ? st : fn) === null || ht === void 0 || ht, strictTypes: (kt = (xt = $.strictTypes) !== null && xt !== void 0 ? xt : fn) !== null && kt !== void 0 ? kt : "log", strictTuples: (R = (I = $.strictTuples) !== null && I !== void 0 ? I : fn) !== null && R !== void 0 ? R : "log", strictRequired: (N = (it = $.strictRequired) !== null && it !== void 0 ? it : fn) !== null && N !== void 0 && N, code: $.code ? Ct(Ct({}, $.code), {}, { optimize: $t, regExp: oe }) : { optimize: $t, regExp: oe }, loopRequired: (K = $.loopRequired) !== null && K !== void 0 ? K : 200, loopEnum: (z = $.loopEnum) !== null && z !== void 0 ? z : 200, meta: (at = $.meta) === null || at === void 0 || at, messages: (yt = $.messages) === null || yt === void 0 || yt, inlineRefs: (jt = $.inlineRefs) === null || jt === void 0 || jt, schemaId: (Ft = $.schemaId) !== null && Ft !== void 0 ? Ft : "$id", addUsedSchema: (zt = $.addUsedSchema) === null || zt === void 0 || zt, validateSchema: (St = $.validateSchema) === null || St === void 0 || St, validateFormats: (Gt = $.validateFormats) === null || Gt === void 0 || Gt, unicodeRegExp: (_e = $.unicodeRegExp) === null || _e === void 0 || _e, int32range: (Fe = $.int32range) === null || Fe === void 0 || Fe, uriResolver: Ce };
  }
  var w = function() {
    function $() {
      var q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      Z(this, $), this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = /* @__PURE__ */ new Set(), this._loading = {}, this._cache = /* @__PURE__ */ new Map(), q = this.opts = Ct(Ct({}, q), k(q));
      var B = this.opts.code, D = B.es5, _ = B.lines;
      this.scope = new c.ValueScope({ scope: {}, prefixes: g, es5: D, lines: _ }), this.logger = function(J) {
        if (J === !1)
          return V;
        if (J === void 0)
          return console;
        if (J.log && J.warn && J.error)
          return J;
        throw new Error("logger must implement log, warn and error methods");
      }(q.logger);
      var L = q.validateFormats;
      q.validateFormats = !1, this.RULES = (0, s.getRules)(), x.call(this, y, q, "NOT SUPPORTED"), x.call(this, b, q, "DEPRECATED", "warn"), this._metaOpts = j.call(this), q.formats && P.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), q.keywords && O.call(this, q.keywords), ne(q.meta) == "object" && this.addMetaSchema(q.meta), T.call(this), q.validateFormats = L;
    }
    return Y($, [{ key: "_addVocabularies", value: function() {
      this.addKeyword("$async");
    } }, { key: "_addDefaultMetaSchema", value: function() {
      var q = this.opts, B = q.$data, D = q.meta, _ = q.schemaId, L = d;
      _ === "id" && ((L = Ct({}, d)).id = L.$id, delete L.$id), D && B && this.addMetaSchema(L, L[_], !1);
    } }, { key: "defaultMeta", value: function() {
      var q = this.opts, B = q.meta, D = q.schemaId;
      return this.opts.defaultMeta = ne(B) == "object" ? B[D] || B : void 0;
    } }, { key: "validate", value: function(q, B) {
      var D;
      if (typeof q == "string") {
        if (!(D = this.getSchema(q)))
          throw new Error('no schema with key or ref "'.concat(q, '"'));
      } else
        D = this.compile(q);
      var _ = D(B);
      return "$async" in D || (this.errors = D.errors), _;
    } }, { key: "compile", value: function(q, B) {
      var D = this._addSchema(q, B);
      return D.validate || this._compileSchemaEnv(D);
    } }, { key: "compileAsync", value: function(q, B) {
      if (typeof this.opts.loadSchema != "function")
        throw new Error("options.loadSchema should be a function");
      var D = this.opts.loadSchema;
      return _.call(this, q, B);
      function _(K, z) {
        return L.apply(this, arguments);
      }
      function L() {
        return (L = mn(de().mark(function K(z, at) {
          var yt;
          return de().wrap(function(jt) {
            for (; ; )
              switch (jt.prev = jt.next) {
                case 0:
                  return jt.next = 2, J.call(this, z.$schema);
                case 2:
                  return yt = this._addSchema(z, at), jt.abrupt("return", yt.validate || ht.call(this, yt));
                case 4:
                case "end":
                  return jt.stop();
              }
          }, K, this);
        }))).apply(this, arguments);
      }
      function J(K) {
        return st.apply(this, arguments);
      }
      function st() {
        return (st = mn(de().mark(function K(z) {
          return de().wrap(function(at) {
            for (; ; )
              switch (at.prev = at.next) {
                case 0:
                  if (at.t0 = z && !this.getSchema(z), !at.t0) {
                    at.next = 4;
                    break;
                  }
                  return at.next = 4, _.call(this, { $ref: z }, !0);
                case 4:
                case "end":
                  return at.stop();
              }
          }, K, this);
        }))).apply(this, arguments);
      }
      function ht(K) {
        return xt.apply(this, arguments);
      }
      function xt() {
        return (xt = mn(de().mark(function K(z) {
          return de().wrap(function(at) {
            for (; ; )
              switch (at.prev = at.next) {
                case 0:
                  return at.prev = 0, at.abrupt("return", this._compileSchemaEnv(z));
                case 4:
                  if (at.prev = 4, at.t0 = at.catch(0), at.t0 instanceof a.default) {
                    at.next = 8;
                    break;
                  }
                  throw at.t0;
                case 8:
                  return kt.call(this, at.t0), at.next = 11, I.call(this, at.t0.missingSchema);
                case 11:
                  return at.abrupt("return", ht.call(this, z));
                case 12:
                case "end":
                  return at.stop();
              }
          }, K, this, [[0, 4]]);
        }))).apply(this, arguments);
      }
      function kt(K) {
        var z = K.missingSchema, at = K.missingRef;
        if (this.refs[z])
          throw new Error("AnySchema ".concat(z, " is loaded but ").concat(at, " cannot be resolved"));
      }
      function I(K) {
        return R.apply(this, arguments);
      }
      function R() {
        return (R = mn(de().mark(function K(z) {
          var at;
          return de().wrap(function(yt) {
            for (; ; )
              switch (yt.prev = yt.next) {
                case 0:
                  return yt.next = 2, it.call(this, z);
                case 2:
                  if (at = yt.sent, yt.t0 = this.refs[z], yt.t0) {
                    yt.next = 7;
                    break;
                  }
                  return yt.next = 7, J.call(this, at.$schema);
                case 7:
                  this.refs[z] || this.addSchema(at, z, B);
                case 8:
                case "end":
                  return yt.stop();
              }
          }, K, this);
        }))).apply(this, arguments);
      }
      function it(K) {
        return N.apply(this, arguments);
      }
      function N() {
        return (N = mn(de().mark(function K(z) {
          var at;
          return de().wrap(function(yt) {
            for (; ; )
              switch (yt.prev = yt.next) {
                case 0:
                  if (!(at = this._loading[z])) {
                    yt.next = 3;
                    break;
                  }
                  return yt.abrupt("return", at);
                case 3:
                  return yt.prev = 3, yt.next = 6, this._loading[z] = D(z);
                case 6:
                  return yt.abrupt("return", yt.sent);
                case 7:
                  return yt.prev = 7, delete this._loading[z], yt.finish(7);
                case 10:
                case "end":
                  return yt.stop();
              }
          }, K, this, [[3, , 7, 10]]);
        }))).apply(this, arguments);
      }
    } }, { key: "addSchema", value: function(q, B, D) {
      var _, L = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this.opts.validateSchema;
      if (Array.isArray(q)) {
        var J, st = ut(q);
        try {
          for (st.s(); !(J = st.n()).done; ) {
            var ht = J.value;
            this.addSchema(ht, void 0, D, L);
          }
        } catch (kt) {
          st.e(kt);
        } finally {
          st.f();
        }
        return this;
      }
      if (ne(q) == "object") {
        var xt = this.opts.schemaId;
        if ((_ = q[xt]) !== void 0 && typeof _ != "string")
          throw new Error("schema ".concat(xt, " must be string"));
      }
      return B = (0, l.normalizeId)(B || _), this._checkUnique(B), this.schemas[B] = this._addSchema(q, D, B, L, !0), this;
    } }, { key: "addMetaSchema", value: function(q, B) {
      var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.opts.validateSchema;
      return this.addSchema(q, B, !0, D), this;
    } }, { key: "validateSchema", value: function(q, B) {
      if (typeof q == "boolean")
        return !0;
      var D;
      if ((D = q.$schema) !== void 0 && typeof D != "string")
        throw new Error("$schema must be a string");
      if (!(D = D || this.opts.defaultMeta || this.defaultMeta()))
        return this.logger.warn("meta-schema not available"), this.errors = null, !0;
      var _ = this.validate(D, q);
      if (!_ && B) {
        var L = "schema is invalid: " + this.errorsText();
        if (this.opts.validateSchema !== "log")
          throw new Error(L);
        this.logger.error(L);
      }
      return _;
    } }, { key: "getSchema", value: function(q) {
      for (var B; typeof (B = S.call(this, q)) == "string"; )
        q = B;
      if (B === void 0) {
        var D = this.opts.schemaId, _ = new u.SchemaEnv({ schema: {}, schemaId: D });
        if (!(B = u.resolveSchema.call(this, _, q)))
          return;
        this.refs[q] = B;
      }
      return B.validate || this._compileSchemaEnv(B);
    } }, { key: "removeSchema", value: function(q) {
      if (q instanceof RegExp)
        return this._removeAllSchemas(this.schemas, q), this._removeAllSchemas(this.refs, q), this;
      switch (ne(q)) {
        case "undefined":
          return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;
        case "string":
          var B = S.call(this, q);
          return ne(B) == "object" && this._cache.delete(B.schema), delete this.schemas[q], delete this.refs[q], this;
        case "object":
          this._cache.delete(q);
          var D = q[this.opts.schemaId];
          return D && (D = (0, l.normalizeId)(D), delete this.schemas[D], delete this.refs[D]), this;
        default:
          throw new Error("ajv.removeSchema: invalid parameter");
      }
    } }, { key: "addVocabulary", value: function(q) {
      var B, D = ut(q);
      try {
        for (D.s(); !(B = D.n()).done; ) {
          var _ = B.value;
          this.addKeyword(_);
        }
      } catch (L) {
        D.e(L);
      } finally {
        D.f();
      }
      return this;
    } }, { key: "addKeyword", value: function(q, B) {
      var D, _ = this;
      if (typeof q == "string")
        D = q, ne(B) == "object" && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), B.keyword = D);
      else {
        if (ne(q) != "object" || B !== void 0)
          throw new Error("invalid addKeywords parameters");
        if (D = (B = q).keyword, Array.isArray(D) && !D.length)
          throw new Error("addKeywords: keyword must be string or non-empty array");
      }
      if (C.call(this, D, B), !B)
        return (0, h.eachItem)(D, function(J) {
          return H.call(_, J);
        }), this;
      F.call(this, B);
      var L = Ct(Ct({}, B), {}, { type: (0, f.getJSONTypes)(B.type), schemaType: (0, f.getJSONTypes)(B.schemaType) });
      return (0, h.eachItem)(D, L.type.length === 0 ? function(J) {
        return H.call(_, J, L);
      } : function(J) {
        return L.type.forEach(function(st) {
          return H.call(_, J, L, st);
        });
      }), this;
    } }, { key: "getKeyword", value: function(q) {
      var B = this.RULES.all[q];
      return ne(B) == "object" ? B.definition : !!B;
    } }, { key: "removeKeyword", value: function(q) {
      var B = this.RULES;
      delete B.keywords[q], delete B.all[q];
      var D, _ = ut(B.rules);
      try {
        for (_.s(); !(D = _.n()).done; ) {
          var L = D.value, J = L.rules.findIndex(function(st) {
            return st.keyword === q;
          });
          J >= 0 && L.rules.splice(J, 1);
        }
      } catch (st) {
        _.e(st);
      } finally {
        _.f();
      }
      return this;
    } }, { key: "addFormat", value: function(q, B) {
      return typeof B == "string" && (B = new RegExp(B)), this.formats[q] = B, this;
    } }, { key: "errorsText", value: function() {
      var q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.errors, B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, D = B.separator, _ = D === void 0 ? ", " : D, L = B.dataVar, J = L === void 0 ? "data" : L;
      return q && q.length !== 0 ? q.map(function(st) {
        return "".concat(J).concat(st.instancePath, " ").concat(st.message);
      }).reduce(function(st, ht) {
        return st + _ + ht;
      }) : "No errors";
    } }, { key: "$dataMetaSchema", value: function(q, B) {
      var D = this.RULES.all;
      q = JSON.parse(JSON.stringify(q));
      var _, L = ut(B);
      try {
        for (L.s(); !(_ = L.n()).done; ) {
          var J, st = _.value.split("/").slice(1), ht = q, xt = ut(st);
          try {
            for (xt.s(); !(J = xt.n()).done; )
              ht = ht[J.value];
          } catch (N) {
            xt.e(N);
          } finally {
            xt.f();
          }
          for (var kt in D) {
            var I = D[kt];
            if (ne(I) == "object") {
              var R = I.definition.$data, it = ht[kt];
              R && it && (ht[kt] = M(it));
            }
          }
        }
      } catch (N) {
        L.e(N);
      } finally {
        L.f();
      }
      return q;
    } }, { key: "_removeAllSchemas", value: function(q, B) {
      for (var D in q) {
        var _ = q[D];
        B && !B.test(D) || (typeof _ == "string" ? delete q[D] : _ && !_.meta && (this._cache.delete(_.schema), delete q[D]));
      }
    } }, { key: "_addSchema", value: function(q, B, D) {
      var _, L = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this.opts.validateSchema, J = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.opts.addUsedSchema, st = this.opts.schemaId;
      if (ne(q) == "object")
        _ = q[st];
      else {
        if (this.opts.jtd)
          throw new Error("schema must be object");
        if (typeof q != "boolean")
          throw new Error("schema must be object or boolean");
      }
      var ht = this._cache.get(q);
      if (ht !== void 0)
        return ht;
      D = (0, l.normalizeId)(_ || D);
      var xt = l.getSchemaRefs.call(this, q, D);
      return ht = new u.SchemaEnv({ schema: q, schemaId: st, meta: B, baseId: D, localRefs: xt }), this._cache.set(ht.schema, ht), J && !D.startsWith("#") && (D && this._checkUnique(D), this.refs[D] = ht), L && this.validateSchema(q, !0), ht;
    } }, { key: "_checkUnique", value: function(q) {
      if (this.schemas[q] || this.refs[q])
        throw new Error('schema with key or id "'.concat(q, '" already exists'));
    } }, { key: "_compileSchemaEnv", value: function(q) {
      if (q.meta ? this._compileMetaSchema(q) : u.compileSchema.call(this, q), !q.validate)
        throw new Error("ajv implementation error");
      return q.validate;
    } }, { key: "_compileMetaSchema", value: function(q) {
      var B = this.opts;
      this.opts = this._metaOpts;
      try {
        u.compileSchema.call(this, q);
      } finally {
        this.opts = B;
      }
    } }]), $;
  }();
  function x($, q, B) {
    var D = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "error";
    for (var _ in $) {
      var L = _;
      L in q && this.logger[D]("".concat(B, ": option ").concat(_, ". ").concat($[L]));
    }
  }
  function S($) {
    return $ = (0, l.normalizeId)($), this.schemas[$] || this.refs[$];
  }
  function T() {
    var $ = this.opts.schemas;
    if ($)
      if (Array.isArray($))
        this.addSchema($);
      else
        for (var q in $)
          this.addSchema($[q], q);
  }
  function P() {
    for (var $ in this.opts.formats) {
      var q = this.opts.formats[$];
      q && this.addFormat($, q);
    }
  }
  function O($) {
    if (Array.isArray($))
      this.addVocabulary($);
    else
      for (var q in this.logger.warn("keywords option as map is deprecated, pass array"), $) {
        var B = $[q];
        B.keyword || (B.keyword = q), this.addKeyword(B);
      }
  }
  function j() {
    var $, q = Ct({}, this.opts), B = ut(m);
    try {
      for (B.s(); !($ = B.n()).done; )
        delete q[$.value];
    } catch (D) {
      B.e(D);
    } finally {
      B.f();
    }
    return q;
  }
  n.default = w, w.ValidationError = o.default, w.MissingRefError = a.default;
  var V = { log: function() {
  }, warn: function() {
  }, error: function() {
  } }, E = /^[a-z_$][a-z0-9_$:-]*$/i;
  function C($, q) {
    var B = this.RULES;
    if ((0, h.eachItem)($, function(D) {
      if (B.keywords[D])
        throw new Error("Keyword ".concat(D, " is already defined"));
      if (!E.test(D))
        throw new Error("Keyword ".concat(D, " has invalid name"));
    }), q && q.$data && !("code" in q) && !("validate" in q))
      throw new Error('$data keyword must have "code" or "validate" function');
  }
  function H($, q, B) {
    var D, _ = this, L = q == null ? void 0 : q.post;
    if (B && L)
      throw new Error('keyword with "post" flag cannot have "type"');
    var J = this.RULES, st = L ? J.post : J.rules.find(function(xt) {
      return xt.type === B;
    });
    if (st || (st = { type: B, rules: [] }, J.rules.push(st)), J.keywords[$] = !0, q) {
      var ht = { keyword: $, definition: Ct(Ct({}, q), {}, { type: (0, f.getJSONTypes)(q.type), schemaType: (0, f.getJSONTypes)(q.schemaType) }) };
      q.before ? X.call(this, st, ht, q.before) : st.rules.push(ht), J.all[$] = ht, (D = q.implements) === null || D === void 0 || D.forEach(function(xt) {
        return _.addKeyword(xt);
      });
    }
  }
  function X($, q, B) {
    var D = $.rules.findIndex(function(_) {
      return _.keyword === B;
    });
    D >= 0 ? $.rules.splice(D, 0, q) : ($.rules.push(q), this.logger.warn("rule ".concat(B, " is not defined")));
  }
  function F($) {
    var q = $.metaSchema;
    q !== void 0 && ($.$data && this.opts.$data && (q = M(q)), $.validateSchema = this.compile(q, !0));
  }
  var G = { $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#" };
  function M($) {
    return { anyOf: [$, G] };
  }
}, { "./compile": 5, "./compile/codegen": 2, "./compile/ref_error": 7, "./compile/resolve": 8, "./compile/rules": 9, "./compile/util": 10, "./compile/validate": 15, "./compile/validate/dataType": 13, "./refs/data.json": 19, "./runtime/uri": 23, "./runtime/validation_error": 24 }], 19: [function(e, t, n) {
  t.exports = { $id: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#", description: "Meta-schema for $data reference (JSON AnySchema extension proposal)", type: "object", required: ["$data"], properties: { $data: { type: "string", anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }] } }, additionalProperties: !1 };
}, {}], 20: [function(e, t, n) {
  t.exports = { $schema: "http://json-schema.org/draft-07/schema#", $id: "http://json-schema.org/draft-07/schema#", title: "Core schema meta-schema", definitions: { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, nonNegativeInteger: { type: "integer", minimum: 0 }, nonNegativeIntegerDefault0: { allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, uniqueItems: !0, default: [] } }, type: ["object", "boolean"], properties: { $id: { type: "string", format: "uri-reference" }, $schema: { type: "string", format: "uri" }, $ref: { type: "string", format: "uri-reference" }, $comment: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: !0, readOnly: { type: "boolean", default: !1 }, examples: { type: "array", items: !0 }, multipleOf: { type: "number", exclusiveMinimum: 0 }, maximum: { type: "number" }, exclusiveMaximum: { type: "number" }, minimum: { type: "number" }, exclusiveMinimum: { type: "number" }, maxLength: { $ref: "#/definitions/nonNegativeInteger" }, minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { $ref: "#" }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: !0 }, maxItems: { $ref: "#/definitions/nonNegativeInteger" }, minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, uniqueItems: { type: "boolean", default: !1 }, contains: { $ref: "#" }, maxProperties: { $ref: "#/definitions/nonNegativeInteger" }, minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { $ref: "#" }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, propertyNames: { format: "regex" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, propertyNames: { $ref: "#" }, const: !0, enum: { type: "array", items: !0, minItems: 1, uniqueItems: !0 }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: !0 }] }, format: { type: "string" }, contentMediaType: { type: "string" }, contentEncoding: { type: "string" }, if: { $ref: "#" }, then: { $ref: "#" }, else: { $ref: "#" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, default: !0 };
}, {}], 21: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("fast-deep-equal");
  r.code = 'require("ajv/dist/runtime/equal").default', n.default = r;
}, { "fast-deep-equal": 63 }], 22: [function(e, t, n) {
  function r(i) {
    for (var o, a = i.length, s = 0, u = 0; u < a; )
      s++, (o = i.charCodeAt(u++)) >= 55296 && o <= 56319 && u < a && (64512 & (o = i.charCodeAt(u))) == 56320 && u++;
    return s;
  }
  Object.defineProperty(n, "__esModule", { value: !0 }), n.default = r, r.code = 'require("ajv/dist/runtime/ucs2length").default';
}, {}], 23: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("uri-js");
  r.code = 'require("ajv/dist/runtime/uri").default', n.default = r;
}, { "uri-js": 65 }], 24: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = function(i) {
    Et(a, Xl(Error));
    var o = Mt(a);
    function a(s) {
      var u;
      return Z(this, a), (u = o.call(this, "validation failed")).errors = s, u.ajv = u.validation = !0, u;
    }
    return Y(a);
  }();
  n.default = r;
}, {}], 25: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.validateAdditionalItems = void 0;
  var r = e("../../compile/codegen"), i = e("../../compile/util"), o = { keyword: "additionalItems", type: "array", schemaType: ["boolean", "object"], before: "uniqueItems", error: { message: function(s) {
    var u = s.params.len;
    return r.str(xk || (xk = ot(["must NOT have more than ", " items"])), u);
  }, params: function(s) {
    var u = s.params.len;
    return r._(jk || (jk = ot(["{limit: ", "}"])), u);
  } }, code: function(s) {
    var u = s.parentSchema, c = s.it, l = u.items;
    Array.isArray(l) ? a(s, l) : (0, i.checkStrictMode)(c, '"additionalItems" is ignored when "items" is not an array of schemas');
  } };
  function a(s, u) {
    var c = s.gen, l = s.schema, f = s.data, h = s.keyword, d = s.it;
    d.items = !0;
    var p = c.const("len", r._(Sk || (Sk = ot(["", ".length"])), f));
    if (l === !1)
      s.setParams({ len: u.length }), s.pass(r._($k || ($k = ot(["", " <= ", ""])), p, u.length));
    else if (ne(l) == "object" && !(0, i.alwaysValidSchema)(d, l)) {
      var v = c.var("valid", r._(_k || (_k = ot(["", " <= ", ""])), p, u.length));
      c.if((0, r.not)(v), function() {
        return function(m) {
          c.forRange("i", u.length, p, function(g) {
            s.subschema({ keyword: h, dataProp: g, dataPropType: i.Type.Num }, m), d.allErrors || c.if((0, r.not)(m), function() {
              return c.break();
            });
          });
        }(v);
      }), s.ok(v);
    }
  }
  n.validateAdditionalItems = a, n.default = o;
}, { "../../compile/codegen": 2, "../../compile/util": 10 }], 26: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../code"), i = e("../../compile/codegen"), o = e("../../compile/names"), a = e("../../compile/util");
  n.default = { keyword: "additionalProperties", type: ["object"], schemaType: ["boolean", "object"], allowUndefined: !0, trackErrors: !0, error: { message: "must NOT have additional properties", params: function(s) {
    var u = s.params;
    return i._(Ck || (Ck = ot(["{additionalProperty: ", "}"])), u.additionalProperty);
  } }, code: function(s) {
    var u = s.gen, c = s.schema, l = s.parentSchema, f = s.data, h = s.errsCount, d = s.it;
    if (!h)
      throw new Error("ajv implementation error");
    var p = d.allErrors, v = d.opts;
    if (d.props = !0, v.removeAdditional === "all" || !(0, a.alwaysValidSchema)(d, c)) {
      var m = (0, r.allSchemaProperties)(l.properties), g = (0, r.allSchemaProperties)(l.patternProperties);
      u.forIn("key", f, function(w) {
        m.length || g.length ? u.if(function(x) {
          var S;
          if (m.length > 8) {
            var T = (0, a.schemaRefOrVal)(d, l.properties, "properties");
            S = (0, r.isOwnProperty)(u, T, x);
          } else
            S = m.length ? i.or.apply(void 0, Pe(m.map(function(P) {
              return i._(Ak || (Ak = ot(["", " === ", ""])), x, P);
            }))) : i.nil;
          return g.length && (S = i.or.apply(void 0, [S].concat(Pe(g.map(function(P) {
            return i._(Pk || (Pk = ot(["", ".test(", ")"])), (0, r.usePattern)(s, P), x);
          }))))), (0, i.not)(S);
        }(w), function() {
          return b(w);
        }) : b(w);
      }), s.ok(i._(Ek || (Ek = ot(["", " === ", ""])), h, o.default.errors));
    }
    function y(w) {
      u.code(i._(Ok || (Ok = ot(["delete ", "[", "]"])), f, w));
    }
    function b(w) {
      if (v.removeAdditional === "all" || v.removeAdditional && c === !1)
        y(w);
      else {
        if (c === !1)
          return s.setParams({ additionalProperty: w }), s.error(), void (p || u.break());
        if (ne(c) == "object" && !(0, a.alwaysValidSchema)(d, c)) {
          var x = u.name("valid");
          v.removeAdditional === "failing" ? (k(w, x, !1), u.if((0, i.not)(x), function() {
            s.reset(), y(w);
          })) : (k(w, x), p || u.if((0, i.not)(x), function() {
            return u.break();
          }));
        }
      }
    }
    function k(w, x, S) {
      var T = { keyword: "additionalProperties", dataProp: w, dataPropType: a.Type.Str };
      S === !1 && Object.assign(T, { compositeRule: !0, createErrors: !1, allErrors: !1 }), s.subschema(T, x);
    }
  } };
}, { "../../compile/codegen": 2, "../../compile/names": 6, "../../compile/util": 10, "../code": 42 }], 27: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/util");
  n.default = { keyword: "allOf", schemaType: "array", code: function(i) {
    var o = i.gen, a = i.schema, s = i.it;
    if (!Array.isArray(a))
      throw new Error("ajv implementation error");
    var u = o.name("valid");
    a.forEach(function(c, l) {
      if (!(0, r.alwaysValidSchema)(s, c)) {
        var f = i.subschema({ keyword: "allOf", schemaProp: l }, u);
        i.ok(u), i.mergeEvaluated(f);
      }
    });
  } };
}, { "../../compile/util": 10 }], 28: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../code");
  n.default = { keyword: "anyOf", schemaType: "array", trackErrors: !0, code: r.validateUnion, error: { message: "must match a schema in anyOf" } };
}, { "../code": 42 }], 29: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../../compile/util");
  n.default = { keyword: "contains", type: "array", schemaType: ["object", "boolean"], before: "uniqueItems", trackErrors: !0, error: { message: function(o) {
    var a = o.params, s = a.min, u = a.max;
    return u === void 0 ? r.str(Mk || (Mk = ot(["must contain at least ", " valid item(s)"])), s) : r.str(Tk || (Tk = ot(["must contain at least ", " and no more than ", " valid item(s)"])), s, u);
  }, params: function(o) {
    var a = o.params, s = a.min, u = a.max;
    return u === void 0 ? r._(Ik || (Ik = ot(["{minContains: ", "}"])), s) : r._(Nk || (Nk = ot(["{minContains: ", ", maxContains: ", "}"])), s, u);
  } }, code: function(o) {
    var a, s, u = o.gen, c = o.schema, l = o.parentSchema, f = o.data, h = o.it, d = l.minContains, p = l.maxContains;
    h.opts.next ? (a = d === void 0 ? 1 : d, s = p) : a = 1;
    var v = u.const("len", r._(Rk || (Rk = ot(["", ".length"])), f));
    if (o.setParams({ min: a, max: s }), s !== void 0 || a !== 0) {
      if (s !== void 0 && a > s)
        return (0, i.checkStrictMode)(h, '"minContains" > "maxContains" is always invalid'), void o.fail();
      if ((0, i.alwaysValidSchema)(h, c)) {
        var m = r._(Dk || (Dk = ot(["", " >= ", ""])), v, a);
        return s !== void 0 && (m = r._(Lk || (Lk = ot(["", " && ", " <= ", ""])), m, v, s)), void o.pass(m);
      }
      h.items = !0;
      var g = u.name("valid");
      s === void 0 && a === 1 ? b(g, function() {
        return u.if(g, function() {
          return u.break();
        });
      }) : a === 0 ? (u.let(g, !0), s !== void 0 && u.if(r._(Vk || (Vk = ot(["", ".length > 0"])), f), y)) : (u.let(g, !1), y()), o.result(g, function() {
        return o.reset();
      });
    } else
      (0, i.checkStrictMode)(h, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
    function y() {
      var k = u.name("_valid"), w = u.let("count", 0);
      b(k, function() {
        return u.if(k, function() {
          return function(x) {
            u.code(r._(zk || (zk = ot(["", "++"])), x)), s === void 0 ? u.if(r._(Bk || (Bk = ot(["", " >= ", ""])), x, a), function() {
              return u.assign(g, !0).break();
            }) : (u.if(r._(Fk || (Fk = ot(["", " > ", ""])), x, s), function() {
              return u.assign(g, !1).break();
            }), a === 1 ? u.assign(g, !0) : u.if(r._(qk || (qk = ot(["", " >= ", ""])), x, a), function() {
              return u.assign(g, !0);
            }));
          }(w);
        });
      });
    }
    function b(k, w) {
      u.forRange("i", 0, v, function(x) {
        o.subschema({ keyword: "contains", dataProp: x, dataPropType: i.Type.Num, compositeRule: !0 }, k), w();
      });
    }
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10 }], 30: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.validateSchemaDeps = n.validatePropertyDeps = n.error = void 0;
  var r = e("../../compile/codegen"), i = e("../../compile/util"), o = e("../code");
  n.error = { message: function(c) {
    var l = c.params, f = l.property, h = l.depsCount, d = l.deps;
    return r.str(Hk || (Hk = ot(["must have ", " ", " when property ", " is present"])), h === 1 ? "property" : "properties", d, f);
  }, params: function(c) {
    var l = c.params, f = l.property, h = l.depsCount, d = l.deps, p = l.missingProperty;
    return r._(Wk || (Wk = ot(["{property: ", `,
	    missingProperty: `, `,
	    depsCount: `, `,
	    deps: `, "}"])), f, p, h, d);
  } };
  var a = { keyword: "dependencies", type: "object", schemaType: "object", error: n.error, code: function(c) {
    var l = xe(function(d) {
      var p = d.schema, v = {}, m = {};
      for (var g in p)
        g !== "__proto__" && ((Array.isArray(p[g]) ? v : m)[g] = p[g]);
      return [v, m];
    }(c), 2), f = l[0], h = l[1];
    s(c, f), u(c, h);
  } };
  function s(c) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c.schema, f = c.gen, h = c.data, d = c.it;
    if (Object.keys(l).length !== 0) {
      var p = f.let("missing"), v = function(g) {
        var y = l[g];
        if (y.length === 0)
          return "continue";
        var b = (0, o.propertyInData)(f, h, g, d.opts.ownProperties);
        c.setParams({ property: g, depsCount: y.length, deps: y.join(", ") }), d.allErrors ? f.if(b, function() {
          var k, w = ut(y);
          try {
            for (w.s(); !(k = w.n()).done; ) {
              var x = k.value;
              (0, o.checkReportMissingProp)(c, x);
            }
          } catch (S) {
            w.e(S);
          } finally {
            w.f();
          }
        }) : (f.if(r._(Uk || (Uk = ot(["", " && (", ")"])), b, (0, o.checkMissingProp)(c, y, p))), (0, o.reportMissingProp)(c, p), f.else());
      };
      for (var m in l)
        v(m);
    }
  }
  function u(c) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c.schema, f = c.gen, h = c.data, d = c.keyword, p = c.it, v = f.name("valid"), m = function(y) {
      (0, i.alwaysValidSchema)(p, l[y]) || (f.if((0, o.propertyInData)(f, h, y, p.opts.ownProperties), function() {
        var b = c.subschema({ keyword: d, schemaProp: y }, v);
        c.mergeValidEvaluated(b, v);
      }, function() {
        return f.var(v, !0);
      }), c.ok(v));
    };
    for (var g in l)
      m(g);
  }
  n.validatePropertyDeps = s, n.validateSchemaDeps = u, n.default = a;
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../code": 42 }], 31: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../../compile/util");
  function o(a, s) {
    var u = a.schema[s];
    return u !== void 0 && !(0, i.alwaysValidSchema)(a, u);
  }
  n.default = { keyword: "if", schemaType: ["object", "boolean"], trackErrors: !0, error: { message: function(a) {
    var s = a.params;
    return r.str(Jk || (Jk = ot(['must match "', '" schema'])), s.ifClause);
  }, params: function(a) {
    var s = a.params;
    return r._(Kk || (Kk = ot(["{failingKeyword: ", "}"])), s.ifClause);
  } }, code: function(a) {
    var s = a.gen, u = a.parentSchema, c = a.it;
    u.then === void 0 && u.else === void 0 && (0, i.checkStrictMode)(c, '"if" without "then" and "else" is ignored');
    var l = o(c, "then"), f = o(c, "else");
    if (l || f) {
      var h = s.let("valid", !0), d = s.name("_valid");
      if (function() {
        var m = a.subschema({ keyword: "if", compositeRule: !0, createErrors: !1, allErrors: !1 }, d);
        a.mergeEvaluated(m);
      }(), a.reset(), l && f) {
        var p = s.let("ifClause");
        a.setParams({ ifClause: p }), s.if(d, v("then", p), v("else", p));
      } else
        l ? s.if(d, v("then")) : s.if((0, r.not)(d), v("else"));
      a.pass(h, function() {
        return a.error(!0);
      });
    }
    function v(m, g) {
      return function() {
        var y = a.subschema({ keyword: m }, d);
        s.assign(h, d), a.mergeValidEvaluated(y, h), g ? s.assign(g, r._(Gk || (Gk = ot(["", ""])), m)) : a.setParams({ ifClause: m });
      };
    }
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10 }], 32: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("./additionalItems"), i = e("./prefixItems"), o = e("./items"), a = e("./items2020"), s = e("./contains"), u = e("./dependencies"), c = e("./propertyNames"), l = e("./additionalProperties"), f = e("./properties"), h = e("./patternProperties"), d = e("./not"), p = e("./anyOf"), v = e("./oneOf"), m = e("./allOf"), g = e("./if"), y = e("./thenElse");
  n.default = function() {
    var b = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], k = [d.default, p.default, v.default, m.default, g.default, y.default, c.default, l.default, u.default, f.default, h.default];
    return b ? k.push(i.default, a.default) : k.push(r.default, o.default), k.push(s.default), k;
  };
}, { "./additionalItems": 25, "./additionalProperties": 26, "./allOf": 27, "./anyOf": 28, "./contains": 29, "./dependencies": 30, "./if": 31, "./items": 33, "./items2020": 34, "./not": 35, "./oneOf": 36, "./patternProperties": 37, "./prefixItems": 38, "./properties": 39, "./propertyNames": 40, "./thenElse": 41 }], 33: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.validateTuple = void 0;
  var r = e("../../compile/codegen"), i = e("../../compile/util"), o = e("../code"), a = { keyword: "items", type: "array", schemaType: ["object", "array", "boolean"], before: "uniqueItems", code: function(u) {
    var c = u.schema, l = u.it;
    if (Array.isArray(c))
      return s(u, "additionalItems", c);
    l.items = !0, (0, i.alwaysValidSchema)(l, c) || u.ok((0, o.validateArray)(u));
  } };
  function s(u, c) {
    var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : u.schema, f = u.gen, h = u.parentSchema, d = u.data, p = u.keyword, v = u.it;
    (function(y) {
      var b = v.opts, k = v.errSchemaPath, w = l.length, x = w === y.minItems && (w === y.maxItems || y[c] === !1);
      b.strictTuples && !x && (0, i.checkStrictMode)(v, '"'.concat(p, '" is ').concat(w, "-tuple, but minItems or maxItems/").concat(c, ' are not specified or different at path "').concat(k, '"'), b.strictTuples);
    })(h), v.opts.unevaluated && l.length && v.items !== !0 && (v.items = i.mergeEvaluated.items(f, l.length, v.items));
    var m = f.name("valid"), g = f.const("len", r._(Qk || (Qk = ot(["", ".length"])), d));
    l.forEach(function(y, b) {
      (0, i.alwaysValidSchema)(v, y) || (f.if(r._(Xk || (Xk = ot(["", " > ", ""])), g, b), function() {
        return u.subschema({ keyword: p, schemaProp: b, dataProp: b }, m);
      }), u.ok(m));
    });
  }
  n.validateTuple = s, n.default = a;
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../code": 42 }], 34: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../../compile/util"), o = e("../code"), a = e("./additionalItems");
  n.default = { keyword: "items", type: "array", schemaType: ["object", "boolean"], before: "uniqueItems", error: { message: function(s) {
    var u = s.params.len;
    return r.str(Zk || (Zk = ot(["must NOT have more than ", " items"])), u);
  }, params: function(s) {
    var u = s.params.len;
    return r._(Yk || (Yk = ot(["{limit: ", "}"])), u);
  } }, code: function(s) {
    var u = s.schema, c = s.parentSchema, l = s.it, f = c.prefixItems;
    l.items = !0, (0, i.alwaysValidSchema)(l, u) || (f ? (0, a.validateAdditionalItems)(s, f) : s.ok((0, o.validateArray)(s)));
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../code": 42, "./additionalItems": 25 }], 35: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/util");
  n.default = { keyword: "not", schemaType: ["object", "boolean"], trackErrors: !0, code: function(i) {
    var o = i.gen, a = i.schema, s = i.it;
    if ((0, r.alwaysValidSchema)(s, a))
      i.fail();
    else {
      var u = o.name("valid");
      i.subschema({ keyword: "not", compositeRule: !0, createErrors: !1, allErrors: !1 }, u), i.failResult(u, function() {
        return i.reset();
      }, function() {
        return i.error();
      });
    }
  }, error: { message: "must NOT be valid" } };
}, { "../../compile/util": 10 }], 36: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../../compile/util");
  n.default = { keyword: "oneOf", schemaType: "array", trackErrors: !0, error: { message: "must match exactly one schema in oneOf", params: function(o) {
    var a = o.params;
    return r._(tw || (tw = ot(["{passingSchemas: ", "}"])), a.passing);
  } }, code: function(o) {
    var a = o.gen, s = o.schema, u = o.parentSchema, c = o.it;
    if (!Array.isArray(s))
      throw new Error("ajv implementation error");
    if (!c.opts.discriminator || !u.discriminator) {
      var l = s, f = a.let("valid", !1), h = a.let("passing", null), d = a.name("_valid");
      o.setParams({ passing: h }), a.block(function() {
        l.forEach(function(p, v) {
          var m;
          (0, i.alwaysValidSchema)(c, p) ? a.var(d, !0) : m = o.subschema({ keyword: "oneOf", schemaProp: v, compositeRule: !0 }, d), v > 0 && a.if(r._(ew || (ew = ot(["", " && ", ""])), d, f)).assign(f, !1).assign(h, r._(nw || (nw = ot(["[", ", ", "]"])), h, v)).else(), a.if(d, function() {
            a.assign(f, !0), a.assign(h, v), m && o.mergeEvaluated(m, r.Name);
          });
        });
      }), o.result(f, function() {
        return o.reset();
      }, function() {
        return o.error(!0);
      });
    }
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10 }], 37: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../code"), i = e("../../compile/codegen"), o = e("../../compile/util"), a = e("../../compile/util");
  n.default = { keyword: "patternProperties", type: "object", schemaType: "object", code: function(s) {
    var u = s.gen, c = s.schema, l = s.data, f = s.parentSchema, h = s.it, d = h.opts, p = (0, r.allSchemaProperties)(c), v = p.filter(function(w) {
      return (0, o.alwaysValidSchema)(h, c[w]);
    });
    if (p.length !== 0 && (v.length !== p.length || h.opts.unevaluated && h.props !== !0)) {
      var m = d.strictSchema && !d.allowMatchingProperties && f.properties, g = u.name("valid");
      h.props === !0 || h.props instanceof i.Name || (h.props = (0, a.evaluatedPropsToName)(u, h.props));
      var y = h.props;
      (function() {
        var w, x = ut(p);
        try {
          for (x.s(); !(w = x.n()).done; ) {
            var S = w.value;
            m && b(S), h.allErrors ? k(S) : (u.var(g, !0), k(S), u.if(g));
          }
        } catch (T) {
          x.e(T);
        } finally {
          x.f();
        }
      })();
    }
    function b(w) {
      for (var x in m)
        new RegExp(w).test(x) && (0, o.checkStrictMode)(h, "property ".concat(x, " matches pattern ").concat(w, " (use allowMatchingProperties)"));
    }
    function k(w) {
      u.forIn("key", l, function(x) {
        u.if(i._(rw || (rw = ot(["", ".test(", ")"])), (0, r.usePattern)(s, w), x), function() {
          var S = v.includes(w);
          S || s.subschema({ keyword: "patternProperties", schemaProp: w, dataProp: x, dataPropType: a.Type.Str }, g), h.opts.unevaluated && y !== !0 ? u.assign(i._(iw || (iw = ot(["", "[", "]"])), y, x), !0) : S || h.allErrors || u.if((0, i.not)(g), function() {
            return u.break();
          });
        });
      });
    }
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../code": 42 }], 38: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("./items");
  n.default = { keyword: "prefixItems", type: "array", schemaType: ["array"], before: "uniqueItems", code: function(i) {
    return (0, r.validateTuple)(i, "items");
  } };
}, { "./items": 33 }], 39: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/validate"), i = e("../code"), o = e("../../compile/util"), a = e("./additionalProperties");
  n.default = { keyword: "properties", type: "object", schemaType: "object", code: function(s) {
    var u = s.gen, c = s.schema, l = s.parentSchema, f = s.data, h = s.it;
    h.opts.removeAdditional === "all" && l.additionalProperties === void 0 && a.default.code(new r.KeywordCxt(h, a.default, "additionalProperties"));
    var d, p = (0, i.allSchemaProperties)(c), v = ut(p);
    try {
      for (v.s(); !(d = v.n()).done; ) {
        var m = d.value;
        h.definedProperties.add(m);
      }
    } catch (T) {
      v.e(T);
    } finally {
      v.f();
    }
    h.opts.unevaluated && p.length && h.props !== !0 && (h.props = o.mergeEvaluated.props(u, (0, o.toHash)(p), h.props));
    var g = p.filter(function(T) {
      return !(0, o.alwaysValidSchema)(h, c[T]);
    });
    if (g.length !== 0) {
      var y, b = u.name("valid"), k = ut(g);
      try {
        for (k.s(); !(y = k.n()).done; ) {
          var w = y.value;
          x(w) ? S(w) : (u.if((0, i.propertyInData)(u, f, w, h.opts.ownProperties)), S(w), h.allErrors || u.else().var(b, !0), u.endIf()), s.it.definedProperties.add(w), s.ok(b);
        }
      } catch (T) {
        k.e(T);
      } finally {
        k.f();
      }
    }
    function x(T) {
      return h.opts.useDefaults && !h.compositeRule && c[T].default !== void 0;
    }
    function S(T) {
      s.subschema({ keyword: "properties", schemaProp: T, dataProp: T }, b);
    }
  } };
}, { "../../compile/util": 10, "../../compile/validate": 15, "../code": 42, "./additionalProperties": 26 }], 40: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../../compile/util");
  n.default = { keyword: "propertyNames", type: "object", schemaType: ["object", "boolean"], error: { message: "property name must be valid", params: function(o) {
    var a = o.params;
    return r._(ow || (ow = ot(["{propertyName: ", "}"])), a.propertyName);
  } }, code: function(o) {
    var a = o.gen, s = o.schema, u = o.data, c = o.it;
    if (!(0, i.alwaysValidSchema)(c, s)) {
      var l = a.name("valid");
      a.forIn("key", u, function(f) {
        o.setParams({ propertyName: f }), o.subschema({ keyword: "propertyNames", data: f, dataTypes: ["string"], propertyName: f, compositeRule: !0 }, l), a.if((0, r.not)(l), function() {
          o.error(!0), c.allErrors || a.break();
        });
      }), o.ok(l);
    }
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10 }], 41: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/util");
  n.default = { keyword: ["then", "else"], schemaType: ["object", "boolean"], code: function(i) {
    var o = i.keyword, a = i.parentSchema, s = i.it;
    a.if === void 0 && (0, r.checkStrictMode)(s, '"'.concat(o, '" without "if" is ignored'));
  } };
}, { "../../compile/util": 10 }], 42: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.validateUnion = n.validateArray = n.usePattern = n.callValidateCode = n.schemaProperties = n.allSchemaProperties = n.noPropertyInData = n.propertyInData = n.isOwnProperty = n.hasPropFunc = n.reportMissingProp = n.checkMissingProp = n.checkReportMissingProp = void 0;
  var r = e("../compile/codegen"), i = e("../compile/util"), o = e("../compile/names"), a = e("../compile/util");
  function s(h) {
    return h.scopeValue("func", { ref: Object.prototype.hasOwnProperty, code: r._(aw || (aw = ot(["Object.prototype.hasOwnProperty"]))) });
  }
  function u(h, d, p) {
    return r._(sw || (sw = ot(["", ".call(", ", ", ")"])), s(h), d, p);
  }
  function c(h, d, p, v) {
    var m = r._(uw || (uw = ot(["", "", " === undefined"])), d, (0, r.getProperty)(p));
    return v ? (0, r.or)(m, (0, r.not)(u(h, d, p))) : m;
  }
  function l(h) {
    return h ? Object.keys(h).filter(function(d) {
      return d !== "__proto__";
    }) : [];
  }
  n.checkReportMissingProp = function(h, d) {
    var p = h.gen, v = h.data, m = h.it;
    p.if(c(p, v, d, m.opts.ownProperties), function() {
      h.setParams({ missingProperty: r._(cw || (cw = ot(["", ""])), d) }, !0), h.error();
    });
  }, n.checkMissingProp = function(h, d, p) {
    var v = h.gen, m = h.data, g = h.it.opts;
    return r.or.apply(void 0, Pe(d.map(function(y) {
      return (0, r.and)(c(v, m, y, g.ownProperties), r._(lw || (lw = ot(["", " = ", ""])), p, y));
    })));
  }, n.reportMissingProp = function(h, d) {
    h.setParams({ missingProperty: d }, !0), h.error();
  }, n.hasPropFunc = s, n.isOwnProperty = u, n.propertyInData = function(h, d, p, v) {
    var m = r._(fw || (fw = ot(["", "", " !== undefined"])), d, (0, r.getProperty)(p));
    return v ? r._(hw || (hw = ot(["", " && ", ""])), m, u(h, d, p)) : m;
  }, n.noPropertyInData = c, n.allSchemaProperties = l, n.schemaProperties = function(h, d) {
    return l(d).filter(function(p) {
      return !(0, i.alwaysValidSchema)(h, d[p]);
    });
  }, n.callValidateCode = function(h, d, p, v) {
    var m = h.schemaCode, g = h.data, y = h.it, b = y.gen, k = y.topSchemaRef, w = y.schemaPath, x = y.errorPath, S = h.it, T = v ? r._(dw || (dw = ot(["", ", ", ", ", "", ""])), m, g, k, w) : g, P = [[o.default.instancePath, (0, r.strConcat)(o.default.instancePath, x)], [o.default.parentData, S.parentData], [o.default.parentDataProperty, S.parentDataProperty], [o.default.rootData, o.default.rootData]];
    S.opts.dynamicRef && P.push([o.default.dynamicAnchors, o.default.dynamicAnchors]);
    var O = r._(vw || (vw = ot(["", ", ", ""])), T, b.object.apply(b, P));
    return p !== r.nil ? r._(pw || (pw = ot(["", ".call(", ", ", ")"])), d, p, O) : r._(mw || (mw = ot(["", "(", ")"])), d, O);
  };
  var f = r._(gw || (gw = ot(["new RegExp"])));
  n.usePattern = function(h, d) {
    var p = h.gen, v = h.it.opts, m = v.unicodeRegExp ? "u" : "", g = v.code.regExp, y = g(d, m);
    return p.scopeValue("pattern", { key: y.toString(), ref: y, code: r._(yw || (yw = ot(["", "(", ", ", ")"])), g.code === "new RegExp" ? f : (0, a.useFunc)(p, g), d, m) });
  }, n.validateArray = function(h) {
    var d = h.gen, p = h.data, v = h.keyword, m = h.it, g = d.name("valid");
    if (m.allErrors) {
      var y = d.let("valid", !0);
      return b(function() {
        return d.assign(y, !1);
      }), y;
    }
    return d.var(g, !0), b(function() {
      return d.break();
    }), g;
    function b(k) {
      var w = d.const("len", r._(bw || (bw = ot(["", ".length"])), p));
      d.forRange("i", 0, w, function(x) {
        h.subschema({ keyword: v, dataProp: x, dataPropType: i.Type.Num }, g), d.if((0, r.not)(g), k);
      });
    }
  }, n.validateUnion = function(h) {
    var d = h.gen, p = h.schema, v = h.keyword, m = h.it;
    if (!Array.isArray(p))
      throw new Error("ajv implementation error");
    if (!p.some(function(b) {
      return (0, i.alwaysValidSchema)(m, b);
    }) || m.opts.unevaluated) {
      var g = d.let("valid", !1), y = d.name("_valid");
      d.block(function() {
        return p.forEach(function(b, k) {
          var w = h.subschema({ keyword: v, schemaProp: k, compositeRule: !0 }, y);
          d.assign(g, r._(kw || (kw = ot(["", " || ", ""])), g, y)), h.mergeValidEvaluated(w, y) || d.if((0, r.not)(g));
        });
      }), h.result(g, function() {
        return h.reset();
      }, function() {
        return h.error(!0);
      });
    }
  };
}, { "../compile/codegen": 2, "../compile/names": 6, "../compile/util": 10 }], 43: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.default = { keyword: "id", code: function() {
    throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
  } };
}, {}], 44: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("./id"), i = e("./ref");
  n.default = ["$schema", "$id", "$defs", "$vocabulary", { keyword: "$comment" }, "definitions", r.default, i.default];
}, { "./id": 43, "./ref": 45 }], 45: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.callRef = n.getValidate = void 0;
  var r = e("../../compile/ref_error"), i = e("../code"), o = e("../../compile/codegen"), a = e("../../compile/names"), s = e("../../compile"), u = e("../../compile/util"), c = { keyword: "$ref", schemaType: "string", code: function(h) {
    var d = h.gen, p = h.schema, v = h.it, m = v.baseId, g = v.schemaEnv, y = v.validateName, b = v.opts, k = v.self, w = g.root;
    if ((p === "#" || p === "#/") && m === w.baseId)
      return function() {
        if (g === w)
          return f(h, y, g, g.$async);
        var S = d.scopeValue("root", { ref: w });
        return f(h, o._(ww || (ww = ot(["", ".validate"])), S), w, w.$async);
      }();
    var x = s.resolveRef.call(k, w, m, p);
    if (x === void 0)
      throw new r.default(v.opts.uriResolver, m, p);
    return x instanceof s.SchemaEnv ? function(S) {
      var T = l(h, S);
      f(h, T, S, S.$async);
    }(x) : function(S) {
      var T = d.scopeValue("schema", b.code.source === !0 ? { ref: S, code: (0, o.stringify)(S) } : { ref: S }), P = d.name("valid"), O = h.subschema({ schema: S, dataTypes: [], schemaPath: o.nil, topSchemaRef: T, errSchemaPath: p }, P);
      h.mergeEvaluated(O), h.ok(P);
    }(x);
  } };
  function l(h, d) {
    var p = h.gen;
    return d.validate ? p.scopeValue("validate", { ref: d.validate }) : o._(xw || (xw = ot(["", ".validate"])), p.scopeValue("wrapper", { ref: d }));
  }
  function f(h, d, p, v) {
    var m = h.gen, g = h.it, y = g.allErrors, b = g.schemaEnv, k = g.opts.passContext ? a.default.this : o.nil;
    function w(S) {
      var T = o._(jw || (jw = ot(["", ".errors"])), S);
      m.assign(a.default.vErrors, o._(Sw || (Sw = ot(["", " === null ? ", " : ", ".concat(", ")"])), a.default.vErrors, T, a.default.vErrors, T)), m.assign(a.default.errors, o._($w || ($w = ot(["", ".length"])), a.default.vErrors));
    }
    function x(S) {
      var T;
      if (g.opts.unevaluated) {
        var P = (T = p == null ? void 0 : p.validate) === null || T === void 0 ? void 0 : T.evaluated;
        if (g.props !== !0)
          if (P && !P.dynamicProps)
            P.props !== void 0 && (g.props = u.mergeEvaluated.props(m, P.props, g.props));
          else {
            var O = m.var("props", o._(_w || (_w = ot(["", ".evaluated.props"])), S));
            g.props = u.mergeEvaluated.props(m, O, g.props, o.Name);
          }
        if (g.items !== !0)
          if (P && !P.dynamicItems)
            P.items !== void 0 && (g.items = u.mergeEvaluated.items(m, P.items, g.items));
          else {
            var j = m.var("items", o._(Cw || (Cw = ot(["", ".evaluated.items"])), S));
            g.items = u.mergeEvaluated.items(m, j, g.items, o.Name);
          }
      }
    }
    v ? function() {
      if (!b.$async)
        throw new Error("async schema referenced by sync schema");
      var S = m.let("valid");
      m.try(function() {
        m.code(o._(Ow || (Ow = ot(["await ", ""])), (0, i.callValidateCode)(h, d, k))), x(d), y || m.assign(S, !0);
      }, function(T) {
        m.if(o._(Aw || (Aw = ot(["!(", " instanceof ", ")"])), T, g.ValidationError), function() {
          return m.throw(T);
        }), w(T), y || m.assign(S, !1);
      }), h.ok(S);
    }() : h.result((0, i.callValidateCode)(h, d, k), function() {
      return x(d);
    }, function() {
      return w(d);
    });
  }
  n.getValidate = l, n.callRef = f, n.default = c;
}, { "../../compile": 5, "../../compile/codegen": 2, "../../compile/names": 6, "../../compile/ref_error": 7, "../../compile/util": 10, "../code": 42 }], 46: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../discriminator/types"), o = e("../../compile"), a = e("../../compile/util");
  n.default = { keyword: "discriminator", type: "object", schemaType: "object", error: { message: function(s) {
    var u = s.params, c = u.discrError, l = u.tagName;
    return c === i.DiscrError.Tag ? 'tag "'.concat(l, '" must be string') : 'value of tag "'.concat(l, '" must be in oneOf');
  }, params: function(s) {
    var u = s.params, c = u.discrError, l = u.tag, f = u.tagName;
    return r._(Pw || (Pw = ot(["{error: ", ", tag: ", ", tagValue: ", "}"])), c, f, l);
  } }, code: function(s) {
    var u = s.gen, c = s.data, l = s.schema, f = s.parentSchema, h = s.it, d = f.oneOf;
    if (!h.opts.discriminator)
      throw new Error("discriminator: requires discriminator option");
    var p = l.propertyName;
    if (typeof p != "string")
      throw new Error("discriminator: requires propertyName");
    if (l.mapping)
      throw new Error("discriminator: mapping is not supported");
    if (!d)
      throw new Error("discriminator: requires oneOf keyword");
    var v = u.let("valid", !1), m = u.const("tag", r._(Ew || (Ew = ot(["", "", ""])), c, (0, r.getProperty)(p)));
    function g(y) {
      var b = u.name("valid"), k = s.subschema({ keyword: "oneOf", schemaProp: y }, b);
      return s.mergeEvaluated(k, r.Name), b;
    }
    u.if(r._(Mw || (Mw = ot(["typeof ", ' == "string"'])), m), function() {
      return function() {
        var y = function() {
          for (var k, w = {}, x = j(f), S = !0, T = 0; T < d.length; T++) {
            var P = d[T];
            (P == null ? void 0 : P.$ref) && !(0, a.schemaHasRulesButRef)(P, h.self.RULES) && (P = o.resolveRef.call(h.self, h.schemaEnv.root, h.baseId, P == null ? void 0 : P.$ref)) instanceof o.SchemaEnv && (P = P.schema);
            var O = (k = P == null ? void 0 : P.properties) === null || k === void 0 ? void 0 : k[p];
            if (ne(O) != "object")
              throw new Error('discriminator: oneOf subschemas (or referenced schemas) must have "properties/'.concat(p, '"'));
            S = S && (x || j(P)), V(O, T);
          }
          if (!S)
            throw new Error('discriminator: "'.concat(p, '" must be required'));
          return w;
          function j(C) {
            var H = C.required;
            return Array.isArray(H) && H.includes(p);
          }
          function V(C, H) {
            if (C.const)
              E(C.const, H);
            else {
              if (!C.enum)
                throw new Error('discriminator: "properties/'.concat(p, '" must have "const" or "enum"'));
              var X, F = ut(C.enum);
              try {
                for (F.s(); !(X = F.n()).done; )
                  E(X.value, H);
              } catch (G) {
                F.e(G);
              } finally {
                F.f();
              }
            }
          }
          function E(C, H) {
            if (typeof C != "string" || C in w)
              throw new Error('discriminator: "'.concat(p, '" values must be unique strings'));
            w[C] = H;
          }
        }();
        for (var b in u.if(!1), y)
          u.elseIf(r._(Tw || (Tw = ot(["", " === ", ""])), m, b)), u.assign(v, g(y[b]));
        u.else(), s.error(!1, { discrError: i.DiscrError.Mapping, tag: m, tagName: p }), u.endIf();
      }();
    }, function() {
      return s.error(!1, { discrError: i.DiscrError.Tag, tag: m, tagName: p });
    }), s.ok(v);
  } };
}, { "../../compile": 5, "../../compile/codegen": 2, "../../compile/util": 10, "../discriminator/types": 47 }], 47: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.DiscrError = void 0, function(r) {
    r.Tag = "tag", r.Mapping = "mapping";
  }(n.DiscrError || (n.DiscrError = {}));
}, {}], 48: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("./core"), i = e("./validation"), o = e("./applicator"), a = e("./format"), s = e("./metadata"), u = [r.default, i.default, (0, o.default)(), a.default, s.metadataVocabulary, s.contentVocabulary];
  n.default = u;
}, { "./applicator": 32, "./core": 44, "./format": 50, "./metadata": 51, "./validation": 54 }], 49: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen");
  n.default = { keyword: "format", type: ["number", "string"], schemaType: "string", $data: !0, error: { message: function(i) {
    var o = i.schemaCode;
    return r.str(Iw || (Iw = ot(['must match format "', '"'])), o);
  }, params: function(i) {
    var o = i.schemaCode;
    return r._(Nw || (Nw = ot(["{format: ", "}"])), o);
  } }, code: function(i, o) {
    var a = i.gen, s = i.data, u = i.$data, c = i.schema, l = i.schemaCode, f = i.it, h = f.opts, d = f.errSchemaPath, p = f.schemaEnv, v = f.self;
    h.validateFormats && (u ? function() {
      var m = a.scopeValue("formats", { ref: v.formats, code: h.code.formats }), g = a.const("fDef", r._(Rw || (Rw = ot(["", "[", "]"])), m, l)), y = a.let("fType"), b = a.let("format");
      a.if(r._(Dw || (Dw = ot(["typeof ", ' == "object" && !(', " instanceof RegExp)"])), g, g), function() {
        return a.assign(y, r._(Lw || (Lw = ot(["", '.type || "string"'])), g)).assign(b, r._(zw || (zw = ot(["", ".validate"])), g));
      }, function() {
        return a.assign(y, r._(Bw || (Bw = ot(['"string"'])))).assign(b, g);
      }), i.fail$data((0, r.or)(h.strictSchema === !1 ? r.nil : r._(Fw || (Fw = ot(["", " && !", ""])), l, b), function() {
        var k = p.$async ? r._(qw || (qw = ot(["(", ".async ? await ", "(", ") : ", "(", "))"])), g, b, s, b, s) : r._(Vw || (Vw = ot(["", "(", ")"])), b, s), w = r._(Hw || (Hw = ot(["(typeof ", ' == "function" ? ', " : ", ".test(", "))"])), b, k, b, s);
        return r._(Ww || (Ww = ot(["", " && ", " !== true && ", " === ", " && !", ""])), b, b, y, o, w);
      }()));
    }() : function() {
      var m = v.formats[c];
      if (m) {
        if (m !== !0) {
          var g = xe(function(w) {
            var x = w instanceof RegExp ? (0, r.regexpCode)(w) : h.code.formats ? r._(Uw || (Uw = ot(["", "", ""])), h.code.formats, (0, r.getProperty)(c)) : void 0, S = a.scopeValue("formats", { key: c, ref: w, code: x });
            return ne(w) != "object" || w instanceof RegExp ? ["string", w, S] : [w.type || "string", w.validate, r._(Jw || (Jw = ot(["", ".validate"])), S)];
          }(m), 3), y = g[0], b = g[1], k = g[2];
          y === o && i.pass(function() {
            if (ne(m) == "object" && !(m instanceof RegExp) && m.async) {
              if (!p.$async)
                throw new Error("async format in sync schema");
              return r._(Kw || (Kw = ot(["await ", "(", ")"])), k, s);
            }
            return typeof b == "function" ? r._(Gw || (Gw = ot(["", "(", ")"])), k, s) : r._(Qw || (Qw = ot(["", ".test(", ")"])), k, s);
          }());
        }
      } else
        (function() {
          if (h.strictSchema !== !1)
            throw new Error(w());
          function w() {
            return 'unknown format "'.concat(c, '" ignored in schema at path "').concat(d, '"');
          }
          v.logger.warn(w());
        })();
    }());
  } };
}, { "../../compile/codegen": 2 }], 50: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("./format");
  n.default = [r.default];
}, { "./format": 49 }], 51: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.contentVocabulary = n.metadataVocabulary = void 0, n.metadataVocabulary = ["title", "description", "default", "deprecated", "readOnly", "writeOnly", "examples"], n.contentVocabulary = ["contentMediaType", "contentEncoding", "contentSchema"];
}, {}], 52: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../../compile/util"), o = e("../../runtime/equal");
  n.default = { keyword: "const", $data: !0, error: { message: "must be equal to constant", params: function(a) {
    var s = a.schemaCode;
    return r._(Xw || (Xw = ot(["{allowedValue: ", "}"])), s);
  } }, code: function(a) {
    var s = a.gen, u = a.data, c = a.$data, l = a.schemaCode, f = a.schema;
    c || f && ne(f) == "object" ? a.fail$data(r._(Zw || (Zw = ot(["!", "(", ", ", ")"])), (0, i.useFunc)(s, o.default), u, l)) : a.fail(r._(Yw || (Yw = ot(["", " !== ", ""])), f, u));
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../../runtime/equal": 21 }], 53: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../../compile/util"), o = e("../../runtime/equal");
  n.default = { keyword: "enum", schemaType: "array", $data: !0, error: { message: "must be equal to one of the allowed values", params: function(a) {
    var s = a.schemaCode;
    return r._(t2 || (t2 = ot(["{allowedValues: ", "}"])), s);
  } }, code: function(a) {
    var s, u = a.gen, c = a.data, l = a.$data, f = a.schema, h = a.schemaCode, d = a.it;
    if (!l && f.length === 0)
      throw new Error("enum must have non-empty array");
    var p, v = function() {
      return s != null ? s : s = (0, i.useFunc)(u, o.default);
    };
    if (f.length >= d.opts.loopEnum || l)
      p = u.let("valid"), a.block$data(p, function() {
        u.assign(p, !1), u.forOf("v", h, function(g) {
          return u.if(r._(e2 || (e2 = ot(["", "(", ", ", ")"])), v(), c, g), function() {
            return u.assign(p, !0).break();
          });
        });
      });
    else {
      if (!Array.isArray(f))
        throw new Error("ajv implementation error");
      var m = u.const("vSchema", h);
      p = r.or.apply(void 0, Pe(f.map(function(g, y) {
        return function(b, k) {
          var w = f[k];
          return ne(w) == "object" && w !== null ? r._(n2 || (n2 = ot(["", "(", ", ", "[", "])"])), v(), c, b, k) : r._(r2 || (r2 = ot(["", " === ", ""])), c, w);
        }(m, y);
      })));
    }
    a.pass(p);
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../../runtime/equal": 21 }], 54: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("./limitNumber"), i = e("./multipleOf"), o = e("./limitLength"), a = e("./pattern"), s = e("./limitProperties"), u = e("./required"), c = e("./limitItems"), l = e("./uniqueItems"), f = e("./const"), h = e("./enum");
  n.default = [r.default, i.default, o.default, a.default, s.default, u.default, c.default, l.default, { keyword: "type", schemaType: ["string", "array"] }, { keyword: "nullable", schemaType: "boolean" }, f.default, h.default];
}, { "./const": 52, "./enum": 53, "./limitItems": 55, "./limitLength": 56, "./limitNumber": 57, "./limitProperties": 58, "./multipleOf": 59, "./pattern": 60, "./required": 61, "./uniqueItems": 62 }], 55: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen");
  n.default = { keyword: ["maxItems", "minItems"], type: "array", schemaType: "number", $data: !0, error: { message: function(i) {
    var o = i.keyword, a = i.schemaCode;
    return r.str(i2 || (i2 = ot(["must NOT have ", " than ", " items"])), o === "maxItems" ? "more" : "fewer", a);
  }, params: function(i) {
    var o = i.schemaCode;
    return r._(o2 || (o2 = ot(["{limit: ", "}"])), o);
  } }, code: function(i) {
    var o = i.keyword, a = i.data, s = i.schemaCode;
    i.fail$data(r._(a2 || (a2 = ot(["", ".length ", " ", ""])), a, o === "maxItems" ? r.operators.GT : r.operators.LT, s));
  } };
}, { "../../compile/codegen": 2 }], 56: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = e("../../compile/util"), o = e("../../runtime/ucs2length");
  n.default = { keyword: ["maxLength", "minLength"], type: "string", schemaType: "number", $data: !0, error: { message: function(a) {
    var s = a.keyword, u = a.schemaCode;
    return r.str(s2 || (s2 = ot(["must NOT have ", " than ", " characters"])), s === "maxLength" ? "more" : "fewer", u);
  }, params: function(a) {
    var s = a.schemaCode;
    return r._(u2 || (u2 = ot(["{limit: ", "}"])), s);
  } }, code: function(a) {
    var s = a.keyword, u = a.data, c = a.schemaCode, l = a.it, f = s === "maxLength" ? r.operators.GT : r.operators.LT, h = l.opts.unicode === !1 ? r._(c2 || (c2 = ot(["", ".length"])), u) : r._(l2 || (l2 = ot(["", "(", ")"])), (0, i.useFunc)(a.gen, o.default), u);
    a.fail$data(r._(f2 || (f2 = ot(["", " ", " ", ""])), h, f, c));
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../../runtime/ucs2length": 22 }], 57: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen"), i = r.operators, o = { maximum: { okStr: "<=", ok: i.LTE, fail: i.GT }, minimum: { okStr: ">=", ok: i.GTE, fail: i.LT }, exclusiveMaximum: { okStr: "<", ok: i.LT, fail: i.GTE }, exclusiveMinimum: { okStr: ">", ok: i.GT, fail: i.LTE } }, a = { message: function(u) {
    var c = u.keyword, l = u.schemaCode;
    return r.str(h2 || (h2 = ot(["must be ", " ", ""])), o[c].okStr, l);
  }, params: function(u) {
    var c = u.keyword, l = u.schemaCode;
    return r._(d2 || (d2 = ot(["{comparison: ", ", limit: ", "}"])), o[c].okStr, l);
  } }, s = { keyword: Object.keys(o), type: "number", schemaType: "number", $data: !0, error: a, code: function(u) {
    var c = u.keyword, l = u.data, f = u.schemaCode;
    u.fail$data(r._(v2 || (v2 = ot(["", " ", " ", " || isNaN(", ")"])), l, o[c].fail, f, l));
  } };
  n.default = s;
}, { "../../compile/codegen": 2 }], 58: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen");
  n.default = { keyword: ["maxProperties", "minProperties"], type: "object", schemaType: "number", $data: !0, error: { message: function(i) {
    var o = i.keyword, a = i.schemaCode;
    return r.str(p2 || (p2 = ot(["must NOT have ", " than ", " properties"])), o === "maxProperties" ? "more" : "fewer", a);
  }, params: function(i) {
    var o = i.schemaCode;
    return r._(m2 || (m2 = ot(["{limit: ", "}"])), o);
  } }, code: function(i) {
    var o = i.keyword, a = i.data, s = i.schemaCode;
    i.fail$data(r._(g2 || (g2 = ot(["Object.keys(", ").length ", " ", ""])), a, o === "maxProperties" ? r.operators.GT : r.operators.LT, s));
  } };
}, { "../../compile/codegen": 2 }], 59: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/codegen");
  n.default = { keyword: "multipleOf", type: "number", schemaType: "number", $data: !0, error: { message: function(i) {
    var o = i.schemaCode;
    return r.str(y2 || (y2 = ot(["must be multiple of ", ""])), o);
  }, params: function(i) {
    var o = i.schemaCode;
    return r._(b2 || (b2 = ot(["{multipleOf: ", "}"])), o);
  } }, code: function(i) {
    var o = i.gen, a = i.data, s = i.schemaCode, u = i.it.opts.multipleOfPrecision, c = o.let("res"), l = u ? r._(k2 || (k2 = ot(["Math.abs(Math.round(", ") - ", ") > 1e-", ""])), c, c, u) : r._(w2 || (w2 = ot(["", " !== parseInt(", ")"])), c, c);
    i.fail$data(r._(x2 || (x2 = ot(["(", " === 0 || (", " = ", "/", ", ", "))"])), s, c, a, s, l));
  } };
}, { "../../compile/codegen": 2 }], 60: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../code"), i = e("../../compile/codegen");
  n.default = { keyword: "pattern", type: "string", schemaType: "string", $data: !0, error: { message: function(o) {
    var a = o.schemaCode;
    return i.str(j2 || (j2 = ot(['must match pattern "', '"'])), a);
  }, params: function(o) {
    var a = o.schemaCode;
    return i._(S2 || (S2 = ot(["{pattern: ", "}"])), a);
  } }, code: function(o) {
    var a = o.data, s = o.$data, u = o.schema, c = o.schemaCode, l = o.it, f = s ? i._($2 || ($2 = ot(["(new RegExp(", ", ", "))"])), c, l.opts.unicodeRegExp ? "u" : "") : (0, r.usePattern)(o, u);
    o.fail$data(i._(_2 || (_2 = ot(["!", ".test(", ")"])), f, a));
  } };
}, { "../../compile/codegen": 2, "../code": 42 }], 61: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../code"), i = e("../../compile/codegen"), o = e("../../compile/util");
  n.default = { keyword: "required", type: "object", schemaType: "array", $data: !0, error: { message: function(a) {
    var s = a.params.missingProperty;
    return i.str(C2 || (C2 = ot(["must have required property '", "'"])), s);
  }, params: function(a) {
    var s = a.params.missingProperty;
    return i._(O2 || (O2 = ot(["{missingProperty: ", "}"])), s);
  } }, code: function(a) {
    var s = a.gen, u = a.schema, c = a.schemaCode, l = a.data, f = a.$data, h = a.it, d = h.opts;
    if (f || u.length !== 0) {
      var p = u.length >= d.loopRequired;
      if (h.allErrors ? function() {
        if (p || f)
          a.block$data(i.nil, k);
        else {
          var w, x = ut(u);
          try {
            for (x.s(); !(w = x.n()).done; ) {
              var S = w.value;
              (0, r.checkReportMissingProp)(a, S);
            }
          } catch (T) {
            x.e(T);
          } finally {
            x.f();
          }
        }
      }() : function() {
        var w = s.let("missing");
        if (p || f) {
          var x = s.let("valid", !0);
          a.block$data(x, function() {
            return function(S, T) {
              a.setParams({ missingProperty: S }), s.forOf(S, c, function() {
                s.assign(T, (0, r.propertyInData)(s, l, S, d.ownProperties)), s.if((0, i.not)(T), function() {
                  a.error(), s.break();
                });
              }, i.nil);
            }(w, x);
          }), a.ok(x);
        } else
          s.if((0, r.checkMissingProp)(a, u, w)), (0, r.reportMissingProp)(a, w), s.else();
      }(), d.strictRequired) {
        var v, m = a.parentSchema.properties, g = a.it.definedProperties, y = ut(u);
        try {
          for (y.s(); !(v = y.n()).done; ) {
            var b = v.value;
            (m == null ? void 0 : m[b]) !== void 0 || g.has(b) || (0, o.checkStrictMode)(h, 'required property "'.concat(b, '" is not defined at "').concat(h.schemaEnv.baseId + h.errSchemaPath, '" (strictRequired)'), h.opts.strictRequired);
          }
        } catch (w) {
          y.e(w);
        } finally {
          y.f();
        }
      }
    }
    function k() {
      s.forOf("prop", c, function(w) {
        a.setParams({ missingProperty: w }), s.if((0, r.noPropertyInData)(s, l, w, d.ownProperties), function() {
          return a.error();
        });
      });
    }
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../code": 42 }], 62: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var r = e("../../compile/validate/dataType"), i = e("../../compile/codegen"), o = e("../../compile/util"), a = e("../../runtime/equal");
  n.default = { keyword: "uniqueItems", type: "array", schemaType: "boolean", $data: !0, error: { message: function(s) {
    var u = s.params, c = u.i, l = u.j;
    return i.str(A2 || (A2 = ot(["must NOT have duplicate items (items ## ", " and ", " are identical)"])), l, c);
  }, params: function(s) {
    var u = s.params, c = u.i, l = u.j;
    return i._(P2 || (P2 = ot(["{i: ", ", j: ", "}"])), c, l);
  } }, code: function(s) {
    var u = s.gen, c = s.data, l = s.$data, f = s.schema, h = s.parentSchema, d = s.schemaCode, p = s.it;
    if (l || f) {
      var v = u.let("valid"), m = h.items ? (0, r.getSchemaTypes)(h.items) : [];
      s.block$data(v, function() {
        var b = u.let("i", i._(V2 || (V2 = ot(["", ".length"])), c)), k = u.let("j");
        s.setParams({ i: b, j: k }), u.assign(v, !0), u.if(i._(H2 || (H2 = ot(["", " > 1"])), b), function() {
          return (m.length > 0 && !m.some(function(w) {
            return w === "object" || w === "array";
          }) ? g : y)(b, k);
        });
      }, i._(W2 || (W2 = ot(["", " === false"])), d)), s.ok(v);
    }
    function g(b, k) {
      var w = u.name("item"), x = (0, r.checkDataTypes)(m, w, p.opts.strictNumbers, r.DataType.Wrong), S = u.const("indices", i._(E2 || (E2 = ot(["{}"]))));
      u.for(i._(M2 || (M2 = ot([";", "--;"])), b), function() {
        u.let(w, i._(T2 || (T2 = ot(["", "[", "]"])), c, b)), u.if(x, i._(I2 || (I2 = ot(["continue"])))), m.length > 1 && u.if(i._(N2 || (N2 = ot(["typeof ", ' == "string"'])), w), i._(R2 || (R2 = ot(["", ' += "_"'])), w)), u.if(i._(D2 || (D2 = ot(["typeof ", "[", '] == "number"'])), S, w), function() {
          u.assign(k, i._(L2 || (L2 = ot(["", "[", "]"])), S, w)), s.error(), u.assign(v, !1).break();
        }).code(i._(z2 || (z2 = ot(["", "[", "] = ", ""])), S, w, b));
      });
    }
    function y(b, k) {
      var w = (0, o.useFunc)(u, a.default), x = u.name("outer");
      u.label(x).for(i._(B2 || (B2 = ot([";", "--;"])), b), function() {
        return u.for(i._(F2 || (F2 = ot(["", " = ", "; ", "--;"])), k, b, k), function() {
          return u.if(i._(q2 || (q2 = ot(["", "(", "[", "], ", "[", "])"])), w, c, b, c, k), function() {
            s.error(), u.assign(v, !1).break(x);
          });
        });
      });
    }
  } };
}, { "../../compile/codegen": 2, "../../compile/util": 10, "../../compile/validate/dataType": 13, "../../runtime/equal": 21 }], 63: [function(e, t, n) {
  t.exports = function r(i, o) {
    if (i === o)
      return !0;
    if (i && o && ne(i) == "object" && ne(o) == "object") {
      if (i.constructor !== o.constructor)
        return !1;
      var a, s, u;
      if (Array.isArray(i)) {
        if ((a = i.length) != o.length)
          return !1;
        for (s = a; s-- != 0; )
          if (!r(i[s], o[s]))
            return !1;
        return !0;
      }
      if (i.constructor === RegExp)
        return i.source === o.source && i.flags === o.flags;
      if (i.valueOf !== Object.prototype.valueOf)
        return i.valueOf() === o.valueOf();
      if (i.toString !== Object.prototype.toString)
        return i.toString() === o.toString();
      if ((a = (u = Object.keys(i)).length) !== Object.keys(o).length)
        return !1;
      for (s = a; s-- != 0; )
        if (!Object.prototype.hasOwnProperty.call(o, u[s]))
          return !1;
      for (s = a; s-- != 0; ) {
        var c = u[s];
        if (!r(i[c], o[c]))
          return !1;
      }
      return !0;
    }
    return i != i && o != o;
  };
}, {}], 64: [function(e, t, n) {
  var r = t.exports = function(o, a, s) {
    typeof a == "function" && (s = a, a = {}), i(a, typeof (s = a.cb || s) == "function" ? s : s.pre || function() {
    }, s.post || function() {
    }, o, "", o);
  };
  function i(o, a, s, u, c, l, f, h, d, p) {
    if (u && ne(u) == "object" && !Array.isArray(u)) {
      for (var v in a(u, c, l, f, h, d, p), u) {
        var m = u[v];
        if (Array.isArray(m)) {
          if (v in r.arrayKeywords)
            for (var g = 0; g < m.length; g++)
              i(o, a, s, m[g], c + "/" + v + "/" + g, l, c, v, u, g);
        } else if (v in r.propsKeywords) {
          if (m && ne(m) == "object")
            for (var y in m)
              i(o, a, s, m[y], c + "/" + v + "/" + y.replace(/~/g, "~0").replace(/\//g, "~1"), l, c, v, u, y);
        } else
          (v in r.keywords || o.allKeys && !(v in r.skipKeywords)) && i(o, a, s, m, c + "/" + v, l, c, v, u);
      }
      s(u, c, l, f, h, d, p);
    }
  }
  r.keywords = { additionalItems: !0, items: !0, contains: !0, additionalProperties: !0, propertyNames: !0, not: !0, if: !0, then: !0, else: !0 }, r.arrayKeywords = { items: !0, allOf: !0, anyOf: !0, oneOf: !0 }, r.propsKeywords = { $defs: !0, definitions: !0, properties: !0, patternProperties: !0, dependencies: !0 }, r.skipKeywords = { default: !0, enum: !0, const: !0, required: !0, maximum: !0, minimum: !0, exclusiveMaximum: !0, exclusiveMinimum: !0, multipleOf: !0, maxLength: !0, minLength: !0, pattern: !0, format: !0, maxItems: !0, minItems: !0, uniqueItems: !0, maxProperties: !0, minProperties: !0 };
}, {}], 65: [function(e, t, n) {
  /** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
  (function(r, i) {
    i(ne(n) == "object" && t !== void 0 ? n : r.URI = r.URI || {});
  })(this, function(r) {
    function i() {
      for (var nt = arguments.length, ct = Array(nt), lt = 0; lt < nt; lt++)
        ct[lt] = arguments[lt];
      if (ct.length > 1) {
        ct[0] = ct[0].slice(0, -1);
        for (var wt = ct.length - 1, Rt = 1; Rt < wt; ++Rt)
          ct[Rt] = ct[Rt].slice(1, -1);
        return ct[wt] = ct[wt].slice(1), ct.join("");
      }
      return ct[0];
    }
    function o(nt) {
      return "(?:" + nt + ")";
    }
    function a(nt) {
      return nt === void 0 ? "undefined" : nt === null ? "null" : Object.prototype.toString.call(nt).split(" ").pop().split("]").shift().toLowerCase();
    }
    function s(nt) {
      return nt.toUpperCase();
    }
    function u(nt) {
      var ct = "[A-Za-z]", lt = "[0-9]", wt = i(lt, "[A-Fa-f]"), Rt = o(o("%[EFef]" + wt + "%" + wt + wt + "%" + wt + wt) + "|" + o("%[89A-Fa-f]" + wt + "%" + wt + wt) + "|" + o("%" + wt + wt)), Bt = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", ee = i("[\\:\\/\\?\\#\\[\\]\\@]", Bt), ie = nt ? "[\\uE000-\\uF8FF]" : "[]", gt = i(ct, lt, "[\\-\\.\\_\\~]", nt ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]");
      o(ct + i(ct, lt, "[\\+\\-\\.]") + "*"), o(o(Rt + "|" + i(gt, Bt, "[\\:]")) + "*");
      var Kt = o(o("25[0-5]") + "|" + o("2[0-4][0-9]") + "|" + o("1[0-9][0-9]") + "|" + o("0?[1-9][0-9]") + "|0?0?" + lt), ae = o(Kt + "\\." + Kt + "\\." + Kt + "\\." + Kt), Yt = o(wt + "{1,4}"), se = o(o(Yt + "\\:" + Yt) + "|" + ae), Ae = o(o(Yt + "\\:") + "{6}" + se), me = o("\\:\\:" + o(Yt + "\\:") + "{5}" + se), Se = o(o(Yt) + "?\\:\\:" + o(Yt + "\\:") + "{4}" + se), Oe = o(o(o(Yt + "\\:") + "{0,1}" + Yt) + "?\\:\\:" + o(Yt + "\\:") + "{3}" + se), Ee = o(o(o(Yt + "\\:") + "{0,2}" + Yt) + "?\\:\\:" + o(Yt + "\\:") + "{2}" + se), kn = o(o(o(Yt + "\\:") + "{0,3}" + Yt) + "?\\:\\:" + Yt + "\\:" + se), Yn = o(o(o(Yt + "\\:") + "{0,4}" + Yt) + "?\\:\\:" + se), It = o(o(o(Yt + "\\:") + "{0,5}" + Yt) + "?\\:\\:" + Yt), un = o(o(o(Yt + "\\:") + "{0,6}" + Yt) + "?\\:\\:"), hn = o([Ae, me, Se, Oe, Ee, kn, Yn, It, un].join("|")), tn = o(o(gt + "|" + Rt) + "+");
      o("[vV]" + wt + "+\\." + i(gt, Bt, "[\\:]") + "+"), o(o(Rt + "|" + i(gt, Bt)) + "*");
      var on = o(Rt + "|" + i(gt, Bt, "[\\:\\@]"));
      return o(o(Rt + "|" + i(gt, Bt, "[\\@]")) + "+"), o(o(on + "|" + i("[\\/\\?]", ie)) + "*"), { NOT_SCHEME: new RegExp(i("[^]", ct, lt, "[\\+\\-\\.]"), "g"), NOT_USERINFO: new RegExp(i("[^\\%\\:]", gt, Bt), "g"), NOT_HOST: new RegExp(i("[^\\%\\[\\]\\:]", gt, Bt), "g"), NOT_PATH: new RegExp(i("[^\\%\\/\\:\\@]", gt, Bt), "g"), NOT_PATH_NOSCHEME: new RegExp(i("[^\\%\\/\\@]", gt, Bt), "g"), NOT_QUERY: new RegExp(i("[^\\%]", gt, Bt, "[\\:\\@\\/\\?]", ie), "g"), NOT_FRAGMENT: new RegExp(i("[^\\%]", gt, Bt, "[\\:\\@\\/\\?]"), "g"), ESCAPE: new RegExp(i("[^]", gt, Bt), "g"), UNRESERVED: new RegExp(gt, "g"), OTHER_CHARS: new RegExp(i("[^\\%]", gt, ee), "g"), PCT_ENCODED: new RegExp(Rt, "g"), IPV4ADDRESS: new RegExp("^(" + ae + ")$"), IPV6ADDRESS: new RegExp("^\\[?(" + hn + ")" + o(o("\\%25|\\%(?!" + wt + "{2})") + "(" + tn + ")") + "?\\]?$") };
    }
    var c = u(!1), l = u(!0), f = function(nt, ct) {
      if (Array.isArray(nt))
        return nt;
      if (Symbol.iterator in Object(nt))
        return function(lt, wt) {
          var Rt = [], Bt = !0, ee = !1, ie = void 0;
          try {
            for (var gt, Kt = lt[Symbol.iterator](); !(Bt = (gt = Kt.next()).done) && (Rt.push(gt.value), !wt || Rt.length !== wt); Bt = !0)
              ;
          } catch (ae) {
            ee = !0, ie = ae;
          } finally {
            try {
              !Bt && Kt.return && Kt.return();
            } finally {
              if (ee)
                throw ie;
            }
          }
          return Rt;
        }(nt, ct);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }, h = 2147483647, d = 36, p = /^xn--/, v = /[^\0-\x7E]/, m = /[\x2E\u3002\uFF0E\uFF61]/g, g = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, y = Math.floor, b = String.fromCharCode;
    function k(nt) {
      throw new RangeError(g[nt]);
    }
    function w(nt, ct) {
      var lt = nt.split("@"), wt = "";
      lt.length > 1 && (wt = lt[0] + "@", nt = lt[1]);
      var Rt = function(Bt, ee) {
        for (var ie = [], gt = Bt.length; gt--; )
          ie[gt] = ee(Bt[gt]);
        return ie;
      }((nt = nt.replace(m, ".")).split("."), ct).join(".");
      return wt + Rt;
    }
    function x(nt) {
      for (var ct = [], lt = 0, wt = nt.length; lt < wt; ) {
        var Rt = nt.charCodeAt(lt++);
        if (Rt >= 55296 && Rt <= 56319 && lt < wt) {
          var Bt = nt.charCodeAt(lt++);
          (64512 & Bt) == 56320 ? ct.push(((1023 & Rt) << 10) + (1023 & Bt) + 65536) : (ct.push(Rt), lt--);
        } else
          ct.push(Rt);
      }
      return ct;
    }
    var S = function(nt, ct) {
      return nt + 22 + 75 * (nt < 26) - ((ct != 0) << 5);
    }, T = function(nt, ct, lt) {
      var wt = 0;
      for (nt = lt ? y(nt / 700) : nt >> 1, nt += y(nt / ct); nt > 455; wt += d)
        nt = y(nt / 35);
      return y(wt + 36 * nt / (nt + 38));
    }, P = function(nt) {
      var ct, lt = [], wt = nt.length, Rt = 0, Bt = 128, ee = 72, ie = nt.lastIndexOf("-");
      ie < 0 && (ie = 0);
      for (var gt = 0; gt < ie; ++gt)
        nt.charCodeAt(gt) >= 128 && k("not-basic"), lt.push(nt.charCodeAt(gt));
      for (var Kt = ie > 0 ? ie + 1 : 0; Kt < wt; ) {
        for (var ae = Rt, Yt = 1, se = d; ; se += d) {
          Kt >= wt && k("invalid-input");
          var Ae = (ct = nt.charCodeAt(Kt++)) - 48 < 10 ? ct - 22 : ct - 65 < 26 ? ct - 65 : ct - 97 < 26 ? ct - 97 : d;
          (Ae >= d || Ae > y((h - Rt) / Yt)) && k("overflow"), Rt += Ae * Yt;
          var me = se <= ee ? 1 : se >= ee + 26 ? 26 : se - ee;
          if (Ae < me)
            break;
          var Se = d - me;
          Yt > y(h / Se) && k("overflow"), Yt *= Se;
        }
        var Oe = lt.length + 1;
        ee = T(Rt - ae, Oe, ae == 0), y(Rt / Oe) > h - Bt && k("overflow"), Bt += y(Rt / Oe), Rt %= Oe, lt.splice(Rt++, 0, Bt);
      }
      return String.fromCodePoint.apply(String, lt);
    }, O = function(nt) {
      var ct = [], lt = (nt = x(nt)).length, wt = 128, Rt = 0, Bt = 72, ee = !0, ie = !1, gt = void 0;
      try {
        for (var Kt, ae = nt[Symbol.iterator](); !(ee = (Kt = ae.next()).done); ee = !0) {
          var Yt = Kt.value;
          Yt < 128 && ct.push(b(Yt));
        }
      } catch (Pr) {
        ie = !0, gt = Pr;
      } finally {
        try {
          !ee && ae.return && ae.return();
        } finally {
          if (ie)
            throw gt;
        }
      }
      var se = ct.length, Ae = se;
      for (se && ct.push("-"); Ae < lt; ) {
        var me = h, Se = !0, Oe = !1, Ee = void 0;
        try {
          for (var kn, Yn = nt[Symbol.iterator](); !(Se = (kn = Yn.next()).done); Se = !0) {
            var It = kn.value;
            It >= wt && It < me && (me = It);
          }
        } catch (Pr) {
          Oe = !0, Ee = Pr;
        } finally {
          try {
            !Se && Yn.return && Yn.return();
          } finally {
            if (Oe)
              throw Ee;
          }
        }
        var un = Ae + 1;
        me - wt > y((h - Rt) / un) && k("overflow"), Rt += (me - wt) * un, wt = me;
        var hn = !0, tn = !1, on = void 0;
        try {
          for (var an, oi = nt[Symbol.iterator](); !(hn = (an = oi.next()).done); hn = !0) {
            var Hi = an.value;
            if (Hi < wt && ++Rt > h && k("overflow"), Hi == wt) {
              for (var wn = Rt, re = d; ; re += d) {
                var Ie = re <= Bt ? 1 : re >= Bt + 26 ? 26 : re - Bt;
                if (wn < Ie)
                  break;
                var ai = wn - Ie, xi = d - Ie;
                ct.push(b(S(Ie + ai % xi, 0))), wn = y(ai / xi);
              }
              ct.push(b(S(wn, 0))), Bt = T(Rt, un, Ae == se), Rt = 0, ++Ae;
            }
          }
        } catch (Pr) {
          tn = !0, on = Pr;
        } finally {
          try {
            !hn && oi.return && oi.return();
          } finally {
            if (tn)
              throw on;
          }
        }
        ++Rt, ++wt;
      }
      return ct.join("");
    }, j = function(nt) {
      return w(nt, function(ct) {
        return v.test(ct) ? "xn--" + O(ct) : ct;
      });
    }, V = function(nt) {
      return w(nt, function(ct) {
        return p.test(ct) ? P(ct.slice(4).toLowerCase()) : ct;
      });
    }, E = {};
    function C(nt) {
      var ct = nt.charCodeAt(0);
      return ct < 16 ? "%0" + ct.toString(16).toUpperCase() : ct < 128 ? "%" + ct.toString(16).toUpperCase() : ct < 2048 ? "%" + (ct >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & ct | 128).toString(16).toUpperCase() : "%" + (ct >> 12 | 224).toString(16).toUpperCase() + "%" + (ct >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & ct | 128).toString(16).toUpperCase();
    }
    function H(nt) {
      for (var ct = "", lt = 0, wt = nt.length; lt < wt; ) {
        var Rt = parseInt(nt.substr(lt + 1, 2), 16);
        if (Rt < 128)
          ct += String.fromCharCode(Rt), lt += 3;
        else if (Rt >= 194 && Rt < 224) {
          if (wt - lt >= 6) {
            var Bt = parseInt(nt.substr(lt + 4, 2), 16);
            ct += String.fromCharCode((31 & Rt) << 6 | 63 & Bt);
          } else
            ct += nt.substr(lt, 6);
          lt += 6;
        } else if (Rt >= 224) {
          if (wt - lt >= 9) {
            var ee = parseInt(nt.substr(lt + 4, 2), 16), ie = parseInt(nt.substr(lt + 7, 2), 16);
            ct += String.fromCharCode((15 & Rt) << 12 | (63 & ee) << 6 | 63 & ie);
          } else
            ct += nt.substr(lt, 9);
          lt += 9;
        } else
          ct += nt.substr(lt, 3), lt += 3;
      }
      return ct;
    }
    function X(nt, ct) {
      function lt(wt) {
        var Rt = H(wt);
        return Rt.match(ct.UNRESERVED) ? Rt : wt;
      }
      return nt.scheme && (nt.scheme = String(nt.scheme).replace(ct.PCT_ENCODED, lt).toLowerCase().replace(ct.NOT_SCHEME, "")), nt.userinfo !== void 0 && (nt.userinfo = String(nt.userinfo).replace(ct.PCT_ENCODED, lt).replace(ct.NOT_USERINFO, C).replace(ct.PCT_ENCODED, s)), nt.host !== void 0 && (nt.host = String(nt.host).replace(ct.PCT_ENCODED, lt).toLowerCase().replace(ct.NOT_HOST, C).replace(ct.PCT_ENCODED, s)), nt.path !== void 0 && (nt.path = String(nt.path).replace(ct.PCT_ENCODED, lt).replace(nt.scheme ? ct.NOT_PATH : ct.NOT_PATH_NOSCHEME, C).replace(ct.PCT_ENCODED, s)), nt.query !== void 0 && (nt.query = String(nt.query).replace(ct.PCT_ENCODED, lt).replace(ct.NOT_QUERY, C).replace(ct.PCT_ENCODED, s)), nt.fragment !== void 0 && (nt.fragment = String(nt.fragment).replace(ct.PCT_ENCODED, lt).replace(ct.NOT_FRAGMENT, C).replace(ct.PCT_ENCODED, s)), nt;
    }
    function F(nt) {
      return nt.replace(/^0*(.*)/, "$1") || "0";
    }
    function G(nt, ct) {
      var lt = nt.match(ct.IPV4ADDRESS) || [], wt = f(lt, 2)[1];
      return wt ? wt.split(".").map(F).join(".") : nt;
    }
    function M(nt, ct) {
      var lt = nt.match(ct.IPV6ADDRESS) || [], wt = f(lt, 3), Rt = wt[1], Bt = wt[2];
      if (Rt) {
        for (var ee = Rt.toLowerCase().split("::").reverse(), ie = f(ee, 2), gt = ie[0], Kt = ie[1], ae = Kt ? Kt.split(":").map(F) : [], Yt = gt.split(":").map(F), se = ct.IPV4ADDRESS.test(Yt[Yt.length - 1]), Ae = se ? 7 : 8, me = Yt.length - Ae, Se = Array(Ae), Oe = 0; Oe < Ae; ++Oe)
          Se[Oe] = ae[Oe] || Yt[me + Oe] || "";
        se && (Se[Ae - 1] = G(Se[Ae - 1], ct));
        var Ee = Se.reduce(function(un, hn, tn) {
          if (!hn || hn === "0") {
            var on = un[un.length - 1];
            on && on.index + on.length === tn ? on.length++ : un.push({ index: tn, length: 1 });
          }
          return un;
        }, []).sort(function(un, hn) {
          return hn.length - un.length;
        })[0], kn = void 0;
        if (Ee && Ee.length > 1) {
          var Yn = Se.slice(0, Ee.index), It = Se.slice(Ee.index + Ee.length);
          kn = Yn.join(":") + "::" + It.join(":");
        } else
          kn = Se.join(":");
        return Bt && (kn += "%" + Bt), kn;
      }
      return nt;
    }
    var $ = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, q = "".match(/(){0}/)[1] === void 0;
    function B(nt) {
      var ct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, lt = {}, wt = ct.iri !== !1 ? l : c;
      ct.reference === "suffix" && (nt = (ct.scheme ? ct.scheme + ":" : "") + "//" + nt);
      var Rt = nt.match($);
      if (Rt) {
        q ? (lt.scheme = Rt[1], lt.userinfo = Rt[3], lt.host = Rt[4], lt.port = parseInt(Rt[5], 10), lt.path = Rt[6] || "", lt.query = Rt[7], lt.fragment = Rt[8], isNaN(lt.port) && (lt.port = Rt[5])) : (lt.scheme = Rt[1] || void 0, lt.userinfo = nt.indexOf("@") !== -1 ? Rt[3] : void 0, lt.host = nt.indexOf("//") !== -1 ? Rt[4] : void 0, lt.port = parseInt(Rt[5], 10), lt.path = Rt[6] || "", lt.query = nt.indexOf("?") !== -1 ? Rt[7] : void 0, lt.fragment = nt.indexOf("#") !== -1 ? Rt[8] : void 0, isNaN(lt.port) && (lt.port = nt.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? Rt[4] : void 0)), lt.host && (lt.host = M(G(lt.host, wt), wt)), lt.reference = lt.scheme !== void 0 || lt.userinfo !== void 0 || lt.host !== void 0 || lt.port !== void 0 || lt.path || lt.query !== void 0 ? lt.scheme === void 0 ? "relative" : lt.fragment === void 0 ? "absolute" : "uri" : "same-document", ct.reference && ct.reference !== "suffix" && ct.reference !== lt.reference && (lt.error = lt.error || "URI is not a " + ct.reference + " reference.");
        var Bt = E[(ct.scheme || lt.scheme || "").toLowerCase()];
        if (ct.unicodeSupport || Bt && Bt.unicodeSupport)
          X(lt, wt);
        else {
          if (lt.host && (ct.domainHost || Bt && Bt.domainHost))
            try {
              lt.host = j(lt.host.replace(wt.PCT_ENCODED, H).toLowerCase());
            } catch (ee) {
              lt.error = lt.error || "Host's domain name can not be converted to ASCII via punycode: " + ee;
            }
          X(lt, c);
        }
        Bt && Bt.parse && Bt.parse(lt, ct);
      } else
        lt.error = lt.error || "URI can not be parsed.";
      return lt;
    }
    function D(nt, ct) {
      var lt = ct.iri !== !1 ? l : c, wt = [];
      return nt.userinfo !== void 0 && (wt.push(nt.userinfo), wt.push("@")), nt.host !== void 0 && wt.push(M(G(String(nt.host), lt), lt).replace(lt.IPV6ADDRESS, function(Rt, Bt, ee) {
        return "[" + Bt + (ee ? "%25" + ee : "") + "]";
      })), typeof nt.port != "number" && typeof nt.port != "string" || (wt.push(":"), wt.push(String(nt.port))), wt.length ? wt.join("") : void 0;
    }
    var _ = /^\.\.?\//, L = /^\/\.(\/|$)/, J = /^\/\.\.(\/|$)/, st = /^\/?(?:.|\n)*?(?=\/|$)/;
    function ht(nt) {
      for (var ct = []; nt.length; )
        if (nt.match(_))
          nt = nt.replace(_, "");
        else if (nt.match(L))
          nt = nt.replace(L, "/");
        else if (nt.match(J))
          nt = nt.replace(J, "/"), ct.pop();
        else if (nt === "." || nt === "..")
          nt = "";
        else {
          var lt = nt.match(st);
          if (!lt)
            throw new Error("Unexpected dot segment condition");
          var wt = lt[0];
          nt = nt.slice(wt.length), ct.push(wt);
        }
      return ct.join("");
    }
    function xt(nt) {
      var ct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, lt = ct.iri ? l : c, wt = [], Rt = E[(ct.scheme || nt.scheme || "").toLowerCase()];
      if (Rt && Rt.serialize && Rt.serialize(nt, ct), nt.host && !lt.IPV6ADDRESS.test(nt.host)) {
        if (ct.domainHost || Rt && Rt.domainHost)
          try {
            nt.host = ct.iri ? V(nt.host) : j(nt.host.replace(lt.PCT_ENCODED, H).toLowerCase());
          } catch (ie) {
            nt.error = nt.error || "Host's domain name can not be converted to " + (ct.iri ? "Unicode" : "ASCII") + " via punycode: " + ie;
          }
      }
      X(nt, lt), ct.reference !== "suffix" && nt.scheme && (wt.push(nt.scheme), wt.push(":"));
      var Bt = D(nt, ct);
      if (Bt !== void 0 && (ct.reference !== "suffix" && wt.push("//"), wt.push(Bt), nt.path && nt.path.charAt(0) !== "/" && wt.push("/")), nt.path !== void 0) {
        var ee = nt.path;
        ct.absolutePath || Rt && Rt.absolutePath || (ee = ht(ee)), Bt === void 0 && (ee = ee.replace(/^\/\//, "/%2F")), wt.push(ee);
      }
      return nt.query !== void 0 && (wt.push("?"), wt.push(nt.query)), nt.fragment !== void 0 && (wt.push("#"), wt.push(nt.fragment)), wt.join("");
    }
    function kt(nt, ct) {
      var lt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, wt = {};
      return arguments[3] || (nt = B(xt(nt, lt), lt), ct = B(xt(ct, lt), lt)), !(lt = lt || {}).tolerant && ct.scheme ? (wt.scheme = ct.scheme, wt.userinfo = ct.userinfo, wt.host = ct.host, wt.port = ct.port, wt.path = ht(ct.path || ""), wt.query = ct.query) : (ct.userinfo !== void 0 || ct.host !== void 0 || ct.port !== void 0 ? (wt.userinfo = ct.userinfo, wt.host = ct.host, wt.port = ct.port, wt.path = ht(ct.path || ""), wt.query = ct.query) : (ct.path ? (ct.path.charAt(0) === "/" ? wt.path = ht(ct.path) : (wt.path = nt.userinfo === void 0 && nt.host === void 0 && nt.port === void 0 || nt.path ? nt.path ? nt.path.slice(0, nt.path.lastIndexOf("/") + 1) + ct.path : ct.path : "/" + ct.path, wt.path = ht(wt.path)), wt.query = ct.query) : (wt.path = nt.path, wt.query = ct.query !== void 0 ? ct.query : nt.query), wt.userinfo = nt.userinfo, wt.host = nt.host, wt.port = nt.port), wt.scheme = nt.scheme), wt.fragment = ct.fragment, wt;
    }
    function I(nt, ct) {
      return nt && nt.toString().replace(ct && ct.iri ? l.PCT_ENCODED : c.PCT_ENCODED, H);
    }
    var R = { scheme: "http", domainHost: !0, parse: function(nt, ct) {
      return nt.host || (nt.error = nt.error || "HTTP URIs must have a host."), nt;
    }, serialize: function(nt, ct) {
      var lt = String(nt.scheme).toLowerCase() === "https";
      return nt.port !== (lt ? 443 : 80) && nt.port !== "" || (nt.port = void 0), nt.path || (nt.path = "/"), nt;
    } }, it = { scheme: "https", domainHost: R.domainHost, parse: R.parse, serialize: R.serialize };
    function N(nt) {
      return typeof nt.secure == "boolean" ? nt.secure : String(nt.scheme).toLowerCase() === "wss";
    }
    var K = { scheme: "ws", domainHost: !0, parse: function(nt, ct) {
      var lt = nt;
      return lt.secure = N(lt), lt.resourceName = (lt.path || "/") + (lt.query ? "?" + lt.query : ""), lt.path = void 0, lt.query = void 0, lt;
    }, serialize: function(nt, ct) {
      if (nt.port !== (N(nt) ? 443 : 80) && nt.port !== "" || (nt.port = void 0), typeof nt.secure == "boolean" && (nt.scheme = nt.secure ? "wss" : "ws", nt.secure = void 0), nt.resourceName) {
        var lt = nt.resourceName.split("?"), wt = f(lt, 2), Rt = wt[0], Bt = wt[1];
        nt.path = Rt && Rt !== "/" ? Rt : void 0, nt.query = Bt, nt.resourceName = void 0;
      }
      return nt.fragment = void 0, nt;
    } }, z = { scheme: "wss", domainHost: K.domainHost, parse: K.parse, serialize: K.serialize }, at = {}, yt = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", jt = "[0-9A-Fa-f]", Ft = o(o("%[EFef][0-9A-Fa-f]%" + jt + jt + "%" + jt + jt) + "|" + o("%[89A-Fa-f][0-9A-Fa-f]%" + jt + jt) + "|" + o("%" + jt + jt)), zt = i("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), St = new RegExp(yt, "g"), Gt = new RegExp(Ft, "g"), _e = new RegExp(i("[^]", "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", "[\\.]", '[\\"]', zt), "g"), Fe = new RegExp(i("[^]", yt, "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]"), "g"), fn = Fe;
    function De(nt) {
      var ct = H(nt);
      return ct.match(St) ? ct : nt;
    }
    var $t = { scheme: "mailto", parse: function(nt, ct) {
      var lt = nt, wt = lt.to = lt.path ? lt.path.split(",") : [];
      if (lt.path = void 0, lt.query) {
        for (var Rt = !1, Bt = {}, ee = lt.query.split("&"), ie = 0, gt = ee.length; ie < gt; ++ie) {
          var Kt = ee[ie].split("=");
          switch (Kt[0]) {
            case "to":
              for (var ae = Kt[1].split(","), Yt = 0, se = ae.length; Yt < se; ++Yt)
                wt.push(ae[Yt]);
              break;
            case "subject":
              lt.subject = I(Kt[1], ct);
              break;
            case "body":
              lt.body = I(Kt[1], ct);
              break;
            default:
              Rt = !0, Bt[I(Kt[0], ct)] = I(Kt[1], ct);
          }
        }
        Rt && (lt.headers = Bt);
      }
      lt.query = void 0;
      for (var Ae = 0, me = wt.length; Ae < me; ++Ae) {
        var Se = wt[Ae].split("@");
        if (Se[0] = I(Se[0]), ct.unicodeSupport)
          Se[1] = I(Se[1], ct).toLowerCase();
        else
          try {
            Se[1] = j(I(Se[1], ct).toLowerCase());
          } catch (Oe) {
            lt.error = lt.error || "Email address's domain name can not be converted to ASCII via punycode: " + Oe;
          }
        wt[Ae] = Se.join("@");
      }
      return lt;
    }, serialize: function(nt, ct) {
      var lt, wt = nt, Rt = (lt = nt.to) != null ? lt instanceof Array ? lt : typeof lt.length != "number" || lt.split || lt.setInterval || lt.call ? [lt] : Array.prototype.slice.call(lt) : [];
      if (Rt) {
        for (var Bt = 0, ee = Rt.length; Bt < ee; ++Bt) {
          var ie = String(Rt[Bt]), gt = ie.lastIndexOf("@"), Kt = ie.slice(0, gt).replace(Gt, De).replace(Gt, s).replace(_e, C), ae = ie.slice(gt + 1);
          try {
            ae = ct.iri ? V(ae) : j(I(ae, ct).toLowerCase());
          } catch (me) {
            wt.error = wt.error || "Email address's domain name can not be converted to " + (ct.iri ? "Unicode" : "ASCII") + " via punycode: " + me;
          }
          Rt[Bt] = Kt + "@" + ae;
        }
        wt.path = Rt.join(",");
      }
      var Yt = nt.headers = nt.headers || {};
      nt.subject && (Yt.subject = nt.subject), nt.body && (Yt.body = nt.body);
      var se = [];
      for (var Ae in Yt)
        Yt[Ae] !== at[Ae] && se.push(Ae.replace(Gt, De).replace(Gt, s).replace(Fe, C) + "=" + Yt[Ae].replace(Gt, De).replace(Gt, s).replace(fn, C));
      return se.length && (wt.query = se.join("&")), wt;
    } }, oe = /^([^\:]+)\:(.*)/, Ce = { scheme: "urn", parse: function(nt, ct) {
      var lt = nt.path && nt.path.match(oe), wt = nt;
      if (lt) {
        var Rt = ct.scheme || wt.scheme || "urn", Bt = lt[1].toLowerCase(), ee = lt[2], ie = E[Rt + ":" + (ct.nid || Bt)];
        wt.nid = Bt, wt.nss = ee, wt.path = void 0, ie && (wt = ie.parse(wt, ct));
      } else
        wt.error = wt.error || "URN can not be parsed.";
      return wt;
    }, serialize: function(nt, ct) {
      var lt = nt.nid, wt = E[(ct.scheme || nt.scheme || "urn") + ":" + (ct.nid || lt)];
      wt && (nt = wt.serialize(nt, ct));
      var Rt = nt;
      return Rt.path = (lt || ct.nid) + ":" + nt.nss, Rt;
    } }, sn = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, vn = { scheme: "urn:uuid", parse: function(nt, ct) {
      var lt = nt;
      return lt.uuid = lt.nss, lt.nss = void 0, ct.tolerant || lt.uuid && lt.uuid.match(sn) || (lt.error = lt.error || "UUID is not valid."), lt;
    }, serialize: function(nt, ct) {
      var lt = nt;
      return lt.nss = (nt.uuid || "").toLowerCase(), lt;
    } };
    E[R.scheme] = R, E[it.scheme] = it, E[K.scheme] = K, E[z.scheme] = z, E[$t.scheme] = $t, E[Ce.scheme] = Ce, E[vn.scheme] = vn, r.SCHEMES = E, r.pctEncChar = C, r.pctDecChars = H, r.parse = B, r.removeDotSegments = ht, r.serialize = xt, r.resolveComponents = kt, r.resolve = function(nt, ct, lt) {
      var wt = function(Rt, Bt) {
        var ee = { scheme: "null" };
        if (Bt)
          for (var ie in Bt)
            ee[ie] = Bt[ie];
        return ee;
      }(0, lt);
      return xt(kt(B(nt, wt), B(ct, wt), wt, !0), wt);
    }, r.normalize = function(nt, ct) {
      return typeof nt == "string" ? nt = xt(B(nt, ct), ct) : a(nt) === "object" && (nt = B(xt(nt, ct), ct)), nt;
    }, r.equal = function(nt, ct, lt) {
      return typeof nt == "string" ? nt = xt(B(nt, lt), lt) : a(nt) === "object" && (nt = xt(nt, lt)), typeof ct == "string" ? ct = xt(B(ct, lt), lt) : a(ct) === "object" && (ct = xt(ct, lt)), nt === ct;
    }, r.escapeComponent = function(nt, ct) {
      return nt && nt.toString().replace(ct && ct.iri ? l.ESCAPE : c.ESCAPE, C);
    }, r.unescapeComponent = I, Object.defineProperty(r, "__esModule", { value: !0 });
  });
}, {}], ajv: [function(e, t, n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.CodeGen = n.Name = n.nil = n.stringify = n.str = n._ = n.KeywordCxt = void 0;
  var r = e("./core"), i = e("./vocabularies/draft7"), o = e("./vocabularies/discriminator"), a = e("./refs/json-schema-draft-07.json"), s = ["/properties"], u = "http://json-schema.org/draft-07/schema", c = function(h) {
    Et(p, h);
    var d = Mt(p);
    function p() {
      return Z(this, p), d.apply(this, arguments);
    }
    return Y(p, [{ key: "_addVocabularies", value: function() {
      var v = this;
      Je(qe(p.prototype), "_addVocabularies", this).call(this), i.default.forEach(function(m) {
        return v.addVocabulary(m);
      }), this.opts.discriminator && this.addKeyword(o.default);
    } }, { key: "_addDefaultMetaSchema", value: function() {
      if (Je(qe(p.prototype), "_addDefaultMetaSchema", this).call(this), this.opts.meta) {
        var v = this.opts.$data ? this.$dataMetaSchema(a, s) : a;
        this.addMetaSchema(v, u, !1), this.refs["http://json-schema.org/schema"] = u;
      }
    } }, { key: "defaultMeta", value: function() {
      return this.opts.defaultMeta = Je(qe(p.prototype), "defaultMeta", this).call(this) || (this.getSchema(u) ? u : void 0);
    } }]), p;
  }(r.default);
  t.exports = n = c, Object.defineProperty(n, "__esModule", { value: !0 }), n.default = c;
  var l = e("./compile/validate");
  Object.defineProperty(n, "KeywordCxt", { enumerable: !0, get: function() {
    return l.KeywordCxt;
  } });
  var f = e("./compile/codegen");
  Object.defineProperty(n, "_", { enumerable: !0, get: function() {
    return f._;
  } }), Object.defineProperty(n, "str", { enumerable: !0, get: function() {
    return f.str;
  } }), Object.defineProperty(n, "stringify", { enumerable: !0, get: function() {
    return f.stringify;
  } }), Object.defineProperty(n, "nil", { enumerable: !0, get: function() {
    return f.nil;
  } }), Object.defineProperty(n, "Name", { enumerable: !0, get: function() {
    return f.Name;
  } }), Object.defineProperty(n, "CodeGen", { enumerable: !0, get: function() {
    return f.CodeGen;
  } });
}, { "./compile/codegen": 2, "./compile/validate": 15, "./core": 18, "./refs/json-schema-draft-07.json": 20, "./vocabularies/discriminator": 46, "./vocabularies/draft7": 48 }] }, {}, [])("ajv"));
var pZ = {};
(function(e) {
  function t(I) {
    return I !== null && Object.prototype.toString.call(I) === "[object Array]";
  }
  function n(I) {
    return I !== null && Object.prototype.toString.call(I) === "[object Object]";
  }
  function r(I, R) {
    if (I === R)
      return !0;
    if (Object.prototype.toString.call(I) !== Object.prototype.toString.call(R))
      return !1;
    if (t(I) === !0) {
      if (I.length !== R.length)
        return !1;
      for (var it = 0; it < I.length; it++)
        if (r(I[it], R[it]) === !1)
          return !1;
      return !0;
    }
    if (n(I) === !0) {
      var N = {};
      for (var K in I)
        if (hasOwnProperty.call(I, K)) {
          if (r(I[K], R[K]) === !1)
            return !1;
          N[K] = !0;
        }
      for (var z in R)
        if (hasOwnProperty.call(R, z) && N[z] !== !0)
          return !1;
      return !0;
    }
    return !1;
  }
  function i(I) {
    if (I === "" || I === !1 || I === null || t(I) && I.length === 0)
      return !0;
    if (n(I)) {
      for (var R in I)
        if (I.hasOwnProperty(R))
          return !1;
      return !0;
    }
    return !1;
  }
  var o;
  o = typeof String.prototype.trimLeft == "function" ? function(I) {
    return I.trimLeft();
  } : function(I) {
    return I.match(/^\s*(.*)/)[1];
  };
  var a = 0, s = 2, u = { 0: "number", 1: "any", 2: "string", 3: "array", 4: "object", 5: "boolean", 6: "expression", 7: "null", 8: "Array<number>", 9: "Array<string>" }, c = "EOF", l = "UnquotedIdentifier", f = "QuotedIdentifier", h = "Rbracket", d = "Rparen", p = "Comma", v = "Colon", m = "Rbrace", g = "Number", y = "Current", b = "Expref", k = "Pipe", w = "Or", x = "And", S = "EQ", T = "GT", P = "LT", O = "GTE", j = "LTE", V = "NE", E = "Flatten", C = "Star", H = "Filter", X = "Dot", F = "Not", G = "Lbrace", M = "Lbracket", $ = "Lparen", q = "Literal", B = { ".": X, "*": C, ",": p, ":": v, "{": G, "}": m, "]": h, "(": $, ")": d, "@": y }, D = { "<": !0, ">": !0, "=": !0, "!": !0 }, _ = { " ": !0, "	": !0, "\n": !0 };
  function L(I) {
    return I >= "0" && I <= "9" || I === "-";
  }
  function J() {
  }
  J.prototype = { tokenize: function(I) {
    var R, it, N, K, z = [];
    for (this._current = 0; this._current < I.length; )
      if ((K = I[this._current]) >= "a" && K <= "z" || K >= "A" && K <= "Z" || K === "_")
        R = this._current, it = this._consumeUnquotedIdentifier(I), z.push({ type: l, value: it, start: R });
      else if (B[I[this._current]] !== void 0)
        z.push({ type: B[I[this._current]], value: I[this._current], start: this._current }), this._current++;
      else if (L(I[this._current]))
        N = this._consumeNumber(I), z.push(N);
      else if (I[this._current] === "[")
        N = this._consumeLBracket(I), z.push(N);
      else if (I[this._current] === '"')
        R = this._current, it = this._consumeQuotedIdentifier(I), z.push({ type: f, value: it, start: R });
      else if (I[this._current] === "'")
        R = this._current, it = this._consumeRawStringLiteral(I), z.push({ type: q, value: it, start: R });
      else if (I[this._current] === "`") {
        R = this._current;
        var at = this._consumeLiteral(I);
        z.push({ type: q, value: at, start: R });
      } else if (D[I[this._current]] !== void 0)
        z.push(this._consumeOperator(I));
      else if (_[I[this._current]] !== void 0)
        this._current++;
      else if (I[this._current] === "&")
        R = this._current, this._current++, I[this._current] === "&" ? (this._current++, z.push({ type: x, value: "&&", start: R })) : z.push({ type: b, value: "&", start: R });
      else {
        if (I[this._current] !== "|") {
          var yt = new Error("Unknown character:" + I[this._current]);
          throw yt.name = "LexerError", yt;
        }
        R = this._current, this._current++, I[this._current] === "|" ? (this._current++, z.push({ type: w, value: "||", start: R })) : z.push({ type: k, value: "|", start: R });
      }
    return z;
  }, _consumeUnquotedIdentifier: function(I) {
    var R, it = this._current;
    for (this._current++; this._current < I.length && ((R = I[this._current]) >= "a" && R <= "z" || R >= "A" && R <= "Z" || R >= "0" && R <= "9" || R === "_"); )
      this._current++;
    return I.slice(it, this._current);
  }, _consumeQuotedIdentifier: function(I) {
    var R = this._current;
    this._current++;
    for (var it = I.length; I[this._current] !== '"' && this._current < it; ) {
      var N = this._current;
      I[N] !== "\\" || I[N + 1] !== "\\" && I[N + 1] !== '"' ? N++ : N += 2, this._current = N;
    }
    return this._current++, JSON.parse(I.slice(R, this._current));
  }, _consumeRawStringLiteral: function(I) {
    var R = this._current;
    this._current++;
    for (var it = I.length; I[this._current] !== "'" && this._current < it; ) {
      var N = this._current;
      I[N] !== "\\" || I[N + 1] !== "\\" && I[N + 1] !== "'" ? N++ : N += 2, this._current = N;
    }
    return this._current++, I.slice(R + 1, this._current - 1).replace("\\'", "'");
  }, _consumeNumber: function(I) {
    var R = this._current;
    this._current++;
    for (var it = I.length; L(I[this._current]) && this._current < it; )
      this._current++;
    var N = parseInt(I.slice(R, this._current));
    return { type: g, value: N, start: R };
  }, _consumeLBracket: function(I) {
    var R = this._current;
    return this._current++, I[this._current] === "?" ? (this._current++, { type: H, value: "[?", start: R }) : I[this._current] === "]" ? (this._current++, { type: E, value: "[]", start: R }) : { type: M, value: "[", start: R };
  }, _consumeOperator: function(I) {
    var R = this._current, it = I[R];
    return this._current++, it === "!" ? I[this._current] === "=" ? (this._current++, { type: V, value: "!=", start: R }) : { type: F, value: "!", start: R } : it === "<" ? I[this._current] === "=" ? (this._current++, { type: j, value: "<=", start: R }) : { type: P, value: "<", start: R } : it === ">" ? I[this._current] === "=" ? (this._current++, { type: O, value: ">=", start: R }) : { type: T, value: ">", start: R } : it === "=" && I[this._current] === "=" ? (this._current++, { type: S, value: "==", start: R }) : void 0;
  }, _consumeLiteral: function(I) {
    this._current++;
    for (var R, it = this._current, N = I.length; I[this._current] !== "`" && this._current < N; ) {
      var K = this._current;
      I[K] !== "\\" || I[K + 1] !== "\\" && I[K + 1] !== "`" ? K++ : K += 2, this._current = K;
    }
    var z = o(I.slice(it, this._current));
    return z = z.replace("\\`", "`"), R = this._looksLikeJSON(z) ? JSON.parse(z) : JSON.parse('"' + z + '"'), this._current++, R;
  }, _looksLikeJSON: function(I) {
    if (I === "")
      return !1;
    if ('[{"'.indexOf(I[0]) >= 0 || ["true", "false", "null"].indexOf(I) >= 0)
      return !0;
    if (!("-0123456789".indexOf(I[0]) >= 0))
      return !1;
    try {
      return JSON.parse(I), !0;
    } catch {
      return !1;
    }
  } };
  var st = {};
  function ht() {
  }
  function xt(I) {
    this.runtime = I;
  }
  function kt(I) {
    this._interpreter = I, this.functionTable = { abs: { _func: this._functionAbs, _signature: [{ types: [a] }] }, avg: { _func: this._functionAvg, _signature: [{ types: [8] }] }, ceil: { _func: this._functionCeil, _signature: [{ types: [a] }] }, contains: { _func: this._functionContains, _signature: [{ types: [s, 3] }, { types: [1] }] }, ends_with: { _func: this._functionEndsWith, _signature: [{ types: [s] }, { types: [s] }] }, floor: { _func: this._functionFloor, _signature: [{ types: [a] }] }, length: { _func: this._functionLength, _signature: [{ types: [s, 3, 4] }] }, map: { _func: this._functionMap, _signature: [{ types: [6] }, { types: [3] }] }, max: { _func: this._functionMax, _signature: [{ types: [8, 9] }] }, merge: { _func: this._functionMerge, _signature: [{ types: [4], variadic: !0 }] }, max_by: { _func: this._functionMaxBy, _signature: [{ types: [3] }, { types: [6] }] }, sum: { _func: this._functionSum, _signature: [{ types: [8] }] }, starts_with: { _func: this._functionStartsWith, _signature: [{ types: [s] }, { types: [s] }] }, min: { _func: this._functionMin, _signature: [{ types: [8, 9] }] }, min_by: { _func: this._functionMinBy, _signature: [{ types: [3] }, { types: [6] }] }, type: { _func: this._functionType, _signature: [{ types: [1] }] }, keys: { _func: this._functionKeys, _signature: [{ types: [4] }] }, values: { _func: this._functionValues, _signature: [{ types: [4] }] }, sort: { _func: this._functionSort, _signature: [{ types: [9, 8] }] }, sort_by: { _func: this._functionSortBy, _signature: [{ types: [3] }, { types: [6] }] }, join: { _func: this._functionJoin, _signature: [{ types: [s] }, { types: [9] }] }, reverse: { _func: this._functionReverse, _signature: [{ types: [s, 3] }] }, to_array: { _func: this._functionToArray, _signature: [{ types: [1] }] }, to_string: { _func: this._functionToString, _signature: [{ types: [1] }] }, to_number: { _func: this._functionToNumber, _signature: [{ types: [1] }] }, not_null: { _func: this._functionNotNull, _signature: [{ types: [1], variadic: !0 }] } };
  }
  st.EOF = 0, st.UnquotedIdentifier = 0, st.QuotedIdentifier = 0, st.Rbracket = 0, st.Rparen = 0, st.Comma = 0, st.Rbrace = 0, st.Number = 0, st.Current = 0, st.Expref = 0, st.Pipe = 1, st.Or = 2, st.And = 3, st.EQ = 5, st.GT = 5, st.LT = 5, st.GTE = 5, st.LTE = 5, st.NE = 5, st.Flatten = 9, st.Star = 20, st.Filter = 21, st.Dot = 40, st.Not = 45, st.Lbrace = 50, st.Lbracket = 55, st.Lparen = 60, ht.prototype = { parse: function(I) {
    this._loadTokens(I), this.index = 0;
    var R = this.expression(0);
    if (this._lookahead(0) !== c) {
      var it = this._lookaheadToken(0), N = new Error("Unexpected token type: " + it.type + ", value: " + it.value);
      throw N.name = "ParserError", N;
    }
    return R;
  }, _loadTokens: function(I) {
    var R = new J().tokenize(I);
    R.push({ type: c, value: "", start: I.length }), this.tokens = R;
  }, expression: function(I) {
    var R = this._lookaheadToken(0);
    this._advance();
    for (var it = this.nud(R), N = this._lookahead(0); I < st[N]; )
      this._advance(), it = this.led(N, it), N = this._lookahead(0);
    return it;
  }, _lookahead: function(I) {
    return this.tokens[this.index + I].type;
  }, _lookaheadToken: function(I) {
    return this.tokens[this.index + I];
  }, _advance: function() {
    this.index++;
  }, nud: function(I) {
    var R, it;
    switch (I.type) {
      case q:
        return { type: "Literal", value: I.value };
      case l:
        return { type: "Field", name: I.value };
      case f:
        var N = { type: "Field", name: I.value };
        if (this._lookahead(0) === $)
          throw new Error("Quoted identifier not allowed for function names.");
        return N;
      case F:
        return { type: "NotExpression", children: [R = this.expression(st.Not)] };
      case C:
        return R = null, { type: "ValueProjection", children: [{ type: "Identity" }, R = this._lookahead(0) === h ? { type: "Identity" } : this._parseProjectionRHS(st.Star)] };
      case H:
        return this.led(I.type, { type: "Identity" });
      case G:
        return this._parseMultiselectHash();
      case E:
        return { type: "Projection", children: [{ type: E, children: [{ type: "Identity" }] }, R = this._parseProjectionRHS(st.Flatten)] };
      case M:
        return this._lookahead(0) === g || this._lookahead(0) === v ? (R = this._parseIndexExpression(), this._projectIfSlice({ type: "Identity" }, R)) : this._lookahead(0) === C && this._lookahead(1) === h ? (this._advance(), this._advance(), { type: "Projection", children: [{ type: "Identity" }, R = this._parseProjectionRHS(st.Star)] }) : this._parseMultiselectList();
      case y:
        return { type: y };
      case b:
        return { type: "ExpressionReference", children: [it = this.expression(st.Expref)] };
      case $:
        for (var K = []; this._lookahead(0) !== d; )
          this._lookahead(0) === y ? (it = { type: y }, this._advance()) : it = this.expression(0), K.push(it);
        return this._match(d), K[0];
      default:
        this._errorToken(I);
    }
  }, led: function(I, R) {
    var it;
    switch (I) {
      case X:
        var N = st.Dot;
        return this._lookahead(0) !== C ? { type: "Subexpression", children: [R, it = this._parseDotRHS(N)] } : (this._advance(), { type: "ValueProjection", children: [R, it = this._parseProjectionRHS(N)] });
      case k:
        return it = this.expression(st.Pipe), { type: k, children: [R, it] };
      case w:
        return { type: "OrExpression", children: [R, it = this.expression(st.Or)] };
      case x:
        return { type: "AndExpression", children: [R, it = this.expression(st.And)] };
      case $:
        for (var K, z = R.name, at = []; this._lookahead(0) !== d; )
          this._lookahead(0) === y ? (K = { type: y }, this._advance()) : K = this.expression(0), this._lookahead(0) === p && this._match(p), at.push(K);
        return this._match(d), { type: "Function", name: z, children: at };
      case H:
        var yt = this.expression(0);
        return this._match(h), { type: "FilterProjection", children: [R, it = this._lookahead(0) === E ? { type: "Identity" } : this._parseProjectionRHS(st.Filter), yt] };
      case E:
        return { type: "Projection", children: [{ type: E, children: [R] }, this._parseProjectionRHS(st.Flatten)] };
      case S:
      case V:
      case T:
      case O:
      case P:
      case j:
        return this._parseComparator(R, I);
      case M:
        var jt = this._lookaheadToken(0);
        return jt.type === g || jt.type === v ? (it = this._parseIndexExpression(), this._projectIfSlice(R, it)) : (this._match(C), this._match(h), { type: "Projection", children: [R, it = this._parseProjectionRHS(st.Star)] });
      default:
        this._errorToken(this._lookaheadToken(0));
    }
  }, _match: function(I) {
    if (this._lookahead(0) !== I) {
      var R = this._lookaheadToken(0), it = new Error("Expected " + I + ", got: " + R.type);
      throw it.name = "ParserError", it;
    }
    this._advance();
  }, _errorToken: function(I) {
    var R = new Error("Invalid token (" + I.type + '): "' + I.value + '"');
    throw R.name = "ParserError", R;
  }, _parseIndexExpression: function() {
    if (this._lookahead(0) === v || this._lookahead(1) === v)
      return this._parseSliceExpression();
    var I = { type: "Index", value: this._lookaheadToken(0).value };
    return this._advance(), this._match(h), I;
  }, _projectIfSlice: function(I, R) {
    var it = { type: "IndexExpression", children: [I, R] };
    return R.type === "Slice" ? { type: "Projection", children: [it, this._parseProjectionRHS(st.Star)] } : it;
  }, _parseSliceExpression: function() {
    for (var I = [null, null, null], R = 0, it = this._lookahead(0); it !== h && R < 3; ) {
      if (it === v)
        R++, this._advance();
      else {
        if (it !== g) {
          var N = this._lookahead(0), K = new Error("Syntax error, unexpected token: " + N.value + "(" + N.type + ")");
          throw K.name = "Parsererror", K;
        }
        I[R] = this._lookaheadToken(0).value, this._advance();
      }
      it = this._lookahead(0);
    }
    return this._match(h), { type: "Slice", children: I };
  }, _parseComparator: function(I, R) {
    return { type: "Comparator", name: R, children: [I, this.expression(st[R])] };
  }, _parseDotRHS: function(I) {
    var R = this._lookahead(0);
    return [l, f, C].indexOf(R) >= 0 ? this.expression(I) : R === M ? (this._match(M), this._parseMultiselectList()) : R === G ? (this._match(G), this._parseMultiselectHash()) : void 0;
  }, _parseProjectionRHS: function(I) {
    var R;
    if (st[this._lookahead(0)] < 10)
      R = { type: "Identity" };
    else if (this._lookahead(0) === M)
      R = this.expression(I);
    else if (this._lookahead(0) === H)
      R = this.expression(I);
    else {
      if (this._lookahead(0) !== X) {
        var it = this._lookaheadToken(0), N = new Error("Sytanx error, unexpected token: " + it.value + "(" + it.type + ")");
        throw N.name = "ParserError", N;
      }
      this._match(X), R = this._parseDotRHS(I);
    }
    return R;
  }, _parseMultiselectList: function() {
    for (var I = []; this._lookahead(0) !== h; ) {
      var R = this.expression(0);
      if (I.push(R), this._lookahead(0) === p && (this._match(p), this._lookahead(0) === h))
        throw new Error("Unexpected token Rbracket");
    }
    return this._match(h), { type: "MultiSelectList", children: I };
  }, _parseMultiselectHash: function() {
    for (var I, R, it, N = [], K = [l, f]; ; ) {
      if (I = this._lookaheadToken(0), K.indexOf(I.type) < 0)
        throw new Error("Expecting an identifier token, got: " + I.type);
      if (R = I.value, this._advance(), this._match(v), it = { type: "KeyValuePair", name: R, value: this.expression(0) }, N.push(it), this._lookahead(0) === p)
        this._match(p);
      else if (this._lookahead(0) === m) {
        this._match(m);
        break;
      }
    }
    return { type: "MultiSelectHash", children: N };
  } }, xt.prototype = { search: function(I, R) {
    return this.visit(I, R);
  }, visit: function(I, R) {
    var it, N, K, z, at, yt, jt, Ft, zt;
    switch (I.type) {
      case "Field":
        return R !== null && n(R) ? (yt = R[I.name]) === void 0 ? null : yt : null;
      case "Subexpression":
        for (K = this.visit(I.children[0], R), zt = 1; zt < I.children.length; zt++)
          if ((K = this.visit(I.children[1], K)) === null)
            return null;
        return K;
      case "IndexExpression":
        return jt = this.visit(I.children[0], R), this.visit(I.children[1], jt);
      case "Index":
        if (!t(R))
          return null;
        var St = I.value;
        return St < 0 && (St = R.length + St), (K = R[St]) === void 0 && (K = null), K;
      case "Slice":
        if (!t(R))
          return null;
        var Gt = I.children.slice(0), _e = this.computeSliceParams(R.length, Gt), Fe = _e[0], fn = _e[1], De = _e[2];
        if (K = [], De > 0)
          for (zt = Fe; zt < fn; zt += De)
            K.push(R[zt]);
        else
          for (zt = Fe; zt > fn; zt += De)
            K.push(R[zt]);
        return K;
      case "Projection":
        var $t = this.visit(I.children[0], R);
        if (!t($t))
          return null;
        for (Ft = [], zt = 0; zt < $t.length; zt++)
          (N = this.visit(I.children[1], $t[zt])) !== null && Ft.push(N);
        return Ft;
      case "ValueProjection":
        if (!n($t = this.visit(I.children[0], R)))
          return null;
        Ft = [];
        var oe = function(Bt) {
          for (var ee = Object.keys(Bt), ie = [], gt = 0; gt < ee.length; gt++)
            ie.push(Bt[ee[gt]]);
          return ie;
        }($t);
        for (zt = 0; zt < oe.length; zt++)
          (N = this.visit(I.children[1], oe[zt])) !== null && Ft.push(N);
        return Ft;
      case "FilterProjection":
        if (!t($t = this.visit(I.children[0], R)))
          return null;
        var Ce = [], sn = [];
        for (zt = 0; zt < $t.length; zt++)
          i(it = this.visit(I.children[2], $t[zt])) || Ce.push($t[zt]);
        for (var vn = 0; vn < Ce.length; vn++)
          (N = this.visit(I.children[1], Ce[vn])) !== null && sn.push(N);
        return sn;
      case "Comparator":
        switch (z = this.visit(I.children[0], R), at = this.visit(I.children[1], R), I.name) {
          case S:
            K = r(z, at);
            break;
          case V:
            K = !r(z, at);
            break;
          case T:
            K = z > at;
            break;
          case O:
            K = z >= at;
            break;
          case P:
            K = z < at;
            break;
          case j:
            K = z <= at;
            break;
          default:
            throw new Error("Unknown comparator: " + I.name);
        }
        return K;
      case E:
        var nt = this.visit(I.children[0], R);
        if (!t(nt))
          return null;
        var ct = [];
        for (zt = 0; zt < nt.length; zt++)
          t(N = nt[zt]) ? ct.push.apply(ct, N) : ct.push(N);
        return ct;
      case "Identity":
        return R;
      case "MultiSelectList":
        if (R === null)
          return null;
        for (Ft = [], zt = 0; zt < I.children.length; zt++)
          Ft.push(this.visit(I.children[zt], R));
        return Ft;
      case "MultiSelectHash":
        if (R === null)
          return null;
        var lt;
        for (Ft = {}, zt = 0; zt < I.children.length; zt++)
          Ft[(lt = I.children[zt]).name] = this.visit(lt.value, R);
        return Ft;
      case "OrExpression":
        return i(it = this.visit(I.children[0], R)) && (it = this.visit(I.children[1], R)), it;
      case "AndExpression":
        return i(z = this.visit(I.children[0], R)) === !0 ? z : this.visit(I.children[1], R);
      case "NotExpression":
        return i(z = this.visit(I.children[0], R));
      case "Literal":
        return I.value;
      case k:
        return jt = this.visit(I.children[0], R), this.visit(I.children[1], jt);
      case y:
        return R;
      case "Function":
        var wt = [];
        for (zt = 0; zt < I.children.length; zt++)
          wt.push(this.visit(I.children[zt], R));
        return this.runtime.callFunction(I.name, wt);
      case "ExpressionReference":
        var Rt = I.children[0];
        return Rt.jmespathType = b, Rt;
      default:
        throw new Error("Unknown node type: " + I.type);
    }
  }, computeSliceParams: function(I, R) {
    var it = R[0], N = R[1], K = R[2], z = [null, null, null];
    if (K === null)
      K = 1;
    else if (K === 0) {
      var at = new Error("Invalid slice, step cannot be 0");
      throw at.name = "RuntimeError", at;
    }
    var yt = K < 0;
    return it = it === null ? yt ? I - 1 : 0 : this.capSliceRange(I, it, K), N = N === null ? yt ? -1 : I : this.capSliceRange(I, N, K), z[0] = it, z[1] = N, z[2] = K, z;
  }, capSliceRange: function(I, R, it) {
    return R < 0 ? (R += I) < 0 && (R = it < 0 ? -1 : 0) : R >= I && (R = it < 0 ? I - 1 : I), R;
  } }, kt.prototype = { callFunction: function(I, R) {
    var it = this.functionTable[I];
    if (it === void 0)
      throw new Error("Unknown function: " + I + "()");
    return this._validateArgs(I, R, it._signature), it._func.call(this, R);
  }, _validateArgs: function(I, R, it) {
    var N, K, z, at;
    if (it[it.length - 1].variadic) {
      if (R.length < it.length)
        throw N = it.length === 1 ? " argument" : " arguments", new Error("ArgumentError: " + I + "() takes at least" + it.length + N + " but received " + R.length);
    } else if (R.length !== it.length)
      throw N = it.length === 1 ? " argument" : " arguments", new Error("ArgumentError: " + I + "() takes " + it.length + N + " but received " + R.length);
    for (var yt = 0; yt < it.length; yt++) {
      at = !1, K = it[yt].types, z = this._getTypeName(R[yt]);
      for (var jt = 0; jt < K.length; jt++)
        if (this._typeMatches(z, K[jt], R[yt])) {
          at = !0;
          break;
        }
      if (!at) {
        var Ft = K.map(function(zt) {
          return u[zt];
        }).join(",");
        throw new Error("TypeError: " + I + "() expected argument " + (yt + 1) + " to be type " + Ft + " but received type " + u[z] + " instead.");
      }
    }
  }, _typeMatches: function(I, R, it) {
    if (R === 1)
      return !0;
    if (R !== 9 && R !== 8 && R !== 3)
      return I === R;
    if (R === 3)
      return I === 3;
    if (I === 3) {
      var N;
      R === 8 ? N = a : R === 9 && (N = s);
      for (var K = 0; K < it.length; K++)
        if (!this._typeMatches(this._getTypeName(it[K]), N, it[K]))
          return !1;
      return !0;
    }
  }, _getTypeName: function(I) {
    switch (Object.prototype.toString.call(I)) {
      case "[object String]":
        return s;
      case "[object Number]":
        return a;
      case "[object Array]":
        return 3;
      case "[object Boolean]":
        return 5;
      case "[object Null]":
        return 7;
      case "[object Object]":
        return I.jmespathType === b ? 6 : 4;
    }
  }, _functionStartsWith: function(I) {
    return I[0].lastIndexOf(I[1]) === 0;
  }, _functionEndsWith: function(I) {
    var R = I[0], it = I[1];
    return R.indexOf(it, R.length - it.length) !== -1;
  }, _functionReverse: function(I) {
    if (this._getTypeName(I[0]) === s) {
      for (var R = I[0], it = "", N = R.length - 1; N >= 0; N--)
        it += R[N];
      return it;
    }
    var K = I[0].slice(0);
    return K.reverse(), K;
  }, _functionAbs: function(I) {
    return Math.abs(I[0]);
  }, _functionCeil: function(I) {
    return Math.ceil(I[0]);
  }, _functionAvg: function(I) {
    for (var R = 0, it = I[0], N = 0; N < it.length; N++)
      R += it[N];
    return R / it.length;
  }, _functionContains: function(I) {
    return I[0].indexOf(I[1]) >= 0;
  }, _functionFloor: function(I) {
    return Math.floor(I[0]);
  }, _functionLength: function(I) {
    return n(I[0]) ? Object.keys(I[0]).length : I[0].length;
  }, _functionMap: function(I) {
    for (var R = [], it = this._interpreter, N = I[0], K = I[1], z = 0; z < K.length; z++)
      R.push(it.visit(N, K[z]));
    return R;
  }, _functionMerge: function(I) {
    for (var R = {}, it = 0; it < I.length; it++) {
      var N = I[it];
      for (var K in N)
        R[K] = N[K];
    }
    return R;
  }, _functionMax: function(I) {
    if (I[0].length > 0) {
      if (this._getTypeName(I[0][0]) === a)
        return Math.max.apply(Math, I[0]);
      for (var R = I[0], it = R[0], N = 1; N < R.length; N++)
        it.localeCompare(R[N]) < 0 && (it = R[N]);
      return it;
    }
    return null;
  }, _functionMin: function(I) {
    if (I[0].length > 0) {
      if (this._getTypeName(I[0][0]) === a)
        return Math.min.apply(Math, I[0]);
      for (var R = I[0], it = R[0], N = 1; N < R.length; N++)
        R[N].localeCompare(it) < 0 && (it = R[N]);
      return it;
    }
    return null;
  }, _functionSum: function(I) {
    for (var R = 0, it = I[0], N = 0; N < it.length; N++)
      R += it[N];
    return R;
  }, _functionType: function(I) {
    switch (this._getTypeName(I[0])) {
      case a:
        return "number";
      case s:
        return "string";
      case 3:
        return "array";
      case 4:
        return "object";
      case 5:
        return "boolean";
      case 6:
        return "expref";
      case 7:
        return "null";
    }
  }, _functionKeys: function(I) {
    return Object.keys(I[0]);
  }, _functionValues: function(I) {
    for (var R = I[0], it = Object.keys(R), N = [], K = 0; K < it.length; K++)
      N.push(R[it[K]]);
    return N;
  }, _functionJoin: function(I) {
    var R = I[0];
    return I[1].join(R);
  }, _functionToArray: function(I) {
    return this._getTypeName(I[0]) === 3 ? I[0] : [I[0]];
  }, _functionToString: function(I) {
    return this._getTypeName(I[0]) === s ? I[0] : JSON.stringify(I[0]);
  }, _functionToNumber: function(I) {
    var R, it = this._getTypeName(I[0]);
    return it === a ? I[0] : it !== s || (R = +I[0], isNaN(R)) ? null : R;
  }, _functionNotNull: function(I) {
    for (var R = 0; R < I.length; R++)
      if (this._getTypeName(I[R]) !== 7)
        return I[R];
    return null;
  }, _functionSort: function(I) {
    var R = I[0].slice(0);
    return R.sort(), R;
  }, _functionSortBy: function(I) {
    var R = I[0].slice(0);
    if (R.length === 0)
      return R;
    var it = this._interpreter, N = I[1], K = this._getTypeName(it.visit(N, R[0]));
    if ([a, s].indexOf(K) < 0)
      throw new Error("TypeError");
    for (var z = this, at = [], yt = 0; yt < R.length; yt++)
      at.push([yt, R[yt]]);
    at.sort(function(Ft, zt) {
      var St = it.visit(N, Ft[1]), Gt = it.visit(N, zt[1]);
      if (z._getTypeName(St) !== K)
        throw new Error("TypeError: expected " + K + ", received " + z._getTypeName(St));
      if (z._getTypeName(Gt) !== K)
        throw new Error("TypeError: expected " + K + ", received " + z._getTypeName(Gt));
      return St > Gt ? 1 : St < Gt ? -1 : Ft[0] - zt[0];
    });
    for (var jt = 0; jt < at.length; jt++)
      R[jt] = at[jt][1];
    return R;
  }, _functionMaxBy: function(I) {
    for (var R, it, N = I[1], K = I[0], z = this.createKeyFunction(N, [a, s]), at = -1 / 0, yt = 0; yt < K.length; yt++)
      (it = z(K[yt])) > at && (at = it, R = K[yt]);
    return R;
  }, _functionMinBy: function(I) {
    for (var R, it, N = I[1], K = I[0], z = this.createKeyFunction(N, [a, s]), at = 1 / 0, yt = 0; yt < K.length; yt++)
      (it = z(K[yt])) < at && (at = it, R = K[yt]);
    return R;
  }, createKeyFunction: function(I, R) {
    var it = this, N = this._interpreter;
    return function(K) {
      var z = N.visit(I, K);
      if (R.indexOf(it._getTypeName(z)) < 0) {
        var at = "TypeError: expected one of " + R + ", received " + it._getTypeName(z);
        throw new Error(at);
      }
      return z;
    };
  } }, e.tokenize = function(I) {
    return new J().tokenize(I);
  }, e.compile = function(I) {
    return new ht().parse(I);
  }, e.search = function(I, R) {
    var it = new ht(), N = new kt(), K = new xt(N);
    N._interpreter = K;
    var z = it.parse(R);
    return K.search(z, I);
  }, e.strictDeepEqual = r;
})(pZ);
/*!
* vanilla-picker v2.12.1
* https://vanilla-picker.js.org
*
* Copyright 2017-2021 Andreas Borgen (https://github.com/Sphinxxxx), Adam Brooks (https://github.com/dissimulate)
* Released under the ISC license.
*/
var U0 = function(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}, J0 = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}(), Gl = function(e, t) {
  if (Array.isArray(e))
    return e;
  if (Symbol.iterator in Object(e))
    return function(n, r) {
      var i = [], o = !0, a = !1, s = void 0;
      try {
        for (var u, c = n[Symbol.iterator](); !(o = (u = c.next()).done) && (i.push(u.value), !r || i.length !== r); o = !0)
          ;
      } catch (l) {
        a = !0, s = l;
      } finally {
        try {
          !o && c.return && c.return();
        } finally {
          if (a)
            throw s;
        }
      }
      return i;
    }(e, t);
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
};
String.prototype.startsWith = String.prototype.startsWith || function(e) {
  return this.indexOf(e) === 0;
}, String.prototype.padStart = String.prototype.padStart || function(e, t) {
  for (var n = this; n.length < e; )
    n = t + n;
  return n;
};
var mZ = { cb: "0f8ff", tqw: "aebd7", q: "-ffff", qmrn: "7fffd4", zr: "0ffff", bg: "5f5dc", bsq: "e4c4", bck: "---", nch: "ebcd", b: "--ff", bvt: "8a2be2", brwn: "a52a2a", brw: "deb887", ctb: "5f9ea0", hrt: "7fff-", chcT: "d2691e", cr: "7f50", rnw: "6495ed", crns: "8dc", crms: "dc143c", cn: "-ffff", Db: "--8b", Dcn: "-8b8b", Dgnr: "b8860b", Dgr: "a9a9a9", Dgrn: "-64-", Dkhk: "bdb76b", Dmgn: "8b-8b", Dvgr: "556b2f", Drng: "8c-", Drch: "9932cc", Dr: "8b--", Dsmn: "e9967a", Dsgr: "8fbc8f", DsTb: "483d8b", DsTg: "2f4f4f", Dtrq: "-ced1", Dvt: "94-d3", ppnk: "1493", pskb: "-bfff", mgr: "696969", grb: "1e90ff", rbrc: "b22222", rwht: "af0", stg: "228b22", chs: "-ff", gnsb: "dcdcdc", st: "8f8ff", g: "d7-", gnr: "daa520", gr: "808080", grn: "-8-0", grnw: "adff2f", hnw: "0fff0", htpn: "69b4", nnr: "cd5c5c", ng: "4b-82", vr: "0", khk: "0e68c", vnr: "e6e6fa", nrb: "0f5", wngr: "7cfc-", mnch: "acd", Lb: "add8e6", Lcr: "08080", Lcn: "e0ffff", Lgnr: "afad2", Lgr: "d3d3d3", Lgrn: "90ee90", Lpnk: "b6c1", Lsmn: "a07a", Lsgr: "20b2aa", Lskb: "87cefa", LsTg: "778899", Lstb: "b0c4de", Lw: "e0", m: "-ff-", mgrn: "32cd32", nn: "af0e6", mgnt: "-ff", mrn: "8--0", mqm: "66cdaa", mmb: "--cd", mmrc: "ba55d3", mmpr: "9370db", msg: "3cb371", mmsT: "7b68ee", "": "-fa9a", mtr: "48d1cc", mmvt: "c71585", mnLb: "191970", ntc: "5fffa", mstr: "e4e1", mccs: "e4b5", vjw: "dead", nv: "--80", c: "df5e6", v: "808-0", vrb: "6b8e23", rng: "a5-", rngr: "45-", rch: "da70d6", pgnr: "eee8aa", pgrn: "98fb98", ptrq: "afeeee", pvtr: "db7093", ppwh: "efd5", pchp: "dab9", pr: "cd853f", pnk: "c0cb", pm: "dda0dd", pwrb: "b0e0e6", prp: "8-080", cc: "663399", r: "--", sbr: "bc8f8f", rb: "4169e1", sbrw: "8b4513", smn: "a8072", nbr: "4a460", sgrn: "2e8b57", ssh: "5ee", snn: "a0522d", svr: "c0c0c0", skb: "87ceeb", sTb: "6a5acd", sTgr: "708090", snw: "afa", n: "-ff7f", stb: "4682b4", tn: "d2b48c", t: "-8080", thst: "d8bfd8", tmT: "6347", trqs: "40e0d0", vt: "ee82ee", whT: "5deb3", wht: "", hts: "5f5f5", w: "-", wgrn: "9acd32" };
function s_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, n = t > 0 ? e.toFixed(t).replace(/0+$/, "").replace(/\.$/, "") : e.toString();
  return n || "0";
}
var gZ = function() {
  function e(t, n, r, i) {
    U0(this, e);
    var o = this;
    if (t !== void 0)
      if (Array.isArray(t))
        this.rgba = t;
      else if (r === void 0) {
        var a = t && "" + t;
        a && function(s) {
          if (s.startsWith("hsl")) {
            var u = s.match(/([\-\d\.e]+)/g).map(Number), c = Gl(u, 4), l = c[0], f = c[1], h = c[2], d = c[3];
            d === void 0 && (d = 1), l /= 360, f /= 100, h /= 100, o.hsla = [l, f, h, d];
          } else if (s.startsWith("rgb")) {
            var p = s.match(/([\-\d\.e]+)/g).map(Number), v = Gl(p, 4), m = v[0], g = v[1], y = v[2], b = v[3];
            b === void 0 && (b = 1), o.rgba = [m, g, y, b];
          } else
            s.startsWith("#") ? o.rgba = e.hexToRgb(s) : o.rgba = e.nameToRgb(s) || e.hexToRgb(s);
        }(a.toLowerCase());
      } else
        this.rgba = [t, n, r, i === void 0 ? 1 : i];
  }
  return J0(e, [{ key: "printRGB", value: function(t) {
    var n = (t ? this.rgba : this.rgba.slice(0, 3)).map(function(r, i) {
      return s_(r, i === 3 ? 3 : 0);
    });
    return t ? "rgba(" + n + ")" : "rgb(" + n + ")";
  } }, { key: "printHSL", value: function(t) {
    var n = [360, 100, 100, 1], r = ["", "%", "%", ""], i = (t ? this.hsla : this.hsla.slice(0, 3)).map(function(o, a) {
      return s_(o * n[a], a === 3 ? 3 : 1) + r[a];
    });
    return t ? "hsla(" + i + ")" : "hsl(" + i + ")";
  } }, { key: "printHex", value: function(t) {
    var n = this.hex;
    return t ? n : n.substring(0, 7);
  } }, { key: "rgba", get: function() {
    if (this._rgba)
      return this._rgba;
    if (!this._hsla)
      throw new Error("No color is set");
    return this._rgba = e.hslToRgb(this._hsla);
  }, set: function(t) {
    t.length === 3 && (t[3] = 1), this._rgba = t, this._hsla = null;
  } }, { key: "rgbString", get: function() {
    return this.printRGB();
  } }, { key: "rgbaString", get: function() {
    return this.printRGB(!0);
  } }, { key: "hsla", get: function() {
    if (this._hsla)
      return this._hsla;
    if (!this._rgba)
      throw new Error("No color is set");
    return this._hsla = e.rgbToHsl(this._rgba);
  }, set: function(t) {
    t.length === 3 && (t[3] = 1), this._hsla = t, this._rgba = null;
  } }, { key: "hslString", get: function() {
    return this.printHSL();
  } }, { key: "hslaString", get: function() {
    return this.printHSL(!0);
  } }, { key: "hex", get: function() {
    return "#" + this.rgba.map(function(t, n) {
      return n < 3 ? t.toString(16) : Math.round(255 * t).toString(16);
    }).map(function(t) {
      return t.padStart(2, "0");
    }).join("");
  }, set: function(t) {
    this.rgba = e.hexToRgb(t);
  } }], [{ key: "hexToRgb", value: function(t) {
    var n = (t.startsWith("#") ? t.slice(1) : t).replace(/^(\w{3})$/, "$1F").replace(/^(\w)(\w)(\w)(\w)$/, "$1$1$2$2$3$3$4$4").replace(/^(\w{6})$/, "$1FF");
    if (!n.match(/^([0-9a-fA-F]{8})$/))
      throw new Error("Unknown hex color; " + t);
    var r = n.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function(i) {
      return parseInt(i, 16);
    });
    return r[3] = r[3] / 255, r;
  } }, { key: "nameToRgb", value: function(t) {
    var n = t.toLowerCase().replace("at", "T").replace(/[aeiouyldf]/g, "").replace("ght", "L").replace("rk", "D").slice(-5, 4), r = mZ[n];
    return r === void 0 ? r : e.hexToRgb(r.replace(/\-/g, "00").padStart(6, "f"));
  } }, { key: "rgbToHsl", value: function(t) {
    var n = Gl(t, 4), r = n[0], i = n[1], o = n[2], a = n[3];
    r /= 255, i /= 255, o /= 255;
    var s = Math.max(r, i, o), u = Math.min(r, i, o), c = void 0, l = void 0, f = (s + u) / 2;
    if (s === u)
      c = l = 0;
    else {
      var h = s - u;
      switch (l = f > 0.5 ? h / (2 - s - u) : h / (s + u), s) {
        case r:
          c = (i - o) / h + (i < o ? 6 : 0);
          break;
        case i:
          c = (o - r) / h + 2;
          break;
        case o:
          c = (r - i) / h + 4;
      }
      c /= 6;
    }
    return [c, l, f, a];
  } }, { key: "hslToRgb", value: function(t) {
    var n = Gl(t, 4), r = n[0], i = n[1], o = n[2], a = n[3], s = void 0, u = void 0, c = void 0;
    if (i === 0)
      s = u = c = o;
    else {
      var l = function(p, v, m) {
        return m < 0 && (m += 1), m > 1 && (m -= 1), m < 0.16666666666666666 ? p + 6 * (v - p) * m : m < 0.5 ? v : m < 0.6666666666666666 ? p + (v - p) * (0.6666666666666666 - m) * 6 : p;
      }, f = o < 0.5 ? o * (1 + i) : o + i - o * i, h = 2 * o - f;
      s = l(h, f, r + 1 / 3), u = l(h, f, r), c = l(h, f, r - 1 / 3);
    }
    var d = [255 * s, 255 * u, 255 * c].map(Math.round);
    return d[3] = a, d;
  } }]), e;
}(), yZ = function() {
  function e() {
    U0(this, e), this._events = [];
  }
  return J0(e, [{ key: "add", value: function(t, n, r) {
    t.addEventListener(n, r, !1), this._events.push({ target: t, type: n, handler: r });
  } }, { key: "remove", value: function(t, n, r) {
    this._events = this._events.filter(function(i) {
      var o = !0;
      return t && t !== i.target && (o = !1), n && n !== i.type && (o = !1), r && r !== i.handler && (o = !1), o && e._doRemove(i.target, i.type, i.handler), !o;
    });
  } }, { key: "destroy", value: function() {
    this._events.forEach(function(t) {
      return e._doRemove(t.target, t.type, t.handler);
    }), this._events = [];
  } }], [{ key: "_doRemove", value: function(t, n, r) {
    t.removeEventListener(n, r, !1);
  } }]), e;
}();
function Ev(e, t, n) {
  var r = !1;
  function i(u, c, l) {
    return Math.max(c, Math.min(u, l));
  }
  function o(u, c, l) {
    if (l && (r = !0), r) {
      u.preventDefault();
      var f = t.getBoundingClientRect(), h = f.width, d = f.height, p = c.clientX, v = c.clientY, m = i(p - f.left, 0, h), g = i(v - f.top, 0, d);
      n(m / h, g / d);
    }
  }
  function a(u, c) {
    (u.buttons === void 0 ? u.which : u.buttons) === 1 ? o(u, u, c) : r = !1;
  }
  function s(u, c) {
    u.touches.length === 1 ? o(u, u.touches[0], c) : r = !1;
  }
  e.add(t, "mousedown", function(u) {
    a(u, !0);
  }), e.add(t, "touchstart", function(u) {
    s(u, !0);
  }), e.add(window, "mousemove", a), e.add(t, "touchmove", s), e.add(window, "mouseup", function(u) {
    r = !1;
  }), e.add(t, "touchend", function(u) {
    r = !1;
  }), e.add(t, "touchcancel", function(u) {
    r = !1;
  });
}
function Xi(e, t) {
  return (t || document).querySelector(e);
}
function lM(e) {
  e.preventDefault(), e.stopPropagation();
}
function Mv(e, t, n, r, i) {
  e.add(t, "keydown", function(o) {
    n.indexOf(o.key) >= 0 && (i && lM(o), r(o));
  });
}
var fM = function() {
  function e(t) {
    U0(this, e), this.settings = { popup: "right", layout: "default", alpha: !0, editor: !0, editorFormat: "hex", cancelButton: !1, defaultColor: "#0cf" }, this._events = new yZ(), this.onChange = null, this.onDone = null, this.onOpen = null, this.onClose = null, this.setOptions(t);
  }
  return J0(e, [{ key: "setOptions", value: function(t) {
    var n = this;
    if (t) {
      var r = this.settings;
      if (t instanceof HTMLElement)
        r.parent = t;
      else {
        r.parent && t.parent && r.parent !== t.parent && (this._events.remove(r.parent), this._popupInited = !1), function(s, u, c) {
          for (var l in s)
            c && c.indexOf(l) >= 0 || (u[l] = s[l]);
        }(t, r), t.onChange && (this.onChange = t.onChange), t.onDone && (this.onDone = t.onDone), t.onOpen && (this.onOpen = t.onOpen), t.onClose && (this.onClose = t.onClose);
        var i = t.color || t.colour;
        i && this._setColor(i);
      }
      var o = r.parent;
      if (o && r.popup && !this._popupInited) {
        var a = function(s) {
          return n.openHandler(s);
        };
        this._events.add(o, "click", a), Mv(this._events, o, [" ", "Spacebar", "Enter"], a), this._popupInited = !0;
      } else
        t.parent && !r.popup && this.show();
    }
  } }, { key: "openHandler", value: function(t) {
    if (this.show()) {
      t && t.preventDefault(), this.settings.parent.style.pointerEvents = "none";
      var n = t && t.type === "keydown" ? this._domEdit : this.domElement;
      setTimeout(function() {
        return n.focus();
      }, 100), this.onOpen && this.onOpen(this.colour);
    }
  } }, { key: "closeHandler", value: function(t) {
    var n = t && t.type, r = !1;
    if (t)
      if (n === "mousedown" || n === "focusin") {
        var i = (this.__containedEvent || 0) + 100;
        t.timeStamp > i && (r = !0);
      } else
        lM(t), r = !0;
    else
      r = !0;
    r && this.hide() && (this.settings.parent.style.pointerEvents = "", n !== "mousedown" && this.settings.parent.focus(), this.onClose && this.onClose(this.colour));
  } }, { key: "movePopup", value: function(t, n) {
    this.closeHandler(), this.setOptions(t), n && this.openHandler();
  } }, { key: "setColor", value: function(t, n) {
    this._setColor(t, { silent: n });
  } }, { key: "_setColor", value: function(t, n) {
    if (typeof t == "string" && (t = t.trim()), t) {
      n = n || {};
      var r = void 0;
      try {
        r = new gZ(t);
      } catch (o) {
        if (n.failSilently)
          return;
        throw o;
      }
      if (!this.settings.alpha) {
        var i = r.hsla;
        i[3] = 1, r.hsla = i;
      }
      this.colour = this.color = r, this._setHSLA(null, null, null, null, n);
    }
  } }, { key: "setColour", value: function(t, n) {
    this.setColor(t, n);
  } }, { key: "show", value: function() {
    if (!this.settings.parent)
      return !1;
    if (this.domElement) {
      var t = this._toggleDOM(!0);
      return this._setPosition(), t;
    }
    var n, r, i = this.settings.template || '<div class="picker_wrapper" tabindex="-1"><div class="picker_arrow"></div><div class="picker_hue picker_slider"><div class="picker_selector"></div></div><div class="picker_sl"><div class="picker_selector"></div></div><div class="picker_alpha picker_slider"><div class="picker_selector"></div></div><div class="picker_editor"><input aria-label="Type a color name or hex value"/></div><div class="picker_sample"></div><div class="picker_done"><button>Ok</button></div><div class="picker_cancel"><button>Cancel</button></div></div>', o = (n = i, (r = document.createElement("div")).innerHTML = n, r.firstElementChild);
    return this.domElement = o, this._domH = Xi(".picker_hue", o), this._domSL = Xi(".picker_sl", o), this._domA = Xi(".picker_alpha", o), this._domEdit = Xi(".picker_editor input", o), this._domSample = Xi(".picker_sample", o), this._domOkay = Xi(".picker_done button", o), this._domCancel = Xi(".picker_cancel button", o), o.classList.add("layout_" + this.settings.layout), this.settings.alpha || o.classList.add("no_alpha"), this.settings.editor || o.classList.add("no_editor"), this.settings.cancelButton || o.classList.add("no_cancel"), this._ifPopup(function() {
      return o.classList.add("popup");
    }), this._setPosition(), this.colour ? this._updateUI() : this._setColor(this.settings.defaultColor), this._bindEvents(), !0;
  } }, { key: "hide", value: function() {
    return this._toggleDOM(!1);
  } }, { key: "destroy", value: function() {
    this._events.destroy(), this.domElement && this.settings.parent.removeChild(this.domElement);
  } }, { key: "_bindEvents", value: function() {
    var t = this, n = this, r = this.domElement, i = this._events;
    function o(u, c, l) {
      i.add(u, c, l);
    }
    o(r, "click", function(u) {
      return u.preventDefault();
    }), Ev(i, this._domH, function(u, c) {
      return n._setHSLA(u);
    }), Ev(i, this._domSL, function(u, c) {
      return n._setHSLA(null, u, 1 - c);
    }), this.settings.alpha && Ev(i, this._domA, function(u, c) {
      return n._setHSLA(null, null, null, 1 - c);
    });
    var a = this._domEdit;
    o(a, "input", function(u) {
      n._setColor(this.value, { fromEditor: !0, failSilently: !0 });
    }), o(a, "focus", function(u) {
      var c = this;
      c.selectionStart === c.selectionEnd && c.select();
    }), this._ifPopup(function() {
      var u = function(l) {
        return t.closeHandler(l);
      };
      o(window, "mousedown", u), o(window, "focusin", u), Mv(i, r, ["Esc", "Escape"], u);
      var c = function(l) {
        t.__containedEvent = l.timeStamp;
      };
      o(r, "mousedown", c), o(r, "focusin", c), o(t._domCancel, "click", u);
    });
    var s = function(u) {
      t._ifPopup(function() {
        return t.closeHandler(u);
      }), t.onDone && t.onDone(t.colour);
    };
    o(this._domOkay, "click", s), Mv(i, r, ["Enter"], s);
  } }, { key: "_setPosition", value: function() {
    var t = this.settings.parent, n = this.domElement;
    t !== n.parentNode && t.appendChild(n), this._ifPopup(function(r) {
      getComputedStyle(t).position === "static" && (t.style.position = "relative");
      var i = r === !0 ? "popup_right" : "popup_" + r;
      ["popup_top", "popup_bottom", "popup_left", "popup_right"].forEach(function(o) {
        o === i ? n.classList.add(o) : n.classList.remove(o);
      }), n.classList.add(i);
    });
  } }, { key: "_setHSLA", value: function(t, n, r, i, o) {
    o = o || {};
    var a = this.colour, s = a.hsla;
    [t, n, r, i].forEach(function(u, c) {
      (u || u === 0) && (s[c] = u);
    }), a.hsla = s, this._updateUI(o), this.onChange && !o.silent && this.onChange(a);
  } }, { key: "_updateUI", value: function(t) {
    if (this.domElement) {
      t = t || {};
      var n = this.colour, r = n.hsla, i = "hsl(" + 360 * r[0] + ", 100%, 50%)", o = n.hslString, a = n.hslaString, s = this._domH, u = this._domSL, c = this._domA, l = Xi(".picker_selector", s), f = Xi(".picker_selector", u), h = Xi(".picker_selector", c);
      b(0, l, r[0]), this._domSL.style.backgroundColor = this._domH.style.color = i, b(0, f, r[1]), k(0, f, 1 - r[2]), u.style.color = o, k(0, h, 1 - r[3]);
      var d = o, p = d.replace("hsl", "hsla").replace(")", ", 0)"), v = "linear-gradient(" + [d, p] + ")";
      if (this._domA.style.background = v + `, linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,
                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em`, !t.fromEditor) {
        var m = this.settings.editorFormat, g = this.settings.alpha, y = void 0;
        switch (m) {
          case "rgb":
            y = n.printRGB(g);
            break;
          case "hsl":
            y = n.printHSL(g);
            break;
          default:
            y = n.printHex(g);
        }
        this._domEdit.value = y;
      }
      this._domSample.style.color = a;
    }
    function b(w, x, S) {
      x.style.left = 100 * S + "%";
    }
    function k(w, x, S) {
      x.style.top = 100 * S + "%";
    }
  } }, { key: "_ifPopup", value: function(t, n) {
    this.settings.parent && this.settings.popup ? t && t(this.settings.popup) : n && n();
  } }, { key: "_toggleDOM", value: function(t) {
    var n = this.domElement;
    if (!n)
      return !1;
    var r = t ? "" : "none", i = n.style.display !== r;
    return i && (n.style.display = r), i;
  } }]), e;
}(), Tv = document.createElement("style");
Tv.textContent = '.picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:flex;flex-flow:row wrap;justify-content:space-between;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:"";display:block;width:100%;height:0;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{flex:1 1 auto}.layout_default .picker_sl::before{content:"";display:block;padding-bottom:100%}.layout_default .picker_editor{order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{order:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px #1e90ff}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:#f5f5f5;background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:#fff}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid #fff;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:linear-gradient(180deg, white, rgba(255, 255, 255, 0) 50%),linear-gradient(0deg, black, rgba(0, 0, 0, 0) 50%),linear-gradient(90deg, #808080, rgba(128, 128, 128, 0))}.picker_alpha,.picker_sample{position:relative;background:linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0/2em 2em,linear-gradient(45deg, lightgrey 25%, white 25%, white 75%, lightgrey 75%) 1em 1em/2em 2em;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:"";position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:"";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}', document.documentElement.firstElementChild.appendChild(Tv), fM.StyleElement = Tv;
var bZ = Object.freeze({ __proto__: null, default: fM });
mt.exports.compileJSONPointer;
mt.exports.compileJSONPointerProp;
mt.exports.deleteIn;
mt.exports.existsIn;
mt.exports.getIn;
mt.exports.immutableJSONPatch;
mt.exports.insertAt;
mt.exports.parseFrom;
mt.exports.parseJSONPointer;
mt.exports.parsePath;
mt.exports.revertJSONPatch;
mt.exports.setIn;
mt.exports.updateIn;
var kZ = typeof global == "object" && global && global.Object === Object && global;
const hM = kZ;
var wZ = typeof self == "object" && self && self.Object === Object && self, xZ = hM || wZ || Function("return this")();
const Vi = xZ;
var jZ = Vi.Symbol;
const Zs = jZ;
var dM = Object.prototype, SZ = dM.hasOwnProperty, $Z = dM.toString, Mu = Zs ? Zs.toStringTag : void 0;
function _Z(e) {
  var t = SZ.call(e, Mu), n = e[Mu];
  try {
    e[Mu] = void 0;
    var r = !0;
  } catch {
  }
  var i = $Z.call(e);
  return r && (t ? e[Mu] = n : delete e[Mu]), i;
}
var CZ = Object.prototype, OZ = CZ.toString;
function AZ(e) {
  return OZ.call(e);
}
var PZ = "[object Null]", EZ = "[object Undefined]", u_ = Zs ? Zs.toStringTag : void 0;
function mu(e) {
  return e == null ? e === void 0 ? EZ : PZ : u_ && u_ in Object(e) ? _Z(e) : AZ(e);
}
function gu(e) {
  return e != null && typeof e == "object";
}
var MZ = "[object Symbol]";
function TZ(e) {
  return typeof e == "symbol" || gu(e) && mu(e) == MZ;
}
var IZ = Array.isArray;
const K0 = IZ;
var NZ = /\s/;
function RZ(e) {
  for (var t = e.length; t-- && NZ.test(e.charAt(t)); )
    ;
  return t;
}
var DZ = /^\s+/;
function LZ(e) {
  return e && e.slice(0, RZ(e) + 1).replace(DZ, "");
}
function ha(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var c_ = 0 / 0, zZ = /^[-+]0x[0-9a-f]+$/i, BZ = /^0b[01]+$/i, FZ = /^0o[0-7]+$/i, qZ = parseInt;
function l_(e) {
  if (typeof e == "number")
    return e;
  if (TZ(e))
    return c_;
  if (ha(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ha(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = LZ(e);
  var n = BZ.test(e);
  return n || FZ.test(e) ? qZ(e.slice(2), n ? 2 : 8) : zZ.test(e) ? c_ : +e;
}
var VZ = "[object AsyncFunction]", HZ = "[object Function]", WZ = "[object GeneratorFunction]", UZ = "[object Proxy]";
function vM(e) {
  if (!ha(e))
    return !1;
  var t = mu(e);
  return t == HZ || t == WZ || t == VZ || t == UZ;
}
var JZ = Vi["__core-js_shared__"];
const Iv = JZ;
var f_ = function() {
  var e = /[^.]+$/.exec(Iv && Iv.keys && Iv.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function KZ(e) {
  return !!f_ && f_ in e;
}
var GZ = Function.prototype, QZ = GZ.toString;
function cs(e) {
  if (e != null) {
    try {
      return QZ.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var XZ = /[\\^$.*+?()[\]{}|]/g, ZZ = /^\[object .+?Constructor\]$/, YZ = Function.prototype, tY = Object.prototype, eY = YZ.toString, nY = tY.hasOwnProperty, rY = RegExp("^" + eY.call(nY).replace(XZ, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function iY(e) {
  if (!ha(e) || KZ(e))
    return !1;
  var t = vM(e) ? rY : ZZ;
  return t.test(cs(e));
}
function oY(e, t) {
  return e == null ? void 0 : e[t];
}
function ls(e, t) {
  var n = oY(e, t);
  return iY(n) ? n : void 0;
}
var aY = ls(Vi, "WeakMap");
const wm = aY;
var h_ = Object.create, sY = function() {
  function e() {
  }
  return function(t) {
    if (!ha(t))
      return {};
    if (h_)
      return h_(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
const uY = sY;
function cY(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var lY = function() {
  try {
    var e = ls(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const d_ = lY;
function fY(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var hY = 9007199254740991, dY = /^(?:0|[1-9]\d*)$/;
function vY(e, t) {
  var n = typeof e;
  return t = t == null ? hY : t, !!t && (n == "number" || n != "symbol" && dY.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function pM(e, t, n) {
  t == "__proto__" && d_ ? d_(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function mM(e, t) {
  return e === t || e !== e && t !== t;
}
var pY = Object.prototype, mY = pY.hasOwnProperty;
function gM(e, t, n) {
  var r = e[t];
  (!(mY.call(e, t) && mM(r, n)) || n === void 0 && !(t in e)) && pM(e, t, n);
}
function jd(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = t.length; ++o < a; ) {
    var s = t[o], u = r ? r(n[s], e[s], s, n, e) : void 0;
    u === void 0 && (u = e[s]), i ? pM(n, s, u) : gM(n, s, u);
  }
  return n;
}
var gY = 9007199254740991;
function yM(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= gY;
}
function bM(e) {
  return e != null && yM(e.length) && !vM(e);
}
var yY = Object.prototype;
function G0(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || yY;
  return e === n;
}
function bY(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var kY = "[object Arguments]";
function v_(e) {
  return gu(e) && mu(e) == kY;
}
var kM = Object.prototype, wY = kM.hasOwnProperty, xY = kM.propertyIsEnumerable, jY = v_(function() {
  return arguments;
}()) ? v_ : function(e) {
  return gu(e) && wY.call(e, "callee") && !xY.call(e, "callee");
};
const SY = jY;
function $Y() {
  return !1;
}
var wM = typeof exports == "object" && exports && !exports.nodeType && exports, p_ = wM && typeof module == "object" && module && !module.nodeType && module, _Y = p_ && p_.exports === wM, m_ = _Y ? Vi.Buffer : void 0, CY = m_ ? m_.isBuffer : void 0, OY = CY || $Y;
const xM = OY;
var AY = "[object Arguments]", PY = "[object Array]", EY = "[object Boolean]", MY = "[object Date]", TY = "[object Error]", IY = "[object Function]", NY = "[object Map]", RY = "[object Number]", DY = "[object Object]", LY = "[object RegExp]", zY = "[object Set]", BY = "[object String]", FY = "[object WeakMap]", qY = "[object ArrayBuffer]", VY = "[object DataView]", HY = "[object Float32Array]", WY = "[object Float64Array]", UY = "[object Int8Array]", JY = "[object Int16Array]", KY = "[object Int32Array]", GY = "[object Uint8Array]", QY = "[object Uint8ClampedArray]", XY = "[object Uint16Array]", ZY = "[object Uint32Array]", En = {};
En[HY] = En[WY] = En[UY] = En[JY] = En[KY] = En[GY] = En[QY] = En[XY] = En[ZY] = !0;
En[AY] = En[PY] = En[qY] = En[EY] = En[VY] = En[MY] = En[TY] = En[IY] = En[NY] = En[RY] = En[DY] = En[LY] = En[zY] = En[BY] = En[FY] = !1;
function YY(e) {
  return gu(e) && yM(e.length) && !!En[mu(e)];
}
function Q0(e) {
  return function(t) {
    return e(t);
  };
}
var jM = typeof exports == "object" && exports && !exports.nodeType && exports, Yu = jM && typeof module == "object" && module && !module.nodeType && module, ttt = Yu && Yu.exports === jM, Nv = ttt && hM.process, ett = function() {
  try {
    var e = Yu && Yu.require && Yu.require("util").types;
    return e || Nv && Nv.binding && Nv.binding("util");
  } catch {
  }
}();
const Ys = ett;
var g_ = Ys && Ys.isTypedArray, ntt = g_ ? Q0(g_) : YY;
const rtt = ntt;
var itt = Object.prototype, ott = itt.hasOwnProperty;
function SM(e, t) {
  var n = K0(e), r = !n && SY(e), i = !n && !r && xM(e), o = !n && !r && !i && rtt(e), a = n || r || i || o, s = a ? bY(e.length, String) : [], u = s.length;
  for (var c in e)
    (t || ott.call(e, c)) && !(a && (c == "length" || i && (c == "offset" || c == "parent") || o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || vY(c, u))) && s.push(c);
  return s;
}
function $M(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var att = $M(Object.keys, Object);
const stt = att;
var utt = Object.prototype, ctt = utt.hasOwnProperty;
function ltt(e) {
  if (!G0(e))
    return stt(e);
  var t = [];
  for (var n in Object(e))
    ctt.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function X0(e) {
  return bM(e) ? SM(e) : ltt(e);
}
function ftt(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var htt = Object.prototype, dtt = htt.hasOwnProperty;
function vtt(e) {
  if (!ha(e))
    return ftt(e);
  var t = G0(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !dtt.call(e, r)) || n.push(r);
  return n;
}
function Z0(e) {
  return bM(e) ? SM(e, !0) : vtt(e);
}
var ptt = ls(Object, "create");
const Pc = ptt;
function mtt() {
  this.__data__ = Pc ? Pc(null) : {}, this.size = 0;
}
function gtt(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ytt = "__lodash_hash_undefined__", btt = Object.prototype, ktt = btt.hasOwnProperty;
function wtt(e) {
  var t = this.__data__;
  if (Pc) {
    var n = t[e];
    return n === ytt ? void 0 : n;
  }
  return ktt.call(t, e) ? t[e] : void 0;
}
var xtt = Object.prototype, jtt = xtt.hasOwnProperty;
function Stt(e) {
  var t = this.__data__;
  return Pc ? t[e] !== void 0 : jtt.call(t, e);
}
var $tt = "__lodash_hash_undefined__";
function _tt(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Pc && t === void 0 ? $tt : t, this;
}
function Qa(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Qa.prototype.clear = mtt;
Qa.prototype.delete = gtt;
Qa.prototype.get = wtt;
Qa.prototype.has = Stt;
Qa.prototype.set = _tt;
function Ctt() {
  this.__data__ = [], this.size = 0;
}
function Sd(e, t) {
  for (var n = e.length; n--; )
    if (mM(e[n][0], t))
      return n;
  return -1;
}
var Ott = Array.prototype, Att = Ott.splice;
function Ptt(e) {
  var t = this.__data__, n = Sd(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Att.call(t, n, 1), --this.size, !0;
}
function Ett(e) {
  var t = this.__data__, n = Sd(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Mtt(e) {
  return Sd(this.__data__, e) > -1;
}
function Ttt(e, t) {
  var n = this.__data__, r = Sd(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function Lo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Lo.prototype.clear = Ctt;
Lo.prototype.delete = Ptt;
Lo.prototype.get = Ett;
Lo.prototype.has = Mtt;
Lo.prototype.set = Ttt;
var Itt = ls(Vi, "Map");
const Ec = Itt;
function Ntt() {
  this.size = 0, this.__data__ = {
    hash: new Qa(),
    map: new (Ec || Lo)(),
    string: new Qa()
  };
}
function Rtt(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function $d(e, t) {
  var n = e.__data__;
  return Rtt(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Dtt(e) {
  var t = $d(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Ltt(e) {
  return $d(this, e).get(e);
}
function ztt(e) {
  return $d(this, e).has(e);
}
function Btt(e, t) {
  var n = $d(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function yu(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
yu.prototype.clear = Ntt;
yu.prototype.delete = Dtt;
yu.prototype.get = Ltt;
yu.prototype.has = ztt;
yu.prototype.set = Btt;
function _M(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var Ftt = $M(Object.getPrototypeOf, Object);
const CM = Ftt;
function qtt() {
  this.__data__ = new Lo(), this.size = 0;
}
function Vtt(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function Htt(e) {
  return this.__data__.get(e);
}
function Wtt(e) {
  return this.__data__.has(e);
}
var Utt = 200;
function Jtt(e, t) {
  var n = this.__data__;
  if (n instanceof Lo) {
    var r = n.__data__;
    if (!Ec || r.length < Utt - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new yu(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function bu(e) {
  var t = this.__data__ = new Lo(e);
  this.size = t.size;
}
bu.prototype.clear = qtt;
bu.prototype.delete = Vtt;
bu.prototype.get = Htt;
bu.prototype.has = Wtt;
bu.prototype.set = Jtt;
function Ktt(e, t) {
  return e && jd(t, X0(t), e);
}
function Gtt(e, t) {
  return e && jd(t, Z0(t), e);
}
var OM = typeof exports == "object" && exports && !exports.nodeType && exports, y_ = OM && typeof module == "object" && module && !module.nodeType && module, Qtt = y_ && y_.exports === OM, b_ = Qtt ? Vi.Buffer : void 0, k_ = b_ ? b_.allocUnsafe : void 0;
function Xtt(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = k_ ? k_(n) : new e.constructor(n);
  return e.copy(r), r;
}
function Ztt(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
function AM() {
  return [];
}
var Ytt = Object.prototype, tet = Ytt.propertyIsEnumerable, w_ = Object.getOwnPropertySymbols, eet = w_ ? function(e) {
  return e == null ? [] : (e = Object(e), Ztt(w_(e), function(t) {
    return tet.call(e, t);
  }));
} : AM;
const Y0 = eet;
function net(e, t) {
  return jd(e, Y0(e), t);
}
var ret = Object.getOwnPropertySymbols, iet = ret ? function(e) {
  for (var t = []; e; )
    _M(t, Y0(e)), e = CM(e);
  return t;
} : AM;
const PM = iet;
function oet(e, t) {
  return jd(e, PM(e), t);
}
function EM(e, t, n) {
  var r = t(e);
  return K0(e) ? r : _M(r, n(e));
}
function aet(e) {
  return EM(e, X0, Y0);
}
function set(e) {
  return EM(e, Z0, PM);
}
var uet = ls(Vi, "DataView");
const xm = uet;
var cet = ls(Vi, "Promise");
const jm = cet;
var fet = ls(Vi, "Set");
const Sm = fet;
var x_ = "[object Map]", het = "[object Object]", j_ = "[object Promise]", S_ = "[object Set]", $_ = "[object WeakMap]", __ = "[object DataView]", det = cs(xm), vet = cs(Ec), pet = cs(jm), met = cs(Sm), get = cs(wm), Ca = mu;
(xm && Ca(new xm(new ArrayBuffer(1))) != __ || Ec && Ca(new Ec()) != x_ || jm && Ca(jm.resolve()) != j_ || Sm && Ca(new Sm()) != S_ || wm && Ca(new wm()) != $_) && (Ca = function(e) {
  var t = mu(e), n = t == het ? e.constructor : void 0, r = n ? cs(n) : "";
  if (r)
    switch (r) {
      case det:
        return __;
      case vet:
        return x_;
      case pet:
        return j_;
      case met:
        return S_;
      case get:
        return $_;
    }
  return t;
});
const t1 = Ca;
var yet = Object.prototype, bet = yet.hasOwnProperty;
function ket(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && bet.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var wet = Vi.Uint8Array;
const C_ = wet;
function e1(e) {
  var t = new e.constructor(e.byteLength);
  return new C_(t).set(new C_(e)), t;
}
function xet(e, t) {
  var n = t ? e1(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var jet = /\w*$/;
function $et(e) {
  var t = new e.constructor(e.source, jet.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var O_ = Zs ? Zs.prototype : void 0, A_ = O_ ? O_.valueOf : void 0;
function _et(e) {
  return A_ ? Object(A_.call(e)) : {};
}
function Cet(e, t) {
  var n = t ? e1(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Oet = "[object Boolean]", Aet = "[object Date]", Pet = "[object Map]", Eet = "[object Number]", Met = "[object RegExp]", Tet = "[object Set]", Iet = "[object String]", Net = "[object Symbol]", Ret = "[object ArrayBuffer]", Det = "[object DataView]", Let = "[object Float32Array]", zet = "[object Float64Array]", Bet = "[object Int8Array]", Fet = "[object Int16Array]", qet = "[object Int32Array]", Vet = "[object Uint8Array]", Het = "[object Uint8ClampedArray]", Wet = "[object Uint16Array]", Uet = "[object Uint32Array]";
function Jet(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case Ret:
      return e1(e);
    case Oet:
    case Aet:
      return new r(+e);
    case Det:
      return xet(e, n);
    case Let:
    case zet:
    case Bet:
    case Fet:
    case qet:
    case Vet:
    case Het:
    case Wet:
    case Uet:
      return Cet(e, n);
    case Pet:
      return new r();
    case Eet:
    case Iet:
      return new r(e);
    case Met:
      return $et(e);
    case Tet:
      return new r();
    case Net:
      return _et(e);
  }
}
function Ket(e) {
  return typeof e.constructor == "function" && !G0(e) ? uY(CM(e)) : {};
}
var Get = "[object Map]";
function Qet(e) {
  return gu(e) && t1(e) == Get;
}
var P_ = Ys && Ys.isMap, Xet = P_ ? Q0(P_) : Qet;
const Zet = Xet;
var Yet = "[object Set]";
function tnt(e) {
  return gu(e) && t1(e) == Yet;
}
var E_ = Ys && Ys.isSet, ent = E_ ? Q0(E_) : tnt;
const nnt = ent;
var rnt = 1, int = 2, ont = 4, MM = "[object Arguments]", ant = "[object Array]", snt = "[object Boolean]", unt = "[object Date]", cnt = "[object Error]", TM = "[object Function]", lnt = "[object GeneratorFunction]", fnt = "[object Map]", hnt = "[object Number]", IM = "[object Object]", dnt = "[object RegExp]", vnt = "[object Set]", pnt = "[object String]", mnt = "[object Symbol]", gnt = "[object WeakMap]", ynt = "[object ArrayBuffer]", bnt = "[object DataView]", knt = "[object Float32Array]", wnt = "[object Float64Array]", xnt = "[object Int8Array]", jnt = "[object Int16Array]", Snt = "[object Int32Array]", $nt = "[object Uint8Array]", _nt = "[object Uint8ClampedArray]", Cnt = "[object Uint16Array]", Ont = "[object Uint32Array]", $n = {};
$n[MM] = $n[ant] = $n[ynt] = $n[bnt] = $n[snt] = $n[unt] = $n[knt] = $n[wnt] = $n[xnt] = $n[jnt] = $n[Snt] = $n[fnt] = $n[hnt] = $n[IM] = $n[dnt] = $n[vnt] = $n[pnt] = $n[mnt] = $n[$nt] = $n[_nt] = $n[Cnt] = $n[Ont] = !0;
$n[cnt] = $n[TM] = $n[gnt] = !1;
function yf(e, t, n, r, i, o) {
  var a, s = t & rnt, u = t & int, c = t & ont;
  if (n && (a = i ? n(e, r, i, o) : n(e)), a !== void 0)
    return a;
  if (!ha(e))
    return e;
  var l = K0(e);
  if (l) {
    if (a = ket(e), !s)
      return cY(e, a);
  } else {
    var f = t1(e), h = f == TM || f == lnt;
    if (xM(e))
      return Xtt(e, s);
    if (f == IM || f == MM || h && !i) {
      if (a = u || h ? {} : Ket(e), !s)
        return u ? oet(e, Gtt(a, e)) : net(e, Ktt(a, e));
    } else {
      if (!$n[f])
        return i ? e : {};
      a = Jet(e, f, s);
    }
  }
  o || (o = new bu());
  var d = o.get(e);
  if (d)
    return d;
  o.set(e, a), nnt(e) ? e.forEach(function(m) {
    a.add(yf(m, t, n, m, e, o));
  }) : Zet(e) && e.forEach(function(m, g) {
    a.set(g, yf(m, t, n, g, e, o));
  });
  var p = c ? u ? set : aet : u ? Z0 : X0, v = l ? void 0 : p(e);
  return fY(v || e, function(m, g) {
    v && (g = m, m = e[g]), gM(a, g, yf(m, t, n, g, e, o));
  }), a;
}
var Ant = 1, Pnt = 4;
function Ent(e) {
  return yf(e, Ant | Pnt);
}
var Mnt = function() {
  return Vi.Date.now();
};
const Rv = Mnt;
var Tnt = "Expected a function", Int = Math.max, Nnt = Math.min;
function Rnt(e, t, n) {
  var r, i, o, a, s, u, c = 0, l = !1, f = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError(Tnt);
  t = l_(t) || 0, ha(n) && (l = !!n.leading, f = "maxWait" in n, o = f ? Int(l_(n.maxWait) || 0, t) : o, h = "trailing" in n ? !!n.trailing : h);
  function d(x) {
    var S = r, T = i;
    return r = i = void 0, c = x, a = e.apply(T, S), a;
  }
  function p(x) {
    return c = x, s = setTimeout(g, t), l ? d(x) : a;
  }
  function v(x) {
    var S = x - u, T = x - c, P = t - S;
    return f ? Nnt(P, o - T) : P;
  }
  function m(x) {
    var S = x - u, T = x - c;
    return u === void 0 || S >= t || S < 0 || f && T >= o;
  }
  function g() {
    var x = Rv();
    if (m(x))
      return y(x);
    s = setTimeout(g, v(x));
  }
  function y(x) {
    return s = void 0, h && r ? d(x) : (r = i = void 0, a);
  }
  function b() {
    s !== void 0 && clearTimeout(s), c = 0, r = u = i = s = void 0;
  }
  function k() {
    return s === void 0 ? a : y(Rv());
  }
  function w() {
    var x = Rv(), S = m(x);
    if (r = arguments, i = this, u = x, S) {
      if (s === void 0)
        return p(u);
      if (f)
        return clearTimeout(s), s = setTimeout(g, t), d(u);
    }
    return s === void 0 && (s = setTimeout(g, t)), a;
  }
  return w.cancel = b, w.flush = k, w;
}
const Dv = $m ? "modelValue" : "value", Wo = LM({
  name: "JsonEditorVue",
  props: [Dv],
  setup(e, { attrs: t, emit: n }) {
    const r = zM(), i = _d(!1), o = $m ? "update:modelValue" : "input", a = _d(), s = _d("json"), u = Ent(e[Dv]), c = Rnt((h) => {
      i.value = !0, n(o, h[s.value]);
    }, 100), l = (h) => h ? { text: "text", tree: "json" }[h] : s.value, f = BM(() => cC([t, NM, {
      onChange: c,
      onChangeMode(h) {
        s.value = l(h);
      }
    }], {
      camelCase: !1,
      mergeFunction: (h, d) => (...p) => {
        h(...p), d(...p);
      },
      ...u !== void 0 && {
        default: ({ mode: h }) => (s.value = l(h), {
          content: {
            [s.value]: u
          }
        }),
        defaultIsDynamic: !0
      }
    }));
    return n1(() => e[Dv], (h, d) => {
      if (i.value) {
        i.value = !1;
        return;
      }
      a.value.set(h === void 0 ? { text: "" } : {
        [s.value]: typeof h != "string" && s.value === "text" ? JSON.stringify(h) : h
      });
    }, {
      deep: !0
    }), n1(f, (h) => {
      s.value = l(h.mode), delete h.content, a.value.updateProps(h);
    }, {
      deep: !0
    }), FM(() => {
      a.value = new lZ({
        target: r.proxy.$refs.jsonEditorRef,
        props: f.value
      });
    }), qM(() => {
      a.value.destroy();
    }), () => VM("div", {
      ref: "jsonEditorRef"
    });
  }
});
let Dnt = {}, NM = {}, Lnt = {}, znt = {};
Wo.install = (e, t = {}) => {
  if (Wo.name) {
    if (Wo.install.installed) {
      console.warn(`${Wo.name} has been registered.`);
      return;
    }
  } else
    throw Error("Name is required for a global component.");
  const { props: n, attrs: r, listeners: i, hooks: o } = XM(t, Wo.props);
  Dnt = n, NM = r, Lnt = i, znt = o, e.component(Wo.name, Wo), Wo.install.installed = !0;
};
export {
  Wo as default,
  NM as globalAttrs,
  znt as globalHooks,
  Lnt as globalListeners,
  Dnt as globalProps
};
